{
  "app": {
    "name": "EnterpriseAI ERP Cloud",
    "shortName": "EnterpriseAI ERP",
    "mark": "EA",
    "skipToContent": "Skip to content"
  },
  "common": {
    "actions": {
      "add": "Add",
      "apply": "Apply",
      "approve": "Approve",
      "back": "Back",
      "backToSignIn": "Back to sign in",
      "cancel": "Cancel",
      "clear": "Clear",
      "clearFilters": "Clear filters",
      "close": "Close",
      "copy": "Copy",
      "create": "Create",
      "delegate": "Delegate",
      "delete": "Delete",
      "detail": "Detail",
      "dismiss": "Dismiss",
      "done": "Done",
      "download": "Download",
      "edit": "Edit",
      "exportCsv": "Export CSV",
      "next": "Next",
      "open": "Open",
      "previous": "Previous",
      "refresh": "Refresh",
      "reject": "Reject",
      "remove": "Remove",
      "reset": "Reset",
      "retry": "Try again",
      "revoke": "Revoke",
      "save": "Save",
      "saveChanges": "Save changes",
      "search": "Search",
      "showPassword": "Show password",
      "signIn": "Sign in",
      "signOut": "Sign out",
      "submit": "Submit"
    },
    "labels": {
      "actions": "Actions",
      "active": "Active",
      "all": "All",
      "confirmPassword": "Confirm password",
      "description": "Description",
      "email": "Email",
      "fullName": "Full name",
      "inactive": "Inactive",
      "jobTitle": "Job title",
      "language": "Language",
      "lastSignIn": "Last sign-in",
      "loading": "Loading",
      "name": "Name",
      "never": "Never",
      "newPassword": "New password",
      "no": "No",
      "noneAssigned": "None assigned",
      "note": "Note",
      "password": "Password",
      "permissions": "Permissions",
      "phone": "Phone",
      "refreshing": "Refreshing…",
      "role": "Role",
      "roles": "Roles",
      "search": "Search",
      "selectedCount": "{count} selected",
      "status": "Status",
      "timezone": "Timezone",
      "total": "Total",
      "workspace": "Workspace",
      "yes": "Yes"
    },
    "languages": {
      "en": "English",
      "dv": "Dhivehi (ދިވެހި)"
    },
    "validation": {
      "passwordMismatch": "The two passwords do not match.",
      "password": {
        "blank": "Enter a password.",
        "tooShort": "Use at least {min} characters.",
        "tooLong": "Use at most {max} characters.",
        "allSame": "One character repeated is not a password."
      }
    },
    "loadingLabels": {
      "exporting": "Exporting",
      "loading": "Loading",
      "refreshing": "Refreshing",
      "saving": "Saving",
      "sending": "Sending",
      "updating": "Updating",
      "verifying": "Verifying"
    }
  },
  "ui": {
    "button": {
      "working": "Working"
    },
    "field": {
      "required": "(required)",
      "optional": "optional"
    },
    "money": {
      "negative": "negative {amount}"
    },
    "select": {
      "placeholder": "Select…",
      "clear": "None"
    },
    "pagination": {
      "label": "Pagination",
      "previousPage": "Previous page",
      "nextPage": "Next page",
      "empty": "No records",
      "showing": "Showing {range}",
      "showingOfTotal": "Showing {range} of {total}",
      "perPage": "{size} per page"
    },
    "table": {
      "recordCountOne": "{count} record",
      "recordCountOther": "{count} records",
      "columns": "Columns",
      "chooseColumns": "Choose columns",
      "visibleColumns": "Visible columns",
      "selectAllRows": "Select all rows on this page",
      "selectRow": "Select row {index}",
      "emptyTitle": "Nothing to show yet",
      "filteredTitle": "No records match these filters",
      "filteredDescription": "Try widening the date range or clearing a filter chip."
    },
    "panel": {
      "emptyTitle": "Nothing here yet"
    }
  },
  "errors": {
    "generic": "Something went wrong.",
    "loadTitle": "That did not load",
    "reference": "Reference {traceId}",
    "codes": {
      "ERR_PERIOD_CLOSED": "That accounting period is closed, so nothing can be posted into it. Reopen the period or post to an open one.",
      "ERR_BUDGET_EXCEEDED": "This would take the budget past its limit. Ask for the budget to be revised, or reduce the amount.",
      "ERR_DUPLICATE_INVOICE": "That invoice number has already been recorded for this vendor.",
      "ERR_STATEMENT_DUPLICATE": "That statement has already been imported for this bank account, so this copy was discarded. The original import is named in the details.",
      "ERR_STATEMENT_LATE_UNACKNOWLEDGED": "That statement arrived later than this account's staleness threshold. Give the reason it is late and import it again.",
      "ERR_STATEMENT_LINE_DUPLICATE": "That statement line repeats a line already on record for this account, so it is kept for reference only and cannot be reconciled or acted on.",
      "ERR_SCREENING_RESULT_CHANGED": "The screening result changed since you looked at it, so nothing was cleared. Review the current findings and try again.",
      "ERR_CREDIT_LIMIT": "This takes the customer past their credit limit. Someone with a credit override has to approve it.",
      "ERR_SOD_VIOLATION": "Segregation of duties blocks this: the same person cannot both raise and approve it.",
      "ERR_ROW_VERSION": "Someone else changed this record while you had it open. Nothing was overwritten — reload and reapply your changes.",
      "ERR_VALIDATION": "Some of what was entered is not valid. The affected fields are marked.",
      "ERR_FORBIDDEN": "Your roles do not include the permission this needs.",
      "ERR_UNAUTHENTICATED": "Sign-in did not succeed, or your session has ended. Check your details and sign in again.",
      "ERR_NOT_FOUND": "That record no longer exists, or you cannot see it.",
      "ERR_RATE_LIMITED": "Too many requests in a short time. Wait a moment and try again.",
      "ERR_STEP_UP_REQUIRED": "This action needs a fresh two-factor code before it can go ahead.",
      "ERR_PASSWORD_CHANGE_REQUIRED": "Your password was set by an administrator. Choose your own before anything else will open.",
      "ERR_TENANT_SUSPENDED": "This workspace is suspended, so changes are blocked. Existing records stay readable.",
      "ERR_MFA_REQUIRED": "This account is protected by two-factor authentication. Enter the code from your authenticator app.",
      "ERR_ILLEGAL_TRANSITION": "Someone else got there first, so this is no longer in a state that allows it.",
      "ERR_SESSION_ENDED": "Your session has ended. Sign in again to continue.",
      "ERR_JOURNAL_APPROVAL_REQUIRED": "This journal type needs approval before it can be posted. Submit it for approval.",
      "ERR_JOURNAL_APPROVAL_UNRESOLVABLE": "No approver is configured for this journal. Set up an approval chain in the authority matrix.",
      "ERR_JOURNAL_APPROVAL_NOT_REQUIRED": "This journal type does not need approval; post it directly.",
      "ERR_OPENING_BALANCE_SIGNED_OFF": "This opening balance is already signed off; its reconciliation is final.",
      "ERR_MFG_TOOL_UNAVAILABLE": "A required tool is unavailable, past its life or overdue for service.",
      "ERR_RATE_OVERRIDE_TOLERANCE": "The exchange rate you entered is outside the tolerance allowed against the system rate. Use the system rate or ask for an override.",
      "ERR_JOURNAL_ATTACHMENT_REQUIRED": "This journal type needs a supporting attachment before it can be submitted or posted.",
      "ERR_JOURNAL_AUTO_REVERSAL_PENDING": "This journal has an auto-reversal still pending, so it cannot be changed or reversed by hand.",
      "ERR_JOURNAL_OWNED_BY_SOURCE": "This journal was posted by another module. Reverse its source document instead; the journal follows.",
      "ERR_BANK_ACCOUNT_DUPLICATE": "A bank account with the same bank and account number already exists for this company.",
      "ERR_BANK_ACCOUNT_NOT_ACTIVE": "This bank account is not active, so it cannot be used for this action.",
      "ERR_BANK_ACCOUNT_STATE": "The bank account is not in a state that allows this step.",
      "ERR_ACCOUNT_ACTIVATION_BLOCKED": "This bank account cannot be activated yet. Check that it is verified and that its approvals are complete.",
      "ERR_ACCOUNT_CLOSE_BLOCKED": "This bank account cannot be closed while it still has a balance or open items.",
      "ERR_BANK_ACCOUNT_AMENDMENT_REQUIRED": "Changing these bank details needs an amendment request, which has to be approved first.",
      "ERR_BENEFICIARY_COOLING_OFF": "These beneficiary details were changed recently and are still in the cooling-off period. Payments to them are blocked until it ends.",
      "ERR_BENEFICIARY_UNVERIFIED": "These beneficiary details have not been verified, so payments to them are blocked.",
      "ERR_WALLET_MAX_BALANCE": "This would take the wallet past its maximum balance.",
      "ERR_WALLET_FUNDING_DESTINATION": "That wallet cannot receive funding from this source.",
      "ERR_MANDATE_NOT_PENDING": "There is nothing to approve: this mandate version is not pending.",
      "ERR_RATE_OVERRIDE_NO_BOOK_RATE": "There is no system rate on file for this currency pair and date, so an override cannot be measured against one. Record the rate first.",
      "ERR_WALLET_TXN_FUNDED_BY_TRANSFER": "This wallet movement was created by a funding transfer. Change or reverse the transfer instead.",
      "ERR_WALLET_FUNDS_IN_TRANSIT": "Funds are still in transit to this wallet. Wait for the transfer to settle before closing it.",
      "ERR_MANDATE_SUPERSEDE_REQUIRED": "An active mandate already covers this. Propose a new version that supersedes it instead of editing it.",
      "ERR_YEAR_HAS_OPEN_PERIODS": "Every period of this fiscal year must be closed before the year can be closed.",
      "ERR_YEAR_ALREADY_CLOSED": "This fiscal year already has a year-end close. Reverse it before closing the year again.",
      "ERR_YEAR_END_CLOSE_APPROVAL_UNRESOLVABLE": "No approver is configured for year-end closes. Set up an approval chain for them first.",
      "ERR_NEXT_YEAR_PERIOD_CLOSED": "A period of the next fiscal year is already closed, so this year-end close can no longer be reversed.",
      "ERR_YEAR_CLOSED_REVERSE_FIRST": "This fiscal year has been closed out. Reverse or withdraw its year-end close before reopening any of its periods.",
      "ERR_PAN_NOT_MASKED": "Enter the card number masked. At most the last four digits may be visible; every other position must be * or X. The full card number is never stored.",
      "ERR_CARD_HAS_OPEN_LINES": "This card still has unmatched statement lines. Match or disposition them before deactivating the card.",
      "ERR_CARD_INACTIVE": "This card is inactive, so a statement cannot be imported into it. Reactivate the card first.",
      "ERR_REBATE_NO_PAYEE": "This customer cannot be paid a rebate by payment because it has no payee record in accounts payable. Link the customer's party to a vendor, or settle the rebate by credit note.",
      "ERR_REBATE_PAYEE_UNUSABLE": "The vendor record linked to this customer cannot be paid right now. It is blocked, or it does not accept the rebate's currency. Fix the vendor, or settle the rebate by credit note.",
      "ERR_REBATE_PAYABLES_UNAVAILABLE": "Accounts payable is not available on this instance, so a rebate cannot be settled by payment. Settle it by credit note instead.",
      "ERR_CREDIT_HOLD": "This customer is on credit hold, so new invoices, orders and deliveries are blocked until the hold is released.",
      "ERR_AR_CREDIT_OVERRIDE_APPROVAL_UNRESOLVABLE": "No approver is configured for credit overrides. Set up an approval chain for them first.",
      "ERR_USE_CREDIT_HOLD_ACTION": "A credit hold cannot be set or cleared by editing the status. Use Place on Credit Hold or Release Hold, which record the reason.",
      "ERR_USE_CREDIT_LIMIT_REQUEST": "A credit limit cannot be changed by editing the customer. Request the new limit; it applies once it is approved.",
      "ERR_AR_CREDIT_LIMIT_APPROVAL_UNRESOLVABLE": "No approver is configured for credit limit changes. Set up an approval chain for them first.",
      "ERR_BUDGET_CYCLE_CLOSED": "This budget cycle is closed, so its versions and lines can no longer change. Start a new budget model for further planning.",
      "ERR_BUDGET_CYCLE_NOT_OPEN": "This budget cycle is not open yet, so cost centre owners cannot enter figures. A cycle manager has to open it first.",
      "ERR_BUDGET_CYCLE_SUBMITTED": "This cost centre has already been submitted and is locked. A cycle manager has to reopen it before you can change it.",
      "ERR_BUDGET_NOTHING_TO_SUBMIT": "This cost centre has no budget lines in the working version yet. Enter its figures before submitting.",
      "ERR_APPROVAL_UNRESOLVABLE": "This action needs approval from someone other than you, and no such approver is configured. Ask an administrator to set up an approval policy for it first.",
      "ERR_CONTROL_NO_EMERGENCY": "This request is a control, so it cannot be approved as an emergency. It must be approved through its approval chain by someone other than the person who asked.",
      "ERR_DUNNING_LEVEL_IN_USE": "This dunning level has sent notices or has invoices on it, so it cannot be deleted or renumbered.",
      "ERR_DUNNING_LEVEL_ORDER": "Dunning levels must escalate: a higher level needs more days overdue than every lower one.",
      "ERR_DUNNING_LEVEL_FINAL": "Only the highest dunning level can be final, and only one level can be.",
      "ERR_DUNNING_AS_OF_FUTURE": "A dunning run cannot be dated after today. Preview a later date instead.",
      "ERR_CLOSE_RECON_ALREADY_CERTIFIED": "This reconciliation is already certified on this close run.",
      "ERR_RECON_EXCEPTION_CLOSED": "This exception is already resolved or written off. It reopens only if the item is unmatched again.",
      "ERR_RECON_EXCEPTION_OUTSTANDING": "This item is still unmatched and nothing explains it. Match it, or reverse its source document, before resolving.",
      "ERR_RECON_EXCEPTION_MATCH_INVALID": "That match cannot resolve this exception. It must be live, on the same bank account, and cover the item.",
      "ERR_RECON_EXCEPTION_WRITE_OFF_REFUSED": "Only a statement line cleared by a missing-entry posting can be written off. Reverse a ledger item at its source instead.",
      "ERR_IC_PRICING_EVIDENCE_REQUIRED": "Record the pricing method and the evidence of its basis before submitting this intercompany instrument.",
      "ERR_SCREENING_REPORT_NOT_REQUIRED": "This transfer is not held on a reporting obligation, or its report has already been recorded.",
      "ERR_SCREENING_REPORT_PENDING": "A regulatory report is still owed on this transfer. Record its reference before clearing the hold.",
      "ERR_FACILITY_CLOSE_BLOCKED": "This facility cannot be closed while it still carries principal, accrued interest, a drawdown in transit, a pending change or an open covenant obligation.",
      "ERR_FACILITY_ROLLOVER_BLOCKED": "This facility cannot be rolled over yet. The details name what is blocking it.",
      "ERR_FACILITY_AUTHORISATION_REQUIRED": "This change needs a second person's authorisation. Use its own request, which someone else then approves.",
      "ERR_FACILITY_IC_INSTRUMENT_REQUIRED": "An intercompany loan needs an approved, priced intercompany instrument before it is authorised or drawn.",
      "ERR_DEBT_EVIDENCE_MISMATCH": "That statement line does not evidence this movement. Check its bank account, direction, amount and currency, and that it is not already used.",
      "ERR_COVENANT_ALREADY_TESTED": "This covenant already has a result for that date. A recorded breach is cleared only by a waiver with a reason.",
      "ERR_DEBT_APPROVAL_PENDING": "This is above the authority band and waits for a second person's approval. It cannot go ahead until then.",
      "ERR_SCHEDULE_SUM_MISMATCH": "The schedule's principal does not add up to the drawn principal at maturity. The difference is stated in the details.",
      "ERR_DEBT_TERMS_CHANGED": "The terms changed after this was submitted. Review the current terms and submit again.",
      "ERR_CASH_ACCOUNT_PLEDGED": "This bank account is pledged as security for a debt facility. Release the pledge first.",
      "ERR_CASH_ACCOUNT_NOT_PLEDGED": "This bank account is not pledged.",
      "ERR_POSITION_STALE_RATE": "A translation rate is older than the tolerance, so this position cannot be published. File a current rate, or raise the tolerance in the treasury settings.",
      "ERR_AP_STATEMENT_DUPLICATE": "This supplier statement is already recorded. Give the supplier's statement number to record a second one for the same date.",
      "ERR_PAYMENT_RUN_APPROVAL_UNRESOLVABLE": "No approver other than the person who prepared this payment run is configured, so it cannot be submitted. Ask an administrator to set up an approval policy for payment runs.",
      "ERR_ASSET_IC_RULE_MISSING": "These legal entities have no intercompany rule in force on the transfer date, so there is no due-to or due-from account to post through. Configure it under the legal entities' intercompany rules first.",
      "ERR_ASSET_IC_TRANSFER_BLOCKED": "This asset cannot be transferred to another legal entity as it stands: it has a pending disposal, an impairment still on its books or awaiting approval, or it is a componentised parent. Clear that first.",
      "ERR_ASSET_IMPAIRMENT_APPROVAL_UNRESOLVABLE": "This impairment needs approval and no approver other than you is configured. Ask an administrator to set up an approval policy for asset impairments.",
      "ERR_ASSET_CAPITALIZE_EXCEEDS_BALANCE": "The cost to capitalise is more than the source's balance at the in-service date. Reduce the cost, or pick a source with enough balance.",
      "ERR_FORCE_MATCH_RESIDUAL_EXCEEDS_TOLERANCE": "The difference between the statement line and the ledger lines is larger than a forced match may carry for this bank account. Match the lines that agree, or ask for the tolerance to be revised.",
      "ERR_RECON_HELD_LINES": "A statement line in this reconciliation is still held in quarantine or is intraday-only. Release or reject the statement, decide the held lines, or import the end-of-day statement, then complete the reconciliation.",
      "ERR_CONSOL_UNMAPPED_BALANCE": "This group has account balances with no group account mapped to them. Map them in the account map, then run the consolidation again.",
      "ERR_DEBT_LIMIT_EXCEEDED": "That would take the facility past its limit.",
      "ERR_COVENANT_BREACHED": "This facility has a covenant breach that is not waived.",
      "ERR_COVENANT_WAIVER_REF": "A waiver must name the lender's waiver document.",
      "ERR_BUDGET_CONTROL_LEVEL_APPROVAL_UNRESOLVABLE": "No approver is configured for budget control level changes, so a looser level cannot be requested.",
      "ERR_WRITEOFF_EVIDENCE_REQUIRED": "A write-off needs an attached document and a record of collection effort before it can be submitted.",
      "ERR_AR_WRITEOFF_APPROVAL_UNRESOLVABLE": "No approver is configured for write-offs, so this one cannot be submitted.",
      "ERR_WHT_ALREADY_REMITTED": "This withholding has already been remitted by another remittance.",
      "ERR_SWEEP_SETOFF_EVIDENCE_REQUIRED": "A notional pool across legal entities needs evidence of the right of set-off. Attach the evidence to the structure first.",
      "ERR_SWEEP_NOT_CONFIGURED": "This sweep structure is not fully set up. Give every participant its target or threshold, and name an intercompany instrument for each movement between legal entities.",
      "ERR_SWEEP_MANDATE_MISSING": "No bank mandate covers one of the movements in this sweep, so the transfer cannot be raised. Set up the mandate first.",
      "ERR_SWEEP_CUTOFF_PASSED": "The bank's cut-off for this date has passed. The sweep is recorded as deferred and has not been executed.",
      "ERR_SWEEP_SIMULATION_STALE": "Balances or terms have moved since this simulation was run. Simulate again before executing.",
      "ERR_SWEEP_SIMULATION_EXPIRED": "This simulation has expired. Simulate again before executing.",
      "ERR_BUDGET_TRANSFER_EXCEEDS_AVAILABLE": "The source does not have that much budget available after commitments and actuals, so it cannot be transferred. Reduce the amount.",
      "ERR_BUDGET_TRANSFER_APPROVAL_UNRESOLVABLE": "No approver other than you is configured for budget transfers, so this one cannot be submitted. Ask an administrator to set up an approval policy for budget transfers.",
      "ERR_BUDGET_SUPPLEMENTARY_APPROVAL_UNRESOLVABLE": "No approver other than you is configured for supplementary budget requests, so this one cannot be submitted. Ask an administrator to set up an approval policy for them.",
      "ERR_BUDGET_VERSION_NOT_IN_FORCE": "The budget version this was requested against is no longer the one in force. Review the current version and request again.",
      "ERR_CONSOL_RUN_ALREADY_PUBLISHED": "This period already has a published consolidation. Restate that run to replace it.",
      "ERR_CONSOL_RUN_IMMUTABLE": "A published consolidation cannot be amended. Restate it to make a correction.",
      "ERR_CONSOL_GROUP_CHART_REQUIRED": "A group chart of accounts is required. Choose one on the group, then run the consolidation again.",
      "ERR_CONSOL_INTERCO_MISMATCH": "Inter-company balances differ by more than the group's tolerance. The details list each pair; resolve them before publishing.",
      "ERR_CONSOL_ELIMINATIONS_UNDECIDED": "Some proposed eliminations are still undecided. Accept or reject each one before publishing.",
      "ERR_CONSOL_ADJUSTMENTS_PENDING": "Some group adjustments are not approved yet. Approve or withdraw each one before publishing.",
      "ERR_CONSOL_ADJUSTMENT_APPROVAL_UNRESOLVABLE": "No approver other than you is configured for group adjustments, so this one cannot be submitted. Ask an administrator to set up an approval policy for them.",
      "ERR_CONSOL_NOT_READY": "A group member is not ready to be consolidated for this period: its period is still open, its close is not certified, or its inter-company differences are over tolerance. The details name each one.",
      "ERR_OWNERSHIP_INCONSISTENT": "A subsidiary's effective ownership by the group parent would be over 100%. Check the ownership percentages of its owners.",
      "ERR_CONSOL_NOT_MEMBER": "That company is not a member of the group as at the date asked for.",
      "ERR_CONSOL_WINDOW_TOO_LARGE": "The period is too long to average rates over. Choose a shorter one.",
      "ERR_EINVOICE_NOT_CONFIGURED": "E-invoicing is not configured for this legal entity's jurisdiction. Choose another delivery channel, or ask an administrator to set up and activate an e-invoicing network.",
      "ERR_CLOSE_STATEMENTS_STALE": "The ledger no longer gives the figures in this statement set, for example after a late posting. Generate a new version and publish that one.",
      "ERR_PERIOD_NOT_CLOSED": "This needs the period to be closed, and it is not closed yet. Close the period first, then try again.",
      "ERR_AR_PROMISE_CLOSED": "This promise is no longer open, so it cannot be changed. Record a new one instead.",
      "ERR_EXIT_BLOCKED": "This exit cannot be settled yet. The employee still has something to hand back, such as a cash wallet. The details list each item.",
      "ERR_WALLET_CASH_BOOK_HELD": "One of these cash books already belongs to another wallet. Choose a cash book that no wallet holds.",
      "ERR_WALLET_NOT_RECONCILED": "This wallet's last reconciliation left a difference. Reconcile its cash books and clear the difference first.",
      "ERR_WALLET_CLOSE_BLOCKED": "This wallet still has open items. The details list each one with its value and owner; settle them before closing.",
      "ERR_WALLET_HANDOVER_NOT_A_PARTY": "Only the outgoing or the incoming custodian of this handover can acknowledge it.",
      "ERR_WALLET_RECOVERY_EXCEEDS_BALANCE": "The amount is more than the wallet holds. Recover no more than its balance.",
      "ERR_WALLET_NOT_ACTIVE": "This wallet is not active, so nothing can be recorded against it.",
      "ERR_USE_DEBT_SCHEDULE": "Loan instalments come from the facility's debt repayment schedule. Record the loan as a debt facility, not as a recurring cash item.",
      "ERR_BUDGET_MATERIALITY_APPROVAL_UNRESOLVABLE": "No approver other than you is configured for changes to the budget materiality threshold, so a looser threshold cannot be requested. Ask an administrator to set up an approval policy for it.",
      "ERR_CLOSE_NOT_READY": "The sub-ledger does not agree with its control account.",
      "ERR_RECORD_LOCKED": "This record no longer accepts attachments.",
      "ERR_LEASE_APPROVAL_UNRESOLVABLE": "No approver is configured for lease contracts: add a lease.contract approval policy",
      "ERR_IC_DIFFERENCE_EVIDENCE_REQUIRED": "Attach evidence of the resolution before resolving this intercompany difference.",
      "ERR_EXPENSE_PAYROLL_SETTLEMENT": "This claim or advance cannot be settled through payroll: it may already be in a payroll run, the employee may not be on this company's payroll, the claim may not be in the company's currency, or the reimbursement clearing account is missing.",
      "ERR_EXPENSE_PAYROLL_NOTHING_TO_PAY": "This claim has no employee-paid spend for payroll to reimburse.",
      "ERR_REVALUATION_EXISTS": "This period already has an FX revaluation for the company. Discard the draft to prepare another, or reverse the posted one through the ledger.",
      "ERR_REVALUATION_STALE": "The books changed after this revaluation was prepared. Discard it and prepare a new one.",
      "ERR_REVALUATION_NOTHING": "Nothing to revalue: no foreign-currency balance differs from its carrying value.",
      "ERR_REVALUATION_NOT_CONFIGURED": "Name the company's unrealised FX gain and loss accounts before running a revaluation.",
      "ERR_USE_PROMOTE": "A scenario becomes the base only by approval. Use Promote to request it.",
      "ERR_SCENARIO_BASE_LOCKED": "The approved base cannot be edited in place. Promote a replacement scenario instead.",
      "ERR_SCENARIO_PROMOTION_PENDING": "This scenario is waiting for a promotion decision, so it cannot be changed. Withdraw the request first.",
      "ERR_SCENARIO_NOT_APPROVED": "Only the approved base can be the basis of a published liquidity analysis. Promote this scenario first, or read it as an exploration.",
      "ERR_SCENARIO_NO_FORECAST": "This scenario has no current published forecast to compare with the base, so it cannot be promoted yet.",
      "ERR_ATTENTION_APPROVAL_RESOLVE": "An approval cannot be acknowledged or resolved from the attention list. Act on it in the approvals inbox instead.",
      "ERR_REVPOLICY_APPROVAL_UNRESOLVABLE": "No approver other than you can be found for the revenue policy. Ask a Tenant Admin to give someone the revenue policy approval permission.",
      "ERR_REVPOLICY_IN_FORCE": "A revenue policy is already in force. Supersede it with a new version instead of creating one from nothing.",
      "ERR_REVPOLICY_DRAFT_OPEN": "A revenue policy version is already open. Finish or discard it before starting another.",
      "ERR_REVPOLICY_NO_RULES": "A revenue policy version needs at least one rule before it can be submitted.",
      "ERR_BANK_LIMIT_APPROVAL_UNRESOLVABLE": "No approver other than you can be found to loosen this bank limit. Ask a Tenant Admin to review the approval policy for bank limits.",
      "ERR_EXPORT_TOO_LARGE": "That export is too large. Narrow the date range or the filters and try again."
    }
  },
  "metrics": {
    "treasury": {
      "debtServiceCoverage": {
        "label": "Debt service coverage",
        "description": "How many times the last twelve months' operating earnings cover the principal and interest falling due in the same period. A covenant metric, computed from the ledger and the facilities' schedules.",
        "formula": "EBITDA of the last 12 months ÷ (principal + interest due in the last 12 months)"
      },
      "netDebtToEbitda": {
        "label": "Net debt to EBITDA",
        "description": "Borrowings drawn, less the cash in the latest published treasury position, as a multiple of the last twelve months' operating earnings. A covenant metric.",
        "formula": "(Total drawn on all facilities − published cash) ÷ EBITDA of the last 12 months"
      },
      "interestCover": {
        "label": "Interest cover",
        "description": "How many times the last twelve months' operating earnings cover the interest expense of the same period. A covenant metric.",
        "formula": "EBITDA of the last 12 months ÷ interest expense of the last 12 months"
      },
      "currentRatio": {
        "label": "Current ratio",
        "description": "Assets against liabilities at the test date. The chart of accounts has no current and non-current split yet, so this uses total assets and total liabilities and the test record says so.",
        "formula": "Total assets ÷ total liabilities"
      },
      "tangibleNetWorth": {
        "label": "Tangible net worth",
        "description": "Equity at the test date. There is no intangible-asset classification yet, so this equals total equity and the test record says so.",
        "formula": "Total equity (no intangible assets deducted yet)"
      },
      "autoMatchRate": {
        "label": "Auto-match rate",
        "description": "Share of live bank statement lines in the window that the auto-match engine matched (exact reference, amount and date, or fuzzy name). A match made by hand does not count.",
        "formula": "Auto-matched statement lines ÷ all live statement lines in the window"
      },
      "daysToReconcile": {
        "label": "Days to reconcile",
        "description": "Average number of days from the end of a statement period to the day its reconciliation session was closed, over the sessions closed in the window.",
        "formula": "Average of (session closed on − statement period end) over sessions closed in the window"
      },
      "forecastAccuracy": {
        "label": "Forecast accuracy",
        "description": "How closely the published cash forecast matched the cash that actually moved. Indicative: it measures a forecast and is never certified.",
        "formula": "100 − mean absolute percentage error of the forecast buckets measured in the window"
      },
      "idleBalance": {
        "label": "Idle balance",
        "description": "Cash held in bank accounts and wallets with no movement beyond their inactivity period, net of commitments and each wallet’s operating minimum, in the legal entity’s base currency.",
        "formula": "Sum of the recoverable value on the Idle Cash Report"
      },
      "floatUtilisation": {
        "label": "Float utilisation",
        "description": "Across the wallets that state an authorised float, the share of that float that is out of the tin and not sitting in it.",
        "formula": "(Authorised float − confirmed balance) ÷ authorised float"
      }
    }
  },
  "routes": {
    "documentTitle": "{title} · EnterpriseAI ERP",
    "titles": {
      "login": "Sign in",
      "ssoCallback": "Single sign-on",
      "forgotPassword": "Reset your password",
      "resetPassword": "Choose a new password",
      "changePassword": "Choose your own password",
      "acceptInvite": "Accept your invitation",
      "dashboard": "Dashboard",
      "approvals": "Approvals",
      "users": "Users",
      "roles": "Roles",
      "audit": "Audit explorer",
      "profile": "Profile & security",
      "forbidden": "Not permitted",
      "notFound": "Page not found",
      "taxCodes": "Tax codes",
      "taxReport": "Tax Position",
      "currencies": "Currencies",
      "fxRates": "Exchange rates",
      "orgHierarchy": "Org structure",
      "orgFiscalPeriods": "Fiscal periods",
      "orgAccounts": "Chart of accounts",
      "orgOpeningBalances": "Opening balances",
      "orgGoLive": "Go-live checklist",
      "glJournalEntries": "Journal entries",
      "glJournalEntry": "Journal entry",
      "glJournalEntryNew": "New journal entry",
      "glTrialBalance": "Trial balance",
      "glIncomeStatement": "Income statement",
      "glBalanceSheet": "Balance sheet",
      "glLedger": "GL detail",
      "glRecurringTemplates": "Recurring journals",
      "apVendor": "Vendor",
      "apInvoices": "Vendor invoices",
      "apCreditNotes": "Vendor credit notes",
      "apDebitNotes": "Vendor debit notes",
      "apInvoiceNew": "New AP document",
      "apInvoice": "AP document",
      "apPaymentRun": "Payment run",
      "cashAccount": "Bank or cash account"
    }
  },
  "nav": {
    "landmark": "Modules",
    "home": "Home",
    "breadcrumbLandmark": "Breadcrumb",
    "groups": {
      "workspace": "Workspace",
      "self": "Self-service",
      "account": "Account"
    },
    "parts": {
      "home": "Home",
      "me": "Me",
      "enterprise": "1 Enterprise",
      "finance": "2 Finance",
      "treasury": "3 Treasury",
      "procurement": "4 Procurement",
      "sales": "5 Sales",
      "crm": "6 CRM",
      "inventory": "7 Inventory",
      "manufacturing": "8 Manufacturing",
      "hcm": "9 Human Capital Management",
      "pointOfSale": "10 Point of Sale",
      "propertyManagement": "11 Property Management",
      "projects": "12 Projects",
      "service": "13 Service",
      "eam": "14 Asset Management",
      "revenueManagement": "15 Revenue Management",
      "platform": "D · 17 Platform"
    },
    "items": {
      "dashboard": {
        "label": "Dashboard",
        "description": "Tenant health and what needs attention",
        "keywords": "home overview kpi"
      },
      "approvals": {
        "label": "Approvals",
        "description": "Everything waiting on your decision",
        "keywords": "inbox approve reject tasks"
      },
      "users": {
        "label": "Users",
        "description": "Tenant user accounts, invitations and roles",
        "keywords": "people staff invite accounts"
      },
      "roles": {
        "label": "Roles",
        "description": "Roles and the permissions they grant",
        "keywords": "rbac permissions access"
      },
      "audit": {
        "label": "Audit explorer",
        "description": "Immutable record of every change",
        "keywords": "log trail evidence who did what"
      },
      "profile": {
        "label": "Profile & security",
        "description": "Your details, password, MFA and active sessions",
        "keywords": "password mfa sessions me"
      },
      "taxCodes": {
        "label": "Tax codes",
        "keywords": "tax gst tgst vat wht levy rate rounding treatment",
        "description": "Rates, treatments and effective dates for every tax code."
      },
      "taxReport": {
        "label": "Tax Position",
        "keywords": "tax report gst return input output mira",
        "description": "Input and output tax for a period, with a CSV export."
      },
      "currencies": {
        "label": "Currencies",
        "keywords": "currency money mvr usd eur code symbol",
        "description": "The currencies this workspace transacts in."
      },
      "fxRates": {
        "label": "Exchange rates",
        "keywords": "fx exchange rate conversion inverse pair",
        "description": "Recorded rates by pair and date, and the rate in force on a day."
      },
      "orgHierarchy": {
        "label": "Departments & Cost Centres",
        "description": "Branches, departments, cost and profit centres",
        "keywords": "branch department cost centre profit unit"
      },
      "orgFiscalPeriods": {
        "label": "Fiscal periods",
        "description": "Calendars, periods and period close",
        "keywords": "calendar period close year"
      },
      "orgAccounts": {
        "label": "GL Accounts",
        "description": "The account tree every posting lands in",
        "keywords": "coa account ledger code"
      },
      "orgOpeningBalances": {
        "label": "Opening balances",
        "description": "Import the balances you are starting from",
        "keywords": "opening balance import csv"
      },
      "orgGoLive": {
        "label": "Go-live checklist",
        "description": "What is set up, and what is still missing",
        "keywords": "checklist setup readiness onboarding"
      },
      "glJournalEntries": {
        "label": "Journal entries",
        "keywords": "journal entry ledger posting voucher double entry",
        "description": "Raise, post and reverse journal entries."
      },
      "glTrialBalance": {
        "label": "Trial balance",
        "keywords": "trial balance tb debits credits",
        "description": "Every account, with the proof that the ledger nets to zero."
      },
      "glIncomeStatement": {
        "label": "Income statement",
        "keywords": "income statement profit loss pl revenue expenses",
        "description": "Income less expenses over a period, with comparatives."
      },
      "glBalanceSheet": {
        "label": "Balance sheet",
        "keywords": "balance sheet position assets liabilities equity",
        "description": "Position on a date, with the assets equals liabilities plus equity check."
      },
      "glLedger": {
        "label": "GL detail",
        "keywords": "general ledger detail account transactions drill down",
        "description": "Every posting on one account, with its running balance."
      },
      "glRecurringTemplates": {
        "label": "Recurring journals",
        "keywords": "recurring template schedule accrual repeat",
        "description": "Journals the worker posts on a schedule."
      },
      "apVendors": {
        "description": "Suppliers, their terms and their bank details."
      },
      "apInvoices": {
        "description": "Bills from vendors: enter, approve, post, pay."
      },
      "apPaymentRuns": {
        "description": "Propose, approve and execute supplier payments."
      },
      "apAging": {
        "description": "What is owed to suppliers, by how overdue it is."
      },
      "apSettings": {
        "label": "Payables settings",
        "keywords": "accounts payable settings duplicate invoice vendor payment defaults",
        "description": "Company-wide defaults and controls for supplier invoices and payments."
      },
      "closeYearEndPlan": {
        "label": "Year-end close plan",
        "keywords": "year end close plan retained earnings income summary fiscal year",
        "description": "What the year-end close will post, line by line, before you run it."
      },
      "arCustomers": {
        "description": "Customers, their credit limits and terms."
      },
      "arInvoices": {
        "description": "Bill customers and post to the ledger."
      },
      "arReceipts": {
        "description": "Record money in and allocate it across invoices."
      },
      "arAging": {
        "description": "What customers owe, by how overdue it is."
      },
      "cashAccounts": {
        "description": "Bank and cash accounts, mapped to the ledger."
      },
      "cashTransferInstructions": {
        "description": "The governed lifecycle: request, approve, sign, release, confirm."
      },
      "cashFundsInTransit": {
        "description": "Money that has left and not yet landed, by how long it has been out."
      },
      "treasuryPositions": {
        "description": "Published cash positions, struck once and never rewritten."
      },
      "treasuryBeneficiaries": {
        "description": "Payees a payment can be released to, with their cooling-off status."
      },
      "treasuryMandates": {
        "description": "Bank mandates and who may sign for the company."
      },
      "treasuryWallets": {
        "description": "Petty cash and imprest floats, their custodians and their counts."
      },
      "treasuryFacilities": {
        "description": "Loans, overdrafts and revolvers, and their covenants."
      },
      "treasuryForecasts": {
        "description": "Persisted 13-week forecast runs and how accurate the last one was."
      },
      "treasurySettings": {
        "description": "Transfer mode, alert thresholds and the accounts treasury posts to."
      },
      "crmAccounts": {
        "description": "Commercial accounts, contacts and segments."
      },
      "crmCampaigns": {
        "description": "Marketing campaigns, their sends and their responses."
      },
      "partyParties": {
        "description": "One record per person or organisation, linking every role they hold"
      },
      "partyMerges": {
        "description": "Duplicate parties proposed for merge, and the merge history"
      },
      "partyConsent": {
        "description": "What each party has agreed to be contacted about, and how"
      },
      "partySuppressions": {
        "description": "Addresses that must never be contacted, regardless of consent"
      },
      "partyLoyalty": {
        "description": "Loyalty programmes, tiers, members and accruals."
      },
      "arDunning": {
        "description": "Chase overdue invoices on a reminder schedule."
      },
      "bankrecSessions": {
        "description": "Match statement lines to the ledger and close a period."
      },
      "bankrecImports": {
        "description": "Import a bank statement as CSV or MT940."
      },
      "bankrecProfiles": {
        "description": "Saved column mappings, one per bank."
      },
      "budgetModels": {
        "description": "Budget models, versions and their lines."
      },
      "budgetVariance": {
        "description": "Budget against commitment, actual and available."
      },
      "budgetCommitments": {
        "description": "What is committed but not yet spent."
      },
      "budgetControlLevels": {
        "description": "How strictly each cost centre's budget is enforced, and the legal entity default it inherits."
      },
      "assetsRegister": {
        "description": "Every fixed asset, its cost and its book value."
      },
      "assetsClasses": {
        "description": "Useful life, method and the accounts each class posts to."
      },
      "assetsDepreciation": {
        "description": "Depreciation runs and what each one charged."
      },
      "assetsMovement": {
        "description": "Opening, additions, depreciation, disposals, closing."
      },
      "invItems": {
        "description": "Items, their units, barcodes and costing method."
      },
      "invStockLevels": {
        "description": "What is on hand, and how much is already promised."
      },
      "invLedger": {
        "description": "Every stock movement, in the order it happened."
      },
      "invValuation": {
        "description": "Stock value, reconciled to the ledger."
      },
      "invCycleCounts": {
        "description": "Blind counts and the variances they found."
      },
      "procRequisitions": {
        "description": "What people have asked to buy."
      },
      "procRfqs": {
        "description": "Quotes from suppliers, compared."
      },
      "procOrders": {
        "description": "Purchase orders and what has arrived against them."
      },
      "procReceipts": {
        "description": "Goods received against a purchase order."
      },
      "procMatches": {
        "description": "Invoice against order against receipt."
      },
      "procGrIr": {
        "description": "Goods received but not yet invoiced."
      },
      "procScorecards": {
        "description": "How each supplier has actually performed."
      },
      "salesQuotes": {
        "description": "Priced offers, and whether they were accepted."
      },
      "salesOrders": {
        "description": "Confirmed orders, what is promised and what has shipped."
      },
      "salesShipments": {
        "description": "Goods picked and sent, and what is left on backorder."
      },
      "salesReturns": {
        "description": "Goods sent back, restocked at the cost they left at."
      },
      "pricingPriceLists": {
        "description": "Contract, tier and quantity-break prices."
      },
      "salesSubscriptions": {
        "description": "Recurring plans and what renews when."
      },
      "salesMrr": {
        "description": "Monthly and annual recurring revenue."
      },
      "crmLeads": {
        "description": "People who might buy, and possible duplicates."
      },
      "crmOpportunities": {
        "description": "Live deals, their stage and weighted value."
      },
      "crmCases": {
        "description": "Support cases and their SLA clocks."
      },
      "crmKb": {
        "description": "Articles agents and customers search."
      },
      "hrEmployees": {
        "description": "The people this workspace employs, their contracts and their org assignment.",
        "keywords": "employee staff people contract joiner leaver hr"
      },
      "hrWorkPermits": {
        "description": "Work permits and visas, by how soon each expires.",
        "keywords": "permit visa expat expatriate immigration expiry renewal"
      },
      "hrLeaveRequests": {
        "description": "Leave asked for, decided and taken, with the balance behind it.",
        "keywords": "leave annual leave holiday absence sick request balance"
      },
      "hrLeaveCalendar": {
        "description": "Who is away, and when.",
        "keywords": "leave calendar absence away out of office roster"
      },
      "hrAttendance": {
        "description": "Hours worked, and the overtime payroll will price from them.",
        "keywords": "attendance hours worked timekeeping overtime import"
      },
      "payrollRuns": {
        "description": "Calculate, approve, post and disburse a pay period.",
        "keywords": "payroll payslip salary wages mpao pension bank file net pay"
      },
      "hrRequisitions": {
        "description": "Approved headcount, and the candidates raised against it.",
        "keywords": "requisition headcount vacancy recruitment hiring position"
      },
      "hrCandidates": {
        "description": "People being considered, and where each of them has got to.",
        "keywords": "candidate applicant recruitment interview shortlist hiring"
      },
      "hrOffers": {
        "description": "What has been offered, to whom, and what came of it.",
        "keywords": "offer letter hiring accepted declined package"
      },
      "hrLeaveTypes": {
        "description": "The kinds of leave this workspace grants, and what accrues each month.",
        "keywords": "leave type policy accrual entitlement annual leave balance"
      },
      "hrOvertimeRules": {
        "description": "How extra hours are turned into paid overtime.",
        "keywords": "overtime rule multiplier hours rate weekend holiday"
      },
      "payrollComponents": {
        "description": "Earnings, deductions and employer costs, as formulas.",
        "keywords": "pay component earning deduction allowance mpao formula statutory rate"
      },
      "projects": {
        "description": "Work broken into phases and tasks, costed from timesheets and billed to a customer.",
        "keywords": "project job wbs task phase milestone gantt schedule profitability"
      },
      "projectsTimesheets": {
        "label": "My timesheets",
        "description": "Key in your week and submit it for approval.",
        "keywords": "timesheet my hours time entry week ess submit"
      },
      "serviceTickets": {
        "description": "Service work, its SLA clock, and the parts and labour it used.",
        "keywords": "ticket service job sla repair breakdown technician case"
      },
      "serviceWorkOrders": {
        "description": "The field job: instructions, skills required, parts, labour and the completion sheet.",
        "keywords": "work order field job dispatch technician visit completion"
      },
      "serviceDispatch": {
        "description": "The day and week board: who is free, who is qualified, who is legal to send.",
        "keywords": "dispatch board schedule technician assign skill working time"
      },
      "serviceContracts": {
        "description": "Coverage, quotas, rate cards and the renewal queue.",
        "keywords": "contract entitlement coverage quota renewal service level"
      },
      "serviceRateCards": {
        "description": "What a job costs, by skill, by version, over time.",
        "keywords": "rate card price version publish labour parts"
      },
      "serviceVans": {
        "description": "What a van holds, what it should hold, and the replenishment proposal.",
        "keywords": "van stock par level replenishment field warehouse"
      },
      "serviceProblems": {
        "description": "Known errors, workarounds and the articles they produced.",
        "keywords": "problem known error workaround knowledge base kb"
      },
      "serviceCustomerAssets": {
        "description": "Equipment a customer owns and this desk services.",
        "keywords": "customer asset equipment serial model machine unit"
      },
      "servicePmSchedules": {
        "description": "Maintenance that falls due, and the tickets it raises.",
        "keywords": "preventive maintenance pm schedule service plan due"
      },
      "serviceReports": {
        "description": "First-time fix, SLA compliance and customer satisfaction.",
        "keywords": "service report sla compliance ftf first time fix csat"
      },
      "serviceAssignmentRules": {
        "description": "Who a new ticket goes to, and on what grounds.",
        "keywords": "assignment rule routing technician queue auto assign"
      },
      "projectsSettings": {
        "description": "The WIP and payroll-clearing accounts timesheet costing posts between.",
        "keywords": "project settings wip work in progress payroll clearing account costing"
      },
      "serviceSettings": {
        "description": "The default warehouse parts come from, and the account service invoices credit.",
        "keywords": "service settings default warehouse revenue account billing"
      },
      "eamAssets": {
        "description": "Criticality, ownership, links, meters, failures and compliance status",
        "keywords": "asset equipment register criticality lifecycle maintain"
      },
      "eamLocations": {
        "description": "The plant hierarchy: block, room, unit, right down to the asset",
        "keywords": "functional location plant hierarchy tree site block"
      },
      "eamMaintenance": {
        "description": "Strategies, PM plans, task lists and the next generation preview",
        "keywords": "maintenance strategy pm plan task list preventive"
      },
      "eamMeters": {
        "description": "Cumulative readings, rollover, and the CSV import",
        "keywords": "meter reading gauge cumulative rollover import"
      },
      "eamFailures": {
        "description": "What broke, when, and how long it took to fix",
        "keywords": "failure breakdown mtbf mttr reliability downtime"
      },
      "eamCompliance": {
        "description": "The compliance calendar: due, warning and overdue by requirement",
        "keywords": "compliance inspection certificate statutory calendar due overdue"
      },
      "eamPermits": {
        "description": "Permits to work, the three-signature strip, and who is doing what",
        "keywords": "permit work isolation hot work confined space issue execute accept"
      },
      "eamDowntime": {
        "description": "Planned and unplanned windows, and what an asset is unavailable for",
        "keywords": "downtime unavailable window outage blocking"
      },
      "eamReconciliation": {
        "description": "Every operational asset against the financial register, both directions",
        "keywords": "reconciliation asset register finance mismatch unlinked"
      },
      "reportingDailyOperating": {
        "description": "One report per operating unit and business date: revenue, cost, labour, cash and exceptions, tied to the ledger",
        "keywords": "daily operating report revenue cost labour cash exceptions ledger tie"
      },
      "reportingBoard": {
        "description": "The month grid: published on time, published late, or missing, one cell per unit and date",
        "keywords": "board month grid published late missing"
      },
      "reportingMetrics": {
        "description": "What every KPI means, who owns it, and whether anybody has certified it",
        "keywords": "metric dictionary definition owner certification formula source"
      },
      "reportingExceptionViews": {
        "description": "A role's saved questions across attention, reconciliation, approvals and recommendations",
        "keywords": "exception view saved attention reconciliation approvals age"
      },
      "aiBriefings": {
        "description": "What the scheduled agents found, figures first and narration second",
        "keywords": "briefing agent cfo procurement sales inventory revenue narration"
      },
      "aiAutonomy": {
        "description": "What each AI capability may do on its own, and why a level is or is not available yet",
        "keywords": "autonomy capability delegated supervised assistive tolerance threshold"
      },
      "aiRecommendations": {
        "description": "Every AI recommendation and its outcome, by type — acceptance rate and accuracy side by side",
        "keywords": "recommendation ledger outcome accuracy accepted rejected routed"
      },
      "aiConfigAnomalies": {
        "description": "Configuration changes that look like churn, a flip-flop, a weakened control, or a bulk edit",
        "keywords": "config anomaly churn flip weaken bulk audit"
      },
      "essProfile": {
        "description": "Your own employment record — contract, department and manager.",
        "keywords": "my profile employment record contract department manager self service ess me"
      },
      "essPayslips": {
        "description": "Every payslip raised for you, and the figures behind the net pay.",
        "keywords": "payslip payslips salary wages net pay mpao pension payroll my"
      },
      "essLeave": {
        "description": "Your leave balances, and the requests you have raised.",
        "keywords": "leave holiday annual sick balance request absence my"
      },
      "essAttendance": {
        "description": "The hours recorded against you, and the overtime priced from them.",
        "keywords": "attendance hours overtime worked days timekeeping my"
      },
      "essDocuments": {
        "description": "The documents on your own HR file, to read and download.",
        "keywords": "documents file contract letter certificate download hr my"
      },
      "mfgProductionOrders": {
        "description": "What is being made, how far it has got and what it has cost.",
        "keywords": "production order works order manufacturing make wip release issue receive shop floor"
      },
      "mfgBoms": {
        "description": "The components and quantities a finished item is built from.",
        "keywords": "bom bill of materials components structure phantom alternate version"
      },
      "mfgRoutings": {
        "description": "The operations an item passes through, and the minutes each takes.",
        "keywords": "routing operations sequence work centre center standard time labour minutes"
      },
      "mfgWorkCenters": {
        "description": "Where work happens, its capacity and what an hour there costs.",
        "keywords": "work centre center machine labour rate overhead capacity resource"
      },
      "mfgMrp": {
        "description": "What to make and what to buy, netted against stock and inbound orders.",
        "keywords": "mrp material requirements planning suggestion demand supply planned shortage"
      },
      "mfgCapacity": {
        "description": "Load per work centre per week, against the hours it can take.",
        "keywords": "capacity load work centre center week schedule utilisation hours"
      },
      "mfgWipClearing": {
        "description": "Proof that every closed order has cleared its work in progress to zero.",
        "keywords": "wip work in progress clearing close variance reconcile invariant"
      },
      "mfgStandardCosts": {
        "description": "The cost an item is planned at, and the variances measured against it.",
        "keywords": "standard cost variance material labour overhead planned rate"
      },
      "mfgSettings": {
        "description": "The WIP, applied-cost and variance accounts production posts to.",
        "keywords": "manufacturing settings wip applied labour overhead variance account configuration"
      },
      "consolGroups": {
        "description": "Who consolidates into whom, and at what ownership percentage.",
        "keywords": "consolidation group parent subsidiary ownership percentage minority interest structure"
      },
      "consolRuns": {
        "description": "Translate, eliminate and consolidate a group for one period.",
        "keywords": "consolidation run translation closing rate average rate cta elimination minority interest inter-company mismatch"
      },
      "attention": {
        "description": "Everything waiting on you: approvals, exceptions and alerts, in one list."
      },
      "opcalDayBoard": {
        "description": "Open, close and reopen the business day; see what is blocking a close."
      },
      "orgLocations": {
        "description": "Address book for companies, branches and warehouses, with country-aware validation."
      },
      "orgPositions": {
        "description": "The org chart: headcount, reporting lines and who currently holds each seat."
      },
      "orgJobs": {
        "description": "What each role in the company does, independent of who holds it."
      },
      "orgJobGrades": {
        "description": "Seniority bands and their pay ranges."
      },
      "orgDesignations": {
        "description": "Payroll and tax reporting unit designations, per jurisdiction."
      },
      "orgFilingCalendar": {
        "description": "Statutory returns due, by registration and period."
      },
      "opcalCalendars": {
        "description": "Working days, shifts and holidays for each operating unit."
      },
      "authorityMatrix": {
        "description": "Who may approve what, by amount, position and document type"
      },
      "authorityDelegations": {
        "description": "Temporary approval authority handed to somebody else"
      },
      "authorityAbsences": {
        "description": "Approvals reassigned while somebody is away"
      },
      "authorityMateriality": {
        "description": "Thresholds that decide when a change needs a fresh approval"
      },
      "rulesControls": {
        "description": "Every governed control, and whether it blocks or only warns"
      },
      "rulesReasonCodes": {
        "description": "The reasons a user may give for an override, by rule"
      },
      "rulesOverrides": {
        "description": "Every recorded override, who approved it and why"
      },
      "rulesQueues": {
        "description": "Exceptions waiting for somebody to resolve them"
      },
      "attentionPolicies": {
        "description": "How each kind of alert is delivered — bell, email or digest"
      },
      "fxHolds": {
        "description": "Exchange-rate observations held for exceeding their tolerance, awaiting a decision."
      },
      "taxSimulator": {
        "label": "Tax simulator",
        "keywords": "tax simulate preview price basis jurisdiction determination waterfall",
        "description": "Work out the tax on a proposed line before raising the document."
      },
      "rvmOnTheBooks": {
        "keywords": "on the books otb snapshot occupancy adr revpar rooms sold as at",
        "description": "What is sold as at a given night, from that night's snapshot."
      },
      "rvmPace": {
        "keywords": "pace pickup last year lead time booking curve forecast",
        "description": "Today's on the books against last year and against the forecast."
      },
      "rvmCommercial": {
        "keywords": "commercial report daily occupancy adr revpar acquisition cost commission net adr",
        "description": "One property, one day: what happened, what is ahead, what it cost to acquire."
      },
      "rvmForecasts": {
        "keywords": "forecast budget version publish variance explanation approve lock",
        "description": "Forecast versions, their lines, and the variance that must be explained before publishing."
      },
      "rvmAccuracy": {
        "keywords": "accuracy mape mae bias horizon as published forecast error",
        "description": "How close each published forecast turned out to be, by lead time."
      },
      "rvmDisplacements": {
        "keywords": "displacement group evaluation net benefit hurdle decision outcome",
        "description": "Whether a group is worth more than the business it pushes out."
      },
      "rvmHurdles": {
        "keywords": "hurdle rate floor minimum adr contribution resolution tester",
        "description": "The floor a rate is tested against, and which hurdle wins on a given night."
      },
      "rvmCompetitorRates": {
        "keywords": "competitor rate shop comp set observed rate sheet import",
        "description": "Rates somebody observed, entered by hand or imported from a sheet."
      },
      "rvmDimensions": {
        "keywords": "segment stream mapping rule market source channel unmapped dimension classify",
        "description": "The segments bookings are classified into, the rules that do it, and the revenue streams a forecast is written against."
      },
      "rvmSettings": {
        "keywords": "revenue settings horizon materiality variance band hurdle enforcement unmapped segment",
        "description": "How far this property's snapshots reach, what counts as material, and whether a below-hurdle rate is refused."
      },
      "reportingDashboards": {
        "description": "The role dashboards: every KPI this build computes, each one clicking through to the rows behind it.",
        "keywords": "dashboard kpi executive finance sales inventory procurement hr project drill export"
      },
      "reportingSavedFilters": {
        "description": "Named parameter sets for the reports you run often, shared or your own",
        "keywords": "saved filter set report parameters shared"
      },
      "projectWipRuns": {
        "description": "Every open contract valued at a period end, and the journal that recognises the difference between work done and work billed.",
        "keywords": "wip work in progress contract asset liability loss provision period run post reverse"
      },
      "projectRetentions": {
        "description": "Money held back from each claim until a date, with its release calendar and any forfeits.",
        "keywords": "retention withheld release forfeit defects liability claim calendar"
      },
      "projectAdvances": {
        "description": "Money taken before the work, and the slice of it each claim recoups.",
        "keywords": "advance recoup recoupment mobilisation prepayment claim credit note"
      },
      "projectVariations": {
        "description": "Contract changes with their cost, revenue and schedule impact, internal approval and customer acceptance.",
        "keywords": "variation change order scope impact accept reject rebaseline"
      },
      "projectSubcontracts": {
        "description": "Who is doing the work, for how much, and how much has been certified.",
        "keywords": "subcontract subcontractor vendor certified retention purchase order"
      },
      "projectRisks": {
        "description": "What could go wrong on a project, how likely, what it would cost, and who owns it.",
        "keywords": "risk register matrix probability impact exposure mitigation"
      },
      "projectResources": {
        "description": "The people whose time is planned, their planning cost rate and their weekly capacity.",
        "keywords": "resource capacity planning cost rate employee hours week"
      },
      "projectAllocations": {
        "description": "Resource by week, hours booked against hours available, with the server's own conflicts.",
        "keywords": "allocation board resource week hours capacity conflict utilisation"
      },
      "projectContractAccounts": {
        "description": "The six accounts contract postings use: contract asset and liability, retention, advance and the loss provision",
        "keywords": "contract accounts mapping asset liability retention advance loss provision"
      }
    },
    "apps": {
      "home": {
        "label": "Home",
        "description": "Your day: approvals, attention and what is due"
      },
      "enterprise": {
        "label": "Enterprise",
        "description": "Legal entities, structures, hierarchies"
      },
      "finance": {
        "label": "Finance",
        "description": "Ledger, payables, receivables, close"
      },
      "treasury": {
        "label": "Treasury",
        "description": "Cash, banks, liquidity and risk"
      },
      "procurement": {
        "label": "Procurement",
        "description": "Requisitions to supplier payment"
      },
      "sales": {
        "label": "Sales",
        "description": "Quotes, orders, pricing and returns"
      },
      "crm": {
        "label": "CRM",
        "description": "Leads, opportunities and cases"
      },
      "inventory": {
        "label": "Inventory",
        "description": "Items, stock, warehouses and counts"
      },
      "manufacturing": {
        "label": "Manufacturing",
        "description": "BOMs, routings, production, quality"
      },
      "hcm": {
        "label": "People",
        "description": "Workforce, leave, rosters and payroll"
      },
      "pos": {
        "label": "Point of Sale",
        "description": "Outlets, terminals, tills and menus"
      },
      "pms": {
        "label": "Property",
        "description": "Reservations, rooms and front desk"
      },
      "projects": {
        "label": "Projects",
        "description": "Plans, timesheets, billing and margin"
      },
      "service": {
        "label": "Service",
        "description": "Tickets, SLAs and field work"
      },
      "eam": {
        "label": "Asset Management",
        "description": "Assets, maintenance and work orders"
      },
      "revenue": {
        "label": "Revenue Management",
        "description": "Demand, rates and yield"
      },
      "platform": {
        "label": "Platform",
        "description": "Users, roles, reporting, AI and audit"
      },
      "me": {
        "label": "Me",
        "description": "Payslips, leave, documents and profile"
      }
    },
    "fsd": {
      "overview": "Overview",
      "s1_2_1": {
        "short": "Enterprise",
        "full": "Enterprise Definition and Global Defaults"
      },
      "s1_2_2": {
        "short": "Divisions",
        "full": "Divisions and Management Hierarchy"
      },
      "s1_2_3": {
        "short": "Legal Entities",
        "full": "Legal Entities and Multi-Entity Management"
      },
      "s1_2_4": {
        "short": "Business Units",
        "full": "Business Units and Business Functions"
      },
      "s1_2_5": {
        "short": "Workforce",
        "full": "Workforce Structures — Departments, Jobs, Positions and Grades"
      },
      "s1_2_6": {
        "short": "Reference Data",
        "full": "Reference Data Sets (SetID)"
      },
      "s1_2_7": {
        "short": "Financial Structures",
        "full": "Financial Structures — Chart of Accounts, Ledgers, Calendars and Currencies"
      },
      "s1_2_8": {
        "short": "Localisation",
        "full": "Locations, Geographies and Localisation"
      },
      "s1_2_9": {
        "short": "Hierarchies",
        "full": "Organisation Hierarchies and Effective Dating"
      },
      "s1_1": {
        "short": "Governance",
        "full": "Requirement catalogue"
      },
      "s2_2_1": {
        "short": "General Ledger",
        "full": "General Ledger"
      },
      "s2_2_2": {
        "short": "Accounts Payable",
        "full": "Accounts Payable"
      },
      "s2_2_3": {
        "short": "Accounts Receivable",
        "full": "Accounts Receivable"
      },
      "s2_2_4": {
        "short": "Fixed Assets",
        "full": "Fixed Assets"
      },
      "s2_2_5": {
        "short": "Budgeting",
        "full": "Budgeting and Commitment Control"
      },
      "s2_2_6": {
        "short": "Cost Accounting",
        "full": "Cost Accounting"
      },
      "s2_2_7": {
        "short": "Consolidation",
        "full": "Consolidation"
      },
      "s2_2_8": {
        "short": "Period Close",
        "full": "Period Close and Financial Reporting"
      },
      "s2_1": {
        "short": "Requirements",
        "full": "Requirement catalogue"
      },
      "s3_2_1": {
        "short": "Cash Management",
        "full": "Cash Management"
      },
      "s3_2_2": {
        "short": "Wallet Management",
        "full": "Wallet Management"
      },
      "s3_2_3": {
        "short": "Debt Management",
        "full": "Debt Management"
      },
      "s3_2_4": {
        "short": "Treasury Forecasting",
        "full": "Treasury Forecasting"
      },
      "s4_2_1": {
        "short": "Purchase Requisition",
        "full": "Purchase Requisition"
      },
      "s4_2_2": {
        "short": "Supplier Management",
        "full": "Supplier Management and Evaluation"
      },
      "s4_2_3": {
        "short": "Sourcing",
        "full": "Sourcing and Request for Quotation"
      },
      "s4_2_5": {
        "short": "Purchase Order and Amendment",
        "full": "Purchase Order and Amendment"
      },
      "s4_2_6": {
        "short": "Goods Receipt and Inspection",
        "full": "Goods Receipt and Inspection"
      },
      "s4_2_7": {
        "short": "Three-Way Match",
        "full": "Three-Way Match and Variance Resolution"
      },
      "s4_2_8": {
        "short": "Contracts and Blanket Orders",
        "full": "Contracts, Blanket Orders and Procurement Analytics"
      },
      "s5_2_1": {
        "short": "Quotation Management",
        "full": "Quotation Management"
      },
      "s5_2_2": {
        "short": "Sales Order Management",
        "full": "Sales Order Management"
      },
      "s5_2_3": {
        "short": "Pricing Engine",
        "full": "Pricing Engine"
      },
      "s5_2_4": {
        "short": "Discount Engine",
        "full": "Discount Engine and Margin Control"
      },
      "s5_2_5": {
        "short": "Fulfilment Orchestration",
        "full": "Fulfilment Orchestration"
      },
      "s5_2_6": {
        "short": "Invoicing and Returns",
        "full": "Invoicing, Returns and Credit Notes"
      },
      "s5_2_7": {
        "short": "Revenue Recognition",
        "full": "Revenue Recognition"
      },
      "s5_2_8": {
        "short": "Subscription",
        "full": "Subscription and Recurring Billing"
      },
      "s5_1": {
        "short": "Requirements",
        "full": "Requirement catalogue"
      },
      "s6_2_1": {
        "short": "Lead Management",
        "full": "Lead Management"
      },
      "s6_2_2": {
        "short": "Opportunity Management",
        "full": "Opportunity Management"
      },
      "s6_2_3": {
        "short": "Account Management",
        "full": "Account Management"
      },
      "s6_2_4": {
        "short": "Contact Management and Consent",
        "full": "Contact Management and Consent"
      },
      "s6_2_5": {
        "short": "Campaign Management",
        "full": "Campaign Management"
      },
      "s7_2_1": {
        "short": "Warehouse and Bin Structure",
        "full": "Warehouse and Bin Structure"
      },
      "s7_2_2": {
        "short": "Lot, Batch and Serial Tracking",
        "full": "Lot, Batch and Serial Tracking"
      },
      "s7_2_3": {
        "short": "Stock Movements and Transfers",
        "full": "Stock Movements and Transfers"
      },
      "s7_2_4": {
        "short": "Reservations and Allocation",
        "full": "Reservations, Allocation and Available-to-Promise"
      },
      "s7_2_5": {
        "short": "Adjustments and Write-Offs",
        "full": "Adjustments, Write-Offs and Physical Counting"
      },
      "s7_2_6": {
        "short": "Valuation and Costing",
        "full": "Valuation, Costing and Reconciliation"
      },
      "s7_2_7": {
        "short": "Replenishment Planning",
        "full": "Replenishment Planning and Stock Optimisation"
      },
      "s7_2_8": {
        "short": "Landed Cost Management",
        "full": "Landed Cost Management"
      },
      "s7_1": {
        "short": "Requirements",
        "full": "Requirement catalogue"
      },
      "s8_2_1": {
        "short": "Bill of Material",
        "full": "Bill of Material and Engineering Change Control"
      },
      "s8_2_2": {
        "short": "Routing and Work Centres",
        "full": "Routing, Work Centres and Capacity Model"
      },
      "s8_2_3": {
        "short": "Material Requirements Planning",
        "full": "Material Requirements Planning"
      },
      "s8_2_4": {
        "short": "Capacity Planning",
        "full": "Capacity Planning and Production Scheduling"
      },
      "s8_2_5": {
        "short": "Production Orders",
        "full": "Production Orders and Material Issue"
      },
      "s8_2_7": {
        "short": "Quality Management",
        "full": "Quality Management and Non-Conformance"
      },
      "s8_2_8": {
        "short": "Production Costing",
        "full": "Production Costing and Order Settlement"
      },
      "s9_2_1": {
        "short": "Employee Lifecycle",
        "full": "Employee Lifecycle and Position Management"
      },
      "s9_2_2": {
        "short": "Recruitment",
        "full": "Recruitment and Applicant Tracking"
      },
      "s9_2_3": {
        "short": "Attendance, Time and Rostering",
        "full": "Attendance, Time and Rostering"
      },
      "s9_2_4": {
        "short": "Leave and Absence Management",
        "full": "Leave and Absence Management"
      },
      "s9_2_5": {
        "short": "Payroll",
        "full": "Payroll"
      },
      "s9_2_7": {
        "short": "Learning",
        "full": "Learning and Compliance Training"
      },
      "s9_1": {
        "short": "Requirements",
        "full": "Requirement catalogue"
      },
      "s10_2_1": {
        "short": "POS Core and Checkout",
        "full": "POS Core and Checkout"
      },
      "s10_2_2": {
        "short": "Offline Operation",
        "full": "Offline Operation and Synchronisation"
      },
      "s10_2_4": {
        "short": "Restaurant Operations",
        "full": "Restaurant Operations and Kitchen Display"
      },
      "s10_2_5": {
        "short": "Pricing and Promotions",
        "full": "Pricing, Promotions and Menu Management"
      },
      "s10_2_7": {
        "short": "Cash Management",
        "full": "Cash Management and Shift Close"
      },
      "s10_2_8": {
        "short": "Business Day Close",
        "full": "Business Day Close and Revenue Posting"
      },
      "s10_2_9": {
        "short": "Retail Selling",
        "full": "Retail Selling"
      },
      "s11_2_1": {
        "short": "Reservations",
        "full": "Reservations"
      },
      "s11_2_2": {
        "short": "Groups, Blocks and Allotments",
        "full": "Groups, Blocks and Allotments"
      },
      "s11_2_3": {
        "short": "Front Desk Operations",
        "full": "Front Desk Operations"
      },
      "s11_2_4": {
        "short": "Housekeeping and Room Status",
        "full": "Housekeeping and Room Status"
      },
      "s11_2_5": {
        "short": "Folio and Billing",
        "full": "Folio and Billing"
      },
      "s11_2_6": {
        "short": "Rate and Inventory Management",
        "full": "Rate and Inventory Management"
      },
      "s11_2_7": {
        "short": "Distribution",
        "full": "Distribution and Channel Management"
      },
      "s11_2_8": {
        "short": "Night Audit and Reconciliation",
        "full": "Night Audit and Reconciliation"
      },
      "s11_2_9": {
        "short": "Ancillary Revenue",
        "full": "Ancillary Revenue and Activity Management"
      },
      "s11_2_10": {
        "short": "Board Basis",
        "full": "Board Basis and Meal Plan Management"
      },
      "s11_2_11": {
        "short": "Guest Services and Requests",
        "full": "Guest Services, Requests and Service Recovery"
      },
      "s11_2_12": {
        "short": "Arrival Logistics",
        "full": "Arrival Logistics and Transfers"
      },
      "s12_2_1": {
        "short": "Project Definition",
        "full": "Project Definition and Planning"
      },
      "s12_2_2": {
        "short": "Change Control and Variations",
        "full": "Change Control and Variations"
      },
      "s12_2_3": {
        "short": "Resource Planning",
        "full": "Resource Planning and Allocation"
      },
      "s12_2_4": {
        "short": "Time and Expense Capture",
        "full": "Time and Expense Capture"
      },
      "s12_2_6": {
        "short": "Revenue Recognition",
        "full": "Revenue Recognition and Work in Progress"
      },
      "s12_2_7": {
        "short": "Project Billing",
        "full": "Project Billing"
      },
      "s12_1": {
        "short": "Requirements",
        "full": "Requirement catalogue"
      },
      "s13_2_1": {
        "short": "Ticket Capture and Triage",
        "full": "Ticket Capture and Triage"
      },
      "s13_2_2": {
        "short": "Entitlements",
        "full": "Entitlements and Service Contracts"
      },
      "s13_2_3": {
        "short": "Service Level Management",
        "full": "Service Level Management"
      },
      "s13_2_4": {
        "short": "Knowledge Management",
        "full": "Knowledge Management"
      },
      "s13_2_5": {
        "short": "Field Service Work Orders",
        "full": "Field Service Work Orders"
      },
      "s13_2_6": {
        "short": "Scheduling and Dispatch",
        "full": "Scheduling and Dispatch"
      },
      "s13_2_7": {
        "short": "Service Parts and Van Stock",
        "full": "Service Parts and Van Stock"
      },
      "s13_2_8": {
        "short": "Service Billing",
        "full": "Service Billing and Cost Recovery"
      },
      "s13_1": {
        "short": "Requirements",
        "full": "Requirement catalogue"
      },
      "s14_2_1": {
        "short": "Asset Register and Hierarchy",
        "full": "Asset Register and Hierarchy"
      },
      "s14_2_3": {
        "short": "Maintenance Strategy",
        "full": "Maintenance Strategy and Preventive Plans"
      },
      "s14_2_4": {
        "short": "Condition Monitoring",
        "full": "Condition Monitoring and Predictive Maintenance"
      },
      "s14_2_5": {
        "short": "Maintenance Work Orders",
        "full": "Maintenance Work Orders"
      },
      "s14_2_6": {
        "short": "Failure Analysis",
        "full": "Failure Analysis and Reliability"
      },
      "s14_2_8": {
        "short": "Asset Performance",
        "full": "Asset Performance, Compliance and Replacement Decisions"
      },
      "s15_2_1": {
        "short": "Budget, Forecast and Pace",
        "full": "Budget, Forecast and Pace"
      },
      "s15_2_2": {
        "short": "Group and Contract Evaluation",
        "full": "Group and Contract Evaluation"
      },
      "s15_1": {
        "short": "Requirements",
        "full": "Requirement catalogue"
      },
      "sD_2": {
        "short": "Authority and Approval",
        "full": "Authority, Approval and Delegation"
      },
      "sD_3": {
        "short": "Audit and Reason Codes",
        "full": "Audit, Reason Codes, Reversal and Correction"
      },
      "sD_4": {
        "short": "Notification, Task and Attention",
        "full": "Notification, Task and Attention Management"
      },
      "sD_5": {
        "short": "User Experience Baseline",
        "full": "User Experience Baseline"
      },
      "sD_6": {
        "short": "Master Data Authority",
        "full": "Master Data Authority and Governance"
      },
      "sD_8": {
        "short": "Reporting",
        "full": "Reporting, Metric Governance and the Enterprise View"
      },
      "sD_9_1": {
        "short": "Exception and Degraded Operation",
        "full": "Exception and Degraded Operation Management"
      },
      "sD_9_2": {
        "short": "Authority and Delegation",
        "full": "Authority and Delegation Management"
      },
      "s17": {
        "short": "Artificial Intelligence",
        "full": "Artificial Intelligence Functional Requirements"
      }
    }
  },
  "shell": {
    "sidebar": {
      "favourites": "Favourites",
      "recent": "Recent",
      "collapse": "Collapse",
      "collapseNav": "Collapse navigation",
      "expandNav": "Expand navigation",
      "addFavourite": "Add {name} to favourites",
      "removeFavourite": "Remove {name} from favourites",
      "pinned": "Pinned",
      "fsdPart": "FSD Part {n}",
      "filterPlaceholder": "Screen, FSD number or code…",
      "filterLabel": "Filter the {app} menu",
      "noMatches": "No screens match “{query}”",
      "noMatchesHint": "Nothing in {app} goes by that name. Try another word, or search every app and record.",
      "searchEverything": "Search everything",
      "flaggedTooltip": "{name} (not in FSD)",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all",
      "sectionCount": "{n} screen | {n} screens"
    },
    "topbar": {
      "searchLabel": "Search everything",
      "searchPlaceholder": "Search documents, people, reports and actions",
      "shortcuts": "Keyboard shortcuts",
      "insights": "Insights panel",
      "toggleInsights": "Toggle insights panel",
      "appMenu": "{app} menu",
      "goHome": "Go to Home",
      "openAppHome": "Open {app}"
    },
    "quickCreate": {
      "trigger": "Create",
      "menuLabel": "Create",
      "unavailable": "Create (unavailable)"
    },
    "theme": {
      "menuLabel": "Appearance",
      "trigger": "Change appearance",
      "current": "Current",
      "tooltip": "Appearance: {choice}",
      "light": "Light",
      "dark": "Dark",
      "system": "Match system"
    },
    "locale": {
      "menuLabel": "Language",
      "trigger": "Change language",
      "current": "Current"
    },
    "userMenu": {
      "menuLabel": "Account",
      "trigger": "Account menu for {name}",
      "signedIn": "Signed in",
      "account": "Account",
      "noName": "—"
    },
    "banner": {
      "suspended": "This workspace is suspended, so changes are blocked. Existing records stay readable. Contact your administrator to reactivate it.",
      "sessionEnded": "Your session ended. Sign in again to continue."
    },
    "readOnly": {
      "reason": "This workspace is suspended, so changes are blocked. Contact your administrator."
    },
    "rail": {
      "landmark": "Insights",
      "title": "Insights",
      "close": "Close insights",
      "sections": "Insight sections",
      "tabs": {
        "activity": "Activity",
        "audit": "Audit trail",
        "session": "Session"
      },
      "linked": "Linked",
      "emptyTitle": "Nothing selected",
      "emptyDescription": "Open a record to see who changed it, when, and what changed.",
      "changesSince": {
        "label": "Changes since you last acted",
        "heading": "{count} changes since you last acted, on {since}",
        "upToDate": "Nothing has changed since you last acted on this.",
        "neverActed": "You have not acted on this record yet.",
        "unknownBaseline": "Your last action on this record is older than the history loaded here — open the full audit trail below to see what changed.",
        "more": "and {count} more",
        "emptyValue": "empty",
        "changedTo": "changed to"
      },
      "signedInAs": "Signed in as",
      "facts": {
        "name": "Name",
        "email": "Email",
        "workspace": "Workspace",
        "roles": "Roles",
        "permissions": "Permissions",
        "tokenExpires": "Token expires",
        "permissionsGranted": "{count} granted"
      }
    },
    "timeline": {
      "emptyTitle": "No recorded activity",
      "emptyDescription": "Activity appears here as soon as this record changes."
    },
    "attachments": {
      "title": "Attachments",
      "description": "Receipts and supporting documents for this record. PDF, image, Excel, Word or CSV, up to {max} MB each.",
      "upload": "Upload",
      "uploading": "Uploading attachments",
      "loadFailed": "The attachments could not be loaded.",
      "dropHint": "Drop files here, or choose Upload.",
      "accepted": "Accepted: PDF, PNG, JPG, XLSX, DOCX, CSV — up to {max} MB. The file's content is checked, not just its name.",
      "progress": "Uploading {done} of {total}: {name}",
      "rejected": "{name} was not attached",
      "dismiss": "Dismiss the message about {name}",
      "conflict": "Someone changed these attachments before your delete went through. The list has been reloaded — check it and try again.",
      "emptyTitle": "No attachments yet",
      "emptyDescription": "Attach the receipt or supporting document here — drop a file onto this panel or choose Upload. Whoever reviews this record sees it here.",
      "emptyReadOnly": "Nothing has been attached to this record.",
      "downloadName": "Download {name}",
      "deleteName": "Delete {name}",
      "deleteTitle": "Delete attachment?",
      "deleteMessage": "{name} will be removed from this record. The deletion is recorded in the audit trail.",
      "uploaded": "Attached {count} file(s)",
      "deleted": "Attachment deleted",
      "uploadFailed": "The file could not be attached.",
      "downloadFailed": "The download link could not be opened.",
      "deleteFailed": "The attachment could not be deleted.",
      "bySystem": "by the system",
      "byYou": "by you",
      "byUser": "by user #{id}",
      "portal": {
        "badge": "Visible in portal",
        "share": "Share with portal",
        "withdraw": "Hide from portal",
        "shareName": "Share {name} with the portal",
        "withdrawName": "Hide {name} from the portal",
        "confirmTitle": "Share this file?",
        "confirmMessage": "The {party} will be able to see this file ({name}).",
        "party": {
          "customer": "customer",
          "supplier": "supplier",
          "contractor": "contractor",
          "counterparty": "counterparty"
        },
        "shared": "File shared with the portal",
        "withdrawn": "File hidden from the portal",
        "failed": "The portal visibility could not be changed."
      }
    },
    "cheatSheet": {
      "title": "Keyboard shortcuts",
      "description": "Everything currently bound on this screen.",
      "empty": "This screen binds no shortcuts of its own.",
      "groups": {
        "global": "Global",
        "navigation": "Navigation",
        "document": "Documents",
        "grid": "Line grids",
        "list": "Lists",
        "approvals": "Approvals"
      }
    },
    "shortcuts": {
      "palette": "Open the command palette",
      "search": "Search everything",
      "cheatSheet": "Show this shortcut list",
      "quickCreate": "Quick create",
      "insights": "Toggle the insights panel",
      "apps": "Open the app launcher"
    },
    "fsd": {
      "notInFsd": "Not in FSD",
      "notInFsdHint": "No feature specification for this screen in the FSD (docs/FSD x ERP Cloud 1.docx). Flagged for scope review — see docs/FSD_UI_EXTRANEOUS.md.",
      "chipLabel": "FSD {ref}",
      "featureLabel": "Feature {code}",
      "identification": "FSD identification"
    },
    "launcher": {
      "trigger": "Apps",
      "triggerHint": "Apps ({shortcut})",
      "title": "Apps",
      "searchPlaceholder": "Search apps and screens",
      "searchLabel": "Search apps and screens",
      "resultsLabel": "Matching apps and screens",
      "appsGroup": "Apps",
      "screensGroup": "Screens",
      "gridLabel": "All apps",
      "emptyTitle": "Nothing matches “{query}”",
      "emptyHint": "Try a shorter word, or use Search in the top bar to look through records and actions too.",
      "openApp": "Open {app}",
      "paletteGroup": "Apps"
    }
  },
  "palette": {
    "title": "Command palette",
    "listLabel": "Commands",
    "placeholder": "Search screens, actions and things to create…",
    "empty": "Nothing matches that. Try a module name, or a document number.",
    "hint": {
      "navigate": "to navigate",
      "run": "to run",
      "close": "to close",
      "escKey": "Esc"
    },
    "groups": {
      "goTo": "Go to",
      "create": "Create",
      "actions": "Actions"
    },
    "commands": {
      "insights": "Toggle insights panel",
      "insightsKeywords": "right rail timeline assistant",
      "shortcuts": "Keyboard shortcuts",
      "shortcutsKeywords": "help keys cheat sheet",
      "signOut": "Sign out",
      "signOutKeywords": "logout leave",
      "createKeywords": "new add"
    }
  },
  "quickCreate": {
    "inviteUser": {
      "label": "Invite user",
      "description": "Send an invitation and assign roles"
    }
  },
  "auth": {
    "login": {
      "title": "Sign in",
      "subtitle": "Use your workspace credentials to continue.",
      "workspaceHint": "The short name your administrator gave you, e.g. velaa",
      "workspacePlaceholder": "workspace",
      "emailPlaceholder": "you{'@'}company.mv",
      "totpLabel": "Authentication code",
      "totpHint": "Six digits from your authenticator app",
      "totpPlaceholder": "000000",
      "submitting": "Signing in",
      "forgotPassword": "Forgot your password?",
      "haveInvitation": "I have an invitation",
      "sessionExpired": "Your session expired, so you were signed out. Sign in again to continue where you left off."
    },
    "sso": {
      "sectionLabel": "Single sign-on",
      "orDivider": "or",
      "signInWith": "Sign in with {provider}",
      "starting": "Opening your sign-in provider",
      "startFailed": "Single sign-on could not be started. Try again, or sign in with your password.",
      "callback": {
        "title": "Single sign-on",
        "subtitle": "Finishing your sign-in.",
        "working": "Signing you in"
      },
      "errors": {
        "providerDenied": "Your sign-in provider did not complete the sign-in. Try again from the sign-in page.",
        "invalidRequest": "The sign-in provider's response was incomplete. Start again from the sign-in page.",
        "expiredOrInvalidState": "This sign-in took too long or was already used. Start again from the sign-in page.",
        "internalError": "Something went wrong while finishing your sign-in. Try again in a moment.",
        "accountNotActive": "Your account in this workspace is not active. Ask your administrator to reactivate it.",
        "noAccount": "There is no account for you in this workspace. Ask your administrator to invite you.",
        "emailNotVerified": "Your sign-in provider has not verified your email address, so it cannot be used to sign in here.",
        "domainNotAllowed": "Your email address's domain is not allowed to sign in to this workspace with this provider.",
        "providerUnavailable": "This sign-in provider is no longer available for this workspace. Sign in another way, or ask your administrator.",
        "ssoFailed": "Single sign-on did not succeed. Start again from the sign-in page.",
        "notStartedHere": "This sign-in was not started in this browser tab, so it was not completed. Start again from the sign-in page.",
        "missingTicket": "There is no sign-in to finish here. Start from the sign-in page.",
        "ticketInvalid": "This sign-in link has expired or was already used. Start again from the sign-in page.",
        "tenantMismatch": "This sign-in belongs to a different workspace than the one you chose, so it was not completed. Start again from the sign-in page.",
        "sessionEnded": "Another sign-in in this tab replaced this one. Start again from the sign-in page."
      }
    },
    "forgot": {
      "title": "Reset your password",
      "subtitle": "We will email a link that lets you choose a new one.",
      "sent": "If that address belongs to an account in this workspace, a reset link is on its way. The link is valid for a short time — check spam if it does not arrive.",
      "submit": "Send reset link"
    },
    "reset": {
      "title": "Choose a new password",
      "subtitle": "Your new password takes effect immediately.",
      "done": "Password updated. Every other session was signed out.",
      "tokenLabel": "Reset token",
      "tokenHint": "Copied from your email link",
      "newPasswordHint": "At least 12 characters. Long beats complicated.",
      "confirmLabel": "Confirm new password",
      "submit": "Update password"
    },
    "changePassword": {
      "title": "Choose your own password",
      "subtitle": "One step, and the rest of the workspace opens.",
      "why": "This account's password was set by someone else, so everything except this screen is blocked until you replace it.",
      "currentLabel": "Password you were given",
      "currentHint": "The one an administrator handed you, or the one from your invitation.",
      "newHint": "At least {min} characters. Long beats complicated.",
      "submit": "Change password and continue"
    },
    "invite": {
      "title": "Accept your invitation",
      "subtitle": "Choose a password and your workspace opens straight away.",
      "tokenLabel": "Invitation token",
      "tokenHint": "Copied from your invitation email",
      "nameLabel": "Your name",
      "nameHint": "Leave blank to keep the name your administrator entered",
      "passwordHint": "At least 12 characters.",
      "submitting": "Setting up",
      "submit": "Accept invitation"
    }
  },
  "dashboard": {
    "greeting": "Good to see you, {name}",
    "greetingFallback": "there",
    "subtitle": "Workspace {slug}. Here is where things stand.",
    "protected": "Account protected",
    "unprotected": "Two-factor off",
    "summaryFailed": "The workspace summary did not load",
    "kpi": {
      "activeUsers": "Active users",
      "activeUsersHelp": "People who can sign in right now.",
      "activeUsersDrill": "View active users",
      "invitations": "Invitations outstanding",
      "invitationsHelp": "Invited but not yet signed in for the first time.",
      "invitationsDrill": "View outstanding invitations",
      "withMfa": "Accounts with two-factor",
      "withMfaHelp": "Counted across every user in the workspace.",
      "allUsersDrill": "View all users",
      "withoutRole": "Users without a role",
      "withoutRoleHelp": "Signed in but permitted nothing. Usually an unfinished invitation.",
      "roles": "Roles defined",
      "rolesHelp": "Seeded role set plus anything your workspace has added.",
      "rolesDrill": "View roles",
      "sessions": "Your active sessions",
      "sessionsHelp": "Devices currently signed in as you. Revoke anything you do not recognise.",
      "sessionsDrill": "View your sessions"
    },
    "usersByStatus": {
      "title": "Users by status",
      "description": "The whole directory, counted.",
      "emptyTitle": "No users yet",
      "emptyDescription": "Invite your first teammate to start populating this workspace.",
      "inviteFirst": "Invite your first teammate",
      "chartLabel": "Bar chart of users by status"
    },
    "checklist": {
      "title": "Getting started",
      "description": "Computed from what is actually set up.",
      "done": "Done",
      "todo": "To do",
      "mfa": "Protect your own account with an authenticator app",
      "invite": "Invite the rest of your team",
      "roles": "Give everyone a role — nobody should be signed in with no permissions",
      "accept": "Chase outstanding invitations"
    }
  },
  "users": {
    "list": {
      "title": "Users",
      "description": "Who can sign in to this workspace, and what they are allowed to do.",
      "tableLabel": "Tenant users",
      "loadFailed": "The user list did not load",
      "searchPlaceholder": "Search name or email",
      "searchLabel": "Search users",
      "filterByStatus": "Filter by status",
      "emptyTitle": "No users yet",
      "emptyDescription": "Invite your first teammate and they will appear here once they accept.",
      "inviteFirst": "Invite your first teammate",
      "shareHint": "This view is in the address bar — copy the URL to share exactly what you are looking at.",
      "noRoles": "No roles assigned",
      "columns": {
        "name": "Name",
        "status": "Status",
        "roles": "Roles",
        "mfa": "MFA",
        "lastLogin": "Last sign-in",
        "added": "Added"
      },
      "mfaOn": "On",
      "mfaOff": "Off",
      "bulk": {
        "disable": "Disable",
        "reinstate": "Reinstate",
        "resend": "Resend invitation",
        "updated": "{count} user updated | {count} users updated",
        "resendDetail": "Fresh invitation links are on their way.",
        "partialFailure": "{failed} of {total} could not be updated"
      },
      "export": {
        "success": "Exported {count} user | Exported {count} users",
        "truncated": "The export stopped at the first 4,000 rows. Narrow the filter for the rest.",
        "failed": "The export failed",
        "columns": {
          "name": "Name",
          "email": "Email",
          "status": "Status",
          "roles": "Roles",
          "mfa": "MFA",
          "jobTitle": "Job title",
          "phone": "Phone",
          "locale": "Locale",
          "lastLogin": "Last sign-in",
          "created": "Created"
        },
        "mfaEnabled": "enabled",
        "mfaDisabled": "disabled"
      },
      "views": {
        "trigger": "Views",
        "label": "Saved views",
        "empty": "Filter the list, then save it here to come back to it in one click.",
        "namePlaceholder": "Name this view",
        "nameLabel": "Name this view",
        "delete": "Delete view {name}",
        "saved": "View saved",
        "savedDetail": "\"{name}\" now appears in your saved views."
      },
      "rail": {
        "lastSeen": "Last seen",
        "lastLogin": "Last signed in",
        "passwordChanged": "Password last changed",
        "created": "Account created",
        "subtitle": "{email} · {status}",
        "rolesLink": "Roles and permissions"
      }
    },
    "status": {
      "active": "Active",
      "invited": "Invited",
      "disabled": "Disabled"
    },
    "invite": {
      "title": "Invite user",
      "description": "Create an account for a colleague, and choose how they sign in the first time.",
      "emailPlaceholder": "name{'@'}company.mv",
      "namePlaceholder": "Aishath Ahmed",
      "noRolePermission": "You can invite this person now; a colleague with role administration can assign their roles afterwards.",
      "submit": "Send invitation",
      "submitting": "Sending invitation",
      "sent": "Invitation sent",
      "sentDetail": "{email} can now set a password and sign in.",
      "failed": "The invitation could not be sent",
      "credential": {
        "legend": "How they sign in the first time",
        "invite": "Send an invitation",
        "inviteHint": "They get an email with a link and choose their own password. Nothing works until they accept.",
        "set": "Set a password",
        "setHint": "For someone who has no mailbox yet. Hand it over in person, never by email.",
        "generate": "Generate a password",
        "generateHint": "A strong one is created for you and shown exactly once."
      },
      "passwordHint": "At least {min} characters. Hand it over in person, never by email.",
      "mustChange": {
        "label": "Require them to change it at first sign-in",
        "hint": "Until they do, they can sign in and do nothing else. Leave this on unless you have a reason not to — it is what makes your knowing the password temporary."
      },
      "submitCreate": "Create user",
      "submittingCreate": "Creating user",
      "created": "User created",
      "createdDetail": "{email} can sign in now.",
      "handover": {
        "warning": "This is the only time this password is shown. It is not stored anywhere it can be read back — if it is lost, set a new one.",
        "label": "Password for {name}",
        "acknowledge": "I have written this down or handed it over",
        "copied": "Password copied",
        "copiedDetail": "Paste it where you are handing it over, then clear your clipboard.",
        "copyBlocked": "Copying was blocked",
        "copyBlockedDetail": "Read it off the screen instead — this is the only time it is shown."
      }
    },
    "edit": {
      "fallbackTitle": "User",
      "mfaEnabled": "MFA enabled",
      "mfaDisabled": "No MFA",
      "lastSignedIn": "Last signed in",
      "staleTitle": "Someone else changed this user while you had it open.",
      "staleDetail": "Nothing was overwritten. Reload to see their version, then reapply your changes.",
      "reload": "Reload this user",
      "timezoneHint": "IANA name, e.g. Indian/Maldives. Blank follows the workspace.",
      "resend": "Resend invitation",
      "disable": "Disable account",
      "reinstate": "Reinstate account",
      "saved": "User updated",
      "savedDetail": "{name} was saved.",
      "saveFailed": "That did not save",
      "disabled": "User disabled",
      "disabledDetail": "Every live session for that account was revoked.",
      "reinstated": "User reinstated",
      "reinstatedDetail": "{name} can sign in again.",
      "resent": "Invitation resent",
      "resentDetail": "A fresh link is on its way to {email}.",
      "actionFailed": "That action failed"
    },
    "roleEditor": {
      "legend": "Roles",
      "loading": "Loading roles…",
      "conflictTitle": "These roles combine into a segregation-of-duties conflict",
      "conflictNote": "Assigning them anyway is allowed, but the reason is recorded against the change and is visible to auditors.",
      "reasonLabel": "Override reason",
      "reasonHint": "Required to accept the conflict. Recorded in the audit trail.",
      "reasonPlaceholder": "e.g. Two-person finance team; compensating control is monthly review by the CFO."
    },
    "servicePrincipal": {
      "badge": "Service principal",
      "new": "New service principal",
      "title": "New service principal",
      "description": "An account that runs background jobs under its own roles. It has no password, receives no email and never signs in.",
      "nameLabel": "Name",
      "namePlaceholder": "For example, Nightly bank import",
      "submit": "Create service principal",
      "submitting": "Creating…",
      "created": "Service principal created",
      "createdDetail": "{name} has no roles yet. Assign the ones its jobs need.",
      "failed": "The service principal could not be created",
      "explanation": "This is a service principal: it runs background jobs and never signs in, so invitations, passwords and MFA do not apply. Its roles still decide what those jobs may do.",
      "notApplicable": "Not applicable",
      "bulkSkipped": "{count} service principal was skipped: service principals receive no invitations | {count} service principals were skipped: service principals receive no invitations"
    }
  },
  "roles": {
    "list": {
      "title": "Roles",
      "description": "Each role is a named bundle of permissions. Assign them to people on the Users screen.",
      "loadFailed": "Roles did not load",
      "tableLabel": "Roles",
      "toolbarHint": "Select a role to see who holds it.",
      "emptyTitle": "No roles defined",
      "emptyDescription": "Roles are seeded when a workspace is provisioned. If this list is empty, provisioning did not finish.",
      "columns": {
        "role": "Role",
        "purpose": "What it is for",
        "origin": "Origin",
        "holders": "Holders"
      },
      "builtIn": "Built in",
      "custom": "Custom"
    },
    "detail": {
      "fallbackTitle": "Role detail",
      "noneSelectedTitle": "No role selected",
      "noneSelectedDescription": "Open a role from the list to see its holders.",
      "needsDirectory": "Listing who holds this role needs the user directory permission.",
      "holders": "Holders ({count})",
      "noHoldersTitle": "Nobody holds this role",
      "noHoldersDescription": "Assign it from a user's drawer on the Users screen.",
      "manage": "Manage assignments"
    }
  },
  "approvals": {
    "inbox": {
      "title": "Approvals",
      "description": "Everything waiting on {name}. Decide without leaving this screen.",
      "descriptionFallbackName": "you",
      "loadFailed": "The inbox did not load",
      "panelTitle": "Assigned to you",
      "taskCount": "{count} task | {count} tasks",
      "emptyTitle": "Nothing is waiting on you",
      "emptyDescription": "Approval tasks land here the moment a document you are named on is submitted. If you expected something, check the approval policy for that document type — it decides who is asked and in what order.",
      "selectAll": "Select all on this page",
      "selectOne": "Select {document}",
      "overdue": "Overdue",
      "due": "Due",
      "step": "Step {step}",
      "approveSelected": "Approve selected",
      "approving": "Approving",
      "previewTitle": "Preview",
      "requestLoadFailed": "That request did not load",
      "unavailableTitle": "This request is not available to you",
      "unavailableDescription": "It may not exist, or it may belong to someone else's queue. Pick a task from the list instead.",
      "alreadyDecided": "This request has already been decided ({status}). There is nothing left for you to do on it.",
      "notYours": "This request is waiting on someone else, so it is not in your queue and you cannot decide it from here.",
      "cycle": "Cycle {cycle}",
      "viaDelegation": "Delegated by {from}"
    },
    "bulk": {
      "staleNote": "The inbox has been reloaded, so the rows others decided are gone.",
      "allApproved": "{count} request approved | {count} requests approved",
      "noneApproved": "None of the {requested} could be approved",
      "partial": "{approved} of {requested} approved, {failed} refused",
      "reasonsListed": "The reasons for each are listed above the inbox.",
      "failed": "The batch did not run",
      "resultLabel": "Bulk approval result",
      "succeededLabel": "{count} approved",
      "failedLabel": "{count} refused and still selected",
      "allFailedLabel": "Nothing was approved — {count} refused",
      "retryLabel": "Retry the refused ones",
      "reason": {
        "alreadyDecided": "Already decided by someone else.",
        "selfApproval": "You cannot approve your own submission.",
        "refused": "The server refused this one."
      }
    },
    "decisions": {
      "approved": "Approved",
      "approvedDetail": "{document} moved on.",
      "approveFailed": "That approval did not go through",
      "rejected": "Rejected",
      "rejectedDetail": "The submitter has been told why.",
      "rejectFailed": "That rejection did not go through",
      "delegated": "Handed over",
      "delegatedDetail": "The task is now on their inbox, not yours.",
      "delegateFailed": "That handover did not go through",
      "requestFallback": "Request #{id}"
    },
    "reject": {
      "title": "Reject this request",
      "description": "The reason is sent to the submitter and recorded in the audit log.",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "What has to change before this can be approved?",
      "commentRequired": "Say why you are rejecting this — the submitter only sees this note.",
      "submitting": "Rejecting"
    },
    "delegate": {
      "title": "Hand this task to someone else",
      "description": "They decide in your place for this request only. Both names stay on the record.",
      "toLabel": "Delegate to",
      "toPlaceholder": "Choose a colleague",
      "noteLabel": "Note",
      "notePlaceholder": "Context for whoever picks this up",
      "submitting": "Handing over"
    },
    "preview": {
      "loading": "Loading the request",
      "emptyTitle": "No request selected",
      "emptyDescription": "Choose a task on the left to see the document, its approval chain and the decision buttons here. The list stays where it is.",
      "amount": "Amount",
      "notMonetary": "Not a monetary request",
      "submittedBy": "Submitted by",
      "submitted": "Submitted",
      "currentStep": "Current step",
      "stepOf": "{current} of {total}",
      "decided": "Decided",
      "comment": "Comment",
      "chainHeading": "Approval chain",
      "historyHeading": "History",
      "historyEmpty": "Nothing has happened to this request since it was submitted.",
      "decidedBy": "Decided",
      "delegatedBy": "delegated by {name}",
      "forBehalf": "for {name}",
      "stepMeta": "step {step}"
    },
    "errors": {
      "stale": "Someone else decided this one first, so your decision was not recorded. The inbox has been reloaded.",
      "selfApproval": "You submitted this request, so you cannot approve it. Segregation of duties requires a different approver."
    },
    "taskStatus": {
      "pending": "Waiting",
      "approved": "Approved",
      "rejected": "Rejected",
      "cancelled": "Cancelled",
      "delegated": "Delegated",
      "skipped": "Skipped",
      "expired": "Expired"
    },
    "assignee": {
      "anyoneInRole": "Anyone in {role}",
      "userById": "User #{id}",
      "unassigned": "Unassigned"
    },
    "document": {
      "fallback": "{docType} #{docId}",
      "genericType": "Document"
    },
    "reroute": {
      "lead": "This document is on approval cycle {cycle}. An earlier chain was voided when it was amended.",
      "cycle": "Cycle {cycle}",
      "foot": "The approvals given on a voided cycle applied to a different version of this document, which is why they were not carried over."
    },
    "emergency": {
      "action": "Emergency approval",
      "title": "Approve outside the chain",
      "consequence": "This approves the document ahead of its normal chain. It is recorded against you, it must be ratified by somebody else within the deadline below, and until it is, no further emergency approval can be raised.",
      "reason": "Why the chain is being gone round",
      "ratifyWithin": "Ratify within (hours)",
      "ratifyWithinHint": "After this, the approval appears on the unratified-emergency queue.",
      "confirm": "Approve as an emergency",
      "raised": "Emergency approval recorded",
      "outstanding": "An earlier emergency approval has not been ratified yet. That one has to be closed before another can be raised."
    },
    "writeOffPreview": {
      "heading": "Write-off",
      "noAccess": "You cannot read write-offs, so the detail is not shown here. The amount above is the request's own.",
      "loadFailed": "The write-off did not load",
      "customer": "Customer",
      "reason": "Reason",
      "total": "Total written off",
      "provisionUsed": "Covered by provision",
      "expense": "Charged to bad debt",
      "taxRelief": "Tax relief",
      "evidenceComplete": "Proof attached ({count})",
      "evidenceMissing": "Proof incomplete",
      "invoice": "Invoice",
      "dueDate": "Due",
      "dunning": "Dunning notices",
      "amount": "Amount",
      "open": "Open the write-off"
    },
    "writeOffSettingsPreview": {
      "heading": "Write-off thresholds",
      "loadFailed": "The thresholds did not load",
      "threshold": "Threshold",
      "inForce": "In force",
      "requested": "Requested",
      "none": "None",
      "pending": "Waiting for a decision",
      "requestedBy": "Requested by user {id}.",
      "open": "Open the thresholds"
    }
  },
  "audit": {
    "explorer": {
      "title": "Audit explorer",
      "description": "Every change, who made it and when. The log is hash-chained and cannot be edited or deleted, including by an administrator.",
      "verify": "Verify chain",
      "export": "Evidence export",
      "loadFailed": "The audit log did not load",
      "tableLabel": "Audit log",
      "emptyTitle": "No audit entries match",
      "emptyDescription": "The log records every create, update, delete, approval, sign-in and export in this workspace. Widen the date range or clear the filters to see the most recent activity.",
      "retryActions": "Retry action list",
      "columns": {
        "when": "When",
        "who": "Who",
        "action": "Action",
        "record": "Record",
        "note": "Note"
      },
      "filters": {
        "entityLabel": "Record type",
        "entityHint": "Table name, e.g. users or journal_entries",
        "entityPlaceholder": "Any record type",
        "entityIdLabel": "Record ID",
        "entityIdHint": "Narrows to one row of that table",
        "entityIdPlaceholder": "Any record",
        "actionLabel": "Action",
        "actionPlaceholder": "Any action",
        "actionsFailed": "The action list did not load. Retry below.",
        "actorLabel": "Actor",
        "actorPlaceholder": "Anyone",
        "fromLabel": "From",
        "toLabel": "To",
        "businessDateHint": "Business date in {zone}",
        "docNoLabel": "Document number",
        "docNoHint": "Exact match, e.g. INV-2026-000123",
        "docNoPlaceholder": "Any document"
      }
    },
    "chain": {
      "okTitle": "Chain intact.",
      "okBody": "All {rows} entries verify against the hash before them. Nothing in this workspace's audit log has been altered.",
      "brokenTitle": "Chain broken.",
      "brokenBody": "Verification failed at entry #{firstBadId} of {rows}. Treat this workspace's log as compromised and escalate immediately.",
      "verifyFailed": "The chain could not be verified"
    },
    "attestation": {
      "title": "Evidence attestation",
      "description": "Hand these figures to the auditor with the CSV. The chain hash is a SHA-256 over the exported rows' own hashes.",
      "missing": "The server returned the file but no attestation headers, so this bundle carries no proof of completeness. Re-run the export; if it happens again, the log is still intact but the file must not be presented as evidence.",
      "rows": "Rows exported",
      "firstEntry": "First entry",
      "lastEntry": "Last entry",
      "chainHash": "Chain hash",
      "exported": "Exported {count} rows",
      "exportedDetail": "The chain attestation is on screen — give it to the auditor with the file.",
      "withoutTitle": "Exported without an attestation",
      "withoutDetail": "The server did not return the chain headers, so this file cannot be proved against the chain.",
      "exportFailed": "The evidence export failed"
    },
    "entry": {
      "fallbackTitle": "Audit entry",
      "recordFallback": "{entity} #{entityId}",
      "entryNumber": "Entry #{id}",
      "when": "When",
      "who": "Who",
      "whoWithType": "{actor} ({actorType})",
      "record": "Record",
      "note": "Note",
      "from": "From",
      "client": "Client",
      "diffHeading": "What changed",
      "diffEmpty": "This action recorded no field values — it is an event, not an edit.",
      "field": "Field",
      "before": "Before",
      "after": "After",
      "chainHeading": "Chain",
      "thisRow": "This row",
      "previous": "Previous",
      "firstRow": "First row in this workspace"
    },
    "trail": {
      "loading": "Loading the record's history",
      "emptyTitle": "No recorded activity",
      "emptyDescription": "Every change to this record is written to the hash-chained audit log. Nothing has been recorded against it yet.",
      "actorUser": "user #{id}",
      "changed": "Changed: {fields}"
    },
    "actors": {
      "system": "System job",
      "platformAdmin": "Platform support",
      "assistant": "AI Assistant",
      "unattributed": "Unattributed",
      "userById": "User #{id}"
    }
  },
  "profile": {
    "title": "Profile & security",
    "tabsLabel": "Account sections",
    "tabs": {
      "profile": "Profile",
      "security": "Security",
      "sessions": "Sessions"
    },
    "details": {
      "title": "Your details",
      "suspended": "This workspace is suspended, so changes are blocked until it is reactivated.",
      "timezoneHint": "IANA name, e.g. Indian/Maldives. Blank follows the workspace.",
      "nameBlank": "Your name cannot be blank.",
      "timezoneInvalid": "That is not an IANA time zone. Try a name like Indian/Maldives or Asia/Colombo.",
      "localeInvalid": "Choose one of the supported languages.",
      "saved": "Profile saved",
      "saveFailed": "That did not save"
    },
    "account": {
      "title": "Account",
      "memberSince": "Member since",
      "firstSignIn": "This is your first"
    },
    "password": {
      "title": "Change password",
      "currentLabel": "Current password",
      "newHint": "At least 12 characters. Length beats punctuation.",
      "submit": "Change password",
      "changed": "Password changed",
      "changedDetail": "Other sessions were signed out.",
      "failed": "The password was not changed"
    },
    "mfa": {
      "title": "Two-factor authentication",
      "description": "A second factor is required for payment, bank-detail and period-close actions.",
      "enabled": "Enabled",
      "notSetUp": "Not set up",
      "explanation": "With an authenticator app enrolled, signing in asks for a six-digit code as well as your password, and sensitive actions can ask again.",
      "setUp": "Set up authenticator",
      "turnOff": "Turn off two-factor",
      "disableTitle": "Turn off two-factor authentication",
      "disableDescription": "Confirm with your password and a current code.",
      "currentCodeLabel": "Current code",
      "keepOn": "Keep it on",
      "disableSubmit": "Turn off",
      "disabling": "Turning off",
      "disabled": "Two-factor authentication is off",
      "disabledDetail": "Your account now relies on the password alone.",
      "disableFailed": "MFA was not disabled",
      "stepUpReason": "You were sent here because an action you started needs a second factor. Set up an authenticator, then go back and try it again."
    },
    "sessions": {
      "loadFailed": "Your sessions did not load",
      "title": "Where you are signed in",
      "description": "Revoking a session signs that device out immediately.",
      "emptyTitle": "No other sessions",
      "emptyDescription": "Only this browser is signed in to your account.",
      "unnamedDevice": "Unnamed device",
      "thisDevice": "This device",
      "unknownAddress": "Unknown address",
      "lastUsed": "last used",
      "revoked": "Session revoked",
      "revokedDetail": "That device has to sign in again.",
      "revokeFailed": "The session was not revoked"
    }
  },
  "mfaEnrol": {
    "title": "Set up two-factor authentication",
    "description": "An authenticator app produces a fresh six-digit code every 30 seconds.",
    "qrAlt": "QR code containing your authenticator setup key",
    "scanHint": "Scan this with Google Authenticator, 1Password, Aegis or any TOTP app.",
    "secretLabel": "Or enter this key by hand",
    "secretHint": "Type it exactly, without spaces.",
    "secretAria": "Setup key",
    "codeLabel": "Code from your app",
    "codePlaceholder": "000000",
    "verify": "Verify and enable",
    "verifying": "Verifying",
    "recoveryWarning": "These recovery codes are shown once and never again. Each one signs you in a single time if you lose your phone. Store them the way you would store a password.",
    "acknowledge": "I have saved these recovery codes somewhere safe",
    "codesFileHeading": "Recovery codes for EnterpriseAI ERP Cloud",
    "codesFileAccount": "Account: {email}",
    "copied": "Recovery codes copied",
    "copiedDetail": "Paste them somewhere only you can reach.",
    "copyBlocked": "Copying was blocked",
    "copyBlockedDetail": "Use Download instead, or select the codes by hand.",
    "startFailed": "Enrolment could not start",
    "codeRejected": "That code was not accepted"
  },
  "stepUp": {
    "title": "Confirm it's you",
    "reasons": {
      "payment": "Paying suppliers needs your authenticator.",
      "bankApprove": "Approving a change to a supplier's bank details needs your authenticator.",
      "reveal": "Showing a full account number needs your authenticator.",
      "bankChange": "Changing a supplier's bank details needs your authenticator.",
      "periodClose": "Closing or reopening a period needs your authenticator.",
      "writeOff": "Posting or reversing a write-off, or changing the write-off thresholds, needs your authenticator.",
      "generic": "This action needs your authenticator."
    },
    "description": "Enter the six-digit code from your authenticator app. What you were doing carries on the moment it is accepted — nothing you entered is lost.",
    "codeLabel": "Code from your app",
    "codePlaceholder": "000000",
    "submit": "Confirm",
    "verifying": "Checking",
    "waiting": "One action is waiting behind this. | {count} actions are waiting behind this.",
    "attemptsWarning": "Wrong codes count towards the same lockout that applies to signing in.",
    "errors": {
      "code": "That code was not accepted. If you have just used this one, wait for your app to show the next code.",
      "lockout": "Too many incorrect codes. This account is locked for a short while — the same limit that applies to signing in.",
      "lockoutUntil": "Too many incorrect codes. Try again after {time}.",
      "other": "The code could not be checked. Try again in a moment."
    },
    "enrol": {
      "title": "Set up your authenticator first",
      "body": "This action needs a second factor, and this account has none enrolled. Setting up an authenticator app takes about a minute, and the action can then be repeated.",
      "action": "Set up two-factor authentication",
      "routedTitle": "Set up an authenticator to continue",
      "routedDetail": "The action you started needs a second factor this account does not have yet."
    }
  },
  "errorPages": {
    "forbidden": {
      "title": "You do not have access to that screen",
      "description": "{screen} needs a permission your roles do not include. You are signed in as {account} with {roles}. A workspace administrator can grant it.",
      "thatScreen": "That screen",
      "thisAccount": "this account",
      "noRoles": "no roles yet",
      "goDashboard": "Go to the dashboard",
      "seeRoles": "See my roles"
    },
    "notFound": {
      "title": "That page does not exist",
      "description": "Nothing is routed at {path}. It may have been renamed, or the link may have been cut short.",
      "goDashboard": "Go to the dashboard",
      "search": "Search for what you wanted"
    }
  },
  "tax": {
    "kinds": {
      "VAT": "VAT / GST",
      "WHT": "Withholding",
      "LEVY": "Levy"
    },
    "bases": {
      "percent": {
        "label": "Percentage of the line",
        "summary": "The tax is the rate applied to the line amount."
      },
      "per_unit": {
        "label": "Amount per unit",
        "summary": "A fixed amount for each unit, such as a per-night green tax."
      }
    },
    "treatments": {
      "standard": {
        "label": "Standard rated",
        "summary": "A taxable supply charged at this code's rate.",
        "reporting": "Reported as taxable turnover, with the tax charged shown against it."
      },
      "zero_rated": {
        "label": "Zero rated",
        "summary": "A taxable supply charged at 0%. This is not the same as a 0% rate on a standard code.",
        "reporting": "Counts toward taxable turnover and keeps input tax on its costs recoverable."
      },
      "exempt": {
        "label": "Exempt",
        "summary": "Not a taxable supply at all.",
        "reporting": "Reported on its own line, and normally blocks recovery of the input tax attributable to it."
      },
      "reverse_charge": {
        "label": "Reverse charge",
        "summary": "The buyer accounts for the tax on both sides.",
        "reporting": "Appears as both output and input tax on the buyer's return."
      },
      "out_of_scope": {
        "label": "Out of scope",
        "summary": "Outside the tax entirely.",
        "reporting": "Appears on no box of the return."
      }
    },
    "rounding": {
      "levelLabel": "Rounding policy",
      "modeLabel": "Tie-break at half a cent",
      "levels": {
        "line": {
          "label": "Round each line",
          "summary": "Each line's tax is rounded to the cent, then the lines are added up."
        },
        "document": {
          "label": "Round the document",
          "summary": "The lines are added up first, and the document's tax is rounded once."
        }
      },
      "modes": {
        "half_up": {
          "label": "Half up",
          "summary": "Exactly half a cent rounds away from zero. This is what most statutes say."
        },
        "half_even": {
          "label": "Half to even",
          "summary": "Exactly half a cent rounds to the nearest even cent, so totals do not drift upward over thousands of lines."
        }
      },
      "exampleIntro": "Worked example: {count} lines of {line} at {rate}%.",
      "tableCaption": "The same three lines under each rounding policy",
      "columns": {
        "policy": "Policy",
        "working": "Working",
        "total": "Document tax"
      },
      "lineWorking": "{line} × {rate}% = {raw} → {each} on each of {count} lines",
      "documentWorking": "{document} × {rate}% = {raw}, rounded once",
      "chosen": "chosen",
      "agree": "At {rate}% the two policies agree, so this choice changes nothing today. It will matter at a rate that does not divide evenly.",
      "differ": "The two policies differ by",
      "applied": "This code uses {policy}, so it would post {total}."
    },
    "tabs": {
      "label": "Tax setup sections",
      "codes": "Codes",
      "coverage": "Coverage",
      "groups": "Groups",
      "preview": "Preview"
    },
    "list": {
      "title": "Tax codes",
      "description": "Each row is one version of a code. A rate change is a new version, so the documents dated under the old rate keep resolving to it.",
      "tableLabel": "Tax code versions",
      "loadFailed": "The tax codes did not load",
      "newCode": "New tax code",
      "createFirst": "Create the first tax code",
      "emptyTitle": "No tax codes yet",
      "emptyDescription": "A tax code names a rate, the accounts it posts to and the dates it applies between. The Maldives localization pack seeds GGST, TGST and green tax; add your own for anything it does not cover.",
      "searchPlaceholder": "Search code or name",
      "searchLabel": "Search tax codes",
      "filterByKind": "Filter by kind",
      "onDateLabel": "Effective on",
      "onDateHint": "Shows only the versions in force on that day.",
      "columns": {
        "code": "Code",
        "kind": "Kind",
        "treatment": "Treatment",
        "rate": "Rate",
        "effective": "Effective",
        "rounding": "Rounding",
        "status": "Status"
      },
      "roundingSummary": "{level}, tie {mode}",
      "windowOpen": "from {from}",
      "windowClosed": "{from} to {to}",
      "active": "Active",
      "inactive": "Inactive",
      "truncated": "Only the first few thousand versions were read, so the coverage check below may be incomplete.",
      "coverageWarning": "{count} tax code has a gap or an overlap between its versions. | {count} tax codes have a gap or an overlap between their versions.",
      "coverageLink": "Show the coverage timelines",
      "export": {
        "done": "Tax codes exported",
        "failed": "The export did not complete",
        "effectiveFrom": "Effective from",
        "effectiveTo": "Effective to",
        "inputAccount": "Input account",
        "outputAccount": "Output account",
        "payableAccount": "Payable account",
        "roundingMode": "Rounding mode"
      }
    },
    "timeline": {
      "label": "Version history for {code}",
      "windowOpen": "From {from}, open-ended",
      "windowClosed": "{from} to {to}",
      "status": {
        "inForce": "In force today",
        "scheduled": "Scheduled",
        "ended": "Ended",
        "superseded": "Superseded"
      },
      "issue": {
        "gap": "Gap in coverage",
        "overlap": "Overlapping versions",
        "ends": "Coverage has ended"
      },
      "gapDetail": "{code} resolves to no rate at all for {days} day, {from}. A document dated in it cannot be posted. | {code} resolves to no rate at all for {days} days, {from} to {to}. A document dated in that range cannot be posted.",
      "overlapDetail": "Two versions of {code} are both in force from {from} to {to}, so the rate on those days is ambiguous.",
      "overlapDetailOpen": "An open-ended version of {code} is still in force when the next one starts on {from}. Close it the day before.",
      "endsDetail": "{code} covers nothing after {on}. A document dated later resolves to no rate."
    },
    "coverage": {
      "emptyTitle": "No tax codes to check",
      "emptyDescription": "Once a code exists, its versions are checked here for gaps and overlaps.",
      "inForce": "A version is in force on {date}.",
      "noneInForce": "No version is in force on {date}.",
      "addVersion": "Add a version of {code}"
    },
    "editor": {
      "createTitle": "New tax code version",
      "createDescription": "A statutory rate change is a new version, not an edit. Give it a start date and close the previous version the day before.",
      "editTitle": "Edit {code}",
      "editDescription": "Code, kind, jurisdiction and start date identify this version and cannot be moved — changing one would restate which documents it governed.",
      "fields": {
        "code": "Code",
        "codeHint": "Short and stable, e.g. GGST or TGST.",
        "codeLocked": "Identifies the version; not editable.",
        "name": "Name",
        "kind": "Kind",
        "kindHint": "Withholding and levies post differently from GST.",
        "jurisdiction": "Jurisdiction",
        "jurisdictionHint": "Two-letter country code, e.g. MV.",
        "jurisdictionLocked": "Identifies the version; not editable.",
        "treatment": "Treatment",
        "basis": "Basis",
        "rate": "Rate",
        "rateHint": "Enter 8.75 for 8.75%.",
        "rateRange": "Enter a percentage between 0 and 100.",
        "rateNotApplicable": "This treatment carries no rate, and that is different from a rate of zero.",
        "amountPerUnit": "Amount per unit",
        "amountPerUnitHint": "The fixed amount charged for each unit.",
        "unitCurrency": "Unit currency",
        "unitCurrencyHint": "A per-unit levy must say which currency its amount is in.",
        "unitLabel": "Unit label",
        "unitLabelHint": "What one unit is, e.g. night.",
        "effectiveFrom": "Effective from",
        "effectiveFromHint": "The first day documents resolve to this version.",
        "effectiveFromLocked": "Identifies the version; not editable.",
        "effectiveTo": "Effective to",
        "effectiveToHint": "Leave empty while this is the current rate. Set it to the day before the next version starts.",
        "inputAccount": "Input tax account",
        "inputAccountHint": "Debited on purchases.",
        "outputAccount": "Output tax account",
        "outputAccountHint": "Credited on sales.",
        "payableAccount": "Payable account",
        "payableAccountHint": "Where the net position settles.",
        "recoverable": "Input tax is recoverable",
        "recoverableHint": "Clear this for a tax the business cannot claim back.",
        "active": "Available on new documents",
        "activeHint": "Turning this off hides the code from new documents; posted documents keep it.",
        "description": "Description"
      },
      "timelineTitle": "{code} after this change",
      "invertedWindow": "The end date is before the start date, so this version would cover no days at all.",
      "overlapOpen": "An open-ended version of {code} starting {from} already covers these days. Close it before saving.",
      "overlapClosed": "A version of {code} already covers {from} to {to}. Two versions cannot be in force on one day.",
      "gapWarning": "Saving this leaves days with no rate at all. A document dated inside a gap cannot be posted.",
      "gapRange": "{from} to {to}",
      "gapAfter": "everything after {on}",
      "gapAcknowledged": "Press save again to record the version with that gap.",
      "saveAnyway": "Save with the gap",
      "created": "Tax code version created",
      "createdDetail": "{code} is now available on documents.",
      "saved": "Tax code saved",
      "savedDetail": "{code} has been updated.",
      "saveFailed": "The tax code was not saved",
      "staleConflict": "Someone else changed this version while it was open. Close and reopen it to see their change, then reapply yours."
    },
    "groups": {
      "loadFailed": "The tax groups did not load",
      "inactive": "Inactive",
      "created": "Tax group created",
      "createdDetail": "{code} can now be used in a rule.",
      "fields": {
        "code": "Code",
        "codeHint": "Short and stable, e.g. STD or EXPORT.",
        "name": "Name",
        "active": "Available in rules"
      },
      "party": {
        "title": "Party groups",
        "description": "Classify vendors and customers, e.g. domestic, export, exempt body.",
        "emptyTitle": "No party groups",
        "emptyDescription": "A rule needs a party group on one side. Add one to start classifying vendors and customers.",
        "add": "Add a party group"
      },
      "item": {
        "title": "Item groups",
        "description": "Classify items, e.g. standard goods, zero-rated staples, services.",
        "emptyTitle": "No item groups",
        "emptyDescription": "A rule needs an item group on the other side. Add one to start classifying items.",
        "add": "Add an item group"
      }
    },
    "preview": {
      "title": "Preview a line",
      "description": "Runs exactly the resolution a document will run, and writes nothing.",
      "movedTitle": "Previewing moved to the tax simulator",
      "movedDescription": "A line's tax is no longer a single code and rate: place of supply decides which jurisdiction governs, and more than one regime can bind the same line. The simulator asks the whole question and shows the working — every stage, every regime, and the figure a document would post.",
      "openSimulator": "Open the tax simulator"
    },
    "report": {
      "title": "Tax Position",
      "description": "Input and output tax for a period, computed from the tax lines documents actually posted.",
      "notTheReturn": "This is a defensible GST summary, not a reproduction of the official return form. Confirm the box mapping against MIRA's current form before filing anything.",
      "periodTitle": "Period",
      "fields": {
        "from": "From",
        "to": "To",
        "company": "Legal Entity",
        "companyHint": "Leave empty to cover every legal entity."
      },
      "allCompanies": "All legal entities",
      "loadFailed": "The summary did not load",
      "netPayable": "Net payable ({currency})",
      "netPayableHelp": "Output tax less recoverable input tax for the period.",
      "totalsTitle": "Position by currency",
      "totalsCaption": "Tax position for the period, per currency",
      "noTotals": "No tax lines were posted in this period.",
      "totals": {
        "outputBase": "Output base",
        "outputTax": "Output tax",
        "inputBase": "Input base",
        "inputTax": "Input tax",
        "recoverable": "Recoverable input",
        "netPayable": "Net payable"
      },
      "columns": {
        "code": "Tax code",
        "currency": "Currency",
        "base": "Base amount",
        "tax": "Tax",
        "recoverable": "Recoverable",
        "documents": "Documents"
      },
      "recoverable": "Recoverable",
      "notRecoverable": "Not recoverable",
      "outputTableLabel": "Output tax by code",
      "outputCaption": "Tax charged on sales. Zero-rated, exempt and out-of-scope supplies keep their own rows.",
      "outputEmptyTitle": "No output tax in this period",
      "outputEmptyDescription": "Nothing has been posted with a sales tax line between these dates.",
      "inputTableLabel": "Input tax by code",
      "inputCaption": "Tax charged to you on purchases. Only the recoverable rows reduce the net position.",
      "inputEmptyTitle": "No input tax in this period",
      "inputEmptyDescription": "Nothing has been posted with a purchase tax line between these dates.",
      "generatedAt": "Computed",
      "export": {
        "action": "Export summary CSV",
        "done": "Summary downloaded",
        "doneDetail": "Saved as {filename}. It is a GST summary, not the statutory return form.",
        "failed": "The export did not complete"
      }
    },
    "spine": {
      "levels": {
        "country": "Country",
        "subdivision": "Region",
        "locality": "Locality"
      },
      "sources": {
        "pack": {
          "label": "Pack",
          "summary": "Curated content you accepted from a published country pack. A sync will replace it."
        },
        "tenant": {
          "label": "Yours",
          "summary": "Authored in this workspace. Every pack sync leaves it untouched."
        },
        "legacy": {
          "label": "Legacy",
          "summary": "Predates the tax spine. It still resolves, but no pack maintains it."
        }
      },
      "regimeKinds": {
        "VAT": {
          "label": "VAT / GST",
          "summary": "A value-added tax charged on supplies and recovered on purchases."
        },
        "WHT": {
          "label": "Withholding tax",
          "summary": "Deducted at source from a payment and remitted on the payee's behalf."
        },
        "LEVY": {
          "label": "Levy",
          "summary": "A statutory charge, often per unit rather than per value — a per-night green tax."
        },
        "CHARGE": {
          "label": "Service charge",
          "summary": "A mandatory charge that computes like a tax, is part of the invoice total and of a later tax's base, and appears on no return."
        },
        "SALES_TAX": {
          "label": "Sales tax",
          "summary": "A tax charged at the point of sale and not recovered on purchases."
        }
      },
      "activation": {
        "statuses": {
          "active": {
            "label": "Active",
            "summary": "This version is computing tax now."
          },
          "update_available": {
            "label": "Update available",
            "summary": "A newer version has been published. Nothing changes until you accept it."
          },
          "validating": {
            "label": "Validating",
            "summary": "A sandbox replay of your own documents is running."
          },
          "validated": {
            "label": "Validated",
            "summary": "The sandbox replay finished. Review what it found, then accept."
          },
          "validation_failed": {
            "label": "Validation failed",
            "summary": "The replay could not complete. The reason is shown below."
          },
          "withdrawn_upstream": {
            "label": "Withdrawn upstream",
            "summary": "The publisher withdrew this pack version. Contact your operator before filing on it."
          }
        },
        "fields": {
          "version": "Version in force",
          "effectiveFrom": "Effective from",
          "activatedAt": "Activated",
          "contentHash": "Content hash"
        },
        "pending": "Version {version} has been published; you are on version {current}. Nothing changes until you accept it.",
        "pendingSeen": "First seen",
        "sandboxRanAt": "Sandbox last run",
        "reviewUpdate": "Review update",
        "viewDetail": "View detail"
      },
      "registration": {
        "statuses": {
          "pending": "Pending",
          "active": "Active",
          "suspended": "Suspended",
          "deregistered": "Deregistered"
        },
        "schemes": {
          "standard": "Standard",
          "simplified": "Simplified",
          "flat_rate": "Flat rate",
          "svat": "SVAT",
          "non_resident": "Non-resident",
          "group": "Group"
        },
        "frequencies": {
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "biannual": "Half-yearly",
          "annual": "Annual"
        },
        "designations": {
          "none": "None",
          "psu": "Payroll statutory unit",
          "tru": "Tax reporting unit",
          "both": "Payroll and tax reporting unit"
        },
        "title": "Tax registrations",
        "description": "One legal entity's standing under one regime: the number, the scheme, and the period it governs.",
        "create": "New registration",
        "createTitle": "New tax registration",
        "editTitle": "Amend registration",
        "editorDescription": "Identity is fixed once the registration exists; the obligation it carries can be amended.",
        "identityImmutable": "Legal entity, regime, number and start date cannot be changed. A different registration is a new row.",
        "loadFailed": "The registration list could not be loaded",
        "tableLabel": "Legal entity tax registrations",
        "emptyTitle": "No registrations yet",
        "emptyDescription": "Determination refuses to guess: without a registration for a bound regime, a line either falls back to the regime's unregistered code or fails outright. Add the registration each legal entity holds.",
        "attention": "{count} registration(s) on this page have lapsed, are about to, or contradict their own dates.",
        "columns": {
          "number": "Registration",
          "status": "Status",
          "validity": "Governs",
          "frequency": "Frequency",
          "scheme": "Scheme",
          "filingCurrency": "Currency",
          "designation": "Designation",
          "primary": "Primary"
        },
        "primary": "Primary",
        "filters": {
          "company": "Legal Entity",
          "regime": "Regime",
          "status": "Status"
        },
        "fields": {
          "company": "Legal Entity",
          "regime": "Regime",
          "number": "Registration number",
          "status": "Status",
          "scheme": "Scheme",
          "effectiveFrom": "Effective from",
          "effectiveTo": "Effective to",
          "effectiveToHint": "Leave empty while the registration is open-ended.",
          "frequency": "Return frequency",
          "frequencyHint": "How often a return falls due under this registration.",
          "firstPeriodStart": "First period starts",
          "firstPeriodStartHint": "Only where the first return covers a stub period.",
          "filingCurrency": "Filing currency",
          "filingCurrencyHint": "Three-letter ISO 4217 code.",
          "designation": "Statutory designation",
          "designationHint": "Whether this registration is the payroll statutory unit, the tax reporting unit, or both.",
          "isPrimary": "Primary registration for this legal entity",
          "isPrimaryHint": "Printed on statutory documents where one number must be shown.",
          "notes": "Notes"
        },
        "numberHintFallback": "This regime declares no number format, so anything is accepted here and checked by the server.",
        "numberMatches": "Matches the regime's format",
        "numberMismatch": "This does not match the format the pack declares for this regime ({pattern}). Save it if you are sure — the server decides.",
        "numberUncheckable": "The pack's format could not be read by this browser, so only the server will check it.",
        "savedTitle": "Registration saved",
        "savedDetail": "Determination will use it from its effective date."
      },
      "certificate": {
        "scopes": {
          "full": {
            "label": "Whole party",
            "summary": "Applies to every line for this party."
          },
          "item_group": {
            "label": "One item group",
            "summary": "Applies only to lines carrying the named item group."
          },
          "tax_code": {
            "label": "One tax code",
            "summary": "Replaces exactly the named tax code and nothing else. The most specific scope wins."
          }
        },
        "statuses": {
          "draft": "Draft",
          "active": "Active",
          "revoked": "Revoked",
          "expired": "Expired"
        },
        "partyKinds": {
          "customer": "Customer",
          "vendor": "Supplier",
          "employee": "Employee",
          "party": "Other party"
        },
        "title": "Exemption certificates",
        "description": "A certificate does not zero a tax — it replaces the code the rule would have chosen, so the line still lands on a return.",
        "create": "New certificate",
        "createTitle": "New exemption certificate",
        "editTitle": "Amend certificate",
        "editorDescription": "Scope and treatment are fixed once the certificate exists; its end date, status and notes are not.",
        "identityImmutable": "Amending a certificate's scope would retroactively change what past documents should have carried. That is a new certificate, not an edit.",
        "loadFailed": "The certificate list could not be loaded",
        "tableLabel": "Exemption certificates",
        "sortCaption": "Sorted by urgency: already lapsed first, then those about to.",
        "emptyTitle": "No exemption certificates",
        "emptyDescription": "Record a certificate here and the engine will substitute its treatment automatically on every matching line, with the certificate named on the tax panel.",
        "attention": "{count} certificate(s) on this page have lapsed, are about to, or contradict their own dates.",
        "alreadyExpired": "The end date is in the past, so this certificate governs nothing from today.",
        "columns": {
          "number": "Certificate",
          "validity": "Valid",
          "status": "Status",
          "scope": "Scope",
          "treatment": "Treatment",
          "issuedBy": "Issued by"
        },
        "filters": {
          "partyKind": "Party type",
          "partyId": "Party id",
          "partyIdHint": "Filter to one counterparty.",
          "status": "Status"
        },
        "fields": {
          "partyKind": "Party type",
          "party": "Party",
          "partySearch": "Search",
          "partySearchHint": "By code or name.",
          "partyId": "Party id",
          "partyIdHint": "This party type has no list to search, so its id is entered directly.",
          "jurisdiction": "Jurisdiction",
          "regime": "Regime",
          "regimeHint": "Leave empty to cover every regime.",
          "company": "Legal Entity",
          "companyHint": "Leave empty to cover every legal entity.",
          "number": "Certificate number",
          "scope": "Scope",
          "itemGroup": "Item group id",
          "itemGroupHint": "Required for an item-group certificate.",
          "taxCode": "Tax code",
          "taxCodeHint": "The exact code this certificate replaces.",
          "treatment": "Treatment it confers",
          "treatmentHint": "Exempt, zero-rated and out-of-scope are three different boxes on a return, not one zero.",
          "exemptTaxCode": "Replacement tax code",
          "exemptTaxCodeHint": "Leave empty and the regime's own code for that treatment is used.",
          "validFrom": "Valid from",
          "validTo": "Valid to",
          "validToHint": "Leave empty while the certificate is open-ended. Set it and the lists warn ahead of the lapse.",
          "status": "Status",
          "issuedBy": "Issued by",
          "notes": "Notes"
        },
        "partyPlaceholder": "Search, then choose",
        "searching": "Searching…",
        "allRegimes": "Every regime",
        "allCompanies": "Every legal entity",
        "savedTitle": "Certificate saved",
        "savedDetail": "Matching lines dated inside its validity will carry its treatment.",
        "delete": "Delete certificate",
        "deleting": "Deleting",
        "deletedTitle": "Certificate deleted",
        "deletedDetail": "{number} no longer applies. Documents already posted keep the treatment they carried.",
        "deleteFailed": "The certificate could not be deleted"
      },
      "return": {
        "statuses": {
          "draft": {
            "label": "Draft",
            "summary": "The shell exists and the due date is fixed. No figures yet."
          },
          "reconciled": {
            "label": "Reconciled",
            "summary": "Figures computed from the period's tax lines and compared to the ledger."
          },
          "submitted": {
            "label": "Submitted",
            "summary": "Sent for approval. The return number has been assigned."
          },
          "approved": {
            "label": "Approved",
            "summary": "Certified internally and ready to file with the authority."
          },
          "filed": {
            "label": "Filed",
            "summary": "Lodged with the authority; the reference is recorded."
          },
          "paid": {
            "label": "Paid",
            "summary": "Settled, and linked to the payment document."
          },
          "superseded": {
            "label": "Superseded",
            "summary": "Replaced by a later return for the same period."
          }
        },
        "title": "Tax returns",
        "description": "The period position, the boxes, the tie-out to the ledger, and the filing.",
        "loadFailed": "The return could not be loaded",
        "tableLabel": "Tax returns",
        "emptyTitle": "No returns yet",
        "emptyDescription": "Prepare one for a registration and a period: preparing fixes the due date, and reconciling fills the boxes from the period's tax lines.",
        "numberAtSubmit": "assigned at submit",
        "overdue": "overdue by {days} day(s)",
        "dueIn": "due in {days} day(s)",
        "overdueSummary": "{count} return(s) on this page are past their due date.",
        "detailTitle": "Return {number} · {code}",
        "detailDescription": "Period {from} to {to}",
        "lifecycleLabel": "Return lifecycle",
        "supersededBy": "Superseded by return #{id}.",
        "columns": {
          "return": "Return",
          "period": "Period",
          "due": "Due",
          "status": "Status",
          "netPayable": "Net payable",
          "currency": "Currency"
        },
        "filters": {
          "registration": "Registration",
          "status": "Status",
          "from": "Period from",
          "to": "Period to"
        },
        "fields": {
          "period": "Period",
          "dueDate": "Due",
          "filingCurrency": "Filing currency",
          "returnNo": "Return number"
        },
        "prepare": {
          "title": "Prepare a return",
          "description": "Creates the shell and fixes the due date. Figures arrive when you reconcile.",
          "action": "Prepare a return",
          "preparing": "Preparing",
          "registration": "Registration",
          "registrationSummary": "Files {frequency}, in {currency}.",
          "returnDefCode": "Return definition",
          "returnDefCodeHint": "The pack's code for the form being filed, e.g. the regime's monthly return.",
          "periodStart": "Period start",
          "periodEnd": "Period end",
          "periodOutOfOrder": "The end of the period is before its start.",
          "whatHappens": "The due date is derived from the pack's rule for this return, on the tenant's clock.",
          "doneTitle": "Return prepared",
          "doneDetail": "Reconcile it to fill the boxes from the period's tax lines."
        },
        "reconciliation": {
          "title": "Reconciliation to the ledger",
          "description": "The return's figures against the movement on the regime's control account for the period.",
          "caption": "Return totals against the ledger",
          "notYetRun": "This return has not been reconciled yet, so there are no figures to compare.",
          "outputBase": "Output base",
          "outputTax": "Output tax",
          "inputBase": "Input base",
          "inputTax": "Input tax",
          "recoverable": "Recoverable input tax",
          "netPayable": "Net payable",
          "glMovement": "Control account movement",
          "difference": "Difference",
          "ties": "The return ties to the ledger to the cent.",
          "doesNotTie": "This return does not tie to the ledger. It is out by {amount} {currency}.",
          "causes": "Usually one of: a journal posted straight to the control account with no tax line behind it, a document posted into the period after reconciling, a manual adjustment, or a period boundary that does not match the registration's. The difference is shown rather than absorbed."
        },
        "boxes": {
          "title": "The return's boxes",
          "description": "In the order the form prints them. A computed box is box arithmetic, not an aggregation.",
          "caption": "Return boxes in {currency}",
          "columns": {
            "box": "Box",
            "label": "Label",
            "base": "Base",
            "tax": "Tax",
            "value": "Value",
            "lines": "Tax lines"
          },
          "computed": "computed",
          "fromTaxLines": "aggregated from tax lines",
          "emptyTitle": "No boxes yet",
          "emptyDescription": "Reconcile the return to compute its boxes from the period's tax lines."
        },
        "actions": {
          "reconcile": "Reconcile",
          "reconciling": "Reconciling",
          "reconciledTitle": "Return reconciled",
          "reconciledDetail": "The boxes and the ledger comparison have been recomputed.",
          "reconcileFailed": "The return could not be reconciled",
          "note": "Note",
          "noteHint": "Recorded on the audit row.",
          "submit": "Submit for approval",
          "submitDialogTitle": "Submit for approval",
          "submitDialogDescription": "The return number is assigned now and the figures are frozen for the approver.",
          "submitDoneTitle": "Return submitted",
          "submitDoneDetail": "It is now waiting on an approver.",
          "approve": "Approve",
          "approveDialogTitle": "Approve this return",
          "approveDialogDescription": "Approving certifies the figures. Whoever prepared the return may not approve it.",
          "approveDoneTitle": "Return approved",
          "approveDoneDetail": "It is ready to file with the authority.",
          "file": "Record filing",
          "fileDialogTitle": "Record the filing",
          "fileDialogDescription": "This records a statement made to a tax authority, so it is kept with its reference.",
          "fileDoneTitle": "Filing recorded",
          "fileDoneDetail": "The reference is stored with the return.",
          "filedOn": "Filed on",
          "reference": "Authority reference",
          "referenceHint": "The acknowledgement number the authority returned.",
          "acknowledgement": "Acknowledgement",
          "acknowledgementHint": "Anything else worth keeping with the filing.",
          "pay": "Record payment",
          "payDialogTitle": "Record the payment",
          "payDialogDescription": "Links the return to the payment document that settled it.",
          "payDoneTitle": "Payment recorded",
          "payDoneDetail": "The return is settled.",
          "paidOn": "Paid on",
          "paymentDocType": "Payment document type",
          "paymentDocTypeHint": "For example a cash payment or a bank payment.",
          "paymentDocId": "Payment document id",
          "paymentDocIdHint": "The id of the document that paid it.",
          "supersede": "Supersede",
          "supersedeDialogTitle": "Supersede this return",
          "supersedeDialogDescription": "Marks this return replaced and opens a fresh one for the same period. Nothing already filed is erased.",
          "supersedeDoneTitle": "Return superseded",
          "supersedeDoneDetail": "A replacement has been opened for the same period.",
          "supersedeReason": "Why",
          "supersedeReasonHint": "Recorded on the audit row. At least ten characters.",
          "stepUpNotice": "You will be asked for your authentication code before this is recorded.",
          "exportCsv": "Export CSV",
          "exportXlsx": "Export XLSX",
          "exportedTitle": "Return exported",
          "exportedDetail": "Saved as {filename}.",
          "exportFailed": "The export failed",
          "evidence": "Evidence bundle",
          "evidenceTitle": "Evidence bundle downloaded",
          "evidenceDetail": "Saved as {filename}. The download itself is an audited event.",
          "evidenceFailed": "The evidence bundle could not be downloaded"
        }
      },
      "via": {
        "explicit": {
          "label": "Typed",
          "summary": "The code was named on the line, overriding rule matching."
        },
        "rule": {
          "label": "Group rule",
          "summary": "Matched a tax group rule — the pre-spine resolution path."
        },
        "regime": {
          "label": "Regime rule",
          "summary": "Matched an ordered regime rule; this is the normal path."
        },
        "certificate": {
          "label": "Certificate",
          "summary": "An exemption certificate replaced the code the rule chose."
        },
        "unregistered": {
          "label": "Unregistered",
          "summary": "No registration governs, so the regime's unregistered code applied."
        }
      },
      "baseKinds": {
        "net": {
          "label": "on net",
          "summary": "The base is the line's net amount alone."
        },
        "net_plus_prior": {
          "label": "compounding",
          "summary": "The base is the net plus the exact, unrounded amounts of every earlier step in this currency."
        }
      },
      "supplyTypes": {
        "goods": "Goods",
        "services": "Services",
        "accommodation": "Accommodation",
        "fnb": "Food and beverage",
        "digital": "Digital",
        "transport": "Transport",
        "other": "Other"
      },
      "channels": {
        "backOffice": "Back office",
        "pos": "Point of sale",
        "portal": "Portal",
        "web": "Web",
        "b2b": "Business to business",
        "hospitality": "Hospitality"
      },
      "priceBases": {
        "exclusive": {
          "label": "Tax exclusive",
          "summary": "The amount is the net; tax is added on top."
        },
        "inclusive": {
          "label": "Tax inclusive",
          "summary": "The amount is the gross the customer was quoted; the net is solved from it and carries the residual."
        }
      },
      "partyClasses": {
        "registered": "Registered",
        "unregistered": "Unregistered",
        "export": "Export",
        "government": "Government",
        "exempt": "Exempt",
        "non_resident": "Non-resident"
      },
      "directions": {
        "output": "Output (sales)",
        "input": "Input (purchases)",
        "any": "Either"
      },
      "placeBases": {
        "origin": {
          "label": "Origin",
          "summary": "Taxed where the supply is made from."
        },
        "destination": {
          "label": "Destination",
          "summary": "Taxed where the supply is received."
        },
        "hybrid": {
          "label": "Hybrid",
          "summary": "Destination when the buyer is registered there and self-accounts; origin otherwise."
        }
      },
      "warnings": {
        "TAX_POS_FALLBACK": "The destination had no registration, so origin rules were used instead.",
        "TAX_POS_OUT_OF_SCOPE": "This regime contributed nothing: the destination is outside its scope.",
        "TAX_COMPOUND_SKIPPED_CURRENCY": "Every earlier step is in another currency, so this step computed on the net alone."
      },
      "routeTitles": {
        "packs": "Country tax packs",
        "packUpdate": "Tax pack update",
        "jurisdictions": "Tax jurisdictions",
        "registrations": "Tax registrations",
        "certificates": "Exemption certificates",
        "returns": "Tax returns",
        "return": "Tax return",
        "simulator": "Tax simulator",
        "charges": "Service charge pools"
      },
      "nav": {
        "packs": {
          "label": "Tax packs",
          "keywords": "pack country activation statutory update accept",
          "description": "Activate a country's pack and accept statutory updates"
        },
        "jurisdictions": {
          "label": "Jurisdictions and regimes",
          "keywords": "jurisdiction regime hierarchy country island atoll",
          "description": "The taxing hierarchy and what is levied in it"
        },
        "registrations": {
          "label": "Tax registrations",
          "keywords": "registration gst tin number company regime frequency",
          "description": "Registration numbers, schemes and filing frequencies"
        },
        "certificates": {
          "label": "Exemption certificates",
          "keywords": "exemption certificate exempt zero rated expiry",
          "description": "Certificates that replace a tax code, and when they lapse"
        },
        "returns": {
          "label": "Tax returns",
          "keywords": "return filing gst vat box reconcile due file pay",
          "description": "Prepare, reconcile, approve, file and pay a return"
        },
        "simulator": {
          "label": "Tax simulator",
          "keywords": "simulate preview explain waterfall compounding inclusive",
          "description": "Ask the engine what a line would carry, and see the working"
        },
        "charges": {
          "label": "Service charge pools",
          "keywords": "service charge pool outlet distribution tips",
          "description": "Service charge collected per pool over a period"
        }
      },
      "packs": {
        "title": "Country tax packs",
        "description": "Which country's statutory rules this workspace computes tax from, and what is waiting on a decision.",
        "loadFailed": "The activation list could not be loaded",
        "emptyTitle": "No country pack is active yet",
        "emptyDescription": "Without an activated pack there are no jurisdictions, no regimes, no registrations and therefore no returns — tax still resolves through the legacy group rules. Activate a country to get the statutory spine.",
        "pendingSummary": "{count} country pack(s) have a newer version waiting on your decision."
      },
      "activate": {
        "title": "Activate a country pack",
        "description": "Copies the published pack's jurisdictions, regimes, codes and rules into this workspace.",
        "action": "Activate a country",
        "activating": "Activating",
        "country": "Country code",
        "countryHint": "Two-letter ISO 3166-1 code. The pack must already be published for it.",
        "countryPlaceholder": "e.g. MV",
        "effectiveFrom": "Effective from",
        "effectiveFromHint": "Documents dated on or after this day resolve through the pack.",
        "whatHappens": "Rows you have authored yourself are never touched by an activation or by a later sync.",
        "done": "Country pack activated",
        "doneDetail": "Jurisdictions, regimes, codes and rules have been copied into this workspace."
      },
      "update": {
        "title": "{country} tax pack",
        "description": "What the update changes, what it would do to your own posted documents, and the decision.",
        "currentTitle": "In force now",
        "pendingVersion": "Version waiting",
        "upToDate": "You are on the newest published version.",
        "diffTitle": "What changes",
        "diffDescription": "Tax codes and rules first, because a rate change is a decision and a label change is not.",
        "diffFailed": "The comparison could not be loaded",
        "notActivatedTitle": "{country} has no activated pack here",
        "notActivatedDescription": "Nothing to review until a pack for this country has been activated in this workspace.",
        "backToPacks": "Back to country packs"
      },
      "diff": {
        "sections": {
          "taxCodes": "Tax codes",
          "rules": "Rules",
          "regimes": "Regimes",
          "jurisdictions": "Jurisdictions",
          "posRules": "Place of supply",
          "priceBasis": "Price basis",
          "returnDefs": "Return definitions",
          "returnBoxes": "Return boxes",
          "docRules": "Document rules",
          "payrollRules": "Payroll rules"
        },
        "added": "{count} added",
        "changed": "{count} changed",
        "withdrawn": "{count} withdrawn",
        "rowAdded": "New",
        "rowWithdrawn": "Withdrawn",
        "movesMoney": "moves money",
        "unnamedRow": "(unnamed row)",
        "emptyTitle": "Nothing changes",
        "emptyDescription": "The pending version is identical to the one in force, row for row."
      },
      "sandbox": {
        "title": "Sandbox validation",
        "description": "A sample of your own posted documents, re-determined under the pending pack.",
        "action": "Run sandbox validation",
        "running": "Replaying documents",
        "ranAt": "Run at",
        "sampleSize": "Documents replayed",
        "differences": "Differences",
        "treatmentChanges": "Treatment changes",
        "clean": "No document in the sample of {count} would compute differently.",
        "dirty": "{count} document(s) would compute differently. A rate change should produce differences — read the direction and size before deciding.",
        "notRunTitle": "The sandbox has not been run",
        "notRunDescription": "Nothing has been checked yet. \"We did not check\" and \"we checked and it was fine\" are opposite facts, so this panel will not pretend otherwise.",
        "tableCaption": "Documents whose tax would change under the pending pack",
        "columns": {
          "document": "Document",
          "taxCode": "Tax code",
          "treatment": "Treatment",
          "oldAmount": "Now",
          "newAmount": "After",
          "reason": "Why"
        },
        "doneTitle": "Sandbox run finished",
        "doneDetail": "The differences it found are shown below.",
        "failedTitle": "The sandbox run failed"
      },
      "accept": {
        "title": "Accept the {country} pack update",
        "description": "This replaces the statutory rules every document dated on or after the effective date computes from. It cannot be undone by editing a field.",
        "open": "Accept update…",
        "summaryHeading": "What you are accepting",
        "versionMove": "Version",
        "rowsChanged": "Rows",
        "rowsBreakdown": "{added} added · {changed} changed · {withdrawn} withdrawn",
        "movesMoney": "Of those, changes that move money",
        "sandbox": "Sandbox",
        "sandboxNotRun": "not run",
        "sandboxClean": "clean over {count} documents",
        "sandboxDirty": "{count} differences",
        "effectiveFrom": "Effective from",
        "effectiveFromHint": "Documents dated on or after this day compute under the new version.",
        "backdatedWarning": "This date is today or earlier, so documents that have already posted fall under the new rules. Do this only where the statutory change is genuinely retrospective.",
        "note": "Why you are accepting",
        "noteHint": "Recorded on the audit row. At least ten characters.",
        "forceExplainDirty": "The sandbox found {count} document(s) whose tax would change. Accepting anyway is allowed, but it needs its own reason.",
        "forceExplainNotRun": "The sandbox has not been run against this version, so nothing is known about what it would do to your documents.",
        "forceLabel": "Accept without a clean sandbox result",
        "forceReason": "Reason for accepting anyway",
        "forceReasonHint": "Recorded separately from the note. At least ten characters.",
        "confirmLabel": "Type {country} to confirm",
        "confirmHint": "The smallest gesture a mis-aimed click cannot produce.",
        "stepUpNotice": "You will be asked for your authentication code before this is applied.",
        "confirmAction": "Accept version {version}",
        "accepting": "Applying the update",
        "doneTitle": "Pack update accepted",
        "doneDetail": "Documents dated on or after the effective date now compute under the new version."
      },
      "jurisdictions": {
        "title": "Jurisdictions and regimes",
        "description": "The taxing hierarchy this workspace resolves against, and what is levied at each level.",
        "country": "Country",
        "packVersionHint": "pack v{version}",
        "treeTitle": "Hierarchy",
        "treeDescription": "A country-level regime covers every level beneath it; a locality-level one does not.",
        "treeLabel": "Tax jurisdiction hierarchy",
        "treeFailed": "The hierarchy could not be loaded",
        "inactive": "Inactive",
        "emptyTreeTitle": "This country has no jurisdictions",
        "emptyTreeDescription": "The pack activated for this country declares no taxing levels. Contact your operator.",
        "noPackTitle": "No country pack is active",
        "noPackDescription": "Activate a country pack first; the jurisdiction hierarchy is copied from it."
      },
      "regimes": {
        "tableLabel": "Tax regimes",
        "loadFailed": "The regime list could not be loaded",
        "orderCaption": "Ordered by sort order — that ordering is why one regime compounds onto another rather than the reverse.",
        "columns": {
          "code": "Regime",
          "kind": "Kind",
          "jurisdiction": "Levied at",
          "sortOrder": "Sort order",
          "filingCurrency": "Filing currency",
          "unregistered": "If unregistered",
          "active": "State"
        },
        "unregisteredRefused": "determination refuses",
        "active": "Active",
        "inactive": "Inactive",
        "emptyTitle": "No regimes",
        "emptyDescription": "Activate a country pack to copy its regimes into this workspace."
      },
      "expiry": {
        "expired": "lapsed {days} day(s) ago",
        "expiring": "lapses in {days} day(s)",
        "future": "starts in {days} day(s)",
        "open": "no end date",
        "statusDisagrees": "the stored status disagrees with these dates"
      },
      "waterfall": {
        "lineLabel": "Tax waterfall for line {lineNo}",
        "tableCaption": "Ordered tax steps for line {lineNo}",
        "line": "Line {lineNo}",
        "net": "Net",
        "gross": "Gross",
        "inclusive": "Tax inclusive",
        "columns": {
          "seq": "Step",
          "code": "Tax code",
          "base": "Base",
          "rate": "Rate",
          "amount": "Amount"
        },
        "units": "units",
        "orderedBy": "{level} {jurisdiction} · regime sort {sortOrder}",
        "viaCertificate": "Certificate {number} replaced the rule's code.",
        "reverseChargePair": "Reverse charge: emitted twice, once as input and once as output.",
        "perUnitNote": "A per-unit code ignores the line's value; {base} is recorded for the audit trail.",
        "currencyExcluded": "A struck-through term is in another currency and was left out of this base.",
        "baseDoesNotTie": "This base does not equal the sum of its own terms. It is out by {amount}.",
        "inclusiveResidual": "Differs from the reported net by {amount}: on an inclusive line the bases are built from the exact solved net, and the residual lands on the net afterwards.",
        "documentRounded": "rounded once across the document",
        "vatFraction": "base × rate ≠ tax here",
        "vatFractionTooltip": "Under inclusive pricing the stored base and the stored tax are each correct against their own population, but the ratio between them is not a rate. This is what every VAT authority's \"VAT fraction\" produces.",
        "doesNotFoot": "does not foot: out by {amount}",
        "lineTax": "Tax on this line",
        "postedOnTop": "Posted on top",
        "totalNet": "Total net",
        "totalTax": "Total tax",
        "totalGross": "Total gross"
      },
      "simulator": {
        "title": "Tax simulator",
        "description": "Ask the engine what a line would carry, and get the working back.",
        "writesNothing": "Simulating runs the same five stages a document runs and writes nothing.",
        "preset": "Load the resort-night example",
        "run": "Simulate",
        "running": "Running the engine",
        "failed": "The simulation failed",
        "contextTitle": "Context",
        "lineTitle": "The line",
        "lineDescription": "One line is enough to exercise compounding, an inclusive price and a per-unit levy.",
        "placeTitle": "Place of supply",
        "placeDescription": "Which jurisdiction governs, which regimes bind, and under which registration.",
        "governing": "Governing jurisdiction",
        "chain": "Chain",
        "fallback": "The destination had no registration, so origin rules were used. That is the difference between charging your tax and charging theirs — and it is invisible in the amounts.",
        "bindingsCaption": "Regimes bound to this supply",
        "columns": {
          "regime": "Regime",
          "basis": "Place rule",
          "jurisdiction": "Bound at",
          "registration": "Registration"
        },
        "unregistered": "Unregistered code applied",
        "resultTitle": "How the tax was reached",
        "resultDescription": "Each code, its base term by term, its rate and its amount, in computation order.",
        "emptyTitle": "Nothing simulated yet",
        "emptyDescription": "Set a context and a line, then simulate. Nothing is written, so anything is safe to try — including a back-dated line or an unregistered destination.",
        "fields": {
          "company": "Legal Entity",
          "direction": "Direction",
          "supplyType": "Supply type",
          "supplyTypeHint": "What is supplied — this is what a place-of-supply rule keys on.",
          "channel": "Channel",
          "channelHint": "The surface the document was raised on.",
          "date": "Business date",
          "dateHint": "Picks the effective version of every code, rule, registration and certificate.",
          "currency": "Currency",
          "priceBasis": "Price basis",
          "partyClass": "Counterparty class",
          "partyClassHint": "The counterparty's statutory standing, as the pack classifies it.",
          "partyRegistered": "Counterparty is registered in the destination",
          "partyRegisteredHint": "A hybrid place-of-supply rule sends the supply to the destination only when this is true.",
          "shipTo": "Ship-to country",
          "shipToHint": "Two-letter code. Leave empty to supply domestically.",
          "property": "Property jurisdiction",
          "propertyHint": "Where an accommodation or F&B supply physically happens. It replaces the ship-to.",
          "amount": "Amount",
          "amountExclusive": "The net; tax is added on top.",
          "amountInclusive": "The gross the customer was quoted; the net is solved from it.",
          "quantity": "Quantity",
          "levyUnits": "Levy units",
          "levyUnitsHint": "What a per-unit code multiplies — guest-nights, litres. Zero falls back to the quantity.",
          "taxCode": "Tax code override",
          "taxCodeHint": "Naming a code here skips rule matching and yields exactly one step.",
          "itemClass": "Item class",
          "itemClassHint": "The pack's own item classification, where a rule narrows by it."
        }
      },
      "charges": {
        "title": "Service charge pools",
        "description": "What was collected per pool over a period, ready for distribution.",
        "notATax": "A service charge is not a tax. It computes like one and is part of the invoice total and of a later tax's base, but it appears on no return box — it is money collected on somebody else's behalf.",
        "loadFailed": "The charge pools could not be loaded",
        "tableLabel": "Service charge pools",
        "emptyTitle": "No service charge in this period",
        "emptyDescription": "Nothing carrying a CHARGE-kind tax code posted between these dates. Widen the period, or check that the outlet's documents set a pool key.",
        "unpooled": "(no pool key)",
        "thisMonth": "This month",
        "filters": {
          "company": "Legal Entity",
          "from": "From",
          "to": "To",
          "poolKey": "Pool key",
          "poolKeyHint": "Outlet, branch or cost centre.",
          "taxCode": "Tax code"
        },
        "columns": {
          "pool": "Pool",
          "currency": "Currency",
          "base": "Base",
          "amount": "Collected",
          "lines": "Lines",
          "documents": "Documents"
        }
      }
    }
  },
  "fx": {
    "fields": {
      "base": "Base currency",
      "baseHint": "The currency one unit of which is being priced.",
      "quote": "Quote currency",
      "quoteHint": "The currency the price is expressed in.",
      "rate": "Rate",
      "rateHint": "Stored to {decimals} decimal places, exactly as typed.",
      "asOf": "As of",
      "asOfHint": "The day this rate was observed. It stays in force until a later one is entered.",
      "note": "Note"
    },
    "sources": {
      "manual": "Entered by hand",
      "api": "Fetched automatically"
    },
    "methods": {
      "direct": {
        "label": "Direct quote",
        "summary": "This pair is quoted, and the rate is that observation."
      },
      "inverse": {
        "label": "Inverted",
        "summary": "Only the opposite pair is quoted, so this rate is its reciprocal, exact to eight decimal places and no further."
      },
      "identity": {
        "label": "Same currency",
        "summary": "A currency against itself needs no observation."
      }
    },
    "currencies": {
      "title": "Currencies",
      "description": "The currencies this workspace transacts in. Seeded by the localization pack and editable afterwards.",
      "tableLabel": "Currencies",
      "loadFailed": "The currencies did not load",
      "add": "Add a currency",
      "editTitle": "Edit {code}",
      "upsertNote": "Saving a code that already exists updates it rather than creating a second one.",
      "columns": {
        "code": "Code",
        "symbol": "Symbol",
        "minorUnits": "Decimal places"
      },
      "codeHint": "Three letters, ISO 4217, e.g. MVR.",
      "symbolHint": "Shown beside amounts, e.g. ރ or $.",
      "minorUnitsHint": "How many decimal places this currency is quoted in: 2 for MVR, 0 for JPY, 3 for KWD.",
      "activeLabel": "Available on documents",
      "activeHint": "Turning this off hides the currency from new documents; posted documents keep it.",
      "active": "Active",
      "inactive": "Inactive",
      "activeOnly": "Active only",
      "searchPlaceholder": "Search code or name",
      "searchLabel": "Search currencies",
      "emptyTitle": "No currencies yet",
      "emptyDescription": "Every amount is held in a currency, so at least the legal entity's base currency has to exist. Add it here.",
      "added": "Currency added",
      "updated": "Currency updated",
      "savedDetail": "{code} is available on documents.",
      "saveFailed": "The currency was not saved"
    },
    "rates": {
      "title": "Exchange rates",
      "description": "A rate reads: one unit of the base currency buys this many units of the quote currency.",
      "tableLabel": "Recorded exchange rates",
      "loadFailed": "The rates did not load",
      "record": "Record a rate",
      "recordFirst": "Record the first rate",
      "anyBase": "Any base",
      "anyQuote": "Any quote",
      "fromLabel": "As of from",
      "toLabel": "As of to",
      "columns": {
        "pair": "Pair",
        "rate": "Rate",
        "asOf": "As of",
        "source": "Source",
        "note": "Note"
      },
      "emptyTitle": "No rates recorded",
      "emptyDescription": "Without a rate, a document in a foreign currency cannot be valued — the system refuses to assume 1:1. Record the first one.",
      "export": {
        "done": "Rates exported",
        "failed": "The export did not complete"
      }
    },
    "rateEditor": {
      "title": "Record an exchange rate",
      "description": "Recording the same pair on the same day corrects that observation instead of adding a second one.",
      "correctTitle": "Correct this rate",
      "correctDescription": "The pair and the date identify the observation, so only the rate and the note can change.",
      "correct": "Save correction",
      "sameCurrency": "A currency against itself is always 1, so there is nothing to record.",
      "reading": "1 {base} buys {rate} {quote}",
      "recorded": "Rate recorded",
      "corrected": "Rate corrected",
      "savedDetail": "{base} to {quote} as of {asOf}.",
      "saveFailed": "The rate was not saved",
      "heldTitle": "Rate held for review",
      "heldDetail": "{base}/{quote} moved {movePct}%, further than its declared tolerance. It has not been applied.",
      "heldExplain": "Nothing failed and nothing was stored: the observation is waiting for somebody to accept or reject it.",
      "heldLink": "Open the holds queue"
    },
    "resolver": {
      "title": "Rate in force",
      "description": "What a document dated on a given day would actually use, and where that number came from.",
      "onLabel": "On",
      "onHint": "A rate later than this date is never used — that would revalue history.",
      "run": "Resolve",
      "running": "Resolving",
      "empty": "Pick a pair and a date to see the rate that applies and how it was derived.",
      "result": {
        "rate": "Rate",
        "method": "Derived",
        "asOf": "Observed",
        "noObservation": "No observation was needed.",
        "source": "Source",
        "derivation": "How"
      },
      "reading": "1 {base} buys {rate} {quote}",
      "carriedForward": "Entered on {asOf} and still in force on {on}.",
      "missing": "No rate on or before {on} for {base} → {quote}, and no {quote} → {base} rate to invert either.",
      "enterMissing": "Record a {base} → {quote} rate"
    },
    "rateType": "Rate type",
    "rateTypeHint": "Which book this observation belongs to.",
    "rateTypes": {
      "spot": "Spot",
      "corporate": "Corporate",
      "historical": "Historical"
    },
    "rateTypeHints": {
      "spot": "The rate a settlement actually happened at. The default.",
      "corporate": "A management rate fixed for a period so internal reporting is comparable.",
      "historical": "The rate a non-monetary item was first recognised at; it never moves again."
    },
    "hold": {
      "routeTitle": "FX rate holds",
      "title": "Rates held for review",
      "description": "Observations that moved further than their pair's declared tolerance. Held, not applied.",
      "openCount": "{count} rate(s) are waiting for a decision. Until one is taken, the pair has no rate for those days.",
      "pair": "Pair",
      "asOf": "As at",
      "priorRate": "Previous",
      "newRate": "Submitted",
      "move": "Move",
      "source": "Source",
      "decide": "Decide",
      "decideTitle": "Accept or reject a held rate",
      "decision": "Decision",
      "accept": "Accept",
      "acceptHint": "Writes the observation. It becomes the rate for that day.",
      "reject": "Reject",
      "rejectHint": "Discards it. The pair keeps no rate for that day, which is the honest outcome for a bad feed.",
      "accepted": "Rate accepted",
      "rejected": "Rate rejected",
      "reason": "Reason",
      "tableLabel": "FX rate holds",
      "emptyTitle": "Nothing held",
      "emptyDescription": "Rates are held only when a tolerance is declared for the pair and an observation breaches it.",
      "loadFailed": "Held rates could not be loaded",
      "statuses": {
        "held": "Held",
        "accepted": "Accepted",
        "rejected": "Rejected"
      }
    }
  },
  "org": {
    "common": {
      "company": "Legal Entity",
      "companyPlaceholder": "Choose a legal entity",
      "legalEntityPlaceholder": "Choose a legal entity",
      "allLegalEntities": "All legal entities",
      "noLegalEntity": "No legal entity available",
      "chooseCompanyTitle": "Choose a legal entity first",
      "chooseCompanyDescription": "Everything on this screen belongs to one legal entity — its calendar, its accounts, its structure.",
      "created": "Created",
      "updated": "Last changed",
      "close": "Close",
      "collapse": "Collapse",
      "expand": "Expand",
      "none": "None",
      "note": "Note"
    },
    "nav": {
      "label": "Organization sections",
      "hierarchy": "Branches & profit centres",
      "fiscalPeriods": "Fiscal periods",
      "accounts": "Chart of accounts",
      "openingBalances": "Opening balances",
      "goLive": "Go-live",
      "locations": "Locations",
      "jobs": "Jobs",
      "grades": "Grades",
      "positions": "Positions",
      "designations": "Designations",
      "filings": "Filing calendar"
    },
    "companies": {
      "title": "Legal entities",
      "description": "The legal entities this workspace keeps books for. Each carries its own base currency, fiscal calendar and chart of accounts.",
      "tableLabel": "Legal entities",
      "loadFailed": "The legal entity list did not load",
      "searchPlaceholder": "Search code or name",
      "searchLabel": "Search legal entities",
      "emptyTitle": "No legal entities yet",
      "emptyDescription": "Register the first legal entity — nothing else in the ledger can be set up until one exists.",
      "createFirst": "Register the first legal entity",
      "createTitle": "New legal entity",
      "editTitle": "Edit legal entity",
      "formDescription": "The legal name goes on documents; the short name is what appears in lists.",
      "created": "Legal entity registered",
      "createdDetail": "{name} is ready to be set up.",
      "saved": "Legal entity saved",
      "savedDetail": "{name} has been updated.",
      "saveFailed": "The legal entity could not be saved",
      "active": "Active",
      "inactive": "Inactive",
      "exported": "Exported one legal entity | Exported {count} legal entities",
      "railSubtitle": "{code} · base currency {currency}",
      "columns": {
        "code": "Code",
        "name": "Name",
        "country": "Country",
        "baseCurrency": "Base currency"
      },
      "fields": {
        "code": "Code",
        "codeHint": "Short, uppercase, and used in document numbers.",
        "codeLocked": "The code cannot change once the legal entity exists.",
        "country": "Country",
        "countryHint": "Two-letter ISO code, e.g. MV.",
        "legalName": "Legal name",
        "legalNameHint": "As registered. This is what prints on invoices.",
        "name": "Short name",
        "nameHint": "What people call it day to day.",
        "baseCurrency": "Base currency",
        "baseCurrencyHint": "Fixed once the legal entity has posted anything: every stored amount was translated at its own document's rate.",
        "baseCurrencyPlaceholder": "Choose a currency",
        "baseCurrencyLocked": "This legal entity has already posted, so its base currency is fixed. Restating it would change amounts that were translated at their own document's rate.",
        "address": "Address",
        "addressLine1": "Address line 1",
        "addressLine2": "Address line 2",
        "city": "City",
        "postalCode": "Postal code",
        "taxRegistrations": "Tax registrations",
        "taxRegistrationsHint": "The authority and the number it issued, e.g. MIRA and the TIN.",
        "taxAuthority": "Authority",
        "taxNumber": "Registration number",
        "addRegistration": "Add a registration",
        "removeRegistration": "Remove registration {index}",
        "active": "Active",
        "activeHint": "An inactive legal entity is hidden from pickers but keeps its history.",
        "skipOpeningBalances": "This legal entity starts from zero",
        "skipOpeningBalancesHint": "Records a deliberate decision, so the go-live checklist can tell it apart from unfinished work.",
        "skipReason": "Why",
        "skipReasonHint": "Whoever audits this later will read it."
      },
      "dissolved": "Legal entity dissolved",
      "dissolvedDetail": "{name} was dissolved on {on}.",
      "dissolveFailed": "The legal entity could not be dissolved",
      "dissolution": {
        "legend": "Dissolution",
        "description": "The end of the legal entity, which is not the same as switching it off.",
        "consequence": "One way. The legal entity stops being active on the date given, the reason goes on the record, and there is no undissolve. Posting into it afterwards is refused.",
        "action": "Dissolve this legal entity",
        "confirm": "Dissolve",
        "on": "Dissolved with effect from",
        "reason": "Reason code",
        "reasonHint": "Recorded against the legal entity and shown to anyone who asks why it closed.",
        "stated": "Dissolved on {on} ({reason}). Nothing further may be posted to this legal entity."
      }
    },
    "hierarchy": {
      "title": "Org structure",
      "description": "Branches, departments, cost centres, profit centres and business units — the dimensions every posting can be tagged with.",
      "loadFailed": "The structure did not load",
      "kindTabsLabel": "Unit kind",
      "addRoot": "New {kind}",
      "addChild": "Add child",
      "delete": "Delete",
      "deleted": "Deleted",
      "deletedDetail": "{name} is no longer in the structure.",
      "deleteFailed": "It could not be deleted",
      "deleteHasChildren": "Move or delete the units under it first — a deleted parent would hide them from the tree entirely.",
      "moveFailed": "The move was refused",
      "noSelection": "Nothing selected",
      "noSelectionHint": "Choose a node in the tree to see and change it.",
      "childCount": "one unit under it | {count} units under it",
      "moveGroup": "Move the selected unit",
      "active": "Active",
      "inactive": "Inactive",
      "emptyKind": "Nothing here yet.",
      "createTitle": "New {kind}",
      "editTitle": "Edit {kind}",
      "formDescription": "A code, a name, and where it sits in the tree.",
      "created": "{kind} created",
      "saved": "{kind} saved",
      "saveFailed": "It could not be saved",
      "loadUnitFailed": "That unit could not be read",
      "unitsScreen": {
        "title": "Branches & Profit Centres",
        "description": "Branches and profit centres — the dimensions every posting can be tagged with that no other register maintains.",
        "elsewhere": "Maintained in their own registers:",
        "navLabel": "Branches & Profit Centres",
        "navDescription": "Branch and profit-centre trees",
        "navKeywords": "branch profit centre unit dimension"
      },
      "kinds": {
        "branch": "Branches",
        "department": "Departments",
        "cost_center": "Cost centres",
        "profit_center": "Profit centres",
        "business_unit": "Business units"
      },
      "kindsSingular": {
        "branch": "branch",
        "department": "department",
        "cost_center": "cost centre",
        "profit_center": "profit centre",
        "business_unit": "business unit"
      },
      "fields": {
        "code": "Code",
        "codeHint": "Unique within this legal entity.",
        "parent": "Sits under",
        "parentHint": "Leave empty to put it at the top level.",
        "noParent": "Top level",
        "active": "Active",
        "activeHint": "Inactive units stay in reports but are not offered on new documents."
      },
      "a11y": {
        "help": "Arrow keys move between units. Space picks a unit up and puts it down; while it is picked up the arrow keys move it, and Escape stops. Alt with an arrow key moves it without picking it up.",
        "movingStart": "Picked up {name}. Arrow keys move it and each move is saved. Escape or Space to finish.",
        "movingStop": "Put {name} down.",
        "movingBadge": "Moving",
        "movedRoot": "{name} moved to position {index} of {total} at the top level.",
        "movedUnder": "{name} moved to position {index} of {total} under {parent}.",
        "blocked": "{name} cannot move {direction} any further.",
        "dropRefused": "{name} cannot be dropped there.",
        "moveFailed": "The move was refused and the structure was put back. {reason}",
        "deleted": "{name} was deleted.",
        "expand": "Expand {name}",
        "collapse": "Collapse {name}",
        "directions": {
          "up": "up",
          "down": "down",
          "in": "in",
          "out": "out"
        }
      }
    },
    "periods": {
      "title": "Fiscal periods",
      "description": "A legal entity's fiscal calendar and the periods postings land in. Closing a period stops everyone else posting to it.",
      "loadFailed": "The calendar did not load",
      "calendarLabel": "Calendar",
      "yearLabel": "Fiscal year",
      "allYears": "All years",
      "noCalendarTitle": "No fiscal calendar yet",
      "noCalendarDescription": "Nothing can be posted until a fiscal year exists. Create the calendar and its first year together.",
      "noPeriodsTitle": "This calendar has no periods yet",
      "noPeriodsDescription": "Generate a fiscal year to lay its periods out.",
      "yearHeading": "Fiscal year {year}",
      "tableCaption": "Periods of fiscal year {year}",
      "createCalendarTitle": "New calendar",
      "createCalendarDescription": "A calendar fixes which month the fiscal year starts in; its first year is laid out at the same time.",
      "generateTitle": "Generate a year",
      "generateDescription": "Lay out one more fiscal year on this calendar.",
      "generateConfirm": "Generate",
      "calendarCreated": "Calendar created",
      "calendarCreatedDetail": "{name} with {count} periods.",
      "periodsGenerated": "Periods generated",
      "periodsGeneratedDetail": "{count} periods for {year}.",
      "calendarFailed": "That could not be created",
      "columns": {
        "no": "No.",
        "name": "Period",
        "start": "From",
        "end": "To",
        "reason": "Reason"
      },
      "status": {
        "open": "Open",
        "soft_closed": "Soft closed",
        "closed": "Closed",
        "permanently_closed": "Permanently closed"
      },
      "statusMeaning": {
        "open": "postings are accepted",
        "soft_closed": "postings warn, and still go through",
        "closed": "postings are refused",
        "permanently_closed": "postings refused; cannot be reopened"
      },
      "actions": {
        "softClose": "Soft close",
        "close": "Close",
        "reopen": "Reopen",
        "permanentClose": "Close permanently"
      },
      "months": {
        "1": "January",
        "2": "February",
        "3": "March",
        "4": "April",
        "5": "May",
        "6": "June",
        "7": "July",
        "8": "August",
        "9": "September",
        "10": "October",
        "11": "November",
        "12": "December"
      },
      "fields": {
        "calendarName": "Calendar name",
        "calendarNameHint": "For example: Standard year.",
        "startMonth": "Fiscal year starts in",
        "startMonthHint": "January for a calendar year; April, July or October for others.",
        "fiscalYear": "Fiscal year",
        "fiscalYearHint": "The year to lay out now.",
        "periodCount": "Periods in the year",
        "periodCountDivisors": "Only 1, 2, 3, 4, 6 and 12 are possible: the year is divided into equal whole months.",
        "periodCountOption": "{count} periods",
        "periodCountHint": "{months} months each",
        "preview": "Fiscal year {year} starts in {month} and is laid out as {count} periods."
      },
      "transitions": {
        "subject": "Period {period}",
        "reasonLabel": "Reason",
        "reasonHint": "Required. It goes on the audit record, and whoever asks later will read it.",
        "reasonRequired": "A reason is required: closing or reopening a period changes what everyone else may post.",
        "mfaNotEnrolled": "Closing a period needs a second factor and this account has none enrolled yet.",
        "mfaLink": "Set up an authenticator",
        "stepUpRequired": "The server asked you to prove it is you again before this is allowed. Confirm your second factor, then try once more.",
        "failed": "That could not be done",
        "doneDetail": "Period {period}.",
        "close": {
          "title": "Close this period",
          "consequence": "No further postings can be made to this period. Corrections will have to go to an open one.",
          "confirm": "Close the period",
          "done": "Period closed"
        },
        "soft_close": {
          "title": "Soft close this period",
          "consequence": "Postings will warn but still go through. Use this while the month is being reviewed.",
          "confirm": "Soft close",
          "done": "Period soft closed"
        },
        "reopen": {
          "title": "Reopen this period",
          "consequence": "This period will accept postings again, so figures already reported for it can change.",
          "confirm": "Reopen the period",
          "done": "Period reopened"
        },
        "permanent_close": {
          "title": "Close this period permanently",
          "consequence": "This asks two approvers to seal the period for good. Once granted there is no reopen, ever — not by an administrator, not by support.",
          "confirm": "Request permanent close",
          "done": "Permanent close requested",
          "codeLabel": "Reason code",
          "codeHint": "A short code recorded on the period, e.g. year_end_signed_off.",
          "dualControl": "Sent for dual approval. The period is not sealed until every approver has signed."
        }
      },
      "terminal": "Sealed",
      "reopenedWith": "Reopened: {code}",
      "permanentPending": "Permanent close awaiting approval (request #{id})"
    },
    "accounts": {
      "title": "Chart of accounts",
      "description": "Every posting lands on one of these. Headings give the chart its shape; postable accounts are the ones journals may touch.",
      "loadFailed": "The chart did not load",
      "searchPlaceholder": "Search code or name",
      "searchLabel": "Search the chart of accounts",
      "emptyTitle": "No accounts yet",
      "emptyDescription": "Apply a template to start from a statutory-friendly chart, or add the first account by hand.",
      "createTitle": "New account",
      "editTitle": "Edit account",
      "formDescription": "Where it sits, what it is, and which dimensions a journal must carry to use it.",
      "created": "Account created",
      "saved": "Account saved",
      "saveFailed": "The account could not be saved",
      "treeTitle": "Accounts",
      "treeCount": "one account | {count} accounts",
      "noSelection": "Nothing selected",
      "noSelectionHint": "Choose an account to see how it may be used.",
      "noMatches": "No account matches that.",
      "postable": "Postable",
      "heading": "Heading",
      "active": "Active",
      "inactive": "Inactive",
      "anyCurrency": "Any currency",
      "noDimensions": "None required",
      "addChild": "Add child account",
      "requiresDimensions": "Dimensions a journal must carry",
      "types": {
        "ASSET": "Asset",
        "LIABILITY": "Liability",
        "EQUITY": "Equity",
        "INCOME": "Income",
        "EXPENSE": "Expense"
      },
      "a11y": {
        "expand": "Expand {name}",
        "collapse": "Collapse {name}"
      },
      "fields": {
        "code": "Code",
        "codeHint": "Unique in this legal entity's chart, and how the account sorts.",
        "type": "Type",
        "parent": "Sits under",
        "parentHint": "A parent and its children must share a type.",
        "noParent": "Top level",
        "postable": "Journals may post to it",
        "postableHint": "A postable account cannot have children.",
        "currency": "Currency restriction",
        "currencyHint": "Leave empty to allow any currency.",
        "dimensions": "Required dimensions",
        "dimensionsHint": "A journal line on this account is refused unless it carries what is ticked here.",
        "requiresCostCenter": "Cost centre",
        "requiresProfitCenter": "Profit centre",
        "requiresBranch": "Branch",
        "requiresDepartment": "Department",
        "requiresProject": "Project",
        "active": "Active",
        "activeHint": "Inactive accounts keep their history but take no new postings."
      },
      "rules": {
        "parentMissing": "That account is no longer in this chart.",
        "cycle": "{code} sits under this account, so it cannot also be its parent.",
        "postableParent": "{code} is postable and cannot have children — make it a heading first.",
        "typeMismatch": "{code} is {type}; a child must be the same type.",
        "postableHasChildren": "This account has {count} children, so journals cannot post to it directly.",
        "typeHasChildren": "Change its {count} children first: a parent and its children must share a type.",
        "blocked": "Fix the highlighted choice before saving."
      },
      "template": {
        "title": "Use a template",
        "description": "A template builds the whole chart at once. It is a starting point, not a merge.",
        "chooseLabel": "Template",
        "confirm": "Build the chart",
        "applied": "Chart of accounts created",
        "appliedDetail": "{count} accounts.",
        "failed": "The template could not be applied",
        "alreadyHasChart": "This legal entity already has accounts, so a template will be refused. Add what is missing by hand instead.",
        "systemHint": "Shipped template {code}"
      }
    },
    "openingBalances": {
      "title": "Opening balances",
      "description": "The balances this legal entity starts from. They are checked whole, approved by two people, and posted as one balanced journal.",
      "uploadTitle": "Upload a CSV",
      "uploadDescription": "The file is validated whole and nothing is written until you submit it.",
      "columnsHint": "Columns: accountCode, debit, credit, and optionally description, costCenter, profitCenter, branch, department.",
      "validate": "Check the file",
      "validating": "Checking",
      "uploadFailed": "The file could not be read",
      "reportTitle": "Validation report",
      "submitForApproval": "Submit for approval",
      "fixAndRetry": "Fix the rows above and upload the file again.",
      "submitted": "Submitted for approval",
      "submittedDetail": "It is now {status}.",
      "submitFailed": "It could not be submitted",
      "loadFailed": "The import history did not load",
      "emptyTitle": "No opening balances imported yet",
      "emptyDescription": "Upload the trial balance you are carrying over, or record on the legal entity that it starts from zero.",
      "historyTitle": "Imports",
      "awaitingApproval": "Waiting on approvers",
      "postJournal": "Post the opening journal",
      "posting": "Posting",
      "posted": "Opening journal posted",
      "postedDetail": "Journal {entryNo} carries {amount} on each side.",
      "postFailed": "The opening journal could not be posted",
      "awaitingPosting": "Approved — waiting for someone to post it",
      "viewJournal": "View the opening journal",
      "lineCount": "one line | {count} lines",
      "fields": {
        "file": "CSV file",
        "fileHint": "One row per account, with a debit or a credit — never both.",
        "asOfDate": "As at",
        "asOfDateHint": "The day before the first period you will post into.",
        "currency": "Currency",
        "currencyHint": "Usually the legal entity's base currency.",
        "note": "Note"
      },
      "columns": {
        "file": "File",
        "asOf": "As at",
        "debit": "Debit",
        "credit": "Credit"
      },
      "status": {
        "draft": "Draft",
        "submitted": "Submitted",
        "approved": "Approved",
        "posted": "Posted",
        "rejected": "Rejected"
      },
      "report": {
        "label": "Validation report",
        "valid": "The file balances. {count} rows are ready to submit.",
        "invalid": "The file was refused. {count} problems to fix.",
        "rows": "Rows",
        "totalDebit": "Total debit",
        "totalCredit": "Total credit",
        "difference": "Difference",
        "unbalanced": "Debits do not equal credits, so nothing was written. The difference above is exact.",
        "fileError": "File",
        "line": "Line",
        "column": "Column",
        "problem": "Problem",
        "account": "Account",
        "debit": "Debit",
        "credit": "Credit",
        "errorsCaption": "Rows that need fixing",
        "linesCaption": "Lines read from the file"
      }
    },
    "routeTitles": {
      "locations": "Locations",
      "jobs": "Jobs",
      "grades": "Job grades",
      "positions": "Positions",
      "designations": "PSU / TRU designations",
      "filings": "Filing calendar"
    },
    "effdate": {
      "groupLabel": "Effective date",
      "asAt": "As at",
      "from": "Effective from",
      "to": "Effective to",
      "window": "In force",
      "backToToday": "Back to today",
      "previousDay": "Previous day",
      "nextDay": "Next day",
      "futureNotice": "Showing a future date",
      "pastNotice": "Showing a past date",
      "history": "History ({count})",
      "states": {
        "current": "In force",
        "future": "Not yet in force",
        "past": "Superseded"
      }
    },
    "address": {
      "legend": "Address",
      "country": "Country",
      "countryPlaceholder": "Two-letter code, e.g. MV",
      "line1": "Address line 1",
      "line2": "Address line 2",
      "line3": "Address line 3",
      "locality": "Island or city",
      "subdivision": "Atoll or province",
      "postalCode": "Postal code",
      "geoHint": "Must match a registered place, not free text — the tax jurisdiction is derived from it.",
      "check": "Check address",
      "checkFailed": "The address could not be checked just now. It has not been validated.",
      "valid": "Address is valid.",
      "jurisdiction": "Resolved to jurisdiction #{id}.",
      "invalidEnforced": "This country requires a valid address. Saving needs a waiver reason.",
      "invalidWarned": "The address does not match this country's rules. It can still be saved.",
      "missing": "Missing: {fields}.",
      "levels": {
        "enforce": "Validation enforced",
        "warn": "Validation advisory",
        "allow": "Validation off"
      },
      "status": {
        "unvalidated": "Not checked",
        "validated": "Validated",
        "waived": "Waived",
        "invalid": "Invalid"
      }
    },
    "location": {
      "title": "Locations",
      "description": "The shared places legal entities, branches and warehouses point at. A location's address is what its tax jurisdiction is derived from.",
      "create": "New location",
      "createTitle": "New location",
      "editTitle": "Edit location",
      "editorDescription": "A location can belong to one legal entity or be shared across the group.",
      "code": "Code",
      "name": "Name",
      "type": "Type",
      "company": "Legal Entity",
      "companyHint": "Leave empty for a location the whole group shares.",
      "shared": "Shared across legal entities",
      "parent": "Inside",
      "address": "Address",
      "addressStatus": "Address",
      "addressRejected": "This country enforces address validation, so the address was refused. Record a waiver reason to save it anyway.",
      "waiverLabel": "Waiver reason",
      "jurisdictionColumn": "Jurisdiction",
      "noJurisdiction": "Not resolved",
      "timezone": "Timezone",
      "timezoneHint": "IANA name, e.g. Indian/Maldives. Leave empty to use the legal entity's.",
      "openedOn": "Opened on",
      "inventory": "Holds stock",
      "inventoryHint": "Warehouses and outlets that carry inventory.",
      "searchHint": "Code, name or island",
      "tableLabel": "Locations",
      "treeLabel": "Locations, as a tree",
      "tabsLabel": "Location view",
      "tabs": {
        "list": "List",
        "tree": "Tree"
      },
      "emptyTitle": "No locations yet",
      "emptyDescription": "Add the places you trade from. A legal entity cannot be activated until its location resolves to a tax jurisdiction.",
      "attention": "{count} location(s) have an address that has not been validated. A legal entity pointed at one cannot determine tax.",
      "loadFailed": "Locations could not be loaded",
      "saved": "Location saved",
      "saveFailed": "The location could not be saved",
      "types": {
        "office": "Office",
        "warehouse": "Warehouse",
        "outlet": "Outlet",
        "property": "Property",
        "plant": "Plant",
        "site": "Site",
        "virtual": "Virtual"
      },
      "statuses": {
        "planned": "Planned",
        "active": "Active",
        "closed": "Closed"
      }
    },
    "division": {
      "title": "Divisions",
      "description": "A management reporting rollup. Divisions sit on the journal line, not on the document header, so one document can span two.",
      "create": "New division",
      "createTitle": "New division",
      "editTitle": "Edit division",
      "editorDescription": "Divisions group results for management reporting. They are not legal or costing entities.",
      "code": "Code",
      "name": "Name",
      "parent": "Parent division",
      "manager": "Accountable manager",
      "managerHint": "A position, not a person: the holder changes, the accountability does not.",
      "managerAfterCreate": "The accountable manager can be set once the division exists.",
      "noManager": "None assigned",
      "activeOnly": "Active only",
      "isActive": "Active",
      "active": "Active",
      "inactive": "Inactive",
      "delete": "Delete",
      "deleteTitle": "Delete division",
      "deleteConsequence": "A division already used on a posted journal line cannot be deleted; deactivate it instead.",
      "deleted": "Division deleted",
      "tableLabel": "Divisions",
      "emptyTitle": "No divisions yet",
      "emptyDescription": "Create one if management reporting needs a rollup the five existing dimensions do not give.",
      "loadFailed": "Divisions could not be loaded",
      "saved": "Division saved",
      "saveFailed": "The division could not be saved"
    },
    "ledger": {
      "title": "Ledgers",
      "description": "Every legal entity keeps exactly one primary book. Every posting lands in it and every report filters to it.",
      "inactive": "Inactive",
      "emptyTitle": "No ledger",
      "emptyDescription": "A primary ledger is created with the legal entity. If this is empty, the legal entity predates the ledger migration.",
      "roles": {
        "primary": "Primary",
        "secondary": "Secondary"
      }
    },
    "designation": {
      "title": "PSU / TRU designations",
      "description": "What a legal entity files statutory returns as, per jurisdiction and over time.",
      "create": "New designation",
      "createTitle": "New designation",
      "createDescription": "A legal entity may be both a payroll statutory unit and a tax reporting unit in one jurisdiction.",
      "supersede": "New version",
      "supersedeTitle": "New version of a designation",
      "supersedeDescription": "Records a change of fact from a date. The earlier version stays on the record.",
      "kind": "Designation",
      "jurisdiction": "Jurisdiction",
      "identifier": "Identifier",
      "identifierHint": "The number this designation files under, when one has been issued.",
      "noIdentifier": "Not issued",
      "registration": "Registration",
      "pendingRegistration": "Not linked",
      "retroactive": "A new version must start after the current one. Correct history through an audit adjustment, not here.",
      "tableLabel": "Legal entity designations",
      "emptyTitle": "No designations",
      "emptyDescription": "Declare what this legal entity files as before payroll or tax returns are prepared for it.",
      "loadFailed": "Designations could not be loaded",
      "saved": "Designation saved",
      "saveFailed": "The designation could not be saved",
      "kinds": {
        "PSU": "Payroll statutory unit",
        "TRU": "Tax reporting unit",
        "LE": "Legal entity"
      },
      "kindHints": {
        "PSU": "Files payroll statutory returns and contributions.",
        "TRU": "Files tax returns for the jurisdiction.",
        "LE": "Recognised as a legal entity in the jurisdiction."
      }
    },
    "filing": {
      "title": "Filing calendar",
      "description": "What is due to a tax authority, and what has slipped.",
      "return": "Return",
      "due": "Due",
      "dueBefore": "Due before",
      "dueIn": "Due in {days} day(s)",
      "overdueBy": "Overdue by {days} day(s)",
      "waivedReason": "Waiver",
      "waive": "Waive",
      "waiveTitle": "Waive a filing obligation",
      "waiveConsequence": "The obligation stays on the record as waived. It is never deleted — a missing row and a waived row read the same to an auditor, and only one of them was a decision.",
      "waiveReason": "Waiver reason code",
      "waiveReasonHint": "Recorded verbatim on the audit trail. No governed set covers this field yet.",
      "waiveNoteHint": "What the waiver rests on, for whoever reads this in a year.",
      "waived": "Obligation waived",
      "kpiOverdue": "Overdue",
      "kpiOverdueHelp": "Obligations past their due date and not filed, paid or waived.",
      "kpiDueSoon": "Due within a week",
      "kpiDueSoonHelp": "Obligations falling due in the next seven days.",
      "tableLabel": "Filing obligations",
      "emptyTitle": "Nothing on the calendar",
      "emptyDescription": "Obligations are generated forward from the current period, so a newly upgraded tenant starts empty and fills as periods open.",
      "loadFailed": "Filing obligations could not be loaded",
      "statuses": {
        "pending": "Pending",
        "prepared": "Prepared",
        "filed": "Filed",
        "paid": "Paid",
        "waived": "Waived",
        "overdue": "Overdue"
      }
    },
    "job": {
      "title": "Jobs",
      "description": "What the work is, independent of legal entity, headcount and pay.",
      "create": "New job",
      "createTitle": "New job",
      "editTitle": "Edit job",
      "editorDescription": "A job is renamed rather than superseded — nothing in the ledger depends on what it was called last year.",
      "code": "Code",
      "name": "Name",
      "family": "Family",
      "familyHint": "A grouping such as finance or front office.",
      "defaultGrade": "Default grade",
      "defaultGradeHint": "The grade a new position of this job takes, unless overridden.",
      "activeOnly": "Active only",
      "isActive": "Active",
      "isActiveHint": "Deactivate rather than delete: positions reference jobs.",
      "active": "Active",
      "inactive": "Inactive",
      "searchHint": "Code or name",
      "tableLabel": "Jobs",
      "emptyTitle": "No jobs yet",
      "emptyDescription": "Define the work before creating the posts that do it.",
      "loadFailed": "Jobs could not be loaded",
      "saved": "Job saved",
      "saveFailed": "The job could not be saved"
    },
    "grade": {
      "title": "Job grades",
      "description": "Seniority bands and their pay ranges. The range is versioned; the grade is not.",
      "create": "New grade",
      "createTitle": "New job grade",
      "createDescription": "The first version of a grade, in force from the date you give.",
      "supersedeTitle": "New version of a grade",
      "supersedeDescription": "An annual pay-band reset. Last year's band stays on the record, because payroll reads the band as at the period being paid.",
      "newVersion": "New version",
      "code": "Code",
      "name": "Name",
      "level": "Level {level}",
      "levelColumn": "Level",
      "levelHint": "Higher is more senior. Authority steps compare against this, so an accidental level is an authority hole.",
      "currency": "Currency",
      "min": "Minimum",
      "mid": "Midpoint",
      "max": "Maximum",
      "effectiveFromNew": "New version in force from",
      "effectiveFromHint": "Must be after the current version's start date.",
      "retroactive": "A new version must start after the current one.",
      "history": "History",
      "historyTitle": "Every version of this grade",
      "activeOnly": "Active only",
      "tableLabel": "Job grades",
      "emptyTitle": "No grades yet",
      "emptyDescription": "Add the seniority bands your authority matrix will route on.",
      "loadFailed": "Job grades could not be loaded",
      "saved": "Grade saved",
      "saveFailed": "The grade could not be saved"
    },
    "position": {
      "title": "Positions",
      "description": "The posts an organisation has, whoever happens to fill them.",
      "create": "New position",
      "createTitle": "New position",
      "createDescription": "The first version of a post, in force from the date you give.",
      "supersede": "Open new version",
      "supersedeTitle": "New version of a position",
      "supersedeDescription": "A reorg: a new manager, department, grade or headcount from a date. The code never changes.",
      "versionNote": "The version in force started on {from}. Saving opens a new one from the date below and leaves that one on the record.",
      "code": "Code",
      "name": "Name",
      "company": "Legal Entity",
      "job": "Job",
      "grade": "Grade",
      "gradeHint": "Defaults from the job when left empty.",
      "reportsTo": "Reports to",
      "reportsToHint": "The line an authority step walks and an absence falls through to.",
      "headcount": "Headcount",
      "headcountHint": "How many people may hold this post at once. A post with unbounded headcount is a job, not a position.",
      "headcountShort": "{count} seat(s)",
      "holders": "Held by",
      "seats": "Filled",
      "effectiveFromNew": "New version in force from",
      "effectiveFromHint": "Must be after the current version's start date.",
      "retroactive": "A new version must start after the current one.",
      "showHistory": "Show history",
      "hideHistory": "Hide history",
      "vacantOnly": "Vacant only",
      "searchHint": "Code or title",
      "assign": "Assign",
      "abolish": "Abolish",
      "abolishTitle": "Abolish a position",
      "abolishConsequence": "Terminal. The post closes on the date given and accepts no further assignment. It is refused while anyone still holds it.",
      "abolishDate": "Abolished with effect from",
      "abolishReason": "Reason",
      "abolished": "Position abolished",
      "created": "Position created",
      "superseded": "New version created",
      "saveFailed": "The position could not be saved",
      "loadFailed": "Positions could not be loaded",
      "tableLabel": "Positions",
      "tabsLabel": "Position view",
      "tabs": {
        "list": "List",
        "chart": "Reporting line"
      },
      "emptyTitle": "No positions yet",
      "emptyDescription": "Create the posts your approval matrix will route to. A chain that names a post nobody holds cannot complete.",
      "statuses": {
        "draft": "Draft",
        "active": "Active",
        "frozen": "Frozen",
        "abolished": "Abolished"
      },
      "statusHints": {
        "draft": "Being set up. Holds no authority and accepts no assignment.",
        "active": "Normal.",
        "frozen": "Keeps authority for its current holder, accepts no new assignment.",
        "abolished": "Closed."
      },
      "placement": "Placement",
      "placementHint": "Where the post sits in the organisation. Every assignment to it inherits these, so an assignment can only name the department the post names.",
      "placementEditHint": "A new version may move the post. It cannot empty a dimension the current version fills — reassign it, or abolish the post and create its replacement.",
      "placementPlaceholder": "Choose",
      "department": "Department",
      "departmentHint": "Required: an assignment takes its department from the post it fills.",
      "branch": "Branch",
      "costCenter": "Cost centre",
      "costCenterHint": "Where the post's payroll cost lands.",
      "businessUnit": "Business unit",
      "division": "Division",
      "location": "Location",
      "locationHint": "The place of work, which sets the holiday calendar and the working day.",
      "headcountOverride": "Approved headcount changes from {from} to {to} on this version. Record why.",
      "headcountReason": "Headcount change reason"
    },
    "assignment": {
      "title": "Who holds this position",
      "employee": "Employee",
      "employeePlaceholder": "Choose an employee",
      "type": "Assignment",
      "fte": "FTE",
      "fteHint": "Fraction of a full-time equivalent, e.g. 0.5000 for a half post.",
      "toHint": "Leave empty for an open-ended assignment.",
      "assign": "Assign",
      "assigned": "Assignment recorded",
      "headcount": "{filled} of {headcount} seat(s) filled",
      "full": "Full",
      "holders": "Assignments",
      "none": "Nobody holds this position.",
      "end": "End",
      "endDate": "Ends on",
      "endReason": "Reason",
      "endConfirm": "End assignment",
      "endExplain": "The assignment closes on the date given. {name} stays on the history — payroll and authority both read it as at a date.",
      "ended": "Assignment ended",
      "overrideExplain": "The server refused this assignment. It can be recorded anyway with a governed reason, which is counted at year end.",
      "overrideLabel": "Override reason",
      "failed": "The assignment could not be saved",
      "types": {
        "primary": "Primary",
        "secondary": "Secondary",
        "acting": "Acting"
      },
      "typeHints": {
        "primary": "The person's substantive post. Only one at a time.",
        "secondary": "An additional post held alongside the primary one.",
        "acting": "Covering the post temporarily."
      }
    },
    "chart": {
      "treeLabel": "Reporting line",
      "vacant": "Vacant",
      "openSeats": "{count} open",
      "vacancies": "{count} seat(s) in this chart are unfilled. An approval routed to one cannot complete.",
      "chooseCompany": "Choose a legal entity to draw its reporting line.",
      "emptyTitle": "No positions to chart",
      "emptyDescription": "Create positions and give them a reporting line to see the structure here.",
      "loadFailed": "The reporting line could not be loaded"
    },
    "obSignOff": {
      "title": "Reconciliation and sign-off",
      "description": "Reconcile this batch to the source system's trial balance. Sign-off becomes available once the difference is exactly zero, and the entity may not transact until the batch is signed off.",
      "open": "Reconcile",
      "close": "Close",
      "loadFailed": "Could not load this opening-balance import",
      "notReady": "This import can be reconciled once it has been approved.",
      "importStatus": "Import",
      "reconStatus": "Reconciliation",
      "chips": {
        "notReconciled": "Not reconciled",
        "variance": "Difference open",
        "clean": "Reconciled, ready to sign off",
        "signedOff": "Signed off"
      },
      "fields": {
        "sourceTotal": "Source total",
        "sourceTotalHint": "Total debits on the source system's trial balance at the import's as-of date.",
        "note": "Reconciliation note"
      },
      "reconcile": "Record reconciliation",
      "reconciling": "Reconciling…",
      "reconciled": "Reconciliation recorded",
      "reconcileFailed": "Could not record the reconciliation",
      "notReconciledYet": "Enter the source total to reconcile this batch. The difference shown is the one the server calculates.",
      "totals": {
        "source": "Source total",
        "loaded": "Loaded total",
        "variance": "Difference"
      },
      "reconciledAt": "Reconciled",
      "linesTitle": "Loaded balances by account",
      "linesHint": "The server reconciles the batch total. Compare these balances with the source trial balance account by account to locate a difference.",
      "columns": {
        "account": "Account",
        "debit": "Debit",
        "credit": "Credit"
      },
      "signOff": "Sign off",
      "signingOff": "Signing off…",
      "signedOff": "Opening balances signed off",
      "signOffFailed": "Could not sign off the opening balances",
      "signOffBlocked": "Sign-off becomes available once the reconciliation shows no difference.",
      "confirmTitle": "Sign off the opening balances?",
      "confirmMessage": "This records that the batch matches the source system. It cannot be undone, and the entity may then begin to transact.",
      "confirmLabel": "Sign off",
      "cancelLabel": "Cancel",
      "signedOffByLabel": "Signed off by",
      "you": "you",
      "userId": "user #{id}",
      "auditTrail": "Audit trail",
      "railTitle": "Opening balances {file}",
      "events": {
        "created": "Imported",
        "reconciled": "Reconciled to source",
        "signedOff": "Signed off",
        "posted": "Posted to the ledger"
      },
      "reloaded": "The batch has been reloaded with the latest version; reapply your changes.",
      "errors": {
        "unsigned": "This batch cannot be signed off until it has been reconciled with no difference.",
        "signedOffAlready": "This batch has already been signed off, so its reconciliation is final and cannot be recorded again.",
        "illegalTransition": "This batch is not in a state that allows this step. It may already be signed off, or not yet approved.",
        "rowVersion": "Someone else changed this batch while you were working on it.",
        "validation": "Check the highlighted field and try again.",
        "forbidden": "You do not have permission to do this.",
        "notFound": "This opening-balance import no longer exists.",
        "mfaRequired": "Signing off needs two-factor authentication. Enrol an authenticator in your profile first."
      }
    }
  },
  "gl": {
    "statuses": {
      "draft": "Draft",
      "posted": "Posted",
      "reversed": "Reversed",
      "submitted": "Submitted",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "sources": {
      "manual": "Manual",
      "recurring": "Recurring",
      "reversal": "Reversal",
      "allocation": "Allocation",
      "opening_balance": "Opening balance",
      "ap": "Accounts payable",
      "ar": "Accounts receivable",
      "cash": "Cash and bank",
      "inventory": "Inventory",
      "payroll": "Payroll",
      "assets": "Fixed assets",
      "sales": "Sales",
      "projects": "Projects",
      "service": "Service",
      "mfg": "Manufacturing",
      "cost": "Cost accounting",
      "expense": "Expenses",
      "interco": "Intercompany",
      "treasury": "Treasury",
      "pos": "Point of sale",
      "pms": "Property management",
      "year_end_close": "Year-end close",
      "template": "Saved template"
    },
    "accountTypes": {
      "ASSET": "Asset",
      "LIABILITY": "Liability",
      "EQUITY": "Equity",
      "INCOME": "Income",
      "EXPENSE": "Expense"
    },
    "list": {
      "title": "Journal entries",
      "description": "Every journal in the ledger, and the drafts on their way there.",
      "filtersTitle": "Filters",
      "searchHint": "Matches the entry number and the memo.",
      "allCompanies": "Every legal entity",
      "from": "Entry date from",
      "to": "Entry date to",
      "newEntry": "New journal entry",
      "tableLabel": "Journal entries",
      "emptyTitle": "No journal entries yet",
      "emptyDescription": "Raise one here, or wait for a sub-ledger to post its first.",
      "loadFailed": "The journal list did not load",
      "exported": "Export ready",
      "exportedDetail": "{count} journal entries were written to the file.",
      "columns": {
        "entryNo": "Entry no.",
        "entryDate": "Entry date",
        "source": "Source",
        "memo": "Memo",
        "currency": "Currency"
      }
    },
    "entry": {
      "title": "Journal entry {entryNo}",
      "newTitle": "New journal entry",
      "draftTitle": "Draft",
      "description": "A journal is a debit or a credit on every line, and it balances to the cent before it can be posted.",
      "backToList": "Back to journal entries",
      "headerTitle": "Entry",
      "loadFailed": "That journal entry did not load",
      "actionsLabel": "Document actions",
      "balanceLabel": "Debits less credits",
      "balanced": "Balanced",
      "outOfBalance": "Out of balance",
      "readyToPost": "The lines balance and every account is postable, so this entry can go into the ledger.",
      "posting": "Posting",
      "postedImmutable": "This entry is in the ledger. A posted entry is corrected with a reversal, never edited or deleted.",
      "stale": "Someone else changed this entry while you had it open. Nothing was overwritten.",
      "reload": "Reload and reapply",
      "railSubtitle": "{status}, dated {date}",
      "fields": {
        "company": "Legal Entity",
        "companyPlaceholder": "Choose a legal entity",
        "entryNo": "Entry number",
        "entryDate": "Entry date",
        "entryDateHint": "The date the transaction belongs to. It decides the period.",
        "postingDate": "Posting date",
        "postingDateHint": "When it entered the books. Differs for a late-entered document.",
        "currency": "Currency",
        "currencyHint": "The legal entity keeps its books in {base}.",
        "memo": "Memo",
        "source": "Source",
        "sourceDoc": "Source document",
        "postedAt": "Posted"
      },
      "actions": {
        "save": "Save draft",
        "post": "Post",
        "reverse": "Reverse",
        "discard": "Discard draft",
        "print": "Print"
      },
      "blockers": {
        "noLines": "Add at least one line with an account and an amount.",
        "tooFewLines": "A journal needs at least two lines: something is debited and something is credited.",
        "lineIssues": "Some lines still need attention. The affected cells are marked.",
        "unbalanced": "Debits and credits do not agree yet, so this cannot be posted."
      },
      "timeline": {
        "created": "Draft raised",
        "posted": "Posted as {entryNo}",
        "reversed": "Reversed by a mirror entry"
      },
      "links": {
        "reverses": "The entry this one reverses",
        "reversedBy": "The entry that reverses this one"
      },
      "shortcuts": {
        "save": "Save the journal entry"
      },
      "toasts": {
        "saved": "Draft saved",
        "savedDetail": "It is not in the ledger yet. Post it when it balances.",
        "saveFailed": "The draft was not saved",
        "posted": "Posted as {entryNo}",
        "postedDetail": "It is in the ledger. Correct it with a reversal if it is wrong.",
        "postFailed": "That entry was not posted",
        "discarded": "Draft discarded",
        "discardedDetail": "Nothing reached the ledger, so nothing was reversed.",
        "discardFailed": "The draft was not discarded"
      },
      "unsavedGuard": {
        "title": "Discard unsaved changes?",
        "message": "This entry has changes that have not been saved. Leaving now discards them.",
        "confirm": "Discard changes",
        "cancel": "Keep editing"
      }
    },
    "lines": {
      "title": "Lines",
      "caption": "Journal lines: an account, an optional set of dimensions, and one amount in either the debit or the credit column.",
      "totals": "Totals",
      "baseOnly": "Revaluation (base only)",
      "accountPlaceholder": "Code or name",
      "noAccountMatch": "No account matches that.",
      "createAccount": "Create account {code}",
      "matchCount": "{count} accounts match",
      "noTaxCode": "No tax code",
      "keyboardHint": "Enter moves down a row. Alt and down arrow duplicates a row. Alt and backspace removes one.",
      "columns": {
        "no": "No.",
        "account": "Account",
        "description": "Description",
        "dimensions": "Dimensions",
        "taxCode": "Tax code",
        "debit": "Debit",
        "credit": "Credit",
        "rowActions": "Row actions"
      },
      "actions": {
        "add": "Add a line",
        "duplicate": "Duplicate this line",
        "remove": "Remove this line"
      },
      "aria": {
        "account": "Account on line {line}",
        "description": "Description on line {line}",
        "taxCode": "Tax code on line {line}",
        "debit": "Debit on line {line}",
        "credit": "Credit on line {line}",
        "duplicate": "Duplicate line {line}",
        "remove": "Remove line {line}"
      },
      "issues": {
        "bothSides": "A line is a debit or a credit, never both.",
        "invalidAmount": "That is not an amount.",
        "negative": "A negative amount is the other column spelled backwards. Put it in the other column.",
        "noAmount": "This line needs a debit or a credit greater than zero.",
        "noAccount": "Choose an account for this line.",
        "notPostable": "Account {account} is a heading, not a postable account. Post to one of its children.",
        "inactive": "Account {account} is inactive.",
        "requiresCostCenter": "Account {account} requires a cost centre on every line.",
        "requiresProfitCenter": "Account {account} requires a profit centre on every line.",
        "requiresBranch": "Account {account} requires a branch on every line.",
        "requiresDepartment": "Account {account} requires a department on every line.",
        "requiresProject": "Account {account} requires a project on every line."
      },
      "dimensions": {
        "title": "Dimensions",
        "costCenter": "Cost centre",
        "profitCenter": "Profit centre",
        "branch": "Branch",
        "department": "Department",
        "businessUnit": "Business unit",
        "project": "Project",
        "projectHint": "The project id the ledger will record. The Projects module arrives later, so there is no list to pick from yet.",
        "unset": "Not set",
        "none": "No dimensions",
        "assigned": "{count} set",
        "requiredShort": "{dimension} required",
        "requiredBy": "Required by account {account}.",
        "triggerLabel": "Dimensions for this line: {summary}",
        "clear": "Clear the dimensions on this line"
      }
    },
    "createAccount": {
      "title": "Create an account",
      "description": "It is added to this legal entity chart of accounts and selected on the line you were typing.",
      "code": "Account code",
      "name": "Account name",
      "type": "Type",
      "postableNote": "It is created as a postable account with no dimension requirements. Set a parent, a currency restriction or a dimension policy in the chart of accounts."
    },
    "reverse": {
      "title": "Reverse {entryNo}",
      "description": "This posts a new entry that cancels this one. Nothing is edited and nothing is deleted.",
      "mirrorHeadline": "A reversal is a mirror entry.",
      "mirrorBody": "Every debit becomes a credit and every credit becomes a debit, at the same amounts and the same exchange rates. The amounts are swapped, not made negative, so both entries still read as an ordinary journal and the pair nets to zero.",
      "originalKept": "The original stays in the ledger, marked reversed, and the two entries link to each other.",
      "dateLabel": "Reversal date",
      "dateHint": "It must fall in an open accounting period.",
      "reasonLabel": "Reason",
      "reasonHint": "Recorded on both entries and in the audit trail.",
      "confirm": "Post the reversal",
      "submitting": "Posting the reversal",
      "periodClosedHeadline": "That date falls in a period that is closed.",
      "doneTitle": "Reversal posted",
      "doneDetail": "The mirror entry is {entryNo}."
    },
    "checks": {
      "versus": "against",
      "difference": "a difference of",
      "advice": "This is what the server computed from the ledger. It has not been adjusted for display. Ask an accountant to look at it before relying on this report.",
      "filtered": "A report narrowed by a dimension is a slice of the ledger, so it is under no obligation to balance. No zero-sum check is claimed here.",
      "tbIdentity": "Debits total",
      "tbOk": "Debits equal credits. The ledger nets to zero.",
      "tbFail": "This trial balance does not net to zero.",
      "openingOk": "The opening column balances.",
      "openingFail": "The opening column does not balance.",
      "movementOk": "The movement column balances.",
      "movementFail": "The movement column does not balance.",
      "bsIdentity": "Assets total",
      "bsOk": "Assets equal liabilities plus equity.",
      "bsFail": "Assets do not equal liabilities plus equity.",
      "bsRefused": "The balance sheet was refused because it does not balance."
    },
    "reports": {
      "scope": "Scope",
      "period": "Period",
      "from": "From",
      "to": "To",
      "asOf": "As of",
      "wholeLedger": "Since the ledger opened",
      "ledgerStart": "the ledger opening",
      "basisLabel": "Date basis",
      "basisHint": "Which of the two business dates on an entry this report reads.",
      "basis": {
        "entry": "Entry date",
        "posting": "Posting date"
      },
      "includeZeroLabel": "Include accounts with no balance",
      "chooseCompany": "Choose a legal entity to run this report.",
      "filteredNote": "A dimension filter is applied, so this report is a slice of the ledger and makes no zero-sum claim.",
      "generatedAt": "Computed",
      "exportDone": "Export ready",
      "exportDoneDetail": "Saved as {filename}.",
      "exportFailed": "The export did not run"
    },
    "tb": {
      "title": "Trial balance",
      "description": "Every account with its opening, its movement and its closing balance, and the proof that the whole ledger nets to zero.",
      "caption": "Trial balance: opening, movement and closing debits and credits per account.",
      "periodHint": "Choosing a period sets the window and overrides the dates.",
      "fromHint": "Leave empty to open the window at the start of the ledger.",
      "convention": "Debit-positive, {from} to {asOf}, in {currency}. An asset or an expense reads positive, a liability, equity or income account reads negative.",
      "empty": "No account has a balance in this window.",
      "loadFailed": "The trial balance did not load",
      "columns": {
        "account": "Account",
        "net": "Closing net"
      },
      "groups": {
        "opening": "Opening",
        "movement": "Movement",
        "closing": "Closing"
      }
    },
    "statement": {
      "incomeTitle": "Income statement",
      "balanceTitle": "Balance sheet",
      "incomeDescription": "What happened between two dates: income less expenses, with comparatives where you ask for them.",
      "balanceDescription": "The position on a date, checked against the identity that assets equal liabilities plus equity.",
      "incomeConvention": "Natural-balance-positive, {from} to {to}, in {currency}. Income and expenses each read positive when the account holds its normal balance, and a loss is a negative net income.",
      "balanceConvention": "Natural-balance-positive as of {asOf}, in {currency}. Assets are debit-positive, liabilities and equity are credit-positive.",
      "loadFailed": "That statement did not load",
      "compareLabel": "Compare with",
      "compareHint": "The same statement over the earlier window, computed the same way.",
      "noComparative": "No comparative",
      "sectionTotal": "Total {section}",
      "retainedEarnings": "Retained earnings for the period",
      "compare": {
        "priorPeriod": "The period before",
        "priorYear": "The same period last year"
      },
      "columns": {
        "amount": "Amount {currency}",
        "comparative": "Comparative",
        "variance": "Variance",
        "variancePct": "Variance percent"
      },
      "sections": {
        "income": "Income",
        "expense": "Expenses",
        "asset": "Assets",
        "liability": "Liabilities",
        "equity": "Equity"
      },
      "summary": {
        "totalIncome": "Total income",
        "totalExpense": "Total expenses",
        "netIncome": "Net income",
        "totalAssets": "Total assets",
        "totalLiabilities": "Total liabilities",
        "retainedEarningsPeriod": "Retained earnings for the period",
        "totalEquity": "Total equity",
        "totalLiabilitiesAndEquity": "Total liabilities and equity"
      }
    },
    "ledger": {
      "title": "GL detail",
      "description": "Every posting on one account, in order, with the running balance and a link to the journal behind each row.",
      "caption": "General ledger detail for one account.",
      "chooseAccount": "Choose an account",
      "chooseScope": "Choose a legal entity and an account to see its postings.",
      "convention": "Debit-positive, in {currency}. The final running balance equals this account closing balance on the trial balance.",
      "openingBalance": "Opening balance",
      "rangeTotals": "Totals for this window",
      "empty": "This account has no postings in this window.",
      "loadFailed": "The ledger detail did not load",
      "columns": {
        "date": "Date",
        "sourceDoc": "Source document",
        "running": "Running balance"
      }
    },
    "drilldown": {
      "recurringTemplate": "Recurring template",
      "allocationRule": "Allocation rule",
      "openingBalance": "Opening balance import",
      "pendingShort": "no screen yet",
      "pendingTooltip": "This journal was raised by {module}, which is not part of this build yet. The document type and its id are shown so the chain can still be followed in the database.",
      "modules": {
        "ap": "accounts payable",
        "ar": "accounts receivable",
        "cash": "cash and bank",
        "inventory": "inventory",
        "payroll": "payroll",
        "assets": "fixed assets",
        "projects": "projects",
        "mfg": "manufacturing",
        "unknown": "a module this screen does not recognise"
      },
      "sourceDoc": "The document this posted from"
    },
    "run": {
      "action": "Run",
      "title": "Run {name}",
      "generatedHeadline": "The journal was generated.",
      "generatedBody": "It was raised as {entryNo}.",
      "amount": "Amount",
      "openEntry": "Open the journal entry",
      "alreadyHeadline": "That period already has its journal.",
      "alreadyBody": "These runs are deliberately once per period, so a second run changes nothing. The ledger is already in the state you asked for.",
      "failed": "The run did not complete"
    },
    "templates": {
      "title": "Recurring journals",
      "description": "Templates the worker turns into journals on a schedule. A template that cannot produce a postable journal is a scheduled failure, so it has to balance here.",
      "newTemplate": "New template",
      "editTemplate": "Edit template",
      "editorDescription": "The lines are a journal, so the same rules apply: a debit or a credit on each line, and the two columns agree.",
      "tableLabel": "Recurring journal templates",
      "emptyTitle": "No recurring journals yet",
      "emptyDescription": "Create one for a rent accrual, a depreciation stand-in or any journal you post every month.",
      "loadFailed": "The templates did not load",
      "active": "Active",
      "inactive": "Inactive",
      "activeLabel": "Active",
      "interval": "Every",
      "intervalHint": "How many of the chosen units between runs.",
      "dayOfMonth": "Day of month",
      "dayOfMonthHint": "Leave empty to keep the start date day.",
      "startDate": "First run",
      "endDate": "Last run",
      "endDateHint": "Leave empty to run until it is switched off.",
      "postAutomatically": "Post automatically",
      "postAutomaticallyHint": "The worker posts the generated journal rather than leaving it as a draft.",
      "saved": "Template saved",
      "savedDetail": "Template {code} is stored.",
      "saveFailed": "The template was not saved",
      "delete": "Delete",
      "deleteTitle": "Delete this template",
      "deleteDescription": "Template {code} will stop generating journals.",
      "deleteBody": "The journals it has already generated stay in the ledger. Only the template goes.",
      "deleted": "Template deleted",
      "deletedDetail": "Template {code} will not run again.",
      "deleteFailed": "The template was not deleted",
      "columns": {
        "code": "Code",
        "frequency": "Frequency",
        "nextRun": "Next run",
        "lastRun": "Last run",
        "runCount": "Runs"
      },
      "frequencies": {
        "daily": "Daily",
        "weekly": "Weekly",
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "annually": "Annually",
        "onDemand": "On demand"
      },
      "onDemandHint": "Posted only when you run it. The scheduler never generates a journal from it, so it has no next run."
    },
    "routeTitles": {
      "journalTypes": "Journal types",
      "dimensionPolicies": "Dimension policy",
      "suspense": "Suspense",
      "accruals": "Accruals",
      "assertions": "Posting assertions"
    },
    "governanceNav": {
      "label": "Posting governance sections",
      "journalTypes": "Journal types",
      "dimensionPolicies": "Dimension policy",
      "suspense": "Suspense",
      "accruals": "Accruals",
      "assertions": "Posting assertions"
    },
    "reversalPolicies": {
      "manual": "By hand",
      "next_period": "Next period",
      "on_match": "On match"
    },
    "requirements": {
      "required": "Required",
      "optional": "Optional",
      "forbidden": "Forbidden"
    },
    "dimensions": {
      "cost_center": "Cost centre",
      "profit_center": "Profit centre",
      "branch": "Branch",
      "department": "Department",
      "business_unit": "Business unit",
      "division": "Division",
      "project": "Project"
    },
    "suspenseStatuses": {
      "open": "Open",
      "partially_cleared": "Partly cleared",
      "cleared": "Cleared",
      "written_off": "Written off"
    },
    "accrualStatuses": {
      "open": "Open",
      "partially_matched": "Partly matched",
      "matched": "Matched",
      "reversed": "Reversed",
      "written_off": "Written off"
    },
    "accrualKinds": {
      "goods_received": "Goods received",
      "services_received": "Services received",
      "expense_accrued": "Expense accrued",
      "revenue_unbilled": "Revenue unbilled",
      "payroll_accrued": "Payroll accrued",
      "other": "Other"
    },
    "assertionStatuses": {
      "pass": "Passed",
      "fail": "Failed",
      "not_run": "Never ran",
      "accepted": "Accepted"
    },
    "journalTypes": {
      "title": "Journal types",
      "description": "A tenant's own classification of what posts. Not the same thing as an entry's source, which names the subsystem that produced it.",
      "sourceHint": "Source is a closed list the server owns and a tenant cannot extend. A journal type is yours, and its allowed sources are which subsystems may post under it.",
      "loadFailed": "Journal types could not be loaded",
      "create": "New journal type",
      "createTitle": "New journal type",
      "editTitle": "Edit journal type",
      "dialogDescription": "The code is how posting paths resolve this type, so it cannot be changed once entries carry it.",
      "created": "Journal type created",
      "updated": "Journal type saved",
      "saveFailed": "The journal type could not be saved",
      "code": "Code",
      "name": "Name",
      "allowedSources": "Allowed sources",
      "allowedSourcesHint": "Comma-separated source codes. Leave blank to allow any source.",
      "anySource": "Any source",
      "allowsManual": "Allows a hand-raised journal",
      "allowsManualHint": "Off means only a subsystem may post under this type — nobody can pick it on a manual entry.",
      "manualYes": "Manual allowed",
      "manualNo": "System only",
      "reversalPolicy": "Reversal",
      "requiresApproval": "Approval",
      "approvalYes": "Required",
      "active": "Active",
      "inactive": "Inactive",
      "system": "System",
      "tableLabel": "Journal types",
      "emptyTitle": "No journal types",
      "emptyDescription": "Create one, or let the seeded defaults arrive with the legal entity's chart of accounts.",
      "approvalNo": "Not required",
      "approvalEffect": "Manual and recurring journals of this type must be submitted and approved before they can be posted.",
      "noApprovalEffect": "Journals of this type are posted directly, without an approval step.",
      "reversalEffect": {
        "manual": "Reversed only when somebody reverses it.",
        "next_period": "Reversed automatically in the next period.",
        "on_match": "Reversed when the document it estimates is matched."
      },
      "delete": "Delete",
      "deleteConfirm": "Delete type",
      "deleteTitle": "Delete this journal type?",
      "deleteMessage": "{code} will no longer be offered on new journals. Entries already raised under it keep it.",
      "deleted": "Journal type deleted",
      "deleteFailed": "The journal type could not be deleted",
      "staleTitle": "This journal type changed",
      "staleDetail": "Someone else saved this journal type while you had it open. It was reloaded and nothing was overwritten. Review your changes and save again.",
      "attachmentAbove": "Attachment required above",
      "attachmentAboveHint": "A hand-keyed journal of this type whose total, in base currency, exceeds this amount cannot be posted without a supporting attachment. Leave blank for no requirement.",
      "attachmentAboveInvalid": "Enter an amount greater than zero, such as 10000.00.",
      "attachmentNone": "Not required",
      "attachmentEffect": "Needs a supporting attachment above {amount}"
    },
    "dimensionPolicies": {
      "title": "Per-account dimension policy",
      "description": "Which dimensions an account requires, permits or forbids — effective-dated, so setting one never restates history.",
      "forbiddenHint": "Forbidden is the one a report can find after the fact. A required dimension that was missing could never have posted in the first place.",
      "loadFailed": "The account's policy could not be loaded",
      "account": "Account",
      "chooseTitle": "Choose an account",
      "chooseDescription": "Policy is per account. Pick a legal entity, then the account whose dimensions you want to govern.",
      "gridTitle": "Dimensions",
      "gridDescription": "A dimension with no policy is optional. All seven are listed so you can see what is unset rather than infer it.",
      "dimension": "Dimension",
      "requirement": "Requirement",
      "effectiveFrom": "Effective from",
      "note": "Note",
      "saved": "Dimension policy saved",
      "saveFailed": "The dimension policy could not be saved"
    },
    "suspense": {
      "title": "Suspense",
      "description": "Amounts whose account is not yet known. Clearing one is bookkeeping; writing one off is a loss and a governed exception.",
      "loadFailed": "Suspense items could not be loaded",
      "reportFailed": "The suspense report could not be loaded",
      "tabItems": "Items",
      "tabReport": "By position",
      "tabsLabel": "Suspense views",
      "position": "Position",
      "anyPosition": "Any position",
      "anyStatus": "Any status",
      "entryDate": "Date",
      "source": "Raised by",
      "noDescription": "No description",
      "amount": "Amount",
      "amountHint": "Defaults to the whole remaining balance. Enter less to clear part of it.",
      "cleared": "Cleared",
      "remaining": "Remaining",
      "openCount": "Open",
      "agedCount": "Aged",
      "agedRemaining": "Aged balance",
      "blocksClose": "Blocks close",
      "blocksCloseColumn": "Close",
      "tableLabel": "Suspense items",
      "emptyTitle": "Nothing in suspense",
      "emptyDescription": "An amount lands here when a posting knows the money but not the account.",
      "reportTitle": "Suspense by position",
      "reportDescription": "Aged balances first: an item older than its position's limit is what will stop the month.",
      "reportEmptyTitle": "No suspense positions",
      "reportEmptyDescription": "A position is where suspense amounts sit. The seeded chart creates one; add more if a source needs its own.",
      "clear": "Clear",
      "clearTitle": "Clear a suspense item",
      "clearDescription": "Move the amount to the account it always belonged to.",
      "clearingAccount": "Clearing account",
      "clearFailed": "The item could not be cleared",
      "writeOff": "Write off",
      "writeOffTitle": "Write a suspense item off",
      "writeOffDescription": "The amount will never be identified, so it becomes a cost.",
      "writeOffWarning": "This is a loss, not a reclassification. It is banded against an authority in money and recorded against your name.",
      "expenseAccount": "Expense account",
      "writtenOff": "Item written off",
      "writeOffFailed": "The item could not be written off",
      "reason": "Reason",
      "clearedItem": "Item cleared",
      "newPosition": "New position",
      "postItem": "Post to suspense",
      "postNeedsPosition": "Create a suspense position first.",
      "positionTitle": "New suspense position",
      "positionDescription": "A named place over a suspense account, where unclassified amounts sit until they are cleared.",
      "positionCode": "Code",
      "positionName": "Name",
      "positionAccount": "Suspense account",
      "positionAccountHint": "The ledger account the position's balance sits in.",
      "maxAgeDays": "Limit (days)",
      "maxAgeDaysHint": "An item older than this is aged. Leave blank for the default.",
      "maxAgeDaysInvalid": "Enter a whole number of days.",
      "blocksCloseLabel": "An aged balance blocks the period close",
      "blocksCloseHint": "The close cockpit reads this: an aged item on a blocking position stops the month.",
      "positionCreated": "Suspense position created",
      "positionCreateFailed": "The suspense position could not be created",
      "postTitle": "Post an amount to suspense",
      "postDescription": "Record money whose account is not yet known. It posts to the position's account against the counter account, and waits there to be cleared.",
      "postAmountHint": "A decimal amount with up to two places.",
      "postAmountInvalid": "Enter an amount such as 1250.00.",
      "counterAccount": "Counter account",
      "counterAccountHint": "The other side of the posting, usually the bank or clearing account the money came through.",
      "itemPosted": "Posted to suspense",
      "postFailed": "The amount could not be posted to suspense",
      "item_opened": "An amount is being held in a suspense account."
    },
    "accruals": {
      "title": "Accruals",
      "description": "GR-IR generalised: an estimate raised at period end, matched to its document, or reversed.",
      "loadFailed": "Accrual items could not be loaded",
      "agingFailed": "The accrual ageing could not be loaded",
      "tabItems": "Items",
      "tabAging": "Ageing",
      "tabsLabel": "Accrual views",
      "position": "Position",
      "anyPosition": "Any position",
      "anyStatus": "Any status",
      "raisedOn": "Raised",
      "raisedFor": "Raised for",
      "noDescription": "No description",
      "reversal": "Reverses",
      "movedFrom": "moved from {date} — that period is closed",
      "amount": "Amount",
      "matched": "Matched",
      "remaining": "Remaining",
      "maxAgeDays": "Limit (days)",
      "openCount": "Open",
      "agedCount": "Aged",
      "agedRemaining": "Aged balance",
      "tableLabel": "Accrual items",
      "emptyTitle": "No accruals",
      "emptyDescription": "An accrual is raised when a cost is incurred before its document arrives — a receipt without an invoice, a service without a bill.",
      "agingTitle": "Accrual ageing",
      "agingDescription": "An item older than its position's limit is an estimate nobody matched. On a position that blocks the close, it stops the month.",
      "agingEmptyTitle": "No accrual positions",
      "agingEmptyDescription": "A position groups accruals of one kind. GR-IR is seeded; add more for services or unbilled revenue.",
      "reverse": "Reverse",
      "reverseTitle": "Reverse an accrual",
      "reverseDescription": "The mirror entry releases the estimate.",
      "reverseOn": "Reverse on",
      "reverseOnHint": "Leave as scheduled unless you have a reason to move it.",
      "closedPeriodHint": "If the date you choose falls in a closed period the reversal lands in the next open one instead, and the screen will tell you where it went.",
      "reversed": "Accrual reversed",
      "reversedMoved": "Reversed — the date moved because the period is closed",
      "reverseFailed": "The accrual could not be reversed",
      "writeOff": "Write off",
      "writeOffTitle": "Write an accrual off",
      "writeOffDescription": "The estimate will never be billed.",
      "writeOffWarning": "Writing an accrual off releases a cost that was already recognised. It shows up as income in the period you do it.",
      "writtenOff": "Accrual written off",
      "writeOffFailed": "The accrual could not be written off",
      "reason": "Reason",
      "newPosition": "New position",
      "positionTitle": "New accrual position",
      "positionDescription": "Groups accruals of one kind over an accrual account, with the rule that reverses them.",
      "positionCode": "Code",
      "positionName": "Name",
      "kind": "Kind",
      "positionAccount": "Accrual account",
      "positionAccountHint": "The balance-sheet account the accrual sits in until it is matched or reversed.",
      "counterAccount": "Counter account",
      "counterAccountHint": "Optional. The expense or revenue side the accrual is raised against.",
      "reversePolicy": "Reverses",
      "reversePolicies": {
        "on_match": "On match",
        "on_date": "On a date",
        "manual": "By hand"
      },
      "reversePolicyEffect": {
        "on_match": "Each item reverses when its document is matched, as GR-IR does.",
        "on_date": "Each item reverses on its scheduled date, moved forward if that period is closed.",
        "manual": "Items stay until somebody reverses or writes them off."
      },
      "maxAgeDaysHint": "An item older than this is aged. Leave blank for the default.",
      "maxAgeDaysInvalid": "Enter a whole number of days.",
      "blocksCloseLabel": "An aged balance blocks the period close",
      "positionCreated": "Accrual position created",
      "positionCreateFailed": "The accrual position could not be created"
    },
    "assertions": {
      "title": "Posting completeness",
      "description": "Did everything that should have posted, post? One answer per module per business date.",
      "loadFailed": "Posting assertions could not be loaded",
      "modules": {
        "ap": "Accounts payable",
        "ar": "Accounts receivable",
        "inventory": "Inventory",
        "sales": "Sales",
        "cash": "Cash"
      },
      "module": "Module",
      "anyModule": "Any module",
      "anyStatus": "Any status",
      "businessDate": "Business date",
      "from": "From",
      "to": "To",
      "expected": "Expected",
      "posted": "Posted",
      "unposted": "Unposted",
      "difference": "Difference",
      "failingBanner": "{count} assertion(s) failed. A sub-ledger that stopped posting is invisible to every other report — the trial balance still balances.",
      "tableLabel": "Posting assertions",
      "emptyTitle": "No assertions recorded",
      "emptyDescription": "Run them for a business date, or wait for the nightly sweep.",
      "run": "Run now",
      "runTitle": "Run posting assertions",
      "runDescription": "Every registered module is asserted for the date you choose.",
      "ran": "Assertions run",
      "ranWithFailures": "Assertions run — some failed",
      "runFailed": "The assertions could not be run",
      "accept": "Accept",
      "acceptTitle": "Accept a failing assertion",
      "acceptDescription": "Record that the difference was investigated and the close may proceed.",
      "acceptWarning": "This does not post anything. The difference stays; what changes is that somebody has taken responsibility for it.",
      "acceptSubject": "{module}, {date} — {unposted} document(s) did not post.",
      "accepted": "Assertion accepted",
      "acceptFailed": "The assertion could not be accepted",
      "reason": "Reason"
    },
    "approval": {
      "actions": {
        "submit": "Submit for approval",
        "returnToDraft": "Return to draft"
      },
      "submitting": "Submitting",
      "returning": "Returning to draft",
      "readyToSubmit": "The lines balance and every account is postable, so this entry can be submitted for approval.",
      "notes": {
        "submitted": "This journal is awaiting approval and cannot be edited. Return it to draft to withdraw the request and change it.",
        "approved": "This journal is approved and can be posted. Returning it to draft voids the approval.",
        "rejected": "This journal was rejected. Edit it and save to return it to draft, then submit it again, or discard it.",
        "gated": "This journal type requires approval: save the draft and submit it. It can be posted once it is approved."
      },
      "openInbox": "Open the approvals inbox",
      "openAuthorityMatrix": "Open the authority matrix",
      "errors": {
        "required": "This journal type requires approval. Submit it for approval, and post it once it is approved.",
        "notRequired": "This journal type does not require approval. Post it directly.",
        "unresolvable": "No approver is configured for journals. Set up an approval chain for the document type gl.journal in the authority matrix, then submit again."
      },
      "toasts": {
        "submitted": "Submitted for approval",
        "submittedDetail": "It is waiting in the approvals inbox. Post it once it is approved.",
        "submitFailed": "The journal was not submitted",
        "returned": "Returned to draft",
        "returnedDetail": "It can be edited again. Submit it for approval when it is ready.",
        "returnFailed": "The journal was not returned to draft"
      }
    },
    "entryType": {
      "label": "Journal type",
      "placeholder": "Choose a journal type",
      "hint": "Decides whether the entry needs approval and how it reverses.",
      "fixedHint": "Set when the entry was created. It cannot be changed on a saved entry.",
      "unreadable": "Your role cannot read journal types, so the entry uses the standard type.",
      "requiresApproval": "Requires approval",
      "noApproval": "No approval",
      "reversal": "Reverses: {policy}",
      "postLocked": "Post becomes available once this journal is approved. Submit it for approval first.",
      "column": "Type"
    },
    "entryExtras": {
      "documentDate": "Document date",
      "documentDateHint": "The date on the source document, when it differs from the entry date. Optional.",
      "reversalDate": "Reversal date",
      "reversalDateHint": "This journal type reverses automatically. The reversal is posted on this date, which must fall after the entry date.",
      "reversalDateRequired": "Enter the reversal date: this journal type reverses in the next period.",
      "autoReversal": {
        "label": "Automatic reversal",
        "open": "Open the reversal",
        "statuses": {
          "draft": "Waiting as a draft",
          "posted": "Posted",
          "discarded": "Discarded"
        }
      },
      "check": {
        "action": "Check",
        "hint": "Runs every posting rule against the saved journal without saving or posting anything.",
        "running": "Checking",
        "title": "Check result",
        "ok": "No issues found. The saved journal passes every posting rule.",
        "issues": "Issues found: {count}. The journal cannot be posted until they are resolved.",
        "where": "Where",
        "code": "Code",
        "message": "Finding",
        "header": "Header",
        "line": "Line {lineNo}",
        "lineField": "Line {lineNo} · {field}",
        "savedVersion": "You have unsaved changes. This result describes the saved version of the journal; save and check again to include them.",
        "failed": "The check could not be run."
      },
      "attachments": {
        "requirement": "This journal type needs a supporting document before posting when the journal's total is above {amount}.",
        "saveFirst": "Save the journal first to attach its supporting documents.",
        "required": "This journal needs a supporting document before it can be posted. Attach one, then post again."
      }
    },
    "approvalPreview": {
      "heading": "Journal lines",
      "noAccess": "Your role cannot read journal entries, so the lines are not shown. The amount above is the journal's total.",
      "loadFailed": "The journal's lines could not be loaded",
      "accountById": "Account #{id}",
      "dated": "Dated {date}",
      "account": "Account",
      "description": "Description",
      "totals": "Totals",
      "open": "Open the journal"
    },
    "ft10": {
      "warnings": {
        "title": {
          "posted": "Posted with budget warnings",
          "check": "Budget warnings if posted now"
        },
        "summary": {
          "posted": "The journal is posted. {count} line exceeded its budget at warn level; review the figures below. | The journal is posted. {count} lines exceeded their budget at warn level; review the figures below.",
          "check": "Posting would succeed, with {count} budget warning. | Posting would succeed, with {count} budget warnings."
        },
        "codes": {
          "WARN_BUDGET_EXCEEDED": "{account} is over its budget for this journal."
        },
        "budget": "Budget",
        "committed": "Committed",
        "actuals": "Actuals",
        "available": "Available",
        "requested": "This journal",
        "overspend": "Over budget by",
        "tolerance": "Tolerance"
      }
    },
    "entryRate": {
      "rateType": "Rate type",
      "rateTypeHint": "The rate book this foreign-currency entry is translated from.",
      "types": {
        "spot": "Spot",
        "corporate": "Corporate",
        "historical": "Historical"
      },
      "rate": "Rate override",
      "rateHint": "Optional. The value of one {currency} in {base}, with up to eight decimal places. Leave blank to use the rate book. An override must stay within the declared tolerance.",
      "ratePlaceholder": "From the rate book",
      "invalid": "Enter a rate greater than zero with at most eight decimal places, such as 15.42.",
      "clearRemovesSaved": "Saving removes the saved override {rate}, and the entry translates at the rate book's rate again. Enter a rate to keep an override."
    },
    "entryActions": {
      "copy": {
        "action": "Copy to new",
        "hint": "Opens a new draft with this entry's lines, dated today. Nothing is saved until you save the copy.",
        "note": "Copied from {source}. The dates are today's and nothing has been saved yet."
      },
      "autoBalance": {
        "action": "Auto-balance",
        "hint": "Adds one line to the suspense account that brings the entry into balance.",
        "title": "Auto-balance to suspense",
        "description": "Adds one line for the difference to the legal entity's suspense account. Review it before you save.",
        "difference": "Difference",
        "alreadyBalanced": "The entry already balances.",
        "invalidAmounts": "Correct the amounts on the lines first. Every amount must be a positive figure on one side only.",
        "forbidden": "Your role cannot read suspense positions, so the suspense account cannot be looked up. Balance the entry by hand instead.",
        "loadFailed": "The suspense positions could not be loaded.",
        "retry": "Retry",
        "noSuspense": "This legal entity has no active suspense position, so there is no suspense account to balance to.",
        "openSuspense": "Set one up under Suspense",
        "position": "Suspense position",
        "positionHint": "This legal entity has more than one. Choose where the difference waits to be cleared.",
        "positionPlaceholder": "Choose a position",
        "accountById": "Account #{id}",
        "lineDescription": "Auto-balance to suspense {position}",
        "previewHeading": "Line to add",
        "side": "Side",
        "amount": "Amount",
        "after": "Totals once the line is added (debit and credit):",
        "notSaved": "The line is only added to the grid. Save the entry to keep it.",
        "confirm": "Add line"
      },
      "validate": {
        "split": "{header} on the journal, {lines} on lines.",
        "linesMarked": "Line findings are also marked on their lines.",
        "linesNotMarked": "Line findings are not marked on the grid, because the lines on screen differ from the saved version that was checked.",
        "gotoLine": "Go to line {lineNo}"
      }
    },
    "ft6": {
      "routeTitles": {
        "journalRegister": "Journal register",
        "manualJournals": "Manual journal analysis",
        "cashFlow": "Cash flow statement",
        "journalTemplates": "Journal templates"
      },
      "register": {
        "title": "Journal register",
        "description": "Every journal with its type, preparer, approver, status and value. Filter it, then export exactly what the filters select.",
        "filters": {
          "journalType": "Journal type",
          "anyType": "Any type",
          "typeCodePlaceholder": "Type code, such as STD",
          "preparer": "Preparer",
          "approver": "Approver",
          "anyone": "Anyone"
        },
        "columns": {
          "entryNo": "Journal",
          "entryDate": "Date",
          "journalType": "Type",
          "source": "Source",
          "status": "Status",
          "preparer": "Preparer",
          "approver": "Approver",
          "approvedAt": "Approved",
          "value": "Value"
        },
        "userById": "User {id}",
        "exportCsv": "Export CSV",
        "exportXlsx": "Export XLSX",
        "exportDone": "Register exported",
        "exportDoneDetail": "Saved as {filename}.",
        "exportFailed": "The register was not exported",
        "exportTooLarge": "Too many journals match to export in one file. Narrow the date range or the filters, then export again.",
        "emptyTitle": "No journals match",
        "emptyDescription": "Widen the date range or clear a filter. A journal appears here as soon as it is saved.",
        "loadFailed": "The journal register did not load"
      },
      "manual": {
        "title": "Manual journal analysis",
        "description": "How many journals were keyed by hand, by whom or to which accounts, and their share of all journals. A rising share is a control signal.",
        "groupBy": "Group by",
        "groupByPreparer": "Preparer",
        "groupByAccount": "Account",
        "summary": {
          "entries": "Manual journals",
          "lines": "Manual lines",
          "value": "Manual value",
          "reversed": "Reversed",
          "share": "Share of all journals"
        },
        "shareOf": "{share}% of {all} journals",
        "columns": {
          "preparer": "Preparer",
          "account": "Account",
          "entries": "Journals",
          "lines": "Lines",
          "totalDebit": "Debits ({currency})",
          "totalCredit": "Credits ({currency})",
          "average": "Average journal",
          "reversed": "Reversed",
          "share": "Share of value"
        },
        "valueNote": "Values are in {currency}, the legal entity's base currency.",
        "emptyTitle": "No manual journals in this period.",
        "emptyDescription": "Every journal in the period came from a sub-ledger, a template or an allocation. Widen the dates to compare.",
        "loadFailed": "The analysis did not load"
      },
      "cashFlow": {
        "title": "Cash flow statement",
        "description": "Indirect method: net profit adjusted for non-cash items and working capital, then investing and financing, reconciled to the movement in cash.",
        "tabs": {
          "statement": "Statement",
          "mapping": "Account mapping"
        },
        "compare": {
          "label": "Comparative",
          "none": "No comparative",
          "priorPeriod": "Prior period",
          "priorYear": "Prior year",
          "custom": "Custom dates",
          "from": "Compare from",
          "thru": "Compare to"
        },
        "columns": {
          "line": "Line",
          "amount": "Amount ({currency})",
          "comparative": "Comparative"
        },
        "sections": {
          "operating": "Operating activities",
          "investing": "Investing activities",
          "financing": "Financing activities"
        },
        "groups": {
          "adjustment": "Adjustments for non-cash items",
          "working_capital": "Changes in working capital"
        },
        "categories": {
          "operating": "Operating",
          "investing": "Investing",
          "financing": "Financing",
          "cash": "Cash",
          "non_cash": "Non-cash"
        },
        "sectionTotal": "Net cash from {section}",
        "netChange": "Net change in cash",
        "openingCash": "Opening cash",
        "closingCash": "Closing cash",
        "cashMovement": "Movement in cash accounts",
        "reconciles": "The statement reconciles to the movement in cash accounts.",
        "doesNotReconcile": "The statement does not reconcile to the movement in cash accounts. Check the account mapping.",
        "differenceLabel": "Difference:",
        "compareDoesNotReconcile": "The comparative column does not reconcile to the movement in cash accounts for its period.",
        "unmappedTitle": "Accounts without a cash-flow mapping: {count}",
        "unmappedBody": "These accounts moved in the period and were placed by their default category. Map them so the statement shows them where you intend.",
        "unmappedColumns": {
          "account": "Account",
          "defaultCategory": "Default used",
          "movement": "Movement"
        },
        "openMapping": "Map these accounts",
        "convention": "{from} to {to}, in {currency}. Positive amounts add cash; negative amounts use it.",
        "loadFailed": "The cash flow statement did not load",
        "mapping": {
          "description": "Choose which section each account's movement appears in. Accounts you have not mapped use a default, shown as Default.",
          "columns": {
            "account": "Account",
            "category": "Category",
            "lineCode": "Line code",
            "source": "Mapping"
          },
          "categoryAria": "Cash-flow category for {code}",
          "lineCodeAria": "Line code for {code}",
          "lineCodePlaceholder": "Optional",
          "sourceExplicit": "Mapped",
          "sourceDefault": "Default",
          "save": "Save",
          "saved": "Mapping saved",
          "savedDetail": "{code} now maps to {category}.",
          "saveFailed": "The mapping was not saved",
          "stale": "Someone changed the mapping for {code} after this list loaded. The current mapping is shown. Apply your change again.",
          "loadFailed": "The account mapping did not load",
          "emptyTitle": "No postable accounts.",
          "emptyDescription": "Add postable accounts to the chart of accounts, then map them here."
        }
      },
      "templates": {
        "title": "Journal templates",
        "description": "Saved journals. A recurring template generates a journal on its schedule. An on-demand template posts only when you run it. Use either on a new journal with From template."
      },
      "entry": {
        "fromTemplate": {
          "action": "From template",
          "hint": "Adds a saved template's lines, with the amounts left blank for you to enter.",
          "title": "Add lines from a template",
          "description": "The template's accounts, descriptions and dimensions are added to this journal. Nothing is saved until you save the journal.",
          "template": "Template",
          "templatePlaceholder": "Choose a template",
          "noTemplates": "This legal entity has no active templates. Save a journal as a template to reuse its lines.",
          "openTemplates": "Open journal templates",
          "currencyDiffers": "This template was saved in {templateCurrency}. This journal is in {currency}, and the lines are added in {currency}.",
          "amountsBlank": "The amounts are left blank. Enter them before you save.",
          "confirm": "Add lines",
          "loadFailed": "The templates did not load",
          "loadTemplateFailed": "That template did not load.",
          "applied": "Lines added from {code}",
          "appliedDetail": "Enter the amounts, then save."
        },
        "saveTemplate": {
          "action": "Save as template",
          "hint": "Saves this journal's lines as an on-demand template.",
          "recurringAction": "Set recurring",
          "recurringHint": "Saves this journal's lines as a template that generates a journal on a schedule.",
          "titleTemplate": "Save as template",
          "titleRecurring": "Set recurring",
          "descriptionTemplate": "Saves this journal's lines and dimensions as a template.",
          "descriptionRecurring": "Saves this journal's lines and dimensions as a template that generates a journal each period, from the start date to the end date.",
          "onDemandNote": "The template is on demand: nothing posts until someone runs it.",
          "savedVersion": "This journal has unsaved changes. The template is made from the saved version.",
          "name": "Name",
          "code": "Code",
          "codeHint": "Optional. If left blank, the code is made from this journal's number.",
          "frequency": "Frequency",
          "startOn": "Start",
          "startOnHint": "The first period it generates a journal for.",
          "endOn": "End",
          "endOnHint": "Optional. If left blank, it runs until it is switched off.",
          "confirm": "Save template",
          "confirmRecurring": "Set recurring",
          "saved": "Template saved",
          "savedDetail": "{code} is in Journal templates."
        },
        "importLines": {
          "action": "Import lines",
          "hint": "Adds lines to this draft from a CSV file.",
          "saveFirst": "Save your changes first. Imported lines are added to the saved version of this journal.",
          "title": "Import lines from a file",
          "description": "Adds the lines in a CSV file to the end of this draft journal.",
          "rowByRow": "Every valid row is imported. A row with a problem is left out and listed, so you can import just the corrected rows afterwards. If the header row is wrong or the file has too many rows, nothing is imported.",
          "fileLabel": "CSV file",
          "fileHint": "Needs a header row with accountCode or accountId, and debit or credit. Optional columns: description, taxCode, costCenterId, profitCenterId, branchId, departmentId, businessUnitId, projectId.",
          "upload": "Import",
          "uploading": "Importing",
          "notDraft": "Lines can only be imported into a draft journal. Return the journal to draft first.",
          "refusedTitle": "Nothing was imported",
          "refusedLead": "The file has {count} problem(s). Correct them and import the file again. The journal is unchanged.",
          "partialTitle": "Rows not imported: {count}",
          "partialLead": "These rows were left out. The other rows are already on the journal, so import only the corrected rows. Importing the whole file again would add those lines twice.",
          "errorsCaption": "Problems in the file",
          "columns": {
            "row": "Row",
            "field": "Column",
            "problem": "Problem"
          },
          "codes": {
            "malformed": "The row could not be read as CSV.",
            "missing_column": "A required column is missing from the header row.",
            "required": "A value is required.",
            "numeric": "Not a number.",
            "scale": "More than two decimal places.",
            "negative": "Amounts cannot be negative.",
            "debit_xor_credit": "Enter a debit or a credit, not both and not neither.",
            "max": "Too long.",
            "too_many_rows": "The file has too many rows. Split it and import each part.",
            "empty": "The file has no data rows.",
            "unknown_account": "No account with this code in this legal entity.",
            "wrong_company": "The account belongs to another legal entity.",
            "inactive_account": "The account is inactive.",
            "not_postable": "The account does not accept postings.",
            "unknown_dimension": "No dimension with this number in this legal entity.",
            "policy": "The account's dimension rules are not met.",
            "forbidden": "This account does not allow this dimension."
          },
          "doneTitle": "Lines imported: {count}",
          "doneLead": "The lines were added to this journal."
        }
      }
    },
    "ft7": {
      "entry": {
        "reversedThroughSource": "Reversed through its source document"
      }
    },
    "assertion": {
      "failed": "A posting completeness check failed: the ledger does not agree with its source."
    },
    "accrual": {
      "reversal_due": "An accrual is due to be reversed.",
      "aged": "An accrual has stayed open longer than its limit."
    },
    "journal": {
      "auto_reversal_blocked": "An automatic reversal could not be posted."
    }
  },
  "ap": {
    "vendors": {
      "title": "Vendors",
      "description": "Everyone the business owes money to, and the terms it owes it on.",
      "oneTitle": "Vendor",
      "oneDescription": "Profile, bank details, documents and the ledger behind them.",
      "tableLabel": "Vendors",
      "loadFailed": "The vendor list did not load",
      "oneLoadFailed": "This vendor did not load",
      "notFound": "This vendor no longer exists, or you may not see it.",
      "newVendor": "New vendor",
      "createFirst": "Add the first vendor",
      "backToList": "Back to vendors",
      "emptyTitle": "No vendors yet",
      "emptyDescription": "Add one here, and bills, payment runs and the AP aging all start from it.",
      "searchPlaceholder": "Code, name or legal name",
      "searchLabel": "Search vendors",
      "filterByStatus": "Filter by status",
      "termsDays": "{days} days",
      "discountTerms": "{percent}% within {days} days",
      "delete": "Delete this vendor",
      "deleteHint": "Only possible while it has no documents. A vendor with history is blocked instead.",
      "deleted": "Vendor deleted",
      "deleteFailed": "This vendor could not be deleted",
      "statuses": {
        "active": "Active",
        "blocked": "Blocked"
      },
      "columns": {
        "code": "Code",
        "name": "Name",
        "currency": "Currency",
        "terms": "Terms",
        "taxRegistrationNo": "Tax registration"
      },
      "fields": {
        "code": "Code",
        "name": "Name",
        "legalName": "Legal name",
        "defaultCurrency": "Default currency",
        "paymentTerms": "Payment terms",
        "discountPercent": "Settlement discount",
        "discountDays": "Discount days",
        "taxGroup": "Tax group",
        "whtTaxCode": "Withholding tax code",
        "taxRegistrationNo": "Tax registration number",
        "email": "Email",
        "phone": "Phone",
        "address": "Address",
        "notes": "Notes"
      },
      "tabs": {
        "profile": "Profile",
        "bank": "Bank accounts",
        "documents": "Documents",
        "ledger": "Ledger and statement"
      },
      "tabsLabel": "Vendor sections",
      "rail": {
        "created": "Vendor added",
        "subtitle": "{status} · pays in {currency}",
        "documentsLink": "Documents from this vendor"
      },
      "form": {
        "createTitle": "New vendor",
        "editTitle": "Edit vendor",
        "description": "Bank details are added separately, and need a second person's approval.",
        "create": "Create vendor",
        "created": "Vendor created",
        "updated": "Vendor updated",
        "codeHint": "Short, permanent, and how people will look this vendor up.",
        "codeRequired": "A vendor needs a code.",
        "nameRequired": "A vendor needs a name.",
        "currencyHint": "The currency its invoices normally arrive in.",
        "currencyInvalid": "Use a three-letter ISO 4217 code, such as MVR.",
        "paymentTermsHint": "Days from the invoice date to the due date.",
        "discountHint": "Percentage off for settling within the discount days.",
        "whtHint": "Applied on this vendor's invoices, and withheld when they are paid.",
        "noTaxGroup": "No tax group",
        "noWht": "No withholding",
        "statusHint": "Blocking stops new documents. Posted ones are untouched.",
        "stale": "Somebody else saved this vendor while it was open. Close this, reopen it, and make the change again.",
        "bankElsewhere": "Bank details live on the vendor's own screen: adding or changing one is a request that a second person has to approve."
      },
      "export": {
        "done": "Export ready",
        "doneDetail": "{count} vendors were written to the file.",
        "failed": "The export did not finish"
      },
      "views": {
        "label": "Saved views",
        "trigger": "Views",
        "empty": "No saved views yet. Filter the list, then name what you see.",
        "saved": "View saved",
        "namePlaceholder": "Name this view",
        "nameLabel": "View name",
        "delete": "Delete the view {name}"
      }
    },
    "bank": {
      "title": "Bank accounts",
      "description": "Where this vendor is paid. Numbers are masked, and every change needs two people.",
      "loadFailed": "The bank accounts did not load",
      "noPermission": "You may not see this vendor's bank details.",
      "maskedExplainer": "Account numbers are shown masked. Revealing one in full is a separate action, and it is recorded against your name.",
      "emptyTitle": "No bank account on file",
      "emptyDescription": "Request one here. It starts paying only once somebody else has approved it.",
      "primary": "Primary",
      "inactive": "Retired",
      "fields": {
        "label": "Label",
        "bankName": "Bank",
        "branch": "Branch",
        "accountName": "Account name",
        "accountNo": "Account number",
        "iban": "IBAN",
        "swift": "SWIFT / BIC",
        "currency": "Currency"
      },
      "actions": {
        "reveal": "Reveal number",
        "requestNew": "Request a new account",
        "requestChange": "Request a change",
        "requestRetire": "Request retirement",
        "allChanges": "All bank-detail changes"
      },
      "pending": {
        "headline": "A change to these details is awaiting approval.",
        "explainer": "Nothing has changed yet: payments still go to the details shown below until somebody other than the requester approves it.",
        "requested": "Requested: {action} — {bank}, {masked}"
      },
      "pendingAdditions": {
        "title": "Requested accounts",
        "explainer": "This account does not exist yet and nothing is paid into it. It is waiting for a second person to approve it."
      },
      "changeStatuses": {
        "pending": "Awaiting approval",
        "applied": "Applied",
        "rejected": "Rejected",
        "cancelled": "Cancelled",
        "approved": "Approved, cooling off"
      },
      "changeActions": {
        "create": "add an account",
        "update": "change the details",
        "deactivate": "retire the account"
      },
      "stepUp": {
        "required": "Confirm your second factor again before this is allowed, then try once more.",
        "notEnrolled": "This action needs two-factor authentication, and your account has none enrolled yet.",
        "link": "Set it up in your profile"
      },
      "form": {
        "createTitle": "Request a new bank account",
        "updateTitle": "Request a change to these bank details",
        "subject": "For {vendor}",
        "submit": "Send request for approval",
        "working": "Sending the request",
        "dualApproval": "This creates a request, not a bank account. Nothing about where this vendor is paid changes until somebody other than you approves it.",
        "labelHint": "How people will recognise this account, e.g. \"BML current\".",
        "bankNameRequired": "Name the bank.",
        "accountNameHint": "The name the bank holds the account under, spelled as the bank spells it.",
        "accountNameRequired": "Name the account holder.",
        "accountNoHint": "Typed once here, encrypted immediately, and masked everywhere afterwards.",
        "accountNoRetype": "Type the account number again in full. There is no stored plaintext to prefill, and retyping it is what makes a change deliberate.",
        "accountNoRequired": "The account number is required.",
        "currencyInvalid": "Use a three-letter ISO 4217 code, such as MVR.",
        "primary": "Make this the account this vendor is paid into",
        "primaryHint": "Payment runs use the primary account unless one is chosen for them.",
        "reasonLabel": "Reason",
        "reasonHint": "Say who asked for this and how you confirmed it. The approver reads this, and so will an auditor.",
        "reasonRequired": "A reason is required.",
        "requested": "Request sent for approval",
        "requestedDetail": "Nothing has changed yet for {vendor}. A second person has to approve it first."
      },
      "reveal": {
        "title": "Reveal the account number",
        "subject": "{label} — {vendor}",
        "recorded": "This will be recorded in the audit log under your name, {name}, together with the reason you give below.",
        "reasonLabel": "Why do you need to see this number?",
        "reasonHint": "For example: confirming a payment the bank rejected. An auditor will read this.",
        "reasonRequired": "A reason is required before the number can be shown.",
        "confirm": "Reveal it",
        "working": "Revealing",
        "countdown": "This will disappear in {seconds} seconds. It is not copied or stored anywhere.",
        "hideNow": "Hide it now",
        "done": "Done"
      },
      "retire": {
        "title": "Request that this account be retired",
        "subject": "{label} — {vendor}",
        "consequence": "This creates a request. The account keeps working, and keeps being paid into, until somebody else approves the retirement.",
        "reasonHint": "Say why this account should stop being used.",
        "reasonRequired": "A reason is required.",
        "confirm": "Send request",
        "requested": "Request sent for approval",
        "requestedDetail": "The account is still active until a second person approves this."
      }
    },
    "bankChanges": {
      "title": "Vendor bank-detail changes",
      "description": "Who has asked to change where a vendor is paid, why, and what is still waiting.",
      "loadFailed": "The change requests did not load",
      "filterByStatus": "Filter by status",
      "empty": "Nothing is waiting. Every requested change has been decided.",
      "requestedAt": "Requested",
      "openVendor": "Open the vendor",
      "ownRequest": "You raised this request, so somebody else has to approve it.",
      "awaitingApprover": "Waiting for somebody with approval rights to decide.",
      "approveTitle": "Approve this change",
      "rejectTitle": "Reject this change",
      "decisionSubject": "Approving applies the change immediately.",
      "approveConsequence": "Once approved, this vendor is paid into these details. Confirm the request with the vendor on a number you already had — not one from the email that asked for the change.",
      "rejectConsequence": "The details stay as they are and the requester is told.",
      "commentLabel": "Comment",
      "commentHint": "What you checked, and how. This is kept with the decision.",
      "approved": "Change approved and applied",
      "approvedDetail": "The vendor is now paid into the new details.",
      "rejected": "Change rejected",
      "rejectedDetail": "Nothing about this vendor's bank details has changed."
    },
    "documents": {
      "titles": {
        "invoice": "Vendor invoices",
        "credit_note": "Vendor credit notes",
        "debit_note": "Vendor debit notes"
      },
      "descriptions": {
        "invoice": "Bills received from vendors, on their way from draft to paid.",
        "credit_note": "What vendors have credited back, netted against what they are owed.",
        "debit_note": "Amounts charged back to a vendor."
      },
      "newTitles": {
        "invoice": "New vendor invoice",
        "credit_note": "New credit note",
        "debit_note": "New debit note"
      },
      "emptyTitles": {
        "invoice": "No vendor invoices yet",
        "credit_note": "No credit notes yet",
        "debit_note": "No debit notes yet"
      },
      "emptyDescriptions": {
        "invoice": "Enter one here. It becomes a figure in the ledger once it is submitted, approved and posted.",
        "credit_note": "Raise one against a posted invoice, and it nets off in the next payment run.",
        "debit_note": "Raise one to charge an amount back to a vendor."
      },
      "filtersTitle": "Filters",
      "searchHint": "Matches the document number, the vendor's own number and the description.",
      "allCompanies": "Every legal entity",
      "allVendors": "Every vendor",
      "openOnly": "Only what is still owed",
      "from": "Invoice date from",
      "to": "Invoice date to",
      "draft": "Draft",
      "loadFailed": "The document list did not load",
      "tableLabel": "AP documents",
      "noPermission": "You may not see this vendor's documents.",
      "seeAll": "See every document from this vendor",
      "firstPageOnly": "Showing the most recent documents only — open the full list for the rest.",
      "vendorPanelTitle": "Documents",
      "vendorEmptyTitle": "Nothing from this vendor yet",
      "vendorEmptyDescription": "Invoices, credit notes and debit notes raised against this vendor appear here.",
      "vendorPlaceholder": "Type a vendor code or name",
      "noVendorMatch": "No vendor matches that.",
      "matchCount": "{count} vendors match",
      "vendorTerms": "Pays in {days} days",
      "whtHint": "Withheld when this document is paid, not when it is posted.",
      "statuses": {
        "draft": "Draft",
        "submitted": "Awaiting approval",
        "approved": "Approved",
        "rejected": "Rejected",
        "posted": "Posted",
        "paid": "Paid",
        "cancelled": "Cancelled",
        "reversed": "Reversed"
      },
      "kinds": {
        "invoice": "Invoice",
        "credit_note": "Credit note",
        "debit_note": "Debit note"
      },
      "columns": {
        "docNo": "Document no.",
        "vendorInvoiceNo": "Vendor's no.",
        "vendor": "Vendor",
        "kind": "Kind",
        "invoiceDate": "Invoice date",
        "dueDate": "Due",
        "currency": "Currency",
        "subtotal": "Net",
        "tax": "Tax",
        "total": "Total",
        "wht": "Withholding",
        "outstanding": "Outstanding",
        "fxRate": "Rate",
        "postedAt": "Posted",
        "hold": "Hold"
      },
      "fields": {
        "company": "Legal Entity",
        "companyPlaceholder": "Choose the legal entity this is billed to",
        "vendor": "Vendor",
        "vendorInvoiceNo": "Vendor's invoice number",
        "vendorInvoiceNoHint": "The number printed on the bill. Two documents cannot share one for the same vendor.",
        "invoiceDate": "Invoice date",
        "dueDate": "Due date",
        "dueDateHint": "Filled in from the vendor's payment terms. Change it if the bill says otherwise.",
        "currency": "Currency",
        "currencyHint": "The legal entity's base currency is {base}.",
        "description": "Description",
        "memo": "Memo",
        "originalInvoice": "Against invoice",
        "originalInvoiceHint": "The posted invoice this credit note relates to.",
        "originalInvoicePlaceholder": "Not against a particular invoice",
        "dueDateOverrideReason": "Due date override reason",
        "dueDateOverrideReasonHint": "The vendor's terms give {terms}. A different due date must say why.",
        "dueDateOverrideReasonHintBare": "Why this document's due date departs from the vendor's terms.",
        "purchaseOrder": "Purchase order",
        "purchaseOrderHint": "Optional. An open order of this vendor and legal entity, in this currency.",
        "purchaseOrderNeedsVendor": "Choose the vendor first",
        "purchaseOrderNone": "No open orders for this vendor",
        "purchaseOrderPlaceholder": "No purchase order"
      },
      "export": {
        "done": "Export ready",
        "doneDetail": "{count} documents were written to the file.",
        "failed": "The export did not finish"
      },
      "views": {
        "label": "Saved views",
        "trigger": "Views",
        "empty": "No saved views yet. Filter the list, then name what you see.",
        "saved": "View saved",
        "namePlaceholder": "Name this view",
        "nameLabel": "View name",
        "delete": "Delete the view {name}"
      },
      "poLineOption": "Line {no} · {description} · {quantity} × {price}",
      "poStatuses": {
        "draft": "Draft",
        "submitted": "Submitted",
        "approved": "Approved",
        "rejected": "Rejected",
        "issued": "Issued",
        "confirmed": "Confirmed",
        "partially_received": "Partly received",
        "received": "Received",
        "closed": "Closed",
        "cancelled": "Cancelled"
      }
    },
    "document": {
      "title": "{kind} {docNo}",
      "kindDescriptions": {
        "invoice": "A bill from a vendor: entered, approved, posted, then paid.",
        "credit_note": "A credit from a vendor. Amounts are positive; the kind carries the sign.",
        "debit_note": "An amount charged back to a vendor. Amounts are positive."
      },
      "headerTitle": "Document",
      "backToList": "Back to the list",
      "loadFailed": "This document did not load",
      "actionsLabel": "Document actions",
      "subtotalLabel": "Net total",
      "taxAtSubmit": "Tax and withholding are worked out when this is submitted.",
      "postingDate": "Posting date",
      "posting": "Posting",
      "submitting": "Submitting",
      "readyToSubmit": "Ready to submit.",
      "stale": "Somebody else saved this document while it was open. Reload their version, look at what changed, and apply your edits again — saving now would overwrite their work.",
      "reload": "Reload the saved version",
      "railSubtitle": "{status} · {vendor}",
      "locked": {
        "submitted": "This document is waiting for approval and cannot be edited. Reject it to send it back to draft.",
        "approved": "This document is approved and cannot be edited. It is waiting to be posted.",
        "posted": "A posted document is corrected with a credit note or a reversal, never edited.",
        "paid": "This document has been paid. Correct it with a credit note.",
        "cancelled": "This document was cancelled.",
        "reversed": "This document was reversed. Its mirror journal is in the ledger."
      },
      "blockers": {
        "noCompany": "Choose the legal entity this is billed to.",
        "noVendor": "Choose the vendor this bill came from.",
        "noVendorInvoiceNo": "Enter the vendor's own invoice number.",
        "noInvoiceDate": "Enter the invoice date.",
        "noCurrency": "Enter a three-letter currency code.",
        "noLines": "Add at least one line.",
        "lineIssues": "Some lines still need attention.",
        "zeroTotal": "The lines have to total more than zero."
      },
      "actions": {
        "save": "Save draft",
        "submit": "Submit for approval",
        "approve": "Approve",
        "reject": "Reject",
        "post": "Post to the ledger",
        "reverse": "Reverse",
        "discard": "Discard draft",
        "pdf": "PDF",
        "hold": "Place on hold",
        "releaseHold": "Release hold",
        "matchToPo": "Match to PO"
      },
      "pdfWorking": "Rendering",
      "pdfOpen": "Open the PDF",
      "pdfNotReady": "The PDF is still rendering. Try again in a moment.",
      "shortcuts": {
        "save": "Save the document"
      },
      "unsavedGuard": {
        "title": "Discard unsaved changes?",
        "message": "This document has changes that have not been saved. Leaving now discards them.",
        "confirm": "Discard changes",
        "cancel": "Keep editing"
      },
      "reject": {
        "title": "Reject this document",
        "description": "It goes back to draft so the mistake can be corrected.",
        "consequence": "Rejecting returns the document to draft. Nothing is deleted and nothing is posted.",
        "commentLabel": "Comment",
        "commentHint": "What is wrong with it. The person who raised it reads this."
      },
      "timeline": {
        "created": "Entered",
        "submitted": "Submitted as {docNo}",
        "approved": "Approved",
        "posted": "Posted to the ledger"
      },
      "links": {
        "journal": "The journal this posted",
        "original": "The invoice this is against",
        "reversedBy": "The document that reversed this",
        "vendor": "The vendor"
      },
      "toasts": {
        "saved": "Draft saved",
        "savedDetail": "Nothing is in the ledger yet: submit it, approve it, then post it.",
        "saveFailed": "The draft was not saved",
        "submitted": "Submitted as {docNo}",
        "submittedDetail": "The number, the tax and the exchange rate are now fixed.",
        "submitFailed": "This document was not submitted",
        "approved": "Approved",
        "approvedDetail": "It can be posted to the ledger now.",
        "rejected": "Rejected",
        "rejectedDetail": "It is back in draft and can be corrected.",
        "decideFailed": "The decision was not recorded",
        "posted": "Posted as {docNo}",
        "postedDetail": "The journal is in the ledger and the vendor's balance has moved.",
        "postFailed": "This document was not posted",
        "discarded": "Draft discarded",
        "discardedDetail": "Nothing was posted, so nothing was left behind.",
        "discardFailed": "The draft was not discarded"
      },
      "hold": {
        "badge": "On hold",
        "lead": "Payment is on hold. This document stays in ageing but cannot be paid until the hold is released.",
        "by": "Placed by user {id}",
        "placed": "Placed on payment hold",
        "released": "Payment hold released",
        "saveFirst": "Save or discard your changes first.",
        "holdTitle": "Place on payment hold",
        "holdDescription": "Payment proposals skip a held document and a payment run that still carries it cannot be executed.",
        "releaseTitle": "Release payment hold",
        "releaseDescription": "The document becomes payable again. The audit trail records who placed the hold and who released it.",
        "currentReason": "Held because: {reason}",
        "reason": "Reason",
        "reasonHint": "Required. Recorded in the audit trail."
      },
      "attachments": {
        "requirement": "A supporting document must be attached before this document is submitted or posted. Your legal entity may exempt documents at or below a set amount.",
        "saveFirst": "Save the document first to attach its supporting documents."
      }
    },
    "lines": {
      "title": "Lines",
      "caption": "Document lines: account, description, quantity, unit price and amount.",
      "subtotal": "Net total",
      "computed": "quantity × price",
      "noTaxCode": "No tax code",
      "keyboardHint": "Enter for the next row, Alt+↓ to duplicate, Alt+Backspace to remove.",
      "columns": {
        "no": "#",
        "account": "Account",
        "description": "Description",
        "dimensions": "Dimensions",
        "taxCode": "Tax code",
        "quantity": "Qty",
        "unitPrice": "Unit price",
        "amount": "Amount",
        "tax": "Tax",
        "rowActions": "Row actions",
        "poLine": "PO line"
      },
      "actions": {
        "add": "Add a line",
        "duplicate": "Duplicate this line",
        "remove": "Remove this line"
      },
      "aria": {
        "account": "Account, line {line}",
        "description": "Description, line {line}",
        "taxCode": "Tax code, line {line}",
        "quantity": "Quantity, line {line}",
        "unitPrice": "Unit price, line {line}",
        "lineAmount": "Amount, line {line}",
        "duplicate": "Duplicate line {line}",
        "remove": "Remove line {line}",
        "poLine": "Purchase order line for line {line}"
      },
      "issues": {
        "invalidQuantity": "That is not a number.",
        "invalidPrice": "That is not a number.",
        "invalidAmount": "That is not an amount.",
        "negativeAmount": "Amounts are positive on every kind of document; the kind carries the sign.",
        "zeroAmount": "A line has to be worth more than nothing.",
        "noAccount": "Choose the account this line is charged to.",
        "notPostable": "Account {account} is a heading, not a postable account.",
        "inactive": "Account {account} is inactive.",
        "requiresCostCenter": "Account {account} needs a cost centre.",
        "requiresProfitCenter": "Account {account} needs a profit centre.",
        "requiresBranch": "Account {account} needs a branch.",
        "requiresDepartment": "Account {account} needs a department.",
        "requiresProject": "Account {account} needs a project."
      },
      "noPoLine": "No PO line"
    },
    "reverse": {
      "title": "Reverse this document",
      "subject": "{docNo} — {vendor}",
      "consequence": "Nothing is deleted. The mirror journal is written, the original stays in the ledger marked reversed, and both point at each other.",
      "settled": "This document has been paid, in whole or in part. Unwind the payment first — it cannot be reversed while a settlement stands against it.",
      "dateLabel": "Reversal date",
      "dateHint": "The mirror journal posts on this date, so its period has to be open.",
      "reasonLabel": "Reason",
      "reasonHint": "Why this is being reversed. It stays with both documents.",
      "reasonRequired": "A reason is required.",
      "confirm": "Reverse it",
      "working": "Reversing",
      "doneTitle": "Reversed",
      "doneDetail": "The mirror document {docNo} is in the ledger."
    },
    "runs": {
      "title": "Payment runs",
      "description": "What is being paid, to whom, and out of which bank account.",
      "oneTitle": "Payment run",
      "oneDescription": "A plan until it is executed: the proposal, its approval, and the file the bank receives.",
      "draftTitle": "Unnumbered run",
      "backToList": "Back to payment runs",
      "loadFailed": "The payment run did not load",
      "emptyTitle": "No payment runs yet",
      "emptyDescription": "Propose one and the outstanding bills due by your cutoff are gathered for approval.",
      "filterByStatus": "Filter by status",
      "summaryTitle": "The run",
      "paymentsTitle": "Payments",
      "paymentsCaption": "One row per vendor, with the documents each payment settles.",
      "noPayments": "This run has no payments.",
      "remittance": "Remittance advice",
      "remittanceWorking": "Rendering",
      "remittanceOpen": "Open the last remittance advice",
      "remittanceNotReady": "The remittance advice is still rendering. Try again in a moment.",
      "noBankAccount": "No bank account on file",
      "totalLabel": "Total",
      "paymentCount": "{count} vendors",
      "actionsLabel": "Payment run actions",
      "executedAt": "Executed",
      "propose": "Propose a payment run",
      "proposing": "Proposing",
      "created": "Payment run proposed",
      "createdDetail": "Nothing has been paid. It is waiting for approval.",
      "createTitle": "Propose a payment run",
      "createDescription": "Gathers what is outstanding and submits it for approval. No money moves.",
      "proposalNote": "This proposes a run and submits it for approval. Nothing is posted, nothing is settled, and no money moves until somebody executes it.",
      "planNote": "This run is a plan. Nothing has been posted or settled yet.",
      "statuses": {
        "draft": "Draft",
        "submitted": "Awaiting approval",
        "approved": "Approved",
        "rejected": "Rejected",
        "executed": "Executed",
        "cancelled": "Cancelled"
      },
      "methods": {
        "bank_transfer": "Bank transfer",
        "cheque": "Cheque",
        "cash": "Cash"
      },
      "columns": {
        "runNo": "Run no.",
        "paymentDate": "Payment date",
        "method": "Method",
        "vendor": "Vendor",
        "bankAccount": "Paid into",
        "documents": "Settles",
        "gross": "Gross",
        "wht": "Withheld",
        "discount": "Discount",
        "net": "Net paid",
        "reference": "Reference",
        "remittance": "Remittance advice"
      },
      "fields": {
        "company": "Legal Entity",
        "paymentDate": "Payment date",
        "paymentDateHint": "The date the journal posts on, so its period has to be open.",
        "currency": "Currency",
        "currencyHint": "A run pays one currency. Documents in others are not picked up.",
        "method": "Method",
        "bankAccount": "Bank account",
        "bankAccountHint": "The ledger account this run is credited to.",
        "bankAccountPlaceholder": "Choose the account the money leaves",
        "bankFileProfile": "Bank file layout",
        "bankFileProfileHint": "Which layout the bank file is rendered with. Editable data, not code.",
        "bankFileProfilePlaceholder": "Decide later",
        "dueOnOrBefore": "Due on or before",
        "dueOnOrBeforeHint": "The cutoff. Leave it empty to propose everything outstanding.",
        "reference": "Reference",
        "memo": "Memo",
        "takeDiscounts": "Take settlement discounts where they are still available",
        "takeDiscountsHint": "Pays a document net of the discount its vendor terms offer, while the discount window is open.",
        "vendors": "Limit to particular vendors",
        "vendorsHint": "Leave everything unticked to propose every vendor with something outstanding.",
        "vendorSearch": "Search vendors",
        "allVendors": "Every vendor with something outstanding.",
        "vendorsChosen": "{count} vendors chosen."
      },
      "execute": {
        "title": "Execute this payment run",
        "subject": "{runNo}",
        "headline": "This is the step that pays.",
        "consequence": "It settles every document in the run, posts the journal — the payables account debited, the bank credited, withholding and settlement discounts recognised — and cannot be undone by editing. Correcting it afterwards means reversing the journal.",
        "referenceLabel": "Bank reference",
        "referenceHint": "What the bank will show against this transfer, if you already know it.",
        "confirm": "Execute the run",
        "working": "Executing"
      },
      "reject": {
        "title": "Reject this payment run",
        "description": "Nothing is paid and the run is closed.",
        "commentHint": "Why this run should not go ahead."
      },
      "timeline": {
        "created": "Proposed",
        "submitted": "Submitted for approval",
        "approved": "Approved",
        "executed": "Executed"
      },
      "links": {
        "journal": "The journal this posted"
      },
      "railSubtitle": "{status} · paying {date}",
      "actions": {
        "execute": "Execute the run",
        "bankFile": "Bank file"
      },
      "toasts": {
        "approved": "Payment run approved",
        "approvedDetail": "It can be executed now. Nothing has been paid yet.",
        "rejected": "Payment run rejected",
        "rejectedDetail": "Nothing was paid.",
        "decideFailed": "The decision was not recorded",
        "executed": "Executed as {runNo}",
        "executedDetail": "The journal is posted and the documents are settled.",
        "executeFailed": "This run was not executed",
        "remittanceFailed": "The remittance advice was not produced"
      },
      "sod": {
        "preparer": "You prepared this run, so somebody else must approve it.",
        "noTask": "There is nothing for you to approve on this run: you prepared it, you have already approved your step, or it is waiting on somebody else.",
        "approvedByYou": "You approved this run, so somebody else must execute it."
      },
      "errors": {
        "sodApprove": "The person who prepared a payment run may not approve it. Somebody else must approve it.",
        "sodExecute": "Somebody who took part in approving a payment run may not release it. Ask a colleague who had no part in approving it to execute the run.",
        "unresolvable": "No approver other than the person who prepared this run is configured, so it cannot be approved. Void it, and ask an administrator to set up an approval policy for payment runs."
      },
      "void": {
        "action": "Void",
        "title": "Void this payment run",
        "description": "Nothing has been paid. The run is closed and its documents become payable again.",
        "consequence": "Every document this run proposed goes back to waiting for payment and can be picked up by the next run. An executed run cannot be voided here: raise a payment exception instead.",
        "reasonLabel": "Reason",
        "reasonHint": "Recorded on the run's audit trail.",
        "reasonRequired": "Give the reason this run is being voided.",
        "confirm": "Void the run",
        "done": "Payment run voided",
        "doneDetail": "Nothing was paid. Its documents are payable again.",
        "failed": "The run was not voided"
      },
      "anomalies": {
        "title": "{count} anomaly flags to read before approving",
        "description": "Raised by fixed rules over each payment. They do not stop the run; they are what an approver should check first.",
        "none": "No anomaly flags on this run.",
        "codes": {
          "new_bank_account_cooling_off": "New bank account, still cooling off",
          "round_amount": "Round amount",
          "first_payment_to_vendor": "First payment to this vendor",
          "above_vendor_average": "More than {multiple} times the vendor's average"
        }
      },
      "funds": {
        "shortTitle": "Not enough in the paying account",
        "shortBody": "Executing it as it stands would overdraw the account. Fund the account, or take payments out of the run, before it is approved.",
        "balance": "Balance",
        "covered": "The paying account covers this run. Balance:",
        "unknown": "The paying account's balance could not be checked"
      }
    },
    "bankFile": {
      "title": "Bank file",
      "subject": "For payment run {runNo}",
      "notVerified": "This layout is not a verified statutory format.",
      "editable": "The column mapping of \"{profile}\" is editable data, not code: check it against the specification your bank gave you and correct the layout if it differs. No release is needed.",
      "plaintext": "This file contains beneficiary account numbers in full. Producing it is recorded against your name. Handle it like the payment instruction it is.",
      "profile": "Layout",
      "filename": "File name",
      "rows": "Rows",
      "sha256": "SHA-256",
      "previewLabel": "The first lines, exactly as the bank will read them:",
      "previewTruncated": "Only the first lines are shown. Download the file for the rest.",
      "download": "Download the file",
      "downloaded": "File downloaded",
      "retry": "Try again",
      "working": "Rendering the file"
    },
    "reports": {
      "company": "Legal Entity",
      "companyPlaceholder": "Choose a legal entity",
      "from": "From",
      "to": "To"
    },
    "aging": {
      "title": "AP aging",
      "description": "What is owed, and how overdue it is, per vendor.",
      "noPermission": "You may not see the AP reports.",
      "loadFailed": "The aging schedule did not load",
      "caption": "Amounts owed per vendor, in bands of days past due.",
      "asOf": "As at",
      "asOfHint": "Days past due are measured from this date. Today, if left empty.",
      "currencyFilter": "Document currency",
      "currencyHint": "Narrows to documents raised in one currency. Amounts stay in the legal entity's base currency.",
      "header": "As at {date}, in {currency}",
      "tiesTo": "Converted at each document's own posted rate, so the grand total ties to the payables control account.",
      "empty": "Nothing is outstanding.",
      "drillHint": "A vendor's name opens their ledger and statement, where each document carries the days past due that put it in a band. A row total opens what they are still owed.",
      "columns": {
        "vendor": "Vendor",
        "total": "Total"
      }
    },
    "ledger": {
      "title": "Ledger and statement",
      "description": "Every movement with a running balance, and what is still open.",
      "noPermission": "You may not see the AP reports.",
      "loadFailed": "The vendor ledger did not load",
      "caption": "Movements on {vendor}'s account, oldest first.",
      "tabsLabel": "Ledger or statement",
      "tabs": {
        "ledger": "Ledger",
        "statement": "Statement"
      },
      "fromHint": "Three months back, if left empty.",
      "window": "{from} to {to}",
      "opening": "Opening balance",
      "closing": "Closing balance",
      "empty": "Nothing moved in this window.",
      "unnumbered": "Unnumbered",
      "viewJournal": "Journal",
      "columns": {
        "date": "Date",
        "document": "Document",
        "description": "Description",
        "debit": "Debit",
        "credit": "Credit",
        "balance": "Balance",
        "journal": "Posted by"
      }
    },
    "statement": {
      "loadFailed": "The statement did not load",
      "caption": "Documents of {vendor} that are still open.",
      "asOf": "Open documents as at {date}",
      "empty": "Nothing is open.",
      "totalFor": "Total in {currency}",
      "columns": {
        "document": "Document",
        "date": "Date",
        "dueDate": "Due",
        "currency": "Currency",
        "total": "Total",
        "paid": "Paid",
        "outstanding": "Outstanding",
        "daysPastDue": "Days late"
      }
    },
    "routeTitles": {
      "signals": "AP signals",
      "paymentExceptions": "Payment exceptions",
      "supplierStatement": "Supplier statement",
      "statementReconciliation": "Statement reconciliation",
      "withholding": "Withholding tax register",
      "duplicatePayments": "Duplicate payment analysis",
      "settings": "AP settings"
    },
    "coolingOff": {
      "requested": "Change requested",
      "approved": "Approved",
      "effective": "Payable from",
      "applied": "Applied to the vendor",
      "releasedEarly": "Cooling-off cut short",
      "releasedMeta": "{at} — {reason}",
      "notYet": "Not yet",
      "waiting": "{at} — {hours} hour(s) to go",
      "window": "{hours}-hour window",
      "activeBanner": "This account cannot be paid for another {hours} hour(s). A payment run naming {account} will be refused until then.",
      "release": "Release early",
      "releaseTitle": "Cut the cooling-off short",
      "releaseDescription": "The account becomes payable immediately.",
      "releaseWarning": "The cooling-off window is what gives a real vendor time to notice a fraudulent change. Releasing it early is recorded against your name, and you may not do it to a change you approved yourself.",
      "reason": "Reason",
      "released": "Cooling-off released",
      "releaseFailed": "The cooling-off could not be released"
    },
    "signals": {
      "title": "AP signals",
      "description": "Eleven deterministic checks over every submitted invoice. Not a score — each one is a statement anybody can verify.",
      "loadFailed": "Signals could not be loaded",
      "tabInbox": "Inbox",
      "tabSettings": "Settings",
      "tabsLabel": "Signal views",
      "signal": "Signal",
      "severity": "Severity",
      "enabled": "On",
      "invoice": "Invoice",
      "related": "Related",
      "detectedAt": "Detected",
      "anySignal": "Any signal",
      "anyStatus": "Any status",
      "blockingBanner": "{count} blocking signal(s) are open. Each one holds an invoice out of the payment run until it is disposed of.",
      "tableLabel": "AP invoice signals",
      "emptyTitle": "Nothing flagged",
      "emptyDescription": "Signals are raised at submit. An empty inbox means every submitted invoice looked ordinary.",
      "dispose": "Dispose",
      "disposeTitle": "Dispose of a signal",
      "disposeHint": "A signal was either a false positive or it was real. Saying which is what makes a month of them countable.",
      "disposition": "Outcome",
      "dispositions": {
        "cleared": "False positive",
        "confirmed": "Confirmed — it is real"
      },
      "clearedHint": "The invoice proceeds.",
      "confirmedHint": "The invoice stays blocked and the finding is on the record.",
      "reason": "Reason",
      "disposed": "Signal disposed of",
      "disposeFailed": "The signal could not be disposed of",
      "statuses": {
        "open": "Open",
        "cleared": "Cleared",
        "confirmed": "Confirmed"
      },
      "severities": {
        "info": "Note",
        "warn": "Warn",
        "block": "Blocks"
      },
      "settingsTitle": "Which signals run, and how loudly",
      "settingsDescription": "All eleven, including the ones that have never fired — which is exactly the one somebody wants to switch on.",
      "settingsSaved": "Signal settings saved",
      "settingsSaveFailed": "The signal settings could not be saved",
      "chooseCompanyTitle": "Choose a legal entity",
      "chooseCompanyDescription": "Signal settings are per legal entity.",
      "codes": {
        "duplicate_exact": "Exact duplicate",
        "near_duplicate_number": "Near-duplicate number",
        "duplicate_amount_date": "Same amount, same date",
        "round_sum": "Suspiciously round sum",
        "fresh_vendor": "Brand-new vendor",
        "bank_change_recent": "Bank details changed recently",
        "just_below_threshold": "Just below an approval threshold",
        "non_business_day_entry": "Entered on a non-business day",
        "sequential_numbering": "Sequential invoice numbers",
        "no_po_over_threshold": "No purchase order, over threshold",
        "tax_without_registration": "Tax charged without a registration"
      },
      "explain": {
        "duplicate_exact": "Same vendor and same invoice number as one already on file.",
        "near_duplicate_number": "An invoice number one character from an existing one.",
        "duplicate_amount_date": "Same vendor, same amount, same date as another invoice.",
        "round_sum": "An amount with no cents and no odd digits, which real billing rarely produces.",
        "fresh_vendor": "The vendor was created days ago and is already being paid.",
        "bank_change_recent": "The vendor's paying account changed shortly before this invoice.",
        "just_below_threshold": "An amount that sits just under the approval band it would otherwise cross.",
        "non_business_day_entry": "Entered on a day the business calendar says was closed.",
        "sequential_numbering": "This vendor's invoice numbers run consecutively to us, which suggests we are their only customer.",
        "no_po_over_threshold": "Above the value where a purchase order is required, with none.",
        "tax_without_registration": "Tax charged by a vendor with no tax registration on file."
      },
      "stale": "Somebody else saved these signal settings while you had them open. Nothing was overwritten — reload the saved settings, then apply your edits again.",
      "reload": "Reload the saved settings"
    },
    "exceptions": {
      "title": "Payment exceptions",
      "description": "A payment that came back, was pulled back, or never left. Each kind posts differently.",
      "loadFailed": "Payment exceptions could not be loaded",
      "raisedOn": "Raised",
      "kind": "Kind",
      "kindHint": "Pick the one that describes what actually happened — the posting follows from it.",
      "payment": "Payment",
      "amount": "Amount",
      "reason": "Reason",
      "bankReasonCode": "Bank's reason code",
      "bankReasonHint": "Whatever the bank returned, verbatim. It is what a bank dispute is argued from.",
      "bankSaid": "bank: {code}",
      "reference": "Reference",
      "journal": "Journal",
      "nothingPosted": "Nothing posted",
      "anyStatus": "Any status",
      "note": "Note",
      "tableLabel": "AP payment exceptions",
      "emptyTitle": "No payment exceptions",
      "emptyDescription": "Every payment settled. Raise one here when a bank returns funds or an instruction has to be stopped.",
      "raise": "Raise an exception",
      "raiseTitle": "Raise a payment exception",
      "raiseDescription": "This changes what a vendor is owed, so it needs a second factor.",
      "raised": "Payment exception raised",
      "raiseFailed": "The payment exception could not be raised",
      "resolve": "Resolve",
      "resolveTitle": "Resolve a payment exception",
      "resolved": "Payment exception resolved",
      "resolveFailed": "The payment exception could not be resolved",
      "kinds": {
        "returned": "Returned",
        "recalled": "Recalled",
        "rejected": "Rejected",
        "stopped": "Stopped",
        "restored": "Restored"
      },
      "posting": {
        "returned": "The bank sent the money back after settlement. The payable is restored exactly.",
        "recalled": "We asked for it back and the bank agreed. The payable is restored exactly.",
        "rejected": "The bank refused the instruction before value date. The payable is restored.",
        "stopped": "The instruction was pulled before it left. Nothing posts — no money moved.",
        "restored": "The correction that closes an earlier exception."
      },
      "statuses": {
        "open": "Open",
        "resolved": "Resolved",
        "cancelled": "Cancelled"
      }
    },
    "reportsFt10": {
      "export": "Export CSV",
      "rangeInvalid": "The start date is after the end date.",
      "chooseCompanyTitle": "Choose a legal entity"
    },
    "supplierStatement": {
      "title": "Supplier statement",
      "description": "One supplier's documents with what was invoiced, paid and is still outstanding, as at a date.",
      "toReconciliation": "Reconcile a supplier's statement",
      "fromHint": "Documents dated on or after this day. Everything, if left empty.",
      "asOf": "As at",
      "asOfHint": "Today, if left empty.",
      "openOnly": "Open items only",
      "openOnlyHint": "Leave out documents that are fully settled.",
      "tableTitle": "Statement",
      "chooseTitle": "Choose a supplier",
      "chooseDescription": "Pick the legal entity and the supplier above to see their statement: every document, what has been paid against it and what is still owed.",
      "emptyTitle": "Nothing on this statement",
      "emptyOpenTitle": "Nothing is open for this supplier",
      "emptyDescription": "No posted documents fall in this range. Widen the dates, or check the supplier's documents under Supplier invoices.",
      "header": "{vendor}, as at {date}"
    },
    "duplicatePayments": {
      "title": "Duplicate payment analysis",
      "description": "Payments that look like the same money paid twice, with the reason each was suspected, and the duplicates that were stopped.",
      "toExceptions": "Payment exceptions",
      "toHint": "Today, if left empty.",
      "window": "Matching window (days)",
      "windowHint": "Same-amount payments to one vendor this many days apart are compared. From {min} to {max}; 7 if left empty.",
      "windowInvalid": "Enter a whole number of days from {min} to {max}, or leave it empty for the default.",
      "chooseDescription": "Pick the legal entity above to analyse its executed payments for duplicates.",
      "loadFailed": "The duplicate payment analysis did not load",
      "scope": "{from} to {to}, payments within {days} days of each other: {suspected} suspected, {prevented} prevented.",
      "suspectedTitle": "Suspected duplicates ({count})",
      "suspectedDescription": "Executed payments to one vendor, in one currency, for one net amount, dated within the window or sharing a reference. Exposure is what would be lost if all but one were duplicates.",
      "suspectedEmptyTitle": "No suspected duplicates",
      "suspectedEmptyDescription": "No two executed payments in this range look like the same money paid twice. A wider window compares payments further apart.",
      "suspectedCaption": "Groups of payments suspected of being duplicates, with the reason.",
      "preventedTitle": "Prevented duplicates ({count})",
      "preventedDescription": "Payment exceptions raised because a payment duplicated another.",
      "preventedEmptyTitle": "No prevented duplicates",
      "preventedEmptyDescription": "When a duplicate payment is caught, raise a payment exception with the reason 'duplicate payment' and it is counted here.",
      "preventedCaption": "Payment exceptions raised for duplicate payments.",
      "columns": {
        "reason": "Detected because",
        "payments": "Payments",
        "exposure": "Exposure"
      },
      "reasons": {
        "same_reference": "Same reference",
        "same_amount_within_window": "Same amount within {days} days"
      }
    },
    "withholding": {
      "title": "Withholding tax register",
      "description": "Tax withheld from suppliers, by period and authority, and whether it has been paid over.",
      "noPermission": "You may not see the withholding tax register.",
      "authorityHint": "The authority's code, such as MIRA. Every authority, if left empty.",
      "filterByState": "Filter by remittance state",
      "states": {
        "unremitted": "Not remitted",
        "draft": "In a draft remittance",
        "remitted": "Remitted"
      },
      "chooseDescription": "Pick the legal entity above to see the tax it has withheld and what has been remitted.",
      "registerTitle": "Withheld",
      "selection": "{count} selected for {authority}",
      "clearSelection": "Clear",
      "draftRemittance": "Draft a remittance",
      "loadFailed": "The withholding register did not load",
      "emptyTitle": "Nothing withheld in this range",
      "emptyDescription": "Withholding is recorded when a payment run that deducts it is executed. Widen the dates or clear the filters.",
      "header": "{from} to {to}; base-currency amounts in {currency}",
      "caption": "Withholding deducted from supplier payments, with its remittance state.",
      "totalsCaption": "Withholding by authority: withheld, remitted, in a draft and outstanding.",
      "oneAuthority": "A remittance pays one authority. Clear the selection to choose another.",
      "selectRow": "Select {invoice}",
      "selectAuthority": "Select everything not remitted",
      "termsMissing": "No rate on file",
      "termsMissingHint": "This record predates the rate being stored with it; the amount is what was withheld.",
      "exportFailed": "The register was not exported",
      "columns": {
        "select": "Select",
        "withheldOn": "Withheld on",
        "period": "Period",
        "invoice": "Invoice",
        "code": "Code and rate",
        "authority": "Authority",
        "base": "Base",
        "withheld": "Withheld",
        "withheldBase": "Withheld ({currency})",
        "state": "Remittance",
        "records": "Records",
        "remitted": "Remitted",
        "inDraft": "In a draft",
        "outstanding": "Outstanding"
      },
      "create": {
        "title": "Draft a remittance to {authority}",
        "description": "Nothing is posted. Somebody other than you posts it, which pays the authority from the bank.",
        "selection": "{count} withholding records selected.",
        "preview": "Selected, in the base currency:",
        "previewNote": "A preview. The server records the amount from each record's posted share, and that is what posts.",
        "period": "Period",
        "periodHint": "The month being remitted, as YYYY-MM. Every record must have been withheld by its end.",
        "periodInvalid": "Enter the month as YYYY-MM, such as 2026-08.",
        "bankAccount": "Pay from",
        "bankAccountHint": "An active bank account in {currency}.",
        "noBankRead": "You cannot list bank accounts. Ask for read access to cash and bank accounts.",
        "bankAccountPlaceholder": "Choose the account the payment leaves",
        "bankRequired": "Choose the bank account the remittance is paid from.",
        "remittanceDate": "Remittance date",
        "remittanceDateHint": "The day the authority is paid. Not before any record was withheld.",
        "dateRequired": "Enter the date.",
        "reference": "Reference",
        "memo": "Memo",
        "confirm": "Draft the remittance",
        "done": "Remittance {number} drafted",
        "doneDetail": "Nothing is posted until somebody else posts it."
      },
      "remittances": {
        "title": "Remittances",
        "description": "Drafted by one person, posted by another. Posting pays the authority from the bank; a reversal puts it back.",
        "filterByStatus": "Filter by status",
        "loadFailed": "The remittances did not load",
        "emptyTitle": "No remittances yet",
        "emptyDescription": "Select the records an authority is owed in the register above and draft a remittance.",
        "draftNo": "Draft #{id}",
        "viewJournal": "Journal",
        "statuses": {
          "draft": "Draft",
          "posted": "Posted",
          "cancelled": "Cancelled",
          "reversed": "Reversed"
        },
        "columns": {
          "number": "Remittance",
          "date": "Date",
          "items": "Records",
          "amount": "Amount",
          "journal": "Journal",
          "actions": "Actions"
        },
        "post": "Post",
        "cancel": "Cancel draft",
        "reverse": "Reverse",
        "postTitle": "Post this remittance",
        "cancelTitle": "Cancel this draft",
        "reverseTitle": "Reverse this remittance",
        "postConsequence": "Posting debits withholding tax payable and credits the bank: the authority is paid. It needs a second factor.",
        "cancelConsequence": "The draft is closed and its records can be remitted by another draft. Nothing was posted.",
        "reverseConsequence": "A mirror journal puts the money back on the bank and the liability back on withholding tax payable. It needs a second factor.",
        "referenceHint": "The authority's receipt or the bank reference, if known.",
        "reason": "Reason",
        "reasonRequired": "Give the reason.",
        "reversalDate": "Reversal date",
        "reversalDateHint": "Today, if left empty.",
        "postConfirm": "Post the remittance",
        "cancelConfirm": "Cancel the draft",
        "reverseConfirm": "Reverse the remittance",
        "posted": "Remittance posted",
        "postedDetail": "The authority is paid and the records are remitted.",
        "cancelled": "Draft cancelled",
        "cancelledDetail": "Its records can be remitted again.",
        "reversed": "Remittance reversed",
        "reversedDetail": "Its records are owed to the authority again.",
        "preparedByYou": "You prepared this remittance, so somebody else must post it.",
        "postedByYou": "You posted this remittance, so somebody else must reverse it."
      },
      "errors": {
        "sodPost": "A remittance must be posted by somebody other than the person who prepared it.",
        "sodReverse": "A remittance must be reversed by somebody other than the person who posted it.",
        "alreadyRemitted": "One of these records has already been remitted by another remittance. Refresh the register and draft again."
      }
    },
    "statementRecon": {
      "title": "Statement reconciliation",
      "description": "What a supplier says we owe them, against our ledger as at the statement date, with every difference itemised.",
      "toStatement": "Supplier statement",
      "vendorHint": "Every supplier, if left empty.",
      "dateRangeHint": "Narrows the list by statement date.",
      "chooseDescription": "Pick the legal entity above to see the supplier statements recorded for it, or to record one.",
      "loadFailed": "The supplier statements did not load",
      "listTitle": "Recorded supplier statements",
      "emptyTitle": "No supplier statements recorded yet",
      "emptyDescription": "Record a statement a supplier sent — line by line, or the CSV file itself — and it is reconciled against our ledger at once.",
      "emptyDescriptionReadOnly": "Recorded statements appear here. Recording one needs the statement reconciliation permission.",
      "pickHint": "Choose a statement to reconcile it.",
      "reconcile": "Reconcile",
      "sources": {
        "json": "Entered",
        "csv": "CSV file"
      },
      "kinds": {
        "invoice": "Invoice",
        "credit_note": "Credit note",
        "debit_note": "Debit note",
        "payment": "Payment",
        "other": "Other"
      },
      "bases": {
        "reference_and_amount": "Reference and amount",
        "amount_and_date": "Amount and date"
      },
      "columns": {
        "statementDate": "Statement date",
        "statementRef": "Statement no.",
        "lines": "Lines",
        "reportedBalance": "Supplier's balance",
        "source": "Source",
        "date": "Date",
        "reference": "Reference",
        "description": "Description",
        "kind": "Kind",
        "amount": "Amount",
        "ourDocument": "Our document",
        "supplierAmount": "Supplier's amount",
        "ourAmount": "Our amount",
        "difference": "Difference",
        "basis": "Matched on",
        "settlementDifference": "Settlement difference"
      },
      "record": {
        "action": "Record a statement",
        "title": "Record a supplier statement",
        "description": "What the supplier says we owe them. Nothing is posted; a recorded statement is never edited.",
        "modeLabel": "How to enter the statement",
        "modeLines": "Enter lines",
        "modeCsv": "Upload CSV",
        "currency": "Currency",
        "currencyHint": "The currency the supplier states in.",
        "statementDate": "Statement date",
        "statementDateHint": "The date the supplier's balance is struck at.",
        "reportedBalance": "Supplier's balance",
        "reportedBalanceHint": "What they say we owe them at that date. Positive means we owe them.",
        "periodFrom": "Lines cover from",
        "periodFromHint": "Leave empty if the statement lists everything.",
        "openingBalance": "Opening balance",
        "openingBalanceHint": "What they say we owed them before that day. Zero, if left empty.",
        "statementRef": "Statement no.",
        "notes": "Notes",
        "linesCaption": "The lines on the supplier's statement.",
        "removeLine": "Remove",
        "removeLineN": "Remove line {line}",
        "lineDate": "Date of line {line}",
        "lineReference": "Reference of line {line}",
        "lineDescription": "Description of line {line}",
        "lineKind": "Kind of line {line}",
        "lineAmount": "Amount of line {line}",
        "linesTotal": "Lines total",
        "addLine": "Add a line",
        "signHint": "Amounts are signed: an invoice increases what we owe the supplier, a payment or credit note reduces it (enter it negative).",
        "file": "Statement file",
        "fileHint": "A CSV with a header row: date (YYYY-MM-DD) and amount are required; reference, description and kind are optional. A file with any bad row records nothing.",
        "lineErrorsTitle": "{count} lines were refused. Nothing was recorded.",
        "confirm": "Record the statement",
        "confirmCsv": "Upload and record",
        "duplicate": "This statement is already recorded for this supplier, currency and date. Give the supplier's statement number to record a second one for the same date.",
        "vendorRequired": "Choose the supplier.",
        "currencyInvalid": "Enter a three-letter currency code, such as MVR.",
        "dateRequired": "Enter the date.",
        "periodFromAfter": "This cannot be after the statement date.",
        "moneyInvalid": "Enter an amount such as 1250.00 or -300.00.",
        "lineAmountInvalid": "Enter a non-zero amount, such as 1250.00 or -300.00.",
        "fileRequired": "Choose the CSV file.",
        "done": "Statement recorded",
        "doneDetail": "{count} lines recorded. Its reconciliation is below."
      },
      "recon": {
        "title": "Reconciliation",
        "subtitle": "{vendor}, as at {date}, in {currency}",
        "loadFailed": "The reconciliation did not load",
        "supplierBalance": "Supplier says we owe",
        "ledgerBalance": "Our ledger says we owe",
        "difference": "Difference",
        "periodFrom": "Lines cover from",
        "identityCaption": "The difference, itemised.",
        "terms": {
          "opening": "Opening balances differ by",
          "supplierOnly": "Lines only the supplier lists",
          "oursOnly": "Items only in our ledger",
          "amountDifferences": "Same reference, different amount",
          "settlementDifferences": "Settlement differences on matched payments",
          "unexplained": "Unexplained by the supplier's own lines"
        },
        "termsSum": "Accounted for",
        "identityHolds": "The items above account for the whole difference.",
        "identityBroken": "The items above add up to {sum}, not the difference of {difference}. Report this: the reconciliation should always account for the whole difference.",
        "fullyMatched": "Every line on the statement matches an item in our ledger.",
        "supplierOnlyTitle": "Only on the supplier's statement",
        "supplierOnlyEmpty": "Every supplier line matches something of ours.",
        "oursOnlyTitle": "Only in our ledger",
        "oursOnlyEmpty": "Every item of ours appears on the statement.",
        "amountDifferencesTitle": "Same reference, different amount",
        "amountDifferencesEmpty": "No line shares a reference with ours at a different amount.",
        "matchedTitle": "Matched",
        "matchedEmptyTitle": "Nothing matched",
        "matchedEmptyDescription": "No supplier line matched an item of ours by reference, or by amount within a few days. Check the statement is for this legal entity and currency.",
        "settlementTotal": "Settlement differences"
      }
    },
    "settings": {
      "attachmentsTitle": "Supporting documents",
      "attachmentsDescription": "Every AP document needs a supporting attachment before it is submitted or posted. A legal entity may relax that for documents at or below an amount.",
      "fields": {
        "attachmentAbove": "Attachment required above",
        "attachmentAboveAlways": "Blank: every document needs an attachment.",
        "attachmentAboveHint": "Documents whose base-currency total is at or below this amount may be submitted and posted without an attachment.",
        "attachmentAbovePlaceholder": "Always required",
        "apControl": "AP control account",
        "whtPayable": "Withholding tax payable account",
        "fxGain": "Realised FX gain account",
        "fxLoss": "Realised FX loss account",
        "discount": "Early-payment discount account",
        "coolingHours": "Cooling-off period (hours)",
        "coolingHoursHint": "Whole hours from 0 to 720. The default is 48.",
        "coolingActive": "Apply the cooling-off period",
        "coolingActiveHint": "When on, payments to a vendor's newly changed bank account wait out the period above."
      },
      "errors": {
        "attachmentAbove": "Enter an amount of zero or more, such as 5000.00, or leave it blank.",
        "hoursRange": "Enter whole hours from 0 to 720."
      },
      "title": "Accounts payable settings",
      "description": "Posting accounts and the bank-change cooling-off period, kept per legal entity.",
      "chooseCompanyTitle": "Choose a legal entity",
      "chooseCompanyDescription": "AP settings are kept per legal entity. Pick one above to see and change its settings.",
      "noPermissionTitle": "You cannot manage AP settings",
      "noPermissionDescription": "Viewing and changing these settings needs the AP settings permission. Ask a tenant administrator for it.",
      "loadFailed": "The AP settings could not be loaded",
      "noChart": "You cannot read the chart of accounts, so accounts cannot be chosen here. Ask for read access to the chart of accounts.",
      "accountsTitle": "Posting accounts",
      "accountsDescription": "Override the accounts AP posts to. An empty field falls back to the chart's standard account.",
      "clearHint": "Clearing a field and saving removes the override, and postings go back to the chart's standard account.",
      "coolingTitle": "Bank-change cooling-off",
      "coolingDescription": "After a vendor's bank details change, payments to the new account wait for this period.",
      "resolved": {
        "configured": "In force: {code}",
        "defaulted": "Not set. Postings fall back to {code} from the chart.",
        "none": "Not set, and the chart has no standard account to fall back to."
      },
      "stale": {
        "body": "These settings were changed elsewhere while you were editing, possibly from Treasury, which also sets the bank-change cooling-off. Reload the saved version, then apply your edits again.",
        "reload": "Reload the saved version"
      },
      "toasts": {
        "saved": "AP settings saved",
        "savedDetail": "New postings and payments use these settings from now on.",
        "saveFailed": "The AP settings were not saved"
      }
    },
    "capture": {
      "title": "Read from the bill (AI)",
      "description": "Upload the vendor's PDF or image. What the AI reads is shown with its confidence; nothing reaches this form until you confirm, and nothing is saved until you save.",
      "fileLabel": "Vendor bill",
      "fileHint": "PDF, PNG or JPEG. A PDF over 10 MB is refused.",
      "read": "Read document",
      "reading": "Reading the document. This can take a few seconds.",
      "loading": "Loading the extraction.",
      "pendingPlaceholder": "Or resume a pending extraction",
      "pendingLead": "Bills uploaded for reading and not yet reviewed, by anyone.",
      "pendingHint": "{confidence}% confidence · #{id}",
      "overall": "Overall {confidence}%",
      "model": "Read by {model}",
      "statuses": {
        "pending": "Awaiting review",
        "confirmed": "Confirmed",
        "discarded": "Discarded"
      },
      "lowNote": "{count} value(s) were read with low confidence. They are highlighted and start unticked — check them against the document.",
      "headerTable": "Values read from the bill header",
      "linesTable": "Lines read from the bill",
      "columns": {
        "use": "Use",
        "field": "Field",
        "value": "Read as",
        "confidence": "Confidence"
      },
      "useField": "Use {field}",
      "useLine": "Use line {line}",
      "checkOnly": "Check only",
      "unusable": "Not in a usable form — type it in",
      "percentTitle": "Confidence {value}%",
      "fields": {
        "vendorName": "Vendor",
        "vendorTaxId": "Vendor tax number",
        "invoiceNumber": "Vendor invoice number",
        "invoiceDate": "Invoice date",
        "dueDate": "Due date",
        "currency": "Currency",
        "notes": "Notes (to the memo)",
        "subtotal": "Subtotal",
        "taxAmount": "Tax",
        "totalAmount": "Total"
      },
      "lineFields": {
        "description": "Description",
        "quantity": "Quantity",
        "unitPrice": "Unit price",
        "lineAmount": "Amount",
        "taxCode": "Tax code"
      },
      "noLines": "No lines were read from this document.",
      "accountsNote": "Lines arrive without an account: choose one for each before saving. Tax is resolved by the server at submit, so the tax and total read here are for checking only.",
      "applied": "Confirmed and filled in. Check the form, choose an account for each line, then save the draft.",
      "alreadyReviewed": "This extraction has already been reviewed, so it can no longer fill a form. Start over to read the document again.",
      "needsReviewer": "Somebody with permission to review AI extractions must confirm this one before it can fill the form.",
      "startOver": "Start over",
      "discard": "Discard",
      "confirm": "Confirm and fill the form",
      "discarded": "Extraction discarded",
      "discardedDetail": "Nothing was filled in. The record of what was read stays in the audit trail.",
      "reviewedElsewhere": "Somebody reviewed this extraction while you had it open. This is what is on file now.",
      "disabledTitle": "AI capture is off",
      "disabledDetail": "AI is switched off for this legal entity, so bills are entered by hand.",
      "tooLargeHint": "Split the PDF, or upload the pages as images.",
      "appliedTitle": "Filled in from the document",
      "appliedDetail": "Nothing is saved yet. Check every field, then save the draft.",
      "vendorUnmatched": "The document names the vendor \"{name}\", which matches no single vendor on file. Choose the vendor yourself."
    },
    "invoiceSignals": {
      "title": "Fraud and duplicate signals",
      "description": "Eleven deterministic checks run at submit. A blocking one holds this document until it is disposed of in the signal inbox.",
      "inbox": "Signal inbox",
      "rescan": "Rescan",
      "rescanned": "Signals rescanned",
      "rescannedDetail": "{count} open signal(s) on this document.",
      "loadFailed": "Signals could not be loaded",
      "blocking": "{count} blocking signal(s) are open, so this document cannot be submitted.",
      "disposeThere": "Dispose of them in the signal inbox.",
      "refusedRescan": "Submit was refused by a blocking signal. A refused submit keeps nothing it found, so rescan to record the signals here, then dispose of them in the signal inbox.",
      "warnings": "{count} warning signal(s) are open. They do not stop submission, but an approver will see them.",
      "empty": "No signals on this document. They are raised at submit; rescan to check now.",
      "listLabel": "Signals on this document",
      "related": "Open the related document"
    },
    "poMatch": {
      "title": "Match to {po}",
      "description": "Compare each line of this bill with what was ordered and what was received. Nothing is posted; a line outside tolerance is recorded as a dispute.",
      "matched": "Matched within tolerance",
      "disputed": "Matched with disputes",
      "doneDetail": "The three-way match against {po} is on file.",
      "existing": "This bill was already matched.",
      "open": "Open the match",
      "all": "All matches",
      "disputedLead": "One or more lines are outside tolerance. Resolve the disputes on the match.",
      "resultTable": "Match result by line",
      "pairTable": "Bill lines and the PO lines they are for",
      "columns": {
        "invoiceLine": "Bill line",
        "poLine": "PO line",
        "quantities": "Qty: bill / PO / received",
        "prices": "Price: bill / PO",
        "qtyVariance": "Qty variance",
        "priceVariance": "Price variance",
        "tolerance": "Tolerance",
        "amount": "Amount"
      },
      "within": "Within",
      "outside": "Outside",
      "statuses": {
        "matched": "Matched",
        "disputed": "Disputed"
      },
      "disputeStatuses": {
        "open": "Open",
        "resolved": "Resolved"
      },
      "invoiceLine": "Line {no} · {description}",
      "cannotCreate": "No match is on file for this bill, and running one needs permission to create matches.",
      "pairLead": "Each bill line is paired with the PO line it is for. Leave a line out if it is not for this order.",
      "pairAria": "PO line for bill line {no}",
      "leaveOut": "Leave out",
      "nonePaired": "Pair at least one line with a PO line to run the match.",
      "run": "Run the match"
    },
    "signal": {
      "duplicate_exact": "Same vendor and invoice number as one already on file.",
      "near_duplicate_number": "The invoice number is nearly identical to an earlier one.",
      "duplicate_amount_date": "Same vendor, amount and date as an invoice already on file.",
      "round_sum": "The invoice total is an unusually round amount.",
      "fresh_vendor": "The invoice is from a vendor created very recently.",
      "bank_change_recent": "The vendor's bank details changed shortly before this invoice.",
      "just_below_threshold": "The amount sits just below an approval threshold.",
      "non_business_day_entry": "The invoice was entered on a non-business day.",
      "sequential_numbering": "The vendor's invoice numbers are unusually sequential.",
      "no_po_over_threshold": "An invoice over the threshold has no purchase order.",
      "tax_without_registration": "Tax was charged by a vendor with no tax registration."
    },
    "payment_exception": {
      "returned": "A payment was returned by the bank.",
      "recalled": "A payment was recalled.",
      "rejected": "A payment was rejected.",
      "stopped": "A payment was stopped.",
      "restored": "A stopped payment was restored."
    }
  },
  "ar": {
    "routeTitles": {
      "arCustomers": "Customers",
      "arCustomer": "Customer",
      "arInvoices": "Sales invoices",
      "arInvoiceNew": "New sales invoice",
      "arInvoice": "Sales invoice",
      "arCreditNotes": "Credit notes",
      "arCreditNoteNew": "New credit note",
      "arCreditNote": "Credit note",
      "arReceipts": "Receipts",
      "arReceiptNew": "Record a receipt",
      "arReceipt": "Receipt",
      "arDunning": "Dunning",
      "arAging": "AR aging",
      "arDso": "Days sales outstanding",
      "arStatement": "Customer statement",
      "eclMatrices": "ECL matrices",
      "eclRuns": "ECL runs",
      "eclRun": "ECL run",
      "eclAssessments": "ECL assessments",
      "eclMovement": "Allowance movement",
      "customerPosition": "Customer position",
      "collections": "Collections worklist",
      "cei": "Collection effectiveness",
      "unallocatedReceipts": "Unallocated receipts",
      "writeOffs": "Write-offs",
      "writeOff": "Write-off",
      "writeOffNew": "New write-off",
      "writeOffSettings": "Write-off thresholds",
      "eclSettings": "ECL settings",
      "creditControl": "Credit control",
      "dunningEffectiveness": "Dunning effectiveness"
    },
    "list": {
      "filtersTitle": "Filters",
      "allCompanies": "All legal entities",
      "from": "From",
      "to": "To",
      "openOnly": "Outstanding only",
      "searchHint": "Document number, reference or customer",
      "loadFailed": "Could not load these documents",
      "exported": "Exported",
      "exportedDetail": "{count} rows written to a CSV file.",
      "views": {
        "trigger": "Views",
        "unsaved": "Unsaved view",
        "save": "Save this view",
        "namePlaceholder": "Name this view",
        "defaultBadge": "Default",
        "setDefault": "Make default",
        "clearDefault": "Clear default",
        "remove": "Delete",
        "empty": "No saved views yet. Filter the list, then save it.",
        "panelLabel": "Saved views",
        "saved": "View saved"
      },
      "columns": {
        "customer": "Customer",
        "dueDate": "Due",
        "settlement": "Settled",
        "currency": "Currency",
        "total": "Total",
        "balance": "Outstanding"
      },
      "invoice": {
        "title": "Sales invoices",
        "description": "What customers have been billed, and what is still owed.",
        "new": "New invoice",
        "tableLabel": "Sales invoices",
        "emptyTitle": "No sales invoices yet",
        "emptyDescription": "Raise one with New invoice, or narrow the filters if you expected to see something here.",
        "columns": {
          "docNo": "Invoice no.",
          "date": "Invoice date"
        }
      },
      "creditNote": {
        "title": "Credit notes",
        "description": "Amounts credited back to customers, and how much of each is still unapplied.",
        "new": "New credit note",
        "tableLabel": "Credit notes",
        "emptyTitle": "No credit notes yet",
        "emptyDescription": "A credit note reduces what a customer owes. Raise one with New credit note, then apply it to their open invoices.",
        "columns": {
          "docNo": "Credit note no.",
          "date": "Credit note date"
        }
      }
    },
    "doc": {
      "headerTitle": "Document",
      "draftTitle": "Draft",
      "loadFailed": "Could not load this document",
      "actionsLabel": "Document actions",
      "subtotalLabel": "Subtotal",
      "totalLabel": "Total",
      "confirming": "Confirming",
      "posting": "Posting",
      "readyToConfirm": "Confirm assigns the document number and runs the customer's credit check.",
      "confirmedImmutable": "This document has been confirmed and numbered, so its lines can no longer be edited.",
      "stale": "Somebody else saved this document while you had it open. Your changes are still on screen — read them, reload, and reapply what you meant.",
      "reload": "Reload from the server",
      "railSubtitle": "{status}, dated {date}",
      "shortcuts": {
        "save": "Save this document"
      },
      "unsavedGuard": {
        "title": "Discard unsaved changes?",
        "message": "This document has changes that have not been saved. Leaving now discards them.",
        "confirm": "Discard changes",
        "cancel": "Keep editing"
      },
      "statuses": {
        "draft": "Draft",
        "confirmed": "Confirmed",
        "posted": "Posted",
        "cancelled": "Cancelled"
      },
      "settlements": {
        "unpaid": "Unpaid",
        "partial": "Part paid",
        "paid": "Paid"
      },
      "blockers": {
        "noLines": "Add at least one line with an amount.",
        "lineIssues": "Fix the highlighted lines first.",
        "zeroTotal": "This document totals zero. Add a line with an amount before confirming it."
      },
      "fields": {
        "company": "Legal Entity",
        "companyPlaceholder": "Choose a legal entity",
        "customer": "Customer",
        "dueDate": "Due date",
        "dueDateHint": "When payment is expected. Drives the aging and the dunning cycle.",
        "currency": "Currency",
        "currencyHint": "Legal entity base currency is {base}.",
        "reference": "Reference",
        "referenceHint": "The customer's order or contract number, if they gave one.",
        "memo": "Memo",
        "taxTotal": "Tax",
        "total": "Total",
        "allocated": "Settled",
        "balance": "Outstanding",
        "postedAt": "Posted",
        "dunningLevel": "Dunning level"
      },
      "actions": {
        "save": "Save draft",
        "confirm": "Confirm",
        "post": "Post",
        "pdf": "PDF",
        "discard": "Discard draft"
      },
      "pdfWorking": "Rendering",
      "pdfOpen": "Open the PDF",
      "pdfNotReady": "The PDF is still rendering. Try again in a moment.",
      "timeline": {
        "created": "Created",
        "confirmed": "Confirmed as {docNo}",
        "posted": "Posted to the ledger",
        "override": "Credit override granted",
        "dunning": "Dunning notice sent — level {level}"
      },
      "links": {
        "customer": "Customer",
        "journal": "Journal entry",
        "originalInvoice": "Original invoice"
      },
      "toasts": {
        "savedDetail": "The draft is stored. It has no number until you confirm it.",
        "saveFailed": "Could not save this document",
        "confirmedDetail": "The number is issued and the credit check passed.",
        "confirmFailed": "Could not confirm this document",
        "postedDetail": "The journal has been written and the sub-ledger updated.",
        "postFailed": "Could not post this document",
        "discarded": "Draft discarded",
        "discardedDetail": "Nothing was posted, so nothing needed reversing.",
        "discardFailed": "Could not discard this draft"
      },
      "invoice": {
        "title": "Invoice {docNo}",
        "newTitle": "New sales invoice",
        "description": "Bill a customer. Confirm numbers it and runs their credit check; Post writes the journal.",
        "backToList": "All invoices",
        "postedImmutable": "A posted invoice is corrected with a credit note, never edited or deleted.",
        "fields": {
          "date": "Invoice date"
        },
        "toasts": {
          "saved": "Invoice draft saved",
          "confirmed": "Invoice {docNo} confirmed",
          "posted": "Invoice {docNo} posted"
        }
      },
      "creditNote": {
        "title": "Credit note {docNo}",
        "newTitle": "New credit note",
        "description": "Credit an amount back to a customer, then apply it to their open invoices.",
        "backToList": "All credit notes",
        "postedImmutable": "A posted credit note is not edited or deleted. Apply it to invoices, or raise an invoice to reverse it.",
        "fields": {
          "date": "Credit note date"
        },
        "toasts": {
          "saved": "Credit note draft saved",
          "confirmed": "Credit note {docNo} confirmed",
          "posted": "Credit note {docNo} posted"
        }
      },
      "pdfUnsafe": "The server returned a PDF link that is not a web address, so it was not opened. Try again, or contact support if it repeats."
    },
    "lines": {
      "title": "Lines",
      "caption": "Document lines: revenue account, quantity, unit price, discount and the amount each produces",
      "subtotal": "Subtotal",
      "noTaxCode": "No tax",
      "keyboardHint": "Enter moves down a row and adds one at the end. Alt+↓ duplicates, Alt+Backspace removes.",
      "columns": {
        "no": "No.",
        "account": "Revenue account",
        "description": "Description",
        "dimensions": "Dimensions",
        "taxCode": "Tax",
        "quantity": "Qty",
        "unitPrice": "Unit price",
        "discount": "Disc %",
        "amount": "Amount",
        "rowActions": "Row actions"
      },
      "actions": {
        "add": "Add a line",
        "duplicate": "Duplicate this line",
        "remove": "Remove this line"
      },
      "aria": {
        "account": "Revenue account, line {line}",
        "description": "Description, line {line}",
        "taxCode": "Tax code, line {line}",
        "quantity": "Quantity, line {line}",
        "unitPrice": "Unit price, line {line}",
        "discount": "Discount percent, line {line}",
        "duplicate": "Duplicate line {line}",
        "remove": "Remove line {line}"
      },
      "issues": {
        "noAccount": "Choose the revenue account this line credits.",
        "invalidQuantity": "That is not a number.",
        "quantityNotPositive": "A quantity must be greater than zero.",
        "invalidUnitPrice": "That is not a number.",
        "negativeUnitPrice": "A unit price cannot be negative. A credit note carries positive amounts and reverses their sides.",
        "invalidDiscount": "That is not a number.",
        "discountRange": "A line discount is a percentage between 0 and 100."
      }
    },
    "credit": {
      "panelTitle": "Credit position",
      "panelDescription": "Where this customer stands right now, across every legal entity in the tenant.",
      "passing": "Within credit terms",
      "failing": "Fails the credit check",
      "limit": "Credit limit",
      "noLimit": "No limit recorded",
      "exposure": "Exposure",
      "available": "Headroom",
      "overage": "Over the limit by",
      "overdue": "Overdue",
      "overdueDays": "up to {days} days",
      "utilisation": "{percent}% of the limit",
      "overrideGranted": "A credit override has been granted for this document.",
      "unavailable": "No credit position to show yet.",
      "conditions": {
        "credit_limit": "This document takes the customer past their credit limit.",
        "overdue": "The customer has balances overdue beyond their agreed tolerance.",
        "customer_status": "The customer's account is not active."
      }
    },
    "creditBlock": {
      "title": "This document fails the customer's credit check",
      "pendingTitle": "Credit override requested",
      "pendingBody": "Your request has gone to the approval chain. The document stays a draft until somebody approves it, and confirming again once they have will number it.",
      "noPermission": "Confirming this document anyway needs the credit override permission, which you do not hold. Ask whoever owns credit control for this customer.",
      "requestOverride": "Request a credit override",
      "reasonLabel": "Why should this document go through?",
      "reasonHint": "Required, and recorded in the audit log against your name. An override with no stated reason is a bypass.",
      "reasonPlaceholder": "e.g. Payment plan agreed with the customer on 3 August; first instalment already received.",
      "submitOverride": "Submit the request",
      "viewApprovals": "Open the approvals inbox",
      "pendingWait": "Confirm and override are disabled while the request is with its approvers. Reload this document once they have decided."
    },
    "customers": {
      "title": "Customers",
      "description": "Who you bill, on what terms, and how much credit they may carry.",
      "detailDescription": "Terms, credit position, ledger and collections state.",
      "dialogDescription": "The commercial terms here are enforced when an invoice is confirmed.",
      "createTitle": "New customer",
      "editTitle": "Edit customer",
      "new": "New customer",
      "backToList": "All customers",
      "tableLabel": "Customers",
      "searchHint": "Code, name or email",
      "loadFailed": "Could not load customers",
      "emptyTitle": "No customers yet",
      "emptyDescription": "Add the first one with New customer — you will need one before you can raise an invoice.",
      "pickerPlaceholder": "Choose a customer",
      "termsTitle": "Terms",
      "quickLinks": "Go to",
      "ledgerTitle": "Ledger",
      "ledgerCaption": "Every posted document for this customer, with a running balance",
      "ledgerFailed": "Could not load this customer's ledger",
      "termsDays": "{days} days",
      "noOverdueBlock": "Not checked",
      "noPriceTier": "Standard",
      "portalOn": "Enabled",
      "portalOff": "Not enabled",
      "statuses": {
        "active": "Active",
        "on_hold": "On hold",
        "blocked": "Blocked"
      },
      "columns": {
        "terms": "Terms",
        "dunning": "Dunning"
      },
      "fields": {
        "code": "Code",
        "name": "Name",
        "legalName": "Legal name",
        "currency": "Trading currency",
        "currencyHint": "The currency invoices default to.",
        "creditLimit": "Credit limit",
        "creditLimitHint": "Zero means no limit is recorded, not that everything is refused. To stop trading, set the status to blocked.",
        "creditLimitCurrency": "Limit currency",
        "creditLimitCurrencyHint": "Exposure in other currencies is converted into this one before it is compared.",
        "creditLimitLockedHint": "A credit limit and its currency change only through an approved credit-limit request.",
        "statusHoldHint": "A credit hold is placed and released with the credit hold actions, which record a reason.",
        "paymentTermsCode": "Terms code",
        "paymentTermsDays": "Terms (days)",
        "paymentTermsDaysHint": "Used to default an invoice's due date.",
        "overdueBlockDays": "Overdue tolerance (days)",
        "overdueBlockDaysHint": "How late a balance may be before new invoices are refused. Zero means do not check.",
        "priceTier": "Price tier",
        "portalAccess": "Portal access",
        "portalAccessHint": "Lets this customer sign in to see their orders, invoices and statements.",
        "notes": "Notes"
      },
      "links": {
        "invoices": "Invoices",
        "openInvoices": "Outstanding invoices",
        "creditNotes": "Credit notes",
        "receipts": "Receipts",
        "recordReceipt": "Record a receipt",
        "statement": "Statement",
        "aging": "Aging",
        "position": "Full exposure"
      },
      "timeline": {
        "created": "Customer created",
        "dunningPaused": "Dunning paused"
      },
      "toasts": {
        "created": "Customer created",
        "updated": "Customer updated"
      }
    },
    "ledger": {
      "opening": "Opening balance",
      "closing": "Closing balance",
      "empty": "Nothing posted for this customer in this legal entity yet.",
      "columns": {
        "date": "Date",
        "doc": "Document",
        "memo": "Memo",
        "debit": "Debit",
        "credit": "Credit",
        "balance": "Balance"
      }
    },
    "receipts": {
      "listTitle": "Receipts",
      "listDescription": "Money received from customers, and how much of it has been applied.",
      "title": "Receipt {receiptNo}",
      "newTitle": "Record a receipt",
      "description": "Record money that has arrived and decide which invoices it settles.",
      "headerTitle": "Receipt",
      "new": "Record a receipt",
      "backToList": "All receipts",
      "tableLabel": "Receipts",
      "searchHint": "Receipt number or payment reference",
      "openOnly": "Unapplied credit only",
      "posted": "Posted",
      "loadFailed": "Could not load this receipt",
      "emptyTitle": "No receipts yet",
      "emptyDescription": "Record the first one with Record a receipt — a receipt is money that has already arrived, so it posts as soon as it is recorded.",
      "immutable": "A receipt posts the moment it is recorded, so its header cannot be changed. What is still open is how much of it is applied.",
      "appliedTitle": "Already applied",
      "appliedCaption": "Invoices this receipt has already settled",
      "actionsLabel": "Receipt actions",
      "railSubtitle": "Received {date} by {method}",
      "methods": {
        "bank_transfer": "Bank transfer",
        "cash": "Cash",
        "cheque": "Cheque",
        "card": "Card",
        "other": "Other"
      },
      "columns": {
        "receiptNo": "Receipt no.",
        "date": "Date",
        "method": "Method",
        "reference": "Reference",
        "amount": "Received",
        "allocated": "Applied",
        "unallocated": "Unapplied"
      },
      "fields": {
        "date": "Receipt date",
        "amount": "Amount received",
        "amountHint": "What actually arrived. Applying it to invoices is the next step, not this one.",
        "depositAccount": "Deposited into",
        "depositAccountHint": "Only accounts in this receipt's currency are offered.",
        "depositAccountPlaceholder": "Choose a bank or cash account",
        "method": "Method",
        "reference": "Payment reference",
        "referenceHint": "If it names an invoice number, that invoice is suggested first.",
        "allocated": "Applied",
        "unallocated": "Unapplied",
        "postedAt": "Posted"
      },
      "actions": {
        "record": "Record receipt",
        "apply": "Apply to invoices"
      },
      "timeline": {
        "created": "Created",
        "posted": "Posted as {receiptNo}"
      },
      "links": {
        "customer": "Customer",
        "journal": "Journal entry"
      },
      "toasts": {
        "recorded": "Receipt {receiptNo} recorded",
        "recordedDetail": "The cash is posted and any allocations you chose have been applied.",
        "recordFailed": "Could not record this receipt",
        "applied": "Allocations applied",
        "appliedDetail": "The invoices have been settled by that much.",
        "applyFailed": "Could not apply these allocations"
      }
    },
    "alloc": {
      "title": "Apply to invoices",
      "description": "Suggestions are ranked by the server. Adjust any amount; the total can never exceed the receipt.",
      "caption": "Open invoices for this customer, with the amount of the receipt applied to each",
      "loadFailed": "Could not load this customer's open invoices",
      "pickCustomer": "Choose a customer to see their open invoices.",
      "noOpenItems": "This customer has no open invoices. The whole receipt will sit on their account as credit.",
      "available": "Receipt",
      "allocated": "Applied",
      "remaining": "Left",
      "overAllocated": "More has been applied than the receipt holds.",
      "overpayment": "The remainder stays on the customer's account as credit.",
      "columns": {
        "apply": "Apply",
        "invoice": "Invoice",
        "dueDate": "Due",
        "reason": "Why suggested",
        "balance": "Outstanding",
        "suggested": "Suggested",
        "amount": "Apply",
        "allocatedOn": "Applied on"
      },
      "reasons": {
        "reference": "Named in the payment reference",
        "exact_amount": "Balance matches the amount received",
        "oldest_first": "Oldest outstanding",
        "manual": "Chosen manually"
      },
      "issues": {
        "invalidAmount": "That is not an amount.",
        "notPositive": "An amount to apply must be greater than zero.",
        "exceedsBalance": "More than this invoice has outstanding.",
        "duplicateInvoice": "This invoice appears twice. Combine the two amounts into one."
      },
      "blockers": {
        "nothingSelected": "Tick at least one invoice to apply this receipt to.",
        "rowIssues": "Fix the highlighted amounts first.",
        "overAllocated": "The applied total is more than the receipt holds. Reduce an amount before continuing."
      },
      "actions": {
        "reset": "Reset to suggested",
        "clear": "Clear all"
      },
      "aria": {
        "apply": "Apply this receipt to invoice {invoice}",
        "amount": "Amount to apply to invoice {invoice}"
      },
      "proposal": {
        "note": "Proposed by the system: {basis}. Adjust any amount, then apply.",
        "none": "No open invoice in this receipt's currency can take its unapplied credit. It stays on the customer's account."
      }
    },
    "dunning": {
      "title": "Dunning",
      "panelTitle": "Collections",
      "panelDescription": "Whether the automated cycle is chasing this customer.",
      "paused": "Paused",
      "active": "Active",
      "pausedState": "The dunning cycle is paused for this customer. No notices will be sent.",
      "activeState": "The dunning cycle is chasing this customer's overdue invoices.",
      "noPermission": "Pausing and resuming collections needs the dunning permission, which you do not hold.",
      "pauseTitle": "Pause dunning",
      "pauseDescription": "No further notices will go to {customer} until collections is resumed.",
      "pauseAction": "Pause dunning",
      "resumeAction": "Resume dunning",
      "reasonLabel": "Why is collections being paused?",
      "reasonHint": "Required, and recorded in the audit log. A pause with no stated reason is indistinguishable from collections having been switched off by accident.",
      "reasonPlaceholder": "e.g. Payment plan agreed to 30 September; instalments arriving monthly.",
      "pausedTitle": "Dunning paused",
      "pausedDetail": "No further notices will go to {customer}.",
      "resumedTitle": "Dunning resumed",
      "resumedDetail": "{customer} is back in the collections cycle.",
      "resumeFailed": "Could not resume dunning",
      "noReason": "No reason recorded",
      "runOn": "Business date",
      "pausedDescription": "Customers the cycle is not chasing, and why.",
      "pausedCaption": "Customers whose dunning cycle is paused",
      "nonePaused": "No customer's collections cycle is paused.",
      "columns": {
        "level": "Level",
        "lastSent": "Last notice",
        "pausedSince": "Paused since",
        "reason": "Reason"
      },
      "pausedListTitle": "Paused customers"
    },
    "aging": {
      "title": "AR aging",
      "description": "What is owed, by customer, by how overdue it is.",
      "asOf": "As of",
      "asOfHint": "Balances are taken as they stood on this date.",
      "tableTitle": "Aged receivables as of {asOf}",
      "caption": "Receivables by customer and aging bucket",
      "loadFailed": "Could not load the aging report",
      "empty": "Nothing is outstanding for this legal entity on that date.",
      "totals": "Total",
      "statement": "Statement",
      "buckets": {
        "current": "Not yet due",
        "1-30": "1–30 days",
        "31-60": "31–60 days",
        "61-90": "61–90 days",
        "91-120": "91–120 days",
        "121+": "121+ days"
      },
      "columns": {
        "customer": "Customer",
        "total": "Total",
        "credit": "Credit on account",
        "net": "Net owed"
      },
      "kpi": {
        "total": "Outstanding",
        "totalHelp": "Everything still owed, before any credit sitting on customer accounts.",
        "credit": "Credit on account",
        "creditHelp": "Receipts and credit notes not yet applied to an invoice.",
        "net": "Net owed",
        "netHelp": "Outstanding less credit on account. This is the figure to quote on a collections call.",
        "customers": "Customers owing",
        "customersHelp": "How many customers have something outstanding."
      }
    },
    "dso": {
      "title": "Days sales outstanding",
      "description": "How long, on average, it takes to collect what has been billed.",
      "days": "days",
      "window": "Window",
      "formula": "Formula",
      "workingTitle": "How this was calculated",
      "workingDescription": "A DSO quoted without its inputs is a claim, not a measurement.",
      "loadFailed": "Could not load the DSO report",
      "kpi": {
        "dso": "DSO (days)",
        "dsoHelp": "Closing receivables divided by credit sales, times the days in the window.",
        "creditSales": "Credit sales",
        "creditSalesHelp": "Invoiced in this window, net of credit notes.",
        "receivables": "Closing receivables",
        "receivablesHelp": "Still outstanding at the end of the window.",
        "days": "Days in window",
        "daysHelp": "The length of the period being measured."
      },
      "links": {
        "openInvoices": "The invoices behind this",
        "aging": "Aging at the end of the window"
      },
      "groupBy": {
        "label": "Analyse by",
        "hint": "Split the same figures by business unit or customer segment.",
        "none": "Company only",
        "business_unit": "Business unit",
        "segment": "Customer segment",
        "description": "The server apportions each document across its groups, so the groups add up to the company figures in the total row.",
        "empty": "Nothing to split in this window.",
        "unassigned": "Unassigned",
        "noSales": "No sales",
        "title": {
          "business_unit": "DSO by business unit",
          "segment": "DSO by customer segment"
        },
        "columns": {
          "code": "Code",
          "name": "Name"
        }
      }
    },
    "statement": {
      "title": "Customer statement",
      "description": "The document a customer is sent: what they owe, and since when.",
      "pdf": "PDF",
      "pdfWorking": "Rendering",
      "pdfOpen": "Open the PDF",
      "pdfNotReady": "The statement PDF is still rendering. Try again in a moment.",
      "openOnly": "Outstanding items only",
      "pickCustomer": "Choose a customer to produce their statement.",
      "loadFailed": "Could not load this statement",
      "empty": "Nothing outstanding for this customer on that date.",
      "asOf": "As of",
      "generatedAt": "Produced",
      "totalDue": "Total due",
      "unappliedCredit": "Credit on account",
      "agingTitle": "How the balance ages",
      "caption": "Statement lines with a running balance",
      "columns": {
        "date": "Date",
        "docType": "Type",
        "docNo": "Reference",
        "dueDate": "Due",
        "daysDue": "Days",
        "amount": "Amount",
        "balance": "Balance"
      },
      "docTypes": {
        "invoice": "Invoice",
        "credit_note": "Credit note",
        "receipt": "Receipt"
      }
    },
    "ecl": {
      "matricesTitle": "ECL matrices",
      "matricesDescription": "A loss rate per ageing bucket per customer segment. The matrix is what turns an ageing into a provision.",
      "matricesLoadFailed": "ECL matrices could not be loaded",
      "matrixHint": "The six buckets are fixed. A matrix is only comparable period to period if the columns do not move under it.",
      "matrixPanelTitle": "Matrices",
      "matrixPanelDescription": "One per segment, effective-dated. Activating a matrix supersedes the one it replaces.",
      "matrixEmptyTitle": "No matrices",
      "matrixEmptyDescription": "Create a segment, then a matrix for it, then type the loss rate for each bucket.",
      "tabMatrices": "Matrices",
      "tabSegments": "Segments",
      "tabsLabel": "ECL configuration",
      "matrix": "Matrix",
      "segment": "Segment",
      "effectiveFrom": "Effective from",
      "macroFactor": "Macro factor",
      "macroFactorHint": "A forward-looking multiplier on every rate in this matrix. 1 leaves the rates as they are.",
      "editRates": "Rates",
      "activate": "Activate",
      "activated": "Matrix activated",
      "activateFailed": "The matrix could not be activated",
      "newMatrix": "New matrix",
      "newMatrixDescription": "Pick the segment it covers and the date it takes effect from.",
      "matrixCreated": "Matrix created",
      "matrixCreateFailed": "The matrix could not be created",
      "matrixStatuses": {
        "draft": "Draft",
        "active": "Active",
        "superseded": "Superseded"
      },
      "ratesTitle": "Loss rates — {code}",
      "ratesDescription": "The expected loss on money in each ageing bucket.",
      "ratesHint": "Rates are decimal fractions: 0.035 is 3.5%. They are stored and multiplied as decimals, never as floating point.",
      "ratesSaved": "Loss rates saved",
      "ratesSaveFailed": "The loss rates could not be saved",
      "bucket": "Bucket",
      "lossRate": "Loss rate",
      "buckets": {
        "current": "Not yet due",
        "d1_30": "1–30 days",
        "d31_60": "31–60 days",
        "d61_90": "61–90 days",
        "d91_120": "91–120 days",
        "d120_plus": "Over 120 days"
      },
      "segmentPanelTitle": "Segments",
      "segmentPanelDescription": "Which customers a matrix applies to. The catch-all segment is always the lowest precedence.",
      "segmentEmptyTitle": "No segments",
      "segmentEmptyDescription": "Start with a catch-all segment so every customer is covered, then add narrower ones above it.",
      "newSegment": "New segment",
      "newSegmentDescription": "A rule for putting customers into one provisioning population.",
      "segmentCreated": "Segment created",
      "segmentCreateFailed": "The segment could not be created",
      "matchKind": "Matches on",
      "matchKindHint": "The catch-all is forced to the lowest precedence whatever priority you give it.",
      "matchValue": "Value",
      "priority": "Priority",
      "priorityHint": "Lower runs first. A customer lands in the first segment that matches.",
      "matchKinds": {
        "all": "Every customer",
        "customer_group": "Customer group",
        "price_tier": "Price tier",
        "country": "Country",
        "customer": "One customer"
      },
      "active": "Active",
      "inactive": "Inactive",
      "runsTitle": "ECL runs",
      "runsDescription": "What the allowance should be, what it is, and the difference — which is the only figure that posts.",
      "runsLoadFailed": "ECL runs could not be loaded",
      "runsTableLabel": "ECL runs",
      "runsEmptyTitle": "No ECL runs",
      "runsEmptyDescription": "Calculate one for a period end. Calculating changes nothing until you post it.",
      "movementHint": "The movement is what reaches the ledger. A provision of 412,000 against a prior allowance of 404,000 is a charge of 8,000, not 412,000.",
      "runTitle": "ECL — {asOf}",
      "runDescription": "Every customer, by ageing bucket.",
      "runLoadFailed": "This ECL run could not be loaded",
      "anyStatus": "Any status",
      "runStatuses": {
        "draft": "Draft",
        "calculated": "Calculated",
        "posted": "Posted",
        "reversed": "Reversed"
      },
      "asOf": "As of",
      "asOfHint": "Defaults to the end of the open period.",
      "grossReceivables": "Gross receivables",
      "collective": "Collective",
      "individual": "Individually assessed",
      "individualShort": "Individual",
      "priorAllowance": "Prior allowance",
      "totalEcl": "Allowance required",
      "movement": "Movement",
      "calculate": "Calculate",
      "calculateTitle": "Calculate an ECL run",
      "calculateDescription": "Reads the ageing, applies the active matrix per segment, and overlays individual assessments.",
      "calculateHint": "Calculating posts nothing. It can be repeated as often as you like while you fix the ageing.",
      "calculated": "ECL calculated",
      "calculateFailed": "The ECL run could not be calculated",
      "post": "Post the movement",
      "posted": "ECL movement posted",
      "postFailed": "The ECL movement could not be posted",
      "postedJournal": "Posted as journal #{id}.",
      "zeroMovement": "The allowance is already where it should be, so posting this run would move nothing. That is a result, not a failure.",
      "customer": "Customer",
      "gross": "Gross",
      "creditApplied": "Credit applied",
      "exposure": "Exposure",
      "eclAmount": "ECL",
      "linesTableLabel": "ECL by customer and bucket",
      "linesEmptyTitle": "No lines",
      "linesEmptyDescription": "This run found no receivables to provision against.",
      "assessmentsTitle": "Individual assessments",
      "assessmentsDescription": "A customer whose expected loss is known better than a matrix rate can express it.",
      "assessmentsLoadFailed": "Assessments could not be loaded",
      "assessmentsTableLabel": "Individual ECL assessments",
      "assessmentsEmptyTitle": "No individual assessments",
      "assessmentsEmptyDescription": "Everybody is provisioned collectively. Raise an assessment when you know something about a debtor the matrix does not.",
      "assessmentHint": "An assessment replaces the matrix for that customer only. Everybody else stays collective, which is why a run reports the two separately.",
      "newAssessment": "New assessment",
      "newAssessmentDescription": "Overriding a statistical model with a human number is what an auditor asks about first, so say why.",
      "assessmentWarning": "This replaces the matrix for this customer. It does not change anybody else's provision.",
      "assessmentCreated": "Assessment recorded",
      "assessmentFailed": "The assessment could not be recorded",
      "assessmentAsOfHint": "Defaults to the next run's date.",
      "assessedAmount": "Expected loss",
      "basis": "Basis",
      "basisHint": "How the figure was arrived at — the recovery expected, the security held, the correspondence relied on.",
      "reason": "Reason",
      "approvedAt": "Approved",
      "awaitingApproval": "Awaiting approval",
      "movementTitle": "Allowance movement",
      "movementDescription": "The loss-allowance reconciliation IFRS 7 asks for: opening, movement, closing.",
      "movementLoadFailed": "The movement report could not be loaded",
      "movementPanelTitle": "By run",
      "movementPanelDescription": "One row per posted run, oldest first.",
      "movementEmptyTitle": "Nothing posted yet",
      "movementEmptyDescription": "The report fills in as runs are posted.",
      "closingAllowance": "Closing allowance",
      "notPosted": "Not posted",
      "postedAt": "Posted",
      "from": "From",
      "to": "To",
      "note": "Note"
    },
    "position": {
      "title": "{customer} — position",
      "description": "Every exposure to one customer, in one place.",
      "crumb": "Position",
      "customers": "Customers",
      "loadFailed": "The customer position could not be loaded",
      "totalExposure": "Total exposure",
      "creditLimit": "Credit limit",
      "headroom": "Headroom",
      "noLimit": "No limit set",
      "overdue": "Overdue",
      "currentEcl": "Provisioned",
      "overLimit": "This customer is over their credit limit. A new order will be refused unless somebody with the credit-override permission releases it.",
      "overdueDays": "Oldest overdue item is {days} day(s) old; orders are blocked past {block}.",
      "sourcesTitle": "Where the exposure is",
      "sourcesDescription": "Each source separately, so the total can be argued with.",
      "sourcesEmptyTitle": "No exposure",
      "sourcesEmptyDescription": "This customer owes nothing and has nothing on order.",
      "source": "Source",
      "amount": "Amount",
      "asOf": "As of {asOf}"
    },
    "collections": {
      "title": "Collections worklist",
      "description": "Customers with overdue invoices, ranked by what is most worth chasing today.",
      "toDunning": "Dunning",
      "asOf": "As of",
      "asOfHint": "Overdue is measured against this date. Leave empty for today.",
      "tableTitle": "Ranked worklist",
      "formula": "Score = value at risk × (1 + 0.25 × broken promises, up to 4 + 0.10 × dunning level, up to 5). Value at risk weights each overdue balance by age: 1–30 days ×1.0, 31–60 ×1.5, 61–90 ×2.0, 91–120 ×3.0, 121+ ×4.0. Broken promises count the last 180 days. Ties go to the lower customer number.",
      "loadFailed": "Could not load the collections worklist",
      "empty": "No customer has an overdue invoice on this date. Nothing to chase.",
      "caption": "Customers with overdue invoices, highest score first",
      "onHold": "On credit hold",
      "daysOverdue": "{days} days",
      "columns": {
        "rank": "Rank",
        "overdue": "Overdue",
        "valueAtRisk": "Value at risk",
        "score": "Score",
        "invoices": "Invoices",
        "oldest": "Oldest",
        "broken": "Broken promises",
        "promise": "Open promise"
      },
      "drill": {
        "title": "Promises to pay: {customer}",
        "description": "Promises to pay for this customer. Kept and broken are decided each day from what was received.",
        "customer": "Customer record",
        "statement": "Statement",
        "openInvoices": "Open invoices",
        "dunning": "Dunning"
      },
      "promises": {
        "loadFailed": "Could not load this customer's promises",
        "empty": "No promises to pay recorded for this customer yet. Record one below when the customer commits to a date.",
        "caption": "Promises to pay from {customer}",
        "onAccount": "Against the account",
        "closed": "This promise is no longer open, so it cannot be changed. Record a new one instead.",
        "stale": "Someone changed this promise first. It has been reloaded; check it and save your change again.",
        "createTitle": "Record a promise to pay",
        "moreOpen": "Show more open promises",
        "moreHistory": "Show more history",
        "columns": {
          "promisedDate": "Promised by",
          "invoice": "Invoice",
          "amount": "Amount",
          "status": "Status",
          "received": "Received",
          "note": "Note"
        },
        "statuses": {
          "open": "Open",
          "kept": "Kept",
          "broken": "Broken",
          "cancelled": "Cancelled"
        },
        "fields": {
          "invoice": "Invoice",
          "invoiceHint": "Optional. Leave empty for a promise against the customer's whole account.",
          "amount": "Amount promised",
          "amountHint": "In the invoice's currency, or the customer's for an account promise.",
          "date": "Promised by",
          "dateHint": "Today or later.",
          "note": "Note"
        },
        "actions": {
          "change": "Change",
          "cancel": "Cancel promise",
          "record": "Record promise"
        },
        "toasts": {
          "created": "Promise recorded",
          "createdDetail": "{customer} promised {amount} by {date}.",
          "updated": "Promise updated",
          "cancelled": "Promise cancelled"
        }
      }
    },
    "cei": {
      "title": "Collection effectiveness",
      "description": "Cash collected against cash available for collection, by period.",
      "loadFailed": "Could not load the collection effectiveness report",
      "periodInvalid": "The end of the period cannot be before its start.",
      "period": "Period",
      "workingTitle": "How this was calculated",
      "workingDescription": "CEI has variants that disagree, so the inputs and the server's formula are shown with the figure.",
      "nothingCollectable": "Nothing was available for collection in this period, so there is no index to show.",
      "noRatio": "No ratio",
      "bar": "Index",
      "trendTitle": "Trend",
      "trendFailed": "Could not load this period",
      "trendDescription": {
        "month": "The last {count} months, the newest measured to the end of the period above.",
        "quarter": "The last {count} quarters, the newest measured to the end of the period above."
      },
      "granularity": {
        "label": "Trend by",
        "month": "Month",
        "quarter": "Quarter"
      },
      "kpi": {
        "cei": "CEI %",
        "ceiHelp": "(B + S − E) ÷ (B + S − C) × 100. 100% means every collectable receivable was collected; above 100% means arrears were collected too.",
        "cash": "Cash collected",
        "cashHelp": "Receipts dated in the period, for reference. The index is built from the receivables positions, not from this.",
        "available": "Available for collection",
        "availableHelp": "B + S − C: what could have been collected in the period."
      },
      "inputs": {
        "b": "B · Opening receivables",
        "s": "S · Credit sales",
        "e": "E · Closing receivables",
        "c": "C · Closing receivables not yet due",
        "numerator": "Collected (B + S − E)",
        "denominator": "Collectable (B + S − C)"
      },
      "links": {
        "aging": "Aging at the end of the period"
      }
    },
    "unallocated": {
      "title": "Unallocated receipts",
      "description": "Money received but not yet applied to an invoice, with how old it is and the allocation the system proposes.",
      "toReceipts": "All receipts",
      "minAge": "At least (days old)",
      "minAgeHint": "Optional. Only receipts at least this many days old.",
      "minAgeInvalid": "Enter a number of days from 0 to 3650.",
      "tableTitle": "Receipts on account",
      "tableDescription": "Oldest first. Applying a proposal allocates exactly the lines shown; every amount is checked again when it is applied.",
      "loadFailed": "Could not load the unallocated receipts",
      "empty": "Every receipt for this legal entity is fully applied.",
      "caption": "Receipts with credit still unapplied, oldest first",
      "ageDays": "{days} days",
      "overMaxAge": "Over the age limit",
      "noProposal": "No open invoice in the receipt's currency can take this money.",
      "unproposed": "Stays as credit:",
      "apply": "Apply proposal",
      "applied": "Receipt {receiptNo} allocated",
      "appliedDetail": "Still unapplied: {unallocated}.",
      "columns": {
        "age": "Age",
        "base": "Unapplied (base)",
        "proposal": "Proposed allocation"
      },
      "basis": {
        "reference": "named in the payment reference",
        "exact_amount": "balance matches the amount",
        "oldest_first": "oldest outstanding first",
        "none": "no match"
      },
      "confidence": {
        "high": "High confidence",
        "medium": "Medium confidence",
        "low": "Low confidence",
        "none": "No proposal"
      },
      "settings": {
        "title": "Alert thresholds",
        "description": "Finance is alerted each day when receipts on account exceed this amount or this age. 0 switches a test off.",
        "loadFailed": "Could not load the alert thresholds",
        "threshold": "Amount threshold",
        "thresholdHint": "Total unapplied, in {currency}. 0 switches the amount test off.",
        "thresholdInvalid": "Enter an amount, for example 25000.00.",
        "maxAge": "Maximum age",
        "maxAgeHint": "Days a receipt may stay unapplied. 0 switches the age test off.",
        "maxAgeInvalid": "Enter a number of days from 0 to 3650.",
        "days": "{days} days",
        "notConfigured": "Not configured",
        "notConfiguredHint": "Nothing is alerted for this legal entity until thresholds are saved.",
        "edit": "Change thresholds",
        "saved": "Alert thresholds saved",
        "stale": "Someone changed these thresholds first. They have been reloaded; check them and save again."
      }
    },
    "dunningFilter": {
      "title": "Customer",
      "hint": "Optional. Focus this screen on one customer.",
      "state": "Collections",
      "notPaused": "This customer's collections cycle is not paused."
    },
    "cnAlloc": {
      "noProposalPermission": "You cannot read credit notes, so no allocation can be proposed here. Ask for the credit note read permission.",
      "title": "Apply to invoices",
      "description": "Apply what is left on this credit note to the customer's open invoices. Nothing moves in the ledger unless the two documents were posted at different rates.",
      "loadFailed": "The customer's open invoices could not be loaded",
      "empty": "This customer has no open invoices to apply the credit note to. It stays on their account as credit until one is posted.",
      "reload": "Reload open invoices",
      "caption": "Open invoices this credit note can be applied to",
      "available": "Left on the credit note",
      "remaining": "Left after applying",
      "overAllocated": "More has been applied than the credit note holds.",
      "apply": "Apply credit note",
      "applying": "Applying…",
      "serverGuard": "The server re-checks every amount against the invoice and the credit note before anything is applied.",
      "blockers": {
        "nothingSelected": "Select at least one invoice to apply the credit note to.",
        "rowIssues": "Correct the highlighted amounts before applying.",
        "overAllocated": "The applied total is more than the credit note holds. Reduce an amount before applying."
      },
      "toasts": {
        "applied": "Credit note {docNo} applied",
        "appliedDetail": "The invoices' balances and the credit note's balance have been updated.",
        "failed": "The credit note could not be applied"
      }
    },
    "people": {
      "userById": "User #{id}"
    },
    "writeOffs": {
      "newTitle": "New write-off",
      "title": "Write-off {no}",
      "draftTitle": "Draft",
      "description": "Take a customer's uncollectable invoices off the books. Evidence of collection effort first, then approval, then a third person posts it.",
      "backToList": "All write-offs",
      "loadFailed": "Could not load this write-off",
      "stale": "Somebody else changed this write-off while you had it open. Nothing was overwritten. Reload it and apply your change again.",
      "reload": "Reload",
      "notProposer": "This draft was proposed by {name}. Only the proposer edits a draft; raise a new write-off instead.",
      "rejectedNote": "This write-off was rejected or lapsed and is closed.",
      "awaiting": "Waiting for its approver in the Approvals Inbox.",
      "awaitingDual": "Waiting for two distinct approvers in the Approvals Inbox: it is above the dual-approval threshold.",
      "toApprovals": "Open the Approvals Inbox",
      "listTitle": "Write-offs",
      "listDescription": "Proposed, approved, posted and reversed write-offs of uncollectable receivables.",
      "toSettings": "Thresholds",
      "new": "New write-off",
      "allStatuses": "All statuses",
      "search": "Search",
      "searchPlaceholder": "Number, customer name or code",
      "tableTitle": "Write-offs, newest first",
      "listLoadFailed": "Could not load the write-offs",
      "empty": "No write-offs match. Propose one from a customer's overdue invoices, with evidence of the collection effort attached.",
      "caption": "Write-offs with their status and base-currency total",
      "headerTitle": "Write-off",
      "actionsLabel": "Write-off actions",
      "tabs": {
        "register": "Register",
        "report": "Report"
      },
      "columns": {
        "no": "Number",
        "date": "Date",
        "customer": "Customer"
      },
      "statuses": {
        "draft": "Draft",
        "submitted": "Submitted",
        "approved": "Approved",
        "posted": "Posted",
        "rejected": "Rejected",
        "reversed": "Reversed"
      },
      "flags": {
        "dual": "Two approvers",
        "committee": "Audit committee"
      },
      "reasons": {
        "insolvency": "Insolvency",
        "untraceable": "Customer untraceable",
        "uncollectable": "Uncollectable",
        "disputed": "Disputed",
        "statute_barred": "Statute barred",
        "other": "Other"
      },
      "fields": {
        "date": "Write-off date",
        "reasonCode": "Reason",
        "reasonCodeHint": "A controlled reason; the free text supplements it.",
        "reasonCodePlaceholder": "Choose a reason",
        "reason": "Explanation",
        "reasonHint": "Optional for every reason except Other.",
        "reasonRequired": "Required for the reason Other.",
        "totalBase": "Total in base currency",
        "status": "Status"
      },
      "lines": {
        "title": "Invoices written off",
        "description": "One line per posted invoice of this customer. Leave the amount empty to write off the whole balance still available.",
        "caption": "Invoices this write-off takes off the books",
        "invoice": "Invoice",
        "dates": "Invoice and due date",
        "balance": "Balance",
        "amount": "Amount",
        "estimate": "Base estimate",
        "base": "Base amount",
        "taxRelief": "Tax relief",
        "notices": "Dunning notices",
        "remove": "Remove",
        "pick": "Choose an invoice",
        "wholeBalance": "Whole balance",
        "add": "Add an invoice",
        "noInvoices": "This customer has no posted invoice with a balance.",
        "optionHint": "Due {due} · balance {currency} {balance}",
        "issues": {
          "badAmount": "Enter an amount greater than zero.",
          "overBalance": "More than the invoice still owes."
        }
      },
      "preview": {
        "title": "Posting preview",
        "description": "How the write-off would split between the customer's own ECL provision and bad-debt expense.",
        "empty": "Choose a customer and an invoice to see the split.",
        "total": "Total written off",
        "provision": "Against the ECL provision",
        "expense": "Bad-debt expense",
        "unavailable": "The customer's provision is not held in this currency, so no split is estimated here. The server fixes the split when the write-off is posted.",
        "estimateNote": "An estimate. The server fixes the real split when the write-off is posted, from the allowance the ledger holds that day, and never uses more provision than the customer has.",
        "taxReliefOn": "Output tax on the written-off balance is relieved for this legal entity.",
        "taxReliefOff": "Output tax is not relieved for this legal entity.",
        "taxRelief": "Tax relief",
        "provisionAvailable": "Customer provision available",
        "notAvailable": "The split could not be previewed for these lines. It is fixed when the write-off is posted."
      },
      "posting": {
        "title": "Posting",
        "provision": "Charged to the ECL allowance",
        "expense": "Charged to bad-debt expense",
        "taxRelief": "Output tax relieved",
        "journal": "Journal",
        "openJournal": "Open the journal",
        "reversalJournal": "Reversal journal"
      },
      "evidence": {
        "title": "Evidence of collection effort",
        "description": "A document attached to the write-off and a dunning notice on record for every invoice written off, both, before it can be submitted.",
        "met": "Met",
        "missing": "Missing",
        "attachments": "{count} document(s) attached",
        "dunning": "A dunning notice is on record for every invoice.",
        "withoutDunning": "No notice yet for:",
        "toDunning": "Open dunning",
        "requirement": "Attach the evidence of collection effort: correspondence, a legal notice, a trace report.",
        "saveFirst": "Save the draft first, then attach the evidence."
      },
      "hands": {
        "title": "Who did what",
        "description": "The proposer, the approvers, and the person who posted are different people.",
        "proposedBy": "Proposed by",
        "submittedBy": "Submitted by",
        "approver1": "First approver",
        "approver2": "Second approver",
        "postedBy": "Posted by",
        "reversedBy": "Reversed by",
        "reverseReason": "Reversal reason"
      },
      "actions": {
        "save": "Save draft",
        "submit": "Submit for approval",
        "submitting": "Submitting",
        "post": "Post write-off",
        "posting": "Posting",
        "reverse": "Reverse"
      },
      "blockers": {
        "noCustomer": "Choose a legal entity and a customer.",
        "noReason": "Choose a reason.",
        "reasonText": "The reason Other needs an explanation.",
        "noLines": "Add at least one invoice.",
        "badAmount": "Fix the highlighted amount.",
        "overBalance": "An amount is more than its invoice still owes."
      },
      "submitBlockers": {
        "unsaved": "Save your changes first.",
        "evidence": "Attach a document and make sure every invoice has a dunning notice on record before submitting."
      },
      "postBlocked": {
        "proposer": "You proposed this write-off, so you cannot post it. Somebody else with the post permission must.",
        "submitter": "You submitted this write-off, so you cannot post it. Somebody else with the post permission must.",
        "approver": "You approved this write-off, so you cannot post it. Somebody who took no part in approving it must."
      },
      "reverseBlocked": {
        "poster": "You posted this write-off, so you cannot reverse it. Somebody else with the post permission must."
      },
      "toasts": {
        "saved": "Write-off saved",
        "savedDetail": "The draft is saved. Attach the evidence, then submit it.",
        "saveFailed": "The write-off could not be saved",
        "submitted": "Write-off {no} submitted",
        "submittedDetail": "It is now with its approvers.",
        "submitFailed": "The write-off could not be submitted",
        "lapsed": "Write-off closed, not posted",
        "posted": "Write-off {no} posted",
        "postedDetail": "The receivable has been taken off the books.",
        "postFailed": "The write-off could not be posted",
        "reversed": "Write-off {no} reversed",
        "reversedDetail": "The invoices carry their balance again."
      },
      "reverse": {
        "title": "Reverse this write-off",
        "description": "Write-off {no} is reversed by a mirror journal; the invoices carry their balance again.",
        "restores": "Puts this receivable back on the books:",
        "reason": "Reason",
        "reasonHint": "Required: a reversal puts a receivable back on the books.",
        "date": "Reversal date",
        "dateHint": "Not before the write-off ({date}).",
        "dateTooEarly": "Cannot be dated before the write-off ({date}).",
        "action": "Reverse write-off"
      },
      "report": {
        "title": "Write-off report",
        "pickEntity": "Choose one legal entity to see its write-off report.",
        "from": "From",
        "to": "To",
        "status": "Status",
        "postedDefault": "Posted (default)",
        "loadFailed": "Could not load the write-off report",
        "total": "Total",
        "committee": "Above the committee threshold",
        "byReason": "Write-offs by reason",
        "count": "Count",
        "empty": "No write-offs in this window.",
        "rows": "Write-offs in the window",
        "hands": "People",
        "journal": "Journal"
      }
    },
    "writeOffSettings": {
      "title": "Write-off thresholds",
      "description": "Above the dual threshold a write-off needs two distinct approvers; above the committee threshold it is reported to the audit committee.",
      "toWriteOffs": "Write-offs",
      "entityTitle": "Legal entity",
      "loadFailed": "Could not load the write-off settings",
      "unconfigured": "This legal entity has no write-off settings yet. Thresholds you set now apply at once, because nothing is in force to loosen.",
      "stale": "Somebody else changed these settings while you had them open. Nothing was overwritten. Reload and apply your change again.",
      "reload": "Reload",
      "noThreshold": "No threshold",
      "formTitle": "Thresholds and accounts",
      "loosening": "This raises or removes a threshold, so write-offs would pass with less scrutiny. It is requested, not applied: it takes effect only when a second person approves it.",
      "tightening": "This lowers a threshold or sets one where there was none. It applies at once, and withdraws any loosening still waiting.",
      "actionsLabel": "Write-off settings actions",
      "readOnly": "You can read these settings but not change them.",
      "pending": {
        "title": "A change is waiting for approval",
        "description": "These thresholds are not in force yet. The ones below are still the ones that apply.",
        "badge": "Pending",
        "requestedBy": "Requested by",
        "yours": "You requested this, so you cannot approve it. Another approver must decide it.",
        "theirs": "A second person with the approve permission decides it.",
        "toApprovals": "Open the Approvals Inbox"
      },
      "fields": {
        "dual": "Dual-approval threshold",
        "dualHint": "In {currency}. A write-off above this needs two distinct approvers. Empty means none does.",
        "committee": "Audit-committee threshold",
        "committeeHint": "In {currency}. A write-off above this is reported to the audit committee. Empty means none is.",
        "badDebt": "Bad-debt expense account",
        "badDebtHint": "Where the part the ECL provision does not cover is charged. Empty uses the ECL expense account.",
        "badDebtPlaceholder": "ECL expense account",
        "taxRelief": "Relieve output tax",
        "taxReliefHint": "Relieve the output tax on a written-off balance where the jurisdiction allows it."
      },
      "actions": {
        "save": "Save",
        "request": "Request change"
      },
      "blockers": {
        "invalid": "A threshold must be an amount of at least zero, or empty.",
        "nothing": "Nothing has changed.",
        "pendingExists": "A loosening is already waiting for approval. It must be decided, or withdrawn by lowering a threshold, before another is requested."
      },
      "toasts": {
        "requested": "Change requested",
        "requestedDetail": "It takes effect only when a second person approves it.",
        "saved": "Settings saved",
        "savedDetail": "The thresholds apply to write-offs submitted from now on.",
        "saveFailed": "The settings could not be saved"
      }
    },
    "delivery": {
      "title": "Delivery",
      "description": "How this invoice reaches the customer, and where its delivery stands.",
      "channel": "Delivery channel",
      "channelHint": "Delivering by another channel is a new attempt.",
      "channelHintConfirmed": "Post & Deliver posts the invoice, then sends it by this channel.",
      "channelPlaceholder": "Choose a channel",
      "draftChannelHint": "How the posted invoice is to reach the customer.",
      "storedChannel": "Channel on the invoice",
      "none": "None chosen",
      "status": "Delivery status",
      "attempts": "Attempts",
      "lastAttempt": "Last attempt",
      "sentAt": "Sent",
      "deliveredAt": "Delivered",
      "reference": "Dispatch reference",
      "referenceHint": "A courier consignment or posting slip number, recorded with a delivery by post.",
      "lastError": "Last error:",
      "waiting": "An email leaves once the invoice PDF has been rendered. Refresh to see where it stands.",
      "delivering": "Delivering",
      "chooseChannel": "Choose a delivery channel to post and deliver.",
      "postedNotDelivered": "The invoice is posted, but its delivery did not complete. Fix the cause and deliver it again below.",
      "channels": {
        "email": "Email",
        "portal": "Customer portal",
        "post": "Post",
        "einvoice": "E-invoice"
      },
      "statuses": {
        "pending": "Pending",
        "sent": "Sent",
        "delivered": "Delivered",
        "failed": "Failed"
      },
      "actions": {
        "postAndDeliver": "Post & Deliver",
        "deliver": "Deliver",
        "retry": "Retry delivery",
        "deliverBy": "Deliver by {channel}",
        "refresh": "Refresh"
      },
      "toasts": {
        "postedNotDelivered": "Posted, but not delivered",
        "deliverFailed": "The invoice could not be delivered",
        "failed": "Delivery failed",
        "pending": "Delivery requested by {channel}",
        "sent": "Sent by {channel}",
        "delivered": "Delivered by {channel}",
        "recorded": "The outcome is recorded on the invoice."
      }
    },
    "reallocation": {
      "title": "Reallocate",
      "description": "Move money from one invoice to another on receipt {receiptNo}. The original allocation stays in the history.",
      "from": "Take it from",
      "fromPlaceholder": "Choose an allocation",
      "to": "Move it to",
      "toHint": "Open invoices of this customer in the receipt's currency, with what each still owes.",
      "toPlaceholder": "Choose an invoice",
      "noDestination": "This customer has no other open invoice in this currency to move the money to.",
      "amount": "Amount",
      "amountHint": "Leave empty to move everything the allocation holds.",
      "amountHintOpen": "Leave empty to move all {currency} {open}.",
      "date": "Date",
      "dateHint": "Not before {date}, not in the future, and in an open period.",
      "reason": "Reason",
      "reasonHint": "Required: moving money between invoices is a decision somebody owns.",
      "summary": "Moves",
      "action": "Reallocate",
      "openHint": "{currency} {open} open",
      "availableHint": "{currency} {balance} owed",
      "blockers": {
        "badAmount": "Enter an amount greater than zero.",
        "overSource": "More than the allocation holds.",
        "overDestination": "More than the destination invoice still owes.",
        "dateTooEarly": "The date is earlier than the receipt, an entry already on its history, or the destination invoice.",
        "dateInFuture": "A reallocation cannot be dated in the future."
      },
      "historyTitle": "Allocation history",
      "historyDescription": "Every allocation, reversal and reallocation of this receipt, oldest first. Nothing is edited or removed.",
      "historyLoadFailed": "Could not load the allocation history",
      "historyEmpty": "Nothing has been allocated from this receipt yet.",
      "historyCaption": "The receipt's allocation ledger, with reversals as negative rows",
      "columns": {
        "entry": "Entry",
        "open": "Still open",
        "fx": "Realised FX",
        "who": "By",
        "actions": "Actions"
      },
      "kinds": {
        "allocation": "Allocation",
        "reversal": "Reversal",
        "reallocation": "Reallocation"
      },
      "movedTo": "Moved to {invoice}",
      "movedFrom": "Moved from {invoice}",
      "journal": "Journal",
      "done": "Reallocated.",
      "fxNet": "net FX {amount}",
      "open": "Reallocate money"
    },
    "eclSettings": {
      "title": "Expected credit loss settings",
      "description": "Which accounts an ECL run posts to, how unapplied credit reduces exposure, and whether ECL is switched on — per legal entity.",
      "chooseCompanyTitle": "Choose a legal entity",
      "chooseCompanyDescription": "ECL is configured separately for each legal entity. Choose one above to see or change its settings.",
      "loadFailed": "ECL settings could not be loaded",
      "unconfigured": "ECL has never been configured for this legal entity. Until an allowance and an expense account are saved here, a run can be calculated but never posted.",
      "disabledNote": "ECL is switched off for this legal entity. Runs can be calculated, but posting stays blocked until it is switched on.",
      "stale": "Somebody else changed these settings while you were editing. Reload the saved version, then reapply your changes.",
      "reload": "Reload the saved version",
      "noChart": "You cannot read the chart of accounts, so no account can be chosen here. Ask for the chart of accounts read permission.",
      "accountsTitle": "Posting accounts",
      "accountsDescription": "A run posts only the movement in the allowance: debit the expense account, credit the allowance account — or the reverse when the allowance falls.",
      "fields": {
        "allowance": "Allowance account",
        "expense": "Impairment expense account",
        "creditApplication": "Unapplied credit",
        "enabled": "ECL enabled"
      },
      "hints": {
        "allowance": "The contra-receivable the allowance is held in. It must be a postable account of this legal entity.",
        "expense": "Where the charge or release lands in profit and loss. It must be a postable account of this legal entity.",
        "creditApplication": "How a customer's unapplied credit reduces the exposure that is provisioned.",
        "enabled": "Off means runs can still be calculated for review but cannot be posted."
      },
      "notConfigured": "Not configured",
      "creditApplications": {
        "oldest_first": "Against the oldest balance first",
        "newest_first": "Against the newest balance first",
        "pro_rata": "Spread across buckets pro rata",
        "none": "Do not offset credit"
      },
      "actionsLabel": "ECL settings actions",
      "auditNote": "Every save is recorded in the audit trail with the values before and after.",
      "readOnlyNote": "You can see these settings read-only. Changing them needs the ECL manage permission.",
      "saved": "ECL settings saved",
      "savedDetail": "The next run uses these accounts. Runs already posted are not changed.",
      "saveFailed": "ECL settings could not be saved"
    },
    "customerCredit": {
      "creditControlLink": "Credit control",
      "onHold": "On credit hold: new invoices, orders and deliveries are blocked until the hold is released.",
      "noHold": "Not on credit hold."
    },
    "creditControl": {
      "title": "Credit control",
      "description": "Credit limit, exposure, overdue and available credit by customer, with hold, release and limit changes.",
      "company": "Legal entity",
      "filters": {
        "onHold": "On hold only",
        "overLimit": "Over limit only"
      },
      "tableTitle": "Credit exposure",
      "tableDescription": "Figures are customer-wide and in the credit limit's currency: the same figures the credit check uses.",
      "loadFailed": "Could not load credit exposure",
      "empty": "No customers yet. Customers appear here once they are created.",
      "emptyFiltered": "No customer matches these filters. Clear a filter to see more.",
      "caption": "Credit exposure by customer",
      "columns": {
        "hold": "Credit state"
      },
      "states": {
        "onHold": "On hold",
        "overLimit": "Over limit",
        "clear": "Clear"
      },
      "sources": {
        "manual": "Placed by a person",
        "dunning": "Placed by dunning",
        "limit": "Placed by a limit reduction"
      },
      "stale": "This customer changed since the list loaded. The list has been reloaded; check the figures and submit again.",
      "reasonHint": "Required, and recorded in the audit log against your name.",
      "hold": {
        "title": "Place on credit hold",
        "description": "New invoices, sales orders, shipments and account sales for {customer} will be refused until the hold is released. Sales owners are notified.",
        "reasonLabel": "Why is this customer being placed on hold?",
        "action": "Place on hold",
        "doneTitle": "Credit hold placed",
        "doneDetail": "{customer} is on credit hold."
      },
      "release": {
        "title": "Release credit hold",
        "description": "{customer} will be able to receive new invoices, orders and deliveries again.",
        "reasonLabel": "Why is the hold being released?",
        "action": "Release hold",
        "sodNote": "A hold a person placed must be released by somebody else. A hold placed by dunning or a limit reduction can be released by anyone allowed to release holds.",
        "doneTitle": "Credit hold released",
        "doneDetail": "{customer} is no longer on credit hold."
      },
      "limit": {
        "open": "Credit limit",
        "title": "Credit limit",
        "description": "Request a new credit limit for {customer}. It applies only once somebody other than you approves it.",
        "submitted": "Request sent for approval:",
        "pendingExists": "A credit limit change for this customer is already awaiting approval. It must be decided before another can be requested.",
        "compareCaption": "Credit limit and headroom before and after the requested change",
        "before": "Now",
        "after": "Requested",
        "projectionNote": "Headroom after the change is the requested limit less today's exposure. The server recalculates the position when the change is approved.",
        "newLimit": "New credit limit ({currency})",
        "newLimitHint": "Zero removes the limit. Up to two decimals.",
        "invalid": "Enter an amount of zero or more, with up to two decimals.",
        "reasonLabel": "Why should the limit change?",
        "noPermission": "Requesting a credit limit change needs the credit limit request permission, which you do not hold.",
        "historyTitle": "Limit change requests",
        "historyFailed": "Could not load the limit change requests",
        "historyEmpty": "No limit change has been requested for this customer.",
        "requestedAt": "Requested",
        "statuses": {
          "pending": "Awaiting approval",
          "applied": "Applied",
          "rejected": "Rejected"
        },
        "action": "Request the change",
        "doneTitle": "Credit limit change requested",
        "doneDetail": "The request has gone to the approval chain. The limit changes when it is approved."
      }
    },
    "dunningLevels": {
      "title": "Dunning levels",
      "description": "The escalation schedule: how overdue an invoice must be for each notice, by which channel, and which level is final.",
      "add": "Add level",
      "loadFailed": "Could not load the dunning levels",
      "empty": "No dunning levels are set up, so the cycle sends nothing.",
      "emptyManage": "No dunning levels are set up, so the cycle sends nothing. Add the first level to start chasing overdue invoices.",
      "fields": {
        "levelNo": "Level",
        "code": "Code",
        "name": "Name",
        "minDaysOverdue": "Days overdue",
        "channel": "Channel",
        "template": "Template",
        "isFinal": "Final level",
        "isActive": "Active"
      },
      "hints": {
        "minDaysOverdue": "An invoice reaches this level once it is at least this many days past due.",
        "template": "The notice template to send. Leave empty for the default.",
        "isFinal": "A notice at the final level places the customer on credit hold. Only the highest level can be final.",
        "isActive": "An inactive level is skipped by the cycle. A level that has sent notices can be deactivated but not deleted."
      },
      "channels": {
        "email": "Email",
        "phone": "Phone"
      },
      "final": "Final",
      "inUse": "In use",
      "createTitle": "Add dunning level",
      "editTitle": "Edit dunning level",
      "dialogDescription": "Levels must escalate: a higher level needs more days overdue than the one below it.",
      "stale": "Somebody else changed this level while you were editing. Reload the saved version, then reapply your changes.",
      "reload": "Reload the saved version",
      "savedTitle": "Dunning level saved",
      "savedDetail": "{name} is saved. The next run uses it.",
      "deletedTitle": "Dunning level deleted",
      "deletedDetail": "{name} has been removed from the schedule.",
      "deleteFailed": "Could not delete the dunning level",
      "deleteTitle": "Delete dunning level",
      "deleteMessage": "{name} will be removed from the schedule. This cannot be undone."
    },
    "dunningRun": {
      "pageDescription": "The dunning schedule, a run with preview, the notices sent and the responses received, and who is paused.",
      "effectivenessLink": "Dunning effectiveness",
      "creditControlLink": "Credit control",
      "pauseCustomerLabel": "Pause a customer",
      "title": "Run dunning",
      "description": "Preview what the cycle would send, then send exactly that. The worker also runs it nightly. Running it again is safe: a notice already sent for a level is skipped.",
      "noPermission": "Running dunning needs the dunning manage permission, which you do not hold.",
      "asOfHint": "Which day the run treats as today. A preview can look ahead; a real run cannot be dated after today.",
      "levelsLegend": "Levels",
      "noActiveLevels": "No active dunning level. Add or activate one above.",
      "levelsHint": "None ticked means every active level.",
      "customersLabel": "Customers",
      "customersHint": "None chosen means every customer.",
      "removeCustomer": "Remove {customer}",
      "previewAction": "Preview",
      "commitAction": "Send {count} notice(s)",
      "futureNote": "This date is after today. You can preview it, but a real run cannot be sent for a future date.",
      "result": "Run for {on}: {noticed} notice(s) sent, {skipped} skipped.",
      "previewSummary": "Preview for {on}: {noticed} notice(s) would be sent, {skipped} skipped. Nothing has been sent yet.",
      "totalLine": "{count} notice(s) chasing",
      "finalWarning": "{count} notice(s) are at a final level. Sending them places those customers on credit hold.",
      "nothingToSend": "Nothing would be sent for this selection.",
      "noticesCaption": "Notices this run would send",
      "columns": {
        "recipient": "Recipient",
        "daysOverdue": "Days overdue",
        "amountDue": "Amount due",
        "nextAction": "Next action"
      },
      "placesHold": "Places hold",
      "skipsCaption": "Invoices this run would skip",
      "skipReasons": {
        "customer_paused": "Customer's dunning is paused",
        "no_recipient": "No recipient on file for this channel",
        "already_sent": "Already sent at this level"
      },
      "doneTitle": "Dunning run finished",
      "doneDetail": "{noticed} notice(s) sent, {skipped} skipped."
    },
    "dunningEvents": {
      "title": "Notices sent",
      "description": "Every notice with its level, channel and recipient, the customer's recorded response and whether a payment followed.",
      "filters": {
        "response": "Response",
        "responded": "Responded or paid",
        "unanswered": "No response and not paid"
      },
      "loadFailed": "Could not load the notices",
      "empty": "No notice matches these filters. Notices appear here once a run has sent them.",
      "caption": "Dunning notices sent",
      "columns": {
        "sentOn": "Sent",
        "response": "Response",
        "paid": "Paid"
      },
      "responses": {
        "promise_to_pay": "Promise to pay",
        "dispute": "Dispute",
        "no_response": "No response",
        "other": "Other"
      },
      "promisedFor": "Promised for {date}",
      "noResponseYet": "Nothing recorded",
      "respond": {
        "open": "Record response",
        "title": "Record the customer's response",
        "description": "{customer}, invoice {invoice}.",
        "noticeLine": "{level} notice sent {on} for",
        "responseLabel": "What did the customer say?",
        "promisedDate": "Promised payment date",
        "promisedDateHint": "Required. When the customer said they would pay; not before today.",
        "action": "Record response",
        "doneTitle": "Response recorded",
        "doneDetail": "The response to the notice for {invoice} is recorded.",
        "promisedDateRequired": "Enter the date the customer promised to pay.",
        "promisedDatePast": "The promised date cannot be before today.",
        "promisedAmount": "Promised amount",
        "promisedAmountHint": "Optional. Leave empty to promise the invoice's whole balance.",
        "promisedAmountInvalid": "Enter a positive amount, for example 1250.50."
      },
      "promisedAmountFor": "Promised amount",
      "promiseStatus": {
        "open": "Promise open",
        "kept": "Promise kept",
        "broken": "Promise broken",
        "cancelled": "Promise cancelled"
      }
    },
    "dunningEffectiveness": {
      "title": "Dunning effectiveness",
      "description": "Response and recovery rate by dunning level and channel.",
      "toDunning": "Dunning",
      "sentHint": "Notices sent in this range.",
      "window": "Attribution window (days)",
      "windowHint": "How long after a notice a payment still counts as recovered by it. Empty uses the default.",
      "windowInvalid": "Enter a whole number of days from 1 to 365.",
      "tableTitle": "By level and channel",
      "windowLine": "Payments within {days} days of a notice count as recovered by it.",
      "loadFailed": "Could not load the dunning effectiveness report",
      "empty": "No notices were sent in this range.",
      "caption": "Dunning response and recovery by level, channel and currency",
      "columns": {
        "currency": "Currency",
        "sent": "Sent",
        "responded": "Responded",
        "noResponse": "No response",
        "paid": "Paid",
        "responseRate": "Response rate",
        "noticed": "Amount chased",
        "recovered": "Recovered",
        "recoveryRate": "Recovery rate"
      }
    },
    "creditRefusal": {
      "hold": {
        "title": "This customer is on credit hold",
        "body": "Nothing new can be confirmed for this customer, and a hold cannot be overridden on a single document. A hold is lifted by releasing it on the customer record.",
        "reasonLabel": "Hold reason"
      },
      "unresolvable": {
        "title": "No approval policy covers a credit override",
        "body": "A credit override has to be decided by an approver, and no approval policy is configured for it, so the request was refused rather than waived. An approval policy for credit overrides must be configured before this document can be confirmed over the limit."
      }
    }
  },
  "cash": {
    "filtersTitle": "Filters",
    "allCompanies": "All legal entities",
    "fields": {
      "company": "Legal Entity",
      "companyBase": "Legal entity's base currency",
      "code": "Code",
      "currency": "Currency"
    },
    "accounts": {
      "title": "Bank and cash accounts",
      "description": "Where the money is held, and the ledger account each one posts to.",
      "tableLabel": "Bank and cash accounts",
      "searchHint": "Matches code, name, bank and IBAN.",
      "loadFailed": "Those accounts did not load",
      "emptyTitle": "No bank or cash accounts yet",
      "emptyDescription": "Add the first account and map it to the asset account in the chart that already carries its balance.",
      "newTitle": "Add an account",
      "newDescription": "One ledger account backs one bank account — that is what makes their balances comparable.",
      "editTitle": "Edit account",
      "editDescription": "The ledger mapping and the currency are fixed once the account exists.",
      "detailDescription": "Bank or cash account, and the ledger account it maps to.",
      "detailsPanel": "Details",
      "kind": "Kind",
      "kinds": {
        "bank": "Bank",
        "bankHint": "Money held at a bank; statements can be imported for it.",
        "cash": "Cash",
        "cashHint": "A till or petty-cash float — real money, no bank, no statement."
      },
      "codeHint": "Short, stable, and never reused. It cannot be changed later.",
      "glAccount": "Ledger account",
      "glAccountHint": "The postable asset account this account's balance already sits in.",
      "glAccountPlaceholder": "Select an asset account",
      "currencyHint": "Fixed once the account exists — every posted figure depends on it.",
      "immutable": "The ledger mapping and the currency cannot be changed: every figure already posted through this account depends on them. To change either, add a new account and deactivate this one.",
      "bankName": "Bank",
      "branchName": "Branch",
      "accountNumber": "Account number",
      "accountNumberHint": "Stored encrypted. It is never shown again in full — only the last few characters, and only through an audited reveal.",
      "accountNumberEditHint": "Leave blank to keep the stored number unchanged.",
      "clearNumber": "Remove the stored account number",
      "iban": "IBAN",
      "swift": "SWIFT / BIC",
      "openingBalance": "Opening balance",
      "openingBalanceHint": "The balance this account carried on its opening date, in its own currency.",
      "openingDate": "Opening date",
      "openingInvalid": "That opening balance is not a number.",
      "createdAt": "Added",
      "active": "Active",
      "inactive": "Inactive",
      "numberPanel": "Account number",
      "numberPanelDescription": "Stored encrypted (AES-256-GCM). Only the masked value is ever returned; revealing the number is a separate, audited action.",
      "noNumber": "No account number stored",
      "revealDenied": "You do not hold the permission that reveals a stored account number.",
      "railSubtitle": "Held in {currency}",
      "railCreated": "Account added",
      "backToList": "All accounts",
      "lifecycleStatus": "Status",
      "lifecycle": {
        "draft": "Draft",
        "pending_approval": "Pending approval",
        "active": "Active",
        "suspended": "Suspended",
        "dormant": "Dormant",
        "closing": "Closing",
        "closed": "Closed"
      },
      "created": "Account added",
      "createdDetail": "{name} is ready to receive movements.",
      "saved": "Account saved",
      "savedDetail": "Changes to {name} have been recorded.",
      "saveFailed": "That account could not be saved"
    },
    "reveal": {
      "action": "Reveal",
      "title": "Reveal the stored account number",
      "subject": "Account: {name}",
      "consequence": "This decrypts a stored bank account number. The reveal is recorded in the audit log against your name, with the reason you give below.",
      "reasonLabel": "Why do you need it?",
      "reasonHint": "This sentence is the audit record. “Preparing the supplier payment file for March”, not “checking”.",
      "reasonRequired": "A reason is required — the audit row has to say why.",
      "masked": "Currently shown as",
      "confirm": "Reveal and record",
      "recorded": "Revealed once and recorded. Reopening this dialog will not show it again without a new, separately recorded reveal.",
      "autoHide": "It clears from this screen after {seconds} seconds.",
      "hide": "Hide it now",
      "failed": "That number could not be revealed",
      "stepUpRequired": "This action needs a recent second factor. Sign in again with your authenticator, then try once more.",
      "mfaNotEnrolled": "Revealing a stored account number requires two-factor authentication, which is not set up on your account.",
      "mfaLink": "Set it up in your profile"
    },
    "recurring": {
      "title": "Recurring cash items",
      "description": "Expected flows no invoice will ever be raised for — rent, instalments, tax. The forecast expands them.",
      "tableLabel": "Recurring cash items",
      "loadFailed": "Those items did not load",
      "emptyTitle": "No recurring cash items",
      "emptyDescription": "Add the payments and receipts that happen on a schedule but never produce a document, so the forecast can include them.",
      "emptyAction": "Add the first recurring item",
      "newTitle": "New recurring item",
      "editTitle": "Edit recurring item",
      "drawerDescription": "An expected flow the forecast expands.",
      "postsNothing": "This posts nothing to the ledger. It only tells the forecast to expect the money.",
      "direction": "Direction",
      "directionHint": "Whether the amount leaves the business or arrives.",
      "directions": {
        "inflow": "Money in",
        "outflow": "Money out"
      },
      "amount": "Amount",
      "cadence": "Repeats",
      "cadences": {
        "once": "Once",
        "weekly": "Weekly",
        "fortnightly": "Fortnightly",
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "annually": "Annually"
      },
      "nextDate": "Next occurrence",
      "nextDateHint": "The forecast expands forward from this date.",
      "endDate": "Stops after",
      "endDateHint": "Leave blank to repeat indefinitely.",
      "bankAccount": "Bank account",
      "bankAccountHint": "Which account the money moves through, when it is always the same one.",
      "anyAccount": "Any account",
      "notes": "Notes",
      "active": "Active",
      "inactive": "Inactive",
      "delete": "Delete",
      "deleted": "Item deleted",
      "deletedDetail": "{name} will no longer appear in the forecast.",
      "deleteFailed": "That item could not be deleted",
      "saved": "Item saved",
      "savedDetail": "{name} has been recorded.",
      "saveFailed": "That item could not be saved",
      "kind": "Kind",
      "reviewKind": "Review kind",
      "needsReview": "Needs review",
      "reviewHint": "This looked like a loan — choose its kind.",
      "kinds": {
        "other": "Other",
        "rent": "Rent",
        "payroll": "Payroll",
        "tax": "Tax",
        "utilities": "Utilities",
        "subscription": "Subscription",
        "loan": "Loan"
      },
      "loansFromSchedule": "Loans come from the debt schedule.",
      "toFacilities": "Open facilities",
      "useDebtSchedule": "Loan payments cannot be entered as recurring items. They come from the debt schedule under treasury facilities.",
      "toTreasuryForecasts": "Cash forecasts these items feed"
    },
    "acct": {
      "allLegalEntities": "All legal entities",
      "positionLink": "Treasury position",
      "reloaded": "Someone else changed this account while you were working. It has been reloaded — check the current state, then apply your change again.",
      "createdDraft": "{name} was saved as a draft. Submit it, then have it verified and activated by other people before it can move money.",
      "immutable": "The ledger mapping and the currency cannot be changed: every figure already posted through this account depends on them. To change either, add a new account and close this one.",
      "glAccountUniqueHint": "The postable asset account this account's balance sits in. No other bank account or wallet may use it — activation checks this.",
      "detailsFrozen": "The bank details were frozen when this account was submitted. To change the bank, branch, IBAN, SWIFT or account number, propose an amendment on the Amendments tab; another person decides it.",
      "tabs": {
        "label": "Account sections",
        "details": "Details",
        "amendments": "Amendments",
        "mandate": "Mandate",
        "profile": "Profile"
      },
      "bank": {
        "placeholder": "Select a bank from the register",
        "add": "Add a bank",
        "emptyCanAdd": "The bank register is empty. Add the bank this account is held at.",
        "emptyAskAdmin": "The bank register is empty. Ask someone who manages banks to add it.",
        "name": "Bank name",
        "bic": "BIC",
        "country": "Country",
        "countryHint": "Two-letter ISO code, for example MV.",
        "save": "Add to register",
        "unregistered": "Currently recorded as \"{name}\", which is not in the bank register."
      },
      "liquidity": {
        "title": "Liquidity classification",
        "fieldHint": "Whether this balance can be used freely. Anything other than unrestricted is excluded from available liquidity.",
        "unrestricted": "Unrestricted",
        "restricted": "Restricted",
        "pledged": "Pledged",
        "escrowed": "Escrowed",
        "trapped": "Trapped"
      },
      "liquidityHint": {
        "unrestricted": "Available for any payment.",
        "restricted": "Usable only for a stated purpose.",
        "pledged": "Held as security for a facility.",
        "escrowed": "Held on behalf of another party.",
        "trapped": "Cannot leave its jurisdiction or entity."
      },
      "fields": {
        "valueDateTolerance": "Value-date tolerance",
        "valueDateToleranceHint": "Days a bank's value date may differ from the booking date before the line is flagged (0–30).",
        "dormancyDays": "Dormancy period",
        "dormancyDaysHint": "Days without a movement before the account is marked dormant. 0 switches the check off (up to 3650).",
        "days": "{n} days",
        "dormancyOff": "Not checked",
        "lastMovement": "Last movement",
        "toleranceInvalid": "Enter a whole number of days from 0 to 30.",
        "dormancyInvalid": "Enter a whole number of days from 0 to 3650.",
        "statementStaleness": "Statement staleness (days)",
        "statementStalenessHint": "Days after a statement's closing date before it counts as late. A late statement needs a stated reason to be imported (1–31, default 2).",
        "stalenessInvalid": "Enter a whole number of days from 1 to 31."
      },
      "verification": {
        "title": "Verification",
        "unverified": "Unverified",
        "verified": "Verified",
        "failed": "Failed",
        "channel": "Verification channel",
        "verifiedAt": "Verified"
      },
      "channels": {
        "callback": "Call-back to the bank",
        "bank_letter": "Letter from the bank",
        "test_credit": "Test credit",
        "bank_portal": "Bank portal",
        "in_person": "In person"
      },
      "coolingOff": {
        "title": "Cooling-off until",
        "running": "Running",
        "elapsed": "Elapsed",
        "notStarted": "Starts when the details are verified"
      },
      "lifecycle": {
        "title": "Lifecycle",
        "description": "Each step is taken by a different person. The server checks every one.",
        "statusReason": "Reason",
        "activatedAt": "Activated",
        "closedAt": "Closed",
        "blockedLead": "This account cannot be activated yet:",
        "doneDetail": "{code} has been updated.",
        "submitted": "Submitted for approval",
        "verified": "Details verified",
        "activated": "Account activated",
        "reactivated": "Account reactivated",
        "suspended": "Account suspended"
      },
      "checklist": {
        "verified": "Details verified",
        "coolingOff": "Cooling-off elapsed",
        "mandate": "Active approved mandate (checked on activation)",
        "glControl": "Ledger account not shared (checked on activation)"
      },
      "actions": {
        "submit": "Submit",
        "verify": "Verify details",
        "activate": "Activate",
        "reactivate": "Reactivate",
        "suspend": "Suspend",
        "close": "Request close",
        "authoriseClose": "Authorise close"
      },
      "sod": {
        "recorderVerify": "You recorded this account, so another person must verify its details.",
        "activator": "You recorded or submitted this account, so another person must activate it."
      },
      "verify": {
        "title": "Verify the bank details",
        "description": "Confirm the details through a channel independent of whoever supplied them.",
        "reference": "Reference",
        "referenceHint": "What proves it: the call reference, the letter number, the test-credit transaction.",
        "coolingNote": "Verifying starts the cooling-off. The account can be activated only once it has elapsed.",
        "confirm": "Record verification"
      },
      "suspend": {
        "title": "Suspend the account",
        "description": "A suspended account cannot take part in transfers until it is reactivated.",
        "reason": "Reason"
      },
      "blockers": {
        "not_verified": "The bank details have not been verified.",
        "cooling_off": "The cooling-off period has not elapsed yet.",
        "no_active_mandate": "There is no active, approved mandate for this account.",
        "gl_control_shared": "Its ledger account is also used by another bank account or wallet.",
        "non_zero_balance": "The account still holds a balance.",
        "unreconciled_lines": "There are unreconciled statement lines.",
        "in_flight_transfers": "Transfers are still in flight.",
        "active_mandate": "A mandate is still active — end it first."
      },
      "close": {
        "requested": "Close requested",
        "requestedDetail": "{code} is now closing. Another person must authorise the close.",
        "authorised": "Account closed",
        "authorisedDetail": "{code} has been closed.",
        "requestTitle": "Request to close the account",
        "requestDescription": "The account moves to closing now and stops taking part in transfers. A second person authorises the close.",
        "authoriseTitle": "Authorise closing the account",
        "authoriseDescription": "The close is refused while the account holds a balance, has unreconciled lines, transfers in flight or an active mandate.",
        "consequence": "Once requested, the account cannot be used for transfers unless it is reactivated.",
        "reason": "Reason for closing",
        "reasonHint": "This is recorded in the audit trail.",
        "requestedAt": "Requested",
        "ownRequest": "You requested this close, so another person must authorise it.",
        "blockedLead": "The account cannot be closed yet:",
        "request": "Request close",
        "authorise": "Authorise close",
        "pending": "A close has been requested: {reason}"
      },
      "amend": {
        "listTitle": "Amendments",
        "listDescription": "Changes to the bank details of a live account. Each is decided by someone other than the person who proposed it.",
        "loadFailed": "The amendments did not load",
        "empty": "No amendments yet.",
        "emptyDraft": "While the account is a draft or pending approval, edit its details directly.",
        "requestedAt": "Proposed",
        "changes": "Changes",
        "reason": "Reason",
        "reasonHint": "Why the details are changing, and on what evidence.",
        "review": "Review",
        "status": {
          "pending": "Pending",
          "approved": "Approved",
          "rejected": "Rejected"
        },
        "proposeTitle": "Propose an amendment",
        "proposeDescription": "Change the bank details. Another person compares the two columns and decides.",
        "decideTitle": "Decide the amendment",
        "decideDescription": "Compare what the account says now with what it would say.",
        "consequence": "Approval applies the change, resets verification and the cooling-off, and suspends the account until it is verified again.",
        "diffCaption": "Current and proposed bank details",
        "field": "Field",
        "current": "Current",
        "proposed": "Proposed",
        "unchanged": "Unchanged",
        "numberPlaceholder": "Leave blank to keep the current number",
        "noChanges": "Change at least one field to propose an amendment.",
        "makerReason": "Reason given",
        "ownProposal": "You proposed this amendment, so another person must decide it.",
        "decisionReason": "Decision note",
        "decisionReasonHint": "Required when rejecting.",
        "rejectReasonRequired": "Say why the amendment is rejected.",
        "propose": "Propose",
        "approve": "Approve",
        "reject": "Reject",
        "proposedToast": "Amendment proposed",
        "proposedDetail": "Another person must now decide it.",
        "approved": "Amendment approved — the account is suspended until it is verified again",
        "rejected": "Amendment rejected",
        "requiredHint": "This account is past draft: its bank details change through an amendment on the Amendments tab."
      },
      "profile": {
        "title": "Treasury profile",
        "description": "How treasury counts this account: its type, limits, blocked amounts, clearing and pooling.",
        "denied": "You do not hold the permission that reads treasury settings.",
        "loadFailed": "The treasury profile did not load",
        "notAmount": "That is not an amount.",
        "saved": "Treasury profile saved",
        "inForce": "in force",
        "minimumAwaiting": "Awaiting approval",
        "minimumPendingBy": "requested by {by}",
        "minimumPendingNote": "A lowering to {amount} {currency} is waiting for a second person. The minimum in force does not change until it is approved.",
        "minimumReason": "Reason for lowering the minimum",
        "minimumReasonHint": "Lowering the minimum loosens the line a breach is measured against, so a second person must approve it. A raise applies at once.",
        "savedPending": "Treasury profile saved"
      },
      "mandate": {
        "title": "Mandates",
        "description": "Who may sign for this account. Mandates are recorded and approved in the mandate register.",
        "register": "Open the mandate register",
        "denied": "You do not hold the permission that reads mandates.",
        "loadFailed": "The mandates did not load",
        "empty": "No mandate recorded for this account. An active, approved mandate is needed before it can be activated.",
        "rule": "Signing rule",
        "band": "Amount band",
        "window": "Effective",
        "signatories": "Current signatories",
        "noCeiling": "no ceiling",
        "approval": {
          "pending_approval": "Pending approval",
          "approved": "Approved"
        }
      }
    },
    "queue": {
      "transit_break_item": "A transfer has been in transit longer than allowed.",
      "bank_limit_breach_item": "This bank holds more than its counterparty limit allows."
    }
  },
  "bankrec": {
    "filtersTitle": "Filters",
    "routeTitles": {
      "sessions": "Bank reconciliation",
      "session": "Reconciliation",
      "imports": "Bank statements",
      "import": "Bank statement",
      "profiles": "Statement mapping profiles",
      "importLines": "Statement lines"
    },
    "nav": {
      "label": "Bank reconciliation sections",
      "sessions": "Reconciliations",
      "imports": "Statements",
      "profiles": "Mapping profiles"
    },
    "accountTypes": {
      "ASSET": "Asset",
      "LIABILITY": "Liability",
      "EQUITY": "Equity",
      "INCOME": "Income",
      "EXPENSE": "Expense"
    },
    "sessions": {
      "title": "Bank reconciliation",
      "description": "Every reconciliation run on a bank account — the open one being worked, and the closed ones that tied out.",
      "tableLabel": "Reconciliation sessions",
      "loadFailed": "Those reconciliations did not load",
      "emptyTitle": "No reconciliations yet",
      "emptyDescription": "Import a bank statement, then open a reconciliation over the dates it covers. The session is where the statement and the ledger are brought into agreement."
    },
    "session": {
      "headerTitle": "Reconciling {account}",
      "headerDescription": "The bank's statement and the ledger, over {from} to {to}.",
      "railTitle": "Reconciliation {from} to {to}",
      "loadFailed": "That reconciliation did not load",
      "backToList": "All reconciliations",
      "accountById": "Bank account #{id}",
      "statusOpen": "Open",
      "statusClosed": "Closed",
      "opened": "Opened",
      "closed": "Closed",
      "reopened": "Reopened",
      "standingTitle": "Where this stands",
      "closedTitle": "Closed on these figures",
      "openingStatement": "Opening (statement)",
      "expectedClosing": "Closing the statement implies",
      "linesMatched": "Statement lines matched",
      "unmatchedStatement": "Unmatched on the statement",
      "unmatchedLedger": "Unmatched in the ledger",
      "unexplained": "Unexplained difference",
      "balancedHelp": "Nothing is outstanding on either side. The statement and the ledger account for the same money over this window.",
      "unbalancedHelp": "{statementCount} statement line(s) and {ledgerCount} ledger line(s) are still unmatched. The difference above is what they come to.",
      "newTitle": "Open a reconciliation",
      "newDescription": "One bank account, one window of dates. An account can have only one reconciliation open at a time.",
      "bankAccount": "Bank account",
      "bankAccountHint": "Only bank accounts appear: a cash float has no statement to reconcile.",
      "bankAccountPlaceholder": "Select a bank account",
      "fromDate": "From",
      "fromDateHint": "The first day the statement covers.",
      "toDate": "To",
      "toDateHint": "The last day the statement covers. Both balances are struck at this date.",
      "openingBalance": "Opening balance per the statement",
      "openingBalanceIn": "Opening balance per the statement ({currency})",
      "openingBalanceHint": "What the bank says the account held on the first day — not what the ledger says. Finding out why they differ is the point.",
      "openingNotANumber": "That opening balance is not a number.",
      "note": "Note",
      "create": "Open reconciliation",
      "created": "Reconciliation opened",
      "createdDetail": "Match the statement lines against the ledger, then close it.",
      "createFailed": "That reconciliation could not be opened",
      "alreadyOpen": "This bank account already has an open reconciliation. Finish or reopen that one first.",
      "columns": {
        "period": "Period",
        "account": "Bank account",
        "opening": "Opening",
        "closingStatement": "Closing (statement)",
        "closingLedger": "Closing (ledger)"
      }
    },
    "workspace": {
      "statementTitle": "What the bank said",
      "statementDescription": "Lines exactly as imported. Nothing here can be edited.",
      "ledgerTitle": "What the books say",
      "ledgerDescription": "Journal lines on this bank account's own ledger account, in this window.",
      "linesFailed": "The statement lines did not load",
      "ledgerFailed": "The ledger lines did not load",
      "showMatched": "Show lines already matched",
      "toImports": "Statements imported for this account",
      "matchSelected": "Match the two selected lines",
      "manualHelp": "No suggestion worth taking? Select one line on each side and match them by hand — it is recorded as a manual match, which is what it is.",
      "noStatementLines": "Nothing outstanding on the statement",
      "noStatementLinesHelp": "Every line the bank reported in this window has been matched or explained.",
      "noLedgerLines": "Nothing outstanding in the ledger",
      "noLedgerLinesHelp": "Every posting on this account in this window has been matched to a statement line."
    },
    "line": {
      "valueDate": "Value date",
      "reference": "Reference",
      "narrative": "Narrative",
      "amount": "Amount",
      "matched": "Matched",
      "unmatched": "Unmatched",
      "noDescription": "No narrative on this line",
      "noReference": "No reference",
      "entry": "Entry #{id}"
    },
    "suggestions": {
      "title": "Why this might be a match",
      "description": "Ranked by the engine. Nothing is applied until you say so.",
      "pickTitle": "Select a statement line",
      "pickDescription": "Choose a line on the left and the engine will look for the posting that explains it — by reference first, then by amount and date, then by counterparty name.",
      "deniedTitle": "Suggestions are not available to you",
      "deniedDescription": "You can still match a statement line to a ledger line by hand by selecting one on each side.",
      "loadFailed": "The suggestions did not load",
      "emptyTitle": "Nothing in the ledger matches this line",
      "emptyDescription": "No posting on this account has the same amount. If the bank moved this money without a document — a charge, interest — post the entry the ledger is missing.",
      "neverAutomatic": "Nothing below has been applied. A match claims both lines exclusively, so it is only ever made by pressing a button.",
      "rank": "Ranking score {percent}%",
      "confirm": "Confirm this match"
    },
    "tiers": {
      "exact_reference": "Same reference",
      "exact_referenceWhy": "The bank and the ledger quote the same reference, and the amounts are equal to the cent. This is the strongest claim the engine makes.",
      "amount_date": "Amount and date",
      "amount_dateWhy": "The amounts are equal to the cent and the dates are {days} day apart. Nothing links them beyond that — check it is not a second, similar payment. | The amounts are equal to the cent and the dates are {days} days apart. Nothing links them beyond that — check it is not a second, similar payment.",
      "fuzzy_name": "Similar name",
      "fuzzy_nameWhy": "The amounts are equal and the counterparty names resemble each other, {days} day apart. Names are the weakest evidence here — read the narrative before accepting. | The amounts are equal and the counterparty names resemble each other, {days} days apart. Names are the weakest evidence here — read the narrative before accepting.",
      "manual": "Chosen by hand",
      "manualWhy": "Someone paired these two lines themselves.",
      "created": "Posted from this line",
      "createdWhy": "The ledger had no entry for this, so one was posted from the statement line."
    },
    "match": {
      "matching": "Matching",
      "matched": "Matched",
      "matchedDetail": "The statement line and the posting are now linked, and both are locked to this reconciliation.",
      "failed": "That match could not be made",
      "alreadyMatched": "That line is already matched",
      "alreadyMatchedDetail": "Someone matched it first, or this screen was out of date. It has been refreshed.",
      "release": "Release",
      "releasing": "Releasing",
      "released": "Match released",
      "releasedDetail": "Both lines are outstanding again.",
      "releaseFailed": "That match could not be released",
      "recentTitle": "Matched in this visit",
      "recentDescription": "Release one here if it was a misclick. To undo a match from an earlier visit, reopen the reconciliation — which is audited, as undoing a settled decision should be.",
      "recentLabel": "{date} matched to {entry}"
    },
    "missing": {
      "action": "Post the missing entry",
      "title": "Post the entry the ledger is missing",
      "description": "For money the bank moved that no document ever recorded — a charge, interest, a returned-cheque fee.",
      "postsForReal": "This posts a real journal into the ledger, now, and matches this statement line to it. It is not a reconciliation adjustment: it is the entry that should have been there, and it is undone the way any posted journal is — by reversing it.",
      "offsetAccount": "Post the other side to",
      "offsetHint": "The expense, income or liability account this belongs in. The bank's own account takes the opposite side.",
      "offsetPlaceholder": "Select an account",
      "offsetRequired": "Choose the account the other side of this entry belongs in.",
      "needsAccountRead": "You cannot read the chart of accounts, so there is no account to post the other side to. Ask for the permission that reads accounts.",
      "previewTitle": "What will be posted",
      "account": "Account",
      "debit": "Debit",
      "credit": "Credit",
      "bankAccount": "This bank account's ledger account",
      "confirm": "Post and match",
      "posting": "Posting",
      "posted": "Entry posted",
      "postedDetail": "The journal is in the ledger and this statement line is matched to it.",
      "failed": "That entry could not be posted"
    },
    "close": {
      "action": "Close reconciliation",
      "title": "Close this reconciliation",
      "description": "Both balances are struck at {date}.",
      "rule": "A reconciliation closes only when the statement's closing balance and the ledger's own balance of this bank account agree to the cent. If they do not, nothing is closed and the difference is shown below.",
      "closingBalanceLabel": "Closing balance per the statement",
      "closingBalanceHint": "The figure printed on the statement, not the one you expect the ledger to hold.",
      "suggestedFrom": "The lines imported for this window add up to",
      "notANumber": "That closing balance is not a number.",
      "confirm": "Close reconciliation",
      "checking": "Checking the balances",
      "closed": "Reconciliation closed",
      "closedDetail": "The statement and the ledger agreed to the cent.",
      "failed": "That reconciliation could not be closed",
      "statementSays": "Statement at {date}",
      "ledgerSays": "Ledger at {date}",
      "difference": "Difference",
      "stillOpen": "{statementCount} statement line(s) and {ledgerCount} ledger line(s) are still unmatched.",
      "showUnmatched": "Show me what is unmatched",
      "certifyFirst": "Certify before closing",
      "needsCertificate": "This reconciliation has not been certified. A session closes only after someone other than the matcher certifies it.",
      "requestReopen": "Request a reopen"
    },
    "imports": {
      "title": "Bank statements",
      "description": "Statements imported per bank account. A statement is imported whole or not at all.",
      "uploadTitle": "Import a statement",
      "uploadDescription": "CSV through a saved mapping profile, or MT940.",
      "wholeFileRule": "A file this importer cannot read at all is refused and nothing is written — the refusal names the line and what was wrong with it. A file that reads but fails a check is kept but held in quarantine as a whole: its opening balance does not follow the last statement or its dates overlap one on record, a statement number is missing, the same file was imported before, its currency is not the account's, its lines do not add up, its account number is not this account's, or its checksum does not match. No line of a quarantined statement is matched or reconciled until a second person releases it.",
      "accountHint": "The account this statement belongs to. Lines are deduplicated per account.",
      "format": "Format",
      "formats": {
        "csv": "CSV",
        "csvHint": "Needs a saved mapping profile for this bank",
        "mt940": "MT940",
        "mt940Hint": "Carries its own structure and balances",
        "camt053": "CAMT.053"
      },
      "profile": "Mapping profile",
      "profileHint": "How this bank's columns map onto dates, amounts and references.",
      "profilePlaceholder": "Select a mapping profile",
      "noProfiles": "No mapping profile exists for this legal entity yet, and a CSV cannot be read without one.",
      "createProfile": "Create one",
      "openingBalance": "Opening balance",
      "openingBalanceHint": "CSV only, and only if the file does not carry one. An MT940 states its own.",
      "file": "Statement file",
      "fileHint": "Up to 25 MB. UTF-8 text.",
      "import": "Import statement",
      "importing": "Importing",
      "imported": "Statement imported",
      "importedDetail": "{imported} new line(s), {duplicates} already on file.",
      "refused": "The statement was refused",
      "refusedAt": "Refused at {format} line {line}",
      "refusedGeneric": "The statement could not be imported.",
      "alreadyImported": "This statement is already on file",
      "nothingWritten": "Nothing was written. Fix the file or the mapping profile and import it again.",
      "outcome": {
        "new": "Every line was new",
        "partial": "Some lines were already on file",
        "none": "Nothing new in this file"
      },
      "outcomeCounts": "{imported} new, {duplicates} already known, {total} in the file",
      "viewLines": "See the lines that were imported",
      "historyTitle": "Imported statements",
      "loadFailed": "Those statements did not load",
      "emptyTitle": "No statements imported yet",
      "emptyDescription": "Import the bank's own statement file for an account. Until one is in, there is nothing to reconcile the ledger against.",
      "columns": {
        "file": "File",
        "period": "Period",
        "opening": "Opening",
        "closing": "Closing",
        "lines": "Lines",
        "format": "Format",
        "status": "Status",
        "kind": "Kind",
        "integrity": "Integrity"
      },
      "status": {
        "quarantined": "Quarantined",
        "released": "Released",
        "accepted": "Accepted",
        "rejected": "Rejected"
      },
      "quarantine": {
        "title": "Held in quarantine — nothing is reconciled yet",
        "held": "The statement and its lines are on record, but no line can be matched, suggested or counted in a reconciliation until a second person releases the file. The person who imported it cannot release it.",
        "reasonsHeading": "Why it was held",
        "rules": {
          "continuity_break": "Its opening balance does not follow on from the previous statement's closing balance, or its dates overlap a statement already on record.",
          "sequence_gap": "Its statement number does not follow on from the last accepted statement, so a statement may be missing.",
          "duplicate_statement": "This exact file was already imported for this account.",
          "currency_mismatch": "The statement is in a different currency from the bank account. Nothing is converted.",
          "sum_mismatch": "Its lines do not add up to the difference between its opening and closing balances.",
          "unknown_account": "The account number in the file is not this bank account's.",
          "integrity_failure": "The file does not match the checksum it was declared with, so it was not read.",
          "unparseable_line": "A line in the file could not be read, so no line of it was imported.",
          "late_statement": "The statement arrived after this account's staleness threshold.",
          "value_date_out_of_tolerance": "A value date is before its booking date, or later than this account's tolerance allows."
        }
      },
      "kind": {
        "end_of_day": "End of day",
        "intraday": "Intraday",
        "intradayNote": "An intraday statement informs the cash position only. Its lines never complete or supersede a reconciliation."
      },
      "integrity": {
        "verified": "Checksum verified",
        "unverified": "Not verified",
        "failed": "Checksum failed"
      },
      "tabs": {
        "label": "Statement sections",
        "imports": "Imports",
        "gaps": "Gaps and staleness"
      },
      "statusFilter": {
        "label": "Show",
        "all": "All statuses"
      },
      "review": "Release or reject",
      "reviewProposed": "Release proposed, awaiting a second person",
      "reviewQuarantine": "Review {file} in its quarantine panel",
      "late": {
        "title": "This statement is late",
        "delay": "It closes on {closing} and arrived {delay} day(s) later, past this account's {threshold}-day staleness threshold. It can be imported with a stated reason, which is recorded as an exception.",
        "label": "Why is this statement late?",
        "hint": "Recorded against the import with the delay. Up to 400 characters.",
        "required": "Say why the statement is late before importing it again.",
        "recorded": "Late statement exception"
      },
      "duplicate": {
        "title": "This statement was already imported",
        "nothingStored": "This copy was discarded. Nothing was stored.",
        "open": "Open the original import #{id}"
      }
    },
    "import": {
      "description": "One imported statement, as the bank sent it.",
      "railSubtitle": "{from} to {to}",
      "imported": "Imported",
      "loadFailed": "That statement did not load",
      "linesFailed": "Those statement lines did not load",
      "backToList": "All statements",
      "detailsTitle": "Details",
      "period": "Period",
      "newLines": "New lines",
      "duplicateLines": "Already on file",
      "statementNo": "Statement number",
      "immutable": "Statement lines cannot be edited. The only thing that changes about one is whether it has been matched.",
      "linesTitle": "Lines",
      "linesDescription": "In the order the file listed them."
    },
    "profiles": {
      "title": "Statement mapping profiles",
      "description": "How each bank's CSV export maps onto dates, amounts and references. Written once per bank.",
      "listTitle": "Mapping profiles",
      "loadFailed": "Those profiles did not load",
      "emptyTitle": "No mapping profiles yet",
      "emptyDescription": "A CSV statement needs one so the importer knows which column is the date and which is the amount. MT940 files need none — they carry their own structure.",
      "newTitle": "New mapping profile",
      "editTitle": "Edit mapping profile",
      "dialogDescription": "Describe this bank's export once; every import from it uses this.",
      "name": "Profile name",
      "company": "Legal Entity",
      "bankAccount": "Bank account",
      "bankAccountHint": "Leave blank to use this profile for any of the legal entity's accounts.",
      "anyAccount": "Any account",
      "hasHeader": "Header row",
      "hasHeaderHint": "Whether row one names the columns. If it does, columns are matched by name; if not, by position.",
      "hasHeaderLabel": "The file has a header row",
      "dateFormat": "Date format",
      "dateFormatHint": "Exactly how dates are written in this bank's file.",
      "decimalSeparator": "Decimal separator",
      "decimalSeparatorHint": "Usually a full stop.",
      "thousandsSeparator": "Thousands separator",
      "thousandsSeparatorHint": "Leave blank if the file groups nothing.",
      "amountMode": "Amounts",
      "amountModeHint": "Whether one column carries a signed amount, or two carry debits and credits.",
      "amountModes": {
        "signed": "One signed column",
        "debit_credit": "Separate debit and credit columns"
      },
      "columnsByName": "Name each column exactly as its header appears in the file. Case does not matter.",
      "columnsByIndex": "Give each column's position, counting from zero.",
      "headerPlaceholder": "Column header",
      "header": "Header",
      "headerYes": "Named",
      "headerNo": "By position",
      "notes": "Notes",
      "delete": "Delete",
      "deleted": "Profile deleted",
      "deletedDetail": "{name} is no longer offered on import.",
      "deleteFailed": "That profile could not be deleted",
      "saved": "Profile saved",
      "savedDetail": "{name} is ready to use on the next import.",
      "saveFailed": "That profile could not be saved",
      "fields": {
        "valueDate": "Value date column",
        "entryDate": "Entry date column",
        "description": "Narrative column",
        "reference": "Reference column",
        "counterpartyName": "Counterparty column",
        "amount": "Amount column",
        "debit": "Debit column",
        "credit": "Credit column"
      },
      "fieldHints": {
        "valueDate": "The date the money actually moved. Required.",
        "entryDate": "The date the bank booked it, when the file separates the two.",
        "description": "The narrative the bank printed. Required — it is what a person reads.",
        "reference": "The bank's own reference. This is what the strongest match tier compares.",
        "counterpartyName": "Who the money went to or came from, when the file names them.",
        "amount": "Negative for money out, positive for money in.",
        "debit": "Money leaving the account.",
        "credit": "Money arriving in the account."
      }
    },
    "importLines": {
      "title": "Statement lines",
      "titleFor": "Lines of {file}",
      "description": "Every line of one imported statement, in the file's order. A line cannot be edited; open one to see the record exactly as it was stored.",
      "backToImport": "Back to the statement",
      "deniedTitle": "Statement lines are not available to you",
      "deniedDescription": "Reading imported statement lines needs the statement read permission.",
      "emptyTitle": "This statement has no lines",
      "emptyDescription": "Every line in the file was already on record for this account, so none were added. The statement itself still records its balances.",
      "lineNo": "Line",
      "actions": "Actions",
      "viewRaw": "Raw",
      "viewRawFor": "Show the stored record for line {line}",
      "drawerTitle": "Line {line} as stored",
      "drawerFallback": "Statement line",
      "drawerDescription": "The parsed fields, then the record itself exactly as the server returned it.",
      "entryDate": "Entry date",
      "direction": "Direction",
      "directions": {
        "in": "Money in",
        "out": "Money out"
      },
      "counterparty": "Counterparty",
      "bankTransactionCode": "Bank transaction code",
      "rawHeading": "Record as returned",
      "openLines": "Open the {count} line(s) of this statement"
    },
    "connectors": {
      "title": "Bank accounts and connectors",
      "description": "How each account's statements arrive. Fetch is offered only where the account's connector can retrieve a statement itself; everything else is uploaded above.",
      "currency": "Currency",
      "connector": "Connector",
      "actions": "Actions",
      "unknown": "Not visible to you",
      "notRegistered": "Not available in this installation",
      "uploadOnly": "Upload only",
      "fetch": "Fetch statement",
      "fetching": "Fetching",
      "fetchFailed": "The fetch was refused",
      "fetched": "{count} statement(s) retrieved",
      "openFetched": "Open the lines of statement #{id}"
    },
    "autoMatch": {
      "action": "Auto-match",
      "notConfigured": "Set an auto-apply confidence for this account in the reconciliation settings to use auto-match.",
      "summary": "Auto-match applied {applied} match(es). {ambiguous} line(s) had more than one qualifying candidate and {below} were below the threshold; those stay as suggestions.",
      "failed": "Auto-match was refused"
    },
    "continuity": {
      "heldCanRelease": "The file is held in quarantine because of this break. Release or reject it in the quarantine panel; you cannot release a file you imported.",
      "heldNeedsReleaser": "The file is held in quarantine because of this break, until someone who can release statements, other than its importer, releases or rejects it.",
      "openQuarantine": "Open the quarantine panel",
      "settled": {
        "released": "This break was released from quarantine by a second person.",
        "rejected": "The file with this break was rejected; a corrected statement is imported as a new file."
      }
    },
    "quarantine": {
      "panelTitle": "Quarantine",
      "release": "Release",
      "reject": "Reject",
      "releaseTitle": "Release this statement",
      "releaseDescription": "Its lines become reconcilable. You must not be its importer, an owner of the connection that delivered it, or whoever proposed the release.",
      "rejectTitle": "Reject this statement",
      "rejectDescription": "The file and its lines stay on record and never become reconcilable. A corrected statement is imported as a new file.",
      "reasonLabel": "Reason",
      "reasonRequired": "A reason is required. It is recorded in the audit log against your name.",
      "proposalTitle": "Proposal recorded",
      "proposalBody": "A second person must release this statement before any of its lines can be reconciled.",
      "proposedBy": "Proposed by user #{user} at {at}.",
      "released": "Statement released",
      "releasedDetail": "Its lines can now be matched.",
      "rejected": "Statement rejected",
      "rejectedDetail": "It stays on record. Import the corrected file.",
      "sod": "You cannot release this statement: the person who imported it, an owner of its connection, and whoever proposed the release are all excluded. Ask someone else to release it. {detail}",
      "notReleasable": "This statement can only be rejected. {detail}",
      "decidedElsewhere": "Someone else decided this statement while you were working. It has been reloaded.",
      "rejectOnly": "This file can only be rejected: its currency is not the account's, its integrity check failed, or a line could not be read. Reject it and import the corrected file.",
      "youImported": "You imported this file, so someone else must release it. You can still reject it.",
      "youProposed": "You proposed releasing this file, so a second person must release it.",
      "decidedAt": "Decided at",
      "decidedBy": "Decided by",
      "decisionReason": "Reason",
      "linesFailed": "The lines of this statement could not be loaded",
      "heldLinesTitle": "Lines held for review",
      "heldLinesDescription": "Each line here was held by its own rule inside an accepted file. It cannot be matched until someone other than its importer releases it.",
      "heldLinesFileFirst": "Decide the file first. A held line can be released or rejected only once its statement is live.",
      "lineNo": "Line",
      "dates": "Booking / value date",
      "amount": "Amount",
      "why": "Why it is held",
      "actions": "Actions",
      "lineRules": {
        "FIN_T01_V030": "The value date is before the booking date, or later than this account's tolerance allows."
      },
      "lineOutcome": {
        "released": "Released",
        "rejected": "Rejected, kept on record",
        "proposed": "Proposal recorded, a second person must decide"
      },
      "lineReleaseTitle": "Release this line",
      "lineReleaseDescription": "The line becomes reconcilable. Its hold reason stays as history.",
      "lineRejectTitle": "Reject this line",
      "lineRejectDescription": "The line stays on record and never becomes reconcilable.",
      "lineProposalBody": "A second person must decide this line before it can be reconciled.",
      "lineReleased": "Line released",
      "lineRejected": "Line rejected",
      "lineSod": "You cannot decide this line: its importer, the owners of its connection and whoever proposed the decision are excluded. {detail}",
      "lineAlreadyDecided": "This line was already decided. {detail}",
      "duplicateLinesTitle": "Duplicate lines kept on record",
      "duplicateOf": "Duplicate of a live line (#{id}), kept on record. It never reconciles."
    },
    "gaps": {
      "title": "Statement gaps",
      "description": "Stretches of an account's history that no accepted statement covers. Each one is resolved by a statement that fills it, or waived with a reason.",
      "loadFailed": "The statement gaps could not be loaded",
      "emptyTitle": "No gaps",
      "emptyDescription": "Every account in this view has continuous statements. A missing statement, a break in balances or a skipped number appears here.",
      "columns": {
        "dates": "Dates",
        "kind": "Kind",
        "detail": "Detail"
      },
      "kind": {
        "continuity": "Balance break",
        "sequence": "Missing statement number",
        "coverage": "Banking day not covered",
        "stale": "Statements stale"
      },
      "status": {
        "all": "All",
        "open": "Open",
        "resolved": "Resolved",
        "waived": "Waived"
      },
      "sourceImport": "Found by import #{id}",
      "filledBy": "Filled by import #{id}",
      "proposalRow": "Waiver proposed, awaiting a second person",
      "resolve": "Resolve",
      "waive": "Waive",
      "resolveTitle": "Resolve this gap",
      "resolveDescription": "Name the statement that fills it. It must be a live end-of-day statement of the same account that covers the dates, restores continuity or carries a missing number.",
      "waiveTitle": "Waive this gap",
      "waiveDescription": "Record that nothing will fill it. The person whose import found the gap and the owners of the account's connection cannot waive it.",
      "fillingImport": "Filling statement",
      "fillingImportHint": "Live end-of-day statements of this account.",
      "fillingImportPlaceholder": "Select the statement that fills the gap",
      "importRequired": "Choose the statement that fills the gap.",
      "noCandidates": "No live end-of-day statement of this account is on record. Import the missing statement, or waive the gap.",
      "proposalTitle": "Proposal recorded",
      "proposalBody": "A second person must waive this gap. It stays open until then.",
      "resolved": "Gap resolved",
      "waived": "Gap waived",
      "sod": "You cannot waive this gap: the person whose import found it, the owners of the account's connection and whoever proposed the waiver are excluded. {detail}",
      "decidedElsewhere": "Someone else decided this gap while you were working. The list has been reloaded."
    },
    "staleness": {
      "title": "Statement staleness",
      "description": "Days since each account's newest accepted end-of-day statement, against the account's own threshold.",
      "loadFailed": "The staleness report could not be loaded",
      "emptyTitle": "No active bank accounts",
      "emptyDescription": "Staleness is reported for active bank accounts.",
      "lastStatement": "Last statement",
      "daysStale": "Age",
      "threshold": "Threshold",
      "openGaps": "Open gaps",
      "quarantined": "Quarantined",
      "never": "None yet",
      "noStatement": "No statement",
      "days": "{n} days"
    },
    "signals": {
      "title": "Contributing signals",
      "reference": "Reference",
      "date": "Date",
      "name": "Counterparty name",
      "value": "{score}% × weight {weight} = {contribution} points"
    },
    "forceMatch": {
      "action": "Force match",
      "openAction": "Force match…",
      "openQueue": "Open the forced matches",
      "pendingInSession": "{count} forced match in this session waits for a second authoriser; its statement line stays unmatched until then. | {count} forced matches in this session wait for a second authoriser; their statement lines stay unmatched until then.",
      "pickHint": "To force a match, tick exactly one statement line and the ledger lines it should be tied to.",
      "dialogTitle": "Force this match",
      "dialogDescription": "Ties the statement line to the ledger lines you ticked even though the engine would not offer them. A reason code and a reason are recorded against your name.",
      "bandNote": "Above {band} this match is not applied until someone else authorises it. A difference larger than {tolerance} is refused; post the missing entry instead.",
      "reasonCode": "Reason code",
      "reasonCodePlaceholder": "Choose why the match is forced",
      "reason": "Reason",
      "reasonHint": "In your own words. Up to 500 characters.",
      "submit": "Force match",
      "reasons": {
        "timing_difference": "Timing difference",
        "bank_error": "Bank error",
        "ledger_error": "Ledger error",
        "fx_difference": "Exchange difference",
        "partial_settlement": "Partial settlement",
        "other": "Other"
      },
      "appliedTitle": "Match forced",
      "appliedDetail": "It was within the value band and is applied.",
      "heldTitle": "Held for authorisation",
      "heldDetail": "Its value is above the {band} band, so nothing is applied until a second person authorises it.",
      "residualRefused": "The difference between the statement line and the ledger lines is larger than this account allows a forced match to carry.",
      "queueTitle": "Forced matches",
      "queueDescription": "Every forced match in this session. One above the value band waits here for someone other than the person who forced it.",
      "queueLoadFailed": "The forced matches could not be loaded",
      "queueEmpty": "No match has been forced in this session.",
      "columns": {
        "line": "Statement line",
        "statement": "Statement",
        "ledger": "Ledger lines",
        "residual": "Difference",
        "value": "Value",
        "reason": "Reason",
        "requested": "Forced by"
      },
      "lineRef": "Line #{line} against {count} ledger line(s)",
      "aboveBand": "above the {band} band",
      "withinBand": "within the {band} band",
      "status": {
        "pending": "Awaiting authorisation",
        "applied": "Applied",
        "declined": "Declined"
      },
      "decidedBy": "Decided by {name}",
      "ownRequest": "You forced this match, so someone else must authorise it.",
      "authorise": "Authorise",
      "decline": "Decline",
      "declineReason": "Why is it declined?",
      "authorised": "Forced match authorised and applied",
      "declined": "Forced match declined; nothing was applied",
      "reloaded": "Someone changed this forced match while you were looking. It has been reloaded; decide again.",
      "sodRefused": "You cannot authorise a match you forced.",
      "inboxTitle": "Forced matches awaiting your authorisation",
      "inboxDescription": "Forced matches above their value band, across every session. Each is decided on its session's match screen, by someone other than the person who forced it.",
      "inboxLoading": "Loading forced matches…",
      "inboxEmpty": "Nothing is waiting for a second authoriser.",
      "yours": "yours, someone else must decide",
      "review": "Review and decide"
    },
    "heldLines": {
      "title": "Quarantined statement lines",
      "description": "This reconciliation cannot complete while any line of its statement is held in quarantine.",
      "loadFailed": "The quarantined statements could not be checked",
      "blocked": "{statements} quarantined statement(s) cover this period, holding {lines} line(s). Release or reject each one in its quarantine panel before completing the reconciliation.",
      "statement": "{file}, {from} to {to}",
      "noReasonStated": "No reason was recorded on this statement.",
      "linesCaption": "Held lines of this statement in the session period",
      "lineNo": "Line",
      "valueDate": "Value date",
      "reference": "Reference",
      "amount": "Amount",
      "linesUnavailable": "This quarantined statement's lines could not be read, so it is not known whether any falls inside this period. Close is still offered; if a held line is in the period, the refusal will list it.",
      "serverListsRest": "A line held by its own rule inside an accepted statement, or an intraday line no end-of-day statement covers, also blocks completion; the refusal lists those when you try to close.",
      "closeBlocked": "A quarantined statement covers this period. Release or reject it first.",
      "closeRefusedTitle": "The reconciliation cannot complete while these statement lines are held",
      "openImports": "Open this account's statements to release or reject them"
    },
    "reopenQueue": {
      "title": "Reopen requests awaiting authorisation",
      "description": "Closed reconciliations someone has asked to reopen. Each is decided on its certificate screen by someone who neither asked, completed it nor certified it.",
      "loadFailed": "The reopen requests could not be loaded",
      "loading": "Loading reopen requests…",
      "empty": "No reopen request is waiting.",
      "sessionRef": "Session #{id}",
      "badge": "Reopen requested",
      "pendingOnSession": "A reopen has been requested; it waits for a second person"
    },
    "certificateHistory": {
      "title": "Certificate history",
      "description": "Every certificate this session has had. A certificate is never altered: a reopen supersedes it and a new one is issued.",
      "loadFailed": "The certificate history could not be loaded",
      "empty": "This session has not been certified yet.",
      "current": "Current",
      "supersededStatus": "Superseded",
      "superseded": "Superseded",
      "matchedSet": "Matched set",
      "matchedSetValue": "{count} match(es), hash {hash}",
      "lines": "{count} match | {count} matches",
      "declineReason": "Reason, if you decline",
      "reopenExcluded": "A second person must authorise this reopen. The requester, whoever completed the reconciliation and whoever certified it cannot.",
      "reopenRequestedBy": "Requested by {name} at {at}.",
      "reopenReloaded": "This reopen request changed while you were looking. It has been reloaded; decide again.",
      "column": "Certificate",
      "certified": "Certified {no}",
      "notCertified": "Not certified"
    },
    "ruleApproval": {
      "view": "Show",
      "viewAll": "All rules",
      "viewPending": "Awaiting approval",
      "formNote": "A new rule, or a new version of one, goes live only after someone other than you previews and approves it.",
      "savedPending": "It goes live once someone else approves it.",
      "counterpartyPattern": "Counterparty pattern",
      "state": {
        "pending": "Awaiting approval",
        "live": "Live",
        "declined": "Declined",
        "superseded": "Superseded",
        "inactive": "Inactive"
      },
      "proposedFrom": "Proposed by the system from {count} repeated manual treatment | Proposed by the system from {count} repeated manual treatments",
      "previewLine": "Preview: would have treated {matched} of {examined} lines",
      "approvedBy": "Approved by {name}",
      "ownRule": "You made this rule, so someone else must approve it.",
      "needsAuto": "Approving a rule that posts unattended needs the unattended-posting permission.",
      "approve": "Approve",
      "decline": "Decline",
      "approveTitle": "Approve rule {code}",
      "declineTitle": "Decline rule {code}",
      "approveDescription": "The rule goes live and starts treating statement lines as previewed.",
      "declineDescription": "The rule stays on record and never goes live. A declined proposal is not proposed again.",
      "previewOnApprove": "This rule has no preview yet. One is taken over the declared window when it is approved, and recorded with the approval.",
      "proposedNote": "This rule was proposed from repeated manual treatments. Nobody whose treatment proposed it may approve it.",
      "approveNote": "Note (optional)",
      "declineReason": "Why is it declined?",
      "approved": "Rule {code} approved and live",
      "declined": "Rule {code} declined",
      "reloaded": "This rule changed while you were working. It has been reloaded; check it and decide again.",
      "sodRefused": "You cannot approve this rule.",
      "emptyPendingTitle": "Nothing awaiting approval",
      "emptyPendingDescription": "New rules, replacement versions and rules the system proposes from repeated treatments wait here for a second person."
    },
    "queue": {
      "continuity_break": "Bank statement continuity breaks"
    }
  },
  "assets": {
    "filtersTitle": "Filters",
    "allCompanies": "All legal entities",
    "months": "{count} months",
    "routeTitles": {
      "classes": "Asset classes",
      "register": "Fixed asset register",
      "asset": "Fixed asset",
      "acquire": "Acquire an asset",
      "capitalize": "Capitalize an invoice line",
      "depreciation": "Depreciation runs",
      "movement": "Asset movement",
      "books": "Depreciation books",
      "componentise": "Componentise",
      "impairments": "Impairment",
      "verifications": "Physical verification",
      "verification": "Count sheet",
      "bookComparison": "Book comparison",
      "capexVsBudget": "Capex against budget",
      "depreciationForecast": "Depreciation forecast",
      "depreciationPreview": "Depreciation preview",
      "disposals": "Disposals",
      "icTransfer": "Inter-company transfers",
      "settings": "Asset settings"
    },
    "fields": {
      "company": "Legal Entity",
      "companyPlaceholder": "Choose a legal entity",
      "class": "Asset class",
      "classPlaceholder": "Choose a class",
      "accountPlaceholder": "Choose an account",
      "none": "None",
      "method": "Method",
      "life": "Useful life",
      "cost": "Cost",
      "salvage": "Salvage value",
      "accumulated": "Accumulated depreciation",
      "nbv": "Net book value",
      "location": "Location",
      "custodian": "Custodian",
      "branch": "Branch",
      "costCenter": "Cost centre",
      "inServiceDate": "In service from",
      "disposalDate": "Disposed on",
      "periodsDepreciated": "Periods charged",
      "reason": "Reason",
      "from": "From",
      "to": "To"
    },
    "methods": {
      "SL": "Straight line",
      "SLHint": "The same amount every period",
      "DB": "Declining balance",
      "DBHint": "A fixed rate on the falling book value",
      "SYD": "Sum of years' digits",
      "SYDHint": "Front-loaded, weighted by the years remaining",
      "UOP": "Units of production",
      "UOPHint": "By use rather than by time"
    },
    "status": {
      "in_service": "In service",
      "disposed": "Disposed"
    },
    "notDepreciating": {
      "disposed": "Disposed",
      "lifeExhausted": "Life used up",
      "fullyDepreciated": "Fully depreciated"
    },
    "periodStatus": {
      "open": "Open",
      "soft_closed": "Soft closed",
      "closed": "Closed"
    },
    "apStatus": {
      "draft": "Draft",
      "submitted": "Submitted",
      "approved": "Approved",
      "rejected": "Rejected",
      "posted": "Posted",
      "paid": "Paid",
      "cancelled": "Cancelled",
      "reversed": "Reversed"
    },
    "accountTypes": {
      "ASSET": "Asset",
      "LIABILITY": "Liability",
      "EQUITY": "Equity",
      "INCOME": "Income",
      "EXPENSE": "Expense"
    },
    "errors": {
      "periodClosed": "That date falls in a closed accounting period, so nothing can be posted into it. Reopen the period, or choose a date inside an open one."
    },
    "classes": {
      "title": "Asset classes",
      "description": "The template every asset copies at acquisition: its method, its default life and salvage, and the four ledger accounts it will reconcile against for the rest of its life.",
      "permanenceNote": "A class cannot be deleted once an asset has used it — its depreciation is in the ledger and the movement report groups by it. Retire one instead: an inactive class stops being offered for new assets and leaves every posted figure intact.",
      "tableLabel": "Asset classes",
      "searchHint": "Code or name",
      "loadFailed": "Those asset classes could not be loaded",
      "emptyTitle": "No asset classes yet",
      "emptyDescription": "Create one for each family of assets you depreciate — vehicles, IT equipment, furniture. Each names a method, a default life, and the four accounts its assets will post to.",
      "newTitle": "New asset class",
      "newDescription": "The accounts chosen here are copied onto every asset acquired against this class, so they are fixed once the class exists.",
      "editTitle": "Edit asset class",
      "editDescription": "The defaults apply to assets acquired from now on. Assets already on the register keep the schedule and accounts they were registered with.",
      "created": "Asset class created",
      "updated": "Asset class updated",
      "saveFailed": "That asset class could not be saved",
      "active": "Active",
      "retired": "Retired",
      "accountById": "Account #{id}",
      "noAccounts": "This legal entity has no postable accounts yet. Build its chart of accounts first — a class cannot exist without the four accounts its assets will post to.",
      "accountsNote": "Four accounts, exactly as §8.8 names them. A revaluation posts through the same gain or loss account a disposal would; there is no separate revaluation reserve.",
      "retireNote": "Retiring this class stops it being offered for new assets. Every asset already registered against it keeps depreciating, and its figures stay in the movement report.",
      "columns": {
        "code": "Code",
        "life": "Life",
        "salvage": "Salvage",
        "assetAccount": "Asset",
        "accumulatedAccount": "Accum. dep.",
        "expenseAccount": "Expense",
        "gainLossAccount": "Gain / loss"
      },
      "fields": {
        "code": "Code",
        "codeHint": "Short and stable, e.g. VEH or IT-EQ",
        "codeFixed": "Fixed once the class exists",
        "methodHint": "Assets may override this one by one",
        "life": "Default useful life (months)",
        "lifeHint": "60 months is five years",
        "salvagePercent": "Default salvage (%)",
        "salvagePercentHint": "Percentage of cost expected to remain at the end of life. Enter 10 for 10%.",
        "salvagePercentRange": "Enter a percentage between 0 and 100.",
        "assetAccount": "Asset account",
        "assetAccountHint": "Where the cost sits on the balance sheet",
        "accumulatedAccount": "Accumulated depreciation account",
        "accumulatedAccountHint": "The contra account credited by every depreciation charge",
        "expenseAccount": "Depreciation expense account",
        "expenseAccountHint": "Debited by every depreciation charge",
        "gainLossAccount": "Gain or loss on disposal account",
        "gainLossAccountHint": "Also carries a revaluation adjustment",
        "active": "Availability",
        "activeHint": "Only active classes are offered for new assets",
        "activeToggle": "Available for new assets"
      }
    },
    "register": {
      "title": "Fixed asset register",
      "description": "Every asset on the books: what it cost, what has been charged against it, and what is left.",
      "tableLabel": "Fixed asset register",
      "searchHint": "Asset number or name",
      "narrowedHere": "Narrowed from the loaded register",
      "loadFailed": "The register could not be loaded",
      "emptyTitle": "No fixed assets yet",
      "emptyDescription": "Register one manually, or capitalize a line on a supplier invoice you have already posted — that second route adds no journal, because the money is already on the books.",
      "classById": "Class #{id}",
      "truncated": "Showing the first {count} assets. The location and custodian filters only see those, so narrow by legal entity or class first if you are looking for something that is not here.",
      "exported": "Exported {count} assets",
      "columns": {
        "assetNo": "Asset no."
      }
    },
    "detail": {
      "loadFailed": "That asset could not be loaded",
      "factsPanel": "Asset",
      "journalsPanel": "Journals",
      "journalsDescription": "What this asset posted directly — its acquisition, any revaluation, and its disposal.",
      "noJournals": "Nothing has posted against this asset yet.",
      "depreciationJournalsElsewhere": "Depreciation journals are not listed here. A run posts one journal covering every asset it charged, so those journals belong to the run rather than to any one asset — see the depreciation runs screen.",
      "capitalizedBadge": "Capitalized",
      "capitalizedNoJournal": "This asset was capitalized from a posted supplier invoice line, so it has no acquisition journal of its own: the cost reached the ledger when that invoice posted.",
      "sourceLine": "Supplier invoice line #{id}",
      "acquisitionJournal": "Acquisition journal",
      "journalById": "Journal #{id}",
      "classLink": "Asset classes",
      "registered": "Registered",
      "inService": "In service",
      "disposedOn": "Disposed",
      "backToRegister": "All fixed assets",
      "saved": "Asset updated",
      "saveFailed": "That change could not be saved"
    },
    "schedule": {
      "title": "How this was worked out",
      "description": "The rule, its inputs, and the figures the server computed from them.",
      "ruleSl": "Straight line: (cost − salvage) ÷ {life} months, the same amount every period, with the final chargeable period absorbing the rounding residual so accumulated depreciation lands exactly on cost − salvage.",
      "ruleDb": "Declining balance: {rate} of the net book value each period — 2 ÷ {life} months — falling as the book value falls, and clamped so it never takes the asset below its salvage value.",
      "depreciableBase": "Depreciable base (cost − salvage)",
      "monthlyRate": "Monthly rate (2 ÷ life)",
      "ofPeriods": "{done} of {total}",
      "remainingBase": "Still to charge",
      "remainingPeriods": "Periods remaining",
      "progressLabel": "Useful life consumed",
      "progressCaption": "{done} of {total} periods charged",
      "stillCharging": "The next depreciation run for this legal entity will charge this asset.",
      "stopped": {
        "disposed": "This asset was disposed, so it is excluded from every future run. Note that disposal does not charge the period it happened in — whatever the last completed run charged is all it has.",
        "lifeExhausted": "Its useful life is used up. The period counter has reached the asset's life in months, so no future run will charge it, however much book value remains — a declining-balance schedule routinely leaves a residual, and only disposal resolves it.",
        "fullyDepreciated": "There is nothing left to charge: accumulated depreciation has reached cost minus salvage."
      },
      "noPeriodTable": "The charges are shown as totals rather than period by period. The individual entries live in a table the API does not expose, and the depreciation journals that carry them are posted per run — covering a batch of assets — so there is no query that gets from one asset to its own charges.",
      "noProjection": "No projection is drawn either. The remaining schedule is computed by the server in exact decimals, compounding on book value for declining balance and clamping the last period so accumulated depreciation lands precisely on cost minus salvage; recomputing that here would be a second answer to a question only the server may answer, and the first cent of disagreement would look exactly like a posting error."
    },
    "acquire": {
      "action": "Acquire asset",
      "title": "Acquire an asset",
      "description": "Register an asset and post its acquisition in one step.",
      "orCapitalize": "Capitalize an invoice line instead",
      "postsImmediately": "There is no draft. Submitting this posts the acquisition journal — debit the class's asset account, credit the account you name — dated the in-service date. A closed period will refuse it.",
      "identityPanel": "What it is",
      "postingPanel": "What it cost, and what paid for it",
      "postingDescription": "The credit side is never assumed: name the bank, cash or payables account the money left.",
      "schedulePanel": "How it will depreciate",
      "scheduleDescription": "Blank means the class default. Whatever is saved is copied onto this asset, so editing the class later never changes it.",
      "fromClass": "From the class",
      "classHint": "{method}, {months} months",
      "submit": "Register and post",
      "posting": "Posting",
      "done": "Asset registered",
      "doneDetail": "{assetNo} is on the register and its acquisition has posted.",
      "failed": "That asset could not be registered",
      "fields": {
        "classHint": "Sets the accounts and the default schedule",
        "creditAccount": "Credit account",
        "creditAccountHint": "The bank, cash or payables account the money came from",
        "inServiceHint": "The journal is dated this day, and depreciation starts from it",
        "lifeHint": "Months. Blank uses the class default.",
        "salvageHint": "Blank uses the class default percentage of cost",
        "memo": "Memo"
      }
    },
    "capitalize": {
      "action": "Capitalize an invoice line",
      "title": "Capitalize a supplier invoice line",
      "description": "Turn a line on a posted supplier invoice into an asset on the register.",
      "orManual": "Acquire manually instead",
      "postsNothing": "This posts nothing. The money reached the ledger when the invoice posted, so registering the asset only starts the depreciation clock on a cost that is already on the books.",
      "accountFromLine": "The asset's own asset account is taken from the invoice line, not from the class default, so it reconciles against the account the money actually landed on.",
      "invoicePanel": "The invoice",
      "invoiceDescription": "Posted and paid supplier invoices. A reversed invoice no longer carries a live posting to capitalize against.",
      "searchHint": "Invoice number or supplier",
      "invoicesFailed": "Those invoices could not be loaded",
      "linesPanel": "The line",
      "linesDescription": "One line becomes one asset. A line that is already an asset cannot become a second one.",
      "assetPanel": "The asset",
      "assetDescription": "Defaults come from the line and the class; change any of them before registering.",
      "tableCaption": "Lines of the selected supplier invoice, and whether each is still available to capitalize",
      "chooseLine": "Choose",
      "chooseLineNo": "Capitalize line {line}",
      "lineTakenLabel": "Line {line} is already asset {assetNo}",
      "lineAvailable": "Available",
      "lineTaken": "Already an asset",
      "noLines": "This invoice has no lines.",
      "allTaken": "Every line on this invoice is already an asset. Nothing here is left to capitalize.",
      "indexTruncated": "More assets exist than could be checked in one pass, so a line shown as available may already be taken. The server will refuse a duplicate either way.",
      "submit": "Register asset",
      "done": "Asset registered",
      "doneDetail": "{assetNo} is on the register. No journal was posted — the cost was already in the ledger.",
      "failed": "That asset could not be registered",
      "raceLost": "Somebody registered an asset against that line while this form was open. The list has been refreshed; the line now shows the asset it became.",
      "columns": {
        "line": "Line",
        "account": "Account",
        "amount": "Amount"
      },
      "fields": {
        "invoice": "Supplier invoice",
        "invoiceHint": "Only posted and paid invoices carry a posting to capitalize",
        "invoicePlaceholder": "Choose an invoice",
        "costHint": "Blank uses the line amount",
        "inServiceHint": "Blank uses the invoice date"
      }
    },
    "relocate": {
      "action": "Move",
      "title": "Move {assetNo}",
      "description": "Change where this asset is, who holds it, and which dimensions its future charges carry.",
      "noPosting": "This posts nothing — a fixed asset's ledger accounts do not move with it. What it records is custody, in the audit trail.",
      "done": "Asset moved",
      "doneDetail": "{assetNo} has been updated.",
      "failed": "That move could not be recorded",
      "fields": {
        "dimensionHint": "Applies to charges posted from now on",
        "reasonHint": "Recorded in the audit trail"
      }
    },
    "revalue": {
      "action": "Revalue",
      "title": "Revalue {assetNo}",
      "description": "Change the cost, the useful life or the salvage value.",
      "currentCost": "Current cost",
      "currentSalvage": "Current salvage value",
      "currentLife": "Current useful life",
      "postsNote": "Changing the cost posts the difference against the class's gain or loss account, dated the day you name. A closed period will refuse it.",
      "prospectiveNote": "Changing only the useful life or the salvage value posts nothing. The periods already charged stay exactly as charged; the new figures apply from the next run onwards.",
      "done": "Asset revalued",
      "doneDetail": "{assetNo} has been revalued.",
      "failed": "That revaluation could not be posted",
      "fields": {
        "on": "Effective date",
        "onHint": "A cost change is dated this day and lands in that period",
        "newCost": "New cost",
        "newCostHint": "Leave blank to keep the current cost",
        "newSalvage": "New salvage value",
        "newSalvageHint": "Leave blank to keep the current salvage value",
        "newLife": "New useful life (months)",
        "newLifeHint": "Leave blank to keep the current life",
        "reasonHint": "Recorded in the audit trail and on the journal"
      }
    },
    "dispose": {
      "action": "Dispose",
      "title": "Dispose {assetNo}",
      "description": "Derecognize the cost and the accumulated depreciation, and post the gain or loss against the proceeds.",
      "carryingAmount": "Carrying amount",
      "gainLoss": "Gain or loss",
      "noCatchUp": "Disposal does not charge depreciation for the period it happens in. This asset keeps whatever the last completed run charged it, and the gain or loss is struck against that book value.",
      "noCatchUpAdvice": "If the period should be charged first, run depreciation and come back.",
      "posting": "Posting",
      "done": "Asset disposed",
      "doneDetail": "{assetNo} has been derecognized.",
      "failed": "That disposal could not be posted",
      "fields": {
        "date": "Disposal date",
        "dateHint": "The journal is dated this day",
        "proceeds": "Proceeds",
        "proceedsHint": "Leave blank for a write-off with nothing received",
        "proceedsAccount": "Proceeds account",
        "proceedsAccountHint": "Where the money arrived — a bank or receivables account",
        "reasonHint": "Sold, scrapped, stolen, written off — recorded in the audit trail"
      }
    },
    "runs": {
      "action": "Run depreciation",
      "bookRunsTitle": "Per book — {count} book(s) ran",
      "columns": {
        "journal": "Journal",
        "date": "Posted",
        "memo": "Memo",
        "charged": "Charged"
      },
      "description": "Charge every eligible asset for a period, and see exactly what was charged and what was passed over.",
      "dialogDescription": "Charges every eligible in-service asset of this legal entity for the period the date falls in.",
      "dialogTitle": "Run depreciation",
      "doneDetail": "{count} assets charged for {period}.",
      "doneTitle": "Depreciation posted",
      "eligibilityNote": "Two exclusions never appear in that list, because the run filters them out before it considers them: a disposed asset, and one whose period counter has reached its useful life. The register's status column says which applies to any given asset.",
      "failed": "That run could not be completed",
      "fields": {
        "on": "Date",
        "onHint": "Blank means today in this workspace's timezone. The period it falls in is the period charged."
      },
      "hideCharges": "Hide charges",
      "historyCaption": "Depreciation journals for this legal entity",
      "historyDescription": "Each run's journal, from the ledger — the record of what was actually posted.",
      "historyEmpty": "No depreciation has been posted for this legal entity in this window.",
      "historyFailed": "That history could not be loaded",
      "historySkipsNote": "What a past run passed over is not shown: that list exists only on the response to the call that ran it. An endpoint over the stored runs would carry it, and the counts are already recorded server-side.",
      "historyTitle": "Past runs",
      "idempotencyNote": "Running this twice is safe. A second run finds no asset without a charge for the period and posts no journal at all.",
      "idempotencyNoteTwo": "Add an asset mid-period and run again, and exactly that asset is charged, in a second journal for the same period. Both journals are real and both are correct.",
      "landsIn": "That date lands in {period}.",
      "moreHistory": "There are older runs beyond this page. Narrow the date range to reach them.",
      "noCharges": "This journal has no debit lines.",
      "noOpDetail": "Every eligible asset already has a charge for {period}, so no journal was posted.",
      "noOpExplained": "No journal was posted: every eligible asset already had a charge for {period}. That is the safe outcome of running it again, not a failure.",
      "noOpTitle": "Nothing to charge",
      "noPeriod": "No fiscal period covers that date for this legal entity. Create the fiscal year first.",
      "noSkips": "Nothing was passed over: every asset the run considered was charged.",
      "periodClosedWarning": "That period is closed, so the run will be refused. Reopen it, or choose a date inside an open period.",
      "processed": "Assets charged",
      "processedCount": "Processed",
      "processedHelp": "Assets that had no charge for this period and still had depreciable base and life left",
      "resultDescription": "What this run charged, and what it passed over.",
      "resultTitle": "The run for {period}",
      "running": "Running",
      "showCharges": "Show charges",
      "skippedCount": "Passed over",
      "skippedHelp": "Assets the run considered and did not charge, each with its reason",
      "skippedTitle": "{count} assets were considered and not charged",
      "title": "Depreciation runs",
      "totalAmount": "Total amount",
      "totalCharged": "Total charged",
      "totalChargedHelp": "The debit total of the journal this run posted",
      "viewJournal": "View the journal"
    },
    "movement": {
      "title": "Asset movement",
      "description": "Opening, additions, depreciation, disposals and closing, per class — reconciled against the ledger accounts behind them.",
      "needsWindow": "Choose a legal entity and a date range to run the report.",
      "loadFailed": "That report could not be loaded",
      "tableTitle": "Movement by class",
      "tableDescription": "From {from} to {to}.",
      "tableCaption": "Asset movement by class: opening, additions, depreciation, disposals and closing",
      "empty": "No assets moved in this window.",
      "total": "Total",
      "generated": "Generated {at}",
      "reconciles": "Every class ties to its control accounts, every row walks from opening to closing, and the rows add up to the totals.",
      "controlMismatch": "{count} control accounts do not agree with the sub-ledger.",
      "rowsBroken": "{count} rows do not walk from opening to closing.",
      "totalsBroken": "These totals do not equal the sum of the rows: {columns}.",
      "controlTitle": "Control account reconciliation",
      "controlDescription": "The server summed the ledger for each class's asset and accumulated depreciation accounts and compared it with the register.",
      "controlCaption": "Sub-ledger totals against the general ledger control accounts",
      "reconciled": "Ties",
      "notReconciled": "Does not tie",
      "noControls": "No control accounts were reconciled for this window.",
      "columns": {
        "class": "Class",
        "openingCost": "Opening cost",
        "additions": "Additions",
        "disposalsCost": "Disposals",
        "closingCost": "Closing cost",
        "openingAccum": "Opening accum.",
        "charge": "Depreciation",
        "disposalsAccum": "Disposals accum.",
        "closingAccum": "Closing accum.",
        "closingNbv": "Closing NBV",
        "account": "Account",
        "subLedger": "Register",
        "control": "Ledger",
        "difference": "Difference"
      }
    },
    "bookKinds": {
      "accounting": "Accounting",
      "tax": "Tax",
      "management": "Management",
      "other": "Other"
    },
    "bookSources": {
      "tenant": "Yours",
      "pack": "From a pack"
    },
    "conventions": {
      "full_month": "Full month",
      "half_year": "Half year",
      "mid_month": "Mid month",
      "mid_quarter": "Mid quarter",
      "actual_days": "Actual days"
    },
    "assetBookStatuses": {
      "in_service": "In service",
      "fully_depreciated": "Fully depreciated",
      "disposed": "Disposed"
    },
    "componentKinds": {
      "whole": "Whole asset",
      "parent": "Parent",
      "component": "Component"
    },
    "indicators": {
      "market_value_decline": "Market value has fallen",
      "physical_damage": "Physical damage",
      "obsolescence": "Obsolescence",
      "idle": "Idle",
      "disposal_planned": "Disposal planned",
      "adverse_regulation": "Adverse regulation",
      "economic_performance": "Economic performance",
      "reversal_indicator": "Conditions have improved",
      "other": "Other"
    },
    "indicatorOutcomes": {
      "pending": "Not yet assessed",
      "no_impairment": "Assessed — no impairment",
      "impaired": "Impaired",
      "reversed": "Reversed"
    },
    "impairmentKinds": {
      "loss": "Loss",
      "reversal": "Reversal"
    },
    "verificationStatuses": {
      "draft": "Draft",
      "in_progress": "In progress",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "dispositions": {
      "none": "Nothing to do",
      "relocated": "Relocate it",
      "recustodied": "Change custodian",
      "impair": "Raise an impairment",
      "dispose": "Dispose of it",
      "write_off": "Write it off",
      "investigate": "Investigate"
    },
    "books": {
      "title": "Depreciation books",
      "description": "A legal entity keeps one accounting book that posts, and as many tax or management books as it needs that do not.",
      "primaryHint": "Exactly one book per legal entity is primary. Only a book that posts to the GL touches a journal — a tax book produces figures and nothing else.",
      "loadFailed": "Depreciation books could not be loaded",
      "create": "New book",
      "createTitle": "New depreciation book",
      "createDescription": "A parallel basis: its own method, its own convention, its own carrying amounts.",
      "created": "Book created",
      "createFailed": "The book could not be created",
      "code": "Code",
      "name": "Name",
      "kind": "Kind",
      "convention": "Convention",
      "conventionHint": "How a part-month in service is treated in the first period.",
      "role": "Role",
      "primary": "Primary",
      "posts": "Posts to the GL",
      "doesNotPost": "Does not post",
      "postsHint": "Leave off for a tax or management book. Only one book per legal entity should post.",
      "source": "Source",
      "descriptionLabel": "Description",
      "active": "Active",
      "inactive": "Inactive",
      "tableLabel": "Depreciation books",
      "emptyTitle": "No books",
      "emptyDescription": "Every legal entity has a primary accounting book. Add a tax book to keep a second basis without a second ledger."
    },
    "assetBooks": {
      "title": "Books",
      "description": "This asset's carrying amount in every book it is held in. They disagree by design — that disagreement is the temporary difference.",
      "loadFailed": "This asset's books could not be loaded",
      "emptyTitle": "Not in any book",
      "emptyDescription": "An asset joins the primary book when it is acquired. Add it to a tax book to carry a second basis.",
      "book": "Book",
      "method": "Method",
      "life": "Life (months)",
      "lifeHint": "Leave blank to inherit the asset class's life.",
      "cost": "Cost",
      "salvage": "Salvage",
      "salvageHint": "Leave blank to inherit the asset class's salvage value.",
      "accumulated": "Accum. depreciation",
      "impairment": "Accum. impairment",
      "carrying": "Carrying",
      "add": "Add a book",
      "addTitle": "Carry this asset in another book",
      "addDescription": "The new book starts from the same cost and in-service date unless you say otherwise.",
      "added": "Asset added to the book",
      "addFailed": "The asset could not be added to that book",
      "change": "Change method",
      "changeTitle": "Change method, life or salvage",
      "changeDescription": "IAS 8 treats this as a change in estimate.",
      "prospectiveWarning": "This is prospective. The remaining depreciable amount is spread over the remaining life, and nothing already posted moves.",
      "reason": "Reason",
      "changed": "Book basis changed",
      "changeFailed": "The book basis could not be changed"
    },
    "impairment": {
      "title": "Impairment",
      "description": "An indicator says look; the assessment decides; the loss or reversal posts.",
      "tabIndicators": "Indicators",
      "tabImpairments": "Impairments",
      "tabsLabel": "Impairment views",
      "indicatorHint": "An indicator is not an impairment. Assessing one and finding nothing wrong is a result, not a dead end.",
      "capHint": "A reversal may not carry an asset above what it would have been worth had the impairment never happened. That ceiling is the cap column.",
      "indicatorsFailed": "Impairment indicators could not be loaded",
      "impairmentsFailed": "Impairments could not be loaded",
      "assessedOn": "Raised",
      "subject": "Subject",
      "wholeClass": "Whole class {code}",
      "raisedBy": "Raised by",
      "byJob": "Nightly sweep",
      "byPerson": "A person",
      "outcome": "Outcome",
      "anyOutcome": "Any outcome",
      "indicatorsTableLabel": "Impairment indicators",
      "indicatorsEmptyTitle": "No indicators",
      "indicatorsEmptyDescription": "The nightly sweep raises one when an asset is idle, damaged or scheduled for disposal. Raise one by hand when you know something it does not.",
      "impairmentsTableLabel": "Impairments",
      "impairmentsEmptyTitle": "No impairments",
      "impairmentsEmptyDescription": "Assess an indicator to raise one.",
      "impairedOn": "Date",
      "asset": "Asset",
      "kind": "Kind",
      "carrying": "Carrying",
      "recoverable": "Recoverable",
      "recoverableHint": "The higher of fair value less costs to sell, and value in use.",
      "amount": "Amount",
      "cap": "Reversal cap",
      "capIs": "The reversal may not exceed a carrying amount of {amount}.",
      "journal": "Journal",
      "notPosted": "Not posted",
      "book": "Book",
      "bookHint": "An impairment is per book: a tax book may carry the asset at a different amount.",
      "assess": "Assess",
      "assessTitle": "Assess an indicator",
      "assessDescription": "Compare the carrying amount with what the asset can still recover.",
      "assessed": "Indicator assessed",
      "assessFailed": "The indicator could not be assessed",
      "note": "Note",
      "post": "Post",
      "posted": "Impairment posted",
      "postFailed": "The impairment could not be posted",
      "reverse": "Reverse",
      "reverseTitle": "Reverse an impairment",
      "reverseDescription": "Conditions improved and the asset can recover more than it is carried at.",
      "reverseCapWarning": "A reversal is capped at the notional carrying amount — what the asset would be worth today had it never been impaired. Beyond that the server refuses.",
      "reverseOn": "Reverse on",
      "reversed": "Impairment reversed",
      "reverseFailed": "The impairment could not be reversed"
    },
    "verification": {
      "listTitle": "Physical verification",
      "listDescription": "Counting the register against the world. A blind count is the only kind worth doing.",
      "loadFailed": "Verification runs could not be loaded",
      "create": "New run",
      "createTitle": "New verification run",
      "createDescription": "Scope it by location or custodian, or leave both blank for the whole register.",
      "created": "Verification run created",
      "createFailed": "The verification run could not be created",
      "code": "Code",
      "name": "Name",
      "scheduledOn": "Scheduled",
      "scope": "Scope",
      "scopeHint": "Blank means the whole register.",
      "wholeRegister": "Whole register",
      "location": "Location",
      "custodian": "Custodian",
      "blind": "Blind",
      "blindYes": "Blind count",
      "blindLabel": "Blind count",
      "blindHint": "On a blind run the counter does not see where the asset is supposed to be until they have said whether they found it. A sheet that shows the answer first is a confirmation, not a count.",
      "blindSheetHint": "This is a blind count. Record found or not found first; the expected location appears afterwards.",
      "anyStatus": "Any status",
      "counts": "Found",
      "missing": "Missing",
      "counted": "Counted",
      "note": "Note",
      "tableLabel": "Verification runs",
      "emptyTitle": "No verification runs",
      "emptyDescription": "Schedule one for a location or a custodian and the register generates the count sheet.",
      "sheetTitle": "Count sheet — {code}",
      "sheetPanelTitle": "Lines",
      "sheetPanelDescription": "Found or not found on every line; the disposition is what happens next.",
      "sheetEmptyTitle": "No lines",
      "sheetEmptyDescription": "The run generates its lines from the register when it starts.",
      "asset": "Asset",
      "found": "Found",
      "foundYes": "Found",
      "foundNo": "Missing",
      "expected": "Expected",
      "hidden": "Hidden until counted",
      "actualLocation": "Actual location",
      "actualCustodian": "Actual custodian",
      "condition": "Condition",
      "disposition": "Disposition",
      "record": "Record",
      "recorded": "Lines recorded",
      "recordFailed": "The lines could not be recorded",
      "complete": "Complete the run",
      "completed": "Verification run completed",
      "completeFailed": "The run could not be completed"
    },
    "componentise": {
      "title": "Componentise {assetNo}",
      "description": "Split one asset into the parts that wear out at different rates.",
      "crumb": "Componentise",
      "register": "Register",
      "loadFailed": "The asset could not be loaded",
      "parentCost": "Parent cost",
      "allocated": "Allocated",
      "residual": "Unallocated",
      "unbalanced": "The components must add up to the parent's cost, to the cent. Describing a building more precisely does not change what it cost.",
      "incomplete": "Every component needs a name and a cost share.",
      "alreadySplit": "This asset is already a {kind}.",
      "effectiveOn": "Effective on",
      "gridTitle": "Components",
      "gridDescription": "At least two. Each carries its own method and life — that is the point of splitting.",
      "addRow": "Add a component",
      "removeRow": "Remove",
      "name": "Name",
      "costShare": "Cost share",
      "note": "Note",
      "submit": "Split the asset",
      "done": "Asset componentised",
      "failed": "The asset could not be componentised"
    },
    "comparison": {
      "title": "Book comparison",
      "description": "Two books' carrying amounts side by side. The difference column is the temporary difference a deferred-tax working is made of.",
      "loadFailed": "The comparison could not be loaded",
      "bookA": "Book A",
      "bookB": "Book B",
      "asOf": "As of",
      "chooseTitle": "Choose two books and a date",
      "chooseDescription": "Usually the accounting book against the tax book, at period end.",
      "tableTitle": "By asset",
      "tableDescription": "Every asset carried in both books.",
      "emptyTitle": "Nothing to compare",
      "emptyDescription": "No asset is carried in both of these books at that date.",
      "asset": "Asset",
      "assetName": "Name",
      "cost": "cost",
      "accumulated": "accum. depreciation",
      "impairment": "accum. impairment",
      "carrying": "carrying",
      "difference": "Difference"
    },
    "ft13": {
      "asset": {
        "booksTab": "Books",
        "months": "{months} months",
        "openPendingDisposal": "Open the pending disposal",
        "reloaded": "Someone else changed this asset while you were editing. It has been reloaded; your changes are kept below. Review them and save again.",
        "unitById": "Unit #{id}"
      },
      "capex": {
        "account": "Asset account",
        "additions": "Capitalised additions",
        "additionsCount": "Additions (count)",
        "additionsCountShort": "{count} additions",
        "budget": "Capital budget",
        "description": "Assets capitalised in the window, by asset account, against the approved capital budget for the same periods.",
        "emptyDescription": "Nothing was capitalised in this window, and no capital budget falls inside it.",
        "emptyTitle": "No capital expenditure in this window",
        "loadFailed": "Could not load capital expenditure against budget",
        "noBudget": "This legal entity has no approved capital budget in force (a budget model whose purpose is capital). Every budget figure is zero, so the rows show the capitalised additions alone.",
        "percent": "{value}%",
        "title": "Capital expenditure against budget",
        "utilisation": "Utilisation",
        "variance": "Variance"
      },
      "capitalize": {
        "cipNotConfigured": "No construction-in-progress account is set for this legal entity, so there is no CIP balance to capitalise. Set one in the asset settings."
      },
      "chooseEntityDescription": "Choose a legal entity above. Its figures are in that entity's base currency.",
      "chooseEntityTitle": "Choose a legal entity",
      "dispose": {
        "needsApproval": "This disposal is above the threshold: it will be submitted for approval, and nothing posts until a second person approves it.",
        "submitForApproval": "Submit for approval",
        "threshold": "Disposals whose proceeds or net book value exceed this amount need a second person's approval:"
      },
      "disposalStatus": {
        "cancelled": "Cancelled",
        "lapsed": "Lapsed",
        "pending_approval": "Pending approval",
        "posted": "Posted",
        "rejected": "Rejected"
      },
      "disposals": {
        "allAssets": "Show every asset",
        "approval": "Approval",
        "assetFilter": "Showing the disposals of asset #{id} only.",
        "caption": "Asset disposals, newest first",
        "count": "Disposals",
        "decidedBy": "Decided by",
        "decisionNote": "Decision note",
        "description": "Every disposal, posted or waiting for approval, with its method, proceeds, the receipt they reconcile to, and the gain or loss.",
        "detailFailed": "Could not load this disposal",
        "detailTitle": "Disposal",
        "details": "Details",
        "emptyDescription": "Disposals are made from an asset's own screen. A disposal above the approval threshold appears here as pending until a second person approves it.",
        "emptyTitle": "No disposals match",
        "gainLossChooseEntity": "The gain and loss analysis is for one legal entity at a time. Choose one above.",
        "gainLossDescription": "Proceeds against net book value for every posted disposal in the window. A disposal waiting for approval has posted nothing and is not here.",
        "gainLossEmptyDescription": "No disposal posted in this window for this legal entity.",
        "gainLossEmptyTitle": "No posted disposals",
        "gainLossFailed": "Could not load the gain and loss analysis",
        "gainLossTitle": "Disposal gain and loss",
        "loadFailed": "Could not load the disposals",
        "netGainLoss": "Net gain or loss",
        "openInbox": "Open the approvals inbox",
        "pendingDetail": "Waiting for a second person's approval. Nothing has posted; the asset is still in service, and the figures are those at the time of the request.",
        "projectionNote": "For a disposal pending approval, the net book value and the gain or loss are a projection at request time. They become final when it posts.",
        "requestedBy": "Requested by",
        "searchHint": "Asset number or name, or the receipt reference",
        "tabs": {
          "gainLoss": "Gain and loss",
          "label": "Disposal views",
          "list": "Disposals"
        },
        "title": "Disposals",
        "totalGain": "Total gain",
        "totalLoss": "Total loss",
        "totalNbv": "Net book value",
        "totalProceeds": "Proceeds"
      },
      "entityById": "Legal entity #{id}",
      "events": {
        "approvedBy": "Approved by",
        "recordedBy": "Recorded by",
        "truncated": "Only the newest {count} events are shown. Narrow the list by event type to see older ones."
      },
      "forecast": {
        "assetCount": "Assets",
        "charge": "Projected charge",
        "description": "Projected depreciation by period, asset class or cost centre, to the end of each asset's life within the window.",
        "emptyDescription": "No in-service asset in this book has a charge projected inside this window.",
        "emptyTitle": "Nothing to project",
        "groupBy": {
          "class": "Asset class",
          "cost_centre": "Cost centre",
          "period": "Period"
        },
        "groupByLabel": "Group by",
        "loadFailed": "Could not load the depreciation forecast",
        "primaryBook": "Primary book",
        "title": "Depreciation schedule and forecast",
        "total": "Total"
      },
      "ic": {
        "approvalNote": "Like any disposal, a transfer whose price or net book value is above the sending legal entity's disposal threshold posts nothing until a second person approves it.",
        "asset": "Asset",
        "assetHint": "An in-service asset of the sending legal entity",
        "assetPlaceholder": "Choose an asset",
        "caption": "Inter-company asset transfers",
        "chooseSender": "Choose the sending legal entity above to start a transfer.",
        "description": "Assets moved between legal entities. A transfer above the sending entity's disposal threshold waits here for a second person's approval.",
        "emptyDescription": "Start a transfer above, or from an asset's own screen.",
        "emptyTitle": "No inter-company transfers",
        "entityHint": "The sending legal entity",
        "fromEntity": "From",
        "listTitle": "Transfers",
        "loadFailed": "Could not load the inter-company transfers",
        "noAssets": "This legal entity has no in-service asset that can be transferred.",
        "pendingEmptyTitle": "No transfers waiting for approval",
        "pendingNote": "These transfers have posted nothing yet. Each asset stays in service in the sending legal entity until a second person approves the transfer.",
        "pendingTitle": "Waiting for approval",
        "startDescription": "Pick an asset of the sending legal entity, then set the receiver, date and price.",
        "startTitle": "Start a transfer",
        "submittedDetail": "The transfer of {assetNo} is above the disposal approval threshold. Nothing posts in either legal entity until a second person approves it.",
        "title": "Inter-company transfers",
        "toClass": "Receiving asset class",
        "toClassDefault": "The class with the same code",
        "toClassHint": "Optional. Left empty, the receiving legal entity's active class with the same code is used."
      },
      "people": {
        "userById": "User #{id}"
      },
      "preview": {
        "account": "Account",
        "action": "Preview",
        "allBooks": "Every active book",
        "book": "Book",
        "bookHint": "Leave empty for every active book",
        "bookTitle": "Book {book}",
        "bookTotal": "{count} charges, total",
        "charge": "Charge",
        "chargeCount": "Charges",
        "closingNbv": "Closing net book value",
        "confirm": "Post depreciation for {period} exactly as previewed?",
        "confirmPost": "Confirm and post",
        "credit": "Credit",
        "debit": "Debit",
        "description": "See exactly what a depreciation run would charge, per asset and book, before anything posts.",
        "differs": "The posted total differs from the preview: something changed between the two.",
        "emptyDescription": "Choose the legal entity, the date the run is for and, optionally, one book. Then preview.",
        "emptyTitle": "Nothing previewed yet",
        "failed": "The preview failed",
        "journalLines": "Journal lines",
        "noCharges": "Nothing to charge in this book for this period.",
        "noGl": "Does not post",
        "noLines": "No journal",
        "on": "Run for",
        "onHint": "The date the run is for; its period is the one charged",
        "openingNbv": "Opening net book value",
        "period": "Period",
        "periodNo": "Period no.",
        "post": "Post depreciation",
        "postExplain": "Posting runs depreciation for the previewed date and book. It is refused if the period was already run.",
        "postFailed": "The depreciation run failed",
        "posted": "Depreciation posted",
        "postedDetail": "Depreciation for {period} has posted.",
        "postsToGl": "Posts to the ledger",
        "primary": "Primary",
        "resultCount": "{count} assets charged",
        "resultNothing": "Nothing was charged: every asset had already been charged for this period.",
        "resultTitle": "Run result",
        "runDate": "Run date",
        "showLines": "Show {count} lines",
        "skipped": "{count} assets not charged:",
        "stale": "The inputs changed since this preview. Preview again before posting.",
        "title": "Depreciation preview",
        "totalCharge": "Total charge",
        "writesNothing": "A preview writes nothing: no run, journal or audit entry. It is refused for a closed period exactly as the run would be."
      },
      "register": {
        "book": "Book",
        "bookFailed": "That book's figures could not be loaded.",
        "bookHint": "Show cost, depreciation and net book value in another book",
        "bookLoading": "Loading the book's figures.",
        "bookNote": "Cost, accumulated depreciation and net book value are shown in book {book}, as at {asOf}. An asset not carried in that book shows a dash.",
        "costCentreHint": "Where the depreciation charge is posted",
        "expiringHint": "On or before this date",
        "insuranceExpiringBefore": "Insurance ending by",
        "insuranceExpiry": "Insurance expiry",
        "insurancePolicy": "Insurance policy",
        "notInBook": "Not carried in this book",
        "primaryBook": "Primary book",
        "serialNo": "Serial number",
        "serialNoHint": "The manufacturer's serial, for verification counts",
        "sourceRef": "Source reference",
        "sourceRefHint": "The purchase order, invoice, project or construction-in-progress record the asset came from",
        "tagNo": "Asset tag",
        "tagNoHint": "The physical tag; unique within the legal entity",
        "tagSerial": "Tag / serial",
        "warrantyExpiringBefore": "Warranty ending by",
        "warrantyExpiry": "Warranty expiry"
      },
      "schedulePreview": {
        "description": "The schedule this asset would carry in its primary book, period by period to the end of its life, from the values above. Nothing is saved until you confirm.",
        "incomplete": "Choose a class and enter the cost and the in-service date to see the schedule.",
        "residual": "Net book value at end of life",
        "showAll": "Show all {count} periods",
        "title": "Depreciation schedule preview",
        "total": "Total depreciation",
        "updating": "Updating for the values you just changed."
      },
      "settings": {
        "accountById": "Account #{id}",
        "amountHint": "In the legal entity's base currency, zero or more",
        "amountInvalid": "Enter the amount as a plain decimal number",
        "amountNegative": "The threshold cannot be negative",
        "awaitsApproval": "Awaits approval",
        "awaitsApprovalDetail": "This change loosens a control, so it is not in force yet. It applies only when a second person approves it.",
        "cip": {
          "description": "The ledger account whose balance Capitalise From Source offers as construction in progress. Without one there is no CIP source.",
          "field": "Construction-in-progress account",
          "none": "None set",
          "remove": "Remove the account",
          "title": "Construction-in-progress account"
        },
        "controlRule": "Tightening a threshold (setting one, or lowering it) applies at once. Loosening it (raising it, or removing it) waits for a second person's approval and is shown below until then.",
        "description": "Per legal entity: the amounts above which a disposal or an impairment needs a second person's approval, and the construction-in-progress account.",
        "disposal": {
          "description": "A disposal whose proceeds or net book value (the larger) exceeds this amount is a request that posts only when a second person approves it.",
          "field": "Disposal approval threshold",
          "title": "Disposal approval threshold"
        },
        "impairment": {
          "description": "An impairment loss above this amount takes effect only when a second person approves it.",
          "field": "Impairment approval threshold",
          "title": "Impairment approval threshold"
        },
        "inForce": "In force",
        "loadFailed": "Could not load the asset settings",
        "noThreshold": "No threshold: no approval needed",
        "pendingBadge": "Change pending approval",
        "pendingRule": "Not in force until a second person approves it. Tightening the threshold now withdraws this request.",
        "proposed": "Proposed:",
        "proposedBy": "Proposed by {name} on",
        "proposedRemoval": "remove the threshold",
        "readOnly": "You can read these settings. Changing them needs the asset settings permission.",
        "reloaded": "Someone else changed these settings while you were editing. They have been reloaded; your value is kept. Review it and save again.",
        "removeThreshold": "Remove the threshold",
        "saveFailed": "The settings could not be saved",
        "saved": "Settings saved",
        "title": "Asset settings"
      },
      "windowInvalid": "The end date must be on or after the start date"
    },
    "bookEdit": {
      "edit": "Edit",
      "title": "Edit book {code}",
      "description": "Change the name, the convention, the description or whether the book is active.",
      "loadFailed": "The latest version of this book could not be loaded.",
      "stale": "Somebody else saved this book while you were editing. Reload the saved version, then reapply your changes.",
      "reload": "Reload the saved version",
      "fixedHint": "The kind, the primary flag and whether the book posts to the GL are fixed once a book exists.",
      "conventionHint": "Applies to depreciation calculated from now on. Periods already charged do not move.",
      "active": "Active",
      "activeHint": "An inactive book cannot be added to further assets. Assets already carried in it keep depreciating.",
      "saved": "Book saved",
      "saveFailed": "The book could not be saved"
    },
    "assetBookAccounts": {
      "edit": "Accounts",
      "title": "GL accounts — {book}",
      "description": "Override the accounts this asset uses in this book. Only future postings change.",
      "stale": "Somebody else changed this asset's book while you were editing. Reload the saved version, then reapply your changes.",
      "reload": "Reload the saved version",
      "noChart": "You cannot read the chart of accounts, so no account can be chosen here. Ask for the chart of accounts read permission.",
      "clearHint": "Leave a field empty to use the asset class's account. The server refuses an account that is not postable or belongs to another legal entity.",
      "classDefault": "Class default",
      "fields": {
        "assetAccountId": "Asset (cost) account",
        "accumulatedDepreciationAccountId": "Accumulated depreciation account",
        "depreciationExpenseAccountId": "Depreciation expense account",
        "impairmentExpenseAccountId": "Impairment loss account",
        "impairmentReversalAccountId": "Impairment reversal account",
        "gainLossAccountId": "Disposal gain or loss account"
      },
      "saved": "Accounts saved",
      "saveFailed": "The accounts could not be saved"
    },
    "bookSchedule": {
      "show": "Schedule",
      "hide": "Hide schedule",
      "loadFailed": "The depreciation schedule could not be loaded.",
      "title": "Depreciation schedule — {book}, {asset}",
      "empty": "This book has no periods to show yet. The schedule fills in once the asset is in service.",
      "period": "Period",
      "when": "Period or date",
      "opening": "Opening carrying amount",
      "charge": "Depreciation",
      "closing": "Closing carrying amount",
      "posted": "Posted",
      "projected": "Projected"
    },
    "impairmentCreate": {
      "open": "Record impairment",
      "title": "Record an impairment",
      "description": "Measure the loss for one asset in one book: its carrying amount against the recoverable amount.",
      "twoStep": "Recording does not post. Posting is a separate step for somebody holding the impairment post permission, so the loss is measured and booked by two people.",
      "noAssetRead": "You cannot read the asset register, so no asset can be chosen here. Ask for the asset read permission.",
      "assetPlaceholder": "Choose an asset in service",
      "amountInvalid": "Enter a plain amount with up to two decimals, for example 90000.00.",
      "reasonCode": "Reason code",
      "confirm": "Record impairment",
      "created": "Impairment recorded — awaiting posting",
      "failed": "The impairment could not be recorded",
      "booksFailed": "The legal entity's depreciation books could not be loaded, so impairments cannot be shown for this legal entity."
    },
    "indicatorCreate": {
      "open": "Raise indicator",
      "title": "Raise an impairment indicator",
      "description": "Record a sign that an asset — or a whole class — may be impaired. The indicator is then assessed like one the nightly check raised.",
      "scope": "Applies to",
      "scopeAsset": "One asset",
      "scopeClass": "A whole asset class",
      "class": "Asset class",
      "classPlaceholder": "Choose a class",
      "indicator": "Indicator",
      "confirm": "Raise indicator",
      "created": "Indicator raised",
      "failed": "The indicator could not be raised"
    },
    "disposeFt6": {
      "alreadyPending": "A disposal of this asset is already waiting for approval. It stays in service until that request is decided; another disposal cannot be raised meanwhile.",
      "errors": {
        "approvalUnresolvable": "This disposal is above the approval threshold, and no approver other than you is configured for asset disposals. An administrator must set up an approval policy or authority-matrix rule for asset disposals."
      },
      "fields": {
        "method": "Disposal method",
        "methodDefault": "From the proceeds (sale, or scrap when none)",
        "methodHint": "A sale has proceeds; a write-off or a donation has none; scrap may have a scrap value",
        "receiptRef": "Proceeds receipt reference",
        "receiptRefHint": "The receipt or bank reference the proceeds arrived under"
      },
      "methods": {
        "donation": "Donation",
        "sale": "Sale",
        "scrap": "Scrap",
        "write_off": "Write-off",
        "ic_transfer": "Inter-company transfer"
      },
      "pendingBadge": "Disposal pending approval",
      "submitted": "Submitted for approval",
      "submittedDetail": "{assetNo} is above the disposal approval threshold. It stays in service, and nothing is posted, until the request is approved."
    },
    "ft9": {
      "approval": {
        "approved": "Approved",
        "cancelled": "Cancelled",
        "column": "Approval",
        "lapsed": "Lapsed",
        "none": "Not required",
        "pending": "Pending approval",
        "rejected": "Rejected",
        "submitted": "Submitted for approval",
        "submittedDetail": "The impairment loss on {assetNo} is above the approval threshold. Nothing changes and nothing posts until a second person approves it.",
        "unresolvable": "This impairment is above the approval threshold, and no approver other than you is configured for asset impairments. An administrator must set up an approval policy or authority-matrix rule for asset impairments."
      },
      "capitalize": {
        "balanceDescription": {
          "cip": "Construction in progress with a balance still on the ledger. A source with nothing left is not listed.",
          "project": "Completed projects with work in progress still on the ledger. A project with nothing left is not listed."
        },
        "balanceIs": "Ledger balance on {account}:",
        "balancePanel": "Source balance",
        "costHint": "Required. The cost to capitalise, at most the balance on the source",
        "exceedsBalance": "The cost is more than the balance left on this source. Lower the cost to at most the balance shown.",
        "inServiceHint": "Required. The date the cost moves to the asset account",
        "kind": "Source of the cost",
        "kinds": {
          "cip": "Construction in progress",
          "cipHint": "Cost sitting on the construction-in-progress account",
          "project": "Completed project",
          "projectHint": "Work in progress of a completed project",
          "purchase": "Purchase (AP invoice line)",
          "purchaseHint": "A posted supplier invoice line; posts nothing"
        },
        "noSources": "Nothing is waiting to be capitalised from this source for this legal entity.",
        "postsFromSource": "This posts a journal: the cost moves Dr the asset account, Cr the project work-in-progress or construction-in-progress account, dated the in-service date.",
        "sourceDescription": "Where the cost of the new asset is coming from.",
        "sourceHint": "Only sources with a real ledger balance are listed",
        "sourceLabel": {
          "cip": "Construction-in-progress account",
          "project": "Project"
        },
        "sourcePanel": "Source",
        "sourcePlaceholder": "Choose a source",
        "sourceSearchHint": "Code or name",
        "sourcesFailed": "Could not load the sources to capitalise"
      },
      "eventTypes": {
        "acquire": "Acquired",
        "book_change": "Book change",
        "capitalise": "Capitalised",
        "componentise": "Componentised",
        "depreciate": "Depreciated",
        "dispose": "Disposed",
        "ic_transfer": "Inter-company transfer",
        "impair": "Impaired",
        "impair_reverse": "Impairment reversed",
        "revalue": "Revalued",
        "transfer": "Relocated",
        "update": "Edited"
      },
      "events": {
        "amount": "Amount",
        "caption": "Events of this asset, newest first",
        "change": "Change",
        "date": "Date",
        "description": "Every change to this asset, newest first. Rows are immutable.",
        "empty": "No events recorded for this asset yet.",
        "journal": "Journal",
        "loadFailed": "Could not load the event log",
        "title": "Event log",
        "type": "Event"
      },
      "ic": {
        "action": "Transfer to legal entity",
        "date": "Transfer date",
        "dateHint": "Must fall in an open period of both legal entities",
        "description": "Move this asset to another legal entity of the tenant.",
        "done": "Asset transferred",
        "doneDetail": "{from} was transferred and registered as {to} in the receiving legal entity.",
        "errors": {
          "blocked": "This asset cannot leave its legal entity as it stands: a pending disposal, an impairment still on its books or waiting for approval, or components must be cleared first.",
          "ruleMissing": "The sending or the receiving legal entity has no intercompany rule towards the other on this date, so there is no due-to or due-from account to post through. Set one up under the legal entities' intercompany rules."
        },
        "failed": "The transfer failed",
        "postsBoth": "This posts a journal in each legal entity: the sender derecognises the asset against due-from the receiver, and the receiver registers it against due-to the sender. The sending asset is disposed.",
        "price": "Price",
        "priceHint": "In the sending legal entity's base currency, greater than zero",
        "priceInvalid": "Enter the price as a plain decimal number",
        "priceZero": "The price must be greater than zero",
        "title": "Transfer {assetNo} to another legal entity",
        "toEntity": "Legal entity",
        "toEntityHint": "The receiving legal entity",
        "toEntityPlaceholder": "Choose a legal entity"
      },
      "note": {
        "justification": "Justification",
        "justificationHint": "Why the asset is impaired. Required.",
        "required": "A justification is required"
      },
      "source": {
        "ap_invoice_line": "AP invoice line",
        "cip": "Construction in progress",
        "ic_transfer": "Inter-company transfer",
        "label": "Acquired through",
        "manual": "Manual acquisition",
        "project": "Completed project"
      },
      "tabs": {
        "details": "Details",
        "events": "Events",
        "label": "Asset sections"
      }
    }
  },
  "budget": {
    "routeTitles": {
      "budgetModels": "Budget models",
      "budgetModel": "Budget model",
      "budgetVersion": "Budget version",
      "budgetVariance": "Budget variance",
      "budgetCommitments": "Commitments",
      "budgetControlLevels": "Budget control levels",
      "budgetForecastVsBudget": "Forecast versus budget",
      "budgetSettings": "Budget settings",
      "budgetTransfers": "Budget transfers",
      "budgetTransferNew": "Request a budget transfer",
      "budgetTransfer": "Budget transfer",
      "budgetSupplementary": "Supplementary budget requests",
      "budgetSupplementaryNew": "Request supplementary budget",
      "budgetSupplementaryRequest": "Supplementary budget request",
      "budgetCycles": "Budget cycles",
      "budgetCycle": "Budget cycle",
      "budgetVersions": "Budget versions",
      "budgetCompare": "Compare budget versions",
      "budgetAvailability": "Budget availability"
    },
    "nav": {
      "label": "Budgeting sections",
      "models": "Models",
      "variance": "Variance",
      "commitments": "Commitments",
      "controlLevels": "Control levels",
      "forecastVsBudget": "Forecast vs budget",
      "settings": "Settings",
      "transfers": "Transfers",
      "supplementary": "Supplementary",
      "cycles": "Cycles",
      "versions": "Versions",
      "availability": "Availability"
    },
    "models": {
      "title": "Budget models",
      "description": "A model holds one legal entity's plan for one fiscal year. The numbers live in its versions.",
      "detailDescription": "Versions of this plan. Only one of them is in force at a time.",
      "factsTitle": "Model",
      "listTitle": "Models",
      "backToList": "All models",
      "loadFailed": "The budget models did not load",
      "emptyTitle": "No budget models yet",
      "emptyDescription": "A model is a container: one legal entity, one fiscal year, a purpose such as operating or capital. Create one, then add a version and load the figures into it.",
      "openVariance": "Open the variance report for this year",
      "inForceNote": "{name} is in force — it is the version budget checks read.",
      "noneInForceNote": "No version of this model is in force, so nothing here is controlling any spend yet. Submit a version and have it approved.",
      "columns": {
        "name": "Name",
        "company": "Legal Entity",
        "fiscalYear": "Fiscal year",
        "purpose": "Purpose"
      },
      "actions": {
        "create": "New model"
      },
      "create": {
        "title": "New budget model",
        "description": "One legal entity, one fiscal year. Versions and figures come next.",
        "nameHint": "What people will call this plan, for example Operating budget.",
        "yearHint": "Four digits, matching a fiscal year the legal entity has periods for.",
        "yearInvalid": "Enter a four-digit fiscal year.",
        "purposeHint": "Free text, for example operating or capital."
      },
      "toasts": {
        "created": "{name} created",
        "createdDetail": "Add a version to start loading figures.",
        "createFailed": "The model was not created"
      }
    },
    "versions": {
      "title": "{model} · {version} (v{no})",
      "description": "Draft, submit for approval, then lock. Lines may be edited only while it is a draft.",
      "listTitle": "Versions",
      "factsTitle": "Version",
      "backToModel": "Back to the model",
      "loadFailed": "The budget version did not load",
      "emptyTitle": "No versions yet",
      "emptyDescription": "A version holds the figures and carries the status. Create one, then type them in, import a CSV, copy last year, or spread a total across the periods.",
      "actionsLabel": "Version actions",
      "awaitingApproval": "Submitted. An approver decides from the Approvals inbox; this screen shows the outcome when they do.",
      "railSubtitle": "{status} · {model}",
      "inForceTag": "in force",
      "totalMismatch": "The stored total ({stored}) and the sum of the lines on screen ({computed}) disagree. Reload; if it persists, this is a data fault worth reporting rather than a display one.",
      "inForce": {
        "approved": "This version is in force. It is what budget checks read when a document is submitted.",
        "locked": "This version is in force and frozen. Unlock it before it can be superseded."
      },
      "otherInForce": "{name} is the version in force, not this one. Nothing here affects a budget check until this version is approved.",
      "openInForce": "Open it",
      "noneInForce": "No version of this model is in force, so this model is not controlling any spend.",
      "readOnly": {
        "draft": "You do not have permission to edit budget lines.",
        "submitted": "Submitted for approval. Lines cannot be edited while a decision is pending.",
        "approved": "Approved and in force. Editing in place would move a control number nobody re-approved — supersede it and approve a new version instead.",
        "rejected": "Rejected. Create a new version rather than editing this record of what was proposed.",
        "locked": "Locked. Unlock it before making any change.",
        "superseded": "Superseded by a later version. Kept as a record of what was once in force."
      },
      "statuses": {
        "draft": "Draft",
        "submitted": "Submitted",
        "approved": "Approved",
        "rejected": "Rejected",
        "locked": "Locked",
        "superseded": "Superseded"
      },
      "columns": {
        "versionNo": "Version",
        "total": "Total",
        "note": "Note",
        "lastChange": "Last change"
      },
      "actions": {
        "create": "New version",
        "submit": "Submit for approval",
        "discard": "Discard draft"
      },
      "create": {
        "title": "New version",
        "description": "A fresh draft. Load its figures afterwards.",
        "defaultName": "Version {no}",
        "nameHint": "For example Draft 2 or Board submission."
      },
      "timeline": {
        "created": "Created",
        "submitted": "Submitted for approval",
        "approved": "Approved",
        "rejected": "Rejected",
        "locked": "Locked",
        "superseded": "Superseded"
      },
      "links": {
        "model": "Budget model",
        "variance": "Variance report",
        "approval": "Approvals inbox"
      },
      "toasts": {
        "submitted": "Submitted for approval",
        "submittedDetail": "An approver decides from the Approvals inbox.",
        "submitFailed": "The version was not submitted",
        "createFailed": "The version was not created",
        "discarded": "Draft discarded",
        "discardedDetail": "Its lines went with it.",
        "discardFailed": "The draft was not discarded"
      }
    },
    "transitions": {
      "reasonLabel": "Reason",
      "reasonHint": "Recorded in the audit trail. Say why, not what.",
      "lock": {
        "title": "Lock this version",
        "description": "Freeze the figures. It stays in force.",
        "consequence": "A locked version cannot be edited or superseded until it is unlocked.",
        "action": "Lock",
        "doneTitle": "Version locked",
        "doneDetail": "It is frozen and still in force."
      },
      "unlock": {
        "title": "Unlock this version",
        "description": "Return it to approved so it can be superseded.",
        "consequence": "It stays in force; unlocking only makes it replaceable again.",
        "action": "Unlock",
        "doneTitle": "Version unlocked",
        "doneDetail": "It is approved and in force."
      },
      "supersede": {
        "title": "Supersede this version",
        "description": "Take it out of force so another version can replace it.",
        "consequence": "Until another version is approved, this model contributes no budget lines at all. Where a legal entity's no-line policy is unlimited, those accounts stop being controlled.",
        "action": "Supersede",
        "doneTitle": "Version superseded",
        "doneDetail": "Approve a replacement to put a budget back in force."
      }
    },
    "lines": {
      "title": "Budget lines",
      "caption": "Budget lines by account and dimension across the fiscal periods",
      "loadFailed": "The budget lines did not load",
      "totalsLabel": "Total",
      "emptyRow": "No lines yet. Add a row, or load figures with an import, a copy or a spread.",
      "noPeriods": "This legal entity has no fiscal periods for {year}, so there are no columns to budget against. Create the fiscal year first.",
      "keyboardHint": "Enter moves down a row · Alt+↓ duplicates · Alt+Backspace removes · an empty cell removes its line",
      "columns": {
        "account": "Account",
        "dimensions": "Dimensions",
        "total": "Year"
      },
      "dimensions": {
        "costCenter": "Cost centre",
        "costCenterAny": "No cost centre",
        "profitCenter": "Profit centre",
        "profitCenterAny": "No profit centre",
        "branch": "Branch",
        "branchAny": "No branch"
      },
      "issues": {
        "duplicateKey": "Another row already budgets this account with these dimensions. Change a dimension, or remove one of the two — saving both would silently overwrite one with the other.",
        "keyIsFixed": "The account and dimensions identify every line on this row, so they cannot be changed here. Add the row you meant and clear this one.",
        "accountRequired": "Choose an account before entering a figure."
      },
      "actions": {
        "add": "Add a row",
        "duplicate": "Duplicate this row",
        "remove": "Remove this row"
      },
      "aria": {
        "account": "Account, row {row}",
        "cell": "{account}, {period}",
        "duplicate": "Duplicate row {row}",
        "remove": "Remove row {row}"
      },
      "toasts": {
        "rowRemoved": "Row removed",
        "rowRemovedDetail": "Its budget lines are gone, which is not the same as budgeting zero.",
        "writeFailed": "The change was not saved"
      }
    },
    "import": {
      "action": "Import CSV",
      "title": "Import budget lines",
      "description": "Upload a CSV, confirm what each column means, and the server validates every row before writing any of them.",
      "fileLabel": "CSV file",
      "fileHint": "One row per account, period and amount. Dimensions and a note are optional.",
      "unreadable": "That file could not be read as CSV. Check it is a text CSV rather than a spreadsheet workbook.",
      "mappingTitle": "Columns",
      "mappingRecognised": "Every column below was recognised. Change any of them if a header does not mean what it says.",
      "mappingAdjusted": "You have changed the mapping. Only the header row is rewritten; every data row is uploaded exactly as written.",
      "mapAria": "What the column {column} means",
      "ignoreColumn": "Ignore this column",
      "unnamedColumn": "(unnamed)",
      "previewTruncated": "Showing the first few rows only. Every row is uploaded.",
      "missingRequired": "Map a column to {fields} — the import cannot run without them.",
      "duplicateMapping": "{fields} is mapped to more than one column. Pick one.",
      "upload": "Validate and import",
      "uploading": "Importing",
      "doneTitle": "{count} lines imported",
      "doneLead": "The figures are in the grid.",
      "refusedTitle": "{count} rows have a problem",
      "refusedLead": "Nothing was written. Fix the file and upload it again — the import is refused whole, never in part.",
      "rowsRead": "{count} rows read, totalling",
      "errorsCaption": "Rows the import refused",
      "columns": {
        "inFile": "In your file",
        "meaning": "Means",
        "sample": "Sample values",
        "line": "Line",
        "column": "Column",
        "problem": "Problem"
      },
      "fields": {
        "accountCode": "Account code",
        "period": "Period number",
        "amount": "Amount",
        "costCenterCode": "Cost centre code",
        "profitCenterCode": "Profit centre code",
        "branchCode": "Branch code",
        "note": "Note"
      }
    },
    "copy": {
      "action": "Copy prior year",
      "title": "Copy from another version",
      "description": "Every line is copied period for period, by period number, and scaled by the uplift.",
      "sourceLabel": "Copy from",
      "sourceHint": "Any version of any model of the same legal entity.",
      "sourcePlaceholder": "Choose a version",
      "upliftLabel": "Uplift %",
      "upliftHint": "5 raises every amount by five per cent; -10 cuts them by ten. Leave empty to copy unchanged.",
      "upliftInvalid": "Enter a number, for example 5 or -10.",
      "previewLabel": "{base} would become",
      "doneTitle": "{count} line copied | {count} lines copied",
      "doneLead": "They are in the grid, ready to edit.",
      "skippedTitle": "These were skipped:"
    },
    "spread": {
      "action": "Spread a total",
      "title": "Spread a total across the year",
      "description": "One account, one figure, divided across every period.",
      "replacesWarning": "This replaces whatever is already budgeted for that account and dimensions, in every period of the year.",
      "totalLabel": "Total for the year",
      "totalHint": "The periods will sum to exactly this figure.",
      "totalInvalid": "Enter an amount.",
      "modeLabel": "How to divide it",
      "modes": {
        "even": "Evenly",
        "evenHint": "Equal per period; the last period absorbs the rounding.",
        "profile": "By a seasonal profile",
        "profileHint": "A percentage per period. They must sum to 100."
      },
      "percentHint": "%",
      "profileSum": "Profile totals {sum}%.",
      "profileMustSum": "It must be exactly 100 before this can run.",
      "previewTitle": "What will be written",
      "done": "{count} line written | {count} lines written"
    },
    "variance": {
      "title": "Budget variance",
      "description": "Budget against commitments and actuals, per account and dimension. Every figure opens what it is made of.",
      "scope": "Scope",
      "choosePlaceholder": "Choose a legal entity",
      "chooseScope": "Choose a legal entity and a fiscal year to run the report.",
      "loadFailed": "The variance report did not load",
      "emptyTitle": "Nothing to report for this year",
      "emptyDescription": "No budget lines, no commitments and no posted actuals for this legal entity and fiscal year yet.",
      "caption": "Budget, commitment, actual and available by account",
      "convention": "Available is budget less commitments less actuals, as the server computed it. A negative figure is an overspend and is shown in red brackets.",
      "totalsLabel": "Total",
      "unbudgeted": "Not budgeted",
      "columns": {
        "budget": "Budget",
        "commitment": "Committed",
        "actual": "Actual",
        "available": "Available",
        "percent": "Available %"
      }
    },
    "commitments": {
      "title": "Commitments",
      "description": "Money already spoken for: soft when a requisition line is approved, hard when its purchase order is.",
      "loadFailed": "The commitments did not load",
      "emptyTitle": "No commitments",
      "emptyDescription": "Commitments are raised by purchase requisitions and orders, which arrive with the procurement module. Until then this list is empty and every variance row's committed column reads zero.",
      "scopedToAccount": "Filtered to account {id}, as opened from the variance report.",
      "docLine": "{type} line {line}",
      "kinds": {
        "soft": "Soft",
        "hard": "Hard"
      },
      "statuses": {
        "open": "Open",
        "released": "Released"
      },
      "columns": {
        "document": "Document",
        "kind": "Kind",
        "amount": "Committed",
        "released": "Released",
        "remaining": "Remaining",
        "raised": "Raised"
      }
    },
    "outcome": {
      "unknownAccount": "Account {id}",
      "onLines": "on line {lines} | on lines {lines}",
      "openVariance": "Open the variance report",
      "columns": {
        "account": "Account",
        "budget": "Budget",
        "committed": "Committed",
        "actuals": "Actuals",
        "available": "Available",
        "requested": "This document"
      },
      "blocked": {
        "title": "This document exceeds its budget",
        "lead": "It was not submitted. The accounts below have less available than this document needs.",
        "caption": "Accounts that exceeded their budget",
        "advice": "Reduce the lines on those accounts, or have the budget raised and approved before submitting again."
      },
      "warned": {
        "title": "This document exceeds its budget",
        "lead": "It was submitted anyway — this legal entity's policy warns rather than blocks — and the figures below are what the check found.",
        "caption": "Accounts that exceeded their budget",
        "advice": "Nothing is required of you. Approvers will see the same figures."
      }
    },
    "controlLevels": {
      "title": "Budget control levels",
      "description": "What happens when a document exceeds the budget available to it: per cost centre, inheriting the legal entity default, with the overspend tolerated before the control triggers.",
      "choosePlaceholder": "Choose a legal entity",
      "chooseTitle": "Choose a legal entity",
      "chooseDescription": "Control levels belong to one legal entity: its default, and every cost centre that sets its own.",
      "loadFailed": "The control levels did not load",
      "defaultTitle": "Legal entity default",
      "defaultScope": "the legal entity default",
      "defaultPending": "A change to the default is awaiting approval. It can be changed again once that is decided.",
      "defaultExplainer": "Every cost centre without a level of its own inherits this one, and so does a document line with no cost centre.",
      "costCentresTitle": "Cost centres",
      "costCentresFooter": "A cost centre shown as inheriting follows the default, including any later change to it.",
      "noCostCentresTitle": "No cost centres to show",
      "noCostCentresDescription": "This legal entity has no active cost centres, so every document is controlled at the default level.",
      "noUnitTree": "Only cost centres with a level of their own are listed: reading the full cost-centre tree needs permission to read organisation units.",
      "pendingTitle": "Changes awaiting approval",
      "noPending": "Nothing is awaiting approval.",
      "pendingExplainer": "Loosening a control (a weaker level or a higher tolerance) takes effect only when someone other than the requester approves it in the Approvals inbox. Tightening applies at once.",
      "pendingLine": "from {from} ({fromPct}%) to {to} ({toPct}%)",
      "awaitingApproval": "Awaiting approval",
      "requestedAt": "Requested {at}",
      "approvalRequest": "approval request {id}",
      "reasonGiven": "Reason: {reason}",
      "percent": "{pct}%",
      "fields": {
        "company": "Legal entity",
        "level": "Control level",
        "tolerance": "Tolerance",
        "reason": "Reason for the change"
      },
      "columns": {
        "costCentre": "Cost centre",
        "level": "Control level",
        "tolerance": "Tolerance",
        "source": "Comes from",
        "pending": "Pending change"
      },
      "levels": {
        "none": "No control",
        "advisory": "Advisory only",
        "warn": "Warn on exceed",
        "block": "Block on exceed"
      },
      "levelHints": {
        "none": "Budget figures are still reported; nothing is checked.",
        "advisory": "The figures are shown to the submitter; nothing is refused or warned.",
        "warn": "A document beyond the budget and tolerance goes through with a warning.",
        "block": "A document beyond the budget and tolerance is refused, with the available amount returned."
      },
      "sources": {
        "cost_center": "Its own level",
        "company_default": "Inherited from the legal entity default"
      },
      "defaultBuiltIn": "No default has been set for this legal entity yet: the built-in level applies until one is saved.",
      "noLine": {
        "label": "When there is no budget line",
        "hint": "For an account, period and cost centre nobody has budgeted. Company-wide; set on the default only.",
        "unlimited": "Not controlled",
        "unlimitedHint": "Nothing was budgeted, so nothing is enforced.",
        "zero": "Nothing available",
        "zeroHint": "Any spend on an unbudgeted key exceeds its budget and meets the control level."
      },
      "pendingNoLine": "no budget line: from {from} to {to}",
      "actions": {
        "setOwn": "Set own level",
        "change": "Change"
      },
      "form": {
        "title": "Control level for {scope}",
        "description": "Tightening applies as soon as you save. Loosening is sent for approval and applies only when someone else approves it.",
        "reloaded": "Someone else changed this control level while you had it open. It has been reloaded; check it and save your change again.",
        "currently": "Currently {level}, tolerance {pct}%.",
        "toleranceHint": "Enter 8.75 for 8.75%. The overspend allowed before the control triggers.",
        "toleranceUnused": "This level never triggers, so it carries no tolerance.",
        "toleranceRange": "Enter a percentage from 0 to 100, for example 8.75.",
        "reasonRequired": "Say why the control level is changing.",
        "unchanged": "This is already the level in force here. Choose a different level or tolerance.",
        "tighten": "This tightens the control. It applies as soon as you save.",
        "loosen": "This loosens the control. It is sent for approval and applies only when someone other than you approves it.",
        "submitForApproval": "Submit for approval",
        "apply": "Apply"
      },
      "toasts": {
        "applied": "Control level applied",
        "appliedDetail": "It applies to the next document checked against this budget.",
        "pending": "Sent for approval",
        "pendingDetail": "The current level stays in force until someone other than you approves the change."
      }
    },
    "drivers": {
      "title": "Line details: drivers and justification",
      "derivedHint": "This amount is derived from the line's driver quantity and rate. Edit the drivers in the line details below.",
      "derived": "derived",
      "filterLabel": "Show",
      "filters": {
        "all": "All lines",
        "drivers": "Driver-based lines",
        "flagged": "Lines needing attention"
      },
      "explainer": "A driver-based line needs both a quantity and a rate; its amount is calculated by the server. A material movement against the prior year needs a justification.",
      "caption": "Drivers and justification of each budget line",
      "columns": {
        "period": "Period",
        "amount": "Amount",
        "driverQty": "Driver quantity",
        "driverRate": "Driver rate",
        "justification": "Justification"
      },
      "actualToDate": "Posted actuals",
      "aria": {
        "driverQty": "Driver quantity, account {account}, {period}",
        "driverRate": "Driver rate, account {account}, {period}",
        "justification": "Justification, account {account}, {period}"
      },
      "malformed": {
        "qty": "Up to 4 decimal places, digits only.",
        "rate": "Up to 6 decimal places, digits only."
      },
      "empty": "No lines to show.",
      "truncated": "Showing the first {max} lines. Narrow the list to see the rest.",
      "threshold": {
        "both": "more than {pct}% of the prior-year figure and more than {amount}",
        "pct": "more than {pct}% of the prior-year figure",
        "amount": "more than {amount}"
      },
      "basis": {
        "budget": "prior-year budget",
        "actuals": "prior-year actuals"
      },
      "issues": {
        "justification": "This line moves {movement} against the {basis} of {prior}, which is material ({threshold}). A justification is required.",
        "driverQty": "A driver-based line needs a driver quantity.",
        "driverRate": "A driver-based line needs a driver rate.",
        "summary": "{count} line(s) need attention before this version can be submitted."
      }
    },
    "assumptions": {
      "label": "Assumptions",
      "hintBudget": "What this budget assumes. Required before it can be submitted.",
      "hintForecast": "What this forecast assumes. Optional.",
      "requiredError": "State the assumptions behind this budget before submitting it.",
      "none": "No assumptions stated.",
      "save": "Save assumptions",
      "saved": "Assumptions saved",
      "requiredToSubmit": "State the assumptions before submitting this budget.",
      "saveFirst": "Save the assumptions before submitting."
    },
    "forecast": {
      "kinds": {
        "budget": "Budget",
        "forecast": "Forecast"
      },
      "banner": "This is a revised forecast, with actuals to {asOf} and the plan after it. A forecast never controls spend.",
      "openSource": "Open the source version",
      "revise": {
        "title": "Revise forecast",
        "description": "Creates a new draft forecast from this version. Periods that ended before the as-of date carry posted actuals; later periods keep this version's plan. This version is not changed.",
        "action": "Revise forecast",
        "name": "Name",
        "nameHint": "Leave blank for the default name.",
        "asOf": "Actuals up to",
        "asOfHint": "Leave blank for today in the tenant's timezone.",
        "asOfInvalid": "Enter a date.",
        "assumptions": "Assumptions",
        "assumptionsHint": "Optional. It can be added later.",
        "note": "Note",
        "doneTitle": "Forecast created",
        "doneDetail": "The new forecast is open for editing."
      },
      "baseline": {
        "title": "Freeze a baseline",
        "description": "Takes an immutable snapshot of this version's lines for later comparison. Taking another adds baseline N+1.",
        "action": "Freeze baseline",
        "label": "Label",
        "labelHint": "Leave blank for \"Baseline N\".",
        "doneTitle": "Baseline frozen",
        "doneDetail": "Baseline {no} holds {count} lines."
      }
    },
    "forecastReport": {
      "title": "Forecast versus budget",
      "description": "A revised forecast against the budget that controls spend, key by key, with the drivers of change, the justification and the movement since its latest baseline.",
      "company": "Legal entity",
      "choosePlaceholder": "Choose a legal entity",
      "chooseTitle": "Choose a legal entity and a fiscal year",
      "chooseDescription": "The report covers one legal entity and one fiscal year.",
      "loadFailed": "The report did not load",
      "noneTitle": "No forecast for this year",
      "noneDescription": "Revise an approved budget into a forecast to compare it here.",
      "forecastTitle": "Forecast",
      "forecast": "Forecast version",
      "asOf": "Actuals up to",
      "budgetVersion": "Budget compared",
      "openBudget": "Open the budget in force",
      "noBudget": "No budget in force",
      "baseline": "Latest baseline",
      "noBaseline": "None taken",
      "rowsTitle": "By account and period",
      "onlyMoved": "Only keys where the forecast differs from budget",
      "caption": "Forecast versus budget by account and period",
      "columns": {
        "budget": "Budget",
        "forecast": "Forecast",
        "variance": "Variance",
        "variancePct": "Variance %",
        "baseline": "Baseline",
        "changeSinceBaseline": "Change since baseline",
        "drivers": "Drivers (quantity × rate)"
      },
      "forecastDrivers": "Forecast",
      "budgetDrivers": "Budget",
      "emptyRows": "No keys to show."
    },
    "settings": {
      "title": "Budget settings",
      "description": "The materiality threshold above which a line's movement against the prior year needs a justification at submission.",
      "company": "Legal entity",
      "choosePlaceholder": "Choose a legal entity",
      "chooseTitle": "Choose a legal entity",
      "chooseDescription": "Budget settings belong to one legal entity.",
      "loadFailed": "The budget settings did not load",
      "materialityTitle": "Materiality",
      "isDefault": "Defaults in use",
      "explainer": "A movement is material when it exceeds every criterion that is set. Clear a field to switch that criterion off; at least one is required.",
      "pct": "Percent of the prior-year figure",
      "pctHint": "Enter 8.75 for 8.75%",
      "pctRange": "Enter a percent between 0 and 100.",
      "amount": "Amount ({currency})",
      "amountHint": "In the legal entity's base currency.",
      "amountInvalid": "Enter a non-negative amount.",
      "needOne": "Set a percent, an amount, or both.",
      "save": "Save settings",
      "readOnly": "You can view these settings but not change them.",
      "awaitingApproval": "Awaiting approval",
      "inForce": "In force:",
      "requested": "requested:",
      "requestedBy": "Requested by user {user} on {at}",
      "openApprovals": "Open the approvals inbox (request {id})",
      "approvalUnresolvable": "No approver other than you could be found for this change. Ask an administrator to assign a Finance Manager.",
      "off": "off",
      "toasts": {
        "pending": "Change sent for approval",
        "pendingDetail": "Loosening the threshold takes effect only when someone else approves it. The current threshold stays in force.",
        "saved": "Settings saved",
        "savedDetail": "The new threshold applies to the next submission."
      }
    },
    "movements": {
      "fields": {
        "company": "Legal entity",
        "amount": "Amount",
        "amountHint": "A positive amount with up to two decimals.",
        "amountInvalid": "Enter a positive amount with at most two decimals.",
        "reason": "Reason",
        "reasonRequired": "A reason is required.",
        "fiscalYear": "Fiscal year",
        "period": "Period",
        "account": "Account",
        "costCentre": "Cost centre",
        "noCostCentre": "No cost centre"
      },
      "statuses": {
        "pending": "Pending approval",
        "approved": "Approved",
        "rejected": "Rejected"
      },
      "columns": {
        "requested": "Requested",
        "approval": "Approval",
        "requestedBy": "Requested by",
        "decidedBy": "Decided by",
        "appliedAt": "Applied"
      },
      "approvalRequest": "Approval request {id}",
      "history": "Requester and decision",
      "decisionNote": "Decision note: {note}",
      "userFallback": "User {id}",
      "availability": {
        "noPermission": "You do not have permission to see availability, so the balance is not shown. The server still checks it.",
        "pick": "Choose a period and an account to see what is available.",
        "loading": "Loading availability...",
        "unbudgeted": "This key has no budget line of its own. The figures are the no-line policy's, not a budget held here.",
        "budget": "Budget",
        "commitments": "Commitments",
        "actuals": "Actuals",
        "available": "Available"
      },
      "chain": {
        "title": "Approval chain",
        "none": "No approval request is attached to this record.",
        "unavailable": "The approval chain could not be loaded. The decision is still made in the Approvals Inbox.",
        "step": "Step {n}",
        "unassigned": "No holder resolved",
        "sodNote": "The requester is never one of the approvers. Anyone who approved any step cannot be the requester.",
        "openInbox": "Open the Approvals Inbox",
        "statuses": {
          "pending": "Waiting",
          "active": "In progress",
          "approved": "Approved",
          "completed": "Completed",
          "rejected": "Rejected",
          "skipped": "Skipped",
          "voided": "Voided"
        }
      }
    },
    "transfers": {
      "title": "Budget transfers",
      "description": "Moves of budget between cost centres or accounts. A transfer is applied only once someone other than the requester approves it.",
      "actions": {
        "request": "Request transfer"
      },
      "totalsTitle": "Register totals",
      "truncated": "The register report was cut at its row limit, so these totals cover the rows it returned.",
      "loadFailed": "Budget transfers could not be loaded",
      "emptyTitle": "No budget transfers",
      "emptyDescription": "No transfer matches these filters. Request one to move budget from a key that has it to a key that needs it.",
      "columns": {
        "number": "Transfer",
        "from": "From",
        "to": "To"
      },
      "toasts": {
        "requested": "Transfer {no} requested",
        "requestedDetail": "It is applied once someone other than you approves it.",
        "requestFailed": "The transfer could not be requested"
      },
      "request": {
        "title": "Request a budget transfer",
        "description": "Move an amount from one budget key to another within one fiscal year.",
        "from": "From (source)",
        "to": "To (destination)",
        "noPermission": "You do not have permission to request budget transfers.",
        "overAvailable": "This is more than the source has available now. The server will refuse it, and checks again when it is approved.",
        "approvalNote": "A transfer waits for approval by someone other than you; nothing moves until then. The source must hold a budget line of its own.",
        "submit": "Request transfer"
      },
      "detail": {
        "title": "Budget transfer",
        "description": "The two keys, the balance the source held, and the approval chain.",
        "back": "Back to transfers",
        "loadFailed": "This transfer could not be loaded",
        "summary": "Transfer",
        "availableAtRequest": "Source available at request",
        "availableAtApproval": "Source available at approval",
        "sourceBudget": "Source budget, before and after",
        "targetBudget": "Destination budget, before and after"
      }
    },
    "supplementary": {
      "title": "Supplementary budget requests",
      "description": "Requests to add budget at one key, with a justification. Approval is banded by value and never by the requester.",
      "actions": {
        "request": "Request supplementary budget"
      },
      "loadFailed": "Supplementary requests could not be loaded",
      "emptyTitle": "No supplementary requests",
      "emptyDescription": "No request matches these filters. Request one when a key needs more budget than it holds.",
      "columns": {
        "number": "Request",
        "key": "Budget key"
      },
      "toasts": {
        "requested": "Request {no} submitted",
        "requestedDetail": "It is applied once the approval chain for its value approves it.",
        "requestFailed": "The request could not be submitted"
      },
      "request": {
        "title": "Request supplementary budget",
        "description": "Add budget at one key and say why.",
        "target": "Budget key to increase",
        "noPermission": "You do not have permission to request supplementary budget.",
        "justification": "Justification",
        "justificationRequired": "A justification is required.",
        "approvalNote": "The request waits for approval by someone other than you; the budget does not change until then.",
        "submit": "Submit request",
        "band": {
          "finance_manager": "Below 100,000: expected to be approved by a Finance Manager. The detail screen shows the chain that was resolved.",
          "cfo": "100,000 or more: expected to need the CFO as well as a Finance Manager. The detail screen shows the chain that was resolved."
        }
      },
      "detail": {
        "title": "Supplementary budget request",
        "description": "The key, the amount, the justification and the approval chain.",
        "back": "Back to supplementary requests",
        "loadFailed": "This request could not be loaded",
        "summary": "Request",
        "budgetChange": "Budget, before and after"
      }
    },
    "cycles": {
      "title": "Budget cycles",
      "description": "A cycle is one legal entity's planning run for one fiscal year: a methodology, a submission deadline, and owners who submit their cost centres.",
      "detailDescription": "The cycle's definition, who has submitted, and its versions. Only one version is in force at a time.",
      "factsTitle": "Cycle",
      "backToList": "All cycles",
      "loadFailed": "The budget cycles did not load",
      "emptyTitle": "No budget cycles yet",
      "emptyDescription": "A cycle is a container: one legal entity, one fiscal year, a methodology and a deadline. Create one, assign cost-centre owners, open it, then add a version and load the figures.",
      "reloaded": "Someone else changed this cycle while you had it open. It has been reloaded; check it and apply your change again.",
      "compareVersions": "Compare versions",
      "actions": {
        "create": "New cycle",
        "open": "Open cycle",
        "close": "Close cycle",
        "edit": "Edit"
      },
      "fields": {
        "methodology": "Methodology",
        "methodologyHint": "Fixed once the cycle is opened.",
        "deadline": "Submission deadline",
        "deadlineHint": "The date owners must submit by. Owners are told it when the cycle opens.",
        "openedAt": "Opened",
        "closedAt": "Closed"
      },
      "methodologies": {
        "incremental": "Incremental",
        "zero_based": "Zero-based",
        "driver_based": "Driver-based",
        "rolling": "Rolling forecast"
      },
      "statuses": {
        "draft": "Draft",
        "open": "Open",
        "closed": "Closed"
      },
      "create": {
        "title": "New budget cycle",
        "description": "One legal entity, one fiscal year. Owners, versions and figures come next."
      },
      "edit": {
        "title": "Edit cycle",
        "description": "Changes are recorded in the audit trail.",
        "methodologyFixed": "The cycle is open or closed, so the methodology can no longer change.",
        "deadlineHint": "Leave empty to remove the deadline.",
        "deadlineFixed": "The cycle is closed, so the deadline can no longer change."
      },
      "open": {
        "title": "Open this cycle?",
        "message": "Opening notifies the {count} assigned cost-centre owners and starts the submission period. The methodology is fixed from then on."
      },
      "close": {
        "title": "Close this cycle?",
        "message": "{outstanding} cost centres have not submitted. Closing ends the cycle: owners can no longer be changed and nothing can be submitted. This cannot be undone."
      },
      "board": {
        "title": "Submissions",
        "assign": "Assign owner",
        "loadFailed": "The submission status did not load",
        "emptyTitle": "No owners assigned",
        "emptyDescription": "Assign an owner to each cost centre that prepares a budget. They are notified when the cycle opens, and submit their cost centre from here.",
        "progress": "{submitted} of {total} cost centres submitted",
        "costCentre": "Cost centre",
        "owner": "Owner",
        "submittedAt": "Submitted",
        "submit": "Submit",
        "reopen": "Reopen",
        "reassign": "Reassign",
        "remove": "Remove",
        "states": {
          "pending": "Outstanding",
          "submitted": "Submitted"
        }
      },
      "assign": {
        "title": "Assign a cost-centre owner",
        "description": "One owner per cost centre. On an open cycle the owner is notified at once."
      },
      "reassign": {
        "title": "Reassign {code}",
        "description": "Currently owned by {owner}. The new owner is notified if the cycle is open."
      },
      "remove": {
        "title": "Remove this owner?",
        "message": "{code} will no longer be owned by {owner} in this cycle."
      },
      "errors": {
        "nothingToSubmit": "This cost centre has no lines in the working version yet. Enter its figures, then submit.",
        "rowVersion": "Someone else changed this first. It has been reloaded; apply your change again."
      },
      "toasts": {
        "createdDetail": "Assign owners, then open the cycle.",
        "createFailed": "The cycle was not created",
        "saved": "Cycle saved",
        "saveFailed": "The cycle was not saved",
        "opened": "Cycle opened",
        "openedDetail": "Every assigned owner has been notified.",
        "closed": "Cycle closed",
        "openFailed": "The cycle was not opened",
        "closeFailed": "The cycle was not closed",
        "submitted": "{code} submitted",
        "reopened": "{code} reopened for its owner",
        "submitFailed": "The cost centre was not submitted",
        "reopenFailed": "The cost centre was not reopened",
        "assigned": "Owner assigned",
        "assignFailed": "The owner was not assigned",
        "reassigned": "{code} reassigned",
        "reassignFailed": "The cost centre was not reassigned",
        "removed": "Owner of {code} removed",
        "removeFailed": "The owner was not removed"
      }
    },
    "versionList": {
      "title": "Budget versions",
      "description": "Every version of every cycle. Tick two of the same legal entity to compare them.",
      "compareSelected": "Compare ({count}/2)",
      "compareHint": "Tick two versions of the same legal entity, then Compare.",
      "differentEntities": "The two versions belong to different legal entities. Versions can only be compared within one legal entity.",
      "loadFailed": "The budget versions did not load",
      "emptyTitle": "No versions match",
      "emptyDescription": "Versions are created inside a budget cycle. Open a cycle and add a version, or clear the filters.",
      "pick": "Pick to compare",
      "pickAria": "Pick {name} to compare",
      "cycle": "Cycle"
    },
    "compare": {
      "title": "Compare budget versions",
      "description": "Two versions of one legal entity, line by line. Every amount, delta and total is computed by the server.",
      "versionA": "Version A",
      "versionB": "Version B",
      "apply": "Compare",
      "swap": "Swap A and B",
      "samePicked": "Pick two different versions.",
      "emptyTitle": "Pick two versions",
      "emptyDescription": "Choose a legal entity, then version A and version B. The delta is B minus A.",
      "loadFailed": "The comparison did not load",
      "summaryTitle": "Summary",
      "totalA": "Total A",
      "totalB": "Total B",
      "totalDelta": "Total change (B − A)",
      "changedCount": "Lines that differ",
      "changedOnly": "Show only lines that differ",
      "noDifferencesTitle": "No differences",
      "noDifferencesDescription": "Every line has the same amount in both versions. Untick the filter to see them all.",
      "account": "Account",
      "period": "Period",
      "dimensions": "Dimensions",
      "amountA": "A",
      "amountB": "B",
      "delta": "Change",
      "change": "Movement",
      "changes": {
        "unchanged": "Unchanged",
        "changed": "Changed",
        "added": "Added in B",
        "removed": "Removed in B"
      }
    },
    "availability": {
      "title": "Budget availability",
      "description": "Budget, commitments, actuals and what is still available for one account and period — the same figures a budget check uses.",
      "account": "Account",
      "period": "Period",
      "costCentre": "Cost centre",
      "anyCostCentre": "Any (account-wide)",
      "check": "Check",
      "emptyTitle": "Pick an intersection",
      "emptyDescription": "Choose a legal entity, fiscal year, account and period, and optionally a cost centre, then Check.",
      "loadFailed": "The availability did not load",
      "unbudgeted": "No budget line matches this intersection. The budget shown comes from the legal entity's no-line policy, not from a plan.",
      "resultTitle": "Fiscal year {year}",
      "controlLevels": {
        "none": "No control",
        "advisory": "Advisory only",
        "warn": "Warn on exceed",
        "block": "Block on exceed"
      },
      "controlSources": {
        "cost_center": "Cost centre setting",
        "company_default": "Legal entity default"
      },
      "controlSource": "Control set by",
      "tolerance": "Tolerance",
      "toleranceValue": "{pct}%",
      "budget": "Budget",
      "commitments": "Commitments",
      "actuals": "Actuals",
      "available": "Available",
      "openVariance": "Open the variance report for this account"
    }
  },
  "inventory": {
    "filtersTitle": "Filters",
    "active": "Active",
    "inactive": "Inactive",
    "itemPickerTruncated": "Only the first two thousand items were loaded, so the item picker may be incomplete. Search to narrow it.",
    "routeTitles": {
      "items": "Items",
      "item": "Item",
      "serials": "Serial register",
      "warehouses": "Warehouses",
      "warehouse": "Warehouse",
      "stockLevels": "Stock levels",
      "stockLedger": "Stock ledger",
      "adjustments": "Stock adjustments",
      "adjustment": "Stock adjustment",
      "reasonCodes": "Adjustment reason codes",
      "cycleCounts": "Cycle counts",
      "cycleCount": "Cycle count",
      "transfers": "Stock transfers",
      "transfer": "Stock transfer",
      "revaluations": "Revaluations",
      "reorderSuggestions": "Reorder suggestions",
      "valuation": "Inventory valuation",
      "lots": "Lots",
      "lot": "Lot",
      "recalls": "Recalls",
      "recall": "Recall",
      "warehouseLayout": "Warehouse layout",
      "settings": "Inventory settings",
      "reservations": "Reservations",
      "shortages": "Shortages",
      "substitutes": "Substitutes",
      "countReview": "Count review",
      "parLevels": "Par levels",
      "requisitions": "Requisitions",
      "requisition": "Requisition",
      "waste": "Waste",
      "shrinkage": "Shrinkage",
      "recipes": "Recipes",
      "recipe": "Recipe",
      "usageVariance": "Usage variance",
      "depletions": "Depletion runs",
      "haccp": "Food safety",
      "shipments": "Landed cost",
      "landedCostSetup": "Landed-cost setup",
      "shipment": "Shipment",
      "landedCostAging": "Clearing aging",
      "replenishment": "Replenishment",
      "classification": "Slow and obsolete stock",
      "recon": "Valuation reconciliation",
      "reconRun": "Reconciliation run"
    },
    "fields": {
      "sku": "SKU",
      "item": "Item",
      "itemPlaceholder": "Choose an item",
      "type": "Type",
      "baseUom": "Base unit",
      "uomCode": "Unit",
      "conversionFactor": "Conversion factor",
      "defaults": "Defaults",
      "purchaseDefault": "Purchase default",
      "salesDefault": "Sales default",
      "barcode": "Barcode",
      "taxGroup": "Tax group",
      "tracking": "Tracking",
      "trackBatch": "Batch tracked",
      "trackSerial": "Serial tracked",
      "reorderMin": "Reorder minimum",
      "reorderPoint": "Reorder point",
      "reorderMax": "Reorder maximum",
      "costingMethod": "Costing method",
      "inventoryAccount": "Inventory account",
      "cogsAccount": "COGS account",
      "adjustmentAccount": "Adjustment gain/loss account",
      "accountPlaceholder": "Choose an account",
      "company": "Legal Entity",
      "companyPlaceholder": "Choose a legal entity",
      "warehouse": "Warehouse",
      "warehousePlaceholder": "Choose a warehouse",
      "fromWarehouse": "From warehouse",
      "toWarehouse": "To warehouse",
      "bin": "Bin",
      "fromBin": "From bin",
      "toBin": "To bin",
      "code": "Code",
      "negativeStockPolicy": "Negative stock",
      "onHand": "On hand",
      "reserved": "Reserved",
      "reservedSoft": "Reserved (soft)",
      "reservedHard": "Reserved (hard)",
      "available": "Available",
      "avgUnitCost": "Average unit cost",
      "unitCost": "Unit cost",
      "newUnitCost": "New unit cost",
      "value": "Value",
      "valueChange": "Value change",
      "quantity": "Quantity",
      "qtyDelta": "Quantity change",
      "systemQty": "System",
      "countedQty": "Counted",
      "variance": "Variance",
      "runningQty": "Running quantity",
      "runningValue": "Running value",
      "movementType": "Movement",
      "document": "Document",
      "documentNo": "Number",
      "lines": "Lines",
      "lotNo": "Lot",
      "serialNos": "Serial numbers",
      "journal": "Journal",
      "businessDate": "Date",
      "date": "Date",
      "adjustmentDate": "Adjustment date",
      "transferDate": "Transfer date",
      "countDate": "Count date",
      "createdAt": "Created",
      "memo": "Memo",
      "reason": "Reason",
      "reasonCode": "Reason code",
      "reasonPlaceholder": "Choose a reason",
      "fromInTransitAccount": "In-transit account (source legal entity)",
      "toInTransitAccount": "In-transit account (destination legal entity)",
      "none": "None",
      "from": "From",
      "to": "To",
      "amount": "Amount",
      "asOf": "As of",
      "currency": "Currency",
      "fxRate": "FX rate",
      "note": "Note"
    },
    "itemTypes": {
      "stocked": "Stocked",
      "non_stock": "Non-stock",
      "service": "Service"
    },
    "itemTypeHints": {
      "stocked": "Moves through the stock ledger and carries a balance.",
      "non_stock": "Bought and expensed directly; never reaches the stock ledger.",
      "service": "Labour or a service; never reaches the stock ledger."
    },
    "movementTypes": {
      "receipt": "Receipt",
      "issue": "Issue",
      "transfer_out": "Transfer out",
      "transfer_in": "Transfer in",
      "adjustment_in": "Adjustment in",
      "adjustment_out": "Adjustment out",
      "revaluation": "Revaluation",
      "reversal": "Reversal",
      "landed_cost": "Landed cost",
      "waste": "Waste"
    },
    "docTypes": {
      "adjustment": "Adjustments",
      "cyclecount": "Cycle counts",
      "transfer": "Transfers",
      "revaluation": "Revaluations"
    },
    "negativeStock": {
      "block": "Blocked",
      "blockHint": "Refuse any movement that would take a balance below zero.",
      "blockStatement": "Negative stock is blocked here: no movement in this warehouse can take a balance below zero, and one that would is refused before anything is written.",
      "allow": "Allowed",
      "allowHint": "Accept a movement that takes a balance below zero.",
      "allowStatement": "Negative stock is allowed here: a movement may take a balance below zero."
    },
    "costing": {
      "MA": "Moving average",
      "MAHint": "One running average cost per warehouse, recomputed as value ÷ quantity after every movement. An issue charges the current average and leaves it unchanged.",
      "FIFO": "FIFO",
      "FIFOHint": "Each receipt creates a cost layer at its own price. An issue consumes layers oldest first, so one issue can post several rows at several costs.",
      "panelTitle": "Costing and posting",
      "panelDescription": "Set per legal entity: an item is tenant-wide, but how a legal entity costs it and which accounts it posts against are not.",
      "title": "Costing settings for {sku}",
      "description": "How {company} costs this item and where its movements post.",
      "methodHint": "Decides where every future cost figure for this item comes from.",
      "configure": "Configure",
      "change": "Change",
      "inventoryAccountHint": "Debited on a receipt, credited on an issue. Must be an ASSET account.",
      "cogsAccountHint": "Charged when stock is issued. Must be an EXPENSE account.",
      "adjustmentAccountHint": "Where an adjustment, count variance or revaluation difference lands. INCOME or EXPENSE.",
      "requiredNote": "An item with no costing settings for a legal entity cannot be received into any of its warehouses — the server refuses it and points at this screen. There is no fallback default.",
      "dangerTitle": "This item already has stock movements",
      "dangerBody": "Changing the costing method now reinterprets the cost basis of stock that is already on the books. FIFO has no layers to consume for stock received under moving average, and a FIFO item's existing layers stop being consulted the moment it becomes moving average.",
      "dangerDetail": "Nothing already on the stock ledger will move — it cannot; the ledger is append-only. The result is a valuation whose history was computed one way and whose future is computed another. Change it only as a deliberate accounting-policy decision.",
      "acknowledge": "I understand this reinterprets the cost basis of existing stock.",
      "changeBeforeMovements": "This item has no movements yet, so the costing method can still be changed freely.",
      "hasMovementsNote": "This item has stock movements. The costing method is load-bearing from here on — changing it reinterprets the cost basis of stock already on the books.",
      "noMovementsNote": "This item has no movements yet, so its costing method can still be changed without consequence.",
      "notConfigured": "{company} has not configured this item.",
      "notConfiguredConsequence": "Until it does, this item cannot be received into any of that legal entity's warehouses.",
      "saved": "Costing settings saved",
      "savedDetail": "Applied for {company}.",
      "saveFailed": "Could not save the costing settings",
      "loadFailed": "Could not load the costing settings"
    },
    "items": {
      "title": "Items",
      "description": "Everything the business buys, holds or sells. Costing is configured per legal entity on each item.",
      "create": "New item",
      "createDescription": "SKU, type and base unit are fixed once the item exists.",
      "edit": "Edit item",
      "editDescription": "SKU, type, base unit and the tracking flags cannot be changed.",
      "immutableNote": "SKU, type, base unit and the batch/serial flags are fixed: every quantity on the stock ledger is expressed in the base unit, and changing it would reinterpret history.",
      "skuHint": "The item's identity. It cannot be changed later.",
      "typeHint": "Only a stocked item ever reaches the stock ledger.",
      "baseUomHint": "The unit every ledger quantity is expressed in. Fixed once the item exists.",
      "taxHint": "The default tax code applied to this item's document lines.",
      "trackingHint": "Batch tracking carries a lot number on every movement; serial tracking registers each unit individually at receipt. Both are fixed at creation.",
      "reorderMinHint": "Below this, stock is uncomfortably low.",
      "reorderPointHint": "The nightly scan suggests a reorder when available stock falls to or below this.",
      "reorderMaxHint": "What a reorder should top the balance back up to.",
      "reorderOrderWarning": "The maximum is below the minimum. That is accepted, but it is usually a typo.",
      "costingNextStep": "Next: set this item's costing method and posting accounts for each legal entity that will hold it. Until then it cannot be received.",
      "searchHint": "SKU, name or barcode",
      "tableLabel": "Items",
      "emptyTitle": "No items yet",
      "emptyDescription": "Create one to start receiving, issuing and counting stock.",
      "truncated": "Only the first {count} items were loaded. Narrow by type or search to see the rest.",
      "loadFailed": "Could not load the items",
      "created": "Item created",
      "createdDetail": "{sku} is ready to configure.",
      "createFailed": "Could not create the item",
      "saved": "Item saved",
      "savedDetail": "{sku} updated.",
      "saveFailed": "Could not save the item",
      "exported": "Exported {count} items",
      "factsTitle": "Item",
      "notStockedNote": "This is a {type} item, so it never reaches the stock ledger: a receipt or an issue naming it is refused.",
      "stockTitle": "Stock by warehouse",
      "stockDescription": "On hand, what is already promised, and what is left to promise.",
      "stockCaption": "On-hand balances for this item by warehouse",
      "noStock": "This item has no stock anywhere.",
      "viewMovements": "Movements",
      "backToList": "Back to items"
    },
    "serials": {
      "title": "Serial register",
      "description": "Every serialized unit taken into stock, and where each one is now.",
      "tableTitle": "Serialized units",
      "caption": "Serialized units matching the current filters",
      "searchLabel": "Serial number",
      "searchPlaceholder": "Scan or type part of a serial number",
      "loadFailed": "Could not load the serial register",
      "empty": "No serialized units yet. A unit appears here when a serial-tracked item is received.",
      "emptyFiltered": "No serialized unit matches these filters.",
      "openLedger": "Movements",
      "lotsLink": "Lot register",
      "historyNote": "Movements open the stock ledger for that unit's item and warehouse. The ledger records the serial numbers on each movement but cannot yet be filtered to one serial, so this is the complete list for the pair rather than for the single unit.",
      "columns": {
        "serialNo": "Serial number",
        "lot": "Lot"
      },
      "statuses": {
        "in_stock": "In stock",
        "issued": "Issued"
      }
    },
    "uoms": {
      "panelTitle": "Units of measure",
      "panelDescription": "Alternate units, each expressed as a conversion onto {base}.",
      "caption": "Units of measure for this item",
      "base": "Base",
      "add": "Add a unit",
      "edit": "Edit unit",
      "description": "How many {base} one of this unit is.",
      "codeHint": "A short code, e.g. CARTON.",
      "factorHint": "How many {base} in one of this unit.",
      "factorMustBePositive": "A conversion factor must be greater than zero.",
      "directionNote": "The factor is how many {base} one of this unit contains — a carton of twelve is 12, not 1/12. Getting it backwards produces orders that look plausible and are out by the factor.",
      "saved": "Unit saved",
      "savedDetail": "{code} updated.",
      "saveFailed": "Could not save the unit"
    },
    "warehouses": {
      "title": "Warehouses",
      "description": "Where stock is held, and the negative-stock rule each one enforces.",
      "create": "New warehouse",
      "edit": "Edit warehouse",
      "dialogDescription": "The legal entity is fixed at creation: movements post through that legal entity's accounts.",
      "companyHint": "Fixed once the warehouse exists.",
      "policyHint": "Checked before anything is written, so a blocked movement never touches the ledger.",
      "allowConsequence": "With negative stock allowed, a FIFO item that runs out of layers has its shortfall charged at the item's current derived average cost rather than refused — an honest best effort for an inherently approximate situation.",
      "allowingNegative": "{count} of these warehouses allow negative stock.",
      "tableTitle": "Warehouses",
      "tableCaption": "Warehouses and their negative-stock policy",
      "binsNote": "Bins live inside a warehouse; open one to manage them.",
      "viewStock": "Stock",
      "empty": "No warehouses yet.",
      "emptyFiltered": "No warehouse matches these filters.",
      "loadFailed": "Could not load the warehouses",
      "saved": "Warehouse saved",
      "savedDetail": "{code} updated.",
      "saveFailed": "Could not save the warehouse",
      "stockTitle": "Stock held here",
      "stockDescription": "On hand, reserved and available, per item.",
      "stockCaption": "On-hand balances in this warehouse",
      "noStock": "Nothing is standing in this warehouse."
    },
    "bins": {
      "blockHint": "A blocked bin accepts no putaway and offers no pick. It keeps the stock it holds.",
      "blockLabel": "Block this bin",
      "blockReasonRequired": "Say why the bin is blocked before saving.",
      "blockedReason": "Reason for blocking",
      "capacityHint": "A bin fills on whichever limit it reaches first. Leave a limit blank to declare none.",
      "kindHint": "What the bin is for. A picking face is replenished from bulk, not received into.",
      "maxQty": "Max quantity",
      "maxVolumeM3": "Max volume (m³)",
      "maxWeightKg": "Max weight (kg)",
      "panelTitle": "Bins",
      "panelDescription": "Locations inside this warehouse. A bin is a place, not a balance.",
      "caption": "Bins in this warehouse",
      "add": "Add a bin",
      "edit": "Edit bin",
      "dialogDescription": "A bin records where something was put or taken from; balances are held per warehouse.",
      "codeHint": "A short code, e.g. A-01-3.",
      "empty": "No bins yet. Stock can still be held without them.",
      "pickSequenceHint": "The order a picker reaches this bin, lowest first.",
      "saved": "Bin saved",
      "savedDetail": "{code} updated.",
      "saveFailed": "Could not save the bin",
      "blocked": "Blocked",
      "capacity": "Capacity",
      "description": "Utilisation is the fill against the declared capacity. A bin with no capacity has no utilisation — not zero.",
      "kind": "Kind",
      "kinds": {
        "bulk": "Bulk",
        "picking": "Picking face",
        "quarantine": "Quarantine",
        "staging": "Staging",
        "storage": "Storage"
      },
      "loadFailed": "Could not load the bins",
      "noCapacity": "No capacity declared",
      "onHand": "On hand",
      "open": "Open",
      "storageClassHint": "Putaway refuses an item whose required class this bin does not offer.",
      "title": "Bins",
      "utilisation": "Utilisation",
      "zoneHint": "Which zone this bin sits in. Unzoned bins take the warehouse default."
    },
    "stockLevels": {
      "title": "Stock levels",
      "description": "On hand is what is in the building. Available is what may still be promised.",
      "itemHint": "Choose one item to see a comparable quantity total.",
      "tableTitle": "Balances",
      "tableDescription": "One row per item and warehouse, maintained in the same transaction as the ledger rows that justify it.",
      "tableCaption": "On-hand, reserved and available stock by item and warehouse",
      "total": "Total",
      "mixedUnits": "Mixed units",
      "holds": "Holds",
      "movements": "Movements",
      "atCap": "Five hundred rows came back, which is this endpoint's cap. There may be more; narrow by item or warehouse to be sure you are seeing everything.",
      "overCommitted": "{count} balances are over-committed: more is reserved than is on hand.",
      "projectionNote": "On-hand is a maintained projection of the stock ledger, written in the same transaction as the movements behind it.",
      "empty": "No stock anywhere yet.",
      "emptyFiltered": "Nothing on hand for these filters.",
      "loadFailed": "Could not load the stock levels",
      "itemById": "Item #{id}",
      "warehouseById": "Warehouse #{id}"
    },
    "reservations": {
      "title": "Reserved stock",
      "description": "A reservation is a promise, not a movement: nothing is written to the stock ledger.",
      "caption": "Active reservations for {sku}",
      "noneActive": "Nothing is holding this stock.",
      "truncated": "Two thousand reservations came back, and there are more. Narrow by item or warehouse to see the rest.",
      "release": "Release",
      "released": "Reservation released",
      "releaseFailed": "Could not release the reservation",
      "loadFailed": "Could not load the reservations",
      "lineNo": "line {no}",
      "historyToggle": "Show {count} released or consumed holds",
      "historyCaption": "Reservations that are no longer active",
      "columns": {
        "document": "Document",
        "kind": "Kind"
      },
      "anyLot": "Any lot",
      "document": "Document",
      "empty": "No reservations match.",
      "expiresAt": "Expires",
      "expiringBefore": "Expiring before",
      "expiringBeforeHint": "The sweep releases these hourly.",
      "kind": "Kind",
      "kinds": {
        "hard": "Hard",
        "soft": "Soft"
      },
      "link": "Reservations",
      "moreUrgent": "More urgent",
      "priority": "Priority",
      "releasedByOperator": "Released by the operator",
      "tableTitle": "Reservations",
      "updateFailed": "Could not update the reservation"
    },
    "reservationKinds": {
      "soft": "Soft",
      "hard": "Hard"
    },
    "reservationStatus": {
      "active": "Active",
      "released": "Released",
      "consumed": "Consumed"
    },
    "ledger": {
      "title": "Stock ledger",
      "description": "Every movement that has ever happened, newest first.",
      "appendOnly": "The stock ledger is append-only. A database trigger refuses an update or a delete of any row, to this product's own code as much as to anyone else's — a correction is a new, opposite row, never a changed one.",
      "runningBalanceNeedsBoth": "The running balance is kept per item and warehouse. Choose one of each to see it; a mixed list would interleave several unrelated balances.",
      "tableTitle": "Movements",
      "tableCaption": "Stock ledger entries",
      "pageTotal": "This page",
      "viewJournal": "View journal",
      "noJournal": "No journal — a same-company transfer debits and credits one account and posts nothing.",
      "empty": "No movements yet.",
      "emptyFiltered": "No movement matches these filters.",
      "loadFailed": "Could not load the stock ledger"
    },
    "adjustments": {
      "title": "Stock adjustments",
      "description": "Write-offs, write-ons and corrections, each under a reason code.",
      "create": "New adjustment",
      "createDescription": "An increase needs a unit cost; a decrease is costed from the stock it removes.",
      "reasonHint": "The reason decides whether this posts immediately or waits for approval.",
      "dateHint": "The business date the movement posts on; it must fall in an open period.",
      "addLine": "Add a line",
      "removeLine": "Remove line {line}",
      "duplicateLine": "Duplicate line {line}",
      "qtyAria": "Quantity change, line {line}",
      "costAria": "Unit cost, line {line}",
      "lotAria": "Lot number, line {line}",
      "increase": "Increase",
      "decrease": "Decrease",
      "costFromLayers": "Costed from stock",
      "noTotalNote": "No extended amount is shown, on purpose. What a decrease is worth is the sum of the FIFO layers it consumes, in the order it consumes them, or the item's current average — a figure only the server can produce. The posted amounts appear on the ledger rows this adjustment writes.",
      "warehouseAllowsNegative": "This warehouse allows negative stock, so a decrease larger than the balance will be accepted rather than refused.",
      "willPost": "This reason code posts immediately: submitting writes the movement, its journal and its ledger rows.",
      "willAwaitApproval": "This reason code needs approval: submitting writes nothing to the ledger until somebody with the approve permission posts it.",
      "postAction": "Post",
      "submitted": "Adjustment submitted for approval",
      "posted": "Adjustment posted",
      "createdDetail": "{no}",
      "createFailed": "Could not raise the adjustment",
      "tableTitle": "Adjustments",
      "caption": "Stock adjustments",
      "linesCaption": "Adjustment lines",
      "pendingCount": "{count} adjustments are waiting for approval.",
      "pendingMeaning": "Nothing about them has reached the ledger: the books still hold the stock they propose to write off.",
      "empty": "No adjustments yet.",
      "emptyFiltered": "No adjustment matches these filters.",
      "loadFailed": "Could not load the adjustments",
      "factsTitle": "Adjustment",
      "linesTitle": "Lines",
      "linesDescription": "What was proposed. A decrease carries no unit cost because the server derives it.",
      "noLines": "This adjustment has no lines.",
      "nothingPostedYet": "Nothing has been posted. This adjustment has written no movement, no journal and no ledger row.",
      "rejectedNote": "This adjustment was rejected. Nothing was ever posted, so there is nothing to reverse.",
      "movementsTitle": "What posted",
      "movementsDescription": "The stock ledger rows this adjustment wrote, at the costs the server resolved.",
      "movementsCaption": "Ledger rows produced by this adjustment",
      "movementTotal": "Total",
      "noMovements": "No ledger rows found for this adjustment.",
      "approveAction": "Approve and post",
      "approveMeaning": "Approving posts the movement, its journal and its ledger rows.",
      "approved": "Adjustment approved and posted",
      "approveFailed": "Could not approve the adjustment",
      "approvedAt": "Approved",
      "rejectTitle": "Reject this adjustment",
      "rejectDescription": "Nothing was posted, so nothing is reversed. Say why, for the record.",
      "rejected": "Adjustment rejected",
      "rejectFailed": "Could not reject the adjustment",
      "sodNote": "Raising an adjustment and approving one are deliberately separate permissions: the person who proposes a write-off must not be the one who puts it in the ledger."
    },
    "adjustmentStatus": {
      "pending_approval": "Awaiting approval",
      "posted": "Posted",
      "rejected": "Rejected"
    },
    "reasonCodes": {
      "title": "Adjustment reason codes",
      "description": "Why stock was adjusted, and which reasons need a second signature.",
      "create": "New reason code",
      "edit": "Edit reason code",
      "dialogDescription": "Reason codes are your own data; nothing here is a fixed list.",
      "codeHint": "A short code, e.g. DAMAGE.",
      "requiresApproval": "Needs approval before posting",
      "requiresApprovalHint": "Adjustments under this reason write nothing to the ledger until somebody with the approve permission posts them.",
      "noApprovalConsequence": "Adjustments under this reason will post to the general ledger the moment they are raised, with no second signature.",
      "approvalColumn": "Approval",
      "approvalRequired": "Needs approval",
      "postsImmediately": "Posts immediately",
      "unapprovedCount": "{count} active reason codes post immediately, with no second signature.",
      "tableTitle": "Reason codes",
      "caption": "Adjustment reason codes",
      "empty": "No reason codes yet. An adjustment needs one.",
      "footnote": "Used by",
      "loadFailed": "Could not load the reason codes",
      "saved": "Reason code saved",
      "savedDetail": "{code} updated.",
      "saveFailed": "Could not save the reason code"
    },
    "cycleCounts": {
      "title": "Cycle counts",
      "description": "Count the shelf, compare it with the books, post the difference.",
      "create": "New count",
      "createDescription": "Every selected item's balance is snapshotted now, and variances are measured against that.",
      "dateHint": "The business date the variance posts on.",
      "blind": "Blind count",
      "blindHint": "Hide the expected quantity from the counter until the session is posted.",
      "blindBadge": "Blind",
      "openBookBadge": "Open book",
      "notBlindConsequence": "Without blind mode the counter can see what the system expects, and a count anchored to that figure is worth much less as evidence.",
      "itemsLabel": "Items to count",
      "itemsHint": "Leave empty to count every stocked item with a balance in this warehouse.",
      "addItem": "Add an item",
      "removeItem": "Remove {item}",
      "fullCountNote": "No items chosen, so this will be a full count of every stocked item with a balance in the warehouse.",
      "snapshotNote": "The expected quantity of each item is recorded at the moment the session opens, so variances measure against the balance as it stood then.",
      "open": "Open the count",
      "created": "Count session opened",
      "createdDetail": "{no}",
      "createFailed": "Could not open the count session",
      "tableTitle": "Sessions",
      "caption": "Cycle count sessions",
      "mode": "Mode",
      "progress": "Counted",
      "progressTitle": "Progress",
      "progressValue": "{counted} of {total} counted",
      "empty": "No cycle counts yet.",
      "emptyFiltered": "No session matches these filters.",
      "loadFailed": "Could not load the cycle counts",
      "blindNotice": "This is a blind count: the expected quantity is not shown until the session is posted.",
      "blindNoticeVariance": "Variance is withheld too — a count minus its variance is the expected quantity, which would defeat the point.",
      "linesTitle": "Count sheet",
      "linesDescription": "Expected, counted and the difference between them.",
      "linesBlindDescription": "Enter what you counted. Nothing on this page reveals what the system expects.",
      "linesCaption": "Cycle count lines",
      "noLines": "This session has no lines.",
      "countAria": "Counted quantity for {item}, line {line}",
      "varianceTotal": "Net variance",
      "found": "Found",
      "short": "Short",
      "linesDiffering": "Lines differing",
      "valueNote": "What a variance is worth is decided by the costing method — FIFO layers consumed oldest first, or the item's current average — and appears on the ledger rows posting produces.",
      "incompleteNote": "{count} lines are still uncounted. A session cannot be posted until every one of them has a count.",
      "saveCounts": "Save {count} counts",
      "countsSaved": "Saved {count} counts",
      "countsFailed": "Could not save the counts",
      "readyToPost": "Every line is counted; posting will write the variances to the ledger.",
      "notReady": "Count every line before posting.",
      "postAction": "Post variances",
      "posted": "Cycle count posted",
      "postFailed": "Could not post the cycle count",
      "postedTitle": "Posted",
      "postedNote": "The variances are on the ledger. One journal was posted for the whole session; lines with no variance were skipped.",
      "noJournal": "No journal was posted — every counted line matched the system quantity."
    },
    "countStatus": {
      "open": "Open",
      "posted": "Posted",
      "cancelled": "Cancelled",
      "counting": "Counting",
      "recount": "Recount owed",
      "review": "In review"
    },
    "transfers": {
      "title": "Stock transfers",
      "description": "Move stock between warehouses. Cross-company transfers post both legs at once.",
      "create": "New transfer",
      "createDescription": "Stock moves at cost; there is no unit price to enter.",
      "addLine": "Add a line",
      "removeLine": "Remove line {line}",
      "qtyAria": "Quantity, line {line}",
      "lotAria": "Lot number, line {line}",
      "submitAction": "Transfer",
      "sameWarehouse": "The source and destination are the same warehouse.",
      "sameCompanyNote": "Both warehouses belong to the same legal entity, so this transfer posts no journal: one inventory account would be debited and credited, netting to nothing.",
      "crossCompanyNote": "These warehouses belong to different legal entities, so both legs post: ship (Dr in-transit / Cr source inventory) and receive (Dr destination inventory / Cr in-transit).",
      "crossCompanyPosting": "Two in-transit accounts are needed, one per legal entity — the two keep separate books and neither's account is the other's.",
      "inTransitHint": "An asset account of that legal entity.",
      "costNote": "A transfer moves stock at cost: FIFO layers consumed oldest first on the source side, or the item's current moving average. There is no price to enter.",
      "noInTransitLifecycle": "There is no separate confirm-receipt step: the stock moves the instant this succeeds.",
      "created": "Transfer posted",
      "createdDetail": "{no}",
      "createFailed": "Could not post the transfer",
      "tableTitle": "Transfers",
      "caption": "Stock transfers",
      "postingColumn": "Posting",
      "sameCompanyBadge": "Same legal entity",
      "crossCompanyBadge": "Cross-company",
      "empty": "No transfers yet.",
      "emptyFiltered": "No transfer matches these filters.",
      "loadFailed": "Could not load the transfers",
      "factsTitle": "Transfer",
      "shipJournal": "Ship journal",
      "receiveJournal": "Receive journal",
      "noJournalNote": "This is a same-company transfer, so no journal was posted: both warehouses share one inventory account and the entry would net to nothing.",
      "linesTitle": "Lines",
      "linesDescription": "The unit cost is what the server resolved when the stock moved, not a price anybody typed.",
      "linesCaption": "Transfer lines",
      "noLines": "This transfer has no lines.",
      "movementsTitle": "Ledger rows",
      "movementsDescription": "Two rows per line: one out of the source, one into the destination.",
      "movementsCaption": "Ledger rows produced by this transfer",
      "movementTotal": "Total",
      "movementBalanceNote": "The quantity and value totals net to zero on a completed transfer: nothing was created or destroyed, only moved.",
      "noMovements": "No ledger rows found for this transfer.",
      "autoReceive": "Receive at the same time",
      "autoReceiveHint": "Both legs and both journals are still written. This only saves the second request.",
      "autoReceived": "Transfer despatched and received",
      "backToBoard": "Back to transfers",
      "boardDescription": "In transit is stock that has left one warehouse and not arrived at the other. It is in neither, and it has its own lane.",
      "cancelDefaultReason": "Cancelled by the operator",
      "cancelFailed": "Could not cancel the transfer",
      "cancelled": "Transfer cancelled",
      "carrier": "Carrier",
      "carrierReference": "Carrier reference",
      "columns": {
        "carrier": "Carrier",
        "count": "Transfers",
        "despatchQty": "Despatch qty",
        "despatched": "Despatched",
        "despatchedQty": "Despatched",
        "expected": "Expected",
        "inTransitValue": "In-transit value",
        "oldest": "Oldest (d)",
        "overdue": "Overdue",
        "receiveQty": "Received",
        "received": "Received",
        "receivedQty": "Received",
        "shortageQty": "Short",
        "shortageReason": "Shortage reason",
        "stillInTransit": "Still in transit",
        "total": "Total",
        "value": "Value"
      },
      "despatch": "Despatch",
      "despatchAction": "Despatch",
      "despatchConsequence": "After this, the stock is in neither warehouse and its value is on the goods-in-transit account.",
      "despatchDescription": "Two ledger legs and a journal are written now: out of the source and into the in-transit warehouse.",
      "despatchFailed": "Could not despatch the transfer",
      "despatchJournal": "Despatch journal",
      "despatchLinesCaption": "Lines being despatched",
      "despatchQtyAria": "Despatch quantity, {item}",
      "despatched": "Transfer despatched",
      "despatchedOn": "Despatched on",
      "documentDescription": "Two postings, four ledger legs.",
      "draftDescription": "This creates a draft. Nothing moves until it is despatched.",
      "draftFailed": "Could not create the transfer",
      "draftMovesNothing": "Saving this moves no stock. Despatch is the act that does, and it needs its own permission.",
      "drafted": "Draft transfer created",
      "driver": "Driver",
      "empty_all": "No transfers yet.",
      "empty_cancelled": "No cancelled transfers.",
      "empty_draft": "No draft transfers.",
      "empty_in_transit": "Nothing is in transit.",
      "empty_received": "No received transfers.",
      "expectedArrival": "Expected arrival",
      "expectedArrivalHint": "Used by the overdue sweep.",
      "inTransitAccountMissing": "This legal entity has no goods-in-transit account. Set one on the inventory settings screen; nothing can be despatched until it is set.",
      "inTransitAccountNote": "This value sits on the goods-in-transit account, not on inventory. The reconciliation run reads both.",
      "inTransitCaption": "In-transit summary by legal entity",
      "inTransitDescription": "Value and age of stock owned by the legal entity and held in neither endpoint warehouse.",
      "inTransitEmpty": "Nothing is in transit.",
      "inTransitExplanation": "This stock has left the source and not arrived at the destination. Do not count it at either end.",
      "inTransitTitle": "In transit",
      "laneNote": "Everything in this lane is stock nobody can count at either warehouse.",
      "legsTitle": "Postings",
      "loadOneFailed": "Could not load the transfer",
      "lotAuto": "Chosen by strategy",
      "lotRefused": "That lot cannot be issued. Quarantined, blocked, recalled and expired lots are all refused.",
      "notDespatched": "This transfer has not been despatched.",
      "notFound": "That transfer does not exist.",
      "notPostedYet": "Not posted yet",
      "overReceipt": "More was received than was despatched.",
      "overdueBanner": "{count} transfer(s) are overdue. Stock nobody can find is stock nobody is looking for.",
      "overdueNote": "This transfer passed its expected arrival date and was flagged by the overdue sweep.",
      "receive": "Receive",
      "receiveAction": "Receive",
      "receiveDescription": "Received and short are two different boxes. What is in neither is still on the truck.",
      "receiveFailed": "Could not receive the transfer",
      "receiveLinesCaption": "Lines being received",
      "receiveQtyAria": "Received quantity, {item}",
      "received": "Transfer received",
      "receivedOn": "Received on",
      "saveDraft": "Save draft",
      "shortageMeaning": "A shortage is quantity that left and will never arrive. It posts. A partial receipt is different: the remainder stays in transit.",
      "shortageNeedsReason": "A shortage needs a reason code.",
      "shortageQtyAria": "Shortage quantity, {item}",
      "shortageReasonPlaceholder": "Choose a reason",
      "showOverdue": "Show them",
      "vehicle": "Vehicle"
    },
    "revaluations": {
      "title": "Revalue stock",
      "description": "Reset the unit cost of what is on hand. The quantity does not move; the value does.",
      "listTitle": "Revaluations",
      "listDescription": "Read from the stock ledger, where every revaluation is a row.",
      "action": "Revalue",
      "costHint": "The cost each unit on hand will carry from now on.",
      "reasonHint": "Recorded on the ledger row and in the audit trail.",
      "postsNote": "The difference between the old and the new value posts against the item's adjustment gain/loss account, dated the business date above.",
      "noPreviewNote": "The resulting value is not previewed here: the server computes it, and a figure worked out in the browser that differed by a cent would be indistinguishable from a posting error.",
      "noBalance": "There is nothing on hand for this item in this warehouse, so there is nothing to revalue.",
      "done": "Stock revalued",
      "doneDetail": "The difference has been posted.",
      "failed": "Could not revalue the stock",
      "tableTitle": "Revaluations",
      "caption": "Revaluation entries from the stock ledger",
      "pageTotal": "This page",
      "filterNote": "This list is the revaluation rows of a page of the stock ledger, so a page can hold fewer rows than the page size while more still exist further down.",
      "empty": "No revaluations in this range.",
      "loadFailed": "Could not load the revaluations"
    },
    "reorder": {
      "title": "Reorder suggestions",
      "description": "What the nightly scan proposed, and the figures it proposed it from.",
      "rule": "The scan runs at 04:00 on your clock. For every item with a reorder point it computes available = on hand − reserved, raises a suggestion when available is at or below the reorder point, and proposes topping the balance back up to the maximum (or to the reorder point when there is no maximum).",
      "noInboundNote": "The scan does not look at purchase orders, so a suggestion may propose reordering something an open order already covers. Check before ordering.",
      "target": "Top up to",
      "suggested": "Suggested",
      "generatedAt": "Scanned",
      "statusOpen": "Open",
      "statusDismissed": "Dismissed",
      "status_open": "Open",
      "status_dismissed": "Dismissed",
      "dismissed": "Suggestion dismissed",
      "dismissFailed": "Could not dismiss the suggestion",
      "tableTitle": "Suggestions",
      "caption": "Reorder suggestions and the figures behind them",
      "emptyOpen": "Nothing needs reordering.",
      "emptyDismissed": "No dismissed suggestions.",
      "loadFailed": "Could not load the reorder suggestions"
    },
    "valuation": {
      "title": "Inventory valuation",
      "description": "What the stock sub-ledger holds, beside what the general ledger says it holds.",
      "needsCompany": "Choose a legal entity to run the valuation.",
      "tableTitle": "Inventory control accounts",
      "tableDescription": "One row per inventory account: the sum of on-hand value posting to it, and that account's own posted balance.",
      "tableCaption": "Inventory valuation reconciled against the general ledger",
      "total": "Total",
      "reconciled": "Reconciles",
      "notReconciled": "Does not reconcile",
      "reconcilesBody": "The stock sub-ledger agrees with every inventory control account, to the cent.",
      "alarmTitle": "Inventory does not reconcile with the general ledger",
      "alarmBody": "The stock sub-ledger and the inventory control accounts differ by",
      "alarmAccount": "sub-ledger {subLedger}, general ledger {control}, difference {difference}",
      "alarmNextStep": "Open each account's ledger to find the postings behind its balance, and the stock levels behind the sub-ledger figure. Until they agree, neither the stock valuation nor the balance sheet can be relied on.",
      "totalBroken": "The printed total is not the sum of the rows above it, so this report is not internally consistent either.",
      "howItIsBuilt": "The sub-ledger figure sums on-hand value for every item posting to that account. The control figure sums the account's own posted journal lines. §16 requires them to be equal — this report is where that is checked rather than assumed.",
      "openStockLevels": "Stock levels",
      "generated": "Generated {at}",
      "empty": "No inventory accounts are configured for this legal entity yet.",
      "loadFailed": "Could not run the valuation report",
      "columns": {
        "account": "Account",
        "subLedger": "Stock sub-ledger",
        "control": "General ledger",
        "difference": "Difference"
      }
    },
    "errors": {
      "periodClosed": "The period this would post into is closed. Reopen it, or use a date in an open period.",
      "itemNotConfigured": "One of these items has no costing settings for this legal entity, so it cannot move through inventory. Set them on the item first.",
      "negativeStock": "This movement would take a balance below zero, and this warehouse blocks that. Count the stock, or change the warehouse's negative-stock policy."
    },
    "chargeKind": {
      "disbursement": "Disbursement",
      "fee": "Fee"
    },
    "chargeState": {
      "billed": "Billed",
      "cancelled": "Cancelled",
      "estimated": "Estimated"
    },
    "classification": {
      "action": "Action it",
      "actionFailed": "Could not action the disposition",
      "actioned": "Disposition actioned",
      "caption": "Inventory classification",
      "classes": {
        "expired": "Expired",
        "expiring": "Expiring",
        "fast": "Fast",
        "obsolete": "Obsolete",
        "slow": "Slow"
      },
      "classification": "Class",
      "coverage": "Coverage (d)",
      "daysSinceIssue": "Days idle",
      "decideFailed": "Could not record the decision",
      "description": "What is not moving, what is about to expire, and what is being done about it.",
      "disposition": "Disposition",
      "dispositionHints": {
        "donate": "Give it away and write it off.",
        "markdown": "Records the decision. The price change belongs to the pricing module.",
        "none": "No decision yet.",
        "return_to_vendor": "Send it back to the supplier.",
        "transfer": "Move it to a warehouse that can sell it.",
        "write_off": "Raises a stock adjustment."
      },
      "dispositionStatus": "Decision status",
      "dispositions": {
        "donate": "Donate",
        "markdown": "Mark down",
        "none": "None",
        "return_to_vendor": "Return to vendor",
        "transfer": "Transfer",
        "write_off": "Write off"
      },
      "empty": "Nothing classified. Run it to see what is not moving.",
      "link": "Classification",
      "loadFailed": "Could not load the classification",
      "markdownNote": "A mark-down posts nothing here: the price change belongs to the pricing module. This records the decision and the link.",
      "ran": "Classification run complete",
      "ranDetail": "{lines} line(s), {value} at risk",
      "run": "Run now",
      "runFailed": "Could not run the classification",
      "statuses": {
        "actioned": "Actioned",
        "open": "Open",
        "waived": "Waived"
      },
      "tableTitle": "Classification",
      "title": "Slow and obsolete stock"
    },
    "countMethod": {
      "abc": "ABC",
      "expiring": "Expiring stock",
      "full": "Full count",
      "item": "Named items",
      "spot": "Spot check",
      "zone": "Zone"
    },
    "counting": {
      "accepted": "Posted from",
      "acceptedSource": {
        "count": "First count",
        "recount": "Recount"
      },
      "attachment": "Evidence attachment",
      "attachmentHint": "Required by some reason codes.",
      "backToSheet": "Back to the count sheet",
      "blindHidden": "Blind",
      "cancelDefaultReason": "Cancelled by the operator",
      "cancelFailed": "Could not cancel the session",
      "cancelled": "Session cancelled",
      "counted": "Counted",
      "countedBy": "Counted by",
      "differentCounter": "Recount by a different counter",
      "differentCounterHint": "Refused by the service and by the database.",
      "differentCounterNote": "A recount by the person who counted first is refused — by the service and by a database constraint.",
      "evidenceRequired": "This reason needs an evidence attachment.",
      "explain": "Explain",
      "explainDescription": "A shrinkage report grouped by 'damage' tells nobody where to look.",
      "explainFailed": "Could not save the explanation",
      "explainTitle": "Explain the variance",
      "factsTitle": "Session",
      "freezeActive": "{count} scope(s) are frozen by this session.",
      "freezeConsequence": "Nobody will be able to pick, put away, transfer or adjust inside this scope until the session posts or is cancelled.",
      "freezeReleased": "The freeze has been released.",
      "freezeScope": "Freeze the scope",
      "freezeScopeHint": "Refuses every movement that touches it until the session posts or is cancelled.",
      "loadFailed": "Could not load the session",
      "method": "Method",
      "methodHint": {
        "abc": "A value-banded selection made elsewhere.",
        "expiring": "Stock approaching its expiry.",
        "full": "Every stocked item with a balance.",
        "item": "Only the items named.",
        "spot": "A quick unscheduled check.",
        "zone": "One zone of the warehouse."
      },
      "methodLabelHint": "Records which selection produced the line list.",
      "noLines": "This session has no lines.",
      "openReview": "Recounts and variance",
      "post": "Post",
      "postFailed": "Could not post the session",
      "posted": "Session posted",
      "postedDetail": "The variance journal is on the ledger and the freeze is released.",
      "queueCaption": "Lines awaiting a recount",
      "queueDescription": "Lines whose variance crossed a threshold and that nobody has recounted.",
      "queueEmpty": "No recounts are owed.",
      "queueTitle": "Recount queue",
      "reason": "Reason",
      "recordRecounts": "Record the recounts",
      "recountAria": "Recount quantity, {item}",
      "recountFailed": "Could not record the recounts",
      "recountQty": "Recount",
      "recountedCount": "{count} line(s) have been recounted.",
      "recountsOutstanding": "Some lines still owe a recount.",
      "recountsRecorded": "Recounts recorded",
      "reportCounts": "{counted} counted · {recounted} recounted",
      "reportTotals": "Totals",
      "review": "Move to review",
      "reviewDescription": "The recount queue and the variance review. A line over threshold cannot post until a different counter has recounted it.",
      "reviewFailed": "Could not move the session to review",
      "reviewTitle": "Review — {no}",
      "reviewed": "Session moved to review",
      "rootCause": "Root cause",
      "rootCauseHint": "Receiving error, picking error, theft, evaporation, and so on.",
      "sameCounter": "The same person cannot recount their own line.",
      "system": "System",
      "thresholdPct": "Recount threshold %",
      "thresholdPctHint": "Blank uses the legal entity setting.",
      "thresholdValue": "Recount threshold value",
      "thresholdValueHint": "Either threshold crossing demands a recount.",
      "varianceCaption": "Count variance",
      "varianceDescription": "The reason says what; the root cause says why. They are separate columns because they are separate questions.",
      "varianceExplained": "Variance explained",
      "varianceTitle": "Variance review",
      "varianceValue": "Variance value",
      "zoneHint": "Narrows the count to one zone."
    },
    "depletions": {
      "businessDate": "Business date",
      "caption": "Depletion runs",
      "component": "Component",
      "componentsCaption": "Depletion components",
      "componentsDescription": "The live cost of what actually left stock, and the lot it came from.",
      "componentsTitle": "Components consumed",
      "description": "The stock relief behind a settled sale: which components left, at what live cost, from which lot.",
      "empty": "No depletion runs yet.",
      "firstSeen": "First seen",
      "issuedQty": "Issued",
      "lastSeen": "Last seen",
      "linesCaption": "Sale lines",
      "link": "Depletion",
      "loadFailed": "Could not load the depletion runs",
      "noComponents": "No components on this run.",
      "occurrences": "Occurrences",
      "reason": "Reason",
      "resolution": "Resolution",
      "resolutions": {
        "resolved": "Resolved",
        "skipped": "Skipped",
        "unresolved": "Unresolved"
      },
      "reverse": "Reverse",
      "reverseDefaultReason": "Reversed by the operator",
      "reverseFailed": "Could not reverse the depletion",
      "reversed": "Depletion reversed",
      "saleLine": "Line",
      "shortfall": "Shortfall",
      "skippedLines": "Skipped",
      "soldItem": "Sold item",
      "soldQty": "Sold qty",
      "sourceDoc": "Source",
      "status": {
        "posted": "Posted",
        "reversed": "Reversed"
      },
      "tableTitle": "Runs",
      "theoreticalQty": "Theoretical",
      "title": "Depletion runs",
      "unresolvedCaption": "Unresolved depletion lines",
      "unresolvedDescription": "Sold items with no resolvable recipe, grouped by item and outlet.",
      "unresolvedEmpty": "Every sold item resolved to a recipe.",
      "unresolvedLines": "Unresolved",
      "unresolvedMeaning": "An unresolved line is stock that left the building without leaving the ledger. It does not fail the sale, and it must not stay invisible.",
      "unresolvedTitle": "Unresolved sold items"
    },
    "expiry": {
      "inDays": "{days} d left",
      "past": "{days} d past",
      "today": "Expires today",
      "undated": "No expiry"
    },
    "fixedBins": {
      "assign": "Assign a bin",
      "caption": "Fixed bin assignments",
      "deleteFailed": "Could not remove the fixed bin",
      "description": "Where an item lives: the first place putaway tries and the first place picking looks.",
      "dialogDescription": "One primary bin per item and warehouse. Two 'where it lives' is nowhere.",
      "empty": "No fixed bins yet.",
      "minQty": "Min qty",
      "primaryReplaces": "Saving this replaces any primary bin the item already has in this warehouse.",
      "remove": "Remove fixed bin",
      "role": "Role",
      "roleHints": {
        "overflow": "Tried after the primary is full.",
        "primary": "The picking face. One per item and warehouse."
      },
      "roles": {
        "overflow": "Overflow",
        "primary": "Primary"
      },
      "saveFailed": "Could not save the fixed bin",
      "saved": "Fixed bin saved",
      "strategyNote": "The warehouse's putaway strategy decides whether fixed bins are tried first. 'Fixed then any' is the default.",
      "targetQty": "Target qty",
      "title": "Fixed bins"
    },
    "genealogy": {
      "depthCapped": "The trace stopped at {depth} levels. There may be more downstream lots than are shown.",
      "description": "What this lot became. The walk is depth-capped by the server; a cap it reached is reported, never hidden.",
      "empty": "This lot has not been repacked, split or merged.",
      "parents": "Came from",
      "title": "Genealogy"
    },
    "haccp": {
      "checkpoint": "Checkpoint",
      "checkpointFailed": "Could not save the checkpoint",
      "checkpointSaved": "Checkpoint saved",
      "checkpointsCaption": "HACCP checkpoints",
      "checkpointsDescription": "A checkpoint is a schedule: this fridge, twice a shift.",
      "checkpointsEmpty": "No checkpoints yet.",
      "checkpointsLoadFailed": "Could not load the checkpoints",
      "checkpointsTitle": "Checkpoints",
      "correctiveAction": "Corrective action",
      "correctiveActionHint": "What must happen when a reading is out of range. This is the kitchen's own procedure.",
      "correctiveRequiredHint": "Required when the outcome is a failure.",
      "csv": "CSV",
      "csvHint": "checkpointCode,recordedOn,shiftCode,reading,outcome,correctiveActionTaken",
      "description": "Checkpoint schedules and the readings taken against them. Manual and CSV capture only.",
      "failNeedsAction": "A failed reading needs a corrective action. A HACCP log with an unexplained failure is worse evidence than no log.",
      "frequencies": {
        "daily": "Daily",
        "on_receipt": "On receipt",
        "per_shift": "Per shift",
        "twice_daily": "Twice daily",
        "weekly": "Weekly"
      },
      "frequency": "Frequency",
      "import": "Import CSV",
      "importDescription": "One reading per row. Rows that fail are reported with their line numbers.",
      "importFailed": "Could not import the readings",
      "importPartial": "{imported} imported, {failed} refused",
      "imported": "{imported} reading(s) imported",
      "kind": "Kind",
      "kinds": {
        "cleaning": "Cleaning",
        "cooking": "Cooking",
        "cooling": "Cooling",
        "humidity": "Humidity",
        "receiving": "Receiving",
        "temperature": "Temperature",
        "visual": "Visual"
      },
      "maxValue": "Max",
      "minValue": "Min",
      "newCheckpoint": "New checkpoint",
      "newCheckpointDescription": "The range is what decides pass or fail for a numeric reading.",
      "newRecord": "Record a reading",
      "newRecordDescription": "The outcome is computed from the checkpoint's range for a numeric kind.",
      "noAutoQuarantine": "Naming a lot records the link a recall trace follows. It does not quarantine the lot; that is a human decision.",
      "noRange": "No range",
      "outcome": "Outcome",
      "outcomes": {
        "fail": "Fail",
        "not_applicable": "Not applicable",
        "pass": "Pass"
      },
      "range": "Range",
      "reading": "Reading",
      "readingHint": "Leave blank for a visual check.",
      "recordFailed": "Could not record the reading",
      "recordSaved": "Reading recorded",
      "recordedOn": "Recorded on",
      "recordsCaption": "HACCP readings",
      "recordsDescription": "A failure is shown as a failure, not as a row like any other.",
      "recordsEmpty": "No readings in this window.",
      "recordsTitle": "Readings",
      "source": "Source",
      "sources": {
        "csv": "CSV import",
        "manual": "Manual"
      },
      "title": "Food safety",
      "unit": "Unit"
    },
    "landedCost": {
      "absorb": "Absorb onto stock",
      "absorbFailed": "Could not absorb the shipment",
      "absorbed": "Absorbed",
      "absorbedDetail": "The carrying value of the stock has changed. Every valuation figure is now refreshed.",
      "accruedCaption": "Accrued-not-invoiced balance by charge counterparty",
      "accruedDescription": "Charges booked to the clearing account for which no supplier invoice has arrived yet.",
      "accruedTitle": "Accrued not invoiced, by counterparty",
      "accruedTotal": "Total accrued",
      "addCharge": "Add a charge",
      "addChargeDescription": "The element decides whether input tax on it is recoverable, and therefore whether it reaches stock.",
      "agingBreakBody": "Sub-ledger {subledger} against control {control}: a difference of {difference}. Either the sub-ledger or the GL has a posting the other cannot see.",
      "agingBreakTitle": "The clearing account does not reconcile",
      "agingCaption": "Landed-cost clearing aging",
      "agingControl": "Control account",
      "agingDescription": "Charges booked, less what has been absorbed, leaves the clearing balance. Over open shipments that sum is the clearing account.",
      "agingEmpty": "No shipments carry a clearing balance.",
      "agingLink": "Clearing aging",
      "agingLoadFailed": "Could not load the aging report",
      "agingReconciled": "The clearing account reconciles at {total}.",
      "agingSubledger": "Sub-ledger total",
      "agingTableTitle": "Shipments by clearing balance",
      "agingTitle": "Clearing aging",
      "allocate": "Allocate",
      "allocateFailed": "Could not compute the allocation",
      "allocated": "Allocation computed",
      "allocatedDetail": "Nothing has been posted. Absorb is the act that puts this onto stock.",
      "allocationStale": "A charge or a receipt line changed after this allocation was computed. Allocate again before absorbing.",
      "backToList": "Back to shipments",
      "billOfLading": "Bill of lading",
      "buckets": {
        "closed": "Closed",
        "current": "Current",
        "days30": "1–30 d",
        "days60": "31–60 d",
        "days90": "61–90 d",
        "over90": "Over 90 d"
      },
      "caption": "Landed-cost shipments",
      "chargeAdded": "Charge added",
      "chargeBasisCaption": "Charge basis and absorbable amount",
      "chargeDeleteFailed": "Could not remove the charge",
      "chargeFailed": "Could not add the charge",
      "chargesCaption": "Shipment charges",
      "chargesTitle": "Charges",
      "cleared": "Cleared",
      "clearingNotZero": "The clearing balance is {balance}. It must be zero to close.",
      "close": "Close",
      "closeFailed": "Could not close the shipment",
      "closed": "Shipment closed",
      "cogsSplitExplainer": "Part of this shipment was absorbed to cost of sales because that stock had already been sold. The proportion is measured against the receipt, not against current on-hand.",
      "columns": {
        "absorbable": "Absorbable",
        "absorbed": "Absorbed",
        "absorbedInventory": "To inventory",
        "accrued": "Accrued",
        "age": "Age",
        "allocated": "Allocated",
        "baseAmount": "Base amount",
        "basis": "Basis",
        "chargeCount": "Charges",
        "chargeTotal": "Charge total",
        "charges": "Charges",
        "clearing": "Clearing balance",
        "counterparty": "Counterparty",
        "country": "Country",
        "duty": "Duty",
        "dutyRate": "Duty %",
        "effectiveFrom": "Effective from",
        "element": "Element",
        "goodsValue": "Goods value",
        "kind": "Kind",
        "lineTotal": "Line total",
        "mode": "Mode",
        "qty": "Qty",
        "receiptLine": "Receipt line",
        "recoverableTax": "Recoverable tax",
        "reference": "Reference",
        "source": "Source",
        "state": "State",
        "toCogs": "To COGS"
      },
      "counterparty": "Charge counterparty",
      "counterpartyHint": "The party this charge is owed to — the forwarder, broker, port or insurer, not the supplier of the goods.",
      "counterpartyUnset": "Not attributed",
      "create": "New shipment",
      "createDescription": "Receipts and charges are attached after it is created.",
      "createFailed": "Could not create the shipment",
      "created": "Shipment created",
      "customsEntry": "Customs entry",
      "customsValue": "Customs value",
      "description": "Freight, insurance, duty and clearing fees, apportioned onto the receipts they belong to.",
      "directAmountAria": "Direct amount, {item}",
      "directCaption": "Direct amounts per receipt line",
      "directExplainer": "A direct charge is entered per receipt line and not apportioned. The server checks the entered amounts sum to the charge.",
      "disbursementTaxRefused": "A disbursement cannot carry recoverable input tax. Check how the AP invoice line was tax-coded.",
      "documentDescription": "Allocate computes the matrix; absorb puts it into the carrying value of stock.",
      "dutyClassificationRefused": "A duty charge must name a tariff classification and a country of origin.",
      "dutyRateHint": "Percent of customs value. Leave blank when duty is entered per shipment.",
      "elementFailed": "Could not save the element",
      "elementSaved": "Element saved",
      "elementsCaption": "Landed-cost elements",
      "elementsDescription": "The kind is not a label: it decides whether input tax is recoverable, and therefore whether the charge reaches stock.",
      "elementsEmpty": "No elements yet — freight, insurance, duty and clearing fees are the usual set.",
      "elementsLink": "Elements and tariffs",
      "elementsLoadFailed": "Could not load the elements",
      "elementsTitle": "Cost elements",
      "empty": "No shipments yet.",
      "factsTitle": "Shipment",
      "fxHint": "Rate to the legal entity's base currency.",
      "includeClosed": "Include closed",
      "isAbsorbable": "May reach stock",
      "isAbsorbableHint": "Untick for a charge that is always a period expense, such as demurrage caused by our own delay.",
      "isDuty": "This is a customs duty",
      "isDutyHint": "Forces the kind to disbursement and makes tariff and origin required on a charge.",
      "journal": "Absorption journal",
      "kindConsequence": {
        "disbursement": "A disbursement is an amount paid to a third party on the importer's behalf. It carries no recoverable input tax and the whole amount is absorbed.",
        "fee": "A fee is the supplier's own supply, so any recoverable input tax on it is never absorbed into stock."
      },
      "kindHint": {
        "disbursement": "Paid to a third party and recharged at cost.",
        "fee": "The supplier's own charge for their own service."
      },
      "loadFailed": "Could not load the shipments",
      "loadOneFailed": "Could not load the shipment",
      "matrixCaption": "Charge by receipt line",
      "matrixDescription": "Read-only. Every amount is the server's largest-remainder apportionment.",
      "matrixEmpty": "Nothing to allocate yet — attach receipts and add charges first.",
      "matrixExplainer": "Shared out on the {basis} basis.",
      "matrixServerComputed": "The share is shown beside the amount as the explanation. The amount itself is never re-derived here: a browser recomputation would disagree by a cent.",
      "matrixTitle": "Allocation",
      "newElement": "New element",
      "newElementDescription": "A duty is definitionally a disbursement; the form enforces what the database does.",
      "newTariff": "New tariff",
      "newTariffDescription": "Two countries' 1006.30 are two rows: their duty rates differ.",
      "noCharges": "No charges yet.",
      "noReceipts": "This shipment has no receipt lines to allocate onto.",
      "noReceiptsYet": "No receipts attached yet.",
      "notAbsorbable": "This element never reaches stock; it posts straight to expense.",
      "notFound": "That shipment does not exist.",
      "originCountry": "Country of origin",
      "receiptsCaption": "Shipment receipt lines",
      "receiptsDescription": "The receipt movements these costs attach to. One movement belongs to one shipment.",
      "receiptsTitle": "Receipts",
      "removeCharge": "Remove charge",
      "searchLabel": "Search",
      "setupDescription": "Cost elements and tariff classifications.",
      "setupTitle": "Landed-cost setup",
      "staleAllocation": "The allocation is stale. Allocate again first.",
      "tableTitle": "Shipments",
      "tariff": "Tariff classification",
      "tariffFailed": "Could not save the tariff",
      "tariffHint": "The HS or national code as the customs authority spells it.",
      "tariffSaved": "Tariff saved",
      "tariffSource": {
        "pack": "Localization pack",
        "tenant": "Tenant"
      },
      "tariffsCaption": "Tariff classifications",
      "tariffsDescription": "Tenant data today; a localization pack may ship rates later.",
      "tariffsEmpty": "No tariff classifications yet.",
      "tariffsLoadFailed": "Could not load the tariffs",
      "tariffsTitle": "Tariff classifications",
      "title": "Landed cost"
    },
    "landedCostBasis": {
      "direct": "Direct",
      "quantity": "Quantity",
      "value": "Value",
      "volume": "Volume",
      "weight": "Weight"
    },
    "landedCostBasisHint": {
      "direct": "Entered per receipt line and not apportioned. Customs duty computed per tariff line is already attributed, and apportioning it would be wrong.",
      "quantity": "Shared out in proportion to received quantity.",
      "value": "Shared out in proportion to each receipt line's goods value.",
      "volume": "Shared out by volume. Refused when no line carries a volume.",
      "weight": "Shared out by net weight. Refused when no line carries a weight."
    },
    "lotRelation": {
      "merge": "Merged",
      "production": "Produced",
      "repack": "Repacked",
      "rework": "Reworked",
      "split": "Split",
      "transform": "Transformed"
    },
    "lotSource": {
      "backfill": "Backfill",
      "manual": "Manual",
      "production": "Production",
      "receipt": "Receipt",
      "repack": "Repack",
      "transfer": "Transfer"
    },
    "lotStatus": {
      "available": "Available",
      "blocked": "Blocked",
      "expired": "Expired",
      "quarantine": "Quarantine",
      "recalled": "Recalled"
    },
    "lots": {
      "addPart": "Add a part",
      "backToRegister": "Back to the lot register",
      "balancesCaption": "Lot balances by warehouse and bin",
      "balancesDescription": "Positions at bin grain, from the projection the ledger maintains in the same transaction.",
      "balancesEmpty": "This lot holds no stock.",
      "balancesTitle": "Where it is",
      "bestBefore": "Best before",
      "bin": "Bin",
      "caption": "Stock lots",
      "changeStatus": "Change status",
      "changeStatusAction": "Change status",
      "changeStatusDescription": "Only the transitions this lot's current status permits are offered.",
      "childExpiry": "Child expiry",
      "childExpiryHint": "Left blank, the parent's expiry is inherited. Repacking does not extend shelf life.",
      "childLotNo": "New lot no.",
      "columns": {
        "expiry": "Expiry",
        "lotNo": "Lot no.",
        "onHand": "On hand",
        "source": "Source",
        "supplierRef": "Supplier ref.",
        "valueAtRisk": "Value at risk"
      },
      "countryHint": "Two-letter code.",
      "countryOfOrigin": "Country of origin",
      "create": "New lot",
      "currentStatus": "Currently",
      "description": "Every batch of stock, with the status that decides whether it may leave.",
      "dialogDescription": "A lot's status is changed on its own screen, not here — that is a separate permission and a separate machine.",
      "edit": "Edit lot",
      "empty": "No lots yet — one is created by the first receipt of a batch-tracked item.",
      "emptyFiltered": "No lot matches these filters.",
      "expiringCaption": "Lots approaching expiry",
      "expiringDescription": "Lots ranked by shelf life, with the value at risk if they are not moved.",
      "expiringEmpty": "Nothing expires within {days} days.",
      "expiringNote": "Lots with no stock left are hidden: an expiry report full of empty lots is noise.",
      "expiringTableTitle": "Expiry risk",
      "expiryHint": "Correcting a wrong date is the only way an expired lot leaves the expired status.",
      "factsTitle": "Lot",
      "firstReceived": "First received",
      "horizon": "Horizon",
      "horizonOption": "Next {days} days",
      "issuable": "This lot may be issued.",
      "ledgerNote": "Every movement of this item, including this lot's, is on the stock ledger.",
      "loadFailed": "Could not load the lots",
      "loadOneFailed": "Could not load the lot",
      "manufacturedOn": "Manufactured",
      "merge": "Merge",
      "mergeDone": "Merge recorded",
      "mergeFailed": "Could not record the merge",
      "mergeNoSiblings": "This item has no other lots to merge with.",
      "mergeWith": "Merge with",
      "mergeWithHint": "Other lots of the same item. At least one is required.",
      "mergedLotNo": "Merged lot no.",
      "newStatus": "New status",
      "noBin": "Unbinned",
      "notFound": "That lot does not exist.",
      "notIssuable": {
        "blocked": "Blocked on commercial grounds. Nothing may be issued until it is released.",
        "expired": "Past its expiry date. Correct the date if it is wrong; the status follows the data.",
        "quarantine": "Quarantined. Nothing may be issued from this lot until it is released.",
        "recalled": "Under recall. This is imposed by a live recall and cannot be cleared from this screen."
      },
      "occurredOn": "Occurred on",
      "openLedger": "Open the stock ledger",
      "partLotAria": "Lot number, part {line}",
      "partQtyAria": "Quantity, part {line}",
      "qtyConsumed": "Quantity consumed",
      "qtyConsumedHint": "How much of the parent went into the child, in the parent's base unit.",
      "removePart": "Remove part {line}",
      "reopensExpired": "This lot is expired. Changing its date will put it back into circulation once the nightly sweep re-evaluates it.",
      "repack": "Repack",
      "repackDone": "Repack recorded",
      "repackFailed": "Could not record the repack",
      "saveFailed": "Could not save the lot",
      "saved": "Lot saved",
      "searchLabel": "Search",
      "searchPlaceholder": "Lot number or supplier reference",
      "showExpiring": "Expiry risk",
      "showRegister": "Lot register",
      "split": "Split",
      "splitCaption": "Split parts",
      "splitDone": "Split recorded",
      "splitFailed": "Could not record the split",
      "statusChangeFailed": "Could not change the status",
      "statusChanged": "Status changed",
      "statusChangedAt": "Last changed {at}",
      "statusChangedDetail": "{lot} is now {status}",
      "statusMeaning": {
        "available": "Stock may be issued.",
        "blocked": "A commercial hold. Reversible.",
        "expired": "Follows the expiry date.",
        "quarantine": "Held pending a decision. Reversible.",
        "recalled": "Imposed by a recall."
      },
      "statusNote": "Reason",
      "statusNoteOptional": "Optional.",
      "statusNoteRequired": "Required — a held lot with no reason is a lot nobody can release.",
      "statusTerminal": {
        "available": "No transition is available.",
        "blocked": "No transition is available.",
        "expired": "An expired lot leaves this status only when its expiry date is corrected.",
        "quarantine": "No transition is available.",
        "recalled": "A recalled lot's status is owned by the recall. Cancel or close the recall to release it."
      },
      "statusTransitionRefused": "That transition is not allowed from {from}.",
      "supplierRefHidden": "Hidden — a supplier's own batch reference needs the lot-manage permission.",
      "tableTitle": "Lot register",
      "title": "Lots",
      "transform": "Repack, split or merge",
      "transformDescription": "All three record a genealogy edge. The physical quantities move through an ordinary adjustment or production document.",
      "transformNoMovement": "This records the relationship only. No stock moves and no journal posts.",
      "transformTitle": "Lot {lot}",
      "vendor": "Vendor"
    },
    "no": "No",
    "par": {
      "asAt": "As at",
      "asAtHint": "Resolves the level in force on that date.",
      "caption": "Par levels by item and outlet",
      "defaultSource": "Legal entity default",
      "description": "How much an outlet should have on the shelf at the start of service.",
      "effectiveFrom": "Effective from",
      "effectiveFromHint": "Par changes by season; a December requisition is measured against December's par.",
      "empty": "No par levels for this outlet.",
      "link": "Par levels",
      "loadFailed": "Could not load the par levels",
      "minQty": "Min qty",
      "minQtyHint": "Below this the run flags it even before service.",
      "noParLevels": "This outlet has no par levels set.",
      "notReorderPoint": "Par drives a requisition from the main store. A reorder point drives a purchase from a vendor. Conflating them is why a bar orders gin from a distributor when there are six in the cellar.",
      "onHand": "On hand",
      "onOrder": "On order",
      "orderMultiple": "Order multiple",
      "orderMultipleHint": "The suggestion is rounded up to this — a case of 12, for instance.",
      "outlet": "Outlet",
      "parQty": "Par qty",
      "previewOnly": "This writes nothing. Turning it into a requisition is a second, explicit step.",
      "requisitionFailed": "Could not raise the requisition",
      "requisitionRaised": "Requisition raised",
      "run": "Preview the run",
      "runCaption": "Par run result",
      "runDescription": "What a requisition would need to contain to bring every item up to par.",
      "runEmpty": "Nothing is below par.",
      "runFailed": "Could not run par",
      "runOn": "Service date",
      "runOnHint": "Par levels are resolved as at this date, not as at today.",
      "runTitle": "Par run",
      "saveFailed": "Could not save the par level",
      "saved": "Par level saved",
      "setLevel": "Set a par level",
      "setLevelDescription": "Effective-dated. Saving creates a new version from the date you choose.",
      "shortfall": "Shortfall",
      "source": "Source",
      "sourceHint": "Where the stock comes from. Blank uses the legal entity default.",
      "suggested": "Suggested",
      "tableTitle": "Par levels",
      "title": "Par levels",
      "toRequisition": "Raise a requisition",
      "unresolvedIntro": "{count} item(s) could not be resolved to a source and are not in the run:"
    },
    "recallAction": {
      "block_sales": "Block sales",
      "dispose": "Dispose",
      "notify_authority": "Notify authority",
      "notify_customer": "Notify customer",
      "quarantine": "Quarantine stock",
      "return_to_vendor": "Return to vendor",
      "verify_disposal": "Verify disposal"
    },
    "recallActionStatus": {
      "done": "Done",
      "open": "Open",
      "waived": "Waived"
    },
    "recallPosition": {
      "consumed": "Consumed",
      "issued": "Issued",
      "on_hand": "Still on hand",
      "returned": "Returned",
      "sold": "Sold",
      "transferred": "Transferred",
      "wasted": "Wasted"
    },
    "recallSeverity": {
      "class_1": "Class 1",
      "class_2": "Class 2",
      "class_3": "Class 3",
      "withdrawal": "Withdrawal"
    },
    "recallStatus": {
      "cancelled": "Cancelled",
      "closed": "Closed",
      "contained": "Contained",
      "draft": "Draft",
      "tracing": "Tracing"
    },
    "recalls": {
      "action": "Action",
      "actionAdded": "Action added",
      "actionCompleteFailed": "Could not complete the action",
      "actionCompleted": "Action completed",
      "actionFailed": "Could not add the action",
      "actionHint": {
        "block_sales": "Stop it being sold.",
        "dispose": "Destroy it.",
        "notify_authority": "Tell the regulator.",
        "notify_customer": "Tell the customers who received it.",
        "quarantine": "Stop the stock moving in every warehouse.",
        "return_to_vendor": "Send it back to the supplier.",
        "verify_disposal": "Confirm the disposal actually happened."
      },
      "actionsCaption": "Recall actions",
      "actionsDescription": "A recall cannot be contained while an action is open.",
      "actionsEmpty": "No actions yet.",
      "actionsOpen": "{count} action(s) are still open.",
      "actionsTitle": "Containment checklist",
      "addAction": "Add an action",
      "addActionDescription": "Each action must be completed or waived with a reason.",
      "affectedLots": "Lots",
      "affectedQty": "Quantity",
      "affectedValue": "Value",
      "backToBoard": "Back to the recall board",
      "buildPack": "Build the pack",
      "cancelDefaultReason": "Cancelled by the operator",
      "cancelFailed": "Could not cancel the recall",
      "cancelled": "Recall cancelled",
      "caption": "Lot recalls",
      "close": "Close",
      "closeFailed": "Could not close the recall",
      "closed": "Recall closed",
      "completeAction": "Complete the action",
      "completeActionDescription": "A waiver needs a reason. The database refuses one without.",
      "contain": "Contain",
      "containBy": "Contain by",
      "containByHint": "A deadline. A recall past it with open actions is escalated.",
      "containFailed": "Could not contain the recall",
      "contained": "Recall contained",
      "counterparty": "Counterparty",
      "create": "Raise a recall",
      "createDescription": "Name the lots you know about. Genealogy expands them when the recall is traced.",
      "createFailed": "Could not raise the recall",
      "created": "Recall raised",
      "description": "Severity is the first decision: a class 1 recall is a probability of serious harm; a withdrawal is a quality matter.",
      "document": "Document",
      "dueOn": "Due",
      "empty": "No recalls. That is the state to be in.",
      "evidenceDescription": "The artefact an external auditor is handed, with a hash over its contents.",
      "evidenceTitle": "Evidence pack",
      "exposureTitle": "Exposure",
      "initiatedOn": "Initiated",
      "loadFailed": "Could not load the recalls",
      "loadOneFailed": "Could not load the recall",
      "lots": "Lots",
      "lotsDescription": "Named lots and everything genealogy reached from them.",
      "lotsHint": "At least one is required.",
      "lotsTitle": "Affected lots",
      "manifestHash": "Manifest hash",
      "markDone": "Done",
      "markWaived": "Waived",
      "namedLotsOnly": "Only the lots you name are recorded now. Downstream lots are found by the trace.",
      "noLots": "No lots match.",
      "noPackYet": "No evidence pack has been built.",
      "notFound": "That recall does not exist.",
      "notTracedYet": "This recall has not been traced. Quarantine is refused until it has been.",
      "openActions": "Open actions",
      "packBuilt": "Evidence pack built",
      "packBytes": "Bytes",
      "packEntries": "Files",
      "packFailed": "Could not build the evidence pack",
      "packReproducible": "The hash is reproducible: nothing inside the pack carries a generation timestamp.",
      "positionMeaning": {
        "consumed": "Consumed into a dish or a production order. Only the record remains.",
        "issued": "Issued to a document. Follow the document to find it.",
        "on_hand": "Still in a warehouse. This is what quarantine stops moving.",
        "returned": "Returned by a customer.",
        "sold": "Sold. This needs a customer notification, not a quarantine.",
        "transferred": "Moved to another warehouse or legal entity.",
        "wasted": "Already written off."
      },
      "quarantine": "Quarantine every lot",
      "quarantineFailed": "Could not quarantine the stock",
      "quarantined": "Stock quarantined",
      "raise": "Raise",
      "reason": "Reason",
      "recallTitle": "Title",
      "retrace": "Trace again",
      "searchLabel": "Search",
      "severity": "Severity",
      "severityHint": {
        "class_1": "A reasonable probability of serious harm.",
        "class_2": "Temporary or reversible harm.",
        "class_3": "Unlikely to cause harm.",
        "withdrawal": "A quality withdrawal, not a safety recall."
      },
      "tableTitle": "Recall board",
      "title": "Recalls",
      "trace": "Trace",
      "traceFailed": "Could not trace the recall",
      "traceFirst": "Trace the recall before quarantining it.",
      "traced": "Recall traced",
      "tracedAt": "Traced at",
      "tracesCaption": "Traced positions",
      "tracesDescription": "Grouped by position kind, because on-hand stock can be quarantined and sold stock cannot.",
      "tracesEmpty": "Nothing traced yet.",
      "tracesTitle": "Where the stock went",
      "viaGenealogy": "{depth} hop(s) downstream",
      "waiveHint": "Requires a reason.",
      "waivedReason": "Waiver reason",
      "waivedReasonHint": "Recorded on the evidence pack."
    },
    "recipeKind": {
      "batch": "Batch",
      "modifier": "Modifier",
      "plated": "Plated",
      "sub_recipe": "Sub-recipe"
    },
    "recipes": {
      "addLine": "Add a component",
      "asAt": "As at",
      "asAtHint": "Resolves the version in force on that date.",
      "backToList": "Back to recipes",
      "caption": "Recipes",
      "component": "Component item",
      "componentsCaption": "Recipe components",
      "componentsDescription": "Net quantity and waste percent are two numbers because that is how a kitchen thinks about them.",
      "componentsTitle": "Components",
      "costAsOf": "Cost as at",
      "costAsOfHint": "Blank uses today's costs.",
      "costCaption": "Exploded recipe cost",
      "costDescription": "Exploded to leaf components. Every figure is the server's.",
      "costEmpty": "Nothing to cost yet.",
      "costPerOutput": "Cost per output unit",
      "costTitle": "Theoretical cost",
      "costTotal": "Total at yield",
      "create": "New recipe",
      "createDescription": "Lines are added on the recipe screen after it is created.",
      "createFailed": "Could not create the recipe",
      "created": "Recipe created",
      "cycleRefused": "A sub-recipe loop was refused.",
      "defaultWarehouse": "Default source",
      "depthCapped": "The explosion stopped at the depth cap. Some components may be missing.",
      "depthRefused": "The sub-recipe nesting is deeper than the cap allows.",
      "description": "What leaves stock when one unit of a sold item is sold.",
      "effectiveBar": "This version is in force from {from} to {to}.",
      "effectiveFrom": "Effective from",
      "effectiveFromHint": "Recipes are effective-dated so last month's cost is reproducible.",
      "empty": "No recipes yet.",
      "factsTitle": "Recipe",
      "kind": "Kind",
      "kindHint": {
        "batch": "A batch whose lines are batch quantities; the engine divides by the yield.",
        "modifier": "An add-on, such as extra cheese.",
        "plated": "A dish or a drink sold as one item.",
        "sub_recipe": "Referenced by other recipes and never sold directly."
      },
      "linesSaved": "Components saved",
      "link": "Recipes",
      "loadFailed": "Could not load the recipes",
      "loadOneFailed": "Could not load the recipe",
      "modifierAria": "Modifier code, line {line}",
      "modifierCode": "Modifier code",
      "netQty": "Net qty",
      "netQtyAria": "Net quantity, line {line}",
      "noLines": "No components yet.",
      "notABom": "A recipe is not a bill of material. A BOM produces a stocked output through a production order; a recipe consumes ingredients at the moment of sale.",
      "notFound": "That recipe does not exist.",
      "oneComponentPerLine": "A line names an item or a sub-recipe, never both.",
      "openEnded": "further notice",
      "optional": "Optional",
      "output": "Output item",
      "outputHint": "Usually a non-stock item: a plate of biryani is not stocked.",
      "path": "Path",
      "qtyPerOutput": "Qty per output",
      "removeLine": "Remove line {line}",
      "saveFailed": "Could not save the components",
      "searchLabel": "Search",
      "subRecipe": "Sub-recipe",
      "supersede": "Supersede",
      "supersedeFailed": "Could not supersede the recipe",
      "supersedeNote": "Superseding creates a new version from today; the old one stays readable.",
      "superseded": "New version created",
      "tableTitle": "Recipe list",
      "theoreticalCost": "Theoretical cost",
      "title": "Recipes",
      "wasteAria": "Waste percent, line {line}",
      "wasteExplainer": "Waste percent is trim, peel and cooking loss added on top: a 0.2500 kg net portion at 10 % draws 0.2750 kg of stock.",
      "wastePercent": "Waste %",
      "yield": "Yield",
      "yieldHint": "How many output units these lines produce.",
      "yieldUom": "Yield unit"
    },
    "recon": {
      "account": "Account",
      "accountsChecked": "Checked",
      "accountsDiffering": "Differing",
      "backToRuns": "Back to runs",
      "blocksClose": "Blocks close",
      "breakBody": "Sub-ledger {subledger} against control {control}: a difference of {difference}.",
      "breakTitle": "The sub-ledger and the control account disagree",
      "caption": "Reconciliation runs",
      "cause": "Cause",
      "causeHints": {
        "in_transit": "Stock in the system in-transit warehouse.",
        "manual_journal": "Somebody posted straight to the control account. The sub-ledger structurally cannot see it.",
        "migration": "An opening balance from a data migration.",
        "posting_error": "A wrong account on a document.",
        "timing": "A posting that lands in the next period.",
        "unknown": "Not yet identified."
      },
      "causes": {
        "in_transit": "In transit",
        "manual_journal": "Manual journal",
        "migration": "Migration",
        "posting_error": "Posting error",
        "timing": "Timing",
        "unknown": "Unknown"
      },
      "clean": "Sub-ledger and control agree at {total}.",
      "clear": "Clear",
      "clearFailed": "Could not clear the difference",
      "cleared": "Difference cleared",
      "closeReadsThisRun": "The close cockpit reads the latest run rather than recomputing, so the two cannot disagree.",
      "control": "Control",
      "description": "The inventory sub-ledger against the inventory control account, evidenced daily.",
      "difference": "Difference",
      "empty": "No runs yet.",
      "explain": "Explain",
      "explainDescription": "A cause is required. The database refuses an explained line without one.",
      "explainFailed": "Could not save the explanation",
      "explainTitle": "Explain the difference",
      "explained": "Difference explained",
      "lineStatuses": {
        "cleared": "Cleared",
        "explained": "Explained",
        "investigating": "Investigating",
        "open": "Open"
      },
      "linesCaption": "Reconciliation by account",
      "linesEmpty": "No accounts were checked.",
      "linesTitle": "Accounts",
      "loadFailed": "Could not load the runs",
      "loadOneFailed": "Could not load the run",
      "manualJournalNote": "For a manual-journal cause, look for journals posted straight to the account from outside inventory. That is the common real cause.",
      "owner": "Owner",
      "ran": "Reconciliation complete",
      "ranDetail": "{checked} account(s) checked, {differing} differing",
      "run": "Run now",
      "runAt": "Run at",
      "runDescription": "Per account, with a cause and an owner for any difference.",
      "runFailed": "Could not run the reconciliation",
      "runTitle": "Reconciliation as at {asOf}",
      "statuses": {
        "differences": "Differences",
        "failed": "Failed",
        "reconciled": "Reconciled"
      },
      "subledger": "Sub-ledger",
      "tableTitle": "Runs",
      "title": "Valuation reconciliation"
    },
    "replenishment": {
      "asRequisition": "As a requisition",
      "avgDemand": "Avg demand",
      "caption": "Reorder suggestions",
      "convert": "Convert {count}",
      "convertAction": "Convert",
      "convertDescription": "One purchase request, one line per suggestion.",
      "convertFailed": "Could not convert the suggestions",
      "convertSummary": "{count} suggestion(s) will be carried onto the request.",
      "convertTitle": "Convert to a purchase request",
      "converted": "Purchase request raised",
      "convertedPartly": "{requestNo} raised, {failed} suggestion(s) refused",
      "demandExclusions": "Transfers out and waste write-offs are excluded from demand: counting them would make a warehouse reorder against its own shrinkage.",
      "description": "Reorder suggestions with the arithmetic that produced them.",
      "effectiveFrom": "Effective from",
      "empty": "No suggestions.",
      "eoq": "EOQ",
      "everyWarehouse": "Every warehouse",
      "inbound": "Inbound",
      "leadTime": "Lead (d)",
      "link": "Replenishment",
      "loadFailed": "Could not load the suggestions",
      "method": "Method",
      "methods": {
        "eoq": "EOQ",
        "min_max": "Min–max",
        "none": "None",
        "par": "Par",
        "rop": "Reorder point"
      },
      "needBy": "Need by",
      "notWired": "Purchasing is not wired into this build. This is a deployment fault, not something you did.",
      "onHand": "On hand",
      "parNote": "A par-method suggestion produces a requisition from the main store, never a purchase from a vendor. It is not offered for conversion here.",
      "partialConversionNote": "A suggestion the request cannot carry is named rather than failing the whole conversion.",
      "policiesCaption": "Replenishment policies",
      "policiesDescription": "Effective-dated. Where no policy exists the item's own reorder columns are used.",
      "policiesEmpty": "No policies. The item's own reorder columns are in force.",
      "policiesTitle": "Policies",
      "ran": "Reorder run complete",
      "ranDetail": "{created} created, {updated} updated, {requisitions} requisition(s) proposed",
      "rop": "ROP",
      "run": "Run now",
      "runFailed": "Could not run the reorder job",
      "safetyOverride": "Safety override",
      "safetyStock": "Safety stock",
      "selectAll": "Select every convertible suggestion",
      "selectRow": "Select the suggestion for {item}",
      "serviceLevel": "Service level",
      "sigma": "Std dev",
      "status": {
        "converted": "Converted",
        "dismissed": "Dismissed",
        "open": "Open"
      },
      "suggested": "Suggested",
      "tableTitle": "Suggestions",
      "title": "Replenishment"
    },
    "requisitionOrigin": {
      "event": "Event",
      "manual": "Manual",
      "par": "Par run",
      "recipe_forecast": "Recipe forecast"
    },
    "requisitionStatus": {
      "approved": "Approved",
      "cancelled": "Cancelled",
      "closed": "Closed",
      "draft": "Draft",
      "issued": "Issued",
      "partially_issued": "Partly issued",
      "rejected": "Rejected",
      "submitted": "Submitted"
    },
    "requisitions": {
      "addLine": "Add a line",
      "approved": "Requisition approved",
      "approvedQty": "Approved",
      "backToList": "Back to requisitions",
      "cancelDefaultReason": "Cancelled by the requester",
      "cancelFailed": "Could not cancel the requisition",
      "cancelled": "Requisition cancelled",
      "caption": "Stock requisitions",
      "costCentreDescription": "Value moves from one to the other when the requisition is issued.",
      "costCentreTitle": "Cost centres",
      "create": "New requisition",
      "createDescription": "Submit routes it through the approval policy if one matches.",
      "createFailed": "Could not create the requisition",
      "created": "Requisition created",
      "decideFailed": "Could not record the decision",
      "description": "An outlet asking the main store for stock.",
      "documentDescription": "Issuing moves value from the store's cost centre to the outlet's.",
      "empty": "No requisitions.",
      "expenseOnIssue": "Expense on issue — the value is expensed the moment it leaves the store.",
      "expenseOnIssueConsequence": "This outlet holds no stock: no destination balance is created, it cannot be counted, and it cannot be a depletion target.",
      "factsTitle": "Requisition",
      "fromCostCentre": "From",
      "issue": "Issue",
      "issueFailed": "Could not issue the requisition",
      "issued": "Requisition issued",
      "issuedQty": "Issued",
      "linesCaption": "Requisition lines",
      "linesTitle": "Lines",
      "loadFailed": "Could not load the requisitions",
      "loadOneFailed": "Could not load the requisition",
      "noCostCentre": "None",
      "noLines": "This requisition has no lines.",
      "notApproved": "This requisition has not been approved.",
      "notFound": "That requisition does not exist.",
      "onHandAtRequest": "On hand then",
      "origin": "Origin",
      "outletHoldsNoStock": "That outlet holds no stock, so nothing can be depleted from it.",
      "parColumnNote": "The par column is what the run computed, kept beside what the human asked for.",
      "perpetual": "Perpetual — the outlet holds counted stock and the value moves through in transit.",
      "qtyAria": "Quantity, line {line}",
      "rejectDefaultReason": "Rejected by the approver",
      "rejected": "Requisition rejected",
      "removeLine": "Remove line {line}",
      "requestedQty": "Requested",
      "requiredOn": "Required on",
      "shift": "Shift",
      "shiftHint": "Attributes the requisition to a shift for the waste and usage reports.",
      "stockModel": "Stock model",
      "submitFailed": "Could not submit the requisition",
      "submitted": "Requisition submitted",
      "tableTitle": "Requisitions",
      "title": "Requisitions",
      "toCostCentre": "To",
      "transfersTitle": "Transfers raised"
    },
    "rootCauseCategory": {
      "external": "External",
      "people": "People",
      "physical": "Physical",
      "process": "Process",
      "system": "System"
    },
    "settings": {
      "accountsDescription": "Every posting path that needs one refuses by name until it is set.",
      "accountsTitle": "Accounts",
      "accrualAccount": "Landed-cost accrual",
      "accrualAccountHint": "Credited when an estimated charge is accrued ahead of its invoice.",
      "allowAutoReceive": "Allow despatch and receipt in one call",
      "allowAutoReceiveHint": "Both legs and both journals are written either way.",
      "blocks": {
        "clearing": "Landed-cost clearing — no shipment can be absorbed.",
        "inTransit": "Goods in transit — no transfer can be despatched.",
        "outlet": "Outlet consumption — an expense-on-issue outlet cannot be issued to.",
        "waste": "Waste — no waste record can post."
      },
      "clearingAccount": "Landed-cost clearing",
      "clearingAccountHint": "Debited as charges arrive, credited as they are absorbed. Clears to zero per shipment.",
      "description": "Per-company accounts and policy. Accounts start unset on purpose: guessing one by code would be a silent wrong answer on a custom chart.",
      "gapsIntro": "These accounts are unset, and each one blocks something:",
      "inTransitAccount": "Goods in transit",
      "inTransitAccountHint": "Debited on despatch, credited on receipt. Clears to zero per transfer.",
      "link": "Inventory settings",
      "loadFailed": "Could not load the settings",
      "missingRecipe": {
        "block": "Refuse the depletion",
        "blockHint": "The stock relief fails and the sale must be corrected.",
        "record": "Record it as unresolved",
        "recordHint": "The only value a point of sale can survive."
      },
      "missingRecipePolicy": "Sale with no recipe",
      "missingRecipePolicyHint": "What depletion does when a sold item cannot be resolved to a recipe.",
      "outletAccount": "Outlet consumption",
      "outletAccountHint": "Distinct from cost of sales: a staff canteen's consumption is not cost of sales.",
      "policyDescription": "Defaults every count session and every transfer inherits.",
      "policyTitle": "Policy",
      "recountPct": "Recount threshold %",
      "recountPctHint": "Percent of the system quantity.",
      "recountValue": "Recount threshold value",
      "recountValueHint": "Variance value at which a recount is demanded.",
      "requireDifferentCounter": "Require a different counter",
      "requireDifferentCounterHint": "The control INV-FR-009 exists for.",
      "saveFailed": "Could not save the settings",
      "saved": "Settings saved",
      "shrinkageTarget": "Shrinkage target %",
      "shrinkageTargetHint": "As a percent of issues. The shrinkage report measures against this.",
      "title": "Inventory settings",
      "transferOverdueDays": "Transfer overdue after (days)",
      "transferOverdueDaysHint": "Counted from the expected arrival date.",
      "wasteAccount": "Waste and spoilage",
      "wasteAccountHint": "A reason code may override this per reason."
    },
    "shipmentMode": {
      "air": "Air",
      "courier": "Courier",
      "road": "Road",
      "sea": "Sea"
    },
    "shipmentStatus": {
      "absorbed": "Absorbed",
      "allocated": "Allocated",
      "cancelled": "Cancelled",
      "closed": "Closed",
      "draft": "Draft"
    },
    "shortageCause": {
      "bin_blocked": "Bin blocked",
      "expired_lot": "Expired lot",
      "in_transit": "Lost in transit",
      "no_stock": "No stock",
      "quarantined_lot": "Quarantined lot",
      "reserved_elsewhere": "Reserved elsewhere",
      "shelf_life": "Shelf life too short"
    },
    "shortageStatus": {
      "backordered": "Backordered",
      "cancelled": "Cancelled",
      "open": "Open",
      "resolved": "Resolved",
      "substituted": "Substituted"
    },
    "shortages": {
      "available": "Available",
      "caption": "Stock shortages",
      "cause": "Cause",
      "description": "A record that a promise could not be kept, by how much, and why.",
      "detectedOn": "Detected",
      "empty": "No shortages.",
      "link": "Shortages",
      "loadFailed": "Could not load the shortages",
      "noSubstitutes": "No substitutes are declared for this item.",
      "outcome": "Outcome",
      "releaseConsequence": "This moves a promise from one document to another. The engine never does it automatically, because nobody would know.",
      "releaseLowerPriority": "Release lower-priority reservations",
      "releaseLowerPriorityHint": "Least urgent first, most recently made first.",
      "requested": "Requested",
      "resolve": "Resolve",
      "resolveDescription": "Say what happened. Releasing a lower-priority reservation is a separate, deliberate choice.",
      "resolveFailed": "Could not resolve the shortage",
      "resolved": "Shortage resolved",
      "shortfall": "Short",
      "substitute": "Substitute",
      "substituteDescription": "This records the choice. It moves no stock: the document's own module issues it.",
      "substituteFailed": "Could not record the substitution",
      "substituteItem": "Substitute item",
      "substituteItemHint": "Declared substitutes for this item, in preference order.",
      "substituteNeedsApproval": "This substitute requires an approval.",
      "substituteNoMovement": "No movement is posted. The substitution changes what the document asks for.",
      "substituted": "Substitution recorded",
      "substitutedWith": "{qty} of {item}",
      "tableTitle": "Shortage inbox",
      "title": "Shortages"
    },
    "shrinkage": {
      "analysisCaption": "Waste analysis",
      "analysisDescription": "Waste that does not count as shrinkage is shown separately rather than excluded.",
      "analysisEmpty": "No waste in this window.",
      "analysisTitle": "Waste by reason, outlet and shift",
      "caption": "Shrinkage by outlet",
      "chooseAPeriod": "Choose a period to run the report.",
      "countedAsShrinkage": "Counted as shrinkage",
      "description": "Are we losing more than we planned to, and where?",
      "empty": "No issues in this window.",
      "issuesValue": "Issues",
      "loadFailed": "Could not load the shrinkage report",
      "notCountedAsShrinkage": "Not counted as shrinkage",
      "overTarget": "Over target",
      "pct": "Shrinkage %",
      "shrinkageValue": "Shrinkage",
      "tableTitle": "Shrinkage against target",
      "target": "Target %",
      "title": "Shrinkage",
      "verdict": "Verdict",
      "withinTarget": "Within target"
    },
    "storageClass": {
      "ambient": "Ambient",
      "bonded": "Bonded",
      "chilled": "Chilled",
      "dry": "Dry",
      "frozen": "Frozen",
      "hazardous": "Hazardous",
      "secure": "Secure"
    },
    "substitutes": {
      "applies": {
        "both": "Both",
        "outbound": "Outbound",
        "production": "Production"
      },
      "appliesHints": {
        "outbound": "Customer orders only.",
        "production": "Kitchen and production only."
      },
      "appliesTo": "Applies to",
      "approval": "Approval",
      "caption": "Item substitutes",
      "create": "New substitute",
      "delete": "Remove substitute",
      "deleteFailed": "Could not remove the substitute",
      "description": "What may replace what, and where.",
      "dialogDescription": "A flour substitute may be fine in a kitchen and wrong on a customer's order.",
      "empty": "No substitutes declared.",
      "everyWarehouse": "Every warehouse",
      "factor": "Factor",
      "factorExplainer": "How many substitute base units replace one of the original.",
      "factorHint": "×{factor}, preference {preference}",
      "link": "Substitutes",
      "loadFailed": "Could not load the substitutes",
      "needsApproval": "Needs approval",
      "needsApprovalHint": "A substitution under this rule is refused without an approver.",
      "notSelf": "An item cannot substitute for itself.",
      "original": "Original",
      "preference": "Preference",
      "preferenceHint": "Lower is offered first.",
      "saveFailed": "Could not save the substitute",
      "saved": "Substitute saved",
      "substitute": "Substitute",
      "tableTitle": "Substitute master",
      "title": "Substitutes",
      "warehouseHint": "Blank applies everywhere."
    },
    "transferStatus": {
      "cancelled": "Cancelled",
      "draft": "Draft",
      "inTransitOverdue": "In transit — overdue",
      "in_transit": "In transit",
      "received": "Received"
    },
    "usageVariance": {
      "actual": "Actual",
      "actualQty": "Actual qty",
      "closing": "Closing",
      "compute": "Compute",
      "computeFailed": "Could not compute the run",
      "computeTitle": "Compute a run",
      "computed": "Run computed",
      "description": "What the recipes say should have been used, against what actually left.",
      "detailDescription": "Five terms from five sources, so the variance can be argued with.",
      "detailTitle": "Run detail",
      "identity": "actual = opening + received − closing        variance = actual − theoretical − waste",
      "linesCaption": "Usage variance lines",
      "linesEmpty": "No lines on this run.",
      "link": "Usage variance",
      "loadFailed": "Could not load the runs",
      "openMeaning": "No closing count has fixed the actual side yet, so only the theoretical figures are meaningful.",
      "opening": "Opening",
      "period": "Period",
      "received": "Received",
      "runsCaption": "Usage variance runs",
      "runsEmpty": "No runs yet.",
      "runsTitle": "Runs",
      "status": {
        "closed": "Closed",
        "open": "Open"
      },
      "theoretical": "Theoretical",
      "theoreticalQty": "Theoretical qty",
      "title": "Theoretical vs actual",
      "variancePct": "Variance %",
      "varianceValue": "Variance value",
      "wasteQty": "Waste"
    },
    "waste": {
      "addLine": "Add a line",
      "approveFailed": "Could not approve the waste",
      "approved": "Waste approved",
      "caption": "Waste records",
      "category": "Category",
      "costNote": "The value is the server's: waste leaves at the item's live moving-average or FIFO cost.",
      "countsTowardShrinkage": "This reason counts toward the shrinkage target.",
      "description": "Spoilage, breakage and staff consumption, by reason, outlet and shift.",
      "doesNotCountTowardShrinkage": "This reason does not count toward the shrinkage target. A staff meal is planned consumption, not loss.",
      "empty": "No waste recorded.",
      "isShrinkage": "Counts",
      "linesCaption": "Waste lines",
      "loadFailed": "Could not load the waste records",
      "needsApproval": "This reason needs an approval before it posts.",
      "needsAttachment": "This reason needs an attachment.",
      "notShrinkage": "Does not count",
      "qtyAria": "Quantity, line {line}",
      "reason": "Reason",
      "record": "Record waste",
      "recordDescription": "The reason decides the account, the approval and whether it counts as shrinkage.",
      "recordFailed": "Could not record the waste",
      "recorded": "Waste recorded",
      "recordedOn": "Recorded on",
      "rejectDefaultReason": "Rejected by the approver",
      "rejectFailed": "Could not reject the waste",
      "rejected": "Waste rejected",
      "removeLine": "Remove line {line}",
      "shiftHint": "Used by the reason × outlet × shift report.",
      "shrinkage": "Shrinkage",
      "shrinkageLink": "Shrinkage report",
      "sodRefusal": "The person who recorded a write-off cannot approve it.",
      "tableTitle": "Waste records",
      "title": "Waste"
    },
    "wasteCategory": {
      "breakage": "Breakage",
      "complimentary": "Complimentary",
      "expiry": "Expiry",
      "over_production": "Over-production",
      "preparation": "Preparation",
      "spoilage": "Spoilage",
      "staff_meal": "Staff meal",
      "theft": "Theft",
      "training": "Training"
    },
    "wasteStatus": {
      "draft": "Draft",
      "pending_approval": "Awaiting approval",
      "posted": "Posted",
      "rejected": "Rejected"
    },
    "wms": {
      "description": "Zones, bins and the items that live in them. Storage class and capacity are what the putaway planner reads.",
      "title": "Warehouse layout"
    },
    "yes": "Yes",
    "zones": {
      "caption": "Warehouse zones",
      "create": "New zone",
      "delete": "Delete zone",
      "deleteFailed": "Could not delete the zone",
      "deleted": "Zone deleted",
      "description": "A zone offers a storage class and a picking sequence. Both mean something: a frozen item is refused into an ambient bin, and pick sequence is the order a picker walks.",
      "dialogDescription": "Storage class and temperature envelope are read by the putaway planner and by the HACCP checkpoint.",
      "edit": "Edit zone",
      "empty": "No zones yet — add one to group bins by storage class.",
      "loadFailed": "Could not load the zones",
      "maxTemp": "Max °C",
      "minTemp": "Min °C",
      "pickSequence": "Pick sequence",
      "pickSequenceHint": "Lower is walked first.",
      "saveFailed": "Could not save the zone",
      "saved": "Zone saved",
      "storageClass": "Storage class",
      "storageClassHint": "The class bins in this zone offer. An item requiring a different class is refused.",
      "tempHint": "Leave blank for an unmonitored zone.",
      "temperature": "Temperature",
      "title": "Zones",
      "unmonitored": "Unmonitored",
      "unzoned": "Unzoned",
      "zone": "Zone"
    }
  },
  "procurement": {
    "routeTitles": {
      "requisitions": "Purchase requisitions",
      "requisitionNew": "New purchase requisition",
      "requisition": "Purchase requisition",
      "rfqs": "Requests for quotation",
      "rfqNew": "New request for quotation",
      "rfq": "Request for quotation",
      "orders": "Purchase orders",
      "orderNew": "New purchase order",
      "order": "Purchase order",
      "receipts": "Goods receipts",
      "receiptNew": "Receive goods",
      "receipt": "Goods receipt",
      "matches": "Three-way matches",
      "matchNew": "Run a three-way match",
      "match": "Three-way match",
      "grIrAging": "GR-IR aging",
      "scorecards": "Vendor scorecards",
      "settings": "Procurement settings"
    },
    "filtersTitle": "Filters",
    "allCompanies": "All legal entities",
    "allVendors": "All suppliers",
    "export": {
      "done": "Exported",
      "doneDetail": "{count} rows written to a CSV file.",
      "failed": "That export did not run"
    },
    "blockers": {
      "noCompany": "Choose the legal entity this is for.",
      "noVendor": "Choose the supplier this order goes to.",
      "noDate": "Give the date this document is dated.",
      "noCurrency": "Give a three-letter currency code.",
      "noLines": "Add at least one line.",
      "lineIssues": "Fix the lines marked above.",
      "zeroTotal": "This comes to nothing. Give a quantity and a price."
    },
    "chain": {
      "label": "Purchase-to-pay trail",
      "notYet": "not yet",
      "draft": "draft",
      "count": "+{count}",
      "hopLabel": "{stage}, {label}, {state}",
      "hopLink": "{stage} {label}",
      "stages": {
        "pr": "Requisition",
        "rfq": "RFQ",
        "po": "Order",
        "grn": "Receipt",
        "inv": "Invoice",
        "pay": "Payment"
      },
      "states": {
        "none": "not started",
        "open": "open",
        "partial": "part done",
        "done": "done",
        "disputed": "disputed"
      },
      "scoped": {
        "pr": "requisitions",
        "rfq": "quotation rounds",
        "po": "orders",
        "grn": "receipts",
        "inv": "invoices",
        "pay": "payment runs"
      },
      "next": {
        "pr": "Next: raise a requisition.",
        "rfq": "Next: run a quotation round, or order directly.",
        "po": "Next: raise the purchase order this authorises.",
        "grn": "Next: receive the goods when they arrive.",
        "inv": "Next: match the supplier's invoice against this order and its receipts.",
        "pay": "Next: pay the matched invoice through a payment run."
      }
    },
    "budget": {
      "label": "{available} available, this line asks for {requested}",
      "exceededLabel": "Only {available} available and this line asks for {requested}",
      "availableSuffix": "left",
      "exceeded": "Over budget",
      "unbudgeted": "No budget set for this account",
      "none": "No budget",
      "pending": "Budget not checked yet",
      "checking": "Checking budget…",
      "noPermission": "Budget check unavailable — you do not hold budget.check",
      "noModule": "No budget model is configured for this legal entity"
    },
    "lines": {
      "prTitle": "What is being requested",
      "poTitle": "What is being ordered",
      "prCaption": "Requisition lines: item, account, quantity, estimated price and the budget each line consumes.",
      "poCaption": "Order lines: item, account, warehouse, quantity, price, and what has been received and matched.",
      "columns": {
        "no": "#",
        "item": "Item",
        "description": "Description",
        "account": "Account",
        "dimensions": "Dimensions",
        "needBy": "Needed by",
        "quantity": "Quantity",
        "uom": "Unit",
        "estimatedPrice": "Est. price",
        "unitPrice": "Unit price",
        "amount": "Amount",
        "budget": "Budget",
        "warehouse": "Warehouse",
        "taxCode": "Tax",
        "received": "Received",
        "matched": "Matched",
        "grIrRemaining": "In GR-IR",
        "rowActions": "Row actions"
      },
      "actions": {
        "add": "Add a line",
        "duplicate": "Copy this line",
        "remove": "Remove this line",
        "closeLine": "Close this line short",
        "closeLineShort": "Close"
      },
      "aria": {
        "item": "Item on line {line}",
        "description": "Description on line {line}",
        "account": "Account on line {line}",
        "needBy": "Needed by, line {line}",
        "quantity": "Quantity on line {line}",
        "unitPrice": "Unit price on line {line}",
        "warehouse": "Warehouse on line {line}",
        "taxCode": "Tax code on line {line}",
        "duplicate": "Copy line {line}",
        "remove": "Remove line {line}",
        "closeLine": "Close line {line} short",
        "adoptLastPrice": "Use the last price paid, {price}, on line {line}"
      },
      "issues": {
        "invalidQuantity": "That is not a number.",
        "invalidPrice": "That is not a number.",
        "negativeQuantity": "A quantity cannot be negative.",
        "zeroQuantity": "Give a quantity above zero.",
        "negativePrice": "A price cannot be negative.",
        "noAccount": "Choose the account this is charged to.",
        "notPostable": "{account} is a heading, not an account you can charge.",
        "inactive": "{account} is no longer in use.",
        "noDescription": "Say what this is, or choose a catalogue item.",
        "notReceivable": "Choose a warehouse, or this line cannot be received.",
        "needByInPast": "That date has passed."
      },
      "estimatedTotal": "Estimated total",
      "orderSubtotal": "Order subtotal",
      "keyboardHint": "Enter adds a row · Alt+↓ copies · Alt+Backspace removes",
      "lastPaid": "Last paid {price}",
      "itemPlaceholder": "Item, or leave empty for free text",
      "itemRetired": "retired",
      "itemService": "service",
      "noItemMatch": "No catalogue item matches. Leave it empty and describe it instead.",
      "matchCount": "{count} items match",
      "noWarehouse": "No warehouse",
      "noTaxCode": "No tax"
    },
    "pr": {
      "listTitle": "Purchase requisitions",
      "listDescription": "Requests to buy, before anybody has committed to a supplier.",
      "title": "Requisition {docNo}",
      "newTitle": "New requisition",
      "draftTitle": "Draft",
      "description": "Say what you need and when. Approval sets the money aside; it does not order anything.",
      "headerTitle": "Requisition",
      "backToList": "All requisitions",
      "loadFailed": "That requisition did not load",
      "emptyTitle": "No purchase requisitions yet",
      "emptyDescription": "Raise one to ask for something to be bought — it goes for approval before any supplier is involved.",
      "searchHint": "Requisition number or memo",
      "mineOnly": "Only mine",
      "estimatedLabel": "Estimated",
      "actionsLabel": "Requisition actions",
      "submitting": "Submitting",
      "readyToSubmit": "Ready to submit for approval.",
      "railSubtitle": "{status} · raised by {requester}",
      "stale": "Somebody else saved this requisition while it was open. Nothing has been lost — reload it, look at their version, and apply your edits again.",
      "reload": "Reload the saved version",
      "locked": {
        "submitted": "This requisition is waiting for approval and cannot be edited. Reject it to send it back for changes.",
        "approved": "This requisition is approved and its budget is committed. Raise an order against it, or close it to release the commitment.",
        "closed": "Everything on this requisition has been ordered.",
        "cancelled": "This requisition was cancelled."
      },
      "statuses": {
        "draft": "Draft",
        "submitted": "Awaiting approval",
        "approved": "Approved",
        "rejected": "Rejected",
        "closed": "Closed",
        "cancelled": "Cancelled"
      },
      "columns": {
        "docNo": "Requisition",
        "requester": "Requested by",
        "needBy": "Needed by",
        "lines": "Lines",
        "currency": "Currency",
        "total": "Estimated total"
      },
      "fields": {
        "company": "Legal Entity",
        "companyPlaceholder": "Choose the legal entity this is for",
        "needBy": "Needed by",
        "needByHint": "When it has to be here. Buyers work to this date.",
        "currency": "Currency",
        "currencyHint": "The legal entity's base currency is {base}.",
        "department": "Department",
        "departmentHint": "Defaults onto every line; a line may say otherwise.",
        "costCenter": "Cost centre",
        "costCenterHint": "Which budget this is charged against.",
        "branch": "Branch",
        "memo": "Why this is needed",
        "memoHint": "The approver reads this before they read the lines.",
        "requester": "Raised by",
        "subtotal": "Subtotal",
        "total": "Estimated total",
        "approvedAt": "Approved"
      },
      "actions": {
        "save": "Save draft",
        "submit": "Submit for approval",
        "approve": "Approve",
        "reject": "Reject",
        "cancel": "Cancel requisition",
        "close": "Close requisition",
        "discard": "Discard draft",
        "print": "Print",
        "raiseOrder": "Raise a purchase order",
        "raiseRfq": "Ask suppliers to quote"
      },
      "reject": {
        "title": "Reject this requisition",
        "description": "It goes back to the person who raised it, with your comment.",
        "consequence": "Rejecting does not delete anything. The requisition returns to draft and can be corrected and submitted again.",
        "commentLabel": "Why",
        "commentHint": "The requester sees this. Say what would make it approvable."
      },
      "cancel": {
        "title": "Cancel this requisition",
        "description": "It stays on the record, marked cancelled.",
        "reasonLabel": "Reason",
        "reasonHint": "Recorded on the audit trail."
      },
      "close": {
        "title": "Close this requisition",
        "description": "Nothing further will be ordered against it.",
        "releasesCommitment": "This releases the budget still set aside for this requisition. Money nobody is going to spend goes back to the department."
      },
      "timeline": {
        "created": "Raised",
        "submitted": "Submitted as {docNo}",
        "approved": "Approved — budget committed",
        "rejected": "Rejected",
        "closed": "Closed"
      },
      "shortcuts": {
        "save": "Save this requisition"
      },
      "unsavedGuard": {
        "title": "Discard unsaved changes?",
        "message": "This requisition has changes that have not been saved. Leaving now discards them.",
        "confirm": "Discard changes",
        "cancel": "Keep editing"
      },
      "toasts": {
        "saved": "Requisition saved",
        "savedDetail": "Still a draft. Submit it when it is ready.",
        "saveFailed": "That did not save",
        "submitted": "Submitted as {docNo}",
        "submittedDetail": "It is now with its approvers.",
        "submitFailed": "That did not submit",
        "approved": "Requisition approved",
        "approvedDetail": "Its budget is now committed. Raise an order to spend it.",
        "rejected": "Requisition rejected",
        "rejectedDetail": "It has gone back to the person who raised it.",
        "decideFailed": "That decision did not save",
        "cancelled": "Requisition closed",
        "cancelledDetail": "Any budget still committed has been released.",
        "cancelFailed": "That did not close",
        "discarded": "Draft discarded",
        "discardedDetail": "Nothing was submitted, so nothing was lost.",
        "discardFailed": "That did not discard"
      }
    },
    "rfq": {
      "listTitle": "Requests for quotation",
      "listDescription": "Ask several suppliers for a price, then compare what came back.",
      "title": "RFQ {docNo}",
      "newTitle": "New request for quotation",
      "draftTitle": "Draft",
      "description": "Issue to suppliers, record what they quoted, compare on the weights you set, and award.",
      "backToList": "All RFQs",
      "loadFailed": "That RFQ did not load",
      "emptyTitle": "No quotation rounds yet",
      "emptyDescription": "Start one from an approved requisition to ask several suppliers for a price before committing.",
      "createTitle": "Set up the quotation round",
      "createDescription": "The weights decide the recommendation, and they cannot be changed once suppliers have quoted.",
      "createBlocked": "Choose at least one supplier, and make the weights sum to 100.",
      "suppliersTitle": "Invited suppliers",
      "linesTitle": "What is being quoted for",
      "comparisonTitle": "Comparison",
      "comparisonDescription": "Every live quote, scored on the weights above. The working is shown for each.",
      "comparisonFailed": "The comparison did not load",
      "comparisonCaption": "Quotes compared on price, lead time and terms, with each criterion's contribution to the weighted score.",
      "whyCaption": "How {vendor}'s weighted score is made up",
      "noQuotes": "No supplier has quoted yet.",
      "recommended": "Recommended",
      "relativeNote": "Price and lead-time scores are relative to the quotes received: the cheapest scores 100 and the dearest 0. Terms are rated by the buyer.",
      "weightsSummary": "Weighted on price {price}%, lead time {leadTime}%, terms {terms}%.",
      "term": "{score} × {weight}%",
      "termsDefaulted": "(not rated — neutral)",
      "days": "{days} days",
      "quotedOf": "{quoted} of {invited}",
      "fromRequisition": "Quotation round for requisition {docNo}",
      "railSubtitle": "{status} · {suppliers} suppliers invited",
      "statuses": {
        "draft": "Draft",
        "issued": "Issued",
        "closed": "Closed",
        "awarded": "Awarded",
        "cancelled": "Cancelled"
      },
      "supplierStatuses": {
        "invited": "Invited",
        "quoted": "Quoted",
        "declined": "Declined"
      },
      "criteria": {
        "price": "Price",
        "leadTime": "Lead time",
        "terms": "Terms"
      },
      "columns": {
        "docNo": "RFQ",
        "memo": "Subject",
        "dueDate": "Quotes due",
        "responses": "Quoted",
        "supplier": "Supplier",
        "total": "Total quoted",
        "leadTime": "Lead time",
        "terms": "Terms",
        "why": "How the score is made up",
        "score": "Weighted score",
        "award": "Award"
      },
      "fields": {
        "dueDate": "Quotes due by",
        "dueDateHint": "Shown to suppliers. Quotes after it are still accepted.",
        "currency": "Currency",
        "suppliers": "Suppliers to ask",
        "suppliersHint": "A blocked supplier cannot be invited.",
        "weights": "How the quotes are weighed",
        "weightsHint": "Percentages, and they must sum to 100. These decide the recommendation.",
        "weightsMustSum": "The three weights must sum to 100.",
        "memo": "What this round is for",
        "issuedAt": "Issued",
        "awardedTo": "Awarded to"
      },
      "actions": {
        "create": "Create the RFQ",
        "invite": "Invite suppliers",
        "issue": "Issue to suppliers",
        "recordQuote": "Record a quote",
        "award": "Award",
        "evaluate": "Evaluate and award"
      },
      "invite": {
        "title": "Invite more suppliers",
        "description": "They are added to this round and can quote once it is issued."
      },
      "quote": {
        "title": "Record a supplier's quote",
        "description": "What they told you. Until the supplier portal exists, a buyer keys this in.",
        "currency": "Currency",
        "leadTime": "Lead time (days)",
        "leadTimeHint": "Scored against the other quotes: the quickest scores 100.",
        "terms": "Payment terms",
        "termsHint": "In their words — 30 days net, 50% on order, and so on.",
        "termsScore": "Your rating of those terms (0–100)",
        "termsScoreHint": "Your judgement, not a computed figure. Left empty it counts as a neutral 50.",
        "unitPrice": "Quoted unit price",
        "priceFor": "Quoted unit price for {description}"
      },
      "award": {
        "title": "Award this round",
        "description": "A purchase order is created for the supplier you choose.",
        "notRecommended": "This is not the recommended supplier. That is allowed, and the audit trail records both who was recommended and who you chose.",
        "createsOrder": "A draft purchase order will be created for {vendor}, from this RFQ's lines and their quoted prices."
      },
      "links": {
        "requisition": "Requisition",
        "order": "Awarded order",
        "evaluation": "Evaluation and award"
      },
      "timeline": {
        "created": "Created",
        "issued": "Issued as {docNo}",
        "closed": "Closed to further quotes",
        "awarded": "Awarded"
      },
      "toasts": {
        "created": "RFQ created",
        "createdDetail": "Issue it when the supplier list is right.",
        "createFailed": "That RFQ was not created",
        "invited": "Suppliers invited",
        "invitedDetail": "They can quote once the round is issued.",
        "inviteFailed": "Those invitations did not save",
        "issued": "Issued as {docNo}",
        "issuedDetail": "Suppliers can now quote.",
        "issueFailed": "That did not issue",
        "quoted": "Quote recorded",
        "quotedDetail": "Every score in the comparison has been recalculated against it.",
        "awarded": "Awarded",
        "awardedDetail": "Purchase order {docNo} was created.",
        "awardFailed": "That award did not go through"
      },
      "awardOnEvaluation": "Awarding happens on the evaluation screen: it scores the criteria, records the rationale, and asks for an override reason when the award is not the top-ranked quote."
    },
    "po": {
      "listTitle": "Purchase orders",
      "listDescription": "What the legal entity has committed to buy, and how much of it has arrived.",
      "title": "Order {docNo}",
      "newTitle": "New purchase order",
      "draftTitle": "Draft",
      "description": "A commitment to a supplier. Approving it holds the budget; issuing it tells them.",
      "headerTitle": "Order",
      "backToList": "All orders",
      "loadFailed": "That order did not load",
      "emptyTitle": "No purchase orders yet",
      "emptyDescription": "Raise one directly, or convert an approved requisition — the requisition then shows what became of it.",
      "searchHint": "Order number or memo",
      "subtotalLabel": "Subtotal",
      "taxAtSubmit": "Tax is resolved when this is submitted.",
      "actionsLabel": "Order actions",
      "submitting": "Submitting",
      "readyToSubmit": "Ready to submit for approval.",
      "railSubtitle": "{status} · {vendor} · version {version}",
      "versionBadge": "v{version}",
      "fromRequisition": "Raised from requisition {docNo}",
      "amendingNote": "You are editing an amendment. Change the lines, then save the amendment with a reason.",
      "stale": "Somebody else saved this order while it was open. Nothing has been lost — reload it, look at their version, and apply your edits again.",
      "reload": "Reload the saved version",
      "locked": {
        "submitted": "This order is waiting for approval and cannot be edited. Reject it to send it back for changes.",
        "approved": "This order is approved and its budget is committed. Issue it to the supplier.",
        "issued": "The supplier has this order. Changes go through a numbered amendment so both sides can see what moved.",
        "confirmed": "The supplier has confirmed this order. Changes go through a numbered amendment, and confirmation is cleared.",
        "partially_received": "Some of this order has arrived. Changes go through a numbered amendment.",
        "received": "Everything on this order has arrived.",
        "closed": "This order is closed.",
        "cancelled": "This order was cancelled."
      },
      "statuses": {
        "draft": "Draft",
        "submitted": "Awaiting approval",
        "approved": "Approved",
        "rejected": "Rejected",
        "issued": "Issued",
        "confirmed": "Confirmed",
        "partially_received": "Part received",
        "received": "Received",
        "closed": "Closed",
        "cancelled": "Cancelled"
      },
      "columns": {
        "docNo": "Order",
        "vendor": "Supplier",
        "orderDate": "Ordered",
        "expectedDate": "Expected",
        "currency": "Currency",
        "total": "Total"
      },
      "fields": {
        "company": "Legal Entity",
        "vendor": "Supplier",
        "vendorTerms": "Pays in {days} days",
        "orderDate": "Order date",
        "expectedDate": "Expected delivery",
        "expectedDateHint": "What you have asked for. The supplier's own date replaces it on confirmation.",
        "currency": "Currency",
        "memo": "Memo",
        "subtotal": "Subtotal",
        "tax": "Tax",
        "total": "Total",
        "baseTotal": "Total in base currency",
        "fxRate": "Rate",
        "confirmedAt": "Confirmed"
      },
      "actions": {
        "save": "Save draft",
        "submit": "Submit for approval",
        "approve": "Approve",
        "approveHint": "Approving commits the budget firmly against this order.",
        "reject": "Reject",
        "issue": "Issue to supplier",
        "confirm": "Record confirmation",
        "amend": "Amend",
        "saveAmendment": "Save amendment",
        "cancel": "Cancel order",
        "receive": "Receive goods",
        "match": "Match an invoice",
        "print": "Print",
        "abandonAmendment": "Abandon amendment",
        "deliverySchedule": "Delivery schedule",
        "raiseAmendment": "Raise for approval"
      },
      "reject": {
        "title": "Reject this order",
        "description": "It goes back to the buyer, with your comment."
      },
      "confirm": {
        "title": "Record the supplier's confirmation",
        "description": "What they came back with, so the receiving schedule reflects reality rather than hope.",
        "referenceLabel": "Their reference",
        "referenceHint": "Their own order or acknowledgement number, if they gave one.",
        "expectedLabel": "Date they committed to",
        "expectedHint": "Often not the date you asked for. This is the one everything downstream will use."
      },
      "amend": {
        "title": "Amend this order",
        "description": "A numbered amendment, with a reason, so both sides can see what moved.",
        "editFirst": "Start editing first — change the lines on the order, then come back here and explain the change.",
        "beginEditing": "Start editing the lines",
        "clearsConfirmation": "The supplier has confirmed this order. Amending clears that confirmation: they confirmed a different document and will need to confirm again.",
        "reasonLabel": "What changed and why",
        "reasonHint": "Kept with the version. \"v3\" tells nobody anything; \"supplier short by 200 bags\" tells them everything.",
        "expectedHint": "Leave as it is unless the delivery date moved.",
        "needsApproval": "The amended total crosses an authority band, so it cannot be applied here. Nothing has changed on the order. Raise it as an amendment instead: it keeps these lines and this reason, routes for approval, and is applied once approved.",
        "raiseHint": "Records the change as a standing amendment and opens the amendment register."
      },
      "cancel": {
        "title": "Cancel this order",
        "description": "It stays on the record, marked cancelled.",
        "releasesCommitment": "This releases the budget committed against the order. An order nobody is going to receive should not be holding money."
      },
      "closeLine": {
        "title": "Close this line short",
        "description": "Nothing further is expected against it.",
        "releasesCommitment": "This releases whatever budget is still committed on the line. The alternative is money held against goods that will never arrive.",
        "reasonLabel": "Why nothing more is coming",
        "reasonHint": "Recorded on the audit trail — discontinued, supplier cannot fill it, ordered elsewhere."
      },
      "versions": {
        "title": "Amendment history",
        "description": "What changed after the supplier had a copy.",
        "version": "Version {version}",
        "original": "Original order as issued",
        "noReason": "No reason was recorded",
        "auditHint": "Every amendment is on the audit trail in the right rail, with who made it and when."
      },
      "links": {
        "matches": "Invoice matches against this order",
        "grIr": "GR-IR balance on this order",
        "amendments": "Amendment register",
        "deliverySchedule": "Delivery schedule"
      },
      "timeline": {
        "created": "Raised",
        "submitted": "Submitted",
        "approved": "Approved — budget committed firmly",
        "rejected": "Rejected",
        "issued": "Issued to supplier as {docNo}",
        "confirmed": "Supplier confirmed",
        "closed": "Closed",
        "cancelled": "Cancelled"
      },
      "shortcuts": {
        "save": "Save this order"
      },
      "unsavedGuard": {
        "title": "Discard unsaved changes?",
        "message": "This order has changes that have not been saved. Leaving now discards them.",
        "confirm": "Discard changes",
        "cancel": "Keep editing"
      },
      "toasts": {
        "saved": "Order saved",
        "savedDetail": "Still a draft — the supplier has not been told anything.",
        "saveFailed": "That did not save",
        "submitted": "Submitted as {docNo}",
        "submittedDetail": "It is now with its approvers.",
        "submitFailed": "That did not submit",
        "approved": "Order approved",
        "approvedDetail": "The budget is now firmly committed against it.",
        "rejected": "Order rejected",
        "rejectedDetail": "It has gone back to the buyer.",
        "decideFailed": "That decision did not save",
        "issued": "Issued as {docNo}",
        "issuedDetail": "The supplier can now confirm it.",
        "issueFailed": "That did not issue",
        "confirmed": "Confirmation recorded",
        "confirmedDetail": "The expected date now reflects what the supplier committed to.",
        "confirmFailed": "That did not save",
        "amended": "Amended to version {version}",
        "amendedDetail": "The reason is kept with the version.",
        "amendFailed": "That amendment did not save",
        "cancelled": "Order cancelled",
        "cancelledDetail": "Its budget commitment has been released.",
        "cancelFailed": "That did not cancel",
        "lineClosed": "Line closed",
        "lineClosedDetail": "The budget still committed on it has been released.",
        "lineCloseFailed": "That line did not close",
        "amendmentRaised": "Amendment {version} raised for approval",
        "amendmentRaisedDetail": "The order is unchanged until the amendment is approved and applied."
      }
    },
    "grn": {
      "listTitle": "Goods receipts",
      "listDescription": "What has arrived, what it was worth, and what it put into GR-IR clearing.",
      "title": "Goods receipt",
      "titleWithNo": "Receipt {docNo}",
      "draftTitle": "Draft",
      "description": "A posted receipt moved stock onto the balance sheet and the same value into GR-IR clearing.",
      "headerTitle": "Receipt",
      "linesTitle": "What arrived",
      "linesCaption": "Ordered, already received, outstanding, what is being received now, and the over-receipt cap.",
      "backToList": "All receipts",
      "loadFailed": "That receipt did not load",
      "emptyTitle": "Nothing received yet",
      "emptyDescription": "Receiving starts from a purchase order — open the order the delivery is against and receive from there.",
      "receiveTitle": "Receive goods",
      "receiveDescription": "Against a purchase order: all of it, some of it, or refused at the door.",
      "chooseOrder": "Open the purchase order the delivery is against and receive from there.",
      "notReceivable": "This order is {status} and cannot be received against. Issue it to the supplier first.",
      "actionsLabel": "Receipt actions",
      "linesReceiving": "Lines on this receipt",
      "posting": "Posting",
      "postsImmediately": "There is no draft: this posts the stock movement and the journal in one step.",
      "postingExplained": "Posting a receipt debits inventory and credits GR-IR clearing at the order's own cost. The GR-IR balance stays until an invoice is matched against it.",
      "tolerancePolicy": "This legal entity accepts up to {percent}% over the ordered quantity. Beyond that the receipt is refused.",
      "toleranceUnavailable": "The over-receipt tolerance is not visible to you, so the cap per line cannot be shown. Ask somebody who holds procurement.settings.manage.",
      "overCap": "Over the cap",
      "capWarning": "One or more lines are over the over-receipt cap. The server will refuse this receipt.",
      "noBin": "No bin",
      "noItem": "No catalogue item",
      "noWarehouse": "No warehouse",
      "blockedTitle": "Lines that cannot be received",
      "blockedDescription": "A line with no catalogue item or no warehouse cannot post a stock movement. Amend the order to add them.",
      "rejectReasonPlaceholder": "Why it was refused",
      "rejectedCount": "{count} line(s) refused",
      "totalValue": "Value into GR-IR",
      "lot": "Lot {lot}",
      "railSubtitle": "{status} · against {poNo}",
      "reversedNote": "This receipt was reversed: {reason}. The mirror stock movement and journal were written; the original stays on the record.",
      "statuses": {
        "draft": "Draft",
        "posted": "Posted",
        "reversed": "Reversed",
        "cancelled": "Cancelled"
      },
      "lineStatuses": {
        "received": "Received",
        "rejected": "Refused"
      },
      "blockers": {
        "noLines": "Enter a quantity on at least one line, or mark a line refused.",
        "noDate": "Give the date the goods arrived.",
        "noReason": "Say why a refused line was refused."
      },
      "columns": {
        "docNo": "Receipt",
        "order": "Order",
        "receiptDate": "Received",
        "lines": "Lines",
        "memo": "Memo",
        "ordered": "Ordered",
        "alreadyReceived": "Already in",
        "outstanding": "Outstanding",
        "receiving": "Receiving now",
        "cap": "Cap",
        "putAway": "Put away in",
        "reject": "Refuse",
        "quantity": "Quantity",
        "unitCost": "Unit cost",
        "value": "Value"
      },
      "fields": {
        "receiptDate": "Date received",
        "receiptDateHint": "The day the goods arrived — the journal is dated by it.",
        "supplier": "Supplier",
        "order": "Against order",
        "memo": "Memo",
        "postedAt": "Posted",
        "grIrValue": "Into GR-IR clearing"
      },
      "aria": {
        "receiving": "Quantity being received of {description}",
        "rejectReason": "Why {description} was refused"
      },
      "actions": {
        "receive": "Receive and post",
        "reverse": "Reverse this receipt",
        "inspection": "Inspection and quarantine"
      },
      "reverse": {
        "title": "Reverse this receipt",
        "description": "The mirror stock movement and the mirror journal.",
        "consequence": "The receipt stays on the record, marked reversed — nothing is deleted. A receipt already matched against an invoice cannot be reversed; unwind the match first.",
        "reasonLabel": "Why",
        "reasonHint": "Recorded on the audit trail and on the reversing journal."
      },
      "timeline": {
        "created": "Recorded",
        "posted": "Posted to the ledger",
        "reversed": "Reversed"
      },
      "toasts": {
        "posted": "Received as {docNo}",
        "postedDetail": "Stock is in, and the value is sitting in GR-IR clearing until an invoice matches it.",
        "postFailed": "That receipt did not post",
        "reversed": "Receipt reversed",
        "reversedDetail": "The mirror stock movement and journal were written.",
        "reverseFailed": "That reversal did not go through"
      },
      "quarantinedCount": "{count} line(s) held in quarantine",
      "inspection": {
        "lineLink": "Release or reject",
        "open": "Open the inspection",
        "quarantineNote": "{count} line(s) on this receipt are quarantined. The goods are in stock and their value is already in GR-IR clearing — what is held is the right to issue them."
      }
    },
    "match": {
      "listTitle": "Three-way matches",
      "listDescription": "Invoices checked against their order and their receipts.",
      "title": "Match #{id}",
      "newTitle": "Run a three-way match",
      "description": "The invoice, the order and the receipt side by side — and why they agreed or did not.",
      "backToList": "All matches",
      "loadFailed": "That match did not load",
      "emptyTitle": "Nothing matched yet",
      "emptyDescription": "A match compares a supplier's invoice against the order it settles and the goods actually received. Run one from an order that has received something.",
      "chooseTitle": "What is being matched",
      "chooseDescription": "Pick the invoice, then say which order line each invoice line settles.",
      "sourcesTitle": "The three documents",
      "linesTitle": "Line by line",
      "linesCaption": "Ordered, received and invoiced quantities with their variance, the two prices with theirs, and the tolerance each was judged against.",
      "pairCaption": "Each invoice line, and the purchase-order line it settles.",
      "noOrder": "No order chosen",
      "unmatched": "Not matched",
      "runExplained": "Running a match records the result either way. A line outside tolerance is recorded as a dispute, not thrown away.",
      "postExplained": "Posting the invoice is refused while any line is outside tolerance — the refusal names the lines, and it arrives before the journal exists rather than after.",
      "matchedLabel": "Matched",
      "actionsLabel": "Match actions",
      "posting": "Posting",
      "railTitle": "Match #{id}",
      "railSubtitle": "{status}",
      "percent": "{value}%",
      "ofTolerance": "of {bound}% allowed",
      "priceBounds": "allowed: {percent}% or {amount}",
      "within": "Within tolerance",
      "outside": "Outside tolerance",
      "disagreement": "This screen reads the tolerance rule differently from the server. The server's decision stands; please report this.",
      "refusedLine": "Refused: quantity varies by {qty}%, price by {price}%.",
      "refusedLines": "Purchase-order line(s) {lines} are outside tolerance.",
      "openDisputes": "{count} dispute(s) still open",
      "disputedOnly": "Only disputed",
      "ofLines": "{outside} of {total}",
      "disputesTitle": "Disputes",
      "disputesDescription": "Each one holds an invoice out of the ledger until somebody decides.",
      "toleranceSummary": "Tolerance: quantity within {qty}%; price within {pricePercent}% or {priceAmount}, whichever passes.",
      "toleranceUnavailable": "The tolerance policy is not visible to you, so the bounds cannot be shown beside each variance. Ask somebody who holds procurement.settings.manage.",
      "statuses": {
        "matched": "Matched",
        "disputed": "Disputed"
      },
      "disputeStatuses": {
        "open": "Open",
        "resolved": "Resolved"
      },
      "invoiceStatuses": {
        "draft": "Draft",
        "submitted": "Awaiting approval",
        "approved": "Approved, not posted",
        "rejected": "Rejected",
        "posted": "Posted",
        "paid": "Paid",
        "reversed": "Reversed",
        "cancelled": "Cancelled"
      },
      "columns": {
        "match": "Match",
        "order": "Order",
        "invoice": "Invoice",
        "vendor": "Supplier",
        "invoiceLine": "Invoice line",
        "settlesPoLine": "Settles order line",
        "poQty": "Ordered",
        "grnQty": "Received",
        "invoiceQty": "Invoiced",
        "qtyVariance": "Quantity variance",
        "poPrice": "Order price",
        "invoicePrice": "Invoice price",
        "priceVariance": "Price variance",
        "verdict": "Verdict",
        "outsideTolerance": "Outside tolerance",
        "openDisputes": "Open disputes"
      },
      "fields": {
        "order": "Purchase order",
        "invoice": "Supplier invoice",
        "invoiceHint": "Approved invoices for this supplier that have not been posted yet.",
        "invoicePlaceholder": "Choose the invoice to match",
        "invoiceStatus": "Invoice status",
        "receipts": "Receipts against the order"
      },
      "actions": {
        "run": "Run the match",
        "post": "Post the invoice",
        "resolve": "Resolve"
      },
      "resolve": {
        "title": "Resolve this dispute",
        "description": "Somebody has to decide: accept the variance, or hold the invoice.",
        "outcomeLabel": "Decision",
        "accept": "Accept the variance",
        "reject": "Hold the invoice",
        "acceptConsequence": "Accepting overrides the tolerance and matches the line at the invoice's figures. The purchase order and the budget commitment are released accordingly.",
        "rejectConsequence": "Holding leaves the line unmatched and its GR-IR balance open. The supplier has to correct the invoice.",
        "noteLabel": "Why",
        "noteHint": "Required. This is the record of why a tolerance was overridden, or why an invoice was held."
      },
      "timeline": {
        "matched": "Matched",
        "disputeOpened": "Dispute opened: {reason}",
        "disputeResolved": "Dispute resolved"
      },
      "toasts": {
        "matched": "Matched",
        "matchedDetail": "Every line was within tolerance. The invoice can be posted.",
        "disputed": "Matched with disputes",
        "disputedDetail": "Some lines are outside tolerance. They are recorded, and the invoice cannot post until they are resolved.",
        "matchFailed": "That match did not run",
        "posted": "Invoice posted",
        "postedDetail": "GR-IR clearing has been debited and the payable raised.",
        "refused": "Posting refused — outside tolerance",
        "postFailed": "That invoice did not post",
        "resolved": "Dispute resolved",
        "resolvedDetail": "Your reason is on the record.",
        "resolveFailed": "That resolution did not save"
      },
      "exception": {
        "price_variance": "The invoice price differs from the order.",
        "qty_variance": "The invoice quantity differs from the order.",
        "missing_receipt": "Invoiced but not yet received.",
        "missing_order": "Invoiced with no purchase order.",
        "tax_variance": "The invoice tax differs from what was expected.",
        "freight_variance": "An unordered freight or handling charge.",
        "duplicate_invoice": "A possible duplicate invoice.",
        "over_invoice": "Cumulative invoicing exceeds the order.",
        "currency_mismatch": "The invoice and the order are in different currencies.",
        "inspection_failed": "The goods failed inspection."
      }
    },
    "grIr": {
      "title": "GR-IR aging",
      "description": "Goods received and not yet invoiced — and whether the sub-ledger and the general ledger agree about it.",
      "loadFailed": "That report did not load",
      "rowsTitle": "Open balances",
      "chooseCompany": "Choose a legal entity",
      "chooseCompanyFirst": "Choose a legal entity to run this report.",
      "asOf": "As at",
      "asOfHint": "Leave empty for today, in the workspace timezone.",
      "openOnly": "Only lines with a balance",
      "caption": "GR-IR balances by purchase-order line as at {asOf}.",
      "generatedAt": "As at {asOf}.",
      "empty": "Nothing received against any purchase order for this legal entity.",
      "emptyOpen": "Nothing outstanding. Every receipt has been matched to an invoice — which is what this report exists to show.",
      "subLedgerBalance": "Procurement sub-ledger",
      "ledgerBalance": "Ledger {code} {name}",
      "difference": "Difference",
      "reconciled": "The sub-ledger and the ledger agree. Everything received and not yet invoiced is accounted for in both.",
      "notReconciled": "The sub-ledger and the ledger disagree by {amount}. Goods received but not invoiced are not accounted for the same way in both, and the difference has to be explained before this period can be closed.",
      "totals": "Totals",
      "onlyThisVendor": "only this supplier",
      "matches": "matches",
      "days": "{days} d",
      "columns": {
        "order": "Order",
        "receivedQty": "Received",
        "receivedValue": "Received value",
        "matchedValue": "Matched value",
        "balance": "In GR-IR",
        "share": "Share",
        "age": "Oldest receipt",
        "lineStatus": "Line"
      }
    },
    "scorecards": {
      "title": "Vendor scorecards",
      "description": "How suppliers actually performed: on time and in full, price against order, and quality at the door.",
      "loadFailed": "Those scorecards did not load",
      "emptyTitle": "No scorecards yet",
      "emptyDescription": "Scorecards are computed nightly from delivered orders and matched invoices. They appear once a supplier has completed an order.",
      "computedNightly": "Computed nightly from received orders, matched invoices and refused deliveries.",
      "otifDetail": "{onTime} on time, {inFull} in full, of {orders}",
      "columns": {
        "vendor": "Supplier",
        "period": "Period",
        "orders": "Orders",
        "otif": "On time in full",
        "priceVariance": "Price variance",
        "quality": "Quality"
      }
    },
    "settings": {
      "title": "Procurement settings",
      "description": "Where received-but-uninvoiced value sits, and how much disagreement is absorbed without a person looking at it.",
      "loadFailed": "Those settings did not load",
      "companyTitle": "Legal Entity",
      "accountTitle": "GR-IR clearing account",
      "accountDescription": "Received goods are debited to inventory and credited here until an invoice matches them.",
      "toleranceTitle": "Tolerances",
      "toleranceDescription": "Each of these decides how often your colleagues are interrupted, and how much goes through unchecked.",
      "configuredAccount": "Receipts credit account {code}.",
      "defaultedAccount": "No account is configured, so receipts credit {code} from the standard chart. Set one to be explicit.",
      "priceRule": "A price passes if it is within either bound — the amount or the percentage. Set the amount for small parts where a percentage would be noise, and the percentage for large ones where an amount would be.",
      "fields": {
        "grIrAccount": "GR-IR clearing account",
        "grIrAccountHint": "Left empty, the standard chart's GR-IR clearing account is used.",
        "grIrAccountPlaceholder": "Use the standard chart's account",
        "qtyTolerance": "Quantity tolerance (%)",
        "qtyToleranceHint": "How far an invoiced quantity may differ from the ordered one before a dispute opens.",
        "overReceipt": "Over-receipt tolerance (%)",
        "overReceiptHint": "How much more than ordered may be received. Beyond it, the receipt is refused at the door.",
        "pricePercent": "Price tolerance (%)",
        "pricePercentHint": "For large-value lines, where a fixed amount would be trivially exceeded.",
        "priceAmount": "Price tolerance (amount)",
        "priceAmountHint": "For small-value lines, where a percentage would open a dispute over a few laari."
      },
      "toasts": {
        "saved": "Settings saved",
        "savedDetail": "New receipts and matches are judged against these from now on.",
        "saveFailed": "Those settings did not save"
      },
      "stale": "Somebody else saved these settings while you had them open. Nothing was overwritten — reload the saved version, then apply your edits again.",
      "reload": "Reload the saved version"
    },
    "c7": {
      "filtersTitle": "Filters",
      "common": {
        "remove": "Remove"
      },
      "routeTitles": {
        "grnInspection": "Receipt inspection",
        "returns": "Supplier returns",
        "return": "Supplier return",
        "suppliers": "Suppliers",
        "supplier": "Supplier",
        "supplierPolicy": "Supplier policy",
        "supplierRisk": "Supplier risk",
        "contracts": "Contracts",
        "contract": "Contract",
        "releases": "Contract releases",
        "contractExpiry": "Contract renewals",
        "spendAnalysis": "Spend analysis",
        "maverick": "Maverick spend",
        "spendFacts": "Spend facts",
        "matchExceptions": "Match exceptions",
        "matchCauses": "Match causes",
        "amendments": "Order amendments",
        "deliverySchedule": "Delivery schedule",
        "incoterms": "Incoterms",
        "rfqEvaluation": "Tender evaluation"
      },
      "fields": {
        "businessDate": "Date",
        "code": "Code",
        "company": "Legal Entity",
        "criticality": "Criticality",
        "currency": "Currency",
        "detail": "Detail",
        "documentNo": "Number",
        "effectivity": "Effectivity",
        "fromDate": "From",
        "incoterm": "Incoterm",
        "item": "Item",
        "kind": "Kind",
        "lot": "Lot",
        "notes": "Notes",
        "openEnded": "open",
        "qualification": "Qualification",
        "quantity": "Quantity",
        "reason": "Reason",
        "title": "Title",
        "toDate": "To",
        "unitCost": "Unit cost",
        "value": "Value",
        "vendor": "Supplier"
      },
      "grnLineStatus": {
        "received": "Accepted",
        "accepted": "Accepted",
        "quarantined": "Quarantined",
        "rejected": "Rejected at the dock",
        "returned": "Returned"
      },
      "returnReason": {
        "quality": "Quality",
        "over_delivery": "Over-delivery",
        "wrong_item": "Wrong item",
        "damaged": "Damaged",
        "expired": "Expired",
        "commercial": "Commercial"
      },
      "returnStatus": {
        "draft": "Draft",
        "submitted": "Submitted",
        "approved": "Approved",
        "despatched": "Despatched",
        "completed": "Completed",
        "cancelled": "Cancelled"
      },
      "qualification": {
        "prospect": "Prospect",
        "under_review": "Under review",
        "qualified": "Qualified",
        "preferred": "Preferred",
        "suspended": "Suspended",
        "exited": "Exited",
        "meaning": {
          "prospect": "Identified, not yet assessed",
          "under_review": "Being assessed; buy with care",
          "qualified": "Approved for ordinary purchasing",
          "preferred": "Approved and favoured in sourcing",
          "suspended": "Purchase orders are refused",
          "exited": "No longer used at all"
        },
        "dialogTitle": "Change qualification",
        "dialogDescription": "A qualification transition is a control, not a label. It is recorded with a reason and a decision date.",
        "current": "Current status",
        "newStatus": "New status",
        "assessmentScore": "Assessment score",
        "validUntil": "Qualified until",
        "validUntilMeaning": "After this date the qualification lapses and the policy applies again.",
        "blocksOrders": "This status refuses new purchase orders for this supplier. Open orders are not cancelled, but nothing new can be raised without an override.",
        "confirm": "Record transition",
        "change": "Change qualification",
        "historyTitle": "Qualification history",
        "historyCaption": "Every qualification transition with its reason and decision date.",
        "transition": "Transition",
        "decidedAt": "Decided",
        "note": "Qualification note",
        "empty": "No transitions recorded. This supplier is at its migrated default.",
        "saved": "Qualification updated",
        "saveFailed": "The qualification was not changed"
      },
      "criticality": {
        "standard": "Standard",
        "important": "Important",
        "critical": "Critical",
        "single_source": "Single source"
      },
      "documentStatus": {
        "submitted": "Submitted",
        "verified": "Verified",
        "rejected": "Rejected",
        "expired": "Expired"
      },
      "screeningList": {
        "sanctions": "Sanctions",
        "pep": "Politically exposed person",
        "adverse_media": "Adverse media",
        "ubo": "Beneficial ownership"
      },
      "screeningOutcome": {
        "clear": "Clear",
        "potential_match": "Potential match",
        "confirmed_match": "Confirmed match",
        "error": "Screening error"
      },
      "screeningReview": {
        "false_positive": "False positive",
        "true_match": "True match"
      },
      "policyMode": {
        "block": "Block",
        "warn": "Warn",
        "ignore": "Ignore"
      },
      "contractKind": {
        "price_agreement": "Price agreement",
        "blanket_order": "Blanket order",
        "framework": "Framework"
      },
      "contractStatus": {
        "draft": "Draft",
        "submitted": "Submitted",
        "active": "Active",
        "rejected": "Rejected",
        "suspended": "Suspended",
        "expired": "Expired",
        "terminated": "Terminated",
        "cancelled": "Cancelled"
      },
      "priceBasis": {
        "exclusive": "Tax exclusive",
        "inclusive": "Tax inclusive"
      },
      "rebateKind": {
        "volume_percent": "Volume percentage",
        "tiered_percent": "Tiered percentage",
        "fixed_amount": "Fixed amount"
      },
      "releaseStatus": {
        "open": "Open",
        "consumed": "Consumed",
        "cancelled": "Cancelled"
      },
      "spendStage": {
        "committed": "Committed",
        "invoiced": "Invoiced",
        "reversed": "Reversed"
      },
      "spendContractStatus": {
        "on_contract": "On contract",
        "off_contract": "Off contract",
        "no_contract": "No contract available",
        "contract_alternate": "Another supplier had a contract"
      },
      "sourcingRoute": {
        "direct": "Direct",
        "rfq": "Tender",
        "contract": "Contract",
        "catalogue": "Catalogue"
      },
      "exceptionStatus": {
        "open": "Open",
        "resolved": "Resolved",
        "accepted": "Accepted",
        "rejected": "Rejected"
      },
      "ownerResolution": {
        "buyer": "Buyer",
        "requester": "Requester",
        "warehouse_manager": "Warehouse manager",
        "role": "A named role",
        "user": "A named person",
        "finance": "Finance"
      },
      "amendmentChange": {
        "add": "Added",
        "update": "Changed",
        "cancel": "Cancelled"
      },
      "amendmentStatus": {
        "draft": "Draft",
        "submitted": "Submitted",
        "approved": "Approved",
        "rejected": "Rejected",
        "applied": "Applied"
      },
      "criterionKind": {
        "price": "Price",
        "landed_cost": "Landed cost",
        "lead_time": "Lead time",
        "terms": "Payment terms",
        "quality_score": "Quality score",
        "otif": "On time in full",
        "manual": "Scored by the panel"
      },
      "borneBy": {
        "buyer": "Buyer",
        "seller": "Seller"
      },
      "receiving": {
        "title": "Receipt inspection",
        "description": "What arrived, what was accepted, what is held and what was refused.",
        "backToReceipt": "Back to the receipt",
        "loadFailed": "The receipt inspection did not load",
        "linesTitle": "Receipt lines",
        "linesCaption": "Each receipt line's three-way split and its inspection lot.",
        "linesEmpty": "This receipt has no lines.",
        "splitCaption": "Delivered quantity split into accepted, quarantined and rejected.",
        "splitEmpty": "Nothing to receive on this order.",
        "columns": {
          "delivered": "Delivered",
          "accepted": "Accepted",
          "quarantined": "Quarantined",
          "rejected": "Rejected",
          "returned": "Returned",
          "foots": "Foots",
          "inspection": "Inspection"
        },
        "acceptedMeaning": "Received into stock and available to issue.",
        "quarantinedMeaning": "Received into stock and held: on the balance sheet, in GR-IR, and not issuable until released.",
        "rejectedMeaning": "Refused at the dock. Nothing was received, nothing entered GR-IR and no invoice is expected.",
        "footing": {
          "foots": "Foots",
          "short": "{qty} unaccounted for",
          "over": "{qty} more than delivered",
          "invalid": "Not a number"
        },
        "brokenSplit": "{count} lines do not foot. Every delivered unit has to be accounted for as accepted, quarantined or rejected before this receipt can be saved.",
        "splitOk": "Every line foots against what was delivered.",
        "quarantineBanner": "{count} lines are quarantined.",
        "quarantineMeaning": "Quarantined goods have been received: they are on the balance sheet and in GR-IR, and the supplier will invoice for them. What is withheld is the right to issue them.",
        "inspectionBlocking": "{count} quarantined lines are waiting on a blocking inspection and cannot be released until it passes.",
        "noInspection": "No inspection",
        "release": "Release",
        "releaseTitle": "Release from quarantine",
        "releaseDescription": "Move this quantity into accepted stock so it can be issued.",
        "released": "Released into stock",
        "releaseFailed": "The line was not released",
        "reject": "Reject",
        "rejectTitle": "Reject quarantined goods",
        "rejectDescription": "Record that this quantity is refused.",
        "rejected": "Rejected",
        "rejectIsNotAReturn": "Rejecting here records a refusal. It does not send the goods back or unwind the receipt — the goods were received and are in GR-IR, so returning them is a supplier return with its own document and its own debit note.",
        "startReturn": "Return to supplier"
      },
      "returns": {
        "title": "Supplier returns",
        "description": "Goods sent back, and the credit expected for them.",
        "tableTitle": "Returns",
        "caption": "Supplier returns with their reason, value and debit note.",
        "create": "New return",
        "dialogDescription": "A return names the receipt line it reverses, so it draws the layer that receipt created at that layer's own cost.",
        "searchLabel": "Search",
        "searchPlaceholder": "Return or supplier",
        "loadFailed": "The returns did not load",
        "empty": "No supplier returns. One is started from a receipt line, not from a catalogue.",
        "emptyFiltered": "No returns match these filters.",
        "columns": {
          "returnDate": "Return date",
          "debitNote": "Debit note"
        },
        "receiptId": "Receipt",
        "receiptHint": "The receipt these goods arrived on.",
        "carrierRef": "Carrier reference",
        "reasonNote": "Notes",
        "returnQty": "Return",
        "linesCaption": "Receipt lines that still have stock to send back.",
        "linesTitle": "Return lines",
        "linesEmpty": "No lines on this return.",
        "noReturnableLines": "Nothing on this receipt can be returned. A rejected line was never received, so there is nothing to send back.",
        "replacementLabel": "The supplier is sending a replacement",
        "replacementMeaning": "Goods are being replaced rather than refunded.",
        "replacementNoCredit": "Replacement — no credit",
        "replacementNoCreditLong": "A replacement return raises no debit note. The supplier is sending the goods again rather than refunding them, so there is nothing to credit.",
        "saved": "Return created",
        "saveFailed": "The return was not created",
        "subtitle": "To {vendor}",
        "factsTitle": "Return",
        "sourceReceipt": "From receipt",
        "noDebitNoteYet": "Not raised yet",
        "submitted": "Return submitted",
        "submitFailed": "The return was not submitted",
        "approved": "Return approved",
        "rejected": "Return rejected",
        "decideFailed": "The decision was not recorded",
        "despatch": "Despatch",
        "despatched": "Goods despatched",
        "despatchFailed": "The despatch was not recorded",
        "despatchMeaning": "Stock leaves at despatch. Everything before that is paperwork.",
        "approvedNotGone": "Approved, not despatched. The stock is still on hand and still counted.",
        "raiseDebitNote": "Raise debit note",
        "debitNoteRaised": "Debit note raised",
        "debitNoteFailed": "The debit note was not raised",
        "backToList": "Back to supplier returns"
      },
      "suppliers": {
        "title": "Suppliers",
        "description": "Qualification, compliance and criticality — the things a buyer needs before raising an order.",
        "tableTitle": "Suppliers",
        "caption": "Suppliers with their qualification, criticality and screening outcome.",
        "searchLabel": "Search",
        "searchPlaceholder": "Code or name",
        "loadFailed": "The suppliers did not load",
        "empty": "No suppliers yet.",
        "emptyFiltered": "No suppliers match these filters.",
        "notFound": "That supplier was not found, or is outside your scope.",
        "neverScreened": "Never screened",
        "columns": {
          "qualifiedUntil": "Qualified until",
          "screening": "Screening"
        },
        "factsTitle": "Supplier",
        "backToList": "Back to suppliers"
      },
      "documents": {
        "title": "Compliance documents",
        "caption": "Compliance documents with their expiry and verification state.",
        "add": "Add document",
        "dialogDescription": "A blocking document type refuses purchase orders when it is missing or expired.",
        "type": "Document type",
        "reference": "Reference",
        "issuedOn": "Issued",
        "expiresOn": "Expires",
        "expiryHint": "Leave empty for a document that does not lapse.",
        "noExpiry": "No expiry",
        "noExpiryMeaning": "Without an expiry this document never lapses and nothing will chase it.",
        "expiredOn": "Expired {date}",
        "expiresIn": "Expires in {days} days",
        "blocking": "Blocking",
        "blockingHint": "Refuses orders when missing or expired",
        "advisoryHint": "Recorded, does not block",
        "blockingMeaning": "This type blocks: a purchase order for this supplier will be refused while the document is missing or expired.",
        "blockingProblem": "{count} blocking documents are missing or expired. Purchase orders for this supplier will be refused unless overridden.",
        "empty": "No compliance documents recorded.",
        "verify": "Verify",
        "verified": "Document verified",
        "verifyFailed": "The document was not verified",
        "rejectedByReviewer": "Rejected on review",
        "saved": "Document recorded",
        "saveFailed": "The document was not recorded"
      },
      "screening": {
        "title": "Screening history",
        "caption": "Sanctions, PEP, adverse-media and ownership screenings with their evidence.",
        "add": "Record screening",
        "dialogDescription": "Record a screening against a published list, with the evidence that supports the outcome.",
        "manualProvider": "The provider is recorded as `manual`: a person reading a published list. That is a complete screening, and recording it as manual is what keeps it auditable years later.",
        "list": "List",
        "screenedName": "Name screened",
        "country": "Country",
        "outcome": "Outcome",
        "outcomeMeaning": {
          "clear": "No match found",
          "potential_match": "Needs review; blocks nothing",
          "confirmed_match": "A true match on the list",
          "error": "The screening could not be completed"
        },
        "matchCount": "Matches",
        "evidence": "Evidence",
        "evidenceHint": "What was searched, where, and what came back.",
        "reference": "Reference",
        "provider": "Provider",
        "review": "Review",
        "screenedAt": "Screened",
        "absoluteMeaning": "A confirmed sanctions match refuses every purchase order for this supplier and offers no override. Unlike every other supplier refusal, no policy relaxes it.",
        "potentialMeaning": "A potential match routes to review and blocks nothing. Somebody has to decide whether it is the same party.",
        "record": "Record screening",
        "reviewed": "Screening reviewed",
        "reviewFailed": "The review was not recorded",
        "empty": "No screenings recorded.",
        "saved": "Screening recorded",
        "saveFailed": "The screening was not recorded"
      },
      "policy": {
        "title": "Supplier policy",
        "description": "What a supplier problem does to a purchase order.",
        "panelTitle": "Legal entity policy",
        "pickCompany": "Choose a legal entity to see its supplier policy.",
        "loadFailed": "The supplier policy did not load",
        "unqualified": "Unqualified supplier",
        "unqualifiedMeaning": "What happens when a purchase order names a supplier that is not qualified.",
        "expiredDocument": "Expired compliance document",
        "expiredDocumentMeaning": "What happens when a blocking document is missing or lapsed.",
        "unscreened": "Unscreened supplier",
        "unscreenedMeaning": "What happens when a supplier has never been screened, or the screening is stale.",
        "modeMeaning": {
          "block": "Refuse the order; an override is still possible",
          "warn": "Let it through and say so",
          "ignore": "Say nothing"
        },
        "screeningValidityDays": "Screening valid for (days)",
        "requalificationMonths": "Requalify every (months)",
        "sanctionsAbsolute": "None of these dials affects a confirmed sanctions match. That refusal is absolute and offers no override.",
        "saved": "Supplier policy saved",
        "saveFailed": "The supplier policy was not saved"
      },
      "supplierRisk": {
        "title": "Supplier risk",
        "description": "Where the supply base is exposed: documents expiring or expired, and suppliers never screened.",
        "tableTitle": "Suppliers by risk",
        "caption": "Suppliers with their criticality, qualification, document exposure and screening outcome.",
        "loadFailed": "The supplier risk report did not load",
        "singleSource": "Single source",
        "expiredDocuments": "Expired documents",
        "neverScreened": "Never screened",
        "suspended": "Suspended",
        "openSpend": "Open committed",
        "empty": "No suppliers match this view.",
        "expiringDocuments": "Expiring documents",
        "openCapas": "Open CAPAs"
      },
      "contracts": {
        "title": "Contracts",
        "description": "Price agreements, blanket orders and frameworks, and what has been drawn against them.",
        "tableTitle": "Contracts",
        "caption": "Contracts with their kind, window, commitment and draw-down.",
        "create": "New contract",
        "edit": "Edit contract",
        "dialogDescription": "The kind decides what the rest of the document means, so it is chosen once.",
        "kindHint": "Chosen once; it decides whether releases consume anything.",
        "kindMeaning": {
          "price_agreement": "Fixes prices, commits no volume",
          "blanket_order": "Commits volume that releases draw down",
          "framework": "Fixes prices and commits volume across a scope"
        },
        "searchLabel": "Search",
        "searchPlaceholder": "Contract or supplier",
        "loadFailed": "The contracts did not load",
        "empty": "No contracts yet. A contract is what turns a negotiated price into one the system applies by itself.",
        "emptyFiltered": "No contracts match these filters.",
        "draftNo": "Draft",
        "subtitle": "With {vendor}",
        "columns": {
          "window": "Window",
          "committed": "Committed",
          "released": "Released",
          "received": "Received",
          "invoiced": "Invoiced",
          "remaining": "Remaining",
          "minQuantity": "Min quantity",
          "unitPrice": "Unit price",
          "priceBasis": "Basis",
          "leadTime": "Lead time",
          "minShelfLife": "Min shelf life"
        },
        "vendorReference": "Supplier reference",
        "startsOn": "Starts",
        "endsOn": "Ends",
        "noticePeriodDays": "Notice period (days)",
        "renewalTermMonths": "Renewal term (months)",
        "leadTimeDays": "Lead time (days)",
        "autoRenewLabel": "Renews itself unless cancelled",
        "autoRenewMeaning": "The contract extends automatically at the end of its term unless notice is given.",
        "autoRenewOn": "Renews for {months} months, {days} days' notice",
        "autoRenewOff": "Does not renew itself",
        "linesTitle": "Price lines",
        "linesCaption": "Effective-dated contract prices with their quantity breaks.",
        "linesEmpty": "No price lines. This contract commits volume but does not fix a price.",
        "linesMeaning": "Prices are effective-dated and selected by quantity break. A price that changed in April does not restate an order raised in March.",
        "commitmentsTitle": "Commitments",
        "commitmentsEmpty": "This contract commits nothing. Releases against it consume no volume.",
        "commitmentPeriod": "{from} to {to}",
        "gaugeLabel": "{label}: {used} of {total}",
        "overCommitmentBlocks": "Over commitment — further releases are refused",
        "overCommitmentWarns": "Over commitment — releases are allowed and flagged",
        "wholeContract": "Whole contract",
        "scopeTitle": "Scope",
        "scopeMeaning": "What this contract covers. A release outside the scope is refused.",
        "scopeAll": "Everything from this supplier",
        "scopesEmpty": "No scope set.",
        "exclusive": "Exclusive",
        "consumptionTitle": "Consumption",
        "consumptionPending": "Consumption has not been computed yet.",
        "termsTitle": "Terms",
        "window": "Window",
        "notReleasable": "This contract is no longer active. Releases against it are refused.",
        "activate": "Activate",
        "activated": "Contract activated",
        "submitted": "Contract submitted",
        "submitFailed": "The contract was not submitted",
        "rejected": "Contract rejected",
        "decideFailed": "The decision was not recorded",
        "suspend": "Suspend",
        "suspended": "Contract suspended",
        "suspendFailed": "The contract was not suspended",
        "suspendedByUser": "Suspended from the contract screen",
        "saved": "Contract saved",
        "saveFailed": "The contract was not saved",
        "backToList": "Back to contracts"
      },
      "rebates": {
        "title": "Rebates",
        "caption": "Rebate terms with their thresholds and what has accrued.",
        "threshold": "Threshold",
        "rate": "Rate",
        "accrued": "Accrued",
        "settled": "Settled",
        "retrospective": "Retrospective",
        "retrospectiveMeaning": "Restates the whole period when a tier is crossed",
        "empty": "No rebate terms on this contract."
      },
      "releases": {
        "title": "Releases",
        "description": "What has been drawn against this contract, and by which order.",
        "tableTitle": "Releases",
        "caption": "Releases with their order, quantity and value.",
        "loadFailed": "The releases did not load",
        "empty": "Nothing has been released against this contract yet.",
        "noCommitment": "This contract commits no volume, so releases consume nothing.",
        "hardenMeaning": "A release hardens the commitment the contract already made — it is not a second commitment, so the money set aside is the money the order spends.",
        "columns": {
          "no": "No",
          "order": "Order",
          "releasedOn": "Released"
        },
        "backToContract": "Back to the contract"
      },
      "contractExpiry": {
        "title": "Contract renewals",
        "description": "What is ending, and what has to be decided before it does.",
        "tableTitle": "Contracts ending",
        "caption": "Contracts with their end date, notice deadline and renewal behaviour.",
        "loadFailed": "The renewal calendar did not load",
        "horizonLabel": "Horizon",
        "horizon": "Next {days} days",
        "daysToExpiry": "Days to end",
        "daysToNotice": "Days to notice",
        "noticeBy": "Notice by",
        "pastNotice": "{count} contracts are past their notice deadline. Whatever they do next has already been decided.",
        "willRenew": "Renews",
        "willLapse": "Lapses",
        "empty": "No contracts end in the next {days} days.",
        "pastNoticeShort": "Past notice"
      },
      "spend": {
        "title": "Spend analysis",
        "description": "Where the money went, and how much of it was on contract.",
        "tableTitle": "Spend",
        "caption": "Spend by group with its on-contract, maverick and no-contract split.",
        "loadFailed": "The spend analysis did not load",
        "empty": "No spend in this period.",
        "groupByLabel": "Group by",
        "groupBy": {
          "supplier": "Supplier",
          "category": "Category",
          "cost_center": "Cost centre"
        },
        "totalSpend": "Total spend",
        "onContract": "On contract",
        "maverick": "Maverick",
        "noContract": "No contract",
        "noContractMeaning": "Spend with no contract available is shown separately and is not counted as maverick. Buying off-contract where no contract exists is the only thing a buyer could have done.",
        "lineCount": "Lines",
        "drill": "Facts",
        "stageMeaning": {
          "committed": "What was ordered",
          "invoiced": "What was billed",
          "reversed": "Reversals of earlier facts"
        }
      },
      "maverick": {
        "title": "Maverick spend",
        "description": "Bought off a contract that existed.",
        "tableTitle": "Off-contract lines",
        "caption": "Off-contract lines with the contract that should have been used.",
        "loadFailed": "The maverick report did not load",
        "empty": "No maverick spend in this period.",
        "scopeMeaning": "Only lines where a contract was available. Spend with no contract at all is not maverick and is not listed here.",
        "shouldHaveUsed": "Contract available",
        "priceVariance": "Price variance vs contract",
        "classification": "Classification"
      },
      "spendFacts": {
        "title": "Spend facts",
        "description": "The append-only register behind every spend figure.",
        "tableTitle": "Facts",
        "caption": "Spend facts with their stage, classification and sourcing route.",
        "loadFailed": "The spend facts did not load",
        "empty": "No spend facts match these filters.",
        "appendOnly": "Facts are never deleted. A cancellation, a closed line or a reversed receipt writes a negative fact naming the one it reverses, so the register always agrees with the ledger.",
        "stage": "Stage",
        "route": "Route",
        "reverses": "reverses #{id}"
      },
      "exceptions": {
        "title": "Match exceptions",
        "description": "Invoice problems, routed to whoever can answer them.",
        "tableTitle": "Exceptions by cause",
        "loadFailed": "The match exceptions did not load",
        "empty": "No open match exceptions.",
        "notApprovals": "This is not the approvals inbox. An exception has an owner and is investigated; accepting a tolerance breach is a different act, with a different permission, on the match itself.",
        "cause": "Cause",
        "ownerHint": "Routed to the {owner}",
        "owner": "Owner",
        "unowned": "Unassigned",
        "expected": "Expected",
        "actual": "Actual",
        "variance": "Variance",
        "due": "Due",
        "overdue": "Overdue",
        "overdueOnly": "Overdue only",
        "mineOnly": "Mine only",
        "select": "Select exception",
        "previewTitle": "Preview",
        "previewEmpty": "Choose an exception to see it without leaving the list.",
        "openMatch": "Open the match",
        "resolveTitle": "Resolve",
        "resolveMeaning": "Records that this was investigated and what was found. It does not accept a tolerance breach.",
        "resolutionNote": "What you found",
        "resolveOne": "Resolve this one",
        "resolveMany": "Resolve {count} selected",
        "resolved": "Exceptions resolved",
        "resolveFailed": "The exception was not resolved",
        "resolutionActionLabel": "What was decided",
        "resolutionActionHint": "Kept with the resolution. \"Resolved\" on its own does not say whether the invoice was accepted or refused.",
        "goThere": "Go there",
        "closesRefused": "This closes the exception as refused: the invoice is not payable as it stands."
      },
      "causes": {
        "title": "Match causes",
        "description": "Who owns each kind of invoice problem, and how long they have.",
        "tableTitle": "Causes",
        "caption": "Match causes with their owner resolution and SLA.",
        "loadFailed": "The match causes did not load",
        "ownerRole": "Role code",
        "ownerMeaning": {
          "buyer": "The person who raised the order",
          "requester": "The person who asked for it",
          "warehouse_manager": "The manager of the receiving warehouse",
          "role": "Whoever holds the named role",
          "user": "One named person",
          "finance": "The legal entity's finance manager"
        },
        "slaHours": "SLA (hours)",
        "slaMeaning": "The deadline is computed in the tenant's working time, so a 24-hour SLA raised at four on a Friday is due on Monday afternoon rather than on Saturday.",
        "autoResolvable": "Clears itself",
        "autoResolvableYes": "Clears when the cause goes away",
        "saved": "Cause saved",
        "saveFailed": "The cause was not saved"
      },
      "amendments": {
        "title": "Order amendments",
        "description": "Changes to an order after it was issued, including after goods have arrived.",
        "tableTitle": "Amendments",
        "caption": "Amendments with their before and after totals and approval state.",
        "loadFailed": "The amendments did not load",
        "empty": "This order has not been amended.",
        "create": "New amendment",
        "drawerDescription": "Enter only the values that change. Everything left blank stays as it is.",
        "drawerCaption": "Order lines with their ordered and received quantities.",
        "afterReceiptMeaning": "An order can be amended after goods have arrived. What it cannot do is cut a line below what has already been received.",
        "version": "Version",
        "totalBefore": "Before",
        "totalAfter": "After",
        "band": "Authority",
        "crossesBand": "Crosses a band",
        "change": "Change",
        "expectedDate": "Expected",
        "ordered": "Ordered",
        "received": "Received",
        "newQuantity": "New quantity",
        "newPrice": "New price",
        "newDate": "New date",
        "belowReceived": "{count} lines are below what has already been received. The server will refuse the amendment and name the received quantity.",
        "linesCaption": "Amendment lines, before and after.",
        "linesEmpty": "No line changes on this amendment.",
        "apply": "Apply",
        "applied": "Amendment applied",
        "applyFailed": "The amendment was not applied",
        "submitted": "Amendment submitted",
        "submitFailed": "The amendment was not submitted",
        "approved": "Amendment approved",
        "decideFailed": "The decision was not recorded",
        "saved": "Amendment drafted",
        "saveFailed": "The amendment was not saved",
        "backToOrder": "Back to the order"
      },
      "schedule": {
        "title": "Delivery schedule",
        "description": "When each line is expected, in how many drops.",
        "caption": "Delivery rungs with their date and quantity.",
        "loadFailed": "The delivery schedule did not load",
        "empty": "No schedule on this line — the whole quantity is expected on the line's own date.",
        "seq": "No",
        "scheduledDate": "Scheduled",
        "addRung": "Add delivery",
        "foots": "Foots against the line",
        "residual": "{qty} of {ordered} unscheduled",
        "deferredMeaning": "The rungs must sum to the line quantity, and that is checked when the schedule is saved rather than on every keystroke — so a schedule can be edited through states that do not yet foot.",
        "saved": "Delivery schedule saved",
        "saveFailed": "The delivery schedule was not saved"
      },
      "incoterms": {
        "title": "Incoterms",
        "description": "Delivery terms and who bears which cost.",
        "tableTitle": "Incoterms",
        "caption": "Incoterms with their cost responsibilities and risk transfer point.",
        "loadFailed": "The Incoterms did not load",
        "empty": "No Incoterms configured.",
        "costMeaning": "The Incoterm decides whether a separately quoted freight or duty amount is already inside the price. A CIF quote's freight is in the price by definition; an FOB quote's is not — which is what makes a landed-cost comparison trustworthy.",
        "freight": "Freight",
        "insurance": "Insurance",
        "duty": "Duty",
        "riskTransfer": "Risk transfers",
        "namedPlace": "Named place",
        "required": "Required",
        "notRequired": "Not required"
      },
      "rfq": {
        "evaluationTitle": "Evaluating {no}",
        "evaluationDescription": "Criteria, bids, clarifications and the award.",
        "backToRfq": "Back to the tender",
        "loadFailed": "The tender did not load",
        "criteriaTitle": "Criteria",
        "criteriaCaption": "Scoring criteria with their weights, direction and gates.",
        "criteriaEmpty": "No criteria set.",
        "noCriteriaMeaning": "With no criteria the tender scores exactly as it did before, from the three weights on the header.",
        "weight": "Weight",
        "direction": "Direction",
        "lowerIsBetter": "Lower is better",
        "higherIsBetter": "Higher is better",
        "gate": "Gate",
        "gateMeaning": "Excludes rather than scores",
        "sealedTitle": "Sealed",
        "sealedMeaning": "Bids are sealed until {at}. No price has been sent to this screen.",
        "sealLifted": "Deadline passed",
        "openableMeaning": "The deadline has passed, so the tender can now be opened. It is not open until somebody opens it, with a witness, and that act is audited.",
        "bidderCount": "{count} bids received",
        "open": "Open the tender",
        "openTitle": "Open the sealed tender",
        "openDescription": "Two people, one of whom is you.",
        "twoPersonMeaning": "A sealed tender cannot be opened alone. Your witness must be somebody else who also holds the authority to open, and both names are recorded.",
        "witness": "Witness",
        "noWitnessAvailable": "Nobody else holds the authority to open a sealed tender. The tender cannot be opened until a second person is granted it.",
        "cannotOpen": "You do not hold the authority to open a sealed tender.",
        "opened": "Tender opened",
        "openFailed": "The tender was not opened",
        "comparisonTitle": "Comparison",
        "comparisonCaption": "Bids ranked by weighted score, with their landed total.",
        "comparisonEmpty": "No bids to compare.",
        "comparisonFailed": "The comparison did not load",
        "rank": "Rank",
        "total": "Quoted total",
        "landedTotal": "Landed total",
        "lowestLandedTotal": "Lowest landed total",
        "leadTime": "Lead time",
        "score": "Score",
        "late": "Late",
        "lateMeaning": "Late",
        "pick": "Pick",
        "excludedBy": "Excluded by",
        "excludedCaption": "Bidders removed by a gate criterion.",
        "gateExclusionMeaning": "Gates remove bidders before the scores are normalised, so an excluded bid does not stretch the range for everybody else. They are listed rather than scored zero.",
        "clarificationsTitle": "Clarifications",
        "clarificationAnonymity": "Published answers go to every bidder without naming who asked.",
        "clarificationsEmpty": "No clarifications on this tender.",
        "question": "Question",
        "answer": "Answer",
        "saveAnswer": "Save answer",
        "publish": "Publish to all bidders",
        "publishedAt": "Published {at}",
        "record": "Record",
        "clarificationAsked": "Clarification recorded",
        "clarificationAnswered": "Answer saved",
        "clarificationPublished": "Answer published to all bidders",
        "clarificationFailed": "The clarification was not saved",
        "awardTitle": "Award",
        "awardDescription": "Who wins, and why.",
        "pickFirst": "Pick a bid from the comparison first.",
        "rationale": "Rationale",
        "overrideReason": "Override reason",
        "overrideMeaning": "This bid is not ranked first. Awarding it needs a reason, and the reason is kept on the award record permanently.",
        "awardAction": "Award the tender",
        "awarded": "Tender awarded",
        "awardFailed": "The tender was not awarded",
        "awardRecordTitle": "Award record",
        "recommended": "Recommended"
      },
      "resolutionAction": {
        "accept_variance": "Accept the variance",
        "correct_receipt": "Correct the receipt",
        "amend_order": "Amend the order",
        "raise_debit_note": "Raise a debit note",
        "dispute_invoice": "Dispute the invoice",
        "reject_invoice": "Reject the invoice"
      },
      "resolutionActionHint": {
        "accept_variance": "The invoice is right and the difference is within what you may accept.",
        "correct_receipt": "The receipt was wrong, not the invoice.",
        "amend_order": "The order carried the wrong price or quantity.",
        "raise_debit_note": "Over-invoiced, short delivered, or the goods went back.",
        "dispute_invoice": "Held with the supplier told why; payment does not go out.",
        "reject_invoice": "Returned to the supplier as unpayable."
      },
      "resolutionActionNext": {
        "correct_receipt": "The correction is made on the receipt itself.",
        "amend_order": "The amendment is raised on the order, where it is routed for approval if it crosses an authority band.",
        "raise_debit_note": "The debit note is raised with the supplier return.",
        "dispute_invoice": "The dispute is recorded on the match, which holds the invoice.",
        "reject_invoice": "The rejection is recorded on the match, which holds the invoice."
      }
    }
  },
  "crm": {
    "routeTitles": {
      "leads": "Leads",
      "lead": "Lead",
      "opportunities": "Opportunities",
      "opportunity": "Opportunity",
      "cases": "Cases",
      "case": "Case",
      "slaPolicies": "SLA policies and business hours",
      "kbArticles": "Knowledge base",
      "kbArticle": "Knowledge base article",
      "pipelineReport": "Pipeline and win rate",
      "conversionReport": "Lead conversion",
      "serviceReport": "Service and SLA compliance"
    },
    "nav": {
      "label": "CRM sections",
      "leads": "Leads",
      "opportunities": "Opportunities",
      "cases": "Cases",
      "kb": "Knowledge base",
      "slaPolicies": "SLA policies",
      "reports": "Reports"
    },
    "list": {
      "filtersTitle": "Filters",
      "exported": "Exported",
      "exportedDetail": "{count} rows written to a CSV file."
    },
    "leads": {
      "title": "Leads",
      "description": "Everyone who has made contact and is not yet a customer. A lead is checked for duplicates when it is captured, qualified into an opportunity when it is worth working, and converted into a customer exactly once.",
      "tableLabel": "Leads",
      "loadFailed": "Those leads did not load",
      "emptyTitle": "No leads yet",
      "emptyDescription": "Capture the first one, or let the web form and the import bring them in. Every lead is checked against the ones already here as soon as it is saved.",
      "searchHint": "Matches name, company and email. A converted lead keeps the email its customer was created with, so this is also how you find the lead behind a customer.",
      "new": "Capture a lead",
      "newTitle": "Capture a lead",
      "newDescription": "Nothing here blocks on a suspected duplicate. The lead is saved first, and anything it might duplicate is shown afterwards for you to judge.",
      "save": "Save the lead",
      "saving": "Saving the lead",
      "savedTitle": "Lead saved — check these first",
      "savedDescription": "The lead is on file. These existing leads look like they might be the same person.",
      "savedNote": "{name} has been saved.",
      "savedMergeHint": "Open the lead to compare a candidate side by side and decide whether to merge. Nothing is merged until somebody says so.",
      "openCreated": "Open the lead",
      "createdTitle": "Lead captured",
      "createdDetail": "{name} is on file, and nothing already here looks like a duplicate.",
      "createFailed": "That lead was not saved",
      "detailsTitle": "Details",
      "contactHint": "The email and the phone number are what duplicate detection compares.",
      "contactlessWarning": "A lead with no email and no phone number cannot be checked for duplicates at all — there is nothing to compare. It will be saved, and it will never appear as a candidate against anyone.",
      "unassigned": "Unassigned",
      "disqualify": "Disqualify",
      "disqualifyTitle": "Disqualify this lead",
      "disqualifyDescription": "The lead stays on file with the reason recorded. It leaves the funnel; it is not deleted.",
      "disqualifyReason": "Why is this lead not worth working?",
      "disqualifiedTitle": "Lead disqualified",
      "disqualifiedDetail": "It stays on file with the reason recorded.",
      "disqualifyFailed": "That lead was not disqualified",
      "disqualifiedBanner": "Disqualified: {reason}",
      "mergedBanner": "This lead was merged into lead #{id}. Its history moved with it, and this record is now only a pointer.",
      "openSurvivor": "Open the surviving lead",
      "fields": {
        "firstName": "First name",
        "lastName": "Last name",
        "companyName": "Company",
        "title": "Job title",
        "email": "Email",
        "phone": "Phone",
        "source": "Source",
        "owner": "Owner",
        "notes": "Notes",
        "raised": "Captured",
        "score": "Score"
      },
      "statuses": {
        "new": "New",
        "contacted": "Contacted",
        "qualified": "Qualified",
        "converted": "Converted",
        "disqualified": "Disqualified"
      },
      "sources": {
        "web_form": "Web form",
        "import": "Import",
        "api": "API",
        "manual": "Entered by hand",
        "referral": "Referral",
        "event": "Event"
      },
      "rail": {
        "captured": "Captured",
        "converted": "Converted to a customer",
        "merged": "Merged into lead #{id}",
        "customerLink": "The customer this lead became",
        "survivorLink": "Surviving lead #{id}"
      },
      "editTitle": "Edit this lead",
      "editDescription": "Descriptive fields only. Status moves through qualifying, disqualifying, converting and merging — never here.",
      "sourceFixed": "Where a lead came from is a fact about the past and is not editable.",
      "contactChangedNote": "Changing the email or the phone number changes what the duplicate check compares. The candidates on this lead will be re-checked against the new values as soon as this is saved.",
      "savedChangesTitle": "Lead updated",
      "savedChangesDetail": "The duplicate check has been re-run against the new details.",
      "saveFailed": "Those changes were not saved",
      "noScore": "Not scored yet"
    },
    "dedupe": {
      "title": "Might be a duplicate",
      "description": "Existing leads whose email or phone number resembles this one. Nothing here has been merged, and nothing will be until you say so.",
      "loadFailed": "The duplicate check did not run",
      "emptyTitle": "Nothing here looks like a duplicate",
      "emptyDescription": "No other lead's email or phone number is close enough to this one to be worth a second look.",
      "neverAutomatic": "Nothing on this screen merges anything. Merging retires one record into another, moves its whole history, and cannot be undone from this app — so it is always a decision somebody makes, never one the system makes for them.",
      "scoreScale": "trigram score, where 1.00 means the two values are identical",
      "review": "Compare and decide",
      "matchedHere": "matched here",
      "blank": "—",
      "unnamed": "Unnamed lead",
      "candidateRef": "Lead #{id}",
      "tableCaption": "This lead compared with {name}",
      "columns": {
        "field": "Field",
        "thisLead": "This lead",
        "candidate": "Possible duplicate",
        "name": "Name",
        "companyName": "Company",
        "email": "Email",
        "phone": "Phone"
      },
      "bands": {
        "identical": "Identical",
        "close": "Close",
        "partial": "Partial"
      },
      "evidence": {
        "identical": "The {field} is character-for-character the same once normalised. Usually this is the same form submitted twice — but check the name and the company before deciding.",
        "close": "The {field} overlaps heavily but is not the same value. Read both carefully: a typo and a different person can look alike at this score.",
        "partial": "Only part of the {field} overlaps. This can easily be a coincidence — two different phone numbers sharing an area code score like this. Treat it as a prompt to look, not as a finding."
      },
      "fields": {
        "email": "email address",
        "phone": "phone number"
      },
      "matchedOn": {
        "email": "Matched on the email address",
        "phone": "Matched on the phone number"
      },
      "agreement": {
        "same": "same",
        "different": "differs",
        "missing": "not comparable"
      },
      "blocked": {
        "converted": "This lead has already become a customer, so it cannot be retired into another. If the two really are the same person, sort it out on the customer record.",
        "merged": "This lead has already been merged into another one."
      }
    },
    "merge": {
      "title": "Merge two leads",
      "description": "One record is kept and one is retired. Read both before choosing.",
      "leadColumn": "This lead (#{id})",
      "candidateColumn": "Possible duplicate (#{id})",
      "raised": "Captured",
      "consequence": "The retired lead is closed and its whole activity timeline — every call, note and email — moves onto the record you keep. There is no way to separate them again from this app. If these are two different people, do not merge them.",
      "survivorLabel": "Which record do you want to keep?",
      "survivorHint": "The other one is retired. Nothing is chosen for you: the older record often holds the history, the newer one often holds the current phone number.",
      "keepThis": "Keep {name} (lead #{id})",
      "keepCandidate": "Keep {name} (lead #{id})",
      "plan": "{retired} (lead #{id}) will be retired into lead #{surviving}.",
      "confirmLabel": "These two records are the same person.",
      "confirmDescription": "You are asserting this, not confirming a suggestion. The score above is evidence, not a decision.",
      "confirm": "Merge them",
      "merging": "Merging",
      "doneTitle": "Leads merged",
      "doneDetail": "Lead #{retired} was retired into lead #{surviving}, and its history moved with it.",
      "refusedChain": "The record you chose to keep has itself been merged into another lead. Merge into that one instead.",
      "refusedAlreadyMerged": "That lead has already been merged — somebody else got there first. Reload to see where it went.",
      "blocked": {
        "converted": "That record has already become a customer and cannot be retired. Choose the other direction, or leave both as they are.",
        "merged": "That record has already been merged into another lead."
      }
    },
    "qualify": {
      "action": "Qualify",
      "title": "Qualify this lead",
      "description": "Qualifying marks the lead qualified and raises the opportunity it becomes, in one step.",
      "oneStep": "Both happen together and cannot come apart: the lead is marked qualified and the opportunity is created in the same transaction.",
      "nameHint": "Leave it as it is unless the deal has a name of its own.",
      "probabilityHint": "Leave blank to take the stage's own probability.",
      "firstStage": "The first stage in the pipeline",
      "confirm": "Qualify and raise the opportunity",
      "qualifying": "Qualifying",
      "doneTitle": "Opportunity raised",
      "doneDetail": "{name} is now in the pipeline.",
      "failed": "That lead was not qualified"
    },
    "convert": {
      "action": "Convert to a customer",
      "title": "Convert this lead into a customer",
      "description": "A customer record will be created for {name}.",
      "onceOnly": "A lead converts to a customer once and only once. The customer is created in the same transaction as this lead's status change — either both happen or neither does — and this action will not be offered again afterwards.",
      "confirm": "Create the customer",
      "converting": "Creating the customer",
      "doneTitle": "Customer created",
      "doneDetail": "Customer {code} has been created and the lead is marked converted.",
      "failed": "That lead was not converted",
      "refusedAlreadyConverted": "This lead has already become a customer — somebody else converted it while this was open. Reload to see which customer it became.",
      "refusedNotQualified": "Only a qualified lead can convert. Qualify it first.",
      "convertedTitle": "Converted to a customer",
      "convertedNote": "This lead became a customer. It cannot be converted again — a lead has exactly one customer, and that relationship is what links the two records in both directions.",
      "convertedAt": "Converted",
      "customer": "Customer",
      "customerRef": "Customer #{id}",
      "fields": {
        "customerCode": "Customer code",
        "customerCodeHint": "Required — accounts receivable has no numbering series for customer codes, so this is the code that will appear on every invoice and statement.",
        "paymentTerms": "Payment terms (days)",
        "creditLimit": "Credit limit",
        "creditLimitCurrency": "Limit currency",
        "portalAccess": "Give this customer portal access",
        "portalAccessHint": "They will be able to sign in to see their orders, invoices and cases."
      },
      "unavailable": {
        "converted": "Already a customer.",
        "merged": "A merged lead cannot be converted — act on the surviving record.",
        "not_qualified": "Qualify this lead before converting it."
      }
    },
    "activities": {
      "title": "History",
      "loadFailed": "The history did not load",
      "deniedTitle": "You cannot read this history",
      "deniedDescription": "Reading a record's activity timeline needs its own permission. Ask an administrator if you need it.",
      "emptyTitle": "Nothing has happened yet",
      "emptyDescription": "Calls, notes, emails and meetings logged here follow this record — through qualification, and through a merge.",
      "kindLabel": "Kind",
      "subjectLabel": "Subject",
      "bodyLabel": "What happened",
      "log": "Log it",
      "logging": "Logging",
      "failed": "That entry was not logged",
      "internalOnly": "Logged internally. It is not sent to anybody.",
      "public": "Sent to the customer",
      "kinds": {
        "note": "Note",
        "call": "Call",
        "email": "Email",
        "meeting": "Meeting",
        "task": "Task",
        "status_change": "Status change",
        "system": "System"
      },
      "authors": {
        "system": "System",
        "customer": "Customer",
        "user": "A colleague"
      }
    },
    "opportunities": {
      "title": "Opportunities",
      "description": "Deals in the pipeline, what each is worth, and what it is worth weighted by the chance of closing.",
      "tableLabel": "Opportunities",
      "loadFailed": "Those opportunities did not load",
      "emptyTitle": "No opportunities yet",
      "emptyDescription": "Qualify a lead to raise the first one, or create one against an existing customer as an upsell.",
      "new": "New opportunity",
      "newTitle": "New opportunity",
      "newDescription": "For an upsell against a customer you already have. An opportunity that comes from a lead is raised by qualifying that lead.",
      "saving": "Saving",
      "createdTitle": "Opportunity created",
      "createdDetail": "{name} is now in the pipeline.",
      "createFailed": "That opportunity was not created",
      "noCustomer": "No customer yet",
      "openOnly": "Open deals only",
      "seePipeline": "See the pipeline report",
      "valueTitle": "What it is worth",
      "weightedNote": "The weighted value is the amount multiplied by the probability, computed and rounded by the database. It is never recalculated on this screen, so the figure here and the figure on the pipeline report cannot drift apart.",
      "open": "Open",
      "won": "Won",
      "lost": "Lost",
      "moveTo": "Move to stage",
      "moveStage": "Move stage",
      "stageMoved": "Stage changed",
      "stageFailed": "That stage change was refused",
      "markWon": "Mark as won",
      "markLost": "Mark as lost",
      "wonTitle": "Deal won",
      "wonDetail": "Sales has been told, so a quote or an order can be built against it.",
      "lostTitle": "Deal lost",
      "lostDetail": "The reason is on the record.",
      "closeFailed": "That deal was not closed",
      "loseTitle": "Mark this deal lost",
      "loseDescription": "A reason is required — it is what makes the win-rate report worth reading.",
      "loseReason": "Why was it lost?",
      "lostBanner": "Lost: {reason}",
      "closedNote": "This deal is closed. Reopening is not something this screen does; raise a new opportunity instead.",
      "fromLead": "Raised from",
      "fields": {
        "name": "Name",
        "customer": "Customer",
        "company": "Company",
        "amount": "Amount",
        "currency": "Currency",
        "probability": "Probability",
        "probabilityShort": "Prob.",
        "weighted": "Weighted",
        "expectedClose": "Expected close",
        "stage": "Stage",
        "forecastCategory": "Forecast category"
      },
      "rail": {
        "raised": "Raised",
        "leadLink": "Lead #{id}",
        "customerLink": "Customer record"
      },
      "noForecastCategory": "None set",
      "forecastCategorySet": "Forecast category updated",
      "forecastCategoryFailed": "That forecast category was not saved",
      "competitorsTitle": "Competitors",
      "competitorsDescription": "Competing suppliers known on this deal, and who is currently winning.",
      "competitorsEmptyTitle": "No competitors recorded",
      "competitorsEmptyDescription": "Record one when a competing supplier shows up in the pursuit.",
      "recordCompetitor": "Record competitor",
      "recordCompetitorDescription": "Add a competing supplier to this deal's landscape.",
      "competitorField": "Competitor",
      "competitorWinning": "Currently winning",
      "competitorNote": "Note",
      "competitorAdded": "Competitor recorded",
      "competitorAddFailed": "That competitor was not recorded",
      "removeCompetitor": "Remove",
      "competitorRemoved": "Competitor removed",
      "competitorRemoveFailed": "That competitor was not removed",
      "winTitle": "Mark this deal won",
      "winDescription": "The reason is optional, but recording it is what makes the win-rate report worth reading.",
      "closeReason": "Close reason",
      "closeReasonPlaceholder": "No structured reason",
      "closeNote": "Note",
      "closeNoteRequiredHint": "This close reason requires a note.",
      "lossCompetitor": "Lost to",
      "lossCompetitorHint": "This close reason requires the competitor."
    },
    "cases": {
      "title": "Cases",
      "description": "Everything a customer has asked for help with, and how the clock is running on each.",
      "tableLabel": "Cases",
      "loadFailed": "Those cases did not load",
      "emptyTitle": "No cases yet",
      "emptyDescription": "Cases arrive from the portal, by email, or are raised here by hand. Each one starts its response and resolution clocks the moment it is raised.",
      "raise": "Raise a case",
      "raising": "Raising the case",
      "newTitle": "Raise a case",
      "newDescription": "The case number and both SLA deadlines are assigned as soon as this is saved. Neither deadline can be changed afterwards.",
      "createdTitle": "Case raised",
      "createdDetail": "{no} is open and its clocks are running.",
      "createFailed": "That case was not raised",
      "detailsTitle": "Details",
      "openOnly": "Open cases only",
      "unassigned": "Unassigned",
      "noCustomer": "No customer",
      "noPolicy": "No policy",
      "priorityHint": "Priority decides which SLA policy governs this case, and the deadlines it sets cannot be changed later.",
      "policyPreview": "\"{policy}\" promises a first response within {response} minutes and a resolution within {resolution} minutes.",
      "noPolicyForPriority": "No active default SLA policy is configured for this priority, so the server will refuse to raise the case at all — it has no deadlines to promise. Set a default policy for this priority first, or choose another priority.",
      "seePolicies": "See the policies",
      "assign": "Assign",
      "assignedTitle": "Case assigned",
      "assignFailed": "That case was not assigned",
      "replyTitle": "Reply to the customer",
      "replyNote": "The first public reply is what satisfies the response SLA. An internal note in the history below does not stop that clock.",
      "replyLabel": "Your reply",
      "replyPublic": "Send this to the customer",
      "replyPublicHint": "A public reply is visible on the portal and stops the response clock.",
      "replyPrivateHint": "Untick to record the reply without sending it — the response clock keeps running.",
      "reply": "Send the reply",
      "replying": "Sending",
      "repliedTitle": "Reply recorded",
      "repliedDetail": "The response clock has been answered.",
      "replyFailed": "That reply was not recorded",
      "resolve": "Resolve",
      "resolveTitle": "Resolve this case",
      "resolveDescription": "The resolution clock stops here. The case stays open to the customer until it is closed.",
      "resolutionLabel": "How was it resolved?",
      "resolvedTitle": "Case resolved",
      "resolvedDetail": "The resolution clock has stopped.",
      "resolveFailed": "That case was not resolved",
      "close": "Close",
      "closedTitle": "Case closed",
      "closedDetail": "It is off the queue.",
      "closeFailed": "That case was not closed",
      "reopen": "Reopen",
      "reopenTitle": "Reopen this case",
      "reopenDescription": "A reason is required, and it goes on the record.",
      "reopenReason": "Why is it being reopened?",
      "reopenKeepsDeadlines": "Reopening does not move the original deadlines. The promise made when this case was raised is the promise that gets measured — including any breach already recorded against it.",
      "reopenedTitle": "Case reopened",
      "reopenedDetail": "The original deadlines are unchanged.",
      "reopenFailed": "That case was not reopened",
      "reopenedBanner": "This case has been reopened {count} time. | This case has been reopened {count} times.",
      "escalatedBanner": "This case was escalated to the policy's escalation contact on",
      "csatSectionTitle": "Customer satisfaction",
      "csatAsk": "Was the customer satisfied?",
      "csatYes": "Satisfied",
      "csatNo": "Not satisfied",
      "csatOnce": "Recorded once and never edited.",
      "csatTitle": "Recorded",
      "csatDetail": "It feeds the CSAT report.",
      "csatFailed": "That was not recorded",
      "csatSatisfied": "The customer was satisfied",
      "csatUnsatisfied": "The customer was not satisfied",
      "fields": {
        "caseNo": "Case",
        "subject": "Subject",
        "description": "What happened",
        "priority": "Priority",
        "origin": "Came in by",
        "category": "Category",
        "customer": "Customer",
        "assignee": "Assigned to",
        "contactName": "Contact",
        "contactEmail": "Contact email",
        "contactPhone": "Contact phone",
        "slaPolicy": "SLA policy"
      },
      "statuses": {
        "new": "New",
        "open": "Open",
        "pending": "Waiting",
        "resolved": "Resolved",
        "closed": "Closed"
      },
      "priorities": {
        "low": "Low",
        "medium": "Medium",
        "high": "High",
        "urgent": "Urgent"
      },
      "origins": {
        "portal": "Portal",
        "email": "Email",
        "manual": "Raised by hand"
      },
      "rail": {
        "raised": "Raised",
        "firstResponse": "First reply to the customer",
        "escalated": "Escalated",
        "resolved": "Resolved",
        "closed": "Closed",
        "customerLink": "Customer record",
        "otherCases": "This customer's other cases"
      }
    },
    "sla": {
      "title": "SLA policies and business hours",
      "description": "What each priority promises, and which hours are counted towards it.",
      "loadFailed": "Those policies did not load",
      "policiesTitle": "Policies",
      "policyDescription": "A policy governs every case raised at its priority, from the moment that case is raised.",
      "newPolicy": "New policy",
      "editPolicy": "Edit policy",
      "policySavedTitle": "Policy saved",
      "policySavedDetail": "It governs cases raised from now on.",
      "policySaveFailed": "That policy was not saved",
      "editingNote": "Editing a policy does not move any existing case's deadlines. Those were computed once, when each case was raised, and are deliberately never recalculated.",
      "default": "Default",
      "defaultLabel": "Use this policy when no other one matches",
      "active": "Active",
      "inactive": "Inactive",
      "activeLabel": "Active",
      "minutes": "{count} min",
      "minutesHint": "In minutes.",
      "businessHoursLabel": "Count business hours only",
      "businessHoursHint": "Counts only the minutes that fall inside the weekly window below. Leave this off and the deadline is plain wall-clock time — nights and weekends included.",
      "countingBusiness": "Business hours",
      "countingWallClock": "Wall clock",
      "escalationHint": "Notified when a case under this policy breaches, on top of the assignee.",
      "escalationUser": "User #{id}",
      "noEscalation": "Nobody",
      "columns": {
        "name": "Policy",
        "response": "First response",
        "resolution": "Resolution",
        "counting": "Counting",
        "escalation": "Escalates to"
      },
      "hoursTitle": "Business hours",
      "hoursDescription": "The weekly working window a business-hours policy counts. It is the only calendar in this system.",
      "hoursTimezoneNote": "Times are in this tenant's own timezone.",
      "hoursSavedTitle": "Business hours saved",
      "hoursSavedDetail": "They apply to deadlines computed from now on.",
      "hoursInvalid": "{day} needs a start and an end, with the end after the start.",
      "from": "From",
      "to": "To",
      "closedDay": "Closed",
      "runSweep": "Run the breach sweep",
      "sweeping": "Sweeping",
      "sweptTitle": "Sweep finished",
      "sweptDetail": "{response} response breaches and {resolution} resolution breaches recorded, {escalations} escalations sent.",
      "sweepFailed": "The sweep did not run",
      "dueAt": "Due",
      "recordedAt": "Breach recorded",
      "notYetSwept": "This deadline has passed but no breach has been recorded yet — the sweep has not run since. Nobody has been notified and nothing has been escalated.",
      "kinds": {
        "response": "First response",
        "resolution": "Resolution"
      },
      "answered": {
        "response": "Replied",
        "resolution": "Resolved"
      },
      "states": {
        "met": "Met",
        "missed": "Missed",
        "breached": "Breached",
        "overdue": "Past due",
        "atRisk": "At risk",
        "pending": "On track",
        "none": "No SLA"
      },
      "leftInDays": "{days}d {hours}h left",
      "leftInHours": "{hours}h {minutes}m left",
      "leftInMinutes": "{minutes}m left",
      "pastByDays": "{days}d {hours}h past due",
      "pastByHours": "{hours}h {minutes}m past due",
      "pastByMinutes": "{minutes}m past due",
      "caveats": {
        "businessHours": "This deadline counts only the hours inside the tenant's weekly working window. That window is the only calendar this system has — there is no holiday calendar anywhere in this build — so a deadline spanning a public holiday falls earlier than it would if somebody counted business hours by hand.",
        "wallClock": "This deadline is plain wall-clock time from the moment the case was raised: nights, weekends and public holidays all count towards it.",
        "noPolicy": "No SLA policy governed this case, so no deadline was ever promised and nothing is being measured."
      },
      "weekdays": {
        "0": "Sunday",
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday"
      }
    },
    "kb": {
      "title": "Knowledge base",
      "description": "The answers people reach for while a case is open. Searching reads the whole article, not just its title.",
      "loadFailed": "The knowledge base did not load",
      "new": "Write an article",
      "newTitle": "Write an article",
      "newDescription": "It is saved as a draft. Only people who can manage the knowledge base see a draft; publishing is what makes it available to everyone answering cases.",
      "saveDraft": "Save as a draft",
      "createdTitle": "Draft saved",
      "createdDetail": "Publish it when it is ready to be relied on.",
      "createFailed": "That article was not saved",
      "savedTitle": "Article saved",
      "savedDetail": "The changes are live.",
      "saveFailed": "Those changes were not saved",
      "publish": "Publish",
      "publishedTitle": "Article published",
      "publishedDetail": "Everyone answering cases can now find it.",
      "publishFailed": "That article was not published",
      "archive": "Archive",
      "archivedTitle": "Article archived",
      "archivedDetail": "It stays searchable to editors and disappears from everyone else's results.",
      "archiveFailed": "That article was not archived",
      "draftNote": "This is a draft. Nobody without knowledge base permissions can read it, and it does not appear in anybody else's search results.",
      "archivedNote": "This article is archived. It is out of circulation but not deleted — publish it again to bring it back.",
      "backToList": "All articles",
      "searchLabel": "Search",
      "searchHint": "A full-text search over the title, the category and the body. Words inside an article will find it.",
      "modeBrowse": "Browsing every article, newest first. Type a search to rank them by how well they match.",
      "modeSearch": "Ranked full-text results for \"{q}\" — the whole body is searched, not just the title.",
      "rank": "Rank",
      "noMatchTitle": "Nothing matched",
      "noMatchDescription": "No article contains \"{q}\" in its title, category or body. Try fewer words.",
      "emptyTitle": "The knowledge base is empty",
      "emptyDescription": "Write the first article. An answer written once while a case is fresh saves the same answer being reconstructed a dozen times.",
      "byline": "Written by {author} on",
      "slugHint": "Leave blank and one is made from the title.",
      "tagsHint": "Separated by commas.",
      "bodyHint": "Every word in here is searchable.",
      "fields": {
        "title": "Title",
        "slug": "Slug",
        "category": "Category",
        "tags": "Tags",
        "body": "Article"
      },
      "statuses": {
        "draft": "Draft",
        "published": "Published",
        "archived": "Archived"
      },
      "rail": {
        "written": "Written",
        "published": "Published",
        "allArticles": "All articles"
      }
    },
    "reports": {
      "loadFailed": "That report did not load",
      "from": "From",
      "to": "To",
      "rangeNote": "Dates are business dates in this tenant's own timezone.",
      "share": "Share",
      "shareOf": "Share of the pipeline held by {stage}",
      "deals": "Deals",
      "pipelineTitle": "Pipeline and win rate",
      "pipelineDescription": "What is in the pipeline now, by stage, and how much of what used to be in it actually landed.",
      "byStage": "By stage",
      "totalPipeline": "Pipeline",
      "totalPipelineHelp": "The sum of every open deal's amount, as the server computed it.",
      "totalWeighted": "Weighted pipeline",
      "totalWeightedHelp": "Each deal's amount multiplied by its probability, summed by the database. Never recalculated in the browser.",
      "currencyNote": "Amounts are summed as they were entered, without currency conversion. If deals are being written in more than one currency, read these totals per currency rather than as one figure — converting a group into one currency is what consolidation does, and it is not what this report does.",
      "winRateTitle": "Win rate",
      "winRateDescription": "Over deals closed between {from} and {to}.",
      "winRateByCount": "Win rate by count",
      "winRateByCountHelp": "Deals won as a share of deals closed in the range.",
      "winRateByAmount": "Win rate by amount",
      "winRateByAmountHelp": "Value won as a share of value closed. It differs from the count whenever the deals that land are not the average size.",
      "wonCount": "Won",
      "lostCount": "Lost",
      "wonAmount": "Value won",
      "lostAmount": "Value lost",
      "conversionTitle": "Lead conversion",
      "conversionDescription": "How many captured leads went on to become customers, and where they came from.",
      "conversionMeaning": "\"Converted\" here means the lead became a customer record — not that it was qualified, and not that a deal was won. A lead with a large open opportunity still counts as unconverted.",
      "leadsCaptured": "Leads captured",
      "leadsConverted": "Became customers",
      "conversionRate": "Conversion rate",
      "conversionRateHelp": "Converted leads as a share of leads captured in the range, computed by the server.",
      "bySource": "By source",
      "noLeadsInRange": "No leads were captured in this range.",
      "serviceTitle": "Service and SLA compliance",
      "serviceDescription": "Case volume, how often the promised deadlines were met, and what customers said afterwards.",
      "casesCreated": "Raised",
      "casesResolved": "Resolved",
      "casesClosed": "Closed",
      "slaComplianceTitle": "SLA compliance",
      "responseCompliance": "First response within the deadline",
      "resolutionCompliance": "Resolved within the deadline",
      "overCases": "({met} of {total} cases with a deadline)",
      "complianceHolidayCaveat": "At least one active policy counts business hours. Business hours are a weekly recurring window and nothing else — this system has no holiday calendar — so any deadline that spanned a public holiday was set earlier than a person counting business hours by hand would have set it, and compliance measured against it is correspondingly harsh.",
      "avgFirstResponse": "Average first response",
      "avgResolution": "Average resolution",
      "hoursMinutes": "{hours}h {minutes}m",
      "minutesOnly": "{minutes}m",
      "csatTitle": "Customer satisfaction",
      "csatDescription": "The thumbs recorded against resolved cases in the range.",
      "csatRate": "Satisfied",
      "csatRateHelp": "As a share of cases that got a response, not of cases raised.",
      "csatResponses": "Responses",
      "csatSatisfied": "Said satisfied",
      "csatNoResponses": "Nobody has rated a case in this range, so there is no satisfaction figure to read."
    },
    "c5": {
      "routeTitles": {
        "accounts": "Accounts",
        "account": "Account",
        "catalogues": "Account catalogues",
        "contacts": "Contacts",
        "contact": "Contact",
        "segments": "Marketing segments",
        "segment": "Segment builder",
        "campaigns": "Campaigns",
        "campaign": "Campaign",
        "send": "Send",
        "sendDetail": "Send",
        "forecast": "Forecast",
        "winLoss": "Win/loss",
        "scoring": "Lead scoring",
        "routing": "Lead routing"
      },
      "nav": {
        "label": "CRM sections",
        "accounts": "Accounts",
        "contacts": "Contacts",
        "catalogues": "Catalogues",
        "segments": "Segments",
        "campaigns": "Campaigns",
        "forecast": "Forecast",
        "winLoss": "Win/loss",
        "scoring": "Scoring",
        "routing": "Routing"
      },
      "accountType": {
        "customer": "Customer",
        "prospect": "Prospect",
        "partner": "Partner",
        "competitor": "Competitor",
        "supplier": "Supplier",
        "other": "Other"
      },
      "accountStatus": {
        "active": "Active",
        "inactive": "Inactive",
        "archived": "Archived"
      },
      "contactStatus": {
        "active": "Active",
        "inactive": "Inactive",
        "left_company": "Left the company"
      },
      "campaignStatus": {
        "draft": "Draft",
        "scheduled": "Scheduled",
        "sending": "Sending",
        "sent": "Sent",
        "paused": "Paused",
        "cancelled": "Cancelled",
        "completed": "Completed"
      },
      "sendStatus": {
        "preparing": "Preparing",
        "ready": "Ready",
        "sending": "Sending",
        "completed": "Completed",
        "failed": "Failed",
        "cancelled": "Cancelled"
      },
      "recipientState": {
        "sent": "Sent",
        "excluded": "Excluded",
        "failed": "Failed"
      },
      "exclusion": {
        "no_consent_record": "No consent record",
        "consent_withdrawn": "Consent withdrawn",
        "consent_expired": "Consent expired",
        "consent_pending": "Awaiting confirmation",
        "suppressed": "Address suppressed",
        "no_destination": "No address on file",
        "party_erased": "Party erased",
        "party_inactive": "Party blocked or inactive",
        "segment_excluded": "Pinned out of the segment",
        "unknown": "Unrecognised reason: {reason}"
      },
      "responseKind": {
        "replied": "Replied",
        "enquiry": "Enquiry",
        "meeting": "Meeting",
        "unsubscribed": "Unsubscribed",
        "complained": "Complained",
        "purchased": "Purchased",
        "declined": "Declined"
      },
      "segmentField": {
        "party_kind": "Party kind",
        "party_country_code": "Party country",
        "account_segment_code": "Account segment",
        "account_owner_user_id": "Account owner",
        "opportunity_stage_code": "Opportunity stage",
        "customer_has_posted_invoice_since": "Has a posted invoice since",
        "lead_score_band": "Lead score band",
        "campaign_received_since": "Received a campaign since"
      },
      "segmentOp": {
        "eq": "is",
        "neq": "is not",
        "in": "is one of",
        "not_in": "is none of",
        "gte": "on or after",
        "lte": "on or before",
        "is_true": "is true",
        "is_false": "is false",
        "contains": "contains"
      },
      "scoreField": {
        "source": "Lead source",
        "company_name_present": "Has a company name",
        "email_domain_kind": "Email domain",
        "has_phone": "Has a phone number",
        "country_code": "Country",
        "campaign_response": "Responded to a campaign",
        "activity_count_7d": "Activities in the last 7 days",
        "title_seniority": "Title seniority",
        "account_segment": "Account segment"
      },
      "scoreBand": {
        "hot": "Hot",
        "warm": "Warm",
        "cold": "Cold"
      },
      "account": {
        "title": "Accounts",
        "description": "The relationship record. An account is not a customer — they join through a party.",
        "notCustomerNote": "Six resorts billed centrally are one customer and seven accounts. A prospect that has never bought anything is an account and no customer. The two join only through a party.",
        "create": "New account",
        "created": "Account created",
        "createTitle": "New account",
        "createDescription": "Attach to an identity that already exists, or let one be created from the name.",
        "searchPlaceholder": "Name or industry",
        "anyType": "Any type",
        "anyStatus": "Any status",
        "anySegment": "Any segment",
        "name": "Name",
        "type": "Type",
        "status": "Status",
        "segment": "Segment",
        "owner": "Owner",
        "annualRevenue": "Annual revenue",
        "employeeCount": "Employees",
        "industry": "Industry",
        "territory": "Territory",
        "website": "Website",
        "noSegment": "No segment",
        "noRole": "No role",
        "findIdentity": "Find an existing identity",
        "identity": "Identity",
        "newIdentity": "Create a new identity",
        "identityHint": "Choosing an existing identity is what stops a prospect who was already a lead becoming a second person.",
        "openIdentity": "Open the identity",
        "emptyTitle": "No accounts yet",
        "emptyDescription": "An account is where a relationship is managed — create one, or convert a qualified lead.",
        "tabsLabel": "Account sections",
        "tabContacts": "Contacts",
        "tabHierarchy": "Hierarchy",
        "tabDetails": "Details",
        "contactsEmptyTitle": "No contacts attached",
        "contactsEmptyDescription": "Attach a contact and give them a role — decision maker, billing, technical.",
        "attachContact": "Attach contact",
        "attachTitle": "Attach a contact",
        "attachDescription": "The contact must already exist. One contact may hold roles at several accounts.",
        "findContact": "Find a contact",
        "contact": "Contact",
        "role": "Role",
        "contactAttached": "Contact attached",
        "contactDetached": "Contact detached",
        "detach": "Detach",
        "primaryContact": "Primary",
        "hierarchyNote": "A group and its members. Re-parenting is cycle-checked, and the refusal names the path.",
        "reparent": "Re-parent",
        "reparentTitle": "Move this account",
        "reparentDescription": "A cycle is refused and the message names the path it would have made.",
        "reparented": "Account moved",
        "parent": "New parent",
        "findParent": "Find an account",
        "detachToRoot": "No parent (top level)",
        "parentIs": "Part of {name}"
      },
      "contact": {
        "title": "Contacts",
        "description": "People at accounts. One contact per identity, however many accounts they serve.",
        "onePerPartyNote": "A person who is a contact at three accounts is one contact with three roles. That is what lets a withdrawal, a suppression and a data-subject request reach all three at once.",
        "create": "New contact",
        "created": "Contact created",
        "createTitle": "New contact",
        "createDescription": "Attach to an existing identity, or supply a name and one will be created.",
        "searchPlaceholder": "Name",
        "anyStatus": "Any status",
        "name": "Name",
        "givenName": "Given name",
        "familyName": "Family name",
        "email": "Email",
        "phone": "Phone",
        "jobTitle": "Job title",
        "department": "Department",
        "status": "Status",
        "notes": "Notes",
        "contactDetailsHint": "Used once, to seed the identity this call may create. Afterwards it is edited on the party.",
        "detailsLiveOnParty": "Name, email and phone live on the identity — correcting them there corrects them everywhere.",
        "findIdentity": "Find an existing identity",
        "identity": "Identity",
        "newIdentity": "Create a new identity",
        "identityHint": "If this person is already a lead or a customer contact, pick them here rather than creating a second identity.",
        "openIdentity": "Open the identity",
        "detailsTitle": "Details",
        "saved": "Contact saved",
        "accountsTitle": "Accounts",
        "accountsDescription": "Every account this person is attached to.",
        "accountsEmptyTitle": "Not attached to an account",
        "accountsEmptyDescription": "Attach this contact from an account's own screen.",
        "consentTitle": "Consent",
        "consentDescription": "What this person has agreed to, as at today.",
        "consentEmptyTitle": "Nothing recorded",
        "consentEmptyDescription": "No consent has been captured for this person on any channel.",
        "openMatrix": "Open the full matrix",
        "emptyTitle": "No contacts yet",
        "emptyDescription": "A contact is a person at an account. Create one, or convert a lead."
      },
      "catalogue": {
        "title": "Account catalogues",
        "description": "How accounts are classified, and what a contact can be at one.",
        "segments": "Account segments",
        "roles": "Contact roles",
        "code": "Code",
        "name": "Name",
        "flags": "Flags",
        "active": "Active",
        "activate": "Activate",
        "deactivate": "Deactivate",
        "yes": "Yes",
        "no": "No",
        "addSegment": "Add segment",
        "segmentAdded": "Segment added",
        "segmentDescription": "Description",
        "addRole": "Add role",
        "roleAdded": "Role added",
        "roleFlagsNote": "A campaign that targets decision makers and an invoice that needs a billing contact both ask this catalogue. The flags are read, not decoration.",
        "decisionMaker": "Decision maker",
        "billing": "Billing",
        "segmentsEmptyTitle": "No segments",
        "segmentsEmptyDescription": "Key account, SME, government — whatever your sales team actually says.",
        "rolesEmptyTitle": "No roles",
        "rolesEmptyDescription": "Decision maker, billing contact and technical contact are the usual three."
      },
      "segment": {
        "title": "Marketing segments",
        "description": "Who a campaign goes to — a hand-picked list, or a filter.",
        "rebuildNote": "A send rebuilds its audience and runs the consent gate over it. The count below is what the last build matched, not what the next send will reach.",
        "create": "New segment",
        "created": "Segment created",
        "createTitle": "New segment",
        "createDescription": "A criteria segment evaluates a filter; a static one is a list you curate.",
        "searchPlaceholder": "Code or name",
        "anyKind": "Any kind",
        "kind": "Kind",
        "kindStatic": "Static",
        "kindCriteria": "Criteria",
        "kindStaticHint": "You add and remove members by hand.",
        "kindCriteriaHint": "Members are whoever matches the filter when it is built.",
        "code": "Code",
        "name": "Name",
        "lastBuiltCount": "Matched last build",
        "lastBuiltAt": "Last built",
        "neverBuilt": "Never built",
        "builtAtCount": "{count} matched at {at}",
        "active": "Active",
        "activeYes": "Active",
        "activeNo": "Inactive",
        "emptyTitle": "No segments",
        "emptyDescription": "A segment is what a campaign sends to. Create one to begin.",
        "criteriaTitle": "Criteria",
        "criteriaDescription": "Only the fields on the whitelist can be filtered on, and only the ones you have permission to read.",
        "criteriaSaved": "Criteria saved",
        "saveCriteria": "Save criteria",
        "allTitle": "Match all of",
        "allDescription": "Every rule here must be true.",
        "noneTitle": "Match none of",
        "noneDescription": "Anyone matching a rule here is left out.",
        "addRule": "Add rule",
        "build": "Build",
        "buildSummary": "{count} member(s) at {at} — {added} added, {removed} removed.",
        "membersTitle": "Members",
        "membersDescription": "Who the last build matched, and who was pinned out.",
        "membersEmptyTitle": "No members",
        "membersEmptyDescription": "Build the segment, or add members by hand.",
        "excluded": "Excluded",
        "showExcluded": "Show excluded only",
        "showAll": "Show all"
      },
      "campaign": {
        "title": "Campaigns",
        "description": "What is sent, to whom, and under which purpose.",
        "create": "New campaign",
        "created": "Campaign created",
        "createTitle": "New campaign",
        "createDescription": "A campaign must name a purpose and a channel — the consent gate has no question to ask without them.",
        "searchPlaceholder": "Name or code",
        "anyStatus": "Any status",
        "name": "Name",
        "code": "Code",
        "channel": "Channel",
        "purpose": "Purpose",
        "purposeHint": "The gate asks whether each subject agreed to THIS purpose on THIS channel.",
        "essential": "Essential purpose",
        "essentialHint": "Permitted without a grant.",
        "essentialWarning": "An essential purpose is permitted without consent, because its lawful basis is not consent. Choosing one for marketing sends to people who refused it.",
        "budget": "Budget",
        "budgetHint": "A planning figure for the ROI report. Actual spend arrives as AP invoices and is not intercepted here.",
        "targetRevenue": "Target revenue",
        "status": "Status",
        "approved": "Approved",
        "notApproved": "Not approved",
        "isApproved": "Approved",
        "approvedToast": "Campaign approved",
        "subject": "Subject",
        "body": "Body",
        "saved": "Campaign saved",
        "attributionWindow": "Attribution window (days)",
        "attributionWindowHint": "Frozen onto each touch when it is written. Changing it does not restate history.",
        "goToSend": "Send",
        "tabsLabel": "Campaign sections",
        "tabContent": "Content",
        "tabSends": "Sends",
        "tabResponses": "Responses",
        "tabRoi": "ROI",
        "sendsEmptyTitle": "Nothing sent yet",
        "sendsEmptyDescription": "Preview the gate first — it writes nothing — then send.",
        "responsesEmptyTitle": "No responses",
        "responsesEmptyDescription": "Replies, meetings, purchases and complaints are recorded here.",
        "recordResponse": "Record a response",
        "recordResponseDescription": "What the recipient did, and when.",
        "responseParty": "Party id",
        "responseKind": "Response",
        "responseNote": "Note",
        "responseRecorded": "Response recorded",
        "emptyTitle": "No campaigns",
        "emptyDescription": "A campaign carries the content, the purpose and the budget."
      },
      "send": {
        "title": "Send",
        "backToCampaign": "Back to the campaign",
        "notApproved": "This campaign has not been approved. The server refuses a send until it is.",
        "withheld": "Executing a send is a separate permission from reading a campaign. You do not hold it.",
        "audienceTitle": "Audience",
        "audienceDescription": "Which segment this send draws from.",
        "segment": "Segment",
        "lastBuilt": "{count} at last build",
        "isTest": "Test send",
        "isTestDescription": "Goes to a named list of internal addresses. No recipient rows are written against real parties and the consent gate does not run against them.",
        "testRecipients": "Test addresses",
        "testRecipientsHint": "Separate with commas or spaces.",
        "previewTitle": "Consent gate",
        "previewDescription": "Writes nothing. Runs the same gate the send will run.",
        "previewEmptyTitle": "Not previewed yet",
        "previewEmptyDescription": "Choose a segment and run the preview to see who the gate would exclude, and why.",
        "runPreview": "Run the preview",
        "audienceTotal": "{count} in the audience",
        "allowed": "{count} allowed",
        "excluded": "{count} excluded",
        "previewNobody": "The gate excludes everyone in this audience. A send would be refused — look at the segment, the purpose and the channel.",
        "previewIsNotAPromise": "The send re-evaluates the gate independently. The two numbers differ whenever a consent changed in between, which is the system working.",
        "sendTitle": "Send",
        "execute": "Send",
        "executeTest": "Send the test",
        "started": "Send started",
        "nobodyExplained": "This send would reach nobody. Check the segment, the purpose and the channel.",
        "nobodyAbsolute": "There is no override for this. A send to nobody is a misconfiguration, and reporting it as success would be worse.",
        "resendWarning": "This audience was sent to recently. Sending again inside the window is a governed exception.",
        "number": "Send #{no}",
        "test": "Test",
        "testNote": "A test send. No real recipient rows were written and the consent gate did not run.",
        "detailDescription": "What the gate decided, recipient by recipient.",
        "counts": "{audience} audience · {sent} sent · {excluded} excluded",
        "evaluatedAt": "Evaluated {at}",
        "breakdownTitle": "Exclusions by reason",
        "breakdownDescription": "Every reason the gate can produce, including the ones that did not apply.",
        "recipientsTitle": "Recipients",
        "recipient": "Recipient",
        "state": "State",
        "exclusionReason": "Exclusion reason",
        "sentAt": "Sent at",
        "anyState": "Any state",
        "anyReason": "Any reason",
        "recipientsEmptyTitle": "No recipients",
        "recipientsEmptyDescription": "Nothing matched this filter."
      },
      "attribution": {
        "model": "Model",
        "firstTouch": "First touch",
        "evenSplit": "Even split",
        "serverComputedNote": "Every figure below is computed by the server. Nothing here re-derives a share.",
        "attributedRevenue": "Attributed revenue",
        "budget": "Budget",
        "net": "Net",
        "roiPercent": "ROI %",
        "touchesTitle": "Touches",
        "touchesDescription": "Each document this campaign is credited against, and its share under the chosen model.",
        "touchesEmptyTitle": "Nothing attributed",
        "touchesEmptyDescription": "A touch is written when a recipient's order, quote or invoice lands inside the attribution window.",
        "share": "Share",
        "windowApplied": "{days}-day window"
      },
      "forecast": {
        "title": "Forecast",
        "description": "What was published, and how close it came.",
        "immutableNote": "A published snapshot cannot be edited or deleted. A number that can be recomputed later is not a published number.",
        "categoriesTitle": "Forecast categories",
        "categoriesDescription": "Which categories roll into commit and best case.",
        "categoriesEmptyTitle": "No categories",
        "categoriesEmptyDescription": "Commit, best case and pipeline are the usual three.",
        "categoriesManagedNote": "Categories are configuration. Commit always implies best case — the database enforces it.",
        "inCommit": "In commit",
        "inBestCase": "In best case",
        "inactive": "Inactive",
        "snapshotsTitle": "Published snapshots",
        "snapshotsDescription": "One row per date, legal entity, owner and period.",
        "snapshotsEmptyTitle": "Nothing published",
        "snapshotsEmptyDescription": "The nightly job publishes a snapshot. Take one now to start the history.",
        "snapshotNow": "Snapshot now",
        "snapshotTaken": "Snapshot published",
        "snapshotOn": "Date",
        "period": "Period",
        "owner": "Owner",
        "allOwners": "All owners",
        "pipeline": "Pipeline",
        "bestCase": "Best case",
        "commit": "Commit",
        "closedWon": "Closed won",
        "opportunities": "Deals",
        "accuracyTitle": "Accuracy",
        "accuracyDescription": "Each period's actual against the commit that was published, never against a recomputation.",
        "accuracyEmptyTitle": "Nothing to compare",
        "accuracyEmptyDescription": "Accuracy needs at least one published snapshot and one closed period.",
        "publishedOn": "Published",
        "actual": "Actual",
        "absoluteError": "Error",
        "percentError": "Error %",
        "periodHint": "A year (2026), a quarter (2026-Q1) or a month (2026-03).",
        "company": "Legal Entity",
        "allCompanies": "All legal entities",
        "companyRef": "Legal entity #{id}",
        "chooseCompany": "Choose a legal entity",
        "ownerRef": "Owner #{id}",
        "currency": "Currency",
        "currencyHint": "The legal entity's base currency, which is what the nightly job snapshots in.",
        "publish": "Publish",
        "snapshotDialogDescription": "The same computation the nightly job runs, published now. Immutable once written.",
        "accuracyPeriodOnly": "Accuracy is reported for the period only; the legal entity filter above does not apply to it.",
        "accuracyNeedsPeriodTitle": "Choose a period",
        "accuracyNeedsPeriodDescription": "Accuracy compares one period, so it needs one named above."
      },
      "winLoss": {
        "title": "Win/loss",
        "description": "Why deals were won and lost, by close reason.",
        "from": "From",
        "to": "To",
        "wonCount": "Won",
        "lostCount": "Lost",
        "wonAmount": "Won value",
        "lostAmount": "Lost value",
        "winRate": "Win rate",
        "winRateHelp": "Computed by the server from won and lost counts.",
        "wonTitle": "Won",
        "lostTitle": "Lost",
        "wonEmptyTitle": "Nothing won in this period",
        "wonEmptyDescription": "Widen the date range, or close a deal.",
        "lostEmptyTitle": "Nothing lost in this period",
        "lostEmptyDescription": "Widen the date range.",
        "reason": "Reason",
        "opportunities": "Deals",
        "amount": "Value",
        "outcome_won": "Win reason",
        "outcome_lost": "Loss reason",
        "requiresCompetitor": "Needs a competitor",
        "requiresNote": "Needs a note",
        "cataloguesTitle": "Close reasons",
        "cataloguesDescription": "A reason belongs to one outcome. A shared list produces a top loss reason somebody picked on a win.",
        "competitorCount": "{count} competitor(s) on file",
        "winRateByAmount": "Win rate by value",
        "winRateByAmountHelp": "Won value over won plus lost value, computed by the server.",
        "window": "Closed between {from} and {to}.",
        "noCompetitorBreakdown": "The report groups by close reason only — it carries no competitor breakdown."
      },
      "scoring": {
        "title": "Lead scoring",
        "description": "Deterministic rules, a version on every run, and a full trace.",
        "oneActiveNote": "Exactly one model may be active. Two active models means two scores and no answer.",
        "emptyTitle": "No score models",
        "emptyDescription": "A model is a list of rules, each worth points. Create one to start scoring leads.",
        "newModel": "New model",
        "newModelDescription": "Bands decide hot, warm and cold. Hot must be above warm.",
        "modelCreated": "Model created",
        "model": "Model",
        "code": "Code",
        "name": "Name",
        "hotThreshold": "Hot at",
        "warmThreshold": "Warm at",
        "bandsInvalid": "Hot must be above warm, warm must be zero or more, and hot must be 100 or less.",
        "bands": "Hot ≥ {hot}, warm ≥ {warm}",
        "active": "Active",
        "activeHint": "Currently active",
        "activate": "Make active",
        "activated": "Model activated",
        "version": "v{version}",
        "rulesTitle": "Rules",
        "rulesDescription": "Evaluated in order. Points add up to the score.",
        "rulesEmptyTitle": "No rules",
        "rulesEmptyDescription": "A model with no rules scores every lead zero.",
        "addRule": "Add rule",
        "addRuleDescription": "Only whitelisted fields can be scored. An unknown field is refused when you save, not silently ignored at run.",
        "ruleAdded": "Rule added",
        "field": "Field",
        "operator": "Operator",
        "value": "Value",
        "points": "Points",
        "pointsHint": "Between -100 and 100. Negative points are legitimate.",
        "label": "Label",
        "traceTitle": "Trace",
        "traceDescription": "Why one lead scored what it scored.",
        "traceEmptyTitle": "No run to show",
        "traceEmptyDescription": "Enter a lead id and re-score it to see every rule's contribution.",
        "leadId": "Lead id",
        "rescore": "Re-score",
        "ranAgainstVersion": "against v{version}",
        "matched": "Matched",
        "notMatched": "No match",
        "running": "running {score}",
        "clamped": "Clamped to 0–100"
      },
      "routing": {
        "title": "Lead routing",
        "description": "Who a new lead goes to, and in what order the rules are tried.",
        "rescoreDoesNotRoute": "The nightly re-score updates scores and bands and deliberately does not re-route. Reassigning a salesperson's leads overnight because a weight changed is a surprise nobody asked for.",
        "emptyTitle": "No routing rules",
        "emptyDescription": "Without a rule, routing a lead is refused. Add one — and make the last one a catch-all.",
        "addRule": "Add rule",
        "addRuleDescription": "Leave the match fields empty to make a catch-all. It must be the last rule.",
        "created": "Rule added",
        "name": "Name",
        "matchBand": "Score band",
        "matchSource": "Lead source",
        "matchCountry": "Country",
        "matchSegment": "Account segment",
        "minScore": "Minimum score",
        "minScoreIs": "score ≥ {score}",
        "anyBand": "Any band",
        "anySegment": "Any segment",
        "target": "Assign to",
        "targetHint": "Exactly one of a person, a role or a strategy.",
        "targetUser": "A named person",
        "targetRole": "A role",
        "targetStrategy": "A strategy",
        "assignUser": "User id",
        "assignRole": "Role code",
        "strategy": "Strategy",
        "roundRobin": "Round robin",
        "leastLoaded": "Least loaded",
        "catchAll": "Catch-all",
        "inactive": "Inactive",
        "catchAllNotLast": "Rule {position} matches everything and is not last. Every rule after it is unreachable.",
        "draftIsCatchAll": "This rule matches everything, so it will be tried last and nothing added after it will ever fire.",
        "moveUp": "Up",
        "moveDown": "Down",
        "routeALead": "Route a lead",
        "route": "Route",
        "routeDescription": "Runs the rules in order and assigns the lead.",
        "leadId": "Lead id",
        "routedToId": "Assigned to user #{id} by rule “{rule}”.",
        "noMatchExplained": "No rule matched and there is no catch-all. Add a rule that matches everything, last.",
        "userRef": "User #{id}",
        "ruleRef": "rule #{id}"
      }
    }
  },
  "sales": {
    "filtersTitle": "Filters",
    "allCompanies": "All legal entities",
    "addLine": "Add line",
    "duplicateLine": "Duplicate",
    "chooseItem": "Choose an item",
    "fields": {
      "company": "Legal Entity",
      "customer": "Customer",
      "item": "Item",
      "warehouse": "Warehouse",
      "currency": "Currency",
      "quantity": "Quantity",
      "ordered": "Ordered",
      "shipped": "Shipped",
      "reservedQty": "Reserved",
      "unitPrice": "Unit price",
      "unitCost": "Unit cost",
      "manualPrice": "Manual price",
      "discount": "Discount",
      "discountPercent": "Discount %",
      "discountTotal": "Discount total",
      "lineAmount": "Line amount",
      "lineNo": "Line",
      "amount": "Amount",
      "subtotal": "Subtotal",
      "total": "Total",
      "memo": "Memo",
      "reference": "Reference",
      "reason": "Reason",
      "description": "Description",
      "revenueAccount": "Revenue account",
      "revRecTerm": "Rev-rec months",
      "createdAt": "Created"
    },
    "aria": {
      "quantity": "Quantity, line {line}",
      "discount": "Discount percent, line {line}",
      "manualPrice": "Manual unit price, line {line}",
      "description": "Description, line {line}",
      "revRecTerm": "Revenue recognition months, line {line}",
      "picking": "Quantity being picked, line {line}",
      "returning": "Quantity being returned for {item}"
    },
    "reports": {
      "from": "From",
      "to": "To"
    },
    "routeTitles": {
      "priceLists": "Price lists",
      "priceList": "Price list",
      "priceListNew": "New price list",
      "promotions": "Promotions",
      "quotes": "Sales quotes",
      "quote": "Sales quote",
      "quoteNew": "New sales quote",
      "orders": "Sales orders",
      "order": "Sales order",
      "orderNew": "New sales order",
      "shipments": "Shipments",
      "shipment": "Shipment",
      "shipmentNew": "Pick and ship",
      "backorders": "Backorders",
      "returns": "Sales returns",
      "return": "Sales return",
      "returnNew": "New sales return",
      "subscriptions": "Subscriptions",
      "subscription": "Subscription",
      "subscriptionPlans": "Subscription plans",
      "revRec": "Deferred revenue",
      "revRecSchedule": "Recognition schedule",
      "pipeline": "Sales pipeline",
      "forecast": "Sales forecast",
      "salesBy": "Sales by",
      "mrr": "MRR and ARR",
      "settings": "Sales settings",
      "tradeAgreements": "Trade agreements",
      "rebatePrograms": "Rebate programs",
      "rebateAccruals": "Rebate accruals",
      "customerContracts": "Customer contracts",
      "discountPolicies": "Discount policies",
      "obligations": "Revenue recognition"
    },
    "chain": {
      "label": "Order-to-cash chain",
      "notYet": "not yet",
      "draft": "draft",
      "count": "{count} documents",
      "hopLabel": "{stage}, {label}, {state}",
      "stages": {
        "quote": "Quote",
        "order": "Order",
        "shipment": "Shipment",
        "invoice": "Invoice",
        "return": "Return"
      },
      "states": {
        "done": "complete",
        "partial": "partly done",
        "cancelled": "cancelled",
        "pending": "not yet done"
      },
      "scoped": {
        "quote": "quotes",
        "order": "orders",
        "shipment": "shipments",
        "invoice": "invoices",
        "return": "returns"
      },
      "next": {
        "quote": "Next: raise a quote for this customer.",
        "order": "Next: convert this quote into a sales order.",
        "shipment": "Next: pick and ship what this order promised.",
        "invoice": "Next: raise the customer invoice for what shipped.",
        "return": "Nothing has been returned against this order."
      }
    },
    "pricing": {
      "whyColumn": "Why this price",
      "why": "Why?",
      "ruleUnknown": "This build does not recognise the pricing rule the server named.",
      "promotionApplied": "Promotion applied",
      "ladderCaption": "Quantity breaks for this item on the winning price list",
      "fromQty": "from {qty}",
      "marginFloorAt": "This item's margin floor is {percent}% over its standard cost.",
      "manualOverridesEngine": "A manual price replaces the pricing engine's answer for this line.",
      "rules": {
        "contract": "Contract price",
        "tier": "Customer tier",
        "qty_break": "Quantity break",
        "base_list": "Base list",
        "manual": "Typed by hand"
      },
      "margin": {
        "ok": "Above the floor",
        "blocked": "Under the margin floor — blocked",
        "overridable": "Under the margin floor — needs approval",
        "ignored": "Under the floor — policy ignores it",
        "unknown": "Under the floor — policy unknown"
      }
    },
    "priceLists": {
      "listTitle": "Price lists",
      "listDescription": "Contract, tier and base lists, in the order the pricing engine reads them.",
      "orderNote": "Sorted by priority: within a kind, the highest priority in force on the day wins.",
      "new": "New price list",
      "newTitle": "New price list",
      "newDescription": "A list holds one ladder per item: a minimum quantity and the price from there up.",
      "emptyTitle": "No price lists yet",
      "emptyDescription": "Create a base list first — without one the engine cannot price anything, and refuses rather than guessing.",
      "loadFailed": "The price lists did not load",
      "saveFailed": "Could not save the price list",
      "saved": "Price list saved",
      "created": "Price list {code} created",
      "headerTitle": "The list",
      "laddersTitle": "Quantity ladders",
      "laddersDescription": "One ladder per item, ascending: buy more, pay less.",
      "laddersCaption": "Items, their minimum quantities and the unit price from each",
      "ladderNote": "The engine picks the highest rung not above the quantity ordered. A quantity below every rung is not priced by this list at all.",
      "addItem": "Add an item",
      "addRung": "Add a rung",
      "sameItem": "same item",
      "chooseItem": "Choose an item",
      "noLines": "This list prices nothing yet.",
      "fromQty": "From quantity",
      "startsAbove": "This ladder starts at {qty}, so this list prices nothing below that.",
      "risesWithQty": "This rung costs more than the one below it.",
      "active": "Active",
      "inactive": "Inactive",
      "inForce": "In force today",
      "notInForce": "Not in force today",
      "columns": {
        "code": "Code",
        "name": "Name",
        "kind": "Kind",
        "tier": "Tier",
        "priority": "Priority",
        "window": "In force",
        "lines": "Rungs",
        "inForce": "Today"
      },
      "kinds": {
        "base": "Base",
        "tier": "Tier",
        "contract": "Contract"
      },
      "kindHints": {
        "base": "The fallback nobody negotiated.",
        "tier": "Applies to every customer on one price tier.",
        "contract": "Agreed with one named customer, and beats every other list."
      },
      "fields": {
        "customerHint": "A contract list prices for this customer only.",
        "tierHint": "Matched against the customer's own price tier.",
        "priorityHint": "Within a kind, the highest priority in force on the day wins.",
        "validFrom": "In force from",
        "validTo": "In force until",
        "validToHint": "Both bounds are inclusive. Leave blank for open-ended."
      },
      "aria": {
        "minQty": "Minimum quantity for {item}",
        "unitPrice": "Unit price for {item}"
      }
    },
    "promotions": {
      "listTitle": "Promotions",
      "listDescription": "Time-boxed offers that move a price after a list has already decided it.",
      "new": "New promotion",
      "newTitle": "New promotion",
      "editTitle": "Edit promotion",
      "dialogDescription": "A promotion discounts whatever price the lists resolved. It does not replace them.",
      "emptyTitle": "No promotions",
      "emptyDescription": "Nothing is running on the date chosen. Move the date to see what ran before, or create one.",
      "loadFailed": "The promotions did not load",
      "saveFailed": "Could not save the promotion",
      "saved": "Promotion saved",
      "created": "Promotion {code} created",
      "active": "Active",
      "inactive": "Inactive",
      "activeOn": "Running on",
      "activeOnHint": "A promotion applies when it is active and the document's date falls inside its window.",
      "everyone": "Everyone",
      "restrictedTo": "{customers} customers, {tiers} tiers, {items} items",
      "unrestricted": "With no customer, tier or item named, this promotion applies to everything you sell.",
      "stacksNote": "A promotion runs after a price list has already won. Both facts are shown on the line: the list that set the price, and the promotion that moved it.",
      "editLimits": "Only the name, the end date and the active switch can change. Quotes already carry lines priced under this promotion, and changing its terms would make those lines unexplainable — end it early instead.",
      "columns": {
        "eligibility": "Applies to"
      },
      "kinds": {
        "percent": "Percent off",
        "amount": "Amount off",
        "bundle": "Bundle"
      },
      "kindHints": {
        "percent": "A percentage off the resolved price.",
        "amount": "A fixed amount off, in one currency.",
        "bundle": "A percentage off, but only once a minimum quantity is taken."
      },
      "valueHints": {
        "percent": "A percentage, e.g. 10 for ten percent off.",
        "amount": "An amount in the currency below.",
        "bundle": "A percentage, applied only at or above the bundle quantity."
      },
      "fields": {
        "code": "Code",
        "name": "Name",
        "kind": "Kind",
        "value": "Value",
        "bundleMinQty": "Bundle quantity",
        "bundleMinQtyHint": "The quantity at which the bundle discount starts.",
        "minQty": "Minimum quantity",
        "minQtyHint": "Below this quantity the promotion does not apply at all.",
        "startDate": "Starts",
        "endDate": "Ends",
        "endDateHint": "Inclusive. Bringing this forward is how a running promotion is stopped.",
        "customerIds": "Customer ids",
        "customerTiers": "Customer tiers",
        "itemIds": "Item ids",
        "idListHint": "Comma separated. Leave blank to apply to all of them.",
        "tierListHint": "Comma separated tier codes. Leave blank for every tier."
      }
    },
    "quotes": {
      "listTitle": "Sales quotes",
      "listDescription": "Prices held open for a period. A quote past its date is not a live offer.",
      "new": "New quote",
      "newTitle": "New sales quote",
      "draftTitle": "Draft quote",
      "emptyTitle": "No quotes yet",
      "emptyDescription": "Raise one for a customer, and the price each line resolves to is explained as it is priced.",
      "searchPlaceholder": "Quote number or reference",
      "loadFailed": "The quotes did not load",
      "saveFailed": "Could not save the quote",
      "saved": "Quote saved",
      "created": "Quote created",
      "headerTitle": "The quote",
      "linesTitle": "Lines",
      "linesDescription": "Type a quantity and any discount. Every price is the server's answer, with the rule that produced it.",
      "linesCaption": "Editable quote lines: item, quantity, discount and an optional manual price",
      "pricedCaption": "Priced quote lines, with the rule behind each price",
      "columns": {
        "quoteNo": "Quote number",
        "quoteDate": "Quote date",
        "expiry": "Expiry"
      },
      "fields": {
        "expiryHint": "After this date the offer is no longer live, whatever the status still says."
      },
      "noExpiry": "No expiry set",
      "expiresInDays": "in {days} days",
      "lapsedDays": "lapsed {days} days ago",
      "lapsedNote": "This quote's expiry passed {days} days ago. It still reads as sent because the server's expiry sweep has not run — but it is not a live offer.",
      "send": "Send to customer",
      "sent": "Quote {quoteNo} sent",
      "sendFailed": "Could not send the quote",
      "recordAccept": "Record acceptance",
      "recordReject": "Record rejection",
      "accepted": "Acceptance recorded",
      "rejected": "Rejection recorded",
      "decisionFailed": "Could not record the customer's decision",
      "rejectTitle": "Record the customer's rejection",
      "rejectDescription": "The reason is kept on the quote and in the audit trail. Say who rejected it and why.",
      "rejectionTitle": "Why it was rejected",
      "cancelTitle": "Cancel this quote",
      "cancelDescription": "A cancelled quote can no longer be sent, accepted or converted.",
      "cancelQuote": "Cancel quote",
      "cancelled": "Quote cancelled",
      "cancelFailed": "Could not cancel the quote",
      "convert": "Convert to order",
      "converted": "Converted to a sales order",
      "convertFailed": "Could not convert the quote",
      "viewOrder": "View the order this became",
      "pdf": "Request PDF",
      "pdfReady": "PDF ready",
      "pdfRequested": "The PDF is being rendered",
      "pdfFailed": "The PDF could not be produced",
      "statuses": {
        "draft": "Draft",
        "sent": "Sent",
        "accepted": "Accepted",
        "rejected": "Rejected",
        "expired": "Expired",
        "cancelled": "Cancelled",
        "converted": "Converted",
        "superseded": "Superseded"
      },
      "parkedToast": "Quote is waiting for approval"
    },
    "orders": {
      "one": "Sales order",
      "listTitle": "Sales orders",
      "listDescription": "A confirmed order holds stock. What it holds, and what it gave away to get there, is on every row.",
      "new": "New order",
      "newTitle": "New sales order",
      "draftTitle": "Draft order",
      "emptyTitle": "No sales orders yet",
      "emptyDescription": "Raise one directly, or convert an accepted quote — the quote then shows what became of it.",
      "searchPlaceholder": "Order number or reference",
      "loadFailed": "The orders did not load",
      "saveFailed": "Could not save the order",
      "saved": "Order saved",
      "created": "Order created",
      "headerTitle": "The order",
      "linesTitle": "Lines",
      "linesDescription": "Every line needs a warehouse and a revenue account: one decides what can be promised, the other what the invoice will credit.",
      "linesCaption": "Editable order lines: item, warehouse, revenue account, quantity and discount",
      "pricedCaption": "Priced order lines, with what has shipped and what is reserved",
      "columns": {
        "orderNo": "Order number",
        "orderDate": "Order date",
        "requestedDate": "Requested for",
        "overrides": "Overrides"
      },
      "fields": {
        "requestedDateHint": "The date the customer asked for. It does not reserve anything by itself."
      },
      "confirm": "Confirm order",
      "confirmed": "Order {orderNo} confirmed and stock reserved",
      "confirmFailed": "The order was not confirmed",
      "cancelOrder": "Cancel order",
      "cancelTitle": "Cancel this order",
      "cancelDescription": "Every reservation this order holds is released. An order that has shipped anything cannot be cancelled.",
      "cancelled": "Order cancelled and its reservations released",
      "cancelFailed": "Could not cancel the order",
      "fromQuote": "From the quote it was converted from",
      "creditOverride": "Credit override",
      "discountOverride": "Discount override",
      "creditOverrideGranted": "A credit override was granted for this order: {reason}",
      "discountOverrideGranted": "A discount override was granted for this order: {reason}",
      "discountNeedsApproval": "Over the {threshold}% approval threshold — confirming will ask for an override.",
      "deferredNote": "Billed to the deferred revenue account and recognised over this many months.",
      "statuses": {
        "draft": "Draft",
        "pending_approval": "Awaiting approval",
        "confirmed": "Confirmed",
        "partially_shipped": "Partly shipped",
        "shipped": "Shipped",
        "invoiced": "Invoiced",
        "closed": "Closed",
        "cancelled": "Cancelled"
      },
      "parkedToast": "Order is waiting for approval"
    },
    "atp": {
      "title": "Available to promise",
      "description": "On hand, less what other orders have reserved, plus what is inbound. On hand alone is not availability.",
      "caption": "Requested, on hand, reserved, inbound and available for each item and warehouse",
      "requested": "Requested",
      "onHand": "On hand",
      "reserved": "Reserved",
      "inbound": "Inbound",
      "available": "Available",
      "checking": "Checking availability",
      "empty": "Add a line with an item and a warehouse, and availability appears here.",
      "shortBy": "short by {qty}",
      "leansOnInbound": "promisable only because of stock still inbound",
      "overCommitted": "This warehouse holds more promises than stock: {qty} free.",
      "willRefuse": "Confirming will be refused while any line is short. Reduce the quantity, choose another warehouse, or wait for stock.",
      "inboundNote": "This order can be promised, but not shipped today: part of it rests on stock that has not arrived.",
      "unknownNote": "Availability could not be answered for at least one line, so the order's position is unknown rather than fine.",
      "notPermitted": "You may not read stock, so availability is not shown. It is not zero — it is unknown.",
      "refused": "Not enough stock to promise",
      "verdicts": {
        "available": "Can be promised",
        "inbound": "Promisable on inbound stock",
        "short": "Not enough to promise",
        "unknown": "Availability unknown"
      }
    },
    "credit": {
      "limit": "Credit limit",
      "noLimit": "No limit recorded",
      "exposure": "Exposure",
      "available": "Headroom left",
      "overage": "Over the limit by",
      "overdue": "Overdue",
      "overdueDays": "up to {days} days",
      "source": {
        "params": "Figures as they stood when the order was refused.",
        "none": "No credit figures could be read."
      }
    },
    "creditBlock": {
      "title": "This order fails the customer's credit check",
      "pendingTitle": "Credit override requested",
      "pendingBody": "The request is with an approver. Confirm again once it is granted; asking twice does not speed it up.",
      "noPermission": "You may confirm orders but not waive a credit ceiling. The approval chain names who can.",
      "requestOverride": "Request a credit override",
      "submitOverride": "Submit the override",
      "submitted": "Credit override submitted for approval",
      "reasonLabel": "Why this order should go through anyway",
      "reasonHint": "Recorded in the audit trail. An override with no stated reason is a bypass.",
      "reasonPlaceholder": "e.g. Payment plan agreed with the customer on 3 August; first instalment already received."
    },
    "convert": {
      "title": "Convert {quoteNo} into a sales order",
      "description": "The prices are the customer's already. What an order needs and a quote does not carry is where each line ships from and what it credits.",
      "whyNote": "A quote carries no revenue account and usually no warehouse, so both are asked here rather than guessed. The warehouse decides what can be promised and which shelf the order reserves.",
      "caption": "Each quote line, with the warehouse it ships from and the revenue account it credits",
      "chooseWarehouse": "Choose a warehouse",
      "allWarehouses": "Warehouse for every line",
      "allWarehousesHint": "Most orders ship from one warehouse.",
      "allAccounts": "Revenue account for every line",
      "allAccountsHint": "Most orders credit one account.",
      "applyToAll": "Apply to every line",
      "noLines": "This quote has no lines to convert.",
      "missingWarehouse": "{count} line(s) still need a warehouse.",
      "missingAccount": "{count} line(s) still need a revenue account.",
      "aria": {
        "warehouse": "Warehouse, line {line}",
        "account": "Revenue account, line {line}"
      }
    },
    "guardrail": {
      "title": "This order needs a discount or margin-floor override",
      "pendingTitle": "Discount override requested",
      "pendingBody": "The request is with an approver. Confirm again once it is granted.",
      "onLine": "line {line}",
      "hardBlock": "Under the block policy a margin-floor breach can never be overridden. Raise the price, or change the policy for this legal entity.",
      "noPermission": "You may confirm orders but not waive a discount or margin rule.",
      "requestOverride": "Request a discount override",
      "submitOverride": "Submit the override",
      "submitted": "Discount override submitted for approval",
      "reasonLabel": "Why this discount should stand",
      "reasonHint": "Recorded in the audit trail, beside the lines it is about.",
      "reasonPlaceholder": "e.g. Matched a competitor's quote for this tender; approved by the regional manager.",
      "kinds": {
        "discount_threshold": "Discount over threshold",
        "margin_floor": "Under the margin floor",
        "insufficient_stock": "Not enough stock"
      }
    },
    "shipments": {
      "one": "Shipment",
      "listTitle": "Shipments",
      "listDescription": "What actually left the warehouse, at the cost the ledger consumed. Reversed shipments stay, marked.",
      "draftTitle": "Draft shipment",
      "emptyTitle": "Nothing shipped yet",
      "emptyDescription": "Shipping is always against a sales order, so the way in is from the order itself.",
      "loadFailed": "The shipments did not load",
      "columns": {
        "shipmentNo": "Shipment number",
        "shipDate": "Ship date",
        "lines": "Lines"
      },
      "pickAgainst": "Pick and ship",
      "pickTitle": "Pick against {orderNo}",
      "pickDescription": "What is picked here leaves the warehouse and posts its journal. Anything left owing becomes a backorder.",
      "headerTitle": "The shipment",
      "linesTitle": "Lines",
      "linesDescription": "Only lines held in the chosen warehouse can be part of this shipment.",
      "linesCaption": "Ordered, already shipped, remaining, being picked and what each would leave owing",
      "fields": {
        "warehouseHint": "A shipment belongs to one warehouse. Lines held elsewhere are shown but cannot be picked here.",
        "invoiceDate": "Invoice date",
        "autoPost": "Post it straight away",
        "autoPostHint": "Leave off to raise a draft the accounts team reviews before posting."
      },
      "remaining": "Still owed",
      "picking": "Picking now",
      "shipEverything": "Fill every line",
      "otherWarehouse": "held in another warehouse",
      "overPicked": "More than the {qty} still owed on this line.",
      "lineCloses": "closes this line",
      "post": "Post shipment",
      "posted": "Shipment {shipmentNo} posted",
      "postFailed": "The shipment was not posted",
      "postConsequence": "Posting moves the stock and its journal together. It cannot be edited afterwards — only reversed.",
      "factsTitle": "The shipment",
      "costDescription": "Unit cost is what the ledger consumed — FIFO layers or a moving average — not a price anybody typed.",
      "costCaption": "Quantity, the unit cost the ledger consumed and the COGS each line posted",
      "extendedCost": "Extended cost",
      "cogsTotal": "Cost of goods sold",
      "costNote": "This is cost, not what the customer pays: the invoice is a different figure by the whole margin. A return against this shipment restocks at exactly these costs.",
      "noLines": "This shipment has no lines.",
      "reverse": "Reverse shipment",
      "reverseTitle": "Reverse this shipment",
      "reverseDescription": "The stock goes back and the journal is mirrored. The shipment stays in the list, marked, because it is part of what happened.",
      "reversed": "Shipment reversed",
      "reverseFailed": "Could not reverse the shipment",
      "reversedNote": "This shipment was reversed: {reason}",
      "invoice": "Raise invoice",
      "invoiceTitle": "Invoice what shipped",
      "invoiceDescription": "The customer invoice is raised for what actually left, not for what was ordered.",
      "raiseInvoice": "Raise the invoice",
      "invoiced": "Invoice {invoiceNo} raised",
      "invoiceFailed": "Could not raise the invoice",
      "viewInvoice": "View invoice {invoiceNo}",
      "deferredNote": "A line with a rev-rec term is invoiced to the deferred revenue account instead of its own — which is what defers the revenue.",
      "statuses": {
        "draft": "Draft",
        "posted": "Posted",
        "reversed": "Reversed",
        "cancelled": "Cancelled"
      }
    },
    "backorders": {
      "title": "Backorders",
      "description": "What this order still owes, from its own lines and from the backorder rows the server wrote.",
      "listDescription": "Promises made and not yet shipped. Fulfilled and cancelled rows are history, not outstanding.",
      "emptyTitle": "Nothing outstanding",
      "emptyDescription": "Every confirmed order has been shipped in full, or nothing has been ordered yet.",
      "loadFailed": "The backorders did not load",
      "caption": "Each order line's outstanding quantity, derived and as recorded",
      "owing": "Still owed",
      "since": "Owed since",
      "derived": "From the order",
      "recorded": "From the backorder rows",
      "agrees": "Agrees",
      "disagrees": "Disagrees",
      "reconcileNote": "These two must agree. Where they do not, both figures are shown exactly as they arrived and neither is adjusted.",
      "openTotal": "Open on this page",
      "willLeave": "Would leave owing",
      "previewTitle": "This shipment will leave {count} line(s) owing.",
      "previewLine": "Line {line}, {item}: {qty} still owed.",
      "statuses": {
        "open": "Open",
        "fulfilled": "Fulfilled",
        "cancelled": "Cancelled"
      }
    },
    "returns": {
      "listTitle": "Sales returns",
      "listDescription": "Goods coming back, and the credit note each one raised.",
      "emptyTitle": "Nothing returned",
      "emptyDescription": "A return is best raised from the shipment it came from — that is where the costs the goods left at are recorded.",
      "loadFailed": "The returns did not load",
      "draftTitle": "Draft return",
      "newTitle": "New sales return",
      "newDescription": "Restocked goods go back at the cost they shipped at, and only restocked lines touch inventory at all.",
      "headerTitle": "The return",
      "factsTitle": "The return",
      "linesTitle": "Lines",
      "linesCaption": "Quantity returned, the cost it shipped at, what is credited and whether it goes back on the shelf",
      "newLinesDescription": "Enter what is coming back. The cost is the shipment's own and is not editable where it could be read.",
      "postedDescription": "What went back on the shelf, at the cost it left at, and what the customer was credited.",
      "columns": {
        "returnNo": "Return number",
        "returnDate": "Return date"
      },
      "returning": "Returning",
      "shippedCost": "Cost it shipped at",
      "restockValue": "Back to stock",
      "credited": "Credited",
      "restock": "Put back on the shelf",
      "restocked": "Restocked",
      "yes": "Yes",
      "writtenOff": "Written off",
      "willRestock": "goes back to stock at the shipped cost",
      "willWriteOff": "not restocked; the customer is credited and COGS is left alone",
      "costLocked": "from the shipment",
      "costTyped": "Typed by hand. Inventory will be debited at exactly this figure.",
      "restockTotal": "Value going back to stock",
      "creditTotal": "Credit to the customer",
      "creditNote": "Credit note",
      "noCreditNote": "none raised",
      "addLine": "Add a line",
      "noLines": "Nothing is being returned yet.",
      "noShipmentSource": "Started without a shipment, so no cost could be carried across. Every cost typed here is the figure inventory will be debited at.",
      "writeOffNote": "{count} line(s) are not being restocked. Those goods are written off: the customer is credited, and COGS is correctly left alone.",
      "overReturned": "A line returns more than that shipment sent. Reduce it, or raise the return against the right shipment.",
      "post": "Post return",
      "posted": "Return {returnNo} posted",
      "postFailed": "The return was not posted",
      "postConsequence": "A return posts on create: the stock, the credit note and the journal all commit together. There is no draft.",
      "costNote": "Restocked lines were received at the cost the goods originally shipped at, never re-derived — so this reversal is the mirror image of the issue the shipment posted.",
      "startFromShipment": "Return against this shipment",
      "statuses": {
        "draft": "Draft",
        "posted": "Posted",
        "cancelled": "Cancelled"
      }
    },
    "subscriptions": {
      "listTitle": "Subscriptions",
      "listDescription": "What the renewal job will bill, and when. Recurring revenue is summed from these.",
      "new": "Start a subscription",
      "newTitle": "Start a subscription",
      "newDescription": "The plan sets the cycle and the default price. A price entered here is a negotiated one for this customer.",
      "start": "Start",
      "started": "Subscription started",
      "startFailed": "Could not start the subscription",
      "emptyTitle": "No subscriptions",
      "emptyDescription": "Create a plan first, then start a subscription on it for a customer.",
      "loadFailed": "The subscriptions did not load",
      "columns": {
        "subscriptionNo": "Subscription",
        "plan": "Plan",
        "pricePerCycle": "Price per cycle",
        "monthly": "Per month",
        "nextBilling": "Next billing",
        "startDate": "Starts",
        "endDate": "Ends"
      },
      "fields": {
        "priceHint": "Defaults to the plan's price. Change it only for a genuinely negotiated rate.",
        "endDateHint": "Leave blank to renew until somebody cancels it."
      },
      "notScheduled": "not scheduled",
      "pageMonthly": "Active on this page, per month",
      "subtotalNote": "The page subtotal counts only active rows on this page. It is not MRR — a filtered, paginated list does not add up to a legal entity's recurring revenue.",
      "billingTitle": "Billing",
      "billingDescription": "The cycle, the period it is in now, and what the next renewal invoice will be for.",
      "currentPeriod": "Current period",
      "nextAmount": "Next renewal invoice",
      "pausedNote": "Paused subscriptions are skipped by the renewal sweep, so there is no next billing date. Pausing stops billing; it does not hide it.",
      "change": "Change quantity or price",
      "changeTitle": "Change this subscription",
      "changeDescription": "The change is prorated over the rest of the current period and applied at the next renewal.",
      "applyChange": "Apply the change",
      "changed": "Subscription changed",
      "changeFailed": "Could not change the subscription",
      "prorationExplained": "{remaining} of this period's {period} days remain, so the change is worth about",
      "prorationEstimateNote": "An estimate from the period the API published. The invoice figure is the server's.",
      "pause": "Pause",
      "pauseTitle": "Pause this subscription",
      "pauseDescription": "Nothing is billed while it is paused.",
      "pauseConsequence": "The renewal job skips a paused subscription, so its next billing date disappears until it is resumed.",
      "paused": "Subscription paused",
      "pauseFailed": "Could not pause the subscription",
      "resume": "Resume",
      "resumed": "Subscription resumed",
      "resumeFailed": "Could not resume the subscription",
      "cancel": "Cancel subscription",
      "cancelTitle": "Cancel this subscription",
      "cancelDescription": "Cancelling stops every future renewal. The reason is kept in the audit trail.",
      "cancelled": "Subscription cancelled",
      "cancelFailed": "Could not cancel the subscription",
      "statuses": {
        "active": "Active",
        "paused": "Paused",
        "cancelled": "Cancelled",
        "expired": "Expired"
      }
    },
    "plans": {
      "title": "Subscription plans",
      "description": "A plan's price is per cycle, not per month. Both are shown, with the divisor named.",
      "new": "New plan",
      "newTitle": "New subscription plan",
      "newDescription": "The cycle and the price together decide what this plan contributes to recurring revenue.",
      "created": "Plan {code} created",
      "saveFailed": "Could not save the plan",
      "loadFailed": "The plans did not load",
      "emptyTitle": "No plans yet",
      "emptyDescription": "A subscription needs a plan: the plan holds the cycle, the price and the revenue account.",
      "active": "Active",
      "inactive": "Inactive",
      "columns": {
        "code": "Code",
        "name": "Name",
        "cycle": "Billing cycle",
        "price": "Price per cycle",
        "monthlyEquivalent": "Per month"
      },
      "cycles": {
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "semi_annual": "Every six months",
        "annual": "Annual"
      },
      "overMonths": "over {months} months",
      "unknownCycle": "cycle unknown",
      "monthlyPreview": "Over {months} months that is",
      "immutableNote": "Plans cannot be edited. A running subscription carries its own price, copied when it started, so changing a plan would not reprice it — create a new plan and change each subscription instead.",
      "fields": {
        "priceHint": "For one whole cycle, not for one month.",
        "revenueAccountHint": "Credited when the renewal invoice posts.",
        "itemHint": "Optional. Links the plan to a catalogue item for reporting."
      }
    },
    "revrec": {
      "listTitle": "Deferred revenue schedules",
      "listDescription": "What has been recognised and what remains deferred, per term-billed document.",
      "emptyTitle": "No schedules",
      "emptyDescription": "A schedule is created when an order line carrying a rev-rec term is invoiced.",
      "loadFailed": "The schedules did not load",
      "docTitle": "{docType} #{docId}",
      "docDescription": "The worker posts each period's recognition journal on its own schedule.",
      "positionTitle": "Recognised and deferred",
      "recognised": "Recognised",
      "stillDeferred": "Still deferred",
      "scheduleTotal": "Schedule total",
      "lineSum": "Sum of the periods",
      "meterLabel": "{percent}% of this schedule has been recognised",
      "driftNote": "The periods do not add up to the schedule's own total. Both figures are shown exactly as they arrived; the difference is",
      "nextPeriod": "The next period the job will post is {from} to {to}, for",
      "periodsTitle": "Periods",
      "periodsDescription": "One row per period, flagged as the worker recognises it.",
      "periodsCaption": "Each period, its amount, whether it has been recognised and when",
      "noLines": "This schedule has no periods.",
      "jobNote": "Recognition is posted by the nightly worker under the system actor. There is no button here because an interactive trigger would need a permission from a module this one does not own.",
      "done": "Recognised",
      "pending": "Not yet",
      "doneOf": "{done} of {total} periods",
      "columns": {
        "source": "Source document",
        "term": "Term",
        "total": "Total",
        "periods": "Recognised",
        "period": "Period",
        "recognised": "Status",
        "recognisedAt": "Recognised on"
      },
      "statuses": {
        "active": "Running",
        "completed": "Complete",
        "cancelled": "Cancelled"
      }
    },
    "pipeline": {
      "title": "Pipeline and win rate",
      "description": "The same quotes read twice: by status now, and by what happened to the ones decided in a window.",
      "loadFailed": "The pipeline did not load",
      "stagesTitle": "By status",
      "stagesDescription": "Every stage clicks through to the quotes behind it.",
      "caption": "Quote count, value and share of the total, by status",
      "count": "Quotes",
      "share": "Share",
      "empty": "No quotes have been raised for this legal entity.",
      "openValue": "Open pipeline",
      "openValueHelp": "Draft and sent quotes only. An accepted or lost quote is an outcome, not an opportunity.",
      "allQuotesValue": "All quotes",
      "allQuotesHelp": "Every quote on record, whatever became of it.",
      "windowHint": "The window applies to the win rate, not to the pipeline: one is a live snapshot, the other a historical ratio."
    },
    "winRate": {
      "title": "Win rate",
      "description": "What happened to the quotes decided inside the window.",
      "loadFailed": "The win rate did not load",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "expired": "Expired",
      "decided": "Decided",
      "rate": "Win rate",
      "formulaLabel": "The server's own formula:",
      "expiredCounts": "An expired quote counts as a loss, not as an absence: the customer simply never said yes."
    },
    "forecast": {
      "title": "Sales forecast",
      "description": "Committed is what is already accepted. Weighted is a projection, and includes quotes nobody has said yes to.",
      "loadFailed": "The forecast did not load",
      "committed": "Committed",
      "committedHelp": "Accepted quotes only. Near-certain money.",
      "weighted": "Weighted",
      "weightedHelp": "Each bucket's value times its probability. A projection, not a promise.",
      "bucketsTitle": "By status",
      "bucketsDescription": "The probability behind each weighting is on its own row, so a reader can disagree with one assumption rather than with the total.",
      "caption": "Value, probability and weighted value for each quote status",
      "value": "Value",
      "probability": "Probability",
      "weightedValue": "Weighted",
      "empty": "No quotes fall inside this window.",
      "driftNote": "The buckets do not sum to the reported weighted total. Both are shown exactly as they arrived; the difference is",
      "assumptionNote": "Weighted totals include quotes nobody has accepted. Plan against committed; sell against weighted."
    },
    "salesBy": {
      "title": "Sales by",
      "description": "Built from posted shipments: an order not yet shipped is not here, and a shipment not yet invoiced is.",
      "postedOnly": "Sorted by amount, largest first, because this report is read for concentration.",
      "loadFailed": "The report did not load",
      "groupBy": "Group by",
      "groups": {
        "customer": "Customer",
        "item": "Item",
        "warehouse": "Warehouse"
      },
      "caption": "Each group's quantity, amount and share of the total",
      "empty": "Nothing shipped between these dates.",
      "driftNote": "The rows do not sum to the reported total. Both figures are shown exactly as they arrived; the difference is"
    },
    "mrr": {
      "title": "MRR and ARR",
      "description": "The server's figures, reconciled line by line against the subscriptions behind them.",
      "loadFailed": "The report did not load",
      "mrr": "MRR",
      "arr": "ARR",
      "mrrHelp": "Every active subscription's price divided by its cycle's month count.",
      "arrHelp": "MRR times twelve, and nothing more clever than that.",
      "activeCount": "Active subscriptions",
      "activeHelp": "Paused and cancelled subscriptions contribute nothing: the renewal job will not bill them.",
      "asOf": "As at",
      "asOfHint": "Leave blank for today.",
      "viewReport": "Open the MRR report",
      "viewSubscriptions": "View the subscriptions",
      "reconciliationTitle": "Where the figure comes from",
      "reconciliationDescription": "Each active subscription's own contribution, summed and compared against the server's MRR.",
      "caption": "Each subscription's plan, cycle, quantity, price and monthly contribution",
      "contribution": "Per month",
      "derivedMrr": "Summed from the rows",
      "derivedArr": "Annualised from the rows",
      "noSubscriptions": "No active subscriptions to reconcile against.",
      "reconcilesNote": "The rows sum exactly to the reported MRR.",
      "driftNote": "The rows do not sum to the reported MRR. Neither figure has been adjusted to match the other; the difference is",
      "incompleteNote": "{count} subscription(s) have a plan this page could not read, so the reconciliation is incomplete rather than wrong.",
      "truncatedNote": "More than one page of active subscriptions exists, so the rows below are a floor and will not reconcile.",
      "arrMismatch": "The reported ARR is not twelve times the reported MRR. Both are shown as they arrived.",
      "contributionTitle": "This subscription's contribution",
      "contributionDescription": "Quantity times price, divided by the cycle's month count.",
      "contributionNote": "The MRR report is the figure of record. This is the same arithmetic for one contract, so the parts can be checked against the whole."
    },
    "settings": {
      "title": "Sales settings",
      "description": "One legal entity's revenue account, default warehouse, discount threshold and margin-floor policy.",
      "forbidden": "You may not read sales settings. The server guards reading them with the same permission as changing them, so there is no read-only view to offer.",
      "loadFailed": "The settings did not load",
      "saved": "Sales settings saved",
      "saveFailed": "Could not save the settings",
      "revenueTitle": "Revenue",
      "revenueDescription": "Where a term-billed line is credited, and which warehouse a new order line defaults to.",
      "guardrailTitle": "Discount and margin guardrails",
      "guardrailDescription": "What happens when a line is discounted past the threshold, or priced under an item's margin floor.",
      "fields": {
        "deferredAccount": "Deferred revenue account",
        "deferredAccountHint": "A liability account. Crediting it at invoice time is what defers the revenue.",
        "deferredAccountPlaceholder": "Choose a liability account",
        "defaultWarehouse": "Default warehouse",
        "defaultWarehouseHint": "Pre-filled on a new order line. Every line can still name its own.",
        "discountThreshold": "Discount approval threshold %",
        "discountThresholdHint": "A discount strictly greater than this needs an override. A discount exactly equal to it passes.",
        "marginPolicy": "Margin floor policy",
        "marginPolicyHint": "What a price under an item's margin floor does on confirm.",
        "standardCost": "Standard cost",
        "standardCostHint": "What the floor is measured against for this item.",
        "marginFloorPercent": "Margin floor %",
        "marginFloorPercentHint": "The minimum margin over standard cost, as a percentage."
      },
      "noDeferredAccount": "Without this account configured, a line carrying a rev-rec term cannot be invoiced at all — the server refuses and names this field.",
      "policies": {
        "block": {
          "label": "Block",
          "summary": "Refuse the confirm outright. No override can clear it."
        },
        "warn": {
          "label": "Warn",
          "summary": "Refuse, but let somebody with the discount override permission approve it."
        },
        "ignore": {
          "label": "Ignore",
          "summary": "Do not check the margin floor at all."
        }
      },
      "blockConsequence": "Under block, a margin-floor breach can never be overridden by anybody. Some orders will simply not go through, and the person who raised them will have no way forward but to change the price.",
      "itemFloorTitle": "Per-item margin floor",
      "itemFloorDescription": "The floor itself is per item, over that item's standard cost — a floor set across a whole catalogue is one nobody could set honestly.",
      "saveItemFloor": "Save item floor",
      "itemSaved": "Item margin floor saved",
      "itemSaveFailed": "Could not save the item's margin floor",
      "itemFloorMoved": "The floor and the standard cost it is measured against are set per item, with the rest of the pricing engine.",
      "itemFloorLink": "Open item pricing settings",
      "stale": "Somebody else saved these sales settings while you had them open. Nothing was overwritten — reload the saved version, then apply your edits again.",
      "reload": "Reload the saved version"
    },
    "amend": {
      "title": "Amend order {orderNo}",
      "description": "A confirmed order is amended, not edited. Every change is re-validated and recorded as a new version.",
      "action": "Amend order",
      "submit": "Amend",
      "revalidates": "Amending re-runs the discount guardrails, the credit check and availability against the changed order.",
      "materiality": "If the change is material, the approval already granted is voided and the order is routed again against the current authority matrix.",
      "reasonCode": "Reason code",
      "reasonCodeHint": "Short code recorded against the amendment, up to 40 characters.",
      "note": "Note",
      "promisedDate": "Promised date",
      "promisedDateHint": "Leave empty to keep the date already promised.",
      "permitBackorder": "Permit backorder",
      "permitBackorderHint": "Allow lines that no longer fit available stock to be carried as backorders.",
      "backorderReasonCode": "Backorder reason code",
      "linesCaption": "The amended order lines",
      "priorTotal": "Total before",
      "newTotal": "Total after",
      "noReprice": "No line has changed, so nothing is repriced. Only the dates and the backorder setting are sent.",
      "short": "Availability is short on at least one line. Permit backorder and give a reason code, or reduce the quantity.",
      "historyTitle": "Amendment history",
      "historyDescription": "Every version of this order, with what changed and how it was assessed.",
      "historyCaption": "Amendments recorded against this order",
      "columns": {
        "no": "No.",
        "changed": "Changed fields",
        "assessment": "Assessment",
        "rechecks": "Re-validation"
      },
      "material": "Material",
      "immaterial": "Immaterial",
      "rerouted": "Approval voided and routed again",
      "creditRecheck": "Credit: {outcome}",
      "atpRecheck": "Availability: {outcome}",
      "repriced": "{count} line(s) repriced",
      "materialToast": "Amendment {no} is material — the order needs approval again",
      "doneToast": "Amendment {no} recorded",
      "failed": "This order could not be amended"
    },
    "discountPolicies": {
      "title": "Discount authority matrix",
      "description": "Discount thresholds and margin floors by channel, customer segment and product category.",
      "newPolicy": "New policy",
      "editTitle": "Edit policy",
      "editorDescription": "A policy governs every line matching its channel, segment and category. Leave a dimension empty to match anything.",
      "supersede": "Supersede",
      "supersedeTitle": "Supersede policy",
      "supersedeDescription": "Close this policy off and open its successor from a new date. The scope cannot change.",
      "supersedeNote": "The current policy is dated out on the day before the new one starts. Nothing already decided under it is altered.",
      "channel": "Channel",
      "segment": "Segment",
      "category": "Category",
      "any": "any",
      "anyHint": "Empty matches anything.",
      "asAt": "In force on",
      "asAtHint": "Show only the policies in force on this date.",
      "effectiveFrom": "Effective from",
      "amountHint": "Optional second trigger in money. Needs a currency.",
      "marginFloorHint": "Block refuses the sale outright; warn allows an override; ignore does neither.",
      "inForce": "In force",
      "superseded": "Superseded",
      "resolutionNote": "The most specific policy in force wins: category beats segment beats channel, and specificity is computed by the database, not by this screen.",
      "fallbackNote": "Where no policy matches, the single company-wide threshold applies —",
      "emptyTitle": "No discount policies yet",
      "emptyDescription": "Every line falls back to the company-wide discount threshold until a policy is written.",
      "loadFailed": "The discount policies could not be loaded",
      "saved": "Policy saved",
      "saveFailed": "The policy could not be saved",
      "columns": {
        "scope": "Scope",
        "specificity": "Specificity",
        "thresholdPercent": "Threshold %",
        "thresholdAmount": "Threshold amount",
        "marginFloor": "Margin floor",
        "window": "Effective"
      },
      "marginPolicies": {
        "block": "Block",
        "warn": "Warn",
        "ignore": "Ignore"
      },
      "authorityNote": "Who may grant a discount past a threshold is a separate question, asked in money —",
      "authorityMatrix": "authority matrix"
    },
    "agreements": {
      "title": "Trade agreements",
      "description": "The negotiated prices and allowances agreed with a customer or a segment, for a stated period.",
      "newAgreement": "New agreement",
      "editHeader": "Edit agreement",
      "headerDescription": "An agreement applies to one customer or to a whole segment, never to both.",
      "detailDescription": "Agreement lines price the customer's orders ahead of tier and base price lists.",
      "customerHint": "Leave empty to agree terms for a whole segment instead.",
      "segment": "Segment",
      "bySegment": "By segment",
      "category": "Category",
      "anyItem": "Any item",
      "kind": "Kind",
      "value": "Value",
      "minQty": "Min qty",
      "priority": "Priority",
      "startsOn": "Starts on",
      "endsOn": "Ends on",
      "activatedAt": "Activated",
      "activate": "Activate",
      "activateTitle": "Activate agreement",
      "activateDescription": "An active agreement prices every matching order from now on. A draft prices nothing.",
      "activated": "Agreement {code} is active",
      "activateFailed": "The agreement could not be activated",
      "saveLines": "Save lines",
      "linesSaved": "Agreement lines saved",
      "linesFailed": "The agreement lines could not be saved",
      "linesCaption": "The lines this agreement prices by",
      "noLines": "No lines yet. An agreement with no lines prices nothing.",
      "precedenceNote": "An active agreement line resolves ahead of the customer's tier price list and the base list.",
      "readOnly": "You may read this agreement but not change it.",
      "rebatePrograms": "Rebate programs",
      "emptyTitle": "No trade agreements yet",
      "emptyDescription": "Create one to hold the prices and allowances agreed with a customer.",
      "loadFailed": "The trade agreements could not be loaded",
      "saved": "Agreement saved",
      "saveFailed": "The agreement could not be saved",
      "columns": {
        "code": "Code",
        "name": "Name",
        "appliesTo": "Applies to",
        "window": "Period",
        "lines": "Lines"
      },
      "statuses": {
        "draft": "Draft",
        "active": "Active",
        "suspended": "Suspended",
        "expired": "Expired",
        "cancelled": "Cancelled"
      },
      "kinds": {
        "fixed_price": "Fixed price",
        "discount_percent": "Discount %",
        "discount_amount": "Discount amount"
      },
      "aria": {
        "category": "Category for line {line}",
        "minQty": "Minimum quantity for line {line}",
        "value": "Value for line {line}",
        "priority": "Priority for line {line}"
      }
    },
    "rebates": {
      "title": "Rebate programs",
      "description": "Off-invoice allowances and growth incentives, accrued as they are earned.",
      "newProgram": "New program",
      "editProgram": "Edit program",
      "formDescription": "A program belongs to a trade agreement and posts to the two accounts named here.",
      "ladderDescription": "The tier ladder that computes what is owed.",
      "ladderCaption": "Rebate tiers, lowest band first",
      "basis": "Basis",
      "basisHint": "Whether the ladder is read against revenue or against quantity.",
      "period": "Period",
      "periodStart": "Period starts",
      "tierKind": "Tier kind",
      "tierKindHint": "Marginal charges each band its own rate; retrospective restates the whole period.",
      "expenseAccount": "Rebate expense account",
      "liabilityAccount": "Rebate liability account",
      "settlementMethod": "Settlement method",
      "seq": "Band",
      "minValue": "From",
      "maxValue": "To",
      "ratePercent": "Rate %",
      "rateAmount": "Rate amount",
      "addTier": "Add band",
      "saveTiers": "Save ladder",
      "tiersSaved": "Tier ladder saved",
      "tiersFailed": "The tier ladder could not be saved",
      "noTiers": "No bands yet. A program with no ladder accrues nothing.",
      "retrospectiveNote": "Retrospective tiers restate the whole period at the band reached, so the accrual can move sharply at period end.",
      "accountsNote": "Accrues to expense account {expense} and liability account {liability}.",
      "viewAccruals": "Accruals",
      "programSaved": "Program saved",
      "programFailed": "The program could not be saved",
      "emptyTitle": "No rebate programs yet",
      "emptyDescription": "Create one against a trade agreement to accrue an allowance as it is earned.",
      "loadFailed": "The rebate programs could not be loaded",
      "accrualsTitle": "Rebate accruals",
      "accrualsDescription": "What each customer has earned, period by period, and how it was settled.",
      "accrualsEmptyTitle": "No accruals yet",
      "accrualsEmptyDescription": "An accrual appears once qualifying revenue is posted in a program's period.",
      "accrualsLoadFailed": "The rebate accruals could not be loaded",
      "detailTitle": "Accrual from {period}",
      "detailDescription": "The documents that qualified, and what the ladder made of them.",
      "linesCaption": "Source documents that contributed to this accrual",
      "noLines": "Nothing has qualified in this period yet.",
      "qualifyingBase": "Qualifying base",
      "qualifyingAmount": "Qualifying amount",
      "qualifyingQty": "Qualifying qty",
      "accrued": "Accrued",
      "posted": "Posted",
      "settledAmount": "Settled",
      "alreadySettled": "Already settled",
      "remaining": "Remaining",
      "tier": "Band",
      "journal": "Journal entry",
      "sourceDoc": "Source document",
      "openNote": "This period is still open, so the accrued figure is a running total rather than a final one.",
      "close": "Close period",
      "closeTitle": "Close the accrual period",
      "closeDescription": "Closing fixes the liability for this period. Nothing further accrues to it.",
      "closed": "Accrual period closed",
      "closeFailed": "The accrual period could not be closed",
      "settle": "Settle",
      "settleTitle": "Settle rebate",
      "settleDescription": "Pay the accrued rebate out by credit note or by payment.",
      "settleConsequence": "Settling posts against the rebate liability and raises the credit note or payment. It is not reversible from this screen.",
      "settled": "Rebate settlement recorded ({status})",
      "settleFailed": "The rebate could not be settled",
      "overSettled": "More than the remaining balance.",
      "columns": {
        "code": "Code",
        "name": "Name",
        "agreement": "Agreement",
        "shape": "Shape",
        "tiers": "Bands",
        "program": "Program"
      },
      "bases": {
        "revenue": "Revenue",
        "quantity": "Quantity"
      },
      "periods": {
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "annual": "Annual"
      },
      "tierKinds": {
        "flat": "Flat",
        "tiered_marginal": "Tiered, marginal",
        "tiered_retrospective": "Tiered, retrospective"
      },
      "methods": {
        "credit_note": "Credit note",
        "payment": "Payment"
      },
      "accrualStatuses": {
        "open": "Open",
        "closed": "Closed",
        "settled": "Settled",
        "cancelled": "Cancelled"
      },
      "aria": {
        "minValue": "Band {tier} from",
        "maxValue": "Band {tier} to",
        "ratePercent": "Band {tier} rate percent",
        "rateAmount": "Band {tier} rate amount"
      }
    },
    "contracts": {
      "title": "Customer contracts",
      "description": "The terms a customer's quotations, orders and revenue answer to.",
      "newContract": "New contract",
      "editContract": "Edit contract",
      "formDescription": "A contract binds one customer for a period, optionally under a trade agreement.",
      "detailDescription": "What was agreed, when it is reviewed, and when it renews.",
      "tradeAgreement": "Trade agreement",
      "tradeAgreementHint": "The agreement whose prices this contract is governed by.",
      "renewalNoticeDays": "Renewal notice (days)",
      "renewalNoticeHint": "How long before the end date the renewal decision is owed.",
      "autoRenew": "Renews automatically",
      "autoRenewNote": "This contract renews itself unless notice is given {days} days before it ends.",
      "autoRenewsIn": "Auto-renews, {days} days notice",
      "noticeDays": "{days} days notice",
      "expiringBefore": "Expiring before",
      "expiringBeforeHint": "Contracts whose end date falls before this day.",
      "reviewBefore": "Price review before",
      "reviewBeforeHint": "Contracts due a price review before this day.",
      "activate": "Activate",
      "activateTitle": "Activate contract",
      "activateDescription": "An active contract governs the customer's documents. A draft governs nothing.",
      "activated": "Contract {code} is active",
      "activateFailed": "The contract could not be activated",
      "revRecObligations": "Performance obligations",
      "obligationsTitle": "Obligations and entitlements",
      "obligationsDescription": "The measurable commitments on both sides, and how far each has been met.",
      "obligationsCaption": "Contract obligations with their targets and measurements",
      "addObligation": "Add obligation",
      "saveObligations": "Save obligations",
      "obligationsSaved": "Obligations saved",
      "obligationsFailed": "The obligations could not be saved",
      "noObligations": "No obligations recorded against this contract.",
      "measuredNote": "The measured figure and the status are maintained by the server as documents post; neither can be typed here.",
      "seq": "No.",
      "kind": "Kind",
      "target": "Target",
      "measured": "Measured",
      "window": "Period",
      "dueOn": "Due",
      "emptyTitle": "No customer contracts yet",
      "emptyDescription": "Create one to hold the terms a customer's documents are governed by.",
      "loadFailed": "The customer contracts could not be loaded",
      "saved": "Contract saved",
      "saveFailed": "The contract could not be saved",
      "columns": {
        "code": "Code",
        "name": "Name",
        "window": "Period",
        "renewal": "Renewal",
        "priceReview": "Price review"
      },
      "statuses": {
        "draft": "Draft",
        "active": "Active",
        "expiring": "Expiring",
        "expired": "Expired",
        "terminated": "Terminated"
      },
      "kinds": {
        "volume": "Volume",
        "value": "Value",
        "service_level": "Service level",
        "price_review": "Price review",
        "other": "Other"
      },
      "obligationStatuses": {
        "open": "Open",
        "met": "Met",
        "missed": "Missed",
        "waived": "Waived"
      },
      "aria": {
        "description": "Description for obligation {row}",
        "target": "Target for obligation {row}",
        "periodStart": "Period start for obligation {row}",
        "periodEnd": "Period end for obligation {row}",
        "dueOn": "Due date for obligation {row}",
        "progress": "Obligation {row} is {percent} percent of its target"
      }
    },
    "obligations": {
      "pageTitle": "Revenue recognition",
      "pageDescription": "Performance obligations, their standalone prices and how each is satisfied.",
      "tabsLabel": "Revenue recognition sections",
      "title": "Performance obligations",
      "detailDescription": "What was promised, what it was allocated, and what has been recognised.",
      "method": "Method",
      "transactionPrice": "Transaction price",
      "ssp": "Standalone price",
      "allocated": "Allocated",
      "recognised": "Recognised",
      "window": "Period",
      "schedule": "Deferral schedule",
      "share": "{share} of the standalone prices",
      "residualHolder": "This obligation absorbed the residual: its allocation is what was left after the others were priced.",
      "dueBefore": "Due before",
      "milestone": "Milestone",
      "milestonesCaption": "Milestones and what each recognises when certified",
      "noMilestones": "No milestones recorded against this obligation.",
      "percent": "Share %",
      "certifiedAt": "Certified",
      "certify": "Certify",
      "certifyTitle": "Certify milestone",
      "certifyDescription": "Only this milestone's share of the allocated amount is recognised.",
      "certifiedOn": "Certified on",
      "certified": "Milestone certified",
      "certifyFailed": "The milestone could not be certified",
      "satisfy": "Satisfy",
      "satisfyTitle": "Satisfy obligation",
      "satisfyDescription": "The whole allocated amount is recognised on the date given.",
      "satisfiedOn": "Satisfied on",
      "satisfied": "Obligation satisfied",
      "satisfyFailed": "The obligation could not be satisfied",
      "overTimeNote": "This obligation recognises across its period. The worker posts each instalment; there is nothing to trigger here.",
      "emptyTitle": "No performance obligations yet",
      "emptyDescription": "An obligation is created when an order line with a revenue term is invoiced.",
      "loadFailed": "The performance obligations could not be loaded",
      "columns": {
        "source": "Source line"
      },
      "methods": {
        "point_in_time": "Point in time",
        "over_time": "Over time",
        "milestone": "Milestone"
      },
      "statuses": {
        "pending": "Pending",
        "in_progress": "In progress",
        "satisfied": "Satisfied",
        "cancelled": "Cancelled"
      }
    },
    "ssp": {
      "title": "Standalone selling prices",
      "description": "What each item would sell for on its own — the basis the transaction price is allocated by.",
      "caption": "Standalone selling prices by item and currency",
      "newPrice": "New price",
      "newDescription": "A standalone price applies to one item in one currency from a stated date.",
      "amount": "Standalone price",
      "method": "Method",
      "methodHint": "Observable is the strongest evidence; residual is only defensible where the price is highly variable.",
      "asAt": "In force on",
      "asAtHint": "Show only the prices in force on this date.",
      "window": "Effective",
      "inForce": "In force",
      "superseded": "Superseded",
      "supersede": "Supersede",
      "supersedeTitle": "Supersede standalone price",
      "supersedeDescription": "Close this price off and open its successor from a new date. The item and currency cannot change.",
      "noteHint": "How the figure was arrived at. Read by whoever audits the allocation.",
      "residualNote": "An allocation is only as defensible as the standalone prices behind it, so the method is recorded with every figure.",
      "empty": "No standalone selling prices recorded yet.",
      "loadFailed": "The standalone selling prices could not be loaded",
      "saved": "Standalone price saved",
      "saveFailed": "The standalone price could not be saved",
      "methods": {
        "observable": "Observable",
        "adjusted_market": "Adjusted market",
        "expected_cost_plus": "Expected cost plus margin",
        "residual": "Residual"
      }
    },
    "approval": {
      "pending": {
        "title": "Waiting for an approver",
        "viewApprovals": "Open the Approvals Inbox",
        "body": {
          "order": "This order is parked in pending approval. Someone other than the requester must decide it in the Approvals Inbox; it is confirmed automatically once approved.",
          "quote": "This quote stays a draft until its discount is approved by someone other than the requester. It is sent automatically once approved.",
          "amendment": "This amendment is waiting for an approver. The order stays pending approval until it is decided."
        }
      },
      "rejected": {
        "title": "The approval was rejected and the document is back in draft",
        "noteLabel": "Approver's note"
      },
      "unresolvable": {
        "title": "No approval policy covers this override",
        "body": "An override has to be decided by an approver other than you, and no approval policy is configured that resolves one, so the request was refused rather than waived. An approval policy must be configured before this can go ahead."
      }
    }
  },
  "hr": {
    "filtersTitle": "Filters",
    "allCompanies": "All legal entities",
    "routeTitles": {
      "employees": "Employees",
      "employeeNew": "New employee",
      "employee": "Employee",
      "workPermits": "Work permits",
      "leaveRequests": "Leave requests",
      "leaveCalendar": "Leave calendar",
      "leaveTypes": "Leave types",
      "attendance": "Attendance",
      "overtimeRules": "Overtime rules",
      "requisitions": "Hiring requisitions",
      "requisition": "Requisition",
      "candidates": "Candidates",
      "candidate": "Candidate",
      "offers": "Offers",
      "exit": "Exit",
      "exits": "Exits",
      "leaveBlackouts": "Leave policy depth",
      "permitQuotas": "Permit quotas",
      "workPermit": "Work permit",
      "skills": "Skills"
    },
    "fields": {
      "employee": "Employee",
      "company": "Legal Entity",
      "companyPlaceholder": "Choose a legal entity",
      "department": "Department",
      "branch": "Branch",
      "costCenter": "Cost centre",
      "unassigned": "Not assigned",
      "manager": "Reports to",
      "managerHint": "A manager cannot report to somebody who already reports to this person — the server refuses a loop.",
      "firstName": "First name",
      "lastName": "Last name",
      "preferredName": "Preferred name",
      "workEmail": "Work email",
      "emailHint": "An employee needs at least one address — work or personal.",
      "personalEmail": "Personal email",
      "employmentType": "Employment type",
      "joinedOn": "Joined on",
      "basicSalary": "Basic salary",
      "basicSalaryHint": "The monthly figure payroll prorates from. Typed and stored exactly as written.",
      "currency": "Currency",
      "pensionable": "Pension scheme",
      "pensionableLabel": "Enrolled in MPAO",
      "pensionableHint": "When enrolled, MPAO's employee and employer contributions are computed on the prorated basic salary. When not, both come to exactly nil.",
      "nationality": "Nationality",
      "expatriate": "Work permit",
      "expatriateLabel": "Employed on a work permit",
      "expatriateHint": "Marks this person for the daily permit-expiry sweep.",
      "workPermitNo": "Work permit number",
      "workPermitHint": "Encrypted on save and masked everywhere afterwards.",
      "workPermitReplaceHint": "Leave blank to keep the number on file. Typing one replaces it.",
      "workPermitExpiry": "Permit expires",
      "workPermitOnFile": "Permit on file",
      "notes": "Notes"
    },
    "employees": {
      "one": "Employee",
      "listTitle": "Employees",
      "listDescription": "The people this workspace employs, their contracts and their org assignment.",
      "detailDescription": "Contract, compensation, org assignment and sensitive details.",
      "newTitle": "New employee",
      "newDescription": "Bank details and statutory ids are not set here — they are raised as a change a second person approves.",
      "loadFailed": "The employee list did not load",
      "emptyTitle": "No employees yet",
      "emptyDescription": "Add the first person, or hire one through a requisition and convert the candidate.",
      "searchPlaceholder": "Search name, number or email",
      "pickerPlaceholder": "Type a number or a name",
      "noMatch": "No employee matches that",
      "matchCount": "{count} employees match",
      "railSubtitle": "Employee {employeeNo} · {status}",
      "created": "Employee added",
      "saved": "Employee saved",
      "terminated": "Employment ended",
      "terminatedDetail": "The leaving date is recorded. Payroll prorates the final period from it.",
      "conflictTitle": "Somebody else changed this employee while you had it open",
      "conflictBody": "Nothing was overwritten. Reload to see their version, then reapply your changes.",
      "tabsLabel": "Employee sections",
      "columns": {
        "employeeNo": "Number",
        "name": "Name",
        "title": "Job title",
        "department": "Department",
        "employmentType": "Type",
        "basicSalary": "Basic salary",
        "joinedOn": "Joined",
        "workPermit": "Permit",
        "workPermitExpiry": "Permit expiry"
      },
      "tabs": {
        "contract": "Contract and compensation",
        "details": "Bank and statutory details",
        "leave": "Leave balances",
        "employment": "Employment history",
        "skills": "Skills"
      },
      "actions": {
        "add": "Add employee",
        "backToList": "All employees",
        "terminate": "End employment",
        "reload": "Reload this employee"
      },
      "timeline": {
        "joined": "Joined",
        "created": "Record created",
        "left": "Left"
      },
      "terminate": {
        "title": "End this employment",
        "subject": "Ending employment for {name}",
        "consequence": "The employee stays on file and keeps every payslip already produced. Payroll will prorate the final period to the leaving date and will not include them afterwards.",
        "leftOn": "Last day of employment",
        "leftOnHint": "The final day worked, in this workspace's timezone.",
        "confirm": "End employment"
      },
      "statuses": {
        "active": "Active",
        "on_leave": "On leave",
        "suspended": "Suspended",
        "terminated": "Left"
      },
      "types": {
        "full_time": "Full time",
        "part_time": "Part time",
        "contract": "Contract",
        "intern": "Intern"
      }
    },
    "sensitive": {
      "bankTitle": "Payroll bank account",
      "statutoryTitle": "Statutory identifiers",
      "loadFailed": "The pending changes did not load",
      "noPermission": "You do not have permission to see this employee's bank or statutory details.",
      "maskedExplainer": "Bank account numbers and statutory ids are shown masked. Seeing a bank number in full is a separate action, and it is recorded against your name.",
      "bankEmptyTitle": "No bank account on file",
      "bankEmptyDescription": "Request one here. Nobody is paid by transfer until a second person has approved it.",
      "statutoryEmptyTitle": "No statutory ids on file",
      "statutoryEmptyDescription": "A national id and a tax id can be requested here; a second person applies them.",
      "statutoryNoReveal": "Statutory ids have no reveal: they are stored encrypted and only ever shown masked, including to you.",
      "historyTitle": "Decided changes",
      "historyExplainer": "Requests that have already been applied or refused. The full record, with who and when, is in the audit trail.",
      "statuses": {
        "pending": "Awaiting approval",
        "approved": "Approved",
        "applied": "Applied",
        "rejected": "Rejected"
      },
      "kinds": {
        "bank": "Bank details",
        "statutory": "Statutory ids"
      },
      "fields": {
        "bankName": "Bank",
        "branch": "Branch",
        "accountName": "Account name",
        "accountNo": "Account number",
        "ibanLabel": "International account number",
        "swiftLabel": "Bank identifier code",
        "currency": "Currency",
        "nationalId": "National id",
        "taxId": "Tax id"
      },
      "actions": {
        "reveal": "Reveal number",
        "requestBankNew": "Request a bank account",
        "requestBankChange": "Request a change",
        "requestStatutoryChange": "Request a change",
        "approveChange": "Approve this change",
        "rejectChange": "Reject"
      },
      "pending": {
        "headline": "A change to these details is awaiting approval.",
        "explainer": "Nothing has changed yet: payroll still pays into the account shown below until somebody other than the requester approves it.",
        "explainerStatutory": "Nothing has changed yet: the ids below are still the ones on file until somebody other than the requester approves the change.",
        "requestedBank": "Requested: {bank}, {masked}",
        "requestedStatutory": "Requested: national id {nationalId}, tax id {taxId}",
        "reason": "Reason given: {reason}"
      },
      "form": {
        "bankTitle": "Request a change to the payroll bank account",
        "statutoryTitle": "Request a change to the statutory ids",
        "subject": "For {name}",
        "dualApprovalHeadline": "This creates a request, not a change.",
        "dualApproval": "Nothing about where this person is paid changes until somebody other than you approves it.",
        "accountNameHint": "The name the bank holds the account under, spelled as the bank spells it.",
        "accountNoHint": "Typed once here, encrypted immediately, and masked everywhere afterwards.",
        "accountNoAgain": "Account number again",
        "accountNoRetype": "Type it a second time. There is no stored plaintext to prefill from, and retyping is what makes a transposed digit visible.",
        "accountNoRequired": "An account number is required.",
        "accountNoMismatch": "The two account numbers do not match.",
        "currencyHint": "Three-letter ISO 4217 code, such as MVR.",
        "statutoryHint": "At least one of a national id or a tax id is required.",
        "statutoryRequired": "Give at least a national id or a tax id.",
        "reasonLabel": "Reason",
        "reasonHint": "Say who asked for this and how you verified it. The approver reads this, and so will an auditor.",
        "reasonRequired": "A reason is required.",
        "submit": "Send for approval",
        "working": "Sending the request",
        "requested": "Request sent for approval",
        "requestedDetail": "Nothing has changed yet for {name}. A second person has to approve it first."
      },
      "reveal": {
        "title": "Reveal the account number",
        "subject": "{name}, account {masked}",
        "recorded": "This will be recorded in the audit log under your name, {name}, together with the reason you give below.",
        "reasonLabel": "Why do you need to see this number?",
        "reasonHint": "For example: the bank rejected the salary transfer and the digits need checking. An auditor will read this.",
        "reasonRequired": "A reason is required before the number can be shown.",
        "confirm": "Reveal it",
        "working": "Revealing",
        "countdown": "This disappears in {seconds} seconds. It is not copied or stored anywhere.",
        "hideNow": "Hide it now",
        "done": "Done"
      },
      "decide": {
        "approveTitle": "Approve this change",
        "rejectTitle": "Reject this change",
        "subject": "A pending change for {name}",
        "approveConsequence": "Approving applies the new details immediately. From this moment the employee is paid into the requested account.",
        "rejectConsequence": "Rejecting leaves the current details in place. The requester is told, and the reason is recorded.",
        "commentLabel": "Comment",
        "commentHint": "The requester sees this, and it stays on the audit record.",
        "notYours": "You raised this request, so somebody else has to approve it.",
        "working": "Recording the decision",
        "approved": "Change approved",
        "approvedDetail": "The new details are in effect.",
        "rejected": "Change rejected",
        "rejectedDetail": "The details on file are unchanged."
      },
      "stepUp": {
        "required": "Confirm your second factor again before this is allowed, then try once more.",
        "notEnrolled": "This action needs two-factor authentication, and your account has none enrolled yet.",
        "link": "Set it up on your profile"
      }
    },
    "permits": {
      "listTitle": "Work permits",
      "listDescription": "Every permit approaching or past its expiry, worst first.",
      "loadFailed": "The permit list did not load",
      "emptyTitle": "No permits to watch",
      "emptyDescription": "Nobody on file has a work-permit expiry recorded. Add one on the employee's contract tab.",
      "noneOnFile": "No expiry recorded",
      "thresholdsExplainer": "A daily job alerts at {thresholds} days before expiry, and again once a permit has lapsed. This screen buckets by the same days, so what is urgent here is what somebody has already been told about.",
      "bannerExpired": "This work permit lapsed {days} days ago.",
      "bannerCritical": "This work permit expires in {days} days.",
      "columns": {
        "status": "Time left",
        "daysLeft": "Days left",
        "expiresOn": "Expires on",
        "kind": "Permit kind",
        "medical": "Medical clearance",
        "permitNo": "Permit no.",
        "quotaCategory": "Quota category"
      },
      "urgency": {
        "expired": "Lapsed {days} days ago",
        "critical": "{days} days left",
        "soon": "{days} days left",
        "watch": "{days} days left",
        "ok": "{days} days left",
        "none": "No expiry recorded"
      },
      "kpi": {
        "expired": "Lapsed",
        "expiredHelp": "Permits whose expiry date has already passed.",
        "critical": "Within a week",
        "criticalHelp": "Permits expiring within seven days — the sweep's loudest band.",
        "soon": "Within a month",
        "soonHelp": "Permits expiring within thirty days.",
        "medicalLapsed": "Medical lapsed",
        "medicalLapsedHelp": "A live permit whose clearance has expired does not authorise work."
      },
      "actions": {
        "activate": "Activate",
        "cancelPermit": "Cancel permit",
        "new": "New permit",
        "recordMedical": "Record medical clearance",
        "reveal": "Reveal permit number"
      },
      "anyStatus": "Any status",
      "create": {
        "description": "A permit that would take its category past its cap is refused.",
        "title": "New work permit"
      },
      "created": "Permit created",
      "detailDescription": "The permit, its quota consumption and its medical clearance.",
      "detailTitle": "Work permit",
      "expiringBefore": "Expiring before",
      "fields": {
        "employeeId": "Employee id",
        "issuedOn": "Issued on",
        "jurisdictionId": "Jurisdiction id",
        "permitNo": "Permit number",
        "permitNoHint": "Stored encrypted. Every response and log carries only the mask.",
        "quotaHint": "Blank consumes no quota.",
        "sponsor": "Sponsor"
      },
      "medical": {
        "clearedOn": "Cleared on",
        "description": "Two dates: when it was cleared and when the clearance expires.",
        "expiresOn": "Clearance expires",
        "lapsedExplainer": "This permit's medical clearance has expired. Assignments and roster lines for this person will be refused until it is renewed.",
        "recorded": "Medical clearance recorded",
        "reference": "Reference",
        "title": "Record medical clearance"
      },
      "medicalLapsed": "Medical lapsed",
      "noQuota": "No quota",
      "quota": {
        "actions": {
          "new": "New quota"
        },
        "available": "Available",
        "cap": "Cap",
        "consumed": "Consumed",
        "create": {
          "description": "A new cap supersedes the old one from its effective date; permits issued under the old cap stay legal.",
          "title": "New permit quota"
        },
        "description": "How much of this category is already used.",
        "edit": {
          "title": "Edit permit quota"
        },
        "emptyDescription": "Without a quota nothing is capped. Add one per category the regulator sets.",
        "emptyTitle": "No quotas set",
        "explainer": "A permit that would take a category past its cap is refused outright — there is no override for anybody.",
        "full": "This category is full. The next permit in it will be refused.",
        "loadFailed": "The quotas could not be loaded",
        "packReadOnly": "From a pack",
        "pageDescription": "The cap per category, per legal entity, per jurisdiction — effective-dated, because a cap is revised by regulation.",
        "pageTitle": "Permit quotas",
        "saved": "Quota saved",
        "source": "Source",
        "sources": {
          "pack": "Pack",
          "tenant": "Own control"
        },
        "title": "Quota"
      },
      "quotasLink": "Quotas",
      "reveal": {
        "auditNote": "This writes an audit record naming you and your reason.",
        "description": "The plaintext is shown once and is never cached.",
        "reasonHint": "An auditor will read this beside your name.",
        "reasonLabel": "Why you need it",
        "stepUp": "A fresh second factor is needed before the number can be shown.",
        "temporary": "Shown once. Close this to drop it.",
        "title": "Reveal permit number"
      },
      "status": {
        "confirm": "Set the permit to {status}?",
        "description": "The status decides whether this permit authorises work.",
        "title": "Change permit status"
      },
      "statusChanged": "Permit status changed",
      "statuses": {
        "active": "Active",
        "cancelled": "Cancelled",
        "expired": "Expired",
        "pending": "Pending",
        "rejected": "Rejected"
      },
      "companyScopeHint": "Scopes the employee names shown, not the register itself."
    },
    "leave": {
      "listTitle": "Leave requests",
      "listDescription": "Who has asked for time off, what it costs their balance, and what was decided.",
      "loadFailed": "The leave list did not load",
      "emptyTitle": "No leave requests yet",
      "emptyDescription": "Raise one for an employee, or wait for theirs to arrive here.",
      "calendarTitle": "Leave calendar",
      "calendarDescription": "Who is away, and when. Approved and submitted leave only.",
      "balancesDescription": "Credited by the monthly accrual job and reduced when leave is approved.",
      "noBalancesTitle": "No balances yet",
      "noBalancesDescription": "Balances appear once the accrual job has credited a month, or a leave type has been set up.",
      "viewRequests": "See this employee's leave requests",
      "days": "days",
      "paid": "Paid",
      "unpaid": "Unpaid",
      "cancelled": "Leave request cancelled",
      "columns": {
        "requestNo": "Request",
        "type": "Type",
        "from": "From",
        "to": "To",
        "days": "Days",
        "paid": "Paid"
      },
      "fields": {
        "type": "Leave type",
        "typePlaceholder": "Choose a leave type",
        "balance": "Balance now",
        "startDate": "First day away",
        "endDate": "Last day away",
        "unpaid": "Unpaid leave",
        "unpaidLabel": "Take this as unpaid leave",
        "unpaidHint": "Unpaid days reduce the payable days payroll prorates the period by.",
        "reason": "Reason"
      },
      "actions": {
        "request": "Request leave",
        "cancel": "Cancel"
      },
      "statuses": {
        "draft": "Draft",
        "submitted": "Awaiting decision",
        "approved": "Approved",
        "rejected": "Rejected",
        "cancelled": "Cancelled"
      },
      "form": {
        "title": "Request leave",
        "description": "The days are counted the way the balance is charged: calendar days, both ends included.",
        "daysCount": "{days} calendar days",
        "daysUnknown": "Choose a start and an end date",
        "calendarDaysExplainer": "Weekends and public holidays are counted: this workspace has no holiday calendar, so a request spanning a weekend costs more days than a hand count would.",
        "rangeInvalid": "The last day cannot be before the first.",
        "employeeRequired": "Choose an employee.",
        "typeRequired": "Choose a leave type.",
        "typeUnpaidHint": "{name} is an unpaid leave type — these days reduce the payable days payroll prorates by.",
        "reasonHint": "Whoever decides this reads it.",
        "submit": "Submit request",
        "created": "Leave requested",
        "createdDetail": "{requestNo} for {days} days is awaiting a decision."
      },
      "decide": {
        "approveTitle": "Approve this leave",
        "rejectTitle": "Reject this leave",
        "subject": "{requestNo} — {name}, {days} days",
        "approveConsequence": "Approving charges the days against the employee's balance and marks them away on the calendar.",
        "rejectConsequence": "Rejecting leaves the balance untouched. The requester sees your reason.",
        "commentLabel": "Comment",
        "commentHint": "The requester sees this and it stays on the audit record.",
        "commentRequired": "Say why this is being rejected.",
        "approved": "Leave approved",
        "rejected": "Leave rejected"
      },
      "cancelDialog": {
        "title": "Cancel this leave request",
        "consequence": "Cancelling returns the days to the balance. A request that has already started cannot be cancelled.",
        "confirm": "Cancel the request"
      },
      "calendar": {
        "previousMonth": "Previous month",
        "nextMonth": "Next month",
        "today": "This month",
        "inMonth": "{count} in this month",
        "scopeExplainer": "Approved and submitted leave only. A rejected or cancelled request is not an absence and is not drawn here.",
        "entryTitle": "{name} on leave — {type} ({status})",
        "weekdays": {
          "mon": "Mon",
          "tue": "Tue",
          "wed": "Wed",
          "thu": "Thu",
          "fri": "Fri",
          "sat": "Sat",
          "sun": "Sun"
        }
      }
    },
    "leaveTypes": {
      "listTitle": "Leave types",
      "listDescription": "The kinds of leave this workspace grants, and how much of each accrues per month.",
      "loadFailed": "The leave types did not load",
      "emptyTitle": "No leave types yet",
      "emptyDescription": "Add one — annual leave is usually first — and the monthly accrual will start crediting it.",
      "saved": "Leave type saved",
      "active": "Active",
      "inactive": "Retired",
      "approvalRequired": "Needs approval",
      "approvalNotRequired": "Automatic",
      "columns": {
        "code": "Code",
        "accrual": "Days accrued per month",
        "maxBalance": "Maximum balance",
        "paid": "Paid",
        "approval": "Approval"
      },
      "actions": {
        "add": "Add leave type",
        "runAccrual": "Run accrual now"
      },
      "form": {
        "createTitle": "Add a leave type",
        "editTitle": "Edit this leave type",
        "description": "Accrual figures are decimals — 1.75 days a month is an ordinary policy.",
        "codeHint": "Short and permanent, such as ANNUAL. It cannot be changed later.",
        "accrualHint": "Credited by the monthly job to every employee active during the month.",
        "maxBalanceHint": "Leave blank for no cap.",
        "isPaid": "Paid leave",
        "isPaidHint": "Unpaid types reduce the payable days payroll prorates a period by.",
        "requiresApproval": "Requires approval",
        "requiresApprovalHint": "When off, a request of this type is granted as soon as it is raised.",
        "isActive": "Available for new requests",
        "isActiveHint": "Retiring a type keeps existing balances and stops new requests against it."
      },
      "accrual": {
        "title": "Run the monthly leave accrual",
        "description": "The same job the worker runs nightly, fired now against a date you choose.",
        "safeHeadline": "Running this twice is safe.",
        "safeExplainer": "At most one credit exists per employee, leave type and calendar month, and a database constraint is what guarantees it — not this screen. A second run reports everything it skipped.",
        "onLabel": "Run as of",
        "onHint": "The accrual credits the calendar month this date falls in.",
        "confirm": "Run the accrual",
        "working": "Running",
        "resultTitle": "Accrual for {month}/{year}",
        "resultBody": "{processed} employees credited, {skipped} skipped because the month was already credited."
      },
      "classes": {
        "annual": "Annual",
        "compassionate": "Compassionate",
        "hajj": "Hajj",
        "maternity": "Maternity",
        "other": "Other",
        "paternity": "Paternity",
        "sick": "Sick",
        "study": "Study",
        "unpaid": "Unpaid"
      },
      "coverage": {
        "block": "Refuse",
        "none": "No check",
        "warn": "Warn"
      },
      "dayBasis": {
        "calendar": "Calendar days",
        "working": "Working days"
      },
      "depth": {
        "carryForward": "Allow carry-forward",
        "carryForwardExpiry": "Carried days expire after (months)",
        "carryForwardExpiryHint": "Leave blank for carried days that never expire.",
        "carryForwardHint": "Unused days move into the next leave year.",
        "carryForwardMaxDays": "Maximum days carried",
        "certificateAfterDays": "Certificate required after",
        "certificateHint": "Days beyond which a medical certificate must be attached.",
        "coverageCheck": "Coverage check",
        "coverageHint": "Whether a request that would leave a department short is warned about or refused.",
        "dayBasis": "Day counting",
        "dayBasisExistingHint": "Changing this changes what every future request counts. Existing balances are not rewritten.",
        "dayBasisNewHint": "Working days exclude the calendar's non-working days and holidays.",
        "encashable": "Allow encashment",
        "encashableHint": "Days may be converted to money through a pay component.",
        "encashmentComponent": "Pay component code",
        "encashmentComponentHint": "The component an encashment is paid through. Required when encashment is allowed.",
        "encashmentMaxDays": "Maximum days encashable",
        "leaveClass": "Leave class",
        "leaveClassHint": "Used to match a statutory minimum from the jurisdiction pack.",
        "maxDaysPerInstance": "Maximum days per request",
        "qualifyingMonths": "Qualifying months",
        "qualifyingMonthsHint": "Months of service before this leave may be taken.",
        "statutoryFloor": "Statutory minimum: {days} days a year",
        "statutoryFloorHint": "From the jurisdiction pack. This type may exceed it and may not undercut it.",
        "title": "Policy depth"
      }
    },
    "attendance": {
      "listTitle": "Attendance",
      "listDescription": "Hours worked, and the overtime payroll will price from them.",
      "loadFailed": "The attendance list did not load",
      "emptyTitle": "No attendance recorded",
      "emptyDescription": "Log a day, or import a month from your time system as CSV.",
      "approved": "Approved",
      "notApproved": "Not approved",
      "approvedToast": "Attendance approved",
      "saved": "Attendance saved",
      "columns": {
        "workDate": "Date",
        "hours": "Hours",
        "overtime": "Overtime",
        "rule": "Rule",
        "source": "Source"
      },
      "sources": {
        "manual": "Entered",
        "import": "Imported"
      },
      "fields": {
        "from": "From",
        "to": "To",
        "approvedOnly": "Approval"
      },
      "actions": {
        "log": "Log a day",
        "import": "Import CSV"
      },
      "form": {
        "logTitle": "Log a day's attendance",
        "editTitle": "Edit this day's hours",
        "description": "Enter the hours worked. Overtime is worked out by the server against the matching rule.",
        "hoursHint": "Decimal hours, such as 8 or 9.5.",
        "employeeRequired": "Choose an employee.",
        "overtimeExplainer": "Overtime hours are computed on save, from the active overtime rule that matches these hours. They are not typed here, because payroll prices exactly what the server recorded."
      },
      "approveDialog": {
        "title": "Approve this attendance",
        "subject": "{name} on {date}, {overtime} overtime hours",
        "consequence": "Payroll counts overtime only from approved rows. Approving this makes these hours payable."
      },
      "import": {
        "title": "Import attendance from CSV",
        "description": "Every imported row starts unapproved — payroll never prices overtime nobody has looked at.",
        "formatTitle": "Required columns",
        "formatBody": "A header row naming employee_no, work_date and hours_worked. Other columns are ignored, and their order does not matter.",
        "sample": "employee_no,work_date,hours_worked\nEMP-2026-0012,2026-08-01,8\nEMP-2026-0012,2026-08-02,9.5",
        "fileLabel": "Choose a file",
        "fileHint": "The file is read in the browser and its text is sent as-is.",
        "contentLabel": "CSV contents",
        "confirm": "Import",
        "working": "Importing",
        "imported": "{count} rows imported",
        "skipped": "{count} rows were skipped",
        "skipRow": "Row {row}: {reason}"
      }
    },
    "overtimeRules": {
      "listTitle": "Overtime rules",
      "listDescription": "The daily thresholds that turn hours worked into overtime hours.",
      "loadFailed": "The overtime rules did not load",
      "emptyTitle": "No overtime rules yet",
      "emptyDescription": "Add one and attendance logged after it will be classified against it.",
      "saved": "Overtime rule saved",
      "notRetroactive": "Editing a rule does not reprice attendance already recorded: hours were classified when the day was logged. Recalculate a payroll run to pick up newly logged hours.",
      "columns": {
        "code": "Code",
        "threshold": "Daily threshold (hours)",
        "multiplier": "Multiplier"
      },
      "actions": {
        "add": "Add rule"
      },
      "form": {
        "createTitle": "Add an overtime rule",
        "editTitle": "Edit this overtime rule",
        "description": "The threshold decides when overtime starts; the multiplier is carried for reference, and a pay component prices the hours.",
        "codeHint": "Short and permanent, such as OT150. It is the bucket a pay component names.",
        "thresholdHint": "Hours in a day beyond which the rest counts as overtime.",
        "multiplierHint": "For example 1.5. The amount paid comes from the pay component, not from here.",
        "isActive": "In use",
        "isActiveHint": "A retired rule stops classifying new attendance and leaves old rows alone."
      }
    },
    "requisitions": {
      "one": "Requisition",
      "listTitle": "Hiring requisitions",
      "listDescription": "Headcount requests, and the candidates raised against them.",
      "detailTitle": "Requisition",
      "loadFailed": "The requisition did not load",
      "emptyTitle": "No requisitions yet",
      "emptyDescription": "Raise one to start collecting candidates against a named headcount.",
      "created": "Requisition raised",
      "saved": "Requisition saved",
      "opened": "Requisition opened",
      "openedDetail": "Candidates can now be filed against it.",
      "candidatesDescription": "Everybody filed against this requisition.",
      "noCandidatesTitle": "No candidates yet",
      "noCandidatesDescription": "Add one from the candidates screen and file it against this requisition.",
      "viewAllCandidates": "See all candidates for this requisition",
      "columns": {
        "requisitionNo": "Requisition",
        "title": "Role",
        "headcount": "Headcount"
      },
      "fields": {
        "justification": "Justification"
      },
      "actions": {
        "add": "Raise a requisition",
        "backToList": "All requisitions",
        "open": "Open for candidates"
      },
      "form": {
        "title": "Raise a hiring requisition",
        "description": "A headcount request. It becomes open to candidates once submitted.",
        "justificationHint": "Why this headcount is needed. Whoever approves it reads this."
      },
      "statuses": {
        "draft": "Draft",
        "open": "Open",
        "closed": "Closed",
        "cancelled": "Cancelled"
      },
      "statusExplainers": {
        "draft": "Still a draft. Open it for candidates when the headcount is agreed.",
        "open": "Open — candidates can be filed against this requisition.",
        "closed": "Closed. The headcount has been filled or withdrawn.",
        "cancelled": "Cancelled. Nothing further can be raised against it."
      },
      "position": {
        "action": "Establishment",
        "title": "Recruit against",
        "description": "The position, grade and location this requisition is filling, and what interviewers score against.",
        "rangeNote": "A grade here is what gives an offer raised from this requisition a salary band to be checked against. Left unset, the band check has nothing to compare.",
        "unreadable": "The API has no read for these fields yet, so the form starts empty. Saving replaces whatever is recorded.",
        "position": "Position",
        "grade": "Grade",
        "gradeHint": "Set a grade directly, or leave it to the position’s own grade.",
        "location": "Location",
        "criteria": "Scorecard criteria",
        "criteriaHint": "One per line. These are what an interviewer scores.",
        "saved": "Establishment attached"
      }
    },
    "candidates": {
      "one": "Candidate",
      "listTitle": "Candidates",
      "listDescription": "People being considered, and where each of them has got to.",
      "detailTitle": "Candidate",
      "timelineTitle": "Stage history",
      "loadFailed": "The candidate did not load",
      "emptyTitle": "No candidates yet",
      "emptyDescription": "Add one, or file an applicant against an open requisition.",
      "searchPlaceholder": "Search name or email",
      "created": "Candidate added",
      "saved": "Candidate saved",
      "advanced": "Stage recorded",
      "converted": "Candidate converted to an employee",
      "convertedNote": "This candidate has already been converted into an employee.",
      "notConverted": "Not converted",
      "viewEmployee": "View the employee",
      "noTimelineTitle": "No stage history yet",
      "noTimelineDescription": "Every stage change is recorded here as it happens.",
      "columns": {
        "candidateNo": "Candidate",
        "source": "Source",
        "stage": "Stage",
        "employee": "Employee"
      },
      "fields": {
        "rating": "Rating",
        "ratingHint": "A whole number, usually 1 to 5."
      },
      "actions": {
        "add": "Add candidate",
        "backToList": "All candidates",
        "advance": "Move stage",
        "convert": "Convert to employee"
      },
      "form": {
        "title": "Add a candidate",
        "description": "Filing them against a requisition is optional — a speculative application is still a candidate.",
        "sourceHint": "Where they came from, such as a referral or a job board.",
        "noRequisition": "No requisition"
      },
      "advance": {
        "title": "Move this candidate to another stage",
        "description": "Every move is recorded with its note and stays on the stage history.",
        "stageLabel": "New stage",
        "stagePlaceholder": "Choose a stage",
        "noteLabel": "Note"
      },
      "convert": {
        "title": "Convert this candidate into an employee",
        "subject": "Hiring {name}",
        "consequenceHeadline": "This creates a paid employee.",
        "consequence": "An employee record is created with the salary entered below, and payroll will include them from their joining date. Bank details are not set here — they are raised separately and approved by a second person.",
        "confirm": "Create the employee"
      },
      "stages": {
        "applied": "Applied",
        "screening": "Screening",
        "interview": "Interview",
        "offer": "Offer",
        "hired": "Hired",
        "rejected": "Rejected"
      },
      "scorecards": {
        "title": "Interview scorecards",
        "description": "One scorecard per interviewer, individually attributed and locked on submission.",
        "emptyTitle": "No scorecards yet",
        "emptyDescription": "Submit one once an interview has taken place.",
        "draft": "Draft",
        "submittedOn": "Submitted {date}",
        "saved": "Scorecard saved as a draft",
        "submitted": "Scorecard submitted",
        "actions": {
          "submit": "Submit scorecard",
          "saveDraft": "Save as draft"
        },
        "fields": {
          "stage": "Interview stage",
          "recommendation": "Recommendation",
          "overallScore": "Overall score",
          "criteria": "Criteria",
          "criterion": "Criterion",
          "score": "Score",
          "criterionNote": "Evidence"
        },
        "recommendations": {
          "strong_hire": "Strong hire",
          "hire": "Hire",
          "no_hire": "No hire",
          "strong_no_hire": "Strong no hire"
        },
        "form": {
          "title": "Submit an interview scorecard",
          "description": "Individually attributed to you, and locked once submitted.",
          "recommendationPlaceholder": "Choose a recommendation",
          "addCriterion": "Add criterion",
          "removeCriterion": "Remove criterion {line}",
          "submitLabel": "Submit now",
          "submitHint": "Locks the scorecard and attributes it to you. Leave unchecked to save a draft you can submit later."
        }
      },
      "references": {
        "title": "References",
        "description": "Structured reference requests and what each referee said.",
        "emptyTitle": "No references requested yet",
        "emptyDescription": "Request one from a referee the candidate has named.",
        "requested": "Reference requested",
        "recorded": "Response recorded",
        "actions": {
          "request": "Request reference",
          "record": "Record response"
        },
        "fields": {
          "refereeName": "Referee name",
          "refereeOrganisation": "Organisation",
          "refereeContact": "Contact",
          "relationship": "Relationship to candidate",
          "outcome": "Outcome",
          "response": "What they said"
        },
        "statuses": {
          "requested": "Requested",
          "received": "Received"
        },
        "outcomes": {
          "positive": "Positive",
          "mixed": "Mixed",
          "negative": "Negative",
          "no_response": "No response"
        },
        "form": {
          "title": "Request a reference",
          "description": "Sends a structured reference request and records it against the candidate."
        },
        "respond": {
          "title": "Record what the referee said",
          "outcomePlaceholder": "Choose an outcome"
        }
      }
    },
    "offers": {
      "listTitle": "Offers",
      "listDescription": "What has been offered, to whom, and what came of it.",
      "loadFailed": "The offer list did not load",
      "emptyTitle": "No offers yet",
      "emptyDescription": "Draft one from a candidate once they reach the offer stage.",
      "created": "Offer drafted",
      "viewAll": "All offers",
      "recordExplainer": "These actions record what happened. Marking an offer accepted means the candidate accepted it — it is not an internal approval.",
      "columns": {
        "offerNo": "Offer",
        "title": "Proposed role",
        "salary": "Proposed salary",
        "startDate": "Start date"
      },
      "actions": {
        "draft": "Draft an offer",
        "send": "Mark as sent",
        "accept": "Record acceptance",
        "decline": "Record decline",
        "withdraw": "Withdraw"
      },
      "done": {
        "send": "Offer marked as sent",
        "accept": "Acceptance recorded",
        "decline": "Decline recorded",
        "withdraw": "Offer withdrawn"
      },
      "confirm": {
        "sendTitle": "Mark this offer as sent",
        "sendConsequence": "Records that the offer has gone to the candidate. It does not send an email.",
        "acceptTitle": "Record that the candidate accepted",
        "acceptConsequence": "Records the candidate's acceptance. Converting them into an employee is a separate step.",
        "declineTitle": "Record that the candidate declined",
        "declineConsequence": "Records the candidate's refusal. The offer cannot be revived afterwards.",
        "withdrawTitle": "Withdraw this offer",
        "withdrawConsequence": "Withdraws the offer on this side. It cannot be revived afterwards.",
        "legalActions": "The recorded actions are: {actions}."
      },
      "form": {
        "title": "Draft an offer",
        "description": "A draft records what is being proposed. Sending, acceptance and refusal are recorded afterwards.",
        "salaryHint": "The monthly basic salary being offered, exactly as written.",
        "draftExplainer": "Drafting an offer does not notify anybody. Mark it as sent once it has actually gone out."
      },
      "statuses": {
        "draft": "Draft",
        "sent": "Sent",
        "accepted": "Accepted",
        "declined": "Declined",
        "withdrawn": "Withdrawn"
      },
      "position": {
        "action": "Establishment",
        "title": "Offer made against",
        "description": "The grade, position and pay group this offer is made against.",
        "resetNote": "Saving this resets any range check already recorded on the offer. The next send re-derives it — including any override that was approved.",
        "unreadable": "The API has no read for these fields yet, so the form starts empty. Saving replaces whatever is recorded.",
        "grade": "Grade",
        "gradeHint": "The band the proposed salary is checked against.",
        "position": "Position",
        "payGroup": "Pay group",
        "saved": "Establishment attached"
      }
    },
    "assignments": {
      "dialog": {
        "changeFteLabel": "Change full-time equivalent",
        "changeLocationLabel": "Change location",
        "changeManagerLabel": "Change manager",
        "changeNoticeLabel": "Change notice period",
        "changeOrgLabel": "Change department, branch or cost centre",
        "changePayGroupLabel": "Change pay group",
        "changePensionableLabel": "Change pension enrolment",
        "changePositionLabel": "Change position",
        "changeProbationLabel": "Change probation end date",
        "changeSalaryLabel": "Change basic salary",
        "changeShiftPatternLabel": "Change shift pattern",
        "changeTypeLabel": "Change employment type",
        "currentTitle": "In force today",
        "description": "The change takes effect from a date. What came before it is kept.",
        "effectiveFromHint": "A date inside a period payroll has already posted raises retro pay.",
        "noCompensation": "Your roles do not include seeing or setting pay, so the salary field is not shown.",
        "salaryHint": "The exact amount, as it should appear on a payslip.",
        "saveWithRetro": "Save and raise retro pay",
        "title": "Change employment terms"
      },
      "fields": {
        "basicSalary": "Basic salary",
        "branchId": "Branch",
        "costCenterId": "Cost centre",
        "departmentId": "Department",
        "effectiveFrom": "Effective from",
        "employmentStatus": "Employment status",
        "employmentType": "Employment type",
        "fte": "Full-time equivalent",
        "locationId": "Location",
        "managerId": "Reports to",
        "noticeDays": "Notice period (days)",
        "note": "Note",
        "payGroupId": "Pay group",
        "pensionable": "Enrolled in the pension scheme",
        "positionId": "Position",
        "probationEndOn": "Probation end date",
        "reasonCode": "Reason",
        "shiftPatternId": "Shift pattern"
      },
      "history": {
        "actions": {
          "change": "Change terms"
        },
        "correctable": "This version has not started yet, so it may still be corrected.",
        "description": "Every version of this person's terms, newest first. A superseded version is never edited.",
        "emptyDescription": "No assignment has been recorded for this employee yet.",
        "inForce": "In force",
        "loadFailed": "The employment history could not be loaded",
        "ongoing": "ongoing",
        "superseded": "Superseded",
        "title": "Employment history"
      },
      "preview": {
        "checking": "Checking…",
        "closesAt": "The version in force closes on {date}.",
        "description": "Checked against the server before anything is written.",
        "diffCaption": "Fields this change would alter",
        "field": "Field",
        "from": "From",
        "noChanges": "Nothing would change. Alter a field before saving.",
        "retroClear": "No posted period is affected, so no retro pay arises.",
        "retroUnknown": "This deployment has no retro-pay engine wired, so whether a posted period is affected is not known.",
        "retroWarning": "This date falls inside a period payroll has already posted. The difference will be paid as retro pay in a later run; the posted payslip is not rewritten.",
        "title": "What this will do",
        "to": "To"
      },
      "reasons": {
        "contract_change": "Contract change",
        "correction_of_terms": "Correction of terms",
        "demotion": "Demotion",
        "other": "Other",
        "pay_review": "Pay review",
        "probation_completed": "Probation completed",
        "promotion": "Promotion",
        "transfer": "Transfer"
      },
      "saved": "Terms changed",
      "savedWithRetro": "Terms changed — retro pay raised"
    },
    "exits": {
      "actions": {
        "finalPay": "Raise final pay",
        "initiate": "Initiate exit",
        "settle": "Settle"
      },
      "blockedByClearance": "{count} mandatory item(s) still open",
      "blockingExplainer": "The final pay cannot be released while a mandatory clearance item is open:",
      "clearance": {
        "actions": {
          "add": "Add item",
          "clear": "Clear",
          "waive": "Waive"
        },
        "add": {
          "description": "What must come back, and from whom.",
          "title": "Add a clearance item"
        },
        "added": "Clearance item added",
        "categories": {
          "access_revocation": "Access revocation",
          "asset_return": "Asset return",
          "financial": "Financial",
          "handover": "Handover",
          "other": "Other",
          "statutory": "Statutory"
        },
        "cleared": "Item cleared",
        "columns": {
          "category": "Category",
          "item": "Item",
          "mandatory": "Mandatory",
          "owner": "Owner",
          "recoverable": "Recoverable"
        },
        "description": "Signed off by the asset, IT and finance owners — none of whom is HR.",
        "emptyDescription": "No clearance items yet. Add the assets, accesses and balances that must come back.",
        "mandatoryHint": "A mandatory item blocks the final pay until it is cleared or waived.",
        "noPermission": "Your roles do not include signing clearance items off.",
        "recoverableHint": "Deducted from the final pay.",
        "statuses": {
          "cleared": "Cleared",
          "open": "Open",
          "waived": "Waived"
        },
        "title": "Clearance checklist",
        "waive": {
          "description": "Waiving unblocks the final pay and is recorded with your reason.",
          "reasonLabel": "Waiver reason",
          "title": "Waive a clearance item"
        },
        "waived": "Item waived",
        "waiverReasons": {
          "item_not_applicable": "Does not apply to this person",
          "other": "Other",
          "recovered_by_deduction": "Recovered by deduction",
          "written_off_approved": "Written off with approval"
        }
      },
      "clearanceProgress": "{done} of {total} cleared",
      "columnEmpty": "Nobody here.",
      "create": {
        "description": "One live exit per person. A second one is a data-entry error, not a second departure.",
        "title": "Initiate an exit"
      },
      "created": "Exit initiated",
      "description": "Initiated, clearance, final pay, settled. Each column is somebody waiting on somebody.",
      "detailDescription": "The clearance checklist decides whether the final pay may be released.",
      "detailTitle": "Exit",
      "fields": {
        "exitType": "Exit type",
        "noticeGivenOn": "Notice given on",
        "noticeInLieu": "Notice paid in lieu (days)",
        "reasonNote": "Reason",
        "recoverableTotal": "Recoverable",
        "rehireEligible": "Eligible for rehire",
        "terminationDate": "Termination date",
        "terminationHint": "Not always the last worked day — notice paid in lieu ends later."
      },
      "finalPay": {
        "description": "An off-cycle payroll run for this person only.",
        "explainer": "Notice pay, leave encashment and recoverable deductions are pre-populated by payroll.",
        "payDate": "Pay date",
        "raised": "Final pay run {runNo} created",
        "title": "Raise final pay"
      },
      "lastWorkingDay": "Last working day",
      "loadFailed": "The exits could not be loaded",
      "no": "No",
      "settle": {
        "description": "Settling closes the exit. Every mandatory clearance item must be cleared or waived first.",
        "title": "Settle the exit"
      },
      "settled": "Exit settled",
      "statuses": {
        "cancelled": "Cancelled",
        "clearance": "Clearance",
        "final_pay_pending": "Final pay pending",
        "initiated": "Initiated",
        "settled": "Settled"
      },
      "title": "Exits",
      "types": {
        "abandonment": "Abandonment",
        "death": "Death",
        "end_of_contract": "End of contract",
        "redundancy": "Redundancy",
        "resignation": "Resignation",
        "retirement": "Retirement",
        "termination": "Termination",
        "termination_for_cause": "Termination for cause"
      },
      "yes": "Yes"
    },
    "leaveDepth": {
      "accrualDone": "Accrual run",
      "actions": {
        "carryForward": "Run carry-forward",
        "encash": "Encash",
        "newBlackout": "New blackout",
        "newCoverage": "New coverage minimum",
        "runAccrual": "Run accrual"
      },
      "asOfDate": "As of date",
      "asOfDateHint": "Jobs run against a chosen date, never a clock.",
      "blackout": {
        "description": "Dates on which this leave type may not start or span.",
        "severityHint": "Block refuses the request; warn lets it through with a note.",
        "title": "New blackout period",
        "typeHint": "Leave blank to apply to every leave type."
      },
      "blackoutRemoved": "Blackout removed",
      "blackoutSaved": "Blackout saved",
      "blackoutsEmptyDescription": "A blackout is dates on which a leave type may not start or span — peak season, a stocktake, a statutory audit.",
      "blackoutsEmptyTitle": "No blackout periods",
      "carryForward": {
        "description": "Carries the allowed balance into the new leave year and expires what has run out.",
        "done": "{carried} carried, {expired} expired, {skipped} skipped",
        "idempotent": "Safe to run twice: at most one carry-forward and one expiry per person per year.",
        "title": "Run carry-forward"
      },
      "columns": {
        "amount": "Amount",
        "days": "Days",
        "department": "Department",
        "effectiveOn": "Date",
        "kind": "Movement",
        "leaveType": "Leave type",
        "minOnDuty": "Minimum on duty",
        "reason": "Reason",
        "severity": "Severity",
        "weekdays": "Weekdays",
        "window": "Window",
        "year": "Leave year"
      },
      "coverage": {
        "description": "How many people must be on duty for the leave check to pass.",
        "maskHint": "Monday first. Only the ticked days are checked.",
        "title": "New coverage minimum"
      },
      "coverageEmptyDescription": "A minimum says how many people must be on duty, so a leave request that would breach it can be refused.",
      "coverageEmptyTitle": "No coverage minimums",
      "coverageExplainer": "Weekdays are a Monday-first mask, the same spelling the operating calendar uses.",
      "coverageSaved": "Coverage minimum saved",
      "description": "Blackout periods, coverage minimums and the annual carry-forward.",
      "drawer": {
        "balanceTitle": "Balance today",
        "description": "The movements that produced this balance: accrual, carry-forward, expiry and encashment.",
        "emptyDescription": "No movements beyond the monthly accrual.",
        "ledgerCaption": "Leave movements, newest first",
        "loadFailed": "The movements could not be loaded",
        "openHint": "Select a balance to see the movements behind it.",
        "title": "{type} balance"
      },
      "encash": {
        "description": "Days come off the balance and are paid through payroll.",
        "noteLabel": "Note",
        "paidThroughPayroll": "Payroll decides what the days are worth. This screen sends days and a reason.",
        "reasonLabel": "Reason",
        "title": "Encash leave",
        "runLabel": "Payroll run",
        "runHint": "The run that will carry the encashment line. Payroll decides what the days are worth."
      },
      "encashReasons": {
        "annual_encashment": "Annual encashment",
        "exit_settlement": "Exit settlement",
        "other": "Other",
        "policy_cap_reached": "Policy cap reached"
      },
      "encashed": "Leave encashed",
      "everyDepartment": "Every department",
      "everyLeaveType": "Every leave type",
      "fromDate": "From",
      "kinds": {
        "adjustment": "Adjustment",
        "carry_forward": "Carried forward",
        "carry_forward_expiry": "Carry-forward expired",
        "encashment": "Encashed",
        "opening": "Opening balance"
      },
      "loadFailed": "The leave policy could not be loaded",
      "severities": {
        "block": "Block",
        "warn": "Warn"
      },
      "tabs": {
        "blackouts": "Blackouts",
        "coverage": "Coverage minimums"
      },
      "title": "Leave policy depth",
      "toDate": "To",
      "weekdays": {
        "fri": "Fri",
        "mon": "Mon",
        "sat": "Sat",
        "sun": "Sun",
        "thu": "Thu",
        "tue": "Tue",
        "wed": "Wed"
      }
    },
    "skills": {
      "pageTitle": "Skills and certifications",
      "pageDescription": "The competencies this legal entity recognises, and whose certificates are about to lapse.",
      "explainer": "Editing the catalogue and granting a competency to a person are separate permissions on purpose: whoever decides a certificate is required must not also be able to award it to themselves.",
      "tabsLabel": "Skills",
      "tabRegister": "Register",
      "tabExpiring": "Expiring",
      "loadFailed": "The skill catalogue could not be loaded",
      "expiringFailed": "The expiring list could not be loaded",
      "expiringExplainer": "These grants fall out of validity inside the window. Book the renewal before the person is rostered onto work the certificate covers.",
      "emptyTitle": "No competencies yet",
      "emptyDescription": "Add the certificates and skills this legal entity recognises, then grant them to people from their own record.",
      "expiringEmptyTitle": "Nothing lapses in this window",
      "expiringEmptyDescription": "Widen the window, or choose another legal entity.",
      "saved": "Skill saved",
      "granted": "Skill granted",
      "revoked": "Grant ended",
      "statutory": "Statutory",
      "expires": "Expires",
      "openEnded": "Open ended",
      "withinLabel": "Within (days)",
      "withinHint": "How far ahead to look. Left empty, the server uses 90 days.",
      "expiresLabel": "This competency expires",
      "expiresHint": "A grant of it must carry a valid-to date.",
      "statutoryLabel": "This competency is statutory",
      "statutoryHint": "A statutory competency is one the law requires for the work. A lapsed one is not an inconvenience.",
      "heldTitle": "Competencies held",
      "heldDescription": "What this person holds, until when, and on whose evidence.",
      "heldCaption": "Competencies this person holds",
      "heldEmpty": "No competency has been granted to this person yet.",
      "heldFailed": "This person’s competencies could not be loaded",
      "grantDescription": "Record a competency this person holds, and the evidence for it.",
      "levelHint": "A proficiency band, not a score.",
      "validToHint": "Leave empty for a competency that does not expire.",
      "referenceHint": "The certificate number an inspector will ask for.",
      "revokeTitle": "End this grant?",
      "revokeConsequence": "The grant is closed with today’s date. The row stays: it is the evidence this person was qualified when work was assigned against it.",
      "actions": {
        "new": "New skill",
        "edit": "Edit skill",
        "grant": "Grant a competency",
        "end": "End"
      },
      "columns": {
        "code": "Code",
        "name": "Name",
        "category": "Category",
        "statutory": "Statutory",
        "expires": "Expires",
        "source": "Source",
        "employee": "Employee",
        "skill": "Competency",
        "level": "Level",
        "validFrom": "Valid from",
        "validTo": "Valid to",
        "issuedBy": "Issued by",
        "reference": "Reference"
      }
    }
  },
  "payroll": {
    "filtersTitle": "Filters",
    "allCompanies": "All legal entities",
    "routeTitles": {
      "runs": "Payroll runs",
      "run": "Payroll run",
      "payslip": "Payslip",
      "components": "Pay components",
      "componentNew": "New pay component",
      "component": "Pay component",
      "payGroups": "Pay groups",
      "retro": "Retro pay",
      "return": "Statutory return",
      "returns": "Statutory returns",
      "serviceCharge": "Service charge",
      "serviceChargePool": "Service-charge pool",
      "serviceChargeSchemes": "Service-charge schemes",
      "statutoryMappings": "Statutory mappings",
      "statutoryRules": "Statutory rules",
      "wageBases": "Wage bases",
      "yearEnd": "Year-end statements"
    },
    "fields": {
      "company": "Legal Entity",
      "companyPlaceholder": "Choose a legal entity",
      "employee": "Employee",
      "component": "Pay component",
      "notes": "Notes"
    },
    "componentTypes": {
      "earning": "Earning",
      "deduction": "Deduction",
      "employer_cost": "Employer cost"
    },
    "componentTypeHints": {
      "earning": "Adds to gross pay and to the salary expense the ledger is charged.",
      "deduction": "Comes off the employee's gross pay and is credited to a liability.",
      "employer_cost": "A cost to the legal entity on top of gross pay. It never reduces what the employee is paid."
    },
    "formulaTypes": {
      "fixed": "Fixed amount",
      "percent_of_base": "Percentage of a base",
      "per_unit_overtime": "Per overtime hour",
      "slab": "Progressive bands"
    },
    "formulaHints": {
      "fixed": "The same amount every period, whoever the employee is.",
      "percent_of_base": "A percentage of the employee's prorated basic salary or pensionable wage.",
      "per_unit_overtime": "Approved overtime hours in a named bucket, priced per hour.",
      "slab": "Progressive bands applied marginally: each band's rate charges only the slice of the base inside it."
    },
    "runTypes": {
      "regular": "Regular",
      "off_cycle": "Off-cycle"
    },
    "runStatuses": {
      "draft": "Draft",
      "calculated": "Calculated",
      "reviewed": "Reviewed",
      "approved": "Approved",
      "posted": "Posted",
      "disbursed": "Disbursed"
    },
    "lifecycle": {
      "nextStep": "Next: {step}",
      "complete": "This run is posted and disbursed. There is nothing further to do.",
      "nothingPermitted": "None of the remaining steps are yours to take.",
      "calculate": {
        "label": "Calculate",
        "title": "Calculate this run",
        "willDo": "Works out every active employee's pay for the period and writes a payslip each, with the full calculation behind every line. Running it again replaces this run's own payslips, so recalculating after a change is safe.",
        "done": "Run calculated",
        "doneDetail": "Payslips have been written. Look through the exceptions before submitting it."
      },
      "review": {
        "label": "Mark reviewed",
        "title": "Mark this run reviewed",
        "willDo": "Records that somebody has looked at the exceptions. It changes no figure — it is the statement that the run has been checked, and it is what lets it be submitted for approval.",
        "commentLabel": "What did you check?",
        "commentHint": "Recorded on the audit trail with your name.",
        "exceptions": "This run has {count} payslips flagged as exceptions. Look at those before marking it reviewed.",
        "done": "Run marked reviewed",
        "doneDetail": "It can now be submitted for approval."
      },
      "submit": {
        "label": "Submit for approval",
        "title": "Submit this run for approval",
        "willDo": "Sends the run into the approval chain for its amount and legal entity. If no approval policy matches, it is approved straight away — which is the right outcome for a workspace that has decided this document needs no chain.",
        "done": "Run submitted",
        "doneDetail": "It is with the approvers now, or already approved if no policy matched."
      },
      "post": {
        "label": "Post to the ledger",
        "title": "Post this run to the ledger",
        "willDo": "Writes one journal entry, dated the last day of the period rather than the payment date — the expense and the liability are incurred as of the period the work was done in. Salary and employer costs are debited, net pay and every statutory liability credited, one line per employee and component. It is refused if that period is closed.",
        "done": "Run posted",
        "doneDetail": "The journal is on the ledger and can be drilled into from here."
      },
      "disburse": {
        "label": "Mark disbursed",
        "title": "Mark this run disbursed",
        "willDo": "Records that the money has gone. It does not move any money itself and it does not touch the ledger — the bank file, uploaded to the bank, is what pays people.",
        "done": "Run marked disbursed",
        "doneDetail": "The run is closed."
      },
      "bankFile": {
        "label": "Bank file",
        "title": "Produce the net-pay bank file",
        "willDo": "Produces the net-pay file for upload to the bank. It contains account numbers in the clear, needs a fresh second factor, and the act of producing it is recorded against your name.",
        "done": "Bank file produced",
        "doneDetail": "Check the layout warning before uploading it."
      },
      "cancel": {
        "label": "Cancel run",
        "title": "Cancel this run",
        "willDo": "Deletes the run and its payslips. This is only possible before approval, because nothing has posted yet and there is no financial record to preserve.",
        "reasonLabel": "Reason",
        "reasonHint": "Recorded on the audit trail. It is the only trace the run leaves.",
        "reasonRequired": "A reason is required to cancel a run.",
        "done": "Run cancelled",
        "doneDetail": "The run and its payslips have been deleted."
      }
    },
    "runs": {
      "one": "Payroll run",
      "listTitle": "Payroll runs",
      "listDescription": "Every pay period, what it came to, and where it has got to.",
      "detailDescription": "Payslips, exceptions, overrides and the lifecycle.",
      "summaryTitle": "This run",
      "loadFailed": "The payroll run did not load",
      "emptyTitle": "No payroll runs yet",
      "emptyDescription": "Create one for a period and calculate it — every active employee gets a payslip with its full workings.",
      "draftTitle": "Draft run",
      "backToList": "All payroll runs",
      "journal": "Ledger journal",
      "journalNo": "Journal",
      "created": "Draft run created",
      "createdDetail": "Nothing is calculated yet. Calculate it when the period's attendance and leave are in.",
      "noCrossCompanyTotal": "Totals are per run: two legal entities may state theirs in different currencies, so nothing is added across rows.",
      "tabsLabel": "Run sections",
      "railSubtitle": "{status} · {periodStart} to {periodEnd}",
      "exceptionsFilter": "Exceptions",
      "exceptionsOnly": "Show only flagged payslips",
      "exceptionsOnlyHint": "A payslip is flagged when net pay is below nil or gross pay is nil.",
      "exceptionsHeadline": "{count} payslips are flagged",
      "exceptionsExplainer": "Net pay below nil means deductions came to more than gross. Gross pay of nil means the employee had no payable days in the period. Both are worth understanding before the run is approved.",
      "reconciles": "The {count} payslips loaded add up to the net total above.",
      "reconcileFailedHeadline": "The payslips do not add up to the run's net total",
      "reconcileFailed": "The payslips loaded come to {total}.",
      "reconcileAuthority": "The run's own totals are the figures of record — those are what the ledger was posted from. Recalculating the run is the way to make them agree.",
      "noPayslipsTitle": "No payslips yet",
      "noPayslipsDescription": "Calculate the run and a payslip appears here for every active employee in the period.",
      "columns": {
        "runNo": "Run",
        "period": "Period",
        "periodStart": "Period starts",
        "periodEnd": "Period ends",
        "paymentDate": "Payment date",
        "runType": "Type",
        "employees": "People",
        "gross": "Gross",
        "deductions": "Deductions",
        "net": "Net",
        "employerCost": "Employer cost",
        "exceptions": "Exceptions"
      },
      "tabs": {
        "payslips": "Payslips",
        "manualLines": "Overrides",
        "anomalies": "Anomalies",
        "provenance": "Provenance",
        "retro": "Retro",
        "variances": "Variances"
      },
      "timeline": {
        "created": "Run created",
        "periodEnd": "Period ends — the journal's date",
        "paymentDate": "Payment date"
      },
      "fields": {
        "netPayAccount": "Net pay payable account",
        "bankFileProfile": "Bank file layout"
      },
      "actions": {
        "add": "New payroll run"
      },
      "form": {
        "title": "Create a payroll run",
        "description": "A draft run. Nothing is calculated and nothing is posted until you say so.",
        "submit": "Create the draft",
        "regularHint": "A regular run may pay an employee once per period; a database constraint guarantees it.",
        "offCycleHint": "An off-cycle run may pay somebody a second time inside a period — a bonus, or a correction.",
        "paymentDateHint": "When the money moves. This is not the journal's date.",
        "postingDateExplainer": "The journal is dated the last day of the period, not the payment date: the salary expense and the liability to pay it are incurred as of the period the work was done in.",
        "netPayAccountHint": "Credited with every employee's net pay. Only postable liability accounts of this legal entity are offered, because those are the only ones the server accepts.",
        "accountPlaceholder": "Choose a liability account",
        "chooseCompanyFirst": "Choose a legal entity first",
        "bankFileProfileHint": "The layout used when the net-pay file is produced. It can be chosen later.",
        "noProfile": "Decide later",
        "periodDays": "{days} calendar days in this period",
        "periodUnknown": "Choose a start and an end date",
        "prorationExplainer": "Everything is prorated against this count: a mid-period joiner, a leaver and anybody on unpaid leave are all paid for the days they actually worked, divided by these days."
      },
      "reviewBlocked": {
        "anomaly": "Review is refused: a high-severity anomaly is open.",
        "anomalyHint": "Open the Anomalies tab and acknowledge it with a note saying what you checked.",
        "variance": "Review is refused: a material variance is unexplained.",
        "varianceHint": "Open the Variances tab and explain each blocking row. There is no override — the explanation is the control the approval relies on."
      }
    },
    "payslip": {
      "one": "Payslip",
      "description": "What this person was paid for this period, and how every figure was arrived at.",
      "headerTitle": "Period and days",
      "totalsTitle": "Totals",
      "loadFailed": "The payslip did not load",
      "backToRun": "Back to the run",
      "viewEmployee": "The employee record",
      "railSubtitle": "{employeeNo} · {periodStart} to {periodEnd}",
      "pdf": "Payslip PDF",
      "pdfWorking": "Preparing",
      "pdfPending": "The PDF is being rendered. It appears in this payslip's attachments when it is ready.",
      "pdfReady": "Payslip PDF ready",
      "pdfReadyDetail": "It is attached to this payslip.",
      "pdfFailed": "The PDF could not be rendered.",
      "prorationExplainer": "Basic salary and pensionable wage are prorated as amount × payable days ÷ period days, rounded once. Payable days are the days worked in the period less any unpaid leave.",
      "employerCostExplainer": "Employer cost sits outside net pay: it is a cost to the legal entity and a credit to a liability, never something taken off what the employee receives.",
      "exceptionHeadline": "This payslip is flagged for review",
      "exceptionNoDetail": "Flagged, with no further detail recorded.",
      "reconciles": "All {count} components on this payslip add up to the totals above.",
      "reconcileFailedHeadline": "The components do not add up to the totals",
      "reconcileFailed": "The lines come to {earnings} gross, {deductions} in deductions and {net} net.",
      "reconcileAuthority": "The totals printed above are the figures of record — the ledger and the bank file were produced from those.",
      "fields": {
        "employeeNo": "Employee number",
        "period": "Period",
        "periodDays": "Days in period",
        "payableDays": "Payable days",
        "unpaidLeaveDays": "Unpaid leave days",
        "gross": "Gross pay",
        "deductions": "Deductions",
        "net": "Net pay",
        "employerCost": "Employer cost"
      }
    },
    "trace": {
      "title": "How every figure was worked out",
      "description": "One entry per component, with the formula it used, the inputs it used and what it came to. This is the record a disputed wage is settled against.",
      "emptyTitle": "No components fired for this payslip",
      "emptyDescription": "Every component came to nil, so no line was written. Check that the pay components are active and that the employee had payable days.",
      "overridden": "Overridden",
      "manualOverride": "A manual override entered on the run",
      "bandsCaption": "Each band charges its rate on the slice of the base inside it, not on the whole amount.",
      "bases": {
        "basic_salary": "Basic salary",
        "pensionable_wage": "Pensionable wage"
      },
      "fields": {
        "formula": "Formula",
        "base": "Base",
        "baseAmount": "Base amount",
        "percent": "Percentage",
        "fixedAmount": "Fixed amount",
        "bucket": "Overtime bucket",
        "hours": "Hours",
        "rate": "Rate",
        "bandRange": "Slice of the base",
        "bandAmount": "Charged",
        "source": "Source",
        "overrideAmount": "Amount entered",
        "note": "Note"
      },
      "summary": {
        "fixed": "A fixed amount of {amount}.",
        "percent_of_base": "{percent}% of the {base}, which was {baseAmount}.",
        "per_unit_overtime": "{hours} hours in the {bucket} bucket, at {rate} per hour.",
        "slab": "{bands} progressive bands applied to the {base}, which was {baseAmount}.",
        "manual_override": "Overridden manually to {amount}. The formula this component would have used did not run.",
        "unknown": "This component's workings were recorded in a form this screen does not recognise. Every value the server stored is listed below."
      }
    },
    "manualLines": {
      "title": "Manual overrides",
      "description": "Amounts entered by hand for one employee and one component on this run — a Ramadan allowance, a service-charge share, a correction.",
      "emptyTitle": "No overrides on this run",
      "emptyDescription": "Add one to pay an employee an amount the formulas cannot work out on their own.",
      "locked": "Overrides can only be changed while a run is still a draft or freshly calculated.",
      "saved": "Override saved",
      "savedDetail": "Recalculate the run for it to reach the payslips.",
      "removed": "Override removed",
      "removedDetail": "Recalculate the run for the formula to take over again.",
      "columns": {
        "amount": "Amount",
        "note": "Note"
      },
      "actions": {
        "add": "Add an override",
        "remove": "Remove"
      },
      "form": {
        "addTitle": "Add a manual override",
        "editTitle": "Edit this override",
        "description": "One amount, for one employee, on one component of this run.",
        "replacesHeadline": "This replaces the component's formula for this employee.",
        "replaces": "Whatever the formula would have computed does not run. The payslip's workings will say the amount was entered manually.",
        "recalculateFirst": "It takes effect on the next calculate. A run already calculated keeps its current figures until it is recalculated.",
        "employeePlaceholder": "Choose an employee",
        "componentPlaceholder": "Choose a pay component",
        "componentContext": "{name} is a {type} whose formula is normally {formula}.",
        "amountHint": "Exactly as it should appear on the payslip.",
        "amountRequired": "An amount is required.",
        "amountShape": "Enter a plain decimal amount, such as 2500 or 2500.00.",
        "noteHint": "Why this override exists. It appears in the payslip's workings."
      }
    },
    "components": {
      "one": "Pay component",
      "listTitle": "Pay components",
      "listDescription": "The formulas every payslip is built from. Statutory rates live here as data, not in code.",
      "detailDescription": "One line of a payroll formula.",
      "newTitle": "New pay component",
      "identityTitle": "What this component is",
      "formulaTitle": "How it is worked out",
      "accountsTitle": "Ledger accounts",
      "accountsDescription": "Where a posted run charges and credits this component. Codes are matched against each legal entity's chart when the run is posted.",
      "loadFailed": "The pay components did not load",
      "emptyTitle": "No pay components yet",
      "emptyDescription": "Add one — basic salary is usually first — and every calculated payslip will carry it.",
      "searchPlaceholder": "Search code or name",
      "backToList": "All pay components",
      "created": "Pay component created",
      "saved": "Pay component saved",
      "reload": "Reload this component",
      "active": "In use",
      "inactive": "Retired",
      "activeOnly": "In use",
      "inactiveOnly": "Retired",
      "conflictTitle": "Somebody else changed this component while you had it open",
      "conflictBody": "Nothing was overwritten. Reload to see their version, then reapply your changes.",
      "rulesAsDataExplainer": "Rates are data, not code. MPAO's employee and employer contributions are two rows here, and changing a statutory rate is an edit on this screen rather than a release.",
      "effectExplainer": "Editing a component changes what future calculations produce. Payslips already calculated keep their figures until their run is recalculated, and posted runs never change.",
      "columns": {
        "sequence": "Order",
        "code": "Code",
        "type": "Type",
        "formula": "Formula",
        "accounts": "Accounts"
      },
      "fields": {
        "expenseAccount": "Expense account code",
        "liabilityAccount": "Liability account code"
      },
      "actions": {
        "add": "Add pay component"
      },
      "summary": {
        "fixed": "A fixed {amount}",
        "percent_of_base": "{percent}% of the {base}",
        "per_unit_overtime": "{rate} per hour in the {bucket} bucket",
        "slab": "{bands} progressive bands on the {base}",
        "unknown": "An unrecognised formula"
      },
      "form": {
        "codeHint": "Short and permanent, such as BASIC or MPAO-EE. It cannot be changed later.",
        "sequenceHint": "The order components appear in on a payslip. It does not change any arithmetic.",
        "fixedAmountHint": "The same amount every period, for every employee this component applies to.",
        "percentHint": "As a percentage, so 7 means seven per cent.",
        "bucketHint": "The overtime rule code these hours come from, such as OT150.",
        "perUnitRateHint": "What one hour in that bucket is worth.",
        "expenseAccountHint": "Debited when the run is posted. Earnings and employer costs need one.",
        "liabilityAccountHint": "Credited when the run is posted. Deductions and employer costs need one.",
        "isActive": "In use",
        "isActiveHint": "A retired component stops appearing on newly calculated payslips and leaves posted ones alone."
      },
      "bands": {
        "upTo": "Up to",
        "noUpperBound": "Everything above",
        "add": "Add a band",
        "remove": "Remove",
        "shapeExplainer": "Bands ascend, and the last one has no upper bound — it charges everything above the band before it. Each band's rate applies only to the slice of the base inside it.",
        "atLeastOne": "A progressive formula needs at least one band.",
        "lastUnbounded": "The last band must have no upper bound.",
        "onlyLastUnbounded": "Only the last band may have no upper bound.",
        "ascending": "Band {index} must have a higher upper bound than the band before it.",
        "upToAria": "Upper bound of band {index}",
        "rateAria": "Rate of band {index}",
        "rateHint": "Enter 8.75 for 8.75%.",
        "rateRange": "The rate of band {index} must be a percentage between 0 and 100."
      }
    },
    "bankFile": {
      "title": "Net pay bank file",
      "subject": "For run {runNo}",
      "notVerified": "This layout is not a verified bank specification.",
      "editable": "The {profile} layout is editable data, so a wrong column can be corrected without a release.",
      "plaintext": "This file contains account numbers in the clear. Producing it is recorded against your name, with the number of beneficiaries it covered.",
      "stepUpRequired": "Confirm your second factor again before this is allowed, then try once more.",
      "stepUpLink": "Set it up on your profile",
      "profile": "Layout",
      "filename": "File name",
      "rows": "Beneficiaries",
      "checksum": "Checksum",
      "previewLabel": "The first lines, so the shape can be checked before it is uploaded.",
      "previewTruncated": "Only the first lines are shown. The download contains every row.",
      "download": "Download the file",
      "downloaded": "Bank file downloaded",
      "retry": "Produce the file",
      "working": "Producing"
    },
    "anomalies": {
      "acknowledge": {
        "description": "A note saying what you checked, so the next reader does not check it again.",
        "noteHint": "Name the figure you looked at and why it is right.",
        "noteLabel": "What you checked",
        "title": "Acknowledge the anomaly"
      },
      "acknowledged": "Anomaly acknowledged",
      "actions": {
        "acknowledge": "Acknowledge"
      },
      "blocksReview": "{count} high-severity anomaly(ies) are open",
      "blocksReviewWhy": "A detector is a heuristic and is often wrong, so acknowledging it with a note is the control — not a silent pass.",
      "clear": "No open high-severity anomaly. Review may proceed.",
      "columns": {
        "figures": "Figures",
        "kind": "What was detected",
        "note": "Note",
        "severity": "Severity"
      },
      "description": "Deterministic detectors over this run. Every figure below is computed, never narrated.",
      "emptyDescription": "No detector fired against this run.",
      "emptyTitle": "Nothing flagged",
      "kinds": {
        "bank_changed_this_period": "Bank account changed this period",
        "duplicate_bank_destination": "Two employees share one bank destination",
        "first_pay_above_grade_max": "First pay above the grade maximum",
        "negative_net": "Negative net pay",
        "net_unchanged_despite_unpaid_leave": "Net unchanged despite unpaid leave",
        "net_zscore": "Net pay far from this person's own trend",
        "new_component": "A component appeared that was not there last period",
        "pay_without_attendance": "Paid with no attendance recorded",
        "terminated_still_paid": "Paid after termination",
        "vanished_component": "A component that was there last period is missing"
      },
      "loadFailed": "The anomalies could not be loaded",
      "runWide": "Whole run",
      "severities": {
        "high": "High",
        "low": "Low",
        "medium": "Medium"
      },
      "statuses": {
        "acknowledged": "Acknowledged",
        "dismissed": "Dismissed",
        "open": "Open"
      },
      "title": "Anomalies"
    },
    "payGroups": {
      "actions": {
        "new": "New pay group"
      },
      "active": "Active",
      "anchorHint": "The day of the month a period starts on.",
      "columns": {
        "anchor": "Anchor day",
        "code": "Code",
        "frequency": "Frequency",
        "lag": "Payment lag"
      },
      "create": {
        "description": "A group a payroll run inherits its calendar from.",
        "title": "New pay group"
      },
      "default": "Default",
      "defaultHint": "Used when a run does not name a group.",
      "defaultMoves": "Setting this moves the default off whichever group holds it now.",
      "description": "The frequency, the period anchor and the payment lag a run inherits.",
      "edit": {
        "title": "Edit pay group"
      },
      "emptyDescription": "Every payroll run belongs to a pay group. Create one for the monthly cycle at least.",
      "emptyTitle": "No pay groups yet",
      "frequencies": {
        "fortnightly": "Fortnightly",
        "monthly": "Monthly",
        "weekly": "Weekly"
      },
      "inactive": "Inactive",
      "lagHint": "Days between the period ending and the money leaving.",
      "loadFailed": "The pay groups could not be loaded",
      "saved": "Pay group saved",
      "title": "Pay groups"
    },
    "provenance": {
      "columns": {
        "citation": "Citation",
        "effectiveFrom": "Effective from",
        "lines": "Lines",
        "reviewDue": "Review due",
        "rule": "Rule",
        "source": "Source",
        "total": "Total"
      },
      "description": "Every rule this run fired, with the pack version and citation behind it.",
      "emptyDescription": "Calculate the run and the rules it used appear here.",
      "emptyTitle": "No rules fired",
      "loadFailed": "The provenance could not be loaded",
      "noCitation": "No citation recorded",
      "notOverridable": "A pack rule cannot be overridden locally.",
      "overdue": "Overdue",
      "popover": {
        "label": "Where this line came from",
        "trigger": "Source"
      },
      "reviewOverdue": "{count} rule(s) are past their review date.",
      "sources": {
        "legacy": "Legacy",
        "pack": "Pack",
        "tenant": "Own"
      },
      "title": "Provenance",
      "unverifiedExplainer": "The rates behind these lines were not verified against a primary source.",
      "unverifiedHeadline": "{count} rule(s) carry an UNVERIFIED citation"
    },
    "retro": {
      "actions": {
        "dismiss": "Dismiss"
      },
      "columns": {
        "affected": "Affected period",
        "change": "Change",
        "component": "Component",
        "delta": "Difference",
        "field": "Field",
        "kind": "What changed",
        "originPeriod": "Origin period",
        "original": "Originally paid",
        "recomputed": "Recomputed"
      },
      "description": "Changes that landed in a period a run had already posted. The next run pays the difference.",
      "dismiss": {
        "consequence": "Nobody will be paid the difference for this change.",
        "description": "Dismissing says this change should not be paid retrospectively.",
        "noteLabel": "Note",
        "reasonLabel": "Reason",
        "title": "Dismiss retro event"
      },
      "dismissReasons": {
        "already_settled_manually": "Already settled by hand",
        "data_entry_correction": "Correcting a data-entry error",
        "duplicate_event": "Duplicate event",
        "not_payable_retrospectively": "Not payable retrospectively",
        "other": "Other"
      },
      "dismissed": "Retro event dismissed",
      "emptyDescription": "This run pays no differences from earlier periods.",
      "emptyTitle": "No retro lines",
      "eventsEmptyDescription": "Nothing has been backdated into a posted period.",
      "eventsEmptyTitle": "No retro events",
      "kinds": {
        "assignment": "Employment terms",
        "attendance": "Attendance",
        "component": "Pay component",
        "leave": "Leave",
        "statutory_rule": "Statutory rule"
      },
      "loadFailed": "The retro events could not be loaded",
      "openExplainer": "{count} open event(s) will be picked up by the next payroll run for their legal entity.",
      "packRule": "Pack rule",
      "panelDescription": "What this run pays for earlier periods, and why.",
      "panelTitle": "Retro lines",
      "repairs": "Repairing {count} earlier period(s)",
      "statuses": {
        "applied": "Applied",
        "dismissed": "Dismissed",
        "open": "Open",
        "superseded": "Superseded"
      },
      "title": "Retro pay"
    },
    "returns": {
      "actions": {
        "approve": "Approve",
        "confirmRemittance": "Confirm",
        "export": "Download file",
        "file": "File",
        "new": "New return",
        "prepare": "Prepare",
        "prepareRemittance": "Prepare remittance",
        "reconcile": "Reconcile"
      },
      "anyStatus": "Any status",
      "approve": {
        "description": "Approval fixes the figures the file will carry.",
        "noteLabel": "Note",
        "title": "Approve the return"
      },
      "approved": "Return approved",
      "codeHint": "The rule family this return reports: MPAO, EPF, APIT.",
      "columns": {
        "amount": "Amount",
        "base": "Base",
        "code": "Return code",
        "difference": "Difference",
        "dueOn": "Due on",
        "employeeAmount": "Employee",
        "employees": "Employees",
        "employerAmount": "Employer",
        "paymentDate": "Payment date",
        "period": "Period",
        "reference": "Reference",
        "returnNo": "Return no.",
        "statutoryId": "Statutory id",
        "total": "Total"
      },
      "confirmRemittance": {
        "description": "Confirm only once the money has actually left the bank account.",
        "posts": "This posts a journal: the statutory payable is cleared against the bank.",
        "stepUp": "A fresh second factor is needed before this can post.",
        "title": "Confirm the remittance"
      },
      "create": {
        "description": "One return per rule family per legal entity per period.",
        "title": "New statutory return"
      },
      "created": "Return created",
      "description": "Prepared from posted payslips, reconciled to the ledger, approved and filed.",
      "detailDescription": "Its lines, its reconciliation, its file and its payment.",
      "detailTitle": "Statutory return",
      "draftNo": "Draft",
      "emptyDescription": "Create a return for a period and prepare it from the payslips that posted in it.",
      "emptyTitle": "No returns yet",
      "file": {
        "description": "Record the reference the authority gave you.",
        "referenceLabel": "Filing reference",
        "title": "File the return"
      },
      "fileDownloaded": "File rendered: {rows} row(s)",
      "filed": "Return filed",
      "linesEmptyDescription": "Prepare the return and the posted payslip lines appear here.",
      "linesEmptyTitle": "No lines yet",
      "linesTitle": "Return lines",
      "loadFailed": "The returns could not be loaded",
      "prepared": "Return prepared",
      "reconciliation": {
        "blocked": "The return does not agree with the ledger",
        "blockedWhy": "Approval is refused until the difference is zero. Re-prepare the return, or find the journal that is missing.",
        "clear": "The return agrees with the ledger.",
        "controlAccount": "Control account",
        "controlMovement": "Ledger movement",
        "description": "The control account's movement, the return's total, and the difference between them.",
        "difference": "Difference",
        "returnTotal": "Return total",
        "title": "Reconciliation to the ledger"
      },
      "remittance": {
        "bankAccountLabel": "Bank account id",
        "description": "The amount is the return's own total, unchanged.",
        "title": "Prepare a remittance"
      },
      "remittanceConfirmed": "Remittance confirmed and posted",
      "remittanceDescription": "Confirming a remittance posts: the statutory payable is cleared against the bank.",
      "remittancePrepared": "Remittance prepared",
      "remittanceStatuses": {
        "cancelled": "Cancelled",
        "confirmed": "Confirmed",
        "prepared": "Prepared"
      },
      "remittanceTitle": "Remittance",
      "statuses": {
        "approved": "Approved",
        "draft": "Draft",
        "filed": "Filed",
        "prepared": "Prepared",
        "reconciled": "Reconciled",
        "superseded": "Superseded"
      },
      "summaryTitle": "Summary",
      "title": "Statutory returns",
      "unreconciledExplainer": "A return cannot be approved while its difference is not zero. That is a database rule, not a policy.",
      "unreconciledHeadline": "{count} return(s) do not agree with the ledger",
      "yearEndLink": "Year-end statements"
    },
    "serviceCharge": {
      "actions": {
        "allocate": "Allocate",
        "approve": "Approve",
        "collect": "Collect",
        "distribute": "Distribute",
        "new": "New pool",
        "newPoint": "New points row",
        "newScheme": "New scheme"
      },
      "allocated": "Pool allocated",
      "allocationsDescription": "Weight, raw share, the rounding cent and the amount — the four figures that make a distribution re-derivable.",
      "allocationsEmptyDescription": "Allocate the pool and every eligible person's share appears here.",
      "allocationsEmptyTitle": "Nothing allocated yet",
      "allocationsGatedExplainer": "This list is every colleague's share, so it needs the permission that manages the pool — not the one that reads it.",
      "allocationsGatedHeadline": "Allocations are not shown to you",
      "allocationsTitle": "Allocations",
      "anyStatus": "Any status",
      "approve": {
        "description": "Approval fixes the allocation and lets it be distributed.",
        "explainer": "Approval is refused unless every distributable cent is somebody's.",
        "noteLabel": "Note",
        "title": "Approve the pool"
      },
      "approved": "Pool approved",
      "bases": {
        "hours": "Attended hours",
        "points": "Points"
      },
      "basisHint": "Points weights by grade or person; hours weights by attended hours.",
      "collected": "Pool collected",
      "columns": {
        "allocated": "Allocated",
        "amount": "Amount",
        "baseAmount": "Base amount",
        "basis": "Basis",
        "capturedAt": "Captured at",
        "code": "Code",
        "component": "Pay component",
        "contributesTo": "Contributes to",
        "currency": "Currency",
        "distributable": "Distributable",
        "documents": "Documents",
        "eligibility": "Eligibility",
        "eligible": "Eligible",
        "eligibleDays": "Eligible days",
        "grade": "Grade",
        "gross": "Collected",
        "hours": "Hours",
        "lines": "Lines",
        "period": "Period",
        "points": "Points",
        "poolKey": "Pool key",
        "poolNo": "Pool no.",
        "rawShare": "Raw share",
        "reason": "Reason",
        "retained": "Retained",
        "retention": "Retention",
        "roundingCents": "Rounding",
        "scheme": "Scheme",
        "scope": "Scope",
        "target": "Target",
        "taxCode": "Charge code",
        "topup": "Employer top-up",
        "totalWeight": "Total weight",
        "weight": "Weight"
      },
      "componentHint": "The pay component a share is paid through. It must be a pool-share component.",
      "contributesHint": "Whether a share enters a contribution base — whether pension is charged on it, for instance.",
      "contributesNothing": "Nothing",
      "contributesWarning": "A share entering a contribution base changes what is deducted from it. Check the statutory rule before saving.",
      "create": {
        "description": "A pool claims one outlet's charges for one period.",
        "title": "New service-charge pool"
      },
      "created": "Pool created",
      "description": "One outlet's collection for one period, distributed to the staff it was collected for.",
      "detailDescription": "The source snapshot, the scheme, every share and every forfeiture.",
      "detailTitle": "Service-charge pool",
      "distribute": {
        "description": "Each share becomes a payslip line in the run you name.",
        "explainer": "This moves money out of the liability account. A pool distributes through exactly one run.",
        "runHint": "A draft or calculated run for the same legal entity.",
        "runLabel": "Payroll run id",
        "title": "Distribute the pool"
      },
      "distributed": "Distributed through run {runNo}: {count} allocation(s)",
      "draftNo": "Draft",
      "eligibility": {
        "eligible": "Eligible",
        "forfeited": "Forfeited",
        "ineligible": "Ineligible"
      },
      "emptyDescription": "Create a pool for a period, collect what guests were charged, then allocate it.",
      "emptyTitle": "No pools yet",
      "excludeOnProbation": "Exclude staff on probation",
      "forfeitForCause": "Forfeit on termination for cause",
      "forfeituresTitle": "Excluded and forfeited ({count})",
      "liabilityExplainer": "Service charge is money collected from guests on the staff's behalf. It sits in a liability account and is distributed, never expensed.",
      "loadFailed": "The pools could not be loaded",
      "minDaysWorked": "Minimum days worked",
      "moneyTitle": "The money",
      "notFullyAllocated": "Not every distributable cent is allocated. Approval is refused until they agree.",
      "oneWindow": "One live pool per outlet per period. A second one over the same window would distribute the same money twice.",
      "periodEnd": "Period end",
      "periodStart": "Period start",
      "point": {
        "description": "Points for one grade, one position or one person, effective from a date.",
        "targetIdHint": "The id of the grade, position or employee this row weights.",
        "targetIdLabel": "Target id",
        "title": "New points row"
      },
      "pointRemoved": "Points removed",
      "pointSaved": "Points saved",
      "pointTargets": {
        "employee": "Employee",
        "grade": "Grade",
        "position": "Position"
      },
      "pointsEmptyDescription": "Without points every eligible person weighs the same. Add a row per grade at least.",
      "pointsEmptyTitle": "No points rows",
      "pointsResolutionOrder": "Points resolve employee first, then position, then grade — most specific wins.",
      "poolKeyHint": "The charge pool key the document service wrote. Blank collects the unnamed pool.",
      "prorateByDays": "Pro-rate by eligible days",
      "prorateHint": "Somebody who worked half the period carries half the weight.",
      "retentionHint": "Retained money stays in the liability account. It does not become income here.",
      "scheme": {
        "createTitle": "New service-charge scheme",
        "description": "Effective-dated: changing a scheme never re-divides a pool that has already been distributed.",
        "editTitle": "Edit service-charge scheme"
      },
      "schemeSaved": "Scheme saved",
      "schemesDescription": "How a pool is divided, and the points each grade, position or person carries.",
      "schemesEmptyDescription": "A scheme decides eligibility, pro-rating, forfeiture and the pay component a share is paid through.",
      "schemesEmptyTitle": "No schemes",
      "schemesLink": "Schemes and points",
      "schemesTitle": "Schemes and points",
      "sourceDescription": "Exactly what the charge query returned when this pool was collected. Immutable.",
      "sourceEmptyDescription": "Collect the pool to snapshot what guests were charged in the period.",
      "sourceEmptyTitle": "Not collected yet",
      "sourceTitle": "Source snapshot",
      "statuses": {
        "allocated": "Allocated",
        "approved": "Approved",
        "cancelled": "Cancelled",
        "collected": "Collected",
        "distributed": "Distributed",
        "draft": "Draft"
      },
      "tabs": {
        "points": "Points",
        "schemes": "Schemes"
      },
      "title": "Service charge",
      "topupHint": "Money the property adds from its own pocket. This part is an expense.",
      "unnamedPool": "Unnamed pool",
      "collectDescription": "Closes the pool over its sources. An employer top-up, if there is one, is stated now."
    },
    "statutoryMappings": {
      "accountCodeHint": "A code from this legal entity's chart of accounts, resolved when the run posts.",
      "actions": {
        "new": "New mapping"
      },
      "columns": {
        "expense": "Expense account",
        "liability": "Liability account"
      },
      "create": {
        "description": "One mapping per rule per legal entity, effective-dated.",
        "title": "New statutory mapping"
      },
      "description": "The account codes each statutory rule posts to in this legal entity's chart.",
      "disableReasonLabel": "Why it does not apply",
      "disableReasons": {
        "exempt_by_ruling": "Exempt by ruling",
        "no_eligible_staff": "No eligible staff",
        "not_applicable": "Does not apply here",
        "other": "Other"
      },
      "disabled": "Disabled",
      "edit": {
        "title": "Edit statutory mapping"
      },
      "emptyDescription": "Without a mapping a rule has no account to post to and the run will refuse at post.",
      "emptyTitle": "No mappings yet",
      "enabled": "Enabled",
      "enabledHint": "Disable only where the rule does not apply to this legal entity at all.",
      "loadFailed": "The mappings could not be loaded",
      "noRateExplainer": "A mapping points a rule at your accounts. It cannot change what the rule computes, and there is no field here that could.",
      "noRateHeadline": "Accounts only — never a rate",
      "saved": "Mapping saved",
      "title": "Statutory mappings"
    },
    "statutoryRules": {
      "actions": {
        "history": "History"
      },
      "columns": {
        "citation": "Citation",
        "code": "Rule code",
        "effectiveFrom": "Effective from",
        "jurisdiction": "Jurisdiction",
        "overridable": "Overridable",
        "pack": "Pack",
        "parameters": "Parameters",
        "reviewDue": "Review due"
      },
      "description": "The rules in force for a legal entity, with the pack version and citation behind each.",
      "emptyDescription": "Activate a jurisdiction pack for this legal entity and its rules appear here.",
      "emptyTitle": "No statutory rules in force",
      "history": {
        "description": "Every version this workspace has held, with the pack version that delivered it.",
        "title": "{code} — every version"
      },
      "loadFailed": "The statutory rules could not be loaded",
      "mappingsLink": "Account mappings",
      "notOverridable": "Not overridable",
      "onDate": "In force on",
      "onDateHint": "Leave blank for today.",
      "overdue": "Review overdue",
      "overdueExplainer": "{count} rule(s) are past their review date. A rate nobody has re-read is a rate nobody is standing behind.",
      "readOnlyExplainer": "A statutory rule is not locally overridable by anybody, including a workspace administrator. What you can change is which accounts it posts to.",
      "readOnlyHeadline": "These rules are read-only",
      "title": "Statutory rules",
      "unverifiedExplainer": "The rates were not verified against a primary source. Check them before relying on a figure.",
      "unverifiedHeadline": "{count} rule(s) carry an UNVERIFIED citation"
    },
    "variances": {
      "actions": {
        "explain": "Explain",
        "explainSelected": "Explain {count} selected"
      },
      "blocking": "Blocking",
      "blocksReview": "{count} material variance(s) are unexplained",
      "blocksReviewWhy": "Review is refused until each one carries an explanation. There is no override: the explanation is the control the approval relies on.",
      "clear": "No material unexplained variance. Review may proceed.",
      "codes": {
        "bonus_paid": "Bonus paid",
        "correction": "Correction",
        "joiner": "New joiner",
        "leaver": "Leaver",
        "other": "Other",
        "overtime_change": "Overtime changed",
        "pay_review": "Pay review",
        "retro_applied": "Retro pay applied",
        "statutory_rate_change": "Statutory rate changed",
        "unpaid_leave": "Unpaid leave"
      },
      "columns": {
        "current": "Current",
        "delta": "Difference",
        "deltaPercent": "Change %",
        "employee": "Employee",
        "explanation": "Explanation",
        "measure": "Measure",
        "prior": "Prior"
      },
      "companyRollup": "Legal entity total",
      "description": "What moved since last period, and whether anybody has explained it.",
      "emptyDescription": "No figure moved by more than the legal entity's materiality thresholds.",
      "emptyTitle": "Nothing to explain",
      "explain": {
        "codeLabel": "Explanation code",
        "description": "A code for the aggregate, and a sentence for the one that mattered.",
        "humanNote": "This is recorded as a human explanation, with your name and the time.",
        "noteHint": "An approver will read this instead of re-deriving the figure.",
        "noteLabel": "What happened",
        "title": "Explain the variance"
      },
      "explained": "Variance explained",
      "explainedBulk": "{count} variance(s) explained",
      "loadFailed": "The variances could not be loaded",
      "materialHint": "Material means past both the absolute and the percentage threshold.",
      "materialOnly": "Material only",
      "measures": {
        "component": "Component",
        "deduction": "Deductions",
        "employer_cost": "Employer cost",
        "gross": "Gross",
        "headcount": "Headcount",
        "net": "Net"
      },
      "sources": {
        "auto": "Auto",
        "human": "Human"
      },
      "title": "Variances against the prior run",
      "unexplained": "Unexplained",
      "unexplainedOnly": "Unexplained only"
    },
    "wageBases": {
      "actions": {
        "new": "New wage base"
      },
      "ceiling": "Ceiling",
      "columns": {
        "bounds": "Floor / ceiling",
        "code": "Code",
        "gate": "Gate",
        "includes": "Includes classes",
        "seed": "Seed",
        "source": "Source"
      },
      "create": {
        "description": "A base is configuration, so it is effective-dated and never rewritten in place.",
        "title": "New wage base"
      },
      "description": "The named sums a statutory rule is computed against.",
      "edit": {
        "title": "Edit wage base"
      },
      "emptyDescription": "Basic salary and pensionable wage are seeded by the migration; add one per contribution base a jurisdiction needs.",
      "emptyTitle": "No wage bases",
      "explainer": "A base seeds from the assignment's basic salary, accumulates the wage classes it names, and may be gated, floored or capped.",
      "floor": "Floor",
      "gateHint": "A gate zeroes the base for anybody it does not apply to.",
      "gates": {
        "none": "No gate",
        "pensionable": "Only when enrolled in the pension scheme"
      },
      "includesHint": "Component amounts in these classes are added to the base.",
      "loadFailed": "The wage bases could not be loaded",
      "packReadOnly": "From a pack",
      "saved": "Wage base saved",
      "seedHint": "Whether the base starts from the assignment's prorated basic salary.",
      "seedSources": {
        "assignment_basic": "The assignment's basic salary",
        "none": "Nothing"
      },
      "title": "Wage bases"
    },
    "wageClasses": {
      "allowance": "Allowance",
      "basic_salary": "Basic salary",
      "benefit_in_kind": "Benefit in kind",
      "bonus": "Bonus",
      "cost_of_living_allowance": "Cost of living allowance",
      "other": "Other",
      "overtime": "Overtime",
      "reimbursement": "Reimbursement",
      "service_charge": "Service charge",
      "statutory": "Statutory"
    },
    "yearEnd": {
      "actions": {
        "issue": "Issue statements"
      },
      "columns": {
        "taxYear": "Tax year"
      },
      "description": "One per employee per tax year, totalled from their issued payslips.",
      "draftExplainer": "{count} statement(s) are still drafts. Only issued statements are visible to the employee.",
      "emptyDescription": "Issue statements for a tax year and they appear here.",
      "emptyTitle": "No statements",
      "issue": {
        "description": "Statements are generated for every employee paid in the year.",
        "explainer": "Issuing makes the statement visible in self-service. A draft stays private.",
        "title": "Issue year-end statements"
      },
      "issued": "{issued} issued, {skipped} skipped",
      "loadFailed": "The statements could not be loaded",
      "statuses": {
        "draft": "Draft",
        "issued": "Issued",
        "superseded": "Superseded"
      },
      "title": "Year-end statements",
      "issuedOne": "Statement issued for {year}"
    },
    "statutory_review": {
      "summary": "A payroll run used a local override of a statutory rule and needs review."
    }
  },
  "projects": {
    "routeTitles": {
      "projects": "Projects",
      "project": "Project",
      "gantt": "Schedule",
      "profitability": "Profitability",
      "billing": "Billing",
      "timesheets": "Timesheets",
      "timesheet": "Timesheet",
      "settings": "Project settings"
    },
    "nav": {
      "label": "Project sections",
      "projects": "Projects",
      "timesheets": "Timesheets",
      "settings": "Settings"
    },
    "tabs": {
      "label": "Project views",
      "overview": "Overview",
      "gantt": "Schedule",
      "profitability": "Profitability",
      "billing": "Billing"
    },
    "actions": {
      "remove": "Remove"
    },
    "statuses": {
      "planning": "Planning",
      "active": "Active",
      "on_hold": "On hold",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "fields": {
      "company": "Legal Entity",
      "companyPlaceholder": "Choose a legal entity",
      "code": "Code",
      "name": "Name",
      "description": "Description",
      "customer": "Customer",
      "customerPlaceholder": "Choose a customer",
      "manager": "Manager",
      "managerPlaceholder": "Choose a manager",
      "startDate": "Starts",
      "endDate": "Ends",
      "dates": "Dates",
      "currency": "Currency",
      "contractValue": "Contract value",
      "billingMethod": "Billing method",
      "revenueAccount": "Revenue account",
      "revenueRecognized": "Revenue recognised",
      "phase": "Phase",
      "task": "Task",
      "project": "Project",
      "assignee": "Assignee"
    },
    "list": {
      "title": "Projects",
      "description": "Work broken into phases and tasks, costed from timesheets and billed to a customer.",
      "filtersTitle": "Filters",
      "searchPlaceholder": "Code or name",
      "new": "New project",
      "loadFailed": "Could not load projects",
      "emptyTitle": "No projects yet",
      "emptyDescription": "Create a project, break it into tasks with budgets, then put your team on it with their cost rates."
    },
    "create": {
      "title": "New project",
      "description": "Name the work and who it is for. Billing method, contract value and revenue account are set afterwards, with the customer.",
      "codeHint": "Unique within the legal entity, and permanent — it appears on every invoice this project raises.",
      "customerHint": "Required before this project can be billed; it can be set later.",
      "contractValueHint": "What was agreed. Percent-complete billing multiplies against this figure.",
      "submit": "Create project",
      "doneTitle": "Project created",
      "failed": "Could not create the project"
    },
    "edit": {
      "title": "Edit {code}",
      "description": "Everything about the project except its code and legal entity.",
      "billingNote": "The billing method decides which billing action this project can run at all. The server refuses any other one.",
      "contractValueHint": "Percent-complete billing multiplies against this. A project on that method with no contract value cannot be billed.",
      "revenueAccountHint": "The account every invoice this project raises will credit. All three billing methods refuse without it.",
      "revenueAccountPlaceholder": "Choose an income account",
      "doneTitle": "Project saved",
      "failed": "Could not save the project"
    },
    "detail": {
      "factsTitle": "Details",
      "openCustomer": "Open customer",
      "noCustomer": "No customer set",
      "noManager": "No manager set",
      "openTimesheets": "Approved time on this project",
      "loadFailed": "Could not load the project"
    },
    "rail": {
      "created": "Created",
      "start": "Planned start",
      "end": "Planned end",
      "timesheets": "Approved timesheets",
      "profitability": "Profitability",
      "customer": "Customer"
    },
    "removedTitle": "Removed",
    "removeFailed": "Could not remove it",
    "confirmRemoveTitle": "Remove this?",
    "confirmRemoveDescription": "{label} will be removed from this project.",
    "confirmRemoveNote": "Removing a task removes its budget from the project total, and with it the denominator percent-complete billing divides by.",
    "phases": {
      "new": "Add phase",
      "createTitle": "New phase",
      "editTitle": "Edit phase",
      "dialogDescription": "A phase groups tasks. Its budget is the sum of theirs, so there is nothing to type here.",
      "sequence": "Order",
      "sequenceHint": "Where this phase sits in the plan. Whole numbers.",
      "statuses": {
        "planned": "Planned",
        "active": "Active",
        "completed": "Completed"
      },
      "createdTitle": "Phase added",
      "savedTitle": "Phase saved",
      "saveFailed": "Could not save the phase"
    },
    "tasks": {
      "panelTitle": "Work breakdown",
      "new": "New task",
      "addHere": "Add task here",
      "createTitle": "New task",
      "editTitle": "Edit task",
      "dialogDescription": "A task carries the budget, the dates and the dependencies. Its budget is what profitability measures against.",
      "wbsCode": "WBS",
      "wbsCodeHint": "Left blank, the server assigns the next one. It cannot be changed afterwards.",
      "budget": "Budget",
      "budgetHint": "This project's budget is the sum of its tasks' budgets. Percent-complete billing divides by that sum.",
      "budgetNote": "The budget figure on the profitability screen is the sum of these task budgets, excluding cancelled tasks. A phase's budget is the sum of its own tasks'.",
      "isMilestone": "This task is a milestone",
      "isMilestoneHint": "A zero-duration marker on the schedule. Not a billing milestone — those live on the Billing tab and carry amounts.",
      "milestoneBadge": "Milestone",
      "dependsOn": "Waits for",
      "noDependencies": "Waits for nothing.",
      "dependencyNote": "Finish-to-start only: this task starts after the ones listed finish. The server refuses a dependency that would close a loop.",
      "addDependency": "Add a dependency",
      "dependencyPlaceholder": "Choose a task",
      "dependenciesAfterSave": "Dependencies can be added once the task exists",
      "dependencyAdded": "Dependency added",
      "dependencyFailed": "Could not change the dependency",
      "cycleRefused": "{task} already depends on this task, directly or through others. Adding this would loop.",
      "noPhase": "No phase",
      "unassigned": "Unassigned",
      "statuses": {
        "not_started": "Not started",
        "in_progress": "In progress",
        "blocked": "Blocked",
        "done": "Done",
        "cancelled": "Cancelled"
      },
      "createdTitle": "Task added",
      "savedTitle": "Task saved",
      "saveFailed": "Could not save the task",
      "emptyTitle": "Nothing broken down yet",
      "emptyDescription": "Add a phase to group the work, or a task on its own. A task's budget is what profitability measures against."
    },
    "members": {
      "panelTitle": "Team and rates",
      "add": "Add someone",
      "addTitle": "Add someone to the project",
      "editTitle": "Edit rates",
      "dialogDescription": "The cost rate is what approving a timesheet posts to WIP. The bill rate is what time-and-materials billing invoices.",
      "person": "Person",
      "personPlaceholder": "Choose someone",
      "role": "Role",
      "costRate": "Cost rate ({currency} per hour)",
      "costRateHint": "Timesheet approval multiplies hours by this and debits Project WIP. Without a row here, this person's time cannot be costed at all.",
      "costRateShort": "Cost rate",
      "billRate": "Bill rate ({currency} per hour)",
      "billRateHint": "What time-and-materials billing invoices the customer. Nil is allowed; nil hours simply cannot be billed.",
      "billRateShort": "Bill rate",
      "ratesNote": "Approving a timesheet resolves each line's cost rate from this table. Somebody with no row here cannot have their time costed, and approval is refused naming them.",
      "savedTitle": "Team updated",
      "savedDetail": "The new rate applies to timesheets approved from now on.",
      "saveFailed": "Could not update the team",
      "emptyTitle": "Nobody on this project yet",
      "emptyDescription": "Add the people who will book time, each with a cost rate. Approval refuses a timesheet from anyone missing here."
    },
    "gantt": {
      "title": "Schedule",
      "chartTitle": "Phases and tasks over time",
      "readOnlyNote": "Read only. Dates are changed on the task itself, so a plan is never rewritten by a drag nobody can review. Dependencies are listed per row rather than drawn, because arrows across a long plan cross every bar between them.",
      "columns": {
        "item": "Phase or task",
        "dates": "Dates",
        "chart": "Timeline"
      },
      "spanLabel": "{from} to {to}",
      "noDates": "No dates",
      "someUndated": "{count} row(s) carry no dates and are listed without a bar.",
      "undatedTitle": "Nothing on this plan has dates yet",
      "undatedDescription": "Give a phase or a task a start and an end and it will appear here.",
      "emptyTitle": "Nothing to schedule yet",
      "emptyDescription": "Add phases and tasks on the project's overview and they will appear here in order.",
      "loadFailed": "Could not load the schedule"
    },
    "profitability": {
      "title": "Profitability",
      "budget": "Budget",
      "budgetSource": "The sum of this project's task budgets, excluding cancelled tasks.",
      "budgetLink": "See the tasks",
      "commitment": "Commitment",
      "commitmentSource": "The still-open part of purchase-order lines coded to this project: ordered less matched, over orders that are neither closed nor cancelled. It comes from procurement's own bookkeeping, not from the budgeting module, which has no project column.",
      "commitmentLink": "Open purchase orders",
      "actualTotal": "Actual",
      "actualSource": "Costed timesheet lines plus posted AP invoice lines tagged to this project.",
      "actualTimesheet": "Time",
      "actualTimesheetShort": "Time cost",
      "actualAp": "Purchases",
      "timesheetSource": "cost written on each line when its timesheet was approved",
      "timesheetLink": "Approved timesheets",
      "journalLink": "Ledger postings",
      "apSource": "posted and paid AP invoice lines tagged to this project",
      "apLink": "Posted purchase invoices",
      "widerThanFigure": "That list is not filtered by project — no list endpoint exposes the line-level project tag — so it is wider than this figure.",
      "eac": "Estimate at completion",
      "eacSource": "What has been spent and committed, at its own value, plus whatever budget is left unspent and uncommitted, at plan. Never less than what has already been spent and committed.",
      "variance": "Variance",
      "varianceSource": "Budget less the estimate at completion. Positive is under budget.",
      "overBudget": "Over budget",
      "underBudget": "Within budget",
      "consumedTitle": "Budget consumed",
      "consumed": "The estimate at completion is {percent}% of the budget.",
      "noBudget": "No task budget has been set, so there is nothing to measure against.",
      "actualBreakdownTitle": "Where the actual came from",
      "columns": {
        "source": "Source",
        "trace": "Trace"
      },
      "revenueTitle": "Revenue",
      "revenueNote": "Billed to date is the sum of this project's billing runs. For percent-complete projects, revenue recognised and revenue billed are the same figure by design.",
      "billedToDate": "Billed to date",
      "billingLink": "Billing history",
      "byPhaseTitle": "By phase",
      "byPhaseNote": "Phase and task rows carry the time cost only. Purchases and commitments are recorded against the project, not against a task, so they appear in the project totals above and not here.",
      "ofBudget": "Of budget",
      "noPhasesTitle": "No phases",
      "noPhasesDescription": "Group tasks into phases on the project's overview to see this breakdown.",
      "byTaskTitle": "By task",
      "noTasksTitle": "No tasks",
      "noTasksDescription": "A project with no tasks has no budget to measure against.",
      "loadFailed": "Could not load profitability"
    },
    "billing": {
      "title": "Billing",
      "methods": {
        "fixed_price_milestone": "Fixed price, by milestone",
        "time_and_materials": "Time and materials",
        "percent_complete": "Percent complete"
      },
      "methodHints": {
        "fixed_price_milestone": "Agreed amounts, invoiced one milestone at a time as each is delivered.",
        "time_and_materials": "Approved, billable hours invoiced at each person's bill rate.",
        "percent_complete": "Cost-to-cost: the share of the budget spent decides the share of the contract value earned, and the increase since last time is invoiced."
      },
      "methodUnset": "Not set",
      "noMethod": "This project has no billing method, so none of the three billing actions can run.",
      "setMethodLink": "Set it on the project",
      "noRevenueAccount": "This project has no revenue account, so no invoice can be raised.",
      "noRevenueAccountTitle": "No revenue account",
      "milestonesTitle": "Billing milestones",
      "addMilestone": "Add milestone",
      "addMilestoneDescription": "An agreed amount, invoiced when the deliverable lands.",
      "amount": "Amount",
      "dueDate": "Due",
      "markReady": "Mark delivered",
      "invoiceIt": "Invoice",
      "invoiceColumn": "Invoice",
      "openInvoice": "Open",
      "milestoneStatuses": {
        "pending": "Pending",
        "ready": "Delivered",
        "invoiced": "Invoiced",
        "cancelled": "Cancelled"
      },
      "milestoneAdded": "Milestone added",
      "readyTitle": "Marked as delivered",
      "noMilestonesTitle": "No milestones yet",
      "noMilestonesDescription": "Add the agreed amounts and their deliverables. Each is marked delivered first, then invoiced.",
      "tmTitle": "Time and materials",
      "tmPreviewTitle": "What this run will invoice",
      "tmPreviewNote": "Every approved, billable, unbilled hour on this project up to the date below, grouped by task exactly as the invoice will group it. Each amount is the figure written on the line when its timesheet was approved.",
      "through": "Up to",
      "throughHint": "Leave blank to bill everything approved and unbilled.",
      "invoiceLine": "Invoice line",
      "hours": "Hours",
      "netAmount": "Net",
      "netTotal": "Net total",
      "taxNote": "Net of tax. The invoice's total is this plus whatever tax the receivables module resolves per line.",
      "zeroRateLines": "{count} line(s) in this run carry no bill amount, because the person had no bill rate when the timesheet was approved. Their hours will appear on the invoice with nothing against them.",
      "runTm": "Raise the invoice",
      "tmEmptyTitle": "Nothing to bill",
      "tmEmptyDescription": "There is no approved, billable, unbilled time on this project up to that date. Approve a timesheet and it will appear here.",
      "generalTime": "General project time",
      "percentTitle": "Percent complete",
      "percentPreviewNote": "Cost-to-cost, worked out from the profitability figures the same way the run works it out. It is a projection: the run reads cost and budget again inside its own transaction, so a timesheet approved in the meantime moves it.",
      "percentComplete": "Percent complete",
      "earnedToDate": "Earned to date",
      "increment": "This run would invoice",
      "percentCapped": "Cost has reached or passed the budget, so the ratio is capped at 100%.",
      "nothingToRecognise": "Everything earned so far is already recognised, so there is nothing new to invoice.",
      "runPercent": "Recognise and invoice",
      "percentBlockedTitle": "Percent complete cannot be worked out yet",
      "percentBlockedDescription": "It needs both a contract value on the project and a budget on its tasks. Without either, there is no ratio to compute.",
      "confirmTitle": "Raise this invoice?",
      "confirmDescription": "This raises, confirms and posts a receivables invoice in one step.",
      "confirmIrreversible": "There is no draft to review afterwards, and this screen cannot undo it. A mistake is corrected with a credit note in the receivables module.",
      "confirmSubmit": "Raise and post",
      "linesToBill": "Timesheet lines",
      "invoiceDate": "Invoice date",
      "invoiceDateHint": "Defaults to today in the tenant's timezone.",
      "invoicedTitle": "Invoice raised",
      "failed": "Could not raise the invoice",
      "historyTitle": "Billing history",
      "billedOn": "Billed on",
      "noHistoryTitle": "Nothing billed yet",
      "noHistoryDescription": "Every billing run this project makes is recorded here with the invoice it raised.",
      "loadFailed": "Could not load billing"
    },
    "timesheets": {
      "title": "Timesheets",
      "description": "A week of hours per person. Approving one costs it into the ledger.",
      "openWeekTitle": "Open a week",
      "openWeekNote": "A timesheet week always starts on a Monday, in the tenant's timezone. Whatever date is chosen is snapped back to its Monday.",
      "weekOf": "Week of",
      "weekHint": "Any day of the week you want.",
      "snappedTo": "That week starts {date}.",
      "forEmployee": "For",
      "forEmployeeHint": "Leave blank for your own week.",
      "myself": "Myself",
      "openWeek": "Open",
      "ownOnly": "Showing your own timesheets. Seeing everybody's needs the timesheet read permission.",
      "pageHours": "{hours} hours on this page",
      "emptyTitle": "No timesheets here",
      "emptyDescription": "Open a week above and fill in the grid — project and task down the side, days across the top.",
      "loadFailed": "Could not load timesheets"
    },
    "timesheet": {
      "title": "Week of {week}",
      "railTitle": "Week of {week}",
      "week": "Week",
      "employee": "Person",
      "gridTitle": "Hours",
      "gridCaption": "Projects and tasks down the side, the days of the week across the top.",
      "pickProject": "Choose a project",
      "noTask": "No task",
      "descriptionPlaceholder": "What was done",
      "billable": "Billable",
      "cellLabel": "Hours on {day}",
      "rowTotal": "Total",
      "dayTotals": "Day totals",
      "addRow": "Add a row",
      "removeRow": "Remove this row",
      "keyboardHint": "Enter moves down a column and adds a row at the bottom. Alt+Down duplicates a row, Alt+Backspace removes it, and the arrow keys move between rows.",
      "hoursScaleNote": "Hours are recorded to {scale} decimal places, at most 24 in a day.",
      "weekTotal": "Week",
      "statuses": {
        "draft": "Draft",
        "submitted": "Submitted",
        "approved": "Approved and costed",
        "rejected": "Rejected"
      },
      "costColumn": "Cost",
      "notCosted": "Not costed",
      "incompleteRows": "{count} row(s) have hours but no project, and would be dropped. Choose a project or clear the hours.",
      "invalidCells": "{count} cell(s) are not hours the server will take. Each must be a figure greater than nil and at most 24.",
      "strayLines": "{count} line(s) on this timesheet fall outside its week and are not shown in the grid. Saving will remove them.",
      "postingTitle": "What approving will post",
      "postingNote": "Approving is the only thing that costs a timesheet. It resolves each person's cost rate from the project's team, writes the cost on every line, and posts one journal: debit Project WIP for each project's hours, credit Payroll clearing for the week's total.",
      "wouldDebit": "Debit WIP",
      "wouldCredit": "Credit payroll clearing",
      "postingProjection": "A projection at the rates on file right now. Approval resolves them again when it runs, and the figures it writes are the ones of record.",
      "postingIncomplete": "One of these projects has no cost rate for this person, so approval will be refused. Add them to that project's team first.",
      "noRate": "No rate",
      "noRateBanner": "This person has no cost rate on {project}, so their time cannot be costed.",
      "noRateLink": "Add them to the team",
      "settingsMissing": "This legal entity has no WIP or payroll-clearing account configured, so nothing can be costed.",
      "settingsLink": "Set the accounts",
      "costedTitle": "Costed",
      "costedNote": "These are the server's figures, written when the timesheet was approved and posted. Nothing on this screen recomputes them.",
      "totalCost": "Total cost",
      "journal": "Journal entry",
      "approveAndPost": "Approve and post",
      "unsavedGuard": {
        "title": "Discard unsaved changes?",
        "message": "This timesheet has changes that have not been saved. Leaving now discards them.",
        "confirm": "Discard changes",
        "cancel": "Keep editing"
      },
      "saveBeforeSubmit": "Save the grid before submitting it.",
      "savedTitle": "Timesheet saved",
      "savedDetail": "The grid now holds exactly what you see.",
      "saveFailed": "Could not save the timesheet",
      "submittedTitle": "Submitted for approval",
      "submittedDetail": "It will be costed when the last approver decides.",
      "submitFailed": "Could not submit the timesheet",
      "autoApprovedTitle": "Submitted, approved and costed",
      "autoApprovedDetail": "No approval policy matched, so the cost was posted in the same step.",
      "approvedTitle": "Approved and costed",
      "approvedDetail": "The journal has been posted; the timesheet now shows its figures.",
      "approveFailed": "Could not approve the timesheet",
      "rejectTitle": "Reject this timesheet",
      "rejectDescription": "It goes back to the person to correct and resubmit. Nothing is posted.",
      "rejectReason": "Why",
      "rejectedTitle": "Rejected",
      "rejectedDetail": "The person can edit and resubmit it.",
      "rejectedBanner": "Rejected: {reason}",
      "rejectFailed": "Could not reject the timesheet",
      "discard": "Discard",
      "discardTitle": "Discard this timesheet?",
      "discardDescription": "A draft with no approval history. It cannot be recovered.",
      "discardedTitle": "Discarded",
      "discardedDetail": "The week is free to open again.",
      "discardFailed": "Could not discard the timesheet",
      "openFailed": "Could not open that week",
      "loadFailed": "Could not load the timesheet",
      "rail": {
        "week": "Week starts",
        "submitted": "Submitted",
        "approved": "Approved",
        "approvedDetail": "Cost posted to the ledger",
        "employeeSheets": "This person's timesheets",
        "journal": "Journal entry"
      },
      "contractorOwner": "Contractor #{id}",
      "unknownOwner": "Unknown owner",
      "postingContractor": "This week belongs to a contractor, whose rate is a flat one on their portal user rather than a rate per project. That table belongs to the portal and this app cannot read it, so what approval will cost is not shown here — the figures appear on the timesheet once it has been approved and posted.",
      "noContractorRateBanner": "Contractor #{id} has no cost rate configured, so their time cannot be costed. The rate is set on their portal user, not on a project team."
    },
    "settings": {
      "title": "Project settings",
      "description": "The two accounts timesheet costing posts between, per legal entity.",
      "companyTitle": "Legal Entity",
      "accountsTitle": "Costing accounts",
      "postingNote": "When a timesheet is approved, one journal is posted: debit the WIP account for each project's costed hours, credit the payroll-clearing account for the week's total. WIP is an asset — work done and not yet billed. Payroll clearing is the liability the payroll run later relieves.",
      "incomplete": "Both accounts are needed. Until they are set, approving a timesheet is refused.",
      "wipAccount": "Work-in-progress account",
      "wipAccountHint": "Debited with each project's costed hours. An asset account.",
      "clearingAccount": "Payroll clearing account",
      "clearingAccountHint": "Credited with the week's total cost. A liability account.",
      "pickAccount": "Choose an account",
      "saveHint": "Changing these affects timesheets approved from now on, never ones already posted.",
      "savedTitle": "Settings saved",
      "savedDetail": "Timesheets for this legal entity can now be costed.",
      "saveFailed": "Could not save the settings",
      "loadFailed": "Could not load the settings",
      "stale": "Somebody else saved these project accounts while you had them open. Nothing was overwritten — reload the saved version, then apply your edits again.",
      "reload": "Reload the saved version"
    },
    "c11": {
      "routeTitles": {
        "wipRuns": "WIP runs",
        "retentions": "Retentions",
        "advances": "Advances",
        "allocations": "Allocation board",
        "resources": "Planning resources",
        "variations": "Variations",
        "risks": "Risk register",
        "subcontracts": "Subcontracts",
        "contractSettings": "Contract accounts",
        "baselines": "Baselines",
        "schedule": "Schedule",
        "evm": "Earned value",
        "contract": "Contract terms"
      },
      "nav": {
        "wipRuns": "WIP",
        "retentions": "Retentions",
        "advances": "Advances",
        "variations": "Variations",
        "subcontracts": "Subcontracts",
        "risks": "Risks",
        "resources": "Resources",
        "allocations": "Allocations",
        "contractSettings": "Contract accounts"
      },
      "tabs": {
        "baselines": "Baselines",
        "schedule": "Schedule",
        "evm": "Earned value",
        "contract": "Contract"
      },
      "project": "Project",
      "status": "Status",
      "choose": "Choose one",
      "optional": "Optional",
      "note": "Note",
      "comment": "Comment",
      "reasonCode": "Reason code",
      "taxCode": "Tax code",
      "currency": "Currency",
      "costCategory": "Cost category",
      "from": "From",
      "to": "To",
      "costCategories": {
        "labour": "Labour",
        "material": "Material",
        "subcontract": "Subcontract",
        "expense": "Expense",
        "overhead": "Overhead"
      },
      "wip": {
        "title": "Work in progress runs",
        "description": "Every open contract valued at a period end: what the work is worth so far, what has been billed, and the journal that recognises the difference.",
        "new": "New run",
        "run": "Run it",
        "newDescription": "A run values every open contract in one legal entity for one fiscal period.",
        "created": "WIP run created",
        "period": "Period",
        "periodHint": "Only open periods can be valued.",
        "periodRequired": "Choose the period to value.",
        "asOf": "As at",
        "projectCount": "Projects",
        "contractAsset": "Contract asset movement",
        "contractLiability": "Contract liability movement",
        "lossProvision": "Loss provision movement",
        "revenue": "Revenue movement",
        "loadFailed": "The WIP runs could not be loaded",
        "detailFailed": "This run could not be loaded",
        "emptyTitle": "No WIP runs yet",
        "emptyDescription": "Value a period to see what each contract is worth against what has been billed.",
        "linesTitle": "Per project",
        "contractValue": "Contract value",
        "costToDate": "Cost to date",
        "eac": "Estimate at completion",
        "percentComplete": "Complete",
        "revenueToDate": "Revenue to date",
        "billedToDate": "Billed to date",
        "positionPrior": "Position before",
        "positionNow": "Position now",
        "lossExpected": "Expected loss",
        "post": "Post the journal",
        "posted": "WIP run posted",
        "postFailed": "The run was not posted",
        "postedAt": "Posted",
        "notPosted": "Not posted yet",
        "journal": "Journal entry",
        "allProjects": "All projects",
        "reverse": "Reverse",
        "reversed": "WIP run reversed",
        "reverseTitle": "Reverse this run?",
        "reverseDescription": "A reversal is a new run that mirrors this one. The posted journal is never deleted.",
        "reason": "Reason",
        "reasonRequired": "A reason is required to reverse a posted run.",
        "reversalDate": "Reversal date",
        "statuses": {
          "draft": "Draft",
          "posted": "Posted",
          "reversed": "Reversed",
          "cancelled": "Cancelled"
        }
      },
      "retentions": {
        "title": "Retention register",
        "description": "Money the customer holds back from every claim until a date, and what has been released or forfeited since.",
        "new": "Withhold retention",
        "newDescription": "Retention is withheld from one claim invoice at an agreed percentage.",
        "created": "Retention withheld",
        "claim": "Claim invoice",
        "claimInvoiceId": "Claim invoice",
        "percent": "Percent",
        "withheld": "Withheld",
        "outstanding": "Outstanding",
        "dueOn": "Release due",
        "withheldOn": "Withheld on",
        "dueBefore": "Due before",
        "dueBeforeHint": "The release calendar: what falls due by this date.",
        "fieldsRequired": "A project, a claim invoice, a percentage and a release date are required.",
        "loadFailed": "The retentions could not be loaded",
        "emptyTitle": "No retention withheld",
        "emptyDescription": "Retention is withheld claim by claim. Nothing on these filters is being held.",
        "release": "Release",
        "released": "Retention released",
        "releaseTitle": "Release this retention?",
        "releaseDescription": "Releasing raises an invoice for money that was always the contractor's.",
        "releaseDate": "Release date",
        "forfeit": "Forfeit",
        "forfeited": "Retention forfeited",
        "forfeitTitle": "Forfeit this retention?",
        "forfeitDescription": "A forfeit is a write-off or a price adjustment and posts a journal. It always carries a reason.",
        "forfeitKind": "Kind",
        "forfeitAmount": "Amount",
        "forfeitDate": "Forfeit date",
        "forfeitFieldsRequired": "An amount and a reason code are required to forfeit.",
        "journal": "Journal",
        "kinds": {
          "write_off": "Write-off",
          "price_adjustment": "Price adjustment"
        },
        "statuses": {
          "withheld": "Withheld",
          "part_released": "Part released",
          "released": "Released",
          "forfeited": "Forfeited"
        }
      },
      "advances": {
        "title": "Advance register",
        "description": "Money the customer paid before the work, and the slice of it each claim recoups.",
        "new": "New advance",
        "newDescription": "An advance raises its own invoice and is recouped from later claims at an agreed percentage.",
        "created": "Advance raised",
        "advanceInvoice": "Advance invoice",
        "claimInvoice": "Claim invoice",
        "claimInvoiceId": "Claim invoice",
        "creditNote": "Credit note",
        "amount": "Amount",
        "percent": "Recoupment",
        "recouped": "Recouped",
        "outstanding": "Outstanding",
        "tax": "Tax",
        "recoupedOn": "Recouped on",
        "invoiceDate": "Invoice date",
        "percentHint": "The share of each claim this advance is recouped from.",
        "amountHint": "Leave empty to apply the recoupment percentage to the claim.",
        "fieldsRequired": "A project, an amount and a recoupment percentage are required.",
        "claimRequired": "Name the claim invoice this advance is recouped from.",
        "recoup": "Recoup",
        "recoupTitle": "Recoup against a claim",
        "recoupDescription": "The advance is recouped from one claim invoice and a credit note records it.",
        "scheduleTitle": "Recoupment schedule",
        "scheduleFailed": "The recoupment schedule could not be loaded",
        "noRecoupmentsTitle": "Nothing recouped yet",
        "noRecoupmentsDescription": "This advance is still outstanding in full.",
        "loadFailed": "The advances could not be loaded",
        "emptyTitle": "No advances",
        "emptyDescription": "An advance is money taken before the work. Raise one to have it recouped automatically from later claims.",
        "statuses": {
          "outstanding": "Outstanding",
          "recouped": "Recouped",
          "written_off": "Written off"
        }
      },
      "allocations": {
        "title": "Allocation board",
        "description": "One row per resource, one cell per week: hours booked against hours available, with every conflict as the server computed it.",
        "resource": "Resource",
        "week": "Week",
        "hours": "Hours",
        "taskId": "Task",
        "book": "Book time",
        "booked": "Allocation booked",
        "bookDescription": "Booking beyond capacity needs a reason, and the reason is stored with the booking.",
        "fieldsRequired": "A resource, a project, a week and a number of hours are required.",
        "overrideReason": "Override reason",
        "overrideHint": "Required only when the booking exceeds the resource's capacity.",
        "overAllocated": "Over capacity",
        "withinCapacity": "Within capacity",
        "chooseWindowTitle": "Choose the weeks to show",
        "chooseWindowDescription": "The board covers the dates you ask for. Nothing here guesses at 'this month' from your browser's clock.",
        "loadFailed": "The allocation board could not be loaded",
        "emptyTitle": "No resources in this window",
        "emptyDescription": "Nobody is set up as a planning resource for this legal entity, or nobody has capacity in these weeks.",
        "bookingsTitle": "Bookings in this window",
        "bookingsFailed": "The bookings could not be loaded",
        "noBookingsTitle": "Nothing booked in these weeks",
        "noBookingsDescription": "Capacity exists but no project has claimed it yet.",
        "remove": "Remove",
        "removed": "Allocation removed",
        "removeTitle": "Remove this booking?",
        "removeDescription": "The hours go back to the resource's free capacity for that week.",
        "removeFailed": "The booking was not removed",
        "utilisationTitle": "Utilisation",
        "utilisationFailed": "The utilisation report could not be loaded",
        "available": "Available",
        "planned": "Planned",
        "actual": "Actual",
        "plannedPercent": "Planned utilisation",
        "actualPercent": "Actual utilisation"
      },
      "resources": {
        "title": "Planning resources",
        "description": "An employee seen from the planning side: the rate a plan values their time at, and the hours they are available each week.",
        "new": "Add resource",
        "edit": "Edit resource",
        "editorDescription": "The employee cannot be changed once a resource exists — allocations, capacity and posted costs all hang off it.",
        "saved": "Resource saved",
        "employee": "Employee",
        "employeeNo": "Employee no.",
        "rate": "Planning cost rate",
        "rateHint": "Values a plan. A timesheet's actual cost still resolves from the project's own member rates.",
        "active": "Active",
        "inactive": "Inactive",
        "activeOnly": "Active only",
        "fieldsRequired": "A legal entity and an employee are required.",
        "loadFailed": "The resources could not be loaded",
        "emptyTitle": "No planning resources yet",
        "emptyDescription": "Add the people whose time is planned, so the allocation board has rows.",
        "capacityTitle": "Weekly capacity",
        "capacityFailed": "The capacity could not be loaded",
        "capacitySaved": "Capacity saved",
        "capacitySavedDetail": "{count} week(s) sent.",
        "availableHours": "Available hours",
        "addWeek": "Add week",
        "removeWeek": "Remove",
        "saveCapacity": "Save capacity",
        "weeksInGrid": "week(s) will be sent",
        "weekFieldsRequired": "A week and a number of hours are required.",
        "chooseWindowTitle": "Choose the weeks to edit",
        "chooseWindowDescription": "Capacity is edited a window at a time; every week shown is sent when you save."
      },
      "baselines": {
        "title": "Baselines",
        "description": "The plan somebody agreed to, its versions, and what has changed underneath it since.",
        "new": "New baseline",
        "newDescription": "A baseline snapshots the current WBS, its dates and its budget.",
        "created": "Baseline created",
        "nameRequired": "A name is required.",
        "name": "Name",
        "no": "Baseline no.",
        "version": "Version",
        "budget": "Budget",
        "contractValue": "Contract value",
        "variationId": "From variation",
        "variationHint": "Leave empty for a plain re-baseline.",
        "loadFailed": "The baselines could not be loaded",
        "detailFailed": "This baseline could not be loaded",
        "emptyTitle": "No baselines yet",
        "emptyDescription": "Take a baseline once the plan is agreed, so the work has something to be measured against.",
        "linesTitle": "Baseline lines",
        "wbs": "WBS",
        "lineName": "Name",
        "start": "Start",
        "end": "End",
        "hours": "Hours",
        "submit": "Submit for approval",
        "submitted": "Baseline submitted",
        "submitFailed": "The baseline was not submitted",
        "approve": "Approve",
        "approved": "Baseline approved",
        "approveTitle": "Approve this baseline?",
        "reject": "Reject",
        "rejected": "Baseline rejected",
        "rejectTitle": "Reject this baseline?",
        "decideDescription": "A comment is recorded with the decision and is visible to whoever drew the plan.",
        "decideFailed": "The decision was not recorded",
        "approvedAt": "Approved",
        "supersededBy": "superseded by baseline #{id}",
        "delete": "Delete",
        "deleted": "Baseline deleted",
        "deleteTitle": "Delete this baseline?",
        "deleteDescription": "Only a baseline nobody has approved can be deleted.",
        "deleteFailed": "The baseline was not deleted",
        "compare": "Compare with current",
        "hideComparison": "Hide comparison",
        "comparisonTitle": "Baseline versus current",
        "comparisonFailed": "The comparison could not be loaded",
        "baselineBudget": "Baseline",
        "currentBudget": "Current",
        "delta": "Change",
        "endDateDelta": "Days late",
        "state": "Change",
        "states": {
          "unchanged": "Unchanged",
          "changed": "Changed",
          "added": "Added",
          "removed": "Removed"
        },
        "statuses": {
          "draft": "Draft",
          "submitted": "Submitted",
          "approved": "Approved",
          "rejected": "Rejected",
          "superseded": "Superseded"
        }
      },
      "variations": {
        "title": "Variations",
        "description": "Changes to the contract: what each costs, what it earns and how many days it adds — with the internal approval and the customer's acceptance kept apart.",
        "new": "New variation",
        "edit": "Edit variation",
        "editorDescription": "A variation may be edited only while it is a draft.",
        "saved": "Variation saved",
        "no": "Variation no.",
        "variationTitle": "Title",
        "descriptionLabel": "Description",
        "origin": "Origin",
        "costImpact": "Cost impact",
        "revenueImpact": "Revenue impact",
        "days": "Days",
        "magnitude": "Magnitude",
        "impactNote": "Impact note",
        "titleRequired": "A title is required.",
        "projectRequired": "Choose the project this variation belongs to.",
        "daysWhole": "The schedule impact must be a whole number of days.",
        "amendmentReason": "Amendment reason",
        "amendmentHint": "Recorded against the change so the trail explains itself.",
        "loadFailed": "The variations could not be loaded",
        "detailFailed": "This variation could not be loaded",
        "emptyTitle": "No variations",
        "emptyDescription": "Raise a variation when the scope changes, so the impact is priced before the work starts.",
        "submit": "Submit for approval",
        "submitted": "Variation submitted",
        "submitFailed": "The variation was not submitted",
        "submittedAt": "Submitted",
        "accept": "Record customer acceptance",
        "accepted": "Customer acceptance recorded",
        "acceptTitle": "Record the customer's acceptance",
        "acceptDescription": "Acceptance is the customer's decision, not a second internal approval — and it is what produces the new baseline.",
        "acceptFailed": "The acceptance was not recorded",
        "customerReference": "Customer reference",
        "referenceHint": "Their order number, letter reference or email subject.",
        "referenceRequired": "The customer's own reference is required.",
        "attachmentId": "Signed instruction",
        "acceptedOn": "Accepted on",
        "customerAcceptedAt": "Customer accepted",
        "baselineName": "New baseline name",
        "baselineNameHint": "Leave empty to let the server name it after the variation.",
        "resultingBaseline": "Resulting baseline",
        "openBaseline": "Baseline #{id}",
        "reject": "Reject",
        "rejected": "Variation rejected",
        "rejectTitle": "Reject this variation?",
        "rejectDescription": "The reason is stored on the variation and is visible to whoever raised it.",
        "rejectFailed": "The variation was not rejected",
        "reason": "Reason",
        "reasonRequired": "A reason is required.",
        "rejectedReason": "Rejected because",
        "origins": {
          "internal": "Internal",
          "customer": "Customer",
          "site": "Site"
        },
        "statuses": {
          "draft": "Draft",
          "submitted": "Submitted",
          "approved": "Approved",
          "accepted": "Accepted",
          "rejected": "Rejected",
          "withdrawn": "Withdrawn"
        }
      },
      "risks": {
        "title": "Risk register",
        "description": "What could go wrong, how likely it is, what it would cost, and who is doing something about it.",
        "new": "New risk",
        "edit": "Edit risk",
        "saved": "Risk saved",
        "editorDescription": "Probability and impact are scored 1 to 5; the exposure the register sorts by is computed from them server-side.",
        "no": "Risk no.",
        "riskTitle": "Title",
        "descriptionLabel": "Description",
        "category": "Category",
        "probability": "Probability",
        "impact": "Impact",
        "exposure": "Exposure",
        "costImpact": "Cost impact",
        "response": "Response",
        "mitigation": "Mitigation",
        "reviewOn": "Review on",
        "closedAt": "Closed",
        "minExposure": "Minimum exposure",
        "exposureHint": "Show only risks at or above this exposure.",
        "scaleHint": "1 to 5.",
        "scaleRange": "Probability and impact must each be a whole number from 1 to 5.",
        "titleRequired": "A title is required.",
        "projectRequired": "Choose the project this risk belongs to.",
        "matrixTitle": "Risk matrix",
        "probabilityN": "P{n}",
        "impactN": "I{n}",
        "loadFailed": "The risk register could not be loaded",
        "emptyTitle": "No risks on the register",
        "emptyDescription": "Record what could go wrong while there is still time to do something about it.",
        "delete": "Delete",
        "deleted": "Risk deleted",
        "deleteTitle": "Delete this risk?",
        "deleteDescription": "{no} will be removed from the register.",
        "deleteFailed": "The risk was not deleted",
        "responses": {
          "avoid": "Avoid",
          "mitigate": "Mitigate",
          "transfer": "Transfer",
          "accept": "Accept"
        },
        "statuses": {
          "open": "Open",
          "mitigating": "Mitigating",
          "realised": "Realised",
          "closed": "Closed"
        }
      },
      "subcontracts": {
        "title": "Subcontracts",
        "description": "The commitment side of a project: who is doing the work, for how much, and how much of it has been certified.",
        "new": "New subcontract",
        "edit": "Edit subcontract",
        "saved": "Subcontract saved",
        "editorDescription": "The vendor is fixed once a subcontract exists; the purchase order is where the money actually moves.",
        "no": "Subcontract no.",
        "subcontractTitle": "Title",
        "vendor": "Subcontractor",
        "contractValue": "Contract value",
        "retention": "Retention",
        "certified": "Certified",
        "purchaseOrder": "Purchase order",
        "purchaseOrderId": "Purchase order",
        "noPurchaseOrder": "Not raised against a purchase order",
        "starts": "Starts",
        "ends": "Ends",
        "titleRequired": "A title is required.",
        "partiesRequired": "A project and a subcontractor are required.",
        "loadFailed": "The subcontracts could not be loaded",
        "emptyTitle": "No subcontracts",
        "emptyDescription": "Record who is doing the work so the commitment is visible beside the project's own cost.",
        "delete": "Delete",
        "deleted": "Subcontract deleted",
        "deleteTitle": "Delete this subcontract?",
        "deleteDescription": "{no} will be removed.",
        "deleteFailed": "The subcontract was not deleted",
        "statuses": {
          "draft": "Draft",
          "active": "Active",
          "completed": "Completed",
          "terminated": "Terminated"
        }
      },
      "schedule": {
        "title": "Schedule",
        "description": "The WBS with the server's own critical path, the dependencies that produce it, and the skills each task needs.",
        "recompute": "Recompute",
        "recomputed": "Schedule recomputed",
        "recomputeFailed": "The schedule was not recomputed",
        "computedAt": "Computed",
        "neverComputed": "Never computed",
        "businessDays": "counted in business days",
        "calendarDays": "counted in calendar days",
        "criticalCount": "{count} task(s) on the critical path",
        "loadFailed": "The schedule could not be loaded",
        "emptyTitle": "No tasks in this project",
        "emptyDescription": "Add tasks to the WBS and the critical path has something to run through.",
        "earlyStart": "Early start",
        "earlyFinish": "Early finish",
        "lateStart": "Late start",
        "lateFinish": "Late finish",
        "float": "Float (days)",
        "critical": "Critical",
        "onCriticalPath": "On the critical path",
        "milestone": "Milestone",
        "plannedStart": "Planned start",
        "plannedEnd": "Planned end",
        "budget": "Budget",
        "budgetAvailable": "Budget available",
        "budgetExceeded": "Over budget",
        "parent": "Parent task",
        "noParent": "Top level",
        "parentHint": "Re-parenting also decides where this task's cost rolls up.",
        "saveParent": "Save placement",
        "parentSaved": "Placement saved",
        "selfParent": "A task cannot be its own parent.",
        "dependencies": "Predecessors",
        "dependenciesNote": "Saving sends the whole list: anything removed here is deleted server-side.",
        "dependenciesSaved": "Predecessors saved",
        "predecessor": "Predecessor",
        "predecessorRequired": "Choose a predecessor task.",
        "selfDependency": "A task cannot depend on itself.",
        "duplicateDependency": "That task is already a predecessor.",
        "kind": "Kind",
        "lag": "Lag (days)",
        "addDependency": "Add",
        "saveDependencies": "Save predecessors",
        "remove": "Remove",
        "skills": "Required skills",
        "skillsNote": "Saving sends the whole list, the same as the predecessors above.",
        "skillsSaved": "Required skills saved",
        "skill": "Skill",
        "skillId": "Skill",
        "minLevel": "Minimum level",
        "skillRequired": "Name the skill to add.",
        "duplicateSkill": "That skill is already required.",
        "addSkill": "Add",
        "saveSkills": "Save skills",
        "costTitle": "Cost breakdown",
        "costFailed": "The cost breakdown could not be loaded",
        "actualAp": "Actual (AP)",
        "commitment": "Commitment",
        "kinds": {
          "FS": "Finish to start",
          "SS": "Start to start",
          "FF": "Finish to finish",
          "SF": "Start to finish"
        }
      },
      "evm": {
        "title": "Earned value",
        "description": "Planned, earned and actual cost over time, with the cost and schedule indices the server computed from them.",
        "asOf": "As at",
        "bcws": "Planned (BCWS)",
        "bcwp": "Earned (BCWP)",
        "acwp": "Actual (ACWP)",
        "cpi": "Cost index (CPI)",
        "spi": "Schedule index (SPI)",
        "eac": "Estimate at completion",
        "chartAria": "Planned, earned and actual cost over time",
        "refresh": "Recompute now",
        "refreshed": "Earned value recomputed",
        "refreshFailed": "The earned value was not recomputed",
        "loadFailed": "The earned value could not be loaded",
        "emptyTitle": "No earned value yet",
        "emptyDescription": "Earned value is measured against an approved baseline. Approve one, then recompute.",
        "acwpFrom": "Actual cost comes from",
        "approvedTimesheets": "approved timesheets",
        "apCaveat": "and posted AP invoices coded to this project, which no list endpoint filters by project."
      },
      "contract": {
        "title": "Contract terms",
        "description": "What the contract is expected to cost, how it bills, and whether time may be booked to it today.",
        "termsTitle": "Terms",
        "eac": "Estimate at completion",
        "eacHint": "What a WIP run values this contract against.",
        "costPlusPercent": "Cost-plus uplift",
        "retainerAmount": "Retainer",
        "editTitle": "Edit contract terms",
        "editDescription": "These figures are inputs to a WIP run and to the two billing runs below.",
        "saved": "Contract terms saved",
        "loadFailed": "The contract terms could not be loaded",
        "emptyTitle": "No contract terms recorded",
        "emptyDescription": "Set the estimate at completion so a WIP run has something to value the contract against.",
        "gateFailed": "The chargeability gate could not be read",
        "chargeable": "Chargeable",
        "notChargeable": "Not chargeable",
        "gateOn": "as at",
        "override": "Override the gate",
        "overridden": "Override recorded",
        "overrideTitle": "Let time be booked anyway",
        "overrideDescription": "An override switches a control off for a stated window. It always ends on a date.",
        "overrideExpires": "override expires",
        "overrideFieldsRequired": "A reason code and an expiry date are required.",
        "validTo": "Valid until",
        "validToHint": "An override with no end is a control nobody switched back on.",
        "revoke": "Revoke",
        "revoked": "Override revoked",
        "revokeFailed": "The override was not revoked",
        "billCostPlus": "Bill cost-plus",
        "billRetainer": "Bill retainer",
        "billDescription": "Both runs raise a real AR invoice and post it.",
        "billed": "Invoice raised",
        "raiseInvoice": "Raise the invoice",
        "through": "Costs through",
        "throughHint": "Bill costs recorded up to this date.",
        "uplift": "Uplift",
        "upliftHint": "Leave empty to use the contract's own cost-plus percentage.",
        "periodStart": "Period start",
        "periodEnd": "Period end",
        "periodStartRequired": "A retainer period needs a start date.",
        "amount": "Amount",
        "amountHint": "Leave empty to bill the contract's own retainer amount.",
        "invoiceDate": "Invoice date",
        "lastBillingTitle": "The invoice this raised",
        "invoice": "Invoice",
        "billedOn": "Billed on",
        "reasons": {
          "gate_disabled": "the chargeability gate is switched off for this legal entity",
          "baseline_approved": "an approved baseline is in force",
          "override": "an override is in force",
          "no_approved_baseline": "no baseline has been approved"
        }
      },
      "settings": {
        "title": "Contract accounts",
        "description": "The six accounts a WIP run, a retention, an advance and a loss provision post to. Until they are set, those postings refuse rather than guess.",
        "accountsTitle": "Account mapping",
        "chooseCompanyTitle": "Choose a legal entity",
        "chooseCompanyDescription": "Contract accounts are set per legal entity, because each has its own chart of accounts.",
        "loadFailed": "The contract accounts could not be loaded",
        "saved": "Contract accounts saved",
        "notSet": "Not set",
        "unset": "{count} account(s) are not set. A WIP run will refuse until they are.",
        "fields": {
          "contractAssetAccountId": "Contract asset",
          "contractLiabilityAccountId": "Contract liability",
          "retentionReceivableAccountId": "Retention receivable",
          "contractAdvanceAccountId": "Contract advance",
          "lossProvisionAccountId": "Loss provision",
          "contractLossAccountId": "Contract loss"
        },
        "hints": {
          "contractAssetAccountId": "Work done and not yet billed.",
          "contractLiabilityAccountId": "Billed ahead of the work.",
          "retentionReceivableAccountId": "Retention withheld from a claim.",
          "contractAdvanceAccountId": "Advances taken before the work.",
          "lossProvisionAccountId": "The provision an onerous contract carries.",
          "contractLossAccountId": "Where that provision is expensed."
        },
        "stale": "Somebody else saved these project settings while you had them open. Nothing was overwritten — reload the saved version, then apply your edits again.",
        "reload": "Reload the saved version"
      }
    }
  },
  "service": {
    "routeTitles": {
      "tickets": "Service tickets",
      "ticket": "Ticket",
      "customerAssets": "Customer assets",
      "customerAsset": "Customer asset",
      "pmSchedules": "Preventive maintenance",
      "assignmentRules": "Assignment rules",
      "reports": "Service reports",
      "settings": "Service settings",
      "workOrders": "Work orders",
      "workOrder": "Work order",
      "dispatch": "Dispatch board",
      "contracts": "Service contracts",
      "contract": "Contract",
      "rateCards": "Rate cards",
      "rateCard": "Rate card",
      "vans": "Vans",
      "problems": "Problems",
      "goodwill": "Goodwill"
    },
    "nav": {
      "label": "Service sections",
      "tickets": "Tickets",
      "customerAssets": "Customer assets",
      "pmSchedules": "Preventive maintenance",
      "assignmentRules": "Assignment rules",
      "reports": "Reports",
      "settings": "Settings",
      "slaPolicies": "SLA policies"
    },
    "statuses": {
      "new": "New",
      "open": "Open",
      "pending": "Pending",
      "resolved": "Resolved",
      "closed": "Closed"
    },
    "priorities": {
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      "urgent": "Urgent"
    },
    "origins": {
      "manual": "Raised here",
      "portal": "Portal",
      "email": "Email"
    },
    "invoiceStatuses": {
      "not_billable": "Not billable",
      "unbilled": "Unbilled",
      "invoiced": "Invoiced"
    },
    "unassigned": "Unassigned",
    "fields": {
      "caseNo": "Ticket",
      "subject": "Subject",
      "description": "Description",
      "name": "Name",
      "company": "Legal Entity",
      "companyPlaceholder": "Choose a legal entity",
      "customer": "Customer",
      "customerPlaceholder": "Choose a customer",
      "customerAsset": "Customer asset",
      "customerAssetPlaceholder": "Choose a unit",
      "category": "Category",
      "causeCode": "Cause code",
      "priority": "Priority",
      "origin": "Origin",
      "slaPolicy": "SLA policy",
      "assignee": "Assigned to",
      "warehouse": "Warehouse",
      "contactName": "Contact",
      "contactEmail": "Contact email",
      "contactPhone": "Contact phone",
      "billable": "Billable",
      "isRevisit": "This is a revisit",
      "invoiceStatus": "Billing",
      "code": "Code",
      "title": "Title",
      "summary": "Summary",
      "workOrderNo": "Work order",
      "kind": "Kind",
      "appointmentOn": "Appointment",
      "amount": "Amount",
      "billability": "Billable",
      "asset": "Asset",
      "totalCost": "Cost",
      "date": "Date",
      "reasonCode": "Reason code",
      "item": "Part",
      "quantity": "Quantity",
      "unitCost": "Unit cost",
      "billAmount": "Bill",
      "covered": "Covered",
      "chargeable": "Chargeable",
      "technician": "Technician",
      "taxCode": "Tax code",
      "workDate": "Work date",
      "workOrder": "Work order",
      "workPerformed": "Work performed / resolution",
      "hours": "Hours",
      "billRate": "Rate",
      "contractNo": "Contract",
      "startsOn": "Starts",
      "endsOn": "Ends",
      "fee": "Fee",
      "renewal": "Renewal",
      "term": "Term",
      "ticket": "Ticket",
      "rateCard": "Rate card",
      "scope": "Scope",
      "quotaHours": "Quota (h)",
      "usedHours": "Used (h)",
      "remainingHours": "Remaining (h)",
      "remaining": "Remaining",
      "exhaustedPolicy": "When exhausted",
      "currency": "Currency",
      "version": "Version",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "travelRate": "Travel",
      "minimumCharge": "Minimum",
      "preApproval": "Pre-approval above",
      "skill": "Competency",
      "overtime": "Overtime",
      "hourlyRate": "Hourly rate",
      "registration": "Registration",
      "parQty": "Par",
      "minQty": "Minimum",
      "onHand": "On hand",
      "proposed": "Proposed",
      "issued": "Issued",
      "problemNo": "Problem",
      "linkedCases": "Linked cases",
      "kbArticle": "Known error",
      "article": "Article",
      "views": "Views",
      "resolved": "Resolved",
      "deflectionRate": "Deflection"
    },
    "list": {
      "title": "Service tickets",
      "description": "Work the desk owes a customer, ordered by how close each promise is to being broken.",
      "filtersTitle": "Filters",
      "searchPlaceholder": "Ticket number or subject",
      "new": "New ticket",
      "resolutionClock": "Resolution clock",
      "clockNote": "A deadline that has passed is shown as overdue until the breach sweep records it; only then is the assignee notified and the policy's contact escalated to.",
      "loadFailed": "Could not load tickets",
      "emptyTitle": "No tickets here",
      "emptyDescription": "Raise one against a customer and, where it applies, the unit it concerns — the SLA clock starts the moment it exists."
    },
    "create": {
      "title": "New service ticket",
      "description": "A ticket is created and its SLA deadlines computed in one step. There is no draft.",
      "clockNote": "The moment this is saved, the case number is assigned and both SLA deadlines are computed from the chosen policy. Priority and policy cannot be changed afterwards.",
      "priorityHint": "Decides which SLA policy applies, and cannot be changed later.",
      "policyHint": "Leave blank to let the server match one by priority.",
      "noPolicy": "Match by priority",
      "assigneeHint": "Leave blank to let the assignment rules decide.",
      "byRules": "By the rules",
      "warehouseHint": "Where parts will be issued from. Blank uses the legal entity default.",
      "defaultWarehouse": "Legal entity default",
      "assetHint": "Puts this ticket in that unit's service history.",
      "assetNeedsCustomer": "Choose a customer first — an asset belongs to one.",
      "billableHint": "A billable ticket can raise a customer invoice for its parts and labour.",
      "revisitHint": "A return visit for the same fault. Excluded from the first-time-fix rate.",
      "submit": "Raise ticket",
      "doneTitle": "Ticket raised",
      "failed": "Could not raise the ticket"
    },
    "detail": {
      "factsTitle": "Details",
      "openCustomer": "Open customer",
      "noCustomer": "No customer",
      "openAsset": "Open unit",
      "noAsset": "No unit named",
      "noPolicy": "No policy",
      "seePolicies": "See policies",
      "loadFailed": "Could not load the ticket"
    },
    "edit": {
      "title": "Edit ticket",
      "description": "The few fields the service record owns.",
      "scopeNote": "The subject, priority, status and SLA policy belong to the underlying case and are changed through its own actions, not here.",
      "billableHint": "Whether this ticket's parts and labour can be invoiced to the customer."
    },
    "rail": {
      "raised": "Raised",
      "firstResponse": "First response",
      "escalated": "Escalated",
      "resolved": "Resolved",
      "closed": "Closed",
      "customer": "Customer",
      "otherTickets": "Their other tickets",
      "assetHistory": "This unit's history",
      "invoice": "Invoice",
      "case": "Case view"
    },
    "escalatedBanner": "Escalated at",
    "reopenedBanner": "Reopened {count} time(s). The original deadlines still stand.",
    "pmGenerated": "Raised automatically by a preventive-maintenance schedule.",
    "replyTitle": "Reply to the customer",
    "replyNote": "A public reply is what stops the response clock. An internal note on the timeline below stops nothing.",
    "replyLabel": "Reply",
    "replyPublic": "Send to the customer",
    "replyPublicHint": "Only a public, staff-authored reply satisfies the response SLA.",
    "replyPrivateHint": "Unticked, this is recorded but the clock keeps running.",
    "reply": "Send",
    "repliedTitle": "Reply recorded",
    "repliedDetail": "If it was the first public one, the response clock has stopped.",
    "replyFailed": "Could not record the reply",
    "assign": "Assign",
    "assignedTitle": "Assigned",
    "assignFailed": "Could not assign the ticket",
    "resolve": "Resolve",
    "resolveTitle": "Resolve this ticket",
    "resolveDescription": "Stops the resolution clock. The ticket can still be reopened.",
    "resolutionLabel": "What was done",
    "resolvedTitle": "Resolved",
    "resolvedDetail": "The resolution clock has stopped.",
    "resolveFailed": "Could not resolve the ticket",
    "close": "Close",
    "closedTitle": "Closed",
    "closedDetail": "No further work is expected.",
    "closeFailed": "Could not close the ticket",
    "reopen": "Reopen",
    "reopenTitle": "Reopen this ticket",
    "reopenDescription": "It goes back to open and counts against the first-time-fix rate.",
    "reopenKeepsDeadlines": "The original deadlines are kept. A missed SLA stays missed — rewriting the promise afterwards would launder it.",
    "reopenReason": "Why",
    "reopenedTitle": "Reopened",
    "reopenedDetail": "The original deadlines are unchanged.",
    "reopenFailed": "Could not reopen the ticket",
    "updatedTitle": "Ticket updated",
    "updatedDetail": "The service record has been saved.",
    "updateFailed": "Could not update the ticket",
    "csatTitleSection": "Customer satisfaction",
    "csatAsk": "Was the customer satisfied?",
    "csatYes": "Satisfied",
    "csatNo": "Not satisfied",
    "csatOnce": "Recorded once and never edited.",
    "csatSatisfied": "The customer was satisfied",
    "csatUnsatisfied": "The customer was not satisfied",
    "csatTitle": "Rating recorded",
    "csatDetail": "It counts towards the CSAT report.",
    "csatFailed": "Could not record the rating",
    "parts": {
      "title": "Parts consumed",
      "note": "Consuming a part issues real stock: a ledger entry is written and a journal posted at the cost the inventory engine actually charges. That cost is the server's, never re-derived here.",
      "add": "Consume a part",
      "addTitle": "Consume a part",
      "addDescription": "Issues the stock and records what it cost.",
      "addWarning": "This moves stock and posts to the ledger straight away. Voiding restocks it, but only until the ticket has been billed.",
      "item": "Item",
      "itemPlaceholder": "Choose a stocked item",
      "warehousePlaceholder": "Choose a warehouse",
      "quantity": "Quantity",
      "unitCost": "Unit cost",
      "net": "Net",
      "consume": "Consume",
      "consumedTitle": "Part consumed",
      "consumedDetail": "Stock has been issued and the cost recorded.",
      "consumeFailed": "Could not consume the part",
      "consumedCost": "Cost of parts consumed",
      "billableHint": "A billable part becomes an invoice line when the ticket is billed.",
      "notBillable": "Not billable",
      "void": "Void",
      "voided": "Voided",
      "voidTitle": "Void this part",
      "voidDescription": "Restocks it and reverses the cost.",
      "voidNote": "The part is received back at exactly the unit cost it left at. A restock at a re-guessed cost would disagree with the ledger.",
      "voidReason": "Why",
      "voidedTitle": "Part voided",
      "voidedDetail": "It has been restocked at the cost it was issued at.",
      "voidFailed": "Could not void the part",
      "billedNote": "This ticket has been invoiced, so its parts can no longer be voided — the invoice already carries them.",
      "emptyTitle": "No parts used",
      "emptyDescription": "Consuming a part issues stock from a warehouse and records what it cost.",
      "loadFailed": "Could not load the parts"
    },
    "labour": {
      "title": "Labour",
      "add": "Log labour",
      "addTitle": "Log labour",
      "addDescription": "Who worked, for how long, at what rate.",
      "date": "Date",
      "technician": "Technician",
      "technicianPlaceholder": "Choose a technician",
      "hours": "Hours",
      "rate": "Rate",
      "rateHint": "What the customer is charged per hour. There is no service price list in this build, so it is entered per entry.",
      "log": "Log",
      "loggedTitle": "Labour logged",
      "loggedDetail": "It will appear as an invoice line when the ticket is billed.",
      "loggedTotal": "Logged",
      "logFailed": "Could not log the labour",
      "voidedTitle": "Entry voided",
      "voidedDetail": "It stays on the record, struck through.",
      "voidFailed": "Could not void the entry",
      "emptyTitle": "No labour logged",
      "emptyDescription": "Log the time a technician spent, with the rate the customer is charged.",
      "loadFailed": "Could not load the labour"
    },
    "billing": {
      "title": "Billing",
      "previewTitle": "What this will invoice",
      "previewNote": "Every billable, unvoided part and labour row, one invoice line each. Parts are priced at the cost inventory charged; labour at its logged rate.",
      "line": "Line",
      "kinds": {
        "part": "Part",
        "labour": "Labour"
      },
      "quantity": "Quantity",
      "unitPrice": "Unit price",
      "netTotal": "Net total",
      "taxNote": "Net of tax. The invoice's total is this plus whatever tax the receivables module resolves per line.",
      "excluded": "Left out: {parts} part(s) and {labour} labour row(s) that are voided or not billable.",
      "lineCount": "Lines",
      "raise": "Raise the invoice",
      "confirmTitle": "Raise this invoice?",
      "confirmDescription": "This raises, confirms and posts a receivables invoice in one step.",
      "confirmIrreversible": "A ticket bills at most once. There is no draft to review afterwards, and anything added later is left for a follow-up rather than changing an invoice that has already posted.",
      "invoiceDate": "Invoice date",
      "invoiceDateHint": "Defaults to today in the tenant's timezone.",
      "labourTaxCode": "Labour tax code",
      "labourTaxCodeHint": "Parts inherit their item's tax group. Labour has none, so a code can be named here.",
      "doneTitle": "Invoice raised",
      "doneDetail": "The receivables invoice has been confirmed and posted.",
      "failed": "Could not raise the invoice",
      "openInvoice": "Open the invoice",
      "alreadyInvoiced": "This ticket has already been invoiced.",
      "nothingToBill": "There is nothing billable on this ticket yet — log labour or consume a part first.",
      "notBillable": "This ticket is not marked billable, so it cannot raise an invoice.",
      "noCustomer": "This ticket names no customer, and a billable ticket must have one."
    },
    "assets": {
      "listTitle": "Customer assets",
      "listDescription": "Equipment a customer owns and this desk services — not the legal entity's own fixed assets, and not stock serials.",
      "new": "New asset",
      "createTitle": "New customer asset",
      "editTitle": "Edit customer asset",
      "dialogDescription": "A unit belonging to a customer, identified by whatever is on its nameplate.",
      "searchPlaceholder": "Name, model or serial",
      "category": "Category",
      "modelNo": "Model",
      "serialNo": "Serial",
      "serialNoHint": "Free text: what a technician reads off the nameplate. Most units were never our stock.",
      "location": "Location",
      "purchasedAt": "Purchased",
      "warrantyExpiresAt": "Warranty until",
      "warrantyHint": "Work on a unit still under warranty is usually not billable.",
      "notes": "Notes",
      "detailsTitle": "Details",
      "noItemSerial": "This unit is not cross-referenced to a stock serial. That is normal — most were bought elsewhere, are not serialised, or predate this system.",
      "raiseTicket": "Raise a ticket",
      "historyTitle": "Service history",
      "historyNote": "Every ticket ever raised against this unit, newest first. The first-time-fix column uses the report's own rule: resolved, not a revisit, never reopened.",
      "raised": "Raised",
      "resolved": "Resolved",
      "firstTimeFix": "First-time fix",
      "ftfYes": "Fixed first time",
      "revisit": "Revisit",
      "noHistoryTitle": "Never serviced",
      "noHistoryDescription": "Tickets naming this unit will appear here.",
      "pmTitle": "Preventive maintenance",
      "noPmTitle": "No schedule",
      "noPmDescription": "A schedule raises a ticket for this unit on a fixed cycle.",
      "createdTitle": "Asset created",
      "savedTitle": "Asset saved",
      "saveFailed": "Could not save the asset",
      "emptyTitle": "No customer assets yet",
      "emptyDescription": "Record the units this desk services, and every ticket against them builds a history.",
      "loadFailed": "Could not load customer assets"
    },
    "pm": {
      "title": "Preventive maintenance",
      "description": "Schedules that raise a ticket for a customer's unit on a fixed cycle.",
      "listTitle": "Schedules",
      "new": "New schedule",
      "createTitle": "New schedule",
      "editTitle": "Edit schedule",
      "dialogDescription": "A unit, a cycle, and the ticket it should raise.",
      "frequency": "Every",
      "frequencyHint": "In days. Ninety days is a quarterly service.",
      "everyDays": "Every {days} days",
      "nextDue": "Next due",
      "nextDueHint": "A business date in the tenant's timezone.",
      "lastGenerated": "Last generated",
      "subjectTemplate": "Ticket subject",
      "subjectTemplateHint": "What the generated ticket will be called.",
      "active": "Active",
      "activeHint": "An inactive schedule generates nothing and keeps its history.",
      "inactive": "Inactive",
      "runNow": "Generate now",
      "runTitle": "Generate due tickets",
      "runDescription": "Runs the same generation the worker runs on schedule.",
      "runOn": "As of",
      "runOnHint": "Leave blank for today in the tenant's timezone. Set a date to catch up after an outage.",
      "runDoneTitle": "Generation finished",
      "runDoneDetail": "{generated} raised, {skipped} already existed.",
      "runFailed": "Could not run the generation",
      "idempotentNote": "Running this twice is safe: generation is unique per schedule and due date at the database, so a second run finds nothing new and reports it as skipped rather than raising a duplicate.",
      "savedTitle": "Schedule saved",
      "saveFailed": "Could not save the schedule",
      "emptyTitle": "No schedules yet",
      "emptyDescription": "Add one against a customer asset and the worker will raise its tickets on the cycle you set.",
      "loadFailed": "Could not load the schedules"
    },
    "rules": {
      "title": "Assignment rules",
      "description": "How a new ticket finds a technician.",
      "listTitle": "Rules, in the order they are walked",
      "firstMatchNote": "First match wins. The rules are walked in order and the first whose category and priority both match takes the ticket; an empty column matches anything. Rules are consulted only when a ticket is raised — changing one never moves work already handed out.",
      "new": "New rule",
      "createTitle": "New assignment rule",
      "editTitle": "Edit assignment rule",
      "dialogDescription": "A match on category and priority, and the person who gets the ticket.",
      "order": "Order",
      "orderHint": "Lower runs first. Two rules sharing a number resolve by age.",
      "matchCategory": "Category",
      "matchCategoryHint": "Leave blank to match any category.",
      "matchPriority": "Priority",
      "matchPriorityHint": "Any priority matches when nothing is chosen.",
      "anyCategory": "Any category",
      "anyPriority": "Any priority",
      "assignTo": "Assign to",
      "assignToPlaceholder": "Choose a technician",
      "remove": "Remove",
      "removeTitle": "Remove this rule?",
      "removeDescription": "{name} will no longer route anything.",
      "removeNote": "Tickets already assigned by it keep their assignee.",
      "removedTitle": "Rule removed",
      "removeFailed": "Could not remove the rule",
      "savedTitle": "Rule saved",
      "saveFailed": "Could not save the rule",
      "emptyTitle": "No assignment rules",
      "emptyDescription": "Without one, a new ticket arrives unassigned unless somebody is named on the form.",
      "loadFailed": "Could not load the rules"
    },
    "reports": {
      "title": "Service reports",
      "description": "First-time fix, SLA compliance and customer satisfaction.",
      "rangeTitle": "Range",
      "from": "From",
      "to": "To",
      "firstTimeFix": "First-time fix",
      "slaCompliance": "SLA compliance",
      "csat": "Customer satisfaction",
      "denominatorsTitle": "What each figure is out of",
      "ftfDenominator": "{fixed} of {resolved} resolved tickets",
      "slaDenominator": "{tickets} tickets that had a deadline",
      "csatDenominator": "{satisfied} of {submitted} ratings submitted",
      "readingTitle": "How to read these",
      "ftfMeaning": "A ticket counts as fixed first time when it is resolved, was not flagged a revisit when it was raised, and was never reopened. The revisit flag is set by a person, never inferred.",
      "slaMeaning": "Measured over tickets that had a deadline, counting breaches the sweep recorded. A ticket past its deadline that the sweep has not yet reached is not counted as a breach.",
      "csatMeaning": "The denominator is ratings submitted, not tickets. Most tickets are never rated, and dividing by tickets would report a response rate wearing a satisfaction label.",
      "holidayCaveat": "At least one active policy counts business hours, and there is no holiday calendar in this build. A deadline whose window spanned a public holiday landed earlier than a person counting by hand would put it, which makes compliance measured against it pessimistic.",
      "breachesTitle": "Breaches recorded",
      "ticketsWithDeadline": "Tickets with a deadline",
      "responseBreaches": "Response breaches",
      "resolutionBreaches": "Resolution breaches",
      "period": "Period",
      "sweepNote": "These are breaches the sweep has stamped — each one notified its assignee and escalated to the policy's contact.",
      "loadFailed": "Could not load the reports"
    },
    "settings": {
      "title": "Service settings",
      "description": "A legal entity's default warehouse and the account its service invoices credit.",
      "defaultsTitle": "Defaults",
      "note": "Both settings block something when missing: without a default warehouse, consuming a part on a ticket that names none is refused; without a revenue account, billing a ticket is refused. There is one revenue account, not one for parts and one for labour.",
      "defaultWarehouse": "Default warehouse",
      "defaultWarehouseHint": "Where parts are issued from when a ticket does not name a warehouse of its own.",
      "pickWarehouse": "Choose a warehouse",
      "revenueAccount": "Service revenue account",
      "revenueAccountHint": "What every ticket invoice credits. An income account.",
      "pickAccount": "Choose an account",
      "saveHint": "Applies to work billed from now on, never to invoices already posted.",
      "savedTitle": "Settings saved",
      "savedDetail": "Tickets for this legal entity can now consume parts and be billed.",
      "saveFailed": "Could not save the settings",
      "loadFailed": "Could not load the settings",
      "stale": "Somebody else saved these service defaults while you had them open. Nothing was overwritten — reload the saved version, then apply your edits again.",
      "reload": "Reload the saved version"
    },
    "filtersTitle": "Filters",
    "goodwill": {
      "title": "Goodwill",
      "description": "Cause-coded write-offs raised against a customer, posted as an AR credit note once approved.",
      "request": "Request goodwill",
      "requestTitle": "Request goodwill",
      "requestDescription": "A goodwill request waives or reduces a charge for a stated cause. Above the legal entity's threshold it needs an override reason; approving it posts an AR credit note.",
      "requested": "Goodwill requested",
      "requestFailed": "That goodwill request could not be raised.",
      "approve": "Approve",
      "approveTitle": "Approve goodwill",
      "approveDescription": "Approving posts an AR credit note for this amount against the customer, in the same step.",
      "approved": "Goodwill approved",
      "approveFailed": "That goodwill request could not be approved.",
      "loadFailed": "The goodwill register could not be loaded.",
      "empty": "No goodwill requests yet.",
      "idColumn": "ID",
      "tableTitle": "Goodwill requests",
      "caption": "Goodwill requests, their cause, amount, status and credit note.",
      "creditNote": "Credit note",
      "overrideAction": "Requesting goodwill beyond the legal entity's threshold"
    },
    "goodwillStatus": {
      "requested": "Requested",
      "approved": "Approved",
      "rejected": "Rejected",
      "posted": "Posted",
      "cancelled": "Cancelled"
    },
    "labels": {
      "yes": "Yes",
      "no": "No",
      "active": "Active",
      "inactive": "Inactive"
    },
    "workOrderKind": {
      "customer": "Customer",
      "internal": "Internal"
    },
    "workOrderStatus": {
      "draft": "Draft",
      "scheduled": "Scheduled",
      "dispatched": "Dispatched",
      "in_progress": "In progress",
      "incomplete": "Incomplete",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "closed": "Closed"
    },
    "priority": {
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      "urgent": "Urgent"
    },
    "billability": {
      "undecided": "Not yet decided",
      "not_billable": "Not billable",
      "partially_billable": "Partly billable",
      "billable": "Billable"
    },
    "originKind": {
      "service.ticket": "Ticket",
      "service.pm_schedule": "PM schedule",
      "eam.pm_plan": "Preventive plan",
      "eam.compliance": "Compliance",
      "pms.room_fault": "Room fault"
    },
    "visitOutcome": {
      "completed": "Finished",
      "incomplete": "Not finished",
      "no_access": "Could not get in",
      "cancelled": "Cancelled on site"
    },
    "contractStatus": {
      "draft": "Draft",
      "active": "Active",
      "suspended": "Suspended",
      "expired": "Expired",
      "cancelled": "Cancelled"
    },
    "entitlementScope": {
      "labour": "Labour",
      "parts": "Parts",
      "travel": "Travel",
      "response": "Response"
    },
    "exhaustedPolicy": {
      "chargeable_overage": "Charge the overage",
      "chargeable_all": "Charge everything"
    },
    "entitlementDecision": {
      "covered": "Covered",
      "partially_covered": "Partly covered",
      "chargeable": "Chargeable",
      "out_of_contract": "Out of contract"
    },
    "rateCardStatus": {
      "draft": "Draft",
      "published": "Published",
      "superseded": "Superseded"
    },
    "problemStatus": {
      "open": "Open",
      "known_error": "Known error",
      "resolved": "Resolved",
      "closed": "Closed"
    },
    "dispatchRefusal": {
      "service": {
        "workorder": {
          "statutory_skill_missing": "A statutory certificate this job requires is not recorded against this engineer. {detail}",
          "skill_not_held": "This engineer is short of a competency the job asks for. {detail}",
          "outside_working_time": "This falls outside the engineer's working time. {detail}",
          "close_unbilled": "Closing this without an invoice needs an override. {detail}"
        }
      }
    },
    "workOrders": {
      "title": "Work orders",
      "description": "One document for a customer job and an own-asset job alike. Billability is decided by the customer's contract, not typed in here.",
      "tableTitle": "Work orders",
      "caption": "Work orders with their status, priority, assignee and billability.",
      "searchLabel": "Search",
      "empty": "No work orders match. Widen the filters, or raise one from a ticket, a preventive plan or a compliance requirement.",
      "loadFailed": "The work orders could not be loaded.",
      "billabilityNote": "Billability is derived from the customer's contract and their remaining quota, and is re-evaluated when a job completes. It cannot be set by hand from any screen."
    },
    "workOrder": {
      "summary": "Summary",
      "skills": "Competencies required",
      "visits": "Visits",
      "parts": "Parts",
      "labour": "Labour",
      "loadFailed": "That work order could not be loaded.",
      "noSkills": "This job asks for no particular competency.",
      "noVisits": "Nobody has visited yet.",
      "noParts": "No parts have been fitted.",
      "noLabour": "No labour has been logged.",
      "minLevel": "level {level}+",
      "statutory": "Statutory",
      "visitNo": "Visit {no}",
      "signedBy": "signed by {name}",
      "start": "Start work",
      "started": "Work started",
      "startFailed": "This job could not be started.",
      "complete": "Complete",
      "completeTitle": "Complete work order",
      "completeDescription": "Record the work performed or the resolution reached before closing this job out — the note becomes part of the work order's evidence.",
      "completed": "Work order completed",
      "completeFailed": "This job could not be completed.",
      "invoice": "Invoice",
      "ticket": "The ticket this came from",
      "contract": "The contract that covers it"
    },
    "permit": {
      "missing": "This job needs a permit to work and none has been issued. It cannot be started until one is.",
      "pending": "Permit {number} has been requested but not issued. Work may not start until somebody with the authority issues it.",
      "held": "Permit {number} is in force until {validTo}.",
      "board": "Permit board"
    },
    "entitlement": {
      "title": "Entitlement",
      "none": "No entitlement decision has been recorded for this job yet.",
      "coveredLabel": "Covered by contract",
      "chargeableLabel": "Chargeable to the customer",
      "decidedOn": "decided for work on {date}",
      "caption": "Each coverage row considered, with what it drew down and why.",
      "scope": "Scope",
      "quota": "Quota",
      "drawn": "Drawn",
      "remaining": "Remaining",
      "reason": "Reason",
      "noConsiderations": "The decision considered no coverage rows.",
      "history": "{count} earlier decision(s)",
      "superseded": "superseded",
      "reevaluate": "Re-evaluate",
      "reevaluated": "A new entitlement decision was recorded",
      "reevaluateFailed": "The entitlement could not be re-evaluated.",
      "internal_work_order": "An internal job: there is no customer to charge.",
      "no_contract": "No contract covers this customer on the work date.",
      "contract_resolved": "Covered by this contract.",
      "shadowed": "A more specific coverage row applied instead.",
      "no_coverage": "The contract has no coverage row for this scope.",
      "covered": "Fully covered by the remaining quota.",
      "quota_exhausted": "The quota was exhausted.",
      "quota_unit_mismatch": "The quota is held in different units from this charge.",
      "no_rate_card": "No rate card is in force, so nothing can be priced.",
      "partially_covered": "Partly covered: the quota ran out part way.",
      "chargeable": "Chargeable in full.",
      "quota_taken_concurrently": "The quota was taken by another job while this one was being decided."
    },
    "dispatch": {
      "title": "Dispatch board",
      "description": "The day's unassigned jobs, and every technician with the refusals already worked out.",
      "chooseCompany": "Choose a legal entity to see its board.",
      "queue": "Unassigned",
      "queueEmpty": "Nothing is waiting to be assigned.",
      "slotsEmpty": "No technicians are available for this day.",
      "loadFailed": "The board could not be loaded.",
      "assignedCount": "{count} assigned",
      "withinShift": "on shift",
      "assignHere": "Assign here",
      "assigned": "Assigned",
      "assignFailed": "That assignment was refused.",
      "noOverride": "This cannot be overridden.",
      "statutoryRefused": "A statutory certificate is missing. Nobody may override this.",
      "noRoster": "No roster data for this day, so working-time checks could not be made. The refusals below cover competencies only.",
      "overrideTitle": "Override this refusal",
      "overrideNote": "The reason is recorded against the assignment and is visible on the job.",
      "overrideConfirm": "Assign with a reason"
    },
    "contracts": {
      "title": "Service contracts",
      "description": "What each customer is entitled to, what it costs them and when it renews.",
      "tableTitle": "Contracts",
      "caption": "Service contracts with their term, fee and renewal chain.",
      "searchLabel": "Search",
      "expiringWithin": "Expiring within (days)",
      "renewalQueue": "Renewal queue",
      "autoRenew": "Auto-renews",
      "renewedTo": "Renewed",
      "empty": "No contracts match.",
      "loadFailed": "The contracts could not be loaded."
    },
    "contract": {
      "summary": "Summary",
      "coverage": "Coverage",
      "chain": "Renewal chain",
      "loadFailed": "That contract could not be loaded.",
      "noEntitlements": "This contract carries no coverage rows, so every job under it is chargeable.",
      "noRateCard": "None",
      "noSla": "None",
      "noChain": "This contract is neither a renewal nor renewed.",
      "renewedFrom": "Renewed from the previous contract",
      "renewedTo": "Renewed into the next contract",
      "activate": "Activate",
      "activated": "Contract activated",
      "activateFailed": "That contract could not be activated.",
      "renew": "Prepare renewal",
      "renewed": "A draft renewal was prepared",
      "renewFailed": "That renewal could not be prepared.",
      "renewNote": "A renewal is created as a draft. Nothing about it applies until somebody activates it."
    },
    "rateCards": {
      "title": "Rate cards",
      "description": "What labour, travel and parts are charged at, and from when.",
      "tableTitle": "Rate cards",
      "empty": "No rate cards yet.",
      "loadFailed": "The rate cards could not be loaded.",
      "versions": "Versions",
      "versionsEmpty": "This card has no versions yet.",
      "openVersion": "Open",
      "lines": "Rates",
      "linesEmpty": "This version prices nothing yet.",
      "defaultRate": "Default",
      "editLines": "Edit the rates",
      "linesSaved": "Rates saved",
      "linesFailed": "Those rates could not be saved.",
      "publish": "Publish",
      "published": "Version published",
      "publishFailed": "That version could not be published.",
      "windowNote": "A job is priced by the version in force on its WORK date, not today's. That is why versions carry windows rather than a single current flag.",
      "frozenNote": "This version is published, so its rates are fixed. Jobs already priced against it must stay priced against it — create a new version to change what is charged from now on."
    },
    "vans": {
      "title": "Vans",
      "description": "What each van is meant to carry, what it is carrying, and what it needs.",
      "registerTitle": "Vans",
      "empty": "No vans yet.",
      "open": "Open",
      "loadFailed": "The vans could not be loaded.",
      "parLevels": "Par levels",
      "parLevelsEmpty": "No par levels are set for this van.",
      "stock": "On the van",
      "stockEmpty": "This van is holding nothing.",
      "replenishment": "Replenishment",
      "propose": "Propose a replenishment",
      "replenishmentProposed": "Replenishment proposed",
      "replenishFailed": "That replenishment could not be proposed.",
      "countNote": "Counting a van is a stock count, and inventory owns count sessions — there is no second counting screen here.",
      "countLink": "Open a count session"
    },
    "problems": {
      "title": "Problems",
      "description": "The underlying faults several cases share, and the known errors they became.",
      "tableTitle": "Problems",
      "empty": "No problems recorded.",
      "loadFailed": "The problems could not be loaded.",
      "create": "Record problem",
      "created": "Problem recorded",
      "createFailed": "That problem could not be recorded.",
      "noCases": "None linked",
      "noArticle": "Not written up",
      "knownError": "Known error"
    },
    "kb": {
      "deflectionTitle": "Knowledge-base deflection",
      "deflectionNote": "How often an article answered the question before it became a case. The percentage is the server's.",
      "deflectionEmpty": "No articles have been read yet."
    }
  },
  "ess": {
    "routeTitles": {
      "profile": "My profile",
      "payslips": "My payslips",
      "payslip": "My payslip",
      "leave": "My leave",
      "attendance": "My attendance",
      "documents": "My documents",
      "clock": "Clock in and out",
      "employment": "My employment history",
      "roster": "My roster",
      "serviceCharge": "My service charge",
      "yearEnd": "My year-end statements"
    },
    "tabs": {
      "label": "Self-service",
      "profile": "Profile",
      "payslips": "Payslips",
      "leave": "Leave",
      "attendance": "Attendance",
      "documents": "Documents",
      "timesheets": "Timesheets",
      "clock": "Clock",
      "employment": "Employment",
      "roster": "Roster",
      "serviceCharge": "Service charge",
      "yearEnd": "Year end"
    },
    "profile": {
      "title": "My profile",
      "description": "What HR holds on record for you, and what payroll works from.",
      "loadFailed": "Your record did not load",
      "identityTitle": "You",
      "employmentTitle": "Employment",
      "payTitle": "Pay",
      "permitTitle": "Work permit",
      "privateTitle": "Bank and statutory details",
      "enrolled": "Enrolled",
      "notEnrolled": "Not enrolled",
      "salaryExplainer": "This is your full-month basic salary. A month you did not work in full — you joined or left partway, or took unpaid leave — is paid pro rata, and your payslip shows the day count it used.",
      "pensionableExplainer": "You are enrolled in the pension scheme, so MPAO contributions are calculated on your pensionable wage and appear on every payslip.",
      "notPensionableExplainer": "You are not enrolled in the pension scheme, so no MPAO contribution is calculated on your pay.",
      "permitExpired": "expired {days} days ago",
      "permitDaysLeft": "{days} days left",
      "permitExplainer": "HR is alerted as this date approaches. If the number here looks wrong, tell them before it lapses rather than after.",
      "maskedHeadline": "These are shown partly hidden, and that is deliberate",
      "maskedExplainer": "Full bank and statutory numbers are stored encrypted. Nobody, including you, can reveal them from this screen; the one route that decrypts them is permissioned and writes an audit record naming who looked.",
      "changeExplainer": "To correct any of these, ask HR. Changing a bank account needs two approvals before payroll will pay to it.",
      "fields": {
        "fullName": "Name",
        "preferredName": "Known as",
        "employeeNo": "Employee number",
        "jobTitle": "Job title",
        "manager": "Manager",
        "workEmail": "Work email",
        "personalEmail": "Personal email",
        "phone": "Phone",
        "employmentStatus": "Status",
        "employmentType": "Employment type",
        "joinedOn": "Joined",
        "leftOn": "Left",
        "nationality": "Nationality",
        "basicSalary": "Basic salary",
        "pensionable": "Pension scheme",
        "workPermitNo": "Permit number",
        "workPermitExpiry": "Expires",
        "bankName": "Bank",
        "bankAccountName": "Account name",
        "bankAccountNo": "Account number",
        "bankIban": "IBAN",
        "nationalId": "National ID",
        "taxId": "Tax ID"
      }
    },
    "payslips": {
      "title": "My payslips",
      "description": "Every payslip raised for you, newest first.",
      "loadFailed": "Your payslips did not load",
      "emptyTitle": "No payslips yet",
      "emptyDescription": "One appears here as soon as payroll calculates a run that includes you. If a month you worked is missing, ask your payroll officer.",
      "provisionalHeadline": "A payslip here may still change",
      "provisionalExplainer": "Payslips appear as soon as payroll calculates them, which is before anyone has approved or paid the run. Figures are final once the run is posted; until then treat them as a draft of what you will be paid.",
      "orderNote": "Newest first. Amounts are in the currency your salary is recorded in.",
      "exception": "Needs review",
      "columns": {
        "period": "Period",
        "payableDays": "Payable days",
        "gross": "Gross",
        "deductions": "Deductions",
        "net": "Net pay",
        "flag": "Flag"
      }
    },
    "payslip": {
      "title": "My payslip",
      "description": "Every component, what it was calculated from, and what it came to.",
      "loadFailed": "This payslip did not load",
      "backToList": "All my payslips",
      "pdf": "Download PDF",
      "pdfWorking": "Preparing",
      "pdfPending": "Your payslip is being prepared. This page updates when it is ready.",
      "pdfReady": "Payslip ready",
      "pdfReadyDetail": "The PDF has been produced and stored against this payslip.",
      "pdfFailed": "The payslip could not be produced.",
      "headerTitle": "Period",
      "totalsTitle": "Totals",
      "traceDescription": "The same working your payroll officer sees. Nothing on this page is recalculated in your browser.",
      "prorationExplainer": "Basic salary for the period is your monthly salary times payable days divided by period days. Unpaid leave reduces payable days.",
      "exceptionHeadline": "Payroll flagged something on this payslip",
      "exceptionNoDetail": "No detail was recorded. Ask your payroll officer what was flagged.",
      "employerCostExplainer": "Employer cost is what your employer pays on top of your gross. It is never taken off what you are paid.",
      "reconciles": "The {count} lines below add up to the totals above.",
      "reconcileFailedHeadline": "The lines and the totals do not agree",
      "reconcileFailed": "The lines add to {earnings} in earnings and {deductions} in deductions, giving {net}.",
      "reconcileAuthority": "The totals above are the figures of record — the ledger was posted from those. Show this page to your payroll officer.",
      "disputeExplainer": "If a figure looks wrong, the working above is what to point at: it names the component, the amount it was calculated from and the rate applied.",
      "fields": {
        "period": "Period",
        "periodDays": "Days in period",
        "payableDays": "Payable days",
        "unpaidLeaveDays": "Unpaid leave days",
        "runNo": "Payroll run",
        "gross": "Gross",
        "deductions": "Deductions",
        "net": "Net pay",
        "employerCost": "Employer cost"
      }
    },
    "leave": {
      "title": "My leave",
      "description": "What you have left, what you have asked for, and what was decided.",
      "loadFailed": "Your leave requests did not load",
      "balancesTitle": "My balances",
      "balancesDescription": "Credited by the monthly accrual and reduced when leave is approved.",
      "balancesFailed": "Your balances did not load",
      "noBalancesTitle": "No balances yet",
      "noBalancesDescription": "A balance appears once the monthly accrual has credited you a leave type. New joiners usually see one after their first full month.",
      "daysUnit": "days",
      "balanceExplainer": "These are the balances as they stand now. A request awaiting a decision has not been taken off yet.",
      "filtersTitle": "Filter",
      "historyTitle": "My leave requests",
      "emptyTitle": "No leave requests yet",
      "emptyDescription": "Ask for time off with the button above. Your manager sees it in their approvals inbox.",
      "ownOnly": "Your own requests only.",
      "paid": "Paid",
      "unpaid": "Unpaid",
      "cancelled": "Request cancelled",
      "cancelledDetail": "{requestNo} has been cancelled and the days returned to your balance.",
      "actions": {
        "request": "Request leave"
      },
      "columns": {
        "requestNo": "Request",
        "type": "Type",
        "dates": "Dates",
        "days": "Days",
        "paid": "Paid"
      },
      "cancelDialog": {
        "title": "Cancel this leave request",
        "consequence": "Cancelling returns the days to your balance. A request whose first day has already passed cannot be cancelled here — ask HR.",
        "confirm": "Cancel the request",
        "keep": "Keep it"
      },
      "fields": {
        "type": "Leave type",
        "typePlaceholder": "Choose a leave type",
        "balance": "Your balance now",
        "startDate": "First day away",
        "endDate": "Last day away",
        "unpaid": "Unpaid leave",
        "unpaidLabel": "Take this as unpaid leave",
        "unpaidHint": "Unpaid days reduce the payable days your pay is prorated by.",
        "reason": "Reason"
      },
      "form": {
        "title": "Request leave",
        "description": "The days are counted the way your balance is charged: calendar days, both ends included.",
        "rangeInvalid": "The last day cannot be before the first.",
        "typeRequired": "Choose a leave type.",
        "daysCount": "{days} calendar days",
        "daysUnknown": "Choose a start and an end date",
        "calendarDaysExplainer": "Weekends and public holidays are counted: this workspace keeps no holiday calendar, so a request spanning a weekend costs more days than you would count by hand.",
        "typeUnpaidHint": "{name} is an unpaid leave type — these days reduce the payable days your pay is prorated by.",
        "reasonHint": "Whoever decides this reads it.",
        "submit": "Submit request",
        "created": "Leave requested",
        "createdDetail": "{requestNo} for {days} days is awaiting a decision."
      }
    },
    "attendance": {
      "title": "My attendance",
      "description": "The days recorded against you, and the overtime on them.",
      "loadFailed": "Your attendance did not load",
      "emptyTitle": "Nothing recorded this month",
      "emptyDescription": "Attendance is entered or imported by your manager. If a day you worked is missing, tell them before the payroll run closes.",
      "previousMonth": "Previous month",
      "nextMonth": "Next month",
      "thisMonth": "This month",
      "approvedYes": "Approved",
      "approvedNo": "Not approved yet",
      "approvalExplainer": "Only approved overtime is paid. An unapproved row is a record of the day, not an entitlement.",
      "noTotalExplainer": "No monthly total is shown here on purpose: the hours you are paid for are the ones on your payslip, which shows how they were calculated.",
      "columns": {
        "date": "Date",
        "hours": "Hours",
        "overtime": "Overtime",
        "rule": "Overtime rule",
        "source": "Recorded by",
        "approved": "Approved",
        "notes": "Notes"
      }
    },
    "documents": {
      "title": "My documents",
      "description": "The documents HR keeps on your file.",
      "loadFailed": "Your documents did not load",
      "emptyTitle": "Nothing on your file yet",
      "emptyDescription": "HR adds contracts, letters and certificates here. You cannot upload to your own file — send anything new to HR and they will file it.",
      "downloading": "Preparing",
      "downloadFailed": "That document could not be opened",
      "auditExplainer": "Every download is recorded against your name, including your own. This is your file; nobody else can list or open it through this page.",
      "linkExpiryNote": "Each download link is generated on the spot and stops working after fifteen minutes.",
      "columns": {
        "filename": "File",
        "note": "Note",
        "size": "Size",
        "added": "Added"
      }
    },
    "clock": {
      "actions": {
        "break_end": "End break",
        "break_start": "Start break",
        "in": "Clock in",
        "out": "Clock out"
      },
      "corrects": "corrects #{id}",
      "description": "One button. The state comes from the server, so a punch made on a kiosk still counts.",
      "kinds": {
        "break_end": "Break end",
        "break_start": "Break start",
        "in": "In",
        "out": "Out"
      },
      "loadFailed": "Your clock state could not be loaded",
      "lockedExplainer": "Payroll has locked this period. Your punch is still recorded and will be picked up when the lock releases.",
      "punchesDescription": "Every event, in order. A correction is a new entry — the original stays.",
      "punchesEmptyDescription": "Your first punch of the day will appear here.",
      "punchesEmptyTitle": "Nothing yet today",
      "punchesTitle": "Today's punches",
      "recorded": "Recorded",
      "rosteredHours": "Rostered",
      "states": {
        "in": "Clocked in",
        "out": "Clocked out"
      },
      "title": "Clock in and out",
      "todayTitle": "Today",
      "workedHours": "Worked"
    },
    "employment": {
      "columns": {
        "from": "From",
        "fte": "FTE",
        "reason": "Reason",
        "salary": "Basic salary",
        "to": "To",
        "type": "Type"
      },
      "current": "Current",
      "description": "Every version of your own terms, newest first.",
      "emptyDescription": "Nothing has been recorded against your record yet.",
      "historyTitle": "Employment history",
      "loadFailed": "Your employment history could not be loaded",
      "ongoing": "ongoing",
      "title": "My employment history"
    },
    "roster": {
      "description": "Read-only. A rest day is shown as a rest day; a blank means nothing is planned.",
      "from": "From",
      "loadFailed": "Your roster could not be loaded",
      "nothingPlanned": "Nothing planned",
      "plannedHours": "{hours} hours planned in this window.",
      "restDay": "Rest day",
      "title": "My roster",
      "to": "To",
      "windowTitle": "Window"
    },
    "serviceCharge": {
      "allocationsTitle": "My shares",
      "columns": {
        "amount": "Amount",
        "eligibleDays": "Eligible days",
        "points": "Points",
        "pool": "Pool",
        "rawShare": "Raw share",
        "rounding": "Rounding",
        "weight": "Weight"
      },
      "description": "Your share of each distributed pool, and how it was worked out.",
      "distributedOnly": "Only pools that have been distributed are shown. A pool still under review is not final.",
      "emptyDescription": "Once a pool covering your period is distributed, your share appears here.",
      "emptyTitle": "No shares yet",
      "forfeited": "One pool recorded no share for you: {reason}",
      "loadFailed": "Your allocations could not be loaded",
      "rawShareExplainer": "The raw share is your exact fraction before rounding. The rounding column is the cent the distribution gave you or took, so every cent in the pool belongs to somebody.",
      "title": "My service charge"
    },
    "yearEnd": {
      "actions": {
        "download": "Download PDF"
      },
      "columns": {
        "deductions": "Deductions",
        "gross": "Gross",
        "net": "Net",
        "period": "Period"
      },
      "description": "Issued statements only. A draft is a working figure the payroll team is still checking.",
      "emptyDescription": "No statement has been issued to you yet.",
      "loadFailed": "Your statements could not be loaded",
      "statementTitle": "Tax year {year}",
      "statuses": {
        "draft": "Draft",
        "issued": "Issued",
        "superseded": "Superseded"
      },
      "title": "My year-end statements"
    }
  },
  "consol": {
    "filtersTitle": "Filters",
    "unknownCompany": "Legal entity not named",
    "routeTitles": {
      "groups": "Consolidation groups",
      "group": "Consolidation group",
      "runs": "Consolidation runs",
      "run": "Consolidation run",
      "trialBalance": "Consolidated trial balance",
      "incomeStatement": "Consolidated income statement",
      "balanceSheet": "Consolidated balance sheet",
      "eliminations": "Elimination proposals",
      "mismatches": "Inter-company mismatches",
      "readiness": "Consolidation readiness",
      "accountMaps": "Account mapping",
      "adjustments": "Group adjustments",
      "adjustment": "Group adjustment",
      "adjustmentNew": "New group adjustment",
      "adjustmentEdit": "Edit group adjustment",
      "statements": "Consolidated statements",
      "currencyTranslation": "Currency translation analysis",
      "minorityInterest": "Minority interest schedule",
      "entityContribution": "Entity contribution analysis"
    },
    "tabs": {
      "label": "This consolidation run",
      "overview": "Overview",
      "trialBalance": "Trial balance",
      "incomeStatement": "Income statement",
      "balanceSheet": "Balance sheet",
      "eliminations": "Eliminations",
      "mismatches": "Mismatches",
      "statements": "Cash flow and equity",
      "translation": "Currency translation",
      "minority": "Minority interest",
      "contribution": "Entity contribution",
      "adjustments": "Group adjustments"
    },
    "rateKinds": {
      "closing": "Closing",
      "opening": "Opening",
      "average": "Average",
      "identity": "Same currency"
    },
    "check": {
      "balanced": "Balances",
      "unbalanced": "Does not balance"
    },
    "export": {
      "done": "Export ready",
      "doneDetail": "{file} has been downloaded. The export is recorded in the audit trail.",
      "failed": "The export did not run"
    },
    "groups": {
      "title": "Consolidation groups",
      "one": "Consolidation group",
      "description": "A parent legal entity, the currency its consolidations present in, and who it owned when.",
      "loadFailed": "The groups did not load",
      "emptyTitle": "No consolidation groups yet",
      "emptyDescription": "Create one for the parent legal entity, add its subsidiaries with the percentage owned and the date it started, then generate a run.",
      "searchPlaceholder": "Code or name",
      "footerNote": "A group is structure, not a report. Its figures live in its runs.",
      "active": "Active",
      "inactive": "Retired",
      "created": "Group created",
      "saved": "Group saved",
      "actions": {
        "add": "New group"
      },
      "columns": {
        "code": "Code",
        "parent": "Parent legal entity",
        "currency": "Presents in"
      },
      "fields": {
        "code": "Code",
        "name": "Name",
        "parent": "Parent legal entity",
        "parentPlaceholder": "Choose the consolidating parent",
        "currency": "Presentation currency",
        "currencyPlaceholder": "Choose a currency",
        "active": "Status",
        "activeLabel": "This group is still consolidated"
      },
      "form": {
        "createTitle": "New consolidation group",
        "editTitle": "Edit consolidation group",
        "description": "The parent legal entity and the currency its runs present in are fixed once the group exists.",
        "codeRequired": "Give the group a short code.",
        "nameRequired": "Give the group a name.",
        "parentRequired": "Choose the consolidating parent legal entity.",
        "currencyRequired": "Choose the currency runs will present in.",
        "currencyExplainer": "Every member's ledger is translated into this currency: closing rate for balance-sheet items, average rate for income and expense. Choose the currency the group reports in, not a member's.",
        "immutableExplainer": "Code, parent legal entity and presentation currency cannot change. Every run ever generated under this group was translated into that currency, and changing it would restate them all."
      }
    },
    "group": {
      "description": "Members, and the ownership history a run resolves its percentages from.",
      "loadFailed": "This group did not load",
      "backToList": "All groups",
      "viewRuns": "Runs for this group",
      "headerTitle": "Group",
      "membersTitle": "Ownership history",
      "membersFooter": "Every row is one period of one legal entity's membership. Rows are never overwritten.",
      "noMembersTitle": "No subsidiaries yet",
      "noMembersDescription": "Add the legal entities this group consolidates, each with the percentage owned and the date that percentage took effect. A legal entity with no membership covering a run's date is not consolidated at all.",
      "presentationExplainer": "Runs of this group present in {currency}. Each member's own ledger stays in its own currency; translation happens at run time.",
      "historyHeadline": "This is a history, not a current state",
      "historyExplainer": "A run resolves each subsidiary's percentage as at the run's own date, never today's. That is why closed rows stay here: re-running a prior quarter has to produce the same figures it produced then.",
      "checkReadiness": "Check readiness",
      "mapAccounts": "Map accounts"
    },
    "members": {
      "inForce": "In force",
      "added": "Subsidiary added",
      "addedDetail": "It will be consolidated by runs whose date falls inside its membership.",
      "ownershipChanged": "Ownership changed",
      "actions": {
        "add": "Add subsidiary",
        "change": "Change ownership"
      },
      "columns": {
        "company": "Legal Entity",
        "code": "Code",
        "ownershipPct": "Owned",
        "effectiveFrom": "From",
        "effectiveTo": "To",
        "note": "Note",
        "method": "Method"
      },
      "fields": {
        "company": "Subsidiary",
        "companyPlaceholder": "Choose a legal entity",
        "ownershipPct": "Percentage owned",
        "ownershipPctHint": "Greater than 0, at most 100. Four decimal places are kept.",
        "effectiveFrom": "Owned from",
        "effectiveTo": "Owned until",
        "effectiveToHint": "Leave empty unless the exit date is already agreed.",
        "method": "Consolidation method",
        "methodHint": "How runs consolidate this member over this membership period."
      },
      "form": {
        "title": "Add a subsidiary",
        "description": "The percentage and the dates together decide what a run consolidates.",
        "companyRequired": "Choose the legal entity to consolidate.",
        "pctRequired": "Enter the percentage owned.",
        "currencyHint": "{company} keeps its books in {currency}. A run translates that into the group's presentation currency.",
        "datesExplainer": "A run resolves the percentage in force at the run's own date. A legal entity outside every membership period covering that date is not consolidated, and a legal entity that joined mid-window contributes only the profit earned from its join date onward.",
        "ownershipRegisterHint": "Ownership is maintained in Enterprise → Legal Entities → Ownership. A run reads the percentage from there, as at the run's own date.",
        "submit": "Add subsidiary"
      },
      "change": {
        "title": "Change ownership percentage",
        "currentPct": "Owned now",
        "newPct": "New percentage",
        "effectiveFrom": "New percentage from",
        "historyHeadline": "This adds a period; it does not edit one",
        "historyExplainer": "The current membership record is closed the day before the date you give, and a new one opens at the new percentage. Runs dated inside the old period keep resolving the old percentage — which is what lets a prior quarter be re-run unchanged.",
        "submit": "Record the change"
      },
      "edit": {
        "title": "Edit membership: {company}",
        "description": "The start date is fixed; set an end date when the member leaves, or correct the method or note.",
        "methodHint": "Applies to this whole membership period. For a change of method from a date, end this period and add a new one.",
        "endHint": "Leave empty to keep the membership open. Clearing a date reopens it.",
        "endBeforeStart": "The end date cannot be before the start date.",
        "reloaded": "Someone else changed this membership while you had it open. It has been reloaded; check it and save again.",
        "saved": "Membership saved"
      }
    },
    "runs": {
      "title": "Consolidation runs",
      "description": "Each run is one translated, persisted snapshot of the group's ledgers.",
      "loadFailed": "The runs did not load",
      "emptyTitle": "No consolidation runs yet",
      "emptyDescription": "Generate one for a group and a reporting period. It translates every member's ledger, resolves ownership as at the period end, and proposes inter-company eliminations.",
      "allGroups": "All groups",
      "noCrossRunTotal": "Figures are not added across rows: two runs may present in different currencies, and overlapping windows would count the same money twice.",
      "generated": "Run generated",
      "generatedDetail": "The snapshot is saved. Elimination proposals are waiting for a decision.",
      "actions": {
        "generate": "Generate run"
      },
      "columns": {
        "window": "Window",
        "group": "Group",
        "currency": "Presents in",
        "totalAssets": "Total assets",
        "equityAttributable": "Equity — owners of parent",
        "minorityInterest": "Minority interest",
        "cta": "Translation adjustment",
        "check": "Check"
      },
      "fields": {
        "group": "Group",
        "groupPlaceholder": "Choose a group",
        "fiscalYear": "Fiscal year",
        "period": "Reporting period",
        "periodHint": "The parent legal entity's fiscal period. Its dates set the run's window.",
        "periodPlaceholder": "Choose a period"
      },
      "form": {
        "title": "Generate a consolidation run",
        "description": "A run consolidates one reporting period: the parent legal entity's fiscal period, whose dates set the window.",
        "groupRequired": "Choose the group to consolidate.",
        "presentationHint": "{group} presents in {currency}. Every member's figures are translated into it.",
        "whatHappensHeadline": "What generating does",
        "whatHappensTranslation": "Translates every member's ledger: closing rate for assets, liabilities and posted equity, day-weighted average rate for income and expense, with the difference recorded as a cumulative translation adjustment in equity.",
        "whatHappensOwnership": "Resolves each subsidiary's ownership percentage as at the report date, splitting the window where ownership changed inside it, and derives minority interest from that.",
        "whatHappensEliminations": "Proposes an inter-company elimination for every configured legal entity pair, all undecided until somebody accepts or rejects them.",
        "whatHappensSnapshot": "Saves the result as a snapshot. To reflect a ledger correction made afterwards, generate a fresh run — this one is not edited.",
        "generating": "Consolidating",
        "submit": "Generate",
        "periodRequired": "Choose the reporting period to consolidate.",
        "openReadiness": "See what is not ready",
        "openAccountMaps": "Map these accounts",
        "noPeriodPermission": "Listing fiscal periods needs permission to read fiscal periods.",
        "windowHint": "Income and expense from {from}; balances as at {to}.",
        "whatHappensReadiness": "Checks readiness first: every member's period closed and certified, inter-company within tolerance, and every account with a balance mapped to the group chart."
      },
      "allStatuses": "All statuses",
      "restates": "Restates run #{id}",
      "supersededBy": "Superseded by run #{id}"
    },
    "run": {
      "title": "Consolidation run",
      "description": "What this run produced, and the rates and percentages it produced it from.",
      "loadFailed": "This run did not load",
      "backToList": "All runs",
      "headerTitle": "Run",
      "totalsTitle": "Group totals",
      "noEntities": "This run folded in no legal entities. No member's membership period covers its report date.",
      "snapshotHeadline": "A run is a snapshot, not a live report",
      "snapshotExplainer": "These figures were computed once, when the run was generated, and do not move when the ledger changes. Only elimination decisions change what the statements show, and they change the statements rather than these totals.",
      "ctaHeadline": "About the translation adjustment",
      "ctaExplainer": "Balance-sheet items translate at the closing rate and income at the average rate, so a member's own balanced trial balance no longer balances once translated. That difference is the cumulative translation adjustment, and it is computed from independent inputs rather than chosen to make the sheet balance.",
      "ctaRateExplainer": "Posted equity — share capital and the like — translates at the opening rate, not the closing one: a historical contribution does not revalue at today's spot rate. Getting that wrong is invisible in the balance check, because the adjustment absorbs it either way.",
      "unbalancedHeadline": "This run does not balance",
      "unbalancedDetail": "Assets {debit} against liabilities plus equity {credit}, a difference of {difference}. The consolidated balance sheet will refuse to render rather than show a plausible wrong figure.",
      "fields": {
        "window": "Window",
        "currency": "Presentation currency",
        "generatedAt": "Generated",
        "check": "Check",
        "totalAssets": "Total assets",
        "totalLiabilities": "Total liabilities",
        "equityAttributable": "Equity — owners of the parent",
        "minorityInterest": "Minority interest",
        "cta": "Translation adjustment",
        "netIncomeAttributable": "Net income — owners of the parent",
        "netIncomeMinority": "Net income — minority interest"
      },
      "reportsTitle": "Reports and adjustments",
      "reports": {
        "statements": "The cash-flow statement and the statement of changes in equity, each reconciled.",
        "translation": "Rates, balances in both currencies and the translation reserve, per entity.",
        "minority": "The non-controlling share of each member's net assets and result.",
        "contribution": "Each entity's contribution to group revenue, profit and net assets.",
        "adjustments": "{approved} approved, {pending} not yet approved."
      }
    },
    "entity": {
      "parentSubtitle": "{code} — the consolidating parent",
      "subsidiarySubtitle": "{code} — {pct}% owned at the report date",
      "ctaIdentity": "The translation adjustment is net assets at the closing rate, less posted equity at the opening rate, less brought-forward profit at the opening rate, less this window's result at the average rate. The four figures above are those inputs; the adjustment is the server's own.",
      "periodsExplainer": "Ownership changed inside this window, so the result was split at the change and the minority share weighted period by period.",
      "oneRateCaveat": "One average rate is applied to the whole window rather than a separate rate per period. That is a recorded simplification, not a rounding artefact.",
      "fields": {
        "baseCurrency": "Keeps books in",
        "ownershipPct": "Owned at report date",
        "closingRate": "Closing rate",
        "averageRate": "Average rate",
        "openingRate": "Opening rate"
      },
      "columns": {
        "figure": "Figure",
        "rateUsed": "Rate used",
        "local": "Local ({currency})",
        "translated": "Translated ({currency})",
        "ownershipPct": "Owned",
        "periodFrom": "From",
        "periodTo": "To",
        "periodNetIncome": "Result ({currency})",
        "periodMinority": "Minority share ({currency})"
      },
      "rows": {
        "assets": "Assets",
        "liabilities": "Liabilities",
        "netAssets": "Net assets",
        "equityPosted": "Posted equity",
        "priorPnl": "Brought-forward profit",
        "netIncome": "Result for the window",
        "cta": "Translation adjustment",
        "minorityEquity": "Minority interest in net assets",
        "minorityIncome": "Minority interest in the result"
      }
    },
    "statement": {
      "generatedAt": "Prepared",
      "emptySection": "Nothing in this section.",
      "groupingHeadline": "Accounts are grouped by legal entity, not merged",
      "groupingExplainer": "There is no chart-of-accounts mapping between legal entities in this workspace, so two members' similarly named accounts are two different accounts. Combining them would invent a mapping nobody approved.",
      "roundingHeadline": "A section total may differ from its own lines by a cent",
      "roundingExplainer": "A section total is one currency conversion applied to each legal entity's whole balance, while each line was converted and rounded on its own. In multi-currency consolidation those two routes can differ by a rounding cent. That is normal and expected, and neither figure is adjusted to hide it.",
      "drillExplainer": "Following an account opens that legal entity's own ledger, in that legal entity's own currency and over the period this run translated.",
      "columns": {
        "accountCode": "Code",
        "account": "Account",
        "amount": "Amount ({currency})"
      }
    },
    "trialBalance": {
      "title": "Consolidated trial balance",
      "description": "Every posted account of every member, translated as this run recorded it.",
      "loadFailed": "The trial balance did not load",
      "debit": "Total debits",
      "credit": "Total credits",
      "emptyExplainer": "This run has no lines, which means it folded in no legal entities.",
      "rateHeadline": "Read the rate column",
      "rateExplainer": "Assets and liabilities use the closing rate; posted equity uses the opening rate; income and expense use the average rate. A share-capital line translated at the wrong rate looks perfectly ordinary in the total, because the translation adjustment absorbs the difference — the rate column is where it shows.",
      "syntheticExplainer": "The brought-forward profit and translation adjustment lines are computed by the run rather than read from any ledger. They are what make the report net to zero, and they have no account to open.",
      "drillCurrencyExplainer": "Following an account opens that legal entity's own ledger. It is stated in the legal entity's own currency — the local column here — not the translated one.",
      "columns": {
        "rateKind": "Rate",
        "rateUsed": "Rate used",
        "local": "Local amount",
        "gross": "Translated ({currency})",
        "elimination": "Eliminated",
        "net": "Net"
      }
    },
    "incomeStatement": {
      "title": "Consolidated income statement",
      "description": "Income and expense across the group, translated at the average rate for the window.",
      "loadFailed": "The income statement did not load",
      "summaryTitle": "Result",
      "detailTitle": "Detail",
      "averageRateExplainer": "Income and expense are translated at a day-weighted average rate over the window, which is why this statement carries a period while the balance sheet carries a single date.",
      "splitExplainer": "The split between owners of the parent and minority interest is the run's own figure, derived from each member's result and the ownership in force. It is not re-derived from the lines below."
    },
    "balanceSheet": {
      "title": "Consolidated balance sheet",
      "description": "Assets, liabilities and equity across the group, as at the run's report date.",
      "loadFailed": "The balance sheet did not load",
      "asOf": "As at",
      "summaryTitle": "Totals",
      "detailTitle": "Detail",
      "checkHeadline": "A balanced sheet does not prove the translation is right",
      "checkExplainer": "The translation adjustment sits in equity and absorbs whatever the rates produce, so this sheet balances either way. The rates each figure used, and the four inputs behind each legal entity's adjustment, are on the run overview — that is where a wrong rate is visible.",
      "eliminationExplainer": "Asset and liability lines are shown net of the elimination proposals accepted so far. Accepting or rejecting one changes this page immediately; the run itself is not regenerated.",
      "syntheticExplainer": "Retained earnings, the translation adjustment and minority interest are computed by the run rather than read from a ledger, and are shown in italics."
    },
    "eliminations": {
      "title": "Elimination proposals",
      "description": "What each legal entity says the other owes it, and what should be eliminated.",
      "loadFailed": "The proposals did not load",
      "emptyTitle": "No elimination proposals",
      "emptyDescription": "A proposal is raised for each configured inter-company account pair where both legal entities are in this run. If none appear, no legal entity pairs are mapped yet.",
      "headline": "Proposals are proposals",
      "explainer": "Nothing is eliminated until somebody accepts it. Accepting nets the agreed amount out of the matching asset and liability lines on the consolidated statements, immediately, without regenerating the run.",
      "translationExplainer": "Both sides are converted into the run's presentation currency before they are compared: a difference between two amounts in two different currencies is not a number.",
      "footerNote": "The eliminated amount is the smaller of the two sides — only what both sets of books agree exists.",
      "agrees": "Sides agree",
      "disagrees": "Sides differ",
      "noMirror": "No mirror account",
      "noMirrorExplainer": "The counterparty has no matching due-to account mapped, so only one side of this balance is known. Accepting will reduce the asset side and leave nothing to offset it.",
      "statuses": {
        "proposed": "Awaiting a decision",
        "accepted": "Accepted",
        "rejected": "Rejected"
      },
      "columns": {
        "company": "Legal Entity",
        "counterparty": "Counterparty",
        "accounts": "Accounts",
        "companySide": "Legal entity says",
        "counterpartySide": "Counterparty says",
        "mismatch": "Difference",
        "eliminated": "Would eliminate",
        "agreement": "Agreement"
      },
      "decide": {
        "acceptTitle": "Accept this elimination",
        "rejectTitle": "Reject this elimination",
        "subject": "{company} and {counterparty}",
        "claimsOwed": "{company} says it is owed",
        "claimsOwes": "{company} says it owes",
        "mismatchHint": "Both sides converted into the presentation currency, then compared.",
        "eliminatedHint": "The smaller of the two sides — what both books agree exists.",
        "acceptConsequence": "Accepting removes this amount from the asset side and the same amount from the liability side, on the consolidated trial balance and balance sheet, from now on.",
        "rejectConsequence": "Rejecting leaves this balance standing on the consolidated statements, difference and all. Say why: whoever reads the statements next quarter needs to know.",
        "finalExplainer": "A decision is final. To revisit it, generate a fresh run — it proposes fresh, undecided rows.",
        "noteLabel": "Reason",
        "noteHint": "Kept with the proposal and in the audit trail.",
        "reasonRequired": "Say why this proposal is being rejected.",
        "accepted": "Elimination accepted",
        "rejected": "Elimination rejected"
      }
    },
    "mismatches": {
      "title": "Inter-company mismatches",
      "description": "Where two members' books disagree about the same balance.",
      "loadFailed": "The mismatch report did not load",
      "emptyTitle": "No mismatches",
      "emptyDescription": "Every inter-company pair in this run agrees to the cent once both sides are converted into the presentation currency.",
      "count": "Mismatches",
      "footerNote": "Local amounts are each legal entity's own currency; the translated columns are the run's presentation currency.",
      "scopeHeadline": "Decided proposals stay on this report",
      "scopeExplainer": "A mismatch somebody accepted is still a mismatch that happened. This is a working paper for closing the period, not a list of things to do — the eliminations screen is that.",
      "translationExplainer": "Both sides were converted into the presentation currency before the difference was taken, because comparing two amounts in two currencies produces noise, not a figure.",
      "columns": {
        "companyLocal": "Legal entity, local",
        "counterpartyLocal": "Counterparty, local",
        "decision": "Decision",
        "reason": "Reason given"
      }
    },
    "methods": {
      "full": "Full",
      "proportional": "Proportional",
      "equity": "Equity method",
      "excluded": "Excluded"
    },
    "methodHints": {
      "full": "Every line consolidated, with minority interest for the share not owned.",
      "proportional": "Each line consolidated at the ownership percentage.",
      "equity": "One investment line at the share of net assets; no line-by-line consolidation.",
      "excluded": "A member of the group that is not consolidated."
    },
    "groupChart": {
      "title": "Group chart of accounts",
      "assign": "Assign group chart",
      "change": "Change",
      "missing": "This group has no group chart. Runs consolidate without translating local accounts to group accounts, and readiness warns about it.",
      "field": "Group chart",
      "mapVersion": "Account map version",
      "locked": "The group chart is fixed: account maps already point at its accounts.",
      "chartId": "Chart {id}",
      "dialogTitle": "Group chart of accounts",
      "dialogDescription": "Local accounts of every member are mapped to the accounts of this chart.",
      "fieldHint": "An active chart of accounts whose account segment holds the group accounts.",
      "none": "No group chart",
      "placeholder": "Choose a chart of accounts",
      "fixedOnceMapped": "Once any account is mapped, the group chart can no longer be changed.",
      "noCharts": "No active chart of accounts is available to you. Charts are set up in Enterprise, Financial structures.",
      "saved": "Group chart assigned",
      "cleared": "Group chart cleared",
      "savedDetail": "Map each member's accounts to it on the Account mapping screen."
    },
    "readiness": {
      "title": "Consolidation readiness",
      "description": "Whether every contributing legal entity is ready for a reporting period, and what is blocking those that are not.",
      "recheck": "Check again",
      "emptyTitle": "Choose a group and a reporting period",
      "emptyDescription": "Readiness is evaluated for one group and one period: each member's period status, close certification, inter-company differences and unmapped balances.",
      "loadFailed": "Readiness could not be checked",
      "summaryTitle": "Readiness",
      "ready": "Ready to consolidate",
      "notReady": "Not ready",
      "asOf": "Period end",
      "tolerance": "Inter-company tolerance",
      "unmappedTotal": "Accounts with an unmapped balance",
      "gateExplainer": "Generating a run for this period is refused while any blocker below remains.",
      "warningsTitle": "Warnings",
      "assignChart": "Assign a group chart",
      "membersTitle": "Contributing legal entities",
      "noMembersTitle": "No contributing legal entities",
      "noMembersDescription": "No member's membership covers this period end.",
      "blockersTitle": "Blockers",
      "noBlockers": "Nothing is blocking this period.",
      "periodStatusIs": "Period status: {status}.",
      "intercoIs": "Unreconciled differences of {amount} against a tolerance of {tolerance}.",
      "unmappedIs": "{count} local accounts with a balance have no group account.",
      "openUnmapped": "Map the unmapped accounts",
      "unmappedMore": "and {count} more",
      "parent": "parent",
      "yes": "Yes",
      "no": "No",
      "memberReady": "Ready",
      "columns": {
        "company": "Legal entity",
        "method": "Method",
        "periodStatus": "Period",
        "certified": "Close certified",
        "interco": "Unreconciled IC",
        "unmapped": "Unmapped",
        "blockers": "Blockers"
      },
      "blockers": {
        "no_fiscal_period": "No fiscal period",
        "period_not_closed": "Period not closed",
        "close_run_not_certified": "Close not certified",
        "interco_over_tolerance": "Inter-company over tolerance",
        "interco_statement_missing": "Inter-company statement missing",
        "unmapped_balances": "Unmapped balances",
        "ic_differences_open": "Inter-company differences above the threshold are unresolved",
        "ic_differences_no_rate": "An inter-company difference has no exchange rate for the run date"
      },
      "blockerDetails": {
        "no_fiscal_period": "The legal entity's calendar has no period covering the period end.",
        "period_not_closed": "Close the legal entity's fiscal period for this date.",
        "close_run_not_certified": "Certify the legal entity's close run for the period.",
        "interco_over_tolerance": "Reconcile or certify the inter-company statements until the difference is within tolerance.",
        "interco_statement_missing": "An inter-company pair that blocks close has no reconciliation statement for the period.",
        "unmapped_balances": "Map each of these accounts to a group account, effective on or before the period end.",
        "ic_differences_open": "Resolve the open inter-company differences above the group's threshold, or ask for the threshold to be raised."
      },
      "warnings": {
        "group_coa_missing": "No group chart of accounts"
      },
      "warningDetails": {
        "group_coa_missing": "Without a group chart, runs consolidate by each legal entity's own accounts and nothing is checked for mapping. Assign one to map local accounts."
      },
      "periodStatuses": {
        "open": "Open",
        "soft_closed": "Soft closed",
        "closed": "Closed",
        "permanently_closed": "Permanently closed",
        "none": "No period"
      }
    },
    "accountMaps": {
      "title": "Account mapping",
      "description": "Each member's local accounts mapped to the group chart, versioned and effective-dated.",
      "loadFailed": "The account map did not load",
      "chooseGroupTitle": "Choose a group",
      "chooseGroupDescription": "Accounts are mapped to the group chart of one consolidation group.",
      "chooseMemberTitle": "Choose a member",
      "chooseMemberDescription": "Map one legal entity's local accounts at a time: the parent or any member.",
      "noChartTitle": "This group has no group chart",
      "noChartDescription": "Assign a group chart of accounts on the group first. Local accounts are mapped to its accounts.",
      "openGroup": "Open the group",
      "noAccountPermission": "Listing this legal entity's accounts needs permission to read the chart of accounts.",
      "noGroupAccountPermission": "Choosing group accounts needs permission to read charts of accounts and their values.",
      "reloaded": "Someone else changed the account map while you were editing. It has been reloaded and your changes are kept; check them against the current mapping and save again.",
      "rowsRefused": "{count} rows were refused. Nothing was saved; correct the marked rows and save again.",
      "suggestSummary": "{proposals} proposals found; {unmatched} unmapped accounts had no match. Accept a proposal on its row; nothing is saved until you save.",
      "versionExplainer": "Showing the mapping in force on {date}. Saved changes take effect from that date: the previous version ends the day before and a new version starts. No version is ever overwritten.",
      "tableTitle": "Local accounts ({unmapped} unmapped)",
      "noUnmapped": "Every local account is mapped on this date.",
      "noAccounts": "No postable accounts match.",
      "versionFrom": "version {version}, from {from}",
      "unmapped": "Unmapped",
      "clearMapping": "Unmap from this date",
      "choose": "Choose a group account",
      "willRetire": "Unmapped from {date}",
      "suggested": "Suggested: {account}",
      "byCode": "code match",
      "byName": "name match {score}",
      "historyTitle": "Version history: {account}",
      "noHistory": "This account has never been mapped.",
      "historyExplainer": "Every version stays on record. A run records the map version it translated through.",
      "fields": {
        "member": "Member",
        "memberPlaceholder": "Choose a legal entity",
        "asOf": "Effective date",
        "asOfHint": "The mapping shown is the one in force on this date; changes take effect from it.",
        "search": "Find an account",
        "show": "Show"
      },
      "filters": {
        "none": "All accounts",
        "balance": "Unmapped with a balance",
        "all": "All unmapped"
      },
      "balance": "Balance",
      "balanceUnavailable": "Which unmapped accounts carry a balance comes from a readiness check for a reporting period. Open this screen from Consolidation readiness to see them; every unmapped account is shown meanwhile.",
      "balanceSource": "Showing the unmapped accounts that carry a balance in the readiness check as at {date}. Choose All unmapped to see the rest.",
      "balanceSourceTruncated": "Showing the first unmapped accounts with a balance in the readiness check as at {date}; there are more. Map these and check readiness again, or choose All unmapped.",
      "noUnmappedWithBalance": "No unmapped account of this member carries a balance for the period.",
      "columns": {
        "local": "Local account",
        "current": "Group account on this date",
        "proposed": "Change to",
        "version": "Version",
        "groupAccount": "Group account",
        "from": "From",
        "to": "To"
      },
      "actions": {
        "suggest": "Suggest",
        "discard": "Discard changes",
        "save": "Save changes ({count})",
        "accept": "Accept",
        "dismiss": "Dismiss",
        "history": "History"
      },
      "toasts": {
        "saved": "Account map saved",
        "savedDetail": "From {date}: {opened} new versions, {closed} ended, {unchanged} already as requested.",
        "suggestFailed": "No suggestions were made"
      }
    },
    "people": {
      "you": "You",
      "userId": "User #{id}"
    },
    "runStatus": {
      "draft": "Draft",
      "ready": "Ready",
      "published": "Published",
      "superseded": "Superseded"
    },
    "runStatusHints": {
      "draft": "Still being prepared: an elimination, an inter-company pair or a group adjustment is not settled. Its figures are computed on each read and can still move.",
      "ready": "Its own preparation is complete. Publishing still checks the readiness of every member at the moment it is done.",
      "published": "Published and locked. Its figures are fixed; a correction is a restatement, which creates a new run and keeps this one.",
      "superseded": "Replaced by a restatement. Kept as evidence of what was published; it can no longer change."
    },
    "source": {
      "frozen": {
        "headline": "Frozen at publication",
        "detail": "These figures come from the snapshot fixed when the run was published. They cannot change."
      },
      "computed": {
        "headline": "Computed on each read",
        "detail": "This run is not published yet. The figures reflect the eliminations and adjustments that stand right now and can still move until it is published."
      },
      "generatedAt": "Read at"
    },
    "workbook": {
      "export": "Export workbook"
    },
    "publication": {
      "title": "Publication",
      "publishedAt": "Published",
      "publishedBy": "Published by",
      "generatedBy": "Generated by",
      "chainTitle": "Restatement chain",
      "chainRun": "Run #{id}",
      "chainThis": "this run",
      "chainReason": "Reason: {reason}",
      "chainTruncated": "A run in this chain could not be read, so older or newer runs may exist.",
      "gatesTitle": "What stands between this run and publication",
      "gateStates": {
        "ok": "Clear",
        "blocked": "Blocking",
        "checked": "Checked at publishing"
      },
      "gates": {
        "chart": {
          "title": "Group chart of accounts",
          "text": "The run must have been translated through a group chart of accounts, so that every balance is mapped to a group account.",
          "link": "Open the group"
        },
        "adjustments": {
          "title": "Group adjustments",
          "text": "No group adjustment may still be a draft or awaiting approval. Withdraw one that is not wanted.",
          "pending": "{count} adjustment(s) not yet approved.",
          "approved": "{count} approved adjustment(s) in the statements.",
          "link": "Open the run's adjustments"
        },
        "readiness": {
          "title": "Readiness of every member",
          "text": "Every member's fiscal period closed, its close certified, and every account with a balance mapped to the group chart.",
          "link": "Check readiness"
        },
        "tolerance": {
          "title": "Inter-company pairs within tolerance",
          "text": "Every inter-company pair must agree within the group's tolerance.",
          "textWith": "Every inter-company pair must agree within the group's tolerance of {tolerance} {currency}.",
          "value": "Tolerance: {tolerance} {currency}.",
          "link": "See the mismatches"
        },
        "eliminations": {
          "title": "Eliminations decided",
          "text": "Every proposed elimination that moves a figure must be accepted or rejected, because a published run is fixed.",
          "link": "Open the eliminations"
        },
        "period": {
          "title": "One published run per period",
          "text": "Only one run is the published consolidation of a group and period. Replacing it is a restatement, not a second publication."
        },
        "secondPerson": {
          "title": "A second person publishes",
          "text": "The publisher is neither the person who generated the run nor the preparer of any approved adjustment on it."
        }
      },
      "barrier": {
        "generator": "You generated this run, so another person with permission to publish must publish it.",
        "preparer": "You prepared an approved adjustment on this run, so another person with permission to publish must publish it."
      },
      "withheld": {
        "chart": "Publishing is not available: this run was translated without a group chart of accounts. Assign one to the group, map the accounts and generate a new run.",
        "adjustments": "Publishing is not available while {count} adjustment(s) are not approved. Approve or withdraw them first."
      },
      "publish": "Publish",
      "publishTitle": "Publish run #{id}",
      "publishDescription": "Publishing makes this run the consolidation of record for its group and period.",
      "lockHeadline": "Publishing locks this run for ever",
      "lockExplainer": "A published run is never amended: its eliminations, adjustments and figures are fixed, and the only way to different figures is a restatement that creates a new run and keeps this one.",
      "checksHeadline": "What publishing checks",
      "publishing": "Publishing",
      "publishConfirm": "Publish and lock",
      "published": "Run published",
      "publishedDetail": "The run is locked. Its statements are now frozen.",
      "secondPersonHint": "A different person with permission to publish must do this. The publisher cannot be the person who generated the run or who prepared one of its approved adjustments.",
      "restate": "Restate",
      "restateTitle": "Restate run #{id}",
      "restateDescription": "A restatement replaces a published consolidation without altering it.",
      "restateHeadline": "What restating does",
      "restateNew": "Generates a new run over the same group, period and window, from the ledgers, ownership and account map as they stand now, through the same checks as any run.",
      "restateKept": "Marks this run superseded and keeps both: the published figures stay on record beside the restated ones.",
      "restateAdjustments": "Carries this run's approved adjustments onto the restatement as approved copies, so the group figures do not silently change.",
      "restateSecondPerson": "The restatement starts as a draft and is published by a second person like any other run.",
      "restateReason": "Reason for the restatement",
      "restateReasonHint": "Kept on the new run and in the audit trail.",
      "restateReasonRequired": "Say why this published consolidation is being restated.",
      "restating": "Restating",
      "restateConfirm": "Restate",
      "restated": "Run restated",
      "restatedDetail": "Run #{id} is the restatement. It is a draft until a second person publishes it.",
      "refusalLinks": {
        "accountMaps": "Map these accounts",
        "readiness": "See what is not ready",
        "mismatches": "See the mismatches",
        "eliminations": "Decide the eliminations",
        "adjustments": "Open the adjustments",
        "group": "Open the group"
      }
    },
    "adjustments": {
      "title": "Group adjustments",
      "one": "Group adjustment",
      "oneDescription": "A balanced journal over group accounts, recorded on one run and in its statements only once approved.",
      "description": "Journals over group chart accounts that exist in no company ledger. A run with an adjustment still being prepared or approved cannot be published.",
      "draftNumber": "Draft #{id}",
      "allStatuses": "All statuses",
      "loadFailed": "The adjustments did not load",
      "loadFailedOne": "This adjustment did not load",
      "emptyTitle": "No group adjustments",
      "emptyDescription": "Prepare one on a draft or ready run to record a consolidation entry that belongs to no company ledger, with its justification.",
      "noCrossRunTotal": "Amounts are not added across rows: runs may present in different currencies.",
      "backToList": "All adjustments",
      "statuses": {
        "draft": "Draft",
        "submitted": "Awaiting approval",
        "approved": "Approved",
        "rejected": "Rejected",
        "withdrawn": "Withdrawn"
      },
      "columns": {
        "number": "Number",
        "description": "Description",
        "run": "Run",
        "total": "Amount",
        "preparer": "Prepared by",
        "created": "Created"
      },
      "fields": {
        "run": "Run",
        "runPlaceholder": "Choose a run",
        "description": "Description",
        "justification": "Justification",
        "justificationHint": "Why the group figures need this adjustment. Required from the moment it is prepared."
      },
      "actions": {
        "create": "New adjustment",
        "edit": "Edit",
        "submit": "Submit for approval",
        "withdraw": "Withdraw",
        "saveDraft": "Save draft"
      },
      "lines": {
        "account": "Group account",
        "accountPlaceholder": "Choose a group account",
        "debit": "Debit ({currency})",
        "credit": "Credit ({currency})",
        "description": "Line description",
        "section": "Statement section",
        "remove": "Remove line",
        "totals": "Totals",
        "balanced": "Balanced",
        "difference": "Out of balance by {difference} {currency}",
        "add": "Add line"
      },
      "accountTypes": {
        "ASSET": "Assets",
        "LIABILITY": "Liabilities",
        "EQUITY": "Equity",
        "INCOME": "Income",
        "EXPENSE": "Expenses"
      },
      "form": {
        "createTitle": "New group adjustment",
        "editTitle": "Edit group adjustment",
        "description": "A draft is saved first. It reaches the run's statements only after it is submitted and approved.",
        "headerTitle": "Adjustment",
        "linesTitle": "Lines",
        "whatHeadline": "About group adjustments",
        "whatGroupAccounts": "Lines are posted to group accounts, the accounts of the run's group chart, in the run's presentation currency. A group account that no local account is mapped to cannot be used, because its statement section cannot be told.",
        "whatApproval": "The Group Controller step approves it in the Approvals Inbox. You cannot approve an adjustment you prepared or submitted.",
        "runRequired": "Choose the run this adjustment is on.",
        "descriptionRequired": "Say what the adjustment is.",
        "justificationRequired": "A justification is required.",
        "unbalanced": "Debits and credits differ by {difference} {currency}. An adjustment must balance.",
        "lineAccountRequired": "Choose a group account.",
        "lineAmountInvalid": "Enter an amount with at most two decimal places.",
        "lineOneSide": "A line is either a debit or a credit, not both.",
        "lineAmountRequired": "Enter a debit or a credit above zero.",
        "reloaded": "Someone changed this draft while you had it open. It has been reloaded; check your entries and save again.",
        "runRefused": "Run #{id} cannot take an adjustment: it is published, superseded, has no group chart, or is not visible to you.",
        "chooseRunFirst": "Choose a run to see its group accounts.",
        "noChartPermission": "Listing group accounts needs permission to read charts of accounts and their values.",
        "noGroupAccounts": "No group account is active on this run's period end.",
        "notDraft": "Only a draft adjustment can be edited.",
        "preparerOnly": "Only the person who prepared a draft can edit it. Prepare a new adjustment instead.",
        "backToAdjustment": "Back to the adjustment"
      },
      "view": {
        "headerTitle": "Adjustment",
        "preparerOnly": "{name} prepared this draft, so only they can edit it. You can still submit or withdraw it.",
        "awaitingApproval": "Waiting for the Group Controller step in the Approvals Inbox.",
        "youPrepared": "You prepared this adjustment, so you are not asked to approve it.",
        "youSubmitted": "You submitted this adjustment, so you are not asked to approve it.",
        "openInbox": "Open the Approvals Inbox",
        "rejectedHeadline": "This adjustment was rejected",
        "approvedExplainer": "Approved. It is part of the run's statements.",
        "submittedBy": "Submitted by",
        "approvedBy": "Approved by",
        "withdrawnBy": "Withdrawn by",
        "carriedFrom": "Carried from",
        "decisionNote": "Decision note"
      },
      "toasts": {
        "saved": "Draft saved",
        "savedDetail": "It is not in the run's statements until it is approved.",
        "submitted": "{no} submitted for approval",
        "withdrawn": "{no} withdrawn"
      },
      "withdrawConfirm": {
        "title": "Withdraw this adjustment?",
        "message": "It will no longer hold the run back from publication, and any pending approval is cancelled. A withdrawn adjustment cannot be submitted again."
      }
    },
    "statementsPack": {
      "title": "Consolidated cash flow and equity",
      "description": "The cash-flow statement and the statement of changes in equity of this run, each reconciled.",
      "loadFailed": "The statements did not load",
      "elsewhere": "The income statement and the balance sheet of the same pack are on their own tabs.",
      "reconciles": "Reconciles",
      "doesNotReconcile": "Does not reconcile",
      "cashFlow": {
        "title": "Cash-flow statement",
        "line": "Line",
        "entity": "Legal entity",
        "amount": "Cash effect ({currency})",
        "netProfit": "Net profit",
        "netChange": "Net change before exchange effects",
        "fxEffect": "Effect of exchange-rate changes on cash",
        "netChangeInCash": "Net change in cash",
        "openingCash": "Opening cash",
        "closingCash": "Closing cash",
        "reconcileDetail": "Group cash moved by {movement} {currency}. Difference to the statement: {difference} {currency} (rounding allowance {allowance}).",
        "fxTitle": "Exchange-rate effect by legal entity",
        "baseCurrency": "Currency",
        "openingRate": "Opening rate",
        "closingRate": "Closing rate"
      },
      "equity": {
        "title": "Statement of changes in equity",
        "row": "Movement",
        "posted": "Posted equity",
        "retained": "Retained earnings",
        "reserve": "Translation reserve",
        "entries": "Consolidation entries",
        "total": "Total",
        "minority": "Minority interest",
        "owners": "Owners of the parent",
        "reconcileDetail": "Closing equity {closing} {currency} against the balance sheet's {balanceSheet} {currency} (difference {balanceSheetDifference}). Unexplained movement: {difference} {currency} (rounding allowance {allowance})."
      }
    },
    "translation": {
      "title": "Currency translation analysis",
      "description": "For each legal entity, the rates, every balance in both currencies and what each contributed to the translation reserve.",
      "loadFailed": "The translation analysis did not load",
      "parent": "The consolidating parent",
      "rate": "Rate",
      "effect": "Reserve effect",
      "cta": "Translation reserve movement (run)",
      "ctaRecomputed": "Recomputed from the rows",
      "ctaMatches": "Agreement",
      "matches": "Agrees",
      "doesNotMatch": "Does not agree",
      "effectsTotal": "Sum of the row effects",
      "residual": "Rounding residual",
      "groupTitle": "The group's translation reserve",
      "balanceType": "Balance type",
      "reserveOpening": "Opening reserve",
      "reserveMovement": "Movement",
      "reserveClosing": "Closing reserve",
      "tbCheck": "The translated trial balance, with the reserve in it, differs by {difference} {currency}."
    },
    "minority": {
      "title": "Minority interest schedule",
      "description": "For each member, the non-controlling share of its translated net assets and result.",
      "loadFailed": "The minority interest schedule did not load",
      "tableTitle": "Non-controlling interests",
      "columns": {
        "entity": "Legal entity",
        "method": "Method",
        "ownership": "Owned",
        "minorityPct": "Minority",
        "netAssets": "Net assets ({currency})",
        "minorityEquity": "Minority equity ({currency})",
        "netIncome": "Net income ({currency})",
        "minorityIncome": "Minority income ({currency})",
        "ownersIncome": "Owners' income ({currency})",
        "reconciles": "Reconciles"
      },
      "totals": "Totals",
      "reconcilesToRun": "The totals equal the run's own minority interest figures.",
      "doesNotReconcileToRun": "The totals differ from the run's own minority interest figures.",
      "periodsTitle": "Ownership periods: {code}"
    },
    "contribution": {
      "title": "Entity contribution analysis",
      "description": "Each legal entity's contribution to group revenue, profit and net assets after the eliminations accepted so far.",
      "loadFailed": "The contribution analysis did not load",
      "tableTitle": "Contribution by legal entity",
      "adjustmentsRow": "Group adjustments",
      "totalRow": "Group total",
      "columns": {
        "entity": "Legal entity",
        "ownership": "Owned",
        "revenue": "Revenue ({currency})",
        "expenses": "Expenses ({currency})",
        "profit": "Profit ({currency})",
        "profitMinority": "Minority share ({currency})",
        "profitAttributable": "Owners' share ({currency})",
        "assets": "Assets after eliminations ({currency})",
        "liabilities": "Liabilities after eliminations ({currency})",
        "netAssets": "Net assets ({currency})",
        "revenueShare": "Revenue share",
        "profitShare": "Profit share",
        "netAssetsShare": "Net assets share"
      },
      "reconcileDetail": "Difference to the consolidated statements: {difference} {currency}."
    }
  },
  "mfg": {
    "bomStatuses": {
      "active": "Active",
      "draft": "Draft",
      "obsolete": "Obsolete"
    },
    "boms": {
      "actions": {
        "activate": "Activate",
        "add": "New bill of materials",
        "addAlternate": "Add alternate",
        "addLine": "Add component",
        "compare": "Compare versions",
        "discard": "Discard draft"
      },
      "activateBlocked": {
        "empty": "A bill of materials needs at least one component before it can be activated.",
        "notDraft": "Only a draft can be activated.",
        "unsaved": "Save your changes first: activation uses the stored components, not the ones on screen."
      },
      "activated": "Bill of materials activated",
      "activatedDetail": "Any previously active version for this item is now obsolete.",
      "alternateLine": "{item} — {qty} per unit, priority {priority}",
      "alternateNotesAria": "Notes for alternate {alternate} of component {line}",
      "alternatePriorityAria": "Priority of alternate {alternate} of component {line}",
      "alternateQtyAria": "Quantity per unit for alternate {alternate} of component {line}",
      "alternatesCaption": "Alternates for component {line}",
      "alternatesCount": "Alternates ({count})",
      "alternatesExplainer": "These are approved second sources for the component. The API stores and returns them, but it has no production-order action that swaps a line for its alternate, so no such button is offered.",
      "alternatesHeadline": "Alternates are declared, not substituted",
      "backToList": "All bills of materials",
      "collapse": "Hide structure",
      "columns": {
        "alternateItem": "Alternate item",
        "component": "Component",
        "components": "Components",
        "phantom": "Phantom",
        "phantoms": "Phantoms",
        "priority": "Priority",
        "quantityPer": "Qty per unit",
        "scrapPct": "Scrap %",
        "version": "Version"
      },
      "compare": {
        "against": "Compare against",
        "caption": "Component lines of both versions, with what differs on each.",
        "changes": {
          "added": "Added",
          "changed": "Changed",
          "removed": "Removed",
          "unchanged": "Same"
        },
        "description": "Line by line against another version of the same item.",
        "fields": {
          "alternates": "Alternates",
          "isPhantom": "Phantom",
          "quantityPer": "Quantity per",
          "scrapPct": "Scrap %",
          "uomCode": "Unit"
        },
        "headline": "{count} component line(s) differ",
        "hideSame": "Hide unchanged",
        "identical": "Every component line is identical in both versions.",
        "onlyVersion": "This item has no other version to compare against.",
        "option": "Version {version} ({status})",
        "pairingRule": "Lines are paired by component, and where a component appears more than once, in the order its lines appear — a BOM carries no identity for \"the same line in another version\".",
        "placeholder": "Choose a version",
        "showSame": "Show unchanged",
        "thatVersion": "Version {version}",
        "thisVersion": "Version {version}",
        "title": "Compare version {version}",
        "whatMoved": "What moved"
      },
      "componentsEditable": "The whole set is replaced in one save. Only a draft can be edited.",
      "componentsReadOnly": "This version is no longer a draft, so its components are fixed.",
      "componentsTitle": "Components",
      "confirm": {
        "activate": {
          "label": "Activate",
          "title": "Activate this bill of materials",
          "willDo": "Makes this the version every future production order explodes, and retires whatever version of this item's bill of materials was active before it."
        },
        "discard": {
          "label": "Discard",
          "title": "Discard this draft",
          "willDo": "Removes this draft version. Only a draft can be discarded, so nothing that has ever been used by a production order is lost."
        }
      },
      "conflictExplainer": "Reload the page, look at what changed, then reapply your edit.",
      "conflictHeadline": "Somebody else changed this",
      "copyFrom": {
        "createdDetail": "Version {version}, with {count} component line(s) copied.",
        "explainer": "Components come across with their quantity, unit, scrap, phantom flag, notes and alternates. Effectivity windows, co-product outputs and expected yield stay with the source — they describe that bill of materials’ own history, not this product.",
        "headline": "{count} component line(s) will be copied",
        "hint": "Clone the components of an existing bill of materials into the new one.",
        "label": "Copy from",
        "loading": "Reading the source bill of materials…",
        "option": "{item} — version {version} ({status})",
        "placeholder": "Start empty"
      },
      "create": "New bill of materials",
      "createDescription": "Start a draft for one produced item.",
      "createExplainer": "It is created empty and draft; components are added in the editor that opens next, where the cycle guard checks each one as you add it.",
      "createFailed": "Could not create it",
      "created": "Bill of materials created",
      "createdDetail": "Version {version}, draft.",
      "detailDescription": "Structure, components and lifecycle.",
      "discarded": "Draft discarded",
      "discardedDetail": "Nothing referenced it.",
      "duplicateLine": "Duplicate component {line}",
      "emptyDescription": "Create one for an item you build. A production order cannot be released without one.",
      "emptyLinesDescription": "Add components on the components tab. Activation refuses a bill of materials with none.",
      "emptyLinesTitle": "This bill of materials is empty",
      "emptyTitle": "No bills of materials yet",
      "expand": "Show structure",
      "expandAria": "Show the structure of {item}",
      "explosionExplainer": "The authoritative requirement is scrap-inflated, phantom-flattened, summed across every path and rounded to the stock ledger's grain. The server computes it at release, and it lands on the production order's material list.",
      "explosionHeadline": "Quantities here are per parent, as entered",
      "fields": {
        "producedItem": "Produced item"
      },
      "incompleteLines": "Every component needs an item, a quantity per unit and a unit before this can be saved.",
      "listDescription": "What each produced item is made of, versioned, with one active version per item.",
      "listTitle": "Bills of materials",
      "loadFailed": "Could not load bills of materials",
      "noAlternates": "No alternates declared.",
      "noSubAssembly": "This component has no active bill of materials of its own; it is bought or held as it is.",
      "notDraftExplainer": "Only a draft can be edited. Create a new version to change the structure.",
      "notesAria": "Notes for component {line}",
      "phantom": "Phantom",
      "phantomNoBomExplainer": "A phantom component must have an active bill of materials of its own. Release will refuse this whole structure until it does.",
      "phantomNoBomHeadline": "This phantom has no structure",
      "quantityAria": "Quantity per unit for component {line}",
      "rail": {
        "orders": "Production orders for this item"
      },
      "railTitle": "Bill of materials for {item}, v{version}",
      "removeAlternate": "Remove alternate {alternate} of component {line}",
      "removeLine": "Remove component {line}",
      "saveFailed": "Could not save the components",
      "saved": "Components saved",
      "savedDetail": "The whole set was replaced.",
      "scrapAria": "Scrap percentage for component {line}",
      "scrapOf": "{pct}% scrap",
      "structureDescription": "Phantom levels are expanded, because the server's own explosion walks straight through them. Sub-assemblies stop the explosion and open on request.",
      "structureTitle": "Structure",
      "subAssemblyNote": "A sub-assembly. The explosion stops here: this order issues it as a finished component, and building it is a separate production order.",
      "summaryTitle": "Bill of materials",
      "tabs": {
        "components": "Components",
        "structure": "Structure"
      },
      "tabsLabel": "Bill of materials sections",
      "timeline": {
        "created": "Created"
      },
      "unsaved": "Unsaved changes",
      "unsavedGuard": {
        "title": "Discard unsaved changes?",
        "message": "This bill of materials has changes that have not been saved. Leaving now discards them.",
        "confirm": "Discard changes",
        "cancel": "Keep editing"
      },
      "uomAria": "Unit for component {line}",
      "versionLabel": "Version {version}"
    },
    "capacity": {
      "barAria": "{workCenter}, week of {week}: {pct}% of capacity",
      "columns": {
        "capacity": "Capacity hrs / wk",
        "load": "Load %",
        "planned": "Planned hrs"
      },
      "description": "Planned load per work centre per week, against each centre's configured capacity.",
      "emptyDescription": "Load comes from the unfinished operations of production orders whose planned start falls in these weeks.",
      "emptyTitle": "No planned load in this window",
      "fields": {
        "weekStart": "Week starting",
        "weeks": "Weeks"
      },
      "loadFailed": "Could not load the capacity view",
      "loadPct": "{pct}% of capacity",
      "loadTitle": "Planned hours per week",
      "methodExplainer": "Setup once plus run time already multiplied by the order quantity, for operations that are not yet complete, bucketed by the order's planned start week. The percentage is the server's; only the bar's width is clamped, so an over-loaded centre still reads above 100%.",
      "methodHeadline": "How this load is computed",
      "noCapacity": "No capacity configured",
      "title": "Capacity",
      "weekStartHint": "A Monday. The report buckets by ISO week.",
      "weeksHint": "How many weeks to show, up to 26."
    },
    "costingModes": {
      "actual": "At actual cost",
      "standard": "At standard cost"
    },
    "fields": {
      "bom": "Bill of materials",
      "company": "Legal Entity",
      "completion": "Completion",
      "description": "Description",
      "issueDate": "Issue date",
      "item": "Item",
      "itemPlaceholder": "Choose an item",
      "laborMinutes": "Labour minutes",
      "laborRate": "Labour rate per hour",
      "lotNo": "Lot number",
      "machineMinutes": "Machine minutes",
      "materialHandling": "Material handling",
      "name": "Name",
      "notes": "Notes",
      "operation": "Operation",
      "overheadRate": "Overhead rate per hour",
      "plannedEnd": "Planned end",
      "plannedStart": "Planned start",
      "quantityPlanned": "Planned quantity",
      "receiptDate": "Receipt date",
      "routing": "Routing",
      "standardUnitCost": "Standard unit cost",
      "uom": "Unit",
      "warehouse": "Warehouse",
      "warehousePlaceholder": "Choose a warehouse",
      "workCenter": "Work centre",
      "workCenterPlaceholder": "Choose a work centre"
    },
    "filtersTitle": "Filters",
    "issue": {
      "columns": {
        "include": "Issue",
        "quantity": "Quantity to issue"
      },
      "dateHint": "Defaults to today in the legal entity's timezone.",
      "description": "Choose which components leave stock, and how much of each.",
      "done": "Material issued",
      "doneDetail": "Stock is out and WIP is up.",
      "failed": "Could not issue material",
      "includeAria": "Issue {item}",
      "linesCaption": "Components to issue",
      "lotAria": "Lot number for {item}",
      "noValueNote": "No value is shown before the issue: what a component is worth is the FIFO layers it consumes or its moving average at that instant, and the server returns that figure on the material line afterwards.",
      "overIssue": "Above the requirement",
      "overIssueExplainer": "This is allowed. Spoilage, rework and an under-estimated routing all consume more than standard, and the material usage variance at close is what measures it.",
      "overIssueHeadline": "More than the standard requirement",
      "postingExplainer": "Each line moves stock out of the warehouse and posts Dr WIP / Cr inventory for what that stock actually cost.",
      "qtyAria": "Quantity of {item} to issue",
      "title": "Issue material to WIP"
    },
    "lifecycle": {
      "cancel": {
        "blocked": {
          "issued": "Material has already been issued to this order's WIP. From here it must be closed so its variances post, never cancelled."
        },
        "done": "Order cancelled",
        "doneDetail": "Its reservations are released.",
        "label": "Cancel order",
        "reasonHint": "Recorded on the audit trail against your name.",
        "reasonLabel": "Reason",
        "reasonRequired": "A reason is required to cancel.",
        "title": "Cancel this production order",
        "willDo": "Releases every material reservation and marks the order cancelled. Nothing has posted, so there is no ledger entry to reverse."
      },
      "close": {
        "blocked": {
          "hold": "This order is on QC hold. Resolve the non-conformance report before closing.",
          "operations": "{count} operation(s) are still unfinished. Every operation must be complete before the order can be closed."
        },
        "done": "Order closed",
        "doneDetail": "Its variances are posted and its WIP balance is zero.",
        "label": "Close",
        "title": "Close this production order",
        "variancesExplainer": "Four named variances plus a residual sweep are computed from this order's own standards and posted. They cannot be reversed from this screen.",
        "variancesHeadline": "This writes to the general ledger",
        "willDo": "Computes and posts every material and labour variance, then sweeps whatever WIP is left to the residual account so this order clears to exactly zero."
      },
      "complete": "This order is closed. Its WIP balance is zero and every variance it produced is posted.",
      "edit": {
        "label": "Edit",
        "willDo": "Change this draft's quantity, warehouse, structure or dates. Only a draft can be edited."
      },
      "issue": {
        "blocked": {
          "backflush": "This order backflushes: it issues exactly the material each finished-goods receipt requires, so it cannot be issued by hand.",
          "noMaterials": "No material requirement exists yet. Releasing the order is what explodes the bill of materials into one."
        },
        "label": "Issue material",
        "willDo": "Moves components out of stock and into this order's WIP, posting Dr WIP / Cr inventory at the cost the stock ledger holds."
      },
      "nextStep": "Next: {step}",
      "nothingPermitted": "You may view this order but not act on it.",
      "operation": {
        "blocked": {
          "allComplete": "Every operation on this order is already complete.",
          "noRouting": "This order has no routing, so it has no operations to log."
        },
        "label": "Log an operation",
        "willDo": "Start or stop an operation on the operations tab. Each stop posts its own applied labour and overhead into WIP."
      },
      "qc": {
        "label": "Record QC",
        "willDo": "Record how many units were inspected, passed and failed. A failure raises a non-conformance report and holds the order."
      },
      "receive": {
        "blocked": {
          "hold": "This order is on QC hold. Resolve the non-conformance report before receiving.",
          "nothingRemaining": "The planned quantity is fully accounted for; there is nothing left to receive."
        },
        "label": "Receive finished goods",
        "willDo": "Brings finished output into stock and clears its cost out of WIP, at the order's standard unit cost when it has one and at actual cost otherwise."
      },
      "release": {
        "blocked": {
          "noBom": "This order has no bill of materials, so there is nothing to explode or reserve. Choose one on the order first."
        },
        "done": "Order released",
        "doneDetail": "Its material requirement is reserved and its number is assigned.",
        "label": "Release",
        "title": "Release this production order",
        "willDo": "Explodes the bill of materials, hard-reserves every component in the warehouse, snapshots the routing and any standard costs, and assigns the order its number."
      }
    },
    "materialStatuses": {
      "issued": "Issued",
      "partially_issued": "Partly issued",
      "pending": "Not issued"
    },
    "materials": {
      "columns": {
        "issued": "Issued",
        "outstanding": "Outstanding",
        "required": "Required",
        "standardCost": "Standard cost",
        "value": "Value issued"
      },
      "description": "Exploded from the bill of materials when the order was released, phantom levels flattened and scrap already applied.",
      "emptyDescription": "Releasing the order explodes its bill of materials into this list and reserves every component.",
      "emptyTitle": "No material requirement yet",
      "explodedNote": "These quantities are the server's own explosion, at the stock ledger's four decimal places. The value issued is what the FIFO layers or the moving average actually cost.",
      "substitute": "Substitute",
      "title": "Material requirement"
    },
    "mrp": {
      "actionFailed": "Could not action the suggestion",
      "actionedProduction": "Draft production order created",
      "actionedProductionDetail": "Raised against the item's active bill of materials, for the suggested quantity.",
      "actionedPurchase": "Marked actioned",
      "actionedPurchaseDetail": "This module does not raise requisitions; procurement owns those. Raise the purchase requisition from these same figures.",
      "actions": {
        "createOrder": "Create draft order",
        "markActioned": "Mark actioned",
        "run": "Run MRP"
      },
      "bulk": {
        "action": "Release selected",
        "confirm": "Release {count}",
        "description": "What releasing these will create, before it creates it.",
        "done": "{count} proposal(s) released",
        "notAtomic": "There is no bulk endpoint: each proposal is released on its own call, one after another. If one fails the run stops there and says how far it got — everything already released stays released.",
        "productionHeadline": "{count} draft production order(s) will be created",
        "productionLabel": "Build",
        "purchaseHeadline": "{count} purchase proposal(s) will be marked actioned only",
        "purchaseLabel": "Buy",
        "skipped": "{count} of the selected are not open and will be left alone.",
        "stopped": "Stopped after {done} of {total}.",
        "title": "Release {count} proposal(s)"
      },
      "columns": {
        "needBy": "Need by",
        "quantity": "Shortfall",
        "reason": "Why",
        "run": "Run",
        "type": "Build or buy"
      },
      "dismissDescription": "It stays on the list, marked dismissed.",
      "dismissExplainer": "Dismissing does not delete anything. The suggestion and your reason stay on record, and the next run may raise it again.",
      "dismissReasonHint": "Recorded on the audit trail.",
      "dismissReasonRequired": "A reason is required.",
      "dismissTitle": "Dismiss this suggestion",
      "dismissed": "Suggestion dismissed",
      "dismissedDetail": "Your reason is on the audit trail.",
      "emptyDescription": "Run MRP for a warehouse to net open sales demand against what you have and what is on its way.",
      "emptyTitle": "No suggestions",
      "fields": {
        "dismissReason": "Reason",
        "horizon": "Horizon (days)"
      },
      "horizonHint": "Days ahead to plan for. Defaults to 90.",
      "lastRunExplainer": "Suggestions are only half of a run. What MRP could not plan at all — demand inside a planning fence, or an item with no source policy, no lead time or no bill of materials — is raised as an exception, and exceptions never appear in this list.",
      "lastRunHeadline": "Run complete — {count} suggestion(s) created",
      "lastRunLink": "Open run #{id}",
      "listDescription": "What open sales demand says you are short of, and whether to build it or buy it.",
      "listTitle": "MRP suggestions",
      "loadFailed": "Could not load MRP suggestions",
      "runDescription": "For one legal entity and one warehouse.",
      "runDone": "MRP run complete",
      "runDoneDetail": "{count} new suggestion(s).",
      "runExplainer": "A run creates new suggestions; it does not remove the ones already open.",
      "runTitle": "Run MRP",
      "scopeExplainer": "Open sales-order demand for one warehouse against on-hand, reservations and inbound purchase orders — plus, for anything it suggests producing, that item's own direct components. It is one level, not a cascading multi-pass plan.",
      "scopeHeadline": "What a run nets, and what it does not",
      "statuses": {
        "actioned": "Actioned",
        "dismissed": "Dismissed",
        "open": "Open"
      },
      "types": {
        "production": "Produce",
        "purchase": "Purchase"
      },
      "warehouseHint": "Demand, stock and inbound are all netted within this one warehouse."
    },
    "operationStatuses": {
      "complete": "Complete",
      "in_progress": "Running",
      "pending": "Not started"
    },
    "operations": {
      "actions": {
        "start": "Start",
        "stop": "Stop"
      },
      "columns": {
        "actualLabour": "Actual labour (min)",
        "actualMachine": "Actual machine (min)",
        "appliedLabour": "Applied labour",
        "appliedOverhead": "Applied overhead",
        "plannedRun": "Planned run (min)",
        "plannedSetup": "Planned setup (min)",
        "seq": "Seq."
      },
      "description": "Snapshotted from the routing when the order was released. Planned run time is already multiplied by the order quantity.",
      "emptyDescription": "Attach a routing to a draft order to log operation time and apply labour and overhead to WIP.",
      "emptyTitle": "This order has no routing",
      "finalDescription": "The order cannot be closed while any operation is still short of complete.",
      "finalLabel": "This finishes the operation",
      "logCount": "{count} time log(s)",
      "machineHint": "Leave empty when this operation logs no machine time.",
      "minutesHint": "Two decimal places",
      "overheadOnLabour": "Overhead will be applied on the labour minutes, because no machine time was logged.",
      "overheadOnMachine": "Overhead will be applied on the machine minutes, because machine time was logged.",
      "postingNote": "Every stop posts its own journal entry: Dr WIP, Cr applied labour and Cr applied overhead for that segment alone.",
      "postsExplainer": "The minutes you enter are applied at the rates below and debited to WIP immediately, not batched at the end of the operation.",
      "postsHeadline": "Stopping posts to the ledger",
      "rateDefault": "Work centre rate {rate}",
      "rateHint": "Leave empty to apply the work centre's own rate.",
      "seqLabel": "Operation {seq}: {name}",
      "startFailed": "Could not start the operation",
      "started": "Operation started",
      "startedDetail": "The clock is running.",
      "stopDescription": "Log the time this segment consumed.",
      "stopFailed": "Could not log the time",
      "stopSubject": "Operation {seq}: {name}",
      "stopTitle": "Stop operation",
      "stopped": "Time logged",
      "stoppedDetail": "Applied labour and overhead are posted to WIP.",
      "title": "Operations"
    },
    "orderSources": {
      "manual": "Manual",
      "mrp": "MRP"
    },
    "orderStatuses": {
      "cancelled": "Cancelled",
      "closed": "Closed",
      "completed": "Completed",
      "draft": "Draft",
      "in_progress": "In progress",
      "released": "Released"
    },
    "orders": {
      "actions": {
        "add": "New order"
      },
      "backToList": "All production orders",
      "backflushDescription": "Off means somebody issues components by hand before production.",
      "backflushExplainer": "Every finished-goods receipt will first issue exactly the material that quantity requires, computed from the bill of materials at that moment. The manual issue button will be refused on this order.",
      "backflushLabel": "Backflush material at receipt",
      "backflushOff": "Issued by hand",
      "backflushOn": "Backflushed at receipt",
      "bomHint": "Defaults to the item's active version. Release refuses an order without one.",
      "columns": {
        "completed": "Completed",
        "orderNo": "Order no.",
        "planned": "Planned",
        "plannedStart": "Planned start",
        "source": "Source",
        "wip": "WIP balance"
      },
      "conflictExplainer": "Reload it, look at what changed, then reapply your edit.",
      "conflictHeadline": "Somebody else changed this order",
      "create": "New production order",
      "createDescription": "What to build, how many, and from which structure.",
      "createFailed": "Could not raise the order",
      "created": "Production order raised",
      "createdDetail": "It is a draft until you release it.",
      "detailDescription": "Materials, operations, receipts and posted variances.",
      "editDescription": "A draft can still change; a released order cannot.",
      "editTitle": "Edit draft order",
      "emptyDescription": "Create one, or run MRP to see what open sales demand says you should be building.",
      "emptyTitle": "No production orders yet",
      "holdApiGap": "The API returns no list of non-conformance reports, so the report can only be resolved from the inspection that raised it, in the QC dialog.",
      "holdExplainer": "A failed QC inspection raised it. Receiving finished goods and closing the order are both refused until it is resolved.",
      "holdHeadline": "This order is held by a non-conformance report",
      "itemImmutable": "The item cannot be changed: the bill of materials, the routing and the standard cost were all resolved against it. A different item is a different order.",
      "listDescription": "What is being built, where it is in the pipeline, and what it still owes the ledger.",
      "listTitle": "Production orders",
      "loadFailed": "Could not load production orders",
      "noBomExplainer": "Release explodes the bill of materials into the order's material requirement, so an order without one has nothing to reserve.",
      "noBomHeadline": "This order cannot be released yet",
      "noBomSelected": "No bill of materials",
      "noCrossCompanyTotal": "WIP balances are not totalled: each legal entity states its own in its own base currency.",
      "noRoutingSelected": "No routing",
      "onHold": "On QC hold",
      "qtyHint": "Four decimal places",
      "rail": {
        "bom": "Bill of materials",
        "item": "Item in inventory",
        "movements": "Stock movements",
        "routing": "Routing"
      },
      "railSubtitle": "{status} — building {item}",
      "reload": "Reload the order",
      "routingHint": "Optional. Without one the order has no operations to log or cost.",
      "saveFailed": "Could not save the order",
      "saved": "Order saved",
      "savedDetail": "Your changes are stored.",
      "standardCostExplainer": "Snapshotted from the item's current standard cost when the order was released. Finished goods are received at this figure, and the variances measure against it.",
      "standardCostHeadline": "Standard unit cost {cost}",
      "summaryTitle": "Order",
      "tabs": {
        "materials": "Materials",
        "operations": "Operations",
        "receipts": "Receipts",
        "variances": "Variances"
      },
      "tabsLabel": "Production order sections",
      "timeline": {
        "actualEnd": "Output complete",
        "actualStart": "Released",
        "closed": "Closed",
        "created": "Raised",
        "plannedStart": "Planned start"
      },
      "unnumbered": "Draft (not yet numbered)"
    },
    "qc": {
      "actions": {
        "record": "Record inspection",
        "resolve": "Resolve the report"
      },
      "cannotResolve": "You may inspect but not decide a disposition. That is deliberate: an inspector does not resolve their own failed inspection.",
      "description": "How many units were inspected, and how many of them passed.",
      "dispositionNote": "Rework, scrap and use-as-is all clear the hold. None of them changes the order's completed or scrapped quantity — the API does not adjust either.",
      "dispositions": {
        "rework": "Rework",
        "scrap": "Scrap",
        "use_as_is": "Use as is"
      },
      "failed": "Could not record the inspection",
      "fields": {
        "disposition": "Disposition",
        "failed": "Failed",
        "inspected": "Quantity inspected",
        "passed": "Passed",
        "resolutionNote": "Resolution note",
        "type": "Inspection point"
      },
      "ncrExplainer": "The order is now on hold. Choose a disposition to resolve it and lift the hold.",
      "ncrOnlyHere": "Resolve it now if you can: the API exposes no list of non-conformance reports, so after this dialog closes there is no other screen that can reach this one.",
      "ncrRaised": "Non-conformance report #{id}",
      "ncrResolveFailed": "Could not resolve the report",
      "ncrResolved": "Non-conformance resolved",
      "ncrResolvedDetail": "The hold is lifted once no report on this order is open.",
      "notesPlaceholder": "What was wrong. This becomes the non-conformance report's reason.",
      "operationHint": "Leave empty for an inspection against the whole order.",
      "recorded": "Inspection recorded",
      "results": {
        "fail": "Every unit failed.",
        "partial": "Some units failed.",
        "pass": "Every unit passed."
      },
      "splitExceeds": "Passed plus failed cannot be more than the quantity inspected.",
      "title": "Record a QC inspection",
      "types": {
        "final": "Final",
        "in_process": "In-process"
      },
      "wholeOrder": "The whole order",
      "willHoldExplainer": "A failed unit raises a non-conformance report. Receiving finished goods and closing the order are both refused until it is resolved.",
      "willHoldHeadline": "This will hold the order"
    },
    "receipts": {
      "columns": {
        "costingMode": "Costing",
        "quantity": "Quantity",
        "receivedAt": "Received",
        "unitCost": "Unit cost",
        "value": "Value"
      },
      "description": "What came off the line, at what cost, and on which basis.",
      "emptyDescription": "Receiving finished goods brings output into stock and clears its cost out of WIP.",
      "emptyTitle": "Nothing received yet",
      "title": "Finished-goods receipts"
    },
    "receive": {
      "actualCostingExplainer": "This item has no current standard cost, so the server derives the unit cost from the WIP still in the order. That is not an error; it is actual costing.",
      "actualCostingHeadline": "Received at actual cost",
      "backflushExplainer": "The bill of materials is exploded for exactly this quantity and that much of every component is issued to WIP first.",
      "backflushHeadline": "This also issues material",
      "dateHint": "Defaults to today in the legal entity's timezone.",
      "description": "Bring completed output into the order's warehouse.",
      "done": "Finished goods received",
      "doneDetail": "Stock is up and WIP is down.",
      "exceedsRemaining": "Only {remaining} of the planned quantity is left; the server refuses more.",
      "failed": "Could not receive",
      "fields": {
        "quantity": "Quantity to receive"
      },
      "remaining": "Remaining",
      "standardCostingExplainer": "The order carries a snapshotted standard cost, so the receipt is valued at it and the difference from actual becomes a variance at close.",
      "standardCostingHeadline": "Received at the standard unit cost {cost}",
      "title": "Receive finished goods"
    },
    "routeTitles": {
      "bom": "Bill of materials",
      "boms": "Bills of materials",
      "capacity": "Capacity",
      "mrp": "MRP suggestions",
      "productionOrder": "Production order",
      "productionOrders": "Production orders",
      "routing": "Routing",
      "routings": "Routings",
      "settings": "Manufacturing settings",
      "standardCosts": "Standard costs",
      "wipClearing": "WIP clearing",
      "workCenters": "Work centres"
    },
    "routings": {
      "actions": {
        "activate": "Activate",
        "add": "New routing",
        "addOperation": "Add operation",
        "discard": "Discard draft"
      },
      "activateBlocked": {
        "notDraft": "Only a draft can be activated.",
        "unsaved": "Save your changes first: activation uses the stored operations, not the ones on screen."
      },
      "activated": "Routing activated",
      "activatedDetail": "Any previously active routing for this item is now obsolete.",
      "backToList": "All routings",
      "columns": {
        "operations": "Operations",
        "runPerUnit": "Run per unit (min)",
        "setup": "Setup (min)"
      },
      "confirm": {
        "activate": {
          "label": "Activate",
          "title": "Activate this routing",
          "willDo": "Makes this the routing every future production order snapshots at release, and retires whatever routing for this item was active before it."
        },
        "discard": {
          "label": "Discard",
          "title": "Discard this draft",
          "willDo": "Removes this draft routing. Only a draft can be discarded, so no routing an order has already snapshotted is affected."
        }
      },
      "conflictExplainer": "Reload the page, look at what changed, then reapply your edit.",
      "conflictHeadline": "Somebody else changed this routing",
      "create": "New routing",
      "createDescription": "Start a draft for one produced item.",
      "createExplainer": "It is created empty and draft; operations are added in the editor that opens next.",
      "createFailed": "Could not create the routing",
      "created": "Routing created",
      "createdDetail": "Version {version}, draft.",
      "descriptionAria": "Description of operation {line}",
      "detailDescription": "Operations and lifecycle.",
      "discarded": "Draft discarded",
      "discardedDetail": "Nothing referenced it.",
      "duplicateSeq": "Two operations share a sequence number. The order they run in is the point of the number, so it must be unique.",
      "emptyDescription": "Create one to log operation time and apply labour and overhead to a production order.",
      "emptyTitle": "No routings yet",
      "incompleteOperations": "Every operation needs a sequence number, a work centre and a name before this can be saved.",
      "listDescription": "The ordered operations that turn components into an item, on which work centre, at what standard time.",
      "listTitle": "Routings",
      "loadFailed": "Could not load routings",
      "nameAria": "Name of operation {line}",
      "noOperations": "No operations yet.",
      "notDraftExplainer": "Only a draft can be edited. Create a new version to change the operations.",
      "operationsEditable": "The whole set is replaced in one save. Only a draft can be edited.",
      "operationsReadOnly": "This version is no longer a draft, so its operations are fixed.",
      "operationsTitle": "Operations",
      "rail": {
        "orders": "Production orders for this item"
      },
      "railTitle": "Routing for {item}, v{version}",
      "removeOperation": "Remove operation {line}",
      "runAria": "Run minutes per unit for operation {line}",
      "saveFailed": "Could not save the operations",
      "saved": "Operations saved",
      "savedDetail": "The whole set was replaced.",
      "seqAria": "Sequence number for operation {line}",
      "setupAria": "Setup minutes for operation {line}",
      "summaryTitle": "Routing",
      "timeline": {
        "created": "Created"
      },
      "timesNote": "Setup time is charged once per order; run time is per unit and is multiplied by the order quantity when the routing is snapshotted at release. Together they are the standard the labour efficiency variance measures against.",
      "unsaved": "Unsaved changes",
      "versionLabel": "Version {version}"
    },
    "settings": {
      "auditNote": "Changing an account is audited, and affects future postings only.",
      "description": "The accounts production posts to. Without them, issuing, receiving and closing are all refused.",
      "fields": {
        "appliedLabour": "Applied labour account",
        "appliedOverhead": "Applied overhead account",
        "wip": "WIP account"
      },
      "hints": {
        "appliedLabour": "The credit side of an operation's labour time.",
        "appliedOverhead": "The credit side of an operation's applied overhead.",
        "labourEfficiency": "The hours an operation actually took, against its planned setup plus run time.",
        "labourRate": "The rate an operation was actually applied at, against the work centre's standard.",
        "materialPrice": "What a component actually cost, against its standard cost.",
        "materialUsage": "How much was issued, against how much the bill of materials called for.",
        "residual": "The sweep at close: applied overhead and any rounding left in WIP. Required — closing refuses without it.",
        "wip": "Debited by every material issue and every logged operation; credited by every receipt."
      },
      "loadFailed": "Could not load the settings",
      "noResidualExplainer": "This is the sweep that makes WIP clear to exactly zero. Without it the server refuses to close an order rather than leave a balance stranded.",
      "noResidualHeadline": "No overhead / residual account is configured",
      "noWipExplainer": "Until one is set, issuing material and receiving finished goods are both refused for this legal entity.",
      "noWipHeadline": "No WIP account is configured",
      "notConfigured": "Not configured",
      "openChart": "Open the chart of accounts",
      "readOnlyNote": "You may see this configuration but not change it. That is deliberate: it is the rule production staff are judged against.",
      "saveFailed": "Could not save the settings",
      "saved": "Settings saved",
      "savedDetail": "Future postings will use these accounts.",
      "title": "Manufacturing settings",
      "unpostedExplainer": "Those variances are still computed and explained on the order; their amounts simply stay inside WIP for the residual sweep to absorb, and the order marks them not posted.",
      "unpostedHeadline": "{count} variance account(s) not configured",
      "varianceDescription": "Where each variance lands at close. An unconfigured one does not fabricate a posting.",
      "varianceTitle": "Variance accounts",
      "wipDescription": "The hinge of the whole module: material issues and applied time debit it, receipts credit it, and closing clears it to zero.",
      "wipTitle": "Work in progress",
      "stale": "Somebody else saved these settings while you had them open. Nothing was overwritten — reload the saved version, then apply your edits again.",
      "reload": "Reload the saved version"
    },
    "standardCosts": {
      "actions": {
        "set": "Set standard cost"
      },
      "asEnteredExplainer": "A standard cost here is a decision somebody made on a date. The API does not roll one up from a bill of materials plus a routing, and no screen claims that it does.",
      "asEnteredHeadline": "These are entered, not rolled up",
      "columns": {
        "cost": "Standard cost",
        "effectiveFrom": "Effective from"
      },
      "costHint": "Six decimal places",
      "costsIn": "Costs are stated in {currency}.",
      "current": "Current",
      "description": "The dated figure every variance on a closed production order is measured against.",
      "effectiveHint": "The date this figure takes effect from.",
      "emptyDescription": "An item with no standard cost is costed at actual. Set one to receive finished goods at standard and to give the variances a baseline.",
      "emptyTitle": "No standard costs set",
      "loadFailed": "Could not load standard costs",
      "saveFailed": "Could not set the standard cost",
      "saved": "Standard cost set",
      "savedDetail": "It is now the current figure for that item.",
      "setDescription": "For one item, effective from one date.",
      "setTitle": "Set a standard cost",
      "supersedeExplainer": "Whatever standard cost this item currently carries stops being current. Production orders already released keep the figure they snapshotted.",
      "supersedeHeadline": "This retires the current figure",
      "superseded": "Superseded",
      "title": "Standard costs"
    },
    "varianceTypes": {
      "labor_efficiency": "Labour efficiency",
      "labor_rate": "Labour rate",
      "material_price": "Material price",
      "material_usage": "Material usage",
      "overhead": "Overhead and residual"
    },
    "variances": {
      "authorityExplainer": "Each variance is computed server-side and carries the journal entry it produced. A variance marked not posted has no account configured, so its amount stayed inside WIP for the residual sweep to absorb.",
      "authorityHeadline": "These figures are the ledger's",
      "columns": {
        "actualAmount": "Actual",
        "actualQty": "Actual qty",
        "expectedAmount": "Expected",
        "expectedQty": "Expected qty",
        "posted": "Posted",
        "subject": "Against",
        "type": "Variance",
        "variance": "Difference"
      },
      "description": "Computed and posted when the order was closed, from the order's own standards.",
      "emptyDescription": "Variances are computed when the order is closed. Until then there is nothing to compare.",
      "emptyTitle": "No variances yet",
      "journal": "Journal",
      "noPermissionDescription": "Viewing posted cost variances is a separate permission from viewing the order.",
      "noPermissionTitle": "You cannot view variances",
      "notPosted": "Recorded, not posted",
      "title": "Cost variances",
      "wholeOrder": "The whole order"
    },
    "wip": {
      "closedBalanceExplainer": "Closing posts every variance and then sweeps the residual precisely so that WIP clears. A closed order above zero means that sweep did not happen.",
      "closedBalanceHeadline": "{count} closed order(s) still carry WIP",
      "columns": {
        "difference": "Difference",
        "ledger": "Ledger balance",
        "maintained": "Order balance"
      },
      "description": "Each order's own WIP balance against an independent sum of the ledger. They must agree, and a closed order must be at zero.",
      "emptyDescription": "There are no production orders for this legal entity yet, or no WIP account is configured for it.",
      "emptyTitle": "Nothing to reconcile",
      "loadFailed": "Could not load the WIP clearing report",
      "methodExplainer": "The maintained balance is the projection each order carries, adjusted in the same transaction as every posting that moved it. The ledger balance is an independent sum over journal lines for that order and the legal entity's WIP account.",
      "methodHeadline": "Two figures, computed apart",
      "mismatchExplainer": "The projection and the ledger disagree. This is a reconciliation failure, not a display problem: the two are computed from different places precisely so that a bug in one cannot hide.",
      "mismatchHeadline": "{count} order(s) do not reconcile",
      "reconcilesExplainer": "Every order's maintained balance equals the independent ledger sum, to the cent.",
      "reconcilesHeadline": "All {count} order(s) reconcile",
      "tableTitle": "Balances as of {asOf}",
      "title": "WIP clearing"
    },
    "workCenters": {
      "actions": {
        "add": "New work centre"
      },
      "active": "Active",
      "activeLabel": "Available for new routings",
      "capacityHint": "The denominator of the capacity report's load percentage.",
      "codeHint": "Immutable once created.",
      "codeImmutable": "The code cannot be changed: it is what this centre is known by on the floor and in every capacity report already printed.",
      "columns": {
        "capacity": "Capacity hrs / wk",
        "costRate": "Cost rate / hr",
        "overheadRate": "Overhead rate / hr"
      },
      "conflictExplainer": "Somebody else changed this work centre. Close this dialog, reload, and reapply your edit.",
      "costRateHint": "What logged labour time is applied at, per hour.",
      "create": "New work centre",
      "createDescription": "Its rates are the standard every operation is costed and judged against.",
      "created": "Work centre created",
      "editTitle": "Edit work centre",
      "emptyDescription": "Create one before building a routing: every operation is performed at a work centre and costed at its rate.",
      "emptyTitle": "No work centres yet",
      "fields": {
        "capacity": "Capacity hours per week",
        "code": "Code",
        "costRate": "Cost rate per hour",
        "overheadRate": "Overhead rate per hour"
      },
      "forwardOnly": "Changing a rate affects future postings only. Time already logged carries the rate it was logged at, and a routing already snapshotted onto a released order is untouched.",
      "inactive": "Inactive",
      "listDescription": "Where an operation is performed, at what rate, and with how much capacity a week.",
      "listTitle": "Work centres",
      "loadFailed": "Could not load work centres",
      "noCapacityWarning": "With no weekly capacity, the capacity report shows planned hours but no load percentage: there is nothing to divide by.",
      "overheadRateHint": "Applied on machine time when an operation logs any, and on labour time otherwise.",
      "ratesIn": "Rates and capacity are stated in {currency}.",
      "saveFailed": "Could not save the work centre",
      "saved": "Work centre saved",
      "savedDetail": "Your changes are stored.",
      "searchPlaceholder": "Code or name"
    },
    "c7": {
      "filtersTitle": "Filters",
      "common": {
        "remove": "Remove"
      },
      "routeTitles": {
        "ecos": "Change orders",
        "eco": "Change order",
        "effectivity": "BOM line effectivity",
        "bomOutputs": "BOM outputs",
        "substitutions": "Substitutions",
        "genealogy": "Genealogy",
        "calendar": "Work centre calendar",
        "dispatch": "Dispatch list",
        "scheduleRuns": "Scheduling",
        "bottlenecks": "Bottlenecks",
        "tools": "Tooling",
        "planningParameters": "Planning parameters",
        "mrpRun": "MRP run",
        "pegging": "Pegging",
        "settlement": "Settlement",
        "rollups": "Standard cost roll-ups",
        "rollup": "Roll-up",
        "varianceAnalysis": "Variance analysis"
      },
      "fields": {
        "code": "Code",
        "company": "Legal Entity",
        "detail": "Detail",
        "documentNo": "Number",
        "effectivity": "Effectivity",
        "fromDate": "From",
        "item": "Item",
        "kind": "Kind",
        "notes": "Notes",
        "openEnded": "open",
        "quantity": "Quantity",
        "reason": "Reason",
        "title": "Title",
        "toDate": "To",
        "urgency": "Urgency",
        "value": "Value"
      },
      "ecoReason": {
        "design": "Design",
        "cost_reduction": "Cost reduction",
        "quality": "Quality",
        "obsolescence": "Obsolescence",
        "supplier_change": "Supplier change",
        "regulatory": "Regulatory"
      },
      "ecoUrgency": {
        "routine": "Routine",
        "expedited": "Expedited",
        "emergency": "Emergency"
      },
      "ecoStatus": {
        "draft": "Draft",
        "submitted": "Submitted",
        "approved": "Approved",
        "rejected": "Rejected",
        "effective": "Effective",
        "closed": "Closed",
        "cancelled": "Cancelled"
      },
      "ecoChangeKind": {
        "bom_line_add": "BOM line added",
        "bom_line_change": "BOM line changed",
        "bom_line_remove": "BOM line removed",
        "routing_op_change": "Operation changed",
        "item_attribute": "Item attribute",
        "alternate_add": "Alternate added",
        "alternate_remove": "Alternate removed"
      },
      "dispositionSubject": {
        "stock": "Stock on hand",
        "wip": "Work in progress",
        "production_order": "Production order",
        "purchase_order": "Purchase order",
        "inspection_plan": "Inspection plan"
      },
      "dispositionAction": {
        "use_up": "Use up",
        "rework": "Rework",
        "scrap": "Scrap",
        "return": "Return",
        "amend": "Amend",
        "no_action": "No action"
      },
      "dispositionStatus": {
        "open": "Open",
        "done": "Done",
        "waived": "Waived"
      },
      "outputKind": {
        "primary": "Primary output",
        "co_product": "Co-product",
        "by_product": "By-product",
        "scrap_output": "Scrap output"
      },
      "splitBasis": {
        "physical_quantity": "Physical quantity",
        "relative_value": "Relative value",
        "fixed_percent": "Fixed percentage"
      },
      "exceptionKind": {
        "closed": "Closed",
        "extra_shift": "Extra shift",
        "reduced": "Reduced"
      },
      "scheduleDirection": {
        "forward": "Forward",
        "backward": "Backward"
      },
      "scheduleMode": {
        "finite": "Finite",
        "infinite": "Infinite"
      },
      "toolStatus": {
        "available": "Available",
        "in_use": "In use",
        "maintenance": "Maintenance",
        "retired": "Retired"
      },
      "weekday": {
        "0": "Sunday",
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday"
      },
      "lotSizing": {
        "lot_for_lot": "Lot for lot",
        "fixed_quantity": "Fixed quantity",
        "min_max": "Minimum and maximum",
        "period_of_supply": "Period of supply",
        "eoq": "Economic order quantity"
      },
      "sourcePolicy": {
        "make": "Make",
        "buy": "Buy",
        "either": "Either"
      },
      "demandKind": {
        "sales_order": "Sales order",
        "production_order": "Production order",
        "forecast": "Forecast",
        "safety_stock": "Safety stock",
        "transfer": "Transfer",
        "min_max": "Minimum stock"
      },
      "mrpException": {
        "inside_time_fence": "Inside the time fence",
        "past_due_demand": "Demand already past due",
        "no_source_policy": "No source policy",
        "no_lead_time": "No lead time",
        "no_bom_for_make": "No bill of materials",
        "no_supplier_for_buy": "No supplier",
        "low_level_cap_reached": "Bill of materials cycle",
        "negative_available": "Negative available stock"
      },
      "settlementStatus": {
        "preview": "Preview",
        "posted": "Posted",
        "superseded": "Superseded"
      },
      "residualDisposition": {
        "write_off": "Write off",
        "reallocate_to_output": "Reallocate to output",
        "carry_to_new_order": "Carry to another order"
      },
      "rollupStatus": {
        "draft": "Draft",
        "applied": "Applied",
        "superseded": "Superseded"
      },
      "rollupBasis": {
        "standard": "Component standard",
        "moving_average": "Moving average"
      },
      "costElement": {
        "material": "Material",
        "labor": "Labour",
        "overhead": "Overhead",
        "subcontract": "Subcontract",
        "by_product_credit": "By-product credit"
      },
      "costSource": {
        "component_standard": "Component standard",
        "component_moving_average": "Component moving average",
        "work_center_rate": "Work centre rate",
        "nested_rollup": "Nested roll-up",
        "manual": "Set by hand"
      },
      "varianceType": {
        "material_price": "Material price",
        "material_usage": "Material usage",
        "labor_rate": "Labour rate",
        "labor_efficiency": "Labour efficiency",
        "overhead": "Overhead (pre-C7 plug)",
        "yield": "Yield",
        "overhead_spend": "Overhead spend",
        "overhead_volume": "Overhead volume"
      },
      "blocker": {
        "operation_incomplete": "An operation is not complete",
        "open_ncr": "A nonconformance is still open",
        "order_on_hold": "The order is on hold",
        "open_inspection": "A blocking inspection has not passed",
        "missing_variance_account": "A variance account is not set for a non-zero variance",
        "missing_overhead_account": "The overhead variance account is not set and the residual is not zero"
      },
      "eco": {
        "title": "Engineering change orders",
        "description": "What changes, what it affects, and what has to be done about the material already in the building.",
        "tableTitle": "Change orders",
        "caption": "Change orders with their reason, urgency, effectivity and outstanding dispositions.",
        "create": "New change order",
        "dialogDescription": "A change is effective from a date or from an order — never both.",
        "searchLabel": "Search",
        "searchPlaceholder": "Number or title",
        "loadFailed": "The change orders did not load",
        "empty": "No change orders. One is raised when a design, a supplier or a specification moves.",
        "emptyFiltered": "No change orders match these filters.",
        "draftNo": "Draft",
        "effectiveFrom": "Effective from",
        "effectiveFromOrder": "Effective from order",
        "fromOrder": "From {no}",
        "openDispositions": "Open",
        "anchor": "Effectivity anchor",
        "anchorHint": "Which build the change lands in.",
        "anchorDate": "A date",
        "anchorDateMeaning": "Effective for everything exploded on or after this date",
        "anchorOrder": "A production order",
        "anchorOrderMeaning": "Effective from this order onwards, whatever the date",
        "noAnchor": "Not anchored yet",
        "estimatedImpact": "Estimated cost impact",
        "realisedImpact": "Realised cost impact",
        "urgencyMeaning": {
          "routine": "Schedule it with the next revision",
          "expedited": "Bring it forward",
          "emergency": "An emergency change stops the line now. Raise it only when production cannot continue."
        },
        "factsTitle": "Change order",
        "itemsTitle": "Changes",
        "itemsCaption": "What changes, before and after.",
        "itemsEmpty": "No change items recorded yet.",
        "changeKind": "Change",
        "before": "Before",
        "after": "After",
        "dispositionsTitle": "Dispositions",
        "dispositionsCaption": "Stock, work in progress and open orders affected by this change.",
        "dispositionsMeaning": "What has to happen to the material and orders already in flight before this change can be closed.",
        "notAnalysed": "This change has not been analysed. Analysing it finds the stock to use up, the work in progress to rework and the open orders to amend — without it an approved change is a document rather than a piece of work.",
        "analyse": "Analyse impact",
        "analysed": "Impact analysed",
        "analyseFailed": "The impact was not analysed",
        "subject": "Subject",
        "action": "Action",
        "markDone": "Mark done",
        "dispositionCompleted": "Disposition completed",
        "dispositionFailed": "The disposition was not updated",
        "openBlocksClose": "{count} dispositions are still open. The change cannot be closed until they are cleared.",
        "submitted": "Change order submitted",
        "submitFailed": "The change order was not submitted",
        "approved": "Change order approved",
        "decideFailed": "The decision was not recorded",
        "apply": "Apply",
        "applied": "Change order applied",
        "applyFailed": "The change order was not applied",
        "close": "Close",
        "closed": "Change order closed",
        "closeFailed": "The change order was not closed",
        "saved": "Change order raised",
        "saveFailed": "The change order was not saved",
        "backToList": "Back to change orders"
      },
      "effectivity": {
        "title": "BOM line effectivity",
        "description": "When this line applies, and how much of it.",
        "tableTitle": "Effectivity windows",
        "caption": "Effectivity windows with the quantity and scrap that apply inside each.",
        "loadFailed": "The effectivity did not load",
        "alwaysMeaning": "This line has no effectivity windows, which means it is effective always. Adding a window turns it off for every date outside that window.",
        "from": "From",
        "to": "To",
        "fromOrder": "From order",
        "quantityPer": "Quantity per",
        "scrapPct": "Scrap %",
        "addRow": "Add window",
        "saved": "Effectivity saved",
        "saveFailed": "The effectivity was not saved",
        "lineLink": "Effectivity",
        "lineLinkAria": "Effectivity windows for {item}"
      },
      "outputs": {
        "title": "BOM outputs",
        "description": "Co-products, by-products and scrap from this bill.",
        "tableTitle": "Outputs",
        "caption": "Outputs with their kind, cost split basis and credit rate.",
        "loadFailed": "The outputs did not load",
        "empty": "No secondary outputs. Everything this bill makes is the primary item.",
        "quantityPer": "Quantity per",
        "basis": "Split basis",
        "sharePercent": "Share %",
        "creditRate": "Credit rate",
        "addRow": "Add output",
        "splitMeaning": "The percentages here are configuration. The money is apportioned by the server from the quantities actually received, by largest remainder, so it foots to the cent against work in progress.",
        "kindMeaning": {
          "co_product": "Takes a share of the order's cost",
          "by_product": "Takes no share; credits WIP at a standard rate",
          "scrap_output": "Takes no cost and credits nothing"
        },
        "basisMeaning": {
          "physical_quantity": "Split by units produced",
          "relative_value": "Split by market value",
          "fixed_percent": "Split by a percentage you set"
        },
        "saved": "Outputs saved",
        "saveFailed": "The outputs were not saved"
      },
      "substitution": {
        "title": "Substitutions",
        "description": "What was used instead of what, and what it cost.",
        "tableTitle": "Substitutions",
        "caption": "Substitutions with their conversion, values and cost impact.",
        "loadFailed": "The substitutions did not load",
        "empty": "Nothing was substituted on this order.",
        "backToOrder": "Back to the order",
        "original": "Required",
        "substitute": "Used",
        "quantityOriginal": "Required quantity",
        "quantitySubstitute": "Issued quantity",
        "conversion": "Conversion",
        "originalStandard": "Original standard",
        "substituteActual": "Substitute actual",
        "costImpact": "Cost impact",
        "planned": "Planned",
        "declaredAlternate": "Declared alternate",
        "unplanned": "Unplanned",
        "unplannedCount": "{count} substitutions were not declared alternates. Each carries a reason and an override.",
        "replacing": "Instead of {item}",
        "declared": "Declared alternate",
        "declaredHint": "In priority order, with each one's conversion and available stock.",
        "noneDeclared": "This material has no declared alternates.",
        "available": "Available",
        "priority": "Priority",
        "optionHint": "×{factor} · {available} available",
        "other": "Another item",
        "otherHint": "Anything not on the declared list needs a reason.",
        "undeclaredMeaning": "This is not a declared alternate. It can still be issued, with a reason, and the reason is what an engineer reads when the variance is investigated.",
        "reasonHint": "Why this was used instead.",
        "required": "Required",
        "meterLabel": "{issued} issued against {required} required",
        "warnMeaning": "More than {percent}% over the requirement. This still issues and is recorded as a usage variance.",
        "approveMeaning": "More than {percent}% over the requirement. This is refused until somebody with the authority overrides it."
      },
      "genealogy": {
        "title": "Genealogy",
        "description": "Which raw lots went into which finished lots.",
        "treeTitle": "Consumed and produced",
        "loadFailed": "The genealogy did not load",
        "empty": "No genealogy on this order. Nothing lot-tracked was consumed or produced, so there is nothing to link.",
        "noConsumed": "No lot-tracked materials consumed",
        "depthCapReached": "The trace hit its depth limit; some earlier lots may not be shown."
      },
      "calendar": {
        "title": "Work centre calendar",
        "description": "When this centre runs, and how much of the clock is productive.",
        "loadFailed": "The calendar did not load",
        "none": "This work centre has no calendar. Until it has one the finite scheduler treats it as unavailable.",
        "opcalMeaning": "Public holidays come from the legal entity's operating calendar, not from here. The exceptions below are for things true of this centre alone.",
        "factorsTitle": "Factors",
        "factorsMeaning": "Efficiency stretches how long the work takes. Utilisation shrinks how much of the clock is available. They are two dials and the scheduler applies both.",
        "efficiency": "Efficiency %",
        "utilisation": "Utilisation %",
        "parallelCapacity": "Jobs at once",
        "shiftsTitle": "Shifts",
        "shiftsCaption": "Shifts by weekday, in minutes from midnight.",
        "weekday": "Day",
        "shifts": "Shifts",
        "shiftCode": "Shift",
        "start": "Start",
        "end": "End",
        "closed": "Closed",
        "overnight": "Crosses midnight",
        "addShift": "Add shift",
        "saved": "Shifts saved",
        "saveFailed": "The shifts were not saved",
        "exceptionsTitle": "Exceptions",
        "exceptionsCaption": "Days this centre does not follow its usual pattern.",
        "exceptionsMeaning": "Days this centre alone differs: an extra Saturday, a maintenance shutdown, a reduced shift.",
        "exceptionsEmpty": "No exceptions recorded.",
        "exceptionMeaning": {
          "closed": "The centre does not run at all",
          "extra_shift": "An additional window on top of the usual pattern",
          "reduced": "The usual pattern, with less capacity"
        },
        "date": "Date",
        "blockedBy": "Blocked by",
        "exceptionSaved": "Exception recorded",
        "exceptionFailed": "The exception was not recorded"
      },
      "dispatch": {
        "title": "Dispatch list",
        "description": "What this centre does next, in order.",
        "tableTitle": "Dispatch",
        "caption": "Scheduled operations in dispatch order.",
        "loadFailed": "The dispatch list did not load",
        "empty": "Nothing is scheduled at this work centre.",
        "seq": "No",
        "operation": "Operation",
        "start": "Start",
        "end": "End",
        "minutes": "Minutes",
        "frozen": "Started",
        "moveUp": "Move earlier",
        "moveDown": "Move later",
        "save": "Save order",
        "saved": "Dispatch order saved",
        "saveFailed": "The dispatch order was not saved"
      },
      "bottlenecks": {
        "title": "Bottlenecks",
        "description": "Load against capacity, and the centre the plan is actually limited by.",
        "tableTitle": "Work centres",
        "caption": "Work centres with their planned and available minutes.",
        "loadFailed": "The bottleneck report did not load",
        "empty": "No load in this period.",
        "workCenter": "Work centre",
        "planned": "Planned",
        "available": "Available",
        "load": "Load",
        "firstOverloadOn": "First overloaded",
        "constraint": "Constraint",
        "isConstraint": "The constraint",
        "meterLabel": "{planned} planned against {available} available",
        "week": "Week",
        "runnerUp": "Runner-up"
      },
      "schedule": {
        "title": "Scheduling",
        "description": "Finite scheduling runs and what they produced.",
        "runTitle": "Run the scheduler",
        "tableTitle": "Runs",
        "caption": "Scheduling runs with their direction, mode and outcome.",
        "loadFailed": "The scheduling runs did not load",
        "empty": "No scheduling runs yet.",
        "direction": "Direction",
        "directionMeaning": {
          "forward": "From a start date: when does it finish?",
          "backward": "From a due date: when must it start?"
        },
        "mode": "Mode",
        "modeMeaning": {
          "finite": "Respects capacity and queues behind existing load",
          "infinite": "Ignores capacity; the theoretical shape"
        },
        "anchor": "Anchor date",
        "horizon": "Horizon (days)",
        "run": "Run",
        "ran": "Schedule run",
        "runFailed": "The scheduler did not run",
        "runAt": "Run at",
        "ordersScheduled": "Orders",
        "operationsScheduled": "Operations",
        "operationsLate": "Late",
        "persistMeaning": "A run writes scheduled starts and ends onto the operations. It is a document with an author and a time, not a preview."
      },
      "tools": {
        "title": "Tooling",
        "description": "Tools, their remaining life and what they block.",
        "tableTitle": "Tools",
        "caption": "Tools with their work centre, life and service date.",
        "loadFailed": "The tooling register did not load",
        "empty": "No tools registered.",
        "workCenter": "Work centre",
        "life": "Life",
        "lifeLabel": "{used} of {life} cycles used",
        "noLifeLimit": "No life limit",
        "nextService": "Next service",
        "blockingMeaning": "{count} tools are retired or in maintenance. An order whose mandatory tool is one of them cannot be released without an override."
      },
      "planning": {
        "title": "Planning parameters",
        "description": "How MRP is allowed to plan each item.",
        "tableTitle": "Parameters",
        "caption": "Planning parameters with their lot-sizing rule, fences and source policy.",
        "loadFailed": "The planning parameters did not load",
        "empty": "No planning parameters set. Items with none are planned lot-for-lot.",
        "rule": "Lot sizing",
        "ruleMeaning": {
          "lot_for_lot": "Order exactly what is short",
          "fixed_quantity": "Always order the same amount",
          "min_max": "Top up to the maximum once the minimum is breached",
          "period_of_supply": "Group several days of demand into one order",
          "eoq": "Economic order quantity"
        },
        "fixedQuantity": "Fixed quantity",
        "min": "Minimum",
        "max": "Maximum",
        "planningFence": "Planning fence",
        "demandFence": "Demand fence",
        "fenceMeaning": "The planning fence is how far out MRP may create suggestions. The demand fence is how close in new demand is ignored because it is too late to react. Demand inside a fence raises an exception rather than a suggestion.",
        "source": "Source",
        "saved": "Planning parameters saved",
        "saveFailed": "The planning parameters were not saved"
      },
      "mrp": {
        "title": "MRP run #{id}",
        "description": "What the run could not plan, and why.",
        "loadFailed": "The MRP run did not load",
        "exceptionsFirstMeaning": "Exceptions come before suggestions. A run with eleven exceptions has suggestions that are wrong in eleven places, and working the suggestion list top-down finds that out on the eleventh order.",
        "blockingTitle": "Could not be planned",
        "blockingMeaning": "These items cannot be planned at all until the underlying data is fixed.",
        "blockingEmpty": "Nothing was unplannable.",
        "advisoryTitle": "Planned, with a warning",
        "advisoryMeaning": "These were planned and flagged: demand already past due, or inside a fence.",
        "advisoryEmpty": "No warnings.",
        "kind": "Exception",
        "shortfall": "Shortfall",
        "needBy": "Need by",
        "earliest": "Earliest possible",
        "suggestions": "Suggestions"
      },
      "pegging": {
        "title": "Pegging",
        "description": "Why this suggestion exists.",
        "suggestionTitle": "Suggestion",
        "treeTitle": "Demand chain",
        "loadFailed": "The pegging did not load",
        "empty": "This suggestion pegs to no demand — it comes from a safety stock or minimum level rather than from an order.",
        "suggestedQuantity": "Suggested",
        "netRequirement": "Net requirement",
        "releaseBy": "Release by",
        "level": "Level {level}"
      },
      "settlement": {
        "title": "Settlement preview",
        "description": "What this order would settle to, and everything stopping it.",
        "loadFailed": "The settlement preview did not load",
        "previewMeaning": "A preview writes no journal. Closing the order is what posts, and a posted settlement supersedes every preview before it.",
        "backToOrder": "Back to the order",
        "blockersTitle": "Blockers",
        "blockersMeaning": "Every reason this order cannot close, at once.",
        "noBlockers": "Nothing is stopping this order from closing.",
        "quantitiesTitle": "Quantities",
        "planned": "Planned",
        "completed": "Completed",
        "scrapped": "Scrapped",
        "wipBefore": "WIP balance",
        "shortCloseMeaning": "This order is {qty} short of what was planned. Closing it needs a decision about where the residual goes.",
        "variancesTitle": "Variances",
        "variancesCaption": "The variances this settlement would post.",
        "varianceType": "Variance",
        "varianceMeaning": "Yield and usage measure different things and neither includes the other: usage is material consumed against material required; yield is output produced against output expected from what was started.",
        "residual": "Residual",
        "residualMeaning": "What is left of work in progress once the variances have absorbed what they explain. Computed with them, not from them.",
        "close": "Close the order",
        "closeMeaning": "Closing posts. It is not the same authority as computing this preview.",
        "historyTitle": "Settlement history",
        "historyCaption": "Previews and postings for this order.",
        "computedAt": "Computed",
        "disposition": "Disposition"
      },
      "shortClose": {
        "title": "Close the order",
        "description": "Where the residual goes.",
        "notShort": "This order made what was planned. Closing it posts the variances and clears work in progress.",
        "shortMeaning": "{qty} short of what was planned.",
        "disposition": "Residual disposition",
        "writeOffMeaning": "The rest is never going to be made. The residual goes to the overhead variance account and stays in this period.",
        "reallocateMeaning": "The good output genuinely bore the cost. The finished-goods receipt is reversed and re-posted at actual.",
        "carryMeaning": "The rest runs on a follow-on order, and the cost goes with it.",
        "carryToOrder": "Carry to order",
        "carryToOrderHint": "The follow-on order that will make the rest. It cannot be closed, cancelled, or this order.",
        "reason": "Why it is short",
        "reasonHint": "Kept permanently; an auditor reads this and the override reason separately.",
        "overrideLabel": "Override the short-close control",
        "overrideMeaning": "Recorded as an override with your name against it.",
        "confirm": "Close the order",
        "closed": "Order closed",
        "closeFailed": "The order was not closed",
        "overrideReason": "Override reason"
      },
      "rollup": {
        "title": "Standard cost roll-ups",
        "description": "Recomputed standards, sorted by how much they moved.",
        "tableTitle": "Roll-ups",
        "caption": "Roll-up drafts with their previous and new cost.",
        "loadFailed": "The roll-ups did not load",
        "empty": "No roll-ups. Computing one produces a draft per item; nothing changes until a draft is applied.",
        "scopeMeaning": "A roll-up over a whole legal entity rolls every item with an active bill, children before parents, so a parent reads its children's fresh drafts rather than their stale standards.",
        "computeTitle": "Compute drafts",
        "basis": "Component basis",
        "basisMeaning": {
          "standard": "Each component's own standard cost, or its draft from this batch",
          "moving_average": "Each component's moving average; an unstocked item contributes an honest zero"
        },
        "effectiveDate": "Effective date",
        "compute": "Compute",
        "computed": "Drafts computed",
        "computeFailed": "The roll-up did not run",
        "select": "Select draft",
        "previousCost": "Previous",
        "newCost": "New",
        "change": "Change %",
        "material": "Material",
        "labor": "Labour",
        "overhead": "Overhead",
        "subcontract": "Subcontract",
        "byProductCredit": "By-product credit",
        "total": "Total",
        "breakdown": "Breakdown",
        "apply": "Apply {count} drafts",
        "applyMeaning": "Applying makes these the standards every future variance is measured against. It does not revalue stock and does not touch a released order's snapshotted standard.",
        "applied": "Drafts applied",
        "applyFailed": "The drafts were not applied",
        "detailTitle": "Roll-up for {item}",
        "detailDescription": "Effective {date}",
        "summaryTitle": "Summary",
        "yield": "Yield %",
        "yieldMeaning": "The total is divided by yield, so a bill that loses 5% in process carries that loss in the standard rather than in every order's variance.",
        "levels": "Levels exploded",
        "linesTitle": "Components",
        "linesCaption": "Each component's quantity, unit cost and where that cost came from.",
        "linesEmpty": "No component lines on this roll-up.",
        "seq": "No",
        "element": "Element",
        "quantityPer": "Quantity per",
        "unitCost": "Unit cost",
        "extendedCost": "Extended",
        "source": "Cost source",
        "level": "Level",
        "noRevalueMeaning": "A roll-up does not revalue stock and does not restate a released order's standard. What is running is still measured against what it was released at.",
        "backToBoard": "Back to the roll-up board"
      },
      "variance": {
        "title": "Variance analysis",
        "description": "Where production cost differed from standard, by type.",
        "tableTitle": "By variance type",
        "caption": "Variance totals by type with their posting account.",
        "loadFailed": "The variance analysis did not load",
        "empty": "No variances in this period.",
        "typesMeaning": "The old `overhead` type is still here: every pre-C7 order's residual was written as overhead, permanently, and dropping it would show a legal entity's history as smaller than it was.",
        "orderCount": "Orders",
        "total": "Total",
        "account": "Account",
        "posted": "Posted"
      },
      "lotRelation": {
        "repack": "Repack",
        "split": "Split",
        "merge": "Merge",
        "transform": "Transform",
        "production": "Production",
        "rework": "Rework"
      }
    }
  },
  "attention": {
    "title": "Needs your attention",
    "description": "Approvals, exceptions, tasks and alerts assigned to you, ranked by consequence.",
    "loadFailed": "Your attention list could not be loaded",
    "emptyTitle": "Nothing needs your attention",
    "emptyDescription": "Approvals still arrive in the inbox and notifications still reach the bell — this list is a view over both, so an empty one means there is nothing waiting.",
    "filteredEmptyTitle": "Nothing matches these filters",
    "filteredEmptyDescription": "Clear them to see everything assigned to you.",
    "routeTitles": {
      "list": "Attention",
      "policies": "Notification policies"
    },
    "kinds": {
      "approval": "Approval",
      "exception": "Exception",
      "task": "Task",
      "alert": "Alert"
    },
    "filters": {
      "kind": "Kind",
      "module": "Module",
      "overdueOnly": "Overdue only",
      "total": "{count} open",
      "overdue": "{count} overdue",
      "severity": "Severity"
    },
    "item": {
      "untitled": "Untitled item",
      "age": "Opened {days} day(s) ago",
      "overdue": "Overdue by {hours}h",
      "escalated": "Escalated",
      "priorityHelp": "Rank, computed by the server. Lower is more urgent.",
      "acknowledge": "Acknowledge",
      "acknowledged": "Acknowledged",
      "acknowledgedToast": "Alert acknowledged",
      "acknowledgeFailed": "The alert could not be acknowledged",
      "resolve": "Resolve",
      "resolved": "Item resolved",
      "resolveTitle": "Resolve this item",
      "resolveDescription": "It leaves your list. The underlying record is untouched, and the code and outcome are recorded.",
      "resolveCode": "Resolution",
      "resolveCodePlaceholder": "Choose how it was resolved",
      "resolveOutcome": "Outcome",
      "resolveOutcomeRequired": "Required: say what was done or why nothing was needed.",
      "resolveOutcomeOptional": "Optional for a dismissal, and recorded.",
      "recommendedAction": "Recommended action"
    },
    "policy": {
      "title": "Notification policies",
      "description": "Which channel each kind of event uses, how often, and when silence becomes an escalation.",
      "explain": "The event kind is the outbox topic the software publishes under. A policy for a topic nothing publishes is inert — it will not error, it will simply never apply.",
      "eventKind": "Event kind",
      "eventKindHint": "An outbox topic, or * for the default that governs everything else.",
      "default": "Default (*)",
      "channels": "Channels",
      "channelsHint": "At least one. In-app writes to the attention list; email sends.",
      "channelNames": {
        "inapp": "In-app",
        "email": "Email"
      },
      "digest": "Delivery",
      "digestHint": "Immediate for things somebody must act on now; digested for the rest.",
      "digests": {
        "immediate": "Immediately",
        "hourly": "Hourly digest",
        "daily": "Daily digest"
      },
      "digestHints": {
        "immediate": "Sent as it happens.",
        "hourly": "Collected and sent once an hour.",
        "daily": "Collected and sent once a day."
      },
      "escalate": "Escalate after",
      "escalateHint": "Hours of silence before a watcher is added. 0 never escalates.",
      "afterHours": "{hours}h",
      "never": "Never",
      "suppress": "Suppress repeats",
      "suppressHint": "Minutes for which the same thing is not announced twice. 0 announces every time.",
      "forMinutes": "{minutes} min",
      "noSuppression": "None",
      "isActive": "Active",
      "create": "New policy",
      "editTitle": "Notification policy",
      "editDescription": "Applies to every recipient of this event kind in the tenant.",
      "saved": "Policy saved",
      "saveFailed": "The policy could not be saved",
      "tableLabel": "Notification policies",
      "emptyTitle": "No policies configured",
      "emptyDescription": "Without one, every event is delivered immediately to both channels. Add a default (*) to change that.",
      "loadFailed": "Notification policies could not be loaded"
    },
    "budget": {
      "thresholdBreached": "{costCenterCode} {costCenterName} has used {consumptionPct}% of its {fiscalYear} budget (alert at {thresholdPct}%). Projected overspend {projectedOverspend}, {monthsRemaining} month(s) remaining"
    },
    "sales": {
      "subscriptionOverdue": "Subscription {subscriptionNo} was due for billing on {nextBillingDate} and has not been billed"
    },
    "projects": {
      "chargeabilityOverrideDue": "Project {projectCode} — {projectName}'s chargeability override lapses on {validTo}"
    },
    "severity": {
      "info": "Info",
      "warning": "Warning",
      "critical": "Critical"
    },
    "resolution": {
      "action_taken": "Action taken",
      "false_positive": "False positive",
      "no_action_needed": "No action needed",
      "duplicate": "Duplicate",
      "dismissed": "Dismissed"
    },
    "treasury": {
      "liquidityBreach": {
        "title": "Liquidity below threshold for {companyCode} on {positionDate}",
        "explanation": "Available liquidity is {availableLiquidity} {currency} (net cash {netCash}, deductions {totalDeductions}), below the threshold set for this legal entity.",
        "action": "Review the position, then arrange funding or defer outflows. The alert closes itself when a published position is back above the threshold."
      },
      "shortfallPredicted": {
        "title": "{currency} cash shortfall predicted on {firstBreachOn}",
        "explanation": "The forecast falls {firstBreachShortfall} {currency} short of the declared minimum {declaredMinimum} in {leadDays} day(s). The deepest shortfall is {deepestShortfall}; {residualShortfall} remains after {actionCount} funding action(s).",
        "action": "Open the forecast and approve the proposed funding actions before the first breach date."
      },
      "reconException": {
        "title": "Reconciliation exception {exceptionNo}: {amount} {currency}",
        "explanation": "An unresolved {kind} item dated {itemDate} has been open for {ageDays} day(s) (escalation level {escalationLevel}).",
        "action": "Match, write off or explain the item in the reconciliation session."
      },
      "fundsInTransitAged": {
        "title": "Funds in transit {reference} are aged",
        "explanation": "{amount} {currency} has been in transit for {ageDays} day(s) without confirmation.",
        "action": "Confirm receipt with the bank, then confirm or recall the instruction."
      },
      "walletIdle": {
        "title": "Wallet {walletCode} is holding idle cash",
        "explanation": "{floatBalance} {currency} has sat unused for {idleDays} day(s), beyond the {inactivityPeriodDays}-day period; {recoverable} {currency} is recoverable above the operating minimum.",
        "action": "Recover the surplus to the cash book, or confirm that the wallet is still needed."
      },
      "statementGap": {
        "title": "Bank statement gap ({kind})",
        "explanation": "No statement covers {fromDate} to {toDate} for this bank account. {detail}",
        "action": "Fetch or import the missing statement so reconciliation can continue."
      },
      "covenantBreach": {
        "title": "Covenant {covenantCode} breached on facility {facilityCode}",
        "explanation": "{covenantName}: {metricKey} was {actualValue} on {testDate} against a required {operator} {threshold}. The facility may be in default.",
        "action": "Escalate to the CFO and contact the lender about a waiver or a remedy."
      },
      "connectionFailed": {
        "title": "Bank connection {name} failed",
        "explanation": "The {channel} connection failed {consecutiveFailures} time(s) in a row while it was {source}: {detail}",
        "action": "Check the credentials and the bank availability, then test the connection again."
      }
    }
  },
  "authority": {
    "nav": {
      "label": "Authority sections",
      "matrix": "Matrix",
      "delegations": "Delegations",
      "absences": "Absences",
      "materiality": "Materiality"
    },
    "routeTitles": {
      "matrix": "Authority matrix",
      "version": "Matrix version",
      "delegations": "Delegations",
      "absences": "Absences",
      "materiality": "Materiality thresholds"
    },
    "modes": {
      "sequential": "Sequential",
      "parallel_any": "Any one of"
    },
    "modeHints": {
      "sequential": "Each approver in turn; the next is asked only after the previous signs.",
      "parallel_any": "Everyone is asked at once; the first to sign completes the step."
    },
    "sources": {
      "position": "A named position",
      "job": "Any position of a job",
      "grade": "Any position at or above a grade",
      "relative": "Walk the reporting line",
      "role": "A role",
      "user": "A named user"
    },
    "sourceHints": {
      "position": "One post. The safest and the least flexible.",
      "job": "Any post doing this job, within the rule's scope.",
      "grade": "Any post at or above this seniority, within the rule's scope.",
      "relative": "Resolves by walking up from the submitter or the raising position.",
      "role": "Not available on a matrix rule — roles live on approval policies.",
      "user": "Not available on a matrix rule — a named person goes stale."
    },
    "relative": {
      "submitter_manager": "The submitter's manager",
      "position_parent": "The raising position's parent"
    },
    "scopes": {
      "global": "Everywhere",
      "company": "Legal Entity",
      "branch": "Branch",
      "department": "Department",
      "cost_center": "Cost centre",
      "business_unit": "Business unit",
      "division": "Division",
      "location": "Location"
    },
    "validation": {
      "title": "Validation",
      "kinds": {
        "gap": "Gap",
        "overlap": "Overlap",
        "unreachable": "Unreachable rule",
        "vacant_position": "Vacant position",
        "cycle": "Cycle",
        "no_steps": "No steps",
        "invalid_step": "Invalid step",
        "unresolvable": "Cannot resolve"
      }
    },
    "version": {
      "title": "Authority matrix",
      "description": "Who may approve what, at which value band, in which part of the organisation — versioned, because a document approved last March was approved under last March's rules.",
      "detailDescription": "Rules, their chains, and what they would actually do.",
      "code": "Version",
      "name": "Name",
      "rules": "Rules",
      "ruleCount": "{count} rule(s)",
      "inForce": "In force",
      "inForceFrom": "In force from {date}",
      "notInForce": "Not in force",
      "dualControl": "Dual control",
      "submittedBy": "Proposed by #{id}",
      "activatedBy": "Activated by #{id}",
      "notSubmitted": "Not yet proposed",
      "create": "New version",
      "createTitle": "New matrix version",
      "createDescription": "Start empty, or clone an existing version and change what moved.",
      "cloneFrom": "Clone from",
      "cloneHint": "Next year's matrix is usually this year's with three bands moved.",
      "startEmpty": "Start empty",
      "created": "Version created",
      "createFailed": "The version could not be created",
      "submit": "Propose",
      "submitTitle": "Propose this version",
      "submitDescription": "Proposing records who wrote these rules, so that somebody else has to put them in force.",
      "submitExplain": "You will not be able to activate this version yourself — that is what dual control means here.",
      "submitFirst": "Propose the version before it can be activated. Dual control needs a proposer and a different activator.",
      "submitted": "Version proposed",
      "submitFailed": "The version could not be proposed",
      "activate": "Activate",
      "activateTitle": "Put this version in force",
      "activateDescription": "From the date you give, every document submitted resolves its approvers through these rules.",
      "activateConsequence": "This changes who may approve what across the tenant. The version that is currently in force is superseded and cannot be edited again.",
      "activateWithErrors": "{count} validation error(s) are outstanding. Activating over a vacant position or an unreachable rule is how an approval lands in a queue nobody holds.",
      "effectiveFrom": "In force from",
      "activated": "Version activated",
      "activateFailed": "The version could not be activated",
      "dualControlBlocked": "You proposed this version, so you may not activate it. Somebody else with the activation permission has to.",
      "backToList": "All versions",
      "tableLabel": "Matrix versions",
      "emptyTitle": "No matrix versions",
      "emptyDescription": "Approvals currently route through approval policies, which continue to work. Create a version when you want bands, scopes and positions instead.",
      "loadFailed": "The matrix could not be loaded",
      "statuses": {
        "draft": "Draft",
        "active": "In force",
        "superseded": "Superseded"
      }
    },
    "rule": {
      "title": "Rules",
      "description": "Ordered by specificity — the order the resolver applies them in, so the row that wins is above the rows that do not.",
      "docType": "Document type",
      "docTypeHint": "The dotted type the module submits, e.g. ap.invoice.",
      "scope": "Scope",
      "scopeId": "Scope id",
      "scopeIdHint": "The id of the legal entity, branch, department, division or location this rule narrows to.",
      "company": "Legal Entity",
      "anyCompany": "Any legal entity",
      "category": "Category",
      "categoryHint": "An optional sub-classification the submitting module passes, e.g. capital.",
      "currency": "Currency",
      "currencyHint": "Leave empty to match any currency.",
      "from": "From",
      "to": "To",
      "toHint": "Leave empty for no upper limit — the band that catches everything above.",
      "unbounded": "No upper limit",
      "priority": "Priority",
      "priorityHint": "Breaks ties between rules of equal specificity. Higher wins.",
      "specificity": "Specificity",
      "chain": "Chain",
      "stepCount": "{count} step(s)",
      "noSteps": "No steps",
      "preview": "Preview",
      "create": "New rule",
      "createTitle": "New authority rule",
      "editTitle": "Edit authority rule",
      "editorDescription": "The header decides which documents match; the steps decide who signs.",
      "remove": "Delete",
      "removeTitle": "Delete this rule",
      "removeConsequence": "Only a draft version can be edited, so this removes the rule from the draft. Versions already in force are untouched.",
      "removed": "Rule deleted",
      "removeFailed": "The rule could not be deleted",
      "saved": "Rule saved",
      "saveFailed": "The rule could not be saved",
      "tableCaption": "Authority rules in this version, most specific first",
      "emptyTitle": "No rules in this version",
      "emptyDescription": "Add a rule for a document type, then give it a chain. Until then, documents fall through to approval policies."
    },
    "step": {
      "title": "Chain",
      "add": "Add step",
      "remove": "Remove step",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "name": "Step name",
      "mode": "Mode",
      "source": "Approver",
      "sourceHint": "A step carries exactly one source. Choosing one clears the others.",
      "sourceMissing": "Choose how this step resolves its approver.",
      "jobHint": "Any position of this job, inside the rule's scope.",
      "gradeHint": "Any position at or above this grade level, inside the rule's scope.",
      "gradeLevel": "Level {level}",
      "relativeTo": "Walk from",
      "relativeLevels": "Levels up",
      "relativeLevelsHint": "1 is the manager, 2 the manager's manager.",
      "sla": "SLA hours",
      "slaHint": "Hours before the step is overdue. 0 means no deadline.",
      "escalateTo": "Escalate to",
      "escalateHint": "A position, not a person — an escalation target who moves job is a dead end.",
      "noEscalation": "No escalation",
      "allowSelfApproval": "Allow self-approval",
      "allowSelfApprovalHint": "Off by default. Turning it on is audited on the rule, and only some document types permit it.",
      "emptyChain": "This rule has no steps, so it cannot route anything. Add at least one."
    },
    "preview": {
      "title": "Resolved chain",
      "description": "What this rule would actually do — who is asked, in what order, and who loses.",
      "emptyTitle": "Choose a rule",
      "emptyDescription": "Select a rule to see the chain it produces, with the people it resolves to.",
      "failedTitle": "The chain could not be resolved",
      "failedDescription": "The preview call failed. Nothing has changed; try again.",
      "noMatch": "No matrix rule matched",
      "fallbackExplain": "Nothing in the matrix matched, so this document would route through approval policies — which is the pre-C1 behaviour and is not an error.",
      "sources": {
        "matrix": "Matrix",
        "policy": "Approval policy"
      },
      "rule": "Rule #{id}",
      "specificity": "Specificity {value}",
      "on": "As at {date}",
      "sla": "{hours}h SLA",
      "unnamedStep": "Step",
      "noHolders": "Resolves to nobody.",
      "unresolved": "{count} step(s) resolve to nobody. A document routed into one stops there.",
      "noStepsTitle": "No steps",
      "noStepsDescription": "The matched rule has no chain, so nothing would be asked of anybody.",
      "rejectedTitle": "Rules that did not win",
      "candidatesTitle": "Candidates considered"
    },
    "whatIf": {
      "title": "Try a document",
      "description": "Resolve the selected rule against a real amount, legal entity and date.",
      "amount": "Amount",
      "amountHint": "The document total the band is matched against.",
      "currency": "Currency",
      "company": "Legal Entity",
      "on": "On",
      "run": "Resolve",
      "chooseRule": "Select a rule above to resolve it."
    },
    "delegation": {
      "title": "Delegations",
      "description": "Handing one position's approval authority to another, for a window and within a limit.",
      "from": "From position",
      "to": "To position",
      "toEmployee": "Employee #{id}",
      "delegator": "Delegator",
      "scope": "Document type",
      "scopeHint": "Leave empty to delegate every document type this position approves.",
      "allDocTypes": "All document types",
      "limit": "Limit",
      "limitHint": "Cannot exceed the delegator's own ceiling — the server refuses.",
      "noLimit": "No extra limit",
      "toDateHint": "Both ends are required. An open-ended delegation is a matrix change made without dual control.",
      "reason": "Reason",
      "create": "New delegation",
      "createTitle": "Delegate authority",
      "createDescription": "The delegate approves in their own name; the record says on whose authority.",
      "created": "Delegation created",
      "createFailed": "The delegation could not be created",
      "exceeds": "This exceeds the delegating position's own authority. A delegation can narrow authority, never widen it.",
      "revokeTitle": "Revoke this delegation",
      "revokeConsequence": "Tasks already acted on stay as they are. Anything still open returns to the delegating position.",
      "revokeReason": "Reason for revoking",
      "revoked": "Delegation revoked",
      "tableLabel": "Delegations",
      "emptyTitle": "No delegations",
      "emptyDescription": "Delegate when an approver will be away and their queue must not stall.",
      "loadFailed": "Delegations could not be loaded",
      "statuses": {
        "active": "Active",
        "revoked": "Revoked",
        "expired": "Expired"
      }
    },
    "absence": {
      "title": "Absences",
      "description": "Where approvals go while somebody is away.",
      "employee": "Employee",
      "kind": "Kind",
      "source": "Source",
      "reassignTo": "Reassign to",
      "reassignHint": "Leave empty to let tasks fall through to the reporting line.",
      "fallsThrough": "Falls through to the line",
      "create": "Record an absence",
      "createTitle": "Record an absence",
      "createDescription": "For absences no leave request covers, or to name where the work should go.",
      "created": "Absence recorded",
      "createFailed": "The absence could not be recorded",
      "cancelTitle": "Cancel this absence",
      "cancelConfirm": "Cancel absence",
      "cancelConsequence": "Approvals stop being reassigned from the moment this is cancelled. Tasks already reassigned stay where they went.",
      "cancelled": "Absence cancelled",
      "tableLabel": "Absences",
      "emptyTitle": "Nobody recorded as absent",
      "emptyDescription": "Approved leave creates rows here automatically. Add one for an absence leave does not cover.",
      "loadFailed": "Absences could not be loaded",
      "kinds": {
        "leave": "Leave",
        "travel": "Travel",
        "suspension": "Suspension",
        "other": "Other"
      },
      "sources": {
        "manual": "Entered by hand",
        "hr_leave": "From approved leave"
      }
    },
    "materiality": {
      "title": "Materiality thresholds",
      "description": "When an amendment is big enough that the approvals given no longer stand.",
      "explain": "A purchase order approved at MVR 100,000 and amended to MVR 400,000 has not been approved — it has been approved for a different thing. These thresholds decide where that line falls.",
      "docType": "Document type",
      "pct": "Percent",
      "pctHint": "Change against the approved value, as a percentage.",
      "abs": "Absolute",
      "absHint": "Change in currency, whichever bites first.",
      "band": "Band crossing",
      "bandOn": "Always material",
      "bandOff": "Not on its own",
      "bandLabel": "A band crossing is always material",
      "bandHint": "A small change can still move the document into a band with a different approver. The thresholds cannot express that case, so it is its own switch.",
      "fields": "Material fields",
      "fieldsHint": "Comma-separated field names whose change is material regardless of amount, e.g. vendorId, currency.",
      "amountOnly": "Amount only",
      "isActive": "Active",
      "create": "New threshold",
      "editTitle": "Materiality threshold",
      "editDescription": "Set per document type, optionally per legal entity.",
      "saved": "Threshold saved",
      "saveFailed": "The threshold could not be saved",
      "tableLabel": "Materiality policies",
      "emptyTitle": "No thresholds set",
      "emptyDescription": "Without one, an amendment does not void an approval chain. Set thresholds for the document types where that matters.",
      "loadFailed": "Materiality thresholds could not be loaded"
    },
    "queue": {
      "unratified": {
        "summary": "An emergency approval is waiting to be ratified."
      }
    }
  },
  "opcal": {
    "nav": {
      "label": "Operating calendar sections",
      "board": "Day board",
      "calendars": "Calendars"
    },
    "routeTitles": {
      "board": "Business day board",
      "calendars": "Operating calendars",
      "calendar": "Operating calendar"
    },
    "weekdays": {
      "mon": "Monday",
      "tue": "Tuesday",
      "wed": "Wednesday",
      "thu": "Thursday",
      "fri": "Friday",
      "sat": "Saturday",
      "sun": "Sunday"
    },
    "weekdayInitials": {
      "mon": "M",
      "tue": "T",
      "wed": "W",
      "thu": "T",
      "fri": "F",
      "sat": "S",
      "sun": "S"
    },
    "unitTypes": {
      "company": "Legal Entity",
      "branch": "Branch",
      "location": "Location"
    },
    "dayStatuses": {
      "scheduled": "Scheduled",
      "open": "Open",
      "closing": "Closing",
      "closed": "Closed",
      "reopened": "Reopened"
    },
    "moduleStatuses": {
      "pending": "Not checked",
      "ready": "Ready",
      "blocked": "Blocked",
      "complete": "Complete"
    },
    "holidayKinds": {
      "public": "Public",
      "religious": "Religious",
      "company": "Legal Entity",
      "closure": "Closure"
    },
    "board": {
      "title": "Business day board",
      "description": "Which operating units have opened and closed today, and what is holding the rest up.",
      "on": "Business date",
      "noDay": "No day opened",
      "notOpened": "{count} unit(s) have not opened a day. Nothing is wrong with them — but nobody has started one either.",
      "stillOpen": "{count} unit(s) are still open.",
      "forced": "Closed with blockers outstanding ({code}).",
      "emptyTitle": "No operating units",
      "emptyDescription": "The board lists the units a calendar is scoped to. Scope a calendar to a legal entity, branch or location to see it here.",
      "loadFailed": "The board could not be loaded"
    },
    "day": {
      "open": "Open day",
      "opened": "Business day opened",
      "openFailed": "The day could not be opened",
      "close": "Close day",
      "closeTitle": "Close the business day",
      "closeSubject": "Business date {date}",
      "closed": "Business day closed",
      "recheck": "Check again",
      "allReady": "Every module reports it is ready.",
      "blocked": "{count} module(s) are not ready.",
      "blockingCount": "{count} outstanding",
      "forceToggle": "Close anyway with a reason",
      "forceClose": "Force close",
      "forceReason": "Reason for forcing",
      "forceConsequence": "Forcing closes the day with work outstanding. It is recorded, it opens a reconciliation queue item, and somebody has to come back to it.",
      "reopen": "Reopen",
      "reopenTitle": "Reopen a closed day",
      "reopenReason": "Reason for reopening",
      "reopenConsequence": "Reopening a closed day reopens a record somebody already certified. It needs a second factor and a written reason.",
      "reopened": "Business day reopened"
    },
    "calendar": {
      "title": "Operating calendars",
      "description": "The working week, holidays and shifts an operating unit runs on. A head office and a resort front desk are not the same calendar.",
      "detailDescription": "Working week, holidays, day parts and shifts.",
      "code": "Code",
      "name": "Name",
      "timezone": "Timezone",
      "timezoneHint": "IANA name, e.g. Indian/Maldives.",
      "dayStart": "Day starts at",
      "dayStartHint": "When this unit's trading day begins. A bar that closes at 02:00 does not start a new day at midnight.",
      "workingDays": "Working days",
      "workingDaysHint": "Business-day arithmetic, leave accrual and value dating all read this.",
      "noWorkingDay": "A calendar must have at least one working day.",
      "weekTitle": "Working week",
      "isDefault": "Default for this legal entity",
      "default": "Default",
      "isActive": "Active",
      "active": "Active",
      "inactive": "Inactive",
      "create": "New calendar",
      "createTitle": "New operating calendar",
      "createDescription": "Starts on a Monday-to-Friday week; adjust it once created.",
      "createHint": "The working week, holidays and shifts are edited on the calendar itself.",
      "created": "Calendar created",
      "saved": "Calendar saved",
      "saveFailed": "The calendar could not be saved",
      "backToList": "All calendars",
      "tabsLabel": "Calendar sections",
      "tabs": {
        "week": "Working week",
        "holidays": "Holidays",
        "dayParts": "Day parts",
        "shifts": "Shifts"
      },
      "probeTitle": "Check a date",
      "probeFrom": "From",
      "probeDays": "Add business days",
      "probeResult": "Next business day {next}; adding the days above lands on {end}, counting {count} business day(s).",
      "isBusinessDay": "A working day",
      "notBusinessDay": "Not a working day",
      "tableLabel": "Operating calendars",
      "emptyTitle": "No calendars yet",
      "emptyDescription": "Create one per operating pattern — one for head office, one for the units that trade seven days.",
      "loadFailed": "Calendars could not be loaded"
    },
    "holiday": {
      "title": "Holidays",
      "description": "Public, religious and company holidays, and whether the unit trades through them.",
      "date": "Date",
      "name": "Name",
      "kind": "Kind",
      "from": "From",
      "to": "To",
      "trading": "Trading",
      "trades": "Trades",
      "halfDay": "Half day",
      "closed": "Closed",
      "source": "Source",
      "isWorkingDay": "The unit trades on this day",
      "isWorkingDayHint": "A public holiday a resort trades through is still a public holiday — it changes pay, not opening.",
      "isHalfDay": "Half day",
      "create": "Add holiday",
      "createTitle": "Add a holiday",
      "createDescription": "One date, one calendar.",
      "saved": "Holiday saved",
      "remove": "Remove",
      "removed": "Holiday removed",
      "removeFailed": "The holiday could not be removed",
      "import": "Import CSV",
      "importTitle": "Import a year of holidays",
      "importDescription": "A year's public holidays arrive as a gazette, not as twelve form submissions.",
      "year": "Year",
      "csv": "CSV",
      "csvHint": "One row per holiday: date,name,kind. Re-running skips dates already present.",
      "importResult": "{imported} imported, {skipped} already present.",
      "tableCaption": "Holidays on this calendar",
      "empty": "No holidays on this calendar."
    },
    "dayPart": {
      "title": "Day parts",
      "description": "The named slices of a trading day. Point of sale and property management report against these.",
      "code": "Code",
      "name": "Name",
      "start": "Starts",
      "end": "Ends",
      "crossesMidnight": "Crosses midnight",
      "add": "Add day part",
      "saved": "Day parts saved",
      "tableCaption": "Day parts on this calendar",
      "empty": "No day parts defined."
    },
    "shift": {
      "title": "Shifts",
      "description": "Working patterns this calendar offers. Rostering consumes them; C1 defines them.",
      "code": "Code",
      "name": "Name",
      "start": "Starts",
      "duration": "Minutes",
      "break": "Break",
      "paid": "Paid",
      "dayPart": "Day part",
      "add": "Add shift",
      "saved": "Shifts saved",
      "tableCaption": "Shifts on this calendar",
      "empty": "No shifts defined."
    }
  },
  "rules": {
    "nav": {
      "label": "Control sections",
      "controls": "Control rules",
      "reasons": "Reason codes",
      "overrides": "Overrides",
      "queues": "Queues"
    },
    "routeTitles": {
      "controls": "Control rules",
      "reasons": "Reason codes",
      "overrides": "Override report",
      "queues": "Reconciliation queues",
      "queueItems": "Queue items"
    },
    "classifications": {
      "absolute": "Absolute",
      "overridable": "Overridable"
    },
    "classificationHints": {
      "absolute": "Never passed, by anybody.",
      "overridable": "May be passed with a governed reason by somebody who holds the authority."
    },
    "severities": {
      "block": "Blocks",
      "warn": "Warns"
    },
    "severityHints": {
      "block": "The action is refused.",
      "warn": "The action proceeds and a warning is recorded."
    },
    "control": {
      "title": "Control rules",
      "description": "The validations that stand between a document and the ledger, and which of them a reason code can pass.",
      "explain": "A control rule is code: it lives where the validation lives and a tenant cannot invent one. What is configurable is whether an overridable rule is on, and whether a warning is tightened into a block.",
      "code": "Rule",
      "module": "Module",
      "classification": "Classification",
      "severity": "Severity",
      "registrySeverity": "Registry default",
      "severityHint": "A warning can be tightened into a block. A block can never be loosened into a warning.",
      "reasonSet": "Reason set",
      "noReasonSet": "None",
      "queue": "Queue",
      "enabled": "Enabled",
      "enabledHint": "Turning an overridable rule off stops it blocking anything. Absolute rules cannot be turned off.",
      "enabledOnly": "Enabled only",
      "on": "On",
      "off": "Off",
      "alwaysOn": "Always on",
      "tightened": "Tightened by this tenant",
      "orphaned": "Orphaned",
      "orphanNotice": "{count} rule(s) no longer exist in the software's registry. They are kept, not deleted, because override records still name them.",
      "configure": "Configure",
      "configureTitle": "Configure a control rule",
      "absoluteRefusal": "This rule is absolute and offers no override to any principal — including a tenant administrator and support. The attempt has been recorded.",
      "saved": "Control rule updated",
      "tableLabel": "Control rules",
      "emptyTitle": "No control rules",
      "emptyDescription": "Rules are projected from the software's registry when a tenant is provisioned or upgraded. An empty list means the projection has not been run.",
      "loadFailed": "Control rules could not be loaded"
    },
    "reason": {
      "label": "Reason",
      "placeholder": "Choose a reason",
      "hint": "Recorded against the exception so it can be counted, not just read.",
      "noteLabel": "Note",
      "noteRequired": "This reason needs a note.",
      "noteOptional": "Optional.",
      "noteRequiredHint": "Requires a note",
      "attachmentRequired": "This reason expects supporting evidence to be attached to the document.",
      "loadFailed": "The reasons for this rule could not be loaded, so no reason can be chosen.",
      "org": {
        "period": {
          "reopen": {
            "correcting_entry": "Correcting entry",
            "late_supplier_invoice": "Late supplier invoice",
            "audit_adjustment": "Audit adjustment",
            "other": "Other"
          }
        },
        "address": {
          "waiver": {
            "rural_no_formal_address": "No formal address at this location",
            "pending_geo_registration": "Awaiting registration of the place",
            "other": "Other"
          }
        },
        "position": {
          "headcount": {
            "temporary_overlap_handover": "Temporary overlap during handover",
            "urgent_backfill": "Urgent backfill",
            "restructure_in_progress": "Restructure in progress"
          }
        }
      },
      "authority": {
        "self_approval": {
          "sole_authorised_signatory": "Sole authorised signatory",
          "emergency_cover": "Emergency cover"
        },
        "emergency": {
          "approver_unreachable": "Approver unreachable",
          "operational_deadline": "Operational deadline",
          "system_outage": "System outage"
        },
        "delegation": {
          "annual_leave": "Annual leave",
          "business_travel": "Business travel",
          "medical_leave": "Medical leave",
          "secondment": "Secondment",
          "workload_cover": "Workload cover",
          "revoked_no_longer_needed": "No longer needed"
        }
      },
      "procurement": {
        "po": {
          "amendment": {
            "price_change": "Price change",
            "quantity_change": "Quantity change",
            "supplier_substitution": "Supplier substitution",
            "specification_change": "Specification change"
          }
        }
      },
      "opcal": {
        "day": {
          "force_close": {
            "reconciled_offline": "Reconciled offline",
            "system_downtime": "System downtime",
            "immaterial_variance": "Immaterial variance"
          },
          "reopen": {
            "missed_transaction": "Missed transaction",
            "correction": "Correction"
          }
        }
      },
      "fx": {
        "rate": {
          "hold": {
            "market_volatility_confirmed": "Market volatility confirmed",
            "central_bank_devaluation": "Central bank devaluation",
            "provider_correction": "Provider correction"
          }
        }
      },
      "gl": {
        "dimension": {
          "shared_cost_unallocated": "Shared cost, not yet allocated",
          "pending_division_setup": "Division not yet set up"
        }
      }
    },
    "reasonCode": {
      "title": "Reason codes",
      "description": "The governed vocabulary every exception in this system is recorded against.",
      "set": "Reason set",
      "code": "Code",
      "label": "Label",
      "requires": "Requires",
      "note": "Note",
      "attachment": "Attachment",
      "requiresNote": "Requires a note",
      "requiresNoteHint": "For reasons that mean nothing without the specifics.",
      "requiresAttachment": "Requires an attachment",
      "requiresAttachmentHint": "For reasons that rest on a document somebody else wrote.",
      "cause": "Cause class",
      "causeHint": "Optional grouping for analysis, e.g. supplier, internal, system.",
      "sortOrder": "Order",
      "origin": "Origin",
      "system": "Software",
      "tenant": "This tenant",
      "activeOnly": "Active only",
      "create": "New reason code",
      "createTitle": "New reason code",
      "createDescription": "Added to the chosen set, in force from the date you give.",
      "newVersion": "New version",
      "supersedeTitle": "New version of a reason code",
      "supersedeDescription": "A code is retired by superseding it, never by deleting it — a two-year-old override still names it.",
      "supersedeHint": "Must be after the current version's start date.",
      "saved": "Reason code saved",
      "saveFailed": "The reason code could not be saved",
      "tableLabel": "Reason codes",
      "emptyTitle": "No reason codes in this set",
      "emptyDescription": "Codes shipped with the software appear here after provisioning. Add your own for exceptions particular to this tenant.",
      "loadFailed": "Reason codes could not be loaded"
    },
    "override": {
      "title": "Override this control",
      "title2": "Override report",
      "description": "Every control rule that was passed, with the reason given and by whom.",
      "auditNote": "This report is an audit artefact. Exporting it records an export event against your name before a byte is sent.",
      "absoluteTitle": "This control cannot be overridden",
      "absoluteExplain": "The rule is absolute: it offers no override to any principal, including a tenant administrator and support. The attempt has been recorded.",
      "requiredAuthority": "Overriding this needs: {authority}.",
      "noActiveCodes": "The reason set {set} has no active codes, so this control cannot be overridden until one is configured.",
      "reason": "Reason for overriding",
      "confirm": "Override",
      "rule": "Rule",
      "document": "Document",
      "amount": "Amount",
      "by": "Overridden by",
      "at": "When",
      "from": "From",
      "to": "To",
      "total": "Overrides in period",
      "totalHelp": "Every control rule passed with a reason between the two dates.",
      "breakdowns": "Where they cluster",
      "byRule": "By rule",
      "byReason": "By reason",
      "byActor": "By actor",
      "none": "None",
      "sources": {
        "matrix": "Authority matrix",
        "permission": "Permission",
        "remote": "Remotely authorised"
      },
      "tableLabel": "Rule overrides",
      "emptyTitle": "No overrides in this period",
      "emptyDescription": "Either no control was passed, or the dates do not cover when one was.",
      "loadFailed": "Overrides could not be loaded",
      "exportFailed": "The export could not be produced"
    },
    "queues": {
      "title": "Reconciliation queues",
      "description": "What an override leaves behind. The exception is allowed; being forgotten is not.",
      "sla": "{hours}h to resolve",
      "escalatesTo": "escalates to position #{id}",
      "inactive": "Inactive",
      "emptyTitle": "No queues",
      "emptyDescription": "Queues are declared by the software and appear after provisioning.",
      "loadFailed": "Queues could not be loaded"
    },
    "queueItem": {
      "description": "Oldest breach first — the order somebody working the queue needs.",
      "subject": "Subject",
      "amount": "Amount",
      "age": "Age",
      "days": "{count} day(s)",
      "due": "Due",
      "breached": "{count} item(s) are past their SLA.",
      "olderThan": "Older than (days)",
      "olderThanHint": "Show only items open longer than this.",
      "resolve": "Resolve",
      "resolveTitle": "Resolve a queue item",
      "resolved": "Item resolved",
      "disposition": "Disposition",
      "dispositionHint": "Fixed and closed, or accepted as it stands. An auditor reads those differently.",
      "dispositions": {
        "resolved": "Resolved",
        "written_off": "Written off"
      },
      "dispositionHints": {
        "resolved": "The underlying problem was corrected.",
        "written_off": "Accepted as it is; no correction was made."
      },
      "reason": "Reason code",
      "reasonHint": "Optional. Recorded verbatim — no governed set covers dispositions yet.",
      "noteHint": "What was done, for whoever reads this later.",
      "backToQueues": "All queues",
      "tableLabel": "Queue items",
      "emptyTitle": "Nothing in this queue",
      "emptyDescription": "Items arrive when a control is overridden or an exception is raised against this queue.",
      "loadFailed": "Queue items could not be loaded",
      "statuses": {
        "open": "Open",
        "in_progress": "In progress",
        "resolved": "Resolved",
        "written_off": "Written off",
        "escalated": "Escalated"
      }
    },
    "queue": {
      "opcal": {
        "forced_close": "Forced business-day closes"
      },
      "fx": {
        "rate_holds": "FX rates held for review"
      },
      "authority": {
        "unratified": "Unratified emergency approvals",
        "orphaned_tasks": "Approval tasks with no holder"
      },
      "interco": {
        "transactions": "Aged intercompany transactions"
      },
      "close": {
        "overdue_tasks": "Overdue period-close tasks"
      },
      "hr": {
        "exit_review": "Exits with clearance outstanding"
      },
      "pms": {
        "oversell": "Overbooking overrides",
        "credit": "Credit-limit overrides",
        "allowance": "Allowance overrides",
        "checkout": "Check-out overrides",
        "night_audit": "Night audit exceptions",
        "commission": "Commission overrides",
        "folio": {
          "unrouted": "Unrouted folio charges"
        }
      },
      "procurement": {
        "match_exception": "Invoice match exceptions"
      },
      "pos": {
        "cash_variance": "Till cash variances",
        "anomaly": "Point-of-sale anomalies"
      },
      "gl": {
        "suspense": "Items held in suspense",
        "accrual_reversal": "Accrual reversals needing attention",
        "completeness": "Posting completeness failures"
      },
      "qms": {
        "quarantine_overdue": "Overdue quarantine holds",
        "capa_overdue": "Overdue corrective actions"
      },
      "ap": {
        "signals": "Invoice anomaly signals",
        "payment_exceptions": "Payment exceptions"
      },
      "roster": {
        "working_time_review": "Working-time reviews"
      },
      "treasury": {
        "wallet_funding": "Wallets below their funding threshold",
        "mandate_panel": "Mandate panels that cannot meet their rule",
        "wallet_leaver": "Wallets held by someone who has left",
        "wallet_dormant": "Dormant wallets"
      },
      "inventory": {
        "valuation_break": "Inventory valuation breaks"
      },
      "projects": {
        "chargeability": "Chargeability overrides",
        "retention": "Retention overrides"
      },
      "ai": {
        "routed_actions": "AI actions routed for review"
      },
      "service": {
        "dispatch": "Dispatch overrides",
        "billing": "Service billing overrides",
        "goodwill": "Goodwill overrides"
      },
      "payroll": {
        "statutory_review": "Statutory payroll reviews",
        "variance_review": "Payroll variance reviews",
        "anomaly_review": "Payroll anomaly reviews"
      },
      "sales": {
        "discount_overrides": "Discount overrides",
        "margin_overrides": "Margin floor overrides"
      }
    },
    "org": {
      "period": {
        "close_with_blockers": {
          "title": "Period close with blockers outstanding",
          "desc": "A period cannot be closed while a registered close guard reports outstanding work."
        },
        "permanent_close_is_final": {
          "title": "Permanent close is final",
          "desc": "A permanently closed period can never be reopened, by anybody."
        },
        "reopen_authority": {
          "title": "Authority to reopen a period",
          "desc": "Reopening a closed period needs the declared authority and a governed reason."
        }
      },
      "location": {
        "address_invalid": {
          "title": "Address fails its country's rules",
          "desc": "The country enforces address validation. A failing address can be accepted with a waiver reason."
        }
      },
      "company": {
        "activate_without_pack": {
          "title": "Activation without an active country pack",
          "desc": "A legal entity cannot be activated in a jurisdiction whose country pack is not active — nothing could determine its tax."
        },
        "post_after_dissolution": {
          "title": "Posting after dissolution",
          "desc": "A dissolved legal entity accepts no further postings."
        }
      },
      "position": {
        "headcount_exceeded": {
          "title": "Headcount exceeded",
          "desc": "The position is already full for the requested period."
        },
        "assign_to_frozen": {
          "title": "Assignment to a frozen position",
          "desc": "A frozen position keeps authority for its holder but accepts no new assignment."
        },
        "cycle": {
          "title": "Reporting line cycle",
          "desc": "A position cannot report to itself, directly or through a chain."
        }
      },
      "assignment": {
        "multiple_primary": {
          "title": "More than one primary position",
          "desc": "An employee holds one substantive post at a time; overlapping posts are secondary or acting."
        }
      }
    },
    "authority": {
      "chain_unresolvable": {
        "title": "Approval chain cannot be resolved",
        "desc": "A step resolves to nobody, so the document would stop in a queue no one holds."
      },
      "self_approval": {
        "title": "Self-approval",
        "desc": "The submitter is also the approver. Permitted only where the rule says so, and always with a reason."
      },
      "delegation_exceeds": {
        "title": "Delegation exceeds the delegator's authority",
        "desc": "A delegation can narrow authority; it can never widen it."
      },
      "emergency_unratified": {
        "title": "Unratified emergency approval outstanding",
        "desc": "A previous emergency approval has not been ratified, so another cannot be raised."
      },
      "matrix_dual_control": {
        "title": "Matrix dual control",
        "desc": "Whoever proposed a matrix version may not be the one who puts it in force."
      }
    },
    "opcal": {
      "day": {
        "close_with_blockers": {
          "title": "Business-day close with blockers",
          "desc": "A module reports outstanding work. Closing anyway is recorded and opens a queue item."
        },
        "reopen": {
          "title": "Business-day reopen",
          "desc": "Reopening a closed day reopens a record somebody already certified."
        },
        "outside_period": {
          "title": "Business day outside its fiscal period",
          "desc": "A business day cannot be opened against a fiscal period that does not contain it."
        }
      }
    },
    "fx": {
      "rate": {
        "tolerance_breach": {
          "title": "Exchange rate outside its tolerance",
          "desc": "The rate moved further than declared for this pair, so it is held rather than applied."
        }
      }
    },
    "numbering": {
      "void_reason": {
        "title": "Void without a governed reason",
        "desc": "Voiding a document number needs a code from the numbering reason set."
      },
      "gapless_breach": {
        "title": "Gap in a gapless sequence",
        "desc": "A sequence declared gapless cannot skip a number."
      }
    },
    "tax": {
      "jurisdiction_missing": {
        "title": "No tax jurisdiction",
        "desc": "Nothing resolves a jurisdiction for this document, so tax cannot be determined."
      }
    },
    "gl": {
      "division_required": {
        "title": "Division required on this account",
        "desc": "The account's dimension policy requires a division on every line."
      },
      "suspense": {
        "write_off": {
          "title": "Suspense written off"
        }
      }
    },
    "rules": {
      "override_without_authority": {
        "title": "Override without authority",
        "desc": "The actor does not hold the authority the rule requires to be passed."
      }
    },
    "party": {
      "merge": {
        "cross_kind": {
          "title": "Merge across party kinds"
        },
        "both_have_customers": {
          "title": "Merge of two parties that both hold customer records"
        },
        "low_confidence": {
          "title": "Merge below the confidence threshold"
        }
      },
      "consent": {
        "evidence_missing": {
          "title": "Consent recorded without evidence"
        },
        "purpose_inactive": {
          "title": "Consent for an inactive purpose"
        }
      },
      "suppression": {
        "release": {
          "title": "Release of a suppressed contact"
        }
      },
      "dsr": {
        "close_without_tasks": {
          "title": "Data-subject request closed with tasks open"
        },
        "erasure_without_verification": {
          "title": "Erasure without identity verification"
        },
        "extension_beyond_policy": {
          "title": "Deadline extension beyond policy"
        }
      }
    },
    "rvm": {
      "snapshotNotToday": {
        "title": "Snapshot not taken for today"
      },
      "forecastUnexplainedVariance": {
        "title": "Forecast variance without explanation"
      },
      "quoteBelowHurdle": {
        "title": "Quote below the hurdle rate"
      }
    },
    "qms": {
      "receipt": {
        "inspection_required": {
          "title": "Receipt without a required inspection"
        }
      },
      "inspection": {
        "inspector_independence": {
          "title": "Inspector is not independent of the work"
        },
        "concession_required": {
          "title": "Failed inspection accepted by concession"
        }
      },
      "capa": {
        "effectiveness_required": {
          "title": "Corrective action closed without an effectiveness check"
        }
      }
    },
    "hr": {
      "assignment": {
        "without_permit": {
          "title": "Assignment without a valid work permit"
        }
      },
      "permit": {
        "quota_exceeded": {
          "title": "Work-permit quota exceeded"
        },
        "medical_lapsed": {
          "title": "Permit medical clearance lapsed"
        }
      },
      "leave": {
        "blackout": {
          "title": "Leave in a blackout period"
        },
        "coverage_minimum": {
          "title": "Leave below minimum cover"
        },
        "below_statutory_minimum": {
          "title": "Leave below the statutory minimum"
        }
      },
      "exit": {
        "clearance_incomplete": {
          "title": "Exit with clearance outstanding"
        }
      }
    },
    "reporting": {
      "outputUncertifiedCertifiedChannel": {
        "title": "Uncertified output sent on a certified channel"
      }
    },
    "cost": {
      "cycle": {
        "leakage_required": {
          "title": "Allocation cycle without a leakage check"
        }
      },
      "run": {
        "driver_quantity_required": {
          "title": "Cost run without driver quantities"
        }
      }
    },
    "eam": {
      "permit": {
        "sod_breach": {
          "title": "Work permit breaks segregation of duties"
        }
      },
      "asset": {
        "inspection_overdue": {
          "title": "Asset inspection overdue"
        }
      },
      "workorder": {
        "no_permit": {
          "title": "Work order started without a permit"
        }
      },
      "meter": {
        "reading_regression": {
          "title": "Meter reading lower than the last"
        }
      }
    },
    "treasury": {
      "beneficiary": {
        "cooling_off": {
          "title": "Payment to a beneficiary in cooling-off"
        },
        "unverified": {
          "title": "Payment to an unverified beneficiary"
        },
        "blocked": {
          "title": "Payment to a blocked beneficiary"
        }
      },
      "wallet": {
        "limit_exceeded": {
          "title": "Wallet limit exceeded"
        },
        "evidence_required": {
          "title": "Wallet spend without evidence"
        },
        "category_blocked": {
          "title": "Wallet spend in a blocked category"
        },
        "count_overdue": {
          "title": "Wallet count overdue"
        },
        "recount_required": {
          "title": "Wallet recount required"
        }
      },
      "debt": {
        "limit_exceeded": {
          "title": "Debt limit exceeded"
        },
        "covenant_breached": {
          "title": "Debt covenant breached"
        }
      },
      "transfer": {
        "duplicate_instruction": {
          "title": "Duplicate transfer instruction"
        },
        "no_mandate": {
          "title": "Transfer without a mandate"
        },
        "insufficient_signatures": {
          "title": "Transfer with insufficient signatures"
        },
        "exceeds_available": {
          "title": "Transfer exceeds the available balance"
        }
      }
    },
    "pos": {
      "allergen": {
        "declared_conflict": {
          "title": "Order conflicts with a declared allergen"
        }
      },
      "session": {
        "blind_count_witness": {
          "title": "Blind count without a witness"
        },
        "variance_beyond_tolerance": {
          "title": "Session variance beyond tolerance"
        }
      },
      "day": {
        "open_check": {
          "title": "Open check at day end"
        },
        "open_drawer": {
          "title": "Open cash drawer at day end"
        }
      },
      "menu": {
        "publish_incomplete": {
          "title": "Menu published incomplete"
        }
      },
      "sale": {
        "void_after_settlement": {
          "title": "Void after settlement"
        },
        "refund_without_original": {
          "title": "Refund without the original sale"
        }
      },
      "discount": {
        "beyond_operator_limit": {
          "title": "Discount beyond the operator's limit"
        }
      },
      "price": {
        "manual_override": {
          "title": "Manual price override"
        }
      },
      "tender": {
        "credit_limit": {
          "title": "Tender beyond the credit limit"
        }
      },
      "instrument": {
        "balance_short": {
          "title": "Instrument balance too low"
        }
      },
      "age": {
        "restricted_item": {
          "title": "Age-restricted item sold"
        }
      }
    },
    "sales": {
      "discount": {
        "over_policy": {
          "title": "Discount beyond policy"
        }
      },
      "margin": {
        "below_floor": {
          "title": "Margin below the floor"
        }
      }
    },
    "assets": {
      "impairment": {
        "reversal_cap": {
          "title": "Impairment reversal above its cap"
        }
      }
    },
    "service": {
      "workorder": {
        "statutory_skill_missing": {
          "title": "Work order without a required statutory skill"
        },
        "skill_not_held": {
          "title": "Technician lacks the required skill"
        },
        "outside_working_time": {
          "title": "Work order outside working time"
        },
        "close_unbilled": {
          "title": "Work order closed unbilled"
        }
      },
      "goodwill": {
        "beyond_threshold": {
          "title": "Goodwill beyond the threshold"
        }
      }
    },
    "projects": {
      "baseline": {
        "immutable": {
          "title": "Change to an approved baseline"
        }
      },
      "cost": {
        "no_approved_baseline": {
          "title": "Cost booked without an approved baseline"
        }
      },
      "variation": {
        "unapproved_scope": {
          "title": "Work on an unapproved variation"
        }
      },
      "retention": {
        "early_release": {
          "title": "Early release of retention"
        }
      },
      "allocation": {
        "over_capacity": {
          "title": "Allocation over capacity"
        }
      }
    },
    "device": {
      "content": {
        "stale": {
          "title": "Device content out of date"
        }
      },
      "enrolment": {
        "clone_detected": {
          "title": "Cloned device detected"
        }
      },
      "sync": {
        "operator_not_permitted": {
          "title": "Sync by an operator without permission"
        }
      },
      "offline": {
        "policy_refuses": {
          "title": "Offline policy refuses the action"
        }
      }
    },
    "pricing": {
      "precedence_dual_control": {
        "title": "Price precedence needs dual control"
      }
    },
    "procurement": {
      "supplier": {
        "not_qualified": {
          "title": "Supplier not qualified"
        },
        "document_expired": {
          "title": "Supplier document expired"
        },
        "screening_match": {
          "title": "Supplier screening match"
        }
      },
      "contract": {
        "over_commitment": {
          "title": "Order beyond the contract commitment"
        }
      },
      "match": {
        "cumulative_over_invoice": {
          "title": "Cumulative invoicing beyond the order"
        },
        "duplicate_invoice": {
          "title": "Duplicate supplier invoice"
        }
      },
      "grn": {
        "shelf_life_short": {
          "title": "Goods received with short shelf life"
        }
      },
      "amendment": {
        "crosses_band": {
          "title": "Amendment crosses an approval band"
        }
      },
      "rfq": {
        "evaluator_conflict": {
          "title": "Quote evaluator has a conflict of interest"
        },
        "sealed_before_deadline": {
          "title": "Sealed bids opened before the deadline"
        }
      }
    },
    "bankrec": {
      "continuity": {
        "break": {
          "title": "Statement continuity break"
        }
      },
      "match_set": {
        "unbalanced": {
          "title": "Match set does not balance"
        }
      },
      "session": {
        "uncertified": {
          "title": "Reconciliation session not certified"
        },
        "certifier_is_matcher": {
          "title": "Certifier also made the matches"
        }
      }
    },
    "expense": {
      "claim": {
        "policy_breach": {
          "title": "Expense claim breaches policy"
        }
      }
    },
    "payroll": {
      "varianceUnexplained": {
        "title": "Payroll variance without explanation"
      },
      "statutoryRuleLocalOverride": {
        "title": "Local override of a statutory payroll rule"
      },
      "anomalyUnacknowledged": {
        "title": "Payroll anomaly not acknowledged"
      }
    },
    "mfg": {
      "eco": {
        "open_dispositions": {
          "title": "Change order with open dispositions"
        }
      },
      "order": {
        "tool_unavailable": {
          "title": "Production order without its tooling"
        }
      },
      "settlement": {
        "short_close": {
          "title": "Order settled short of its output"
        }
      },
      "material": {
        "over_issue_warn": {
          "title": "Material issued above the planned quantity (warning)"
        },
        "over_issue": {
          "title": "Material issued above the planned quantity"
        },
        "substitute_undeclared": {
          "title": "Material substituted without declaration"
        }
      }
    },
    "close": {
      "task": {
        "blocked": {
          "title": "Close task blocked"
        },
        "not_ready": {
          "title": "Close task not ready"
        },
        "accept": {
          "title": "Close task accepted with open items"
        }
      },
      "run": {
        "certifier_not_sole_preparer": {
          "title": "Certifier was the sole preparer"
        }
      }
    },
    "ap": {
      "bank_detail": {
        "cooling_off": {
          "title": "Payment to recently changed bank details"
        }
      },
      "invoice": {
        "fraud_signal": {
          "title": "Invoice with a fraud signal"
        }
      }
    },
    "roster": {
      "working_time": {
        "statutory_breach": {
          "title": "Statutory working-time breach"
        },
        "house_breach": {
          "title": "House working-time rule breach"
        }
      },
      "publish": {
        "unfilled_open_lines": {
          "title": "Roster published with unfilled lines"
        }
      }
    },
    "crm": {
      "campaign": {
        "send_without_purpose_consent": {
          "title": "Campaign sent without consent for its purpose"
        },
        "resend_within_window": {
          "title": "Campaign resent within the suppression window"
        }
      }
    },
    "pms": {
      "guest": {
        "restricted": {
          "title": "Restricted guest"
        }
      },
      "folio": {
        "charge_immutable": {
          "title": "Change to a posted folio charge"
        },
        "credit_limit": {
          "title": "Folio beyond its credit limit"
        },
        "allowance": {
          "title": "Folio allowance override"
        },
        "late_charge": {
          "title": "Late charge on a closed folio"
        }
      },
      "night_audit": {
        "unposted_nights": {
          "title": "Night audit with unposted nights"
        },
        "force": {
          "title": "Night audit forced"
        }
      },
      "settlement": {
        "window_not_zero": {
          "title": "Settlement window not at zero"
        }
      },
      "board": {
        "no_transfer_price": {
          "title": "Board basis without a transfer price"
        }
      },
      "availability": {
        "oversell": {
          "title": "Overbooking"
        }
      },
      "rate": {
        "manual_override": {
          "title": "Manual room-rate override"
        },
        "restricted": {
          "title": "Restricted rate used"
        }
      },
      "reservation": {
        "amend_after_arrival": {
          "title": "Reservation amended after arrival"
        }
      },
      "checkout": {
        "balance_outstanding": {
          "title": "Check-out with a balance outstanding"
        }
      },
      "housekeeping": {
        "inspect_own_clean": {
          "title": "Housekeeper inspected their own clean"
        }
      },
      "commission": {
        "write_off": {
          "title": "Commission written off"
        }
      }
    },
    "ai": {
      "capabilityDelegationWithoutEvidence": {
        "title": "Capability delegated without evidence"
      },
      "actionOutsideTolerance": {
        "title": "AI action outside its tolerance"
      }
    },
    "inventory": {
      "transfer": {
        "received_short": {
          "title": "Transfer received short"
        }
      },
      "lot": {
        "not_available": {
          "title": "Lot not available"
        },
        "expired": {
          "title": "Expired lot"
        },
        "shelf_life_short": {
          "title": "Lot with short remaining shelf life"
        }
      },
      "landed_cost": {
        "disbursement_recoverable_tax": {
          "title": "Disbursement with recoverable tax"
        },
        "duty_needs_classification": {
          "title": "Duty without a tariff classification"
        }
      },
      "count": {
        "recount_required": {
          "title": "Recount required"
        },
        "same_counter": {
          "title": "Same counter on repeated counts"
        },
        "frozen_scope": {
          "title": "Movement in a frozen count scope"
        }
      },
      "adjustment": {
        "evidence_required": {
          "title": "Adjustment without evidence"
        }
      }
    }
  },
  "pricing": {
    "filtersTitle": "Filters",
    "allCompanies": "All legal entities",
    "chooseItem": "Choose an item",
    "nav": {
      "label": "Pricing",
      "priceLists": "Price lists",
      "promotions": "Promotions",
      "itemSettings": "Item settings",
      "categories": "Categories",
      "precedence": "Precedence",
      "priceSets": "Price sets",
      "explanations": "Explanations"
    },
    "routeTitles": {
      "priceLists": "Price lists",
      "priceListNew": "New price list",
      "priceList": "Price list",
      "promotions": "Promotions",
      "itemSettings": "Item pricing settings",
      "categories": "Pricing categories",
      "precedence": "Price precedence",
      "precedenceVersion": "Precedence version",
      "priceSets": "Price sets",
      "priceSet": "Price set",
      "explanations": "Price explanations"
    },
    "common": {
      "note": "Note",
      "reasonCode": "Reason code"
    },
    "fields": {
      "company": "Legal Entity",
      "customer": "Customer",
      "item": "Item",
      "currency": "Currency",
      "quantity": "Quantity",
      "uom": "Unit of measure",
      "unitPrice": "Unit price",
      "channel": "Channel",
      "supplyType": "Supply type",
      "dayPart": "Day part",
      "segmentCode": "Segment",
      "location": "Location",
      "createdAt": "Created"
    },
    "sources": {
      "subscription_plan": "Subscription plan",
      "customer_contract": "Customer contract",
      "contract_price_list": "Contract price list",
      "trade_agreement": "Trade agreement",
      "tier_price_list": "Tier price list",
      "segment_price_list": "Segment price list",
      "channel_price_list": "Channel price list",
      "published_price_set": "Published price set",
      "base_price_list": "Base price list",
      "manual": "Keyed by hand"
    },
    "outcomes": {
      "won": "Won",
      "lost": "Lost on price",
      "ineligible": "Not eligible",
      "out_of_window": "Outside its window",
      "not_configured": "Not configured",
      "disabled": "Switched off",
      "not_reached": "Not reached"
    },
    "outcomeHints": {
      "won": "This source decided the price.",
      "lost": "It produced a price and another source undercut it.",
      "ineligible": "It could price this item, but not on these terms — check the quantity and the customer.",
      "out_of_window": "It exists, but its dates do not cover this line. Extend the window to use it.",
      "not_configured": "Nothing is configured for this source. Create it to bring it into play.",
      "disabled": "Somebody switched this source off in the precedence version in force.",
      "not_reached": "An earlier source ended the search, so this one was never queried."
    },
    "margin": {
      "clear": "Clears the floor",
      "below": "Below the floor",
      "unconfigured": "No floor configured"
    },
    "basis": {
      "exclusive": "Tax exclusive",
      "inclusive": "Tax inclusive"
    },
    "modifierKinds": {
      "promotion": "Promotion",
      "trade_discount": "Trade discount",
      "unrecorded": "Not recorded"
    },
    "reason": {
      "beaten_by_price": "Another source priced it at {price} and won.",
      "beaten_by_promotion": "A promotion gave a better price than this trade discount.",
      "beaten_by_trade_discount": "A trade discount gave a better price than this promotion.",
      "earlier_source_won": "Never queried: the source at seq {seq} already won and stops the search.",
      "entry_disabled": "Switched off in the precedence version in force.",
      "item_not_in_list": "{code} carries no price for this item.",
      "list_out_of_window": "{code} is not in force on this date.",
      "manual_override": "Priced by hand rather than by the engine.",
      "min_qty_not_met": "{code} starts at {minQty}; this line is for {qty}.",
      "no_channel": "This line names no channel, so a channel list cannot apply.",
      "no_customer": "This line names no customer, so a customer list cannot apply.",
      "no_segment": "This line names no segment, so a segment list cannot apply.",
      "not_configured": "Nothing is configured for this source.",
      "precedence_defaulted": "No precedence version covered this date, so the built-in order was used.",
      "promotion_applied": "Promotion {code} applied.",
      "qty_break": "{code} priced it from {minQty} up.",
      "set_out_of_window": "Price set {code} is not in force on this date.",
      "set_scope_mismatch": "The price set does not cover this line's scope or currency.",
      "source_unavailable": "This build has no evaluator for {source}.",
      "trade_discount_applied": "Trade agreement {code} applied."
    },
    "waterfall": {
      "title": "Why this price",
      "none": "No price explanation is available for this line.",
      "listPrice": "List price",
      "decidedBy": "Decided by",
      "preview": "Preview",
      "tableCaption": "Every price source considered, in the order the engine evaluated them.",
      "columns": {
        "seq": "Seq",
        "source": "Source",
        "outcome": "Outcome",
        "minQty": "From qty",
        "unitPrice": "Unit price"
      },
      "deltaVsWinner": "{amount} against the winner",
      "modifiers": "Applied after the source won",
      "modifierDerived": "Derived, not recorded",
      "marginFloor": "Margin floor",
      "floorPercent": "Floor %",
      "minPrice": "Minimum price",
      "standardCost": "Standard cost",
      "precedenceVersion": "Precedence version",
      "priceSetVersion": "Price set version",
      "resolvedAt": "Resolved at",
      "fingerprint": "Fingerprint",
      "fingerprintHint": "Identifies the question asked and the configuration that answered it. Two resolutions sharing a fingerprint have the same answer.",
      "precedenceDefaulted": "No active precedence version covered this date, so the built-in order was used. Run erpxctl pricing sync.",
      "setSuperseded": "Priced from price set version #{versionId}, which is no longer the published one.",
      "unknownOutcome": "This build does not recognise every outcome recorded here: {codes}. They are shown under their raw codes."
    },
    "priceLists": {
      "listTitle": "Price lists",
      "listDescription": "The lists that carry prices, ordered by the priority the engine reads them in.",
      "new": "New price list",
      "newTitle": "New price list",
      "newDescription": "A code, a kind and at least one priced item.",
      "headerTitle": "Price list",
      "loadFailed": "Could not load price lists",
      "saveFailed": "Could not save the price list",
      "saved": "Price list saved",
      "created": "Price list {code} created",
      "emptyTitle": "No price lists yet",
      "emptyDescription": "Create a base list so every item has a price, then add tier and contract lists above it.",
      "orderNote": "Within a kind, the highest priority in force on the day wins.",
      "active": "Active",
      "inactive": "Inactive",
      "inForce": "In force today",
      "notInForce": "Not in force",
      "columns": {
        "code": "Code",
        "name": "Name",
        "kind": "Kind",
        "tier": "Tier",
        "priority": "Priority",
        "window": "Window",
        "lines": "Lines",
        "inForce": "In force"
      },
      "kinds": {
        "base": "Base",
        "tier": "Tier",
        "contract": "Contract",
        "segment": "Segment",
        "channel": "Channel"
      },
      "kindHints": {
        "base": "The fallback nobody negotiated. Every legal entity needs one.",
        "tier": "Applies to customers on one price tier.",
        "contract": "Agreed with one customer, and the strongest claim on a price.",
        "segment": "Applies to customers carrying one segment code.",
        "channel": "Applies to one sales channel."
      },
      "fields": {
        "customerHint": "A contract list prices for this customer and nobody else.",
        "tierHint": "Matched against the customer's price tier, exactly.",
        "segmentCode": "Segment",
        "segmentCodeHint": "Required: a segment list with no segment code matches nothing at all.",
        "channel": "Channel",
        "channelHint": "Required: a channel list with no channel matches nothing at all.",
        "dayPart": "Day part",
        "dayPartHint": "Leave empty to price at any time of day.",
        "priorityHint": "Highest priority wins within a kind.",
        "validFrom": "Valid from",
        "validTo": "Valid to",
        "validToHint": "Inclusive. Leave empty for open-ended."
      },
      "laddersTitle": "Prices",
      "laddersDescription": "One ladder per item: each rung is the price from that quantity up.",
      "laddersCaption": "Price list lines, grouped by item and ordered by the quantity each rung starts at.",
      "fromQty": "From qty",
      "sameItem": "Same item",
      "addItem": "Add item",
      "addRung": "Add rung",
      "chooseItem": "Choose an item",
      "noLines": "No lines yet. Add an item to price it.",
      "startsAbove": "This ladder starts at {qty}, so it prices nothing below that.",
      "risesWithQty": "Dearer than the rung below it.",
      "ladderNote": "The engine takes the highest rung not exceeding the quantity ordered. A quantity below every rung is not priced by this list at all.",
      "aria": {
        "minQty": "From quantity for {item}",
        "unitPrice": "Unit price for {item}"
      }
    },
    "promotions": {
      "listTitle": "Promotions",
      "listDescription": "Time-boxed campaigns that move a price after a list has decided it.",
      "new": "New promotion",
      "newTitle": "New promotion",
      "editTitle": "Promotion",
      "dialogDescription": "A promotion discounts the list price; it never replaces the list that set it.",
      "loadFailed": "Could not load promotions",
      "saveFailed": "Could not save the promotion",
      "saved": "Promotion saved",
      "created": "Promotion {code} created",
      "emptyTitle": "No promotions running",
      "emptyDescription": "Create one to discount a price for a window, a customer tier or a set of items.",
      "active": "Active",
      "inactive": "Inactive",
      "activeOn": "Running on",
      "activeOnHint": "A promotion applies when it is active and this date falls inside its window.",
      "everyone": "Everyone",
      "restrictedTo": "{customers} customer(s), {tiers} tier(s), {items} item(s)",
      "unrestricted": "No customers, tiers or items named — this promotion applies to the whole catalogue.",
      "editLimits": "Name, end date and the two switches are editable. Value, kind and eligibility are fixed once quotes carry lines priced under them.",
      "stacksNote": "A promotion runs after the winning list price.",
      "stackableOn": "It combines with a trade discount.",
      "stackableOff": "It does not combine: the customer gets whichever is better.",
      "columns": {
        "eligibility": "Applies to"
      },
      "kinds": {
        "percent": "Percent",
        "amount": "Amount",
        "bundle": "Bundle"
      },
      "kindHints": {
        "percent": "A percentage off the list price.",
        "amount": "A fixed amount off, in one currency.",
        "bundle": "A discount that only applies from a quantity up."
      },
      "valueHints": {
        "percent": "Percent off, e.g. 5 for five percent.",
        "amount": "Amount off, in the currency below.",
        "bundle": "The discount, applied once the bundle quantity is reached."
      },
      "fields": {
        "code": "Code",
        "name": "Name",
        "kind": "Kind",
        "value": "Value",
        "bundleMinQty": "Bundle quantity",
        "bundleMinQtyHint": "The quantity that unlocks the bundle.",
        "minQty": "Minimum quantity",
        "minQtyHint": "Below this quantity the promotion does not apply.",
        "startDate": "Starts",
        "endDate": "Ends",
        "endDateHint": "Inclusive. Ending it early is the supported way to stop it.",
        "customerIds": "Customer ids",
        "customerTiers": "Customer tiers",
        "itemIds": "Item ids",
        "idListHint": "Comma-separated ids. Empty means every one of them.",
        "tierListHint": "Comma-separated tiers. Empty means every tier.",
        "channel": "Channel",
        "channelHint": "Empty applies to every channel.",
        "dayPart": "Day part",
        "dayPartHint": "Empty applies at any time of day.",
        "segmentCode": "Segment",
        "segmentCodeHint": "Empty applies to every segment.",
        "isStackable": "Combines with a trade discount",
        "isStackableHint": "Off means the customer gets the better of the two, and the loser is recorded."
      }
    },
    "itemSettings": {
      "title": "Item pricing settings",
      "description": "What an item costs us, the margin it may not fall below, and the category its discount authority keys on.",
      "formTitle": "Pricing for this item",
      "chooseFirst": "Choose a legal entity and an item to see its pricing settings.",
      "loadFailed": "Could not load the item's settings",
      "saveFailed": "Could not save the item's settings",
      "saved": "Item pricing settings saved",
      "standardCost": "Standard cost",
      "standardCostHint": "What the item costs us. The margin floor is measured against it.",
      "floorPercent": "Margin floor",
      "floorPercentHint": "The minimum margin as a percent of the selling price. Leave empty to enforce no floor.",
      "category": "Category",
      "categoryHint": "The category the discount authority matrix keys on.",
      "noCategory": "No category",
      "noCategories": "No categories defined yet",
      "unset": "Nothing is configured for this item, so no margin floor is enforced and it can be sold at any price.",
      "zeroCost": "The standard cost is nil, so no margin floor is enforced. Enter what the item costs to bring the floor into play.",
      "noFloor": "A standard cost is recorded but no floor percentage, so nothing is enforced. Enter a floor percentage to enforce one.",
      "enforced": "A floor is enforced on this item."
    },
    "categories": {
      "title": "Pricing categories",
      "description": "The validated list of category codes a discount policy and an item setting can both name.",
      "create": "New category",
      "createTitle": "New category",
      "editTitle": "Category",
      "dialogDescription": "A code and a name. Codes cannot be changed once other rows name them.",
      "code": "Code",
      "codeHint": "Lower case letters, digits and underscores.",
      "codeInvalid": "Use lower case letters, digits and underscores only.",
      "parent": "Parent",
      "parentHint": "Optional. A parent groups categories for reporting; the matrix still matches on the exact code.",
      "noParent": "No parent",
      "active": "Active",
      "inactive": "Retired",
      "activeHint": "A retired category stays on the rows that already name it.",
      "activeOnly": "Active only",
      "retire": "Retire",
      "retireTitle": "Retire this category?",
      "retireDescription": "It stops being offered on new rows.",
      "retireWarning": "Policies and item settings that already name this category keep it. Nothing already priced changes.",
      "saved": "Category saved",
      "saveFailed": "Could not save the category",
      "deleted": "Category retired",
      "deleteFailed": "Could not retire the category",
      "loadFailed": "Could not load categories",
      "emptyTitle": "No categories yet",
      "emptyDescription": "Create the categories your discount policies key on — a policy naming a category that does not exist matches nothing."
    },
    "precedence": {
      "title": "Price precedence",
      "description": "Which order the engine asks its price sources in, as dated versions rather than as a setting.",
      "tableLabel": "Precedence versions",
      "create": "New version",
      "createTitle": "New precedence version",
      "createDescription": "Start from the ordering in force and change what needs changing.",
      "created": "Precedence version created",
      "createFailed": "Could not create the version",
      "loadFailed": "Could not load precedence versions",
      "code": "Code",
      "entryCount": "Sources",
      "statusAny": "Any status",
      "fromHint": "The date this ordering starts deciding prices, once it is activated.",
      "cloneFrom": "Clone from",
      "cloneHint": "Copies that version's ladder, which is nearly always the right starting point.",
      "cloneEmpty": "Start from an empty ladder",
      "dualControl": "Dual control",
      "notSubmitted": "Not submitted",
      "submittedBy": "Submitted by user {user}",
      "notActivated": "Not activated",
      "activatedBy": "Activated by user {user}",
      "emptyTitle": "No precedence versions",
      "emptyDescription": "Run erpxctl pricing sync to seed the default ordering, then clone it to change one.",
      "statuses": {
        "draft": "Draft",
        "submitted": "Submitted",
        "active": "Active",
        "superseded": "Superseded"
      }
    },
    "editor": {
      "title": "Precedence version",
      "description": "Reordering this ladder restates every price the engine produces from the day it takes effect.",
      "loadFailed": "Could not load the version",
      "ladderLabel": "Price sources, in the order they are evaluated",
      "draftNotice": "This is a draft. Nothing it says affects a price until it is submitted, simulated and activated.",
      "emptyLadder": "No sources in this ladder yet. Add one below.",
      "addSource": "Add a source",
      "addSourcePlaceholder": "Choose a source",
      "removeSource": "Remove {source}",
      "moveUp": "Move {source} up",
      "moveDown": "Move {source} down",
      "enabled": "Enabled",
      "stopOnMatch": "Stop here",
      "stopOnMatchHint": "When this source produces a price, the search ends and later sources are never queried.",
      "allDisabled": "Every source in this ladder is switched off, so nothing would price at all.",
      "bestPricePolicy": "No source stops the search, so every source is asked and the best price wins. That is a policy, and it is rarely the intended one.",
      "sourceUnavailable": "This build has no evaluator for: {sources}. Those sources are recorded as unavailable on every line priced while they are in the ladder.",
      "saved": "Ladder saved",
      "savedHint": "Nothing changes for a price until this version is activated.",
      "saveFailed": "Could not save the ladder",
      "simulate": "Simulate",
      "submit": "Submit",
      "submitTitle": "Submit for activation",
      "submitDescription": "The ladder is frozen and somebody else activates it.",
      "submitted": "Submitted",
      "submittedHint": "Somebody other than you must now activate it.",
      "submitFailed": "Could not submit the version",
      "activate": "Activate",
      "activateTitle": "Activate this version",
      "activateDescription": "From the date below, this ordering decides every price.",
      "activateWarning": "Every price the engine produces from this date is decided by this ordering. Run the simulation first if you have not.",
      "activated": "Version activated",
      "activatedHint": "It now decides prices from its effective date.",
      "activateFailed": "Could not activate the version"
    },
    "simulate": {
      "title": "Simulate this ordering",
      "description": "Replays a sample of prices that were actually struck against this draft.",
      "from": "From",
      "to": "To",
      "limit": "Sample size",
      "limitHint": "Up to 500 lines.",
      "run": "Run",
      "running": "Running",
      "idle": "Choose a legal entity and a window, then run the simulation.",
      "sampled": "Sampled",
      "unchanged": "Unchanged",
      "changed": "Changed",
      "failed": "Could not re-price",
      "totalDelta": "Total difference",
      "deltaHint": "Over the sample only",
      "failedAlert": "{count} sampled line(s) could not be priced at all under this ordering. That is the most important thing here — open them before activating.",
      "noChange": "No line in the sample of {sampled} would change. This is a sample, not the whole history.",
      "tableCaption": "Every sampled line whose winning source or price would change under this ordering.",
      "columns": {
        "document": "Document",
        "was": "Was",
        "becomes": "Becomes",
        "oldPrice": "Old price",
        "newPrice": "New price",
        "delta": "Difference"
      }
    },
    "priceSets": {
      "title": "Price sets",
      "description": "Frozen answer sheets a disconnected surface can trade from and name by version.",
      "create": "New price set",
      "createTitle": "New price set",
      "editTitle": "Price set",
      "dialogDescription": "A scope and a currency. The versions underneath carry the prices.",
      "code": "Code",
      "scope": "Scope",
      "channel": "Channel",
      "channelHint": "Filter the list by channel.",
      "channelScopeHint": "Empty means every channel.",
      "channelIs": "Channel {channel}",
      "everyChannel": "Every channel",
      "location": "Location",
      "locationHint": "Empty means every location.",
      "locationIs": "Location {location}",
      "everyLocation": "Every location",
      "active": "Active",
      "inactive": "Inactive",
      "activeOnly": "Active only",
      "saved": "Price set saved",
      "saveFailed": "Could not save the price set",
      "created": "Price set created",
      "loadFailed": "Could not load price sets",
      "emptyTitle": "No price sets yet",
      "emptyDescription": "Create one for the channel and location a till trades from, then build and publish a version.",
      "backToSets": "All price sets",
      "versionsTitle": "Price set",
      "versionsDescription": "Its versions, and the content of the one selected.",
      "versionsPanel": "Versions",
      "versionsCaption": "Every version of this price set, newest first.",
      "versionNo": "Version",
      "noVersions": "No versions yet. Create one, build it from the engine, then publish it.",
      "newVersion": "New version",
      "newVersionTitle": "New version",
      "newVersionDescription": "Cloning the published version is the usual starting point.",
      "versionCreated": "Version created",
      "cloneFrom": "Clone from",
      "cloneHint": "Copies that version's entries into the new draft.",
      "cloneEmpty": "Start empty",
      "entriesTitle": "Version {versionNo} entries",
      "entriesDescription": "What a surface holding this version would charge.",
      "entriesCaption": "Every priced entry in the selected version.",
      "entryCount": "Entries",
      "noEntries": "No entries yet. Build them from the engine, which is faster and cannot disagree with the ledger.",
      "build": "Build from the engine",
      "buildTitle": "Build this version",
      "buildDescription": "Ask the engine for today's price for every item in scope and write it as entries.",
      "buildNote": "Existing entries in this draft are replaced. Only a draft can be built.",
      "buildCategory": "Category",
      "buildCategoryHint": "Restrict the build to one category.",
      "buildEveryItem": "Every item",
      "built": "Version built",
      "buildFailed": "Could not build the version",
      "uom": "UoM",
      "dayPart": "Day part",
      "segment": "Segment",
      "taxClass": "Tax class",
      "taxGroup": "Tax group {id}",
      "noTaxClass": "No tax class",
      "basis": "Basis",
      "untaxed": "{count} of these entries carry no tax class. A surface cannot trade them offline, and publishing will be refused.",
      "contentHash": "Content hash",
      "notHashed": "Not published",
      "publish": "Publish",
      "publishTitle": "Publish this version",
      "publishDescription": "Publishing freezes the content and stamps its hash.",
      "publishWarning": "Version {versionNo} and its {entryCount} entries become immutable. To change a price afterwards, create a new version.",
      "published": "Version published",
      "publishFailed": "Could not publish the version",
      "incomplete": "{count} of these entries cannot be published:",
      "withdraw": "Withdraw",
      "withdrawTitle": "Withdraw this version",
      "withdrawDescription": "It stops being the published version.",
      "withdrawWarning": "A surface may still be holding this version. Its hash survives so the supersession report can say what it was holding.",
      "withdrawn": "Version withdrawn",
      "withdrawFailed": "Could not withdraw the version",
      "statuses": {
        "draft": "Draft",
        "published": "Published",
        "withdrawn": "Withdrawn"
      }
    },
    "explanations": {
      "title": "Price explanations",
      "description": "Every price this legal entity struck, and which source struck it.",
      "loadFailed": "Could not load price explanations",
      "document": "Document",
      "docType": "Document type",
      "winner": "Winning source",
      "listPrice": "List price",
      "margin": "Margin",
      "setState": "Price set",
      "superseded": "Superseded",
      "supersededOnly": "Superseded sets only",
      "preview": "Preview, no document",
      "previewOnly": "This price was resolved before its document existed, so there is no document to explain. Nothing was filed against a line.",
      "drawerTitle": "Why this price",
      "drawerDescription": "The waterfall recorded against this line at the moment it was priced.",
      "exported": "Explanations exported",
      "exportFailed": "Could not export the explanations",
      "emptyTitle": "No price explanations",
      "emptyDescription": "Every priced document line files one. Widen the dates, or price something."
    },
    "resolve": {
      "title": "Resolve a price",
      "description": "Ask the engine what it would charge, and see every source it considered.",
      "on": "On",
      "onHint": "The business date the price is asked for.",
      "customerHint": "Leave empty to price as an anonymous walk-in.",
      "anonymous": "No customer",
      "pinnedVersion": "Pinned price set version",
      "pinnedVersionHint": "What a disconnected surface passes when it prices from a set it cached.",
      "run": "Resolve",
      "running": "Resolving",
      "idle": "Choose an item and a quantity, then resolve. Nothing is priced or recorded."
    }
  },
  "close": {
    "nav": {
      "label": "Close cockpit sections",
      "board": "Board",
      "readiness": "Readiness",
      "runs": "Runs",
      "calendars": "Calendars"
    },
    "routeTitles": {
      "board": "Close board",
      "readiness": "Close readiness",
      "runs": "Close runs",
      "cockpit": "Close cockpit",
      "calendars": "Close calendars",
      "calendar": "Close calendar"
    },
    "taskStatuses": {
      "pending": "Pending",
      "blocked": "Blocked",
      "ready": "Ready",
      "in_progress": "In progress",
      "completed": "Completed",
      "accepted": "Accepted",
      "skipped": "Skipped",
      "failed": "Failed"
    },
    "runStatuses": {
      "not_started": "Not started",
      "in_progress": "In progress",
      "ready": "Ready to certify",
      "certified": "Certified",
      "closed": "Closed",
      "abandoned": "Abandoned"
    },
    "taskKinds": {
      "manual": "Manual",
      "readiness": "Readiness check",
      "obligation": "Obligation",
      "action": "Action"
    },
    "scopes": {
      "monthly": "Monthly",
      "quarterly": "Quarterly",
      "annual": "Annual"
    },
    "severities": {
      "blocking": "Blocks close",
      "advisory": "Advisory"
    },
    "evidenceKinds": {
      "attachment": "Attachment",
      "report": "Report",
      "reconciliation": "Reconciliation",
      "assertion": "Assertion",
      "certification": "Certification",
      "signoff": "Sign-off",
      "trial_balance": "Trial balance"
    },
    "signoffKinds": {
      "task": "Task sign-off",
      "preparer": "Preparer",
      "reviewer": "Reviewer",
      "certifier": "Certifier",
      "reconciliation": "Reconciliation certification"
    },
    "board": {
      "title": "Close board",
      "description": "Every legal entity's close, in one place. Blocked and overdue are the two counts that need somebody.",
      "company": "Legal Entity",
      "period": "Period",
      "status": "Status",
      "progress": "Progress",
      "blocked": "Blocked",
      "overdue": "Overdue",
      "target": "Target",
      "anyStatus": "Any status",
      "noCalendar": "No close calendar",
      "openRun": "Open a run",
      "cockpit": "Cockpit",
      "tableLabel": "Close status by legal entity",
      "emptyTitle": "No legal entities to close",
      "emptyDescription": "A legal entity appears here once it has a fiscal calendar. Create one under Organisation, then give it a close calendar.",
      "loadFailed": "The close board could not be loaded"
    },
    "readiness": {
      "title": "Close readiness",
      "description": "What each sub-ledger says about a period, computed now — before a run is opened.",
      "loadFailed": "Readiness could not be evaluated",
      "choosePeriod": "Choose a period",
      "chooseTitle": "Choose a legal entity and a period",
      "chooseDescription": "Readiness is evaluated for one legal entity's fiscal period. Pick both and every check runs.",
      "blockingCount": "Blocking",
      "advisoryCount": "Advisory",
      "evaluatedAt": "Evaluated",
      "allClear": "Nothing is blocking this period. The ledger can be closed once the run's mandatory tasks are signed off.",
      "blockingTitle": "Blocking checks",
      "blockingDescription": "Each of these refuses the period close until it is cleared, or accepted on a task with a reason.",
      "noBlockingTitle": "No blocking checks",
      "noBlockingDescription": "Every blocking check for this period is satisfied.",
      "advisoryTitle": "Advisory checks",
      "advisoryDescription": "Shown so nothing is a surprise. None of these refuses a close.",
      "noAdvisoryTitle": "No advisory checks",
      "noAdvisoryDescription": "Nothing to note for this period.",
      "failingTitle": "Failing checks on this run",
      "failingDescription": "Every readiness answer the last refresh returned as not-ready, gathered from the tasks that carry them.",
      "ready": "Ready",
      "goClear": "Go and clear it",
      "genericMessage": "{key} — {count} outstanding",
      "providerError": "The check could not run: {error}",
      "assets": {
        "controlReconciles": "Fixed-asset register ties to the ledger"
      },
      "gl": {
        "anomaliesDisposed": "Close anomaly findings are all dispositioned ({count} still open)",
        "anomaliesNotScanned": "Run the anomaly scan for this period.",
        "anomaliesStale": "Entries were posted after the last anomaly scan — run it again."
      }
    },
    "lanes": {
      "title": "Task graph",
      "description": "Laid out by dependency depth. Two tasks in the same lane cannot block each other; a task to the right waits on something to its left.",
      "lane": "Lane {n}",
      "emptyTitle": "No tasks match",
      "emptyDescription": "Clear the state filter above, or add a task to this run."
    },
    "run": {
      "title": "Close — {period}",
      "description": "{company} · {calendar}",
      "listTitle": "Close runs",
      "listDescription": "One run per calendar per fiscal period. Opening the same pair twice is refused, not duplicated.",
      "loadFailed": "This close run could not be loaded",
      "company": "Legal Entity",
      "period": "Period",
      "calendar": "Calendar",
      "progress": "Completed",
      "blocked": "Blocked",
      "overdue": "Overdue",
      "blockingChecks": "Blocking checks",
      "target": "Target date",
      "targetHint": "Defaults to the calendar's working-day target after period end.",
      "certifiedAt": "Certified",
      "tableLabel": "Close runs",
      "emptyTitle": "No close runs yet",
      "emptyDescription": "Open one for the period you are closing — it instantiates the calendar's task graph.",
      "refresh": "Refresh readiness",
      "refreshed": "Readiness re-evaluated",
      "refreshFailed": "Readiness could not be re-evaluated",
      "open": "Open a run",
      "openTitle": "Open a close run",
      "openDescription": "The calendar's active templates become this run's tasks. Editing the template afterwards does not restate the run.",
      "opened": "Close run opened",
      "openFailed": "The close run could not be opened",
      "noCalendar": "This legal entity has no active close calendar. Create one first.",
      "readyHint": "Every mandatory task is satisfied. The run can be certified.",
      "solePreparer": "You signed off every task on this run, so you may not also certify it. Somebody else has to sign one.",
      "certify": "Certify",
      "certifyTitle": "Certify this close",
      "certifyDescription": "Certification is a statement of record. It requires a second factor.",
      "certifyHint": "The certifier may not be the sole preparer. If every task on the run was signed off by you, certification is refused.",
      "statement": "Certification statement",
      "statementHint": "What you are attesting to. It is stored on the run and printed on the evidence pack's cover.",
      "certified": "Close certified",
      "certifiedBy": "Certified by {who} at {at}. Evidence hash {hash}.",
      "certifyFailed": "This close could not be certified",
      "abandon": "Abandon",
      "abandonTitle": "Abandon this close run",
      "abandonDescription": "The run stops being worked. The period's own status is untouched — abandoning a run does not close or reopen a ledger.",
      "abandoned": "Close run abandoned",
      "abandonFailed": "The close run could not be abandoned"
    },
    "task": {
      "code": "Code",
      "kind": "Kind",
      "due": "Due",
      "noDue": "No due date",
      "owner": "Owner",
      "unassigned": "Unassigned",
      "mandatory": "Mandatory",
      "mandatoryYes": "Blocks the close",
      "mandatoryNo": "Advisory",
      "advisoryTask": "Advisory — does not block the close",
      "signedOffBy": "Signed off by",
      "dueOn": "due {date}",
      "overdueOn": "overdue since {date}",
      "blockedBy": "Waiting on {tasks}",
      "blockedDetail": "This task cannot be completed while {tasks} is unsatisfied.",
      "noForce": "There is no force. Clear the predecessor, or accept it with a reason.",
      "acceptedFor": "Accepted — {reason}",
      "acceptedDetail": "Accepted with reason {reason}. {note}",
      "skippedFor": "Skipped — {reason}",
      "skippedDetail": "Skipped: {reason}. The check did not run, so nothing here was verified.",
      "failedDetail": "The check could not run. Refresh readiness; if it still fails, the provider is reporting an error rather than a blocker.",
      "obligationCount": "{done} of {total} satisfied",
      "satisfied": "Satisfied",
      "outstanding": "Outstanding",
      "resultDoc": "Produced {docType} #{docId}",
      "runAction": "Run it",
      "actionRan": "Action completed",
      "actionFailed": "The action could not be run",
      "complete": "Complete",
      "completeTitle": "Sign this task off",
      "completed": "Task completed",
      "completeFailed": "The task could not be completed",
      "statement": "Evidence statement",
      "statementHint": "This template requires evidence. What you write here is stored as the task's sign-off and goes into the evidence pack.",
      "note": "Note",
      "accept": "Accept the failure",
      "acceptTitle": "Accept a failing check",
      "acceptDescription": "The check says no. Accepting it lets the close proceed and puts your reason on the record.",
      "acceptWarning": "This does not fix anything. It records that you decided the close proceeds anyway, and it ages in the evidence pack under your name.",
      "accepted": "Failing check accepted",
      "acceptFailed": "The check could not be accepted",
      "reopen": "Reopen",
      "reopenTitle": "Reopen this task",
      "reopened": "Task reopened",
      "reopenFailed": "The task could not be reopened",
      "assign": "Assign",
      "assignTitle": "Assign this task",
      "assigneeUserId": "Assignee user id",
      "assigneeHint": "Leave blank to unassign and fall back to the owning position.",
      "assigned": "Task assigned",
      "assignFailed": "The task could not be assigned"
    },
    "evidence": {
      "title": "Evidence",
      "description": "What the auditor will be handed. Each artefact is hashed, so the pack's attestation means something.",
      "build": "Build evidence pack",
      "built": "Evidence pack built",
      "builtDetail": "{count} artefact(s)",
      "buildFailed": "The evidence pack could not be built",
      "hashChanged": "Rebuilt — the manifest hash differs from the certified one",
      "download": "Download the pack",
      "downloadFailed": "The evidence pack could not be downloaded",
      "rows": "{count} row(s)",
      "emptyTitle": "No evidence yet",
      "emptyDescription": "Build the pack to generate the run manifest, the sign-off register and the period's reconciliations."
    },
    "signoffs": {
      "title": "Sign-offs",
      "description": "Who signed what, and the position they held when they signed it.",
      "line": "{who} — {kind}"
    },
    "calendar": {
      "listTitle": "Close calendars",
      "listDescription": "A calendar is a close plan: a task graph and a working-day target. One active calendar per legal entity per cadence.",
      "loadFailed": "Close calendars could not be loaded",
      "create": "New calendar",
      "createTitle": "New close calendar",
      "createDescription": "Give it a code and a cadence, then build its task graph.",
      "created": "Close calendar created",
      "createFailed": "The close calendar could not be created",
      "code": "Code",
      "name": "Name",
      "scope": "Cadence",
      "targetWorkingDays": "Target days",
      "targetHint": "Working days after period end, counted through the business calendar so a target never lands on a holiday.",
      "templates": "Tasks",
      "active": "Active",
      "inactive": "Inactive",
      "tableLabel": "Close calendars",
      "emptyTitle": "No close calendars",
      "emptyDescription": "Create one, then seed the default task set to start from a working month-end plan."
    },
    "templates": {
      "title": "Task templates — {code}",
      "description": "The plan a run instantiates. Edits here never restate an open run, which is what makes changing the plan mid-month safe.",
      "loadFailed": "The calendar could not be loaded",
      "gridTitle": "Templates",
      "gridDescription": "Sequence is presentation; the graph is what decides order. A task waits on everything it depends on.",
      "addRow": "Add a task",
      "removeRow": "Remove",
      "emptyTitle": "No tasks in this calendar",
      "emptyDescription": "Seed the defaults for a working month-end plan, or add tasks one at a time.",
      "seedDefaults": "Seed the default plan",
      "seeded": "Default plan seeded",
      "seedFailed": "The default plan could not be seeded",
      "saved": "Task templates saved",
      "saveFailed": "The task templates could not be saved",
      "cycleDetected": "These tasks depend on each other in a loop: {codes}. Break the loop before saving.",
      "invalidRows": "Every task needs a code and a name, and a readiness, action or obligation task needs the key it binds to.",
      "seq": "Seq",
      "code": "Code",
      "name": "Name",
      "kind": "Kind",
      "binding": "Bound to",
      "dueOffset": "Due +days",
      "flags": "Flags",
      "dependsOn": "Depends on",
      "mandatory": "Mandatory",
      "evidence": "Evidence",
      "readinessKey": "Readiness key",
      "actionKey": "Action key",
      "obligationKind": "Obligation kind",
      "manualBinding": "Signed off by hand",
      "addDependency": "Add a dependency",
      "removeDependency": "Remove the dependency on {code}"
    },
    "anomaly": {
      "driver": {
        "balanceSpike": "The movement of {movement} is {z} standard deviations {direction} the account's usual {mean}.",
        "signFlip": "The closing balance of {closingBalance} has swapped from {from} to {to} after {stablePeriods} periods on the same side.",
        "dormantActivity": "The account had no activity for {silentPeriods} periods and now carries {currentLines} lines worth {grossActivity}.",
        "roundAmountJournal": "The journal total of {total} is an exact multiple of {roundUnit}.",
        "unusualPreparer": "Nobody who prepared this has prepared to this account before; {distinctPreparers} others have, across {priorEntries} entries.",
        "weekendPost": "Posted on {weekday} {postedOn} at {postedAt}, which is not a working day."
      }
    },
    "ft13": {
      "common": {
        "legalEntity": "Legal entity",
        "allPeriods": "All periods",
        "you": "You"
      },
      "routeTitles": {
        "certifications": "Close certifications",
        "reconciliation": "Sub-ledger reconciliation",
        "evidencePacks": "Close evidence packs",
        "cycleAnalysis": "Close cycle analysis",
        "statements": "Financial statements",
        "statement": "Financial statement set"
      },
      "reconTypes": {
        "bank": "Bank",
        "ap": "Accounts payable",
        "ar": "Accounts receivable",
        "inventory": "Inventory",
        "fixed_assets": "Fixed assets",
        "run": "Close run"
      },
      "certify": {
        "action": "Certify a reconciliation",
        "title": "Certify a reconciliation",
        "description": "A personal attestation that this reconciliation is complete and correct, recorded with your name, the time and the evidence it rests on. It requires a second factor.",
        "hint": "You may not certify a reconciliation you prepared, and a sub-ledger that disagrees with its control account cannot be certified until the difference is cleared or accepted on its task.",
        "type": "Reconciliation",
        "evidence": "Evidence",
        "evidenceHint": "The tie-out the attestation rests on: PDF, image, spreadsheet, Word or CSV, up to {max} MB. It is kept with the close run and goes into the evidence pack.",
        "note": "Statement",
        "noteHint": "Optional. What you checked, in your own words.",
        "confirm": "Certify",
        "certified": "Reconciliation certified",
        "failed": "The reconciliation could not be certified",
        "uploadFailed": "The evidence file could not be stored",
        "unavailable": {
          "certified": "Already certified on this close run.",
          "preparer": "You prepared this reconciliation, so somebody else has to certify it.",
          "sole_preparer": "Every task on this close was signed off by you, so this reconciliation needs a second person to certify it.",
          "no_preparer": "Nobody has signed off any task on this close yet, so there is no prepared work to certify.",
          "not_reconciled": "The sub-ledger does not agree with its control account. Clear the difference, or accept it on the close task with a reason.",
          "not_entitled": "This sub-ledger's module is not in your plan, so there is nothing to certify."
        },
        "errors": {
          "sod": "You prepared this reconciliation, so you may not also certify it. Somebody else has to.",
          "notReady": "The sub-ledger no longer agrees with its control account, so it cannot be certified as complete and correct. Refresh the figures and clear the difference first.",
          "already": "Somebody has already certified this reconciliation on this close run. The screen has been refreshed.",
          "uploadRefused": "The evidence file could not be attached to this close run. Ask an administrator to check that certification evidence can be uploaded.",
          "evidenceInvalid": "The evidence file was not accepted. Choose the file again and retry."
        }
      },
      "recon": {
        "title": "Sub-ledger reconciliation",
        "description": "Each sub-ledger against its control accounts in the general ledger, with every difference itemised by account and a drill-down to the entries behind it.",
        "loadFailed": "The reconciliation could not be computed",
        "chooseDescription": "The reconciliation is computed for one legal entity's fiscal period. Pick both and every sub-ledger is compared.",
        "state": "State",
        "reconciled": "Reconciled",
        "notReconciled": "Differences",
        "differences": "Sub-ledgers that disagree",
        "blocksClose": "{count} sub-ledger(s) disagree with the general ledger. The period close is refused until each is cleared or accepted.",
        "noRun": "This period has no open close run, so certifications cannot be recorded yet.",
        "noRunLink": "Open a close run",
        "onRun": "Certifications are recorded on close run {run}.",
        "emptyTitle": "No sub-ledgers to compare",
        "emptyDescription": "None of the sub-ledgers that keep a control account is in use for this legal entity.",
        "skipped": "Not in plan",
        "failed": "Could not compare",
        "agrees": "Agrees",
        "disagrees": "Disagrees",
        "skippedDetail": "This sub-ledger's module is not in your plan. It is reported so nothing is hidden, and it never blocks the close.",
        "subLedgerBalance": "Sub-ledger",
        "controlBalance": "General ledger",
        "difference": "Difference",
        "accountsDiffering": "Accounts differing",
        "basis": "Compared as at",
        "basisNow": "Now (the sub-ledger keeps no history)",
        "basisAsOf": "{date}",
        "certifiedBy": "Certified by {who} at {at}. Evidence: {file}.",
        "accountsCaption": "{subledger} control accounts",
        "account": "Account",
        "role": "Role",
        "drillDown": "Entries",
        "roles": {
          "control": "Control",
          "cost": "Cost",
          "accumulated_depreciation": "Accumulated depreciation"
        }
      },
      "certifications": {
        "title": "Close certifications",
        "description": "Every reconciliation and close certification: who attested, the position they held, when, and the evidence it rests on.",
        "anyType": "Any type",
        "type": "Type",
        "loadFailed": "The certifications could not be loaded",
        "emptyTitle": "No certifications yet",
        "emptyDescription": "A certification appears here once a reconciliation owner certifies a reconciliation, or a close run is certified.",
        "certifiedBy": "Certified by",
        "certifiedAt": "Certified at",
        "statement": "Statement",
        "evidence": "Evidence",
        "run": "Close run",
        "packIsEvidence": "The evidence pack"
      },
      "packs": {
        "title": "Close evidence packs",
        "description": "The archived evidence of each close: certifications, reconciliations and approvals, hashed so the attestation means something.",
        "loadFailed": "The evidence packs could not be loaded",
        "emptyTitle": "No evidence packs yet",
        "emptyDescription": "A pack is archived when a close run is certified, or when somebody builds one from the close cockpit.",
        "register": "All evidence packs",
        "run": "Close run",
        "certified": "Certified",
        "manifestHash": "Certified hash",
        "archive": "Archive",
        "parts": "Parts",
        "reconCertifications": "Reconciliation certifications",
        "match": "Matches certification",
        "actions": "Actions",
        "noHash": "Not certified",
        "noArchive": "Not stored",
        "chainBroken": "audit chain did not verify",
        "verify": "Verify",
        "verifyHint": "Rebuild the pack from the ledger and compare its manifest hash with the one recorded at certification.",
        "verifyFailed": "The evidence pack could not be verified",
        "state": {
          "matches": "Matches",
          "differs": "Differs",
          "uncertified": "No certified hash",
          "notVerified": "Not verified"
        }
      },
      "cycle": {
        "title": "Close cycle analysis",
        "description": "Days to close by period, against each close's own target, with the trend and the tasks that recur late.",
        "allYears": "All years",
        "fiscalYear": "Fiscal year",
        "loadFailed": "The cycle analysis could not be computed",
        "closedCount": "Closes certified",
        "onTargetCount": "On target",
        "averageDays": "Average days to close",
        "averageTarget": "Average target days",
        "trendLabel": "Trend",
        "trend": {
          "improving": "Improving",
          "worsening": "Worsening",
          "flat": "Flat",
          "insufficient_data": "Not enough closes yet"
        },
        "trendDelta": "{days} day(s) against the earlier closes",
        "peerNote": "Peer benchmarks are not shown: comparing with other organisations would read data across the tenant boundary.",
        "periodsTitle": "Days to close by period",
        "periodsDescription": "Calendar days from period end to certification, on your organisation's clock. An open close shows the days elapsed so far.",
        "emptyTitle": "No closes to analyse",
        "emptyDescription": "Open and certify a close run; its days to close then appear here.",
        "periodEnd": "Period end",
        "days": "Days to close",
        "targetDays": "Target days",
        "variance": "Against target",
        "overdueTasks": "Overdue tasks",
        "bar": "Days, as a bar",
        "stillOpen": "This close is not yet certified",
        "elapsedSoFar": "{days} so far",
        "late": "{days} day(s) late",
        "early": "{days} day(s) early",
        "onTheDay": "On the day",
        "bottlenecksTitle": "Recurring bottlenecks",
        "bottlenecksDescription": "The tasks that most often finished after their own due date across the closes analysed.",
        "noBottlenecksTitle": "No recurring delays",
        "noBottlenecksDescription": "No task finished late often enough to be called a bottleneck.",
        "task": "Task",
        "runs": "Closes",
        "averageAfterEnd": "Average days after period end",
        "lateCount": "Times late",
        "averageLate": "Average days late",
        "generatedAt": "Computed {at}"
      },
      "statements": {
        "title": "Financial statements",
        "description": "Profit and loss, balance sheet, cash flow and equity movement for each legal entity and period, as numbered versions. A published version is never changed.",
        "generate": "Generate statements",
        "loadFailed": "The statement sets could not be loaded",
        "loadOneFailed": "This statement set could not be loaded",
        "emptyTitle": "No statements generated yet",
        "emptyDescription": "Generate a set for a period at any time to preview it. It can be published once the period is closed, by somebody other than the person who generated it.",
        "setNo": "Set",
        "version": "Version",
        "compareLabel": "Comparative",
        "compareHint": "Adds a comparative column to the profit and loss, balance sheet and cash flow.",
        "generatedAt": "Generated",
        "publishedAt": "Published",
        "statuses": {
          "generated": "Generated",
          "published": "Published",
          "superseded": "Superseded"
        },
        "compare": {
          "none": "None",
          "prior_period": "Prior period",
          "prior_year": "Prior year"
        },
        "generated": "Statements generated",
        "versionOf": "Version {version} · {setNo}",
        "generateFailed": "The statements could not be generated",
        "generateTitle": "Generate financial statements",
        "generateDescription": "Builds the four statements from the ledger as a new version. An earlier version is never replaced.",
        "generateHint": "You can generate at any time. Publishing needs the period closed, and somebody other than you.",
        "detailTitle": "Statements {setNo}",
        "detailDescription": "{period} · {entity} · version {version}",
        "downloadPdf": "Download PDF",
        "downloadXlsx": "Download XLSX",
        "downloadFailed": "The statements could not be downloaded",
        "newVersion": "Generate a new version",
        "publish": "Publish",
        "publishTitle": "Publish these statements",
        "publishDescription": "Publishing makes this version final, replaces the period's earlier published version, archives it with the close evidence pack and sends it to the audience.",
        "publishHint": "Each recipient is notified with a link back to this page.",
        "published": "Statements published",
        "publishFailed": "The statements could not be published",
        "audience": "Audience",
        "audiences": {
          "executive": "Executive",
          "finance": "Finance",
          "audit": "Audit"
        },
        "audienceHints": {
          "executive": "The CFO and tenant administrators",
          "finance": "The CFO, finance managers and accountants",
          "audit": "The auditors"
        },
        "errors": {
          "sod": "You generated this version, so somebody else has to publish it.",
          "periodNotClosed": "Statements are published only once the period is closed. This period is {status}. Close the period, then publish.",
          "stale": "The ledger no longer gives these figures, for example after a late posting. Generate a new version and publish that one.",
          "illegalTransition": "This version can no longer be published: it has been published or replaced, or a newer version was published first. The page has been refreshed."
        },
        "notes": {
          "generator": "You generated this version, so publishing it needs a second person.",
          "newerPublished": "A newer version of this period has already been published. Generate a new version to publish different figures.",
          "periodOpen": "This period is {status}. Statements are published only once the period is closed.",
          "published": "Published to {audience} by {who} at {at}; sent to {count} recipient(s).",
          "superseded": "Replaced by a later published version at {at}.",
          "openLatest": "Open the latest"
        },
        "factsTitle": "This version",
        "basis": "Basis",
        "contentHash": "Content hash",
        "evidence": "Evidence pack",
        "historyTitle": "Version history",
        "historyDescription": "Every version of this legal entity's period, newest first.",
        "historyFailed": "The version history could not be loaded.",
        "kinds": {
          "income": "Profit and loss",
          "balance": "Balance sheet",
          "cashFlow": "Cash flow",
          "equity": "Equity movement"
        },
        "amount": "Amount ({currency})",
        "comparative": "Comparative",
        "variance": "Variance",
        "sectionTotal": "Total {section}",
        "noStatementsTitle": "No statements in this set",
        "noStatementsDescription": "The set was stored without statement data. Generate a new version.",
        "equityUnreconciled": "The equity movement does not agree with the balance sheet. Difference:",
        "equityColumns": {
          "opening": "Opening",
          "movement": "Movement",
          "yearEnd": "Year-end transfer",
          "closing": "Closing"
        },
        "equityTotals": {
          "opening": "Opening equity",
          "netProfit": "Net profit",
          "otherMovements": "Other movements",
          "closing": "Closing equity"
        }
      }
    },
    "cockpit": {
      "assignee": "Assigned to user #{id}",
      "ownerPosition": "Owned by position #{id}",
      "userRef": "User #{id}",
      "staleTitle": "Somebody else changed this close first",
      "staleDetail": "The run has been reloaded with their change. Check it, then do what you meant to again — nothing of yours was saved over theirs.",
      "period": {
        "title": "Period",
        "description": "Soft close, close or lock the run's fiscal period. The close is refused while a blocking check stands, and the refusal lists them.",
        "status": "Period status",
        "actions": {
          "soft_close": "Soft close",
          "close": "Close period",
          "permanent_close": "Lock period"
        },
        "blockersHint": "{count} blocking check(s) are failing on this run. Closing the period will be refused until they are cleared or accepted on their tasks.",
        "locked": "This period is locked. Nothing can be posted into it, and it cannot be reopened.",
        "noAccess": "You can see this run, but not its period's controls. Ask somebody with period-close authority to close it."
      },
      "addTask": {
        "action": "Add task",
        "title": "Add a task to this run",
        "description": "For work this month needs that the calendar did not plan. The calendar itself is not changed.",
        "name": "Name",
        "module": "Module",
        "dueOffset": "Due + days",
        "dueOffsetHint": "Working days after period end. Leave empty for no due date.",
        "dueOffsetInvalid": "Enter a whole number of days",
        "mandatoryHint": "A mandatory task blocks certification until it is satisfied",
        "evidence": "Requires evidence",
        "evidenceHint": "Completing it then needs an evidence statement",
        "dependsOn": "Waits on",
        "dependsOnHint": "Only tasks already on this run. A loop is refused.",
        "noTasks": "This run has no tasks yet, so the new one waits on nothing.",
        "binding": {
          "readinessKey": "Readiness key",
          "actionKey": "Action key",
          "obligationKind": "Obligation kind"
        },
        "added": "Task added",
        "failed": "The task could not be added"
      },
      "board": {
        "blockingChecks": "Blocking checks",
        "nextTask": "Next task",
        "emptyTitle": "No closes open",
        "emptyDescription": "Open a close run for the period you are closing under Close runs; every entity's open close then appears here."
      }
    },
    "yearEnd": {
      "routeTitle": "Year-end close plan",
      "title": "Year-end close plan",
      "description": "The income-summary entry that closes a fiscal year's income and expense accounts into retained earnings.",
      "recompute": "Recompute",
      "scope": "Legal entity and fiscal year",
      "company": "Legal entity",
      "companyPlaceholder": "Choose a legal entity",
      "fiscalYear": "Fiscal year",
      "fiscalYearPlaceholder": "Choose a fiscal year",
      "yearAllClosed": "All periods closed",
      "yearOpen": "{count} period(s) still open",
      "retainedEarnings": "Retained earnings account",
      "retainedEarningsHint": "Leave empty to use the equity account your chart names retained earnings.",
      "retainedEarningsPlaceholder": "Resolved from the chart",
      "noPeriods": "This legal entity has no fiscal periods yet. Set up its fiscal calendar before closing a year.",
      "chooseScope": "Choose a legal entity and a fiscal year to compute the close plan.",
      "notClosedTitle": "The fiscal year is not fully closed",
      "notClosedBody": "Close every period of the year before computing its close plan.",
      "accountNeeded": "Choose the retained earnings account: the chart names none, or more than one, so the server will not guess.",
      "loadFailed": "The close plan could not be computed",
      "facts": {
        "window": "Fiscal year window",
        "entryDate": "Entry date",
        "memo": "Memo",
        "retainedEarnings": "Retained earnings",
        "totalIncome": "Total income",
        "totalExpense": "Total expense",
        "netIncome": "Net income",
        "check": "Balance check"
      },
      "balanced": "Balanced",
      "unbalanced": "Not balanced",
      "computedNotPosted": "This plan is computed, never posted. Every income and expense account is zeroed at its year-end balance and the net result moves to retained earnings; the general ledger posts it as a journal entry.",
      "caption": "Proposed year-end close entry lines",
      "columns": {
        "line": "Line",
        "account": "Account",
        "description": "Description",
        "debit": "Debit",
        "credit": "Credit"
      },
      "empty": "No income or expense account carries a balance at the year end, so there is nothing to close.",
      "totals": "Totals",
      "generatedAt": "Computed at",
      "exportDone": "Close plan exported",
      "exportDoneDetail": "{filename} has been downloaded. The export is recorded in the audit trail.",
      "exportFailed": "The close plan could not be exported"
    }
  },
  "cost": {
    "nav": {
      "label": "Cost accounting sections",
      "pools": "Pools",
      "drivers": "Drivers",
      "cycles": "Cycles",
      "runs": "Runs",
      "rates": "Absorption rates",
      "reports": "Reports",
      "quantities": "Driver quantities",
      "absorptionVariance": "Absorption variance",
      "profitability": "Profitability"
    },
    "routeTitles": {
      "pools": "Cost pools",
      "drivers": "Allocation drivers",
      "quantities": "Driver quantities",
      "cycles": "Allocation cycles",
      "cycle": "Allocation cycle",
      "runs": "Allocation runs",
      "run": "Allocation run",
      "rates": "Absorption rates",
      "reports": "Cost reports",
      "absorptionVariance": "Absorption variance",
      "profitability": "Cost object profitability"
    },
    "common": {
      "period": "Period",
      "delete": "Delete",
      "edit": "Edit",
      "actions": "Actions",
      "stale": "Somebody else changed this record while you had it open. It has been reloaded — check what changed, then make your change again."
    },
    "filters": {
      "anyKind": "Any kind",
      "anyMethod": "Any method",
      "anyStatus": "Any status",
      "anyCycle": "Any cycle",
      "anyPeriod": "Any period",
      "anyObjectType": "Every object type"
    },
    "poolKinds": {
      "service": "Service",
      "overhead": "Overhead",
      "primary": "Primary"
    },
    "methods": {
      "direct": "Direct",
      "step_down": "Step-down",
      "reciprocal": "Reciprocal"
    },
    "methodHints": {
      "direct": "Service pools go straight to final objects; mutual consumption is ignored",
      "step_down": "Pools allocate in step order and never receive again once allocated",
      "reciprocal": "Mutual consumption is solved simultaneously and leaves an iteration trace"
    },
    "cycleStatuses": {
      "draft": "Draft",
      "active": "Active",
      "archived": "Archived"
    },
    "runStatuses": {
      "draft": "Draft",
      "calculated": "Calculated",
      "posted": "Posted",
      "reversed": "Reversed",
      "failed": "Failed"
    },
    "rateStatuses": {
      "draft": "Draft",
      "active": "Active",
      "superseded": "Superseded"
    },
    "objectTypes": {
      "cost_center": "Cost centre",
      "profit_center": "Profit centre",
      "department": "Department",
      "business_unit": "Business unit",
      "division": "Division",
      "branch": "Branch",
      "project": "Project",
      "item": "Item",
      "company": "Legal Entity",
      "pool": "Cost pool"
    },
    "objectRef": {
      "type": "Object type",
      "object": "Object",
      "internalHint": "Sending to a pool is an internal flow and never posts to the ledger",
      "idPlaceholder": "Record id"
    },
    "pool": {
      "title": "Cost pools",
      "description": "Where cost accumulates before anybody decides which object bears it.",
      "code": "Pool",
      "name": "Name",
      "kind": "Kind",
      "kindHint": "A service pool may send to another pool; an overhead pool absorbs onto objects",
      "object": "Bound object",
      "clearingAccount": "Clearing account",
      "clearingHint": "The pool's own balance sheet position while cost sits in it",
      "absorbedAccount": "Absorbed account",
      "absorbedHint": "Credited when cost leaves the pool onto its receivers",
      "active": "Active",
      "inactive": "Inactive",
      "sources": "Sources",
      "create": "New pool",
      "createTitle": "Create a cost pool",
      "createDescription": "A pool needs a clearing account and an absorbed account before it can take part in a cycle.",
      "createHint": "Add the accounts that feed the pool once it exists, from the Sources action on its row.",
      "created": "Pool created",
      "saveFailed": "The pool could not be saved",
      "loadFailed": "The pool list could not be loaded",
      "searchHint": "Code or name",
      "tableLabel": "Cost pools",
      "emptyTitle": "No cost pools yet",
      "emptyDescription": "Create a pool for each service department and overhead group whose cost has to be spread.",
      "deleteTitle": "Delete this pool?",
      "deleteDescription": "{code} will be removed. A pool named by a cycle step cannot be deleted.",
      "deleteFailed": "The pool could not be deleted",
      "deleted": "Pool deleted"
    },
    "sources": {
      "title": "Sources for {code}",
      "description": "Which accounts' movement accumulates in this pool, and in which direction.",
      "account": "Account",
      "sign": "Direction",
      "signAdd": "Adds to the pool",
      "signDeduct": "Deducts from the pool",
      "add": "Add a source",
      "remove": "Remove this source",
      "duplicate": "Already listed",
      "hint": "The pool's balance is the movement on these accounts for the period, computed at read time and never stored.",
      "saved": "Sources saved",
      "saveFailed": "The sources could not be saved",
      "loadFailed": "The sources could not be loaded",
      "emptyTitle": "No sources yet",
      "emptyDescription": "A pool with no sources always has a zero balance, and a run over it allocates nothing."
    },
    "balance": {
      "title": "Balance of {code}",
      "description": "Movement on the pool's source accounts for the chosen period.",
      "account": "Account",
      "sign": "Direction",
      "debit": "Adds",
      "credit": "Deducts",
      "movement": "Account movement",
      "contribution": "Contribution",
      "primaryCost": "Primary cost",
      "loadFailed": "The balance could not be computed",
      "emptyTitle": "Nothing in this pool",
      "emptyDescription": "No movement on the pool's source accounts in this period."
    },
    "driver": {
      "title": "Allocation drivers",
      "description": "The measures cost is spread by — square metres, room nights, headcount, machine hours.",
      "code": "Driver",
      "name": "Name",
      "uom": "Unit",
      "uomHint": "A label on the report, not a convertible unit of measure",
      "active": "Active",
      "inactive": "Inactive",
      "quantities": "Quantities",
      "create": "New driver",
      "createTitle": "Create an allocation driver",
      "createDescription": "A driver carries no figures of its own; the quantities are keyed per period.",
      "created": "Driver created",
      "saveFailed": "The driver could not be saved",
      "loadFailed": "The driver list could not be loaded",
      "searchHint": "Code or name",
      "tableLabel": "Allocation drivers",
      "emptyTitle": "No drivers yet",
      "emptyDescription": "Create a driver for each measure a cost is spread by, then key its quantities each period.",
      "deleteTitle": "Delete this driver?",
      "deleteDescription": "{code} will be removed.",
      "deleteHint": "A driver named by a cycle step cannot be deleted; retire the step first.",
      "deleteFailed": "The driver could not be deleted",
      "deleted": "Driver deleted"
    },
    "quantities": {
      "title": "Quantities for {driver}",
      "description": "One figure per cost object per period. Nothing here saves until you say so.",
      "objectType": "Keyed against",
      "object": "Object",
      "quantity": "Quantity",
      "note": "Note",
      "entered": "Entered",
      "ofRows": "of {total} objects",
      "save": "Save quantities",
      "saved": "Quantities saved",
      "savedDetail": "{count} figure(s) recorded",
      "saveFailed": "The quantities could not be saved",
      "loadFailed": "The quantities could not be loaded",
      "tableLabel": "Driver quantities by cost object",
      "cellLabel": "Quantity for {object}",
      "noteLabel": "Note for {object}",
      "emptyTitle": "No cost objects to key",
      "emptyDescription": "This legal entity has no units of the chosen kind. Create them under Organization first.",
      "unsaved": "{count} unsaved change(s)",
      "invalid": "{count} cell(s) are not a number",
      "keyboardHint": "Enter or ↓ moves down, ↑ moves up, Ctrl+Home and Ctrl+End jump to the ends.",
      "import": "Import CSV",
      "importTitle": "Import driver quantities",
      "importDescription": "For object sets too large to key by hand — items, projects, a full property.",
      "importFormat": "One row per object: object type, object code or id, quantity, optional note.",
      "csv": "CSV",
      "replace": "Replace the period",
      "replaceHint": "On: every existing quantity for the period is removed first. Off: rows are merged.",
      "imported": "Quantities imported",
      "importedDetail": "{imported} imported, {rejected} rejected",
      "importFailed": "The import could not be completed"
    },
    "cycle": {
      "title": "Allocation cycles",
      "description": "An ordered set of steps and the method that decides how mutual consumption is treated.",
      "code": "Cycle",
      "name": "Name",
      "method": "Method",
      "steps": "Steps",
      "journalType": "Journal type",
      "journalTypeHint": "The GL journal type the run posts under; resolved by code",
      "convergence": "Convergence",
      "tolerance": "Tolerance {value}",
      "maxIterations": "at most {count} rounds",
      "maxIterationsLabel": "Maximum rounds",
      "maxIterationsHint": "Hitting this limit refuses the run rather than posting an unsettled answer",
      "toleranceLabel": "Convergence tolerance",
      "toleranceHint": "The solve stops when the largest change in a round falls below this",
      "postAutomatically": "Post automatically",
      "postAutomaticallyHint": "The scheduled run posts without waiting for somebody to confirm it",
      "create": "New cycle",
      "createTitle": "Create an allocation cycle",
      "createDescription": "Pick the method now; it decides whether the run produces an iteration trace.",
      "createHint": "The cycle starts in draft. Add its steps, validate it, then activate it.",
      "created": "Cycle created",
      "activate": "Activate",
      "activated": "Cycle activated",
      "activateFailed": "The cycle could not be activated",
      "headerTitle": "Cycle",
      "headerSaved": "Cycle saved",
      "saveFailed": "The cycle could not be saved",
      "loadFailed": "The cycle could not be loaded",
      "tableLabel": "Allocation cycles",
      "emptyTitle": "No allocation cycles yet",
      "emptyDescription": "A cycle says which pool sends to whom, in what order, by which driver.",
      "editorTitle": "Cycle {code}",
      "editorDescription": "Steps run in sequence order; the graph, not the sequence number, is what the solver reads."
    },
    "steps": {
      "title": "Steps",
      "description": "Each step sends one pool's cost to its receivers, by driver or by fixed percentage.",
      "pool": "Sending pool",
      "basis": "Basis",
      "basisDriver": "By driver",
      "basisDriverHint": "Shares follow the driver quantities keyed for the period",
      "basisFixed": "Fixed percentage",
      "basisFixedHint": "Shares are the percentages entered on each receiver",
      "driver": "Driver",
      "excludeSelf": "Exclude the sender",
      "excludeSelfHint": "A pool does not receive its own cost back",
      "fixedPercent": "Percent",
      "fixedPercentIgnored": "Ignored on a driver basis",
      "receiversDriver": "Receivers — the driver decides each share",
      "receiversFixed": "Receivers — percentages must total 100",
      "addReceiver": "Add a receiver",
      "removeReceiver": "Remove this receiver",
      "add": "Add a step",
      "remove": "Remove this step",
      "moveUp": "Move this step earlier",
      "moveDown": "Move this step later",
      "empty": "This cycle has no steps yet. A cycle with no steps allocates nothing.",
      "save": "Save steps",
      "saved": "Steps saved",
      "saveFailed": "The steps could not be saved",
      "missingPool": "Step {seq} has no sending pool",
      "missingDriver": "Step {seq} is on a driver basis but names no driver",
      "missingReceivers": "Step {seq} is on a fixed percentage but has no receivers",
      "missingReceiverObject": "Step {seq} has a receiver with no object chosen"
    },
    "validate": {
      "title": "Validation",
      "description": "Run this before a month-end, not during one.",
      "run": "Validate",
      "periodHint": "With a period, driver quantities are checked too",
      "shapeOnly": "Shape only",
      "ok": "This cycle is valid.",
      "notRun": "Not validated yet. Run the check to see whether this cycle can allocate.",
      "atStep": "at step {seq}",
      "failed": "The validation could not be run"
    },
    "run": {
      "listTitle": "Allocation runs",
      "listDescription": "Calculating is a preview an accountant repeats; posting is a ledger act.",
      "title": "Run {runNo}",
      "description": "Cycle {cycle} · period {period}",
      "runNo": "Run",
      "draftNo": "Not numbered",
      "cycle": "Cycle",
      "method": "Method",
      "converged": "Converged",
      "yes": "Yes",
      "no": "No",
      "notApplicable": "Not applicable",
      "roundsShort": "{count} rounds",
      "iterations": "Rounds",
      "totalPrimary": "Primary cost",
      "totalAbsorbed": "Absorbed",
      "residual": "Residual",
      "residualBreach": "This run's residual is not zero. Cost has gone missing between the pools and their receivers, and the run must not be posted.",
      "journal": "Posted as journal {entryNo}",
      "note": "Note",
      "calculate": "Calculate",
      "calculateTitle": "Calculate an allocation run",
      "calculateDescription": "This produces figures to look at. Nothing reaches the ledger until you post it.",
      "calculateHint": "Recalculating an existing run for the same cycle and period replaces its figures.",
      "calculated": "Run calculated",
      "calculateFailed": "The run could not be calculated",
      "recalculate": "Replace an existing run",
      "recalculateHint": "Without this, a second calculation for the same cycle and period is refused",
      "noActiveCycle": "No cycle in this legal entity is active. Activate one before calculating a run.",
      "post": "Post",
      "postTitle": "Post this allocation run",
      "postDescription": "The run's allocations become a journal in the general ledger.",
      "postHint": "Internal pool-to-pool flows are not posted; only cost landing on a final object is.",
      "posted": "Run posted",
      "postFailed": "The run could not be posted",
      "reverse": "Reverse",
      "reverseTitle": "Reverse this allocation run",
      "reverseDescription": "A mirror journal is posted; neither the run nor its journal is deleted.",
      "reverseReason": "Reason",
      "reverseOn": "Reversal date",
      "reverseOnHint": "Left empty, the reversal posts on today's business date",
      "reversed": "Run reversed",
      "reverseFailed": "The run could not be reversed",
      "alreadyPosted": "This run is already in the ledger.",
      "alreadyReversed": "This run has been reversed.",
      "failed": "This run failed to calculate and cannot be posted.",
      "notCalculated": "This run has not been calculated yet.",
      "blockedNotConverged": "This run did not converge within its cycle's iteration limit, so its figures are not a settled answer and it cannot be posted.",
      "blockedResidual": "This run has a residual of {residual}. Posting is withheld until it is zero.",
      "blockedPermission": "You do not hold the permission to post an allocation run.",
      "exported": "Allocations exported",
      "tabsLabel": "Run sections",
      "tabTrace": "Iteration trace",
      "tabMatrix": "Flow matrix",
      "tabAllocations": "Allocations",
      "tabVariance": "Absorption variance",
      "tableLabel": "Allocation runs",
      "loadFailed": "The run could not be loaded",
      "emptyTitle": "No allocation runs yet",
      "emptyDescription": "Calculate a run for an active cycle and a period to see where the cost lands."
    },
    "trace": {
      "title": "Iteration trace",
      "description": "Each round recomputes every service pool from the previous round's totals. The trace is how a reciprocal answer becomes checkable.",
      "round": "Round",
      "worstDelta": "Largest change",
      "movement": "Settling",
      "rounds": "{count} rounds",
      "settledUnder": "tolerance {tolerance}",
      "finalDelta": "final change {delta}",
      "converged": "Converged",
      "notConverged": "Did not converge",
      "notConvergedHint": "The solve hit the cycle's iteration limit. Raise the limit, loosen the tolerance, or look for a service loop with no way out.",
      "showEveryPool": "Every pool",
      "hiddenPools": "{count} further pool(s) hidden",
      "readingHint": "Every figure here is the engine's own. Nothing on this screen is recomputed in the browser.",
      "tableLabel": "Solver iterations by pool",
      "emptyTitle": "No iteration trace",
      "emptyDescription": "Only a reciprocal cycle iterates. Direct and step-down allocations resolve in one pass."
    },
    "matrix": {
      "title": "Flow matrix",
      "description": "Senders down the side, receivers across the top, posted amounts in the cells.",
      "sender": "Sender",
      "counts": "{senders} senders · {receivers} receivers",
      "showInternal": "Internal flows ({count})",
      "internalHidden": "Pool-to-pool flows are hidden. They are real, but they never reach the general ledger.",
      "tableLabel": "Allocation flow matrix",
      "emptyTitle": "Nothing allocated",
      "emptyDescription": "This run moved no cost. Check the pool balances and the driver quantities for the period."
    },
    "allocations": {
      "step": "Step",
      "sender": "Sender",
      "receiver": "Receiver",
      "receiverType": "Receiver type",
      "internal": "Internal",
      "driverQuantity": "Driver quantity",
      "share": "Share",
      "exact": "Exact",
      "amount": "Posted",
      "tableLabel": "Run allocations",
      "emptyTitle": "No allocations",
      "emptyDescription": "This run produced no allocation rows."
    },
    "variance": {
      "title": "Absorption variance",
      "tab": "Absorption variance",
      "description": "The difference between cost applied at the budgeted rate and cost actually incurred.",
      "reportTitle": "Absorption variance",
      "reportDescription": "Spend is the pool costing more than budgeted; volume is the driver running at a different level.",
      "pool": "Pool",
      "applied": "Applied",
      "actual": "Actual",
      "spend": "Spend",
      "volume": "Volume",
      "total": "Total",
      "totalRow": "Total",
      "tableLabel": "Absorption variance by pool",
      "loadFailed": "The variance report could not be loaded",
      "emptyTitle": "No absorption variance",
      "emptyDescription": "No pool in this period has an active absorption rate."
    },
    "rates": {
      "title": "Absorption rates",
      "description": "The budgeted rate a pool applies cost at, fixed before the period rather than after it.",
      "pool": "Pool",
      "driver": "Driver",
      "budgetedCost": "Budgeted cost",
      "budgetedQuantity": "Budgeted quantity",
      "rate": "Rate",
      "rateOverride": "Rate override",
      "rateOverrideHint": "Leave empty and the server derives the rate. Fill it only for a board-approved rate.",
      "varianceAccount": "Variance account",
      "varianceAccountHint": "Where the spend and volume variances post",
      "activate": "Activate now",
      "activateHint": "An active rate supersedes any earlier rate for the same pool and period",
      "set": "Set a rate",
      "setTitle": "Set an absorption rate",
      "setDescription": "Enter the budget; the rate follows from it.",
      "serverComputesHint": "The rate is computed server-side from budgeted cost and quantity so that every applied figure agrees with it to the last place.",
      "saved": "Rate saved",
      "saveFailed": "The rate could not be saved",
      "loadFailed": "The rates could not be loaded",
      "tableLabel": "Absorption rates",
      "emptyTitle": "No absorption rates",
      "emptyDescription": "Without a rate a pool's cost is allocated as incurred, and there is no variance to report."
    },
    "profitability": {
      "tab": "Cost object profitability",
      "title": "Cost object profitability",
      "object": "Object",
      "objectType": "Object type",
      "revenue": "Revenue",
      "directCost": "Direct cost",
      "allocatedCost": "Allocated cost",
      "totalCost": "Total cost",
      "margin": "Margin",
      "marginPercent": "Margin %",
      "total": "Total",
      "from": "From",
      "to": "To",
      "pickRange": "Choose a date range",
      "pickRangeHint": "Profitability is computed over a range of business dates, not over a fiscal period.",
      "exported": "Profitability exported",
      "tableLabel": "Profitability by cost object",
      "loadFailed": "The profitability report could not be loaded",
      "emptyTitle": "Nothing to report",
      "emptyDescription": "No revenue or cost is tagged to a cost object in this range."
    },
    "reports": {
      "title": "Cost reports",
      "description": "What the allocation produced, read two ways.",
      "tabsLabel": "Cost report sections"
    },
    "quantityReport": {
      "title": "Driver quantities",
      "description": "What each cost object consumed of one driver, period by period. Capture a period's figures from the driver itself.",
      "driver": "Driver",
      "driverPlaceholder": "Choose a driver",
      "periods": "Periods shown",
      "periodsHint": "The most recent periods of the legal entity's fiscal calendar, oldest first",
      "objectType": "Object type",
      "object": "Cost object",
      "change": "Change on previous",
      "capture": "Capture quantities",
      "chooseTitle": "Choose a legal entity and a driver",
      "chooseDescription": "The report lists every cost object the driver was keyed against, one column per period.",
      "noDriversTitle": "No drivers in this legal entity",
      "noDriversDescription": "Create a driver under Drivers first, then capture its quantities each period.",
      "noPeriodsTitle": "No fiscal periods",
      "noPeriodsDescription": "Quantities are keyed per fiscal period. Generate this legal entity's periods under Period Control first.",
      "emptyTitle": "No quantities captured yet",
      "emptyDescription": "Nothing has been keyed for this driver in these periods. Use Capture quantities to key the latest one.",
      "loadFailed": "The driver quantities could not be loaded",
      "tableLabel": "Driver quantities by cost object and period",
      "up": "Up {delta}",
      "down": "Down {delta}",
      "flat": "Unchanged",
      "noPrior": "No prior figure"
    },
    "poolEdit": {
      "title": "Edit {code}",
      "description": "The pool code never changes. Changing an account affects runs calculated from now on, not runs already posted.",
      "active": "Active",
      "activeHint": "An inactive pool is left out of new runs",
      "saved": "Pool saved",
      "saveFailed": "The pool could not be saved"
    },
    "driverEdit": {
      "title": "Edit {code}",
      "description": "The driver code never changes. Quantities already keyed stay as they are.",
      "active": "Active",
      "activeHint": "An inactive driver cannot be chosen for a new cycle step",
      "saved": "Driver saved",
      "saveFailed": "The driver could not be saved"
    },
    "cycleDelete": {
      "action": "Delete",
      "title": "Delete this cycle?",
      "description": "{code} and its steps will be removed.",
      "hint": "A cycle with a live run cannot be deleted; reverse or abandon the run first. Posted runs keep their figures either way.",
      "deleted": "Cycle deleted",
      "failed": "The cycle could not be deleted"
    },
    "runExport": {
      "action": "Export CSV",
      "includeInternal": "Include pool-to-pool flows",
      "includeInternalHint": "Internal flows never posted; leave this off for a file that agrees with the ledger",
      "title": "Export this run",
      "description": "The server writes the run's flow matrix as CSV and records the export in the audit trail.",
      "done": "Run exported",
      "doneDetail": "{filename} downloaded",
      "failed": "The run could not be exported"
    },
    "absorptionReport": {
      "title": "Absorption variance",
      "description": "Applied cost against actual cost for one period, by pool, split into spend and volume.",
      "pool": "Pool",
      "anyPool": "Every pool",
      "chooseTitle": "Choose a legal entity and a period",
      "chooseDescription": "Absorption variance is reported for one fiscal period at a time."
    },
    "profitabilityReport": {
      "title": "Cost object profitability",
      "description": "Revenue less direct and allocated cost, per cost object, over a range of business dates."
    }
  },
  "expense": {
    "nav": {
      "label": "Expense sections",
      "claims": "Claims",
      "approvals": "Approvals",
      "travel": "Travel",
      "advances": "Advances",
      "cards": "Cards",
      "policies": "Policies",
      "cardAccounts": "Card accounts",
      "settings": "Settings",
      "payrollInclusions": "Payroll inclusions"
    },
    "routeTitles": {
      "claims": "Expense claims",
      "claim": "Expense claim",
      "approvals": "Expense approvals",
      "travel": "Travel requests",
      "advances": "Travel advances",
      "cards": "Card statements",
      "cardStatement": "Card statement",
      "policies": "Expense policies",
      "cardAccounts": "Corporate card accounts",
      "settings": "Expense settings",
      "payrollInclusions": "Payroll inclusions"
    },
    "claimStatuses": {
      "draft": "Draft",
      "submitted": "Submitted",
      "approved": "Approved",
      "rejected": "Rejected",
      "posted": "Posted",
      "cancelled": "Cancelled"
    },
    "policyOutcomes": {
      "ok": "Within policy",
      "warn": "Over, warned",
      "breach": "Over the limit",
      "overridden": "Overridden"
    },
    "paidBy": {
      "employee": "Employee paid",
      "card": "Company card",
      "advance": "From an advance"
    },
    "paidByHint": {
      "employee": "Reimbursed through an AP invoice against the employee's vendor record.",
      "card": "The legal entity already paid. It is a cost, not a reimbursement.",
      "advance": "Netted against money already advanced."
    },
    "limitKinds": {
      "per_line": "Per line",
      "per_day": "Per day",
      "per_claim": "Per claim",
      "per_month": "Per month"
    },
    "limitKindHints": {
      "per_line": "Judged against the line on its own.",
      "per_day": "Every line of this category on the same date, in this claim.",
      "per_claim": "The claim's subtotal for this category.",
      "per_month": "The employee's approved claims this calendar month, plus this one."
    },
    "breachActions": {
      "warn": "Warn",
      "block": "Block",
      "approve": "Route to authority"
    },
    "breachActionHints": {
      "warn": "Records the breach and lets the claim proceed to approval.",
      "block": "Refuses the line outright.",
      "approve": "Asks an authority to clear the excess before the claim is submitted."
    },
    "travelStatuses": {
      "draft": "Draft",
      "submitted": "Submitted",
      "approved": "Approved",
      "rejected": "Rejected",
      "cancelled": "Cancelled",
      "closed": "Closed"
    },
    "advanceStatuses": {
      "draft": "Draft",
      "submitted": "Submitted",
      "approved": "Approved",
      "paid": "Paid out",
      "partially_settled": "Partly settled",
      "settled": "Settled",
      "cancelled": "Cancelled"
    },
    "cardStatuses": {
      "open": "Open",
      "reconciled": "Reconciled",
      "closed": "Closed"
    },
    "cardLineStatuses": {
      "unmatched": "Unmatched",
      "matched": "Matched",
      "disputed": "Disputed",
      "personal": "Personal",
      "written_off": "Written off"
    },
    "matchKinds": {
      "exact": "Exact",
      "amount_date": "Amount and date",
      "amount_merchant": "Amount and merchant",
      "manual": "By hand"
    },
    "cardDispositions": {
      "personal": "Personal charge",
      "disputed": "Dispute it",
      "written_off": "Write it off"
    },
    "cardDispositionHints": {
      "personal": "The employee owes the legal entity. Posts to the employee receivable.",
      "disputed": "The issuer is being challenged. Nothing posts yet.",
      "written_off": "Absorbed as a cost with a reason."
    },
    "uom": {
      "km": "Kilometres",
      "mi": "Miles"
    },
    "claims": {
      "title": "Expense claims",
      "description": "What people spent, what the legal entity already paid, and what is owed back.",
      "detailDescription": "{no} · {employee}",
      "loadFailed": "Expense claims could not be loaded",
      "claim": "Claim",
      "claimTitle": "Title",
      "claimDate": "Date",
      "employee": "Employee",
      "draftNo": "Not numbered yet",
      "anyStatus": "Any status",
      "subtotal": "Subtotal",
      "taxTotal": "Tax",
      "total": "Total",
      "cardPaid": "Card paid",
      "advanceApplied": "Advance applied",
      "reimbursable": "Reimbursable",
      "splitHint": "Only the reimbursable figure is what the employee gets back. Card-paid lines are the legal entity's cost, and advance-applied lines are money already handed over.",
      "ownOnly": "You are seeing your own claims. Somebody who may approve claims sees their team's.",
      "note": "Note",
      "comment": "Comment",
      "create": "New claim",
      "createTitle": "New expense claim",
      "createDescription": "Give it a title and a date, then add the lines.",
      "created": "Claim created",
      "createFailed": "The claim could not be created",
      "numberedAtSubmit": "A claim gets its number when it is submitted, never while it is a draft.",
      "submitTitle": "Submit this claim",
      "submitDescription": "Policy is re-evaluated and the number is assigned.",
      "submitted": "Claim submitted",
      "submitFailed": "The claim could not be submitted",
      "overrideNeeded": "One or more lines are over a limit whose policy routes to an authority. Give a reason and the claim goes to whoever can clear the excess.",
      "overrideReason": "Override reason",
      "breachBanner": "{count} line(s) are over a limit. The badge on each says which.",
      "approveTitle": "Approve this claim",
      "approved": "Claim approved",
      "rejectTitle": "Reject this claim",
      "rejected": "Claim rejected",
      "decideFailed": "The decision could not be recorded",
      "post": "Post",
      "postTitle": "Post this claim",
      "postDescription": "Raises the payable and posts the card-paid half.",
      "postHint": "The reimbursable balance becomes an AP invoice against the employee's vendor record, so it ages, gets selected by a payment run and is paid by bank file like any other supplier invoice.",
      "postingDate": "Posting date",
      "postingDateHint": "Empty means the claim date.",
      "posted": "Claim posted",
      "postFailed": "The claim could not be posted",
      "notPayable": "This employee has no linked vendor record, so there is nothing to pay. Link one on the employee's profile — a vendor is a payee with bank details under dual approval, so it is not created automatically.",
      "becameInvoice": "Posted as supplier invoice {invoiceNo}.",
      "tableLabel": "Expense claims",
      "emptyTitle": "No expense claims",
      "emptyDescription": "Raise one for what you have spent. Add the lines, then submit — the number comes at submit."
    },
    "lines": {
      "title": "Lines",
      "description": "Every line is evaluated against policy on save, so the badge here is the same verdict the submit will make.",
      "category": "Category",
      "incurredOn": "Incurred",
      "merchant": "Merchant",
      "amount": "Amount",
      "distance": "Distance",
      "vehicleClass": "Vehicle",
      "paidBy": "Paid by",
      "policy": "Policy",
      "taxRecoverable": "Tax recoverable",
      "limitWas": "limit {limit}",
      "mileageCategory": "Mileage — computed from distance",
      "mileagePreview": "≈ {amount}",
      "mileageHint": "A mileage line's amount is computed by the server from the rate in force on the day it was incurred. The figure shown while you type is a preview against today's rate.",
      "addRow": "Add a line",
      "removeRow": "Remove",
      "saved": "Lines saved",
      "saveFailed": "The lines could not be saved",
      "emptyTitle": "No lines yet",
      "emptyDescription": "Add what you spent, one line per receipt."
    },
    "approvals": {
      "title": "Expense approvals",
      "description": "Claims awaiting your decision, with their lines beside them.",
      "loadFailed": "Claims awaiting approval could not be loaded",
      "awaiting": "Awaiting you",
      "preview": "Lines",
      "chooseTitle": "Choose a claim",
      "chooseDescription": "Its lines and their policy verdicts appear here, so you never have to leave this screen to decide.",
      "breachBanner": "{count} line(s) on this claim are over a limit.",
      "emptyTitle": "Nothing awaiting approval",
      "open": "Open the claim"
    },
    "travel": {
      "title": "Travel requests",
      "description": "The pre-approval an advance hangs off: where, when, and roughly how much.",
      "loadFailed": "Travel requests could not be loaded",
      "request": "Request",
      "draftNo": "Not numbered yet",
      "destination": "Destination",
      "purpose": "Purpose",
      "dates": "Dates",
      "departOn": "Departs",
      "returnOn": "Returns",
      "returnBeforeDepart": "The return cannot be before the departure.",
      "estimate": "Estimated cost",
      "estimateHint": "What the trip is expected to cost. It is what an approver is committing to.",
      "anyStatus": "Any status",
      "create": "New request",
      "createTitle": "New travel request",
      "createDescription": "A request gets its number when it is submitted.",
      "created": "Travel request created",
      "createFailed": "The travel request could not be created",
      "submitted": "Travel request submitted",
      "submitFailed": "The travel request could not be submitted",
      "tableLabel": "Travel requests",
      "emptyTitle": "No travel requests",
      "emptyDescription": "Raise one before the trip, so an advance has something to hang off."
    },
    "advances": {
      "title": "Travel advances",
      "description": "Money handed over before the trip, and what is still outstanding after it.",
      "loadFailed": "Travel advances could not be loaded",
      "advance": "Advance",
      "draftNo": "Not numbered yet",
      "amount": "Advanced",
      "settled": "Settled",
      "outstanding": "Outstanding",
      "dueBy": "Due by",
      "dueByHint": "After this, the advance is chased and shows on the close cockpit.",
      "overdue": "Overdue",
      "overdueBanner": "{count} advance(s) are past their due date and still outstanding.",
      "employeeId": "Employee id",
      "employeeIdHint": "Leave blank to advance to yourself.",
      "anyStatus": "Any status",
      "create": "New advance",
      "createTitle": "New travel advance",
      "createDescription": "It is paid out through AP once approved.",
      "created": "Advance created",
      "createFailed": "The advance could not be created",
      "pay": "Pay out",
      "payTitle": "Pay this advance out",
      "payDescription": "Raises the AP invoice that puts the money in the employee's hands.",
      "payHint": "The advance sits in the advance account until a claim nets against it. What is left over is chased.",
      "paymentDate": "Payment date",
      "paymentDateHint": "Empty means today.",
      "paid": "Advance paid out",
      "payFailed": "The advance could not be paid out",
      "tableLabel": "Travel advances",
      "emptyTitle": "No travel advances",
      "emptyDescription": "Advance against a travel request when somebody needs money before they go."
    },
    "cards": {
      "title": "Card statements",
      "description": "What the issuer says was spent, against the claims that should account for it.",
      "loadFailed": "Card statements could not be loaded",
      "card": "Card",
      "opening": "Opening",
      "openingHint": "Must equal the previous statement's closing balance — the server refuses a gap and names the missing range.",
      "charges": "Charges",
      "credits": "Credits",
      "closing": "Closing",
      "matched": "Matched",
      "periodFrom": "Period from",
      "periodTo": "Period to",
      "anyStatus": "Any status",
      "import": "Import a statement",
      "importTitle": "Import a card statement",
      "importDescription": "Paste the rows; the server checks that the period follows the last one.",
      "paste": "Rows",
      "pasteHint": "One transaction per line: date (YYYY-MM-DD), merchant, reference, amount. Tabs or commas. A charge is positive, a refund negative.",
      "parsed": "{count} row(s) read.",
      "unreadable": "{count} line(s) could not be read and will not be imported. Check the date format.",
      "imported": "Statement imported",
      "importFailed": "The statement could not be imported",
      "tableLabel": "Card statements",
      "emptyTitle": "No card statements",
      "emptyDescription": "Import the issuer's statement for the month, then match its lines to the claims that account for them."
    },
    "match": {
      "title": "Card statement — {card}",
      "description": "{from} → {to}",
      "loadFailed": "This card statement could not be loaded",
      "linesTitle": "Lines",
      "linesDescription": "Every charge, and what accounts for it.",
      "emptyTitle": "No lines",
      "emptyDescription": "The import produced no readable rows.",
      "noMerchant": "No merchant",
      "unmatched": "Unmatched",
      "autoMatch": "Suggest matches",
      "suggested": "Suggestions ready",
      "suggestedBanner": "{count} suggestion(s). Nothing is matched until you accept one.",
      "autoFailed": "Suggestions could not be generated",
      "suggestion": "Claim line #{claimLine} — {kind}, {confidence}",
      "accept": "Accept",
      "matched": "Line matched",
      "matchFailed": "The line could not be matched",
      "manual": "Match by hand",
      "manualTitle": "Match a card line by hand",
      "manualDescription": "When no suggestion is right, name the claim line yourself.",
      "claimLineId": "Claim line id",
      "claimLineHint": "The id of the expense claim line this charge accounts for.",
      "matchIt": "Match",
      "dispose": "Dispose",
      "disposeTitle": "Dispose of a card line",
      "disposeDescription": "No claim accounts for this charge. Say what it was.",
      "disposition": "Outcome",
      "personalPosting": "A personal charge posts to the employee receivable and is owed back to the legal entity. Recovering it is a matter for payroll or a receipt.",
      "reason": "Reason",
      "disposed": "Line disposed of",
      "disposeFailed": "The line could not be disposed of",
      "cannotClose": "{count} line(s) are still unmatched. Every line has to be matched or disposed of before the statement can close.",
      "close": "Close the statement",
      "closeTitle": "Close this card statement",
      "closeDescription": "Raises the issuer's bill.",
      "closeHint": "Closing raises an AP invoice against the issuer for charges less credits, which empties the clearing account the individual charges were posted to.",
      "closed": "Statement closed",
      "closeFailed": "The statement could not be closed",
      "issuerInvoice": "Issuer billed as supplier invoice #{id}."
    },
    "policies": {
      "title": "Categories, limits and mileage",
      "description": "What may be spent, on what, and at what rate.",
      "loadFailed": "Expense configuration could not be loaded",
      "tabCategories": "Categories",
      "tabLimits": "Limits",
      "tabMileage": "Mileage",
      "tabsLabel": "Expense configuration",
      "asAt": "In force on",
      "asAtHint": "Narrows to the version that applied on a date. Empty shows every version.",
      "category": "Category",
      "code": "Code",
      "expenseAccount": "Expense account",
      "mileage": "Mileage",
      "mileageYes": "Mileage",
      "isMileage": "This is a mileage category",
      "mileageCategoryHint": "A mileage line carries a distance and a vehicle class; the amount is computed from the rate in force and whatever the client sends is ignored.",
      "receiptAbove": "Receipt above",
      "receiptAboveHint": "A receipt is required for a line over this. Zero means always.",
      "active": "Active",
      "inactive": "Inactive",
      "categoriesTitle": "Categories",
      "categoriesDescription": "What an expense can be. Each names the account it posts to.",
      "categoriesEmptyTitle": "No categories",
      "categoriesEmptyDescription": "Create one for each kind of spending — travel, meals, mileage — and give it the account it belongs in.",
      "newCategory": "New category",
      "newCategoryDescription": "The account it posts to cannot be changed once claims carry it.",
      "categoryCreated": "Category created",
      "categoryFailed": "The category could not be created",
      "limitKind": "Applies to",
      "limit": "Limit",
      "breachAction": "When over",
      "authorityInMoney": "The authority is asked in money, against the amount by which the limit was exceeded — not the line total, and not a percentage.",
      "requiresPreApproval": "Requires pre-approval",
      "effective": "Effective",
      "effectiveFrom": "Effective from",
      "effectiveFromHint": "A line is judged by the policy in force on the day it was incurred, not on the claim date.",
      "open": "open",
      "limitsTitle": "Limits",
      "limitsDescription": "Effective-dated, so a July rate is judged by July's policy.",
      "limitsEmptyTitle": "No limits",
      "limitsEmptyDescription": "Without a limit every claim passes. Set one where a ceiling actually matters.",
      "newPolicy": "New limit",
      "newPolicyDescription": "Resubmitting a live key supersedes it rather than clashing with it.",
      "policyCreated": "Limit created",
      "policyFailed": "The limit could not be created",
      "vehicleClass": "Vehicle class",
      "ratePerUnit": "Rate per unit",
      "uom": "Unit",
      "mileageTitle": "Mileage rates",
      "mileageDescription": "What a kilometre is worth, by vehicle class, effective-dated.",
      "mileageEmptyTitle": "No mileage rates",
      "mileageEmptyDescription": "A mileage category needs a rate for the vehicle class before a line can be computed.",
      "newRate": "New rate",
      "newRateDescription": "Rates supersede rather than overwrite, so an old claim keeps the rate it was computed at.",
      "rateCreated": "Mileage rate created",
      "rateFailed": "The mileage rate could not be created"
    },
    "claimEdit": {
      "edit": "Edit details",
      "editTitle": "Edit claim details",
      "editDescription": "The title, date, period and note. The lines are edited in the grid.",
      "periodFrom": "Period from",
      "periodTo": "Period to",
      "saved": "Claim details saved",
      "saveFailed": "The claim details could not be saved",
      "stale": "Somebody else changed this claim after you opened it. Reload it, then apply your changes again.",
      "staleDelete": "Somebody else changed this claim after you opened it. Reload it and decide again.",
      "reload": "Reload",
      "delete": "Delete",
      "deleteTitle": "Delete this claim",
      "deleteWarning": "The claim and its lines are removed. Only a draft or a rejected claim can be deleted, and the deletion is kept in the audit trail.",
      "deleted": "Claim deleted",
      "deleteFailed": "The claim could not be deleted"
    },
    "cardAccounts": {
      "title": "Corporate card accounts",
      "description": "Each company card, who holds it, and the clearing account its charges post to until the issuer's bill empties it.",
      "loadFailed": "Card accounts could not be loaded",
      "chooseCompanyTitle": "Choose a legal entity",
      "chooseCompanyDescription": "Card accounts belong to one legal entity, and their clearing account comes from its chart.",
      "code": "Code",
      "issuer": "Issuer",
      "maskedPan": "Card number (masked)",
      "maskedPanHint": "Only the last four digits, for example **** **** **** 4821. The full number is never stored.",
      "maskedPanInvalid": "Enter the masked number with no more than four digits showing.",
      "holder": "Card holder",
      "holderHint": "The employee the card is issued to. Leave empty for a shared card.",
      "noHolder": "Shared card",
      "currency": "Currency",
      "currencyInvalid": "Use a three-letter currency code.",
      "clearingAccount": "Clearing account",
      "clearingAccountHint": "Charges post here when they are matched; closing the statement raises the issuer's bill that empties it.",
      "issuerVendor": "Issuer as supplier",
      "issuerVendorHint": "The supplier record the closed statement is billed against. Without one, the statement cannot be closed into a bill.",
      "noIssuerVendor": "Not linked",
      "active": "Active",
      "inactive": "Inactive",
      "status": "Status",
      "create": "New card account",
      "createTitle": "New corporate card account",
      "createDescription": "Statements are imported against a card account, so create it before the first statement arrives.",
      "created": "Card account created",
      "createFailed": "The card account could not be created",
      "noChart": "You cannot read this legal entity's chart of accounts, so the clearing account cannot be chosen here.",
      "tableLabel": "Corporate card accounts",
      "emptyTitle": "No card accounts",
      "emptyDescription": "Create one for each company card, then import its statements under Cards.",
      "creditLimit": "Credit limit",
      "creditLimitHint": "The card's spend limit in {currency}. Leave blank to keep the stored limit.",
      "creditLimitInvalid": "Enter an amount of zero or more.",
      "noLimit": "No limit set",
      "holderEditHint": "Reassign the card to another employee. A holder cannot be cleared here.",
      "actions": "Actions",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "activated": "Card account activated",
      "deactivated": "Card account deactivated",
      "statusFailed": "The card account status could not be changed",
      "statusStale": "Somebody else changed this card account first. The list has been reloaded — check its current state, then make your change again.",
      "editTitle": "Edit card account",
      "edited": "Card account updated",
      "editFailed": "The card account could not be updated",
      "stale": "Somebody else saved this card account while you had it open. Nothing was overwritten — reload it, then apply your edits again.",
      "reload": "Reload the saved version"
    },
    "settings": {
      "title": "Expense settings",
      "description": "Where advances and personal card charges post, the default claim currency, and when a receipt is required.",
      "loadFailed": "Expense settings could not be loaded",
      "chooseCompanyTitle": "Choose a legal entity",
      "chooseCompanyDescription": "Expense settings are kept per legal entity.",
      "notConfigured": "This legal entity has no expense settings yet. Until they are saved, travel advances cannot be paid and personal card charges cannot be dispositioned.",
      "accountsTitle": "Accounts",
      "accountsDescription": "Both are balance-sheet accounts the employee owes the legal entity through.",
      "advanceAccount": "Travel advance account",
      "advanceAccountHint": "Advances paid out sit here until a claim nets against them.",
      "receivableAccount": "Employee receivable account",
      "receivableAccountHint": "A personal charge on a company card posts here: the employee owes it back.",
      "claimsTitle": "Claims",
      "claimsDescription": "Defaults for a new claim and the receipt rule.",
      "defaultCurrency": "Default claim currency",
      "defaultCurrencyHint": "A new claim starts in this currency. Three letters, for example MVR.",
      "requireReceiptAbove": "Receipt required above",
      "requireReceiptAboveHint": "A line over this amount needs a receipt. Zero means every line.",
      "advanceOverdueDays": "Advance overdue after (days)",
      "advanceOverdueDaysHint": "An advance not settled this many days after the trip is chased and shows on the close cockpit. Empty uses 30.",
      "saved": "Expense settings saved",
      "saveFailed": "The expense settings could not be saved",
      "stale": "Somebody else changed these settings after you opened them. Reload them, then apply your changes again.",
      "reload": "Reload",
      "noChart": "You cannot read this legal entity's chart of accounts, so the accounts cannot be chosen here.",
      "readOnly": "You can read these settings but not change them.",
      "errors": {
        "account": "Choose an account.",
        "currency": "Use a three-letter currency code.",
        "receiptAbove": "Enter an amount of zero or more.",
        "overdueDays": "Enter a whole number of days from 1 to 365."
      }
    },
    "settlement": {
      "method": "Settlement method",
      "methodHint": "Payment raises a supplier invoice. Payroll adds the employee-paid spend to the employee's next open payroll run.",
      "methods": {
        "payment": "Payment (AP invoice)",
        "payroll": "Payroll"
      },
      "statuses": {
        "included": "In a payroll run",
        "settled": "Settled by payroll"
      },
      "kinds": {
        "claim": "Claim",
        "advance": "Advance recovery"
      },
      "paidVia": "Paid via: {method}",
      "run": "Payroll run {id}",
      "settledAt": "Settled {at}",
      "viewInclusions": "View payroll inclusions",
      "routeToPayroll": "Route to payroll",
      "routeToPayment": "Route to payment",
      "routeTitle": "How is this claim paid",
      "routeHint": "Allowed only before payroll reads the claim. You cannot change this if you raised the claim, are the claimant, or took part in its approval.",
      "routed": "Settlement method changed",
      "routeFailed": "The settlement method could not be changed",
      "recovery": "Recovery from pay",
      "recoveryMarked": "Marked for payroll",
      "recoveryLocked": "In payroll run {id}",
      "markRecovery": "Recover from pay",
      "unmarkRecovery": "Stop recovery",
      "recoveryMarkedToast": "Advance marked for recovery from pay",
      "recoveryUnmarked": "Recovery from pay stopped",
      "recoveryFailed": "The advance could not be updated",
      "kind": "Kind",
      "anyKind": "Any kind",
      "runColumn": "Run",
      "includedAt": "Included / settled",
      "runFilter": "Showing payroll run {id} only.",
      "clearRun": "Show all runs",
      "inclusionsTitle": "Payroll inclusions",
      "inclusionsDescription": "Claims and advance recoveries that payroll has read, and whether the run has posted.",
      "inclusionsLoadFailed": "Payroll inclusions could not be loaded",
      "inclusionsEmptyTitle": "Nothing included yet",
      "inclusionsEmptyDescription": "A claim routed to payroll, or an advance marked for recovery, appears here once a payroll run reads it."
    },
    "queue": {
      "advance_overdue": "Overdue travel advances",
      "policy_breach": "Expense policy breaches"
    }
  },
  "interco": {
    "nav": {
      "label": "Intercompany sections",
      "pairs": "Pairs",
      "match": "Match board",
      "statements": "Statements",
      "ageing": "Ageing"
    },
    "routeTitles": {
      "pairs": "Intercompany pairs",
      "match": "Intercompany match board",
      "statements": "Intercompany statements",
      "ageing": "Intercompany ageing"
    },
    "directions": {
      "due_from": "Owed to us",
      "due_to": "Owed by us"
    },
    "statuses": {
      "open": "Open",
      "matched": "Matched",
      "disputed": "Disputed",
      "written_off": "Written off",
      "eliminated": "Eliminated"
    },
    "statementStatuses": {
      "open": "Open",
      "reconciled": "Reconciled",
      "certified": "Certified"
    },
    "dispositions": {
      "disputed": "Dispute it",
      "written_off": "Write it off"
    },
    "dispositionHints": {
      "disputed": "The two legal entities disagree and somebody has to settle it.",
      "written_off": "It will never be matched, and the difference is accepted."
    },
    "pairs": {
      "title": "Intercompany pairs",
      "description": "A standing reconciliation between two legal entities, checked monthly rather than discovered at consolidation.",
      "loadFailed": "Intercompany pairs could not be loaded",
      "pair": "Pair",
      "pairLabel": "{company} ↔ {counterparty}",
      "counterparty": "Counterparty legal entity",
      "tolerance": "Tolerance",
      "toleranceHint": "A difference at or below this is noise and does not block the close.",
      "toleranceCurrency": "Tolerance currency",
      "maxAgeDays": "Max age (days)",
      "maxAgeHint": "An open item older than this is flagged on the ageing report.",
      "mirror": "Mirror posting",
      "mirrorOn": "Generated automatically",
      "mirrorOff": "Not configured — post the other side by hand",
      "mirrorHint": "A mirror is generated only when the reciprocal intercompany rule exists. It is never inferred, so a pair without one reconciles against a side nobody posted.",
      "blocksClose": "Blocks close",
      "blocksCloseYes": "Blocks the close",
      "blocksCloseHint": "On means an uncertified statement for this pair will stop the month.",
      "active": "Active",
      "inactive": "Inactive",
      "create": "New pair",
      "createTitle": "New intercompany pair",
      "createDescription": "Both legal entities must already have a due-to/due-from mapping between them.",
      "created": "Intercompany pair created",
      "createFailed": "The pair could not be created",
      "noCompanyPair": "These two legal entities have no due-to/due-from mapping. Configure an intercompany rule under Enterprise → Legal Entities → Intercompany first — a reconciliation with no accounts to reconcile is not a reconciliation.",
      "tableLabel": "Intercompany reconciliation pairs",
      "emptyTitle": "No intercompany pairs",
      "emptyDescription": "Create one for each pair of legal entities that trades internally. Until then, a mismatch only surfaces at consolidation.",
      "edit": "Edit",
      "editTitle": "Edit intercompany pair",
      "editDescription": "Loading the pair…",
      "companiesFixed": "The two legal entities of a pair are fixed. Their due-to/due-from accounts come from the intercompany rule.",
      "openRules": "Open intercompany rules",
      "isActive": "Active",
      "isActiveHint": "An inactive pair is not reconciled and no longer blocks the close.",
      "updated": "Intercompany pair updated",
      "updateFailed": "The pair could not be updated",
      "loadPairFailed": "The pair could not be loaded",
      "stale": "Somebody else changed this pair after you opened it. Reload it, then apply your changes again.",
      "reload": "Reload"
    },
    "match": {
      "title": "Match board",
      "description": "Both sides at once. A break is two rows that should have been one.",
      "loadFailed": "Intercompany transactions could not be loaded",
      "pair": "Pair",
      "choosePair": "Choose a pair",
      "chooseTitle": "Choose a pair",
      "chooseDescription": "The board shows one pair's open items, this legal entity on the left and the counterparty on the right.",
      "sideEmpty": "Nothing open on this side.",
      "noMirror": "This pair generates no mirror posting, so the counterparty side only fills in when somebody posts it there.",
      "matchThem": "Match these two",
      "matched": "Transactions matched",
      "matchFailed": "The transactions could not be matched",
      "unmatch": "Unmatch",
      "unmatched": "Transaction unmatched",
      "unmatchFailed": "The transaction could not be unmatched",
      "autoMatch": "Auto-match",
      "autoMatched": "Auto-match complete",
      "autoFailed": "Auto-match could not run",
      "considered": "Considered",
      "byExactRef": "By reference",
      "byAmountDate": "By amount and date",
      "stillOpen": "Still open",
      "dispose": "Dispute or write off",
      "disposeTitle": "Dispose of a transaction",
      "disposeDescription": "It will not be matched. Say which and why.",
      "disposition": "Outcome",
      "reason": "Reason",
      "disposed": "Transaction disposed of",
      "disposeFailed": "The transaction could not be disposed of"
    },
    "statements": {
      "title": "Period statements",
      "description": "A snapshot per pair per period, so \"was it reconciled at 30 September\" survives the items later being matched.",
      "loadFailed": "Statements could not be loaded",
      "anyPair": "Any pair",
      "period": "Period",
      "dueFrom": "We are owed",
      "counterpartyDueTo": "They say they owe",
      "difference": "Difference",
      "openItems": "Open items",
      "outsideTolerance": "Outside tolerance",
      "toleranceUnknown": "Tolerance in another currency",
      "generate": "Generate",
      "generateTitle": "Generate a statement",
      "generateDescription": "Freezes both balances and the difference at the period end.",
      "generated": "Statement generated",
      "generateFailed": "The statement could not be generated",
      "certify": "Certify",
      "certifyTitle": "Certify a statement",
      "certifyDescription": "Attest that this pair reconciled at the period end.",
      "certifyHint": "Certifying is what clears the close blocker. An active pair that blocks the close needs a certified statement for the period before the ledger can close.",
      "certifyUnblocks": "This clears the intercompany blocker on the close cockpit for this pair and period.",
      "certifyBreachWarning": "The difference is outside this pair's tolerance. Certifying it says you have looked at the break and accepted it — it does not make the break go away.",
      "certified": "Statement certified",
      "certifyFailed": "The statement could not be certified",
      "note": "Note",
      "emptyTitle": "No statements",
      "emptyDescription": "Generate one for the period you are closing. Without it the close cockpit has nothing to check."
    },
    "ageing": {
      "title": "Intercompany ageing",
      "description": "Open items by age, per pair. An unmatched item becomes an elimination that does not eliminate.",
      "loadFailed": "The ageing report could not be loaded",
      "asOf": "As of",
      "panelTitle": "By pair",
      "panelDescription": "Oldest first. A pair whose oldest open item has passed its own limit is the one that will stop a close.",
      "emptyTitle": "Nothing open",
      "emptyDescription": "Every intercompany transaction is matched or disposed of.",
      "company": "Legal Entity",
      "counterparty": "Counterparty",
      "openCount": "Open",
      "current": "Current",
      "days30": "1–30",
      "days60": "31–60",
      "days90Plus": "Over 90",
      "openAmount": "Total open",
      "oldest": "Oldest (days)"
    }
  },
  "party": {
    "routeTitles": {
      "parties": "Parties",
      "party": "Party",
      "matrix": "Consent matrix",
      "merges": "Merges",
      "merge": "Merge workbench",
      "catalogues": "Consent catalogues",
      "consents": "Consent records",
      "suppressions": "Suppressions",
      "dsrBoard": "Data-subject requests",
      "dsr": "Data-subject request",
      "retention": "Retention catalogue",
      "loyaltyPrograms": "Loyalty programmes",
      "loyaltyProgram": "Loyalty programme",
      "loyaltyMembers": "Loyalty members",
      "loyaltyMember": "Loyalty member"
    },
    "nav": {
      "label": "Party sections",
      "parties": "Parties",
      "merges": "Merges",
      "consent": "Consent",
      "catalogues": "Catalogues",
      "suppressions": "Suppressions",
      "dsr": "Requests",
      "retention": "Retention",
      "loyalty": "Loyalty"
    },
    "kind": {
      "person": "Person",
      "organisation": "Organisation"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "blocked": "Blocked"
    },
    "identifierKind": {
      "national_id": "National ID",
      "passport": "Passport",
      "tax_id": "Tax ID",
      "driving_licence": "Driving licence",
      "company_registration": "Company registration",
      "loyalty_number": "Loyalty number",
      "external_key": "External key"
    },
    "linkRule": {
      "manual": "Linked by hand",
      "convert": "Created by a conversion",
      "backfill": "Backfilled",
      "merge": "Moved by a merge",
      "auto_exact": "Matched on an identifier",
      "import": "Imported"
    },
    "matchMethod": {
      "identifier": "Same identifier",
      "email": "Same email",
      "phone": "Same phone",
      "name_address": "Similar name and address"
    },
    "consentState": {
      "granted": "Granted",
      "withdrawn": "Withdrawn",
      "pending": "Pending confirmation",
      "expired": "Expired",
      "not_asked": "Not asked"
    },
    "consentBasis": {
      "consent": "Consent",
      "contract": "Contract",
      "legal_obligation": "Legal obligation",
      "legitimate_interest": "Legitimate interest",
      "vital_interest": "Vital interest",
      "public_task": "Public task"
    },
    "consentSource": {
      "portal": "Portal",
      "web_form": "Web form",
      "import": "Import",
      "verbal": "Verbal",
      "contract": "Contract",
      "api": "API",
      "staff": "Recorded by staff",
      "merge": "Written by a merge",
      "system": "System"
    },
    "medium": {
      "email": "Email",
      "sms": "SMS",
      "voice": "Voice",
      "whatsapp": "WhatsApp",
      "postal": "Post",
      "in_app": "In-app"
    },
    "suppressionReason": {
      "unsubscribe": "Unsubscribed",
      "hard_bounce": "Hard bounce",
      "spam_complaint": "Spam complaint",
      "manual": "Added by hand",
      "dsr_objection": "Objection to marketing",
      "invalid": "Invalid address"
    },
    "mergeStatus": {
      "draft": "Draft",
      "submitted": "Submitted",
      "approved": "Approved",
      "committed": "Committed",
      "rejected": "Rejected",
      "cancelled": "Cancelled",
      "reversed": "Reversed"
    },
    "mergeField": {
      "display_name": "Display name",
      "email": "Email",
      "phone": "Phone",
      "country_code": "Country"
    },
    "mergeRule": {
      "S1": "Withdrawal beats everything",
      "S2": "The stricter state wins",
      "S2prime": "Equal states — the later capture wins",
      "S3": "The earlier expiry wins",
      "R2": "One side holds no record, so nothing was decided",
      "unknown": "Rule not recognised by this screen"
    },
    "mergeAction": {
      "unchanged": "Unchanged",
      "written": "New record written"
    },
    "mergeOutcome": {
      "moved": "Moved",
      "collided": "Collided and demoted",
      "skipped": "Skipped"
    },
    "dsrKind": {
      "access": "Access",
      "portability": "Portability",
      "rectification": "Rectification",
      "erasure": "Erasure",
      "restriction": "Restriction",
      "objection": "Objection"
    },
    "dsrStatus": {
      "received": "Received",
      "awaiting_identity": "Awaiting identity",
      "in_progress": "In progress",
      "awaiting_extension": "Awaiting extension",
      "fulfilled": "Fulfilled",
      "refused": "Refused",
      "withdrawn": "Withdrawn"
    },
    "dsrChannel": {
      "email": "Email",
      "portal": "Portal",
      "post": "Post",
      "phone": "Phone",
      "in_person": "In person",
      "api": "API"
    },
    "dsrLane": {
      "overdue": "Overdue",
      "today": "Due today",
      "soon": "Due within 7 days",
      "later": "Later",
      "closed": "Closed"
    },
    "dsrTaskStatus": {
      "open": "Open",
      "done": "Done",
      "not_applicable": "Not applicable"
    },
    "treatment": {
      "erase": "Erase",
      "pseudonymise": "Pseudonymise",
      "retain_statutory": "Retain — statutory",
      "retain_contract": "Retain — contract",
      "retain_legitimate": "Retain — legitimate interest",
      "retain_dispute": "Retain — dispute"
    },
    "anchor": {
      "last_transaction": "Last transaction",
      "relationship_end": "End of the relationship",
      "record_created": "Record created",
      "erasure_request": "The erasure request"
    },
    "register": {
      "title": "Parties",
      "description": "One identity per person and organisation. Customers, vendors, employees and portal users are records that point at one.",
      "create": "New party",
      "createTitle": "New party",
      "createDescription": "Check for an existing identity first — a duplicate created here is a merge somebody has to do later.",
      "created": "Party created",
      "searchPlaceholder": "Name, email or phone",
      "anyKind": "Any kind",
      "anyStatus": "Any status",
      "anyLinkType": "Any linked record",
      "linkTypeHint": "{count} linked",
      "linked": "Has this link",
      "notLinked": "Has no such link",
      "name": "Name",
      "kind": "Kind",
      "status": "Status",
      "country": "Country",
      "links": "Links",
      "flags": "Flags",
      "erased": "Erased",
      "merged": "Merged away",
      "email": "Email",
      "phone": "Phone",
      "countryHint": "Two-letter ISO code. It decides which retention policy applies.",
      "checkDuplicates": "Check for duplicates",
      "exactMatch": "An identifier on this party already belongs to an existing party. Open that one instead of creating a second.",
      "noCandidates": "Nothing similar found. Creating this party is safe.",
      "candidatesFound": "{count} similar party (or parties) already exist. Open one, or create anyway.",
      "openExisting": "Open the existing party",
      "emptyTitle": "No parties yet",
      "emptyDescription": "Parties are created by the backfill, by converting a lead, and by hand here."
    },
    "detail": {
      "tabsLabel": "Party sections",
      "tabProfile": "360",
      "tabLinks": "Linked records",
      "tabIdentifiers": "Identifiers",
      "tabTimeline": "Timeline",
      "tabMerges": "Merges",
      "openConsent": "Consent matrix",
      "erasedBanner": "This party has been erased under a fulfilled data-subject request. Most fields are gone; the ones that remain are retained for a stated statutory reason.",
      "mergedBanner": "This party was absorbed by a merge.",
      "openSurvivor": "Open the surviving party"
    },
    "profile": {
      "consentTitle": "Consent",
      "consentAsOf": "Resolved as at {date}",
      "granted": "{count} granted",
      "pending": "{count} pending",
      "withdrawn": "{count} withdrawn",
      "openDsrTitle": "Open requests",
      "noSectionsTitle": "Nothing linked yet",
      "noSectionsDescription": "Sections appear as modules link their records to this identity.",
      "sectionCount": "{count} record(s)",
      "sectionEmpty": "Nothing recent.",
      "timelineNote": "Merged and sorted by the server across activity, consent, campaigns, loyalty and merges.",
      "timelineEmptyTitle": "Nothing has happened yet",
      "timelineEmptyDescription": "Activity appears here as it is recorded against this identity."
    },
    "link": {
      "primary": "Primary",
      "orphaned": "No module owns this link type",
      "makePrimary": "Make primary",
      "primarySet": "Primary link set",
      "emptyTitle": "No records linked",
      "emptyDescription": "A customer, vendor, employee or portal user linked to this identity appears here."
    },
    "identifier": {
      "add": "Add identifier",
      "added": "Identifier added",
      "addTitle": "Add an identifier",
      "addDescription": "The value is encrypted at rest and is only ever shown masked. Revealing it later is a separate, audited act.",
      "kind": "Kind",
      "issuingCountry": "Issuing country",
      "value": "Value",
      "verification": "Verification",
      "verificationHint": "Record that a human checked the document. An erasure's identity gate consumes this.",
      "notVerified": "Not checked",
      "verifiedNow": "Checked against the document",
      "verified": "Verified",
      "maskedNote": "Identifiers are stored encrypted and shown masked. Revealing one needs a second factor, a reason, and writes an audit record.",
      "reveal": "Reveal",
      "revealTitle": "Reveal this identifier",
      "revealDescription": "You are about to see the full {kind}.",
      "revealConsequence": "This writes a sensitive-reveal record naming you, the identifier and your reason, and you will be asked for a second factor. The value is shown once and is not kept by this screen.",
      "reason": "Why are you revealing it?",
      "reasonHint": "This sentence is what makes the audit record answerable in a year.",
      "revealConfirm": "Reveal it",
      "revealedNote": "Shown once. Closing this dialog discards it.",
      "emptyTitle": "No identifiers recorded",
      "emptyDescription": "A passport, national ID or tax number recorded here is what lets two records be recognised as the same person."
    },
    "match": {
      "railTitle": "Possible duplicates",
      "railDescription": "Proposals, not instructions. Nothing merges until a human commits one.",
      "queueTitle": "Proposed duplicates",
      "queueDescription": "Ordered by score. A score is a reason to look, never an answer.",
      "queueEmptyTitle": "Nothing proposed",
      "queueEmptyDescription": "The weekly sweep proposes duplicates. Run it now if you have just imported data.",
      "emptyTitle": "No duplicates proposed",
      "emptyDescription": "The sweep has not found another party that looks like this one.",
      "pair": "Pair",
      "method": "Matched on",
      "score": "Score",
      "signals": "Signals",
      "status": "Status",
      "statusOpen": "Open",
      "statusDismissed": "Dismissed",
      "statusMerged": "Merged",
      "propose": "Propose a merge",
      "dismiss": "Dismiss",
      "dismissed": "Candidate dismissed",
      "dismissTitle": "Dismiss this candidate",
      "dismissDescription": "The reason is what makes the dismissal stick — the next sweep will not re-propose this pair.",
      "dismissReason": "Why are these not the same party?",
      "runSweep": "Run the sweep",
      "sweepTitle": "Run the duplicate sweep",
      "sweepDescription": "A schedule is not a control. Run it now against a date you choose.",
      "sweepOn": "As at",
      "sweepOnHint": "Empty means today, on the tenant's clock.",
      "sweepResult": "Scanned {scanned}. Proposed {proposed} new. {open} were already on the queue; {suppressed} had been dismissed and were not re-proposed."
    },
    "merge": {
      "inboxTitle": "Merges",
      "inboxDescription": "Proposed duplicates and the merge documents that resolve them.",
      "documentsTitle": "Merge documents",
      "documentsEmptyTitle": "No merges yet",
      "documentsEmptyDescription": "A merge starts from a proposed duplicate, or from a party's own detail screen.",
      "anyStatus": "Any status",
      "no": "Number",
      "parties": "Parties",
      "status": "Status",
      "linksMoved": "Moved",
      "reversibleUntil": "Reversible until",
      "survivorIs": "Survivor: {name}",
      "sourceIs": "Absorbed: {name}",
      "workbenchDescription": "Choose field by field, read the consent outcome, then commit.",
      "fieldsTitle": "Fields",
      "fieldsDescription": "The survivor keeps its own value unless you choose the absorbed party's.",
      "field": "Field",
      "survivorValue": "Survivor",
      "sourceValue": "Absorbed party",
      "saveChoices": "Save choices",
      "choicesSaved": "Choices saved",
      "consentTitle": "Consent outcome",
      "consentDescription": "Resolved by the server. This table is the record of which clause decided each cell — nothing here is recomputed in the browser.",
      "consentCaption": "One row per channel and purpose the two parties held between them.",
      "consentEmptyTitle": "Neither party holds a consent record",
      "consentEmptyDescription": "Nothing to resolve, and the merge writes no consent rows.",
      "inputSurvivor": "Survivor held",
      "inputSource": "Absorbed party held",
      "winner": "Winner",
      "winner_survivor": "Survivor",
      "winner_source": "Absorbed party",
      "decidingRule": "Deciding rule",
      "action": "Action",
      "noRecord": "No record",
      "movePreviewTitle": "What will move",
      "movePreviewDescription": "Every record the absorbed party owns today.",
      "movePreviewEmptyTitle": "Nothing to move",
      "movePreviewEmptyDescription": "The absorbed party owns no linked records.",
      "wouldCollide": "Would collide",
      "lineageTitle": "What moved",
      "lineageDescription": "The lineage this merge left behind, record by record.",
      "lineageEmptyTitle": "Nothing moved",
      "lineageEmptyDescription": "The absorbed party owned no linked records at commit.",
      "movedFromTo": "Party {from} → {to}",
      "submitTitle": "Submit for approval",
      "submitDescription": "A merge relinks financial records, so the person who proposed it does not approve it.",
      "submitted": "Merge submitted",
      "reasonCode": "Reason",
      "reasonNote": "Note",
      "approve": "Approve",
      "approved": "Merge approved",
      "rejectTitle": "Reject this merge",
      "rejectReason": "Why?",
      "rejected": "Merge rejected",
      "commit": "Commit the merge",
      "commitTitle": "Commit the merge",
      "commitDescription": "Links move, consent is resolved and the absorbed party is closed.",
      "commitWarning": "A commit relinks financial records. It can be reversed inside the window, and a reversal cannot restore everything.",
      "commitOverrideNote": "This refusal can be overridden, and the reason the merge was submitted under is what overrides it. Nothing further is asked for — resubmit with a reason that covers this if the one on record does not.",
      "committed": "Merge committed",
      "reverse": "Reverse the merge",
      "reverseTitle": "Reverse this merge",
      "reverseDescription": "Read what a reversal cannot restore before confirming.",
      "reverseLimitations": "A reversal restores what the merge moved. It does not undo what has happened since.",
      "reverseLimitPostMerge": "Records created after the merge stay with the survivor — guessing which side they would have belonged to is a guess.",
      "reverseLimitEdited": "Fields edited after the merge are left alone rather than mechanically restored.",
      "reverseLimitWindow": "A merge outside its reversal window cannot be reversed at all.",
      "reverseLimitErased": "A merge whose party has since been erased, or which has itself been merged again, cannot be reversed.",
      "reverseReason": "Why are you reversing it?",
      "reversed": "Merge reversed",
      "reverseRestored": "Restored {links} link(s), {consents} consent record(s) and {fields} field(s).",
      "reverseRetainedTitle": "Left with the survivor — created after the merge:",
      "reverseEditedTitle": "Left alone — edited after the merge:",
      "cancelTitle": "Cancel this merge",
      "cancelReason": "Why?",
      "cancelMerge": "Cancel the merge",
      "cancelled": "Merge cancelled",
      "emptyTitle": "This party has no merge history",
      "emptyDescription": "Merges involving this identity, in either direction, appear here."
    },
    "consent": {
      "matrixTitle": "Consent matrix",
      "matrixCaption": "Purposes down, channels across. The state is what was recorded; whether we may contact them is the server's own verdict.",
      "matrixEmptyTitle": "No channels or purposes configured",
      "matrixEmptyDescription": "Add a channel and a purpose in the catalogues before capturing consent.",
      "backToParty": "Back to the party",
      "asOf": "As at",
      "asOfHint": "Empty means the record in force now. A date answers what the position was on that day.",
      "purpose": "Purpose",
      "cell": "Purpose and channel",
      "party": "Party",
      "state": "State",
      "basis": "Lawful basis",
      "source": "Source",
      "window": "In force",
      "evidence": "Evidence",
      "permitted": "May contact",
      "blocked": "Blocked",
      "expiresOn": "Expires {date}",
      "historyTitle": "Consent history",
      "historyEmptyTitle": "No record for this cell",
      "historyEmptyDescription": "Nothing has been captured for this purpose on this channel.",
      "capture": "Capture consent",
      "captured": "Consent captured",
      "captureTitle": "Capture consent",
      "captureDescription": "A record of what the subject decided, when, and on what evidence.",
      "effectiveFrom": "Effective from",
      "effectiveFromHint": "Empty means today, on the tenant's clock.",
      "evidenceRef": "Evidence reference",
      "evidenceText": "Evidence",
      "evidenceHint": "What the subject actually did — the wording of the form, the words on the call.",
      "evidenceRequired": "A grant on the basis of consent needs evidence. The server refuses one without it, and so does this form.",
      "overlapExplained": "Another consent record already covers this cell over the same dates. Withdraw or supersede that one first.",
      "withdraw": "Withdraw",
      "withdrawn": "Consent withdrawn",
      "withdrawTitle": "Withdraw this consent",
      "withdrawDescription": "The record is closed and a withdrawal is recorded in its place.",
      "withdrawWarning": "A withdrawal outranks every later grant a merge might carry. It is the strictest state there is.",
      "withdrawReason": "Reason",
      "withdrawFromHint": "Empty means today. Use an earlier date to record a withdrawal that took effect then.",
      "recordsTitle": "Consent records",
      "recordsDescription": "Every piece of consent evidence in the tenant, answerable as at any date.",
      "recordsEmptyTitle": "No consent records",
      "recordsEmptyDescription": "Consent is captured on a party's matrix, imported from an existing system, or recorded by a portal form.",
      "anyChannel": "Any channel",
      "anyPurpose": "Any purpose",
      "anyState": "Any state",
      "exportEvidence": "Export evidence",
      "exported": "Evidence exported",
      "import": "Import",
      "importTitle": "Import a consent history",
      "importDescription": "A CSV from a system this tenant is leaving.",
      "importEpochNote": "A row with no effective date starts at the beginning of time, not today. An imported history is evidence of what already happened; dating it from now would restate every existing consent as brand new.",
      "importFile": "CSV file",
      "importFileHint": "One row per party, channel and purpose.",
      "importSummary": "{rows} row(s) read · {imported} imported · {errors} rejected.",
      "importLine": "Line {line}",
      "importCleanTitle": "Every row imported",
      "importCleanDescription": "Nothing was rejected."
    },
    "catalogue": {
      "title": "Consent catalogues",
      "description": "The channels a message can travel on, and the purposes a subject can agree to.",
      "channels": "Channels",
      "purposes": "Purposes",
      "code": "Code",
      "name": "Name",
      "medium": "Medium",
      "doubleOptIn": "Double opt-in",
      "doubleOptInHint": "A grant on this channel starts as pending until the subject confirms.",
      "required": "Required",
      "active": "Active",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "yes": "Yes",
      "no": "No",
      "showInactive": "Show inactive",
      "addChannel": "Add channel",
      "channelAdded": "Channel added",
      "channelCodeNote": "The code cannot be changed once any consent record references it.",
      "addPurpose": "Add purpose",
      "purposeAdded": "Purpose added",
      "purposeDescription": "Description",
      "purposeEssentialNote": "An essential purpose is permitted without consent because its lawful basis is not consent. Do not mark a marketing purpose essential to make a send work.",
      "defaultBasis": "Default basis",
      "essential": "Essential",
      "essentialYes": "Essential",
      "essentialHint": "Permitted without a grant — the lawful basis is not consent.",
      "validityDays": "Validity (days)",
      "validityHint": "A grant lapses to expired after this many days. Empty means it does not lapse.",
      "codeInUse": "That code is referenced by a consent record and cannot be changed. Deactivate it and add a new one instead.",
      "channelsEmptyTitle": "No channels",
      "channelsEmptyDescription": "Email, SMS and post are the usual three.",
      "purposesEmptyTitle": "No purposes",
      "purposesEmptyDescription": "Marketing, service notifications and profiling are the usual starting set."
    },
    "suppression": {
      "title": "Suppressions",
      "description": "Addresses we must not contact, whoever they belong to.",
      "addressNote": "A suppression is keyed on the address, not the party. A bounce is a fact about a mailbox, and the mailbox may belong to two parties or to none we have identified.",
      "add": "Add suppression",
      "added": "Suppression added",
      "addTitle": "Suppress an address",
      "addDescription": "The address is stored for matching and is only ever shown masked.",
      "destination": "Destination",
      "destinationHint": "The exact address. It is masked everywhere it is displayed.",
      "channel": "Channel",
      "reason": "Reason",
      "scope": "Scope",
      "scopeGlobal": "All purposes",
      "scopePurpose": "Only {purpose}",
      "status": "Status",
      "inForce": "In force",
      "released": "Released",
      "releasedToast": "Suppression released",
      "note": "Note",
      "anyChannel": "Any channel",
      "anyReason": "Any reason",
      "showReleased": "Include released",
      "release": "Release",
      "releaseTitle": "Release this suppression",
      "releaseDescription": "The address becomes contactable again, subject to consent.",
      "releaseReason": "Why?",
      "releaseGoverned": "This suppression was not added by hand, so releasing it needs a governed reason code.",
      "releaseGovernedNote": "This suppression came from a bounce, a complaint or an objection. Releasing it is a governed exception and needs a reason code on the record.",
      "overrideCode": "Override reason",
      "overrideNote": "Override note",
      "emptyTitle": "Nothing suppressed",
      "emptyDescription": "Unsubscribes, bounces and complaints land here automatically. You can also add one by hand.",
      "import": "Import bounces",
      "importTitle": "Import a bounce file",
      "importDescription": "Every row becomes a suppression keyed on the address.",
      "importFile": "CSV file",
      "importFileHint": "One row per address, with its channel and reason.",
      "importSummary": "{rows} row(s) read · {imported} suppressed · {errors} rejected.",
      "importLine": "Line {line}"
    },
    "dsr": {
      "boardTitle": "Data-subject requests",
      "boardDescription": "Grouped by days remaining, on the tenant's clock.",
      "tenantClockNote": "Deadlines are counted on the tenant's business date, not on your browser's.",
      "emptyTitle": "No requests",
      "emptyDescription": "Raise one when a subject asks for their data, asks for it to be corrected, or asks for it to be erased.",
      "laneEmpty": "Nothing here.",
      "anyKind": "Any kind",
      "anyStatus": "Any status",
      "create": "New request",
      "created": "Request raised",
      "createTitle": "Raise a data-subject request",
      "createDescription": "The clock starts at the moment the request was received.",
      "clockStartsNote": "The response period runs from receipt, not from when it was typed in and not from when identity is verified.",
      "findParty": "Find the subject",
      "subject": "Subject",
      "kind": "Kind",
      "channel": "Arrived by",
      "receivedAt": "Received on",
      "receivedAtHint": "Empty means today. Use the real date if the request has been sitting in an inbox.",
      "requesterName": "Requester name",
      "requesterEmail": "Requester email",
      "requesterRelationship": "Requester",
      "requesterRelationshipHint": "An agent or a parent filing on someone's behalf is a different verification burden. It is recorded, not enforced.",
      "requesterIsSubject": "The subject themselves",
      "requesterIsAgent": "An agent acting for them",
      "requestText": "What they asked for",
      "dueOn": "Due {date}",
      "daysRemaining": "{days} day(s) left",
      "overdueBy": "Overdue by {days} day(s)",
      "clockPanelTitle": "The clock",
      "receivedOn": "Received",
      "responseDays": "Window (days)",
      "dueOnLabel": "Due",
      "extension": "Extension",
      "effectiveDueOn": "Effective due",
      "remaining": "Days left",
      "extensionReasonIs": "Extension reason: {reason}",
      "policyIs": "Policy for {jurisdiction}: {days} days",
      "breached": "This request is past its deadline. The breach has been recorded.",
      "warned": "This request is approaching its deadline.",
      "identityTitle": "Identity",
      "identityVerified": "Identity verified",
      "identityVerifiedOn": "Identity was verified at {at}.",
      "identityUnverified": "Identity has not been verified. The export and the erasure are both refused until it is.",
      "clockRunsAnyway": "The clock keeps running while identity is being checked — the response period starts at receipt.",
      "verifyIdentity": "Verify identity",
      "verifyTitle": "Verify the subject's identity",
      "verifyDescription": "Name the identifier a human checked against a document.",
      "evidenceIdentifier": "Evidence",
      "verifyNote": "Note",
      "noIdentifiersTitle": "This party holds no identifiers",
      "noIdentifiersDescription": "Record one on the party first — verification names the identifier that was checked.",
      "extend": "Extend",
      "extended": "Deadline extended",
      "extendTitle": "Extend the deadline",
      "extendDescription": "An extension is documented and is bounded by the policy.",
      "extendDays": "Extra days",
      "extendReason": "Why?",
      "extensionAllowance": "The policy allows up to {days} extra day(s).",
      "extensionLimit": "The policy allows at most {days} extra day(s).",
      "tasksTitle": "Tasks",
      "tasksDescription": "One per module that holds this subject's data.",
      "tasksEmptyTitle": "No tasks",
      "tasksEmptyDescription": "Tasks are generated from the registry when the request is raised.",
      "tasksRegenerated": "{count} task(s) added",
      "regenerateTasks": "Add missing tasks",
      "notApplicable": "Not applicable",
      "tasksStillOpen": "Tasks are still open. Complete them, or fulfil with a governed override reason.",
      "coverageTitle": "Coverage",
      "coverageDescription": "Every registered link type, and whether this request has worked it.",
      "coverageEmptyTitle": "Nothing registered",
      "coverageEmptyDescription": "No module has declared that it holds data about a party.",
      "noTask": "No task",
      "exportTitle": "Export bundle",
      "exportDescription": "Everything the registry declares about this subject, with a manifest hash.",
      "exportWithheld": "Building and downloading the bundle is a separate permission from reading the request. You do not hold it.",
      "exportNeedsIdentity": "The bundle is refused until identity is verified — an export delivered to an impostor is a breach performed on request.",
      "buildBundle": "Build the bundle",
      "bundleBuilt": "Bundle built",
      "bundleHash": "Manifest hash: {hash}",
      "bundleSections": "Sections in the bundle",
      "bundleRows": "{count} row(s)",
      "fulfil": "Fulfil",
      "fulfilled": "Request fulfilled",
      "fulfilTitle": "Fulfil this request",
      "fulfilDescription": "Close the request as answered.",
      "fulfilNote": "Note",
      "overrideCode": "Override reason",
      "overrideHint": "Fulfilling with open tasks is a governed exception.",
      "refuse": "Refuse",
      "refused": "Request refused",
      "refuseTitle": "Refuse this request",
      "refuseDescription": "A refusal needs a reason code the subject can be told.",
      "refuseCode": "Refusal reason",
      "runClock": "Run the clock",
      "clockTitle": "Run the deadline sweep",
      "clockDescription": "Raises warnings and breaches as at a date you choose. A schedule is not a control.",
      "clockOn": "As at",
      "clockOnHint": "Empty means today, on the tenant's clock.",
      "clockResult": "As at {on}: scanned {scanned}, warned {warned}, breached {breached}.",
      "due_soon": "A data-subject request is approaching its deadline."
    },
    "erasure": {
      "panelTitle": "Erasure",
      "panelDescription": "What goes, what stays, and the law that says so.",
      "withheld": "Executing an erasure is a separate permission. You do not hold it.",
      "blockedUnverified": "Identity has not been verified. An erasure is refused absolutely — there is no override for this.",
      "preview": "Preview the erasure",
      "title": "Erasure preview",
      "description": "Everything this erasure will do to {name}. Nothing is written until you confirm.",
      "identityGate": "Identity has not been verified, so this erasure cannot be executed. There is no override — not for a tenant admin, not with a reason code.",
      "uncovered": "These modules registered after this request was raised and have no task yet: {types}. Add the missing tasks before erasing.",
      "willErase": "{columns} column(s) erased · {records} record(s)",
      "willRetain": "{columns} column(s) retained · {records} record(s)",
      "unruledCount": "{count} column(s) with no rule",
      "eraseHeading": "Will be erased",
      "eraseNote": "Replaced with an empty value, or with a stable token where the column must stay unique.",
      "noneToErase": "Nothing to erase.",
      "retainHeading": "Will be retained",
      "retainNote": "Kept because a law, a contract or a live dispute requires it. Each one names its reason.",
      "noneRetained": "Nothing is retained.",
      "records": "{count} record(s)",
      "retainYears": "{years} year(s)",
      "noStatuteCited": "No statute cited — this rule should be reviewed.",
      "unruledField": "No retention rule covers this column. It will be erased and reported.",
      "attachmentNote": "{count} stored file(s) will be queued for deletion after the transaction commits. A storage delete cannot be rolled back, so it never happens inside one.",
      "confirmLabel": "Type {name} to confirm",
      "confirmHint": "An irreversible act reached by one click is an act somebody performs by accident.",
      "note": "Note",
      "execute": "Erase",
      "done": "Erasure complete",
      "unverifiedAbsolute": "This erasure is refused because identity has not been verified. There is no override for this rule.",
      "receipt": "Erased {erased} column(s), pseudonymised {pseudonymised}, retained {retained}, across {records} record(s).",
      "attachmentsQueued": "{count} stored file(s) queued for deletion. They are removed after commit, with retries.",
      "unruledErased": "These columns had no retention rule and were erased: {columns}. Add rules for them."
    },
    "retention": {
      "title": "Retention catalogue",
      "description": "The table an erasure is driven by. There is no column list anywhere else.",
      "column": "Column",
      "treatment": "Treatment",
      "basis": "Lawful basis",
      "statute": "Statute or contract",
      "noStatute": "None cited — a retain rule must name its reason",
      "retainYears": "Years",
      "anchor": "Counted from",
      "source": "Source",
      "source_system": "System",
      "source_tenant": "Tenant",
      "orphaned": "Orphaned",
      "anyLinkType": "Any link type",
      "unruledOnly": "Only columns with no rule",
      "emptyTitle": "No retention rules",
      "emptyDescription": "Run a reconciliation to write the rules each module declares.",
      "zeroRuleTitle": "Link types declaring no personal data",
      "zeroRuleDescription": "These modules declare zero retention rules. That is a legitimate assertion — \"I hold no personal data\" — and it is also what a module that forgot to declare looks like. Check each one.",
      "reconcile": "Reconcile",
      "reconciled": "Catalogue reconciled",
      "reconcileTitle": "Reconcile against the registry",
      "reconcileDescription": "Write any rule a module declares that is missing here.",
      "reconcileExplains": "Missing rules are written. A rule you have made stricter is left alone. A rule that is looser than the module's own default is left alone and reported — silently tightening your configuration would be its own kind of wrong. Nothing is ever deleted.",
      "reconcileSummary": "Wrote {inserted} rule(s); {unchanged} were already correct.",
      "looserTitle": "Looser than the module declares — review these:",
      "orphanedTitle": "No module owns these link types any more:",
      "unruledTitle": "Declared columns with no rule:",
      "reconcileCleanTitle": "Nothing to report",
      "reconcileCleanDescription": "Every declared column has a rule, and none of them is looser than its module's default."
    },
    "loyalty": {
      "programsTitle": "Loyalty programmes",
      "programsDescription": "Earning rules and tiers. Points are a quantity, not money.",
      "noLedgerNote": "Points post nothing to the general ledger. A points liability needs a redemption value and a breakage estimate, and neither exists until points can be spent.",
      "programsEmptyTitle": "No programmes",
      "programsEmptyDescription": "A programme sets the earn rate and the currency it applies to.",
      "createProgram": "New programme",
      "createProgramDescription": "The currency cannot be changed later — an accrual records the currency it was earned in.",
      "programCreated": "Programme created",
      "searchPlaceholder": "Code or name",
      "anyStatus": "Any status",
      "code": "Code",
      "name": "Name",
      "currency": "Currency",
      "currencyHint": "Three-letter ISO code.",
      "pointsPerUnit": "Points per unit",
      "pointsPerUnitHint": "Points earned per one unit of eligible spend.",
      "rounding": "Rounding",
      "rounding_down": "Round down",
      "rounding_nearest": "Round to nearest",
      "tiers": "Tiers",
      "status": "Status",
      "status_draft": "Draft",
      "status_active": "Active",
      "status_closed": "Closed",
      "rateIs": "{rate} points per {currency}",
      "viewMembers": "Members",
      "tiersTitle": "Tiers",
      "tiersDescription": "A tier multiplies the earn rate. Every tier needs at least one threshold.",
      "tiersEmptyTitle": "No tiers",
      "tiersEmptyDescription": "A programme without tiers earns at the base rate for everyone.",
      "addTier": "Add tier",
      "addTierDescription": "A tier needs a points threshold, a spend threshold, or both.",
      "tierAdded": "Tier added",
      "sortOrder": "Order",
      "minPoints": "Minimum points",
      "minPointsIs": "{points} points",
      "minSpend": "Minimum spend",
      "earnMultiplier": "Earn multiplier",
      "earnMultiplierHint": "1 earns at the base rate; 1.5 earns half as much again.",
      "thresholdRequired": "A tier needs at least one threshold — points, spend, or both. Without one, nobody can reach it.",
      "membersTitle": "Loyalty members",
      "membersDescription": "A membership belongs to a party, so one person's stays, orders and tickets accrue to one balance.",
      "membersEmptyTitle": "No members",
      "membersEmptyDescription": "Enrol a party into a programme to start accruing.",
      "memberSearchPlaceholder": "Membership number or name",
      "anyProgram": "Any programme",
      "anyMemberStatus": "Any status",
      "membershipNo": "Membership",
      "membershipNoHint": "Leave empty and one is issued. Supply a value only when importing an existing programme's numbers.",
      "program": "Programme",
      "party": "Party",
      "findParty": "Find the party",
      "tier": "Tier",
      "pointsBalance": "Points balance",
      "pointsLifetime": "Lifetime points",
      "spendRolling12": "Spend, rolling 12 months",
      "memberStatus_active": "Active",
      "memberStatus_suspended": "Suspended",
      "memberStatus_closed": "Closed",
      "enrol": "Enrol",
      "enrolled": "Member enrolled",
      "enrolTitle": "Enrol a party",
      "enrolDescription": "The membership belongs to the identity, not to a customer record.",
      "enrolledOn": "Enrolled {date}",
      "tierReviewedOn": "Tier reviewed {date}",
      "openParty": "Open the party",
      "reviewTier": "Review tier",
      "tierChanged": "Tier moved from {from} to {to} — {reason}",
      "tierUnchanged": "Reviewed; the tier did not change — {reason}",
      "ledgerTitle": "Accrual ledger",
      "ledgerDescription": "Append-only. The balance above is the server's projection of this ledger, not a total of this page.",
      "ledgerEmptyTitle": "Nothing earned yet",
      "ledgerEmptyDescription": "Accruals arrive from invoices, orders and folios, or are added here by hand.",
      "businessOn": "Date",
      "source": "Source",
      "accrualSource_ar_invoice": "Sales invoice",
      "accrualSource_sales_order": "Sales order",
      "accrualSource_pos_sale": "POS sale",
      "accrualSource_pms_folio": "Folio",
      "accrualSource_manual": "Added by hand",
      "eligibleAmount": "Eligible amount",
      "eligibleAmountHint": "What the points are computed from. Eligibility is decided by the module that raised the document, never here.",
      "rateApplied": "Rate",
      "multiplierApplied": "Multiplier",
      "points": "Points",
      "addAccrual": "Add accrual",
      "addAccrualDescription": "A goodwill award or a correction. The regular path is the document that earned them.",
      "accrualAdded": "Accrual added",
      "sourceKey": "Reference",
      "sourceKeyHint": "Unique per member. A repeated reference returns the original accrual rather than adding a second.",
      "note": "Note"
    },
    "queue": {
      "dsr_overdue": "Data-subject requests near or past their deadline"
    }
  },
  "treasury": {
    "accountType": {
      "collection": "Collection",
      "deposit": "Term deposit",
      "disbursement": "Disbursement",
      "escrow": "Escrow",
      "operating": "Operating",
      "payroll": "Payroll",
      "pool_header": "Pool header"
    },
    "accuracy": {
      "absoluteError": "Absolute error",
      "actualClosing": "Actual",
      "actualFrom": "Actual from",
      "bandsCaption": "Mean absolute percentage error by horizon band",
      "bandsTitle": "By horizon",
      "breachedBuckets": "{count} bucket(s) below minimum",
      "description": "How close the published forecasts came to the published positions that followed them.",
      "empty": "Nothing has been measured yet.",
      "error": "Error",
      "forecastClosing": "Forecast",
      "horizon": "Horizon",
      "horizonDays": "Days ahead",
      "loadFailed": "That report did not load",
      "mape": "MAPE",
      "mapeNote": "{measured} measurement(s) counted; {undefinedCount} could not be measured because the actual was zero. A percentage error against zero is undefined, and inventing one would make this report unreadable.",
      "meanError": "Mean error",
      "measuredOn": "Measured on",
      "measurements": "Measurements",
      "measurementsCaption": "Each forecast bucket against the position that followed it",
      "measurementsTitle": "Measurements",
      "notMeasurable": "not measurable",
      "openRun": "Open the run",
      "overall": "Overall",
      "publishedPosition": "Published position",
      "title": "Forecast accuracy"
    },
    "actions": {
      "confirm": "Confirm"
    },
    "approvals": {
      "approveDescription": "Approving books the expense and, with a tax invoice, releases the recoverable input tax.",
      "approveTitle": "Approve the spend",
      "caption": "Captured spends awaiting a decision",
      "decided": "The spend was decided.",
      "description": "Spends waiting for a decision — and the only place recoverable input tax is released.",
      "emptyDescription": "No captures from this wallet are waiting for a decision.",
      "emptyTitle": "Nothing is waiting",
      "loadFailed": "Those captures did not load",
      "noInvoiceNote": "This capture has no tax invoice, so no input tax can be recovered from it.",
      "openWallet": "Open the wallet",
      "receiptOnly": "Receipt only",
      "recoverableHint": "The receipt shows {tax} of tax. The server refuses more than that.",
      "rejectDescription": "Rejecting makes the money recoverable from the custodian, so it needs a reason.",
      "rejectNote": "This makes the amount recoverable from the custodian.",
      "rejectTitle": "Reject the spend",
      "releaseTax": "Release recoverable input tax",
      "tableTitle": "Awaiting approval",
      "taxInvoice": "Tax invoice",
      "title": "Wallet approvals",
      "walletLink": "Every capture belongs to a wallet."
    },
    "basis": {
      "available": "Available",
      "bankBooked": "Bank booked",
      "ledger": "Ledger",
      "valueDated": "Value dated"
    },
    "beneficiaries": {
      "anyStatus": "Any verification",
      "caption": "Payment beneficiaries and their verification state",
      "coolingUntil": "Until {at}",
      "description": "Everyone this legal entity may instruct money to, and how well each one is proven.",
      "detailWithheld": "Withheld",
      "emptyDescription": "Raise a request for the first payee. It is approved by somebody else, and then it waits out a cooling-off period before any money can reach it.",
      "emptyTitle": "No beneficiaries yet",
      "loadFailed": "Those beneficiaries did not load",
      "openChanges": "Change requests",
      "request": "New beneficiary",
      "requestConfirm": "Raise request",
      "requestDescription": "This raises a change request. Approval is what creates the beneficiary — one person cannot add a payee alone.",
      "requestNote": "Nothing is paid to this beneficiary until the request is approved and its cooling-off period has run.",
      "requestTitle": "Request a new beneficiary",
      "requested": "The change request was raised.",
      "searchHint": "Matches name, code and bank.",
      "tableTitle": "Register",
      "title": "Payment beneficiaries"
    },
    "beneficiary": {
      "blockAction": "Block",
      "blockDescription": "A blocked beneficiary cannot be paid at all, and the refusal has no override.",
      "blockTitle": "Block or unblock",
      "blockUpdated": "The beneficiary was updated.",
      "blockedBanner": "This beneficiary is blocked. No instruction may be submitted to it, and there is no override.",
      "changeAction": "Change bank detail",
      "changeConfirm": "Raise change request",
      "changeDescription": "Changing where money goes is the oldest payment fraud there is, so a change is a request.",
      "changeNote": "Somebody else approves this, and it then waits out a cooling-off period before any payment can use it.",
      "changeRaised": "The change request was raised.",
      "changeTitle": "Request a change",
      "coolingOffBanner": "This beneficiary is cooling off until {at}. Nothing may be paid to it before then.",
      "description": "The payee, its bank detail, and everything that has ever been done to prove it.",
      "detailsTitle": "Details",
      "independentSourceHint": "Where the number came from — a contract, a prior statement, the payee's published switchboard. It must NOT be the change request.",
      "loadFailed": "That beneficiary did not load",
      "pennyAmount": "Penny amount",
      "pennyAmountHint": "A token credit the payee must quote back.",
      "pennyReference": "Reference quoted back",
      "revealAction": "Reveal account number",
      "revealAudited": "This reveal has been recorded in the audit log.",
      "revealConfirm": "Reveal",
      "revealDescription": "The number is decrypted once, shown once, and never cached.",
      "revealReasonHint": "Why you need it. The reason is stored with your name against it.",
      "revealTitle": "Reveal the account number",
      "title": "Beneficiary",
      "unblockAction": "Unblock",
      "verificationRecorded": "The verification was recorded.",
      "verificationsCaption": "Verification attempts",
      "verificationsDescription": "Every attempt, not only the last one. The second attempt is what an investigator wants to see.",
      "verificationsEmpty": "This beneficiary has never been verified.",
      "verificationsTitle": "Verification history",
      "verifyAction": "Verify",
      "verifyComplete": "Record the outcome",
      "verifyDescription": "Prove that the account belongs to the payee you think it does.",
      "verifyStart": "Start",
      "verifyTitle": "Verify the beneficiary",
      "withheldNote": "Bank detail is not shown to a read-only reader. A masked number is still four real digits, and a bank name is still a lead."
    },
    "blockReasons": {
      "dispute": "Dispute",
      "dormant": "Dormant",
      "fraud_suspicion": "Fraud suspected",
      "other": "Other",
      "sanctions_hit": "Sanctions hit"
    },
    "certificate": {
      "actionsTitle": "Actions",
      "addUnrecorded": "Add: items not yet recorded",
      "authorise": "Authorise",
      "backToSession": "Back to the session",
      "balancePerBank": "Balance per bank statement",
      "balancePerLedger": "Balance per ledger",
      "certified": "Certificate {no} was issued.",
      "certifiedBy": "Certified by",
      "certify": "Certify",
      "certifyWithOverride": "Certify anyway",
      "decline": "Decline",
      "description": "The attestation a session needs before it can close, and the reopen that invalidates it.",
      "download": "Download certificate",
      "downloaded": "The certificate was downloaded.",
      "gateNote": "Certification is a second gate in front of the tie-out, never a replacement for it. A session that does not balance cannot be certified.",
      "hash": "Manifest hash",
      "ledgerClosing": "Balance per ledger",
      "lessUnpresented": "Less: unpresented payments",
      "loadFailed": "That session did not load",
      "matcherWarning": "You confirmed matches in this session. The certifier attests that the matches are right; the matcher made them. The override is banded, logged and reported.",
      "number": "Certificate number",
      "openLink": "Certificate",
      "override": "Override",
      "overrideAcknowledge": "I am certifying matches I made myself",
      "overrideHint": "Why you are certifying a session whose matches you made.",
      "reopenDecided": "The reopen request was decided.",
      "reopenDescription": "A different person has to authorise it.",
      "reopenPending": "A reopen has been requested and is waiting for a second authoriser.",
      "reopenRequested": "The reopen was requested.",
      "reopenSod": "You requested this reopen, so you may not authorise it.",
      "reopenTitle": "Request a reopen",
      "reopenWarning": "Reopening invalidates the certificate. A session certified, reopened, changed and closed on the strength of the original attestation would make the attestation worthless.",
      "requestReopen": "Request a reopen",
      "sessionTitle": "Session",
      "statementClosing": "Balance per bank",
      "statementTitle": "Bank reconciliation statement",
      "title": "Reconciliation certificate",
      "unmatched": "Unmatched statement lines"
    },
    "changeAction": {
      "create": "Create",
      "deactivate": "Deactivate",
      "update": "Change"
    },
    "changeStatus": {
      "applied": "Applied",
      "approved": "Approved, cooling off",
      "pending": "Awaiting approval",
      "rejected": "Rejected"
    },
    "changes": {
      "anyStatus": "Any status",
      "approveTitle": "Approve the change",
      "caption": "Beneficiary change requests and their cooling-off state",
      "decideDescription": "Approving starts the cooling-off period; the beneficiary cannot be paid before it ends.",
      "decided": "The change request was decided.",
      "description": "What is waiting for approval, and what has been approved and is still cooling off.",
      "effectiveAt": "Effective {at}",
      "emptyDescription": "No beneficiary change requests match these filters.",
      "emptyTitle": "Nothing is waiting",
      "hours": "{hours} h",
      "loadFailed": "Those change requests did not load",
      "openRegister": "Beneficiary register",
      "rejectTitle": "Reject the change",
      "releaseConfirm": "Release now",
      "releaseDescription": "The wait exists to give somebody time to notice a fraud. Cutting it short is recorded against your name.",
      "releaseEarly": "Release early",
      "releaseTitle": "Cut the cooling-off short",
      "releaseWarning": "Whoever approved this change may not release it. That is the control, and the server enforces it.",
      "released": "The cooling-off was released.",
      "releasedEarly": "Released early — {code}",
      "sodBlocked": "You approved this",
      "tableTitle": "Change requests",
      "title": "Beneficiary changes"
    },
    "clearingPolicy": {
      "immediate": "Immediate",
      "manual": "Manual",
      "next_day": "Next day",
      "value_date": "On value date"
    },
    "continuity": {
      "acknowledge": "Acknowledge the break",
      "acknowledgeDescription": "Say why the statements do not follow on. An unexplained break somebody clicked past is what this control exists to prevent.",
      "acknowledgeTitle": "Acknowledge the continuity break",
      "acknowledged": "The break was acknowledged.",
      "acknowledgedBy": "Acknowledged by {who} at {at} — {code}",
      "breakBody": "The prior statement closed at {prior} and this one opens at {opening}. The gap is",
      "okBody": "This statement follows on from the last one."
    },
    "continuityReasons": {
      "account_opened_mid_period": "Account opened mid-period",
      "bank_reissued_statement": "The bank reissued the statement",
      "known_bank_error": "Known bank error",
      "other": "Other",
      "statement_out_of_order": "Statements imported out of order"
    },
    "continuityStatus": {
      "balance_break": "Opening does not match",
      "first": "First statement",
      "ok": "Continuous",
      "overlap": "Windows overlap",
      "sequence_gap": "Statement number skipped",
      "unchecked": "Not checked"
    },
    "count": {
      "blindNotice": "This is a blind count. The system figure is not in the response, so nothing on this page can show it to you before you post.",
      "cancel": "Cancel count",
      "cancelConfirm": "Cancel count",
      "cancelDescription": "The sheet is kept and the count is closed without posting.",
      "cancelTitle": "Cancel the count",
      "cancelled": "The count was cancelled.",
      "caption": "Denominations counted",
      "countedTotal": "Counted total",
      "description": "Count the tin, save the sheet, and post. The system figure appears only once you have posted.",
      "loadFailed": "That count sheet did not load",
      "post": "Post count",
      "postDescription": "Posting snapshots the system figure and computes the variance. It cannot be undone.",
      "postTitle": "Post the count",
      "posted": "The count was posted.",
      "resultTitle": "Result",
      "save": "Save sheet",
      "saved": "The sheet was saved and totalled.",
      "sheetTitle": "Count sheet",
      "systemTotal": "System total",
      "title": "Cash count {no}",
      "unapprovedCaptures": "Unapproved captures held",
      "unapprovedNote": "A tin short by exactly the value of receipts sitting in it is not short. Unapproved captures are shown so the variance is not read as a shortage.",
      "variance": "Variance",
      "witnessHint": "A second pair of eyes, and a different person from the counter.",
      "witnessSame": "The witness must be a different person from the counter.",
      "varianceOwner": "Variance owner",
      "varianceOwnerHint": "The person who answers for this variance. A variance is never written off without a cause and an owner."
    },
    "countKind": {
      "closing": "Closing",
      "handover": "Handover",
      "periodic": "Periodic",
      "surprise": "Surprise"
    },
    "countStatus": {
      "cancelled": "Cancelled",
      "counted": "Counted",
      "draft": "Draft",
      "posted": "Posted"
    },
    "counterpartyKind": {
      "customer": "Customer",
      "employee": "Employee",
      "other": "Other",
      "related_company": "Related company",
      "tax_authority": "Tax authority",
      "vendor": "Vendor"
    },
    "covenantKind": {
      "affirmative": "Affirmative",
      "financial": "Financial",
      "information": "Information",
      "negative": "Negative"
    },
    "covenantOutcome": {
      "fail": "Fail",
      "not_tested": "Not tested",
      "pass": "Pass",
      "pending": "Not yet tested",
      "waived": "Waived"
    },
    "covenants": {
      "caption": "Covenants and their latest test",
      "computationTitle": "How it was computed",
      "computationWithheld": "Working withheld",
      "create": "New covenant",
      "createDescription": "A financial covenant names a registered metric, a comparison and a threshold.",
      "createTitle": "Create a covenant",
      "created": "The covenant was created.",
      "description": "What each facility promised, and whether it is being kept.",
      "emptyDescription": "Record what the lender asked for, so a breach is found here rather than in a letter.",
      "emptyTitle": "No covenants on this facility",
      "loadFailed": "Those covenants did not load",
      "metricHint": "A registered metric key. The system computes it; a covenant from typed arithmetic is one nobody can audit.",
      "openFacilities": "Facilities",
      "record": "Record test",
      "recordDescription": "State the actual figure and the outcome for the period under test.",
      "recordTitle": "Record a covenant test",
      "recorded": "The test was recorded.",
      "showComputation": "Working",
      "tableTitle": "Covenant board",
      "title": "Covenants",
      "waive": "Waive",
      "waiveDescription": "A waiver names the document the lender granted it in.",
      "waiveTitle": "Waive a breach",
      "waived": "The breach was waived.",
      "waiverRefHint": "Waived with no reference is an assertion, not evidence."
    },
    "dayCount": {
      "act_360": "Actual / 360",
      "act_365": "Actual / 365",
      "thirty_360": "30 / 360"
    },
    "diff": {
      "availableDelta": "Available change",
      "caption": "Differences per holder",
      "change": "Change",
      "changes": {
        "added": "Added",
        "changed": "Changed",
        "removed": "Removed",
        "unchanged": "Unchanged"
      },
      "description": "Two versions of one position date, and every figure that moved between them.",
      "empty": "Nothing changed between these versions.",
      "fromLedger": "Was",
      "linesTitle": "By holder",
      "loadFailed": "That comparison did not load",
      "summaryTitle": "Totals",
      "title": "What the correction changed",
      "toLedger": "Now"
    },
    "exceptionReasons": {
      "account_closed": "Account closed",
      "bank_refused": "The bank refused it",
      "duplicate": "Duplicate",
      "entered_in_error": "Entered in error",
      "fraud": "Fraud",
      "insufficient_funds": "Insufficient funds",
      "invalid_details": "Invalid details",
      "no_longer_needed": "No longer needed",
      "other": "Other",
      "superseded": "Superseded",
      "wrong_amount": "Wrong amount",
      "wrong_beneficiary": "Wrong beneficiary"
    },
    "facilities": {
      "anyStatus": "Any status",
      "caption": "Debt facilities, drawn and outstanding",
      "commitmentHint": "Charged on the undrawn balance of a revolver only.",
      "create": "New facility",
      "createDescription": "The rate, the day count and the maturity are what every later accrual is computed from.",
      "createTitle": "Create a facility",
      "created": "The facility was created.",
      "dayCountHint": "A market convention, not a tax rule. It changes the interest by real money.",
      "description": "What has been committed by a lender, what has been drawn, and what is left.",
      "emptyDescription": "Record the loan, overdraft or revolving facility the legal entity holds, so its interest is accrued rather than remembered.",
      "emptyTitle": "No facilities yet",
      "loadFailed": "Those facilities did not load",
      "openCovenants": "Covenants",
      "openMaturity": "Maturity ladder",
      "tableTitle": "Facilities",
      "title": "Debt facilities"
    },
    "facility": {
      "accrualsCaption": "Interest and fee accrued per period",
      "accrualsDescription": "Each accrual expands to the segments it was computed over — exact figures, summed and rounded once.",
      "accrualsEmpty": "No interest has been accrued on this facility.",
      "accrualsTitle": "Interest accruals",
      "activate": "Activate",
      "activated": "The facility is active.",
      "commitSchedule": "Commit schedule",
      "covenantsTitle": "Covenants",
      "currentPortionHint": "Moves at the reporting date, not at drawdown",
      "description": "Its terms, its schedule, what has moved, and the interest it has accrued.",
      "drawdown": "Drawdown",
      "drawdownConfirm": "Post drawdown",
      "drawdownDescription": "Money comes in and a liability is created, in one posting.",
      "drawdownPosted": "The drawdown was posted.",
      "drawdownTitle": "Post a drawdown",
      "generateSchedule": "Schedule",
      "loadFailed": "That facility did not load",
      "movementsCaption": "Money in and out of this facility",
      "movementsEmpty": "Nothing has been drawn or repaid on this facility.",
      "movementsTitle": "Drawdowns and repayments",
      "overrideAcknowledge": "I am posting past a limit the system refused",
      "overrideHint": "Why this is being allowed past the limit. It is logged and reported.",
      "previewCaption": "Proposed instalments",
      "previewNote": "This is a preview. Nothing has been written.",
      "previewSchedule": "Preview",
      "repayment": "Repayment",
      "repaymentConfirm": "Post repayment",
      "repaymentDescription": "Accrued interest is settled before principal.",
      "repaymentPosted": "The repayment was posted.",
      "repaymentTitle": "Post a repayment",
      "roundedOnce": "Sum of the exact segments, rounded once",
      "scheduleCaption": "Contractual instalments",
      "scheduleCommitted": "The schedule was committed.",
      "scheduleDialogDescription": "Preview first. Committing supersedes the current schedule and leaves the old generation readable.",
      "scheduleDialogTitle": "Generate a schedule",
      "scheduleEmpty": "No schedule has been generated for this facility.",
      "scheduleTitle": "Repayment schedule (v{version})",
      "scheduleTotals": "Totals",
      "segmentsCaption": "The balance segments the accrual was computed over",
      "termsTitle": "Terms",
      "title": "Facility"
    },
    "facilityKind": {
      "guarantee": "Guarantee",
      "overdraft": "Overdraft",
      "revolving": "Revolving",
      "term_loan": "Term loan",
      "bond": "Bond",
      "demand_loan": "Demand loan",
      "intercompany_loan": "Intercompany loan",
      "lease_liability": "Lease liability"
    },
    "facilityStatus": {
      "active": "Active",
      "cancelled": "Cancelled",
      "defaulted": "Defaulted",
      "draft": "Draft",
      "repaid": "Repaid",
      "closed": "Closed",
      "in_default": "In default",
      "matured": "Matured",
      "pending_approval": "Pending approval"
    },
    "fields": {
      "accountName": "Account name",
      "accountNumber": "Account number",
      "accountNumberHint": "Stored encrypted. Only the last few characters are ever shown again.",
      "accountType": "Account type",
      "accruedInterest": "Accrued interest",
      "action": "Action",
      "actual": "Actual",
      "amount": "Amount",
      "asOf": "As at",
      "averagePrincipal": "Average principal",
      "balance": "Balance",
      "band": "Band",
      "bankAccount": "Bank account",
      "bankDetail": "Bank detail",
      "bankName": "Bank",
      "bankReference": "Bank reference",
      "baseRateCode": "Base rate series",
      "basis": "Basis",
      "beneficiary": "Beneficiary",
      "blocked": "Blocked",
      "blockedNote": "Why it is blocked",
      "canSignInApp": "Can sign in app",
      "category": "Category",
      "ceiling": "Ceiling",
      "clearingAccount": "Clearing account",
      "clearingPolicy": "Clearing policy",
      "closing": "Closing",
      "code": "Code",
      "commitmentFeeRate": "Commitment fee rate",
      "company": "Legal Entity",
      "connector": "Connector",
      "contactName": "Contact name",
      "contactNumber": "Number called",
      "coolingOff": "Cooling off",
      "countKind": "Count kind",
      "countedBy": "Counted by",
      "counterparty": "Counterparty",
      "counterpartyKind": "Kind",
      "covenant": "Covenant",
      "covenantKind": "Covenant kind",
      "currency": "Currency",
      "currentPortion": "Current portion",
      "custodian": "Custodian",
      "dailyDays": "Daily days",
      "date": "Date",
      "dayCount": "Day count",
      "days": "Days",
      "delta": "Change",
      "denomination": "Denomination",
      "description": "Description",
      "document": "Document",
      "documentNo": "Document no.",
      "documentRef": "Document reference",
      "drawn": "Drawn / undrawn",
      "dueDate": "Due date",
      "effective": "Effective",
      "effectiveFrom": "Effective from",
      "effectiveOn": "Effective on",
      "effectiveTo": "Effective to",
      "eligible": "Eligible",
      "evidence": "Evidence",
      "exactInterest": "Exact interest",
      "facility": "Facility",
      "facilityKind": "Facility kind",
      "fee": "Fee",
      "firstDueDate": "First due date",
      "fixedRate": "Fixed rate",
      "rateFloor": "Rate floor",
      "rateCap": "Rate cap",
      "float": "Float",
      "frequency": "Frequency",
      "from": "From",
      "fromAccount": "From account",
      "fundingAccount": "Funding account",
      "glAccount": "Ledger account",
      "graceDays": "Grace days",
      "granularity": "Granularity",
      "handoverCountId": "Handover count id",
      "heldReceipts": "Held receipts",
      "holder": "Holder",
      "holders": "Holders",
      "horizonWeeks": "Horizon (weeks)",
      "hours": "Hours",
      "iban": "IBAN",
      "independentSource": "Independent source",
      "instalments": "Instalments",
      "interest": "Interest",
      "journal": "Journal",
      "kind": "Kind",
      "lastCounted": "Last counted",
      "lender": "Lender",
      "limit": "Limit",
      "lineTotal": "Line total",
      "mandate": "Mandate",
      "marginRate": "Margin",
      "maturity": "Maturity",
      "maxAmount": "Maximum",
      "memo": "Memo",
      "method": "Method",
      "metricKey": "Metric",
      "minAmount": "Minimum",
      "minimumBalance": "Minimum balance",
      "module": "Module",
      "name": "Name",
      "newCustodianUserId": "New custodian (user id)",
      "nonCurrentPortion": "Non-current portion",
      "note": "Note",
      "onDate": "On date",
      "operator": "Operator",
      "origin": "Origin",
      "outcome": "Outcome",
      "outstanding": "Outstanding",
      "overdraftLimit": "Overdraft limit",
      "overrideReasonCode": "Override reason code",
      "panel": "Panel",
      "payableDelayDays": "Payable delay (days)",
      "payee": "Payee",
      "performedAt": "Performed at",
      "performedBy": "Performed by",
      "period": "Period",
      "poolRole": "Pool role",
      "positionDate": "Position date",
      "principal": "Principal",
      "purposeCode": "Purpose code",
      "quantity": "Quantity",
      "rate": "Rate",
      "rateKind": "Rate kind",
      "reason": "Reason",
      "reasonCode": "Reason code",
      "reasonCodePlaceholder": "Choose a reason",
      "receiptDate": "Receipt date",
      "receivableDelayDays": "Receivable delay (days)",
      "receivableHaircutPct": "Receivable haircut",
      "recoverable": "Recoverable tax",
      "recurringMultiplierPct": "Recurring multiplier",
      "reference": "Reference",
      "requestedBy": "Requested by",
      "requiredSignatures": "Signatures required",
      "restrictionNote": "Restriction",
      "rule": "Rule",
      "scenario": "Scenario",
      "search": "Search",
      "segment": "Segment",
      "sendDate": "Send date",
      "shortfall": "Shortfall",
      "signatory": "Signatory",
      "signatures": "Signatures",
      "signingRule": "Signing rule",
      "source": "Source",
      "sourceRef": "Source reference",
      "startDate": "Start date",
      "subject": "Subject",
      "supplierTaxId": "Supplier TIN",
      "swift": "SWIFT / BIC",
      "tax": "Tax",
      "taxCode": "Tax code",
      "test": "Test",
      "threshold": "Threshold",
      "to": "To",
      "toAccount": "To account",
      "txnNo": "Transaction no.",
      "undrawn": "Undrawn",
      "valueDate": "Value date",
      "varianceAccount": "Variance account",
      "verificationMethod": "Verification method",
      "verificationStatus": "Verification",
      "version": "Version",
      "waiverExpires": "Waiver expires",
      "waiverRef": "Waiver reference",
      "wallet": "Wallet",
      "walletKind": "Wallet kind",
      "witnessUserId": "Witness (user id)",
      "witnessedBy": "Witnessed by",
      "workings": "Workings"
    },
    "filtersTitle": "Filters",
    "forecast": {
      "adjustedDate": "Assumed date",
      "adjustment": "Adjustment",
      "against": "against a minimum of {minimum}",
      "alreadyPublished": "{date} was already published. The existing run is shown.",
      "belowMinimum": "below minimum",
      "bucketsCaption": "Forecast buckets across the horizon",
      "bucketsDescription": "Week 1 is seven daily buckets and week 2 is a week; each row says which it is.",
      "bucketsTitle": "Buckets",
      "chartAria": "{buckets} buckets, of which {daily} are daily, in {currency}",
      "chartTitle": "Horizon",
      "closing": "Closing",
      "description": "The horizon, the buckets, and the items behind each bucket.",
      "drill": "Show items",
      "fromPosition": "from a published position",
      "frozenNote": "A published forecast is frozen by the same guarantee as a published position. To change it, publish a revision.",
      "inflows": "Inflows",
      "items": "Items",
      "itemsCaption": "The documents behind this bucket",
      "itemsEmpty": "Nothing falls in this bucket.",
      "liquidityGap": "Liquidity gap",
      "loadFailed": "That forecast did not load",
      "minClosing": "Worst closing",
      "minimum": "Minimum balance",
      "noPosition": "no published position to open from",
      "opening": "Opening",
      "outflows": "Outflows",
      "partial": "Some sources were unavailable when this run was built:",
      "publish": "Publish forecast",
      "published": "Forecast published for {date}.",
      "revise": "Publish a revision",
      "reviseConfirm": "Publish revision",
      "reviseDescription": "This creates a new version. The run on screen stays readable and unchanged.",
      "reviseTitle": "Publish a revision",
      "revised": "Version {version} was published.",
      "title": "Forecast as at {date}"
    },
    "forecastSource": {
      "ap": "Supplier invoices",
      "ar": "Customer invoices",
      "debt": "Debt schedule",
      "manual": "Manual adjustment",
      "recurring": "Recurring items",
      "transfer": "Transfers"
    },
    "forecasts": {
      "baseScenario": "Base",
      "caption": "Published forecast runs",
      "dailyHint": "How many days of week 1 to show daily. 0 turns it off.",
      "description": "Forecast runs as they were published, so accuracy is measured against something that cannot move.",
      "emptyDescription": "Publish a forecast for a date. Until then there is nothing for the accuracy report to compare against.",
      "emptyTitle": "Nothing has been published yet",
      "includeSuperseded": "Include superseded revisions",
      "loadFailed": "Those forecasts did not load",
      "openAccuracy": "Accuracy",
      "openScenarios": "Scenarios",
      "publishDescription": "Week 1 is broken into daily buckets; the rest are weeks.",
      "publishTitle": "Publish a forecast",
      "publishedNote": "The live 13-week forecast is under Cash and is untouched. This screen is the published artefact — accuracy compares a published forecast to a published position.",
      "tableTitle": "Runs",
      "title": "Published forecasts"
    },
    "frequency": {
      "annual": "Yearly",
      "monthly": "Monthly",
      "quarterly": "Quarterly",
      "semiannual": "Half-yearly",
      "at_maturity": "At maturity"
    },
    "granularity": {
      "day": "Day",
      "week": "Week"
    },
    "holderKind": {
      "bank_account": "Bank account",
      "wallet": "Wallet"
    },
    "instruction": {
      "alreadySigned": "You have signed this instruction. A second click cannot satisfy a two-signature mandate.",
      "approved": "The instruction was approved.",
      "arrives": "Arrives",
      "beneficiaryBlocked": "This beneficiary is blocked. There is no override — unblock it first, and that is a decision somebody has to take with their name on it.",
      "beneficiaryCoolingOff": "This beneficiary is still cooling off. The wait exists so somebody can notice a fraud; it can be released early, with a reason, by somebody who did not approve it.",
      "beneficiaryUnverified": "This beneficiary has not been verified. Prove the account belongs to the payee before instructing money to it.",
      "cancel": "Cancel",
      "cancelTitle": "Cancel the instruction",
      "confirm": "Confirm receipt",
      "confirmDescription": "Confirming clears funds in transit and posts the receipt leg.",
      "confirmTitle": "Confirm the transfer",
      "confirmed": "The transfer was confirmed.",
      "description": "Who is being paid, out of which account, on whose signature, and where it has got to.",
      "duplicateAcknowledge": "I am submitting a payment the system believes is a duplicate",
      "duplicateSubmit": "Submit anyway",
      "duplicateTitle": "This looks like an instruction you have already sent",
      "duplicateWarning": "The same beneficiary, amount and account inside the duplicate window. A genuine second payment is possible, with a reason on the record.",
      "exceptionDescription": "Governed reasons only. The code is what a report groups by.",
      "exceptionRecorded": "The outcome was recorded.",
      "from": "from {status}",
      "headerTitle": "Instruction",
      "inTransitBanner": "The money has left and has not been confirmed. It is sitting in funds in transit.",
      "loadFailed": "That instruction did not load",
      "noMandate": "no mandate resolved",
      "panelLabel": "Panel {panel}",
      "recall": "Request a recall",
      "recallFailed": "The bank refused the recall",
      "recallNote": "A recall changes nothing in the ledger. The money is still gone; you are asking the bank to send it back, and it may refuse.",
      "recallOutcome": "Record the recall outcome",
      "recallOutcomeTitle": "Record the recall outcome",
      "recallSucceeded": "The bank returned the money",
      "recallTitle": "Request a recall",
      "receiptLeg": "Receipt journal",
      "reject": "Record a rejection",
      "rejectTitle": "The bank refused it",
      "release": "Release to the bank",
      "releaseDescription": "This is the act that instructs the bank.",
      "releaseTitle": "Release the instruction",
      "releaseWarning": "Releasing posts the money out of the bank account and into funds in transit. It cannot be undone — only recalled, and the bank may refuse.",
      "released": "The instruction was released.",
      "reversalLeg": "Reversal journal",
      "sendLeg": "Send journal",
      "sign": "Sign",
      "signaturesDescription": "{applied} of {required} applied.",
      "signaturesEmpty": "Nobody has signed this instruction.",
      "signaturesTitle": "Signatures",
      "signed": "Your signature was applied.",
      "submitted": "The instruction was submitted.",
      "timelineEmpty": "Nothing has happened to this instruction yet.",
      "timelineTitle": "Lifecycle",
      "title": "Instruction"
    },
    "instructionStatus": {
      "approved": "Approved",
      "cancelled": "Cancelled",
      "confirmed": "Confirmed",
      "draft": "Draft",
      "recall_requested": "Recall requested",
      "recalled": "Recalled",
      "rejected": "Rejected by the bank",
      "released": "Released to the bank",
      "returned": "Returned",
      "submitted": "Submitted",
      "screening_hold": "Held for screening"
    },
    "instructions": {
      "anyStatus": "Any status",
      "beneficiaryHint": "An external payee. Its verification state is shown beside the name.",
      "caption": "Transfer instructions and where each one stands",
      "description": "Governed transfers, as documents with a lifecycle rather than postings.",
      "draft": "New instruction",
      "draftConfirm": "Create draft",
      "draftDescription": "Nothing is posted and no money moves until the instruction is released.",
      "draftNote": "A draft posts nothing. It is submitted, approved, signed against a bank mandate, and only then released.",
      "draftTitle": "Draft an instruction",
      "drafted": "Instruction {no} was drafted.",
      "emptyDescription": "Draft the first instruction. It will be approved, signed against a bank mandate, and released by somebody else.",
      "emptyTitle": "No instructions yet",
      "loadFailed": "Those instructions did not load",
      "openTransit": "Funds in transit",
      "tableTitle": "Instructions",
      "title": "Transfer instructions",
      "toAccountHint": "Or another account of this legal entity, for an internal transfer."
    },
    "lineKind": {
      "coin": "Coin",
      "note": "Note",
      "other": "Other",
      "receipt_held": "Receipt held",
      "voucher": "Voucher"
    },
    "mandate": {
      "addSignatory": "Add signatory",
      "addSignatoryDescription": "A signatory may be a user of this system or a person named only on the bank's record.",
      "addSignatoryTitle": "Add a signatory",
      "ceilingHint": "A lower limit than the mandate's own, for a junior signatory. Leave blank for none.",
      "description": "The band it governs, the rule it applies, and the panels it draws signatures from.",
      "effectiveBar": "Effective {from} → {to}",
      "endSignatory": "End",
      "endSignatoryDescription": "This sets an end date. The row is never deleted — they signed things, and the register has to be able to say so.",
      "endSignatoryTitle": "End a signatory's authority",
      "loadFailed": "That mandate did not load",
      "noCeiling": "no ceiling",
      "noSignatories": "This mandate has no signatories, so nothing can be released against it.",
      "openEnded": "open-ended",
      "panelLabel": "Panel {panel}",
      "panelsDescription": "Each signatory's own ceiling is shown beside their name; a release refused for that reason is baffling without it.",
      "panelsTitle": "Signatory panels",
      "signatoryAdded": "The signatory was added.",
      "signatoryEnded": "The signatory's authority was ended.",
      "supersede": "Supersede",
      "supersedeDescription": "A new version takes effect from the date you choose. This one keeps its window and stays readable.",
      "supersedeNote": "A mandate is replaced, never edited — so \"who could sign on 14 March\" stays answerable.",
      "supersedeTitle": "Supersede this mandate",
      "superseded": "The mandate was superseded.",
      "termsTitle": "Terms",
      "title": "Mandate"
    },
    "mandates": {
      "asOfHint": "Show the mandates that were effective on this date.",
      "canSignInApp": "In app",
      "caption": "Bank mandates by account and effective window",
      "create": "New mandate",
      "createDescription": "A mandate governs one amount band on one account from one date.",
      "createTitle": "Create a mandate",
      "created": "The mandate was created.",
      "description": "Who the bank accepts as a signatory on each account, and for how much.",
      "eligibleNo": "Not eligible",
      "eligibleYes": "Eligible",
      "emptyDescription": "Record the bank's own mandate for this account, so a release can be checked against it rather than against somebody's memory.",
      "emptyTitle": "No mandates yet",
      "loadFailed": "Those mandates did not load",
      "maxHint": "Leave blank for no upper limit.",
      "noMandate": "No mandate governed that instruction",
      "paperOnly": "Paper only",
      "requires": "{count} signature(s)",
      "resolveAction": "Resolve",
      "resolveCaption": "Signatories eligible on that date",
      "resolveDescription": "An amount, an account and a date. This is a read and it writes nothing.",
      "resolveTitle": "Who could sign this?",
      "tableTitle": "Mandates",
      "title": "Bank mandates"
    },
    "matchSetStatus": {
      "active": "Active",
      "released": "Released"
    },
    "matchSets": {
      "activate": "Activate set",
      "activated": "Set {no} was activated.",
      "backToSession": "Back to the session",
      "description": "Three statement lines against one journal line, or one against five. A set activates only when it balances.",
      "difference": "Difference",
      "empty": "No match sets in this session.",
      "existingCaption": "Match sets in this session",
      "existingTitle": "Existing sets",
      "ledgerCaption": "Unmatched ledger lines in this session",
      "ledgerEmpty": "No unmatched ledger lines.",
      "ledgerSide": "Ledger lines",
      "ledgerTotal": "Ledger",
      "loadFailed": "That session did not load",
      "openLink": "Match sets",
      "pick": "Select",
      "release": "Release set",
      "releaseNote": "Releasing any member releases the whole set — a set missing one line would no longer balance.",
      "released": "The set was released.",
      "setNo": "Set",
      "shape": "Shape",
      "sides": "Statement {statement} over {statementCount} line(s) · ledger {ledger} over {ledgerCount} line(s)",
      "statementCaption": "Unmatched statement lines in this session",
      "statementEmpty": "No unmatched statement lines.",
      "statementSide": "Statement lines",
      "statementTotal": "Statement",
      "title": "Match sets"
    },
    "maturity": {
      "asOfHint": "The split is computed against this date, not against the drawdown.",
      "description": "The current / non-current split the balance sheet needs, and the ladder behind it.",
      "empty": "No debt is outstanding at this date.",
      "facilitiesCaption": "Outstanding principal split current and non-current",
      "facilitiesTitle": "By facility",
      "inBase": "In {currency}",
      "ladderCaption": "Principal and interest falling due by band",
      "ladderTitle": "Maturity ladder",
      "loadFailed": "That report did not load",
      "splitNote": "An instalment falling due within twelve months of {asOf} is current. The same instalment was non-current a year ago.",
      "title": "Debt maturity"
    },
    "maturityBands": {
      "months0to3": "Within 3 months",
      "months3to12": "3 to 12 months",
      "over5": "Over 5 years",
      "years1to2": "1 to 2 years",
      "years2to5": "2 to 5 years"
    },
    "poolRole": {
      "header": "Pool header",
      "none": "Not pooled",
      "participant": "Pool participant"
    },
    "position": {
      "alreadyPublished": "{date} was already published. The existing run is shown.",
      "blocked": "Less: blocked",
      "bridgeAction": "Bridge",
      "bridgeTitle": "From the ledger to the bank",
      "correctionCodes": {
        "backdated_journal": "A back-dated journal was posted",
        "corrected_fx_rate": "An exchange rate was corrected",
        "late_statement": "A late statement arrived",
        "observation_restated": "A bank observation was restated",
        "other": "Other"
      },
      "currencyCaption": "Totals by currency",
      "currentVersion": "Current",
      "description": "A published position, frozen at the moment it was struck.",
      "export": "Export CSV",
      "exported": "The position was written to a file.",
      "headlineTitle": "Totals, by basis",
      "holdersCaption": "Balances per holder, by basis",
      "holdersDescription": "Every bank account and wallet, with four bases and the source of each.",
      "holdersEmpty": "This run has no holders.",
      "holdersTitle": "Holders",
      "immutableNote": "A published position cannot be edited. To correct it, publish a new version — the old one stays readable.",
      "inBase": "In {currency}",
      "loadFailed": "That position did not load",
      "origin": {
        "manual": "Manual",
        "scheduled": "Scheduled"
      },
      "overdraftLimit": "Add: overdraft limit",
      "partial": "Some sources were unavailable when this was struck, so the figures are partial:",
      "previewBanner": "This is a live figure and it may change. Do not quote it as a published position — publish one first.",
      "previewDescription": "Computed now, from today's data. Nothing here has been published.",
      "previewTitle": "Cash position — live",
      "publish": "Publish",
      "published": "Position published for {date}.",
      "publishedBy": "Published by {who} at {at}",
      "publishedValue": "Published",
      "recomputedValue": "Recomputed",
      "republish": "Publish a correction",
      "republishConfirm": "Publish version",
      "republishDescription": "This creates a new version. The version on screen stays readable and unchanged.",
      "republishTitle": "Publish a correcting version",
      "republished": "Version {version} of {date} published.",
      "status": {
        "draft": "Draft",
        "live": "Live",
        "published": "Published",
        "superseded": "Superseded"
      },
      "supersededVersion": "Superseded",
      "title": "Cash position at {date}",
      "uncleared": "Uncleared credits",
      "unpresented": "Add: unpresented",
      "unrecorded": "Less: unrecorded",
      "verify": "Verify",
      "verifyCaption": "Differences found by recomputation",
      "verifyHashes": "published {published} · recomputed {recomputed}",
      "verifyOutcome": {
        "matched": "The run reproduces exactly inside its own watermark.",
        "mismatch": "The run does not reproduce. Something it depended on has been changed since.",
        "unverifiable": "The run cannot be verified — a source it used is no longer reachable."
      },
      "verifyTitle": "Verification report",
      "versionLabel": "v{version}",
      "versionsDescription": "A correction is a new version. Version 1 stays exactly as it was published.",
      "versionsTitle": "Versions",
      "viewDiff": "What changed"
    },
    "positions": {
      "currentFailed": "The current position did not load",
      "currentTitle": "Current published position",
      "description": "The cash position as it stood on each date it was struck, and never re-derived since.",
      "empty": "No positions match these filters.",
      "historyCaption": "Published position runs",
      "historyTitle": "History",
      "includeSuperseded": "Include superseded versions",
      "loadFailed": "Those positions did not load",
      "neverPublishedDescription": "Publish a position for a date below, or open the live position to see where the legal entity stands right now.",
      "neverPublishedTitle": "Nothing has been published yet",
      "openPreview": "Live position",
      "publishDescription": "A published date is frozen forever. Publishing the same date twice returns the run that already exists.",
      "publishTitle": "Publish a position",
      "title": "Published positions"
    },
    "postingStatus": {
      "draft": "Draft",
      "posted": "Posted",
      "reversed": "Reversed",
      "cancelled": "Cancelled",
      "in_transit": "In transit",
      "pending_approval": "Pending approval"
    },
    "provenance": {
      "derived": "derived",
      "ledger": "from the ledger",
      "observation": "from an observation",
      "statement": "from a statement",
      "unavailable": "no source"
    },
    "rateKind": {
      "fixed": "Fixed",
      "floating": "Floating"
    },
    "rejectReasons": {
      "duplicate": "Duplicate",
      "no_evidence": "No evidence",
      "not_business_expense": "Not a business expense",
      "other": "Other",
      "over_limit": "Over the limit"
    },
    "releaseReasons": {
      "contract_signed": "Contract signed",
      "other": "Other",
      "payroll_deadline": "Payroll deadline",
      "statutory_deadline": "Statutory deadline",
      "verified_by_callback": "Verified by callback"
    },
    "reopenReasons": {
      "audit_finding": "An audit finding",
      "late_statement": "A late statement arrived",
      "mismatched_match": "A match was wrong",
      "other": "Other",
      "wrong_period": "Wrong period"
    },
    "replenishmentStatus": {
      "approved": "Approved",
      "draft": "Draft",
      "funded": "Funded",
      "rejected": "Rejected",
      "submitted": "Submitted"
    },
    "routeTitles": {
      "beneficiaries": "Beneficiaries",
      "beneficiary": "Beneficiary",
      "beneficiaryChanges": "Beneficiary changes",
      "certificate": "Reconciliation certificate",
      "covenants": "Covenants",
      "debtMaturity": "Debt maturity",
      "facilities": "Debt facilities",
      "facility": "Debt facility",
      "forecast": "Forecast",
      "forecastAccuracy": "Forecast accuracy",
      "forecasts": "Published forecasts",
      "fundsInTransit": "Funds in transit",
      "instruction": "Transfer instruction",
      "instructions": "Transfer instructions",
      "mandate": "Bank mandate",
      "mandates": "Bank mandates",
      "matchSets": "Match sets",
      "position": "Position",
      "positionDiff": "Position differences",
      "positionPreview": "Cash position (live)",
      "positions": "Published positions",
      "scenarios": "Forecast scenarios",
      "settings": "Treasury settings",
      "standingRules": "Standing rules",
      "wallet": "Wallet",
      "walletApprovals": "Wallet approvals",
      "walletBalances": "Wallet balances",
      "walletCount": "Cash count",
      "wallets": "Wallets",
      "concentration": "Cash concentration",
      "accrualRun": "Accrual run",
      "accrualRuns": "Interest accruals",
      "positionGroup": "Group cash position",
      "liquidity": "Liquidity Analysis",
      "liquidityGap": "Liquidity gap",
      "walletFunding": "Wallet funding",
      "bankConnections": "Bank connections",
      "intercompanyInstruments": "Intercompany funding",
      "screeningLists": "Screening lists",
      "reconciliationExceptions": "Reconciliation Exceptions",
      "walletCounts": "Cash counts",
      "walletExpenditure": "Expenditure capture"
    },
    "scenarios": {
      "assumptionNote": "A scenario is an assumption, never a second copy of the data. That is what makes base and pessimistic comparable.",
      "assumptions": "Assumptions",
      "caption": "Scenarios and the assumptions each applies",
      "create": "New scenario",
      "createTitle": "Create a scenario",
      "default": "Default",
      "description": "Named sets of assumptions applied to the same due schedules.",
      "dialogDescription": "Five typed assumptions. There is deliberately no way to edit an invoice from here.",
      "editTitle": "Edit the scenario",
      "emptyDescription": "Create a pessimistic scenario beside the base one, so the board can see both from the same facts.",
      "emptyTitle": "No scenarios yet",
      "haircut": "Receivables reduced by",
      "haircutHint": "Assume only part of the receivables arrive. Enter 10 for 10%.",
      "haircutRange": "Enter a percentage between 0 and 100.",
      "includeOverdue": "Overdue receivables are still collectible",
      "loadFailed": "Those scenarios did not load",
      "makeDefault": "Make this the default scenario",
      "multiplierHint": "Enter 100 to leave recurring outflows unchanged; 110 raises them by 10%.",
      "multiplierRange": "Enter a percentage between 0 and 500.",
      "overdue": "Overdue receivables",
      "overdueExcluded": "Treated as lost",
      "overdueIncluded": "Still collectible",
      "payableDelay": "We pay {days} days later",
      "receivableDelay": "Customers pay {days} days later than terms",
      "receivableDelayHint": "Assume customers pay this many days later than their terms.",
      "recurringMultiplier": "Recurring outflows scaled to",
      "saved": "The scenario was saved.",
      "tableTitle": "Scenarios",
      "title": "Forecast scenarios",
      "type": "Type",
      "typeHint": "The base is never chosen here: a scenario becomes the base only by an approved promotion.",
      "types": {
        "base": "Base",
        "upside": "Upside",
        "downside": "Downside",
        "stress": "Stress",
        "what_if": "What-if"
      },
      "baseByPromotion": "A scenario becomes the approved base only through Promote, which a second person approves.",
      "awaitingApproval": "Promotion awaiting approval",
      "superseded": "Superseded base",
      "frozen": "A promotion of this scenario is waiting for its decision, so it cannot be edited.",
      "pendingBanner": "{name} is waiting to replace the base. Requested by {by}; the base in force is unchanged until a second person approves.",
      "toApprovals": "Open the approvals inbox",
      "promote": "Promote to base",
      "promoteTitle": "Promote {name} to base",
      "promoteDescription": "This requests that the scenario replace the planning base. Nothing changes until a second person approves it; the current base is kept.",
      "promoteRequest": "Request promotion",
      "promoteRequested": "The promotion was requested and is waiting for approval.",
      "withdraw": "Withdraw promotion",
      "withdrawTitle": "Withdraw the promotion of {name}",
      "withdrawDescription": "The request is cancelled and the scenario can be edited again.",
      "withdrawNote": "Why is it withdrawn",
      "promotionWithdrawn": "The promotion was withdrawn.",
      "historyTitle": "Promotion history",
      "historyDescription": "Every request to change the planning base, decided or not.",
      "historyLoadFailed": "The promotion history did not load",
      "historyEmpty": "No scenario has been put forward as the base yet.",
      "requested": "Requested",
      "decided": "Decided",
      "promotionStatuses": {
        "pending": "Pending",
        "approved": "Approved",
        "rejected": "Rejected",
        "cancelled": "Withdrawn"
      }
    },
    "scheduleMethod": {
      "annuity": "Annuity",
      "bullet": "Bullet",
      "equal_principal": "Equal principal"
    },
    "scheduleStatus": {
      "paid": "Paid",
      "partly_paid": "Partly paid",
      "scheduled": "Scheduled",
      "superseded": "Superseded",
      "waived": "Waived"
    },
    "sessionStatus": {
      "closed": "Closed",
      "open": "Open"
    },
    "settings": {
      "accountsFooter": "A posting path that needs an account it does not have refuses and names it.",
      "accountsTitle": "Ledger accounts and behaviour",
      "autoPublish": "Publish a position automatically each night",
      "borrowings": "Borrowings",
      "borrowingsCurrent": "Current portion of borrowings",
      "coolingActive": "On",
      "coolingActiveLabel": "This policy is in force",
      "coolingCaption": "Cooling-off policy per subject",
      "coolingDescription": "One timer, shared by vendor bank details, beneficiaries and the legal entity's own accounts.",
      "coolingEditDescription": "How long an approved change waits before any money can pass through it.",
      "coolingEditTitle": "Tune the cooling-off period",
      "coolingEmpty": "No cooling-off subjects are registered.",
      "coolingOff": "Off",
      "coolingSaved": "The policy was saved.",
      "coolingTitle": "Cooling-off policies",
      "coolingZero": "Zero hours with the policy on is a control that is armed and instantaneous — which is off, wearing a label that says on. Switch it off instead.",
      "description": "The accounts treasury posts to, how transfers are governed, and the controls that apply to both.",
      "duplicateWindow": "Duplicate window (hours)",
      "duplicateWindowHint": "An identical instruction inside this window is refused, overridably. 0 turns the check off.",
      "escrowHint": "An escrow account is money held for a third party.",
      "escrowWarning": "An escrow account contributes nothing to available liquidity, whatever its balance says.",
      "facilityFee": "Facility and commitment fees",
      "fundsInTransit": "Funds in transit",
      "fundsInTransitHint": "Where released-but-unconfirmed money sits.",
      "inTransitAlert": "In-transit alert (days)",
      "interestExpense": "Interest expense",
      "interestPayable": "Interest payable",
      "loadFailed": "Those settings did not load",
      "observationDescription": "Re-observing the same account and date corrects the earlier reading; it does not add a second one.",
      "observationRecorded": "The observation was recorded.",
      "observationTitle": "Record a bank balance",
      "observationsCaption": "Recorded bank balances by date",
      "observationsDescription": "What the bank says it holds. An observation never touches the ledger; the position names the one it used.",
      "observationsEmpty": "No observations recorded.",
      "observationsTitle": "Bank balance observations",
      "recordObservation": "Record an observation",
      "saved": "Treasury settings were saved.",
      "sourceRefHint": "Where the figure came from — a portal screenshot, a phone call, a statement number.",
      "tabs": {
        "accounts": "Accounts and modes",
        "coolingOff": "Cooling-off policies",
        "observations": "Balance observations",
        "profiles": "Bank account profiles"
      },
      "title": "Treasury settings",
      "walletClearing": "Wallet clearing",
      "walletCountInterval": "Wallet count interval (days)",
      "walletFloat": "Wallet float",
      "walletVariance": "Cash count variance"
    },
    "signingRule": {
      "a_plus_b": "One from A and one from B",
      "all": "All signatories",
      "any": "Any signatories"
    },
    "standingRules": {
      "accountHint": "Leave blank to apply to every bank account of the legal entity.",
      "anyDirection": "Either direction",
      "autoWarning": "An unattended rule posts to the ledger with nobody watching. It needs a ceiling, and it will not fire against a statement whose continuity is in doubt.",
      "caption": "Standing rules and how each posts",
      "ceiling": "Ceiling",
      "ceilingHint": "The most this rule may post on one line without a human.",
      "create": "New rule",
      "createDescription": "All non-empty conditions must hold. A rule with no conditions would post every line to one account.",
      "createTitle": "Create a standing rule",
      "description": "Turn a recurring bank line into a posting, with the tax treatment stated rather than assumed.",
      "descriptionPattern": "Description contains",
      "direction": "Direction",
      "directionIn": "Money in",
      "directionOut": "Money out",
      "dryRun": "Dry run",
      "dryRunCaption": "Statement lines this rule would match",
      "dryRunDescription": "Over the most recent statements. Nothing is written and nothing is posted.",
      "dryRunEmpty": "This rule matches nothing in the statements examined.",
      "dryRunSummary": "{statements} statement(s), {lines} line(s) examined, {hits} match(es).",
      "dryRunTitle": "What this rule would have matched",
      "dryRunTotals": "Totals",
      "dryRunWritesNothing": "This is a report. Nothing was written.",
      "emptyDescription": "Create a rule for the bank charge that arrives every month, so nobody types an account for it again.",
      "emptyTitle": "No standing rules yet",
      "gross": "Gross",
      "grossToOffset": "gross to the offset account",
      "hits": "Hits",
      "lines": "Lines to examine",
      "loadFailed": "Those rules did not load",
      "match": "Match",
      "mode": "Mode",
      "modeAuto": "Post unattended",
      "modeSuggest": "Suggest",
      "net": "Net",
      "noCeiling": "An unattended rule needs a ceiling. An unattended poster with no ceiling is an unattended poster with no limit.",
      "noCondition": "A rule needs at least one condition, or it would match every statement line.",
      "offsetAccount": "Offset account",
      "patternHint": "Matched against the bank's own wording, so keep it short and stable.",
      "posting": "Posting",
      "priority": "Priority",
      "referencePattern": "Reference contains",
      "saved": "The rule was saved.",
      "statements": "Statements to examine",
      "supersede": "Supersede",
      "supersedeDescription": "A new version takes effect from a date. A rule that rewrote history would restate what it already posted.",
      "supersedeTitle": "Supersede the rule",
      "tableTitle": "Rules",
      "taxCodeHint": "Leave blank to post the gross amount, which is right for an exempt line such as interest received.",
      "taxExclusive": "tax exclusive",
      "taxInclusive": "tax inclusive",
      "taxInclusiveHint": "A bank charge from a registered bank is tax-inclusive: 108.00 on the statement is 100.00 of charge and 8.00 of input tax. Posting the whole 108.00 overstates the expense every month, forever.",
      "taxInclusiveLabel": "The statement amount includes the tax",
      "title": "Standing rules",
      "transactionCode": "Bank transaction code",
      "wouldAutoPost": "post unattended",
      "wouldPost": "Would",
      "wouldSuggest": "suggest only"
    },
    "transit": {
      "age": "Age",
      "alerted": "alerted",
      "anyBucket": "Any band",
      "bandsCaption": "Funds in transit by ageing band",
      "bandsTitle": "Ageing",
      "breakBody": "Register {register}, control account {control}, difference {difference}. One of them has a posting the other cannot see.",
      "breakTitle": "The register and the ledger disagree",
      "controlBalance": "Control account balance",
      "count": "Count",
      "description": "Money that has left and has not arrived — and the ledger account that must equal it.",
      "empty": "Nothing is in transit.",
      "laneCaption": "Released instructions awaiting confirmation",
      "laneTitle": "In transit",
      "loadFailed": "That report did not load",
      "openInstructions": "Instructions",
      "reconciled": "The register and the ledger agree at {total}.",
      "registerTotal": "Register total",
      "released": "Released",
      "title": "Funds in transit"
    },
    "transitBuckets": {
      "days0to2": "0–2 days",
      "days11to20": "11–20 days",
      "days3to5": "3–5 days",
      "days6to10": "6–10 days",
      "over20": "Over 20 days"
    },
    "txnKind": {
      "approval": "Approval",
      "count_variance": "Count variance",
      "rejection": "Rejection",
      "replenish": "Replenishment",
      "return": "Return to bank",
      "reversal": "Reversal",
      "spend": "Spend",
      "transfer_in": "Transfer in",
      "transfer_out": "Transfer out"
    },
    "txnStatus": {
      "approved": "Approved",
      "captured": "Captured",
      "posted": "Posted",
      "rejected": "Rejected",
      "submitted": "Submitted"
    },
    "varianceReasons": {
      "change_given": "Change given",
      "other": "Other",
      "rounding": "Rounding",
      "theft_suspected": "Theft suspected",
      "till_error": "Till error",
      "unrecorded_spend": "Unrecorded spend"
    },
    "verificationMethod": {
      "callback": "Callback",
      "document": "Document",
      "existing_relationship": "Existing relationship",
      "manual": "Manual",
      "penny": "Penny credit"
    },
    "verificationOutcome": {
      "failed": "Failed",
      "passed": "Passed",
      "pending": "Pending"
    },
    "verificationStatus": {
      "blocked": "Blocked",
      "failed": "Verification failed",
      "pending": "Verification in flight",
      "unverified": "Unverified",
      "verified": "Verified"
    },
    "wallet": {
      "blind": "Blind count",
      "blindHint": "The counter is not shown the system figure — not hidden on screen, absent from the response.",
      "capture": "Record a spend",
      "captureConfirm": "Record spend",
      "captureDescription": "Cash left the tin. The expense is not in the accounts until somebody approves it.",
      "captureTaxNote": "Record the tax the receipt shows. Whether any of it is recoverable is decided on approval, and only with a valid tax invoice.",
      "captureTitle": "Record a spend from the tin",
      "captured": "The spend was recorded.",
      "countConfirm": "Open count",
      "countDescription": "One count may be open per wallet, so a variance is always attributable.",
      "countTitle": "Open a cash count",
      "custodyOpened": "The handover was opened.",
      "custodyPending": "Custody is being handed to {to}, effective {on}.",
      "description": "What is in the tin, what has moved through it, and what is owed back to it.",
      "evidenceRequired": "Evidence is required above {ceiling}.",
      "handover": "Hand over custody",
      "handoverConfirm": "Open handover",
      "handoverDescription": "Both custodians sign, and the incoming one must count before accepting.",
      "handoverTitle": "Hand the tin over",
      "hasTaxInvoice": "The receipt is a valid tax invoice",
      "loadFailed": "That wallet did not load",
      "noTaxInvoice": "no tax invoice",
      "openCount": "Open a count",
      "openCountBanner": "Count {no} is open on this wallet.",
      "openCountLink": "Open the sheet",
      "policyHint": "Per spend {perTxn} · per day {daily} · per month {monthly}",
      "replenish": "Request replenishment",
      "replenishConfirm": "Request",
      "replenishDescription": "The money moves through a governed bank transfer; nothing here posts a bank movement of its own.",
      "replenishHint": "An imprest wallet is restored by exactly what was approved and spent.",
      "replenishRequested": "The replenishment was requested.",
      "replenishTitle": "Request a replenishment",
      "replenishmentPending": "Replenishment {no} is {status}.",
      "shortfallHint": "What a replenishment would restore",
      "taxHint": "The tax shown on the receipt.",
      "title": "Wallet",
      "transactionsCaption": "Movements through this wallet",
      "transactionsEmpty": "Nothing has moved through this wallet yet.",
      "transactionsTitle": "Transactions"
    },
    "walletKind": {
      "fluctuating": "Fluctuating",
      "imprest": "Imprest"
    },
    "walletReport": {
      "breakBody": "Sub-ledger {subledger}, control account {control}, difference {difference}. One of them has a posting the other cannot see.",
      "breakTitle": "The wallets and the ledger disagree",
      "caption": "Wallet balances against the control account",
      "control": "Control account balance",
      "description": "Every float, what is in it, and whether the sub-ledger agrees with the ledger.",
      "difference": "Difference",
      "empty": "No wallets to report.",
      "inBase": "In {currency}",
      "loadFailed": "That report did not load",
      "reconciled": "The wallets and the ledger agree at {total}.",
      "subledger": "Sub-ledger total",
      "tableTitle": "By wallet",
      "title": "Wallet balances"
    },
    "walletStatus": {
      "active": "Active",
      "closed": "Closed",
      "suspended": "Suspended",
      "closing": "Closing",
      "dormant": "Dormant",
      "in_handover": "In handover"
    },
    "wallets": {
      "anyStatus": "Any status",
      "caption": "Wallets, their floats and their balances",
      "clearingHint": "Where a captured-but-unapproved spend sits until somebody approves it.",
      "countOverdue": "Count overdue",
      "create": "New wallet",
      "createDescription": "A wallet has its own sub-ledger, so several floats can share one ledger account and still reconcile.",
      "createTitle": "Create a wallet",
      "created": "The wallet was created.",
      "description": "Petty cash tins and imprest floats, and who is accountable for each.",
      "emptyDescription": "A wallet is visible to its custodian, to whoever manages or approves it, and to anyone named on an open count. If you hold no float, an empty list is the right answer.",
      "emptyTitle": "No wallets you can see",
      "floatHint": "The amount an imprest wallet is restored to.",
      "kindHint": "An imprest float is restored to a fixed amount; a fluctuating one is topped up to no particular figure.",
      "loadFailed": "Those wallets did not load",
      "openCaptures": "{count} awaiting approval",
      "openReport": "Balances report",
      "sameAccount": "The float and the clearing account must be different, or a capture would net to nothing.",
      "tableTitle": "Wallets",
      "title": "Wallets"
    },
    "capturePolicies": {
      "allWallets": "All wallets",
      "approval": "Approval",
      "approvalNotRequired": "Not required",
      "approvalRequired": "Required",
      "blockCategory": "Block this category outright",
      "blockedNote": "A blocked category refuses every spend, for everyone, with no override.",
      "caption": "Capture policy versions by expense category",
      "create": "New policy",
      "createDescription": "Per category: what may be spent at once, per day and per month, and when evidence is needed.",
      "createTitle": "Create a capture policy",
      "created": "The capture policy was created.",
      "currentOnly": "Current versions only",
      "daily": "Per day",
      "defaultTaxCode": "Default tax code",
      "description": "The limits a custodian spends within, by expense category. A policy is superseded from a date, never edited.",
      "empty": "No capture policies for this legal entity. Without one, no category can be spent against.",
      "evidenceAbove": "Above {ceiling}",
      "evidenceCeiling": "Evidence-free ceiling",
      "evidenceCeilingHint": "Spends at or below this need no receipt attached.",
      "expenseAccount": "Expense account",
      "limitHint": "Leave blank for no limit.",
      "loadFailed": "Those capture policies did not load",
      "monthly": "Per month",
      "noEvidence": "Not required",
      "openEnded": "open-ended",
      "perTxn": "Per spend",
      "requiresApproval": "A spend needs approval",
      "requiresEvidence": "A spend needs evidence above the ceiling",
      "supersede": "Supersede",
      "supersedeConfirm": "Create new version",
      "supersedeDescription": "The new version takes effect from the date you choose; the current one ends the day before and stays readable.",
      "supersedeFromHint": "Must be after the date the current version took effect.",
      "supersedeNote": "Superseding {code}, in force since {from}.",
      "supersedeTitle": "Supersede the policy",
      "superseded": "A new version of the policy was created.",
      "tab": "Capture policies",
      "title": "Capture policies",
      "walletHint": "Leave blank to apply to every wallet in this legal entity."
    },
    "concentration": {
      "title": "Cash concentration",
      "description": "Sweep structures that pull balances into a header account, push funding out of it, or net a notional pool. A structure is prepared by one person and activated by another; a sweep is simulated first and only that simulation is executed.",
      "create": "New structure",
      "createTitle": "New sweep structure",
      "editTitle": "Edit sweep structure",
      "formDescription": "The header account, its participants, the calendar and the cut-off. An edit is authorised afresh by a second person.",
      "reauthoriseNote": "This structure is suspended. Saving a change returns it to draft, and a second person must activate it again.",
      "reloaded": "This structure was changed by someone else and has been reloaded. Your entries are kept; check them and save again.",
      "saved": "Structure saved.",
      "created": "Structure {code} prepared. A second person must activate it.",
      "anyKind": "Any kind",
      "anyStatus": "Any status",
      "loadFailed": "The sweep structures could not be loaded.",
      "emptyTitle": "No sweep structures yet",
      "emptyDescription": "Prepare a structure to concentrate cash into a header account. Someone other than the preparer then activates it.",
      "tableTitle": "Sweep structures",
      "detailTitle": "Sweep structure",
      "detailFailed": "The sweep structure could not be loaded.",
      "crossEntity": "Cross-entity",
      "activate": "Activate",
      "activateTitle": "Activate this structure",
      "activateDescription": "You are the second person authorising where concentrated money goes. You cannot have prepared it or last changed its terms.",
      "activated": "Structure activated.",
      "activatedAt": "Activated",
      "activationNote": "Activation note",
      "suspend": "Suspend",
      "suspendTitle": "Suspend this structure",
      "suspendDescription": "A suspended structure cannot be simulated or executed. Re-activating it needs a second person.",
      "suspendReason": "Reason for suspending",
      "suspended": "Structure suspended.",
      "deleted": "Structure deleted.",
      "deleteTitle": "Delete this draft",
      "deleteMessage": "The draft is removed. A structure with simulations on record is suspended instead.",
      "awaitingSecondPerson": "A second person must activate this structure. You prepared it or last changed its terms, so you cannot.",
      "faultsTitle": "What stands between this structure and activation, simulation or execution:",
      "entityHint": "Narrows the header accounts offered. Participants may belong to other legal entities.",
      "headerHint": "The account the money is concentrated into, or funded from. The structure takes its legal entity and currency.",
      "cutoffHint": "HH:MM in the operating calendar's timezone. A sweep executed after it is deferred to the next business day.",
      "tabs": {
        "terms": "Terms",
        "simulation": "Simulate and execute",
        "history": "History"
      },
      "kind": {
        "zero_balance": "Zero balance",
        "target_balance": "Target balance",
        "threshold": "Threshold",
        "notional": "Notional pool"
      },
      "kindHint": {
        "zero_balance": "Every participant is swept to zero into the header.",
        "target_balance": "Each participant is brought to its target balance, in either direction.",
        "threshold": "A participant above its threshold is swept down to its target, if one is set.",
        "notional": "No cash moves. The pool position is netted and recorded."
      },
      "status": {
        "draft": "Draft",
        "active": "Active",
        "suspended": "Suspended"
      },
      "runStatus": {
        "simulated": "Simulated",
        "executed": "Executed",
        "recorded": "Recorded",
        "deferred": "Deferred"
      },
      "fields": {
        "code": "Code",
        "name": "Name",
        "kind": "Kind",
        "entity": "Legal entity",
        "headerAccount": "Header account",
        "calendar": "Operating calendar",
        "cutoffTime": "Cut-off",
        "notes": "Notes",
        "account": "Bank account",
        "target": "Target balance",
        "threshold": "Threshold",
        "instrument": "Intercompany instrument"
      },
      "participants": {
        "title": "Participants",
        "hint": "Accounts swept into, or funded from, the header. A zero-balance or notional participant carries no target. A movement between legal entities needs an intercompany instrument.",
        "add": "Add participant",
        "instrumentHint": "Instruments between this account's legal entity and the header's, in the structure's currency."
      },
      "evidence": {
        "title": "Evidence of a right of set-off",
        "required": "This pool spans legal entities. It cannot be activated, simulated or netted without evidence of a right of set-off between them.",
        "optional": "Only needed if a participant belongs to another legal entity than the header.",
        "current": "Evidence is on file (attachment {id}). Choose a file to replace it.",
        "file": "Evidence file",
        "fileHint": "PDF, image, spreadsheet or document, up to {mb} MB.",
        "clear": "Remove the evidence on file",
        "savedButNotAttached": "The structure was saved, but the evidence could not be attached.",
        "retry": "Attach evidence"
      },
      "errors": {
        "stale": "Balances or terms changed after this was simulated. Simulate again.",
        "expired": "This simulation has expired. Simulate again.",
        "mandateMissing": "No bank mandate permits a movement this sweep would instruct.",
        "notConfigured": "The structure is not fully configured.",
        "secondPerson": "A second person must activate this structure: not the preparer, and not whoever last changed its terms."
      },
      "direction": {
        "to_header": "To header",
        "from_header": "From header",
        "none": "No movement"
      },
      "movementOutcome": {
        "planned": "Planned",
        "instructed": "Instructed",
        "none": "None",
        "skipped": "Skipped",
        "blocked": "Blocked",
        "deferred": "Deferred"
      },
      "execution": {
        "instructed": "Executed. The movements became transfer instructions, which now follow the cash module's own approval, signature and release.",
        "recorded": "Recorded. The notional pool position was recorded and no cash moved.",
        "deferred": "The cut-off had passed. Nothing was instructed.",
        "deferredDetail": "The sweep is deferred to {date} and the deferral is recorded.",
        "simulateDeferred": "Simulate {date}"
      },
      "simulation": {
        "title": "Simulation {id}",
        "date": "Business date",
        "dateHint": "A date that does not trade under the calendar moves to the next business day.",
        "run": "Simulate",
        "suspendedNote": "This structure is suspended and cannot be simulated.",
        "loadFailed": "The simulation could not be loaded.",
        "emptyTitle": "No simulation selected",
        "emptyDescription": "Simulate a business date, or open one from the history, to see each participant's movement before anything is executed.",
        "valueDate": "Value date",
        "effectiveDate": "Effective date",
        "cutoffAt": "Cut-off",
        "expiresAt": "Valid until",
        "header": "Header",
        "headerBefore": "Header balance before",
        "headerAfter": "Header balance after",
        "totalToHeader": "Moved to header",
        "totalFromHeader": "Moved from header",
        "shifted": "Moved to {date}: {reason}",
        "cutoffWarning": "The cut-off has passed for this date. Executing now defers the sweep to {date} and records the deferral.",
        "deferred": "Deferred to {date}.",
        "deferralRecorded": "Recorded",
        "poolTitle": "Notional pool",
        "poolNet": "Net position",
        "poolEvidence": "Netted across legal entities on the evidence of set-off in attachment {id}.",
        "poolNoEvidence": "No evidence of a right of set-off is on file.",
        "poolEntityNet": "Net",
        "movements": "Movements",
        "before": "Balance before",
        "direction": "Direction",
        "amount": "Amount",
        "after": "Balance after",
        "outcome": "Outcome",
        "movementDeferredTo": "Deferred to {date}",
        "instruction": "Instruction {id}",
        "execute": "Execute this simulation",
        "resimulate": "Simulate again",
        "blocked": {
          "structureNotActive": "The structure is not active, so this simulation cannot be executed.",
          "executed": "This simulation was executed.",
          "recorded": "This simulation was recorded. Nothing moved.",
          "deferred": "This sweep was deferred to {date}. Simulate that date afresh to run it.",
          "expired": "This simulation has expired. Simulate again.",
          "blocked": "A movement in this simulation is blocked, so it cannot be executed. The reason is shown on the movement."
        }
      },
      "history": {
        "loadFailed": "The simulations could not be loaded.",
        "emptyTitle": "No simulations",
        "emptyDescription": "Nothing has been simulated for this structure yet.",
        "simulated": "Simulated",
        "executed": "Executed",
        "deferredTo": "Deferred to {date}"
      }
    },
    "accrualRun": {
      "accrualsCaption": "Interest and fee accrued per facility in this run",
      "accrualsEmpty": "This run accrued nothing. Every facility it considered was skipped; the reasons are below.",
      "accrualsTitle": "Accruals",
      "backToRuns": "Accrual runs",
      "description": "The journal this run posted, every facility it accrued with its workings, and every facility it skipped.",
      "factsTitle": "Run",
      "loadFailed": "That accrual run did not load",
      "skippedDescription": "A skipped facility was not accrued for this period. Fix the reason, then run the period again; facilities already accrued are not touched twice.",
      "title": "Accrual run: {period}"
    },
    "accrualRuns": {
      "caption": "Interest accrual runs and the journal each one posted",
      "description": "One run per legal entity per fiscal period posts one journal for every active facility. Runs are listed newest first.",
      "emptyDescription": "Run the accrual for a period to post interest and commitment fees on every active facility of this legal entity.",
      "emptyTitle": "No accrual runs yet",
      "facilitiesFailed": "The facilities this run would consider did not load",
      "facilityCount": "Facilities",
      "loadFailed": "Those accrual runs did not load",
      "needsObservation": "Needs a rate observation",
      "noActiveFacilities": "This legal entity has no active facility. A run now would accrue nothing.",
      "noJournal": "No journal",
      "nothingPosted": "Nothing was posted. Every active facility already has an accrual or a recorded skip for {period}.",
      "onDate": "Accrue the period containing",
      "onDateHint": "Leave blank for today in your organisation's timezone. The whole fiscal period this date falls in is accrued.",
      "openFacilities": "Debt facilities",
      "openRun": "Open the run",
      "processed": "Facilities accrued",
      "reviewCaption": "Active facilities this run will consider",
      "reviewNote": "Review what the run will consider. No interest is estimated here: the server computes every figure when the run posts, and a floating facility without a rate observation on or before the period start is skipped, not accrued at zero.",
      "run": "Run accrual",
      "runConfirm": "Post accrual",
      "runDate": "Run date",
      "runDescription": "Posts one journal for this legal entity and period: Dr interest expense, Cr interest payable.",
      "runTitle": "Run the interest accrual",
      "skipped": "Skipped",
      "skippedTitle": "Skipped facilities",
      "tableTitle": "Runs",
      "title": "Interest accruals"
    },
    "debtMaturity": {
      "allEntities": "All legal entities",
      "noEntities": "No legal entity is available to you, so there is no ladder to show.",
      "showAll": "Show every legal entity"
    },
    "debtOps": {
      "agreementRef": "Agreement reference",
      "editDescription": "Correct the terms while the facility is still a draft. Only the fields you change are sent.",
      "editDraftNote": "Terms can be edited only while the facility is a draft. Once active, a change is an amendment, not an edit.",
      "editTitle": "Edit facility terms",
      "edited": "Facility {code} was updated.",
      "errors": {
        "ERR_DEBT_LIMIT_EXCEEDED": "That would take the facility past its limit.",
        "ERR_PERIOD_CLOSED": "That date falls in a closed period. Choose a date in an open period.",
        "ERR_ROW_VERSION": "Someone changed this record first. It has been reloaded; check it and apply your change again."
      },
      "limitHint": "In {currency}. It cannot be set below what is already drawn.",
      "noLongerReversible": "That entry is no longer posted, so there is nothing left to reverse.",
      "notes": "Notes",
      "capBelowFloor": "The rate cap cannot be below the rate floor.",
      "rateHint": "Enter 8.75 for 8.75%.",
      "rateRange": "Enter a percentage between 0 and 100.",
      "reasonHint": "Required. It is written into the reversal journal and the audit trail.",
      "reloaded": "Someone changed this record first. It has been reloaded; check it and apply your change again.",
      "reversalDate": "Reversal date",
      "reversalDateHint": "Leave blank for today. The date must fall in an open period.",
      "reverse": "Reverse",
      "reverseConfirm": "Post reversal",
      "reverseDescription": "Posts the mirror of the original journal. The original stays on record.",
      "reverseDrawdownTitle": "Reverse a drawdown",
      "reverseNote": "A reversal cannot itself be undone here. If the original was right, cancel.",
      "reverseRepaymentTitle": "Reverse a repayment",
      "reversed": "The reversal was posted.",
      "reversedBy": "reversed by"
    },
    "rateObservations": {
      "caption": "Observations of the reference rate",
      "description": "A floating facility accrues at the latest observation of its reference rate on or before each period start, plus its margin.",
      "empty": "No observation of {code} has been recorded. A floating facility on this rate is skipped by the accrual run until one is.",
      "loadFailed": "Those rate observations did not load",
      "noFloating": "No active facility in this legal entity has a floating rate, so no reference rate needs observing.",
      "record": "Record observation",
      "recorded": "The rate observation was recorded.",
      "sourceHint": "Where the rate was published. Leave blank for manual.",
      "title": "Reference rates"
    },
    "debtFt10": {
      "breach": {
        "line": "{covenant}: {metric} was {actual} against {operator} {threshold} on {date}.",
        "notified": "The facility is in default. The CFO, Risk and Audit were notified when the breach was recorded.",
        "title": "Covenant breached",
        "waiveHint": "A breach is cleared only by a waiver that names the lender's document and states a reason."
      },
      "covenantTabs": {
        "compliance": "Compliance",
        "interestExpense": "Interest expense",
        "label": "Covenant compliance"
      },
      "errors": {
        "ERR_CASH_ACCOUNT_NOT_PLEDGED": "That account is no longer pledged. Someone may have released it already.",
        "ERR_CASH_ACCOUNT_PLEDGED": "That bank account is already pledged. Release the other pledge first.",
        "ERR_COVENANT_WAIVER_REF": "A waiver must name the lender's waiver document.",
        "ERR_ILLEGAL_TRANSITION": "This cannot be done in its current state."
      },
      "filters": {
        "anyKind": "Any instrument type",
        "anyLender": "Any lender",
        "currencyHint": "A three-letter code, for example MVR.",
        "kind": "Instrument type",
        "lender": "Lender"
      },
      "inDefault": {
        "description": "A breached covenant puts its facility in default. Show one to see its covenants.",
        "show": "Show covenants",
        "title": "Facilities in default"
      },
      "interestFrequency": "Interest frequency",
      "lenderFromRegister": "From the bank register",
      "lenderLegalName": "Lender (legal name)",
      "lenderLegalNameHint": "The counterparty's registered legal name, as on the agreement.",
      "noFacility": {
        "description": "This legal entity has no open facility, so there are no covenants to test. Register a facility first.",
        "title": "No open facility"
      },
      "noSettlementAccount": "No settlement account",
      "secondPrincipal": {
        "covenantAuthor": "You added or last edited a covenant awaiting approval with this facility, so a different person must activate it.",
        "covenantAuthorChange": "You added or last edited this covenant, so a different person must decide it.",
        "editedTerms": "You last edited this facility's terms, so a different person must activate it.",
        "ownChange": "You requested this change, so a different person must decide it.",
        "ownMovement": "You prepared this, so a different person must approve or reject it.",
        "prepared": "You registered this facility, so a different person must activate it.",
        "requestedClose": "You requested this close, so a different person must complete it. You can still withdraw the request.",
        "submitted": "You submitted this facility, so a different person must activate or reject it."
      },
      "settlementAccount": "Settlement bank account",
      "settlementAccountHint": "Optional. Where drawdowns arrive and repayments leave; both default to it.",
      "testedBy": "by {name}",
      "waiver": {
        "ref": "Waived under {ref}",
        "until": "until {date}"
      }
    },
    "positionsFt11": {
      "calcVersion": "Calculation",
      "calcVersionLabel": "Calc v{version}",
      "calcVersionHint": {
        "v1": "Struck with calculation version 1, which counted the overdraft limit in the available basis. It is verified with that formula, never restated by it.",
        "current": "Struck with the current calculation: the overdraft limit is capacity, not cash."
      },
      "rate": {
        "identity": "Same currency: no translation",
        "facts": "{type} · {date} · {source} · {age} days old",
        "inverted": "inverse of the quoted pair",
        "stale": "Stale: older than {tolerance} days"
      },
      "tolerance": {
        "title": "Rate tolerance — {entity}",
        "description": "How many whole days old a translation rate may be, against the position date, before a position translated at it cannot be published.",
        "current": "Currently {days} days.",
        "days": "Tolerance (whole days)",
        "daysHint": "0 to 90 days. A number of days, not a rate and not a percentage.",
        "invalid": "Enter a whole number of days from 0 to 90.",
        "raiseNeedsApproval": "A higher tolerance loosens a publication control, so this files a request for a second person's approval. {days} days stays in force, and publication stays refused, until it is approved.",
        "raiseBlocked": "A raise to {proposed} days is already waiting for approval. It must be decided, or the tolerance lowered, before another raise can be requested.",
        "raiseFiled": "Raise to {proposed} days filed for approval. {days} days stays in force until it is approved.",
        "lowerApplies": "A lower tolerance is stricter, so it applies at once.",
        "lowerWithdraws": "A lower tolerance applies at once and withdraws the pending raise to {proposed} days.",
        "requestRaise": "Request raise",
        "withdraw": "Withdraw the pending raise",
        "withdrawNote": "Keeping {days} days withdraws the pending raise to {proposed} days. Nothing else changes.",
        "withdrawn": "Pending raise withdrawn. {days} days stays in force.",
        "reloaded": "Someone changed the treasury settings first. They have been reloaded; check the value and save again.",
        "settingsMissing": "This legal entity has no treasury settings yet, so its tolerance cannot be changed here. Set up its treasury settings first.",
        "save": "Save tolerance",
        "saved": "Rate tolerance set to {days} days."
      },
      "pending": {
        "title": "Raise to {days} days awaiting approval",
        "requested": "Requested by user #{user} at {at}.",
        "awaiting": "Not in force until another person approves approval request #{request} in the approvals inbox."
      },
      "stale": {
        "title": "Not published: a translation rate is too old",
        "explain": "A position translated at a rate older than the declared tolerance cannot be published, so no figure is frozen as evidence on a stale rate.",
        "waysOut": "File a current rate for the pair and publish again, or change the declared tolerance.",
        "askHolder": "Only someone who manages treasury settings can change the tolerance.",
        "changeTolerance": "Change the rate tolerance"
      },
      "list": {
        "openGroup": "Group position",
        "entitiesFailed": "The legal entities did not load",
        "noEntityTitle": "No legal entity to show",
        "noEntityDescription": "You cannot see any active legal entity. Ask an administrator to give you access to one, then its published positions appear here.",
        "restatement": "Restatement reason"
      },
      "group": {
        "title": "Group cash position",
        "description": "The cash of every legal entity inside a declared perimeter, in one reporting currency, with the rate behind every translated figure.",
        "openPublished": "Published positions",
        "openLiquidity": "Liquidity Analysis",
        "deniedTitle": "You cannot read the group position",
        "deniedDescription": "The group position needs the treasury group-position read permission. Ask an administrator if you need it.",
        "perimeterTitle": "Perimeter",
        "declareBy": "Declare the perimeter by",
        "modePerimeter": "Consolidation group",
        "modeEntities": "Legal entities",
        "perimeter": "Consolidation group",
        "reportingCurrency": "Reporting currency",
        "reportingCurrencyHint": "Every figure is translated into this currency.",
        "reportingDefault": "Perimeter's presentation currency",
        "sourceLive": "Live",
        "sourceLiveHint": "Computed now, at one watermark",
        "sourcePublished": "Published",
        "sourcePublishedHint": "Each legal entity's current published run for the date",
        "inTransaction": "Transaction currency",
        "inFunctional": "Functional currency",
        "inReporting": "Reporting currency",
        "entitiesLegend": "Legal entities to aggregate",
        "entitiesFailed": "The legal entities did not load",
        "noScopeTitle": "Declare a perimeter",
        "noScopeDescription": "Choose a consolidation group, or tick the legal entities to aggregate. Only the entities inside the perimeter are summed; every other one is named separately.",
        "filterRefused": "The server refused one of the filters above. The reason is shown under it.",
        "loadFailed": "The group position did not load",
        "headlineTitle": "Group totals",
        "source": {
          "live": "Live — not published",
          "published": "Published runs"
        },
        "asOfAt": "As at {date}, figures from {at}",
        "declaredEntities": "Declared legal entities",
        "tolerance": "Rate tolerance: {days} days",
        "liveBanner": "These figures are computed now and are not published. Quote a published position for evidence.",
        "staleWarning": "At least one translation rate is older than the declared tolerance of {days} days. The figures are shown, but a position translated at it cannot be published.",
        "entitiesTitle": "Aggregated legal entities",
        "entitiesDescription": "Each legal entity at 100%. A proportionally consolidated one also shows the share the group aggregates.",
        "showLinesIn": "Show lines in",
        "entitiesCaption": "Legal entities aggregated into the group position",
        "method": "Method",
        "ownership": "Ownership",
        "functionalCurrency": "Functional currency",
        "publishedRun": "Published run",
        "notPublished": "Not published for this date",
        "groupShare": "Group share",
        "hideLines": "Hide accounts",
        "showLines": "Show {count} account(s)",
        "publish": "Publish in {currency}",
        "changeTolerance": "Rate tolerance",
        "liquidity": "Liquidity",
        "linesCaption": "Accounts of {entity}",
        "reportingRate": "Reporting rate",
        "functionalRate": "Functional rate",
        "entitiesEmpty": "No legal entity is inside this perimeter on this date.",
        "excludedTitle": "Not aggregated",
        "excludedDescription": "These legal entities are named but not summed into the group figure.",
        "byCurrencyTitle": "By transaction currency",
        "ratesTitle": "Translation rates used",
        "ratesDescription": "Every rate behind a translated figure: type, date, source and age.",
        "ratesEmpty": "No translation was needed.",
        "liquidityTitle": "Group liquidity",
        "liquidityDescription": "Summed over the aggregated legal entities at the group's share.",
        "notesTitle": "Notes"
      },
      "method": {
        "parent": "Parent",
        "full": "Full",
        "proportional": "Proportional",
        "declared": "Declared"
      },
      "reason": {
        "not_in_perimeter": "Outside the perimeter",
        "method_equity": "Equity-accounted",
        "method_proportional": "No recorded holding",
        "method_excluded": "Excluded",
        "not_published": "Not published"
      }
    },
    "liquidityFt11": {
      "title": "Liquidity Analysis",
      "description": "Available liquidity of a legal entity: accessible cash less every named deduction, plus undrawn committed facilities shown as capacity.",
      "openPositions": "Published positions",
      "openGroup": "Group position",
      "deniedTitle": "You cannot read liquidity",
      "deniedDescription": "Liquidity Analysis needs the treasury position read permission. Ask an administrator if you need it.",
      "reportingHint": "Every translated figure is stated in this currency.",
      "reportingDefault": "Legal entity's base currency",
      "asOfHint": "Empty means today.",
      "entitiesFailed": "The legal entities did not load",
      "noEntityTitle": "No legal entity to analyse",
      "noEntityDescription": "You cannot see any active legal entity. Ask an administrator to give you access to one.",
      "loadFailed": "Liquidity did not load",
      "headlineTitle": "Available liquidity",
      "linesTitle": "Deductions by account",
      "linesDescription": "Each account's cash and the six deductions, in {currency}. Each deduction states why it applies.",
      "unavailable": "{count} account(s) have no available basis. They add nothing to accessible cash and nothing is deducted from them.",
      "liquidityClass": "Liquidity class",
      "gross": "Cash before deductions",
      "net": "Net cash",
      "overdraftHeadroom": "Overdraft headroom",
      "noBasis": "No available basis",
      "overdraftOf": "limit {limit}, drawn {drawn}",
      "linesEmpty": "This legal entity holds no accounts.",
      "total": "Total",
      "facilitiesTitle": "Undrawn committed facilities",
      "facilitiesDescription": "Capacity to borrow, not cash. Added to net cash on its own line and never summed into a cash balance.",
      "drawn": "Drawn",
      "drawdownsInTransit": "Drawdowns in transit",
      "awaitingApproval": "Awaiting approval",
      "inReporting": "In {currency}",
      "facilitiesEmpty": "No committed facility is live on this date.",
      "kind": {
        "restricted": "Restricted",
        "pledged": "Pledged",
        "escrowed": "Escrowed",
        "in_transit": "In transit",
        "blocked": "Blocked",
        "minimum": "Minimum balance"
      },
      "bridge": {
        "caption": "From accessible cash to available liquidity",
        "line": "Line",
        "accessible": "Accessible cash",
        "less": "Less: {what}",
        "totalDeductions": "Total deductions",
        "netCash": "Net cash",
        "plusUndrawn": "Plus: undrawn committed facilities",
        "capacityNotCash": "Capacity, not cash",
        "available": "Available liquidity",
        "undrawnShort": "Undrawn committed facilities",
        "overdraftHeadroom": "Overdraft headroom",
        "overdraftNote": "Uncommitted capacity: shown, and not added to available liquidity.",
        "inTransitTotal": "In-transit register",
        "inTransitNote": "Belongs to neither the sending nor the receiving balance until confirmed.",
        "breached": "Available liquidity is below the declared minimum balances."
      },
      "inTransit": {
        "title": "In-transit register",
        "description": "Value released or requested and not yet confirmed. It is part of neither the originating nor the receiving balance; this register is the only place it appears.",
        "caption": "Value in transit",
        "direction": "Direction",
        "age": "Age",
        "kind": {
          "transfer": "Transfer",
          "debt_drawdown": "Debt drawdown",
          "other": "Other"
        },
        "fromTo": "From account {from} to {to}",
        "wallet": "a wallet",
        "into": "Into account {to}",
        "days": "{days} days",
        "empty": "Nothing is in transit on this date.",
        "total": "Total in transit"
      }
    },
    "forecastFt13": {
      "horizon": {
        "label": "Horizon",
        "operational": "Operational (up to 13 weeks)",
        "strategic": "Strategic (24 months)"
      },
      "granularity": {
        "day": "Day",
        "week": "Week",
        "month": "Month"
      },
      "sourceClass": {
        "open_item": "Open item",
        "commitment": "Commitment",
        "calendar": "Calendar",
        "contract": "Contract",
        "modelled": "Modelled"
      },
      "lineClass": {
        "label": "Basis of the lines",
        "modelledCount": "{count} modelled lines",
        "overriddenCount": "{count} overridden lines",
        "sourced": "Sourced",
        "modelled": "Modelled",
        "override": "Override"
      },
      "degraded": {
        "badge": "Degraded",
        "note": "This forecast is incomplete: at least one input did not deliver. Do not read it as the full position.",
        "input": {
          "ap": "Supplier invoices",
          "ar": "Customer invoices",
          "recurring": "Recurring items",
          "debt": "Debt schedule"
        }
      },
      "item": {
        "sourceClass": "Basis",
        "confidence": "Confidence",
        "actions": "Actions",
        "was": "was",
        "override": "Override"
      },
      "override": {
        "title": "Override this line",
        "description": "The next forecast that carries this line uses your figure and reports it as an override. The published run on screen does not change. The override stops applying after its expiry.",
        "amount": "Overriding amount",
        "amountHint": "In {currency}, not negative. The line's direction carries the sign. Zero removes it from the forecast.",
        "amountInvalid": "Enter a non-negative number, for example 1500.00.",
        "expiresOn": "Expires on",
        "confirm": "Record override",
        "saved": "Override recorded."
      },
      "series": {
        "title": "Series by source class",
        "description": "This run only, split by where each line comes from, with the confidence band around the closing balance.",
        "loadFailed": "That series did not load",
        "separateNote": "Operational and strategic forecasts are separate runs and are never combined.",
        "emptyTitle": "No buckets in this run",
        "emptyDescription": "The run has no series to draw.",
        "chartAria": "{buckets} buckets by source class with a confidence band, in {currency}",
        "caption": "Closing balance, confidence band and source-class split by bucket",
        "bandLow": "Band low",
        "bandHigh": "Band high",
        "bySourceClass": "By source class (inflows / outflows)",
        "overrides": "Overrides"
      },
      "overrides": {
        "title": "Manual overrides",
        "description": "Reported apart from sourced and modelled lines, with author, reason and expiry.",
        "loadFailed": "The overrides did not load",
        "applied": "{count} lines in this run carry an override.",
        "emptyTitle": "No overrides",
        "emptyDescription": "Nobody has overridden a line of this forecast.",
        "caption": "Manual overrides of forecast lines",
        "original": "Before",
        "override": "Override",
        "expiresOn": "Expires",
        "by": "By",
        "notYetApplied": "applies from the next run",
        "status": {
          "active": "Active",
          "expired": "Expired",
          "superseded": "Superseded"
        }
      },
      "publish": {
        "weeksMin": "Enter a whole number of weeks, 1 or more.",
        "weeksCap": "An operational forecast is at most {max} weeks. Use a strategic forecast for a longer view.",
        "weeksHint": "At most {max} weeks.",
        "dailyRange": "Enter a whole number of daily days from 0 to {max}.",
        "strategicNote": "A strategic forecast covers 24 calendar months, one bucket per month. It is published on its own and never combined with the operational forecast."
      }
    },
    "liquidityGap": {
      "title": "Liquidity gap",
      "description": "When a legal entity's current forecast first falls below its minimum balance, and how far.",
      "openForecasts": "Cash forecasts",
      "deniedTitle": "The liquidity gap is not available to you",
      "deniedDescription": "Reading it needs the forecast read permission.",
      "currencyHint": "Narrows the legal entities offered to those reporting in this currency. Nothing is converted.",
      "anyCurrency": "Any currency",
      "scenarioHint": "Blank reports the legal entity's base forecast.",
      "baseScenario": "Base forecast",
      "asOfHint": "Blank reports the current forecast.",
      "entitiesFailed": "The legal entities did not load",
      "noEntityTitle": "Choose a legal entity",
      "noEntityDescription": "The gap is computed per legal entity. Pick one above, or clear the currency filter if none reports in it.",
      "loadFailed": "The liquidity gap did not load",
      "noRunTitle": "No published forecast yet",
      "noRunDescription": "The gap is read from a published cash forecast. Publish one for this legal entity on the cash forecasts screen and it will show here.",
      "headlineTitle": "First breach",
      "headlineDescription": "From the current published forecast as at {date}, in {currency}.",
      "firstBreachOn": "First breach on {date}",
      "noBreach": "No breach in the horizon",
      "bucketsFailed": "The forecast buckets did not load",
      "bucketsDescription": "The published run's own buckets. A bucket the server flagged as closing below the minimum is marked.",
      "bucketsEmpty": "This forecast has no buckets."
    },
    "walletFunding": {
      "anyEntity": "All legal entities",
      "anyStatus": "Any status",
      "anyWallet": "All wallets you can see",
      "approved": "Approved",
      "caption": "Wallet funding requests and where each one stands",
      "decide": {
        "approve": "Approve funding",
        "approved": "Request {no} was approved and transfer instruction {transfer} raised. The wallet is credited only when that transfer is confirmed.",
        "ownRequest": "You requested this funding or hold this wallet. Another person must decide it, and the server will refuse a decision from you.",
        "reason": "Reason",
        "reasonHint": "Required to approve or reject. It is recorded with the decision.",
        "reject": "Reject",
        "rejected": "Request {no} was rejected.",
        "reloaded": "Somebody else changed this request first. It has been reloaded; check it and decide again.",
        "title": "Decide"
      },
      "decideAction": "Decide",
      "description": "Every wallet funding request you can reach. Approving one raises a bank transfer instruction; the wallet is credited only when that transfer is confirmed against the bank statement.",
      "dialog": {
        "atMax": "This wallet is at its maximum balance, counting what is already in transit. A request now will be refused.",
        "creditOnConfirm": "Nothing is credited when you request or when the request is approved. The wallet is credited when the bank transfer that funds it is confirmed against the statement.",
        "firstLoadRule": "This wallet has never been funded, so the amount is the float shortfall.",
        "float": "Authorised float",
        "nothingToRestore": "Nothing to restore: the wallet holds its float.",
        "openRequest": "Replenishment {no} is still {status}. Another request will be refused until it settles.",
        "overMaxTitle": "Over the maximum balance"
      },
      "emptyDescription": "Funding is requested from a wallet, or proposed automatically when a wallet falls to its replenishment threshold.",
      "emptyTitle": "No wallet funding requests",
      "entityHint": "Narrows the wallets offered, and the requests shown on each page to that legal entity's wallets.",
      "errors": {
        "ERR_ILLEGAL_TRANSITION": "This request has already been decided.",
        "ERR_PERIOD_CLOSED": "The period for today is closed for this legal entity, so no funding can be raised.",
        "ERR_ROW_VERSION": "Somebody else changed this request first. It has been reloaded; check it and decide again.",
        "ERR_SOD_VIOLATION": "You cannot decide this funding: the person who requested it and the wallet's custodian may not decide it.",
        "ERR_WALLET_MAX_BALANCE": "This load would take the wallet over its maximum balance."
      },
      "facts": {
        "approvedSpendTotal": "Approved spending covered",
        "decidedBy": "Decided by",
        "failedReason": "Why it failed",
        "floatShortfall": "Float shortfall when requested",
        "fundingAccount": "Funding account",
        "justification": "Justification",
        "note": "Note"
      },
      "fundedNote": "Funded on {at}: the transfer was confirmed and the wallet credited.",
      "inTransitNote": "Approved and in transit. Transfer instruction {no} carries the money; the wallet is credited only when it is confirmed.",
      "instruction": "Transfer instruction",
      "legalEntity": "Legal entity",
      "loadFailed": "Those funding requests did not load",
      "noInstruction": "Not raised yet",
      "openInstruction": "Open transfer instruction {no}",
      "openWallets": "Wallets",
      "pageEmpty": "Nothing for this legal entity on this page. Try the next page.",
      "position": {
        "confirmed": "Confirmed balance",
        "headroom": "Can still be loaded",
        "inTransit": "In transit",
        "loadFailed": "The funding position did not load",
        "maxBalance": "Maximum balance",
        "noMax": "No maximum balance set",
        "note": "Only a confirmed transfer changes the confirmed balance. An approved request sits in transit until its transfer instruction is confirmed against the bank statement.",
        "refresh": "Read again",
        "resulting": "Once everything in transit confirms",
        "title": "Funding position"
      },
      "previewTitle": "Request {no}",
      "requestNo": "Request",
      "requested": "Requested",
      "requestedOn": "Requested on",
      "review": "Review",
      "status": {
        "approved": "Approved, in transit",
        "draft": "Draft",
        "failed": "Failed",
        "funded": "Funded",
        "proposed": "Proposed",
        "rejected": "Rejected",
        "submitted": "Awaiting decision"
      },
      "tableTitle": "Funding requests",
      "title": "Wallet funding",
      "walletBanner": {
        "inTransit": "It is in transit: the wallet is credited when its transfer is confirmed.",
        "open": "Open in wallet funding"
      }
    },
    "instructionFt6": {
      "approvalStepRecorded": "Your approval is recorded. The instruction stays submitted until the next approver in the chain acts.",
      "awaitingApproval": "Submitted for approval. It waits in the approvals inbox of the assigned approver; only a person holding an approval task for it can approve it.",
      "errors": {
        "approvalUnresolvable": "No approver is configured for this transfer instruction. An administrator must set up an approval policy or authority-matrix rule for transfer instructions that names someone other than you.",
        "noApprovalTask": "You have no approval task for this instruction — it is in the approvals inbox of the assigned approver.",
        "screeningResultChanged": "The screening result changed since you opened this. Nothing was cleared. Review the current findings, then clear again if they are false positives.",
        "sod": {
          "approve": "You submitted this instruction, so you cannot approve it. Another person must.",
          "clear": "You raised this instruction or made the release attempt that was held, so you cannot clear the hold. Another compliance officer must.",
          "release": "You raised or submitted this instruction, or cleared its screening hold, so you cannot release it. Another person must.",
          "submit": "This act needs a second person: you cannot both raise and decide this instruction."
        }
      },
      "screening": {
        "clear": "Clear screening hold",
        "clearDescription": "Clearing returns the instruction to approved. It still has to be released, and a release that finds something different will be held again.",
        "clearTitle": "Clear the screening hold",
        "cleared": "Screening hold cleared. The instruction is approved again and can be released.",
        "heldNotice": "Held for sanctions/exchange-control screening — a compliance officer must clear it. Nothing has been sent to the bank and nothing has been posted.",
        "matched": "matched “{value}”",
        "reason": "Reason for clearing",
        "resultChanged": "The screening result changed when the instruction was screened again, so nothing was cleared and the hold stands. Review the new findings below before clearing."
      }
    },
    "bankConnections": {
      "title": "Bank connections",
      "description": "How statements reach the system without someone uploading them. A connection runs as a service principal, never as a person.",
      "create": "New connection",
      "newTitle": "New bank connection",
      "editTitle": "Edit bank connection",
      "formDescription": "A connection is saved as a draft and does nothing until it is activated.",
      "created": "Connection created",
      "saved": "Connection saved",
      "reloaded": "Someone else changed this connection while you were working. It has been reloaded. Check it, then apply your change again.",
      "loadFailed": "The bank connections could not be loaded",
      "healthFailed": "The connection health could not be loaded",
      "healthTitle": "Health",
      "tableTitle": "Connections",
      "emptyTitle": "No bank connections yet",
      "emptyDescription": "Statements can always be uploaded by hand. Add a connection to have a storage inbox drained on schedule.",
      "statusFilter": {
        "label": "Status",
        "all": "All statuses"
      },
      "status": {
        "draft": "Draft",
        "active": "Active",
        "disabled": "Disabled"
      },
      "health": {
        "total": "Connections",
        "healthy": "Healthy",
        "degraded": "Degraded",
        "failing": "Failing",
        "rotation_due": "Rotation due",
        "inactive": "Inactive"
      },
      "channel": {
        "manual_upload": "Manual upload",
        "storage_inbox": "Storage inbox"
      },
      "channelHint": {
        "manual_upload": "Statements are uploaded by hand. Nothing is fetched.",
        "storage_inbox": "Files dropped in this connection's inbox are imported on schedule."
      },
      "columns": {
        "state": "State",
        "lastRun": "Last test and fetch",
        "rotation": "Credential rotation",
        "actions": "Actions"
      },
      "fields": {
        "name": "Name",
        "bank": "Bank",
        "bankFixed": "The bank cannot change once the connection exists.",
        "channel": "Channel",
        "channelHint": "Live bank links (host-to-host, API, network) are not offered. Fixed once created.",
        "endpoint": "Endpoint",
        "endpointHint": "Optional. The address the channel reads from, if it has one.",
        "credentialRef": "Credential reference",
        "credentialRefHint": "The NAME of the secret that holds the credential, never the secret itself.",
        "rotatesOn": "Credential rotates on",
        "rotatesOnHint": "The date the credential must be rotated by. A warning is raised before it.",
        "principal": "Service principal",
        "principalHint": "The user id of the service principal statements are retrieved as. A person's account is refused at activation.",
        "principalActive": "The principal of an active connection cannot change. Disable the connection first.",
        "accounts": "Bank accounts served",
        "accountsHint": "Accounts held at this bank. Precedence orders connections serving the same account; leave it blank to take the next free one.",
        "precedence": "Precedence",
        "precedenceAuto": "Next free",
        "precedenceInvalid": "Precedence is a whole number from 1.",
        "noAccounts": "No bank account held at this bank is visible to you."
      },
      "rotation": {
        "title": "Credential rotation needed",
        "due": "rotates by {date}, in {days} day(s)",
        "overdue": "rotation date {date} passed {days} day(s) ago",
        "ok": "rotates by {date}",
        "none": "No rotation date"
      },
      "consecutiveFailures": "{n} failure(s) in a row",
      "namedUserWarning": "A person's account: activation will be refused",
      "noPrincipal": "No service principal",
      "unassignedFiles": "{n} unassigned file(s) in the inbox",
      "lastTest": "Tested {at}: {result}",
      "lastFetch": "Fetched {at}: {result}",
      "test": "Test",
      "fetch": "Fetch now",
      "activate": "Activate",
      "disable": "Disable",
      "testOk": "The connection test passed",
      "testFailed": "The connection test failed",
      "testFiles": "{waiting} file(s) waiting, {unassigned} unassigned.",
      "fetched": "Fetch finished",
      "fetchCounts": "{imported} imported, {duplicates} duplicate(s), {rejected} rejected, {failed} failed, {unassigned} unassigned.",
      "openImports": "Open the statement imports",
      "actionFailed": "That was refused",
      "activateTitle": "Activate this connection",
      "activateDescription": "Statements start arriving on schedule, retrieved as the connection's service principal.",
      "disableTitle": "Disable this connection",
      "disableDescription": "Nothing more is fetched. Statements can still be uploaded by hand.",
      "reasonLabel": "Reason",
      "reasonRequired": "A reason is required to disable a connection.",
      "activated": "Connection activated",
      "disabled": "Connection disabled",
      "errors": {
        "namedUser": "This connection runs as a person's account. Statement retrieval must run as a service principal. Set a service principal, then activate.",
        "principalUnauthorised": "The service principal is disabled or cannot import statements.",
        "noPrincipal": "Set a service principal before activating.",
        "noAccounts": "The connection must serve at least one bank account.",
        "active": "The service principal of an active connection cannot change. Disable the connection, change it, then activate it again."
      }
    },
    "debtLifecycle": {
      "activate": {
        "confirm": "Activate facility",
        "description": "Authorise this facility so it can be drawn. You must not be the person who registered or submitted it.",
        "title": "Activate the facility"
      },
      "amend": {
        "action": "Change terms",
        "confirm": "Request change",
        "description": "Change what this covenant tests. Only the fields you change are sent.",
        "done": "The covenant was changed.",
        "note": "On a covenant in force the change is not made yet: it waits for a second person to approve it.",
        "pending": "The change is waiting for a second person to approve it.",
        "title": "Change covenant terms"
      },
      "approvedAt": "Authorised",
      "awaitingApproval": "Awaiting approval",
      "cancelDrawdown": {
        "action": "Cancel",
        "confirm": "Cancel drawdown",
        "description": "This drawdown has not posted, so it is cancelled rather than reversed. No journal is written.",
        "done": "The drawdown was cancelled.",
        "note": "Cancelling releases the commitment it held. The drawdown stays on record as cancelled.",
        "title": "Cancel a drawdown"
      },
      "changePending": "Change pending",
      "changes": {
        "approveTitle": "Approve the change",
        "approved": "The change was approved and applied.",
        "decideDescription": "You must not be the person who requested this change.",
        "description": "Limit increases and covenant changes wait here for a second person to approve or reject them.",
        "empty": "No change requests. A limit increase or a covenant change will wait here for a second approver.",
        "kind": {
          "covenant_add": "New covenant",
          "covenant_amend": "Covenant change",
          "limit_increase": "Limit increase"
        },
        "rejectTitle": "Reject the change",
        "rejected": "The change was rejected.",
        "status": {
          "approved": "Approved",
          "pending": "Waiting",
          "rejected": "Rejected"
        },
        "title": "Change requests"
      },
      "close": {
        "completeAction": "Complete close",
        "completeConfirm": "Close facility",
        "completeDescription": "A colleague requested this close. Closing completes it; the history is kept.",
        "completeTitle": "Complete the close",
        "completed": "Facility {code} is closed.",
        "requestAction": "Close facility",
        "requestConfirm": "Request close",
        "requestDescription": "State why the facility is closing. A second person completes the close.",
        "requestTitle": "Request to close the facility",
        "requested": "The close of {code} was requested. A second person must complete it.",
        "requestedReason": "Reason given"
      },
      "closeRequestedNote": "A close was requested on {at}: {reason}. A second person must complete it, and no new drawdown can be requested meanwhile.",
      "confirm": {
        "action": "Confirm",
        "confirm": "Confirm and post",
        "description": "Name the bank statement line that shows the funds arriving.",
        "done": "Drawdown {no} was confirmed and posted.",
        "note": "Until it is confirmed the drawdown is in transit: it is not part of the facility balance and nothing has posted.",
        "title": "Confirm a drawdown"
      },
      "covenantApproval": {
        "approved": "Approved",
        "pending_approval": "Awaiting approval",
        "rejected": "Rejected"
      },
      "covenantDualNote": "On a live facility a new covenant waits for a second person to approve it before it is tested.",
      "covenantPendingApproval": "The covenant was added and is waiting for a second person to approve it.",
      "decision": {
        "approve": "Approve",
        "approveDrawdown": "Approve a drawdown",
        "approveDrawdownNote": "Approving releases the drawdown into transit. It still has to be confirmed against the bank statement.",
        "approveRepayment": "Approve a repayment",
        "approveRepaymentNote": "Approving posts the repayment against its bank statement line.",
        "description": "This movement is above the authority band. You must not be the person who prepared it.",
        "done": "The decision was recorded.",
        "reject": "Reject",
        "rejectDrawdown": "Reject a drawdown",
        "rejectNote": "Rejecting cancels the movement. Say why.",
        "rejectRepayment": "Reject a repayment"
      },
      "degraded": "Degraded",
      "degradedNote": "Interest was not accrued for {periods}. Until those periods are accrued this facility's figures are incomplete.",
      "drawdown": {
        "awaitingApproval": "Drawdown {no} was requested and is waiting for approval.",
        "confirm": "Request drawdown",
        "description": "A drawdown stays in transit until it is confirmed against the bank statement. It cannot take the facility past its limit.",
        "inTransit": "Drawdown {no} was requested and is in transit until the bank statement confirms it."
      },
      "errors": {
        "ERR_COVENANT_ALREADY_TESTED": "This covenant already has a result on that date. A recorded result stands; a breach is cleared only by a waiver.",
        "ERR_COVENANT_BREACHED": "This facility has a covenant breach that is not waived.",
        "ERR_DEBT_APPROVAL_PENDING": "A second person has not approved this yet.",
        "ERR_DEBT_EVIDENCE_MISMATCH": "That statement line does not evidence this movement.",
        "ERR_DEBT_TERMS_CHANGED": "The terms changed after this was submitted. It has been reloaded; check the new terms before deciding.",
        "ERR_FACILITY_AUTHORISATION_REQUIRED": "This change needs a second person. Request it instead.",
        "ERR_FACILITY_CLOSE_BLOCKED": "This facility still has obligations, so it cannot close yet.",
        "ERR_FACILITY_IC_INSTRUMENT_REQUIRED": "An intercompany loan needs a priced intercompany instrument.",
        "ERR_FACILITY_ROLLOVER_BLOCKED": "This facility cannot be superseded yet.",
        "ERR_SCHEDULE_SUM_MISMATCH": "The schedule does not repay the drawn principal by maturity.",
        "ERR_SOD_VIOLATION": "A different person must do this."
      },
      "evidence": {
        "choose": "Choose a statement line",
        "empty": "No unmatched statement line on this account could evidence this. Import the statement first.",
        "hintIn": "Unmatched money in on this bank account. The amount must match.",
        "hintOut": "Unmatched money out on this bank account, for the repayment's total.",
        "line": "Bank statement line",
        "lineId": "Statement line id",
        "lineRef": "line {id}",
        "loadFailed": "The statement lines did not load. Retry, or close and open this dialog again.",
        "noAccount": "Choose the bank account first.",
        "typedHint": "Ask whoever reconciles this account for the line id."
      },
      "expenseReport": {
        "accrued": "Accrued",
        "atRepayment": "At repayment",
        "caption": "Interest expense and effective rate by facility",
        "chooseRange": "Choose a from and a to date to see interest expense for the range.",
        "description": "Accrued and paid interest by facility, with the realised effective rate. Each line is in its facility's currency.",
        "effectiveRate": "Effective rate",
        "empty": "No facility of this legal entity accrued or paid interest in this range.",
        "from": "From",
        "loadFailed": "The interest expense report did not load",
        "paid": "Paid",
        "title": "Interest expense and effective rate",
        "to": "To"
      },
      "headroom": "Headroom",
      "icInstrument": "Intercompany instrument",
      "icInstrumentHint": "The priced loan instrument this facility draws on. No drawdown is released without it.",
      "icInstrumentId": "Intercompany instrument id",
      "inTransit": "In transit",
      "inTransitHint": "not yet confirmed by the bank",
      "interestExpense": "Interest expense",
      "ladderDegradedNote": "At least one facility missed an accrual run, so this ladder leaves out interest that was never accrued.",
      "lender": {
        "bankHint": "From the bank relationship register.",
        "bankId": "Lender bank id",
        "counterparty": "Lender or counterparty"
      },
      "limit": {
        "action": "Increase limit",
        "confirm": "Request increase",
        "current": "Current limit",
        "description": "A limit increase on an authorised facility needs a second person to approve it.",
        "hint": "The new limit in {currency}. Nothing changes until it is approved.",
        "proposed": "New limit",
        "requested": "The limit increase for {code} is waiting for a second person.",
        "title": "Request a limit increase"
      },
      "metricHint": "A registered metric key, for example treasury.net_debt_to_ebitda. A computable metric is computed by the system when tested.",
      "openFacility": "Open the facility",
      "pendingApprovalNote": "This facility is waiting for a second person to activate it. Its terms cannot be edited until it is activated or rejected back to draft.",
      "registerNote": "The facility is registered as a draft. Submit it from the facility screen; a second person activates it.",
      "registered": "The facility was registered as a draft.",
      "reject": {
        "action": "Reject",
        "confirm": "Reject facility",
        "description": "Send the facility back to draft. Say what needs to change.",
        "done": "Facility {code} was sent back to draft.",
        "title": "Reject the facility"
      },
      "rejectedNote": "This facility was sent back: {note}",
      "repayment": {
        "awaitingApproval": "Repayment {no} was recorded and is waiting for approval.",
        "description": "A repayment is matched to the bank statement line that paid it, and posts on that line's date.",
        "interestHint": "Leave blank to settle the interest accrued so far.",
        "penalty": "Penalty",
        "valueDateHint": "Optional. The repayment is dated by its bank statement line."
      },
      "rollover": {
        "action": "Roll over",
        "confirm": "Draft successor",
        "description": "Draft the facility that supersedes this one. Nothing moves until a second person activates it.",
        "drafted": "Successor {code} was drafted. Submit it for activation.",
        "inheritHint": "Leave blank to keep this facility's term.",
        "note": "On activation the outstanding balance of {code} moves to the successor, and {code} closes as superseded. It is never deleted.",
        "title": "Roll over or refinance"
      },
      "rolloverReason": "Rollover reason",
      "schedulePrincipalHint": "Leave blank to schedule the drawn principal. The schedule must repay it in full by maturity.",
      "secondPrincipalNote": "You must not be the person who prepared this. The system checks and refuses otherwise.",
      "securities": {
        "accountHint": "A pledged account's balance is deducted from available liquidity.",
        "accountWithheld": "Pledging a bank account needs permission to update bank accounts. You can still record a described security.",
        "description": "Assets and accounts pledged against this facility.",
        "empty": "Nothing is pledged against this facility.",
        "noAccount": "No bank account",
        "pledge": "Pledge security",
        "pledgeDescription": "Name what is pledged. A pledged bank account becomes pledged liquidity.",
        "pledgeTitle": "Pledge security",
        "pledged": "The security was recorded.",
        "release": "Release",
        "releaseDescription": "Release this security. A bank account returns to the liquidity class it had.",
        "releaseTitle": "Release security",
        "released": "The security was released.",
        "status": {
          "pledged": "Pledged",
          "released": "Released"
        },
        "title": "Security and collateral"
      },
      "securityDescription": "Security or collateral",
      "securityDescriptionHint": "Optional. Record a pledged account from the facility screen so it is deducted from liquidity.",
      "submit": {
        "action": "Submit for approval",
        "confirm": "Submit",
        "description": "Send this draft to a second person to activate.",
        "done": "Facility {code} was submitted for approval.",
        "title": "Submit the facility"
      },
      "supersededBy": "Superseded by",
      "supersedes": "Supersedes",
      "test": {
        "action": "Test",
        "breached": "The covenant is breached. The CFO, Risk and Audit have been notified.",
        "computable": "Computed",
        "computedDescription": "The system computes the value from the covenant's metric.",
        "computedNote": "{metric} is computed by the system. You choose only the test date.",
        "confirm": "Record test",
        "date": "Test date",
        "dateHint": "Leave blank for the earliest test due, or today.",
        "derive": "Compare with the threshold",
        "manualDescription": "There is no source for this value, so enter it. The test is recorded as manual.",
        "manualNote": "{metric} has no computable source. Enter the actual value; it is recorded as manual.",
        "manualOnly": "Manual entry",
        "title": "Test the covenant"
      },
      "valueSource": {
        "computed": "computed",
        "manual": "manual"
      },
      "waiveReasonHint": "Required. A breach is cleared only with a reason.",
      "withdraw": {
        "action": "Withdraw",
        "closeAction": "Withdraw close request",
        "closeNote": "Withdrawing leaves the facility open as it is. A close can be requested again later.",
        "closeTitle": "Withdraw the close request",
        "confirm": "Withdraw",
        "description": "Only the person who prepared or requested this, or an approver, can withdraw it. Say why.",
        "done": "It was withdrawn.",
        "drawdownTitle": "Withdraw a drawdown awaiting approval",
        "movementNote": "Withdrawing cancels the approval request and releases what it held. Nothing posted, so there is nothing to reverse.",
        "repaymentTitle": "Withdraw a repayment awaiting approval"
      }
    },
    "transferIc": {
      "destinationEntity": "Destination legal entity",
      "destinationEntityHint": "Whose account the money goes to. Another legal entity's account makes this an intercompany transfer.",
      "instrument": "Intercompany instrument",
      "instrumentHint": "The loan, advance or current account this transfer draws on. Release is refused without an active one.",
      "instrumentOption": "{no} — {kind}, {direction} — headroom {headroom} {currency}",
      "advance": "advance",
      "repayment": "repayment",
      "headroom": "headroom",
      "toEntity": "to {entity}",
      "noInstrument": "No active instrument between these legal entities in this currency. State one under Intercompany funding first.",
      "noInstrumentRead": "You cannot see intercompany instruments. Ask treasury to name one.",
      "instrumentMissing": "This transfer goes to another legal entity and names no intercompany instrument. Release will be refused until one is named.",
      "counterpartyLeg": "Receiving entity's journal",
      "errors": {
        "instrumentRequired": "A transfer to another legal entity needs an active intercompany instrument between the two entities."
      }
    },
    "transferRoute": {
      "title": "Approval route",
      "previewDescription": "Who would approve this instruction if it were submitted now. Nothing has been sent to anyone yet.",
      "liveDescription": "The approval request this instruction raised, and where each step stands.",
      "loadFailed": "The approval route could not be loaded",
      "band": "Authority band:",
      "preview": "Preview",
      "unresolvable": "Nobody other than you can approve this instruction, so a submit would be refused. An administrator must configure an approver.",
      "step": "Step {n}",
      "anyoneInRole": "anyone holding {role}",
      "noSteps": "No approval step applies to this instruction.",
      "mode": {
        "sequential": "in turn",
        "parallel_any": "any one of"
      }
    },
    "transferEdit": {
      "title": "Edit draft instruction",
      "description": "A draft can change freely. Once submitted, a change is a new instruction.",
      "beneficiaryHint": "A beneficiary can be changed here but not removed. Cancel the draft and raise a new one to pay an internal account instead.",
      "saved": "Draft saved",
      "reloaded": "Someone else changed this instruction while you were editing. It has been reloaded; check it and save your changes again."
    },
    "transferConfirm": {
      "creditedAmount": "Amount credited",
      "creditedAmountHint": "What the destination actually received, in its currency. Leave blank to keep the expected amount.",
      "debitLine": "Source statement line",
      "debitLineHint": "The debit on the source account's statement.",
      "creditLine": "Destination statement line",
      "creditLineHint": "The credit on the destination account's statement.",
      "evidenceRequired": "A transfer between legal entities is complete only when both ends are proved: name the debit on the source statement and the credit on the destination statement.",
      "evidenceOptional": "Statement evidence is optional for a transfer between this entity's own accounts. Name both lines or neither.",
      "bothRequired": "Name both statement lines: a transfer between legal entities confirms only on evidence from both ends.",
      "bothOrNeither": "Name both statement lines or neither.",
      "noLines": "No unmatched statement line was found on one of the accounts since the send date. Import the statement first.",
      "errors": {
        "evidenceMismatch": "The statement lines named do not evidence this transfer."
      }
    },
    "transferReport": {
      "pending": "A regulatory report must be recorded before release for: {countries}.",
      "clearBlocked": "A compliance clearance never waives a regulatory report. Record the report first; Clear then answers for whatever else holds the instruction.",
      "record": "Record regulatory report ({countries})",
      "listTitle": "Regulatory reports",
      "reportedOn": "reported {date}",
      "round": "round {n}",
      "dialogTitle": "Record the regulatory report ({countries})",
      "dialogDescription": "One reference answers for every jurisdiction this hold names. If nothing else holds the instruction it returns to approved.",
      "sodNote": "Whoever's release attempt hit this hold cannot record its report, and whoever records it cannot then release the transfer.",
      "reference": "Regulator's reference",
      "reportedOnLabel": "Reported on",
      "submit": "Record report",
      "reloaded": "Someone else changed this instruction first. It has been reloaded; check it and record the report again.",
      "recordedReleasable": "Report recorded. The instruction can now be released by someone other than you.",
      "recordedStillHeld": "Report recorded. The instruction is still held for a compliance clearance of its other findings.",
      "errors": {
        "sodRecord": "Your release attempt put this instruction on hold, so you cannot record its report. Someone else must.",
        "sodRelease": "You recorded the regulatory report for this instruction, so you cannot release it. Someone else must.",
        "pending": "The hold cannot be cleared while a regulatory report is outstanding. Record the report first; a clearance never waives it.",
        "notRequired": "This instruction is no longer held on a reporting obligation, so there is no report to record. It has been reloaded."
      }
    },
    "transferScreening": {
      "clearedRecord": "Screening hold cleared {at}: {reason}"
    },
    "icInstruments": {
      "title": "Intercompany funding",
      "description": "Every loan, advance and current account between two legal entities. A transfer to another legal entity draws on one of these, and is refused without it.",
      "create": "New instrument",
      "createTitle": "New intercompany instrument",
      "editTitle": "Edit intercompany instrument",
      "formDescription": "Saved as a draft. It backs no transfer until it is submitted and approved.",
      "created": "Instrument {no} drafted",
      "saved": "Instrument saved",
      "submitted": "Instrument submitted for approval",
      "closed": "Instrument closed",
      "close": "Close instrument",
      "closeTitle": "Close this instrument",
      "closeDescription": "Only at a zero balance with nothing in flight. State why it is being closed.",
      "reloaded": "Someone else changed this instrument first. It has been reloaded; check it and apply your change again.",
      "loadFailed": "The intercompany instruments could not be loaded",
      "detailFailed": "The instrument could not be loaded",
      "detailTitle": "Instrument",
      "tableTitle": "Instruments",
      "emptyTitle": "No intercompany instruments yet",
      "emptyDescription": "Money between legal entities moves only under a stated instrument. Create one for each lending relationship.",
      "anyEntity": "Any legal entity",
      "anyKind": "Any kind",
      "anyStatus": "Any status",
      "awaitingApproval": "Waiting for approval in the approvals inbox. Someone other than whoever drafted or submitted it must decide.",
      "rejected": "Rejected: {note}",
      "pairFixed": "The two legal entities are fixed. A different pair is a new instrument.",
      "basisHint": "Transfer pricing policy: the approved policy for the pair is required before any release.",
      "maturityHint": "Optional. After it, no advance is released; repayments still are.",
      "descriptionHint": "The settlement expectation: how and when the borrower is to repay.",
      "noMaturity": "No maturity",
      "tpPolicy": "policy #{id}",
      "tabs": {
        "instruments": "Instruments",
        "loans": "Loan register"
      },
      "fields": {
        "instrumentNo": "Instrument",
        "lender": "Lender",
        "borrower": "Borrower",
        "kind": "Kind",
        "pricingBasis": "Pricing basis",
        "principalLimit": "Principal limit",
        "outstanding": "Outstanding",
        "inFlight": "In flight",
        "headroom": "Headroom",
        "effectiveFrom": "Effective from",
        "maturityDate": "Maturity",
        "description": "Settlement expectation",
        "closeNote": "Close note"
      },
      "kind": {
        "loan": "Loan",
        "advance": "Advance",
        "current_account": "Current account"
      },
      "status": {
        "draft": "Draft",
        "pending_approval": "Pending approval",
        "active": "Active",
        "matured": "Matured",
        "closed": "Closed"
      },
      "basis": {
        "tp_policy": "Transfer pricing policy",
        "at_cost": "At cost",
        "interest_free": "Interest free"
      },
      "evidence": {
        "policy": "Pricing basis: {basis}. Submitting needs the approved transfer pricing policy for these legal entities in force on the effective date, documented by a basis note or an attachment on the policy. This is checked when you submit.",
        "attachmentMissing": "Pricing basis: {basis}. Attach the evidence for this basis below before submitting: a submit without at least one attachment is refused.",
        "attachmentPresent": "Pricing basis: {basis}. Evidence is attached; it is frozen with the instrument once submitted.",
        "attachmentUnknown": "Pricing basis: {basis}. Submitting needs at least one attachment evidencing the basis. You cannot see this instrument's attachments, so it is checked when you submit.",
        "methodLabel": "Pricing method",
        "evidenceLabel": "Evidence",
        "requirement": "Attach the evidence for the pricing basis (for example the cost computation or the board approval for an interest-free loan). Attachments can be changed only while the instrument is a draft."
      },
      "errors": {
        "pricingEvidence": "The instrument cannot be submitted without a recorded pricing method and its evidence.",
        "ruleMissing": "These legal entities have no intercompany rule between them, so there are no due-to and due-from accounts to post through. Configure the rule under Enterprise first.",
        "approvalUnresolvable": "No approver other than you is configured for intercompany instruments. An administrator must configure one.",
        "outstanding": "This instrument still has a balance. Settle the outstanding and in-flight amounts first.",
        "samePair": "Lender and borrower must be two different legal entities."
      },
      "report": {
        "title": "Intercompany loan register",
        "asOf": "As of",
        "asOfLabel": "Position as of {date}",
        "scope": "Show",
        "scopeLoans": "Loans only",
        "scopeAll": "Every kind",
        "includeClosed": "Include closed instruments",
        "advanced": "Advanced",
        "repaid": "Repaid",
        "total": "Total {currency}",
        "totalsNote": "Totals per currency cover every kind of instrument together. Show every kind to see them.",
        "loadFailed": "The loan register could not be loaded",
        "emptyTitle": "Nothing on the register",
        "emptyDescription": "No live intercompany instrument matches. Approved instruments appear here with what was advanced, repaid and is outstanding."
      }
    },
    "exchangeControls": {
      "intro": "The exchange-control obligations of each corridor. A cross-border release that breaks one is held for screening and must be cleared by compliance, like a sanctions hit.",
      "loadFailed": "The exchange-control rules could not be loaded",
      "currentTitle": "Rules in force",
      "emptyTitle": "No exchange-control rules",
      "emptyDescription": "Without rules, no corridor is closed, capped or required to state a purpose. Add the obligations each jurisdiction declares.",
      "edit": "Edit rules",
      "draftTitle": "Draft rule set",
      "draftDescription": "Nothing changes until you review and replace the whole set.",
      "draftEmpty": "The draft has no rules. Replacing with it removes every rule.",
      "add": "Add rule",
      "remove": "Remove",
      "review": "Review changes",
      "reviewTitle": "Replace the exchange-control rules",
      "reviewDescription": "What saving this draft changes, rule by rule.",
      "reviewWarning": "The whole set is replaced at once and takes effect on the next release screened.",
      "backToDraft": "Back to the draft",
      "replace": "Replace rule set",
      "saved": "Exchange-control rules replaced",
      "reloaded": "Someone else changed the rules while you were editing. Nothing was saved. Your changes are now measured against their set; review them and replace again.",
      "anyCurrency": "Any currency",
      "active": "Active",
      "inactive": "Inactive",
      "fields": {
        "countryCode": "Country",
        "currency": "Currency",
        "rule": "Rule",
        "threshold": "Threshold",
        "description": "Description",
        "status": "Status"
      },
      "rule": {
        "prohibited": "Prohibited",
        "limit": "Limit per instruction",
        "purpose_required": "Purpose code required",
        "report_required": "Regulatory report required"
      },
      "thresholdHint": {
        "prohibited": "Every payment to the corridor is held.",
        "limit": "Required. A payment above this is held.",
        "purpose_required": "From this amount (blank is any amount) a payment without a purpose code is held.",
        "report_required": "From this amount (blank is any amount) a payment is held at release until the regulator's report reference is recorded. A compliance clearance does not waive it."
      },
      "change": {
        "added": "Added",
        "removed": "Removed",
        "changed": "Changed",
        "field": "{field}: {before} → {after}"
      }
    },
    "screeningLists": {
      "tabs": {
        "entries": "Parties and jurisdictions",
        "exchangeControls": "Exchange controls"
      },
      "title": "Screening lists",
      "description": "The parties and jurisdictions every transfer release is screened against. There is no external feed: an entry missing here is a payment nobody stops.",
      "create": "New entry",
      "createTitle": "New screening entry",
      "editTitle": "Edit screening entry",
      "formDescription": "Takes effect on the next release screened.",
      "created": "Entry added to the screening list",
      "saved": "Entry saved",
      "retire": "Retire",
      "reactivate": "Reactivate",
      "retired": "Entry retired",
      "reactivated": "Entry reactivated",
      "reloaded": "Someone else changed this entry first. It has been reloaded; apply your change again.",
      "loadFailed": "The screening list could not be loaded",
      "tableTitle": "Entries",
      "emptyTitle": "The screening list is empty",
      "emptyDescription": "Add sanctioned parties and jurisdictions, or import a list from CSV. Until then, releases are screened against nothing.",
      "anyType": "Any type",
      "actionsColumn": "Actions",
      "typeFixed": "The type is fixed once the entry exists.",
      "aliasesHint": "Other names the party is known by, one per line or separated by ;",
      "countryHint": "Two-letter ISO code. Required for a jurisdiction.",
      "sourceHint": "Where the entry came from, for example the list publisher.",
      "type": {
        "party": "Party",
        "country": "Jurisdiction"
      },
      "state": {
        "active": "Active",
        "retired": "Retired"
      },
      "activeFilter": {
        "active": "Active only",
        "retired": "Retired only",
        "all": "Active and retired"
      },
      "fields": {
        "entryType": "Type",
        "name": "Name",
        "aliases": "Aliases",
        "bic": "BIC",
        "countryCode": "Country",
        "listName": "List",
        "source": "Source"
      },
      "import": {
        "open": "Import CSV",
        "title": "Import the screening list",
        "description": "Header row required: name; optional entryType (party or country), aliases (separated by ;), bic, countryCode, listName, source. One bad row imports nothing.",
        "file": "CSV file",
        "submit": "Import",
        "done": "{n} entries imported",
        "refused": "Nothing was imported: {n} row error(s).",
        "rowError": "Line {row}, {field}: {code}"
      }
    },
    "wallet_funding": {
      "below_threshold": "A wallet has fallen below its funding threshold.",
      "credited_closed_wallet": "A funding transfer was credited to a wallet that is already closed."
    },
    "mandate_panel": {
      "cannot_meet_rule": "The approver panel cannot satisfy the mandate rule."
    },
    "queue": {
      "transit_break": "Transfers stuck in transit",
      "wallet_variance": "Wallet count variances",
      "bank_limit_breach": "Banks holding more than their counterparty limit"
    },
    "wallet_leaver": {
      "holder_gone": "The holder of this wallet has left. It has moved to handover and needs a new custodian or a recovery."
    },
    "wallet_dormant": {
      "idle": "This wallet has been idle past its dormancy period. Reactivate it, recover its balance or close it."
    },
    "wallet_variance": {
      "unreconciled": "A reconciliation of this wallet's cash books left a difference. Find the cause and reconcile again."
    },
    "reconExceptions": {
      "title": "Reconciliation Exceptions",
      "description": "Every unmatched item past its age threshold, with a named owner, how old it is and how far it has been escalated.",
      "openSessions": "Reconciliation sessions",
      "tabs": {
        "label": "Reconciliation exception views",
        "exceptions": "Exceptions",
        "dashboard": "Dashboard"
      },
      "fields": {
        "legalEntity": "Legal entity",
        "bankAccount": "Bank account",
        "kind": "Kind",
        "owner": "Owner",
        "escalation": "Escalation",
        "item": "Item",
        "itemDate": "Item date",
        "age": "Age",
        "amount": "Amount",
        "journal": "Journal",
        "description": "Description",
        "resolution": "Resolution"
      },
      "filters": {
        "anyEntity": "Any legal entity",
        "anyAccount": "Any bank account",
        "anyStatus": "Any status",
        "anyKind": "Any kind",
        "anyOwner": "Any owner",
        "anyEscalation": "Any escalation",
        "unowned": "Only items nobody owns"
      },
      "status": {
        "open": "Open",
        "investigating": "Investigating",
        "resolved": "Resolved",
        "written_off": "Written off"
      },
      "kind": {
        "unmatched_bank": "Unmatched bank line",
        "unmatched_ledger": "Unmatched ledger item",
        "unpresented_payment": "Unpresented payment",
        "stale_deposit": "Unbanked deposit"
      },
      "escalation": {
        "atLeast": "Level {level} or higher",
        "level": "Escalation level {level}"
      },
      "accountById": "Bank account #{id}",
      "owner": {
        "none": "Nobody",
        "byId": "User #{id}"
      },
      "ownerSource": {
        "declared": "declared account owner",
        "account": "account owner",
        "assigned": "assigned",
        "none": "no owner found; the Controller is told"
      },
      "loadFailed": "The reconciliation exceptions could not be loaded",
      "emptyTitle": "No exceptions",
      "emptyDescription": "Nothing in this view has aged past its threshold unmatched. The daily sweep raises an exception, with an owner, when an item does.",
      "tableTitle": "Exceptions",
      "pageEmpty": "Nothing on this page matches the filters.",
      "days": "{days} days",
      "staleSince": "Stale since {date}",
      "work": "Work on it",
      "view": "View",
      "detail": {
        "title": "Exception #{id}",
        "loadFailed": "This exception could not be loaded",
        "openWorkspace": "Open this account's reconciliation sessions",
        "staleNote": {
          "unpresented_payment": "This payment has not presented past the staleness period. It is cleared by its own sub-ledger writing it back or replacing it, then resolved as reversed at source.",
          "stale_deposit": "This deposit has not reached the bank past the staleness period. It is cleared by its own sub-ledger cancelling or replacing it, then resolved as reversed at source."
        },
        "candidates": "Candidate matches",
        "noCandidates": "Nothing of the same amount and direction is near this item's date.",
        "trail": "Investigation trail",
        "noTrail": "Nothing has been recorded yet."
      },
      "resolution": {
        "matched": "Matched",
        "written_off": "Written off through the missing-entry posting",
        "reversed_at_source": "Reversed at source",
        "no_longer_outstanding": "No longer outstanding"
      },
      "actions": {
        "assignTitle": "Assign",
        "newOwner": "New owner",
        "newOwnerHint": "They must be able to manage reconciliation exceptions.",
        "note": "Note",
        "assign": "Assign",
        "assignDone": "Exception assigned",
        "investigateTitle": "Investigate",
        "investigationNote": "What you found or did",
        "investigationHint": "Added to the trail. If nobody owns the exception it becomes yours.",
        "investigate": "Record investigation",
        "investigateDone": "Investigation recorded",
        "resolveTitle": "Resolve",
        "resolveHintBank": "Clear the line on the reconciliation workspace first: match it, or post the missing entry. Then name that match here.",
        "resolveHintLedger": "Match the item on the reconciliation workspace, or have its own sub-ledger reverse it. A ledger item is never written off here.",
        "matchId": "Match number",
        "matchIdHint": "The number of the match that cleared this item.",
        "resolutionNote": "Resolution note",
        "resolve": "Resolve",
        "resolveDone": "Exception resolved",
        "reloaded": "Someone changed this exception while you were working. It has been reloaded; check it and apply your change again."
      },
      "errors": {
        "ERR_RECON_EXCEPTION_CLOSED": "This exception is already closed; only the daily sweep reopens one.",
        "ERR_RECON_EXCEPTION_OUTSTANDING": "The item is still unmatched and nothing explains it yet.",
        "ERR_RECON_EXCEPTION_MATCH_INVALID": "That match does not clear this item.",
        "ERR_RECON_EXCEPTION_WRITE_OFF_REFUSED": "This item cannot be written off here."
      },
      "trail": {
        "actor": {
          "system": "the daily sweep",
          "other": "another principal"
        }
      },
      "dashboard": {
        "loadFailed": "The reconciliation dashboard could not be loaded",
        "inProgress": "Accounts being reconciled",
        "neverReconciled": "Accounts never reconciled",
        "openExceptions": "Open exceptions",
        "escalated": "Escalated",
        "unowned": "Nobody owns",
        "stale": "Stale items",
        "asOfSwept": "As of {asOf}. Exceptions last swept on {sweep}.",
        "asOfNoSweep": "As of {asOf}. The exception sweep has not run yet.",
        "emptyTitle": "No bank accounts",
        "emptyDescription": "The dashboard reports every active bank account in this view.",
        "byAccount": "By bank account",
        "state": "Reconciliation",
        "states": {
          "reconciled": "Reconciled",
          "in_progress": "In progress",
          "never_reconciled": "Never reconciled"
        },
        "openSession": "Open the session",
        "lastReconciled": "Reconciled to",
        "daysAgo": "{days} days ago",
        "daysToReconcile": "Days to reconcile",
        "sample": "over {count} completed",
        "unmatchedStatement": "Unmatched bank lines",
        "unmatchedLedger": "Unmatched ledger items",
        "items": "{count} item(s)",
        "exceptions": "Exceptions",
        "liveExceptions": "{count} live",
        "breakdown": "{escalated} escalated · {unowned} unowned · {stale} stale"
      }
    },
    "walletCounts": {
      "anyStatus": "Any status",
      "anyWallet": "All wallets you can see",
      "caption": "Cash counts and where each one stands",
      "countNo": "Count",
      "description": "Every cash count you can reach, newest first. A blind count shows no system figure until it is posted.",
      "emptyDescription": "Counts are opened from a wallet, one at a time per wallet. Open one from the wallet you hold.",
      "emptyTitle": "No counts yet",
      "entityHint": "Narrows the wallets offered. With no wallet chosen, every count you can see is listed.",
      "loadFailed": "Those counts did not load",
      "openWallets": "Wallets",
      "tableTitle": "Counts",
      "title": "Cash counts"
    },
    "walletDepth": {
      "capture": {
        "bookHint": "This wallet is made of several cash books. Name the one the money left."
      },
      "clearDeputy": "Remove the deputy {name}",
      "composition": {
        "addBook": "Add cash book",
        "book": "Cash book",
        "caption": "The cash books this wallet is made of",
        "createHint": "A wallet's cash books are fixed when it is created, and a cash book belongs to one wallet only. Leave this empty for a single cash book named after the wallet.",
        "description": "The cash books this wallet is made of, with the balance each one records.",
        "duplicate": "Two cash books have the same code. Each cash book is named once.",
        "empty": "This wallet has no cash books.",
        "fixedAtCreation": "Fixed at creation",
        "missingCode": "Every cash book you add needs a code. Enter it, or remove the row.",
        "kind": {
          "group": "Several cash books",
          "single": "One cash book"
        },
        "primary": "Primary",
        "recorded": "Recorded balance",
        "removeBook": "Remove",
        "title": "Composition"
      },
      "deputyHint": "The deputy may record spending but never approves it. Must be a different person from the custodian.",
      "dormancyDays": "Dormancy period (days)",
      "dormancyHint": "A wallet with no movement for this many days becomes dormant. Between 1 and 3650.",
      "funding": {
        "accountOnFile": "An account is on file (not an active account you can see)",
        "createHint": "The bank account this wallet is funded from and recovered to. Only active accounts in the wallet's currency are offered.",
        "description": "Where the wallet is funded from and recovered to, and the limits on what it may hold.",
        "editDescription": "All three terms are saved together. Leave a figure blank to remove that limit.",
        "editTitle": "Edit funding terms",
        "maxHint": "The most the wallet may hold, counting loads in transit. Not below the float of an imprest wallet.",
        "noAccount": "No funding account",
        "noLimit": "No maximum",
        "noThreshold": "No threshold",
        "saved": "The funding terms were saved.",
        "threshold": "Replenishment threshold",
        "thresholdHint": "When the balance falls to this figure, a replenishment is proposed.",
        "title": "Funding"
      },
      "handover": {
        "count": "Handover count",
        "incoming": "Incoming custodian",
        "outgoing": "Outgoing custodian",
        "pending": "Not yet acknowledged",
        "signed": "Acknowledged by {name} at {at}"
      },
      "reconcile": {
        "caption": "Observed balance per cash book",
        "cause": "Cause",
        "confirm": "Record reconciliation",
        "description": "State the balance you observe in every cash book. A book that differs needs a cause and an owner before anything is recorded.",
        "difference": "Difference",
        "differs": "Differs from the recorded balance",
        "doneReconciled": "The wallet was reconciled. Every cash book agrees.",
        "doneUnreconciled": "The reconciliation was recorded as unreconciled: {books} cash book(s) differ.",
        "everyBook": "Every cash book is stated. An aggregate that agrees can hide a book that does not.",
        "historyEmpty": "This wallet has never been reconciled.",
        "historyLoadFailed": "The reconciliations did not load",
        "historyTitle": "Reconciliations",
        "linesCaption": "Each cash book in this reconciliation",
        "maskedByAggregate": "The total agrees, but a cash book does not",
        "observed": "Observed balance",
        "open": "Reconcile per cash book",
        "owner": "Owner",
        "status": {
          "reconciled": "Reconciled",
          "unreconciled": "Unreconciled"
        },
        "title": "Reconcile the wallet",
        "total": "Total"
      },
      "recover": {
        "amountHint": "Leave blank to recover everything the wallet (or the chosen cash book) holds.",
        "bookHint": "Required for a wallet of several cash books. Recover from that cash book, never more than it holds.",
        "confirm": "Recover balance",
        "description": "Returns value from this wallet to its funding account on treasury's authority.",
        "done": "{amount} {currency} was recovered. The wallet now holds {balance}.",
        "fundingHint": "Defaults to the wallet's funding account. Only active accounts in the wallet's currency are offered.",
        "notifyNotAsk": "The custodian is notified, not asked. Their consent is not required, and the reason you give is recorded and sent to them.",
        "open": "Recover balance",
        "reasons": {
          "custodian_left": "The custodian left",
          "dormant": "Dormant wallet",
          "excess_float": "Holding more than it needs",
          "investigation": "Under investigation",
          "other": "Other"
        },
        "title": "Recover the wallet's balance"
      },
      "unresolved": "The last submission got no answer, so it may already have been applied. It is shown as it was sent: send it again to get its outcome. It will not be applied twice.",
      "varianceCauseOwner": "Cause and owner",
      "varianceOwner": "Variance owner"
    },
    "walletOps": {
      "errors": {
        "ERR_WALLET_CASH_BOOK_HELD": "That cash book already belongs to another wallet.",
        "ERR_WALLET_RECOVERY_EXCEEDS_BALANCE": "That is more than the wallet holds.",
        "ERR_ILLEGAL_TRANSITION": "That step is not allowed from the record's current state.",
        "ERR_PERIOD_CLOSED": "The period for that date is closed.",
        "ERR_ROW_VERSION": "Somebody else changed this record first. It has been reloaded; apply your change again.",
        "ERR_SOD_VIOLATION": "You may not decide a spend from a wallet you hold or a spend you recorded.",
        "ERR_WALLET_CATEGORY_BLOCKED": "Spending on this category is blocked for this wallet.",
        "ERR_WALLET_CUSTODY_COUNT_REQUIRED": "A handover needs a posted count first.",
        "ERR_WALLET_EVIDENCE_REQUIRED": "This spend needs evidence attached.",
        "ERR_WALLET_HANDOVER_NOT_A_PARTY": "You are neither the outgoing nor the incoming custodian of this handover.",
        "ERR_WALLET_LIMIT": "This spend is over a limit for its category.",
        "ERR_WALLET_NOT_RECONCILED": "This wallet's latest reconciliation left a difference. Reconcile it before handing it over.",
        "ERR_WALLET_TAX_WITHOUT_INVOICE": "Tax cannot be recovered without a valid tax invoice.",
        "ERR_WALLET_VARIANCE_UNEXPLAINED": "The count has a variance and needs a reason.",
        "ERR_WALLET_WITNESS_REQUIRED": "This count needs a witness."
      },
      "captureAndSubmit": "Record and submit",
      "captureNotSubmitted": "The spend was recorded but not submitted for approval: {reason} Submit it from the list.",
      "captureSubmitDescription": "Cash left the tin. Recording it also submits it to an approver; the expense is not in the accounts until it is approved.",
      "captureSubmitted": "The spend was recorded and submitted for approval.",
      "close": "Close wallet",
      "closeBlocked": "This wallet still holds money. Approve or reject what is held in clearing, then post a closing count that brings the tin to zero; a wallet cannot close over a live balance.",
      "closeConfirm": "Close wallet",
      "closeDescription": "A closed wallet takes no more spends, counts or replenishments. Its history stays readable.",
      "closeReasons": {
        "consolidated": "Merged into another wallet",
        "custodian_left": "The custodian left",
        "no_longer_required": "No longer required",
        "other": "Other"
      },
      "closeTitle": "Close the wallet",
      "closed": "The wallet was closed.",
      "closedBanner": "This wallet was closed on {at}. Its history is kept; nothing new can be recorded against it.",
      "countsCaption": "Cash counts on this wallet",
      "countsDescription": "The most recent counts, newest first. A blind count shows no variance until it is posted.",
      "countsEmpty": "This wallet has never been counted.",
      "countsTitle": "Count history",
      "editDescription": "Only what you change is sent. Closing is a separate action.",
      "editTitle": "Edit the wallet",
      "ownCapture": "You recorded this, or you hold this wallet — someone else decides it",
      "reloaded": "Somebody else changed this record first. It has been reloaded; apply your change again.",
      "reverse": "Reverse",
      "reverseConfirm": "Post reversal",
      "reverseDescription": "Posts the exact opposite of the movement, dated today. The original is kept.",
      "reverseNote": "A reversal cannot itself be reversed from here. Be sure of the movement before you post it.",
      "reverseReasons": {
        "duplicate": "Duplicate",
        "entered_in_error": "Entered in error",
        "other": "Other",
        "wrong_amount": "Wrong amount"
      },
      "reverseTitle": "Reverse the movement",
      "reversed": "The reversal was posted.",
      "saved": "The wallet was saved.",
      "statusHint": "A suspended wallet takes no spends until it is made active again.",
      "submitted": "The spend was submitted for approval.",
      "suspendNote": "Suspending stops new spends from this wallet. Counts and handovers still work.",
      "txnsLoadFailed": "Those transactions did not load"
    },
    "walletExpenditure": {
      "anyKind": "Any kind",
      "anyStatus": "Any status",
      "caption": "Movements recorded against the selected wallet",
      "description": "Spends recorded against a wallet, where each one stands, and the movements that can be reversed.",
      "emptyDescription": "Nothing matches these filters on this wallet. Record a spend when cash leaves the tin; it goes to an approver as soon as it is recorded.",
      "emptyTitle": "No movements here",
      "loadFailed": "Those movements did not load",
      "noWalletsDescription": "A wallet is visible to its custodian and to whoever manages or approves it. If you hold no float in this legal entity, there is nothing to record against.",
      "noWalletsTitle": "No wallets you can see",
      "openApprovals": "Approvals queue",
      "tableTitle": "Movements",
      "title": "Expenditure capture"
    },
    "walletCustody": {
      "countCycle": "Count cycle",
      "everyDays": "Every {days} days",
      "since": "Custodian since"
    },
    "walletHandover": {
      "acknowledgeIncoming": "Acknowledge as incoming",
      "acknowledgeOutgoing": "Acknowledge as outgoing",
      "awaitingIncoming": "The outgoing custodian has acknowledged. The incoming custodian must acknowledge with a posted handover count.",
      "awaitingOutgoing": "Awaiting the outgoing custodian's acknowledgement.",
      "completed": "The handover is complete. Custody has passed.",
      "confirm": {
        "decline": "Decline handover",
        "incoming": "Acknowledge and take custody",
        "outgoing": "Acknowledge"
      },
      "countRequired": "A handover cannot be acknowledged by the incoming custodian without a posted count of this wallet. Taking over a tin without counting it is how a shortage becomes your problem.",
      "custodian": "Custodian",
      "decline": "Decline",
      "declineReason": "Reason for declining",
      "declined": "The handover was declined. Custody stays with the outgoing custodian.",
      "deputy": "Deputy",
      "description": {
        "decline": "The wallet returns to what it was and accountability stays with the outgoing custodian.",
        "incoming": "Name the count you performed at handover. Custody passes when you acknowledge.",
        "outgoing": "You confirm you are handing this wallet over. The incoming custodian acknowledges next."
      },
      "hide": "Hide",
      "masked": "Masked",
      "outgoingAcknowledged": "You have acknowledged the handover. The incoming custodian is next.",
      "reveal": "Reveal",
      "revealDescription": "Custodian and deputy details are masked. Revealing them needs your authenticator code and is recorded against your name with the purpose you state.",
      "revealReason": "Purpose",
      "revealTitle": "Reveal custodian and deputy",
      "revealedContact": "Contact",
      "title": {
        "decline": "Decline the handover",
        "incoming": "Acknowledge custody as incoming custodian",
        "outgoing": "Acknowledge handover as outgoing custodian"
      }
    },
    "walletReplenish": {
      "currentShortfall": "Current shortfall, for reference",
      "derivedLabel": "Amount",
      "derivedRule": "Worked out when you submit: the approved spending since the last replenishment, or the float shortfall if this wallet has never been replenished. Spends not yet approved are left out.",
      "justification": "Justification",
      "justificationOptionalHint": "Optional for an imprest wallet.",
      "justificationRequiredHint": "Why this wallet needs the money. Required for a variable wallet.",
      "requested": "Replenishment {no} was requested for {amount} {currency}.",
      "variableAmountHint": "A variable wallet has no float to restore, so state the amount it needs."
    }
  },
  "qms": {
    "filtersTitle": "Filters",
    "common": {
      "yes": "Yes",
      "no": "No",
      "remove": "Remove"
    },
    "routeTitles": {
      "plans": "Inspection plans",
      "plan": "Inspection plan",
      "samplingPlans": "Sampling plans",
      "worklist": "Inspections",
      "inspection": "Inspection",
      "capaBoard": "Corrective actions",
      "capa": "Corrective action",
      "qualitySummary": "Quality summary",
      "settings": "Quality settings"
    },
    "origin": {
      "goods_receipt": "Goods receipt",
      "production": "Production",
      "shipment": "Shipment"
    },
    "planStatus": {
      "draft": "Draft",
      "active": "Active",
      "obsolete": "Obsolete"
    },
    "characteristicKind": {
      "numeric": "Numeric",
      "attribute": "Attribute",
      "visual": "Visual"
    },
    "severity": {
      "critical": "Critical",
      "major": "Major",
      "minor": "Minor"
    },
    "samplingMethod": {
      "fixed_percent": "Fixed percentage",
      "aql_table": "AQL table",
      "hundred_percent": "Every unit"
    },
    "inspectionStatus": {
      "pending": "Pending",
      "in_progress": "In progress",
      "passed": "Passed",
      "failed": "Failed",
      "waived": "Waived"
    },
    "dispositionKind": {
      "accept": "Accept",
      "accept_with_concession": "Accept with concession",
      "rework": "Rework",
      "reject_return": "Reject and return",
      "reject_scrap": "Reject and scrap",
      "hold": "Hold"
    },
    "capaKind": {
      "corrective": "Corrective",
      "preventive": "Preventive"
    },
    "capaStatus": {
      "open": "Open",
      "investigating": "Investigating",
      "actions_planned": "Actions planned",
      "actions_complete": "Actions complete",
      "verifying": "Verifying",
      "closed": "Closed",
      "cancelled": "Cancelled"
    },
    "capaActionStatus": {
      "open": "Open",
      "done": "Done",
      "cancelled": "Cancelled"
    },
    "capaSource": {
      "inspection": "Inspection",
      "ncr": "Nonconformance report",
      "supplier_scorecard": "Supplier scorecard",
      "recall": "Recall",
      "audit": "Audit",
      "customer_complaint": "Customer complaint",
      "manual": "Raised by a person"
    },
    "receiptPolicy": {
      "none": "Receive straight into stock",
      "quarantine": "Quarantine on arrival"
    },
    "sla": {
      "ok": "Within SLA",
      "due_soon": "Due soon",
      "overdue": "Overdue",
      "unknown": "No SLA set"
    },
    "fields": {
      "acceptNumber": "Accept number",
      "allowedValues": "Allowed values",
      "code": "Code",
      "company": "Legal Entity",
      "controls": "Controls",
      "critical": "critical",
      "decidedAt": "Decided",
      "decimals": "Decimal places",
      "defects": "Defects",
      "dueOn": "Due",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "effectiveness": "Effectiveness",
      "effectivenessDueOn": "Effectiveness due",
      "effectivenessNote": "Effectiveness note",
      "effectivity": "Effectivity",
      "fromDate": "From",
      "item": "Item",
      "kind": "Kind",
      "lotNo": "Lot",
      "lotQuantity": "Lot quantity",
      "lotSizeFrom": "Lot size from",
      "lotSizeTo": "Lot size to",
      "mandatory": "Mandatory",
      "maxSampleSize": "Maximum sample size",
      "method": "Method",
      "minSampleSize": "Minimum sample size",
      "openEnded": "open",
      "origin": "Origin",
      "originDoc": "Source document",
      "quantity": "Quantity",
      "reason": "Reason",
      "reasonCode": "Reason code",
      "recordedDefects": "Recorded defects",
      "rejected": "Rejected",
      "rejectNumber": "Reject number",
      "samplePercent": "Sample percentage",
      "sampleSize": "Sample size",
      "sampling": "Sampling plan",
      "scope": "Scope",
      "seqNo": "Seq",
      "severity": "Severity",
      "source": "Source",
      "specMax": "Maximum",
      "specMin": "Minimum",
      "specTarget": "Target",
      "specification": "Specification",
      "title": "Title",
      "toDate": "To",
      "uom": "Unit",
      "vendor": "Supplier",
      "waiting": "Waiting"
    },
    "plans": {
      "title": "Inspection plans",
      "description": "What is checked, how much of it is checked, and what happens when it fails.",
      "tableTitle": "Plans",
      "caption": "Inspection plans with their origin, scope, sampling plan and effectivity window.",
      "create": "New plan",
      "edit": "Edit plan",
      "dialogDescription": "A plan applies to one origin. Resolution runs item first, then category, then supplier, then the catch-all.",
      "searchLabel": "Search",
      "searchPlaceholder": "Code or name",
      "loadFailed": "The inspection plans did not load",
      "empty": "No inspection plans yet. Create one to start inspecting deliveries, production output or shipments.",
      "emptyFiltered": "No inspection plans match these filters.",
      "scopeAll": "Every item",
      "scopeHint": "One scope, not several. A plan naming both an item and a category is two plans.",
      "scopePanel": "Scope and effectivity",
      "scopeKind": {
        "all": "Every item at this origin",
        "item": "One item",
        "category": "One item category",
        "vendor": "One supplier"
      },
      "originHint": "A plan written for a receipt is never selected for a production operation.",
      "samplingHint": "Leave empty to inspect the whole lot.",
      "noSampling": "Whole lot",
      "quarantines": "Quarantines",
      "blocking": "Blocking",
      "independent": "Independent inspector",
      "quarantineLabel": "Quarantine the delivery on arrival",
      "quarantineMeaning": "Received stock is held: it is on the balance sheet, it is in GR-IR, and it cannot be issued until the inspection is dispositioned.",
      "blockingLabel": "A failed inspection blocks the next step",
      "blockingMeaning": "A failure refuses the release to stock, the finished-goods receipt or the despatch rather than merely recording it.",
      "advisoryMeaning": "Advisory only: a failure is recorded and nothing downstream is refused.",
      "independentLabel": "The inspector must not be the person who raised the document",
      "independentMeaning": "An inspection recorded by the source document's own actor is refused, in the service and again by a database constraint.",
      "activate": "Activate",
      "activated": "Plan activated",
      "activateFailed": "The plan was not activated",
      "draftMeaning": "A draft plan selects for nothing. Activating it starts quarantining matching deliveries from the next receipt.",
      "saved": "Plan saved",
      "saveFailed": "The plan was not saved",
      "backToList": "Back to inspection plans"
    },
    "characteristics": {
      "title": "Characteristics",
      "caption": "Measurable properties in the order an inspector records them.",
      "add": "Add characteristic",
      "edit": "Edit characteristic",
      "dialogDescription": "The kind decides which fields mean anything, and the severity decides how a defect is counted.",
      "empty": "No characteristics yet. A plan with none cannot be activated.",
      "saved": "Characteristic saved",
      "saveFailed": "The characteristic was not saved",
      "removed": "Characteristic removed",
      "removeFailed": "The characteristic was not removed",
      "kindHint": {
        "numeric": "A reading is a number compared against the bounds",
        "attribute": "A reading is one of a fixed list of values",
        "visual": "A reading is pass or fail, with a note"
      },
      "severityHint": {
        "critical": "One defect fails the whole lot",
        "major": "Counted against the acceptance number",
        "minor": "Counted against the acceptance number"
      },
      "severityMeaning": "A critical defect fails the lot whatever the acceptance number says.",
      "unbounded": "unbounded",
      "unboundedHint": "Leave empty for no bound on this side.",
      "needsBound": "A numeric characteristic needs at least one bound. Without one, no reading can pass or fail.",
      "visualSpec": "pass or fail",
      "noAllowedValues": "no values set",
      "allowedValuesHint": "One value per line.",
      "target": "target {value}",
      "decimalsMeaning": "How many places a reading is rounded to before it is compared.",
      "mandatoryLabel": "Mandatory",
      "mandatoryMeaning": "The lot cannot pass until this characteristic has been recorded.",
      "codeFixedOnceCreated": "Fixed once created"
    },
    "samplingPlans": {
      "title": "Sampling plans",
      "description": "How many of a delivery to inspect, and how many defects to tolerate.",
      "tableTitle": "Plans",
      "caption": "Sampling plans with their method, percentage, floor and acceptance number.",
      "create": "New sampling plan",
      "dialogDescription": "The method decides which fields exist. AQL bands are entered after the plan is created.",
      "empty": "No sampling plans yet. Create one, or leave a plan without one to inspect whole lots.",
      "loadFailed": "The sampling plans did not load",
      "saved": "Sampling plan saved",
      "saveFailed": "The sampling plan was not saved",
      "selectFirst": "Choose a sampling plan to preview it or edit its bands.",
      "methodHint": {
        "fixed_percent": "Inspect a percentage of the lot, never fewer than the floor",
        "aql_table": "Inspect the size your own band table says for this lot size",
        "hundred_percent": "Inspect every unit; the acceptance number is zero"
      },
      "floorMeaning": "Stops a 2% plan inspecting nothing on a ten-unit delivery.",
      "acceptMeaning": "Defects up to and including this number still pass the lot.",
      "aqlNote": "AQL plans take their sample size and acceptance number from the band table. Enter the bands before activating a plan that uses this one.",
      "hundredNote": "Every unit is inspected and the acceptance number is zero.",
      "previewTitle": "Preview",
      "previewDescription": "What this plan would do to a delivery of a given size. The figures are the server's own arithmetic.",
      "previewAction": "Preview",
      "bandsTitle": "AQL bands",
      "bandsDescription": "Lot-size bands with their sample size and acceptance number. A lot outside every band is refused rather than defaulted to 100%.",
      "bandsCaption": "AQL bands for the selected sampling plan.",
      "bandsEmpty": "No bands yet. A plan using the AQL method cannot be activated without them.",
      "addBand": "Add band",
      "saveBands": "Save bands",
      "bandsSaved": "Bands saved",
      "bandsFailed": "The bands were not saved"
    },
    "worklist": {
      "title": "Inspections",
      "description": "What is waiting to be inspected, by where it came from.",
      "tableTitle": "Inspection lots",
      "caption": "Open inspection lots with their source document, sample size and defects found.",
      "searchLabel": "Search",
      "searchPlaceholder": "Lot or document number",
      "loadFailed": "The inspections did not load",
      "empty": "No inspections. They are created by a receipt, a production receipt or a shipment when a plan matches.",
      "emptyOpen": "Nothing is waiting to be inspected.",
      "showOpen": "Open only",
      "showAll": "Show all",
      "openCount": "{count} open on this page",
      "critical": "{count} critical",
      "noSla": "No quarantine SLA is set for this legal entity, so no lot is shown as overdue. Set one in quality settings.",
      "backToList": "Back to inspections"
    },
    "inspection": {
      "untitled": "Inspection #{id}",
      "subtitle": "From {doc}",
      "factsTitle": "Lot",
      "sheetTitle": "Recording sheet",
      "sheetHelp": "Enter or the down arrow moves to the next sample; the right arrow moves to the next characteristic.",
      "sheetCaption": "One row per characteristic, one column per sample.",
      "sample": "S{no}",
      "cellLabel": "{name}, sample {no}",
      "pass": "Pass",
      "fail": "Fail",
      "noCharacteristics": "This plan has no characteristics, so there is nothing to record.",
      "record": "Record readings",
      "recorded": "Readings recorded",
      "recordedCount": "{count} readings",
      "recordFailed": "The readings were not recorded",
      "readingCount": "{count} readings entered",
      "loadFailed": "The inspection did not load",
      "notIndependent": "You raised the source document, and this plan requires an independent inspector. Somebody else has to record these readings.",
      "provisionalCritical": "A critical defect has been entered. A critical defect fails the lot whatever the acceptance number says.",
      "provisionalOverAccept": "{defects} defects entered against an acceptance number of {accept}. On these readings the lot will fail.",
      "waive": "Waive",
      "waiveConfirm": "Waive inspection",
      "waiveDescription": "Release this lot without inspecting it.",
      "waiveMeaning": "The goods proceed and no reading is ever recorded for this lot. The reason is kept permanently and is what an auditor reads.",
      "waived": "Inspection waived",
      "waiveFailed": "The inspection was not waived"
    },
    "disposition": {
      "title": "Dispositions",
      "caption": "What was decided about the lot, and how much of it.",
      "decide": "Disposition",
      "confirm": "Record disposition",
      "dialogDescription": "What happens to the goods, and to how many of them.",
      "saved": "Disposition recorded",
      "saveFailed": "The disposition was not recorded",
      "concessionRequired": "This lot failed. Accepting it needs a reason, which is recorded as a concession.",
      "returnMeaning": "The goods go back to the supplier: this starts a return, and a debit note when the return is despatched.",
      "scrapMeaning": "The value is written off to the legal entity's receipt-scrap account. No debit note is raised, because the supplier is not taking the goods back.",
      "kindMeaning": {
        "accept": "Into stock and available to issue",
        "accept_with_concession": "Into stock despite the failure, with a recorded reason",
        "rework": "Held for rework rather than issued",
        "reject_return": "Returned to the supplier",
        "reject_scrap": "Written off to the P&L",
        "hold": "Left quarantined pending a decision"
      }
    },
    "capa": {
      "title": "Corrective actions",
      "description": "What went wrong, what was done about it, and whether it worked.",
      "create": "New CAPA",
      "dialogDescription": "Corrective responds to something that happened; preventive to something that has not.",
      "searchLabel": "Search",
      "searchPlaceholder": "Number or title",
      "loadFailed": "The corrective actions did not load",
      "empty": "No corrective actions. Raise one from a failed inspection, a nonconformance or an audit finding.",
      "columnEmpty": "Nothing here",
      "truncated": "Showing the first page. The columns count what is on screen, not the whole register.",
      "showMine": "Mine only",
      "showAll": "Show all",
      "dueOn": "Due {date}",
      "saved": "CAPA raised",
      "saveFailed": "The CAPA was not saved",
      "kindHint": {
        "corrective": "Something has already gone wrong",
        "preventive": "Something has not gone wrong yet"
      },
      "sourceHint": "How the finding reached you.",
      "factsTitle": "Details",
      "rootCauseTitle": "Root cause",
      "rootCausePlaceholder": "What actually caused this?",
      "rootCauseSaved": "Root cause saved",
      "actionsTitle": "Actions",
      "actionsCaption": "Planned actions with their owner, due date and completion.",
      "actionsEmpty": "No actions planned yet.",
      "newAction": "New action",
      "completeAction": "Mark complete",
      "actionAdded": "Action added",
      "actionCompleted": "Action completed",
      "actionFailed": "The action was not saved",
      "verifyTitle": "Effectiveness",
      "verifyDescription": "Did the actions work? This is a separate authority from running them.",
      "verifyingMeaning": "Waiting on a verdict. Not effective sends the CAPA back to actions planned.",
      "verifyNotPermitted": "This CAPA is waiting on an effectiveness verdict. Recording one needs the verify authority, which is held separately from managing the actions.",
      "effective": "Effective",
      "effectiveMeaning": "The problem has not recurred and the CAPA closes.",
      "notEffective": "Not effective",
      "notEffectiveMeaning": "The CAPA returns to actions planned. A corrective action that did not work is not finished.",
      "recordVerdict": "Record verdict",
      "verifiedClosed": "CAPA closed",
      "verifiedReopened": "CAPA returned to actions planned",
      "verifyFailed": "The verdict was not recorded",
      "backToBoard": "Back to corrective actions"
    },
    "qualitySummary": {
      "title": "Quality summary",
      "description": "Pass rate and defect rate, by characteristic, supplier and item.",
      "pickCompany": "Choose a legal entity to run the summary.",
      "loadFailed": "The quality summary did not load",
      "passRate": "Pass rate",
      "inspected": "Inspected",
      "failed": "Failed",
      "waived": "Waived",
      "defectRate": "Defect rate",
      "byCharacteristic": "By characteristic",
      "byVendor": "By supplier",
      "byItem": "By item",
      "empty": "Nothing in this period.",
      "readings": "Readings",
      "critical": "Critical"
    },
    "settings": {
      "title": "Quality settings",
      "description": "Where quarantined stock sits, where scrap posts, and how long a lot may wait.",
      "panelTitle": "Legal entity settings",
      "pickCompany": "Choose a legal entity to see its quality settings.",
      "loadFailed": "The quality settings did not load",
      "saved": "Quality settings saved",
      "saveFailed": "The quality settings were not saved",
      "readOnly": "You can see these settings but not change them.",
      "quarantineWarehouse": "Quarantine warehouse",
      "quarantineWarehouseMeaning": "Where held stock physically sits. It is on the balance sheet and cannot be issued.",
      "scrapAccount": "Receipt scrap account",
      "scrapAccountMeaning": "Where a reject-and-scrap disposition writes the value off.",
      "receiptPolicy": "Default receipt policy",
      "policyHint": {
        "none": "Deliveries with no matching plan go straight into stock",
        "quarantine": "Deliveries with no matching plan are held until released"
      },
      "slaDays": "Quarantine SLA (days)",
      "slaDaysMeaning": "How long a lot may wait before the worklist calls it overdue.",
      "noSlaMeaning": "With no SLA set the worklist shows no assurance at all, which is honest but leaves nothing chasing an old lot.",
      "capaDueDays": "Default CAPA due (days)"
    },
    "quarantine_overdue": {
      "summary": "Stock has been in quarantine beyond the legal entity's allowed days."
    },
    "capa_overdue": {
      "summary": "A corrective action is past its due date."
    }
  },
  "pos": {
    "filtersTitle": "Filters",
    "routeTitles": {
      "outlets": "Outlets",
      "outlet": "Outlet",
      "settings": "Point-of-sale settings",
      "devices": "Device fleet",
      "device": "Device",
      "contentSets": "Content sets",
      "contentSet": "Content set",
      "menus": "Menus",
      "menuVersion": "Menu version",
      "availability": "86 board",
      "sales": "POS sales",
      "sale": "POS sale",
      "cashSessions": "Cash sessions",
      "cashSession": "Cash session",
      "dayCloseBoard": "Day close",
      "dayClose": "Day close pack",
      "anomalies": "Operator anomalies",
      "conflicts": "Sync conflicts",
      "ratifications": "Deferred authorisations",
      "operatorPins": "Operator PINs",
      "supersededPricing": "Superseded pricing",
      "floorPlan": "Floor plan",
      "retailLedgers": "Retail ledgers"
    },
    "fields": {
      "businessDate": "Business date",
      "cashAccount": "Drawer GL account",
      "cashRounding": "Cash rounding",
      "channel": "Channel",
      "channelDefault": "Legal entity default",
      "code": "Code",
      "company": "Legal Entity",
      "currency": "Currency",
      "dayUnit": "Operating day unit",
      "docKind": "Document",
      "effectivity": "Effective",
      "kind": "Kind",
      "location": "Location",
      "openEnded": "open-ended",
      "outlet": "Outlet",
      "priceSet": "Price set",
      "state": "State",
      "supplyType": "Supply type",
      "taxChannel": "Tax channel",
      "terminal": "Terminal",
      "warehouse": "Warehouse"
    },
    "outletKind": {
      "retail": "Retail",
      "hospitality": "Hospitality",
      "wholesale": "Wholesale"
    },
    "supplyType": {
      "goods": "Goods",
      "services": "Services",
      "accommodation": "Accommodation",
      "fnb": "Food and beverage",
      "digital": "Digital",
      "transport": "Transport",
      "other": "Other"
    },
    "terminalStatus": {
      "active": "Active",
      "suspended": "Suspended",
      "retired": "Retired"
    },
    "tenderKind": {
      "cash": "Cash",
      "card": "Card",
      "gift_card": "Gift card",
      "store_credit": "Store credit",
      "account": "On account",
      "room_charge": "Room charge"
    },
    "denominationKind": {
      "note": "Note",
      "coin": "Coin"
    },
    "saleStatus": {
      "open": "Open",
      "settled": "Settled",
      "voided": "Voided",
      "abandoned": "Abandoned"
    },
    "saleDocKind": {
      "sale": "Sale",
      "refund": "Refund"
    },
    "channelMode": {
      "dine_in": "Dine in",
      "takeaway": "Takeaway",
      "delivery": "Delivery",
      "room_charge": "Room charge",
      "counter": "Counter"
    },
    "priceBasis": {
      "exclusive": "Tax exclusive",
      "inclusive": "Tax inclusive"
    },
    "discountKind": {
      "percent": "Percentage",
      "amount": "Amount",
      "promotion": "Promotion"
    },
    "sessionStatus": {
      "open": "Open",
      "counting": "Counting",
      "closed": "Closed",
      "reconciled": "Reconciled"
    },
    "cashMovementKind": {
      "float_in": "Float in",
      "float_out": "Float out",
      "drop": "Drop to safe",
      "paid_in": "Paid in",
      "paid_out": "Paid out",
      "no_sale": "No sale"
    },
    "depositStatus": {
      "draft": "Prepared",
      "banked": "Banked",
      "confirmed": "Confirmed by the bank"
    },
    "dayCloseStatus": {
      "draft": "Draft",
      "posted": "Posted",
      "reversed": "Reversed"
    },
    "dayCloseLineKind": {
      "revenue": "Revenue",
      "tax": "Tax",
      "service_charge": "Service charge",
      "tender": "Tender",
      "instrument_issue": "Instrument issued",
      "instrument_redeem": "Instrument redeemed",
      "tip": "Tips",
      "rounding": "Cash rounding",
      "cash_variance": "Cash over or short",
      "paid_in": "Paid in",
      "paid_out": "Paid out"
    },
    "dayCloseBlocker": {
      "check": "Open check",
      "session": "Open drawer",
      "sale": "Unsettled sale",
      "period": "Accounting period",
      "day": "Operating day"
    },
    "publicationStatus": {
      "draft": "Draft",
      "published": "Published",
      "withdrawn": "Withdrawn"
    },
    "availabilityState": {
      "available": "Available",
      "eighty_six": "86'd",
      "limited": "Limited"
    },
    "deviceStatus": {
      "pending": "Awaiting enrolment",
      "active": "Enrolled",
      "suspended": "Suspended",
      "revoked": "Revoked"
    },
    "partKind": {
      "price_set_version": "Price set version",
      "tax_pack": "Tax pack",
      "menu_version": "Menu version",
      "operator_roster": "Operator roster",
      "terminal_policy": "Terminal policy"
    },
    "syncBatchStatus": {
      "received": "Received",
      "applying": "Applying",
      "completed": "Completed",
      "failed": "Failed"
    },
    "conflictRule": {
      "queued_for_review": "Queued for review",
      "server_wins_config": "Server value kept (configuration)",
      "client_wins_completed": "Terminal value kept (completed act)"
    },
    "conflictRuleHint": {
      "queued_for_review": "Nobody has decided these yet. They are the reason this screen exists.",
      "server_wins_config": "The terminal held stale configuration; the server's value stands. Recorded so it can be explained, not because anything is owed.",
      "client_wins_completed": "The act was already complete on the terminal and the server accepted it. Recorded for the same reason."
    },
    "conflictStatus": {
      "open": "Open",
      "resolved": "Resolved",
      "dismissed": "Dismissed"
    },
    "ratificationStatus": {
      "pending": "Awaiting decision",
      "ratified": "Ratified",
      "refused": "Refused"
    },
    "offlinePolicy": {
      "permit_within_limit": "Permit within a limit",
      "defer_ratification": "Permit, then ratify",
      "refuse": "Refuse offline"
    },
    "offlinePolicyHint": {
      "permit_within_limit": "The terminal decides inside a ceiling and nobody reviews it afterwards. The ceiling is the whole control.",
      "defer_ratification": "The terminal decides and somebody ratifies later. A refusal triggers a compensating action; it is not an undo.",
      "refuse": "The terminal may not decide. The guest pays another way."
    },
    "anomalyStatus": {
      "open": "Open",
      "investigating": "Investigating",
      "resolved": "Resolved",
      "dismissed": "Dismissed"
    },
    "anomalyCode": {
      "void_rate": "Void rate",
      "discount_rate": "Discount rate",
      "refund_rate": "Refund rate",
      "no_sale_count": "No-sale count",
      "cash_variance": "Cash variance"
    },
    "contentCheck": {
      "referents": "Every part points at something published and hashed",
      "oneEach": "At most one part of each kind",
      "required": "Every part kind this surface requires is present",
      "crossChecks": "The owning module's own cross-checks"
    },
    "contentCheckHint": {
      "referents": "A set may only carry a price list, a tax pack or a menu that has itself been published, so the terminal can verify what it holds.",
      "oneEach": "Which of two price sets wins is not something a terminal should have to guess.",
      "required": "A point-of-sale set without prices, tax rules or a catalogue is a till that cannot sell.",
      "crossChecks": "The menu is checked against the price set it will be sold from — the check that catches an unpriced dish before service."
    },
    "menuCheck": {
      "no_price": "Every item has a price",
      "no_tax_class": "Every item is tax-classified",
      "unknown_item": "Every item exists and is sellable",
      "empty_section": "No empty sections",
      "empty_modifier_group": "No empty modifier groups",
      "insufficient_modifiers": "Every mandatory group has enough choices"
    },
    "outlets": {
      "title": "Outlets",
      "description": "Where trading happens. An outlet's tax channel, price set, warehouse and rounding decide what every sale under it costs.",
      "tableTitle": "Outlets",
      "caption": "Outlets with their tax channel, currency, warehouse, price set and cash rounding.",
      "detailDescription": "Configuration, terminals and the offline policy this outlet's tills answer to.",
      "factsTitle": "Configuration",
      "create": "New outlet",
      "dialogDescription": "Four of these fields decide what every future sale costs. The hints say which and why.",
      "searchLabel": "Search",
      "searchPlaceholder": "Code or name",
      "chooseCompany": "Choose a legal entity to see its outlets. Every outlet belongs to one, and the list is scoped to the legal entities you may see.",
      "empty": "No outlets yet. Create one to give a terminal somewhere to trade from.",
      "loadFailed": "The outlets could not be loaded.",
      "saved": "Outlet saved",
      "saveFailed": "The outlet could not be saved.",
      "noWarehouse": "none",
      "noPriceSet": "none",
      "noWarehouseWarning": "This outlet has no warehouse, so a settled sale moves no stock. That is right for a service-only counter and a silent shrinkage problem anywhere else.",
      "locationHint": "An outlet is a place: the location resolves its tax jurisdiction and attaches its operating day.",
      "channelHint": "The Maldives pack makes the pos channel tax-INCLUSIVE. An outlet on the legal entity default prices the same figure exclusively and is out on every line it sells.",
      "warehouseHint": "What a settled sale depletes. Leave empty only for a counter that sells no stock.",
      "roundingHint": "Zero means no rounding. The server rounds; this form never does."
    },
    "terminals": {
      "title": "Terminals",
      "description": "Till positions under this outlet, and the device bound to each.",
      "caption": "Terminals with their offline policy, content age limit and enrolled device.",
      "create": "New terminal",
      "edit": "Edit terminal",
      "dialogDescription": "The offline pair decides whether this till may trade without the server, and for how long.",
      "empty": "No terminals yet. A terminal is a till position; a device is the tablet on the counter.",
      "loadFailed": "The terminals could not be loaded.",
      "saved": "Terminal saved",
      "saveFailed": "The terminal could not be saved.",
      "offlineEnabled": "May trade offline",
      "offlineHint": "When this is off, a terminal that cannot reach the server shows the blocking screen instead of selling.",
      "contentMaxAge": "Content age limit (hours)",
      "contentMaxAgeHint": "Past this age the cached content is expired and the terminal stops trading. It is how long the outlet may sell at yesterday's prices.",
      "cashAccountHint": "The drawer's own GL account. Left empty it falls back to the legal entity's cash-on-hand account in point-of-sale settings.",
      "device": "Device",
      "noDevice": "not enrolled",
      "lastSeen": "Last seen",
      "highWater": "Sync high-water",
      "fleetNote": "A terminal marked offline-capable whose device has not been seen for days is selling from expired content."
    },
    "settings": {
      "title": "Point-of-sale settings",
      "description": "The accounts a day close posts to and the thresholds an operator's day is measured against.",
      "accountsTitle": "Accounts",
      "accountsDescription": "Each of these is a posting that fails without it. A day close refuses by name.",
      "thresholdsTitle": "Windows and thresholds",
      "thresholdsDescription": "Configuration lives here; findings live on the anomaly board. Somebody reading the board must not be able to move the line they are judged against.",
      "noLegalEntity": "No legal entity is available to you, so there are no point-of-sale settings to show. Ask an administrator for access to one.",
      "chooseCompany": "Choose a legal entity. Point-of-sale settings are per legal entity, because the accounts are.",
      "loadFailed": "The settings could not be loaded.",
      "saved": "Settings saved",
      "saveFailed": "The settings could not be saved.",
      "missingAccounts": "{count} account(s) the day close needs are still unset. Posting will refuse by name until they are.",
      "rowVersionNote": "Saving carries the row version, so two people editing at once produce a conflict rather than a silent overwrite.",
      "cashOnHand": "Cash on hand",
      "cashOnHandHint": "Where drawer cash sits between the till and the bank.",
      "cashOverShort": "Cash over and short",
      "cashOverShortHint": "Where an accepted count variance posts.",
      "defaultRevenue": "Default revenue",
      "defaultRevenueHint": "Used where a revenue centre resolves no account of its own.",
      "cardClearing": "Card clearing",
      "giftCardLiability": "Gift card liability",
      "storeCreditLiability": "Store credit liability",
      "customerDepositLiability": "Customer deposit liability",
      "tipPayable": "Tips payable",
      "cashRoundingAccount": "Cash rounding",
      "defaultRounding": "Default cash rounding increment",
      "defaultRoundingHint": "The outlet may override it. Zero means no rounding.",
      "voidWindow": "Void window (minutes)",
      "voidWindowHint": "How long after settlement a sale may still be voided. Past it, the refusal is ERR_POS_VOID_WINDOW_ELAPSED.",
      "voidRate": "Void rate threshold (%)",
      "discountRate": "Discount rate threshold (%)",
      "refundRate": "Refund rate threshold (%)",
      "noSaleCount": "No-sale count threshold"
    },
    "tenderTypes": {
      "title": "Tender types",
      "description": "How a guest may pay, and where each kind clears.",
      "caption": "Tender types with their kind, clearing account and surcharge.",
      "create": "New tender type",
      "edit": "Edit tender type",
      "dialogDescription": "The clearing account is the field a day close fails without.",
      "empty": "No tender types yet. A till with none cannot take payment.",
      "saved": "Tender type saved",
      "saveFailed": "The tender type could not be saved.",
      "clearingAccount": "Clearing account",
      "clearingAccountHint": "Where this tender clears at day close. Cash settles into the drawer; every other kind needs one.",
      "noClearingAccount": "not set",
      "clearingNote": "A tender type with no clearing account refuses the whole day close, at 23:00, with the takings already in the drawer.",
      "clearingWarning": "This kind clears to an account rather than into the drawer. Without one, the day close refuses with ERR_POS_TENDER_ACCOUNT_UNSET.",
      "surcharge": "Surcharge (%)",
      "surchargeHint": "Applied on top of the tendered amount, as a line the guest can see.",
      "opensDrawer": "Opens the cash drawer",
      "allowsChange": "Change may be given",
      "allowsPartial": "May pay part of a sale",
      "allowsRefund": "May be refunded to"
    },
    "denominations": {
      "title": "Cash denominations",
      "description": "The notes and coins a blind count sheet is built from.",
      "caption": "Cash denominations with their face value, kind and sheet order.",
      "faceValue": "Face value",
      "sortOrder": "Sheet order",
      "add": "Add a denomination",
      "none": "No denominations configured.",
      "emptyWarning": "No denominations are configured, so a count sheet is a free-text box — and a free-text box is not a count.",
      "note": "A counter declares nineteen fifties, not nine hundred and fifty. The first is checkable against the drawer.",
      "loadFailed": "The denominations could not be loaded.",
      "saved": "Denominations saved",
      "saveFailed": "The denominations could not be saved."
    },
    "policies": {
      "title": "Offline authorisation policy",
      "description": "What a terminal may decide when it cannot ask.",
      "caption": "Offline policies with their limits and effective date.",
      "control": "Control",
      "policy": "Policy",
      "limitAmount": "Amount limit",
      "limitPercent": "Percent limit",
      "limitCount": "Count limit",
      "effectiveFrom": "Effective from",
      "effectiveFromHint": "Choose the date this set starts. Saving one that starts today supersedes the running set mid-shift, on terminals that may be offline holding the previous one.",
      "appliesFromBelow": "from the date below",
      "notConfigured": "not configured",
      "unconfiguredMeansRefuse": "A control with no row resolves to refuse. An unconfigured control offline is a control nobody decided about, and the safe reading of that is \"not offline\".",
      "absolute": "absolute",
      "absoluteLocked": "absolute — cannot be made overridable here",
      "bindingNote": "A row for this binding overrides the company-wide default; narrower wins.",
      "reason": "Reason",
      "edit": "Change the policy",
      "noPermission": "You do not hold device.policy.manage, so the offline policy is not shown here.",
      "loadFailed": "The offline policies could not be loaded.",
      "saved": "Offline policy saved",
      "saveFailed": "The offline policy could not be saved."
    },
    "devices": {
      "title": "Device fleet",
      "description": "Every enrolled device, what content it holds and when it was last heard from.",
      "tableTitle": "Devices",
      "caption": "Devices with their status, held and published content versions, and last contact.",
      "detailDescription": "Identity, trading state, content assignments and sync history.",
      "identityTitle": "Identity",
      "tradingTitle": "May this device trade?",
      "assignmentsTitle": "Content assignments",
      "assignmentsCaption": "Content sets assigned to this device, with the version it holds and the version published.",
      "assignmentsEmpty": "No content is assigned to this device, so it may not trade.",
      "batchesTitle": "Sync history",
      "batchesCaption": "Sync batches this device has sent, with what was applied, replayed, conflicted and failed.",
      "batchesEmpty": "This device has not synced yet.",
      "searchLabel": "Search",
      "searchPlaceholder": "Code or name",
      "empty": "No devices yet. Create one, then mint an enrolment code for it.",
      "loadFailed": "The devices could not be loaded.",
      "legend": "Behind means the device has not fetched the published version yet. A hash mismatch is worse: it holds a payload that is not the one that hash describes.",
      "surface": "Surface",
      "binding": "Bound to",
      "held": "Held",
      "published": "Published",
      "heldHash": "Held hash",
      "contentState": "Content",
      "reportedAt": "Reported",
      "current": "Current",
      "stale": "Stale",
      "hashMismatch": "Hash mismatch",
      "noContent": "none assigned",
      "lastSeen": "Last seen",
      "lastSync": "Last sync",
      "neverSeen": "never",
      "queueDepth": "Queued mutations",
      "hasActiveVersion": "Has an active content version",
      "hashVerified": "Hash verified",
      "validUntil": "Content valid until",
      "contentMaxAge": "Content age limit (hours)",
      "mayTrade": "This device may trade.",
      "mayNotTrade": "This device may not trade.",
      "installationId": "Installation id",
      "attested": "Attested platform",
      "mint": "Mint enrolment code",
      "mintFailed": "The enrolment code could not be minted.",
      "enrolTitle": "Enrolment code for {code}",
      "enrolDescription": "A one-time code the device presents once, to obtain its own secret.",
      "enrolOnceWarning": "The code is shown once and is never retrievable again. If it is lost, mint another — which invalidates this one.",
      "enrolShownOnce": "This is the only time this code is shown. Key it into the device now.",
      "enrolExpires": "Expires {at}",
      "suspend": "Suspend",
      "suspended": "Device suspended",
      "revoke": "Revoke",
      "revoked": "Device revoked",
      "revokeTitle": "Revoke this device",
      "revokeDescription": "Revoking ends the binding. It is what you do when a tablet leaves the building.",
      "revokeReason": "Reason",
      "revokedAt": "Revoked",
      "actionFailed": "The device could not be updated.",
      "create": "New device",
      "createDescription": "Register a device, then mint the one-time code it presents to enrol itself.",
      "createPendingNote": "A new device is created pending: it can do nothing at all until an enrolment code has been minted and keyed into it. Minting opens as soon as this is saved.",
      "created": "Device registered",
      "createFailed": "The device could not be registered.",
      "companyPlaceholder": "Choose a legal entity",
      "outletPlaceholder": "Choose an outlet",
      "terminalPlaceholder": "Choose a terminal",
      "codeHint": "Unique within the legal entity. Stored in upper case.",
      "surfaceHint": "The point-of-sale back office registers point-of-sale devices. Housekeeping and field-service devices are registered from their own modules.",
      "bindingHint": "What this device is bound to. A terminal is one till position; an outlet covers the whole floor.",
      "noTerminals": "This outlet has no terminals yet. Open one on the outlet page, or bind the device to the outlet instead."
    },
    "roster": {
      "title": "Operator roster for {code}",
      "description": "Who this terminal may sign in while it cannot reach the server, and until when.",
      "scopeNote": "A roster is published for one device. The verifier it derives works on this terminal and on no other.",
      "deviceScope": "device {code}",
      "operators": "Operators",
      "searchPlaceholder": "Name or email",
      "usersEmpty": "No active user matches that search.",
      "validHours": "Valid for (hours)",
      "validHoursHint": "Between 1 and 168. After that the roster expires and the terminal can no longer sign anybody in offline.",
      "credentialWarning": "Publishing hands this terminal the means to check these operators' PINs with no server. Include only the people who work on it.",
      "publish": "Publish operator roster",
      "published": "Operator roster published",
      "publishedNote": "Published. The PIN verifiers went to the device alone — they are not in this response and cannot be retrieved.",
      "publishFailed": "The operator roster could not be published.",
      "setPinsLink": "Set operator PINs",
      "rosterId": "Roster id",
      "versionNo": "Version",
      "contentHash": "Content hash",
      "validUntil": "Valid until",
      "entryCount": "Operators on it",
      "pinPartHint": "Pin this roster into a content set version as an operator_roster part, using the roster id above, then publish that version for the device to fetch it.",
      "operator": "Operator",
      "supervisor": "May authorise overrides",
      "entriesCaption": "Operators on the published roster, whether each may authorise an override, and how many permissions each carries.",
      "entriesEmpty": "The published roster carries no operators."
    },
    "pins": {
      "title": "Operator PINs",
      "description": "Set and clear the PIN a person types at a till, including one that is offline.",
      "tableTitle": "Users",
      "caption": "Tenant users, with the actions that set or clear a point-of-sale PIN.",
      "noStateNote": "Whether somebody already has a PIN is not readable here: the API returns nothing about a credential. Publishing an operator roster names anyone who is missing one.",
      "searchPlaceholder": "Name or email",
      "empty": "No active user matches that search.",
      "loadFailed": "The users could not be loaded.",
      "setAction": "Set PIN",
      "clearAction": "Clear PIN",
      "setTitle": "Set a PIN for {name}",
      "setDescription": "Typed twice, sent once, and never shown again.",
      "pinLabel": "New PIN",
      "pinHint": "Between {min} and {max} digits. Digits only.",
      "confirmLabel": "Confirm PIN",
      "credentialWarning": "Have the operator key this in themselves wherever you can. A PIN somebody else chose is a PIN somebody else knows.",
      "digitsOnly": "A PIN is digits only.",
      "tooShort": "A PIN is at least {min} digits.",
      "tooLong": "A PIN is at most {max} digits.",
      "mismatch": "The two PINs do not match.",
      "set": "PIN set",
      "setFailed": "The PIN could not be set.",
      "clearTitle": "Clear the PIN for {name}",
      "clearDescription": "The PIN is removed, not replaced with another.",
      "clearWarning": "This operator will not be able to sign in at a terminal until a new PIN is set.",
      "cleared": "PIN cleared",
      "clearFailed": "The PIN could not be cleared."
    },
    "contentSets": {
      "title": "Content sets",
      "description": "The named, versioned, hashed bundle a terminal is allowed to trade from.",
      "tableTitle": "Content sets",
      "caption": "Content sets with their surface and binding.",
      "detailTitle": "Content set #{id}",
      "detailDescription": "Versions, parts, the publication checks and the fleet that holds them.",
      "create": "New content set",
      "dialogDescription": "A set bundles a price set version, a tax pack, a menu version and a roster. The binding says who it is for.",
      "empty": "No content sets yet. A terminal with none may not trade.",
      "loadFailed": "The content sets could not be loaded.",
      "saved": "Content set saved",
      "saveFailed": "The content set could not be saved.",
      "actionFailed": "The action could not be completed.",
      "binding": "Binding",
      "bindingCompany": "Whole legal entity",
      "bindingOutlet": "One outlet",
      "bindingTerminal": "One terminal",
      "bindingId": "Binding id",
      "bindingHint": "A set bound to an outlet or a terminal overrides the company-wide one. Narrower wins.",
      "set": "Set",
      "versionsTitle": "Versions",
      "version": "Version",
      "versionLabel": "v{no} — {status}",
      "newVersion": "New draft version",
      "versionCreated": "Draft version created",
      "noVersions": "This set has no versions yet. Create a draft, put parts in it, then publish.",
      "hash": "Content hash",
      "noHashYet": "not yet hashed",
      "validity": "Valid",
      "publishedAt": "Published",
      "partsTitle": "Parts",
      "partsCaption": "The parts in this version, with the version and hash of each referent.",
      "partsEmpty": "This version has no parts. A content set with no parts is not a content set.",
      "partsSaved": "Parts saved",
      "partKind": "Part kind",
      "addPart": "Add part",
      "refId": "Reference",
      "refVersion": "Referent version",
      "refHash": "Referent hash",
      "seq": "#",
      "checksTitle": "Publication checks",
      "checksDescription": "Run without publishing, so every problem is fixed in one pass.",
      "checkOk": "All four checks pass. This version may be published.",
      "checkNotOk": "This version cannot be published yet. Every finding is listed below.",
      "checkFailed": "The publication checks could not be run.",
      "crossChecksSkipped": "Not run: the cross-checks only run once the structural checks pass.",
      "missingKinds": "Required part kinds that are missing:",
      "findingsCaption": "Every publication finding, with the checker that raised it.",
      "checker": "Checker",
      "findingCode": "Code",
      "findingRef": "Reference",
      "noFindings": "No findings.",
      "publishTitle": "Publish",
      "publish": "Publish",
      "published": "Version published",
      "publishNote": "Publishing stamps the content hash. A terminal verifies that hash before it trades, and refuses if it does not match.",
      "publishHashNote": "The hash is computed at publish from the referents' own versions, not from what a client sent.",
      "validFrom": "Valid from",
      "validUntil": "Valid until",
      "validUntilHint": "After this instant the content is expired and terminals holding it stop trading.",
      "withdraw": "Withdraw",
      "withdrawn": "Version withdrawn",
      "matrixTitle": "Assignment matrix",
      "matrixDescription": "Which device holds which version of this set.",
      "matrixCaption": "Devices assigned this set, with the version each holds.",
      "matrixEmpty": "No device has been assigned this set."
    },
    "menus": {
      "title": "Menus",
      "description": "A catalogue with a day part. Breakfast and dinner are two menus, not two versions of one.",
      "tableTitle": "Menus",
      "caption": "Menus with the version currently published and its effectivity.",
      "create": "New menu",
      "dialogDescription": "A menu belongs to one outlet, because the price set, the tax channel and the warehouse are the outlet's.",
      "chooseOutlet": "Choose an outlet to see its menus.",
      "empty": "No menus yet for this outlet.",
      "loadFailed": "The menus could not be loaded.",
      "saved": "Menu saved",
      "saveFailed": "The menu could not be saved.",
      "actionFailed": "The action could not be completed.",
      "dayPart": "Day part",
      "dayPartHint": "Which part of the operating day this menu is for, if any.",
      "channelHint": "Leave empty to use the outlet's channel.",
      "publishedVersion": "Published version",
      "noPublishedVersion": "none",
      "draftOnly": "draft only",
      "versionTitle": "Menu version {no}",
      "versionDescription": "Sections, items, modifier groups, and the publication gate in full.",
      "itemCount": "Items",
      "gateTitle": "Publication gate",
      "gateDescription": "Run without publishing. Every offender is listed, so a menu is fixed in one pass rather than one refusal at a time.",
      "gateReady": "This version may be published.",
      "gateNotReady": "This version cannot be published: {count} problem(s) below.",
      "checkFailed": "The publication gate could not be run.",
      "checkPassed": "Nothing to fix.",
      "checkOffenders": "{count} to fix",
      "unpricedHeading": "{count} item(s) have no price",
      "unpricedExplanation": "An unpriced item is a button on the till that does nothing. Every one is listed, because being told about one of eleven is ten more round trips than there is time for before service.",
      "unpricedCaption": "Menu items with no resolvable price.",
      "offendersCaption": "Every publication-gate finding for this version.",
      "noOffenders": "No findings.",
      "check": "Check",
      "section": "Section",
      "menuItem": "Menu item",
      "itemId": "Item",
      "group": "Group",
      "publish": "Publish",
      "published": "Menu version published",
      "withdraw": "Withdraw",
      "withdrawn": "Menu version withdrawn",
      "contentTitle": "Sections and items",
      "sectionCaption": "Items in {name}.",
      "sectionsEmpty": "This version has no sections yet.",
      "seq": "#",
      "displayName": "Shown as",
      "qtyPerPress": "Qty per press",
      "flags": "Flags",
      "modifierGroups": "Modifier groups",
      "ageCheck": "age {age}+",
      "serial": "serial",
      "unavailable": "unavailable"
    },
    "availability": {
      "title": "86 board",
      "description": "What the kitchen has run out of, and when it comes back.",
      "tableTitle": "Availability",
      "caption": "Item availability with its remaining quantity, reason and window.",
      "chooseOutlet": "Choose an outlet to see its 86 board.",
      "empty": "Nothing is 86'd or limited at this outlet.",
      "loadFailed": "The 86 board could not be loaded.",
      "set": "Set availability",
      "dialogDescription": "86 means the kitchen has run out. A window is when the item comes back on its own.",
      "saved": "Availability saved",
      "saveFailed": "The availability could not be saved.",
      "restore": "Restore",
      "restored": "Item restored to available",
      "remaining": "Remaining",
      "reason": "Reason",
      "window": "Window",
      "until": "Comes back at",
      "untilHint": "Leave empty and the item stays off until somebody turns it back on.",
      "untilRestored": "until restored by hand",
      "openEndedWarning": "{count} item(s) are 86'd with no window, so they stay off until somebody turns them back on.",
      "untilTime": "Time"
    },
    "sales": {
      "title": "POS sales",
      "description": "Every sale and refund, with the pricing and the stock movement behind it.",
      "tableTitle": "Sales",
      "caption": "POS sales with their net, tax and gross totals as the server computed them.",
      "detailDescription": "The header, the lines, the price waterfall and the depletion run.",
      "headerTitle": "Sale",
      "totalsTitle": "Totals",
      "totalsAreServerFigures": "Every figure here was computed by the server inside the posting transaction. This screen adds nothing up.",
      "noLegalEntity": "No legal entity is available to you, so there are no sales to show. Ask an administrator for access to one.",
      "chooseCompany": "Choose a legal entity to see its sales.",
      "empty": "No sales match these filters.",
      "loadFailed": "The sales could not be loaded.",
      "searchLabel": "Search",
      "searchPlaceholder": "Sale or receipt number",
      "unclosedOnly": "Only sales not yet inside a posted day close",
      "saleNo": "Sale",
      "receiptNo": "Receipt",
      "operator": "Operator",
      "device": "Device",
      "localSeq": "local sequence {seq}",
      "unnumbered": "Sale #{id}",
      "channelMode": "Channel",
      "priceBasis": "Price basis",
      "superseded": "Superseded set",
      "currentPricing": "current",
      "supersededExplanation": "This sale was priced against a price set that has since been replaced. It is not wrong — it is explainable, and this is the explanation.",
      "voidReason": "Void reason",
      "voidedLine": "voided",
      "net": "Net",
      "tax": "Tax",
      "gross": "Gross",
      "discount": "Discount",
      "serviceCharge": "Service charge",
      "tip": "Tip",
      "rounding": "Rounding",
      "tendered": "Tendered",
      "change": "Change",
      "pricing": "Pricing",
      "dayCloseLink": "Day close",
      "sessionLink": "Cash session",
      "linesTab": "Lines",
      "pricingTab": "Price waterfall",
      "depletionTab": "Stock depletion",
      "linesCaption": "Sale lines with their server-computed amounts.",
      "linesEmpty": "This sale has no lines.",
      "lineNo": "#",
      "lineGross": "Gross",
      "quantity": "Qty",
      "unitPrice": "Unit price",
      "taxCode": "Tax code",
      "priceSource": "Price source",
      "discountsTitle": "Discounts",
      "discountsCaption": "Discounts applied to this sale.",
      "percent": "Percent",
      "amount": "Amount",
      "reason": "Reason",
      "authorisedBy": "Authorised by",
      "waterfallNote": "This is a read of the explanation the pricing engine persisted when the sale was priced — not a second resolution. Re-resolving today would answer a different question.",
      "waterfallFailed": "The price waterfall could not be loaded.",
      "waterfallEmpty": "No pricing explanation was recorded for this sale.",
      "waterfallLine": "Line {no} — item {item}",
      "listPrice": "List price",
      "winner": "Winning rule",
      "marginOutcome": "Margin",
      "resolvedAt": "Resolved at",
      "considerationsCaption": "What was considered when pricing line {no}.",
      "seq": "#",
      "source": "Source",
      "outcome": "Outcome",
      "depletionFailed": "The depletion run could not be loaded.",
      "depletionCaption": "What each sale line took off the shelf.",
      "depletionEmpty": "This sale depleted nothing.",
      "depletionRun": "Run",
      "depletionValue": "Depleted value",
      "unresolvedLines": "Unresolved lines",
      "journal": "Journal",
      "resolution": "Resolution",
      "theoretical": "Theoretical",
      "actual": "Actual",
      "shortfallsNote": "{count} line(s) could not be fully depleted. The sale completed; the stock did not cover it.",
      "shortfallsCaption": "Lines whose depletion fell short.",
      "required": "Required",
      "shortfall": "Short by"
    },
    "sessions": {
      "title": "Cash sessions",
      "description": "Drawers, their counts and the variances somebody accepted.",
      "boardTitle": "Sessions",
      "caption": "Cash sessions with their float, open and close times.",
      "detailDescription": "Movements, the count sheet and — once closed — the variance.",
      "headerTitle": "Session",
      "balancesTitle": "Balances",
      "chooseOutlet": "Choose an outlet to see its drawers.",
      "empty": "No cash sessions match these filters.",
      "loadFailed": "The cash sessions could not be loaded.",
      "sessionNo": "Session",
      "unnumbered": "Session #{id}",
      "operator": "Operator",
      "openingFloat": "Opening float",
      "openedAt": "Opened",
      "closedAt": "Closed",
      "countedBy": "Counted by",
      "witnessedBy": "Witnessed by",
      "countedBalance": "Counted",
      "expectedBalance": "Expected",
      "variance": "Variance",
      "varianceReason": "Variance reason",
      "varianceIsServerComputed": "The variance is the server's own figure. This screen never subtracts one balance from another.",
      "blindNote": "The expected balance is not in the payload while a session is open or counting. That is the blind close, and it is enforced by the server rather than hidden here.",
      "blindUntilCounted": "blind until counted",
      "blindExplanation": "The expected balance and the variance appear once the count has been submitted. Until then the server does not send them at all — a blind count is only blind if the number is genuinely absent.",
      "varianceQueueTitle": "Variance queue",
      "varianceQueueDescription": "Counts submitted but not yet accepted, and accepted differences with their attribution.",
      "varianceQueueCaption": "Sessions awaiting acceptance, and closed sessions carrying a variance reason.",
      "varianceQueueEmpty": "Nothing is waiting. Every count has been accepted and no closed session carries a variance reason.",
      "movementsTitle": "Movements",
      "movementsCaption": "Drops, paid in, paid out and no-sales for this session.",
      "movementsEmpty": "No movements were recorded on this drawer.",
      "seq": "#",
      "amount": "Amount",
      "reason": "Reason",
      "occurredAt": "At"
    },
    "count": {
      "title": "Count sheet",
      "description": "What the counter declared, denomination by denomination.",
      "caption": "The count sheet as submitted.",
      "faceValue": "Face value",
      "unitCount": "Count",
      "lineTotal": "Line total",
      "empty": "No count has been submitted for this session.",
      "readOnly": "This session is closed, so the sheet is evidence rather than a form. Re-keying a count after the variance was accepted would make the blind count worth nothing.",
      "noTotalHere": "No total is shown here on purpose: the counted balance is the server's own figure, and a second figure arrived at differently is the disagreement a count sheet exists to eliminate."
    },
    "deposits": {
      "title": "Deposits",
      "description": "What happened to the cash a session counted.",
      "caption": "Deposits with the sessions they bank and their bank reference.",
      "empty": "No deposits have been prepared for this outlet.",
      "depositNo": "Deposit",
      "amount": "Amount",
      "sessions": "Sessions",
      "bankReference": "Bank reference",
      "bankReferenceHint": "The slip or transfer reference. Bank reconciliation matches on it.",
      "journal": "Journal",
      "bank": "Bank it",
      "bankTitle": "Bank this deposit",
      "bankDescription": "This posts a bank movement. Bank reconciliation confirms it afterwards.",
      "banked": "Deposit banked",
      "bankFailed": "The deposit could not be banked."
    },
    "dayClose": {
      "boardTitle": "Day close",
      "boardDescription": "Every outlet's day, its blockers first.",
      "boardEmpty": "No outlets to close for this date.",
      "chooseCompany": "Choose a legal entity to see its day-close board.",
      "outletsTitle": "Outlets on {date}",
      "dateHint": "Leave empty for the current operating day.",
      "dayStatus": "Operating day",
      "unpostedSales": "Unposted sales",
      "unpostedGross": "Unposted gross",
      "postedClose": "Posted close",
      "blockersHeading": "{count} blocker(s) must be cleared before this day can close:",
      "blockersRecorded": "Blockers recorded at the time of this close:",
      "preview": "Preview the journal",
      "previewTitle": "The journal this close would post",
      "previewWritesNothing": "This preview writes no journal, no close row and nothing else. It is safe to run repeatedly while the floor clears.",
      "previewFailed": "The preview could not be computed.",
      "post": "Post the day",
      "posted": "Day closed and posted",
      "postFailed": "The day could not be closed.",
      "journalTitle": "The journal",
      "journalDescription": "The lines the close posted, exactly as the server built them.",
      "journalLink": "Journal #{id}",
      "serverFigures": "Every amount on this pack is the server's. Nothing on this screen is added up, because a client-side total that disagreed with the journal would be believed.",
      "doesNotBalance": "The debits and credits the server sent do not match. That is a server-side problem and it is shown rather than hidden.",
      "linesCaption": "The day-close journal lines with their accounts and dimensions.",
      "linesEmpty": "This close has no journal lines.",
      "seq": "#",
      "key": "Key",
      "account": "Account",
      "debit": "Debit",
      "credit": "Credit",
      "dimensions": "Dimensions",
      "totals": "Totals",
      "saleCount": "Sales",
      "voidCount": "Voids",
      "refundCount": "Refunds",
      "grossSales": "Gross sales",
      "discountTotal": "Discounts",
      "netRevenue": "Net revenue",
      "taxTotal": "Tax",
      "serviceChargeTotal": "Service charge",
      "tipTotal": "Tips",
      "roundingTotal": "Rounding",
      "cashVariance": "Cash over/short",
      "accountGross": "On account (gross)",
      "instrumentIssued": "Instruments issued",
      "instrumentRedeemed": "Instruments redeemed",
      "headerTitle": "Close",
      "detailDescription": "The posted close, its journal and the three-way reconciliation behind it.",
      "unnumbered": "Close #{id}",
      "closedAt": "Closed",
      "closedBy": "Closed by",
      "reopenedAt": "Reopened",
      "reopenReason": "Reopen reason",
      "reversalEntry": "Reversal journal",
      "reopenElsewhere": "Reopen on the operating-day board",
      "operatingDayBoard": "Operating-day board",
      "reconciliationTitle": "Three-way reconciliation",
      "reconciliationDescription": "Outlet totals against the journal against the sub-ledger.",
      "reconciliationFailed": "The reconciliation could not be loaded.",
      "threeWayNote": "The three sides are computed three different ways, which is what makes this evidence rather than an echo. The tax assertion ties the day back to the same tax lines the return is built from.",
      "tiesOut": "All assertions tie.",
      "doesNotTie": "{count} assertion(s) do not tie.",
      "assertionsCaption": "Reconciliation assertions with their expected and actual figures.",
      "assertion": "Assertion",
      "expected": "Expected",
      "actual": "Actual",
      "difference": "Difference",
      "passed": "Ties",
      "failed": "Does not tie",
      "assertionsEmpty": "No assertions were computed for this close.",
      "loadFailed": "The day close could not be loaded.",
      "pack": "Download day pack",
      "packFailed": "The day pack could not be downloaded."
    },
    "anomaly": {
      "title": "Operator anomalies",
      "description": "Void, discount and refund rates against the thresholds this legal entity set.",
      "operatorsTitle": "Operators",
      "operatorsDescription": "Worst first: the count of breached measures, not a name.",
      "operatorsCaption": "Operator day statistics with their rates and breached measures.",
      "operatorsEmpty": "No operator statistics for these filters.",
      "loadFailed": "The operator statistics could not be loaded.",
      "breachedOnly": "Only operators with a breach",
      "operator": "Operator",
      "sales": "Sales",
      "grossSales": "Gross",
      "voidRate": "Void %",
      "discountRate": "Discount %",
      "refundRate": "Refund %",
      "noSales": "No-sales",
      "cashVariance": "Cash variance",
      "breached": "Breached",
      "drillThrough": "Sales behind this",
      "thresholdsLink": "Thresholds",
      "exceptionsTitle": "Exception queue",
      "exceptionsDescription": "Breaches somebody has to look at, and what they found.",
      "exceptionsCaption": "Anomaly exceptions with their observed and threshold values.",
      "exceptionsEmpty": "No exceptions match these filters.",
      "code": "Measure",
      "observed": "Observed",
      "threshold": "Threshold",
      "resolution": "Resolution",
      "resolve": "Record a finding",
      "resolveTitle": "Record what you found",
      "resolveDescription": "An exception is closed by a finding, not by a click.",
      "resolved": "Exception resolved",
      "resolveFailed": "The exception could not be resolved.",
      "dismiss": "Dismiss instead of resolving",
      "dismissHint": "Dismissing records that the breach needed no action. It is still a finding, and the note is what makes it one."
    },
    "superseded": {
      "title": "Superseded pricing",
      "description": "Lines sold from a price set version that was no longer the published one on the day of sale.",
      "legend": "A terminal trading offline sells from the last content it downloaded. These are the lines that produced, with the price charged, the price then published, and the difference the server computed.",
      "tableTitle": "Lines",
      "caption": "Sale lines priced from a superseded price set version, with the price charged, the published price and the gross variance.",
      "companyPlaceholder": "Choose a legal entity",
      "outletPlaceholder": "Choose an outlet",
      "from": "From",
      "to": "To",
      "run": "Run report",
      "rangeInverted": "The end of the range is before its start.",
      "rangeRequired": "Choose an outlet and a date range first.",
      "chooseRange": "Choose an outlet and a date range, then run the report.",
      "empty": "No line in this range was priced from a superseded version.",
      "loadFailed": "The report could not be loaded.",
      "lineCount": "Lines: {count}",
      "saleNo": "Sale",
      "item": "Item",
      "priceSetVersion": "Price set version",
      "charged": "Charged",
      "current": "Published price",
      "variance": "Gross variance"
    },
    "conflicts": {
      "title": "Sync conflicts",
      "description": "Where a terminal and the server disagreed, and what was done about it.",
      "notApprovals": "This is not the approvals inbox. A conflict has an owner, not an approver: resolving one records what somebody found, not permission to proceed.",
      "empty": "No sync conflicts. Every mutation the fleet sent applied cleanly.",
      "groupCaption": "Conflicts under the {rule} rule.",
      "groupEmpty": "Nothing under this rule.",
      "loadFailed": "The sync conflicts could not be loaded.",
      "rule": "Rule",
      "device": "Device",
      "localSeq": "Local seq",
      "mutationKind": "Mutation",
      "field": "Field",
      "ageHours": "Age (h)",
      "owner": "Owner",
      "noOwner": "unassigned",
      "createdAt": "Raised",
      "inspect": "Inspect",
      "previewTitle": "Conflict detail",
      "previewDescription": "The two values, side by side, with neither emphasised.",
      "clientValue": "Terminal said",
      "serverValue": "Server holds",
      "resolution": "What was done",
      "resolve": "Record it",
      "resolved": "Conflict resolved",
      "resolveFailed": "The conflict could not be resolved.",
      "dismiss": "Dismiss instead of resolving",
      "dismissHint": "Dismissing records that the terminal's value needed no action. That is a finding too.",
      "readOnly": "This conflict has already been dealt with, or you do not hold device.conflict.resolve."
    },
    "ratifications": {
      "title": "Deferred authorisations",
      "description": "Acts a terminal permitted while it could not ask, awaiting a decision.",
      "tableTitle": "Awaiting ratification",
      "caption": "Deferred offline authorisations with their control, amount and deadline.",
      "empty": "Nothing is awaiting ratification.",
      "loadFailed": "The deferred authorisations could not be loaded.",
      "refusalIsNotAnUndo": "A refusal is not an undo. The act already happened; refusing triggers the control's own compensating action.",
      "overdueOnly": "Only those past their deadline",
      "control": "Control",
      "amount": "Amount",
      "reason": "Reason",
      "dueAt": "Due",
      "compensating": "Compensating document",
      "ratify": "Ratify",
      "ratified": "Authorisation ratified",
      "ratifyTitle": "Ratify this authorisation",
      "ratifyConsequence": "Ratifying records that the business stands behind what {control} permitted offline. Nothing else changes.",
      "refuse": "Refuse",
      "refused": "Authorisation refused",
      "refuseTitle": "Refuse this authorisation",
      "refuseConsequence": "Refusing triggers the compensating action {control} defines — for a void, the void is reversed and an exception is opened against the operator; for an account tender, the invoice is raised anyway, because the goods are gone.",
      "noteHint": "What you decided and why. It is the record somebody reads six months from now.",
      "decideFailed": "The decision could not be recorded."
    },
    "sync": {
      "batch": "Batch",
      "receivedAt": "Received",
      "mutations": "Sent",
      "applied": "Applied",
      "replayed": "Replayed",
      "conflicts": "Conflicts",
      "failed": "Failed",
      "clockSkew": "Clock skew (s)"
    },
    "assign": {
      "action": "Assign drawer",
      "title": "Assign a drawer",
      "description": "Open a drawer on a terminal for an operator, with a counted opening float.",
      "operator": "Assigned operator",
      "operatorHint": "Whoever is accountable for this drawer for the shift.",
      "openingFloat": "Opening float ({currency})",
      "openingFloatHint": "The cash counted into the drawer before trading starts.",
      "confirmedBy": "Confirmed by",
      "confirmedByHint": "The server records whoever is signed in as the supervisor who opened it.",
      "breakdownNote": "The float is stored as one figure. The denomination breakdown is recorded at the blind count, not at assignment — the open request carries no count lines.",
      "samePartyWarning": "The operator and the confirming supervisor are the same person. POS-F07-V02 wants the opening float confirmed by both.",
      "submit": "Assign drawer",
      "opened": "Drawer assigned",
      "failed": "The drawer could not be assigned."
    },
    "variance": {
      "action": "Review",
      "title": "Review this variance",
      "description": "Witness the count, explain any difference, and close the drawer.",
      "acceptedBy": "Accepted by",
      "blindNote": "The expected balance and the variance arrive with the closed session. While it is counting the server does not send them, so this screen cannot show you the difference before you accept it.",
      "witnessHint": "Must be someone other than whoever counted. The database refuses that pair.",
      "reasonHint": "Required whenever the difference is not zero; the server names the field if it is missing.",
      "authorisedBy": "Authorised by",
      "authorisedByHint": "A difference beyond the outlet's tolerance may need an authority-band override.",
      "note": "Note",
      "noteHint": "What the reason code cannot say. It is evidence, so write it for a reader a year from now.",
      "escalationNote": "A session has no \"under investigation\" state. Escalating a cash variance happens on the operator anomaly board, where it carries its own status.",
      "submit": "Accept and close",
      "accepted": "Drawer closed",
      "failed": "The drawer could not be closed."
    },
    "banking": {
      "action": "Prepare banking",
      "title": "Prepare a banking deposit",
      "description": "Assemble a deposit from the drawers whose cash it takes to the bank.",
      "bankAccount": "Bank account",
      "bankAccountHint": "An active bank account belonging to the outlet's own legal entity.",
      "witnessHint": "Must be someone other than whoever prepares it. The database refuses that pair.",
      "note": "Note",
      "caption": "Closed drawers, and how much of each one's cash this deposit takes.",
      "include": "Include",
      "includeSession": "Include {session} in this deposit",
      "allocation": "Amount taken",
      "allocationFor": "Amount taken from {session}",
      "total": "Deposit total",
      "noBankableSessions": "No drawer here is closed yet. Only a counted and closed drawer's cash may be banked.",
      "safeNote": "Reconcile Safe is not on this screen because there is no safe balance and no reconcile endpoint to read: POS-F07-V09's gate has nothing behind it yet.",
      "submit": "Prepare deposit",
      "prepared": "Deposit prepared",
      "failed": "The deposit could not be prepared."
    },
    "tableShape": {
      "square": "Square",
      "round": "Round",
      "rect": "Rectangular",
      "bar": "Bar"
    },
    "tableStatus": {
      "free": "Free",
      "seated": "Seated",
      "ordered": "Ordered",
      "printed": "Printed",
      "paid": "Paid",
      "dirty": "Needs clearing"
    },
    "floorPlan": {
      "title": "Floor plan",
      "description": "The outlet's sections, the tables in each, and the stations tickets route to.",
      "chooseOutlet": "Choose an outlet to see and edit its floor.",
      "loadFailed": "The floor plan could not be loaded.",
      "sectionsTitle": "Sections",
      "sectionsDescription": "How the room is divided for service. A check binds to a table inside one.",
      "sectionsCaption": "Floor sections with their code, name and display order.",
      "sectionsEmpty": "This outlet has no sections yet. A hospitality outlet needs at least one before a check can bind to a table.",
      "addSection": "Add section",
      "openSection": "Open",
      "sectionDialogDescription": "A code, a name and where it sits in the list.",
      "areaSaved": "Section added",
      "areaSaveFailed": "The section could not be added.",
      "seqNo": "Order",
      "seqNoHint": "Where it appears in the list. Lower comes first.",
      "tablesTitle": "Tables",
      "tablesDescription": "The tables in the chosen section, their seats and where they sit on the plan.",
      "tablesCaption": "Tables with their code, seats, position, shape and live status.",
      "tablesEmpty": "This section has no tables yet.",
      "editTables": "Edit tables",
      "addTable": "Add table",
      "tablesSaved": "Tables saved",
      "tablesSaveFailed": "The tables could not be saved.",
      "wholeSetNote": "Saving replaces this section's whole table set: a code you remove is removed from the floor, and a code you keep is updated in place.",
      "seats": "Seats",
      "gridX": "X",
      "gridY": "Y",
      "shape": "Shape",
      "statusFromFloor": "set by the floor",
      "statusNote": "A table's status moves as a check moves through it, and the till drives every step. Only clearing a table is offered here.",
      "clearTable": "Mark free",
      "tableCleared": "Table cleared",
      "tableClearFailed": "The table could not be cleared.",
      "stationsTitle": "Preparation stations",
      "stationsDescription": "Where a kitchen ticket is printed and timed.",
      "stationsCaption": "Stations with their code, display order and target preparation minutes.",
      "stationsEmpty": "This outlet has no stations yet. A menu item with no station routes nowhere.",
      "addStation": "Add station",
      "stationDialogDescription": "A code, a name and the minutes a ticket at this station is expected to take.",
      "stationSaved": "Station added",
      "stationSaveFailed": "The station could not be added.",
      "targetMinutes": "Target minutes",
      "targetMinutesHint": "How long a ticket at this station should take. A ticket past it escalates.",
      "routingNote": "Which station an item routes to is set on the item itself, in the menu version editor — there is no separate routing-rule table.",
      "assignServerNote": "Assign Server is not offered: a check's server is stamped from whoever opened it, and there is no endpoint that reassigns it or binds a server to a section for a shift."
    },
    "allergenSeverity": {
      "contains": "Contains",
      "may_contain": "May contain"
    },
    "menuEditor": {
      "sectionsTitle": "Sections",
      "sectionsDescription": "How the menu is grouped on the till. An item names one by code.",
      "sectionsCaption": "Menu sections with their code, name, order, revenue centre and colour.",
      "sectionsEmpty": "This version has no sections yet. An item cannot be added until one exists.",
      "addSection": "Add section",
      "saveSections": "Save sections",
      "sectionsSaved": "Sections saved",
      "sectionsSaveFailed": "The sections could not be saved.",
      "revenueCentre": "Revenue centre",
      "colour": "Colour",
      "wholeSetNote": "Each Save replaces that whole set for this version: a code left out is removed, a code kept is updated in place.",
      "groupsTitle": "Modifier groups",
      "groupsDescription": "The choices an item offers, and how many of them a guest must make.",
      "groupsEmpty": "This version has no modifier groups.",
      "addGroup": "Add group",
      "removeGroup": "Remove group",
      "saveGroups": "Save modifier groups",
      "groupsSaved": "Modifier groups saved",
      "groupsSaveFailed": "The modifier groups could not be saved.",
      "minSelect": "Minimum",
      "minSelectHint": "How many the guest must choose. Zero means the group is optional.",
      "maxSelect": "Maximum",
      "maxSelectHint": "Leave blank for no ceiling.",
      "addModifier": "Add modifier",
      "modifiersEmpty": "This group offers nothing yet.",
      "modifiersCaption": "The modifiers in group {group}.",
      "isDefault": "Default",
      "itemsTitle": "Items",
      "itemsDescription": "What the till sells, where it sits, where it is prepared and what it asks for.",
      "itemsCaption": "Menu items with their section, inventory item, station, course and flags.",
      "itemsEmpty": "This version sells nothing yet.",
      "addItem": "Add item",
      "saveItems": "Save items",
      "itemsSaved": "Items saved",
      "itemsSaveFailed": "The items could not be saved.",
      "item": "Inventory item",
      "station": "Station",
      "courseNo": "Course",
      "ageCheck": "Age check",
      "minimumAge": "Min age",
      "allergens": "Allergens",
      "sectionCodeNote": "An item names its section by code, so a new section and the items in it can be saved in one sitting — save the sections first.",
      "nutritionNote": "Nutrition is not declarable: there is no nutrition table, column or endpoint anywhere in the build, so §10.2.5's nutrition half has nothing to write to.",
      "publishedLocked": "This version is published, so its contents cannot be edited. Terminals hold a content hash of it; create a new draft version to change the menu."
    },
    "allergens": {
      "title": "Declare allergens",
      "description": "What this item contains, and what the kitchen cannot rule out.",
      "caption": "The allergen lines declared for this item.",
      "allergen": "Allergen",
      "severity": "Severity",
      "add": "Add line",
      "empty": "Nothing is declared for this item.",
      "loadFailed": "The allergen list could not be loaded.",
      "noVocabulary": "This legal entity has no allergen codes yet, so nothing can be declared. Seed the localisation pack or add codes first.",
      "withdrawTitle": "How this is stored",
      "wholeSetNote": "Saving replaces the whole declaration for this item. Removing a line withdraws that allergen; there is no per-line delete.",
      "nutritionNote": "Nutrition is not part of this declaration and has no home in the model — there is no nutrition field anywhere in the build.",
      "saved": "Allergens declared",
      "saveFailed": "The declaration could not be saved."
    },
    "customerDepositStatus": {
      "open": "Held",
      "applied": "Applied",
      "refunded": "Refunded",
      "expired": "Expired"
    },
    "employeePurchaseStatus": {
      "pending": "Owing",
      "deducted": "Deducted",
      "waived": "Waived",
      "cancelled": "Cancelled"
    },
    "retail": {
      "title": "Retail ledgers",
      "description": "Deposits the outlet holds for customers, and purchases staff owe payroll.",
      "chooseOutlet": "Choose an outlet to see the deposits it holds.",
      "depositsTitle": "Customer deposits",
      "depositsDescription": "Money taken against an order and not yet applied or given back.",
      "depositsCaption": "Customer deposits with what has been applied, refunded and what remains.",
      "depositsEmpty": "This outlet holds no deposits.",
      "depositsLoadFailed": "The deposits could not be loaded.",
      "depositStatusFilter": "Deposit status",
      "purchaseStatusFilter": "Purchase status",
      "customer": "Customer",
      "applied": "Applied",
      "refunded": "Refunded",
      "remaining": "Still held",
      "expiresOn": "Expires",
      "expiresOnHint": "After this date the job marks it expired. Leave blank for no expiry.",
      "liabilityNote": "A deposit is a liability from the moment it is taken: what is still held is what the outlet owes, and the age of a held row is the uncollected-goods control.",
      "applyNote": "Applying a deposit is done at the counter, against the sale it pays for. This screen refunds and does not settle somebody else's transaction from a list.",
      "takeDeposit": "Take deposit",
      "takeDescription": "Money received against an order the customer has not collected.",
      "amountIn": "Amount ({currency})",
      "depositTaken": "Deposit taken",
      "depositTakeFailed": "The deposit could not be taken.",
      "customerPermissionNote": "You cannot read the customer list, so there is nobody to pick. Ask for ar.customer.read.",
      "refund": "Refund",
      "refundTitle": "Refund this deposit",
      "refundDescription": "Give held money back. The liability is released by what you refund.",
      "refundAmountHint": "Defaults to everything still held. A smaller amount refunds part of it.",
      "depositRefunded": "Deposit refunded",
      "depositRefundFailed": "The deposit could not be refunded.",
      "purchasesTitle": "Employee purchases",
      "purchasesDescription": "Staff purchases recorded against a sale, for payroll to deduct.",
      "purchasesCaption": "Employee purchases with the sale they came from and the payroll run that deducted them.",
      "purchasesEmpty": "No employee purchases are recorded for this legal entity.",
      "purchaseNote": "An employee purchase is recorded at the till against a settled sale, so there is no create here — the sale would have to be invented with it.",
      "employee": "Employee",
      "sale": "Sale",
      "payrollRun": "Payroll run"
    },
    "queue": {
      "sync_conflict": "Device sync conflicts"
    },
    "sync_conflict": {
      "server_wins_config": "The server's configuration replaced a different value on the device.",
      "client_wins_completed": "A completed action on the device was kept over a conflicting server change.",
      "queued_for_review": "The device change conflicts with the server and awaits review."
    }
  },
  "pms": {
    "filtersTitle": "Filters",
    "routeTitles": {
      "properties": "Properties",
      "property": "Property",
      "settings": "Property-management settings",
      "ratePlans": "Rate plans",
      "ratePlan": "Rate plan",
      "restrictions": "Restriction calendar",
      "availability": "Availability",
      "reservations": "Reservations",
      "reservation": "Reservation",
      "groupBlocks": "Group blocks",
      "groupBlock": "Group block",
      "guests": "Guests",
      "guest": "Guest"
    },
    "fields": {
      "adults": "Adults",
      "advanceLimits": "Advance days",
      "arrival": "Arrival",
      "arrivalFrom": "Arriving from",
      "arrivalTo": "Arriving to",
      "attritionPercent": "Attrition %",
      "available": "Available",
      "baseOccupancy": "Base occupancy",
      "blockNo": "Block",
      "cancellationCharge": "Cancellation charge",
      "cancellationPolicy": "Cancellation policy",
      "channelDefault": "Legal entity default",
      "channels": "Channels",
      "chargeKind": "Charge",
      "checkInTime": "Check-in time",
      "checkOutTime": "Check-out time",
      "checkTimes": "Check-in / out",
      "children": "Children",
      "cleanDeparture": "Departure credit",
      "cleanStayover": "Stayover credit",
      "code": "Code",
      "commissionable": "Commissionable",
      "company": "Legal Entity",
      "costCenter": "Cost centre",
      "currency": "Currency",
      "cutoffApplied": "Cut-off applied",
      "cutoffDays": "Cut-off days",
      "dateOfBirth": "Date of birth",
      "departure": "Departure",
      "document": "Travel document",
      "documentCountry": "Issuing country",
      "documentExpires": "Document expires",
      "documentKind": "Document type",
      "documentNumber": "Document number",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "effectivity": "Effective",
      "familyName": "Family name",
      "floor": "Floor",
      "from": "From",
      "givenName": "Given name",
      "gross": "Gross",
      "guarantee": "Guarantee",
      "guaranteeReference": "Guarantee reference",
      "guest": "Guest",
      "guests": "Guests",
      "heldUntil": "Held until",
      "hoursBefore": "Hours before arrival",
      "housekeeping": "Housekeeping",
      "item": "Sells as item",
      "itemClass": "Accommodation item class",
      "kind": "Kind",
      "location": "Location",
      "maxAdults": "Max adults",
      "maxAdvance": "Max advance days",
      "maxChildren": "Max children",
      "maxNights": "Max nights",
      "maxOccupancy": "Max occupancy",
      "minAdvance": "Min advance days",
      "minNights": "Min nights",
      "nationality": "Nationality",
      "net": "Net",
      "nights": "Nights",
      "note": "Note",
      "notes": "Notes",
      "occupancy": "Occupancy",
      "offerExpires": "Offer expires",
      "openEnded": "open-ended",
      "outcome": "Outcome",
      "overbooking": "Overbooking rooms",
      "package": "Package",
      "policy": "Policy",
      "posted": "Posted",
      "priceBasis": "Price basis",
      "priority": "Priority",
      "profitCenter": "Profit centre",
      "property": "Property",
      "rateGross": "Rate gross",
      "ratePlan": "Rate plan",
      "reason": "Reason",
      "reservationNo": "Reservation",
      "restricted": "Restricted",
      "revenueAccount": "Revenue account",
      "revenueCenter": "Revenue centre",
      "roomNumber": "Room",
      "roomType": "Room type",
      "rooms": "Rooms",
      "scope": "Scope",
      "section": "Housekeeping section",
      "segment": "Segment",
      "segments": "Segments",
      "sortOrder": "Sort order",
      "stay": "Stay",
      "stayDate": "Stay date",
      "stayLimits": "Nights",
      "tax": "Tax",
      "taxChannel": "Tax channel",
      "to": "To",
      "unitPrice": "Unit price",
      "vip": "VIP",
      "wing": "Wing"
    },
    "propertyKind": {
      "resort": "Resort",
      "hotel": "Hotel",
      "guesthouse": "Guesthouse",
      "vessel": "Vessel",
      "villa": "Villa"
    },
    "propertyStatus": {
      "active": "Active",
      "suspended": "Suspended"
    },
    "roomStatus": {
      "active": "Active",
      "retired": "Retired"
    },
    "housekeepingStatus": {
      "dirty": "Dirty",
      "cleaning": "Cleaning",
      "clean": "Clean",
      "inspected": "Inspected"
    },
    "occupancyStatus": {
      "vacant": "Vacant",
      "occupied": "Occupied"
    },
    "outOfOrderKind": {
      "out_of_order": "Out of order",
      "out_of_service": "Out of service"
    },
    "revenueCenterKind": {
      "rooms": "Rooms",
      "fnb": "Food and beverage",
      "spa": "Spa",
      "activities": "Activities",
      "transfers": "Transfers",
      "minibar": "Minibar",
      "other": "Other"
    },
    "taxChannel": {
      "accommodation": "Accommodation",
      "guesthouse": "Guesthouse"
    },
    "noShowPolicy": {
      "charge_first_night": "Charge the first night",
      "charge_full_stay": "Charge the full stay",
      "no_charge": "No charge"
    },
    "chargeKind": {
      "none": "No charge",
      "first_night": "First night",
      "full_stay": "Full stay",
      "charge_first_night": "Charge the first night",
      "charge_full_stay": "Charge the full stay",
      "no_charge": "No charge"
    },
    "ratePlanStatus": {
      "draft": "Draft",
      "active": "Active",
      "closed": "Closed"
    },
    "guaranteeKind": {
      "none": "None",
      "token": "Card token",
      "deposit": "Deposit",
      "company": "Company",
      "travel_agent": "Travel agent"
    },
    "priceBasis": {
      "inclusive": "Tax inclusive",
      "exclusive": "Tax exclusive"
    },
    "reservationStatus": {
      "quote": "Quote",
      "held": "Held",
      "confirmed": "Confirmed",
      "checked_in": "Checked in",
      "checked_out": "Checked out",
      "cancelled": "Cancelled",
      "no_show": "No show",
      "waitlisted": "Waitlisted"
    },
    "waitlistStatus": {
      "waiting": "Waiting",
      "offered": "Offered",
      "converted": "Converted",
      "expired": "Expired",
      "withdrawn": "Withdrawn"
    },
    "groupBlockStatus": {
      "tentative": "Tentative",
      "definite": "Definite",
      "cancelled": "Cancelled",
      "closed": "Closed"
    },
    "roomingStatus": {
      "draft": "Draft",
      "validated": "Validated",
      "applied": "Applied",
      "failed": "Failed"
    },
    "roomingOutcome": {
      "pending": "Pending",
      "accepted": "Accepted",
      "rejected": "Rejected"
    },
    "quoteOutcome": {
      "available": "Available",
      "unavailable": "Unavailable",
      "restricted": "Restricted",
      "no_rate": "No rate"
    },
    "documentKind": {
      "passport": "Passport",
      "national_id": "National ID",
      "driving_licence": "Driving licence",
      "unknown": "Not recorded"
    },
    "restrictionReason": {
      "non_payment": "Non-payment",
      "property_damage": "Property damage",
      "abusive_behaviour": "Abusive behaviour",
      "security_concern": "Security concern",
      "fraud": "Fraud",
      "health_and_safety": "Health and safety",
      "other": "Other"
    },
    "preferenceCategory": {
      "room": "Room",
      "housekeeping": "Housekeeping",
      "dining": "Dining",
      "transport": "Transport",
      "other": "Other"
    },
    "outcome": {
      "won": "Applied",
      "lost": "Lost",
      "ineligible": "Ineligible",
      "out_of_window": "Out of window",
      "not_configured": "Not configured",
      "disabled": "Disabled",
      "not_reached": "Not reached"
    },
    "priceSource": {
      "rate_plan": "Rate plan",
      "derived_rate": "Derived rate",
      "manual": "Manual",
      "published_price_set": "Published price set",
      "base_price_list": "Base price list",
      "channel_price_list": "Channel price list",
      "segment_price_list": "Segment price list",
      "tier_price_list": "Tier price list",
      "customer_contract": "Customer contract",
      "contract_price_list": "Contract price list",
      "trade_agreement": "Trade agreement",
      "subscription_plan": "Subscription plan"
    },
    "reason": {
      "no_rate": "No rate is published for this night on this plan.",
      "no_rate_plan": "This line names no rate plan, so a rate plan cannot price it.",
      "rate_plan_posted": "Priced from the rate posted on {code} for this night.",
      "rate_plan_channel": "{code} is not sold on the {channel} channel.",
      "derived_rate": "{code} derives from no parent plan, so there is nothing to derive from.",
      "derived_rate_too_deep": "The derivation chain from {code} runs deeper than the engine will walk.",
      "rate_closed": "{date} is closed on this plan.",
      "rate_cta": "{date} is closed to arrival, so a stay may span it but not begin on it.",
      "rate_ctd": "{date} is closed to departure, so a stay may span it but not end on it.",
      "rate_minlos": "{date} carries a minimum stay of {minLengthOfStay} nights.",
      "rate_maxlos": "{date} carries a maximum stay of {maxLengthOfStay} nights."
    },
    "waterfall": {
      "title": "Why this price",
      "none": "The server recorded no considerations for this night."
    },
    "properties": {
      "title": "Properties",
      "description": "Every property a legal entity operates, and the four fields that decide what its room nights cost.",
      "tableTitle": "Property register",
      "caption": "Properties of the selected legal entity, with kind, tax channel, currency, check-in and check-out times, and the overbooking allowance.",
      "create": "New property",
      "dialogDescription": "A property is the unit room types, rooms, rate plans, availability and the night audit all hang from.",
      "chooseCompany": "Choose a legal entity to see its properties. Every property belongs to exactly one, and the register is scoped to the legal entities you are permitted.",
      "searchLabel": "Search",
      "searchPlaceholder": "Code or name",
      "empty": "No properties yet — create one to give room types, rates and reservations somewhere to live.",
      "loadFailed": "The property register could not be loaded.",
      "saved": "Property created",
      "saveFailed": "The property could not be created.",
      "kindHint": "Not cosmetic: the Maldives pack keys the per-night Green Tax on the tax channel a kind implies, at a different rate for a guesthouse than for a resort.",
      "locationHint": "Where the property is. It is what the tax engine resolves a jurisdiction from and what the operating calendar attaches the business day to.",
      "channelHint": "Left empty, accommodation is priced on the legal entity's default channel, which is the back-office one and taxes exclusively. Set it deliberately.",
      "itemClassHint": "The item class room nights are sold under, when the property does not use the pack default.",
      "overbookingHint": "How many rooms beyond the physical count the availability engine may sell. Zero is a real answer and a different one from three."
    },
    "property": {
      "description": "Everything scoped to one property: what it is, what it sells, what it has, where the money lands, and what cannot be sold.",
      "link": "Property",
      "loadFailed": "The property could not be loaded.",
      "saved": "Property saved",
      "saveFailed": "The property could not be saved.",
      "statusHint": "A suspended property keeps its history and sells nothing.",
      "tabsLabel": "Property sections",
      "tabs": {
        "overview": "Overview",
        "roomTypes": "Room types",
        "rooms": "Rooms",
        "revenueCenters": "Revenue centres",
        "outOfOrder": "Out of order"
      }
    },
    "roomTypes": {
      "title": "Room types",
      "description": "What the property sells and what availability is counted in. A rate plan prices a room type, never a room.",
      "caption": "Room types of this property, with their occupancy limits, housekeeping credits and overbooking override.",
      "create": "New room type",
      "dialogDescription": "A room type carries the item its nights sell as, the occupancy the rate covers, and what a clean costs the housekeeping board.",
      "empty": "No room types yet — add one before publishing a rate, because a rate prices a room type.",
      "saved": "Room type created",
      "saveFailed": "The room type could not be created.",
      "itemHint": "The item a room night sells as. Its tax group is what resolves accommodation GST and the per-night levy; without it a folio charge is unclassified at the night audit.",
      "cleanHint": "What a clean costs the housekeeping board in credits. Sent as typed — the board balances on the server.",
      "overbookingHint": "Leave empty to inherit the property's allowance.",
      "inheritsOverbooking": "Inherits property"
    },
    "rooms": {
      "title": "Rooms",
      "description": "The physical rooms, their room type, and where housekeeping finds them.",
      "caption": "Rooms of this property, with room type, floor, wing, housekeeping section, and current housekeeping and occupancy status.",
      "create": "New room",
      "dialogDescription": "A room belongs to exactly one room type, and that is what decides the money: availability is counted in room types.",
      "empty": "No rooms yet — add rooms so availability has something to count.",
      "saved": "Room created",
      "saveFailed": "The room could not be created.",
      "sectionHint": "The housekeeping section this room is assigned to. Boards are built from sections.",
      "connectTo": "Connect to room",
      "connectHint": "A connecting door. The pairing is symmetric; the server stores it lower-id-first.",
      "connected": "Rooms connected",
      "connectFailed": "The rooms could not be connected.",
      "disconnect": "Disconnect",
      "disconnectFrom": "Disconnect room",
      "disconnectTo": "…from room",
      "disconnected": "Rooms disconnected",
      "disconnectFailed": "The rooms could not be disconnected.",
      "connectionsNote": "Connections can be created and removed here, but not listed: the API returns no read for a room's existing pairings, so this screen would be guessing if it drew a table."
    },
    "outOfOrder": {
      "title": "Out of order",
      "description": "Rooms that cannot be sold, and rooms that can be sold but are flagged. Open records only.",
      "caption": "Open out-of-order and out-of-service records for this property's rooms, with the dates they cover and the reason given.",
      "create": "Take a room out",
      "dialogDescription": "Out of order removes the room from availability. Out of service leaves it sellable and flagged. The choice is the decision.",
      "empty": "Every room is available. Nothing is out of order or out of service today.",
      "release": "Release",
      "released": "Room released",
      "releaseFailed": "The room could not be released.",
      "saved": "Room taken out",
      "saveFailed": "The room could not be taken out.",
      "reasonHint": "Mandatory. A record with no reason is a room somebody will put back without knowing what was wrong with it.",
      "consequenceOutOfOrder": "Out of order removes this room from the availability count for every date in the range. Nobody can sell it, and every night it covers is a night the property has decided not to sell.",
      "consequenceOutOfService": "Out of service leaves this room sellable and flags it. Choose it only for work a guest would tolerate."
    },
    "revenueCenters": {
      "title": "Revenue centres",
      "description": "Where a charge's revenue lands. A centre's account overrides the legal entity default for anything posted through it.",
      "caption": "Revenue centres of this property, with the revenue account, cost centre and profit centre each posts to.",
      "create": "New revenue centre",
      "dialogDescription": "Postable accounts only: a header account named here is discovered by a night audit refusing to post.",
      "empty": "No revenue centres yet — add one to report spa separately from rooms without a second chart of accounts.",
      "saved": "Revenue centre created",
      "saveFailed": "The revenue centre could not be created.",
      "accountHint": "Leave empty to use the legal entity's default revenue account from property-management settings.",
      "usesDefault": "Legal entity default"
    },
    "settings": {
      "title": "Property-management settings",
      "description": "The eight accounts the night audit posts to, and the two decisions the roll depends on.",
      "accountsTitle": "Account map",
      "noLegalEntity": "No legal entity is available to you, so there is no account map to show. Ask an administrator for access to one.",
      "chooseCompany": "Choose a legal entity. The account map is per legal entity, because a chart of accounts is.",
      "loadFailed": "The settings could not be loaded.",
      "saved": "Settings saved",
      "saveFailed": "The settings could not be saved.",
      "unset": "Not yet configured: {accounts}. The night audit cannot post without them.",
      "guestLedger": "Guest ledger",
      "guestLedgerHint": "The receivable a folio balance is while the guest is in house. Every room-night charge debits it.",
      "depositLiability": "Deposit liability",
      "depositLiabilityHint": "Money taken before the stay is not revenue and is not the guest ledger. It is a liability until the stay consumes it.",
      "packageLedger": "Package ledger",
      "packageLedgerHint": "Where a board-basis carve-out sits between the night it is charged and the outlet that earns it. Unused by a property with no board plans.",
      "allowance": "Allowance",
      "allowanceHint": "Where a written-off charge goes. Separately permissioned and separately posted, so somebody can look at it.",
      "commissionExpense": "Commission expense",
      "commissionPayable": "Commission payable",
      "defaultRevenue": "Default revenue",
      "defaultRevenueHint": "Where a charge with no revenue centre lands. A revenue centre's own account overrides it.",
      "cashRounding": "Cash rounding",
      "noShowPolicy": "No-show policy",
      "noShowPolicyHint": "What the roll applies to a reservation that never arrived, where no cancellation policy says otherwise.",
      "resumeWindow": "Audit resume window (hours)",
      "resumeWindowHint": "After this many hours an abandoned night-audit run must be started again rather than continued."
    },
    "ratePlans": {
      "title": "Rate plans",
      "description": "What the property sells a night for, to whom, and on what terms.",
      "tableTitle": "Rate plans",
      "caption": "Rate plans of this property, with their currency, effectivity, stay and advance limits, channels, guarantee and status.",
      "create": "New rate plan",
      "dialogDescription": "A plan is created draft and prices nothing until it is activated, which is a separate act under a separate permission.",
      "chooseProperty": "Choose a legal entity and a property. A rate plan belongs to one property and publishes in that property's currency.",
      "searchLabel": "Search",
      "searchPlaceholder": "Code or name",
      "empty": "No rate plans yet — create one, fill its grid, then activate it to start selling.",
      "loadFailed": "The rate plans could not be loaded.",
      "saved": "Rate plan created",
      "saveFailed": "The rate plan could not be created.",
      "capped": "Showing the first {limit}. This endpoint answers with a plain array and offers no cursor, so there is no page to turn — narrow the filter to see the rest.",
      "allChannels": "All channels",
      "allSegments": "All segments",
      "commissionable": "Yes",
      "commissionableLabel": "Commission is payable on this plan",
      "commissionableHint": "Channel commission accrues when a stay on this plan is posted, not when the statement arrives.",
      "channelsHint": "Comma-separated codes. Empty means every channel.",
      "segmentsHint": "Comma-separated codes. Empty means every segment.",
      "guaranteeHint": "What the property holds against a no-show. Snapshotted onto each reservation, so changing it later does not rewrite bookings already taken.",
      "policyHint": "Snapshotted onto the reservation at confirmation. Leave empty to let the property's default apply.",
      "openEndedHint": "Leave empty for an open-ended plan.",
      "draftNote": "The plan is created draft in {currency}, the property's currency, and prices nothing until somebody with publish authority activates it."
    },
    "ratePlan": {
      "description": "Terms, the grid and the derivation. Saving the grid and putting the plan live are two authorities.",
      "loadFailed": "The rate plan could not be loaded.",
      "tabsLabel": "Rate plan sections",
      "tabs": {
        "grid": "Rate grid",
        "terms": "Terms",
        "derivation": "Derivation"
      },
      "activate": "Activate",
      "activated": "Rate plan submitted for activation",
      "activateFailed": "The rate plan could not be activated.",
      "draftWarning": "This plan is a draft. It prices nothing: the pricing walk asks whether the plan is active on the date, and a draft is not.",
      "basisFromPack": "From the tax pack",
      "basisNote": "Where the price basis is not set on the plan, the tax pack decides whether the published rate is inclusive or exclusive for the property's channel. It is never assumed here."
    },
    "rateGrid": {
      "title": "Rate grid",
      "description": "Room type by stay date. Arrow keys move, Enter goes down, Escape restores a cell, and a spreadsheet block pasted into a cell fills right and down.",
      "caption": "Published rates for this plan across the selected window, one row per room type and one column per stay date.",
      "empty": "This property has no room types, so the grid has no rows. Add a room type first.",
      "amount": "Rate",
      "extraAdult": "Extra adult",
      "extraChild": "Extra child",
      "showSupplements": "Show supplements",
      "currencyNote": "Amounts are in {currency}, as published. Supplements are applied by the server above the room type's base occupancy and are never added here.",
      "save": "Save the window",
      "saved": "Rates saved",
      "savedDetail": "{count} row(s) written",
      "saveFailed": "The rates could not be saved.",
      "loadFailed": "The rates could not be loaded.",
      "unsaved": "{count} unsaved change(s)",
      "previousWindow": "Previous two weeks",
      "nextWindow": "Next two weeks",
      "badWindow": "Give a from date on or before the to date.",
      "truncated": "The window is longer than the grid will draw. Narrow it, or move through it a window at a time.",
      "passthrough": "{count} occupancy-specific rate(s) in this window are not shown and are sent back unchanged, so saving cannot destroy them.",
      "replaceNote": "Saving replaces every rate this plan has in the window shown. A cell left blank is a rate the property no longer publishes for that date.",
      "cellLabel": "{measure} for {roomType} on {date}"
    },
    "derivation": {
      "title": "Derivation",
      "description": "Price this plan from another, by a delta, rounded and clamped. The chain is walked when a night is quoted, never stored.",
      "none": "This plan derives from nothing and prices from its own grid. Name a parent below to derive it instead.",
      "parent": "Parent plan",
      "parentHint": "The plan whose posted rate this one starts from.",
      "deltaAmount": "Delta amount",
      "deltaAmountHint": "Added to the parent's rate, after the percentage.",
      "deltaPercent": "Delta percent",
      "deltaPercentHint": "Applied to the parent's rate before the amount.",
      "rounding": "Rounding increment",
      "roundingHint": "The derived rate is rounded to this increment. Zero rounds to the currency's own scale.",
      "floor": "Floor",
      "ceiling": "Ceiling",
      "saved": "Derivation saved",
      "saveFailed": "The derivation could not be saved.",
      "previewTitle": "Preview the chain",
      "previewDescription": "A real quote, not a simulation. It writes nothing, takes no availability and consumes no number — and it is the same answer a guest would be given.",
      "previewCaption": "Per-night prices the engine produced for the previewed stay.",
      "preview": "Run the preview",
      "previewEmpty": "Choose a room type and a stay, then run the preview to see the price the engine actually produces.",
      "previewFailed": "The preview could not be run.",
      "waterfallLabel": "Why the first night is that price"
    },
    "restrictions": {
      "title": "Restriction calendar",
      "description": "Whether a date may be sold, and on what terms. A month at a time, a row per scope.",
      "gridTitle": "Month grid",
      "caption": "Restrictions for this property across the month, one row for the property as a whole and one per room type.",
      "chooseProperty": "Choose a legal entity and a property to see its restriction calendar.",
      "allRoomTypes": "All room types",
      "legend": "C closed · A closed to arrival · D closed to departure · numbers are the minimum and maximum length of stay. Arrows move, Space toggles closed, A and D toggle arrival and departure.",
      "previousMonth": "Previous month",
      "nextMonth": "Next month",
      "loadFailed": "The restriction calendar could not be loaded.",
      "save": "Save the month",
      "saved": "Restrictions saved",
      "saveFailed": "The restrictions could not be saved.",
      "unsaved": "Unsaved changes",
      "passthrough": "{count} rate-plan-scoped restriction(s) this month are not edited here and are sent back unchanged, so saving cannot destroy them.",
      "editorTitle": "{scope} on {date}",
      "editorDescription": "The five toggles for the selected cell. Apply them across a range when a whole season closes together.",
      "cellLabel": "Restrictions for {scope} on {date}",
      "closed": "Closed",
      "closedLabel": "This date cannot be sold",
      "closedHint": "The strongest of the five: no stay may include this date at all.",
      "closedToArrival": "Closed to arrival",
      "ctaLabel": "A stay may span this date but not begin on it",
      "ctaHint": "The Saturday-arrival rule, stated per date.",
      "closedToDeparture": "Closed to departure",
      "ctdLabel": "A stay may span this date but not end on it",
      "ctdHint": "Keeps a departure out of a peak changeover day.",
      "minLos": "Minimum stay",
      "maxLos": "Maximum stay",
      "bulkFrom": "Apply from",
      "bulkTo": "Apply to",
      "applyToRange": "Apply to range",
      "applied": "Applied across the range",
      "appliedDetail": "{count} date(s) updated — not yet saved"
    },
    "availability": {
      "title": "Availability",
      "description": "Room type by date, with the five numbers behind every answer one click away.",
      "gridTitle": "Availability calendar",
      "caption": "Rooms available per room type per stay date, as the availability engine computes them.",
      "chooseProperty": "Choose a legal entity and a property to see its availability.",
      "empty": "This property has no room types, so there is nothing to count. Add a room type first.",
      "loadFailed": "The availability calendar could not be loaded.",
      "previousWindow": "Previous two weeks",
      "nextWindow": "Next two weeks",
      "showBlocks": "Show group blocks",
      "legend": "Each cell is the rooms the engine will sell. A red cell is none or oversold, an amber cell is two or fewer, and +n is rooms held by a group block. Click a cell for the numbers behind it.",
      "cellLabel": "Availability for {roomType} on {date}",
      "whyTitle": "{roomType} on {date}",
      "whyDescription": "The five inputs the engine used, and the answer it produced.",
      "whyNote": "Available is the engine's own figure, not these five subtracted. It is what the conditional update will accept, computed by the same code that refuses an oversell — so it is shown beside the inputs, never derived from them.",
      "physicalRooms": "Physical rooms",
      "outOfOrder": "Out of order",
      "committed": "Committed",
      "blocked": "Held by blocks",
      "overbooking": "Overbooking allowance",
      "available": "Available"
    },
    "reservations": {
      "title": "Reservations",
      "description": "Every booking of a property, and the waitlist beside it.",
      "tableTitle": "Reservations",
      "caption": "Reservations for this property, with the stay, the room type, the guests, the quoted gross and the status.",
      "create": "New reservation",
      "createFromQuote": "Book this quote",
      "dialogDescription": "Quote the stay first. The price, the tax and the reason for each night come from the engine, not from this screen.",
      "chooseProperty": "Choose a legal entity and a property. Reservations are property-scoped, and a booking at another property is not yours to see.",
      "searchLabel": "Search",
      "searchPlaceholder": "Reservation number or guest",
      "empty": "No reservations match. Take a booking, or widen the arrival dates.",
      "loadFailed": "The reservations could not be loaded.",
      "saved": "Reservation created",
      "saveFailed": "The reservation could not be created.",
      "unnumbered": "Not yet numbered",
      "quote": "Quote the stay",
      "quoteFailed": "The stay could not be quoted.",
      "quoteFirst": "Quote the stay to see the price, the tax and each night's availability before booking anything.",
      "quoteCaption": "Per-night prices and availability the engine produced for this stay.",
      "quoteTotal": "Quoted",
      "notSellable": "At least one night of this stay cannot be sold. The outcome column says which and why; a booking cannot be made until it is resolved.",
      "planHint": "Only active plans are offered. A draft plan prices nothing.",
      "waterfallLabel": "Why the first night is that price",
      "tabsLabel": "Reservation lists",
      "tabsReservations": "Reservations",
      "tabsWaitlist": "Waitlist"
    },
    "reservation": {
      "description": "The stay as promised: its nights, their prices, the guarantee and the terms it was booked on.",
      "loadFailed": "The reservation could not be loaded.",
      "tabsLabel": "Reservation sections",
      "tabs": {
        "nights": "Nights",
        "terms": "Terms"
      },
      "nightsTitle": "Nights",
      "nightsDescription": "The prices stored on the reservation — what the property promised this guest, at the moment it promised it.",
      "nightsCaption": "Each night of the stay with its unit price, rate, package amount, net, tax and gross, and whether it has been posted to a folio.",
      "nightsEmpty": "This reservation has no priced nights.",
      "posted": "Posted",
      "why": "Why",
      "explainNote": "This is today's explanation of the same pricing walk, run for this one night. The prices in the row above are the ones the guest was promised; where the two differ, the difference is the answer.",
      "explainFailed": "The explanation could not be loaded.",
      "waterfallLabel": "Why {date} is that price",
      "hold": "Hold",
      "held": "Reservation held",
      "holdFailed": "The reservation could not be held.",
      "holdNote": "This hold has taken availability until {until}. The rooms are out of general sale and nobody has paid for them.",
      "confirm": "Confirm",
      "confirmed": "Reservation confirmed",
      "confirmFailed": "The reservation could not be confirmed.",
      "amend": "Amend",
      "cancel": "Cancel",
      "termsTitle": "Cancellation terms",
      "termsDescription": "The tiers snapshotted onto this reservation when it was confirmed — not the policy as it stands today.",
      "snapshotCaption": "The cancellation tiers this reservation was booked under.",
      "snapshotEmpty": "No cancellation tiers were snapshotted onto this reservation.",
      "snapshotNote": "A property that changed its terms after this booking does not get to apply them to it. The charge on a cancellation is computed by the server against these tiers."
    },
    "waitlist": {
      "title": "Waitlist",
      "description": "Guests who want a stay the property cannot sell yet. They have no reservation, no rooms and no price.",
      "caption": "Waitlist entries for this property, with the stay wanted, the priority and the offer window.",
      "empty": "Nobody is waiting for this property.",
      "loadFailed": "The waitlist could not be loaded.",
      "offer": "Offer",
      "offered": "Offer sent",
      "offerFailed": "The offer could not be made."
    },
    "amend": {
      "title": "Amend the reservation",
      "description": "The server releases the old nights and takes the new ones in one transaction, re-quotes the stay, and can refuse.",
      "currentStay": "Current stay",
      "currentGross": "Current gross",
      "submit": "Amend",
      "saved": "Reservation amended",
      "savedDetail": "{released} night(s) released, {committed} taken",
      "failed": "The reservation could not be amended.",
      "unchanged": "Nothing has changed yet. Move a date, a room type or a count to amend the booking.",
      "postedWarning": "{count} night(s) of this stay have already been posted to a folio. An amendment that would move a posted night is always refused.",
      "overrideReason": "Override reason",
      "overrideHint": "Needed only where the amendment crosses a control the property has configured as overridable."
    },
    "cancel": {
      "title": "Cancel the reservation",
      "description": "Under the terms it was booked on, not the terms in force today.",
      "snapshotCaption": "The cancellation tiers snapshotted onto this reservation.",
      "snapshotEmpty": "No tiers were snapshotted, so the property's default no-show policy applies.",
      "chargeNote": "The charge is computed by the server against these tiers and the hours remaining before arrival, in the property's own timezone. It is shown once the cancellation is made.",
      "reasonLabel": "Reason",
      "reasonHint": "Recorded on the reservation and in the audit trail.",
      "submit": "Cancel the reservation",
      "done": "Reservation cancelled",
      "failed": "The reservation could not be cancelled."
    },
    "groupBlocks": {
      "title": "Group blocks",
      "description": "Rooms contracted to a group, what has been picked up against them, and when the rest goes back on sale.",
      "tableTitle": "Group blocks",
      "caption": "Group blocks for this property, with the stay, the cut-off, the attrition percentage and the status.",
      "create": "New group block",
      "dialogDescription": "A block is created tentative and holds nothing until it is confirmed.",
      "chooseProperty": "Choose a legal entity and a property to see its group blocks.",
      "searchLabel": "Search",
      "searchPlaceholder": "Block number or name",
      "empty": "No group blocks yet — create one to contract rooms to a group before they are booked.",
      "loadFailed": "The group blocks could not be loaded.",
      "saved": "Group block created",
      "saveFailed": "The group block could not be created.",
      "unnumbered": "Not yet numbered",
      "cutoffPending": "Not yet",
      "tentativeNote": "The block is created tentative. It holds no rooms until somebody with confirm authority makes it definite, which is the moment the property gives away inventory.",
      "cutoffHint": "How many days before arrival the unpicked allotment goes back on sale.",
      "attritionHint": "The shortfall the contract forgives. The server computes the allowed shortfall and the chargeable rooms from it against the actual pickup.",
      "planHint": "The rate plan the group's bookings are priced on."
    },
    "groupBlock": {
      "description": "The allotment, the pickup, the attrition and the rooming list.",
      "loadFailed": "The group block could not be loaded.",
      "tabsLabel": "Group block sections",
      "tabs": {
        "allotment": "Allotment",
        "rooming": "Rooming list"
      },
      "confirm": "Confirm the block",
      "confirmed": "Group block submitted for confirmation",
      "confirmFailed": "The group block could not be confirmed.",
      "cutoff": "Apply the cut-off",
      "cutoffDone": "Cut-off applied",
      "cutoffFailed": "The cut-off could not be applied.",
      "tentativeWarning": "This block is tentative and holds no rooms. Its allotment appears in no availability count until it is confirmed.",
      "attritionTitle": "Pickup and attrition",
      "attritionDescription": "What was contracted, what the group took, and what the contract forgives.",
      "attritionNote": "The allowed shortfall and the chargeable rooms are computed by the server from the contracted rooms and the attrition percentage. They are decimal figures and are never re-derived here.",
      "totalContracted": "Contracted",
      "totalPickedUp": "Picked up",
      "totalReleased": "Released",
      "allowedShortfall": "Allowed shortfall",
      "attritionRooms": "Chargeable attrition"
    },
    "allotments": {
      "title": "Allotment",
      "description": "Room type by stay night. Contracted is editable; picked up, released and remaining are the server's.",
      "caption": "Contracted rooms per room type per night, with the pickup, the release and the remaining rooms the server computed.",
      "legend": "The top row of each pair is contracted and is editable. The row below is picked up / released / remaining, as the server computed them. Arrows and Enter move between cells.",
      "contracted": "contracted",
      "pickedUpReleasedRemaining": "picked up / released / remaining",
      "cellLabel": "Contracted rooms of {roomType} on {date}",
      "empty": "This property has no room types, so the allotment grid has no rows.",
      "save": "Save the allotment",
      "saved": "Allotment saved",
      "savedDetail": "{count} cell(s) written",
      "saveFailed": "The allotment could not be saved.",
      "unsaved": "{count} unsaved change(s)",
      "stranded": "{count} cell(s) are cut below what the group has already picked up or released. The server will refuse them and say which.",
      "wash": "Wash",
      "washAll": "Wash the block",
      "washRow": "Wash {roomType}",
      "washHint": "Cut every night to what the group has already picked up, handing the rest back to general sale. Staged in the grid; the save writes it.",
      "washStaged": "{rooms} room(s) staged for release. Save the allotment to hand them back to general sale.",
      "washNothing": "Nothing is left to wash — every contracted room on this grid has already been picked up or released."
    },
    "rooming": {
      "title": "Rooming list",
      "description": "Paste the list, read every row's outcome, then apply. Validation writes nothing.",
      "caption": "Each row of the rooming list with the outcome the server gave it and, where it was rejected, the reason.",
      "format": "Columns, in order: given name, family name, email, room type code, arrival, departure, adults, children. Tab or comma separated; a header row is skipped.",
      "filename": "File name",
      "filenamePlaceholder": "As the agency sent it",
      "pasteLabel": "Rooming list",
      "pasteHint": "Paste straight from the spreadsheet. Nothing is judged here — every check is the server's.",
      "pastePlaceholder": "Given name\tFamily name\tEmail\tRoom type\tArrival\tDeparture\tAdults\tChildren",
      "parsed": "{count} row(s) parsed",
      "validate": "Validate",
      "apply": "Apply the accepted rows",
      "applied": "Rooming list applied",
      "appliedDetail": "{accepted} accepted, {rejected} rejected",
      "failed": "The rooming list could not be processed.",
      "summary": "{rows} row(s): {accepted} accepted, {rejected} rejected. Status {status}.",
      "lineNo": "Line",
      "guest": "Guest",
      "outcome": "Outcome",
      "reason": "Reason",
      "empty": "The server returned no rows for this list."
    },
    "guests": {
      "title": "Guests",
      "description": "The people who stay. One identity per person, shared with the party spine.",
      "tableTitle": "Guest register",
      "caption": "Guests of the selected legal entity, with contact details, the masked travel document and any restriction.",
      "create": "New guest",
      "dialogDescription": "Creating a guest resolves or creates the party in the same transaction, so a second booking for the same email is the same person everywhere.",
      "chooseCompany": "Choose a legal entity. A guest belongs to one, and the register is scoped to the legal entities you are permitted.",
      "searchLabel": "Search",
      "searchHint": "Matches on name, email and phone through the trigram index.",
      "searchPlaceholder": "Name, email or phone",
      "restrictedFilter": "Restricted",
      "restrictedOnly": "Restricted guests only",
      "restricted": "restricted",
      "empty": "No guests match. Register one, or widen the search.",
      "loadFailed": "The guest register could not be loaded.",
      "saved": "Guest registered",
      "saveFailed": "The guest could not be registered.",
      "noDocument": "None recorded",
      "emailHint": "Used to resolve the party, which is what makes a returning guest the same person across the system.",
      "documentHint": "The number is encrypted at rest and never returned in a list.",
      "documentNote": "The document number is write-only from here. It comes back as a masked last four, and seeing it again is an audited reveal under its own permission."
    },
    "guest": {
      "description": "Profile, preferences, the travel document and the stay history.",
      "loadFailed": "The guest could not be loaded.",
      "tabsLabel": "Guest sections",
      "tabs": {
        "profile": "Profile",
        "preferences": "Preferences",
        "stays": "Stays",
        "messages": "Messages"
      },
      "partyLink": "Party profile",
      "restrictedNote": "This guest is on the restricted list: {reason}. {note} Check-in is refused outright and there is no override.",
      "noRestrictedNote": "No note was recorded.",
      "documentTitle": "Travel document",
      "documentDescription": "Masked. The number is AES-GCM encrypted at rest and is not in this payload.",
      "documentNote": "Revealing the number writes an audit row naming you, the guest and your reason, and is stepped up with a one-time code.",
      "staysTitle": "Stay history",
      "staysDescription": "This property's own record of the guest's reservations.",
      "staysCaption": "Reservations this guest holds at the selected property.",
      "staysChooseProperty": "Choose a property. Reservations are property-scoped, so a guest who has stayed at three of a group's properties has three histories.",
      "staysEmpty": "This guest has no reservations at this property."
    },
    "preferences": {
      "title": "Preferences",
      "description": "What this guest asks for, so the desk does not have to be told twice.",
      "caption": "Recorded preferences for this guest, by category.",
      "category": "Category",
      "value": "Value",
      "codeHint": "A short code the property uses, such as HIGH_FLOOR or FEATHER_FREE.",
      "empty": "No preferences recorded. Add one so the next stay starts better than the last.",
      "remove": "Remove",
      "removed": "Preference removed",
      "removeFailed": "The preference could not be removed.",
      "saved": "Preference saved",
      "saveFailed": "The preference could not be saved."
    },
    "reveal": {
      "title": "Reveal {guest}'s document",
      "description": "An audited act, not a display toggle.",
      "auditNote": "This writes an audit row naming you, the guest and your reason, and is stepped up with a one-time code. The number is shown once and is not kept.",
      "reasonLabel": "Reason",
      "reasonHint": "Recorded verbatim in the audit trail. Say what you need it for.",
      "submit": "Reveal",
      "failed": "The document could not be revealed.",
      "revealedAt": "Revealed at",
      "onceNote": "Closing this dialog forgets the number. Seeing it again is another reveal and another audit row."
    },
    "restrict": {
      "title": "Restrict the guest",
      "description": "A restricted guest cannot be checked in. There is no override.",
      "consequence": "Check-in will be refused outright for this guest, at every property of the legal entity, with no override and no approval path.",
      "reasonLabel": "Reason",
      "reasonHint": "A desk agent turning somebody away needs to know which decision they are enforcing.",
      "noteHint": "What happened, in enough detail for whoever reads this in a year.",
      "submit": "Restrict",
      "applied": "Guest restricted",
      "liftTitle": "Lift the restriction",
      "liftDescription": "The guest becomes checkable-in again immediately.",
      "liftConsequence": "Lifting the restriction makes this guest checkable-in again at once. The original reason stays in the audit trail.",
      "lift": "Lift the restriction",
      "lifted": "Restriction lifted",
      "liftNoteHint": "Required. Adding a restriction was somebody's decision; removing one is a decision somebody else will be asked about.",
      "failed": "The restricted list could not be updated."
    },
    "ops": {
      "routeTitles": {
        "frontDesk": "Front desk",
        "folios": "Folios",
        "folio": "Folio",
        "deposits": "Deposits",
        "nightAudit": "Night audit",
        "nightAuditRun": "Night audit run",
        "channels": "Channels",
        "channel": "Channel",
        "parity": "Rate parity",
        "agreements": "Commission agreements",
        "agreement": "Commission agreement",
        "accruals": "Commission accruals",
        "statements": "Commission statements",
        "statement": "Commission statement",
        "services": "Services",
        "schedule": "Service schedule",
        "boardPlans": "Board plans",
        "unconsumed": "Unconsumed allowances",
        "transfers": "Transfers",
        "guestRequests": "Guest requests",
        "reports": "Reports"
      },
      "fields": {
        "accepted": "Accepted",
        "account": "Account",
        "accrued": "Accrued",
        "adapter": "Adapter",
        "adr": "ADR",
        "allowanceCap": "Allowance cap",
        "amount": "Amount",
        "applied": "Applied",
        "approvalCode": "Approval code",
        "arrivals": "Arrivals",
        "arriveAt": "Arrives",
        "assignmentReason": "Why this room",
        "balance": "Balance",
        "basisAmount": "Basis",
        "bookedPax": "Booked pax",
        "businessDate": "Business date",
        "cancelWindowHours": "Cancellation window (hours)",
        "cap": "Cap",
        "capacityPax": "Capacity (pax)",
        "capacityPerSlot": "Capacity per slot",
        "card": "Card",
        "cardLast4": "Last 4 digits",
        "cardScheme": "Card scheme",
        "category": "Category",
        "channel": "Channel",
        "channelKind": "Channel type",
        "channelReference": "Channel reference",
        "charge": "Charge",
        "chargeKind": "Charge type",
        "charges": "Charges",
        "chargesPosted": "Charges posted",
        "closing": "Closing",
        "code": "Code",
        "commissionBasis": "Commission basis",
        "confidence": "Confidence",
        "consumed": "Consumed",
        "covers": "Covers per person per night",
        "createdAt": "Recorded",
        "credit": "Credit",
        "currency": "Currency",
        "currentStep": "Current step",
        "dateDistance": "Date gap (days)",
        "debit": "Debit",
        "declaredTotal": "Declared total",
        "departAt": "Departs",
        "departures": "Departures",
        "depositNo": "Deposit no.",
        "description": "Description",
        "destination": "Destination",
        "deviation": "Deviation %",
        "direction": "Direction",
        "drawnCovers": "Drawn covers",
        "drawnValue": "Drawn value",
        "dueDate": "Due date",
        "durationMinutes": "Duration (minutes)",
        "effectiveFrom": "Effective from",
        "effectiveTo": "Effective to",
        "entitlements": "Entitlements",
        "expiresAt": "Expires",
        "filename": "File name",
        "flatAmount": "Flat amount",
        "flatPerBooking": "Flat per booking",
        "flatPerNight": "Flat per night",
        "folioKind": "Folio type",
        "folioNo": "Folio no.",
        "forced": "Forced",
        "from": "From",
        "grantedCovers": "Granted covers",
        "grantedValue": "Granted value",
        "gross": "Gross",
        "guest": "Guest",
        "heldAt": "Held at",
        "invoiceNo": "Invoice no.",
        "item": "Item id",
        "journal": "Journal",
        "keyKind": "Key type",
        "leadTimeHours": "Lead time (hours)",
        "legNo": "Leg no.",
        "lineKind": "Line type",
        "lineNo": "Line",
        "marketCode": "Default market",
        "matchType": "Match type",
        "matchedTotal": "Matched total",
        "mealPeriod": "Meal period",
        "memo": "Memo",
        "method": "Method",
        "net": "Net",
        "nextBusinessDate": "Next business date",
        "nightPosted": "Night posted",
        "noShows": "No-shows processed",
        "note": "Note",
        "observedAmount": "Observed",
        "observedOn": "Observed on",
        "occupancyPercent": "Occupancy %",
        "openedAt": "Opened",
        "opening": "Opening",
        "order": "Order",
        "origin": "Origin",
        "outlet": "Outlet id",
        "parityTolerance": "Parity tolerance %",
        "partyKey": "Party",
        "pax": "Pax",
        "payloadKind": "Payload",
        "percent": "Percent",
        "period": "Period",
        "periodFrom": "Period from",
        "periodTo": "Period to",
        "quantity": "Quantity",
        "reason": "Reason",
        "reasonCode": "Reason code",
        "receivedOn": "Received on",
        "recoveryKind": "Recovery",
        "recoveryValue": "Recovery value",
        "reference": "Reference",
        "referenceAmount": "Reference",
        "refunded": "Refunded",
        "rejected": "Rejected",
        "remaining": "Remaining",
        "remainingCovers": "Remaining covers",
        "remainingValue": "Remaining value",
        "requestKind": "Type",
        "requestNo": "Request no.",
        "reservation": "Reservation",
        "resolutionNote": "Resolution note",
        "revenueCenter": "Revenue centre",
        "revenueGross": "Revenue (gross)",
        "revpar": "RevPAR",
        "room": "Room",
        "roomRevenue": "Room revenue",
        "roomState": "Room state",
        "roomsAvailable": "Rooms available",
        "roomsOccupied": "Rooms occupied",
        "roomsOutOfOrder": "Rooms out of order",
        "roomsPosted": "Rooms posted",
        "rowCount": "Rows",
        "runNo": "Run no.",
        "scheduledAt": "Scheduled",
        "scheduledDate": "Date",
        "segmentCode": "Default segment",
        "seq": "Seq.",
        "service": "Service",
        "serviceKind": "Service type",
        "settleThis": "Settle",
        "settlementMode": "Settlement mode",
        "settlements": "Settlements",
        "severity": "Severity",
        "source": "Source",
        "sourceCode": "Default source",
        "splitReason": "Reason for splitting the party",
        "statementNo": "Statement no.",
        "stayDate": "Stay date",
        "stayovers": "Stayovers",
        "targetFolio": "Target folio id",
        "targetWindow": "Target window",
        "tax": "Tax",
        "taxCode": "Tax code",
        "theirCommission": "Their commission",
        "to": "To",
        "transferPrice": "Transfer price",
        "unitPrice": "Unit price",
        "validFrom": "Valid from",
        "validTo": "Valid to",
        "variance": "Variance",
        "versionNo": "Version",
        "window": "Window",
        "windowName": "Window name",
        "sourceRow": "Row",
        "exceptionReason": "Why it was refused",
        "resolutionStatus": "Outcome"
      },
      "chargeKind": {
        "room": "Room",
        "tax": "Tax",
        "service_charge": "Service charge",
        "levy": "Levy",
        "ancillary": "Ancillary",
        "pos": "Point of sale",
        "deposit": "Deposit",
        "payment": "Payment",
        "allowance": "Allowance",
        "transfer_in": "Transfer in",
        "transfer_out": "Transfer out",
        "package_draw": "Package draw",
        "package_relief": "Package relief"
      },
      "chargeStatus": {
        "posted": "Posted",
        "reversed": "Reversed",
        "reversal": "Reversal"
      },
      "postingSource": {
        "pms": "Front office",
        "pos": "Point of sale",
        "channel": "Channel",
        "import": "Import"
      },
      "folioKind": {
        "guest": "Guest",
        "group_master": "Group master",
        "house": "House",
        "walk_in": "Walk-in"
      },
      "folioStatus": {
        "open": "Open",
        "settled": "Settled",
        "transferred": "Transferred",
        "disputed": "Disputed"
      },
      "windowStatus": {
        "open": "Open",
        "settled": "Settled",
        "transferred": "Transferred"
      },
      "settlementMethod": {
        "cash": "Cash",
        "card": "Card",
        "bank_transfer": "Bank transfer",
        "deposit_applied": "Apply a deposit",
        "city_ledger": "To the city ledger",
        "allowance": "Allowance",
        "transfer_to_folio": "Transfer to another folio"
      },
      "depositMethod": {
        "cash": "Cash",
        "card": "Card",
        "bank_transfer": "Bank transfer"
      },
      "depositStatus": {
        "held": "Held",
        "applied": "Applied",
        "refunded": "Refunded",
        "forfeited": "Forfeited"
      },
      "assignmentReason": {
        "requested": "Guest requested it",
        "upgrade": "Upgrade",
        "accessible": "Accessible room needed",
        "connecting": "Connecting rooms",
        "only_available": "Only room available",
        "room_move": "Room move"
      },
      "holdStatus": {
        "held": "Held",
        "captured": "Captured",
        "released": "Released",
        "expired": "Expired",
        "failed": "Failed"
      },
      "keyKind": {
        "guest": "Guest",
        "duplicate": "Duplicate",
        "staff": "Staff",
        "master": "Master"
      },
      "keyStatus": {
        "issued": "Issued",
        "cancelled": "Cancelled",
        "expired": "Expired"
      },
      "step": {
        "readiness": "Readiness checks",
        "no_show": "Resolve no-shows",
        "post_room_and_tax": "Post room and tax",
        "board_allowances": "Grant board allowances",
        "package_relief": "Stamp package relief",
        "commission": "Accrue commission",
        "build_lines": "Build the journal lines",
        "post_journal": "Post the journal",
        "day_pack": "Build the day pack",
        "roll": "Roll the date"
      },
      "stepStatus": {
        "pending": "Pending",
        "running": "Running",
        "done": "Done",
        "skipped": "Skipped",
        "failed": "Failed"
      },
      "runStatus": {
        "pending": "Pending",
        "running": "Running",
        "blocked": "Blocked",
        "completed": "Completed",
        "abandoned": "Abandoned",
        "reversed": "Reversed"
      },
      "lineKind": {
        "guest_ledger": "Guest ledger",
        "revenue": "Revenue",
        "tax": "Tax",
        "service_charge": "Service charge",
        "levy": "Levy",
        "package_ledger": "Package ledger",
        "package_relief": "Package relief",
        "allowance": "Allowance",
        "rounding": "Rounding"
      },
      "channelKind": {
        "ota": "Online travel agent",
        "wholesaler": "Wholesaler",
        "tour_operator": "Tour operator",
        "direct": "Direct",
        "gds": "GDS",
        "corporate": "Corporate"
      },
      "channelStatus": {
        "active": "Active",
        "suspended": "Suspended"
      },
      "direction": {
        "push": "Push",
        "pull": "Pull"
      },
      "payloadKind": {
        "rates": "Rates",
        "restrictions": "Restrictions",
        "availability": "Availability",
        "bookings": "Bookings",
        "commission": "Commission"
      },
      "exchangeStatus": {
        "pending": "Pending",
        "complete": "Complete",
        "failed": "Failed"
      },
      "paritySource": {
        "manual": "Spot check",
        "import": "Feed"
      },
      "agreementStatus": {
        "draft": "Draft",
        "active": "Active",
        "closed": "Closed"
      },
      "versionStatus": {
        "draft": "Draft",
        "published": "Published (frozen)",
        "superseded": "Superseded"
      },
      "commissionBasis": {
        "room_net": "Room revenue, net of tax",
        "room_gross": "Room revenue, gross",
        "stay_net": "Whole stay, net of tax"
      },
      "settlementMode": {
        "invoiced": "We invoice them",
        "net_remittance": "They remit net"
      },
      "accrualStatus": {
        "accrued": "Accrued",
        "matched": "Matched",
        "disputed": "Disputed",
        "settled": "Settled",
        "reversed": "Reversed"
      },
      "statementStatus": {
        "imported": "Imported",
        "matching": "Matching",
        "reconciled": "Reconciled",
        "disputed": "Disputed",
        "closed": "Closed"
      },
      "statementLineStatus": {
        "unmatched": "Unmatched",
        "matched": "Matched",
        "disputed": "Disputed",
        "written_off": "Written off"
      },
      "serviceKind": {
        "activity": "Activity",
        "spa": "Spa",
        "dining": "Dining",
        "transfer": "Transfer",
        "rental": "Rental",
        "other": "Other"
      },
      "bookingStatus": {
        "booked": "Booked",
        "confirmed": "Confirmed",
        "delivered": "Delivered",
        "cancelled": "Cancelled",
        "no_show": "No-show"
      },
      "mealPeriod": {
        "breakfast": "Breakfast",
        "lunch": "Lunch",
        "dinner": "Dinner",
        "snack": "Snack"
      },
      "boardPlanStatus": {
        "draft": "Draft",
        "active": "Active",
        "closed": "Closed"
      },
      "transferDirection": {
        "arrival": "Arrival",
        "departure": "Departure",
        "internal": "Internal"
      },
      "transferLegStatus": {
        "planned": "Planned",
        "confirmed": "Confirmed",
        "departed": "Departed",
        "completed": "Completed",
        "cancelled": "Cancelled"
      },
      "requestKind": {
        "request": "Request",
        "complaint": "Complaint"
      },
      "requestStatus": {
        "open": "Open",
        "assigned": "Assigned",
        "resolved": "Resolved",
        "escalated": "Escalated",
        "closed": "Closed"
      },
      "severity": {
        "low": "Low",
        "medium": "Medium",
        "high": "High"
      },
      "recoveryKind": {
        "none": "None — acknowledged, nothing given",
        "allowance": "Folio allowance",
        "comp_service": "Complimentary service",
        "points": "Loyalty points",
        "gift": "Gift"
      },
      "frontDesk": {
        "title": "Front desk",
        "description": "Arrivals, departures and who is in house.",
        "tabsLabel": "Front desk boards",
        "tabArrivals": "Arrivals",
        "tabDepartures": "Departures",
        "tabInHouse": "In house",
        "arrivalsCaption": "Reservations arriving today",
        "departuresCaption": "Reservations departing today",
        "inHouseCaption": "Rooms occupied tonight",
        "arrivalsEmpty": "Nobody is arriving on this date. Choose another date, or take a booking from the reservations screen.",
        "departuresEmpty": "Nobody is departing on this date.",
        "inHouseEmpty": "Nobody is in house on this date.",
        "loadFailed": "The board could not be loaded",
        "chooseProperty": "Choose a legal entity and a property to work the desk.",
        "dateHint": "Blank means the property's own business date.",
        "restricted": "Restricted guest"
      },
      "checkIn": {
        "title": "Check in",
        "action": "Check in",
        "description": "Assigns the room, opens the folio, writes the registration card, takes the authorisation and issues the key — in one transaction.",
        "submit": "Check in",
        "done": "Checked in",
        "failed": "The check-in was refused",
        "restricted": "This guest is on the restricted list. Check-in is refused and there is no override — for anyone. Take it to a manager.",
        "roomHint": "Leave blank if a room is already assigned.",
        "reasonHint": "Recorded against the assignment, so it can be explained later.",
        "issueKeyLabel": "Issue a key",
        "issueKeyHint": "A guest who is checked in and cannot open the door is not checked in.",
        "holdLabel": "Take a card authorisation",
        "holdHint": "Records what the terminal returned. No card number is accepted or stored.",
        "panHint": "Four digits only — never the full card number."
      },
      "checkOut": {
        "title": "Check out",
        "action": "Check out",
        "description": "Settles the stay, cancels the keys and releases the holds.",
        "submit": "Check out",
        "done": "Checked out",
        "failed": "The check-out was refused",
        "summary": "{keys} key(s) cancelled, {holds} hold(s) released",
        "outstandingNote": "This folio still has a balance. Checking out over it needs a reason and opens a queue item for somebody to chase."
      },
      "assign": {
        "title": "Assign a room",
        "action": "Assign",
        "description": "Pre-assign a room before the guest arrives.",
        "submit": "Assign",
        "done": "Room assigned",
        "failed": "The assignment was refused",
        "reasonHint": "Why this room and not another one.",
        "rationaleNote": "The rationale is stored on the assignment. \"Why did this guest get this room\" is a question asked days later."
      },
      "roomMove": {
        "title": "Move room",
        "action": "Move",
        "description": "Moves the guest mid-stay, atomically.",
        "submit": "Move",
        "done": "Moved from {from} to {to}",
        "summary": "{repriced} night(s) repriced, {untouched} left alone",
        "failed": "The move was refused",
        "fromRoom": "From",
        "toRoom": "To",
        "repriceLabel": "Reprice the remaining nights",
        "repriceHint": "Off leaves the rate as booked — the property absorbs the difference.",
        "postedNote": "Nights that have already been posted are never repriced. Correct one of those by reversing its charge."
      },
      "registration": {
        "title": "Registration card",
        "description": "Read the travel document, then confirm each field.",
        "uploadLabel": "Document image or PDF",
        "uploadHint": "The extraction reads it and writes nothing. You confirm what it read.",
        "extracting": "Reading the document…",
        "empty": "No document has been read yet. Upload one, or type the card by hand.",
        "noGuest": "This reservation has no guest attached, so there is no profile to read a document into. Attach a guest first.",
        "confirmNote": "Nothing below is confirmed until you tick it. A field the model was unsure about is highlighted — check it against the document in your hand.",
        "confirm": "Confirmed",
        "confidenceFor": "Confidence for {field}",
        "overall": "Overall confidence",
        "lowCount": "{count} field(s) read with low confidence",
        "extractFailed": "The document could not be read",
        "signatureLabel": "Signature captured",
        "signatureHint": "Records that the guest signed the card."
      },
      "holds": {
        "title": "Authorisation holds",
        "description": "Card authorisations taken against this folio.",
        "caption": "Authorisation holds on this folio",
        "empty": "No authorisation has been taken on this folio.",
        "loadFailed": "The holds could not be loaded",
        "release": "Release",
        "released": "Hold released",
        "releaseFailed": "The hold could not be released"
      },
      "keys": {
        "title": "Keys",
        "description": "Keys issued for this stay. A key is an event, not a lock.",
        "caption": "Keys issued for this stay",
        "empty": "No key has been issued for this stay.",
        "noStay": "This folio has no reservation behind it, so it has no keys.",
        "loadFailed": "The keys could not be loaded",
        "cancel": "Cancel",
        "cancelled": "Key cancelled",
        "cancelFailed": "The key could not be cancelled"
      },
      "folios": {
        "title": "Folios",
        "description": "Every guest bill in the property, open and settled.",
        "tableTitle": "Folios",
        "caption": "Folios for the chosen property",
        "empty": "No folio matches these filters. A stay's folio opens at check-in; a walk-in or house folio is created here.",
        "loadFailed": "The folios could not be loaded",
        "chooseProperty": "Choose a legal entity and a property to see its folios.",
        "searchLabel": "Search",
        "searchPlaceholder": "Folio number or guest",
        "create": "New folio",
        "createDescription": "A walk-in or house folio — one with no reservation behind it.",
        "created": "Folio opened",
        "createFailed": "The folio could not be opened"
      },
      "folio": {
        "description": "The guest's bill. Charges are append-only; a correction is a reversal.",
        "summary": "Folio",
        "loadFailed": "The folio could not be loaded",
        "tabsLabel": "Folio windows and panels",
        "tabRouting": "Routing",
        "tabDeposits": "Deposits and settlements",
        "tabDesk": "Keys and holds",
        "postCharge": "Post a charge",
        "settle": "Settle",
        "cityLedger": "To the city ledger",
        "allowance": "Allowance",
        "transfer": "Transfer",
        "addWindow": "Add a window",
        "addWindowDescription": "A window is a separate balance owed by a separate party.",
        "windowAdded": "Window added",
        "windowFailed": "The window could not be added",
        "invoice": "Invoice PDF",
        "invoiceFailed": "The invoice could not be produced",
        "closedNote": "This folio is closed. Charges and settlements are read-only; a charge arriving now is a late charge and opens a new window."
      },
      "ledger": {
        "caption": "Charges on the {window} window",
        "empty": "Nothing has been charged to this window yet.",
        "reverse": "Reverse",
        "windowBalance": "Window balance"
      },
      "postCharge": {
        "title": "Post a charge",
        "description": "Adds one charge to a folio window.",
        "submit": "Post",
        "done": "Charge posted",
        "split": "The routing rules split it across {count} windows.",
        "failed": "The charge was refused",
        "dateHint": "Blank means the property's own business date.",
        "netHint": "The amount before tax, as a decimal string.",
        "taxHint": "Leave blank and the tax engine solves it from the tax code.",
        "taxCodeHint": "Every charge carries a tax code or an item tax group. There is no unclassified charge.",
        "routingNote": "The routing rules decide which window this lands on, and may split it if a cap has less headroom than the amount.",
        "lateNote": "This folio has been settled, so this is a late charge."
      },
      "reverse": {
        "title": "Reverse a charge",
        "description": "The only way to correct a posted charge. It writes a mirror row; the original stays.",
        "submit": "Reverse",
        "done": "Charge reversed",
        "failed": "The reversal was refused",
        "reasonLabel": "Why is this being reversed",
        "exactNote": "A reversal is the exact negation of the charge above. There is no partial reversal — for part of a charge, reverse it and post the correct amount."
      },
      "settle": {
        "title": "Settle the folio",
        "description": "One line per window that still has a balance.",
        "caption": "Windows to settle",
        "submit": "Settle",
        "done": "Folio settled",
        "failed": "The settlement was refused",
        "empty": "Every window on this folio is already settled.",
        "includeLabel": "Settle the {window} window",
        "accountPlaceholder": "Where did the money land",
        "dateHint": "Blank means the property's own business date.",
        "keepOpenLabel": "Keep the folio open",
        "keepOpenHint": "For a departing guest whose legal entity is being invoiced and whose late charges are still to come.",
        "routedNote": "Three methods do something a settlement does not, and each has its own action:",
        "settledTitle": "Settlements",
        "settledCaption": "Settlements already posted to this folio",
        "settledEmpty": "Nothing has been settled on this folio yet."
      },
      "cityLedger": {
        "title": "Transfer to the city ledger",
        "description": "Raises a real receivable against the legal entity the window is billed to.",
        "submit": "Transfer",
        "done": "Transferred to the city ledger",
        "failed": "The transfer was refused",
        "amountHint": "Blank transfers the whole window balance.",
        "receivableNote": "This raises an accounts-receivable invoice. It is not a bookkeeping gesture inside the property — the legal entity will be chased for it."
      },
      "allowance": {
        "title": "Post an allowance",
        "description": "Writes an amount off a folio window.",
        "submit": "Post the allowance",
        "done": "Allowance posted",
        "failed": "The allowance was refused",
        "reasonLabel": "Why is this being written off",
        "taxCodeHint": "Blank reverses the tax the same way the original charge carried it.",
        "controlNote": "An allowance is money the property gives up. It is approved, it opens a queue item, and whoever posts it must not be the person who then closes the day."
      },
      "transfer": {
        "title": "Transfer to another folio",
        "description": "Moves a window's balance to a different folio — a group master, usually.",
        "submit": "Transfer",
        "done": "Balance transferred",
        "failed": "The transfer was refused",
        "targetHint": "The folio id it is moving to. Take it from the paperwork, not from a guess.",
        "amountHint": "Blank moves the whole window balance.",
        "pairNote": "This writes two charges — one out of this folio and one into the other — and both stay visible on both."
      },
      "routing": {
        "title": "Routing rules",
        "description": "What lands on which window, in order, and up to how much.",
        "caption": "Routing rules for this folio",
        "empty": "No routing rule. Every charge lands on the guest window.",
        "add": "Add a rule",
        "remove": "Remove",
        "moveUp": "Move earlier",
        "moveDown": "Move later",
        "saved": "Routing rules saved",
        "failed": "The routing rules were refused",
        "loadFailed": "The routing rules could not be loaded"
      },
      "deposits": {
        "title": "Deposits",
        "description": "Money taken before a stay, and what became of it.",
        "tableTitle": "Deposits",
        "caption": "Deposits for the chosen property",
        "folioDescription": "Deposits held against this folio.",
        "empty": "No deposit is held against this folio.",
        "emptyList": "No deposit matches these filters.",
        "goToRegister": "Open the deposit register",
        "loadFailed": "The deposits could not be loaded",
        "chooseProperty": "Choose a legal entity and a property to see its deposits.",
        "searchLabel": "Search",
        "take": "Take a deposit",
        "takeDescription": "Records money actually received. It posts to the bank and to the deposits-held liability.",
        "taken": "Deposit recorded",
        "apply": "Apply",
        "applyTitle": "Apply a deposit",
        "applyDescription": "Moves the deposit onto a folio window.",
        "applied": "Deposit applied",
        "refund": "Refund",
        "refundTitle": "Refund a deposit",
        "refundDescription": "Returns what is left of the deposit to the guest.",
        "refunded": "Deposit refunded",
        "failed": "The deposit could not be updated",
        "amountHint": "Blank means all of what is left.",
        "wholeNote": "Leaving the amount blank applies or refunds everything remaining. The server refuses more than the deposit still holds."
      },
      "nightAudit": {
        "title": "Night audit",
        "description": "Post the day, roll the date, and produce the pack an auditor reads.",
        "chooseProperty": "Choose a legal entity and a property to see whether it can roll.",
        "dateHint": "Blank means the property's own business date.",
        "readinessTitle": "Readiness",
        "readinessDescription": "Every check the roll makes, blockers first.",
        "readinessFailed": "The readiness checks could not be run",
        "ready": "Ready to roll.",
        "blocked": "{count} blocking check(s) must be cleared, or the roll must be forced.",
        "checkBlocking": "Blocking",
        "checkAdvisory": "Advisory",
        "checkPassed": "Passed",
        "checksEmpty": "No readiness check ran.",
        "start": "Start the night",
        "startHint": "Idempotent — a second start returns the run already in flight.",
        "started": "Night audit started",
        "startFailed": "The night audit could not be started",
        "runsTitle": "Runs",
        "runsDescription": "Every night this legal entity has rolled.",
        "runsCaption": "Night audit runs",
        "runsEmpty": "No night has been rolled for this legal entity yet.",
        "runsFailed": "The runs could not be loaded",
        "runFailed": "The run could not be loaded",
        "runDescription": "Ten steps, the journal they posted, and the day pack.",
        "runSummary": "Run",
        "backToBoard": "Back to the board",
        "advance": "Run the next step",
        "advancing": "Running the step",
        "advanceFailed": "The step was refused",
        "stepsTitle": "Steps",
        "stepsDescription": "Each step is committed separately, so a run that dies resumes where it stopped.",
        "durationMs": "{ms} ms",
        "force": "Force",
        "forceTitle": "Force the roll",
        "forceDescription": "Proceeds past a blocking readiness check.",
        "forceSubmit": "Force the roll",
        "forceWarning": "Forcing posts the day over a control that refused. The run is stamped as forced for as long as it exists, and a queue item opens for somebody to answer for it.",
        "forceReasonLabel": "Why is the roll being forced",
        "forceNoBlockers": "Nothing is blocking this run.",
        "forced": "Run forced",
        "forceFailed": "The roll could not be forced",
        "forcedBadge": "Forced",
        "forcedNote": "This run was forced: {reason}.",
        "forcedQueueLink": "Open the queue item",
        "abandon": "Abandon",
        "abandonTitle": "Abandon this run",
        "abandonDescription": "Stops the run. A new one has to be started for this date.",
        "abandoned": "Run abandoned",
        "abandonFailed": "The run could not be abandoned",
        "abandonedNote": "This run was abandoned: {reason}. Start a new run for this date.",
        "journalTitle": "The journal it posted",
        "journalDescription": "The lines as the run built them, and the entry they became.",
        "journalCaption": "Night audit journal lines",
        "journalEmpty": "This run has not built its journal lines yet.",
        "journalLink": "Open journal entry #{id}",
        "revenueTotals": "Revenue recorded by the run (net, gross)",
        "checks": {
          "unpostedNights": "In-house rooms with an unposted night",
          "arrivalsPending": "Confirmed arrivals that have not checked in",
          "departuresDue": "Departures still in house",
          "departedOpenFolios": "Departed guests with an open folio",
          "posDayUnswept": "Point-of-sale days not yet closed",
          "unroutedCharges": "Charges that matched no routing rule",
          "outOfOrderExpired": "Out-of-order rooms past their release date",
          "periodOpen": "The accounting period is open"
        }
      },
      "dayPack": {
        "title": "Day pack",
        "description": "The evidence bundle, and the hash that makes it evidence.",
        "caption": "Parts of the day pack",
        "manifestHash": "Manifest hash",
        "downloadedHash": "Hash of the file you downloaded",
        "part": "Part",
        "contentType": "Type",
        "rows": "Rows",
        "bytes": "Bytes",
        "sha256": "SHA-256",
        "partsEmpty": "The pack has no parts recorded.",
        "pending": "The day pack is built at step 9. It is not available yet.",
        "download": "Download the pack",
        "downloadFailed": "The pack could not be downloaded",
        "noHash": "The download did not return its attestation hash. Compare it against the manifest above before relying on the file."
      },
      "channels": {
        "title": "Channels",
        "description": "The distribution channels this legal entity sells through.",
        "tableTitle": "Channels",
        "caption": "Distribution channels",
        "empty": "No channel is configured for this legal entity.",
        "loadFailed": "The channels could not be loaded",
        "chooseCompany": "Choose a legal entity to see its channels.",
        "searchLabel": "Search",
        "create": "New channel",
        "createTitle": "New channel",
        "editTitle": "Edit channel",
        "dialogDescription": "Who sells the rooms, and how the exchange happens.",
        "saved": "Channel saved",
        "saveFailed": "The channel could not be saved",
        "adapterManual": "Manual — somebody pastes the exchange in",
        "adapterFile": "File — an exchange file is picked up from storage",
        "adapterHint": "Only registered adapters are offered; an unknown one stops the server at boot.",
        "adapterNote": "The adapter is the first thing to check when nothing has arrived: manual waits for a person, file waits for a file.",
        "toleranceHint": "How far the channel's price may drift from the reference plan before it counts as a breach.",
        "detailDescription": "What it is, what it last exchanged, and how to exchange again.",
        "summary": "Channel",
        "backToList": "Back to channels",
        "exchangeTitle": "Exchange",
        "exchangeDescription": "Push rates out, or pull bookings and commission in.",
        "exchangeSummary": "{rows} row(s): {accepted} accepted, {rejected} rejected",
        "push": "Push",
        "pushed": "Pushed",
        "pushFailed": "The push failed",
        "pull": "Pull",
        "pulled": "Pulled",
        "pullFailed": "The pull failed",
        "directionNote": "A push sends rates, restrictions or availability out. A pull brings bookings and commission in. A booking is never pushed.",
        "exchangesTitle": "Exchange log",
        "exchangesCaption": "Exchanges with this channel",
        "exchangesEmpty": "Nothing has been exchanged with this channel yet.",
        "exchangesFailed": "The exchange log could not be loaded",
        "ingestionTitle": "Ingestion queue",
        "ingestionDescription": "Bookings this channel sent that the ingest refused, newest exchange first.",
        "ingestionCaption": "Refused inbound bookings, with the channel's own reference and the reason each was refused.",
        "ingestionNote": "Correct the row at the channel and pull again. The ingest is idempotent on the channel reference, so a booking that already arrived is not created a second time."
      },
      "parity": {
        "title": "Rate parity",
        "description": "What a channel is showing, against what it should be.",
        "tableTitle": "Observations",
        "caption": "Rate parity observations",
        "empty": "No observation has been recorded.",
        "loadFailed": "The observations could not be loaded",
        "recordTitle": "Record an observation",
        "recordDescription": "What you saw on the channel, and when you saw it.",
        "record": "Record",
        "recorded": "Observation recorded",
        "recordFailed": "The observation was refused",
        "breachedOnly": "Breaches only",
        "breach": "Parity",
        "breached": "Breached",
        "withinTolerance": "Within tolerance",
        "serverNote": "The deviation and the breach are computed against the channel's reference plan and its own tolerance. Neither is worked out in the browser."
      },
      "agreements": {
        "title": "Commission agreements",
        "description": "One agreement per channel, and terms that are versioned rather than edited.",
        "tableTitle": "Agreements",
        "caption": "Commission agreements",
        "empty": "No agreement is recorded for this legal entity.",
        "loadFailed": "The agreements could not be loaded",
        "chooseCompany": "Choose a legal entity to see its agreements.",
        "create": "New agreement",
        "createDescription": "A code and a name. The terms live on its versions.",
        "created": "Agreement created",
        "createFailed": "The agreement could not be created",
        "statusVocab": "Agreement statuses: {statuses}",
        "detailDescription": "The agreement, and every version of its terms.",
        "backToList": "Back to agreements",
        "frozenNote": "A published version is frozen. Every accrual records the version it was computed under, so changing terms means adding a version — never editing one.",
        "newVersion": "New version",
        "newVersionDescription": "Terms effective from a date. Save it as a draft, then publish it.",
        "versionCreated": "Version created",
        "versionFailed": "The version was refused",
        "versionsTitle": "Version history",
        "versionsDescription": "Newest first. A published version has no editable field.",
        "versionsCaption": "Commission agreement versions",
        "versionsEmpty": "This agreement has no version yet, so nothing accrues against it.",
        "versionsFailed": "The versions could not be loaded",
        "publish": "Publish",
        "published": "Version published",
        "publishFailed": "The version could not be published"
      },
      "accruals": {
        "title": "Commission accruals",
        "description": "What the night audit accrued, per reservation.",
        "tableTitle": "Accruals",
        "caption": "Commission accruals",
        "empty": "No commission has been accrued for these filters.",
        "loadFailed": "The accruals could not be loaded",
        "serverNote": "Every figure is the one the accrual posted with. The variance is set by the statement match, on the other side."
      },
      "statements": {
        "title": "Commission statements",
        "description": "What the channels say they are owed, and what we say.",
        "tableTitle": "Statements",
        "caption": "Commission statements",
        "empty": "No statement has been imported.",
        "loadFailed": "The statements could not be loaded",
        "import": "Import a statement",
        "importTitle": "Import a statement",
        "importDescription": "Paste the statement's lines. Tab-separated, as a spreadsheet copies them.",
        "imported": "Statement imported",
        "importFailed": "The import was refused",
        "declaredHint": "The total the channel states. It is compared with what we match, never re-added here.",
        "pasteLabel": "Statement lines",
        "pasteHint": "Reference, guest, arrival, departure, room revenue, commission — one line each, separated by tabs.",
        "parsedCount": "{count} line(s) will be imported.",
        "detailDescription": "The statement's lines, and the matches the scorer suggests.",
        "backToList": "Back to statements",
        "summary": "Statement",
        "linesTitle": "Lines",
        "linesCaption": "Statement lines",
        "linesEmpty": "This statement has no lines."
      },
      "match": {
        "title": "Match review",
        "description": "The server's ranked candidates for the chosen line.",
        "caption": "Suggested matches",
        "chooseLine": "Choose a line to review its candidates.",
        "noSuggestions": "The scorer found no candidate for this line. Check the channel reference, or write the line off with a reason.",
        "review": "Review",
        "accept": "Match",
        "matched": "Line matched",
        "matchFailed": "The match was refused",
        "scorerNote": "The confidence, the match type and the variance are the reconciliation engine's own output, shown exactly as it produced them.",
        "writeOff": "Write off",
        "writeOffTitle": "Write off this line",
        "writeOffDescription": "Accepts the channel's figure and closes the difference.",
        "writeOffReasonLabel": "Why is this being written off",
        "writeOffHint": "Only when there is genuinely nothing to match it to.",
        "writtenOff": "Line written off",
        "writeOffFailed": "The write-off was refused",
        "noPermission": "You may see the statement but not the scorer's candidates. That needs pms.commission.match."
      },
      "services": {
        "title": "Services",
        "description": "What the property sells besides a room.",
        "tableTitle": "Service catalogue",
        "caption": "Ancillary services",
        "empty": "No service is on this property's catalogue.",
        "loadFailed": "The services could not be loaded",
        "chooseProperty": "Choose a legal entity and a property to see its catalogue.",
        "searchLabel": "Search",
        "create": "New service",
        "createTitle": "New service",
        "editTitle": "Edit service",
        "dialogDescription": "What it is, how long it takes, and how it is billed.",
        "saved": "Service saved",
        "saveFailed": "The service could not be saved",
        "itemHint": "The inventory item it sells as. That is where its tax group lives.",
        "leadHint": "How far ahead it has to be booked.",
        "cancelHint": "How late it can be cancelled without a charge.",
        "mealHint": "Set it and a guest on board can eat it against their allowance.",
        "noMealPeriod": "Not covered by board",
        "boardNote": "A service with a meal period draws a board allowance when it is delivered to a guest who has one, instead of billing them."
      },
      "schedule": {
        "title": "Service schedule",
        "description": "The day, grouped by the resource that has to be there.",
        "caption": "Bookings on {resource}",
        "empty": "Nothing is scheduled on this date.",
        "loadFailed": "The schedule could not be loaded",
        "chooseProperty": "Choose a legal entity and a property to see its schedule.",
        "unassigned": "Not assigned to a resource"
      },
      "bookings": {
        "title": "Book a service",
        "description": "Reserves a slot. Nothing is charged until it is delivered.",
        "submit": "Book",
        "created": "Booking created",
        "failed": "The booking was refused",
        "reservationHint": "Without a stay, the charge has no folio to route to.",
        "priceHint": "Blank uses the service's own price.",
        "deliveryNote": "Delivering the booking posts the folio charge, draws any board allowance and depletes stock — all at once.",
        "deliver": "Deliver",
        "delivered": "Delivered",
        "deliverFailed": "The delivery was refused",
        "cancelled": "Booking cancelled",
        "cancelFailed": "The booking could not be cancelled"
      },
      "itinerary": {
        "title": "Itinerary",
        "description": "What this guest has booked, and anything that clashes.",
        "caption": "Itinerary for the stay",
        "empty": "This stay has nothing booked.",
        "chooseStay": "Enter a reservation id to see its itinerary.",
        "loadFailed": "The itinerary could not be loaded",
        "lookupTitle": "Look up an itinerary",
        "lookupDescription": "By reservation."
      },
      "boardPlans": {
        "title": "Board plans",
        "description": "Half board, full board, all inclusive — and what each entitles a guest to.",
        "tableTitle": "Board plans",
        "caption": "Board plans",
        "empty": "This property has no board plan.",
        "loadFailed": "The board plans could not be loaded",
        "chooseProperty": "Choose a legal entity and a property to see its board plans.",
        "create": "New board plan",
        "createDescription": "A code and a name. Add its entitlements next.",
        "created": "Board plan created",
        "createFailed": "The board plan could not be created",
        "editEntitlements": "Entitlements",
        "entitlementsTitle": "Entitlements — {plan}",
        "entitlementsDescription": "What a guest gets per person per night, and what it is worth to F&B.",
        "entitlementsCaption": "Board plan entitlements",
        "entitlementsEmpty": "This plan entitles a guest to nothing yet.",
        "entitlementsSaved": "Entitlements saved",
        "entitlementsFailed": "The entitlements were refused",
        "addEntitlement": "Add an entitlement",
        "transferPriceNote": "Every entitlement needs a transfer price. It is the amount carved out of the room rate and credited to F&B when the guest eats — without it, the department that served the meal is paid nothing for it.",
        "activate": "Activate",
        "activated": "Board plan activated",
        "activateFailed": "The board plan could not be activated",
        "unpricedHint": "Every entitlement needs a transfer price before this plan can go live."
      },
      "unconsumed": {
        "title": "Unconsumed allowances",
        "description": "Board that was granted and never eaten — the breakage.",
        "tableTitle": "Unconsumed allowances",
        "caption": "Board allowances granted and not drawn",
        "empty": "Every allowance granted has been drawn.",
        "loadFailed": "The report could not be loaded",
        "chooseProperty": "Choose a legal entity and a property to run the report.",
        "breakageNote": "The carve-out has already moved from rooms to F&B at the transfer price. What is left here is what F&B was paid for and did not serve."
      },
      "transfers": {
        "title": "Transfers",
        "description": "Boats, seaplanes and vans — the legs and who is on them.",
        "tableTitle": "Transfer legs",
        "caption": "Transfer legs",
        "empty": "No transfer leg is planned for this property.",
        "loadFailed": "The legs could not be loaded",
        "chooseProperty": "Choose a legal entity and a property to see its transfers.",
        "create": "New leg",
        "createDescription": "When it leaves, when it arrives, and how many it takes.",
        "created": "Leg created",
        "createFailed": "The leg was refused",
        "addBooking": "Add a guest",
        "addBookingDescription": "Puts a reservation's party on this leg.",
        "added": "Added to the leg",
        "addFailed": "The booking was refused",
        "partyHint": "Guests sharing a party key travel together.",
        "splitHint": "Only needed when this splits a party that is travelling together.",
        "manifest": "Manifest",
        "manifestTitle": "Manifest — {leg}",
        "manifestDescription": "Who is on this leg. This is what the skipper carries.",
        "manifestCaption": "Transfer manifest",
        "manifestEmpty": "Nobody is booked on this leg.",
        "manifestFailed": "The manifest could not be loaded"
      },
      "requests": {
        "title": "Guest requests",
        "description": "Requests and complaints, worst and oldest first.",
        "tableTitle": "Queue",
        "caption": "Guest requests and complaints",
        "empty": "Nothing is in the queue for these filters.",
        "loadFailed": "The queue could not be loaded",
        "chooseProperty": "Choose a legal entity and a property to work the queue.",
        "log": "Log a request",
        "logDescription": "What the guest asked for, or what went wrong.",
        "logged": "Request logged",
        "logFailed": "The request could not be logged",
        "escalate": "Escalate",
        "escalated": "Request escalated",
        "escalateTitle": "Escalate the request",
        "escalateDescription": "Why it could not be settled here, and what the duty manager is being handed.",
        "close": "Close",
        "closed": "Request closed",
        "closeTitle": "Close the request",
        "closeDescription": "How it ended, and — for a service failure — what caused it.",
        "statusFailed": "The outcome could not be recorded",
        "closeNeedsCause": "A service failure is closed with its cause recorded, so that what went wrong can be counted.",
        "recoveredLocked": "This request already carries a recovery. Record its outcome from the recovery instead — setting it here would overwrite what was given away."
      },
      "recovery": {
        "title": "Service recovery",
        "action": "Recover",
        "description": "What was done to put it right, and why it went wrong.",
        "submit": "Record the recovery",
        "done": "Recovery recorded",
        "failed": "The recovery was refused",
        "causeLabel": "What caused this",
        "folioHint": "Which folio the allowance lands on. Blank uses the stay's own.",
        "allowanceNote": "An allowance is real money. It is checked against your authority and posts to the guest's folio.",
        "outcomeUnchanged": "Leave the status as it is",
        "outcomeHint": "Recording the outcome here is the only way to settle a request that carries a recovery."
      },
      "reports": {
        "title": "Property reports",
        "description": "Occupancy, rate metrics, who is in house, the guest ledger and the day’s posted revenue.",
        "chooseProperty": "Choose a legal entity and a property to run these reports.",
        "dateHint": "Leave empty for the property’s current business date, resolved in the workspace timezone.",
        "tabsLabel": "Property reports",
        "tabOccupancy": "Occupancy",
        "tabAdrRevpar": "ADR and RevPAR",
        "tabInHouse": "In house",
        "tabLedger": "Guest ledger",
        "tabDaily": "Daily operating",
        "loadFailed": "That report could not be loaded",
        "exported": "Report exported",
        "exportFailed": "That report could not be exported",
        "occupancyCaption": "Rooms, movement and occupancy per room type",
        "occupancyEmpty": "No room types are configured for this property yet.",
        "adrCaption": "Average daily rate and revenue per available room, per room type",
        "postedNote": "ADR and RevPAR are computed from what was posted, not from the rate plan — the difference is the allowances, the board carve-out and the rate overrides.",
        "inHouseCaption": "Every stay resident tonight, with its folio balance",
        "inHouseEmpty": "Nobody is in house on this date.",
        "posted": "Posted",
        "notPosted": "Not posted",
        "ledgerDescription": "Opening, charges, settlements and closing per folio for the date.",
        "ledgerCaption": "The guest-ledger roll-forward per folio",
        "ledgerEmpty": "No folio moved on this date.",
        "ledgerNote": "Each figure is the balance the server carried; nothing on this screen is added up in the browser.",
        "dailyCaption": "The day’s revenue as the night audit posted it",
        "dailyEmpty": "The night audit has not posted revenue for this date.",
        "dailyNote": "These are the rows the night audit built its journal from, so this report and the general ledger cannot diverge.",
        "noRunNote": "No night audit has run for this date, so nothing has been posted yet.",
        "openRun": "Open the night audit run"
      },
      "channelPull": {
        "title": "Pull from {channel}",
        "description": "Bring bookings or a commission statement in from this channel's file.",
        "what": "What to pull",
        "commissionStatement": "Commission statement",
        "file": "CSV file",
        "fileHintBookings": "The channel's booking export, one booking per row.",
        "fileHintCommission": "The channel's commission statement, one stay per row.",
        "statementNo": "Statement number",
        "periodFrom": "Period from",
        "periodTo": "Period to",
        "currency": "Currency",
        "currencyHint": "The three-letter code the statement is in, for example MVR or USD.",
        "failedNote": "The file was recorded but could not be read. Correct it and pull again.",
        "done": "Done",
        "manualNote": "This channel uses the manual adapter, so there is no file to pull. Enter bookings as reservations and commission statements on the commission screen, or switch the channel to the file adapter."
      }
    },
    "housekeeping": {
      "routeTitles": {
        "boards": "Housekeeping boards",
        "rooms": "Room status",
        "faults": "Fault queue",
        "outOfOrder": "Out of order"
      },
      "fields": {
        "property": "Property",
        "businessDate": "Business date",
        "attendant": "Attendant",
        "attendantId": "Attendant employee id",
        "attendantIdHint": "The picker needs hr.employee.read, which this account does not hold. Enter the employee id instead.",
        "section": "Section",
        "noSection": "No section",
        "creditTarget": "Credit target",
        "creditTargetHint": "A decimal with up to four places, e.g. 10.0000. Leave blank to accept the property default.",
        "creditShape": "Enter a number with up to four decimal places, e.g. 10.0000.",
        "assignedCredit": "Credit assigned",
        "completedCredit": "Credit done",
        "category": "Category",
        "severity": "Severity",
        "description": "Description",
        "reportedOn": "Reported",
        "guestMove": "Guest",
        "resolutionNote": "What was done",
        "outcome": "Outcome",
        "source": "Opened by"
      },
      "boardStatus": {
        "planned": "Planned",
        "released": "Released",
        "in_progress": "In progress",
        "complete": "Complete"
      },
      "taskKind": {
        "departure": "Departure clean",
        "stayover": "Stayover",
        "turndown": "Turndown",
        "deep_clean": "Deep clean",
        "inspection": "Inspection"
      },
      "taskStatus": {
        "pending": "Not started",
        "in_progress": "In progress",
        "done": "Done",
        "skipped": "Skipped"
      },
      "roomStatus": {
        "dirty": "Dirty",
        "cleaning": "Being cleaned",
        "clean": "Cleaned",
        "inspected": "Inspected"
      },
      "roomStatusHelp": {
        "dirty": "Nobody has started this room.",
        "cleaning": "Part-way through. NOT ready for a guest.",
        "clean": "Cleaning finished; still needs inspecting.",
        "inspected": "Checked by a supervisor. Ready to sell."
      },
      "occupancy": {
        "vacant": "Vacant",
        "occupied": "Occupied"
      },
      "faultCategory": {
        "plumbing": "Plumbing",
        "electrical": "Electrical",
        "hvac": "Air conditioning",
        "furniture": "Furniture",
        "appliance": "Appliance",
        "structural": "Structural",
        "safety": "Safety",
        "other": "Something else"
      },
      "faultSeverity": {
        "minor": "Minor",
        "major": "Major",
        "blocking": "Room unusable"
      },
      "faultStatus": {
        "open": "Open",
        "triaged": "Triaged",
        "in_repair": "In repair",
        "resolved": "Resolved",
        "rejected": "Rejected"
      },
      "outOfOrderSource": {
        "manual": "A person",
        "housekeeping": "A housekeeping fault",
        "eam": "Maintenance"
      },
      "boards": {
        "title": "Housekeeping boards",
        "description": "One day's cleaning, dealt out and balanced by credit rather than by room count — a departure clean of a villa costs more than a stayover of a standard room.",
        "chooseProperty": "Choose a property and a business date to see its boards.",
        "loadFailed": "The boards could not be loaded.",
        "empty": "No boards for this property on this date. The daily generation job deals them out; create one here to stand a board up ahead of it.",
        "attendant": "Attendant {id}",
        "noTasks": "Nothing on this board yet.",
        "create": "New board",
        "createDescription": "A board shell for one attendant, ahead of the daily generation job.",
        "created": "Board created.",
        "createFailed": "The board could not be created.",
        "release": "Release to the attendant",
        "released": "Board released.",
        "releaseFailed": "The board could not be released.",
        "moveTo": "Move to…",
        "moveTaskTo": "Move task {id} to another board",
        "moved": "Task moved.",
        "moveFailed": "That task could not be moved.",
        "unassignedTitle": "Not on any board",
        "unassignedLead": "Nobody had the credit headroom for these, so the generation left them unassigned rather than overfilling somebody. Raise a target or add a board, and the next generation will place them."
      },
      "rooms": {
        "title": "Room status",
        "description": "The floor as it stands: dirty, being cleaned, cleaned, inspected. A room that is only being cleaned is not ready for a guest.",
        "chooseProperty": "Choose a property to see its rooms.",
        "loadFailed": "The rooms could not be loaded.",
        "empty": "No rooms match this filter.",
        "legendTitle": "What the four states mean",
        "allStatuses": "Every status",
        "filterByStatus": "Filter by housekeeping status",
        "setTo": {
          "dirty": "Mark dirty",
          "cleaning": "Start cleaning",
          "clean": "Finish cleaning"
        },
        "statusSet": "Room {room} is now {status}.",
        "statusFailed": "That status could not be set.",
        "inspect": "Inspect",
        "inspected": "Room {room} inspected.",
        "inspectFailed": "That room could not be inspected.",
        "inspectSeparate": "Inspecting a room is a separate authority from cleaning it, and this account does not hold it. The attendant who cleaned a room must not be the one who certifies it."
      },
      "faults": {
        "title": "Fault queue",
        "description": "Faults reported from a tablet in the room, from the desk, and — later — from maintenance. A fault has an owner, not an approver.",
        "chooseProperty": "Choose a property to see its faults.",
        "loadFailed": "The fault queue could not be loaded.",
        "empty": "No faults match this filter.",
        "tableTitle": "Faults ({count} still open)",
        "caption": "Room faults for this property",
        "allStatuses": "Every status",
        "allSeverities": "Every severity",
        "filterByStatus": "Filter by fault status",
        "filterBySeverity": "Filter by severity",
        "guestMove": "Move the guest",
        "attachment": "Photo",
        "attachmentFailed": "That photo could not be opened.",
        "report": "Report a fault",
        "reportDescription": "The same report a tablet files from the doorway, for the times there is no tablet.",
        "reported": "Fault reported.",
        "reportFailed": "That fault could not be reported.",
        "blockingOnReport": "A blocking fault takes the room out of use as soon as it is triaged. If a guest is in it, front desk has to move them.",
        "triage": "Triage",
        "triageTitle": "Triage the fault in room {room}",
        "triageDescription": "Confirm what is wrong and how bad it is, or reject the report.",
        "triaged": "Room {room}'s fault triaged.",
        "outcomeTriage": "Accept it",
        "outcomeReject": "Reject the report",
        "blockingConsequence": "Confirming this takes the room out of order from now until the fault is resolved. It stops being sellable, and a guest already in it has to be moved.",
        "rejectConsequence": "Rejecting records that the report is not actionable — a duplicate, or not a fault. No out-of-order record is opened and none already open is touched.",
        "resolve": "Resolve",
        "resolveTitle": "Resolve the fault in room {room}",
        "resolveDescription": "The repair is done and the room can go back into use.",
        "resolveConsequence": "Resolving releases any out-of-order record this fault opened, and the nights it covered return to availability.",
        "resolved": "Room {room}'s fault resolved.",
        "actionFailed": "That could not be saved."
      },
      "outOfOrder": {
        "title": "Out of order",
        "description": "Room by date: which nights the property has decided not to sell, and which rooms are merely flagged.",
        "chooseProperty": "Choose a property to see its out-of-order calendar.",
        "loadFailed": "The out-of-order records could not be loaded.",
        "empty": "No room is out of order or out of service in this window.",
        "calendarTitle": "Calendar",
        "caption": "Rooms out of order or out of service, by date",
        "recordsTitle": "Open records",
        "recordsCaption": "Open out-of-order records for this property",
        "legendTitle": "What the two kinds do",
        "consequenceOutOfOrder": "Removes the room from the availability count. Nobody can sell it, and every night it covers is a night the property has decided to lose.",
        "consequenceOutOfService": "Leaves the room sellable and flags it. The right answer for cosmetic work; the wrong answer for a room with no water.",
        "shortOutOfOrder": "OOO",
        "shortOutOfService": "OOS",
        "create": "Take a room out",
        "previous": "Earlier",
        "next": "Later",
        "release": "Release",
        "released": "Room released back into availability.",
        "releaseFailed": "That record could not be released."
      }
    },
    "messageChannel": {
      "email": "Email",
      "sms": "SMS",
      "in_app": "In app",
      "print": "Printed"
    },
    "messagePurpose": {
      "confirmation": "Confirmation",
      "pre_arrival": "Pre-arrival",
      "in_stay": "In stay",
      "departure": "Departure",
      "marketing": "Marketing"
    },
    "messageStatus": {
      "pending": "Pending",
      "rendered": "Rendered",
      "sent": "Sent",
      "suppressed": "Suppressed",
      "failed": "Failed"
    },
    "messages": {
      "title": "Messages",
      "description": "What this property has written to this guest, and what consent allowed.",
      "caption": "Outbound messages recorded for this guest",
      "empty": "Nothing has been written to this guest yet.",
      "loadFailed": "The messages could not be loaded",
      "composeTitle": "Record a message",
      "composeDescription": "Recording a message asks the consent gate first; a refusal is stored, never dropped.",
      "channel": "Channel",
      "purpose": "Purpose",
      "subject": "Subject",
      "body": "Message",
      "bodyHint": "What was, or is to be, sent to the guest.",
      "consentNote": "Consent is checked as this is recorded. A message the guest has not consented to is kept as suppressed, with the reason.",
      "record": "Record message",
      "recorded": "Message recorded",
      "suppressed": "Recorded, but not sent",
      "suppressedNoReason": "No reason was recorded",
      "failed": "That message could not be recorded",
      "sentAt": "Sent at",
      "markSent": "Mark sent",
      "markedSent": "Marked as sent",
      "markFailed": "That message could not be marked sent"
    },
    "queue": {
      "availability_drift": "Room availability differs from the reservations on file.",
      "folio_unrouted": "A charge matched no routing rule and is unrouted.",
      "commission_variance": "A commission statement differs from the computed commission."
    }
  },
  "roster": {
    "allCompanies": "All legal entities",
    "anyStatus": "Any status",
    "cancel": {
      "confirm": "Cancel roster",
      "description": "A cancelled roster keeps its lines: what was planned and abandoned is a question labour cost asks.",
      "noteLabel": "Note",
      "reasonLabel": "Reason code",
      "title": "Cancel roster"
    },
    "clock": {
      "kinds": {
        "break_end": "Break end",
        "break_start": "Break start",
        "in": "In",
        "out": "Out"
      }
    },
    "demand": {
      "actions": {
        "import": "Import CSV",
        "new": "Add figure"
      },
      "columns": {
        "date": "Date",
        "dayPart": "Day part",
        "location": "Location",
        "metric": "Metric",
        "source": "Source",
        "value": "Value"
      },
      "dayPartHint": "A day-part code your workspace defines, or blank for the whole day.",
      "description": "Typed or imported demand, and the rules that turn a figure into a headcount.",
      "emptyDescription": "Type last year's occupancy, or import a CSV, then a roster can be proposed from it.",
      "emptyTitle": "No demand recorded",
      "entry": {
        "description": "One figure per location, date, day part and metric. Entering it again replaces it.",
        "title": "Add a demand figure"
      },
      "import": {
        "confirm": "Import",
        "csvLabel": "CSV",
        "description": "Rows are read here and every one is validated by the server before any of them is written; a row that cannot be read is reported rather than guessed.",
        "format": "One row per figure: date, day part, metric, value.",
        "rowUnreadable": "Line {line} could not be read: {text}",
        "title": "Import demand from CSV"
      },
      "imported": "{imported} imported, {skipped} skipped",
      "loadFailed": "The demand figures could not be loaded",
      "locationHint": "Demand is recorded per location.",
      "metrics": {
        "arrivals": "Arrivals",
        "covers": "Covers",
        "departures": "Departures",
        "headcount": "Headcount",
        "occupied_rooms": "Occupied rooms",
        "revenue": "Revenue",
        "transactions": "Transactions"
      },
      "noSignal": "No figures at all for {metrics}. A proposal on demand will produce no lines for those.",
      "removed": "Demand figure removed",
      "rules": {
        "actions": {
          "new": "New staffing rule"
        },
        "columns": {
          "effectiveFrom": "Effective from",
          "max": "Maximum",
          "min": "Minimum",
          "shift": "Shift",
          "unitsPerHead": "Units per head"
        },
        "create": {
          "description": "Headcount is ceil(demand ÷ units per head), floored at the minimum and capped at the maximum.",
          "title": "New staffing rule"
        },
        "emptyDescription": "A rule turns a demand figure into a headcount: one housekeeper per 14 occupied rooms, minimum 2.",
        "emptyTitle": "No staffing rules",
        "saved": "Staffing rule saved",
        "title": "Staffing rules",
        "unitsHint": "Units of the metric one person covers."
      },
      "saved": "Demand figure saved",
      "sources": {
        "import": "Imported",
        "manual": "Typed"
      },
      "tabs": {
        "demand": "Demand",
        "rules": "Staffing rules"
      },
      "title": "Demand and staffing",
      "wholeDay": "Whole day"
    },
    "exceptions": {
      "actions": {
        "correct": "Correct",
        "resolve": "Resolve"
      },
      "anyKind": "Any kind",
      "columns": {
        "channel": "Channel",
        "corrects": "Corrects",
        "date": "Date",
        "employee": "Employee",
        "expected": "Expected h",
        "happenedAt": "Happened at",
        "kind": "Exception",
        "observed": "Observed h",
        "punchKind": "Punch",
        "reason": "Reason"
      },
      "correct": {
        "atLabel": "Corrected time",
        "description": "The original punch survives. A correction is a new, linked event with a reason.",
        "newEventNote": "A clock event is never edited — it is corrected by a second event, exactly as a posted journal is reversed.",
        "reasonLabel": "Reason code",
        "title": "Correct a punch"
      },
      "corrected": "Correction recorded",
      "description": "Where the roster and the punches disagree. Closing one always records a reason.",
      "dismissed": "Exception dismissed",
      "employeeIdHint": "Narrow the punch list to one person.",
      "employeeIdLabel": "Employee id",
      "emptyDescription": "Every rostered day was worked and every punch paired.",
      "emptyTitle": "No exceptions",
      "kinds": {
        "early_out": "Early out",
        "late_in": "Late in",
        "long_hours": "Long hours",
        "missing_in": "Missing clock-in",
        "missing_out": "Missing clock-out",
        "no_show": "No show",
        "overlapping_shift": "Overlapping shifts",
        "short_hours": "Short hours",
        "unrostered_work": "Worked without a roster line"
      },
      "loadFailed": "The exceptions could not be loaded",
      "openCount": "{count} open exception(s) are waiting on somebody.",
      "punchFilters": "Punch filters",
      "punchesEmptyDescription": "Nothing was clocked in this window.",
      "punchesEmptyTitle": "No punches",
      "reasons": {
        "approved_absence_retrospective": "Absence approved after the fact",
        "device_failure": "Clocking device failed",
        "other": "Other",
        "overtime_approved": "Overtime approved",
        "rostered_in_error": "Rostered in error",
        "shift_swapped": "Shift swapped with a colleague",
        "worked_no_punch": "Worked, no punch recorded"
      },
      "resolve": {
        "description": "A reason code is mandatory: it is what makes the queue answerable in aggregate.",
        "noteLabel": "Note",
        "reasonLabel": "Reason code",
        "subject": "{name} on {date} — {kind}",
        "title": "Resolve exception",
        "writesAttendance": "This reason writes the rostered hours as attendance, which payroll will pay."
      },
      "resolved": "Exception resolved",
      "statuses": {
        "dismissed": "Dismissed",
        "open": "Open",
        "resolved": "Resolved"
      },
      "tabs": {
        "exceptions": "Exceptions",
        "punches": "Punches"
      },
      "title": "Attendance exceptions"
    },
    "fields": {
      "company": "Legal Entity",
      "fromDate": "From",
      "locationId": "Location id",
      "toDate": "To"
    },
    "grid": {
      "actions": {
        "cancel": "Cancel roster",
        "lock": "Lock",
        "propose": "Propose",
        "publish": "Publish",
        "save": "Save ({count})",
        "unlock": "Unlock"
      },
      "basis": {
        "demand": "From demand signals",
        "pattern": "From shift patterns"
      },
      "blockedBanner": "Publishing is refused: {count} working-time breach(es) must be resolved first.",
      "cancelled": "Roster cancelled",
      "cellLabel": "{name}, {date}, shift {shift}",
      "coverageGap": "No demand signal for {metrics} on {dates} date(s). Those dates produced no lines.",
      "description": "Employees down, dates across. Arrow keys move, 1–9 assign a shift, R marks a rest day, O marks an unfilled slot.",
      "draftNo": "Draft",
      "employee": "Employee",
      "empty": "nothing",
      "emptyDescription": "Propose from a pattern or from demand, or add lines by hand.",
      "emptyTitle": "Nobody is on this roster yet",
      "legend": {
        "keys": "Keyboard: arrows move · 1–9 shift · R rest · O open · Backspace clear · ⌘S save"
      },
      "loadFailed": "The roster could not be loaded",
      "locked": "Roster locked for payroll",
      "open": "Open",
      "plannedCost": "Planned cost",
      "plannedHours": "Planned {hours} h",
      "proposed": "{count} line(s) proposed",
      "published": "Roster {no} published",
      "rest": "Rest",
      "saved": "Roster saved",
      "tableCaption": "Roster grid: employees by date",
      "title": "Roster",
      "titleFor": "{no} · {from} to {to}",
      "unlocked": "Roster unlocked"
    },
    "labour": {
      "chooseScope": "Choose a legal entity and a date range.",
      "columns": {
        "actual": "Actual h",
        "bucket": "Bucket",
        "cost": "Labour cost",
        "costBasis": "Cost basis",
        "costPercent": "Cost %",
        "headcount": "Headcount",
        "overtime": "Overtime h",
        "revenue": "Revenue",
        "revenueBasis": "Revenue basis",
        "rostered": "Rostered h",
        "spmh": "Sales per man hour"
      },
      "costBasis": {
        "estimate": "Estimated from the roster",
        "mixed": "Partly posted",
        "posted": "Posted payroll"
      },
      "description": "Rostered against actual, and against revenue where there is any.",
      "emptyDescription": "Publish a roster or approve some attendance, and the figures appear here.",
      "emptyTitle": "Nothing in this window",
      "groupBy": {
        "day": "Day",
        "department": "Department",
        "location": "Location",
        "week": "Week"
      },
      "groupByLabel": "Group by",
      "kpi": {
        "actualHours": "Actual hours",
        "actualHoursHelp": "Approved attendance, not the roster.",
        "cost": "Labour cost",
        "costPercent": "Cost of sales %"
      },
      "loadFailed": "The labour cost could not be loaded",
      "noRevenueBasis": "No revenue basis",
      "revenueBasis": {
        "none": "No revenue source",
        "pms": "From property management",
        "pos": "From point of sale",
        "tax_lines": "From tax lines"
      },
      "revenueGap": "{count} bucket(s) have no revenue source, so no cost percentage is shown for them.",
      "title": "Labour cost"
    },
    "list": {
      "actions": {
        "new": "New roster"
      },
      "columns": {
        "cost": "Planned cost",
        "hours": "Planned hours",
        "location": "Location",
        "no": "Roster no.",
        "open": "Open lines",
        "window": "Window"
      },
      "create": {
        "confirm": "Create roster",
        "description": "A roster covers one legal entity and one date range. A second roster over the same window is refused.",
        "spanHint": "Up to 92 days.",
        "title": "New roster"
      },
      "created": "Roster created",
      "description": "Each roster is one legal entity, one location and one date range, published as a unit.",
      "emptyDescription": "Create a roster for a fortnight, then fill the grid from a pattern or from demand.",
      "emptyTitle": "No rosters yet",
      "filtersTitle": "Filters",
      "loadFailed": "The rosters could not be loaded",
      "title": "Rosters"
    },
    "patterns": {
      "actions": {
        "new": "New pattern"
      },
      "columns": {
        "calendar": "Calendar",
        "code": "Code",
        "cycle": "Cycle days",
        "name": "Name",
        "shape": "Shape"
      },
      "create": {
        "description": "Slots are edited as a whole. Changing the cycle length resizes them.",
        "title": "New shift pattern"
      },
      "dayLabel": "Day {day}",
      "description": "The repeating shape of a rotation. A template — it pays nothing and is not evidence of work.",
      "edit": {
        "title": "Edit shift pattern"
      },
      "emptyDescription": "A pattern is how a roster gets proposed without typing every day.",
      "emptyTitle": "No shift patterns yet",
      "everyDayWorkable": "Every day workable",
      "fields": {
        "code": "Code",
        "cycle": "Cycle days",
        "cycleHint": "7 for an ordinary week; 6 for a four-on-two-off.",
        "name": "Name"
      },
      "loadFailed": "The shift patterns could not be loaded",
      "restSlot": "Rest day",
      "saved": "Pattern saved",
      "slotsNote": "A slot with no shift is an explicit rest day, which is what weekly-rest rules count.",
      "title": "Shift patterns"
    },
    "propose": {
      "basisHint": "A date with no demand signal produces no line — never a zero-staff line.",
      "basisLabel": "Basis",
      "confirm": "Propose",
      "description": "Generate lines from shift patterns, or from demand signals and staffing rules.",
      "title": "Propose a roster"
    },
    "publish": {
      "blocked": "A statutory limit is breached. No override exists for anybody, including a workspace administrator.",
      "clear": "No breaches. This roster may be published.",
      "confirm": "Publish",
      "description": "Publishing notifies everybody on it. Working-time rules are checked first.",
      "needsOverride": "Only house rules are breached. Publishing needs a reason, which is recorded.",
      "noteLabel": "What was decided, and by whom",
      "openLines": "{count} line(s) are still unfilled. Publishing over them needs a reason, which is recorded.",
      "openLinesNoteLabel": "Why the roster goes out with gaps",
      "openLinesReasonLabel": "Unfilled-line override reason code",
      "reasonLabel": "Override reason code",
      "title": "Publish roster"
    },
    "routeTitles": {
      "demand": "Demand and staffing",
      "exceptions": "Attendance exceptions",
      "labourCost": "Labour cost",
      "roster": "Roster",
      "rosters": "Rosters",
      "shiftDefinitions": "Shift definitions",
      "shiftPatterns": "Shift patterns",
      "workingTimeRules": "Working-time rules"
    },
    "rules": {
      "actions": {
        "new": "New house rule"
      },
      "anyKind": "Any kind",
      "clear": "No breaches and no warnings.",
      "columns": {
        "code": "Code",
        "kind": "Rule",
        "severity": "Severity",
        "source": "Source",
        "threshold": "Threshold",
        "window": "Window"
      },
      "create": {
        "description": "A house rule of your own. Statutory rules arrive from the jurisdiction pack and are read-only.",
        "title": "New working-time rule"
      },
      "description": "Every rule that applies, and how much headroom is left. Checked by the server over this roster and the ones around it.",
      "edit": {
        "title": "Edit working-time rule"
      },
      "emptyDescription": "Activate a jurisdiction pack for the statutory limits, or add a house rule of your own.",
      "emptyTitle": "No working-time rules",
      "fields": {
        "code": "Code",
        "effectiveFrom": "Effective from",
        "name": "Name",
        "severityHint": "A house rule may warn instead of blocking. A pack rule always blocks.",
        "threshold": "Threshold",
        "thresholdHint": "Hours, minutes or a count of days, depending on the rule.",
        "window": "Window units",
        "windowHint": "Weeks to average a weekly cap over, or days for a night-shift period."
      },
      "house": "House rule",
      "houseBadge": "House",
      "kinds": {
        "max_consecutive_days": "Maximum consecutive days",
        "max_hours_per_day": "Maximum hours per day",
        "max_hours_per_week": "Maximum hours per week",
        "max_night_shifts_per_period": "Maximum night shifts per period",
        "min_break_minutes_per_shift": "Minimum break per shift",
        "min_rest_hours_between_shifts": "Minimum rest between shifts",
        "min_weekly_rest_hours": "Minimum weekly rest"
      },
      "loadFailed": "The working-time rules could not be loaded",
      "notOverridable": "Not overridable",
      "packBadge": "Pack v{version}",
      "packExplainer": "{count} rule(s) come from a jurisdiction pack. A pack rule always blocks and cannot be edited or overridden by anybody.",
      "pageDescription": "The bounds a roster publish and an attendance approval are tested against.",
      "pageTitle": "Working-time rules",
      "recheck": "Re-check now",
      "remaining": "{remaining} left",
      "saved": "Rule saved",
      "severity": {
        "block": "Block",
        "warn": "Warn"
      },
      "stale": "{count} unsaved change(s). Save to re-check the rules.",
      "statutory": "Statutory",
      "title": "Working time"
    },
    "shifts": {
      "actions": {
        "new": "New shift"
      },
      "columns": {
        "break": "Break (min)",
        "code": "Code",
        "name": "Name",
        "night": "Night shift",
        "paidHours": "Paid hours",
        "times": "Times"
      },
      "companyHint": "Shift definitions belong to one legal entity.",
      "create": {
        "description": "Paid hours are derived from the times and the break, then stored.",
        "title": "New shift definition"
      },
      "description": "The named blocks of time a roster line refers to.",
      "edit": {
        "title": "Edit shift definition"
      },
      "emptyDescription": "Define the shifts this legal entity works — an early, a late, a night — before building a roster.",
      "emptyTitle": "No shift definitions yet",
      "fields": {
        "break": "Unpaid break (minutes)",
        "code": "Code",
        "colour": "Colour",
        "colourHint": "Used for the chip in the roster grid.",
        "crossesMidnight": "Ends the next day",
        "crossesMidnightHint": "Set explicitly: a 24-hour shift ends at the same clock time it starts.",
        "endsAt": "Ends at",
        "isNight": "Counts as a night shift",
        "name": "Name",
        "startsAt": "Starts at"
      },
      "loadFailed": "The shift definitions could not be loaded",
      "night": "Night",
      "paidHoursNote": "This shift is worth {hours} paid hours. Changing the times changes what future lines are worth, never a published one.",
      "saved": "Shift saved",
      "title": "Shift definitions"
    },
    "statuses": {
      "cancelled": "Cancelled",
      "draft": "Draft",
      "locked": "Locked",
      "proposed": "Proposed",
      "published": "Published"
    },
    "unlock": {
      "confirm": "Unlock",
      "description": "Payroll holds this lock. Unlocking is audited, and if the run has posted it raises retro pay.",
      "noteLabel": "Note",
      "reasonLabel": "Reason code",
      "title": "Unlock roster"
    }
  },
  "ai": {
    "nav": {
      "label": "AI sections",
      "briefings": "Briefings",
      "autonomy": "Autonomy",
      "ledger": "Recommendation ledger",
      "anomalies": "Config anomalies"
    },
    "routeTitles": {
      "briefings": "AI briefings",
      "briefing": "Briefing",
      "autonomy": "AI autonomy",
      "ledger": "Recommendation ledger",
      "anomalies": "Config anomalies"
    },
    "priorities": {
      "info": "Information",
      "attention": "Attention",
      "urgent": "Urgent"
    },
    "kinds": {
      "advice": "Advice",
      "draft": "Draft",
      "action": "Action"
    },
    "fallbacks": {
      "figures_only": "Figures only",
      "skip": "Skip",
      "queue": "Queue"
    },
    "runStatuses": {
      "running": "Running",
      "complete": "Complete",
      "degraded": "Degraded",
      "failed": "Failed"
    },
    "dispositions": {
      "pending": "Pending",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "expired": "Expired",
      "auto_confirmed": "Confirmed unattended",
      "routed": "Routed to a human"
    },
    "outcomes": {
      "realised": "Realised",
      "not_realised": "Not realised",
      "not_taken": "Not taken",
      "unmeasurable": "Unmeasurable"
    },
    "anomalyStatuses": {
      "open": "Open",
      "acknowledged": "Acknowledged",
      "dismissed": "Dismissed"
    },
    "commands": {
      "group": "Assistant",
      "keywords": "assistant ask ai chat question",
      "open": "Ask the Assistant",
      "openDescription": "Open the Assistant in the right rail, beside what you are looking at.",
      "cash": "Ask about cash",
      "cashDescription": "Open the Assistant with a cash-position question ready to send.",
      "cashPrompt": "What does the 13-week cash forecast look like, and what moved it since last week?",
      "aging": "Ask about receivables",
      "agingDescription": "Open the Assistant with a receivables-ageing question ready to send.",
      "agingPrompt": "Show me the AR ageing and name the three customers driving the over-90 bucket."
    },
    "assistant": {
      "tabLabel": "Assistant",
      "forbiddenTitle": "The Assistant is not available to this account",
      "forbiddenDescription": "Using the Assistant needs the ai.assistant.use permission, which this account does not hold.",
      "loadFailed": "The conversation could not be loaded",
      "emptyTitle": "Ask the Assistant something",
      "emptyDescription": "It runs under your own permissions and can only see what you can. Anything it would create comes back as a preview for you to confirm.",
      "placeholder": "Ask about a figure, a document, or a report…",
      "send": "Send",
      "confirm": "Confirm",
      "discard": "Discard",
      "confirmed": "Created",
      "confirmFailed": "Nothing was created",
      "discarded": "Discarded",
      "discardFailed": "The preview was not discarded",
      "previewTitle": "{tool} — nothing has been created yet",
      "previewNote": "Review this and confirm it to create it. Discarding leaves nothing behind.",
      "tokens": "{input} in / {output} out",
      "roles": {
        "user": "You",
        "assistant": "Assistant",
        "system": "System",
        "tool": "Tool"
      }
    },
    "briefings": {
      "title": "Briefings",
      "description": "What each agent found, by day. Figures are computed here and the model only narrates them.",
      "agent": "Agent",
      "briefing": "Briefing",
      "priority": "Priority",
      "sections": "Sections",
      "businessDate": "Business date",
      "unreadOnly": "Unread only",
      "unread": "unread",
      "withheld": "{count} withheld",
      "loadFailed": "The briefings could not be loaded",
      "emptyTitle": "No briefings yet",
      "emptyDescription": "Agents run on a schedule and write a briefing each time. Run one now, or wait for tonight's schedule.",
      "runTitle": "Run an agent now",
      "runDescription": "An operator recovery action for a schedule that did not fire. A date already run comes back as a conflict naming the run that exists.",
      "run": "Run",
      "ran": "{title}",
      "runFailed": "The agent did not run",
      "chooseAgent": "Choose an agent"
    },
    "briefing": {
      "title": "Briefing",
      "backToFeed": "Back to briefings",
      "loadFailed": "This briefing could not be loaded",
      "markRead": "Mark read",
      "marked": "Marked read",
      "tokens": "{input} tokens in / {output} out",
      "degraded": "The model was unreachable for this run. The figures below are complete — they were computed here, not by the model — and only the narration is missing.",
      "withheld": "{count} section(s) are not shown because this account cannot read the module behind them.",
      "figuresLabel": "Computed figures",
      "figuresOnly": "No narration for this section."
    },
    "autonomy": {
      "title": "Autonomy",
      "description": "How far each AI capability may act on its own, what evidence that takes, and what happens when it falls short.",
      "loadFailed": "The capabilities could not be loaded",
      "emptyTitle": "No capabilities are registered",
      "emptyDescription": "Capabilities are declared in code and projected into this tenant. None has been.",
      "capability": "Capability",
      "kind": "Kind",
      "level": "Level",
      "ceiling": "Registry ceiling",
      "threshold": "Confidence threshold",
      "tolerance": "Tolerance %",
      "tolerancePct": "Tolerance %",
      "toleranceAbs": "Tolerance amount",
      "percentHint": "Enter 10 for 10%.",
      "percentRange": "Enter a percentage between 0 and 100.",
      "fallback": "Fallback",
      "detailDescription": "Every level, and for the ones that cannot be chosen, exactly why.",
      "choose": "Use this level",
      "levelSet": "Level changed",
      "tuned": "Saved",
      "note": "Note",
      "delegatedOn": "Delegated on the evidence of {samples} measured outcomes at {accuracy}, on",
      "sodNote": "Setting a tolerance band and deciding that band may be acted on unattended are segregated. This account can tune a capability but cannot change its level.",
      "levels": {
        "assistive": "Assistive",
        "supervised": "Supervised",
        "delegated": "Delegated"
      },
      "levelDescriptions": {
        "assistive": "Explains what would happen. Nothing is staged and nothing is confirmable.",
        "supervised": "Stages a preview. A person confirms it before anything exists.",
        "delegated": "Confirms the same preview unattended, under the principal's identity, and routes to a human the moment a gate fails."
      },
      "reasons": {
        "kind": "Only a capability that acts can be delegated. This one gives advice.",
        "registry_ceiling": "The registry caps this capability below that level, and a tenant cannot raise it.",
        "company_ceiling": "This legal entity's ceiling caps every capability below that level.",
        "insufficient_evidence": "Delegated needs {needed} measured outcomes at {neededAccuracy}; this capability has {have} at {haveAccuracy}."
      }
    },
    "ledger": {
      "title": "Recommendation ledger",
      "description": "Everything the AI has proposed, what was decided, and — once the horizon passed — whether it turned out to be right. A record, not a work list.",
      "loadFailed": "The ledger could not be loaded",
      "emptyTitle": "Nothing has been recommended yet",
      "emptyDescription": "A recommendation is written whenever a capability proposes something. None has.",
      "capability": "Capability",
      "type": "Type",
      "disposition": "Disposition",
      "subject": "Subject",
      "amount": "Amount",
      "issued": "Issued",
      "autonomyAtIssue": "Level at issue",
      "work": "Where the work is",
      "inApprovals": "Approvals inbox",
      "inAttention": "Attention list",
      "accuracyTitle": "Accuracy by recommendation type",
      "accuracyDescription": "A rejection is not an error: accuracy is realised over realised plus not-realised, and all four counts are shown so the denominator is never invisible.",
      "noAccuracyTitle": "Nothing has been measured yet",
      "noAccuracyDescription": "Accuracy appears once recommendations reach their measurement horizon.",
      "samples": "Measured",
      "accuracy": "Accuracy",
      "coverage": {
        "realised": "Realised",
        "notRealised": "Not realised",
        "notTaken": "Not taken",
        "unmeasurable": "Unmeasurable",
        "measuredRatio": "Measured share"
      },
      "detailTitle": "Recommendation",
      "figuresLabel": "Computed figures",
      "outcome": "{result} — predicted {predicted}, actual {actual}",
      "accept": "Accept",
      "accepted": "Accepted",
      "acceptFailed": "Nothing was created",
      "reject": "Reject",
      "rejected": "Rejected",
      "rejectTitle": "Reject this recommendation",
      "rejectDescription": "A rejection is recorded and does not count against the capability's accuracy. Say why, so the ledger is worth reading back.",
      "reason": "Reason",
      "reasonRequired": "A reason is required."
    },
    "anomalies": {
      "title": "Config anomalies",
      "description": "Deterministic rules over the configuration-change audit trail. They run whether or not AI is enabled; only the narration needs a model.",
      "loadFailed": "The anomalies could not be loaded",
      "emptyTitle": "Nothing unusual in the configuration trail",
      "emptyDescription": "Seven rules watch for churn, flips, out-of-hours changes, first-time editors, weakened controls, changes just before a document, and bulk edits.",
      "severity": "Severity",
      "status": "Status",
      "sweep": "Sweep now",
      "swept": "{scanned} audit rows scanned, {detected} detected, {known} already known.",
      "sweepFailed": "The sweep did not run",
      "coverageIntro": "{rules} rules registered. Configuration surfaces currently in the audit stream:",
      "coverageNone": "No configuration changes have been audited yet, so there is nothing to watch. This is a gap in coverage, not a clean bill of health.",
      "occurrences": "{count} change(s)",
      "impacted": "{count} document(s) affected",
      "evidence": "Audit rows:",
      "figuresLabel": "Computed figures",
      "acknowledge": "Acknowledge",
      "acknowledgeTitle": "Acknowledge this anomaly",
      "dismiss": "Dismiss",
      "dismissTitle": "Dismiss this anomaly",
      "actionDescription": "A reason code is recorded against your name. Acknowledging keeps the row; dismissing says it needed no action.",
      "actioned": "Recorded",
      "reasonCode": "Reason code",
      "reasonRequired": "A reason code is required.",
      "note": "Note"
    },
    "agent": {
      "cfo": {
        "label": "CFO",
        "description": "Cash, journal anomalies, close readiness and the daily operating ties."
      },
      "procurement": {
        "label": "Procurement",
        "description": "Price variance, supplier risk, consolidation candidates and match-exception ageing."
      },
      "sales": {
        "label": "Sales",
        "description": "Pipeline risk, stale deals, forecast commentary and rebate accrual exposure."
      },
      "inventory": {
        "label": "Inventory",
        "description": "Stockout risk, slow movers and expiry exposure."
      },
      "revenue": {
        "label": "Revenue",
        "description": "Pace, pickup, forecast accuracy, open displacement decisions and acquisition cost."
      },
      "maintenance": {
        "label": "Maintenance and reliability",
        "description": "Reliability metrics registered by the asset modules, and nothing invented when none are."
      },
      "workforce": {
        "label": "Workforce",
        "description": "Roster coverage, overtime exposure, leave liability and expiring permits."
      }
    },
    "capability": {
      "queryArAging": {
        "label": "Query AR ageing",
        "description": "Reads the receivables ageing you are permitted to see."
      },
      "cashForecast": {
        "label": "Cash forecast",
        "description": "Reads the 13-week direct cash forecast."
      },
      "explainVariance": {
        "label": "Explain a variance",
        "description": "Reads budget against actual and explains the movement."
      },
      "runReport": {
        "label": "Run a report",
        "description": "Runs a report you already have permission to run."
      },
      "draftPo": {
        "label": "Draft a purchase order",
        "description": "Creates a draft a human still approves and posts."
      },
      "anomalyTriage": {
        "label": "Triage an anomaly",
        "description": "Proposes a disposition for a configuration anomaly, never applies one."
      }
    },
    "anomalyRule": {
      "churn": {
        "label": "Repeated changes",
        "description": "The same setting changed more than a handful of times in a day."
      },
      "flip": {
        "label": "Changed and changed back",
        "description": "A value moved and returned to what it was, within days."
      },
      "offHours": {
        "label": "Out of hours",
        "description": "A change outside the legal entity's own working window."
      },
      "firstTime": {
        "label": "First-time editor",
        "description": "Someone changing a setting they have never touched."
      },
      "controlWeaken": {
        "label": "Control weakened",
        "description": "A change whose direction makes a control less strict."
      },
      "preDocument": {
        "label": "Changed just before a document",
        "description": "A threshold moved, then a document arrived at the old band."
      },
      "bulk": {
        "label": "Bulk change",
        "description": "One person changing many settings in a short window."
      }
    }
  },
  "eam": {
    "routeTitles": {
      "locations": "Functional locations",
      "assets": "Asset register",
      "asset": "Asset",
      "reconciliation": "Asset reconciliation",
      "maintenance": "Maintenance",
      "taskList": "Task list",
      "meters": "Meters",
      "failures": "Failures",
      "compliance": "Compliance calendar",
      "permits": "Permits to work",
      "downtime": "Downtime"
    },
    "filtersTitle": "Filters",
    "noLegalEntity": "No legal entity is available to you, so there are no assets to show. Ask an administrator for access to one.",
    "chooseCompany": "Choose a legal entity to see its assets. Every row is scoped to the legal entities you are permitted, so there is nothing sensible to show until one is chosen.",
    "actions": {
      "remove": "Remove"
    },
    "labels": {
      "yes": "Yes",
      "no": "No",
      "active": "Active",
      "inactive": "Inactive"
    },
    "fields": {
      "company": "Legal Entity",
      "code": "Code",
      "assetId": "Asset",
      "assetNo": "Asset no.",
      "classCode": "Class",
      "criticality": "Criticality",
      "ownership": "Ownership",
      "lifecycleState": "Lifecycle",
      "location": "Functional location",
      "financeAsset": "Financial asset",
      "manufacturer": "Manufacturer",
      "modelNo": "Model",
      "serialNo": "Serial no.",
      "meter": "Meter",
      "unit": "Unit",
      "currentReading": "Current reading",
      "cumulative": "Cumulative",
      "readAt": "Read at",
      "readOn": "Read on",
      "reading": "Reading",
      "delta": "Change",
      "source": "Source",
      "rollsOver": "Rolls over",
      "overrideReason": "Regression reason",
      "failureNo": "Failure no.",
      "failureMode": "Failure mode",
      "severity": "Severity",
      "detectedAt": "Detected",
      "restoredAt": "Restored",
      "workOrder": "Work order",
      "windowDays": "Window (days)",
      "failures": "Failures",
      "mtbf": "MTBF (h)",
      "mttr": "MTTR (h)",
      "downtimeHours": "Downtime (h)",
      "availability": "Availability %",
      "intervalDays": "Every (days)",
      "intervalMeter": "Every (meter units)",
      "nextDue": "Next due",
      "lastCompleted": "Last completed",
      "strategyKind": "Strategy",
      "estimatedHours": "Estimated hours",
      "requiresPermit": "Permit required",
      "stepNo": "Step",
      "instruction": "Instruction",
      "measurementUnit": "Measured in",
      "minValue": "Min",
      "maxValue": "Max",
      "standing": "Standing",
      "daysUntilDue": "Days until due",
      "certificateRef": "Certificate ref.",
      "validUntil": "Valid until",
      "inspectedOn": "Inspected on",
      "result": "Result",
      "findings": "Findings",
      "from": "From",
      "to": "To",
      "hazards": "Hazards",
      "precautions": "Precautions",
      "isolationRef": "Isolation ref.",
      "downtimeKind": "Kind",
      "state": "State",
      "reasonCode": "Reason",
      "startedAt": "Started",
      "endedAt": "Ended",
      "releaseNote": "Release note"
    },
    "criticality": {
      "1": "1 — the business stops",
      "2": "2 — a shift is lost",
      "3": "3 — noticeable",
      "4": "4 — tolerable",
      "5": "5 — cosmetic"
    },
    "ownership": {
      "owned": "Owned",
      "leased": "Leased",
      "customer": "Customer's"
    },
    "lifecycleState": {
      "planned": "Planned",
      "commissioned": "Commissioned",
      "in_service": "In service",
      "standby": "Standby",
      "decommissioned": "Decommissioned"
    },
    "lifecycleEvent": {
      "commissioned": "Commissioned",
      "baselined": "Baselined",
      "modified": "Modified",
      "relocated": "Relocated",
      "decommissioned": "Decommissioned"
    },
    "linkKind": {
      "pms": {
        "room": "Room"
      },
      "mfg": {
        "work_center": "Work centre"
      },
      "service": {
        "resource": "Service resource"
      },
      "inventory": {
        "warehouse": "Warehouse"
      }
    },
    "strategyKind": {
      "run_to_failure": "Run to failure",
      "time_based": "Time based",
      "usage_based": "Usage based",
      "condition_based": "Condition based"
    },
    "severity": {
      "minor": "Minor",
      "major": "Major",
      "critical": "Critical"
    },
    "standing": {
      "current": "Current",
      "due_soon": "Due soon",
      "overdue": "Overdue"
    },
    "inspectionResult": {
      "pass": "Pass",
      "pass_with_conditions": "Pass with conditions",
      "fail": "Fail"
    },
    "permitKind": {
      "hot_work": "Hot work",
      "confined_space": "Confined space",
      "electrical": "Electrical",
      "height": "Working at height",
      "lifting": "Lifting",
      "general": "General"
    },
    "permitStatus": {
      "requested": "Requested",
      "issued": "Issued",
      "active": "Active",
      "returned": "Returned",
      "closed": "Closed",
      "cancelled": "Cancelled",
      "expired": "Expired"
    },
    "downtimeKind": {
      "planned": "Planned",
      "unplanned": "Unplanned",
      "compliance": "Compliance"
    },
    "downtimeState": {
      "unavailable": "Unavailable",
      "degraded": "Degraded"
    },
    "downtimeSource": {
      "manual": "Recorded by hand",
      "compliance": "Compliance",
      "work_order": "Work order",
      "failure": "Failure"
    },
    "availabilityState": {
      "unavailable": "Went unavailable",
      "available": "Came back"
    },
    "differenceClass": {
      "matched": "Matched",
      "unlinked_operational": "Only in maintenance",
      "unlinked_financial": "Only in finance",
      "state_divergent": "States disagree",
      "company_divergent": "Legal entities disagree"
    },
    "locations": {
      "title": "Functional locations",
      "description": "Where a thing is, as distinct from what it is. Drag a location onto another to re-parent it, or use the parent picker on the row.",
      "treeTitle": "Hierarchy",
      "create": "New location",
      "createFailed": "That location could not be created.",
      "parent": "Parent",
      "noParent": "No parent",
      "dragHint": "Drag a row onto another to re-parent it. The parent picker does the same thing from the keyboard. A move that would make a loop is refused by the server and the reason appears here.",
      "moved": "Moved",
      "moveFailed": "That location could not be moved.",
      "loadFailed": "The hierarchy could not be loaded.",
      "empty": "No functional locations yet. Create one for each site, building or line so assets have somewhere to live."
    },
    "assets": {
      "title": "Asset register",
      "description": "The operational register: where a machine is, how critical it is and whether it is in service. The financial register is separate and the two are reconciled by their own report.",
      "tableTitle": "Assets",
      "caption": "Operational assets with their criticality, lifecycle state and financial counterpart.",
      "create": "New asset",
      "dialogDescription": "The asset number is assigned when it is saved.",
      "criticalityHint": "1 is “the business stops”, 5 is “somebody notices eventually”. It orders preventive maintenance and decides which failures escalate.",
      "locationHint": "An asset with no location never appears on a site's compliance calendar.",
      "searchLabel": "Search",
      "searchPlaceholder": "Asset number, name or serial",
      "empty": "No assets match. Create one, or widen the filters.",
      "loadFailed": "The asset register could not be loaded.",
      "saved": "Asset created",
      "saveFailed": "That asset could not be created.",
      "criticalityValue": "C{value}",
      "noFinanceAsset": "Not linked",
      "identity": "Identity",
      "availability": "Availability",
      "available": "Available",
      "unavailable": "Unavailable",
      "availableOn": "Available on {date}",
      "unavailableOn": "Unavailable on {date}",
      "availabilityUnknown": "Availability has not been answered for this asset yet.",
      "degraded": "Degraded",
      "meters": "Meters",
      "failures": "Failures",
      "openDowntime": "Open downtime",
      "compliance": "Compliance",
      "lifecycle": "Lifecycle",
      "links": "Linked to",
      "noLifecycleEvents": "Nothing has happened to this asset yet.",
      "commission": "Commission",
      "commissionHint": "Commissioning is dated in the legal entity's own timezone by the server.",
      "commissioned": "Asset commissioned",
      "commissionFailed": "That asset could not be commissioned.",
      "decommissionNote": "Decommissioning is done from the asset's own disposal paperwork: it requires the evidence attachment, so it is not offered as a button here."
    },
    "reconciliation": {
      "title": "Asset reconciliation",
      "description": "Both directions: assets the maintenance register holds that finance does not, assets finance holds that nothing maintains, and pairs whose states have drifted apart.",
      "summary": "Differences",
      "tableTitle": "Rows",
      "caption": "Operational and financial asset registers, side by side, with the difference the server classified.",
      "eamName": "Maintenance name",
      "financeNo": "Financial no.",
      "financeName": "Financial name",
      "financeStatus": "Financial status",
      "differenceClass": "Difference",
      "notInEam": "Not in maintenance",
      "notInFinance": "Not in finance",
      "balanced": "Nothing to reconcile.",
      "empty": "No rows. Either register may still be empty.",
      "loadFailed": "The reconciliation could not be loaded."
    },
    "maintenance": {
      "title": "Maintenance",
      "description": "Strategies, preventive plans and the task lists they run."
    },
    "strategies": {
      "title": "Strategies",
      "empty": "No strategies yet.",
      "saveFailed": "That strategy could not be saved."
    },
    "taskLists": {
      "title": "Task lists",
      "empty": "No task lists yet.",
      "saveFailed": "That task list could not be saved.",
      "summary": "Summary",
      "steps": "Steps",
      "stepsEmpty": "No steps yet. Add the first one.",
      "addStep": "Add step",
      "stepsSaved": "Steps saved",
      "stepsFailed": "Those steps could not be saved.",
      "loadFailed": "That task list could not be loaded.",
      "skills": "Competencies required",
      "skillsEmpty": "No competencies are required for this task list.",
      "skillsNote": "Competencies come from the shared HR register. They are added there, not invented here, so dispatch and payroll agree about who holds what.",
      "minLevel": "level {level}+",
      "statutory": "Statutory"
    },
    "pmPlans": {
      "title": "Preventive plans",
      "empty": "No preventive plans yet.",
      "loadFailed": "The preventive plans could not be loaded.",
      "twoTriggers": "A plan can fire on the calendar and on a meter. Whichever comes first raises the work order, which is why both columns are shown.",
      "preview": "Preview",
      "previewLoading": "Working out what the generator would do…",
      "previewDue": "Due now — {reason}, as of {asOf}. The generator would raise a work order.",
      "previewNotDue": "Not due. Next due {nextDue}, generated {lead} days ahead.",
      "generateNow": "Generate now",
      "generated": "Generation finished — {count} plan(s) considered",
      "generateFailed": "Generation failed."
    },
    "meters": {
      "title": "Meters",
      "description": "Running hours, cycles and counters. Every reading is the server's figure; the change between readings is its subtraction, not this screen's.",
      "registerTitle": "Meters",
      "empty": "No meters yet.",
      "loadFailed": "The meters could not be loaded.",
      "readingsTitle": "Readings",
      "readingsEmpty": "No readings for this meter yet.",
      "recordReading": "Record reading",
      "readingRecorded": "Reading recorded",
      "readingFailed": "That reading could not be recorded.",
      "regressionHint": "Only needed when the reading is lower than the last one — a replaced meter, or a correction.",
      "importTitle": "Import readings",
      "importHint": "CSV only. One row per reading; the server reports every row it skipped and why.",
      "import": "Import",
      "imported": "{count} reading(s) imported",
      "importFailed": "The import failed.",
      "skippedRow": "Row {line}: {reason}"
    },
    "failures": {
      "title": "Failures",
      "description": "What broke, when, and how reliable the fleet has been since. The reliability figures are the server's.",
      "tableTitle": "Failures",
      "empty": "No failures recorded.",
      "loadFailed": "The failures could not be loaded.",
      "open": "Open",
      "openOnly": "Show",
      "openOnlyYes": "Open only",
      "openOnlyNo": "All",
      "record": "Record failure",
      "recorded": "Failure recorded",
      "recordFailed": "That failure could not be recorded.",
      "restore": "Mark restored",
      "restored": "Failure marked restored",
      "restoreFailed": "That failure could not be marked restored.",
      "reliabilityTitle": "Reliability",
      "reliabilityEmpty": "No reliability figures for this window."
    },
    "compliance": {
      "title": "Compliance calendar",
      "description": "Statutory inspections by due date. A requirement that blocks operation takes the asset out of service when it goes overdue.",
      "calendarTitle": "By due date",
      "summary": "Standing",
      "overdueCount": "{count} overdue",
      "dueSoonCount": "{count} due soon",
      "asOf": "as of {date}",
      "blocksOperation": "Blocks operation",
      "assetUnavailable": "Asset unavailable",
      "empty": "Nothing due in this window.",
      "loadFailed": "The compliance calendar could not be loaded.",
      "recordInspection": "Record inspection",
      "inspectionTitle": "Record an inspection",
      "inspectionRecorded": "Inspection recorded",
      "inspectionFailed": "That inspection could not be recorded.",
      "passReleasesNote": "A pass sets the next due date and releases the compliance downtime in the same transaction, so the asset becomes available again immediately."
    },
    "permits": {
      "title": "Permits to work",
      "description": "Who asked, who issued, who did the work and who accepted it back. Three signatures, three different people.",
      "empty": "No permits match.",
      "loadFailed": "The permits could not be loaded.",
      "sodNote": "Requesting, issuing and accepting the return are held by different people. A control you cannot sign is not shown, because a permit is a safety document and not a form.",
      "stepRequested": "Requested",
      "stepIssued": "Issued",
      "stepExecuted": "Executed",
      "stepAccepted": "Return accepted",
      "requested": "Requested",
      "notSigned": "Not signed",
      "signedBy": "by {user}",
      "executedByStart": "Stamped when the work order is started, by whoever starts it.",
      "issue": "Issue permit",
      "issued": "Permit issued",
      "issueFailed": "That permit could not be issued.",
      "acceptReturn": "Accept return",
      "returnAccepted": "Return accepted",
      "acceptFailed": "That return could not be accepted."
    },
    "downtime": {
      "title": "Downtime",
      "description": "When assets were unavailable, why, and whether the modules that care acknowledged it.",
      "tableTitle": "Downtime",
      "empty": "No downtime in this window.",
      "loadFailed": "The downtime could not be loaded.",
      "openOnly": "Show",
      "openOnlyYes": "Open only",
      "openOnlyNo": "All",
      "release": "Release",
      "released": "Downtime released",
      "releaseFailed": "That downtime could not be released.",
      "complianceReleaseNote": "Released by recording a passing inspection",
      "eventsTitle": "Availability events",
      "eventsEmpty": "No availability events yet.",
      "receiptsNote": "Each event lists what acknowledged it. An event with no receipt against a linked room or work centre is a real problem, and this is where it is visible.",
      "noReceipts": "Nothing acknowledged this event."
    }
  },
  "reporting": {
    "nav": {
      "label": "Reporting governance sections",
      "dailyOperating": "Daily operating",
      "board": "Month board",
      "dictionary": "Metric dictionary",
      "exceptionViews": "Exception views",
      "dashboards": "Dashboards",
      "savedFilters": "Saved filters"
    },
    "routeTitles": {
      "dictionary": "Metric dictionary",
      "metric": "Metric",
      "dailyOperating": "Daily operating report",
      "board": "Daily operating board",
      "exceptionViews": "Exception views",
      "dashboards": "Role dashboards",
      "drill": "KPI drill-through",
      "savedFilters": "Saved filter sets"
    },
    "dictionary": {
      "title": "Metric dictionary",
      "description": "Every figure this product reports, with what it means, who owns it and whether anybody stands behind it.",
      "search": "Narrow this page",
      "searchPlaceholder": "Code or label",
      "module": "Module",
      "certification": "Certification",
      "includeOrphaned": "Include metrics no longer produced",
      "sync": "Sync from the registry",
      "synced": "{metrics} metric(s) projected, {orphaned} marked no longer produced.",
      "syncFailed": "The sync did not run",
      "chooseCompanyTitle": "Choose a legal entity",
      "chooseCompanyDescription": "A certification and an owner are recorded per legal entity, so the dictionary needs to know which one you are reading.",
      "loadFailed": "The dictionary could not be loaded",
      "filteredEmptyTitle": "No metric matches these filters",
      "filteredEmptyDescription": "Clear the filters to see the whole dictionary you are permitted to read.",
      "emptyTitle": "No metrics are projected into this tenant yet",
      "emptyDescription": "Modules declare their metrics in code and a sync projects them here. Run the sync, or ask an administrator to.",
      "tableLabel": "Metric dictionary",
      "orphanReason": "no longer produced",
      "noOwner": "Unowned",
      "states": {
        "certified": "Certified",
        "adHoc": "Ad hoc",
        "stale": "Certified (stale)"
      },
      "sourceKinds": {
        "module_function": "Module function",
        "read_model": "Read model",
        "ledger": "Ledger",
        "derived": "Derived"
      },
      "columns": {
        "code": "Code",
        "label": "Label",
        "formula": "Formula",
        "source": "Source",
        "grain": "Grain",
        "unit": "Unit",
        "refresh": "Refresh",
        "owner": "Owner",
        "certification": "Certification"
      },
      "minutesUnit": "min"
    },
    "metric": {
      "description": "What this figure means, who owns it, and what has been emitted carrying it.",
      "loadFailed": "This metric could not be loaded",
      "orphanedNote": "No module produces this metric any more. Its row, its certifications and the outputs that carried it are kept so an evidence pack can still say what it certified.",
      "definitionTitle": "Definition",
      "permission": "Read permission",
      "contentHash": "Definition hash",
      "tenantTitle": "Your settings",
      "tenantDescription": "Four things belong to this tenant. Everything above belongs to the code that produces the figure and is shown, not offered for edit.",
      "refreshMinutes": "Refresh interval (minutes)",
      "refreshHint": "May be lengthened, never shortened. The registry declares {current} minutes.",
      "published": "Publish this metric to users",
      "note": "Note",
      "saved": "Saved",
      "ownershipTitle": "Ownership",
      "ownershipDescription": "A metric is owned by a position, not a person, so ownership survives the person moving on.",
      "noOwnerTitle": "Nobody owns this metric",
      "noOwnerDescription": "An unowned figure is one nobody has to answer for. Ask a metric manager to assign a position.",
      "position": "Position",
      "from": "From",
      "to": "To",
      "current": "Current",
      "newOwner": "New owner",
      "choosePosition": "Choose a position",
      "assignOwner": "Assign owner",
      "ownerSet": "Owner assigned",
      "positionsUnreadable": "Assigning an owner needs permission to read positions, which this account does not hold.",
      "certificationTitle": "Certification",
      "notCertifiable": "This metric is indicative and cannot be certified. The registry says so, and the server refuses it.",
      "sodNote": "Certifying is segregated from managing: whoever can change what a metric means must not be the one who certifies that it means the right thing. This account manages metrics, so it cannot certify them.",
      "staleNote": "The definition has changed since this certification was signed, so it no longer certifies anything. Every output emitted from now on records this metric as ad hoc until it is certified again.",
      "status": "Status",
      "basis": "Basis",
      "certifiedBy": "Certified by",
      "certifiedAt": "Certified at",
      "revoke": "Revoke",
      "certify": "Certify",
      "certifyTitle": "Certify this metric",
      "certifyDescription": "Say what you checked. The basis is what an external auditor reads.",
      "basisHint": "For example: reconciled to the AR control account for FY2026 Q3; confirmed the window is trailing 90 days and excludes intercompany.",
      "basisRequired": "A basis is required.",
      "certified": "Certified",
      "revokeTitle": "Revoke this certification",
      "revokeDescription": "Outputs already emitted still say they carried a certified figure, because they did. Revoking changes what happens next, never what happened.",
      "reasonCode": "Reason code",
      "reasonRequired": "A reason code is required.",
      "revoked": "Certification revoked",
      "outputsTitle": "Outputs carrying this metric",
      "outputsDescription": "Every export, schedule and PDF that carried this figure, and whether it was certified at the moment it was emitted.",
      "noOutputsTitle": "Nothing has been emitted carrying this metric",
      "noOutputsDescription": "Exports, scheduled reports and PDFs record which metrics they carried. None has yet.",
      "report": "Report",
      "format": "Format",
      "certificationState": "State when emitted",
      "emittedAt": "Emitted",
      "certificationStatuses": {
        "active": "Active",
        "revoked": "Revoked",
        "superseded": "Superseded"
      }
    },
    "dailyOps": {
      "title": "Daily operating report",
      "description": "One operating day for one unit: revenue, controllable cost, labour, cash and the exceptions somebody has to clear.",
      "build": "Build a day",
      "built": "Report built",
      "buildFieldsRequired": "A unit and a business date are required.",
      "unitType": "Unit type",
      "unitId": "Unit",
      "businessDate": "Business date",
      "force": "Rebuild a published day",
      "from": "From",
      "to": "To",
      "lateOnly": "Late only",
      "loadFailed": "The reports could not be loaded",
      "detailFailed": "This report could not be loaded",
      "emptyTitle": "No daily operating report for this window",
      "emptyDescription": "Reports are built overnight for the previous business day. Build one to see today's, or widen the dates.",
      "tableLabel": "Daily operating reports",
      "unit": "Unit",
      "status": "Status",
      "revenue": "Revenue",
      "exceptions": "Exceptions",
      "ledgerTie": "Ledger tie",
      "ties": "Ties",
      "doesNotTie": "Does not tie",
      "reportRevenue": "Report revenue",
      "ledgerRevenue": "Posted to the ledger",
      "difference": "Difference",
      "ledgerScope": "Ledger scope",
      "failedSections": "{count} section(s) failed and their lines are missing from this report:",
      "publishedAtLabel": "Published",
      "aheadOfDue": "· {ahead} before the due time of",
      "lateBy": "· {late} late against the due time of",
      "notPublished": "Not published yet",
      "dueAtLabel": "· due",
      "publish": "Publish",
      "published": "Report published",
      "publishFailed": "The report was not published",
      "familyEmptyTitle": "Nothing in this family today",
      "familyEmptyDescription": "No section produced a line here for this unit and date.",
      "line": "Line",
      "stream": "Stream",
      "quantity": "Quantity",
      "amount": "Amount",
      "memo": "Memo",
      "unitTypes": {
        "company": "Legal Entity",
        "branch": "Branch",
        "location": "Location"
      },
      "statuses": {
        "draft": "Draft",
        "published": "Published",
        "superseded": "Superseded"
      },
      "families": {
        "revenue": "Revenue",
        "controllable_cost": "Controllable cost",
        "labour": "Labour",
        "cash": "Cash",
        "exception": "Exceptions"
      },
      "sectionStatuses": {
        "ok": "Ran",
        "empty": "Empty",
        "skipped": "Skipped",
        "failed": "Failed"
      },
      "outcomesTitle": "Section outcomes",
      "outcomesShow": "Show",
      "outcomesHide": "Hide",
      "outcomesHint": "Which of the report's sections ran, which were skipped and which failed.",
      "outcomesFailed": "The section outcomes could not be loaded",
      "section": "Section",
      "module": "Module",
      "lineCount": "Lines",
      "durationMs": "Took (ms)",
      "outcomeNote": "Note",
      "outcomeNoLines": "Ran and found nothing."
    },
    "dailyOperating": {
      "section": {
        "revenuePos": "Point of sale",
        "revenuePms": "Rooms and property",
        "revenueAr": "Invoiced revenue",
        "controllableCostInventory": "Inventory issues",
        "labourRoster": "Labour",
        "cashSessions": "Cash sessions",
        "exceptions": "Exceptions",
        "exceptionAttention": "Exceptions"
      },
      "line": {
        "posOutlet": "Outlet",
        "posAccountTendered": "Charged to rooms",
        "pmsRevenueCentre": "Revenue centre",
        "pmsBoardPackage": "Board package carve-out",
        "arRevenueAccount": "Revenue account",
        "inventoryIssues": "Stock issued at value",
        "labourCosted": "Costed labour",
        "labourUncosted": "Rostered but not costed",
        "cashPaidIn": "Paid in",
        "cashPaidOut": "Paid out",
        "cashVariance": "Cash variance",
        "reconciliation": "Reconciliation item"
      }
    },
    "board": {
      "title": "Daily operating board",
      "description": "One cell per unit and day: filed on time, filed late, or not filed at all.",
      "chooseWindowTitle": "Choose a legal entity and a window",
      "chooseWindowDescription": "The board shows one month at a time. Pick the dates you want rather than letting a browser clock guess at the tenant's month.",
      "loadFailed": "The board could not be loaded",
      "emptyTitle": "No reports in this window",
      "emptyDescription": "Nothing has been built for these dates. Build a day from the daily operating screen.",
      "lateCount": "Filed late",
      "missingCount": "Not filed",
      "dueHour": "Due hour",
      "dueHourHelp": "The hour of the next business day by which a report is expected, in the tenant's own timezone.",
      "late": "Late"
    },
    "exceptions": {
      "title": "Exception views",
      "description": "The exceptions your role owns, ranked by consequence and refreshed on each view's own interval, without opening each module in turn.",
      "loadFailed": "The exception views could not be loaded",
      "rowsFailed": "This view's rows could not be loaded",
      "emptyTitle": "No exception views for this legal entity",
      "emptyDescription": "A view is a role, a set of sources and a refresh interval. Ask an administrator to create one for your role.",
      "noRowsTitle": "Nothing open in this view",
      "noRowsDescription": "Every question this view asks currently has no answer outstanding.",
      "tabsLabel": "Exception views",
      "asAt": "As at",
      "live": "live",
      "refreshEvery": "refreshes every {minutes} minutes",
      "ageIs": "{age} old",
      "source": "Source",
      "document": "Document",
      "opened": "Opened",
      "age": "Age (days)",
      "amount": "Amount",
      "sources": {
        "attention": "Attention",
        "recon_queue": "Reconciliation queue",
        "approvals": "Approvals",
        "ai_recommendations": "AI recommendations"
      },
      "newTitle": "New exception view",
      "editTitle": "Edit exception view",
      "editorDescription": "A view is a role, the sources it draws from, and how often its answer may be reused.",
      "code": "Code",
      "codeHint": "Fixed once the view exists; links refer to it.",
      "name": "Name",
      "roleCode": "Role",
      "roleHint": "The role this view is offered to.",
      "sourcesLabel": "Sources",
      "sourceRequired": "Choose at least one source.",
      "fieldsRequired": "A code, a name and a role are required.",
      "refreshMinutes": "Refresh every (minutes)",
      "refreshHint": "Zero means the view is computed live on every open.",
      "refreshRange": "The refresh interval must be zero or more whole minutes.",
      "sortOrder": "Order",
      "sortRange": "The order must be zero or more.",
      "active": "Offered to the role",
      "inactive": "Not offered",
      "saved": "Exception view saved",
      "deleted": "Exception view deleted",
      "deleteFailed": "The exception view was not deleted",
      "deleteTitle": "Delete this exception view?",
      "deleteDescription": "{name} will no longer be offered to its role."
    },
    "metricCatalogue": {
      "ar": {
        "dso": {
          "label": "Days sales outstanding",
          "formula": "Closing AR balance ÷ credit sales in the window × days in the window."
        },
        "unposted_invoices": {
          "label": "Unposted customer invoices",
          "formula": "Customer invoices in the period that are approved but not yet posted."
        }
      },
      "ap": {
        "dpo": {
          "label": "Days payable outstanding",
          "formula": "Closing AP balance ÷ purchases in the window × days in the window."
        },
        "unposted_invoices": {
          "label": "Unposted supplier invoices",
          "formula": "Supplier invoices in the period that are approved but not yet posted."
        }
      },
      "gl": {
        "gross_margin": {
          "label": "Gross margin",
          "formula": "Revenue less cost of sales, over revenue, for the window."
        },
        "suspense_balance": {
          "label": "Suspense balance",
          "formula": "Balance on the suspense accounts at the end of the period."
        },
        "unposted_journals": {
          "label": "Unposted journals",
          "formula": "Journal entries in the period that are drafted or submitted but not posted."
        }
      },
      "budget": {
        "headroom_fytd": {
          "label": "Budget headroom, year to date",
          "formula": "Approved budget less commitments less actuals, financial year to date."
        }
      },
      "org": {
        "open_periods": {
          "label": "Open fiscal periods",
          "formula": "Count of periods in the fiscal year whose status is open or soft closed."
        }
      },
      "inventory": {
        "value": {
          "label": "Inventory value",
          "formula": "Sum of the stock ledger's running value across every item and warehouse at the instant."
        },
        "turns": {
          "label": "Inventory turns",
          "formula": "Cost of goods sold in the window ÷ average inventory value over the window."
        }
      },
      "procurement": {
        "grir_open": {
          "label": "Open GR-IR",
          "formula": "Goods received not yet invoiced, at cost, across every purchase order line."
        },
        "vendor_otif": {
          "label": "Vendor on time in full",
          "formula": "Receipts delivered complete and on the promised date, over all receipts in the window."
        }
      },
      "crm": {
        "open_pipeline": {
          "label": "Open pipeline",
          "formula": "Value of opportunities not yet won or lost, at the instant."
        }
      },
      "sales": {
        "mrr": {
          "label": "Monthly recurring revenue",
          "formula": "Normalised monthly value of active subscriptions in the month."
        }
      },
      "hr": {
        "headcount": {
          "label": "Headcount",
          "formula": "Employees with an active assignment at the instant."
        },
        "attrition": {
          "label": "Attrition",
          "formula": "Leavers in the window over average headcount across the window."
        }
      },
      "projects": {
        "open_projects": {
          "label": "Open projects",
          "formula": "Projects whose status is neither closed nor cancelled, at the instant."
        }
      },
      "reporting": {
        "posted_revenue_by_date": {
          "label": "Posted revenue by business date",
          "formula": "Sum of credits less debits on the unit's revenue accounts for one business date."
        },
        "daily_revenue_by_stream": {
          "label": "Daily revenue by stream",
          "formula": "Sum of the day's non-memo revenue lines for the unit, by stream."
        },
        "daily_controllable_cost": {
          "label": "Daily controllable cost",
          "formula": "Sum of the day's non-memo controllable cost lines for the unit."
        },
        "daily_labour_cost": {
          "label": "Daily labour cost",
          "formula": "Sum of the day's costed labour lines for the unit."
        },
        "daily_cash_variance": {
          "label": "Daily cash variance",
          "formula": "Counted cash less expected cash across the day's closed sessions."
        },
        "daily_exception_count": {
          "label": "Daily exception count",
          "formula": "Open attention and reconciliation items attributable to the unit's day."
        }
      },
      "close": {
        "blocking_readiness_count": {
          "label": "Blocking close checks",
          "formula": "Readiness checks in the period that would refuse a close."
        }
      }
    },
    "dashboards": {
      "title": "Dashboards",
      "description": "The role dashboards, each figure computed by the reporting read models and each one clicking through to the rows behind it.",
      "tabsLabel": "Role dashboards",
      "loadFailed": "This dashboard could not be loaded",
      "catalogueFailed": "The KPI catalogue could not be loaded",
      "emptyTitle": "Nothing to show on this dashboard yet",
      "emptyDescription": "No KPI has been computed for this legal entity. Rebuild to compute them now, or wait for tonight's run.",
      "generatedAt": "Generated",
      "hidden": "{count} KPI(s) hidden by your permissions",
      "cardCount": "{count} card(s)",
      "computedAt": "Computed {at} · to {period}",
      "cardHelp": "{unit}, from the {source} projection.",
      "drill": "Open the rows behind {label}",
      "unitDays": "days",
      "export": "Export",
      "exportGroup": "Export this dashboard",
      "exported": "Export downloaded",
      "exportFailed": "The export could not be produced",
      "rebuild": "Rebuild",
      "rebuilt": "Dashboards rebuilt",
      "rebuiltDetail": "{count} card(s) recomputed.",
      "rebuildFailed": "The rebuild did not run",
      "names": {
        "executive": "Executive",
        "finance": "Finance",
        "sales": "Sales",
        "inventory": "Inventory",
        "procurement": "Procurement",
        "hr": "People",
        "project": "Projects",
        "commercial": "Commercial"
      },
      "units": {
        "money": "An amount",
        "percent": "A percentage",
        "count": "A count",
        "days": "A number of days",
        "ratio": "A ratio"
      },
      "sources": {
        "incremental": "incrementally maintained",
        "rebuild": "rebuilt"
      },
      "formats": {
        "csv": "CSV file",
        "xlsx": "Excel workbook",
        "pdf": "PDF document"
      }
    },
    "kpiCatalogue": {
      "dso": "Days sales outstanding",
      "dpo": "Days payable outstanding",
      "margin": "Gross margin",
      "variance": "Budget headroom (year to date)",
      "close_status": "Open fiscal periods",
      "inventory_value": "Inventory value",
      "turns": "Inventory turns (annualised)",
      "grir_open": "Open GR-IR balance",
      "vendor_otif": "Supplier on-time in-full (90 days)",
      "pipeline": "Open pipeline",
      "mrr": "Monthly recurring revenue",
      "headcount": "Active headcount",
      "attrition": "Attrition (trailing 12 months)",
      "open_projects": "Open projects"
    },
    "drill": {
      "title": "{label} — the rows behind it",
      "description": "Exactly the rows that make up the card, in the server's own words and figures. Nothing here is recomputed.",
      "back": "Back to the dashboard",
      "generatedAt": "Generated {at}",
      "loadFailed": "The rows behind this figure could not be loaded",
      "emptyTitle": "No rows behind this figure",
      "emptyDescription": "The figure is currently made up of nothing — there is no outstanding balance, order or record to list.",
      "noCompanyTitle": "Open this from a dashboard card",
      "noCompanyDescription": "A drill-through belongs to one legal entity. Open the dashboard, then click the figure you want to see behind."
    },
    "savedFilters": {
      "title": "Saved filter sets",
      "description": "A name for a question: the report it belongs to, the parameters that narrow it, and whether colleagues may use it too.",
      "new": "New filter set",
      "edit": "Edit filter set",
      "editorDescription": "The report a set belongs to is fixed once it exists, because links and schedules refer to it.",
      "name": "Name",
      "report": "Report",
      "reportKey": "Report key",
      "reportKeyHint": "dashboard:finance or kpi:dso",
      "params": "Parameters",
      "paramsHint": "A JSON object of the filters this set applies.",
      "paramsInvalid": "The parameters are not valid JSON.",
      "paramsNotObject": "The parameters must be a JSON object, not a list or a value.",
      "fieldsRequired": "A name and a report key are required.",
      "shareWithColleagues": "Share this set with colleagues",
      "shared": "Shared",
      "private": "Yours only",
      "visibility": "Visibility",
      "updated": "Last changed",
      "saved": "Filter set saved",
      "delete": "Delete",
      "deleteTitle": "Delete this filter set?",
      "deleteDescription": "{name} will be removed. Anyone who has been using it will lose it.",
      "deleted": "Filter set deleted",
      "deleteFailed": "The filter set was not deleted",
      "loadFailed": "The saved filter sets could not be loaded",
      "emptyTitle": "No saved filter sets yet",
      "emptyDescription": "Save the parameters of a report you run often so it comes back the same way every time."
    }
  },
  "rvm": {
    "nav": {
      "label": "Revenue management sections",
      "onTheBooks": "On the books",
      "pace": "Pace",
      "commercial": "Commercial report",
      "forecasts": "Forecasts",
      "accuracy": "Accuracy",
      "displacements": "Displacement",
      "hurdles": "Hurdles",
      "competitorRates": "Competitor rates",
      "settings": "Settings",
      "dimensions": "Dimensions"
    },
    "routeTitles": {
      "onTheBooks": "On the books",
      "pace": "Pace and pickup",
      "commercial": "Daily commercial report",
      "forecasts": "Forecasts",
      "forecast": "Forecast",
      "accuracy": "Forecast accuracy",
      "displacements": "Displacement evaluations",
      "displacement": "Displacement evaluation",
      "hurdles": "Hurdle rates",
      "competitorRates": "Competitor rates",
      "settings": "Revenue settings",
      "dimensions": "Segments and streams"
    },
    "common": {
      "stayDate": "Stay date",
      "segment": "Segment",
      "stream": "Stream",
      "roomType": "Room type",
      "allSegments": "Every segment",
      "allRoomTypes": "Every room type",
      "remove": "Remove",
      "yes": "Yes",
      "no": "No",
      "active": "Active",
      "inactive": "Inactive",
      "channel": "Channel",
      "allChannels": "Every channel"
    },
    "picker": {
      "property": "Property",
      "placeholder": "Choose a property",
      "idPlaceholder": "Property id",
      "chooseTitle": "Choose a property",
      "chooseDescription": "Every revenue figure belongs to one property, so nothing can be shown until you pick one.",
      "unnamedProperty": "Property #{id}",
      "unnamedHint": "Properties are listed by id because naming them needs the pms.property.read and org.company.read permissions, which this account does not hold.",
      "unnamedRoomTypes": "Room types are shown by id: naming them needs the pms.property.read permission, which this account does not hold."
    },
    "onTheBooks": {
      "title": "On the books",
      "description": "What is sold as at a given night, from the snapshot taken on that night. A snapshot is never rebuilt afterwards.",
      "asOf": "As at",
      "asOfHint": "Walk the snapshot series",
      "latest": "Latest snapshot",
      "older": "Older snapshot",
      "newer": "Newer snapshot",
      "linesTaken": "{count} line(s)",
      "stayFrom": "Stay from",
      "stayTo": "Stay to",
      "wholeHorizon": "Whole horizon",
      "window": "Window",
      "horizonTo": "Horizon to",
      "takenAt": "Taken at",
      "basis": "Reservation statuses counted",
      "take": "Take today's snapshot",
      "taken": "Snapshot taken for {date}.",
      "alreadyTaken": "A snapshot for this business date already exists, and a snapshot is never retaken.",
      "takeFailed": "The snapshot was not taken",
      "loadFailed": "The on-the-books surface could not be loaded",
      "noSnapshotEverTitle": "No snapshot has ever been taken for this property",
      "noSnapshotEverDescription": "This is not the same as nothing being booked. A snapshot is taken nightly on the property's own business date and is never backfilled, so until the first one is taken there is no on-the-books figure to show.",
      "noSnapshotForTitle": "No snapshot as at {date}",
      "noSnapshotForDescription": "That night's snapshot was never taken, and one cannot be reconstructed afterwards. Choose another as-at date from the series.",
      "noBookingsTitle": "Nothing on the books as at {date}",
      "noBookingsDescription": "The snapshot was taken and it is empty for this window: no rooms are sold for these stay dates. That is a different fact from there being no snapshot.",
      "roomsOtb": "Rooms on the books",
      "roomsOtbHelp": "Room nights sold as at the snapshot date.",
      "capacity": "Capacity",
      "arrivals": "Arrivals",
      "cancellations": "Cancellations",
      "occupancy": "Occupancy",
      "occupancyHelp": "Rooms sold over capacity, computed by the server.",
      "adr": "ADR",
      "adrHelp": "Revenue over rooms sold, computed by the server.",
      "revpar": "RevPAR",
      "revparHelp": "Revenue over capacity — never ADR multiplied by occupancy, which rounds twice.",
      "revenue": "Net revenue",
      "revenueHelp": "Net of package allocations, as the snapshot defines it.",
      "linesTitle": "The snapshot's lines",
      "linesDescription": "One line per stay date, segment, room type and channel, exactly as the snapshot stored it.",
      "focusDate": "Show this stay date on its own",
      "noArithmetic": "Occupancy, ADR and RevPAR above are computed by the server for the window shown. Narrow the window to one stay date to see that date's own figures.",
      "definitionTitle": "What this snapshot counted",
      "defStatuses": "Reservation statuses",
      "defHeld": "Held reservations included",
      "defUnpicked": "Unpicked group block rooms included",
      "defComplimentary": "Complimentary rooms included",
      "defRevenueBasis": "Revenue basis"
    },
    "pace": {
      "title": "Pace and pickup",
      "description": "Today's on the books against the same lead time last year and against the published forecast.",
      "asOf": "As at",
      "asOfPlaceholder": "Choose a snapshot date",
      "breakdownHint": "Narrow the whole page to one segment",
      "thisYearAsOf": "This year, as at",
      "priorYearAsOf": "Last year, same lead time",
      "snapshotId": "snapshot {id}",
      "snapshotPair": "snapshots {from} and {to}",
      "chartTitle": "Three lines",
      "chartAria": "Net revenue on the books, last year and forecast, by stay date",
      "seriesOtb": "On the books",
      "seriesPriorYear": "Same lead time last year",
      "seriesForecast": "Published forecast",
      "noPublishedForecast": "This property has no published forecast version, so the third line is not drawn.",
      "noPublishedBudget": "This property has no published budget version, so the third line is not drawn.",
      "noVersionChosen": "Choose a container and a version to draw the third line.",
      "comparisonBasis": "Comparison basis",
      "basisOptions": {
        "forecast": "Forecast",
        "budget": "Budget",
        "version": "Nominated version"
      },
      "basisContainer": "Container",
      "basisContainerPlaceholder": "Choose a forecast or budget",
      "basisVersion": "Version",
      "basisVersionPlaceholder": "Choose a version",
      "tableTitle": "Pace by stay date",
      "priorYearStayDate": "Last year's date",
      "rooms": "Rooms",
      "roomsPriorYear": "Rooms last year",
      "roomsVariance": "Rooms variance",
      "revenue": "Revenue",
      "revenuePriorYear": "Revenue last year",
      "revenueVariance": "Revenue variance",
      "adrVariance": "ADR variance",
      "emptyTitle": "No overlapping stay dates",
      "emptyDescription": "The two snapshots share no stay date in this window. Widen the window or choose another as-at date.",
      "loadFailed": "Pace could not be loaded",
      "needsTwoSnapshots": "Pace compares two snapshots, so it needs at least one to have been taken. Snapshots are taken nightly.",
      "missingDescription": "Pace needs the snapshot for that as-at date and for the same lead time a year earlier. One of them was never taken and cannot be reconstructed.",
      "pickupTitle": "Pickup",
      "pickupDescription": "What was added between two snapshots, for the same stay dates.",
      "pickupFrom": "From snapshot",
      "pickupTo": "To snapshot",
      "pickupRooms": "Rooms picked up",
      "pickupRoomsHelp": "The difference in rooms between the two snapshots.",
      "pickupRevenue": "Revenue picked up",
      "pickupAdr": "Pickup ADR",
      "pickupAdrHelp": "Revenue picked up over rooms picked up, computed by the server.",
      "pickupBetween": "Between",
      "pickupRoomsFromTo": "Rooms, before and after",
      "pickupRevenueFromTo": "Revenue, before and after",
      "pickupFailed": "Pickup could not be loaded",
      "pickupMissingDescription": "Pickup needs both snapshots. One of the two dates has none, and a snapshot is never reconstructed.",
      "channelHint": "Narrow the comparison to one channel. A booking taken at the desk carries no channel and is not included."
    },
    "forecasts": {
      "title": "Forecasts",
      "description": "A forecast is a container; the number a property is run to is a published version of one.",
      "new": "New forecast",
      "code": "Code",
      "name": "Name",
      "kind": "Kind",
      "kinds": {
        "forecast": "Forecast",
        "budget": "Budget"
      },
      "period": "Period",
      "periodFrom": "Period from",
      "periodTo": "Period to",
      "currency": "Currency",
      "currencyHint": "Defaults to the property's own currency",
      "published": "Published version",
      "noPublished": "None published",
      "versionRef": "version {id}",
      "status": "Status",
      "created": "Forecast created.",
      "fieldsRequired": "Code, name and both period dates are required.",
      "loadFailed": "Forecasts could not be loaded",
      "emptyTitle": "No forecast for this property yet",
      "emptyDescription": "Create one, then add a draft version and its lines. Nothing is published until a version is approved."
    },
    "forecast": {
      "subtitle": "{kind}, {from} to {to}",
      "loadFailed": "The forecast could not be loaded",
      "versionsTitle": "Versions",
      "versionNo": "Version",
      "versionName": "Name",
      "versionLabel": "v{no}",
      "versionRef": "version {id}",
      "newVersion": "New version",
      "status": "Status",
      "statuses": {
        "draft": "Draft",
        "submitted": "Submitted",
        "approved": "Approved",
        "rejected": "Rejected",
        "published": "Published",
        "locked": "Locked",
        "superseded": "Superseded"
      },
      "submitted": "Submitted at",
      "approved": "Approved at",
      "publishedAt": "Published at",
      "roomNights": "Room nights",
      "revenue": "Net revenue",
      "submit": "Submit for approval",
      "approve": "Approve",
      "reject": "Reject",
      "publish": "Publish",
      "lock": "Lock",
      "done": {
        "newVersion": "Version created.",
        "submit": "Submitted for approval.",
        "approve": "Version approved.",
        "reject": "Version rejected.",
        "publish": "Version published.",
        "lock": "Version locked.",
        "explain": "Explanation recorded.",
        "lines": "Lines saved."
      },
      "failed": {
        "newVersion": "The version was not created",
        "submit": "The version was not submitted",
        "approve": "The version was not approved",
        "reject": "The version was not rejected",
        "publish": "The version was not published",
        "lock": "The version was not locked"
      },
      "varianceTitle": "Movement against the last published version",
      "varianceDescription": "A movement is material only when it exceeds both the absolute and the percentage band the property has set.",
      "unexplained": "{count} material movement(s) still need an explanation:",
      "allExplained": "All {count} material movement(s) are explained.",
      "noMaterialMovement": "Nothing has moved materially against the last published version.",
      "bandAbs": "Material above",
      "bandPct": "and above a movement ratio of",
      "priorRevenue": "Prior revenue",
      "newRevenue": "New revenue",
      "delta": "Movement",
      "explanation": "Explanation",
      "explain": "Explain",
      "explainNotPermitted": "You do not have permission to explain variances",
      "explainTitle": "Explain this movement",
      "reason": "Reason",
      "reasonRequired": "Choose a reason code.",
      "recordExplanation": "Record explanation",
      "publishBlocked": "Publish is unavailable until every material movement is explained: {count} outstanding.",
      "linesTitle": "Lines",
      "linesEditable": "This version is a draft, so its lines can still be changed.",
      "linesFrozen": "This version is frozen: its lines are the record of what was published.",
      "editLines": "Edit lines",
      "addLine": "Add line",
      "lineFieldsRequired": "Every line needs a stay date, a segment and a stream.",
      "adrServerSide": "computed",
      "noLinesTitle": "This version has no lines",
      "noLinesDescription": "Add lines to a draft version, then submit it for approval.",
      "editHeader": "Edit forecast",
      "headerSaved": "Forecast updated",
      "headerSaveFailed": "The forecast could not be updated",
      "nameRequired": "A forecast needs a name.",
      "retire": "Retire",
      "reactivate": "Reactivate",
      "retired": "Forecast retired",
      "reactivated": "Forecast reactivated",
      "retiredNote": "This forecast is retired. Its published versions stay readable and every accuracy run that scored them is unchanged, but it no longer feeds the commercial report."
    },
    "accuracy": {
      "title": "Forecast accuracy",
      "description": "Every point is scored against the forecast as it stood when it was published, never against the current version.",
      "run": "Run accuracy",
      "ran": "Accuracy run completed.",
      "rangeRequired": "Both scored dates are required.",
      "forecast": "Forecast",
      "actual": "Actual",
      "scored": "Scored",
      "scoredFrom": "Scored from",
      "scoredTo": "Scored to",
      "startedAt": "Started",
      "lineCount": "Lines",
      "runsTitle": "Runs",
      "byHorizonTitle": "By horizon",
      "byHorizonDescription": "One row per lead time, so a forecast that is good at 30 days and poor at 90 cannot hide behind an average.",
      "horizon": "Horizon",
      "horizonDays": "{days} days out",
      "n": "Points scored",
      "mapeN": "Points with a percentage",
      "mape": "MAPE",
      "mae": "MAE",
      "bias": "Bias",
      "nNote": "A stay date with no version published at that lead time is skipped and counted, so the two counts differ on purpose.",
      "chartTitle": "Forecast against actual",
      "chartAria": "Forecast and actual net revenue by stay date",
      "pointStamp": "forecast of {date}, {horizon} days out, version {version} — forecast {forecast}, actual {actual}",
      "linesTitle": "Scored lines",
      "asPublished": "As published",
      "absoluteError": "Absolute error",
      "ape": "Percentage error",
      "noLinesTitle": "No scored lines at this horizon",
      "noLinesDescription": "Choose another horizon, or score a wider date range.",
      "loadFailed": "Accuracy runs could not be loaded",
      "emptyTitle": "No accuracy run yet",
      "emptyDescription": "Accuracy is scored on demand or nightly, over a range of stay dates that have already happened."
    },
    "hurdles": {
      "title": "Hurdle rates",
      "description": "A hurdle is a test applied to a price the pricing engine produced. It is not a price and it quotes nothing.",
      "new": "New hurdle",
      "activeOnly": "Active only",
      "narrowing": "Applies to",
      "narrowHint": "Leave blank to apply to everything",
      "anySegment": "Any segment",
      "anyRoomType": "Any room type",
      "anyDate": "Any date",
      "dateFrom": "From",
      "dateTo": "To",
      "minAdr": "Minimum ADR",
      "minAdrRequired": "A minimum ADR is required.",
      "minContribution": "Minimum contribution",
      "tier": "Tier",
      "note": "Note",
      "everyDay": "Every day",
      "days": {
        "legend": "Days of the week",
        "sun": "Sun",
        "mon": "Mon",
        "tue": "Tue",
        "wed": "Wed",
        "thu": "Thu",
        "fri": "Fri",
        "sat": "Sat"
      },
      "noDays": "A hurdle that applies on no day applies to nothing. Deactivate it instead.",
      "created": "Hurdle created.",
      "removed": "Hurdle removed.",
      "removeFailed": "The hurdle was not removed",
      "loadFailed": "Hurdles could not be loaded",
      "emptyTitle": "No hurdle for this property",
      "emptyDescription": "Without a hurdle, a displacement evaluation reports its net benefit and applies no floor to the rate.",
      "testerTitle": "Which hurdle applies?",
      "testerDescription": "Resolution is most-specific first over seven tiers, and ties break on id, so exactly one hurdle can win.",
      "testerFailed": "The tester could not resolve a hurdle",
      "winner": "{narrowing} wins, at tier {tier}.",
      "noWinner": "No hurdle applies on this date.",
      "candidates": "Every hurdle that matched",
      "outcome": "Outcome",
      "wins": "Wins",
      "lessSpecific": "Less specific"
    },
    "displacements": {
      "title": "Displacement evaluations",
      "description": "Is this group worth more than the transient business it pushes out? The server answers with a net benefit from both arms.",
      "evaluate": "Evaluate a group",
      "evaluateDescription": "Evaluating is not deciding: they are different permissions, and one person should not do both.",
      "enquiry": "Enquiry",
      "arrival": "Arrival",
      "departure": "Departure",
      "arrivalFrom": "Arriving from",
      "arrivalTo": "Arriving to",
      "offeredAdr": "Offered ADR",
      "rooms": "Rooms",
      "roomsRequested": "Rooms requested",
      "addRoomType": "Add a room type",
      "groupAncillaryRate": "Group ancillary, % of room revenue",
      "groupDirectCostRate": "Group direct cost, % of room revenue",
      "displacedAncillaryRate": "Displaced ancillary, % of room revenue",
      "displacedDirectCostRate": "Displaced direct cost, % of room revenue",
      "rateHint": "Enter 8.75 for 8.75%. The property default is used when blank.",
      "rateRange": "Enter a percentage between 0 and 500.",
      "fieldsRequired": "A segment, both dates, an offered ADR and at least one room type are required.",
      "evaluationNo": "Evaluation",
      "draftRef": "Draft #{id}",
      "stay": "Stay",
      "groupRoomNights": "Group room nights",
      "netBenefit": "Net benefit",
      "hurdle": "Hurdle",
      "hurdleMet": "Hurdle met",
      "hurdleMissed": "Below hurdle",
      "noHurdle": "No hurdle applies",
      "statuses": {
        "draft": "Draft",
        "evaluated": "Evaluated",
        "accepted": "Accepted",
        "declined": "Declined",
        "countered": "Countered",
        "withdrawn": "Withdrawn",
        "lapsed": "Lapsed"
      },
      "loadFailed": "Evaluations could not be loaded",
      "detailFailed": "The evaluation could not be loaded",
      "emptyTitle": "No displacement evaluation yet",
      "emptyDescription": "Evaluate a group enquiry to see what it is worth against the business it would displace.",
      "measureOutcomes": "Measure outcomes",
      "measured": "{measured} of {considered} measured, {skipped} skipped.",
      "measureFailed": "Outcomes were not measured",
      "detailSubtitle": "{enquiry}, {from} to {to}",
      "basisSnapshot": "Evaluated against",
      "snapshotRef": "snapshot {id}",
      "noSnapshotBasis": "no snapshot",
      "outcomeDue": "Outcome due",
      "summaryTitle": "Both arms",
      "measure": "Measure",
      "groupArm": "The group",
      "displacedArm": "Displaced business",
      "roomNights": "Room nights",
      "roomRevenue": "Room revenue",
      "ancillaryRevenue": "Ancillary revenue",
      "directCost": "Direct cost",
      "netValue": "Net value",
      "nightsTitle": "Night by night",
      "nightsDescription": "What the group takes and what it pushes out, with the basis of every displaced rate on its own row.",
      "requested": "Requested",
      "accommodated": "Accommodated",
      "displaced": "Displaced",
      "displacedAdr": "Displaced ADR",
      "basis": "Basis",
      "bases": {
        "otb": "Measured (on the books)",
        "forecast": "Forecast",
        "rate_plan": "Assumed (rate plan)"
      },
      "reEvaluate": "Re-evaluate against today",
      "reEvaluated": "Re-evaluated against today's snapshot.",
      "reEvaluateFailed": "The evaluation was not re-run",
      "outcomeTitle": "Prediction against outcome",
      "result": "Result",
      "results": {
        "materialised": "Materialised",
        "partly_materialised": "Partly materialised",
        "no_show": "No show",
        "declined_and_filled": "Declined and filled",
        "declined_and_unsold": "Declined and unsold",
        "unmeasurable": "Unmeasurable"
      },
      "unmeasurableExplained": "An enquiry that never became a group block cannot be scored, so this outcome is excluded from every accuracy figure rather than counted as a miss.",
      "predicted": "Predicted net benefit",
      "realised": "Realised net benefit",
      "outcomeVariance": "Variance",
      "measuredOn": "Measured on",
      "noOutcomeTitle": "No outcome measured yet",
      "noOutcomeDescription": "The outcome is measured after {date}.",
      "decisionTitle": "The decision",
      "decisionDescription": "Accept, decline or counter. A decision with no reason is a decision nobody can review.",
      "decision": "Decision",
      "decisionStatus": "Decided",
      "reason": "Reason",
      "reasonRequired": "Choose a reason code.",
      "counteredAdr": "Countered at",
      "counterRequired": "A counter states the rate it was countered at.",
      "note": "Note",
      "decidedAt": "Decided at",
      "recordDecision": "Record decision",
      "decided": "Decision recorded.",
      "overrideNeeded": "This rate is below the hurdle. Accepting it anyway is an override of a control and needs its own reason.",
      "overrideReason": "Override reason",
      "decideNotPermitted": "Deciding a displacement evaluation needs rvm.displacement.decide, which is deliberately held apart from evaluating."
    },
    "competitors": {
      "title": "Competitor rates",
      "description": "Rates somebody observed, on the day they observed them.",
      "provenance": "Rates are entered by hand or imported from a sheet. This product does not fetch competitor rates from anywhere, by design.",
      "record": "Record a rate",
      "competitor": "Competitor",
      "roomTypeLabel": "Room type as they name it",
      "rate": "Rate",
      "observedOn": "Observed on",
      "observedHint": "Defaults to today in the property's timezone",
      "source": "Source",
      "sources": {
        "manual": "Entered",
        "csv": "Imported"
      },
      "fieldsRequired": "A competitor, a stay date and a rate are required.",
      "recorded": "Rate recorded.",
      "removed": "Rate removed.",
      "removeFailed": "The rate was not removed",
      "loadFailed": "Competitor rates could not be loaded",
      "emptyTitle": "No competitor rate observed yet",
      "emptyDescription": "Record one by hand, or paste a rate sheet and map its columns.",
      "import": "Import a sheet",
      "importDescription": "Column numbers start at zero. The mapping is remembered on this device, because a sheet from one source has the same columns every week.",
      "colCompetitor": "Competitor column",
      "colStayDate": "Stay date column",
      "colRate": "Rate column",
      "colRoomType": "Room type column",
      "colCurrency": "Currency column",
      "colObservedOn": "Observed-on column",
      "colOmit": "-1 to omit",
      "delimiter": "Delimiter",
      "hasHeader": "First row is a header",
      "csv": "Paste the sheet",
      "csvHint": "Comma-separated rows, as exported from a spreadsheet",
      "csvRequired": "Paste the sheet first.",
      "preview": "Preview",
      "commit": "Import {count} row(s)",
      "previewSummary": "{read} row(s) read, {valid} valid, {duplicate} already recorded. Batch:",
      "imported": "{count} row(s) imported.",
      "errors": "Rows that would be refused",
      "line": "Line",
      "column": "Column",
      "problem": "Problem",
      "chartTitle": "Rates side by side",
      "chartAria": "Observed competitor rates by stay date"
    },
    "commercial": {
      "title": "Daily commercial report",
      "description": "One property, one business date: what actually happened, what is on the books ahead, and what it cost to acquire.",
      "businessDate": "Business date",
      "dateHint": "Dates come from the property's own snapshot series",
      "loadFailed": "The commercial report could not be loaded",
      "noSnapshotDescription": "The report reads the latest snapshot for its on-the-books figures, and this property has none yet.",
      "actualOccupancy": "Occupancy",
      "actualOccupancyHelp": "Rooms actually occupied on the business date.",
      "actualAdr": "ADR",
      "actualRevpar": "RevPAR",
      "acquisitionCost": "Acquisition cost",
      "acquisitionHelp": "Commission accrued on this business date.",
      "netAdr": "Net ADR",
      "netAdrHelp": "ADR net of acquisition cost, computed by the server.",
      "roomsOccupied": "Rooms occupied",
      "ofCapacity": "of",
      "onTheBooksTitle": "On the books ahead",
      "onTheBooksDescription": "The next seven, thirty and ninety nights, from the latest snapshot.",
      "horizon": "Horizon",
      "noHorizonsTitle": "No forward window on this snapshot",
      "noHorizonsDescription": "The snapshot's horizon ends before the next seven nights.",
      "segmentTitle": "Revenue by segment",
      "noSegmentsTitle": "No revenue by segment",
      "noSegmentsDescription": "Nothing is on the books for the segments configured on this property.",
      "againstTitle": "Against last year and the forecast",
      "priorYear": "Same lead time last year",
      "noPriorYear": "No snapshot for the same lead time a year ago.",
      "forecast": "Published forecast",
      "noForecast": "No published forecast covers this date.",
      "varianceVsForecast": "Against forecast",
      "streamTitle": "Revenue by stream",
      "streamDescription": "Actual net revenue on this business date, resolved through each stream's own revenue centres and outlets — beside the published forecast for the same stream.",
      "actualRevenue": "Actual revenue",
      "sources": "Sources",
      "streamSources": "{centres} revenue centre(s), {outlets} outlet(s)",
      "streamUnmapped": "No sources mapped",
      "noStreamForecast": "No published forecast",
      "noStreamsTitle": "No revenue streams yet",
      "noStreamsDescription": "Add a stream under Segments and streams, then name the revenue centres and outlets whose takings roll into it."
    },
    "settings": {
      "title": "Revenue management settings",
      "description": "How far this property's snapshots and forecasts reach, what counts as a material movement, and whether a below-hurdle rate is refused.",
      "loadFailed": "The settings could not be loaded",
      "saved": "Settings saved",
      "saveFailed": "The settings could not be saved",
      "readOnly": "You can read these settings but not change them. Changing them needs rvm.settings.manage.",
      "currentTitle": "Current settings",
      "horizonsTitle": "Horizons",
      "horizonsDescription": "Both are capped at 1,095 days — three years. Lengthening a horizon does not backfill: yesterday's snapshot keeps yesterday's reach, and pace compares only the stay dates present in both.",
      "snapshotHorizon": "Snapshot horizon",
      "snapshotHorizonHint": "How many days forward tonight's on-the-books snapshot covers.",
      "forecastHorizon": "Forecast horizon",
      "forecastHorizonHint": "How far ahead a forecast line may be written.",
      "accuracyHorizons": "Accuracy horizons",
      "accuracyHorizonsHint": "The lead times an accuracy run scores at, in days. Separate them with commas.",
      "accuracyHorizonsNumber": "Every accuracy horizon must be a whole number of days.",
      "horizonNumber": "A horizon must be a whole number of days.",
      "materialityTitle": "Materiality",
      "materialityDescription": "A forecast movement is material only when it exceeds BOTH bands. A percentage alone makes a 100% move on 40.00 material; an absolute alone makes 6,000.00 on 3,000,000.00 material.",
      "materialPct": "Material movement, percentage",
      "materialPctHint": "Enter 10 for 10%.",
      "materialPctRange": "Enter a percentage between 0 and 100.",
      "materialAbs": "Material movement, amount",
      "materialAbsHint": "In the property's own currency.",
      "behaviourTitle": "Classification and enforcement",
      "behaviourDescription": "Where unclassified demand lands, and what happens when a rate falls below its hurdle.",
      "unmappedSegment": "Unmapped segment code",
      "unmappedSegmentHint": "Where a booking no mapping rule matched is counted. It is never dropped. Changing this creates the segment immediately.",
      "unmappedRequired": "Unmapped demand needs somewhere to land — name a segment code.",
      "hurdleEnforcement": "Below-hurdle rates",
      "hurdleEnforcementHint": "Warn records the decision and lets it through with an override reason. Block refuses it outright.",
      "enforcement": {
        "warn": "Warn and record an override",
        "block": "Refuse the rate"
      },
      "days": "{days} days"
    },
    "dimensions": {
      "title": "Segments and streams",
      "description": "The market segments this legal entity reports on, the rules that classify a booking into one, and the revenue streams a forecast is written against.",
      "loadFailed": "The dimensions could not be loaded",
      "readOnly": "You can read these but not change them. Changing them needs rvm.dimension.manage.",
      "code": "Code",
      "name": "Name",
      "family": "Family",
      "families": {
        "transient": "Transient",
        "group": "Group",
        "contract": "Contract",
        "wholesale": "Wholesale",
        "complimentary": "Complimentary",
        "house": "House"
      },
      "displacementRank": "Displacement rank",
      "displacementRankHint": "Which demand is given up first. Lower yields first; ties break on code.",
      "rankNumber": "A displacement rank must be a whole number.",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "segmentsTitle": "Market segments",
      "segmentsDescription": "A booking's segment code is free text in the reservation; these are the governed segments every RVM figure is grouped by.",
      "newSegment": "New segment",
      "segmentRequired": "A segment needs a code and a name.",
      "segmentCreated": "Segment created",
      "segmentRemoved": "Segment removed",
      "segmentRemoveFailed": "The segment could not be removed",
      "segmentUpdateFailed": "The segment could not be changed",
      "noSegmentsTitle": "No segments yet",
      "noSegmentsDescription": "Add the segments this legal entity sells to — transient, groups, contracted corporate — then map bookings into them below.",
      "mappingsTitle": "Mapping rules",
      "mappingsDescription": "The first active rule that matches a booking wins, in the order shown. A booking matching nothing is never dropped: it lands in the unmapped segment named in Revenue settings.",
      "newMapping": "New rule",
      "targetSegment": "Maps to",
      "chooseSegment": "Choose a segment",
      "priority": "Priority",
      "priorityHint": "Lower runs first. Ties break on the order rules were created.",
      "priorityNumber": "A priority must be a whole number.",
      "matches": "Matches",
      "matchHint": "Leave a criterion blank to ignore it. At least one must be given.",
      "matchSegmentCode": "Reservation segment code",
      "matchMarketCode": "Market code",
      "matchSourceCode": "Source code",
      "matchChannel": "Channel",
      "anyChannel": "Any channel",
      "channelIdHint": "Enter a channel id. Grant pms.channel.read to choose one by name.",
      "mappingSegmentRequired": "A rule has to say which segment it maps to.",
      "mappingCriterionRequired": "A rule needs at least one criterion, or it would claim every booking.",
      "mappingCreated": "Rule created",
      "mappingRemoved": "Rule removed",
      "mappingRemoveFailed": "The rule could not be removed",
      "mappingUpdateFailed": "The rule could not be changed",
      "noMappingsTitle": "No mapping rules yet",
      "noMappingsDescription": "Without a rule every booking lands in the unmapped segment. Add one rule per code your channels actually send.",
      "criterion": {
        "segmentCode": "segment {value}",
        "marketCode": "market {value}",
        "sourceCode": "source {value}",
        "channel": "channel {value}"
      },
      "testerTitle": "Mapping tester",
      "testerDescription": "Enter the codes a booking would carry and see which segment it resolves to, and whether a rule chose it.",
      "testerFailed": "The tester could not resolve those codes",
      "matched": "A rule matched: this booking is counted in {code} — {name}.",
      "unmatched": "No rule matched. This booking is counted in {code} — {name}, the unmapped segment. Nothing is dropped, but the figures will read as unclassified until a rule covers it.",
      "streamsTitle": "Revenue streams",
      "streamsDescription": "What a forecast line is written against. Four codes and no more; a stream's actual sources name the revenue centres and outlets whose takings roll into it.",
      "newStream": "New stream",
      "streamCodes": {
        "room": "Rooms",
        "fnb": "Food and beverage",
        "ancillary": "Ancillary",
        "other": "Other"
      },
      "streamCodeHint": "One of four. There is no fifth and none is tenant-added.",
      "streamRequired": "A stream needs a name.",
      "streamCreated": "Stream created",
      "streamUpdateFailed": "The stream could not be changed",
      "actualSources": "Actual sources",
      "noActualSources": "None mapped",
      "noStreamsTitle": "No revenue streams yet",
      "noStreamsDescription": "Add at least a rooms stream. Without one a forecast has nothing to be written against."
    }
  },
  "notifications": {
    "routeTitles": {
      "inbox": "Notifications"
    },
    "nav": {
      "description": "Everything the system has told you, newest first.",
      "keywords": "notifications bell alerts messages inbox unread"
    },
    "loadFailed": "Your notifications could not be loaded",
    "markAllRead": "Mark all read",
    "allMarkedRead": "All notifications marked read",
    "dismissed": "Notification dismissed",
    "actionFailed": "That could not be saved",
    "bell": {
      "label": "Notifications, {count} unread",
      "labelNone": "Notifications, none unread",
      "status": "{count} unread notifications",
      "statusNone": "No unread notifications"
    },
    "panel": {
      "title": "Notifications",
      "label": "Recent notifications",
      "close": "Close notifications",
      "viewAll": "View all notifications",
      "emptyTitle": "Nothing yet",
      "emptyDescription": "Approvals, posted documents and alerts assigned to you will appear here."
    },
    "inbox": {
      "title": "Notifications",
      "description": "Everything the system has told you, newest first. Dismissing a notification removes the message, never the document it points at.",
      "filterLabel": "Show",
      "filterAll": "All",
      "filterUnread": "Unread only",
      "emptyTitle": "No notifications yet",
      "emptyDescription": "You will be told here when an approval reaches you, a document you follow is posted, or a threshold you set is crossed. Notification policies decide which of those also arrive by email.",
      "unreadEmptyTitle": "Nothing unread",
      "unreadEmptyDescription": "You have read everything. Switch back to All to see the history."
    },
    "item": {
      "unread": "Unread",
      "noLink": "No linked record",
      "markReadFor": "Mark “{title}” as read",
      "dismissFor": "Dismiss “{title}”"
    },
    "kinds": {
      "approvalAssigned": "Approval assigned",
      "approvalReminded": "Approval reminder",
      "approvalEscalated": "Approval escalated",
      "mention": "Mention",
      "system": "System"
    },
    "severities": {
      "info": "Information",
      "success": "Success",
      "warning": "Warning",
      "danger": "Urgent"
    }
  },
  "enterprise": {
    "businessUnits": {
      "title": "Business units",
      "description": "The operational level at which transactions are processed and data is secured.",
      "create": "New business unit",
      "tableLabel": "Business unit register",
      "emptyTitle": "No business units match",
      "emptyDescription": "Create a business unit, or clear the filters to see every unit.",
      "loadFailed": "Could not load business units",
      "search": "Search",
      "searchHint": "Code or name",
      "functionCount": "0 functions | 1 function | {count} functions",
      "columns": {
        "code": "Code / name",
        "legalEntity": "Legal entity",
        "functions": "Functions"
      },
      "statuses": {
        "draft": "Draft",
        "pending": "Pending",
        "active": "Active",
        "inactive": "Inactive"
      },
      "fields": {
        "company": "Legal entity",
        "code": "Code",
        "name": "Name",
        "primaryLegalEntity": "Primary legal entity",
        "defaultLocation": "Default location",
        "manager": "Manager / General Manager",
        "division": "Division",
        "divisionHint": "Management rollup only — does not affect posting or security.",
        "ledger": "Ledger",
        "ledgerHint": "The coarse ledger binding on the unit itself. Per-document-type sequencing is set on the Ledger alignment tab."
      },
      "form": {
        "createTitle": "New business unit",
        "createDescription": "Register a business unit with its code, name, legal entity binding and default location (FSD 1.2.4.4).",
        "created": "Business unit created",
        "createFailed": "Could not create the business unit"
      },
      "tabs": {
        "profile": "Profile",
        "functions": "Business functions",
        "serviceProviders": "Service providers",
        "referenceSets": "Reference sets",
        "ledgerAlignment": "Ledger alignment",
        "securityScope": "Security scope"
      },
      "detail": {
        "oneTitle": "Business unit",
        "oneDescription": "Profile, functions, service-provider relationships, reference sets, ledger alignment and security scope.",
        "oneLoadFailed": "Could not load this business unit",
        "tabsLabel": "Business unit detail",
        "notFound": "This business unit could not be found.",
        "backToList": "Back to business units",
        "activate": "Activate",
        "activated": "Business unit activated",
        "activateFailed": "Could not activate the business unit",
        "deactivate": "Deactivate",
        "deactivated": "Business unit deactivated",
        "deactivateTitle": "Deactivate business unit",
        "deactivateDescription": "Blocked while open transactions exist in any assigned function (F-BU.005). If blocked, the response names the function, module and count.",
        "effectiveTo": "Effective to"
      },
      "rail": {
        "activated": "Activated",
        "deactivated": "Deactivated",
        "registerLink": "Business units",
        "subtitle": "0 functions assigned | 1 function assigned | {functions} functions assigned"
      },
      "functions": {
        "title": "Business functions",
        "description": "A unit performs the transactions of every function assigned to it, and only those (F-BU.002).",
        "emptyTitle": "No functions assigned yet",
        "emptyDescription": "Activation is blocked until at least one business function is assigned.",
        "assignTitle": "Assign a function",
        "function": "Function",
        "selectFunction": "Choose a function",
        "effectiveFrom": "Effective from",
        "effectiveTo": "Effective to",
        "assign": "Assign",
        "assigned": "Function assigned",
        "assignFailed": "Could not assign the function",
        "removeConfirm": "Remove {code} from this unit? Refused if open transactions exist for this function (F-BU.006).",
        "removed": "Function removed",
        "removeFailed": "Could not remove the function"
      },
      "serviceProviders": {
        "title": "Service-provider relationships",
        "description": "A shared-service unit performs a function on behalf of client units only where an effective relationship exists (F-BU.003).",
        "emptyTitle": "No service-provider relationships",
        "emptyDescription": "No relationship matches. Define one to let a shared-service unit act for its clients.",
        "loadFailed": "Could not load service-provider relationships",
        "registerTitle": "Service providers",
        "registerDescription": "Every shared-service relationship: which unit performs which business function for which client unit, and when.",
        "businessUnit": "Business unit (either party)",
        "asOfHint": "Shows only relationships in force on this date.",
        "effectiveDates": "Effective",
        "effective": "In force",
        "notEffective": "Not in force",
        "defineTitle": "Define a relationship",
        "provider": "Providing unit",
        "client": "Client unit",
        "function": "Function provided",
        "effectiveFrom": "Effective from",
        "effectiveTo": "Effective to",
        "saved": "Service-provider relationship recorded",
        "saveFailed": "Could not record the relationship",
        "asProvider": "Provider",
        "asClient": "Client",
        "resolveTitle": "Resolve client",
        "resolveDescription": "Checks whether this unit may act for a client unit under an effective relationship (F-BU.003) — always calls the server.",
        "asOf": "As of",
        "resolve": "Resolve",
        "resolveAllowed": "Allowed — relationship #{relationshipId}.",
        "resolveDenied": "Refused — no effective service-provider relationship names this unit for that function."
      },
      "referenceSets": {
        "title": "Reference data set assignment",
        "description": "Exactly one reference data set per determinant type at any effective date (F-BU.008).",
        "emptyTitle": "No reference sets assigned",
        "emptyDescription": "Assign a set for at least one determinant type before activation.",
        "assignTitle": "Assign a set",
        "determinantType": "Determinant type",
        "setId": "Reference set id",
        "effectiveFrom": "Effective from",
        "effectiveTo": "Effective to",
        "saved": "Reference set assigned",
        "saveFailed": "Could not assign the reference set",
        "determinants": {
          "common": "Common",
          "region": "Region",
          "legal_entity": "Legal entity",
          "business_unit": "Business unit"
        }
      },
      "ledgerAlignment": {
        "title": "Ledger alignment",
        "description": "Gapless document sequencing requires a single-ledger binding per document type (F-BU.004).",
        "emptyTitle": "No ledger alignments recorded",
        "emptyDescription": "Align a document type to a ledger where the jurisdiction requires gapless sequencing.",
        "alignTitle": "Align a document type",
        "ledger": "Ledger",
        "documentType": "Document type",
        "jurisdiction": "Jurisdiction id",
        "sequence": "Sequence id",
        "saved": "Ledger alignment saved",
        "saveFailed": "Could not save the ledger alignment"
      },
      "securityScope": {
        "title": "Security scope preview",
        "description": "The data-security scope activation would generate, including scopes inherited through service-provider relationships — nothing here is granted yet.",
        "noPermission": "You do not hold the permission to preview security scopes for this unit.",
        "loadFailed": "Could not load the security scope preview",
        "tableLabel": "Security scope preview",
        "emptyTitle": "No scopes would be generated",
        "emptyDescription": "Assign at least one business function and a service-provider relationship, if this unit is a shared-service provider.",
        "principal": "Principal",
        "scopeType": "Scope type",
        "source": "Source",
        "expiresAt": "Expires"
      },
      "securityScopes": {
        "title": "Security scopes",
        "description": "Who can reach each business unit's data, granted directly or derived through an effective service-provider relationship. Expired grants stop giving access automatically.",
        "noPermission": "You do not hold the permission to review security scopes.",
        "loadFailed": "Could not load security scopes",
        "tableLabel": "Security scope grants",
        "emptyTitle": "No grants match",
        "emptyDescription": "No business unit confers access matching these filters on this date.",
        "businessUnit": "Business unit",
        "userId": "User id",
        "asAt": "As at",
        "derivation": "Granted",
        "direct": "Direct",
        "derived": "Derived",
        "open": "Open-ended",
        "effectiveOn": "On this date",
        "effective": "Effective",
        "notEffective": "Not effective",
        "grantedAt": "Granted on",
        "regenerationNote": "Grants are regenerated whenever a business unit is activated or a service-provider relationship changes, and each regenerated grant is dated at that regeneration. An as-at date before the last regeneration therefore shows today's grants, not the grants as they actually stood on that date.",
        "previewHint": "Choose one business unit to also see what activation would generate for it now."
      },
      "routeTitles": {
        "list": "Business Units",
        "detail": "Business Unit",
        "serviceProviders": "Service Providers",
        "securityScopes": "Security Scopes"
      }
    },
    "currencyRates": {
      "title": "Currency Rates",
      "description": "Recorded exchange rates by book (spot, corporate, historical), the rate in force on any date, and controlled retroactive revaluation.",
      "routeTitles": {
        "list": "Currency Rates"
      },
      "record": "Record a rate",
      "recordFirst": "Record the first rate",
      "loadFailed": "The rates did not load",
      "tableLabel": "Exchange rates",
      "emptyTitle": "No exchange rates yet",
      "emptyDescription": "Record a rate, or widen the filters.",
      "anyRateType": "Any book",
      "anyBase": "Any base",
      "anyQuote": "Any quote",
      "fromLabel": "From",
      "toLabel": "To",
      "exportDone": "Rates exported",
      "exportFailed": "The export failed",
      "columns": {
        "pair": "Pair",
        "rateType": "Book",
        "rate": "Rate",
        "asOf": "As of",
        "source": "Source",
        "note": "Note"
      },
      "rateTypes": {
        "spot": "Spot",
        "corporate": "Corporate",
        "historical": "Historical"
      },
      "sources": {
        "manual": "Manual",
        "api": "Feed"
      },
      "fields": {
        "base": "Base currency",
        "quote": "Quote currency",
        "rate": "Rate",
        "rateHint": "Units of quote one unit of base buys, up to {decimals} decimal places.",
        "asOf": "As of",
        "note": "Note"
      },
      "editor": {
        "title": "Record an exchange rate",
        "description": "Recording the same pair, book and day corrects that observation instead of adding a second one.",
        "correctTitle": "Correct this rate",
        "correctDescription": "The pair, book and date identify the observation, so only the rate and the note can change.",
        "correct": "Save correction",
        "sameCurrency": "A currency against itself is always 1, so there is nothing to record.",
        "reading": "1 {base} buys {rate} {quote}",
        "recorded": "Rate recorded",
        "corrected": "Rate corrected",
        "savedDetail": "{base} to {quote} as of {asOf}.",
        "saveFailed": "The rate was not saved",
        "heldTitle": "Rate held for review",
        "heldDetail": "{base}/{quote} moved {movePct}%, further than its declared tolerance. It has not been applied.",
        "heldExplain": "Nothing failed and nothing was stored: the observation is waiting for somebody to accept or reject it.",
        "heldLink": "Open the holds queue"
      },
      "revalue": {
        "open": "Revalue",
        "title": "Retroactive revaluation",
        "description": "Restate a rate that documents have already used. The change is dual-approved and comes back with a before/after impact statement.",
        "dualControl": "Two distinct approvers must sign the request before the new rate can be applied.",
        "asOf": "Rate date",
        "reasonCode": "Reason code",
        "stepRequest": "1. Request approval",
        "stepRequestHint": "Sends the pair, book, date and reason for dual approval. Nothing changes yet.",
        "request": "Request approval",
        "requested": "Revaluation sent for approval",
        "requestedDetail": "Approval request #{id}.",
        "submittedNote": "Approval request #{id} is {status}. Execute once both approvers have signed.",
        "stepExecute": "2. Execute",
        "stepExecuteHint": "Applies the new rate under an approved request and records the impact.",
        "approvalRequestId": "Approval request",
        "newRate": "New rate",
        "execute": "Execute revaluation",
        "executed": "Revaluation executed",
        "failed": "The revaluation could not be completed",
        "resultTitle": "Revaluation run #{id}",
        "result": {
          "pair": "Pair and book",
          "window": "Dates restated",
          "priorRate": "Prior rate",
          "newRate": "New rate",
          "approvers": "Approvers",
          "executedAt": "Executed at",
          "impact": "Impact statement"
        }
      }
    },
    "divisions": {
      "title": "Divisions",
      "description": "The managerial view of the enterprise. A division is a product line, brand or geography that may span multiple legal entities and countries, kept independent of the legal structure so reorganisation never requires legal restructuring.",
      "tableLabel": "Divisions",
      "searchPlaceholder": "Search code, name…",
      "searchLabel": "Search divisions",
      "createTitle": "New division",
      "createFirst": "Create the first division",
      "emptyTitle": "No divisions yet",
      "emptyDescription": "Create a division to start mapping its countries, legal entities and chart-of-accounts segment.",
      "loadFailed": "Could not load the division register.",
      "exported": "Exported one division | Exported {count} divisions",
      "columns": {
        "code": "Code",
        "name": "Name",
        "owner": "Owner",
        "defaultCurrency": "Currency"
      },
      "fields": {
        "code": "Division code",
        "name": "Division name",
        "company": "Legal entity",
        "purpose": "Purpose / charter",
        "owner": "Accountable owner",
        "ownerIdHint": "Employee id — no employee directory access to browse one",
        "defaultCurrency": "Default currency",
        "parent": "Parent division",
        "parentHint": "Optional, for multi-level divisional structures. Must not create a cycle.",
        "approvalStatus": "Approval status"
      },
      "statuses": {
        "draft": "Draft",
        "submitted": "Submitted",
        "approved": "Approved",
        "rejected": "Rejected",
        "ended": "Ended"
      },
      "form": {
        "createTitle": "Create a division",
        "createDescription": "Creates the division in DRAFT status. Associate at least one country before submitting it for approval.",
        "editTitle": "Edit division",
        "editDescription": "Only the purpose, owner and default currency are edited here — code, name and legal entity are immutable once created (FSD 1.2.2.3).",
        "readOnlyHint": "Code and name are read-only on this screen.",
        "created": "Division created",
        "createdDetail": "{name} was created in DRAFT status.",
        "createFailed": "Could not create the division.",
        "saved": "Division saved",
        "savedDetail": "{name} was updated.",
        "saveFailed": "Could not save the division."
      },
      "tabs": {
        "profile": "Profile",
        "countries": "Countries",
        "legalEntities": "Legal entities",
        "segmentMap": "Segment mapping",
        "crossCharging": "Cross-charging",
        "rollup": "Rollup"
      },
      "detail": {
        "oneTitle": "Division",
        "oneDescription": "Profile, countries, legal entities, chart-of-accounts segment mapping, cross-charging and the resolved management rollup.",
        "oneLoadFailed": "Could not load this division.",
        "notFound": "This division could not be found.",
        "tabsLabel": "Division sections",
        "backToList": "Back to the register",
        "submit": "Submit for approval",
        "submitted": "Submitted for approval",
        "submitFailed": "Could not submit the division.",
        "activate": "Activate",
        "activated": "Division activated",
        "activateFailed": "Could not activate the division.",
        "reorganise": "Reorganise…",
        "endDate": "End-date…"
      },
      "rail": {
        "registerLink": "Division register"
      },
      "countries": {
        "title": "Countries of operation",
        "description": "F-3.001: a division may operate in more than one country. At least one is required before submitting for approval (FND-F02-V02).",
        "add": "Add country",
        "emptyTitle": "No countries of operation yet",
        "emptyDescription": "Add at least one country of operation before submitting this division for approval.",
        "saved": "Country added",
        "saveFailed": "Could not add the country.",
        "terminate": "End…",
        "confirmEnd": "Confirm",
        "terminated": "Country association ended",
        "terminateFailed": "Could not end the country association.",
        "fields": {
          "countryCode": "Country code",
          "effectiveFrom": "Effective from"
        }
      },
      "legalEntities": {
        "title": "Legal entities",
        "description": "1.2.2.4: assignment is many-to-many and does not alter the entity's own structure. A legal entity may contribute to more than one division.",
        "associate": "Associate entity",
        "emptyTitle": "No legal entities associated yet",
        "emptyDescription": "Associate a legal entity with this division for management reporting.",
        "saved": "Legal entity associated",
        "saveFailed": "Could not associate the legal entity.",
        "terminate": "End…",
        "confirmEnd": "Confirm",
        "terminated": "Legal entity association ended",
        "terminateFailed": "Could not end the legal entity association.",
        "fields": {
          "company": "Legal entity",
          "effectiveFrom": "Effective from"
        }
      },
      "segmentMap": {
        "title": "Chart-of-accounts segment mapping",
        "description": "F-3.006: a division is represented as a value in a management segment. Selecting a balancing segment raises a warning requiring Finance confirmation (FND-F02-V04).",
        "noneYet": "No segment mapping on file yet.",
        "saved": "Segment mapping saved",
        "saveFailed": "Could not save the segment mapping.",
        "confirmBalancing": "Confirm balancing segment",
        "needsFinanceConfirm": "Requires the Finance Manager's balancing-segment confirmation permission.",
        "fields": {
          "structure": "Chart of accounts",
          "segment": "Segment",
          "segmentValue": "Segment value",
          "isBalancing": "Balancing segment",
          "effectiveFrom": "Effective from"
        }
      },
      "crossCharging": {
        "title": "Cross-charging",
        "description": "F-3.004: cross-charging rules must produce balanced entries at every ledger boundary they cross, verified by simulation before activation. Activation requires dual approval — divisional owner and Finance Manager (1.2.2.10).",
        "define": "Define arrangement",
        "emptyTitle": "No cross-charging arrangements yet",
        "emptyDescription": "Define a cross-charging arrangement to recover costs between this division and another.",
        "created": "Cross-charge rule created",
        "createFailed": "Could not create the cross-charge rule.",
        "simulate": "Simulate…",
        "runSimulation": "Run simulation",
        "balanced": "Balanced at every ledger boundary crossed.",
        "unbalanced": "Not balanced — residual {residual}. Activation is blocked until this clears.",
        "activate": "Activate",
        "activated": "Cross-charge rule activated",
        "activateFailed": "Could not activate the cross-charge rule.",
        "needsApprovePermission": "Activating requires the Finance Manager's cross-charge approval permission.",
        "pricingMethods": {
          "cost": "Cost",
          "cost_plus": "Cost-plus",
          "market": "Market",
          "fixed_rate": "Fixed rate"
        },
        "statuses": {
          "draft": "Draft",
          "active": "Active"
        },
        "fields": {
          "toDivision": "Recovering division",
          "pricingMethod": "Pricing method",
          "rate": "Rate",
          "rateHint": "For cost-plus, a markup percentage: enter 10 for 10%. For market or fixed rate, a stated amount.",
          "rateRange": "A cost-plus markup must be a percentage between 0 and 1000.",
          "effectiveFrom": "Effective from",
          "baseAmount": "Base amount to simulate",
          "debit": "Debit",
          "credit": "Credit"
        }
      },
      "rollup": {
        "title": "Management rollup",
        "description": "F-3.002: the rollup — cost centres, entities and countries — resolved as at any date.",
        "loadFailed": "Could not load the rollup.",
        "countries": "Countries",
        "legalEntities": "Legal entities",
        "costCentres": "Cost centres",
        "none": "None as at this date.",
        "fields": {
          "asAt": "As at"
        }
      },
      "reorganise": {
        "title": "Reorganise division",
        "subject": "Reorganising {name}",
        "consequence": "Moves the selected legal-entity associations to another division on a single future-dated effective date, under one approval, so a partial reorganisation can never be activated (1.2.2.10).",
        "confirm": "Reorganise",
        "done": "Reorganisation complete",
        "doneDetail": "{count} association(s) moved.",
        "failed": "Could not reorganise the division.",
        "noEntities": "This division has no legal entity associations to move.",
        "fields": {
          "toDivision": "Move to division",
          "entities": "Legal entities to move",
          "effectiveOn": "Effective on",
          "effectiveOnHint": "Must be a future date — this is a future-dated restructure.",
          "reasonCode": "Reason"
        }
      },
      "endDate": {
        "title": "End-date division",
        "subject": "Ending {name}",
        "consequence": "End-dating is blocked while active cost centres, open cross-charges or hierarchy memberships reference this division (F-3.007). Full history is retained for reporting.",
        "fields": {
          "reasonCode": "Reason code"
        },
        "confirm": "End-date",
        "done": "Division end-dated",
        "doneDetail": "{name} was end-dated and remains fully reportable historically.",
        "failed": "Could not end-date the division."
      },
      "crossCharges": {
        "title": "Cross-charging",
        "loadFailed": "Could not load the cross-charging register.",
        "emptyTitle": "No cross-charging arrangements",
        "emptyDescription": "No arrangement matches. Define one to recover costs from one division to another.",
        "anyStatus": "Any status",
        "anyDivision": "Any division",
        "simulateTitle": "Simulate recovery",
        "columns": {
          "from": "Provider division",
          "to": "Recovering division",
          "effective": "Effective"
        },
        "fields": {
          "fromDivision": "Provider division",
          "division": "Division"
        }
      },
      "costCentres": {
        "title": "Cost centres",
        "description": "The cost-centre register of a legal entity. A cost centre rolls up to a division through the published management hierarchy, never through the legal structure.",
        "createTitle": "New cost centre",
        "editTitle": "Edit cost centre",
        "formDescription": "Code and name identify the cost centre within its legal entity.",
        "loadFailed": "Could not load the cost centres.",
        "emptyTitle": "No cost centres yet",
        "emptyDescription": "Create the first cost centre for this legal entity.",
        "pickCompany": "Choose a legal entity to list its cost centres",
        "searchPlaceholder": "Search code, name…",
        "searchLabel": "Search cost centres",
        "managerPosition": "Position #{id}",
        "created": "Cost centre created",
        "saved": "Cost centre saved",
        "saveFailed": "Could not save the cost centre.",
        "stale": "Somebody else changed this cost centre since you opened it. Reload it, then apply your changes again.",
        "reload": "Reload",
        "reloadFailed": "Could not reload the cost centre.",
        "deleted": "Cost centre deleted",
        "deleteFailed": "Could not delete the cost centre.",
        "deleteStale": "Somebody else changed this cost centre, so it was not deleted. The list has been reloaded — review it and try again.",
        "deleteTitle": "Delete cost centre",
        "deleteMessage": "Delete the cost centre {name}?",
        "columns": {
          "code": "Code",
          "name": "Name",
          "manager": "Manager"
        },
        "statuses": {
          "active": "Active",
          "inactive": "Inactive"
        },
        "fields": {
          "company": "Legal entity",
          "code": "Cost centre code",
          "name": "Cost centre name",
          "active": "Active"
        }
      },
      "rollupScreen": {
        "title": "Rollup & reorganise",
        "description": "F-3.002: the cost centres, legal entities and countries rolling up to a division, as at any date. Reorganise moves associations between divisions on one effective date without touching the legal structure (F-3.003).",
        "openDivision": "Open division",
        "noDivisions": "No divisions yet. Create a division first.",
        "fields": {
          "division": "Division"
        }
      },
      "routeTitles": {
        "list": "Divisions",
        "detail": "Division",
        "costCentres": "Cost centres",
        "crossCharges": "Cross-charging",
        "rollup": "Rollup & reorganise"
      }
    },
    "financialStructures": {
      "title": "Financial Structures",
      "description": "Design the multi-segment chart of accounts every posting resolves through: segments, value sets, cross-validation rules and segment security.",
      "routeTitles": {
        "list": "Charts of Accounts",
        "detail": "Chart of Accounts",
        "valueSetsList": "Value Sets",
        "valueSetDetail": "Value Set",
        "cvrRegister": "Cross-Validation Rules"
      },
      "cvrRegister": {
        "title": "Cross-Validation Rules",
        "description": "Every cross-validation rule across every chart of accounts: what it covers, what it forbids, and whether it is in force today.",
        "tableLabel": "Cross-validation rules",
        "loadFailed": "The cross-validation rules did not load",
        "emptyTitle": "No cross-validation rules yet",
        "emptyDescription": "Pick a chart of accounts below to add its first rule.",
        "structureFilter": "Chart of accounts",
        "allStructures": "All charts of accounts",
        "manage": "Manage",
        "manageHint": "Pick a chart of accounts to add a rule or re-run a rule's impact scan.",
        "truncated": "A chart of accounts has more than {limit} rules; only the first {limit} are listed here.",
        "when": "When: {list}",
        "columns": {
          "structure": "Chart of accounts",
          "rule": "Rule",
          "condition": "Condition",
          "effective": "Effective"
        },
        "statuses": {
          "active": "Active",
          "scheduled": "Scheduled",
          "ended": "Ended"
        }
      },
      "create": "New Chart of Accounts",
      "createFirst": "Create your first chart of accounts",
      "createTitle": "New Chart of Accounts",
      "createDescription": "Creates the chart in DRAFT. Add its segments once it exists.",
      "createSegmentsHint": "Segments are added on the chart's own page once it is created.",
      "saved": "Chart of accounts created",
      "saveFailed": "Could not create the chart of accounts",
      "loadFailed": "Could not load charts of accounts",
      "tableLabel": "Charts of accounts",
      "emptyTitle": "No charts of accounts yet",
      "emptyDescription": "Create one to start defining its segments.",
      "statusFilterPlaceholder": "Filter by status",
      "valueSetsLink": "Value Sets",
      "notFrozen": "Not frozen",
      "frozenBadge": "Frozen",
      "frozenSince": "Frozen since {date}",
      "columns": {
        "name": "Name",
        "segmentCount": "Segments",
        "effectiveFrom": "Effective from",
        "frozen": "Structure"
      },
      "statuses": {
        "draft": "Draft",
        "active": "Active",
        "inactive": "Inactive"
      },
      "fields": {
        "name": "Name",
        "effectiveFrom": "Effective from",
        "effectiveFromHint": "The date this chart of accounts becomes usable."
      },
      "bindings": {
        "company": "Legal entity",
        "natural_account": "Natural Account",
        "division": "Division",
        "cost_center": "Cost Centre",
        "profit_center": "Profit Centre",
        "branch": "Branch",
        "department": "Department",
        "business_unit": "Business Unit",
        "project": "Project",
        "intercompany": "Intercompany",
        "value_set": "Value set (no physical column)"
      },
      "qualifiers": {
        "none": "None",
        "primary_balancing": "Primary balancing",
        "natural_account": "Natural account",
        "cost_center": "Cost centre",
        "intercompany": "Intercompany",
        "management": "Management"
      },
      "detail": {
        "oneTitle": "Chart of Accounts",
        "oneDescription": "Segments, cross-validation rules and segment security for this chart.",
        "oneLoadFailed": "Could not load this chart of accounts",
        "notFound": "This chart of accounts could not be found.",
        "backToList": "Back to charts of accounts",
        "tabsLabel": "Chart of accounts sections",
        "editTitle": "Edit chart of accounts",
        "saved": "Chart of accounts updated",
        "saveFailed": "Could not update the chart of accounts",
        "activate": "Activate",
        "activated": "Chart of accounts activated",
        "activateFailed": "Could not activate the chart of accounts",
        "frozenNote": "This structure is frozen: a transaction posted against it on {date}, so its segments, name and effective date are immutable (FSD F-6.009). Define a new chart of accounts for a structural change.",
        "frozenFieldHint": "Frozen since {date} — this field cannot change; the status transition still can."
      },
      "tabs": {
        "segments": "Segments",
        "crossValidation": "Cross-Validation Rules",
        "segmentSecurity": "Segment Security"
      },
      "segments": {
        "title": "Segments",
        "description": "Each segment names an existing column elsewhere in the schema — the binding — rather than owning new storage of its own.",
        "add": "Add segment",
        "emptyTitle": "No segments yet",
        "emptyDescription": "Add a segment to start building this chart of accounts.",
        "created": "Segment added",
        "saved": "Segment updated",
        "saveFailed": "Could not save the segment",
        "deleted": "Segment removed",
        "deleteFailed": "Could not remove the segment",
        "deleteTitle": "Remove segment",
        "deleteMessage": "Remove the \"{prompt}\" segment? This only works before anything has posted under this chart of accounts.",
        "frozenHint": "This chart of accounts is frozen (first posting {date}) — segments can no longer be added, changed or removed.",
        "secured": "Secured",
        "length": "{length} chars",
        "fields": {
          "prompt": "Prompt",
          "sequence": "Sequence",
          "displayOrder": "Display order",
          "binding": "Binding",
          "bindingHint": "Which existing column this segment reads — picking a binding maps to data that already exists, it never creates a new column.",
          "valueSet": "Value set",
          "qualifier": "Qualifier",
          "length": "Length",
          "isSecured": "Segment security applies to this segment"
        }
      },
      "cvr": {
        "title": "Cross-Validation Rules",
        "description": "Prevent invalid account combinations at entry and at posting (F-6.002). Creating or re-running a rule always shows a scan of what it would invalidate.",
        "add": "New rule",
        "emptyTitle": "No cross-validation rules yet",
        "emptyDescription": "Add a rule to block invalid segment combinations.",
        "created": "Cross-validation rule created",
        "saveFailed": "Could not create the cross-validation rule",
        "scan": "Scan",
        "scanning": "Scanning…",
        "scanFailed": "Could not run the scan",
        "excludeHeading": "Exclude conditions (required)",
        "excludeHint": "A combination matching every exclude condition is refused.",
        "excludes": "Excludes: {list}",
        "includeHeading": "Include conditions (optional)",
        "includeHint": "Narrows the exclude conditions to combinations that also match every include condition.",
        "addRow": "Add condition row",
        "anyCombination": "any combination",
        "fields": {
          "ruleName": "Rule name",
          "effectiveFrom": "Effective from",
          "effectiveTo": "Effective to",
          "from": "From",
          "to": "To"
        },
        "saveAndScan": "Save and scan",
        "scanResultsTitle": "Scan results — {name}",
        "scanResultsDescription": "Existing combinations this rule would invalidate, and how many journal lines used them.",
        "scanned": "Combinations scanned",
        "violatingCombinations": "Violating combinations",
        "affectedLines": "Affected lines",
        "scanTruncated": "The scan stopped at its limit of {limit} combinations — results below are a sample, not the full picture.",
        "scanClean": "No existing combination violates this rule.",
        "lineCount": "no lines | 1 line | {count} lines"
      },
      "segmentSecurity": {
        "title": "Segment Security",
        "description": "Restrict which segment values a role or business unit may view or use (F-6.003). Only segments marked \"secured\" can carry a rule.",
        "add": "New rule",
        "emptyTitle": "No segment security rules yet",
        "emptyDescription": "Add a rule to restrict a secured segment's values.",
        "created": "Segment security rule created",
        "saveFailed": "Could not create the segment security rule",
        "noSecuredSegments": "No segment on this chart of accounts is marked secured yet — mark one on the Segments tab first.",
        "previewLabel": "Preview:",
        "previewFailed": "Could not load the preview",
        "previewTitle": "Segment security preview — {segment}",
        "previewEmpty": "No security rules cover this segment — every role currently sees every value.",
        "previewTruncated": "List truncated",
        "everyone": "Everyone (no role restriction)",
        "visibleCount": "no visible values | 1 visible value | {count} visible values",
        "hiddenCount": "no hidden values | 1 hidden value | {count} hidden values",
        "role": "Role: {role}",
        "businessUnit": "Business unit: {bu}",
        "saveAndPreview": "Save and preview",
        "access": {
          "view": "View",
          "use": "Use",
          "both": "View and use"
        },
        "fields": {
          "segment": "Segment",
          "valueRange": "Value range",
          "valueRangeHint": "A single value or a range, e.g. \"1000..1999\".",
          "accessType": "Access type",
          "roleId": "Role id",
          "roleIdHint": "Leave blank to scope by business unit only.",
          "businessUnitId": "Business unit id",
          "businessUnitIdHint": "Leave blank to scope by role only."
        }
      },
      "valueSets": {
        "title": "Value Sets",
        "description": "Reusable, named sets of segment values (FSD 1.2.7.5) — a set can back a segment on more than one chart of accounts.",
        "backToStructures": "Back to charts of accounts",
        "create": "New value set",
        "createFirst": "Create your first value set",
        "createTitle": "New value set",
        "saved": "Value set created",
        "saveFailed": "Could not create the value set",
        "loadFailed": "Could not load value sets",
        "tableLabel": "Value sets",
        "emptyTitle": "No value sets yet",
        "emptyDescription": "Create one to start populating its values.",
        "kindFilterPlaceholder": "Filter by kind",
        "columns": {
          "code": "Code",
          "name": "Name",
          "kind": "Kind",
          "parent": "Parent set"
        },
        "kinds": {
          "independent": "Independent",
          "dependent": "Dependent"
        },
        "fields": {
          "code": "Code",
          "name": "Name",
          "kind": "Kind",
          "parentValueSetId": "Parent value set id",
          "parentValueSetIdHint": "Required for a dependent set — each of its values will qualify one value of the parent set."
        },
        "detail": {
          "oneTitle": "Value Set",
          "oneDescription": "The values this set makes available to any segment bound to it.",
          "oneLoadFailed": "Could not load this value set",
          "notFound": "This value set could not be found.",
          "backToList": "Back to value sets",
          "profile": "Profile"
        }
      },
      "segmentValues": {
        "title": "Values",
        "description": "A value is never edited in place once created — it is end-dated and a new one opened, because a posting may already carry it as an identity.",
        "add": "Add value",
        "emptyTitle": "No values yet",
        "emptyDescription": "Add the first value to this set.",
        "created": "Value added",
        "saveFailed": "Could not add the value",
        "active": "Active",
        "inactive": "Inactive",
        "activate": "Reactivate",
        "deactivate": "Deactivate",
        "endDate": "End-date",
        "endDated": "Value end-dated",
        "endDateFailed": "Could not end-date the value",
        "endDateTitle": "End-date \"{value}\"",
        "fields": {
          "value": "Value",
          "description": "Description",
          "effectiveFrom": "Effective from",
          "effectiveTo": "Effective to",
          "parentValueId": "Parent value id",
          "parentValueIdHint": "Required for a dependent set — the parent set's value this one qualifies."
        }
      }
    },
    "geographies": {
      "title": "Geographies & addresses",
      "description": "The places this tenant's addresses and tax jurisdictions resolve against, and a check of how an address validates in each country.",
      "routeTitles": {
        "geographies": "Geographies & addresses"
      },
      "levels": {
        "country": "Country",
        "subdivision": "Region / atoll",
        "locality": "Island / locality"
      },
      "tree": {
        "title": "Geography hierarchy",
        "description": "Country, then region or atoll, then island or locality, as the country pack curates it.",
        "country": "Country",
        "search": "Search places",
        "searchPlaceholder": "Name or code",
        "countryInvalid": "Enter a two-letter country code to see its geography.",
        "loadFailed": "The geography did not load",
        "empty": "No geography is curated for {country} yet. It arrives with the country's localisation pack.",
        "count": "{total} places",
        "matching": "{shown} of {total} places shown",
        "noMatch": "No place matches “{query}”.",
        "label": "Geography of {country}",
        "expand": "Expand {name}",
        "collapse": "Collapse {name}",
        "inactive": "Inactive"
      },
      "address": {
        "title": "Address check",
        "description": "Enter an address the way a location would record it and see whether — and to which place — it validates. Nothing is saved.",
        "rulesTitle": "Address rules for this country",
        "chooseCountry": "Enter a two-letter country code to see its rules.",
        "rulesFailed": "The address rules did not load",
        "validationLevel": "Validation",
        "geoLocality": "Registered place",
        "required": "Required",
        "notRequired": "Not required",
        "postalCode": "Postal code pattern",
        "noPostalSystem": "No postal code",
        "resultTitle": "Result",
        "valid": "Valid",
        "invalid": "Not valid",
        "checkedAt": "Level applied",
        "jurisdiction": "Resolved place",
        "jurisdictionId": "Jurisdiction #{id}",
        "missing": "Missing"
      }
    },
    "governance": {
      "routeTitles": {
        "mastership": "Mastership Register",
        "dependencyPostures": "Dependency Postures",
        "classifications": "Data Classifications"
      },
      "mastership": {
        "title": "Mastership Register",
        "description": "Declare which system is the authoritative master record holder for each data domain across the enterprise (FND-FR-086).",
        "emptyTitle": "No mastership entries yet",
        "emptyDescription": "No data domains have been registered with their mastering systems."
      },
      "dependencyPosture": {
        "title": "Dependency Postures",
        "description": "Module-to-module dependency criticality and business continuity impact (FND-FR-089). Declares whether the enterprise continues to operate if a dependency fails.",
        "emptyTitle": "No dependencies registered",
        "emptyDescription": "No inter-module dependencies have been declared."
      },
      "classification": {
        "title": "Data Classifications",
        "description": "Sensitivity classification of data domains and their handling requirements: audit trails, retention periods, residency constraints, masking rules (FND-FR-090).",
        "emptyTitle": "No classifications defined",
        "emptyDescription": "No data domains have been classified for sensitivity."
      },
      "columns": {
        "dataDomain": "Data Domain",
        "masteringModule": "Mastering Module",
        "enforcement": "Enforcement",
        "effectiveFrom": "Effective From",
        "fromModule": "From Module",
        "toModule": "To Module",
        "posture": "Posture",
        "continuesDuringOutage": "Continues During Outage",
        "note": "Note",
        "sensitivity": "Sensitivity",
        "readAuditRequired": "Read Audit",
        "retentionYears": "Retention (years)",
        "residencyConstraint": "Residency Constraint",
        "maskingRule": "Masking Rule"
      },
      "enforcement": {
        "strict": "Strict",
        "advisory": "Advisory"
      },
      "posture": {
        "critical": "Critical",
        "important": "Important",
        "optional": "Optional"
      },
      "outage": {
        "continues": "Continues",
        "halts": "Halts"
      },
      "sensitivity": {
        "public": "Public",
        "internal": "Internal",
        "confidential": "Confidential",
        "restricted": "Restricted"
      },
      "audit": {
        "required": "Required",
        "notRequired": "Not Required"
      }
    },
    "hierarchies": {
      "title": "Organisation Hierarchies",
      "description": "Arrange the same organisations into named, date-effective structures — management rollup, legal ownership, cost aggregation, security scoping and consolidation.",
      "tableLabel": "Organisation hierarchies",
      "loadFailed": "The hierarchy register did not load",
      "filters": {
        "anyPurpose": "Any purpose",
        "anyStatus": "Any status",
        "search": "Search",
        "searchHint": "Code or name"
      },
      "emptyTitle": "No hierarchies yet",
      "emptyDescription": "Create a hierarchy to name a structure and the organisation types it may contain, then add a version and arrange its nodes.",
      "created": "Hierarchy created",
      "versionCreated": "Draft version created",
      "versionCreatedDetail": "Version {versionNo} starts with {nodeCount} node(s).",
      "defaultBadge": "Default for purpose",
      "openById": "Open by id",
      "openByIdHint": "Open a version directly when you know its id. Resolve and Compare need only the hierarchy id.",
      "openVersion": "Open version",
      "routeTitles": {
        "register": "Organisation Hierarchies",
        "version": "Hierarchy version",
        "compare": "Compare hierarchy versions",
        "resolve": "Resolve hierarchy as at a date"
      },
      "fields": {
        "code": "Hierarchy code",
        "name": "Hierarchy name",
        "purpose": "Purpose",
        "permittedNodeTypes": "Permitted node types",
        "depthLimit": "Depth limit",
        "isDefault": "Default for this purpose",
        "effectiveFrom": "Effective from",
        "effectiveTo": "Effective to",
        "effectiveToHint": "Leave empty for an open-ended period.",
        "changeSummary": "Change summary",
        "seedFromActive": "Seed from the active version",
        "hierarchyId": "Hierarchy id",
        "versionId": "Version id",
        "orgType": "Organisation type",
        "orgId": "Organisation id",
        "nodeCount": "Nodes",
        "maxDepth": "Deepest path",
        "blockingFindings": "Blocking findings"
      },
      "purposes": {
        "management": "Management",
        "legal": "Legal",
        "cost": "Cost",
        "security": "Security",
        "consolidation": "Consolidation",
        "reporting": "Reporting"
      },
      "nodeTypes": {
        "division": "Division",
        "legal_entity": "Legal entity",
        "business_unit": "Business unit",
        "department": "Department",
        "cost_center": "Cost centre",
        "position": "Position"
      },
      "status": {
        "draft": "Draft",
        "pending": "Pending approval",
        "published": "Published",
        "superseded": "Superseded"
      },
      "hierarchyStatus": {
        "active": "Active",
        "archived": "Archived"
      },
      "routing": {
        "finance": "Finance",
        "security": "Security",
        "hr": "HR",
        "enterprise": "the Enterprise Data Owner"
      },
      "create": {
        "action": "New hierarchy",
        "title": "New organisation hierarchy",
        "description": "Names a structure and the organisation types it may contain. The structure itself is built afterwards, on a version.",
        "purposeHint": "A security hierarchy derives row-level access scopes when it is published, so publishing one additionally requires the Security Administrator.",
        "purposePlaceholder": "Choose a purpose",
        "nodeTypesHint": "Only these types may be placed on this hierarchy. A node of any other type is refused with the permitted set named.",
        "depthLimitHint": "Defaults to 8 and may not exceed {max}.",
        "isDefaultHint": "The hierarchy consumers fall back to for this purpose."
      },
      "newVersion": {
        "action": "New version",
        "title": "New draft version",
        "description": "Creates a draft you can arrange. Nothing is visible to any other module until it is published.",
        "confirm": "Create draft",
        "overlapNote": "Versions of one hierarchy may not overlap in time. The overlap is checked when you publish, and the overlapping version and its period are named if it is refused.",
        "seedHint": "On, the draft starts as a copy of the version in force on its own start date. Off, it starts empty.",
        "changeSummaryHint": "Optional here, mandatory when you submit the draft for approval."
      },
      "canvas": {
        "title": "Node arrangement",
        "addRoot": "Add a root node",
        "addChildOf": "Add a node under {name}",
        "retimeOf": "Change the effective period of {name}",
        "removeOf": "Remove {name} from this draft",
        "nodeLabel": "{type} number {id}",
        "windowOpen": "from {from}, open-ended",
        "windowClosed": "from {from} to {to}",
        "depthOf": "depth {depth} of {limit}",
        "detached": "Not reachable from a root",
        "empty": "This version has no nodes yet. Add a root node to begin building the structure.",
        "arrangeFailed": "The arrangement was refused"
      },
      "a11y": {
        "help": "Use the arrow keys to move between nodes. Press Space to pick a node up, then the arrow keys to reorder it, indent it under the node above, or outdent it. Press Escape to put it down. Hold Alt with an arrow key to make the same move without picking the node up.",
        "helpReadOnly": "Use the arrow keys to move between nodes and the left and right arrow keys to collapse and expand branches. This version is not a draft, so its structure cannot be changed.",
        "expand": "Expand {name}",
        "collapse": "Collapse {name}",
        "movingStart": "Picked up {name}. Use the arrow keys to place it.",
        "movingStop": "Put down {name}.",
        "movingBadge": "Moving",
        "moveUnavailable": "That move is not available from here.",
        "dropRefused": "That node cannot be dropped there.",
        "arrangedClean": "Applied {count} change(s). The structure is valid.",
        "arrangedWithFindings": "Applied {count} change(s). {findings} finding(s) need attention.",
        "arrangeRefused": "The change was refused and the structure is unchanged."
      },
      "addNode": {
        "title": "Place an organisation",
        "asRoot": "Placed at the top of the structure, with no parent.",
        "underParent": "Placed under {parent}.",
        "confirm": "Place node",
        "typePlaceholder": "Choose a type",
        "typesUnknown": "This session does not hold this hierarchy's permitted node types, so every type is offered. A type the hierarchy does not permit is refused by the server, with the permitted set named.",
        "orgIdHint": "The numeric id of the organisation being placed.",
        "windowHint": "Leave both empty to inherit the version's own period, which keeps the node inside its parent's period by construction."
      },
      "retime": {
        "title": "Effective period",
        "description": "Changes the period during which {name} sits where it does.",
        "containment": "A node's period must sit inside its parent's period. Narrowing a child below its parent is reported against both of them.",
        "openEndedHint": "Clear this to make the period open-ended."
      },
      "validate": {
        "action": "Validate",
        "failed": "Could not validate this version",
        "findingsTitle": "Validation findings",
        "clean": "No findings. Cycle detection, depth, date containment and node-type conformance all pass."
      },
      "submit": {
        "action": "Submit for approval",
        "title": "Submit for approval",
        "description": "Submits version {versionNo} and closes it to further editing.",
        "confirm": "Submit",
        "working": "Submitting",
        "locksDraft": "The {nodeCount} node(s) in this draft are frozen while it is under approval, so the structure cannot change under the approver reading it.",
        "routedTo": "It will be routed to {queue}.",
        "routedUnknown": "It will be routed by the hierarchy's purpose.",
        "changeSummaryHint": "Required. It appears in the version history and the audit log, and is what an approver reads first.",
        "done": "Submitted for approval",
        "doneRouted": "Routed to {queue}.",
        "doneNoQueue": "The draft is now pending approval."
      },
      "publish": {
        "action": "Publish",
        "title": "Publish this version",
        "subject": "{code}, version {versionNo}",
        "subjectVersionOnly": "Version {versionNo}",
        "headline": "This cannot be undone.",
        "consequence": "Publishing freezes this version permanently. It can never be edited or republished — the only way to change the structure afterwards is a new draft, which you can seed from this version with Rollback.",
        "supersedes": "The version currently in force is closed at this version's start date, and its structure stays readable for its own dates. The closure cache and every derived access scope are regenerated before any other module sees the change.",
        "securityPurpose": "This is a security hierarchy: publishing it regenerates row-level access scopes, which is why it additionally requires the Security Administrator's permission.",
        "securityCaveat": "This session does not hold this hierarchy's purpose. If it is a security hierarchy, publication additionally requires the Security Administrator's permission and will be refused without it.",
        "noteLabel": "Approver's note",
        "noteHint": "Optional. Recorded on the publication audit row beside the change summary the version was submitted with.",
        "confirmLabel": "Type {versionNo} to confirm",
        "confirmHint": "Retyping the version number makes this a deliberate act rather than a click.",
        "confirm": "Publish version",
        "working": "Publishing",
        "done": "Version {versionNo} published",
        "doneDetail": "{closure} closure row(s) and {scopes} derived scope row(s) regenerated."
      },
      "rollback": {
        "action": "Roll back",
        "title": "Create a draft from an earlier version",
        "description": "Restates an earlier structure as a new draft you can edit and submit.",
        "headline": "Nothing published is changed.",
        "consequence": "A new draft version is created and seeded with the nodes of the version you name. No existing version is modified, deleted or reordered, and the version currently in force stays in force until the new draft is published in its turn.",
        "pickVersion": "Versions seen this session",
        "pickVersionHint": "Only versions that have actually been in force can be restated. Choosing one fills the id field below.",
        "pickVersionPlaceholder": "Choose a version",
        "versionOption": "Version {versionNo}, {status}, from {from}",
        "versionId": "Version id to restate",
        "versionIdHint": "The API serves no version list, so a version not seen in this session is entered by its id.",
        "changeSummaryHint": "Carried onto the new draft, so the submission that follows already has the summary it requires.",
        "confirm": "Create draft",
        "working": "Creating draft",
        "done": "Draft created from the earlier version",
        "doneDetail": "Version {versionNo} is a draft holding {nodeCount} node(s). Nothing published changed."
      },
      "compare": {
        "action": "Compare",
        "title": "Compare versions",
        "description": "Shows the organisations added, moved and removed between any two versions of this hierarchy, with counts.",
        "fromVersionId": "From version id",
        "toVersionId": "To version id",
        "run": "Compare",
        "failed": "Could not compare these versions",
        "idHint": "The comparison is keyed on the organisation rather than on node ids, because node ids are not shared between versions.",
        "knownVersions": "Versions seen this session: {list}",
        "added": "Added",
        "moved": "Moved",
        "removed": "Removed",
        "unchanged": "Unchanged",
        "none": "None",
        "between": "Between version {from} and version {to}.",
        "movedDetail": "from {from} to {to}",
        "rootParent": "the top of the structure"
      },
      "resolve": {
        "action": "Resolve as at a date",
        "title": "Resolve as at a date",
        "description": "Returns an organisation's ancestors, descendants and rollup path as the structure stood on any date, including dates covered by superseded versions.",
        "asAt": "As at",
        "asAtHint": "Any date. A past date is answered by the version that was in force then.",
        "run": "Resolve",
        "failed": "Could not resolve that organisation",
        "answeredBy": "Answered by version {versionNo}, as at {asAt}",
        "answeredByCurrent": "This is the version currently in force for that date.",
        "answeredBySuperseded": "This version has since been superseded. Its structure is what was in force on the date you asked for, which is what makes a historical answer possible.",
        "versionBadge": "Version {versionNo}",
        "rollupPath": "Rollup path",
        "rollupPathHint": "Root first, ending with the organisation itself — the path an amount travels when it rolls up this hierarchy.",
        "ancestors": "Ancestors",
        "descendants": "Descendants",
        "isRoot": "This organisation sits at the top of the structure on this date.",
        "isLeaf": "Nothing rolls up into this organisation on this date."
      },
      "version": {
        "title": "Version {versionNo}",
        "titleById": "Version number {versionId}",
        "subtitle": "{name}, a {purpose} hierarchy",
        "subtitleUnknown": "Hierarchy number {hierarchyId}",
        "readOnlyTitle": "This version cannot be edited",
        "readOnly": {
          "pending": "It is under approval. A structure that could change while it is being reviewed is not a structure anyone approved. Roll it back to a new draft if it needs changing.",
          "published": "A published version is permanent: it is the record of the structure in force for its dates, and reporting still resolves against it. Create a new version, or roll this one back into a new draft.",
          "superseded": "A later version has taken over. This one stays exactly as it was so that dates inside its period still resolve correctly. Roll it back into a new draft to restate it."
        },
        "statusUnknownTitle": "This version's publication status is not available here",
        "statusUnknown": "The API serves no version read, so a version opened directly by its id cannot be submitted or published from this screen. Open it from the register, or create a new version there.",
        "structureUnavailableTitle": "This version holds {count} node(s) that cannot be displayed here",
        "structureUnavailable": "The API serves no read of a version's nodes, and this browser session was never handed them. The canvas is withheld rather than shown empty, because an empty canvas would invite you to add organisations that are already placed.",
        "whatYouCanDo": "What you can do instead",
        "optionResolve": "Resolve an organisation as at a date to read the published structure around it.",
        "optionCompare": "Compare this version with another to see what differs.",
        "optionRollback": "Roll this version back into a new draft, which you can then arrange."
      }
    },
    "ledgers": {
      "routeTitles": {
        "ledgers": "Ledgers",
        "ledgerSets": "Ledger sets",
        "accountingMethods": "Accounting methods",
        "accountingCalendars": "Accounting calendars"
      },
      "title": "Ledgers",
      "description": "Every ledger with its legal entity, role and functional currency. Expand a ledger to see the currencies it also reports in.",
      "loadFailed": "Could not load the ledgers.",
      "tableLabel": "Ledgers",
      "emptyTitle": "No ledgers yet",
      "emptyDescription": "Each legal entity receives its primary ledger when it is created.",
      "filterLegalEntity": "Filter by legal entity",
      "activeOnly": "Active only",
      "idHint": "Record id",
      "columns": {
        "ledger": "Ledger",
        "legalEntity": "Legal entity",
        "coaStructure": "Chart of accounts structure",
        "calendar": "Accounting calendar",
        "accountingMethod": "Accounting method",
        "role": "Role",
        "currency": "Currency"
      },
      "notAttached": "Not attached",
      "roles": {
        "primary": "Primary",
        "secondary": "Secondary",
        "reporting": "Reporting"
      },
      "statuses": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "periodStatuses": {
        "open": "Open",
        "soft_closed": "Soft-closed",
        "closed": "Closed",
        "permanently_closed": "Permanently closed"
      },
      "reportingCurrencies": {
        "title": "Reporting currencies — {ledger}",
        "description": "Currencies this ledger also reports in, besides its functional currency {currency}.",
        "add": "Add reporting currency",
        "noAccess": "You do not have permission to view reporting currencies.",
        "loadFailed": "Could not load the reporting currencies.",
        "empty": "This ledger reports only in its functional currency.",
        "current": "Current",
        "ended": "Ended",
        "saved": "{currency} added as a reporting currency of {ledger}",
        "saveFailed": "Could not add the reporting currency.",
        "toggle": "Reporting currencies",
        "show": "Reporting currencies",
        "hide": "Hide currencies",
        "bases": {
          "spot": "Spot rate",
          "average": "Average rate",
          "historical": "Historical rate",
          "closing": "Closing rate"
        },
        "fields": {
          "currency": "Currency",
          "effectiveFrom": "Effective from",
          "basis": "Conversion basis"
        }
      },
      "resolve": {
        "title": "Ledger selector",
        "description": "Which ledger and period would a posting for this legal entity on this date go to? The answer is the one every posting uses.",
        "legalEntity": "Legal entity",
        "legalEntityIdHint": "Legal entity id",
        "on": "Date",
        "onHint": "Leave empty for today.",
        "run": "Resolve",
        "resolving": "Resolving",
        "ledger": "Ledger",
        "onDate": "As of",
        "period": "Period",
        "periodStatus": "Period status",
        "allowed": "Posting allowed",
        "warning": "Posting allowed with a warning",
        "blocked": "Posting blocked",
        "noPeriod": "No period covers this date"
      },
      "methods": {
        "title": "Accounting methods",
        "description": "The accounting methods a ledger can be built on. System methods ship with the product; add your own for statutory or management variants.",
        "loadFailed": "Could not load the accounting methods.",
        "tableLabel": "Accounting methods",
        "emptyTitle": "No accounting methods yet",
        "emptyDescription": "Add an accounting method to use it when building a ledger.",
        "create": "New accounting method",
        "createTitle": "New accounting method",
        "createDescription": "The code is how ledgers refer to this method.",
        "created": "Accounting method {code} added",
        "createFailed": "Could not add the accounting method.",
        "system": "System",
        "tenant": "Your own",
        "columns": {
          "code": "Code",
          "name": "Name",
          "origin": "Source"
        },
        "fields": {
          "description": "Description"
        }
      },
      "sets": {
        "title": "Ledger sets",
        "description": "Named groups of ledgers that share a chart of accounts structure, for consolidated reporting and closing their periods together.",
        "loadFailed": "Could not load the ledger sets.",
        "tableLabel": "Ledger sets",
        "emptyTitle": "No ledger sets yet",
        "emptyDescription": "Create a ledger set to report on several ledgers together or close their periods at once.",
        "create": "New ledger set",
        "createTitle": "New ledger set",
        "createDescription": "Every ledger you add must use the same chart of accounts structure.",
        "created": "Ledger set {code} created",
        "createFailed": "Could not create the ledger set.",
        "columns": {
          "set": "Ledger set",
          "structure": "Chart of accounts structure",
          "calendar": "Calendar"
        },
        "fields": {
          "code": "Code",
          "name": "Name",
          "calendarHint": "Optional. Ledgers in the set then close on one calendar."
        },
        "members": {
          "show": "Members",
          "title": "Members of {code}",
          "titlePlain": "Ledger set members",
          "description": "Ledgers in this set, with the dates each membership applies.",
          "add": "Add ledger",
          "loadFailed": "Could not load this ledger set.",
          "empty": "No ledgers in this set yet.",
          "current": "Current",
          "ended": "Ended",
          "ledger": "Ledger",
          "effectiveFrom": "Effective from",
          "added": "Ledger added to the set",
          "addFailed": "Could not add the ledger to the set."
        }
      },
      "calendars": {
        "title": "Accounting calendars",
        "description": "Calendars set out the accounting periods of each legal entity's fiscal year. Select a calendar to see its periods.",
        "loadFailed": "Could not load the accounting calendars.",
        "tableLabel": "Accounting calendars",
        "emptyTitle": "No accounting calendars yet",
        "emptyDescription": "Define a calendar to create the accounting periods of a fiscal year.",
        "create": "Define calendar",
        "createTitle": "Define accounting calendar",
        "createDescription": "Monthly and quarterly calendars create their periods automatically. Weekly, 4-4-5 and custom calendars need you to enter each period's dates.",
        "created": "Calendar {name} defined",
        "createdDetail": "No periods were generated. | 1 period was generated. | {count} periods were generated.",
        "createFailed": "Could not define the calendar.",
        "showPeriods": "Periods",
        "columns": {
          "name": "Calendar",
          "anchor": "Fiscal year starts",
          "frequency": "Frequency",
          "adjusting": "Adjusting periods"
        },
        "fields": {
          "name": "Name",
          "anchor": "Fiscal year starts in",
          "anchorHint": "The month the fiscal year opens.",
          "adjusting": "Adjusting periods",
          "adjustingHint": "0 to 6. Monthly and quarterly calendars place them inside the last days of the year.",
          "generateYear": "Generate fiscal year",
          "generateYearHint": "Optional. Creates that year's periods now.",
          "frequency": "Frequency"
        },
        "frequencies": {
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "weekly": "Weekly",
          "fourFourFive": "4-4-5",
          "custom": "Custom"
        },
        "frequencyHints": {
          "monthly": "12 periods, created automatically",
          "quarterly": "4 periods, created automatically",
          "weekly": "Enter each period's dates",
          "fourFourFive": "4, 4 and 5 weeks per quarter",
          "custom": "Enter each period's dates"
        },
        "explicitNoYear": "Enter a fiscal year to set out its periods, or leave it empty to define the calendar only.",
        "explicitHint": "Periods must run one after another, with no gaps or overlaps. Mark any adjusting periods.",
        "layout445": "Fill in 4-4-5",
        "addPeriod": "Add period",
        "remove": "Remove",
        "removePeriod": "Remove period {no}",
        "explicitSummary": "{count} periods covering {days} days.",
        "seamGap": "{days} day gap before {name}.",
        "seamOverlap": "{name} overlaps the previous period by {days} days.",
        "seamOk": "Contiguous",
        "seamGapShort": "Gap of {days} days",
        "seamOverlapShort": "Overlap of {days} days",
        "periodFields": {
          "no": "No.",
          "name": "Period",
          "start": "Start",
          "end": "End",
          "quarter": "Quarter",
          "adjusting": "Adjusting",
          "days": "Days",
          "seam": "Follows previous"
        },
        "timeline": {
          "title": "Periods — {name}",
          "description": "Periods in a fiscal year must run one after another, with no gaps or overlaps.",
          "emptyTitle": "No periods generated yet",
          "emptyDescription": "Generate a fiscal year for this calendar to create its periods.",
          "year": "Fiscal year",
          "loadFailed": "Could not load this calendar's periods.",
          "stripLabel": "{count} periods in fiscal year {year}",
          "summary": "{count} periods covering {days} days.",
          "breaks": "No breaks. | 1 break in continuity. | {count} breaks in continuity.",
          "tableLabel": "Periods of fiscal year {year}",
          "quarterHeading": "Quarter {quarter}",
          "noQuarter": "Outside any quarter",
          "adjustingBadge": "Adjusting"
        }
      }
    },
    "legalEntities": {
      "title": "Legal Entities",
      "description": "The enterprise's legal entity register. Each entity owns its assets, its filings and its obligations, and is the contracting party on every transaction.",
      "tableLabel": "Legal entities",
      "searchPlaceholder": "Search code, name…",
      "searchLabel": "Search legal entities",
      "entityTypeFilterPlaceholder": "All entity types",
      "createTitle": "New legal entity",
      "createFirst": "Register the first legal entity",
      "emptyTitle": "No legal entities yet",
      "emptyDescription": "Register a legal entity to start mapping it to a ledger, designating it and bringing it into the consolidation structure.",
      "loadFailed": "Could not load the legal entity register.",
      "exported": "Exported one legal entity | Exported {count} legal entities",
      "columns": {
        "code": "Code",
        "name": "Name",
        "entityType": "Type",
        "country": "Country",
        "baseCurrency": "Currency"
      },
      "fields": {
        "code": "Legal entity code",
        "legalName": "Registered legal name",
        "name": "Display name",
        "country": "Country",
        "baseCurrency": "Functional currency",
        "entityType": "Entity type",
        "incorporationDate": "Incorporation date",
        "dissolvedOn": "Dissolved on",
        "approvalStatus": "Approval status",
        "phone": "Phone",
        "email": "Email"
      },
      "entityTypes": {
        "limited_company": "Limited company",
        "branch": "Branch",
        "partnership": "Partnership",
        "representative_office": "Representative office",
        "joint_venture": "Joint venture",
        "trust": "Trust",
        "other": "Other"
      },
      "statuses": {
        "draft": "Draft",
        "submitted": "Submitted",
        "approved": "Approved",
        "rejected": "Rejected",
        "active": "Active",
        "dissolved": "Dissolved"
      },
      "form": {
        "createTitle": "Register a legal entity",
        "createDescription": "Registers the entity in DRAFT status (FSD 1.2.3.9). Map it to a ledger and assign a balancing segment value before submitting it for approval.",
        "editTitle": "Edit legal entity",
        "editDescription": "Only the entity type and incorporation date are edited here — the registered name, country and currency belong to the underlying legal entity record.",
        "readOnlyHint": "Code, name, country and currency are read-only on this screen.",
        "created": "Legal entity registered",
        "createdDetail": "{name} was registered in DRAFT status.",
        "createFailed": "Could not register the legal entity.",
        "saved": "Legal entity saved",
        "savedDetail": "{name} was updated.",
        "saveFailed": "Could not save the legal entity."
      },
      "tabs": {
        "profile": "Profile",
        "ledgers": "Ledgers",
        "balancing": "Balancing segments",
        "designations": "Designations",
        "consolidation": "Consolidation path"
      },
      "detail": {
        "oneTitle": "Legal entity",
        "oneDescription": "Profile, ledger mapping, balancing segments, designations and consolidation route.",
        "oneLoadFailed": "Could not load this legal entity.",
        "notFound": "This legal entity could not be found.",
        "tabsLabel": "Legal entity sections",
        "backToList": "Back to the register",
        "submit": "Submit for approval",
        "submitted": "Submitted for approval",
        "submitFailed": "Could not submit the legal entity.",
        "activate": "Activate",
        "activated": "Legal entity activated",
        "activateFailed": "Could not activate the legal entity.",
        "dissolve": "Dissolve…"
      },
      "rail": {
        "subtitle": "{entityType} · {currency}",
        "incorporated": "Incorporated",
        "activated": "Activated",
        "dissolved": "Dissolved",
        "registerLink": "Legal entity register"
      },
      "ledgers": {
        "title": "Ledger mapping",
        "description": "F-7.001: a legal entity maps to at least one ledger before it can activate.",
        "map": "Map to ledger",
        "emptyTitle": "No ledger mapped yet",
        "emptyDescription": "Map this entity to one of its own ledgers so it can carry a balancing segment value and activate.",
        "saved": "Ledger mapping saved",
        "saveFailed": "Could not map the ledger.",
        "roles": {
          "primary": "Primary",
          "secondary": "Secondary"
        },
        "fields": {
          "ledger": "Ledger",
          "role": "Role",
          "effectiveFrom": "Effective from"
        }
      },
      "balancing": {
        "title": "Balancing segment values",
        "description": "F-7.009: a balancing segment value is exclusive to this entity within its ledger — assigning one already held elsewhere is refused and the holder is named.",
        "assign": "Assign value",
        "emptyTitle": "No balancing segment value assigned",
        "emptyDescription": "Assign at least one balancing segment value in a mapped ledger so this entity can activate (F-7.001).",
        "saved": "Balancing segment value assigned",
        "saveFailed": "Could not assign the balancing segment value.",
        "derived": "Derived",
        "fields": {
          "ledger": "Ledger",
          "coaSegmentValueId": "COA segment value ID",
          "coaSegmentValueIdHint": "The chart-of-accounts segment value's numeric id (Foundation → Chart of Accounts → Value Sets).",
          "isDerived": "Derived from a parent value",
          "effectiveFrom": "Effective from"
        }
      },
      "designations": {
        "title": "Designations",
        "description": "F-7.007/F-7.008: Legal Employer and Payroll Statutory Unit designations, set together or separately.",
        "designate": "Set designation",
        "emptyTitle": "No designations yet",
        "emptyDescription": "Designate this entity a Legal Employer or a Payroll Statutory Unit where it employs workers or operates payroll.",
        "saved": "Designation saved",
        "saveFailed": "Could not save the designation.",
        "kinds": {
          "PSU": "Payroll Statutory Unit",
          "TRU": "Tax Reporting Unit",
          "LE": "Legal Employer"
        },
        "fields": {
          "isLegalEmployer": "Legal Employer",
          "isPsu": "Payroll Statutory Unit",
          "jurisdiction": "Jurisdiction",
          "ldg": "Legislative Data Group",
          "effectiveFrom": "Effective from",
          "note": "Note"
        }
      },
      "consolidation": {
        "title": "Consolidation path",
        "description": "F-7.004: the route to a nominated parent — a shared ledger with balancing segments, or an ownership path with elimination.",
        "fields": {
          "parent": "Nominated parent"
        },
        "parentPlaceholder": "Choose a legal entity",
        "check": "Check the route",
        "noAccessTitle": "Restricted",
        "noAccessDescription": "The consolidation path is visible to Finance, Legal, Compliance and Internal Audit roles (1.2.3.11).",
        "routes": {
          "balancing_segment": "Balancing segment",
          "ownership_and_elimination": "Ownership + elimination",
          "ownership_only": "Ownership only — no elimination rule yet",
          "none": "No consolidation route"
        }
      },
      "dissolve": {
        "title": "Dissolve legal entity",
        "subject": "Dissolving {name}",
        "consequence": "Dissolution end-dates the entity. It remains fully reportable historically but cannot originate any new transaction after the effective date (F-7.006). This cannot be undone.",
        "blockedTitle": "Cannot dissolve yet:",
        "fields": {
          "dissolvedOn": "Dissolved on",
          "reasonCode": "Reason code",
          "reasonCodeHint": "A short code recorded on the terminal audit entry."
        },
        "confirm": "Dissolve",
        "done": "Legal entity dissolved",
        "doneDetail": "{name} was end-dated and remains fully reportable historically.",
        "failed": "Could not dissolve the legal entity."
      },
      "routeTitles": {
        "list": "Legal Entities",
        "detail": "Legal Entity",
        "ownership": "Ownership Graph",
        "intercompany": "Intercompany",
        "eliminationRules": "Elimination Rules"
      },
      "accountPicker": {
        "placeholder": "Choose an account",
        "chooseEntityFirst": "Choose the entity first",
        "idPlaceholder": "Account ID"
      },
      "ownership": {
        "title": "Ownership Graph",
        "description": "Who owns whom across the group, as at a date. Each link records the parent's direct or indirect holding in a legal entity; direct holdings in any one entity may not exceed 100% (F-7.011).",
        "record": "Record ownership",
        "recordFirst": "Record the first holding",
        "loadFailed": "Could not load the ownership register.",
        "asAt": "As at",
        "graphTitle": "Ownership as at {date}",
        "graphDescription": "Built from the holdings in force on this date. The percentage on each line is the parent's holding in the entity below it.",
        "emptyTitle": "No ownership recorded",
        "emptyDescription": "This register is the only place group ownership is maintained — consolidation groups no longer carry their own ownership percentage, and consolidation reads its holdings from here. Record each shareholding to build the graph.",
        "treeLabel": "Legal ownership",
        "cycle": "Circular holding",
        "selectHint": "Select an entity to check its consolidation path.",
        "openEntity": "Open legal entity",
        "noSelectionTitle": "No entity selected",
        "noSelectionDescription": "Select an entity in the graph to see how it consolidates into a parent.",
        "registerTitle": "Ownership register",
        "registerLabel": "Ownership register",
        "includeHistory": "Include superseded versions",
        "open": "In force",
        "amend": "Amend",
        "fields": {
          "parent": "Parent entity",
          "child": "Owned entity",
          "holdingPct": "Holding %",
          "holdingType": "Holding type",
          "effectiveFrom": "Effective from",
          "effectiveTo": "Effective to",
          "note": "Note"
        },
        "holdingTypes": {
          "direct": "Direct",
          "indirect": "Indirect"
        },
        "form": {
          "title": "Record ownership",
          "amendTitle": "Amend ownership",
          "description": "Records a shareholding from the effective date. A later date for the same parent, entity and holding type supersedes the version in force.",
          "entityPlaceholder": "Choose a legal entity",
          "selfOwned": "An entity cannot own itself.",
          "holdingPctHint": "Greater than 0 and at most 100, up to four decimals. Confirm against the share register.",
          "noteHint": "Recorded on the audit trail with the change.",
          "contributorsTitle": "Existing direct holders in this entity:",
          "save": "Record",
          "saved": "Ownership recorded",
          "saveFailed": "Could not record the ownership."
        }
      },
      "intercompany": {
        "title": "Intercompany",
        "description": "Automatic intercompany balancing per entity pair (F-7.002): the due-from and due-to accounts each side posts to. Every configuration is simulated before it is saved (FND-F03-V09).",
        "toElimination": "Elimination rules",
        "create": "New intercompany rule",
        "createFirst": "Configure the first entity pair",
        "loadFailed": "Could not load the intercompany rules.",
        "tableLabel": "Intercompany rules",
        "emptyTitle": "No intercompany rules yet",
        "emptyDescription": "Configure an entity pair so transactions between them balance automatically through intercompany receivable and payable accounts.",
        "asAt": "As at",
        "asAtHint": "Leave empty to see every version.",
        "inForce": "In force",
        "amend": "Amend",
        "simulateRule": "Simulate",
        "segmentValueShort": "Segment {value}",
        "fields": {
          "company": "Entity",
          "counterparty": "Counterparty entity",
          "receivable": "IC receivable (due from)",
          "payable": "IC payable (due to)",
          "counterpartySegmentValue": "Counterparty segment value",
          "balancingRule": "Balancing rule",
          "effectiveFrom": "Effective from",
          "effective": "Effective"
        },
        "form": {
          "title": "Configure intercompany rule",
          "amendTitle": "Amend intercompany rule",
          "description": "Both accounts belong to the originating entity. The configuration is simulated before it is saved; an unbalanced configuration is refused with its findings.",
          "entityPlaceholder": "Choose a legal entity",
          "samePair": "The counterparty must be a different entity.",
          "receivableHint": "A postable asset account of the entity.",
          "payableHint": "A postable liability account of the entity.",
          "segmentValueHint": "Optional: the intercompany segment value that identifies the counterparty.",
          "balancingRuleHint": "Defaults to auto.",
          "save": "Simulate and save",
          "saved": "Intercompany rule saved",
          "saveFailed": "Could not save the intercompany rule."
        },
        "simulate": {
          "title": "Balance simulation",
          "description": "Checks that a configuration's due-from and due-to accounts exist, belong to the originating entity, are postable and of the right type. A configuration that passes balances any amount.",
          "seeded": "Simulating rule #{id}; the run is logged against it.",
          "from": "From entity",
          "to": "To entity",
          "dueFrom": "Due-from account (IC receivable)",
          "dueTo": "Due-to account (IC payable)",
          "run": "Simulate",
          "balanced": "Balanced",
          "unbalanced": "Does not balance",
          "residual": "Residual"
        }
      },
      "elimination": {
        "title": "Elimination Rules",
        "description": "The elimination entries consolidated reporting applies to an entity pair (LE-08), optionally limited to one consolidation group.",
        "toIntercompany": "Intercompany rules",
        "create": "New elimination rule",
        "createFirst": "Configure the first elimination rule",
        "loadFailed": "Could not load the elimination rules.",
        "tableLabel": "Elimination rules",
        "emptyTitle": "No elimination rules yet",
        "emptyDescription": "Declare which accounts are eliminated, debit and credit, when an entity pair is consolidated.",
        "asAt": "As at",
        "asAtHint": "Leave empty to see every version.",
        "inForce": "In force",
        "amend": "Amend",
        "fields": {
          "company": "Entity",
          "counterparty": "Counterparty entity",
          "ruleType": "Rule type",
          "consolGroup": "Consolidation group",
          "accounts": "Elimination entries",
          "account": "Account",
          "side": "Side",
          "effectiveFrom": "Effective from",
          "effective": "Effective"
        },
        "sides": {
          "dr": "Debit",
          "cr": "Credit"
        },
        "ruleTypes": {
          "intercompany_balance": "Intercompany balances"
        },
        "form": {
          "title": "Configure elimination rule",
          "amendTitle": "Amend elimination rule",
          "description": "Validated by simulation before it is saved: every account must belong to one of the two entities, and both a debit and a credit entry are required. A later date for the same pair and rule type supersedes the version in force.",
          "entityPlaceholder": "Choose a legal entity",
          "samePair": "The counterparty must be a different entity.",
          "ruleTypeHint": "What is eliminated. Intercompany balances is currently the only rule type consolidation applies.",
          "ruleTypePlaceholder": "Choose a rule type",
          "consolGroupHint": "Optional: limit the rule to one consolidation group.",
          "anyGroup": "Every group",
          "accountsHint": "Pick each account from either entity of the pair.",
          "needBothSides": "Add at least one debit and one credit entry.",
          "owner": "From entity",
          "ownerCompany": "Entity",
          "ownerCounterparty": "Counterparty",
          "removeEntry": "Remove entry {n}",
          "addEntry": "Add entry",
          "save": "Simulate and save",
          "saved": "Elimination rule saved",
          "saveFailed": "Could not save the elimination rule."
        }
      }
    },
    "localisation": {
      "routeTitles": {
        "einvoicing": "e-Invoicing Configuration",
        "sandboxRuns": "Pack Validation Runs",
        "sandboxRunDetail": "Validation Run",
        "statutoryLanguages": "Statutory Document Languages"
      },
      "einvoicing": {
        "title": "e-Invoicing Configuration",
        "description": "Configure the gateway a jurisdiction's e-invoicing mandate submits to, and prove it can be reached before enabling live submission (FND-F08-V07).",
        "create": "New Configuration",
        "createTitle": "New e-Invoicing Configuration",
        "editTitle": "Edit e-Invoicing Configuration",
        "country": "Country",
        "gateway": "Gateway",
        "endpoint": "Endpoint",
        "credential": "Credential",
        "credentialHint": "Leave blank to keep the current credential. Never displayed once saved.",
        "currentCredential": "Current credential: {masked}",
        "pollInterval": "Status poll interval (seconds)",
        "pollIntervalHint": "How often submission status is polled. Defaults to 300 seconds.",
        "saved": "e-Invoicing configuration saved",
        "saveFailed": "Could not save the e-invoicing configuration",
        "tableLabel": "e-Invoicing configurations",
        "emptyTitle": "No e-invoicing gateways configured",
        "emptyDescription": "Configure a gateway for a jurisdiction that mandates e-invoicing, then test connectivity before enabling live submission.",
        "loadFailed": "Could not load e-invoicing configurations",
        "status": {
          "draft": "Draft",
          "testing": "Testing",
          "active": "Active",
          "failed": "Failed",
          "disabled": "Disabled"
        },
        "lastTest": "Last connectivity test",
        "neverTested": "Never tested",
        "pass": "Pass",
        "fail": "Fail",
        "testConnectivity": "Test connectivity",
        "resultTitle": "Connectivity test result",
        "detail": "Detail",
        "statusCode": "HTTP status",
        "testedAt": "Tested at",
        "resultConsequence": "A failing result leaves the configuration in Failed status; live submission stays unavailable until a test passes (FND-F08-V07)."
      },
      "sandboxRuns": {
        "title": "Pack Validation Runs",
        "description": "F-8.008: a pending tax pack update must be validated in a non-production enterprise against a sample of historical transactions before production acceptance is offered. Every run executed is kept here, append-only.",
        "run": "Run validation",
        "runTitle": "Run sandbox validation",
        "runDescription": "Replays a sample of real sampled tax lines under the country's pending pack version and reports every one that would change.",
        "country": "Country",
        "filterCountry": "Filter by country",
        "version": "Pack version",
        "sampleSize": "Sample size",
        "sampleSizeHint": "Number of sampled tax lines to replay. Defaults to 200.",
        "nonProductionEnterpriseId": "Non-production enterprise id",
        "nonProductionEnterpriseIdHint": "Optional. Must be a non-production enterprise if supplied (F-8.008).",
        "status": {
          "completed": "Completed",
          "failed": "Failed"
        },
        "differences": "Differences",
        "noDifferences": "No differences",
        "differenceCount": "{count} difference(s)",
        "executedAt": "Executed at",
        "executed": "Validation run executed",
        "executeFailed": "Could not execute the validation run",
        "tableLabel": "Pack validation runs",
        "emptyTitle": "No validation runs yet",
        "emptyDescription": "Run a sandbox validation against a country's pending pack update before offering it for production acceptance.",
        "loadFailed": "Could not load pack validation runs"
      },
      "sandboxRunDetail": {
        "title": "Validation Run",
        "backToList": "Back to validation runs",
        "loadFailed": "Could not load this validation run",
        "executedBy": "Executed by (user id)",
        "nonProductionEnterprise": "Non-production enterprise",
        "summaryUnavailable": "This run's result summary is not in the expected shape and cannot be displayed.",
        "noDifferences": "No differences — the pending pack version agrees with every sampled line.",
        "differencesHeading": "{count} difference(s) found",
        "differencesTableLabel": "Sampled differences",
        "columns": {
          "document": "Document",
          "taxCode": "Tax code",
          "treatment": "Treatment",
          "taxAmount": "Tax amount",
          "reason": "Reason"
        }
      },
      "statutoryLanguages": {
        "title": "Statutory Document Languages",
        "description": "F-8.004: the language a statutory document is generated in is determined by the jurisdiction of issuance, not by the user's preferred language. This register declares that requirement per country and document class, effective-dated.",
        "create": "New Requirement",
        "createTitle": "New statutory language requirement",
        "reviseTitle": "Revise statutory language requirement",
        "formDescription": "Declares or revises which language a statutory document class renders in for a country.",
        "country": "Country",
        "documentClass": "Document class",
        "documentClassHint": "e.g. invoice, payslip, tax_return, statement",
        "language": "Language",
        "languageHint": "ISO 639-1 code, e.g. en, dv, ar",
        "effectiveFrom": "Effective from",
        "effective": "Effective",
        "openEnded": "open-ended",
        "revise": "Revise",
        "reviseNote": "Revising creates a new version starting on the effective date above; the current version's history is kept, not overwritten.",
        "saved": "Statutory language requirement saved",
        "saveFailed": "Could not save the statutory language requirement",
        "tableLabel": "Statutory document languages",
        "emptyTitle": "No statutory language requirements declared",
        "emptyDescription": "Declare which language a statutory document class must render in for a country.",
        "loadFailed": "Could not load statutory document languages"
      }
    },
    "overview": {
      "title": "Enterprise dashboard & inbox",
      "description": "How complete the enterprise configuration is, what it contains, and what is waiting for you.",
      "navLabel": "Dashboard & Inbox",
      "routeTitles": {
        "overview": "Enterprise dashboard"
      },
      "checklist": {
        "title": "Configuration completeness",
        "description": "Computed from what is actually in the database — no item is ever reported done without the rows to prove it.",
        "loadFailed": "The configuration checklist did not load",
        "requiredCounted": "Required items done",
        "progressLabel": "Configuration progress",
        "ready": "Ready to go live",
        "notReady": "Not ready yet",
        "optional": "Optional",
        "itemDone": "Done",
        "itemToDo": "Still to do",
        "review": "Review",
        "fix": "Set it up"
      },
      "structure": {
        "title": "Enterprise structure",
        "description": "Counted from each register. Open a register to see or change its records.",
        "registers": {
          "legalEntities": "Legal entities (active)",
          "divisions": "Divisions",
          "businessUnits": "Business units",
          "costCentres": "Cost centres (active)",
          "positions": "Positions",
          "ledgers": "Ledgers"
        },
        "atLeast": "{count}+",
        "capped": "Counted the first {pages} pages only; the register holds more.",
        "openRegister": "Open register"
      },
      "approvals": {
        "title": "Awaiting my approval",
        "description": "The first tasks in your approvals inbox, across every document type.",
        "openInbox": "Open approvals inbox",
        "loadFailed": "Your approval tasks did not load",
        "empty": "Nothing is waiting for your approval.",
        "unknownSubmitter": "Submitter not recorded",
        "overdue": "Overdue",
        "more": "More tasks are waiting — open the inbox to see them all."
      },
      "attention": {
        "title": "Needs my attention",
        "description": "Open exceptions, tasks and alerts raised for you.",
        "openList": "Open attention list",
        "loadFailed": "Your attention items did not load",
        "empty": "Nothing needs your attention.",
        "untitled": "Untitled item",
        "more": "More items are open — open the attention list to see them all."
      },
      "activity": {
        "title": "Recent enterprise activity",
        "description": "The latest audited changes to legal entities, divisions, business units, ledgers, positions and opening balances.",
        "openAudit": "Open audit explorer",
        "loadFailed": "Recent activity did not load",
        "empty": "No enterprise changes have been recorded yet.",
        "caption": "Latest enterprise audit entries",
        "columns": {
          "when": "When",
          "object": "Object",
          "action": "Action",
          "actor": "By"
        },
        "actor": "{type} {id}",
        "entities": {
          "org_company": "Legal entity",
          "org_division": "Division",
          "business_units": "Business unit",
          "org_ledger": "Ledger",
          "org_position": "Position",
          "org_opening_balance": "Opening balances"
        },
        "actions": {
          "create": "Created",
          "update": "Updated",
          "delete": "Deleted",
          "restore": "Restored",
          "status_change": "Status changed",
          "submit": "Submitted",
          "post": "Posted",
          "reverse": "Reversed",
          "approve": "Approved",
          "reject": "Rejected",
          "config_change": "Configuration changed"
        }
      }
    },
    "periods": {
      "title": "Period Control",
      "description": "The status of every accounting period, by ledger. Closing a period stops everyone else posting to it; a permanently closed period can never be reopened.",
      "routeTitles": {
        "control": "Period Control"
      },
      "ledgerLabel": "Ledger",
      "ledgerPlaceholder": "Any ledger",
      "ledgerNote": "Ledger {ledger} posts through its legal entity's fiscal calendar, so every ledger of that legal entity shares these period statuses.",
      "ledgerRoles": {
        "primary": "Primary",
        "secondary": "Secondary"
      },
      "calendarLabel": "Calendar",
      "yearLabel": "Fiscal year",
      "allYears": "All years",
      "chooseTitle": "Choose a ledger or a legal entity",
      "chooseDescription": "Periods belong to a legal entity's fiscal calendar. Pick a ledger, or its legal entity, to see them.",
      "loadFailed": "The periods did not load",
      "noCalendarTitle": "No fiscal calendar yet",
      "noCalendarDescription": "This legal entity has no accounting calendar. Define one under Accounting Calendars, then come back to control its periods.",
      "noPeriodsTitle": "This calendar has no periods yet",
      "noPeriodsDescription": "Generate a fiscal year to lay its periods out.",
      "yearHeading": "Fiscal year {year}",
      "tableCaption": "Periods of fiscal year {year}",
      "columns": {
        "no": "No.",
        "name": "Period",
        "quarter": "Quarter",
        "start": "From",
        "end": "To",
        "reason": "Reason"
      },
      "status": {
        "open": "Open",
        "soft_closed": "Soft closed",
        "closed": "Closed",
        "permanently_closed": "Permanently closed"
      },
      "statusMeaning": {
        "open": "postings are accepted",
        "soft_closed": "postings warn, and still go through",
        "closed": "postings are refused; may be reopened",
        "permanently_closed": "postings refused; can never be reopened"
      },
      "actions": {
        "softClose": "Soft close",
        "close": "Close",
        "reopen": "Reopen",
        "permanentClose": "Close permanently"
      },
      "adjusting": "Adjusting",
      "quarterShort": "Q{quarter}",
      "frequency": {
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "weekly": "Weekly",
        "445": "4-4-5",
        "custom": "Custom"
      },
      "terminal": "Sealed",
      "reopenedWith": "Reopened: {code}",
      "permanentPending": "Permanent close awaiting approval (request #{id})",
      "blockers": {
        "title": "This period cannot close yet",
        "hint": "Clear each blocker (for example in the close checklist or bank reconciliation), then close the period again.",
        "count": "({count} outstanding)",
        "open": "Open the list",
        "unknown": "Blocker {code}",
        "byCode": {
          "CLOSE_READINESS": "Close checklist items are not complete",
          "BUSINESS_DAY_OPEN": "Business days are still open"
        }
      },
      "generate": {
        "title": "Generate a year",
        "description": "Lay out one more fiscal year on {calendar}.",
        "fiscalYear": "Fiscal year",
        "shape": "Laid out from the calendar: {frequency}, with {adjusting} adjusting period(s).",
        "confirm": "Generate",
        "done": "Periods generated",
        "doneDetail": "{count} periods for {year}.",
        "failed": "The periods could not be generated"
      },
      "transitions": {
        "subject": "Period {period}",
        "reasonLabel": "Reason",
        "reasonHint": "Required. It goes on the audit record, and whoever asks later will read it.",
        "reasonRequired": "A reason is required: closing or reopening a period changes what everyone else may post.",
        "codeRequired": "A reason code is required for a permanent close.",
        "mfaNotEnrolled": "Closing a period needs a second factor and this account has none enrolled yet.",
        "mfaLink": "Set up an authenticator",
        "stepUpRequired": "The server asked you to prove it is you again before this is allowed. Confirm your second factor, then try once more.",
        "failed": "That could not be done",
        "doneDetail": "Period {period}.",
        "close": {
          "title": "Close this period",
          "consequence": "No further postings can be made to this period. Corrections will have to go to an open one.",
          "confirm": "Close the period",
          "done": "Period closed"
        },
        "soft_close": {
          "title": "Soft close this period",
          "consequence": "Postings will warn but still go through. Use this while the month is being reviewed.",
          "confirm": "Soft close",
          "done": "Period soft closed"
        },
        "reopen": {
          "title": "Reopen this period",
          "consequence": "This period will accept postings again, so figures already reported for it can change.",
          "confirm": "Reopen the period",
          "done": "Period reopened"
        },
        "permanent_close": {
          "title": "Close this period permanently",
          "consequence": "This asks two approvers to seal the period for good.",
          "irreversible": "Once granted, this period can never be reopened, by anyone: not an administrator, not support.",
          "confirm": "Request permanent close",
          "done": "Permanent close requested",
          "codeLabel": "Reason code",
          "codeHint": "A short code recorded on the period, e.g. year_end_signed_off.",
          "dualControl": "Sent for dual approval. The period is not sealed until every approver has signed."
        }
      }
    },
    "referenceSets": {
      "title": "Reference Data Sets",
      "description": "Define which configuration is shared across the enterprise and which is partitioned by region, legal entity or business unit.",
      "create": "New Reference Data Set",
      "tableLabel": "Reference data sets",
      "loadFailed": "The reference data sets did not load",
      "filters": {
        "anyStatus": "Any status",
        "search": "Search",
        "searchHint": "Code or name"
      },
      "emptyTitle": "No reference data sets yet",
      "emptyDescription": "Create a set to partition configuration by region, legal entity or business unit.",
      "openById": "Open a set by id",
      "setId": "Set id",
      "open": "Open",
      "openByIdHint": "Version, assignment and end-date actions all work on a set by id, whether or not it appears in the list above.",
      "createTitle": "New Reference Data Set",
      "createDescription": "Creates a set in DRAFT with an owner and purpose.",
      "code": "Code",
      "name": "Name",
      "purpose": "Purpose",
      "ownerPosition": "Owner position id",
      "ownerPositionHint": "The accountable data owner for values within the set.",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "effectiveToHint": "Leave blank for open-ended.",
      "regionsScope": "Region / legal entity scope",
      "regionsScopeHint": "Mandatory where the determinant is Region or Legal Entity.",
      "regionCode": "Region code",
      "companyId": "Legal entity id",
      "addRegionRow": "Add scope row",
      "saved": "Reference data set created",
      "saveFailed": "Could not create the reference data set",
      "manage": "Manage",
      "compare": "Compare",
      "visibility": "Visibility",
      "status": {
        "draft": "Draft",
        "active": "Active",
        "retired": "Retired"
      },
      "system": "System",
      "systemBadge": "Common (system)",
      "effective": "Effective",
      "openEnded": "open-ended",
      "manageUntitled": "Manage set #{id}",
      "manageTitled": "{code} · {name}",
      "manageDescription": "Version and approve, assign business units, or end-date this set.",
      "unknownSetNote": "This set's current details are not available — there is no lookup endpoint for an existing set. The actions below still call the real API for this set id.",
      "currentStatus": "Current status",
      "tabsLabel": "Reference set actions",
      "tabs": {
        "version": "Version & Activate",
        "assign": "Assign Business Units",
        "endDate": "End-date"
      },
      "versionHelp": "Submits a set change for approval. Retroactive effective dates require a reason and additional approval.",
      "effectiveDate": "Effective date",
      "approvedBy": "Approved by (position id)",
      "approvedByHint": "Required for a retroactive change.",
      "retroactiveWarning": "This effective date is in the past — a change reason is required and the change routes for approval.",
      "changeReason": "Change reason",
      "activateSwitch": "Activate — move this set from DRAFT to ACTIVE",
      "submitVersion": "Submit version",
      "noManagePermission": "You do not hold the permission to manage reference data sets.",
      "versionSaved": "Version submitted",
      "versionSavedDetail": "Version {no} recorded",
      "versionFailed": "Could not submit the version",
      "assignHelp": "Assigns business units to this set for one determinant. A unit already assigned elsewhere for the same determinant and period is refused unless reassign is set.",
      "determinantType": "Determinant type",
      "determinants": {
        "common": "Common",
        "region": "Region",
        "legalEntity": "Legal Entity",
        "businessUnit": "Business Unit"
      },
      "businessUnits": "Business units",
      "businessUnitId": "Business unit id",
      "confirmedBy": "Confirmed by (position id)",
      "confirmedByHint": "The accountable business unit manager confirming this change.",
      "reassignSwitch": "Reassign — move a unit already assigned elsewhere",
      "assignResultLine": "Unit #{id}: gained {gained}, lost {lost} configuration value(s)",
      "submitAssign": "Submit assignment",
      "noAssignPermission": "You do not hold the permission to assign business units to reference data sets.",
      "assignSaved": "Assignment saved",
      "assignSavedDetail": "{count} business unit(s) assigned",
      "assignFailed": "Could not assign the business units",
      "commonSetGuard": "The Common set cannot be end-dated — this action is unavailable for every role, including system administrator.",
      "endDateHelp": "Blocked while active downstream references exist. On success the set's memberships and assignments are archived with it.",
      "retirementReason": "Retirement reason",
      "submitEndDate": "End-date set",
      "endDateSaved": "Set end-dated",
      "endDateSavedDetail": "{count} value(s) archived",
      "endDateFailed": "Could not end-date the set",
      "compareTitle": "Compare Sets",
      "compareDescription": "Presents two sets side by side, showing values unique to each and values in common — used before consolidating sets.",
      "leftSetId": "Left set id",
      "rightSetId": "Right set id",
      "configurationType": "Configuration type",
      "asOf": "As of",
      "compareRun": "Compare",
      "compareFailed": "Could not compare the sets",
      "overlapRatio": "{ratio}% overlap",
      "uniqueToLeft": "Unique to {code}",
      "uniqueToRight": "Unique to {code}",
      "none": "None",
      "inCommon": "In common",
      "visibilityTitle": "Preview Visibility",
      "visibilityDescription": "Shows, for a selected configuration value, the exact list of business units that will see it under the current assignments.",
      "valueId": "Value id",
      "visibilityRun": "Preview",
      "visibilityFailed": "Could not preview visibility",
      "inSet": "In this set",
      "notInSet": "Not in this set",
      "visibilitySummary": "{code} · determinant: {determinant}",
      "noUnits": "No business units currently see this value.",
      "viaAssignment": "via assignment",
      "viaCommonFallback": "via Common fallback",
      "determinantsTitle": "Determinants",
      "determinantsDescription": "Declares which determinant partitions each configuration type — Common, Region, Legal Entity or Business Unit. No type may be left implicit.",
      "noDeterminantPermission": "You do not hold the permission to declare determinants.",
      "note": "Note",
      "declareDeterminant": "Declare determinant",
      "determinantSaved": "Determinant declared",
      "determinantFailed": "Could not declare the determinant",
      "determinantsRegistryNote": "This list shows determinants declared in this browser session — there is no list endpoint for prior declarations.",
      "determinantsTableLabel": "Declared determinants",
      "determinantsEmptyTitle": "No determinants declared in this session yet",
      "determinantsEmptyDescription": "Declare a determinant above for each set-enabled configuration type.",
      "superseded": "Superseded",
      "current": "Current",
      "browserTitle": "Browse Reference Data",
      "browserDescription": "The Reference-Data Query service: values of a configuration type, resolved for a business unit's determinant. Returns only the values in scope for that unit.",
      "browserHint": "Enter a configuration type and a business unit id to browse the values resolved for it.",
      "browserFailed": "Could not load reference data",
      "browserTableLabel": "Reference data values",
      "browserEmptyTitle": "No values resolved",
      "browserEmptyDescription": "Nothing is in scope for this business unit and configuration type as of the chosen date.",
      "routeTitles": {
        "catalogue": "Reference Data Sets",
        "compare": "Compare Reference Sets",
        "visibility": "Preview Visibility",
        "determinants": "Determinants",
        "browse": "Browse Reference Data"
      }
    },
    "setup": {
      "title": "Enterprise setup",
      "description": "Define the enterprise and run the one-time guided configuration. Every structure below it inherits what is captured here.",
      "loadFailed": "Could not load the enterprise configuration",
      "nonProduction": "Non-production enterprise",
      "routeTitles": {
        "workspace": "Enterprise",
        "wizard": "Enterprise setup"
      },
      "intro": {
        "title": "This is the first configuration on a new tenant",
        "body": "Nothing else can be set up until an enterprise is active: no legal entity, no ledger, no chart of accounts. Capture the identity, review what the guided pass proposes, and have an approver apply it."
      },
      "denied": {
        "title": "You cannot configure the enterprise",
        "body": "Enterprise setup needs the Enterprise Administrator permission. Ask a tenant administrator to grant foundation.enterprise.manage, then reopen this page."
      },
      "statuses": {
        "draft": "Draft",
        "pending": "Awaiting approval",
        "active": "Active",
        "inactive": "Inactive"
      },
      "versionStatuses": {
        "draft": "Draft",
        "pending": "Awaiting approval",
        "active": "Active",
        "superseded": "Superseded"
      },
      "types": {
        "production": "Production",
        "non_production": "Non-production"
      },
      "levels": {
        "enterprise": "Enterprise",
        "division": "Division",
        "legal_entity": "Legal entity",
        "business_unit": "Business unit"
      },
      "weekStart": {
        "monday": "Monday",
        "sunday": "Sunday",
        "saturday": "Saturday"
      },
      "months": {
        "1": "January",
        "2": "February",
        "3": "March",
        "4": "April",
        "5": "May",
        "6": "June",
        "7": "July",
        "8": "August",
        "9": "September",
        "10": "October",
        "11": "November",
        "12": "December"
      },
      "entityTypes": {
        "limited_company": "Limited company",
        "branch": "Branch",
        "partnership": "Partnership",
        "representative_office": "Representative office",
        "joint_venture": "Joint venture",
        "trust": "Trust",
        "other": "Other"
      },
      "stepKinds": {
        "create_legal_entity": "Legal entity",
        "ensure_primary_ledger": "Primary ledger",
        "create_calendar": "Fiscal calendar",
        "create_division": "Division",
        "create_business_unit": "Business unit",
        "create_coa_structure": "Chart of accounts"
      },
      "validation": {
        "codeFormat": "Use 2 to 10 uppercase letters or digits, with no spaces or punctuation."
      },
      "fields": {
        "enterpriseCode": "Enterprise code",
        "enterpriseCodeHint": "2–10 uppercase letters or digits. Cannot be changed after the enterprise is activated.",
        "enterpriseType": "Enterprise type",
        "enterpriseTypeHint": "A tenant may hold exactly one active production enterprise. Use non-production for test or training.",
        "residencyRegion": "Residency region",
        "residencyRegionHint": "Where regulated data is stored and processed. A regulated region blocks switching PII encryption off.",
        "legalName": "Legal name",
        "legalNameHint": "The registered name. It appears on generated statutory outputs and is kept date-effective.",
        "brandName": "Brand / trading name",
        "brandNameHint": "Leave blank to use the legal name.",
        "primaryCountry": "Primary country",
        "primaryCountryHint": "Two-letter ISO code. Drives the country pack, holiday calendar and address validation.",
        "otherCountries": "Other countries of operation",
        "otherCountriesHint": "Comma-separated two-letter ISO codes, e.g. LK, IN.",
        "countries": "Countries of operation",
        "defaultCurrency": "Default currency",
        "defaultCurrencyHint": "Three-letter ISO 4217 code. Cannot be changed once anything has posted.",
        "timezone": "Default time zone",
        "timezoneHint": "IANA name, e.g. Indian/Maldives. Sets effective-date boundaries and period cut-off.",
        "language": "Default language",
        "dateFormat": "Date format",
        "numberFormat": "Number format",
        "weekStart": "Week start",
        "weekStartHint": "Anchors weekly and 4-4-5 calendars.",
        "fiscalAnchor": "Fiscal anchor month",
        "fiscalAnchorHint": "The month the financial year opens on.",
        "effectiveFrom": "Effective from",
        "effectiveFromHint": "The date this version of the identity takes effect.",
        "effectivePeriod": "Effective period",
        "changeSummary": "Change summary",
        "changeSummaryHint": "Recorded against this version for the configuration change log.",
        "changes": "Before → after",
        "version": "Version",
        "versionHint": "Optional pack version, e.g. 2026.1.",
        "versionNo": "Version",
        "status": "Status",
        "code": "Code",
        "name": "Name",
        "entity": "Table",
        "id": "Id",
        "entityCode": "Entity code",
        "tradingName": "Trading name",
        "country": "Country",
        "countryHint": "Two-letter ISO code.",
        "currencyHint": "Three-letter ISO 4217 code.",
        "baseCurrency": "Base currency",
        "entityType": "Entity type",
        "incorporationDate": "Incorporation date",
        "legalEntity": "Legal entity",
        "startMonth": "Start month",
        "generateYear": "Generate year",
        "generateYearHint": "Leave blank to generate no periods yet.",
        "periodCount": "Periods",
        "periodCountHint": "1 to 13. Leave blank for the default of twelve.",
        "coaName": "Chart of accounts name",
        "sequence": "Seq",
        "prompt": "Prompt",
        "qualifier": "Qualifier",
        "binding": "Binding",
        "length": "Length",
        "stepKind": "Creates",
        "industry": "Industry",
        "industryHint": "Shapes the proposal and the explanation on each step.",
        "legalEntities": "Legal entities",
        "footprintHint": "How many the enterprise operates, not how many per entity.",
        "divisions": "Divisions",
        "businessUnits": "Business units",
        "defaultKey": "Key",
        "defaultKeyHint": "The default's name, e.g. workforce_model.",
        "defaultValue": "Value",
        "defaultValueHint": "Stored as written. Every change records the acting user and the prior value.",
        "level": "Supplied by",
        "source": "Source",
        "structureType": "Structure",
        "inherits": "Relationship",
        "packCode": "Pack code",
        "packCodeHint": "The industry pack to make available for selection.",
        "activatedAt": "Activated"
      },
      "identity": {
        "title": "Enterprise identity and global defaults",
        "description": "Everything below the enterprise inherits these unless it overrides them.",
        "summaryTitle": "Enterprise identity",
        "summaryDescription": "Captured when the enterprise was created. Edit it from the enterprise workspace.",
        "create": "Create enterprise",
        "saving": "Saving",
        "saved": "Identity updated",
        "savedDetail": "A new date-effective version was created. The previous one is preserved with its own effective period."
      },
      "copilot": {
        "title": "Setup Copilot",
        "description": "Propose a starter configuration from the industry, country and operating footprint — or start from a blank canvas and add the objects yourself.",
        "assistive": "The Copilot recommends; you decide and commit. It cannot activate the enterprise, toggle a platform flag or consume the guided configuration.",
        "propose": "Propose a configuration",
        "repropose": "Propose again",
        "startBlank": "Start blank",
        "working": "Proposing"
      },
      "plan": {
        "title": "What this pass will create",
        "description": "Every object the single pass creates, in the order it creates them. Amend anything here before submitting.",
        "emptyTitle": "Nothing proposed yet",
        "emptyDescription": "Ask the Copilot for a starter configuration, or start blank and add divisions and business units yourself.",
        "totalObjects": "Objects in total",
        "stepToggle": "{kind}: {subject}",
        "blockingBadge": "{count} to fix",
        "blockingTitle": "{count} blocking finding(s)",
        "blockingHelp": "Each one is shown on the field it belongs to. Fix them and validate again; the pass cannot be submitted while any remain.",
        "validatedHelp": "Validated with no blocking findings. Nothing has been created yet — submitting sends it for approval.",
        "removeStep": "Remove from plan",
        "addKind": "Add",
        "addParent": "Under legal entity",
        "addNeedsEntity": "Add a legal entity first — every division and business unit belongs to one.",
        "addStep": "Add to plan",
        "readOnly": "Submitted — read only",
        "segmentsFixed": "Segments are proposed by the platform and are fixed for this pass. Change the chart of accounts through its own task after setup.",
        "noSegments": "No segments proposed."
      },
      "bar": {
        "noPlan": "No configuration proposed yet.",
        "blocking": "{count} blocking finding(s) — fix them before submitting.",
        "validated": "Validated. Nothing has been created yet.",
        "unvalidated": "{count} object(s) planned. Validate before submitting.",
        "validate": "Validate",
        "validating": "Validating",
        "submit": "Submit for approval",
        "submitting": "Submitting"
      },
      "approval": {
        "title": "Awaiting approval",
        "body": "The configuration below has been submitted. An approver applies it — which creates every object in one transaction — or rejects it with a reason.",
        "sod": "You submitted this configuration, so you cannot approve it. Segregation of duties requires a different approver.",
        "waiting": "You do not hold the approval permission. An approver will apply or reject this configuration.",
        "pendingSince": "Submitted {at}"
      },
      "apply": {
        "open": "Apply configuration",
        "title": "Apply the guided configuration",
        "subject": "Enterprise {code}",
        "headline": "This cannot be undone.",
        "consequence": "Every object below is created in one transaction, the enterprise becomes active, and the guided configuration is marked consumed. If any step fails, nothing at all is created.",
        "oneShot": "Exactly one guided configuration is permitted per enterprise. After this, every structural change goes through the individual management tasks.",
        "confirmLabel": "Type {code} to confirm",
        "confirmHint": "Reproducing the enterprise code is what arms the button. Nothing else on this screen is irreversible.",
        "confirm": "Apply configuration",
        "working": "Applying"
      },
      "applied": {
        "title": "{count} object(s) created",
        "body": "The enterprise is active and the guided configuration is consumed. All further structural change goes through the individual management tasks.",
        "objectsTitle": "What was created",
        "objectsDescription": "Every row below exists in the database now, created in the one transaction that applied this pass.",
        "noObjects": "The pass created no objects.",
        "toWorkspace": "Open the enterprise workspace"
      },
      "reject": {
        "title": "Reject this configuration",
        "description": "It returns to draft and the submitter is told why.",
        "consequence": "The configuration goes back to draft along with the enterprise. The plan is kept, so it can be amended and submitted again.",
        "reasonLabel": "Reason",
        "reasonHint": "Required. The submitter reads this when they reopen the workspace.",
        "working": "Rejecting"
      },
      "consumed": {
        "title": "The guided configuration has already been used",
        "body": "Exactly one guided configuration is permitted per enterprise, and this one has been consumed.",
        "onward": "Divisions, legal entities, business units, workforce structures, reference data sets, the chart of accounts, locations and hierarchies are each managed from their own screen.",
        "workspaceLink": "Open the enterprise workspace"
      },
      "closed": {
        "title": "Guided configuration is no longer available",
        "body": "This enterprise is already live. The guided pass is only available before activation; from here every structural change goes through the individual management tasks."
      },
      "toasts": {
        "created": "Enterprise {code} created",
        "createdDetail": "It is a draft. Nothing consumes it until it is activated.",
        "proposed": "{count} object(s) proposed",
        "proposedDetail": "Nothing has been created. Review each one, amend what you need, then validate.",
        "proposeFailed": "Could not propose a configuration",
        "validated": "{count} object(s) validated",
        "validatedDetail": "No blocking findings. Nothing was created or stored by this check.",
        "validateFailed": "Could not validate the configuration",
        "submitted": "Submitted for approval",
        "submittedDetail": "An approver now applies or rejects it. You cannot approve your own submission.",
        "submitFailed": "Could not submit the configuration",
        "submitBlocked": "{count} blocking finding(s)",
        "submitBlockedDetail": "Each one is shown on the step and field it belongs to.",
        "applied": "{count} object(s) created",
        "appliedDetail": "The enterprise is active and the guided configuration is consumed.",
        "rejected": "Configuration rejected",
        "rejectedDetail": "It is back in draft with your reason recorded against it."
      },
      "workspace": {
        "title": "Enterprise",
        "description": "Identity, global defaults, platform flags, industry packs and the configuration change log.",
        "summaryTitle": "Enterprise at a glance",
        "summaryDescription": "The values every structure below the enterprise inherits unless it overrides them.",
        "tabsLabel": "Enterprise configuration sections",
        "noneTitle": "No enterprise has been created yet",
        "noneBody": "An enterprise is the umbrella every division, legal entity and business unit is created under. Nothing else can be configured until one is active.",
        "startWizard": "Start enterprise setup",
        "openWizard": "Open guided setup",
        "draftHint": "This enterprise is a draft. Submit it for approval when the identity is right.",
        "pendingHint": "Awaiting approval. An approver activates it or rejects it with a reason.",
        "activate": "Activate",
        "activated": "Enterprise activated",
        "activatedDetail": "It is now the tenant's active enterprise.",
        "activateFailed": "Could not activate the enterprise",
        "submitted": "Submitted for approval",
        "submittedDetail": "An approver now activates it or rejects it. You cannot approve your own submission.",
        "submitFailed": "Could not submit the enterprise",
        "rejected": "Enterprise rejected",
        "rejectedDetail": "It is back in draft with your reason recorded against it."
      },
      "tabs": {
        "identity": "Identity",
        "defaults": "Global defaults",
        "flags": "Platform flags",
        "packs": "Industry packs",
        "versions": "Change log"
      },
      "defaults": {
        "title": "Global defaults",
        "description": "Values every new structure inherits unless it overrides them, with the level that supplied each one.",
        "empty": "No global defaults have been set beyond the identity's own.",
        "saving": "Saving",
        "saved": "Default saved",
        "savedDetail": "The change records the acting user, the timestamp and the prior value.",
        "inherits": "Inherits",
        "overrides": "Overrides"
      },
      "flags": {
        "title": "Platform flags",
        "description": "Enterprise-wide switches. Every change is audited with its prior value, and one that reduces protection needs a second approver.",
        "empty": "No platform flags reported.",
        "on": "On",
        "off": "Off",
        "changedAt": "Last changed {at}",
        "confirmTitle": "Change a platform flag",
        "confirmSubject": "Switch {flag} {state}",
        "confirm": "Change flag",
        "saving": "Applying",
        "reducesTitle": "This reduces protection.",
        "reducesBody": "A named second approver is required, and the change is reported to the Risk and Compliance Committee.",
        "secondApprover": "Second approver (user id)",
        "secondApproverHint": "Must be someone other than you.",
        "reasonLabel": "Reason",
        "reasonHint": "Recorded against the change.",
        "toggled": "{flag} changed",
        "toggledDetail": "The prior value and the approver are recorded.",
        "pii_encryption": {
          "name": "PII encryption",
          "help": "Encrypts personal and statutory fields at rest. On by default; it cannot be switched off while the residency region is regulated."
        },
        "ai_assistance": {
          "name": "AI assistance",
          "help": "The master switch for embedded AI. Off suspends every agent immediately; registrations and history are kept, not deleted."
        },
        "telemetry": {
          "name": "Telemetry participation",
          "help": "Shares anonymised product usage. Changes take effect without a redeployment and are audited."
        }
      },
      "packs": {
        "title": "Industry packs",
        "description": "An activated pack makes its structures and terminology available for selection. It never alters structures already in use.",
        "empty": "No industry pack has been activated.",
        "activate": "Activate pack",
        "activating": "Activating",
        "activated": "Pack {code} activated",
        "activatedDetail": "Its structures and terminology are now available for selection.",
        "deactivate": "Deactivate",
        "deactivated": "Pack {code} deactivated",
        "deactivatedDetail": "Structures already created from it are untouched.",
        "statuses": {
          "active": "Active",
          "inactive": "Inactive"
        }
      },
      "versions": {
        "title": "Configuration change log",
        "description": "Every identity version with its author, approver, effective period and what changed.",
        "empty": "No versions recorded yet."
      }
    },
    "simulator": {
      "title": "Determination simulator",
      "description": "Walk a transaction through the checks a real posting meets — business unit, access, opening balances, ledger, period, account combination and intercompany — and see where it would be stopped and why.",
      "routeTitles": {
        "simulator": "Determination simulator"
      },
      "run": "Run determination",
      "running": "Running determination",
      "inputs": {
        "title": "Transaction inputs",
        "description": "Nothing is posted or saved. Each step asks the server the same question a real posting would.",
        "pickersFailed": "Some choices did not load: {message}",
        "user": "User",
        "me": "Me ({name})",
        "businessUnit": "Business unit",
        "choose": "Choose…",
        "provider": "Acting through a shared-service provider",
        "providerHint": "Choose the provider business unit when another unit performs this function for the one above.",
        "none": "None",
        "function": "Business function",
        "date": "Transaction date",
        "structure": "Chart of accounts",
        "structureHint": "Needed to check the account combination.",
        "combination": "Account combination",
        "combinationHint": "The segment values in the chart's own order and separator, for example 1005.0000.0000.411001.",
        "counterparty": "Counterparty legal entity",
        "counterpartyHint": "Set it to check intercompany balancing when the other side is a different legal entity."
      },
      "path": {
        "title": "Determination path",
        "description": "Each step in the order a posting meets it. The first failure stops the chain.",
        "idle": "Enter the inputs, then run the determination."
      },
      "verdicts": {
        "passed": "Every check passed — this transaction would be accepted.",
        "passedWithWarnings": "Every check passed, with warnings to review.",
        "incomplete": "No check failed, but some could not be run. Read the steps marked not checked before relying on this.",
        "failed": "This transaction would be stopped. The failing step says why."
      },
      "outcomes": {
        "pass": "Passed",
        "warn": "Warning",
        "fail": "Failed",
        "skipped": "Not checked",
        "notRun": "Not run",
        "pending": "Waiting"
      },
      "steps": {
        "businessUnit": {
          "title": "Business unit and legal entity",
          "checks": "The business unit is active, performs the function (or a provider is authorised to perform it for it), and names a legal entity."
        },
        "securityScope": {
          "title": "Data access",
          "checks": "The user holds a security scope on the business unit. The server computes this as of today."
        },
        "openingBalances": {
          "title": "Opening balances",
          "checks": "The legal entity's latest opening-balance batch is signed off."
        },
        "ledger": {
          "title": "Ledger",
          "checks": "The legal entity's primary ledger as the ledger selector resolves it."
        },
        "period": {
          "title": "Accounting period",
          "checks": "The period containing the transaction date is open."
        },
        "accountCombination": {
          "title": "Account combination",
          "checks": "The combination passes the chart's cross-validation rules on the date."
        },
        "intercompany": {
          "title": "Intercompany",
          "checks": "When the counterparty is another legal entity, a rule exists for the pair and its accounts balance."
        }
      },
      "reasons": {
        "refused": "The server refused: {message}",
        "stoppedAfter": "Not run because “{step}” failed.",
        "notPermitted": "Not checked: you do not hold {permission}, which this check needs.",
        "buNotActive": "Business unit {unit} is {status}, not active.",
        "providerRefused": "No effective relationship lets the provider perform {function} for {unit}.",
        "noLegalEntity": "Business unit {unit} has no primary legal entity to post to.",
        "viaProvider": "{unit} is served for {function} through relationship {relationship}; it posts to {entity}.",
        "functionNotAssigned": "Business unit {unit} does not perform {function}. Assign the function, or name the provider that performs it.",
        "buResolved": "{unit} performs {function} and posts to {entity}.",
        "noBusinessUnit": "Not checked: the business unit did not resolve.",
        "scopeExpired": "User {user}'s access to {unit} has expired by {date}.",
        "noScope": "User {user} has no security scope on {unit}.",
        "scopeFound": "User {user} has {scope} access to {unit} ({source}).",
        "noLegalEntityResolved": "Not checked: no legal entity was resolved.",
        "noOpeningBalances": "Not checked: {entity} has no opening-balance batch.",
        "signedOff": "Opening balances for {entity} (batch {batch}) were signed off on {date}.",
        "noSignedOffBatch": "No signed-off opening-balance batch for {entity}: {count} batch(es) exist, none signed off.",
        "ledgerResolved": "{entity} posts to ledger {ledger} in {currency}.",
        "noLedgerResolved": "Not checked: no ledger was resolved, so there is no ledger calendar to read periods from.",
        "ledgerNoCalendar": "Ledger {ledger} has no accounting calendar attached.",
        "noPeriod": "No regular (non-adjusting) period on calendar {calendar} of ledger {ledger} contains {date}.",
        "periodOpen": "Period {period} is open on {date}.",
        "periodSoftClosed": "Period {period} is soft-closed on {date}: posting is allowed with a warning.",
        "periodClosed": "Period {period} is {status} on {date}: posting is blocked.",
        "noCombination": "Not checked: choose a chart of accounts and enter an account combination.",
        "combinationValid": "Combination {values} is valid.",
        "combinationInvalid": "Combination {values} breaks rule “{rule}” on values {offending}.",
        "noCounterparty": "Not checked: no counterparty legal entity was given.",
        "sameEntity": "Not checked: the counterparty is {entity} itself, so there is nothing intercompany.",
        "noIntercompanyRule": "No intercompany rule is configured between {entity} and {counterparty} on this date.",
        "intercompanyBalanced": "The intercompany accounts between {entity} and {counterparty} balance.",
        "intercompanyUnbalanced": "The intercompany accounts do not balance — residual {residual}. {findings}"
      }
    },
    "workforce": {
      "routeTitles": {
        "namingTemplates": "Naming Templates",
        "headcount": "Headcount",
        "reorganisations": "Reorganisations",
        "reorganisation": "Reorganisation",
        "model": "Model, Naming & Headcount",
        "departments": "Departments",
        "assignmentValidator": "Assignment Validator"
      },
      "model": {
        "title": "Model, Naming & Headcount",
        "description": "The workforce model the data shows, the naming templates that compose job and position names, and approved versus filled headcount.",
        "tabsLabel": "Workforce model sections",
        "tabs": {
          "model": "Model & headcount",
          "naming": "Naming templates",
          "headcount": "Headcount events"
        },
        "modelTitle": "Workforce model",
        "modelLabel": "Model in use",
        "derived": {
          "positions": "Positions-based",
          "jobs": "Jobs-based"
        },
        "modelHint": "Read from the data, not a setting: positions defined means a positions-based model; jobs without positions means a jobs-based one. Nothing is shown until either exists.",
        "headcountTitle": "Headcount — approved vs filled",
        "headcountDescription": "Positions as at today: approved headcount, current holders and the seats still available.",
        "positionsLoadFailed": "Could not load positions",
        "noPositionsTitle": "No positions yet",
        "noPositionsDescription": "Define positions to govern approved headcount per seat.",
        "firstPageOnly": "Showing the first 50 positions. Use the Positions screen to see them all.",
        "overFilled": "Over by {count}",
        "namingNoPermission": "You do not hold the permission to read naming templates."
      },
      "departments": {
        "title": "Departments",
        "description": "The departments of a legal entity: the units positions sit in and the reorganisation engine moves.",
        "create": "New department",
        "company": "Legal entity",
        "companiesFailed": "Could not load legal entities",
        "search": "Search",
        "searchHint": "Code or name",
        "loadFailed": "Could not load departments",
        "tableLabel": "Departments",
        "emptyTitle": "No departments",
        "emptyDescription": "Create the first department for this legal entity, or clear the search.",
        "columns": {
          "department": "Department",
          "parent": "Parent",
          "actions": "Actions"
        },
        "active": "Active",
        "inactive": "Inactive",
        "deleteTitle": "Delete department",
        "deleteMessage": "Delete {name}? Refused while positions or child departments still reference it.",
        "deleted": "Department deleted",
        "deleteFailed": "Could not delete the department",
        "conflict": "Someone else changed this department — the list has been reloaded. Review it and try again."
      },
      "validator": {
        "title": "Assignment Validator",
        "description": "Check an assignment against department, position headcount, grade pay range and legal employer before it is made. Nothing is saved.",
        "formTitle": "Check an assignment",
        "fields": {
          "position": "Position",
          "department": "Department",
          "legalEmployer": "Legal employer",
          "grade": "Grade",
          "salary": "Salary",
          "salaryHint": "Optional — checked against the grade's pay range.",
          "effectiveFrom": "Effective from",
          "effectiveTo": "Effective to",
          "employee": "Employee number",
          "employeeHint": "Optional — the employee's record number, to check the assignment for that person.",
          "employeeInvalid": "Enter the employee's record number (digits only).",
          "assignmentType": "Assignment type",
          "overrideReason": "Override reason",
          "overrideReasonHint": "Optional — why a rule should be overridden for this assignment.",
          "intendedHint": "State the assignment's intended value. It is compared with the position's own; left empty, it is not checked."
        },
        "assignmentTypes": {
          "primary": "Primary",
          "secondary": "Secondary"
        },
        "fieldNames": {
          "positionId": "position",
          "departmentId": "department",
          "legalEmployerId": "legal employer",
          "gradeId": "grade",
          "salary": "salary",
          "effectiveFrom": "effective from",
          "effectiveTo": "effective to",
          "employeeId": "employee",
          "assignmentType": "assignment type",
          "overrideReason": "override reason"
        },
        "validate": "Validate",
        "pass": "Valid — this assignment meets every department, headcount, grade range and legal employer rule.",
        "failed": "No violations | 1 violation found | {count} violations found",
        "assignmentsTitle": "Current assignments",
        "assignmentsDescription": "Assignments in force today. Re-validate one to check it against today's rules.",
        "assignmentsLoadFailed": "Could not load assignments",
        "noAssignmentsTitle": "No current assignments",
        "noAssignmentsDescription": "Assignments appear here once people are assigned to positions.",
        "firstPageOnly": "Showing the first 50 assignments.",
        "revalidate": "Re-validate",
        "columns": {
          "employee": "Employee",
          "type": "Type · FTE",
          "lastCheck": "Last check"
        },
        "outcome": {
          "valid": "Valid",
          "invalid": "Violations",
          "failed": "Not checked"
        }
      },
      "namingTemplates": {
        "title": "Naming Templates",
        "description": "Compose job and position names from configurable attributes, defined at enterprise, business unit or reference data set level.",
        "create": "New Naming Template",
        "scope": {
          "label": "Scope",
          "enterprise": "Enterprise",
          "business_unit": "Business Unit",
          "reference_set": "Reference Data Set"
        },
        "object": {
          "label": "Applies to",
          "job": "Job",
          "position": "Position"
        },
        "attributeSequence": "Attribute sequence",
        "active": "Active",
        "inactive": "Inactive",
        "loadFailed": "Could not load naming templates",
        "tableLabel": "Naming templates",
        "emptyTitle": "No naming templates yet",
        "emptyDescription": "Create one to compose job and position names from a configured attribute sequence instead of typing them by hand.",
        "createTitle": "New Naming Template",
        "editTitle": "Edit Naming Template",
        "editorDescription": "The attribute sequence and separator compose the name; the live preview on the right shows what a set of sample values would produce.",
        "scopeId": "Scope id",
        "attributeSequenceHint": "The order these attribute keys are composed in, joined by the separator below.",
        "attribute": "Attribute {n}",
        "addAttribute": "Add attribute",
        "separator": "Separator",
        "isActive": "Active",
        "isActiveHint": "Inactive templates are kept for history but no longer offered when composing a new name.",
        "previewTitle": "Live preview",
        "previewLocked": "Save this template first — the preview composes names for a saved template's own attribute sequence.",
        "previewHint": "Enter a sample value for each attribute to see the name this template would compose.",
        "collides": "This name collides with an existing entry ({code}).",
        "saved": "Naming template saved",
        "saveFailed": "Could not save the naming template"
      },
      "headcount": {
        "title": "Headcount",
        "description": "Approved, filled and available headcount for a position, and the requisitions, overrides and reductions raised against it.",
        "position": "Position",
        "approvedColumn": "Approved",
        "search": "Search positions",
        "searchHint": "Position code or name",
        "searchFailed": "Could not search positions",
        "resultsLabel": "Matching positions",
        "noResultsTitle": "No positions found",
        "noResultsDescription": "Try a different code or name.",
        "loadFailed": "Could not load this position's headcount",
        "asAt": "As at",
        "raiseEvent": "Raise headcount event",
        "approved": "Approved",
        "filled": "Filled",
        "available": "Available",
        "sessionLogTitle": "Events raised this session",
        "sessionLogHint": "There is no history endpoint yet — this list is what this browser session has recorded, not the position's full history.",
        "effectiveFromLabel": "Effective from",
        "newApproved": "new approved",
        "eventType": {
          "requisition": "Requisition",
          "override": "Override",
          "reduction": "Reduction"
        },
        "raiseTitle": "Raise a headcount event",
        "raiseDescription": "A requisition or override raises approved headcount; a reduction lowers it and cannot drop it below the position's current holder count.",
        "eventTypeLabel": "Event type",
        "magnitude": "FTE change",
        "requisitionRef": "Requisition reference",
        "overrideReasonCode": "Override reason code",
        "overrideReason": "Override reason",
        "overrideConsequence": "An override is recorded and reported to HR governance as an exception (FSD 1.2.5.11).",
        "reductionHint": "Approved headcount cannot be reduced below the number of people currently holding the position.",
        "approverId": "Approver (user id)",
        "eventSaved": "Headcount event recorded",
        "eventSaveFailed": "Could not record the headcount event"
      },
      "reorganisations": {
        "title": "Workforce Reorganisations",
        "description": "Future-dated batches of position and department changes, simulated before they are submitted and applied automatically on their effective date.",
        "create": "New Reorganisation",
        "registryNote": "This list shows the reorganisations you have created or opened in this browser session — there is no reorganisation-catalogue list endpoint yet (see the id lookup below to keep working across a reload).",
        "tableLabel": "Reorganisations",
        "emptyTitle": "No reorganisations in this session yet",
        "emptyDescription": "Create one, or if you already know its id, open it below.",
        "code": "Code",
        "status": {
          "draft": "Draft",
          "pending": "Pending approval",
          "approved": "Approved",
          "applied": "Applied",
          "reversed": "Reversed"
        },
        "effectiveOn": "Effective on",
        "effectiveOnHint": "Must be after today — an immediate change uses the ordinary supersede action instead.",
        "changeSummary": "Change summary",
        "openById": "Open a reorganisation by id",
        "reorgId": "Reorganisation id",
        "open": "Open",
        "createTitle": "New Reorganisation",
        "createDescription": "Simulate the change to see its effect before submitting it for approval.",
        "items": "Field changes",
        "objectType": "Object",
        "objectId": "Object id",
        "fieldLabel": "Field",
        "toValue": "New value",
        "addItem": "Add field change",
        "simulate": "Simulate",
        "simulationStale": "The form has changed since this simulation — simulate again before confirming.",
        "simulationReady": "Simulation ready — review the effect below, then confirm.",
        "resolvedItems": "Resolved changes",
        "affectedAssignments": "Affected assignments",
        "noAffectedAssignments": "No worker assignments are affected by this change.",
        "employee": "employee",
        "costCentreImpact": "Cost centre impact",
        "confirmCreate": "Confirm & Submit",
        "saved": "Reorganisation submitted",
        "saveFailed": "Could not submit the reorganisation",
        "simulateFailed": "Could not simulate the reorganisation",
        "object": {
          "position": "Position",
          "department": "Department"
        },
        "field": {
          "reportsToPositionId": "Reports to (position id)",
          "departmentId": "Department id",
          "businessUnitId": "Business unit id",
          "costCenterId": "Cost centre id",
          "headcount": "Approved headcount",
          "managerPositionId": "Manager (position id)",
          "parentId": "Parent department id"
        },
        "detailTitle": "Reorganisation {code}",
        "loadFailed": "Could not load this reorganisation",
        "reverse": "Reverse",
        "reverseBlockedApplied": "This reorganisation already applied on {date}; submit a new reorganisation to reverse it.",
        "reverseBlockedReversed": "This reorganisation is already reversed.",
        "appliedAt": "Applied at",
        "reverseTitle": "Reverse this reorganisation",
        "reverseDescription": "Only a reorganisation that has not yet applied can be reversed this way.",
        "reverseConsequence": "This cancels the reorganisation before its effective date. It cannot be undone — a cancelled reorganisation must be resubmitted from scratch.",
        "reverseReason": "Reason (optional)",
        "reversed": "Reorganisation reversed",
        "reverseFailed": "Could not reverse the reorganisation"
      }
    }
  },
  "home": {
    "hero": {
      "workspace": "Workspace {slug}",
      "search": "Search screens, records and actions",
      "mfaFix": "Set up two-factor sign-in for your account"
    },
    "role": {
      "eyebrow": "Start here",
      "title": "Your {name} dashboard",
      "description": "The figures your role answers for, each one opening the rows behind it.",
      "open": "Open dashboard"
    },
    "today": {
      "title": "Today",
      "description": "Shared work waiting on you, across every app.",
      "attentionOpen": "{count} open",
      "attentionOverdue": "{count} overdue",
      "notificationsUnread": "{count} unread",
      "countLoading": "Loading the count"
    },
    "apps": {
      "title": "Apps",
      "description": "Every part of the product you can open. Each app opens on its first screen.",
      "part": "Part {n}",
      "emptyTitle": "No apps are open to you yet",
      "emptyDescription": "Your roles do not reach any app's screens. Ask a Tenant Admin to assign you a role."
    },
    "pinned": {
      "title": "Pinned",
      "emptyTitle": "Nothing pinned yet",
      "emptyDescription": "Star a screen in any app's menu to pin it here.",
      "unpin": "Unpin {label}"
    },
    "recent": {
      "title": "Recent",
      "emptyTitle": "No recent screens",
      "emptyDescription": "Screens you open appear here, so you can pick up where you left off."
    },
    "setup": {
      "title": "Workspace setup",
      "description": "Who can sign in, which roles exist, and how accounts are protected.",
      "accountTitle": "Your account",
      "accountDescription": "How your own sign-in is protected, and where you are signed in."
    }
  }
}
